(function () {
	'use strict';

	angular
		.module('trakeyeApp', [
			'ngStorage',
			'cp.ngConfirm',
			'tmh.dynamicLocale',
			'pascalprecht.translate',
			'ngResource',
			'ngCookies',
			'ngAria',
			'ngCacheBuster',
			'ngFileUpload',
			'ui.bootstrap',
			'ui.bootstrap.datetimepicker',
			'ui.router',
			"isteven-multi-select",
			'infinite-scroll',
			// jhipster-needle-angularjs-add-module JHipster will add new module here
			'angular-loading-bar',
			'angularUtils.directives.dirPagination'
			//            'uiGmapgoogle-maps'
		])
		.run(run)
		//Added for Before and After login design changes
		.run([
			'$log', '$rootScope', '$window', '$state', '$location', '$timeout',
			function ($log, $rootScope, $window, $state, $location, $timeout) {
				$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
					$(window).resize(function () {
						if ($(window).height() <= 250) {
							$rootScope.mapHeight = ($(window).height() + 262);
							$rootScope.userMapHeight = ($(window).height() + 262);
						}
						else {
							$rootScope.mapHeight = ($(window).height() - 220);
							$rootScope.userMapHeight = ($(window).height() - 262);
						}
					});
					$(window).trigger('resize');
					$(".select2-container").hide();//Added to hide select2 search box
					if (toState.url == "/") {
						$('body').addClass('layout-top-nav').removeClass('sidebar-mini tryitbg');
						$('.main-footer').addClass('home-footer');
					} else {
						$('body').removeClass('layout-top-nav').addClass('sidebar-mini');
						$('.content-wrapper').removeClass('home-container tryitbg');
						$('.main-footer').removeClass('home-footer');
					}
					if (toState.url == "/login" || toState.url == "/reset/request" || toState.url == "/reset/finish?key" || toState.url == "/accessdenied") {
						$('body').addClass('layout-top-nav').removeClass('sidebar-mini');
						$('.content-wrapper').addClass('main-wrapper');
						$('.main-footer').addClass('login-footer');
					} else {
						$('.content-wrapper').removeClass('main-wrapper tryitbg').addClass('sidebar-mini');
						$('.main-footer').removeClass('login-footer');
					}
					if (toState.url == "/register") {
						$('body').addClass('layout-top-nav tryitbg').removeClass('sidebar-mini');
						$('.content-wrapper').addClass('main-wrapper tryitbg');
						$('.main-footer').addClass('home-footer');
					} else {
						$('body').removeClass('tryitbg').addClass('sidebar-mini');
						$('.content-wrapper').removeClass('main-wrapper tryittrans').addClass('sidebar-mini');
						$('.main-footer').removeClass('home-footer');
					}

					if (toState.url == "/feasibilityverify/finish?key") {
						$('body').addClass('layout-top-nav remove-header');
						$('.main-footer').addClass('home-footer');

					}
					//Added for redirecting to login page
					if (toState.url == "/accessdenied") {
						$timeout(function () {
							$state.go('login');
						}, 5000);
					}

				});
			}
		])
		//Added for upload required functionality
		.directive('validFile', function () {
			return {
				require: 'ngModel',
				link: function (scope, el, attrs, ngModel) {
					//change event is fired when file is selected
					el.bind('change', function () {
						scope.$apply(function () {
							ngModel.$setViewValue(el.val());
							ngModel.$render();
						})
					})
				}
			}
		});


	run.$inject = ['stateHandler', 'translationHandler'];

	function run(stateHandler, translationHandler) {
		stateHandler.initialize();
		translationHandler.initialize();
	}
})();
/* window.addEventListener('load', function () {

	var script = document.createElement('script');
	script.type = 'text/javascript';
	//script.src = '//maps.googleapis.com/maps/api/js?key=AIzaSyCZwufiWIHL8icKRYAXRRnfm3tYME3fcHU&libraries=geometry,drawing';
	document.body.appendChild(script);
}); */

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('upload', {
                parent: 'app',
                url: '/upload',
                data: {
                    authorities: ['ROLE_SUPER_ADMIN', 'ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER'],
                    pageTitle: 'global.menu.admin.upload'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/upload/uploadagent.html',
                        controller: 'UploadController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }


            })
    }
})();
(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('Upload', Upload);

    Upload.$inject = ['$http'];

    function Upload ($http) {
       
        var service ={};
    	service.upload = function (data,callback){
    		
    		$http.post('api/upload',data,{
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
             }).then(function(response){
    			
        		callback(response,response.headers);
        	}, function(error){
        		callback(error, error.headers);
        	});
    	};
    	
    	 service.findAllFiles= function (callback){
    			$http.get('api/listfiles').then(function(response){
    	    	    callback(response.data);
    	    	});
    		};
    		
         service.findAllIosFiles= function (callback){
    				$http.get('api/listfiles-ios').then(function(response){
    		    	    callback(response.data);
    		    	});
         };		
    	return service;
    }
    
})();


(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('UploadController', UploadController)
        .directive('agentFile', [function() {
        'use strict';

        return {
            restrict: "A",

            link: function($scope, element){

                element.change(function(event){
                    $scope.$apply(function(){
                      $scope.myFile =element[0].files[0];
                      $scope.versionNo = $scope.version;
                      
                    });
                });
            }

        };
    }]);

    UploadController.$inject = ['$scope', '$state', 'Auth', 'Principal','Upload' ,'ProfileService', 'LoginService','$rootScope','$timeout','$window'];

    function UploadController ($scope, $state, Auth, Principal,Upload, ProfileService, LoginService, $rootScope,$timeout, $window) {
    	$scope.FILE_EXT_REGEXP =/^(.*?)\.(apk||ipa)$/;
    	
        var vm = this;
        vm.upload = upload;
        vm.success= null;
        vm.fileempty = null;
        vm.error = null;
        vm.files=[];
        vm.iosfiles=[];
        vm.showiosfiles=showiosfiles;
        vm.showandroidfiles=showandroidfiles;
        
      
//        vm.changedFile =fileselected;
        var formData;
        function upload () {
        formData=new FormData();
       
        formData.append("version", $scope.version);
        formData.append('file',$scope.myFile);
        
               Upload.upload(formData,function(response,headers){
            	    if(response.status == 200){
                		vm.error=null;
                		vm.success='OK';
                		$scope.version='';
                		
               		$timeout(function(){
               			vm.success= '';
               		},4000);
               		
               		Upload.findAllFiles(function(data){
                        	vm.files=data;
                        });
                		
               		Upload.findAllIosFiles(function(data){
                			vm.iosfiles=data;
                		});
                	} 
                	if(response.status == 400){
                		vm.success=null;
                		vm.error='error';
                			
                	} 
                });
        
        }   
        //Added for upload styles
        $(":file").filestyle({buttonBefore: true});      
        //$(":file").filestyle('placeholder', 'Choose File');
        $(":file").filestyle('buttonText', 'Browse File');
        
        function showiosfiles(){
          Upload.findAllIosFiles(function(data){
        	  vm.iosfiles=data;
          });
        }
        
        vm.showandroidfiles();
        
        function showandroidfiles(){
        	Upload.findAllFiles(function(data){
          	  vm.files=data;
            });
        }
        $scope.tab = 1;

		$scope.setTab = function(newTab){
		  $scope.tab = newTab;
		  if( $scope.tab==1){
			  vm.showandroidfiles();
		  }
		  if( $scope.tab==2){
			  vm.showiosfiles();
		  }
		};

		$scope.isSet = function(tabNum){
		  return $scope.tab === tabNum;
		};
    }
   
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('User', User);

	User.$inject = ['$resource'];

	function User($resource) {
		var service = $resource('api/users/:login', {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'save': {
				method: 'POST'
			},
			'update': {
				method: 'PUT'
			},
			'delete': {
				method: 'DELETE'
			}
		});

		return service;
	}
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserSearch', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getuserbyname = function (data, callback) {
			$http.get('api/users-details/' + data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadUsers', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-users').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserById', UserById);

	UserById.$inject = ['$resource'];

	function UserById($resource) {
		var service = $resource('api/user-data/:userId', {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserDetails', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getuserbystatus = function (data, callback) {
			$http.get('api/user/userdetails/' + data).then(function (response) {
				callback(response.data);
			});
		};
		
		service.getMasterGeofenceCoods = function (callback) {
			$http.get('/api/user-geofence-coord-by-type-master').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserIDs', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/userslist').then(function (response) {
				callback(response.data);
			});
		};

		service.getAdminAll = function (callback) {
			$http.get('api/adminuserslist').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ActivatedUsers', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getactivatedusers = function (callback) {
			$http.get('api/activateduserlist').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UsersByGeo', UsersByGeo);

	UsersByGeo.$inject = ['$resource'];

	function UsersByGeo($resource) {
		var service = $resource('/api/geousers/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserValueSearch', UserValueSearch);

	UserValueSearch.$inject = ['$resource'];

	function UserValueSearch($resource) {
		var service = $resource('/api/users/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserValueGeofenceSearch', UserValueGeofenceSearch);

	UserValueGeofenceSearch.$inject = ['$resource'];

	function UserValueGeofenceSearch($resource) {
		var service = $resource('/api/users/geosearchvalue/:geofenceId/:search/:columnNames', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UsersStatusService', UsersStatusService);

	UsersStatusService.$inject = ['$resource'];

	function UsersStatusService($resource) {
		var service = $resource('api/userdetails/:status/:geofenceId', {geofenceId : '@geofenceId'}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserStatusSearch', UserStatusSearch);

	UserStatusSearch.$inject = ['$resource'];

	function UserStatusSearch($resource) {
		var service = $resource('/api/userdetails/statussearch/:status/:searchtext', {
			status: '@status',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ActivatedUserSearch', ActivatedUserSearch);

	ActivatedUserSearch.$inject = ['$resource'];

	function ActivatedUserSearch($resource) {
		var service = $resource('/api/users/searchactivatedusers/:userId/:user', {
			userId: '@id'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AssocitedVendorSearch', AssocitedVendorSearch);

	AssocitedVendorSearch.$inject = ['$resource'];

	function AssocitedVendorSearch($resource) {
		var service = $resource('/api/users/searchvendors/:userId/:user', {
			userId: '@id'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserHierarchy', UserHierarchy);

	UserHierarchy.$inject = ['$resource'];

	function UserHierarchy($resource) {
		var service = $resource('api/users/reporties/:login', {
			login: 'bang_south'
		}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UsersHierarchy', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		/*
		 * service.getUserHierarchy = function (callback){
		 * $http.get('api/users/reporties').then(function(response){
		 * callback(response.data); }); };
		 */

		service.getUsersHierarchy = function (login, callback) {
			var url = 'api/users/reporties/';
			if (login != null) {
				url = url + login
			}
			$http.get(url).then(function (response) {
				callback(response.data);
			});

		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('BaseUrl', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getBaseUrl = function (callback) {
            $http.get('api/base-url').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource'];

    function Customer ($resource) {
        var service = $resource('api/customers', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CustomerValueSearch', CustomerValueSearch);

    CustomerValueSearch.$inject = ['$resource'];

    function CustomerValueSearch ($resource) {
    	var service = $resource('/api/customers/searchvalue/:customerId',{customerId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CustomerDetails', CustomerDetails);

    CustomerDetails.$inject = ['$resource'];

    function CustomerDetails ($resource) {
    	var service = $resource('/api/customer/:customerId',{customerId:'@id'},{},{
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
}) ();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CustomerUpdate', CustomerUpdate);

    CustomerUpdate.$inject = ['$resource'];

    function CustomerUpdate ($resource) {
    	var service = $resource('/api/customer',{},{
            'update': { method:'PUT' },
            'save': { method:'POST' },
        });

        return service;
    }
})();


(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        var service = $resource('api/customer', {}, {
            'save': { method:'POST' }
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account','$rootScope','Configs','UserDetails','DEFAULT_LATITUDE','DEFAULT_LONGITUDE'];

    function Principal ($q, Account,$rootScope,Configs,UserDetails,DEFAULT_LATITUDE,DEFAULT_LONGITUDE) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                Configs.rolloutFeatures(function (response) {
                    $rootScope.Roles = {}
                    if (response && response.length) {
                        response.forEach(function (value) {
                            $rootScope.Roles[value.configKey] = true 

                            if(value.configKey == "noOfWorkingHours"){
                                $rootScope.maxNoOfWorkingHours = parseInt(value.configValue)
                            }
                        });
                        if($rootScope.Roles){
                            for (var key in $rootScope.Roles) {
                                if ($rootScope.Roles.hasOwnProperty(key)) {
                                    account.data.authorities.push(key);
                                }
                              }
                        }
                    }
                    _identity = account.data;
                    _authenticated = true;
                    deferred.resolve(_identity);
						UserDetails.getMasterGeofenceCoods(function (response) {
  						if (response && response.lat && response.lng) {
    						DEFAULT_LATITUDE.value = response.lat;
    						DEFAULT_LONGITUDE.value = response.lng;

  						}
					});

                },function (err){
                    $rootScope.Roles = {}
                
                    _identity = account.data;
                    _authenticated = true;
                    deferred.resolve(_identity);
                });

              

                //switch
               /*  Configs.get("Features", function (response) {
                    response.filter(function (value){

                        if(value.configKey == "ProjectExplorer"){
                            if(value.configValue == "True"){
                                $rootScope.showProjectExplorer = true
                            }else{
                                $rootScope.showProjectExplorer = false
                            }
                        } })}) */
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$http','$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $http,$state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            verify: verify
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
        	AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
        
        function verify(data,callback){
        	/*AuthServerProvider.logout();
            Principal.authenticate(null);*/
        	$http.post('api/account/verify',data,{
                
             }).then(function(response){
            	callback(response);
        	}, function(error){
        		callback(error);
        	});
    	};
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UserLogout', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.post = function ( data, callback) {
            $http.post("api/logout", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
        	
            /*var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
              
                $http.post('api/logout',$.param(""),
                		{
                	      headers:
                	    	  {
                	    	  'Content-Type' : 'application/json',
                	    	  'Authorization' : 'Bearer ' + token

                	    	  }
                		}
                		
                ).then(function(response){
            	    callback(response.data);
            	});
            }*/
            
        	
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('VehicleDistanceController', VehicleDistanceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	VehicleDistanceController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function VehicleDistanceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadVehicleDistanceReport = downloadVehicleDistanceReport;
		vm.report = report;
		vm.reporthide = false;
		vm.sortResponse = sortResponse;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "gpsUser";
		vm.selecterange = selectRange;

		vm.select2();

		vm.vehicles = loadPage();

		function loadPage() {
			Report.getVehicles('', function (response) {
				vm.vehicles = response;
			})
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadVehicleDistanceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getVehicleDistanceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "vehicle_distance_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getVehicleDistanceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getVehicleDistanceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('UserStatsController', UserStatsController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	UserStatsController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function UserStatsController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadUserStatsReport = downloadUserStatsReport;
		vm.report = report;
		vm.sortResponse = sortResponse;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "gpsUser";
		vm.selecterange = selectRange;

		vm.select2();

		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadUserStatsReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserDistanceStatsReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_distance_statistics_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserStatsReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserStatsReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("UserReportingController", UserReportingController);
    angular.module("trakeyeApp").filter("trustFilter", [
        "$sce",
        function ($sce) {
            return function (text) {
                return $sce.trustAsHtml(text);
            };
        },
    ]);

    UserReportingController.$inject = ["$scope", "$sce", "$state", "Report"];

    function UserReportingController($scope, $sce, $state, Report) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.downloadAttendenceReport = downloadAttendenceReport;
        vm.report = report;
        vm.reporthide = false;
        vm.select2 = select2;
        var date = "dd EEE";
        vm.today = today();
        vm.reportRecords = [];
        vm.select2();

        vm.users = loadPage();

        vm.img;
        var zoomImage;

        function enable() {
            zoomImage = new ZoomNPan(imgZoom);
            zoomImage.minScale = 100;
        }
        enable();

        function loadPage() {
            Report.getUsers("", function (response) {
                vm.users = response;
            });
        }

        function today() {
            var today = new Date();
            vm.currentDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate()
            );
            vm.currentDate.setHours(0, 0, 0, 0);
            vm.currentTime = vm.currentDate.getTime();
        }

        function downloadAttendenceReport() {
            Report.downloadReportingReport(
                {
                    id: vm.id,
                    fromTime: vm.currentTime,
                    toTime: vm.currentTime,
                },
                function (response) {
                    var a = document.createElement("a");
                    a.style = "display: none";
                    var file = new Blob([response], {
                        type: "application/csv",
                    });
                    var fileURL = URL.createObjectURL(file);
                    a.href = fileURL;
                    a.download = "user_reporting_status_report.csv";
                    a.click();
                    window.URL.revokeObjectURL(fileURL);
                }
            );
        }

        function report() {
            Report.getReportingReport(
                {
                    id: vm.id,
                    fromTime: vm.currentTime,
                    toTime: vm.currentTime,
                },
                function (response) {
                    vm.reportRecords = response;
                }
            );
        }

        $scope.getImage = function (img) {
            vm.img = img;
        };

        function select2() {
            $(".select2").select2();
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.calculateDate = calculateDate;
        function calculateDate() {
            vm.currentDate.setHours(0, 0, 0, 0);
            vm.currentTime = vm.currentDate.getTime();
        }

        function ZoomNPan(elm) {
            var that = this;

            /** minimum zoom allowed (in percent) */
            this.minScale = 30;
            /** maximun zoom allowed (in percent) */
            this.maxScale = 300;
            /** Snap to 100% if the zoom is in +- this amount (in percent) */
            this.snap = 9;
            /** invert the direction on MacOS */
            this.invertOnMac = false;

            if (elm.hasAttribute("data-zoom-and-pan"))
                return console.error(
                    "ZoomNPan This element is already initialized"
                );
            elm.setAttribute("data-zoom-and-pan", "");

            var currentScale = 100;
            elm.addEventListener("wheel", zoom);
            elm.addEventListener("mousemove", pan);

            function zoom(e) {
                e.preventDefault();
                var y = normalizeWheel(e);

                var step = y * (that.maxScale / 500);
                currentScale += step * -1;
                if (currentScale > that.maxScale) currentScale = that.maxScale;
                if (currentScale < that.minScale) currentScale = that.minScale;

                var s =
                    Math.abs(100 - currentScale) > that.snap
                        ? currentScale
                        : 100; //snap to 100%
                elm.classList.toggle("zoomed-in", s > 100);
                elm.classList.toggle("zoomed-out", s < 100);
                elm.style.backgroundSize = s + "%";
            }

            function pan(e) {
                var panX,
                    panY,
                    pad = 20;
                if (currentScale >= 100) {
                    panX = (e.offsetX - pad) / (e.target.clientWidth - pad * 2);
                    panY =
                        (e.offsetY - pad) / (e.target.clientHeight - pad * 2);
                } else {
                    panX = 0.5;
                    panY = 0.5;
                }
                elm.style.backgroundPositionX = panX * 100 + "%";
                elm.style.backgroundPositionY = panY * 100 + "%";
            }

            function normalizeWheel(ev) {
                var sY = 0;
                if ("detail" in ev) sY = ev.detail;
                if ("wheelDelta" in ev) sY = -ev.wheelDelta / 120;
                if ("wheelDeltaY" in ev) sY = -ev.wheelDeltaY / 120;
                var pY = 10 * sY;
                if ("deltaY" in ev) pY = ev.deltaY;
                if (pY && ev.deltaMode) pY *= ev.deltaMode === 1 ? 40 : 800;
                if (pY && !sY) sY = 1 > pY ? -1 : 1;
                that.invertOnMac &&
                    navigator.platform.match(/mac/i) &&
                    ((sY *= -1), (pY *= -1)); //invert direction on MacOS
                return pY;
            }

            /**
             * theardown the events and remove styles, call this when you don't need it anymore.
             * @public
             */
            this.destroy = function () {
                elm.removeEventListener("wheel", zoom);
                elm.removeEventListener("mousemove", pan);
                elm.removeAttribute("data-zoom-and-pan");
                elm.className = "zoom"; //remove zoomed-in and zoomed-out
                elm.style.backgroundSize = ""; //reset zoom
                elm.style.backgroundPosition = ""; //reset position
            };
        }
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('UserLoginHistoryReportController', UserLoginHistoryReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	UserLoginHistoryReportController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function UserLoginHistoryReportController($scope, $sce, $state, Report) {
		var vm = this;
		vm.report = report;
		vm.reporthide = false;
		vm.select2 = select2;
		vm.select2();
		vm.sortResponse = sortResponse;
		vm.downloadUserLastLoginReport = downloadUserLastLoginReport;
		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserLastLoginReport({
				id: vm.id
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}
		
		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserLastLoginReport({
				id: vm.id,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc'
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			});
		}

		function downloadUserLastLoginReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.downloadUserLastLoginReport({
				id: vm.id
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_last_login_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}
		
		function select2() {
			$(".select2").select2();
		}
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('UserGeofenceReportController', UserGeofenceReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	UserGeofenceReportController.$inject = ['$scope', '$sce', '$state', 'Report', 'UserGeofences'];

	function UserGeofenceReportController($scope, $sce, $state, Report, UserGeofences) {
		var vm = this;
		vm.select2 = select2;
		vm.select2();
		vm.downloadUserGeofenceReport = downloadUserGeofenceReport;
		vm.userGeofences = [];
		vm.users = loadPage();
		vm.userAgent ="username";

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
				$(".select2").select2();
			})
			UserGeofences.getAll(function (response) {
				response.forEach(function(geofence){
					if(geofence.geofenceType == "MINI"){
						vm.userGeofences.push(geofence);
					}
				});
				$(".select2").select2();
			});
		}

		function downloadUserGeofenceReport() {
				if(vm.userAgent == 'username'){
					vm.id=vm.userid;
				} else {
					vm.id=vm.geofenceid;
				}
				Report.downloadUserGeofenceReport({
					id: vm.id,
					reportType: vm.userAgent
				}, function (response) {
					var a = document.createElement("a");
					a.style = "display: none";
					var file = new Blob([(response)], { type: 'application/csv' });
					var fileURL = URL.createObjectURL(file);
					// window.open(fileURL, "_blank");
					a.href = fileURL;
					a.download = "user_geofences_report.csv";
					a.click();
					window.URL.revokeObjectURL(fileURL);
				});
			
		}
		
		function select2() {
			$(".select2").select2();
		}
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('UserAttendaceController', UserAttendaceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	UserAttendaceController.$inject = ['$scope', '$sce', '$state', "Report"];

	function UserAttendaceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.report = report;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "gpsUser";
		vm.selecterange = selectRange;

		vm.select2();

		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
			vm.reportType = 'gpsUser';
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadAttendenceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} 
		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('UserAgentReportController', UserAgentReportController)

	UserAgentReportController.$inject = [ '$scope', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval' ];

	function UserAgentReportController($scope, $state, Report, $rootScope, $timeout, $window, $filter, $interval) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.batteryusers = [];
		$scope.reporthide = false;
		vm.select2 = select2;
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.sortResponse = sortResponse;
		vm.today = today();
		vm.downloadUserAgentReport = downloadUserAgentReport;
		vm.select2();

		Report.getUsers('', function(response) {
			vm.batteryusers = response;

		})
		
		vm.users = loadPage();
		function loadPage(){
			Report.getUsers('', function(response) {
				vm.users = response;
			})
			vm.reportType = 'agent';
		}
		
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		$scope.report = function() {
			if (vm.reportType == 'agent' && vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getReport({
				id : vm.id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				$scope.search = "";
				$scope.reporthide = true;
			})

		}

		function sortResponse() {
			if (vm.reportType == 'agent' && vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getReport({
				id : vm.id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType : vm.reportType
			}, function(response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				$scope.search = "";
				$scope.reporthide = true;
			})
		}

		function downloadUserAgentReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.downloadUserAgentReport({
				id : vm.id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
			a.download = "users_agent_view_reportp.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}
		vm.detailedReport = detailedReport;

		vm.selecterange = selectRange;
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		function selectRange(range) {
			
               if (range == 'week') {   
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} else if (range == 'year') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setYear(date.getFullYear() - 1);
				vm.fromTime = date.getTime();
			}
		}
		function select2() {
			$(".select2").select2();
		}

		// Added for generating pdf start
		$scope.close = function() {
			$('#genericReport').show();
			$scope.reporthide = true;
			$('#report').hide();
		}
		$scope.loader = false;
		$(function() {
			$scope.getPdf = function() {
				$scope.loader = true;
				html2canvas(reportpdf, {
					onrendered : function(canvas) {
						var img = canvas.toDataURL("image/png");
						var pdf = new jsPDF('landscape', 'mm', 'a2');
						pdf.addImage(img, 'JPEG', 0, 0);
						pdf.save($scope.pdftype);
						$scope.loader = false;
					}
				});
				$interval(function() {
				}, 1000);
			}
		});
		// Added for generating pdf end
		function detailedReport(id) {
			Report.getDetailedReport({
				id : id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {
				vm.detailedReportCounts = response;

				$('#report').show();
				$scope.reporthide = false;
				$('#genericReport').hide();

				if (vm.reportType == 'agent') {
					$scope.pdftype = 'Agent.pdf';

				}

			})
		}

		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		$scope.batteryreport = function() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			Report.getbatteryReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
				$scope.batteryline = response;
				$scope.battery = [];
				$scope.createTime = [];
				angular.forEach($scope.batteryline, function(value, key) {
					$scope.battery.push(value.batteryValue);
					$scope.createTime.push($filter('date')(value.createTime, dateFormat));
				});

				Highcharts.chart('battery_graph', {

					title : {
						text : 'Battery Usage Report'
					},

					subtitle : {
						text : ''
					},

					yAxis : {
						title : {
							text : 'Battery Percentage'
						}
					},
					legend : {
						layout : 'vertical',
						align : 'right',
						verticalAlign : 'middle'
					},
					xAxis : {
						categories : $scope.createTime
					},

					series : [ {
						name : ' ',
						data : $scope.battery
					} ],
					credits : {
						enabled : false
					},
					exporting : {
						buttons : {
							contextButton : {
								menuItems : [ {
									textKey : 'downloadPNG',
									onclick : function() {
										var fileName = "battery_report";
										this.exportChart({
											filename : fileName
										});
									}
								}, {
									textKey : 'downloadPDF',
									onclick : function() {
										this.exportChart({
											type : 'application/pdf'
										});
									}
								} ]
							}
						}
					}

				});

			})
		}

		$scope.distancereport = function() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			Report.getDistanceReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
				$scope.distanceData = response;
				$scope.distance = [];
				$scope.date = [];

				angular.forEach($scope.distanceData, function(value, key) {
					$scope.distance.push(value.distance);
					$scope.date.push(value.date);
				});

				Highcharts.chart('distance_graph', {

					title : {
						text : 'Distance Travelled Report'
					},

					subtitle : {
						text : ''
					},

					yAxis : {
						title : {
							text : 'Distance Travelled in KM'
						}
					},
					legend : {
						layout : 'vertical',
						align : 'right',
						verticalAlign : 'middle'
					},
					xAxis : {
						categories : $scope.date
					},
					series : [ {
						name : 'Distance in km',
						data : $scope.distance
					} ],
					credits : {
						enabled : false
					},
					exporting : {
						buttons : {
							contextButton : {
								menuItems : [ {
									textKey : 'downloadPNG',
									onclick : function() {
										var fileName = "distance_report";
										this.exportChart({
											filename : fileName
										});
									}
								}, {
									textKey : 'downloadPDF',
									onclick : function() {
										this.exportChart({
											type : 'application/pdf'
										});
									}
								} ]
							}
						}
					}

				});

			})
		}				
 }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('TeamReportController', TeamReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce){
    return function(text) {
        return $sce.trustAsHtml(text);
    	};
	}]);

	TeamReportController.$inject = [ '$scope','$sce' ,'$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval','Principal' ];

	function TeamReportController($scope, $sce,$state, Report, $rootScope, $timeout, $window, $filter, $interval,Principal) {
		var vm = this;
		vm.users = [];
		
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		vm.openCalendar = openCalendar;
		vm.reportGenerated = false;
		vm.reportGeneratedFileName='';
		
		vm.datePickerOpenStatus = {};
		$scope.reporthide = false;
		vm.reportUser = $rootScope.userName;
		vm.users = loadPage();
		function loadPage(){
			Report.getUsers('', function(response) {
				vm.users = response;
			})
		}
		$scope.loader = false;
		
		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		
		
		$scope.report = function() {
		
			Report.getTeamReport({
					"fromDateTime":vm.fromTime,
					"toDateTime":vm.toTime,
					"login":vm.reportUser,
				}, function(response) {
					$scope.myhtml = response;
				});
			vm.reportGenerated = true;
		}
		
		$scope.download = function() {
			window.location.href = "/images/TeamReport.xls";
		}
		
	}

})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("SurveyReportController", SurveyReportController);

    SurveyReportController.$inject = ["UserMasterGeofences","MiniGeofencesByMasterID","Report","CustomAssetTypeAttribute"
    ];

    function SurveyReportController(UserMasterGeofences,MiniGeofencesByMasterID,Report,CustomAssetTypeAttribute
    ) {
        var vm = this;
        $(".select2").select2();
        load();
        vm.statuslabel = {
            search          : "Search",
            nothingSelected : "Select",
            selectAll       : "All",
            selectNone      : "None", 
            Done : "Done" 
        }
        vm.statusType = []
        vm.selectedstatusType = null
        var authoritiesList,activityTypeList,terrainTypeList,existingInfraList,mappedAttributes
        var storeAuthority = [], storeactivity = [], storeterrain = [], storeexisting = []

        function load() {
            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                        });
                    }
                );
            });

            CustomAssetTypeAttribute.query({
                page: 0,
                size: 100,
                sort: 'id,asc'
            }, onSuccess, onError);
            function onSuccess(data) {
                data.forEach(function(item){
                    if(item.name == "Authority"){
                        vm.statusType.push( {   value: '<strong>Authority</strong>' , msGroup: true })
                        item.customAssetTypeAttributeValues.forEach(function(attribute){
                            vm.statusType.push(attribute)
                            storeAuthority.push(attribute.id)
                        })
                        vm.statusType.push( {   msGroup: false })
                    }

                    if(item.name == "Terrain Type"){
                        vm.statusType.push( {   value: '<strong>Terrain Type</strong>' , msGroup: true })
                        item.customAssetTypeAttributeValues.forEach(function(attribute){
                            vm.statusType.push(attribute)
                            storeterrain.push(attribute.id)
                        })
                        vm.statusType.push( {   msGroup: false })
                    }

                    if(item.name == "Activity Type"){
                        vm.statusType.push( {   value: '<strong>Activity Type</strong>' , msGroup: true })
                        item.customAssetTypeAttributeValues.forEach(function(attribute){
                            vm.statusType.push(attribute)
                            storeactivity.push(attribute.id)
                        })
                        vm.statusType.push( {   msGroup: false })
                    }

                    if(item.name == "Existing Infra"){
                        vm.statusType.push( {   value: '<strong>Existing Infra</strong>' , msGroup: true })
                        item.customAssetTypeAttributeValues.forEach(function(attribute){
                            vm.statusType.push(attribute)
                            storeexisting.push(attribute.id)
                        })
                        vm.statusType.push( {   msGroup: false })
                    }
                })
            
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.selectedGeofenceId="";
            vm.geofenceMini = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );
        };

        vm.downloadSurveyReport = function (){
            Report.getSurveyReportDownload({
                id: vm.selectedGeofenceId,
                "attributeMap": mappedAttributes
            }, function (response) {
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([(response)], { type: 'application/csv' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "survey_report.csv";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
        }

        vm.savePriorityStatusFilter = function(){
            authoritiesList = [],activityTypeList = [],terrainTypeList = [],existingInfraList = []
            authoritiesList = vm.selectedstatusType.filter(function(item) {
                return storeAuthority.indexOf(item.id) !== -1;
            }).map(function(item) {
                return item.value;
            });

            activityTypeList = vm.selectedstatusType.filter(function(item) {
                return storeactivity.indexOf(item.id) !== -1;
            }).map(function(item) {
                return item.value;
            });

            terrainTypeList = vm.selectedstatusType.filter(function(item) {
                return storeterrain.indexOf(item.id) !== -1;
            }).map(function(item) {
                return item.value;
            });

            existingInfraList = vm.selectedstatusType.filter(function(item) {
                return storeexisting.indexOf(item.id) !== -1;
            }).map(function(item) {
                return item.value;
            });

            mappedAttributes = {}
        if(authoritiesList.length > 0){
            mappedAttributes.Authority = authoritiesList
        }
        if(activityTypeList.length > 0){
            mappedAttributes["Activity Type"] = activityTypeList
        }
        if(terrainTypeList.length > 0){
            mappedAttributes["Terrain Type"] = terrainTypeList
        }
        if(existingInfraList.length > 0){
            mappedAttributes["Existing Type"] = existingInfraList
        }
        }

        vm.surveyReport = function(){
            vm.surveyTotalLength = 0
            Report.getSurveyReportList({
                id: vm.selectedGeofenceId,
                "attributeMap": mappedAttributes
            },function (response){
                vm.surveyReportList = response
                if(vm.surveyReportList.length > 0){
                    vm.surveyReportList.forEach(function(item){
                        vm.surveyTotalLength += item.asset_length
                    })
                }
            }) 
        }
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('SplicingReportController', SplicingReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	SplicingReportController.$inject = ['$scope', '$sce', '$state', '$localStorage', 'AlertService', 'AllCaseTypes', 'TrCasesForType', 'Report', 'BaseUrl'];

	function SplicingReportController($scope, $sce, $state, $localStorage, AlertService, AllCaseTypes, TrCasesForType, Report, BaseUrl) {
		var vm = this;
		vm.downloadSplicingReport = downloadSplicingReport;
		vm.selectedCaseTypeId = null;
		vm.selectedCaseId = null;
		vm.select2 = select2;
		vm.select2();
		vm.caseTypes = [];
		vm.cases = [];

		AllCaseTypes.getAll(function (response) {
			response.forEach(function(caseType){
				if(caseType.name == "Splicing Details" || caseType.name == "Termination Details" ) {
					vm.caseTypes.push(caseType);
				}
			});
		});

		$scope.onCaseTypeChange = function () {
			vm.cases = [];
			TrCasesForType.query(
				{
					caseTypeId: vm.selectedCaseTypeId,
				},
				onSuccess,
				onError
			);

			function onSuccess(data, headers) {
				vm.cases = data;
			}

			function onError(error) {
				AlertService.error(error.data.message);
			}
        };

		function downloadSplicingReport() {
			BaseUrl.getBaseUrl(function(baseurl){
				var request = new XMLHttpRequest();
				request.open('GET', baseurl.stringValue+"api/download-splicing-pdf/"+vm.selectedCaseId, true);
				request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
				request.responseType = 'blob';
				
				request.onload = function(e) {
					if (this.status === 200) {
						var blob = this.response;
						if(blob.size > 0){
							var blob = new Blob([this.response], {type: 'application/pdf'});
							var link = document.createElement('a');
							link.href = window.URL.createObjectURL(blob);
							link.download = "document.pdf";
							vm.caseTypes.forEach(function(value){
								if(value.id == vm.selectedCaseTypeId){
									link.download = value.name + ".pdf";
								}
							});
							
							link.click();
							
						}
					}
				};
				request.send();
			});

		}

		function select2() {
			$(".select2").select2();
		}

	}
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('SiteStatusReportController', SiteStatusReportController)

    SiteStatusReportController.$inject = ['$scope', 'UsersList', 'TrCaseForMap', 'CasesForMapByAdmin', 'Principal'];

    function SiteStatusReportController($scope, UsersList, TrCaseForMap, CasesForMapByAdmin, Principal) {
        var vm = this;
        vm.userlist = [];
        $scope.reporthide = false;
        vm.select2 = select2;
        vm.select2();
        vm.users = loadPage();
        vm.multiassets = [];
        vm.selectedVendor = "";

        function loadPage() {
            var loggedInUserId = 0;
  
            Principal.identity().then(function (identity) {
                if (identity) {
                    loggedInUserId = identity.id;
                }
            })
            UsersList.getusers(function (response) {
                var users = [];
                response.forEach(function (item, index) {
                    if (item.authorities.includes("ROLE_USER_ADMIN") && (item.id != loggedInUserId)) {
                        users.push(item)
                    }
                });
                vm.userlist = users;
                var vendorData = [];
                vm.userlist.forEach(function (item) {

                    CasesForMapByAdmin.casesformapbyadmin(item.id, function (response) {
                        var OnAirCaseCount = 0;
                        response.forEach(function (item1, index) {
                            var caseAV = item1.caseTypeAttributeValues;
                            caseAV.forEach(function (item2) {
                                if (item2.caseDataTypeName == 'Fiber Status') {
                                    if (item2.attributeValue == 'On Air') {
                                        OnAirCaseCount++;
                                    }
                                }
                            });
                        });
                        vendorData.push({
                            label: item.firstName + " " + item.lastName,
                            value: OnAirCaseCount
                        });

                        var donut = new Morris.Donut({
                            element: 'vendor-chart',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });
                        
                        var donut1 = new Morris.Donut({
                            element: 'vendor-chart1',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });
                        $scope.reporthide = true;
                    });

                });

            });

            vm.reportType = 'agent';
        }

		     

//        vm.caseTypeClick = function (caseTypeName) {
//            if (vm.selectedVendor != "") {
//            	
//            	
//                var vendorName = "";
//
//                vm.userlist.forEach(function (userVal) {
//                    if (userVal.id == vm.selectedVendor) {
//                        vendorName = userVal.firstName + " " + userVal.lastName;
//                    }
//                });
//
//                var vendorData = [];
//                CasesForMapByAdmin.casesformapbyadmin(vm.selectedVendor, function (response) {
//                	
//	                    var OnAirCaseCount = 0;
//	                    var result = [];
//	                    var grouped = {};
//	
//	                    response.forEach(function (item) {
//	                    	if(item.caseTypeName == caseTypeName){
//		                        var caseAV = item.caseTypeAttributeValues;
//		                        var onAirCount = 0;
//		                        var underDeploymentCount = 0;
//		                        var plannedCount = 0;
//		                        caseAV.forEach(function (item1) {
//		                            if (item1.caseDataTypeName == 'Fiber Status') {
//		                                if (item1.attributeValue == 'On Air') {
//		                                    onAirCount++;
//		                                    OnAirCaseCount++;
//		                                } else if (item1.attributeValue == 'Under Deployment') {
//		                                    underDeploymentCount++;
//		                                } else if (item1.attributeValue == 'Planned') {
//		                                    plannedCount++;
//		                                }
//		                            }
//		                        });
//		                        result.push({
//		                            name: item.caseTypeName,
//		                            onair: onAirCount,
//		                            deployed: underDeploymentCount,
//		                            planned: plannedCount
//		                        });
//	                    	}
//	                    });
//	
//	                    result.forEach(function (a) {
//	                        grouped[a.name] = grouped[a.name] || [];
//	                        grouped[a.name].push({
//	                            name: a.name,
//	                            onair: a.onair,
//	                            deployed: a.deployed,
//	                            planned: a.planned
//	                        });
//	                    });
//	                    result = Object.values(grouped);
//	                    result.forEach(function (item) {
//	                        var name = "";
//	                        var onAirVal = 0;
//	                        var deployedVal = 0;
//	                        var plannedVal = 0;
//	                        item.forEach(function (item1) {
//	                            name = item1.name;
//	                            onAirVal += item1.onair;
//	                            deployedVal += item1.deployed;
//	                            plannedVal += item1.planned;
//	                        });
//	                        vm.multiassets.push({
//	                            name: name,
//	                            onair: onAirVal,
//	                            deployed: deployedVal,
//	                            planned: plannedVal
//	                        });
//	                    });
//	                    vendorData.push({
//	                        label: vendorName,
//	                        value: OnAirCaseCount
//	                    });
//	
//	                    var donut = new Morris.Donut({
//	                        element: 'vendor-chart',
//	                        resize: true,
//	                        colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
//	                        data: vendorData,
//	                        hideHover: 'auto'
//	                    });
//                });
//            }else{
//              	vm.selectedVendor = "";
//                var vendorData = [];
//                vm.userlist.forEach(function (item) {
//                    CasesForMapByAdmin.casesformapbyadmin(item.id, function (response) {
//                        var OnAirCaseCount = 0;
//                        response.forEach(function (item1, index) {
//                        	if(item1.caseTypeName == caseTypeName){
//	                            var caseAV = item1.caseTypeAttributeValues;
//	                            caseAV.forEach(function (item2) {
//	                                if (item2.caseDataTypeName == 'Fiber Status') {
//	                                    if (item2.attributeValue == 'On Air') {
//	                                        OnAirCaseCount++;
//	                                    }
//	                                }
//	                            });
//                        	}
//                        });
//                        vendorData.push({
//                            label: item.firstName + " " + item.lastName,
//                            value: OnAirCaseCount
//                        });
//
//                        var donut = new Morris.Donut({
//                            element: 'vendor-chart',
//                            resize: true,
//                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
//                            data: vendorData,
//                            hideHover: 'auto'
//                        });
//                    });
//                });
//                TrCaseForMap.getAllCases(function (response) {
//                    var result = [];
//                    var grouped = {};
//
//                    response.forEach(function (item) {
//                    	if(item.caseTypeName == caseTypeName){
//	                        var caseAV = item.caseTypeAttributeValues;
//	                        var onAirCount = 0;
//	                        var underDeploymentCount = 0;
//	                        var plannedCount = 0;
//	                        caseAV.forEach(function (item1) {
//	                            if (item1.caseDataTypeName == 'Fiber Status') {
//	                                if (item1.attributeValue == 'On Air') {
//	                                    onAirCount++;
//	                                } else if (item1.attributeValue == 'Under Deployment') {
//	                                    underDeploymentCount++;
//	                                } else if (item1.attributeValue == 'Planned') {
//	                                    plannedCount++;
//	                                }
//	                            }
//	                        });
//	                        result.push({
//	                            name: item.caseTypeName,
//	                            onair: onAirCount,
//	                            deployed: underDeploymentCount,
//	                            planned: plannedCount
//	                        });
//                    	}
//                    });
//
//                    result.forEach(function (a) {
//                        grouped[a.name] = grouped[a.name] || [];
//                        grouped[a.name].push({
//                            name: a.name,
//                            onair: a.onair,
//                            deployed: a.deployed,
//                            planned: a.planned
//                        });
//                    });
//                    result = Object.values(grouped);
//                    result.forEach(function (item) {
//                        var name = "";
//                        var onAirVal = 0;
//                        var deployedVal = 0;
//                        var plannedVal = 0;
//                        item.forEach(function (item1) {
//                            name = item1.name;
//                            onAirVal += item1.onair;
//                            deployedVal += item1.deployed;
//                            plannedVal += item1.planned;
//                        });
//                        vm.multiassets.push({
//                            name: name,
//                            onair: onAirVal,
//                            deployed: deployedVal,
//                            planned: plannedVal
//                        });
//                    });
//                });
//            }
//        };

        function select2() {
            $(".select2").select2();
        }


        $("#userlist").change(function () {
            vm.multiassets = [];
            var result = $("#userlist").val();
            if (result != "") {
            	vm.selectedVendor = result;
                var vendorName = "";

                vm.userlist.forEach(function (userVal) {
                    if (userVal.id == result) {
                        vendorName = userVal.firstName + " " + userVal.lastName;
                    }
                });

                var vendorData = [];
                CasesForMapByAdmin.casesformapbyadmin(result, function (response) {
                    var OnAirCaseCount = 0;
                    var result = [];
                    var grouped = {};

                    response.forEach(function (item) {
                        var caseAV = item.caseTypeAttributeValues;
                        var onAirCount = 0;
                        var underDeploymentCount = 0;
                        var plannedCount = 0;
                        caseAV.forEach(function (item1) {
                            if (item1.caseDataTypeName == 'Fiber Status') {
                                if (item1.attributeValue == 'On Air') {
                                    onAirCount++;
                                    OnAirCaseCount++;
                                } else if (item1.attributeValue == 'Under Deployment') {
                                    underDeploymentCount++;
                                } else if (item1.attributeValue == 'Planned') {
                                    plannedCount++;
                                }
                            }
                        });
                        result.push({
                            name: item.caseTypeName,
                            onair: onAirCount,
                            deployed: underDeploymentCount,
                            planned: plannedCount
                        });
                    });

                    result.forEach(function (a) {
                        grouped[a.name] = grouped[a.name] || [];
                        grouped[a.name].push({
                            name: a.name,
                            onair: a.onair,
                            deployed: a.deployed,
                            planned: a.planned
                        });
                    });
                    result = Object.values(grouped);
                    result.forEach(function (item) {
                        var name = "";
                        var onAirVal = 0;
                        var deployedVal = 0;
                        var plannedVal = 0;
                        item.forEach(function (item1) {
                            name = item1.name;
                            onAirVal += item1.onair;
                            deployedVal += item1.deployed;
                            plannedVal += item1.planned;
                        });
                        vm.multiassets.push({
                            name: name,
                            onair: onAirVal,
                            deployed: deployedVal,
                            planned: plannedVal
                        });
                    });
                    vendorData.push({
                        label: vendorName,
                        value: OnAirCaseCount
                    });

                    var donut = new Morris.Donut({
                        element: 'vendor-chart',
                        resize: true,
                        colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                        data: vendorData,
                        hideHover: 'auto'
                    });
                    var donut1 = new Morris.Donut({
                        element: 'vendor-chart1',
                        resize: true,
                        colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                        data: vendorData,
                        hideHover: 'auto'
                    });
                });
            } else {
            	vm.selectedVendor = "";
                var vendorData = [];
                vm.userlist.forEach(function (item) {
                    CasesForMapByAdmin.casesformapbyadmin(item.id, function (response) {
                        var OnAirCaseCount = 0;
                        response.forEach(function (item1, index) {
                            var caseAV = item1.caseTypeAttributeValues;
                            caseAV.forEach(function (item2) {
                                if (item2.caseDataTypeName == 'Fiber Status') {
                                    if (item2.attributeValue == 'On Air') {
                                        OnAirCaseCount++;
                                    }
                                }
                            });
                        });
                        vendorData.push({
                            label: item.firstName + " " + item.lastName,
                            value: OnAirCaseCount
                        });

                        var donut = new Morris.Donut({
                            element: 'vendor-chart',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });
                        
                        var donut1 = new Morris.Donut({
                            element: 'vendor-chart1',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });
                    });
                });
                TrCaseForMap.getAllCases(function (response) {
                    var result = [];
                    var grouped = {};

                    response.forEach(function (item) {
                        var caseAV = item.caseTypeAttributeValues;
                        var onAirCount = 0;
                        var underDeploymentCount = 0;
                        var plannedCount = 0;
                        caseAV.forEach(function (item1) {
                            if (item1.caseDataTypeName == 'Fiber Status') {
                                if (item1.attributeValue == 'On Air') {
                                    onAirCount++;
                                } else if (item1.attributeValue == 'Under Deployment') {
                                    underDeploymentCount++;
                                } else if (item1.attributeValue == 'Planned') {
                                    plannedCount++;
                                }
                            }
                        });
                        result.push({
                            name: item.caseTypeName,
                            onair: onAirCount,
                            deployed: underDeploymentCount,
                            planned: plannedCount
                        });
                    });

                    result.forEach(function (a) {
                        grouped[a.name] = grouped[a.name] || [];
                        grouped[a.name].push({
                            name: a.name,
                            onair: a.onair,
                            deployed: a.deployed,
                            planned: a.planned
                        });
                    });
                    result = Object.values(grouped);
                    result.forEach(function (item) {
                        var name = "";
                        var onAirVal = 0;
                        var deployedVal = 0;
                        var plannedVal = 0;
                        item.forEach(function (item1) {
                            name = item1.name;
                            onAirVal += item1.onair;
                            deployedVal += item1.deployed;
                            plannedVal += item1.planned;
                        });
                        vm.multiassets.push({
                            name: name,
                            onair: onAirVal,
                            deployed: deployedVal,
                            planned: plannedVal
                        });
                    });
                });
            }
        });

        $('#userlist').trigger('change');

        // Added for generating pdf start
        $scope.close = function () {
            $('#genericReport').show();
            $scope.reporthide = true;
            $('#report').hide();
        }
        $scope.loader = false;


    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("report", {
                abstract: true,
                parent: "app",
            })
            .state("generic-report", {
                parent: "report",
                url: "/generic-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/report.html",
                        controller: "ReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("geofence-report", {
                parent: "report",
                url: "/geofence-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.geofence-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/geofence-report.html",
                        controller: "GeofenceReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            /*   
               .state('asset-type-site-report', {
                   parent: 'report',
                   url: '/asset-type-site-report',
                   data: {
                       authorities: ['ROLE_USER', 'ROLE_USER_ADMIN'],
                       pageTitle: 'trakeyeApp.report.asset-type-site-report'
                   },
                   views: {
                       'content@': {
                           templateUrl: 'app/report/asset-type-site-report.html',
                           controller: 'AssetTypeSiteReportController',
                           controllerAs: 'vm'
                       }
                   },
                   resolve: {
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                           $translatePartialLoader.addPart('reports');
                           $translatePartialLoader.addPart('logSource');
                           $translatePartialLoader.addPart('global');
                           return $translate.refresh();
                   }]
                   }
               })*/

            .state("case-report", {
                parent: "report",
                url: "/case-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-report.html",
                        controller: "CaseReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("case-type-report", {
                parent: "report",
                url: "/case-type-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-type-report.html",
                        controller: "CaseReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("entity-dump", {
                parent: "report",
                url: "/entity-dump",
                data: {
                    pageTitle: "trakeyeApp.report.entity-dump",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/entity-dump.html",
                        controller: "EntityDumpController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state('entity-dump.new', {
                parent: 'entity-dump',
                url: '/create',
                views: {
                    'content@': {
                        templateUrl: 'app/report/entity-dump-dialog.html',
                        controller: 'EntityDumpDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state('asset-kml-dump-dialog', {
                parent: 'report',
                url: '/asset-kml-dump-dialog',
                views: {
                    'content@': {
                        templateUrl: 'app/report/asset-kml-dump-dialog.html',
                        controller: 'AssetKmlDumpDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("asset-health-report", {
                parent: "report",
                url: "/asset-health",
                data: {
                    pageTitle: "trakeyeApp.report.asset-health-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-health-report.html",
                        controller: "AssetHealthController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("asset-health-status-report", {
                parent: "report",
                url: "/asset-health-status",
                data: {
                    pageTitle: "trakeyeApp.report.asset-health-status-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-health-status-report.html",
                        controller: "AssetHealthStatusController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("asset-geofence-mapping", {
                parent: "report",
                url: "/asset-geofence-mapping",
                data: {
                    pageTitle: "trakeyeApp.report.asset-geofence-mapping",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-geofence-mapping.html",
                        controller: "AssetGeofenceMappingController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("geofence-dump", {
                parent: "report",
                url: "/geofence-dump",
                data: {
                    authorities: ["ROLE_USER_ADMIN"],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/geofence-dump.html",
                        controller: "GeofenceDumpController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("splicing-report", {
                parent: "report",
                url: "/splicing-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/splicing-report.html",
                        controller: "SplicingReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-agent-report", {
                parent: "report",
                url: "/user-agent-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.user-agent-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/user-agent-report.html",
                        controller: "UserAgentReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("fiber-status-report", {
                parent: "report",
                url: "/fiber-status-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.fiber-status-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/fiber-status-report.html",
                        controller: "FiberStatusReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("site-status-report", {
                parent: "report",
                url: "/site-status-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.site-status-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/site-status-report.html",
                        controller: "SiteStatusReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("case-aging-report", {
                parent: "report",
                url: "/case-aging-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-aging-report.html",
                        controller: "CaseAgingReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            $translatePartialLoader.addPart("caseAgingReport");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("distance-report", {
                parent: "report",
                url: "/distance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.distance-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/distance-report.html",
                        controller: "DistanceReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("battery-report", {
                parent: "report",
                url: "/battery-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.battery-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/battery-report.html",
                        controller: "ReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("distance-travelled", {
                parent: "report",
                url: "/distance-travelled",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.distance-travelled",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/distance-travelled.html",
                        controller: "ReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("asset-report", {
                parent: "report",
                url: "/asset-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.asset-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-report.html",
                        controller: "AssetReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("asset-case-report", {
                parent: "report",
                url: "/asset-case-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.asset-case-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-case-report.html",
                        controller: "AssetCaseReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("case-tat-report", {
                parent: "report",
                url: "/case-tat-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.tat.tat-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-tat-report.html",
                        controller: "CaseTatReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            $translatePartialLoader.addPart("caseTatReport");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("team-report", {
                parent: "report",
                url: "/team-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.teamreport.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/team-report.html",
                        controller: "TeamReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            $translatePartialLoader.addPart("teamReport");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("field-user-report", {
                parent: "report",
                url: "/field-user-report",
                data: {
                    authorities: ["ROLE_USER", "ROLE_USER_ADMIN"],
                    pageTitle: "trakeyeApp.report.distance-travelled",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/field-user-report.html",
                        controller: "UserAgentReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("case-user-report", {
                parent: "report",
                url: "/case-user-report",
                data: {
                    authorities: ["ROLE_USER", "ROLE_USER_ADMIN"],
                    pageTitle: "trakeyeApp.report.distance-travelled",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-user-report.html",
                        controller: "CaseAgingReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-attendance-report", {
                parent: "report",
                url: "/user-attendance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/user-attendance-report.html",
                        controller: "UserAttendaceController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("mobile-user-attendance-report", {
                parent: "report",
                url: "/mobile-user-attendance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/mobile-user-attendance-report.html",
                        controller: "MobileUserAttendaceController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("gps-user-attendance-report", {
                parent: "report",
                url: "/gps-user-attendance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/gps-user-attendance-report.html",
                        controller: "GpsUserAttendaceController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-login-history-report", {
                parent: "report",
                url: "/user-login-history-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/user-login-history-report.html",
                        controller: "UserLoginHistoryReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("user-geofence-report", {
                parent: "report",
                url: "/user-geofence-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/user-geofence-report.html",
                        controller: "UserGeofenceReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("vehicle-distance-report", {
                parent: "report",
                url: "/vehicle-distance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/vehicle-distance-report.html",
                        controller: "VehicleDistanceController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-stats-report", {
                parent: "report",
                url: "/user-stats-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/user-stats-report.html",
                        controller: "UserStatsController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("cases-dump-report", {
                parent: "report",
                url: "/cases-dump-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/cases-dump-report.html",
                        controller: "CasesDumpController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-reporting-report", {
                parent: "report",
                url: "/user-reporting-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/user-reporting-report.html",
                        controller: "UserReportingController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("survey-report", {
                parent: "report",
                url: "/survey-report",
                data: {
                    pageTitle: "trakeyeApp.report.survey-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/survey-report.html",
                        controller: "SurveyReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
             .state("buried-chamber-report", {
                parent: "report",
                url: "/buried-chamber-report",
                data: {
                    pageTitle: "trakeyeApp.report.burried-report",
                },
                views: {
                    "content@": {
                        templateUrl:"app/report/burried-chamber-report.html",
                        controller: "BurriedChamberReportController",
                        
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("Report", [
        "$rootScope",
        "$http",

        function ($rootScope, $http) {
            var service = {};
            
            service.getListEntity = function (callback) {
                $http.get("api/reports/email-report").then(function (response) {
                    callback(response.data);
                });
            };

            service.getUsers = function (name, callback) {
                $http.get("api/userslist").then(function (response) {
                    callback(response.data);
                });
            };
            service.getVehicles = function (name, callback) {
                $http.get("api/vehicleslist").then(function (response) {
                    callback(response.data);
                });
            };
            service.getGeofences = function (name, callback) {
                $http.get("api/geofenceslist").then(function (response) {
                    callback(response.data);
                });
            };
            service.getReport = function (data, callback) {
                $http.post("api/reports/view", data).then(function (response) {
                    callback(response.data);
                });
            };
            service.downloadUserAgentReport = function (data, callback) {
                $http
                    .post("api/reports/download-user-agent-view-report", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            
            service.downloadPdfReport = function (data, callback) {
                $http
                    .post("api/download-splicing-pdf", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAttendenceReport = function (data, callback) {
                $http
                    .post("api/reports/attendence-view", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAssetHealthListWithGeoReport = function (data, callback) {
                $http
                    .post("api/asset-health-list-with-geofence", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getUserLastLoginReport = function (data, callback) {
                $http
                    .post("api/reports/user-last-login", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadUserLastLoginReport = function (data, callback) {
                $http
                    .post("api/reports/download-user-last-login", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadUserGeofenceReport = function (data, callback) {
                $http
                    .post("api/reports/download-user-geofence", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadGeofenceDump = function (data, callback) {
                $http
                    .post("api/reports/download-geofence", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.emailReport = function (
                data,
                successCallback,
                errorCallback
            ) {
                $http
                    .post("api/reports/email-report", data)

                    .then(
                        function (response) {
                            successCallback(response.data);
                        },
                        function (response) {
                            // this function handles error
                            errorCallback(response);
                        }
                    );
            };

            service.downloadKmlAssetReport = function (
                data,
                successCallback,
                errorCallback
            ) {
                $http
                    .post("api/reports/asset-kml-report", data)

                    .then(
                        function (response) {
                            successCallback(response.data);
                        },
                        function (response) {
                            // this function handles error
                            errorCallback(response);
                        }
                    );
            };

            service.downloadGeofenceDumpKml = function (data, callback) {
                $http
                    .post("api/reports/download-geofence-kml", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getVehicleDistanceReport = function (data, callback) {
                $http
                    .post("api/reports/vehicleDistanceReport", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getUserStatsReport = function (data, callback) {
                $http
                    .post("api/reports/userDistStats", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getUsersAroundCase = function (data, callback) {
                $http
                    .post("api/reports/viewUsersArounCase", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAttendenceReportDownload = function (data, callback) {
                $http
                    .post("api/reports/download-attendence-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getBurriedReportDownload = function (data, callback) {
                $http
                    .post("api/reports/download-burried-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getVehicleDistanceReportDownload = function (
                data,
                callback
            ) {
                $http
                    .post("api/reports/download-vehicle-distance-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getUserDistanceStatsReportDownload = function (
                data,
                callback
            ) {
                $http
                    .post("api/reports/download-user-dist-stats-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getOpenCasesReportDownload = function (data, callback) {
                $http
                    .post("api/download-opencases-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAssetHealthStatusReportDownload = function (data, callback) {
                $http
                    .post("api/download-assethealthstatus-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getClosedCasesReportDownload = function (data, callback) {
                $http
                    .post("api/download-closedcases-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getReportingReport = function (data, callback) {
                $http
                    .post("api/reports/user-reporting-report", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadReportingReport = function (data, callback) {
                $http
                    .post("api/reports/download-user-reporting-report", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getCaseReport = function (data, callback) {
                $http
                    .post("api/download-cases-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getCaseReportList = function (data, callback) {
                $http
                    .post("api/cases-reports-list", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getDetailedReport = function (data, callback) {
                $http.post("api/reports/detailed-report", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getbatteryReport = function (
                login,
                fromtime,
                totime,
                callback
            ) {
                $http
                    .get(
                        "api/reports/batteryreport/" +
                            login +
                            "/" +
                            fromtime +
                            "/" +
                            totime
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getDistanceReport = function (
                login,
                fromtime,
                totime,
                callback
            ) {
                $http
                    .get(
                        "api/reports/distancereport/" +
                            login +
                            "/" +
                            fromtime +
                            "/" +
                            totime
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getCasesReport = function (data, callback) {
                $http.post("api/reports/cases", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getCasesAgingReport = function (data, callback) {
                $http.post("api/reports/caseagingreport", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getCasesTatReport = function (data, callback) {
                $http.post("api/reports/casetatreport", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getCasesMttrReport = function (
                ageType,
                fromDate,
                toDate,
                callback
            ) {
                $http
                    .get(
                        "api/tr-cases-report/" +
                            ageType +
                            "/" +
                            fromDate +
                            "/" +
                            toDate
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getTeamReport = function (data, callback) {
                $http.post("api/reports/teamreport", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getDistReport = function (data, callback) {
                $http.post("api/reports/distance", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };
            service.getAssetReport = function (
                assetIdReport,
                casetypeid,
                attname,
                fromDate,
                toDate,
                callback
            ) {
                $http
                    .get(
                        "api/reports/assetreport/" +
                            assetIdReport +
                            "/" +
                            casetypeid +
                            "/" +
                            attname +
                            "/" +
                            fromDate +
                            "/" +
                            toDate
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getAssetCaseTypeReport = function (
                assetIdReport,
                fromDate,
                toDate,
                callback
            ) {
                $http
                    .get(
                        "api/reports/assetcasetypereport/" +
                            assetIdReport +
                            "/" +
                            fromDate +
                            "/" +
                            toDate
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAssetCaseReport = function (
                casetypeid,
                fromDate,
                toDate,
                callback
            ) {
                $http
                    .get(
                        "api/reports/assetcasereport/" +
                            casetypeid +
                            "/" +
                            fromDate +
                            "/" +
                            toDate
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAssetCaseReportSearch = function (
                casetypeid,
                fromDate,
                toDate,
                searchText,
                callback
            ) {
                $http
                    .get(
                        "api/reports/assetcasereport/" +
                            casetypeid +
                            "/" +
                            fromDate +
                            "/" +
                            toDate +
                            "/" +
                            searchText
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getSurveyReportDownload = function (data, callback) {
                $http
                    .post("api/download-assetsurvey-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getSurveyReportList = function (data, callback) {
                $http
                    .post("api/assetsurvey-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getBurriedReportList = function (data, callback) {
                $http
                    .post("api/reports/get-burried-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAssetNameByGeofences = function (data, callback) {
                $http
                    .post("api/chamberassetsname-geofences", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getEntityDetails = function (id, callback) {
                $http
                    .get("api/reports/trakeyereport/"+id)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadZip = function (id, imgId, callback) {
               /*  $http
                    .get("api/reports/trakeyereport/"+id+"/"+imgId)
                    .then(function (response) {
                        callback(response.data);
                    }); */
                    $http({
                        method: 'GET',
                        url: "api/reports/trakeyereport/"+id+"/"+imgId,
                        responseType: 'arraybuffer',
                    }).then(function (response) {
                        callback(response.data);
                    }).catch(function (error) {
                        console.error('Error during download:', error);
                    });
                    
                    
            };

            return service;
        },
    ]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('DumpRequest', DumpRequest);

    DumpRequest.$inject = ['$resource', 'DateUtils'];

    function DumpRequest($resource, DateUtils) {
        var resourceUrl = 'api/reports/email-report';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
(function() {
    'use strict';

    angular.module('trakeyeApp').controller('ReportController', ReportController)

    ReportController.$inject = ['$scope', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval'];

    function ReportController($scope, $state, Report, $rootScope, $timeout, $window, $filter, $interval) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.reportTypeChange = reportTypeChanged;
        vm.users = [];
        vm.batteryusers = [];
        vm.geofences = [];
        $scope.reporthide = false;
        vm.select2 = select2;
        var dateFormat = 'dd EEE HH:mm';
        var date = "dd EEE";
        vm.fromTime = 0;
        vm.toTime = 0;
        vm.today = today();
        // vm.today();
        vm.select2();
        Report.getUsers('', function(response) {
            vm.batteryusers = response;

        })

        function today() {
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }

        $scope.report = function() {
            if ((vm.reportType == 'geofence' && vm.geofence == 'all') || (vm.reportType == 'agent' && vm.userAgent == 'all')) {
                vm.id = 0;
            }
            Report.getReport({
                id: vm.id,
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                reportType: vm.reportType
            }, function(response) {

                if (response instanceof Array) {
                    vm.reportRecords = response;
                } else {
                    vm.reportRecords = [];
                    vm.reportRecords.push(response);
                }
                $scope.search = "";
                $scope.reporthide = true;
            })

        }
        vm.detailedReport = detailedReport;

        vm.selecterange = selectRange;
        vm.calculateToDate = calculateToDate;
        vm.calculateFromDate = calculateFromDate;

        function calculateFromDate() {

            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
        }

        function calculateToDate() {

            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }

        function selectRange(range) {
            if (range == 'week') {
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setDate(date.getDate() - 7)
                vm.fromTime = date.getTime();

            } else if (range == 'month') {

                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setMonth(date.getMonth() - 1);
                vm.fromTime = date.getTime();
            } else if (range == 'year') {

                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setYear(date.getFullYear() - 1);
                vm.fromTime = date.getTime();
            }
        }

        function select2() {
            $(".select2").select2();
        }

        function reportTypeChanged() {
            $scope.reporthide = false;
            if (vm.reportType == 'agent') {
                if (vm.users.length == 0) {
                    Report.getUsers('', function(response) {
                        vm.users = response;
                    })
                }
            } else if (vm.reportType == 'geofence') {
                if (vm.geofences.length == 0) {
                    Report.getGeofences('', function(response) {
                        vm.geofences = response;
                    })
                }
            }

        }
        // Added for generating pdf start
        $scope.close = function() {
            $('#genericReport').show();
            $scope.reporthide = true;
            $('#report').hide();
        }
        $scope.loader = false;
        $(function() {
            $scope.getPdf = function() {
                $scope.loader = true;
                html2canvas(reportpdf, {
                    onrendered: function(canvas) {
                        var img = canvas.toDataURL("image/png");
                        var pdf = new jsPDF('landscape', 'mm', 'a2');
                        pdf.addImage(img, 'JPEG', 0, 0);
                        pdf.save($scope.pdftype);
                        $scope.loader = false;
                    }
                });
                $interval(function() {}, 1000);
            }
        });
        // Added for generating pdf end
        function detailedReport(id) {
            Report.getDetailedReport({
                id: id,
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                reportType: vm.reportType
            }, function(response) {
                vm.detailedReportCounts = response;

                $('#report').show();
                $scope.reporthide = false;
                $('#genericReport').hide();

                if (vm.reportType == 'agent') {
                    $scope.pdftype = 'Agent.pdf';
                    /*var map = new google.maps.Map(document.getElementById('map_canvas'), {
                    	zoom : 13,
                    	center : new google.maps.LatLng(response.locations[0].lat, response.locations[0].lng)
                    });
                    var flightPath = new google.maps.Polyline({
                    	path : response.locations,
                    	geodesic : true,
                    	strokeColor : "#425cf4",
                    	strokeOpacity : 1,
                    	strokeWeight : 2,
                    	icons : [ {
                    		icon : {
                    			path : google.maps.SymbolPath.FORWARD_CLOSED_ARROW
                    		},
                    		offset : '25px',
                    		repeat : '50px'
                    	} ]
                    });
                    var startMarker = new google.maps.Marker({
                    	map : map,
                    	position : new google.maps.LatLng(response.locations[0].lat, response.locations[0].lng),
                    	title : 'Started here'
                    });
                    startMarker.setIcon('http://maps.google.com/mapfiles/ms/icons/green-dot.png');
                    var endMarker = new google.maps.Marker({
                    	map : map,
                    	position : new google.maps.LatLng(response.locations[response.locations.length - 1].lat, response.locations[response.locations.length - 1].lng),
                    	title : 'Ended here'
                    });
                    endMarker.setIcon('http://maps.google.com/mapfiles/ms/icons/red-dot.png');
                    flightPath.setMap(map);
                    setTimeout(function() {
                    	google.maps.event.trigger(map, "resize");
                    	map.setCenter(new google.maps.LatLng(response.locations[0].lat, response.locations[0].lng));
                    }, 100);*/

                } else if (vm.reportType == 'geofence') {
                    $scope.pdftype = 'Geofence.pdf';
                    var coordicates = JSON.parse(response.coordinates);
                    var map = new google.maps.Map(document.getElementById('map_canvas'), {
                        zoom: 13,
                        center: new google.maps.LatLng(coordicates[0].lat, coordicates[0].lng)
                    });

                    var polygon = new google.maps.Polygon({
                        path: coordicates,
                        strokeColor: "#ff0000",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#ff0000",
                        fillOpacity: 0.3,
                        editable: true
                    })
                    polygon.setMap(map);
                    setTimeout(function() {
                        google.maps.event.trigger(map, "resize");
                        map.setCenter(new google.maps.LatLng(coordicates[0].lat, coordicates[0].lng));
                    }, 100);
                }

            })
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;
        vm.datePickerOpenStatus.serviceDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $scope.batteryreport = function() {
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();

            Report.getbatteryReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
                $scope.batteryline = response;
                $scope.battery = [];
                $scope.createTime = [];
                angular.forEach($scope.batteryline, function(value, key) {
                    $scope.battery.push(value.batteryValue);
                    $scope.createTime.push($filter('date')(value.createTime, dateFormat));
                });

                Highcharts.chart('battery_graph', {

                    title: {
                        text: 'Battery Usage Report'
                    },

                    subtitle: {
                        text: ''
                    },

                    yAxis: {
                        title: {
                            text: 'Battery Percentage'
                        }
                    },
                    legend: {
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle'
                    },
                    xAxis: {
                        categories: $scope.createTime
                    },

                    series: [{
                        name: ' ',
                        data: $scope.battery
                    }],
                    credits: {
                        enabled: false
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                menuItems: [{
                                    textKey: 'downloadPNG',
                                    onclick: function() {
                                        var fileName = "battery_report";
                                        this.exportChart({
                                            filename: fileName
                                        });
                                    }
                                }, {
                                    textKey: 'downloadPDF',
                                    onclick: function() {
                                        this.exportChart({
                                            type: 'application/pdf'
                                        });
                                    }
                                }]
                            }
                        }
                    }

                });

            })
        }

        $scope.distancereport = function() {
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();

            Report.getDistanceReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
                $scope.distanceData = response;
                $scope.distance = [];
                $scope.date = [];

                angular.forEach($scope.distanceData, function(value, key) {
                    $scope.distance.push(value.distance);

                    // $scope.date.push($filter('date')(value.date,"dd EEE"));
                    $scope.date.push(value.date);
                });

                Highcharts.chart('distance_graph', {

                    title: {
                        text: 'Distance Travelled Report'
                    },

                    subtitle: {
                        text: ''
                    },

                    yAxis: {
                        title: {
                            text: 'Distance Travelled in KM'
                        }
                    },
                    legend: {
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle'
                    },
                    xAxis: {
                        categories: $scope.date
                    },
                    series: [{
                        name: 'Distance in km',
                        data: $scope.distance
                    }],
                    credits: {
                        enabled: false
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                menuItems: [{
                                    textKey: 'downloadPNG',
                                    onclick: function() {
                                        var fileName = "distance_report";
                                        this.exportChart({
                                            filename: fileName
                                        });
                                    }
                                }, {
                                    textKey: 'downloadPDF',
                                    onclick: function() {
                                        this.exportChart({
                                            type: 'application/pdf'
                                        });
                                    }
                                }]
                            }
                        }
                    }

                });

            })
        }


        var data = [
            { "date": "2012-01-01", "value": 4.13 },
            { "date": "2012-01-02", "value": 4.88 },
            { "date": "2012-01-03", "value": 5.89 },
            { "date": "2012-01-04", "value": 5.87 },
            { "date": "2012-01-05", "value": 8.54 },
            { "date": "2012-01-06", "value": 4.41 },
            { "date": "2012-01-07", "value": 8.56 },
            { "date": "2012-01-08", "value": 8.05 },
            { "date": "2012-01-09", "value": 8.13 },
            { "date": "2012-01-10", "value": 5.86 }
        ]

        /* Monday 2012 */
        var data1 = data;
        // var title1 = "Line graph";
        var dateformat = "%Y-%m-%d";
        //drawTimeSeriesGraph(data1, dateformat);

        /* 
        Tooltip from: http://bl.ocks.org/d3noob/6eb506b129f585ce5c8a
        line graph from here: http://www.d3noob.org/2012/12/starting-with-basic-d3-line-graph.html
        */

        function drawTimeSeriesGraph(data, dateformat) {

            //Set bounds for red dots
            var lbound = 0.045,
                ubound = 0.075;

            // Set the dimensions of the canvas / graph
            var margin = { top: 50, right: 200, bottom: 30, left: 20 },
                width = document.getElementById('line-chart').offsetWidth - margin.left - margin.right,
                height = document.getElementById('line-chart').offsetHeight - margin.top - margin.bottom;

            // Parse the date / time
            var parseDate = d3.time.format(dateformat).parse,
                formatDate = d3.time.format(dateformat),
                bisectDate = d3.bisector(function(d) { return d.date; }).left;

            // Set the ranges
            var x = d3.time.scale().range([0, width]);
            var y = d3.scale.linear().range([height, 0]);

            // Define the axes
            var xAxis = d3.svg.axis().scale(x)
                .orient("bottom").ticks(10);

            var yAxis = d3.svg.axis().scale(y)
                .orient("left").ticks(10);

            // Define the line
            var valueline = d3.svg.line()
                .x(function(d) { return x(d.date); })
                .y(function(d) { return y(d.value); });

            // Adds the svg canvas
            var svg = d3.select("#line-chart")
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform",
                    "translate(" + margin.left + "," + margin.top + ")");

            var lineSvg = svg.append("g")
                .attr("shape-rendering", "geometricPrecision");

            var focus = svg.append("g")
                .style("display", "none");

            // Get the data

            data.forEach(function(d) {
                d.date = parseDate(d.date);
                d.value = +d.value;
            });

            // Scale the range of the data
            x.domain(d3.extent(data, function(d) { return d.date; }));
            y.domain([0, d3.max(data, function(d) { return d.value; })]);
            //Use below if instead you want to define the y limits:
            //y.domain([0, 0.11]);

            // Add the valueline path.
            lineSvg.append("path")
                .attr("class", "line")
                .attr("d", valueline(data))
                .attr("stroke", "steelblue")
                .attr("stroke-width", 2)
                .attr("fill", "none")


            // Add the X Axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxis);

            // Add the Y Axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxis);

            // append the x line
            focus.append("line")
                .attr("class", "x")
                .style("stroke", "blue")
                .style("stroke-dasharray", "3,3")
                .style("opacity", 0.5)
                .attr("y1", 0)
                .attr("y2", height)
                .attr("fill", "none");

            // append the y line
            focus.append("line")
                .attr("class", "y")
                .style("stroke", "blue")
                .style("stroke-dasharray", "3,3")
                .style("opacity", 0.5)
                .attr("x1", width)
                .attr("x2", width)
                .attr("fill", "none");

            // append the circle at the intersection
            focus.append("circle")
                .attr("class", "y")
                .style("fill", "blue")
                .style("stroke", "blue")
                .attr("r", 4);

            // place the value at the intersection
            focus.append("text")
                .attr("class", "y1")
                .style("stroke", "white")
                .style("stroke-width", "3.5px")
                .style("opacity", 0.8)
                .attr("dx", 8)
                .attr("dy", "-.3em");
            focus.append("text")
                .attr("class", "y2")
                .attr("dx", 8)
                .attr("dy", "-.3em");

            // place the date at the intersection
            focus.append("text")
                .attr("class", "y3")
                .style("stroke", "white")
                .style("stroke-width", "3.5px")
                .style("opacity", 0.8)
                .attr("dx", 8)
                .attr("dy", "1em");
            focus.append("text")
                .attr("class", "y4")
                .attr("dx", 8)
                .attr("dy", "1em");

            // append the rectangle to capture mouse
            svg.append("rect")
                .attr("width", width)
                .attr("height", height)
                .style("fill", "none")
                .style("pointer-events", "all")
                .on("mouseover", function() { focus.style("display", null); })
                .on("mouseout", function() { focus.style("display", "none"); })
                .on("mousemove", mousemove);

            function mousemove() {
                var x0 = x.invert(d3.mouse(this)[0]),
                    i = bisectDate(data, x0, 1),
                    d0 = data[i - 1],
                    d1 = data[i],
                    d = x0 - d0.date > d1.date - x0 ? d1 : d0;

                focus.select("circle.y")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")");

                focus.select("text.y1")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")")
                    .text(d.value.toFixed(2));

                focus.select("text.y2")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")")
                    .text(d.value.toFixed(2));

                focus.select("text.y3")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")")
                    .text(formatDate(d.date));

                focus.select("text.y4")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")")
                    .text(formatDate(d.date));

                // focus.select(".x")
                // 	.attr("transform",
                // 		  "translate(" + x(d.date) + "," +
                // 						 y(d.value) + ")")
                // 			   .attr("y2", height - y(d.value));

                // focus.select(".y")
                // 	.attr("transform",
                // 		  "translate(" + width * -1 + "," +
                // 						 y(d.value) + ")")
                // 			   .attr("x2", width + width);
            };

            // svg.append("text")
            // 	.attr("x", (width / 2))             
            // 	.attr("y", 0 - (margin.top / 2))
            // 	.attr("text-anchor", "middle")  
            // 	.style("font-size", "16px") 
            // 	.style("text-decoration", "underline")  
            // 	.text(title);
        };


    }

})();
(function () {
	'use strict';

	angular.module('trakeyeApp').controller('MobileUserAttendaceController', MobileUserAttendaceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	MobileUserAttendaceController.$inject = ['$scope', '$sce', '$state', "Report"];

	function MobileUserAttendaceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.report = report;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "mobileUser";
		vm.selecterange = selectRange;
		vm.sortResponse = sortResponse;

		vm.select2();

		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadAttendenceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('GpsUserAttendaceController', GpsUserAttendaceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	GpsUserAttendaceController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function GpsUserAttendaceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.report = report;
		vm.sortResponse = sortResponse;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "gpsUser";
		vm.selecterange = selectRange;

		vm.select2();

		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadAttendenceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "gps_user_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('GeofenceDumpController', GeofenceDumpController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	GeofenceDumpController.$inject = ['$scope', '$sce', '$state', 'AllGeofenceIDs', 'Report'];

	function GeofenceDumpController($scope, $sce, $state, AllGeofenceIDs, Report) {
		var vm = this;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.downloadAttendenceReportKml = downloadAttendenceReportKml;
		vm.select2 = select2;
		vm.select2();
		vm.geofences = [];
		vm.selectedGeofenceId = 0;
		vm.users = loadPage();

		function loadPage() {
			AllGeofenceIDs.getAll(function (response) {
                response.forEach(function (geofence) {
                    vm.geofences.push({ name: geofence.name, id: geofence.id, nameZone: geofence.name + " - " + geofence.geofenceType});
                });
            });
		}

		function downloadAttendenceReport() {
			Report.downloadGeofenceDump({
				id: vm.selectedGeofenceId
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "geofence.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function downloadAttendenceReportKml() {
			Report.downloadGeofenceDumpKml({
				id: vm.selectedGeofenceId
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/text' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "geofence.kml";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function select2() {
			$(".select2").select2();
		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('GeofenceReportController', GeofenceReportController)

	GeofenceReportController.$inject = [ '$scope', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval' ];

	function GeofenceReportController($scope, $state, Report, $rootScope, $timeout, $window, $filter, $interval) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.batteryusers = [];
		$scope.reporthide = false;
		vm.select2 = select2;
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		// vm.today();
		vm.select2();
		Report.getUsers('', function(response) {
			vm.batteryusers = response;

		})

		vm.geofences = loadPage();
		function loadPage(){
			Report.getGeofences('', function(response) {
				vm.geofences = response;
			})
			vm.reportType = 'geofence';
		}
		
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		$scope.report = function() {
			if (vm.reportType == 'geofence' && vm.geofence == 'all') {
				vm.id = 0;
			}
			Report.getReport({
				id : vm.id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				$scope.search = "";
				$scope.reporthide = true;
			})

		}
		vm.detailedReport = detailedReport;

		vm.selecterange = selectRange;
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		function selectRange(range) {
			if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} else if (range == 'year') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setYear(date.getFullYear() - 1);
				vm.fromTime = date.getTime();
			}
		}
		function select2() {
			$(".select2").select2();
		}

		// Added for generating pdf start
		$scope.close = function() {
			$('#genericReport').show();
			$scope.reporthide = true;
			$('#report').hide();
		}
		$scope.loader = false;
		$(function() {
			$scope.getPdf = function() {
				$scope.loader = true;
				html2canvas(reportpdf, {
					onrendered : function(canvas) {
						var img = canvas.toDataURL("image/png");
						var pdf = new jsPDF('landscape', 'mm', 'a2');
						pdf.addImage(img, 'JPEG', 0, 0);
						pdf.save($scope.pdftype);
						$scope.loader = false;
					}
				});
				$interval(function() {
				}, 1000);
			}
		});
		// Added for generating pdf end
		function detailedReport(id) {
			Report.getDetailedReport({
				id : id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {
				vm.detailedReportCounts = response;

				$('#report').show();
				$scope.reporthide = false;
				$('#genericReport').hide();

				if (vm.reportType == 'geofence') {
					$scope.pdftype = 'Geofence.pdf';
					var coordicates = JSON.parse(response.coordinates);
					var map = new google.maps.Map(document.getElementById('map_canvas'), {
						zoom : 13,
						center : new google.maps.LatLng(coordicates[0].lat, coordicates[0].lng)
					});

					var polygon = new google.maps.Polygon({
						path : coordicates,
						strokeColor : "#ff0000",
						strokeOpacity : 0.8,
						strokeWeight : 2,
						fillColor : "#ff0000",
						fillOpacity : 0.3,
						editable : true
					})
					polygon.setMap(map);
					setTimeout(function() {
						google.maps.event.trigger(map, "resize");
						map.setCenter(new google.maps.LatLng(coordicates[0].lat, coordicates[0].lng));
					}, 100);
				}

			})
		}

		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		$scope.batteryreport = function() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			Report.getbatteryReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
				$scope.batteryline = response;
				$scope.battery = [];
				$scope.createTime = [];
				angular.forEach($scope.batteryline, function(value, key) {
					$scope.battery.push(value.batteryValue);
					$scope.createTime.push($filter('date')(value.createTime, dateFormat));
				});

				Highcharts.chart('battery_graph', {

					title : {
						text : 'Battery Usage Report'
					},

					subtitle : {
						text : ''
					},

					yAxis : {
						title : {
							text : 'Battery Percentage'
						}
					},
					legend : {
						layout : 'vertical',
						align : 'right',
						verticalAlign : 'middle'
					},
					xAxis : {
						categories : $scope.createTime
					},

					series : [ {
						name : ' ',
						data : $scope.battery
					} ],
					credits : {
						enabled : false
					},
					exporting : {
						buttons : {
							contextButton : {
								menuItems : [ {
									textKey : 'downloadPNG',
									onclick : function() {
										var fileName = "battery_report";
										this.exportChart({
											filename : fileName
										});
									}
								}, {
									textKey : 'downloadPDF',
									onclick : function() {
										this.exportChart({
											type : 'application/pdf'
										});
									}
								} ]
							}
						}
					}

				});

			})
		}

		$scope.distancereport = function() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			Report.getDistanceReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
				$scope.distanceData = response;
				$scope.distance = [];
				$scope.date = [];

				angular.forEach($scope.distanceData, function(value, key) {
					$scope.distance.push(value.distance);

					// $scope.date.push($filter('date')(value.date,"dd EEE"));
					$scope.date.push(value.date);
				});

				Highcharts.chart('distance_graph', {

					title : {
						text : 'Distance Travelled Report'
					},

					subtitle : {
						text : ''
					},

					yAxis : {
						title : {
							text : 'Distance Travelled in KM'
						}
					},
					legend : {
						layout : 'vertical',
						align : 'right',
						verticalAlign : 'middle'
					},
					xAxis : {
						categories : $scope.date
					},
					series : [ {
						name : 'Distance in km',
						data : $scope.distance
					} ],
					credits : {
						enabled : false
					},
					exporting : {
						buttons : {
							contextButton : {
								menuItems : [ {
									textKey : 'downloadPNG',
									onclick : function() {
										var fileName = "distance_report";
										this.exportChart({
											filename : fileName
										});
									}
								}, {
									textKey : 'downloadPDF',
									onclick : function() {
										this.exportChart({
											type : 'application/pdf'
										});
									}
								} ]
							}
						}
					}

				});

			})
		}

	}

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('FiberStatusReportController', FiberStatusReportController)

    FiberStatusReportController.$inject = ['$scope', 'UsersList', 'Principal', 'AssetsForMap', 'AssetsForMapByAdmin'];

    function FiberStatusReportController($scope, UsersList, Principal, AssetsForMap, AssetsForMapByAdmin) {
        var vm = this;
        vm.userlist = [];
        $scope.reporthide = false;
        vm.select2 = select2;
        vm.select2();
        vm.users = loadPage();
        vm.multiassets = [];
        vm.assets = [];

    	var result = [];

        function loadPage() {
            var loggedInUserId = 0;
            Principal.identity().then(function (identity) {
                if (identity) {
                    loggedInUserId = identity.id;
                }
            })
            UsersList.getusers(function (response) {
                var users = [];
                response.forEach(function (item, index) {
                    if (item.authorities.includes("ROLE_USER_ADMIN") && (item.id != loggedInUserId)) {
                        users.push(item)
                    }
                });
                vm.userlist = users;

                vm.userlist.forEach(function (item, index) {
                    var vendorName = item.firstName + ' ' + item.lastName;
                    AssetsForMapByAdmin.assetsformapbyadmin(item.id, function (response) {
                    	var onAirDis = 0.0,
                            deployedDis = 0.0,
                            plannedDis = 0.0;
                        response.forEach(function (item) {
                        	
                            var disVal = 0.0;
                            var assetLocations = item.assetCoordinates;
                            if (assetLocations.length > 1) {
                                for (var index in assetLocations) {
                                    if (index >= 1) {
                                        var disCal = distanceCal(assetLocations[index].latitude, assetLocations[index].longitude, assetLocations[index - 1].latitude, assetLocations[index - 1].longitude);
                                        if (disCal > 0) {
                                            disVal += disCal;
                                        }
                                    }
                                }
                            }
                            var assetAV = item.assetTypeAttributeValues;
                            assetAV.forEach(function (item1) {
                                if (item1.assetDataTypeName == 'Fiber Status') {
                                    if (item1.attributeValue == 'On Air') {
                                        onAirDis = onAirDis + disVal;
                                    } else if (item1.attributeValue == 'Under Deployment') {
                                        deployedDis = deployedDis + disVal;
                                    } else if (item1.attributeValue == 'Planned') {
                                        plannedDis = plannedDis + disVal;
                                    }
                                }
                            });
                        });
                        vm.multiassets.push({
                            name: vendorName,
                            onair: onAirDis.toFixed(2),
                            deployed: deployedDis.toFixed(2),
                            planned: plannedDis.toFixed(2)
                        });

                        var vendorData = [];
                        var fiberStatusData = [];
                        var onAirDis = 0.0,
                            deployedDis = 0.0,
                            plannedDis = 0.0;
                        vm.multiassets.forEach(function (item2) {
                            vendorData.push({
                                label: item2.name,
                                value: item2.onair
                            })
                            onAirDis += parseFloat(item2.onair);
                            deployedDis += parseFloat(item2.deployed);
                            plannedDis += parseFloat(item2.planned);

                        });

                        fiberStatusData.push({
                            label: "ON AIR",
                            value: onAirDis.toFixed(2)
                        });
                        fiberStatusData.push({
                            label: "UNDER DEPLOYMENT",
                            value: deployedDis.toFixed(2)
                        });
                        fiberStatusData.push({
                            label: "PLANNED",
                            value: plannedDis.toFixed(2)
                        });
                        var donut = new Morris.Donut({
                            element: 'vendor-chart',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });

                        var donut1 = new Morris.Donut({
                            element: 'fiber-chart',
                            resize: true,
                            colors: ["#5668e2", "#56aee2", "#56e2cf", "#56e289", "#68e256", "#aee256", "#e2cf56", "#e28956", "#e25668", "#e256ae", "#cf56e2", "#8a56e2"],
                            data: fiberStatusData,
                            hideHover: 'auto'
                        });
                    });


                });
            });
            vm.reportType = 'agent';
        }
        
        vm.caseTypeClick = function (caseTypeName, value) {
        	vm.assets = [];
        	
        	 vm.userlist.forEach(function (item, index) {
                 var vendorName = item.firstName + ' ' + item.lastName;
                 if(caseTypeName == vendorName){
	                 AssetsForMapByAdmin.assetsformapbyadmin(item.id, function (response) {
	                     response.forEach(function (item) {
	                    	 if(item.assetType.layout == "SPREAD"){
	                    		 var isFiberStatusVal = false; 
	                    		 item.assetTypeAttributeValues.forEach(function(item1){
	                    			 if(item1.assetDataTypeName == "Fiber Status" && item1.attributeValue == value){
	                    				 isFiberStatusVal = true;
	                    			 }
	                    		 });
	                    		 if(isFiberStatusVal){
	                    			 result.push(item);
	                    		 }
	                    	 }
	                     });
	                    
	                 });
                 }
             });
        	 
        	 result.forEach(function(item2){
        		 var disVal = 0.0;
                 var assetLocations = item2.assetCoordinates;
                 if (assetLocations.length > 1) {
                     for (var index in assetLocations) {
                         if (index >= 1) {
                             var disCal = distanceCal(assetLocations[index].latitude, assetLocations[index].longitude, assetLocations[index - 1].latitude, assetLocations[index - 1].longitude);
                             if (disCal > 0) {
                                 disVal += disCal;
                             }
                         }
                     }
                 }
                 var linkStatusVal = '';
                 item2.assetTypeAttributeValues.forEach(function(item3){
        			 if(item3.name == "Link Status"){
        				 if(item3.attributeValue == "True"){
        					 linkStatusVal = "Active";
        				 }else{
        					 linkStatusVal = "Inactive";
        				 }
        			 }
        		 });
                 vm.assets.push({name:item2.name,status:value, distance:disVal.toFixed(2), linkstatus:linkStatusVal });
        	 });
  
        	 result = [];
        };

        function select2() {
            $(".select2").select2();
        }


        $("#userlist").change(function () {
        	vm.assets = [];
            vm.multiassets = [];
            var result = $("#userlist").val();
            if (result != "") {
                vm.multiassets = getAssetObj(result);
            } else {
                vm.userlist.forEach(function (item, index) {
                    var vendorName = item.firstName + ' ' + item.lastName;
                    AssetsForMapByAdmin.assetsformapbyadmin(item.id, function (response) {
                        var onAirDis = 0.0,
                            deployedDis = 0.0,
                            plannedDis = 0.0;
                        response.forEach(function (item) {
                            var disVal = 0.0;
                            var assetLocations = item.assetCoordinates;
                            if (assetLocations.length > 1) {
                                for (var index in assetLocations) {
                                    if (index >= 1) {
                                        var disCal = distanceCal(assetLocations[index].latitude, assetLocations[index].longitude, assetLocations[index - 1].latitude, assetLocations[index - 1].longitude);
                                        if (disCal > 0) {
                                            disVal += disCal;
                                        }
                                    }
                                }
                            }
                            var assetAV = item.assetTypeAttributeValues;
                            assetAV.forEach(function (item1) {
                                if (item1.assetDataTypeName == 'Fiber Status') {
                                    if (item1.attributeValue == 'On Air') {
                                        onAirDis = onAirDis + disVal;
                                    } else if (item1.attributeValue == 'Under Deployment') {
                                        deployedDis = deployedDis + disVal;
                                    } else if (item1.attributeValue == 'Planned') {
                                        plannedDis = plannedDis + disVal;
                                    }
                                }
                            });
                        });
                        vm.multiassets.push({
                            name: vendorName,
                            onair: onAirDis.toFixed(2),
                            deployed: deployedDis.toFixed(2),
                            planned: plannedDis.toFixed(2)
                        });

                        var vendorData = [];
                        var fiberStatusData = [];
                        var onAirDis = 0.0,
                            deployedDis = 0.0,
                            plannedDis = 0.0;
                        vm.multiassets.forEach(function (item1) {
                            vendorData.push({
                                label: item1.name,
                                value: item1.onair
                            })
                            onAirDis += parseFloat(item1.onair);
                            deployedDis += parseFloat(item1.deployed);
                            plannedDis += parseFloat(item1.planned);

                        });

                        fiberStatusData.push({
                            label: "ON AIR",
                            value: onAirDis.toFixed(2)
                        });
                        fiberStatusData.push({
                            label: "UNDER DEPLOYMENT",
                            value: deployedDis.toFixed(2)
                        });
                        fiberStatusData.push({
                            label: "PLANNED",
                            value: plannedDis.toFixed(2)
                        });
                        var donut = new Morris.Donut({
                            element: 'vendor-chart',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });

                        var donut1 = new Morris.Donut({
                            element: 'fiber-chart',
                            resize: true,
                            colors: ["#5668e2", "#56aee2", "#56e2cf", "#56e289", "#68e256", "#aee256", "#e2cf56", "#e28956", "#e25668", "#e256ae", "#cf56e2", "#8a56e2"],
                            data: fiberStatusData,
                            hideHover: 'auto'
                        });
                    });
                });
            }
        });

        $('#userlist').trigger('change');
        
        function getAssetObj(adminId) {
            var vendorName = "";
            var assetObj = [];
            vm.userlist.forEach(function (item, index) {
                if (item.id == adminId) {
                    vendorName = item.login;
                }
            });
            AssetsForMapByAdmin.assetsformapbyadmin(adminId, function (response) {
                var onAirDis = 0.0,
                    deployedDis = 0.0,
                    plannedDis = 0.0;
                response.forEach(function (item) {
                    var disVal = 0.0;
                    var assetLocations = item.assetCoordinates;
                    if (assetLocations.length > 1) {
                        for (var index in assetLocations) {
                            if (index >= 1) {
                                var disCal = distanceCal(assetLocations[index].latitude, assetLocations[index].longitude, assetLocations[index - 1].latitude, assetLocations[index - 1].longitude);
                                if (disCal > 0) {
                                    disVal += disCal;
                                }
                            }
                        }
                    }
                    var assetAV = item.assetTypeAttributeValues;
                    assetAV.forEach(function (item1) {
                        if (item1.assetDataTypeName == 'Fiber Status') {
                            if (item1.attributeValue == 'On Air') {
                                onAirDis = onAirDis + disVal;
                            } else if (item1.attributeValue == 'Under Deployment') {
                                deployedDis = deployedDis + disVal;
                            } else if (item1.attributeValue == 'Planned') {
                                plannedDis = plannedDis + disVal;
                            }
                        }
                    });
                });
                assetObj.push({
                    name: vendorName,
                    onair: onAirDis.toFixed(2),
                    deployed: deployedDis.toFixed(2),
                    planned: plannedDis.toFixed(2)
                });

                var vendorData = [];
                var fiberStatusData = [];
                var onAirDis = 0.0,
                    deployedDis = 0.0,
                    plannedDis = 0.0;
                vm.multiassets.forEach(function (item1) {
                    vendorData.push({
                        label: item1.name,
                        value: item1.onair
                    })
                    onAirDis += parseFloat(item1.onair);
                    deployedDis += parseFloat(item1.deployed);
                    plannedDis += parseFloat(item1.planned);

                });

                fiberStatusData.push({
                    label: "ON AIR",
                    value: onAirDis.toFixed(2)
                });
                fiberStatusData.push({
                    label: "UNDER DEPLOYMENT",
                    value: deployedDis.toFixed(2)
                });
                fiberStatusData.push({
                    label: "PLANNED",
                    value: plannedDis.toFixed(2)
                });
                var donut = new Morris.Donut({
                    element: 'vendor-chart',
                    resize: true,
                    colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                    data: vendorData,
                    hideHover: 'auto'
                });

                var donut1 = new Morris.Donut({
                    element: 'fiber-chart',
                    resize: true,
                    colors: ["#5668e2", "#56aee2", "#56e2cf", "#56e289", "#68e256", "#aee256", "#e2cf56", "#e28956", "#e25668", "#e256ae", "#cf56e2", "#8a56e2"],
                    data: fiberStatusData,
                    hideHover: 'auto'
                });
            });
            return assetObj;
        }

        

        // Added for generating pdf start
        $scope.close = function () {
            $('#genericReport').show();
            $scope.reporthide = true;
            $('#report').hide();
        }
        $scope.loader = false;



    }

    function distanceCal(lat1, lon1, lat2, lon2) {
        var theta = lon1 - lon2;
        var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
            Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
        dist = Math.acos(dist);
        dist = radians_to_degrees(dist);
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        if (isNaN(dist)) {
            return 0.0;
        } else {
            return (dist);
        }
    }

    function degrees_to_radians(degrees) {
        var pi = Math.PI;
        return degrees * (pi / 180);
    }

    function radians_to_degrees(radians) {
        var pi = Math.PI;
        return radians * (180 / pi);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("EntityDumpController", EntityDumpController);

    EntityDumpController.$inject = [
        "Report",
        "myservice",
        "$interval",
        "$scope",
        "DumpRequest",
        "pagingParams",
        "paginationConstants",
        "AlertService",
        "ParseLinks",
        "$state"
    ];

    function EntityDumpController(
        Report,
        myservice,
        $interval,
        $scope,
        DumpRequest,
        pagingParams,
        paginationConstants,
        AlertService,
        ParseLinks,
        $state
    ) {
        var vm = this;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        vm.highlightRow = false
        if(myservice.getValue() == 'true'){
            vm.highlightRow = true;
        }
       
        
        // callReportApi()
        filterSearch();

        vm.refresh = function(){
            filterSearch();
        }

        function callReportApi(){
            Report.getListEntity(function (response){
                if(response.length){
                    vm.displayList = response.reverse()
                }
            })

            
        }
        
        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search
            });
        }

        function filterSearch() {
            if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
                var str = $scope.search+"";
                str = str.replace('/', 'slash');
                DumpRequest.query({
                    userId: str,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);

                function sort() {
                    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                    if (vm.predicate !== 'id') {
                        //  result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.displayList = data;
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            DumpRequest.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.displayList = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        var myInterval = $interval(function() {
            // Code to be executed periodically
            // callReportApi()
            filterSearch();
          }, 60000); // Interval duration in milliseconds
        
          // Listen for the $destroy event to clear the interval when the controller is destroyed
          $scope.$on('$destroy', function() {
            // Clear the interval when the controller is destroyed
            if (angular.isDefined(myInterval)) {
              $interval.cancel(myInterval);
            }
          });
        
        vm.expand = function(entity) {
            vm.displayList.forEach(function (item) {
                item.expand = false;
            });

            if (vm.toggle == entity.id) {
                vm.toggle = undefined;
            } else {
                entity.expand = true;
                vm.toggle = entity.id;

                Report.getEntityDetails(entity.id,function (response){
                    vm.expandResponse = response
                })

            }


        }

        vm.download = function(imgId,id,name){
            var temp = "Report"
            Report.downloadZip(id,imgId,function (data){
                var a = document.createElement("a");
               var file = new Blob([data], { type: 'application/zip' });

               var fileURL = URL.createObjectURL(file);
               a.href = fileURL;
               a.download = name ? name + ".zip" : temp + ".zip";
               a.click();
               window.URL.revokeObjectURL(fileURL);
            })
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("EntityDumpDialogController", EntityDumpDialogController);

        EntityDumpDialogController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "$localStorage",
        "Report",
        "AllGeofenceIDs",
        "AllCaseTypes",
        "UserMasterGeofences",
        "MiniGeofencesByMasterID",
        "AssetType",
        "BaseUrl",
        "myservice"
    ];
    
    function EntityDumpDialogController(
        $timeout,
        $state,
        $scope,
        $localStorage,
        Report,
        AllGeofenceIDs,
        AllCaseTypes,
        UserMasterGeofences,
        MiniGeofencesByMasterID,
        AssetType,
        BaseUrl,
        myservice
    ) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        var dateFormat = "dd EEE HH:mm";
        var date = "dd EEE";
        vm.fromTime = 0;
        vm.toTime = 0;
        //vm.today = today();
        vm.searchMini = "";
        vm.report;
        vm.geofences = [];
        vm.userMasterGeofences = [];
        vm.geofenceMini;
        vm.selectedMasterGeofenceId = 0;
        vm.selectedGeofenceId;
        vm.entity;
        vm.showMessage = false;
        vm.showMessageError = false;
        vm.selecterange = selectRange;
        vm.calculateToDate = calculateToDate;
        vm.calculateFromDate = calculateFromDate;
        vm.trackingId;
        //vm.submit = true;
        var date = new Date();
        $scope.optionsTo = {
			maxDate: date.setDate(date.getDate())
		};
        $scope.optionsFrom = {
			maxDate: date.setDate(date.getDate())
		};

        $(".select2").select2(); // Added search for select box
        function today() {
            var today = new Date();
            vm.toDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate()
            );
            vm.fromDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate()
            );
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }
        vm.users = loadPage();
        vm.toDate = null
        vm.fromDate = null
        $(".select2").change(function () {
            vm.showMessage = false;
            vm.showMessageError = false;
            //vm.submit = true;
        });

        function loadPage() {
            // AllGeofenceIDs.getAll(function (response) {
            // response.forEach(function (geofence) {
            // vm.geofences.push({
            // name: geofence.name,
            // id: geofence.id,
            // geofenceTypeMini: geofence.geofenceType,
            // nameZone: geofence.name + " - " + geofence.geofenceType,
            // });

            // vm.geofenceMini = vm.geofences.filter(function onlyMINI(a) {
            // return a.geofenceTypeMini == "MINI";
            // });
            // });
            // });

            AssetType.query(
                {
                    page: 0,
                    size: 100,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
            }
            function onSuccess(data, headers) {
                vm.assetTypesData = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                        });
                    }
                );
            });
            AllCaseTypes.getAll(function (response) {
                vm.caseTypes = response;
            });
        }

        /* $scope.submitChange = function(){
//vm.submit = true;
vm.showMessageError= false
vm.showMessage= false
} */

        function openCalendar(date) {
            //vm.submit = true;
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.datePickerOpenStatus[date] = true;
        }

        function selectRange(range) {
            if (range == "week") {
                vm.showMessageError = false;
                vm.showMessage = false;
                //vm.submit = true;
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setDate(date.getDate() - 7);
                vm.fromTime = date.getTime();
            } else if (range == "month") {
                vm.showMessageError = false;
                vm.showMessage = false;
                //vm.submit = true;
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setMonth(date.getMonth() - 1);
                vm.fromTime = date.getTime();
            } else if (range == "year") {
                vm.showMessageError = false;
                vm.showMessage = false;
                //vm.submit = true;
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setYear(date.getFullYear() - 1);
                vm.fromTime = date.getTime();
            }
        }

        function calculateFromDate() {
            $scope.optionsTo = {
                minDate: vm.fromDate.setDate(vm.fromDate.getDate()),
                maxDate: date.setDate(date.getDate())
            };
           vm.fromDate.setHours(0, 0, 0, 0);
           vm.fromTime = vm.fromDate.getTime();
        }

        $scope.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            //vm.submit = true;
            vm.geofenceMini = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );
        };

        vm.assetTypes = []
        $scope.assetLayoutChange = function (){
            if(vm.entityLayout == "FIXED"){
                vm.assetTypes = []
                vm.assetTypesData.filter(function(val){
                    if(val.layout  == "FIXED"){
                        vm.assetTypes.push({name: val.name, id: val.id})
                    }
                })
            }else{
                vm.assetTypes = []
                vm.assetTypesData.filter(function(val){
                    if(val.layout  == "SPREAD"){
                        vm.assetTypes.push({name: val.name, id: val.id})
                    }
                })
            }
        }

        function calculateToDate() {
            $scope.optionsFrom = {
                maxDate: vm.toDate.setDate(vm.toDate.getDate())
            };
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }

        $scope.entityDump = function () {
            //vm.submit = false;
            if (vm.entity == "Assets") {
                var geofenceDTO = vm.selectedGeofenceId;
                /*var geoList = [];
                geoList.push(geofenceDTO);*/
                if(vm.entityFileFormat == "EXCEL"){
                    BaseUrl.getBaseUrl(function(baseurl){
                        var request = new XMLHttpRequest();
                        request.open('GET', baseurl.stringValue+"api/assets-export-excel/"+geofenceDTO[0].id+"/"+vm.selectedAssettypeId[0].id, true);
                        request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
                        request.responseType = 'blob';
            
                        request.onload = function(e) {
                            if (this.status === 200) {
                                var blob = this.response;
                                if(blob.size > 0){
                                    if(window.navigator.msSaveOrOpenBlob) {
                                        window.navigator.msSaveBlob(blob, 'test.xlsx');
                                    }
                                    else{
                                        var downloadLink = window.document.createElement('a');
                                        var contentTypeHeader = request.getResponseHeader("Content-Type");
                                        downloadLink.href = window.URL.createObjectURL(new Blob([blob], { 
                                        type: contentTypeHeader }));
                                        downloadLink.download = 'AssetExportExcel.xlsx';
                                        document.body.appendChild(downloadLink);
                                        downloadLink.click();
                                        document.body.removeChild(downloadLink);
                                    }
                                }
                            }
                        };
                        request.send();
                    });
                } else {
                    var geofenceId = geofenceDTO;
                    if(geofenceDTO.length == 0){
                        geofenceId = [];
                        geofenceId.push({"id":parseInt(vm.selectedMasterGeofenceId)});
                    }

                    var selectedAssettypeId = 0;
                    if(vm.selectedAssettypeId != undefined || vm.selectedAssettypeId != null){
                        selectedAssettypeId = vm.selectedAssettypeId[0].id;    
                    }
                    
                    Report.emailReport(
                        {
                            entityName: vm.entity,
                            geofences: geofenceId,
                            entityLayout : vm.entityLayout,
                            entityTypeId : selectedAssettypeId,
                            fileFormat : vm.entityFileFormat
                        },
                        function (response) {
                            vm.showMessageError = false;
                            vm.showMessage = true;
                            vm.trackingId = response.id
                            $timeout(function () {
                                $state.go('entity-dump');
                            }, 2000);  
                            myservice.setValue("true");
                        },
                        function (e) {
                            vm.errorMessage = e.data.message;
                            vm.showMessage = false;
                            vm.showMessageError = true;
                            $timeout(function () {
                                vm.showMessageError = false;
                            }, 4000);
                        }
                    );
                    
                }
            } else if (vm.entity == "Cases") {
                var selectedCaseType = 0;
                if (
                    vm.selectedCaseType != undefined &&
                    vm.selectCaseType != "all"
                ) {
                    selectedCaseType = vm.selectedCaseType.id;
                }
				var geofenceDTO = vm.selectedGeofenceId;
				  var geofenceId = geofenceDTO;
                    if(geofenceDTO.length == 0){
                        geofenceId = [];
                        geofenceId.push({"id":parseInt(vm.selectedMasterGeofenceId)});
                    }
                Report.emailReport(
                    {
                        entityName: vm.entity,
                        entityStatus: vm.entityStatus,
                        caseTypeId: selectedCaseType,
                        entityTypeId: selectedCaseType,
                        reqFromDate: vm.fromTime,
                        reqToDate: vm.toTime,
						geofences: geofenceId,
                    },
                    function (response) {
                        vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id
                        $timeout(function () {
                            $state.go('entity-dump');
                        }, 2000); 
                        myservice.setValue("true");
                    },
                    function (e) {
                        vm.errorMessage = e.data.message;
                        vm.showMessage = false;
                        vm.showMessageError = true;
                        $timeout(function () {
                            vm.showMessageError = false;
                        }, 4000);
                    }
                );
            } else if (vm.entity == "Users") {
                Report.emailReport(
                    {
                        entityName: vm.entity,
                    },
                    function (response) {
                        vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id
                        $timeout(function () {
                            $state.go('entity-dump');
                        }, 2000);  
                        myservice.setValue("true");
                    },
                    function (e) {
                        vm.errorMessage = e.data.message;
                        vm.showMessage = false;
                        vm.showMessageError = true;
                        $timeout(function () {
                            vm.showMessageError = false;
                        }, 4000);
                    }
                );
            } else {
                alert("Please select valid entity!");
            }
        };
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('DistanceReportController', DistanceReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce){
    return function(text) {
        return $sce.trustAsHtml(text);
    	};
	}]);

	DistanceReportController.$inject = [ '$scope','$sce' ,'$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval' ];

	function DistanceReportController($scope, $sce,$state, Report, $rootScope, $timeout, $window, $filter, $interval) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.reportTypeChange = reportTypeChanged;
		vm.users = [];
		
		vm.geofences = [];
		$scope.reporthide = false;
		vm.select2 = select2;
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		// vm.today();
		vm.select2();
		Report.getUsers('', function(response) {
			vm.users = response;

		})

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		
		//vm.detailedReport = detailedReport;

		vm.selecterange = selectRange;
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		function selectRange(range) {
			if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} else if (range == 'year') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setYear(date.getFullYear() - 1);
				vm.fromTime = date.getTime();
			}
		}
		function select2() {
			$(".select2").select2();
		}
		function reportTypeChanged() {
			$scope.reporthide = false;
			
				if (vm.users.length == 0) {
					Report.getUsers('', function(response) {
						vm.users = response;
					})
				}
			

		}
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		
		
		$scope.report = function() {
			
				Report.getDistReport({
					"fromDateTime":vm.fromTime,
					"toDateTime":vm.toTime,
					"login":vm.userid
				}, function(response) {
					
					$scope.myhtml = response;
					
							
				});
				
			

		}
		
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('CasesDumpController', CasesDumpController)

	CasesDumpController.$inject = ['$scope', '$state', 'Report'];

	function CasesDumpController($scope, $state, Report) {
		var vm = this;
		vm.downloadType = "";
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.downloadCaseDumpReport = downloadCaseDumpReport;
		vm.showMessage = false;
		vm.selecterange = selectRange;
		vm.select2();

		$('input[type=radio][name=type]').change(function() {
			vm.showMessage = false;
		});

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

		function downloadCaseDumpReport() {
			if((vm.toTime-vm.fromDate) > 2592000000){
				alert("Date Range exceeded month limit");
			}else{
				vm.showMessage = true;
				if (vm.downloadType == 'opencases') {
					Report.getOpenCasesReportDownload({
						id: 0,
						ageType: vm.dateRange,
						fromTime: vm.fromTime,
						toTime: vm.toTime,
						reportType: 'open'
					}, function (response) {
						var a = document.createElement("a");
						a.style = "display: none";
						var file = new Blob([(response)], { type: 'application/csv' });
						var fileURL = URL.createObjectURL(file);
						a.href = fileURL;
						a.download = "open_cases_report.csv";
						a.click();
						window.URL.revokeObjectURL(fileURL);
					});
				} else if (vm.downloadType == 'closedcases') {
					Report.getClosedCasesReportDownload({
						id: 0,
						ageType: vm.dateRange,
						fromTime: vm.fromTime,
						toTime: vm.toTime,
						reportType: 'closed'
					}, function (response) {
						var a = document.createElement("a");
						a.style = "display: none";
						var file = new Blob([(response)], { type: 'application/csv' });
						var fileURL = URL.createObjectURL(file);
						a.href = fileURL;
						a.download = "closed_cases_report.csv";
						a.click();
						window.URL.revokeObjectURL(fileURL);
					});
				}
			}

		}
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('CaseTatReportController', CaseTatReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce){
    return function(text) {
        return $sce.trustAsHtml(text);
    	};
	}]);

	CaseTatReportController.$inject = [ '$scope','$sce' ,'$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval','Principal' ];

	function CaseTatReportController($scope, $sce,$state, Report, $rootScope, $timeout, $window, $filter, $interval,Principal) {
		var vm = this;
		vm.users = [];
		$scope.reporthide = false;
		vm.reportUser = $rootScope.userName;
		vm.openCalendar = openCalendar;
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		vm.datePickerOpenStatus = {};
		vm.tat = 5;
		vm.users = loadPage();
		$scope.loader = false;
		vm.search='';
		
		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		
		function loadPage(){
			Report.getUsers('', function(response) {
				vm.users = response;
			})
		}
		
		
		$scope.report = function() {
		 
			Report.getCasesTatReport({
					reportType:"USER",
					ageType:vm.dateRange,
					login:vm.reportUser,
					 tat : vm.tat,
					 fromDateTime : vm.fromTime,
					 toDateTime : vm.toTime
				}, function(response) {
					$scope.myhtml = response;
				});

		}
		var strokeWidth = 1.5;
		var margin = { top: 20, bottom: 20, left: 30, right: 20 };
		var width = 600 - margin.left - margin.right - (strokeWidth * 2);
		var height = 200 - margin.top - margin.bottom;

		var x0 = d3.scale.ordinal()
			.rangeRoundBands([0, width], .1);

		var x1 = d3.scale.ordinal();

		var y = d3.scale.linear()
			.range([height, 0]);

		var color = d3.scale.ordinal()
		.range(["#00FF00", "#000080", "#FFA500", "#FF0000"]);

		var xAxis = d3.svg.axis()
			.scale(x0)
			.orient("bottom");

		var yAxis = d3.svg.axis()
			.scale(y)
			.orient("left")
			.tickFormat(d3.format(".2s"));

		var svg = d3.select("#verticalBarChart").append("svg")
			.attr("viewBox", "0 0 600 200")
			// .attr("width", width + margin.left + margin.right)
			// .attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		// d3.csv("data.csv", function(error, data) {
		var data = [
			{
				"State": 0,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 1,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 2,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 3,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 4,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 5,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},


		]

		var ageNames = d3.keys(data[0]).filter(function (key) { return key !== "State"; });

		data.forEach(function (d) {
			d.ages = ageNames.map(function (name) { return { name: name, value: +d[name] }; });
		});

		x0.domain(data.map(function (d) { return d.State; }));
		x1.domain(ageNames).rangeRoundBands([0, x0.rangeBand()]);
		y.domain([0, d3.max(data, function (d) { return d3.max(d.ages, function (d) { return d.value; }); })]);

		svg.append("g")
			.attr("class", "x axis")
			.attr("transform", "translate(0," + height + ")")
			.call(xAxis)
			.append("text")
			.attr("text-anchor", "end")
			.attr("x", 560)
			.attr("dx", ".71em")
			.text("Weeks")
			;

		svg.append("g")
			.attr("class", "y axis")
			.call(yAxis)
			.append("text")
			.attr("transform", "rotate(-90)")
			.attr("y", 4)
			.attr("dy", ".71em")
			.style("text-anchor", "end")
			.text("Cases");

		var state = svg.selectAll(".state")
			.data(data)
			.enter().append("g")
			.attr("class", "g")
			.attr("transform", function (d) { return "translate(" + x0(d.State) + ",0)"; });

		state.selectAll("rect")
			.data(function (d) { return d.ages; })
			.enter().append("rect")
			.attr("class", "bars")
			.attr("width", x1.rangeBand())
			.attr("x", function (d) { return x1(d.name); })
			.attr("y", function (d) { return y(d.value); })
			.attr("height", function (d) { return height - y(d.value); })
			.style("fill", function (d) { return color(d.name); });

		state.selectAll("text")
			.data(function (d) { return d.ages; })
			.enter().append("text")
			.attr("class", "barstext")
			.attr("x", function (d) { return x1(d.name); })
			.attr("y", function (d) { return y(d.value); })
			.text(function (d) { return (d.value) })
		// .text(function (d) { console.log(d.value / 1000000); return (d.value / 1000000).toFixed(2)})

		var legend = svg.selectAll(".legend")
			.data(ageNames.slice().reverse())
			.enter().append("g")
			.attr("class", "legend")
			.attr("transform", function (d, i) { return "translate(0," + i * 20 + ")"; });

		legend.append("rect")
			.attr("x", width - 22)
			.attr("width", 10)
			.attr("height", 10)
			.style("fill", color);

		legend.append("text")
			.attr("x", width - 12)
			.attr("y", 5)
			.attr("dy", ".20em")
			// .style("text-anchor", "end")
			.text(function (d) { return d; });

		// });
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('CaseReportController', CaseReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	CaseReportController.$inject = ['$scope', '$sce', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval', 'AllCaseTypes', 'DownloadCaseReports'];

	function CaseReportController($scope, $sce, $state, Report, $rootScope, $timeout, $window, $filter, $interval, AllCaseTypes, DownloadCaseReports) {
		var vm = this;
		vm.sortResponse = sortResponse;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.reportTypeChange = reportTypeChanged;
		vm.downloadCaseReport = downloadCaseReport;
		vm.submitCaseReport = submitCaseReport;
		vm.users = [];
		vm.batteryusers = [];
		vm.geofences = [];
		$scope.reporthide = false;
		vm.select2 = select2;
		// vm.selectshow = selectshow;
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		// vm.caseReport = true;
		vm.selectCaseType = 1;
		$scope.reporthide = false;
		// vm.today();
		vm.select2();
		Report.getUsers('', function (response) {
			vm.batteryusers = response;

		})

		AllCaseTypes.getAll(function (response) {
			vm.caseTypes = response;
		});

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		
		function downloadCaseReport() {
			var caseTypeId = 0;
			if (vm.selectCaseType != 'all') {
				caseTypeId = vm.selectedCaseType.id;
			}
			Report.getCaseReport({
				id: caseTypeId,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.caseType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "case_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function submitCaseReport() {
			var caseTypeId = 0;
			if (vm.selectCaseType != 'all') {
				caseTypeId = vm.selectedCaseType.id;
			}
			Report.getCaseReportList({
				id: caseTypeId,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.caseType
			}, function (response) {
				vm.reportRecords = response;
				$scope.reporthide = true;
			});
		}

		function sortResponse() {
			var caseTypeId = 0;
			if (vm.selectCaseType != 'all') {
				caseTypeId = vm.selectedCaseType.id;
			}
			Report.getCaseReportList({
				id: caseTypeId,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType: vm.caseType
			}, function (response) {
				vm.reportRecords = response;
				$scope.reporthide = true;
			});
		}

		//vm.detailedReport = detailedReport;

		vm.selecterange = selectRange;
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		function selectRange(range) {
			if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} else if (range == 'year') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setYear(date.getFullYear() - 1);
				vm.fromTime = date.getTime();
			}
		}
		function select2() {
			$(".select2").select2();
			vm.caseReport = true;
		}
		function reportTypeChanged() {
			$scope.reporthide = false;
			if (vm.reportType == 'AGENT') {
				if (vm.users.length == 0) {
					Report.getUsers('', function (response) {
						vm.users = response;
					})
				}
			} else if (vm.reportType == 'GEOFENCE') {
				if (vm.geofences.length == 0) {
					Report.getGeofences('', function (response) {
						vm.geofences = response;
					})
				}
			}

		}
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		$scope.report = function () {
			Report.getCasesReport({
				"fromDateTime": vm.fromTime,
				"toDateTime": vm.toTime,
				"caseReportType": vm.reportType
			}, function (response) {
				$scope.myhtml = response;
			});
		}
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('CaseAgingReportController', CaseAgingReportController);
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	CaseAgingReportController.$inject = ['$scope', '$sce', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval', 'Principal'];

	function CaseAgingReportController($scope, $sce, $state, Report, $rootScope, $timeout, $window, $filter, $interval, Principal) {
		var vm = this;
		vm.geofence = [];
		$scope.reporthide = false;
		// vm.reportUser = $rootScope.userName;
		vm.openCalendar = openCalendar;
		vm.geofence = loadPage();
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		vm.datePickerOpenStatus = {};
		vm.reportGenerated = false;
		vm.reportGeneratedFileName = '';
		vm.data;
		vm.tableShow = false
		vm.dateRange;
		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		$(".select2").select2();

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		vm.calculateToDate = function calculateToDate() {
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		};

		vm.calculateFromDate = function calculateFromDate() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		};

		function loadPage() {
			Report.getGeofences('', function (response) {
				vm.geofence = response;

			});
		}

		$scope.loader = false;

		$scope.getPdf = function () {
			$scope.loader = true;
			html2canvas(reportpdf, {
				onrendered: function (canvas) {
					var img = canvas.toDataURL("image/png");
					var pdf = new jsPDF('landscape', 'mm', 'a2');
					pdf.addImage(img, 'JPEG', 0, 0);
					pdf.save($scope.pdftype);
					$scope.loader = false;
				}
			});
			$interval(function () { }, 1000);
		};

		function select2() {
			$(".select2").select2();
		}

		$scope.report = function () {

			Report.getCasesAgingReport({
				reportType: "GEOFENCE",
				ageType: vm.dateRange,
				fromDateTime: vm.fromTime,
				toDateTime: vm.toTime,
				geofenceId: vm.reportGeofence
			}, function (response) {
				vm.data = response;
				clearChart()
				initBarChart(vm.data);
			});
			vm.reportGenerated = true;
		};

		$scope.downloadCaseAgingReport = function () {
			Report.getCasesAgingReport({
				ageType: vm.dateRange,
				fromDateTime: vm.fromTime,
				toDateTime: vm.toTime,
				geofenceId: vm.reportGeofence
			}, function (response) {
				var csvContent = "data:text/csv;charset=utf-8,";
				var headers = Object.keys(response[0]);
				csvContent += headers.join(",") + "\n";
				response.forEach(function (row) {
					var values = headers.map(function (header) {
						return row[header];
					});
					csvContent += values.join(",") + "\n";
				});
				var encodedUri = encodeURI(csvContent);
				var link = document.createElement("a");
				link.setAttribute("href", encodedUri);
				link.setAttribute("download", "case_aging_report.csv");
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
		};

		function clearChart() {
			d3.select("#virticalBarchart").selectAll("*").remove();
		}

		function initBarChart(data) {

			var colorScale = d3.scale.ordinal()
				.domain(["HIGH", "MEDIUM", "CRITICAL", "LOW"])
				.range(["#fd7a24", "#00a658", "red", "#294985"]);
			var groupedData = d3.nest()
				.key(function (d) {
					return d.ageType + "-" + d.priority;
				})
				.rollup(function (v) {
					return v.length;
				})
				.entries(data);
			var dataArray = groupedData.map(function (d) {
				var split = d.key.split("-");
				return {
					ageType: split[0],
					priority: split[1],
					count: d.values
				};
			});
			dataArray.sort(function (a, b) {
				return parseInt(a.ageType) - parseInt(b.ageType);
			});

			var margin = {
				top: 20,
				right: 30,
				bottom: 80,
				left: 50
			};
			var width = 1000 - margin.left - margin.right;
			var height = 450 - margin.top - margin.bottom;

			var tooltip1 = d3.select("body").append("div")
				.attr("class", "tooltip1")
				.style("opacity", 0);

			var svg = d3.select("#virticalBarchart")
				.append("svg")
				.attr("width", width + margin.left + margin.right)
				.attr("height", height + margin.top + margin.bottom)
				.append("g")
				.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

			var x = d3.scale.ordinal()
				.domain(dataArray.map(function (d) { return d.ageType + "-" + d.priority; }))
				.rangeRoundBands([0, width], 0.6);

			var y = d3.scale.linear()
				.domain([0, d3.max(dataArray, function (d) { return d.count; })])
				.range([height, 0]);

			svg.selectAll(".bar2")
				.data(dataArray)
				.enter().append("rect")
				.attr("class", "bar2")
				.attr("fill", function (d) {
					return colorScale(d.priority.toUpperCase());
				})
				.attr("x", function (d) {
					return x(d.ageType + "-" + d.priority);
				})
				.attr("width", x.rangeBand())
				.attr("y", function (d) {
					return y(d.count);
				})
				.attr("height", function (d) {
					return height - y(d.count);
				}).on("mouseover", function (d) {
					tooltip1.transition()
						.duration(100)
						.style("opacity", .9);
					tooltip1.html("Age: " + d.ageType + "<br/>Priority: " + d.priority + "<br/>Case: " + d.count)
						.style("left", (d3.event.pageX) + "px")
						.style("top", (d3.event.pageY - 28) + "px");
				})
				.on("mouseout", function (d) {
					tooltip1.transition()
						.duration(300)
						.style("opacity", 0);
				});;

			svg.selectAll(".bar-text")
				.data(dataArray)
				.enter().append("text")
				.attr("class", "bar-text")
				.attr("x", function (d) { return x(d.ageType + "-" + d.priority) + x.rangeBand() / 2; })
				.attr("y", function (d) { return y(d.count) - 5; })
				.attr("text-anchor", "middle")
				.text(function (d) { return d.count; });

			svg.append("g")
				.attr("class", "x axis1")
				.attr("transform", "translate(0," + height + ")")
				.call(d3.svg.axis().scale(x).orient("bottom").tickFormat(function (d) {
					return d.split("-")[0];
				}))
				.selectAll("text")
				.style("text-anchor", "end")
				.attr("dx", "-.9em")
				.attr("dy", "1.0em")
				.attr("font-size", "10px")
				.attr("transform", "rotate(-45)");

			// Add Y axis
			svg.append("g")
				.attr("class", "y axis1")
				.call(d3.svg.axis().scale(y).orient("left").tickFormat(d3.format("d")));

			svg.append("text")
				.attr("transform", "rotate(-90)")
				.attr("y", 0 - margin.left)
				.attr("x", 0 - (height / 2))
				.attr("dy", "1em")
				.style("text-anchor", "middle")
				.attr("font-size", "17px")
				.text("CASES");

			// Legend
			var legend = svg.selectAll(".legend")
				.data(colorScale.domain())
				.enter().append("g")
				.attr("class", "legend")
				.attr("transform", function (d, i) {
					return "translate(0," + i * 20 + ")";
				});

			legend.append("rect")
				.attr("x", width - 18)
				.attr("width", 18)
				.attr("height", 18)
				.style("fill", colorScale);

			legend.append("text")
				.attr("x", width - 24)
				.attr("y", 9)
				.attr("dy", ".35em")
				.style("text-anchor", "end")
				.text(function (d) {
					return d;
				});
		}



	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("BurriedChamberReportController", BurriedChamberReportController);

    BurriedChamberReportController.$inject = ["UserMasterGeofences","MiniGeofencesByMasterID","Report"
    ];

    function BurriedChamberReportController(UserMasterGeofences,MiniGeofencesByMasterID,Report
    ) {
        var vm = this;
        $(".select2").select2();
        load();
        vm.statuslabel = {
            search          : "Search",
            nothingSelected : "Select",
            selectAll       : "All",
            selectNone      : "None", 
            Done : "Done" 
        }

        vm.ids = [];
        vm.searchMini="";
        function load() {
            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];

                vm.ids = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                            vm.ids.push(value.id);
                        });
                    }
                );
            });
        }

        vm.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.selectedGeofenceId="";
            vm.geofenceMini = [];
            vm.ids = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                        vm.ids.push(value.id);
                    });
                }
            );
        };

        vm.onMiniChange = function () {
            vm.selectedAssetId = "";
            vm.ids = [];
            if(vm.selectedGeofenceId==""){
                vm.showMessageError = false;
                vm.showMessage = false;
                vm.selectedGeofenceId="";
                vm.ids = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                            vm.ids.push(value.id);
                        });
                    }
                );
            } else {
                vm.ids.push(vm.selectedGeofenceId);
                Report.getAssetNameByGeofences({
                    ids: vm.ids
                }, function (response) {
                   vm.assets = response;
                });
            }
            
        };

        vm.onAssetChange = function () {
            vm.burriedReportList = [];
        };

        vm.downloadBurriedReport = function (){

            Report.getBurriedReportDownload({
                ids: vm.ids,
                id:vm.selectedAssetId
            }, function (response) {
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([(response)], { type: 'application/csv' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "burried_report.csv";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
            
        }

        vm.surveyReport = function(){

            vm.surveyTotalLength = 0
            Report.getBurriedReportList({
                ids: vm.ids,
                id:vm.selectedAssetId
            },function (response){
                vm.burriedReportList = response;
            }) 
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetKmlDumpDialogController", AssetKmlDumpDialogController);

        AssetKmlDumpDialogController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "Report",
        "AllCaseTypes",
        "UserMasterGeofences",
        "MiniGeofencesByMasterID",
        "AssetType",
        "BaseUrl",
        "myservice"
    ];
    
    function AssetKmlDumpDialogController(
        $timeout,
        $state,
        $scope,
        Report,
        AllCaseTypes,
        UserMasterGeofences,
        MiniGeofencesByMasterID,
        AssetType,
        BaseUrl,
        myservice
    ) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.searchMini = "";
        vm.report;
        vm.geofences = [];
        vm.userMasterGeofences = [];
        vm.geofenceMini;
        vm.selectedMasterGeofenceId = 0;
        vm.selectedGeofenceId;
        vm.entity = 'Assets';
        vm.entityLayout = 'SPREAD';
        vm.entityFileFormat = 'KML';
        vm.showMessage = false;
        vm.showMessageError = false;
        vm.trackingId;
        //vm.submit = true;
        vm.entityTask='DOWNLOAD';

        $(".select2").select2(); // Added search for select box
        vm.users = loadPage();
        $(".select2").change(function () {
            vm.showMessage = false;
            vm.showMessageError = false;
            //vm.submit = true;
        });

        function loadPage() {

            AssetType.query(
                {
                    page: 0,
                    size: 100,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
            }
            function onSuccess(data, headers) {
                vm.assetTypesData = data;
                vm.assetTypes = [];
                vm.assetTypesData.filter(function(val){
                    if(val.layout  == "SPREAD"){
                        vm.assetTypes.push({name: val.name, id: val.id});
                    }
                });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                        });
                    }
                );
            });
            AllCaseTypes.getAll(function (response) {
                vm.caseTypes = response;
            });
        }

        $scope.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            //vm.submit = true;
            vm.geofenceMini = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );

        };


        $scope.entityDump = function () {
            //vm.submit = false;
            if (vm.entity == "Assets") {
                var geofenceDTO = vm.selectedGeofenceId;
                var geofenceId = geofenceDTO;
                    if(geofenceDTO.length == 0){
                        geofenceId = [];
                        geofenceId.push({"id":parseInt(vm.selectedMasterGeofenceId)});
                    }
                    
                    Report.downloadKmlAssetReport(
                        {
                            entityName : vm.entity,
                            geofences: geofenceId,
                            task: vm.entityTask,
                            source: vm.entitySource
                        },
                        function (response) {
                            var a = document.createElement("a");
                            a.style = "display: none";
                            var file = new Blob([(response)], { type: 'application/text' });
                            var fileURL = URL.createObjectURL(file);
                            a.href = fileURL;
                            a.download = vm.entity + ".kml";
                            a.click();
                            window.URL.revokeObjectURL(fileURL);
                        }
                    );
            } else {
                alert("Please select valid entity!");
            }
        };
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetHealthStatusController", AssetHealthStatusController);

    AssetHealthStatusController.$inject = [
        "$scope",
        "AlertService",
        "UserMasterGeofences",
        "MiniGeofencesByMasterID",
        "AssetStatusListWithGeofence",
        "CasesForAsset",
        "Report"
    ];

    function AssetHealthStatusController(
        $scope,
        AlertService,
        UserMasterGeofences,
        MiniGeofencesByMasterID,
        AssetStatusListWithGeofence,
        CasesForAsset,
        Report
    ) {
        var vm = this;
        
        vm.userMasterGeofences = [];
        vm.geofenceMini = [];
        vm.caseTable = caseTable;
        vm.downloadAssetHealthStatusReport = downloadAssetHealthStatusReport;
        vm.sortResponse = sortResponse;

        load();
        

        function load() {
            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                        });
                    }
                );
            });
        }

        $scope.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.selectedGeofenceId="";
            vm.geofenceMini = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );
        };
        vm.predicate = 'assetId';
        $scope.onMiniChange = function () {
            Report.getAssetHealthListWithGeoReport({
				id: vm.selectedGeofenceId,
                sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
			}, function (response) {
                vm.assetRecords = response;
			});
        };

        function caseTable(assetRecord) {
            vm.assetRecords.forEach(function (item) {
                item.isExpanded = false;
            });
            if (vm.toggle == assetRecord.assetId) {
                vm.toggle = undefined;
            } else {
                assetRecord.isExpanded = true;
                vm.toggle = assetRecord.assetId;
            }
            CasesForAsset.query(
                {
                    assetId: assetRecord.assetId
                },
                onSuccessList,
                onErrorList
            );
            function onSuccessList(data) {
                vm.caseRecords = data;
                console.log(vm.caseRecords);
            }

            function onErrorList(error) {
                AlertService.error(error.data.message);
            }
        }
        function downloadAssetHealthStatusReport() {
            Report.getAssetHealthStatusReportDownload({
                id: vm.selectedGeofenceId
            }, function (response) {
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([(response)], { type: 'application/csv' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "asset_health_status_report.csv";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
		}

        function sortResponse() {
			Report.getAssetHealthListWithGeoReport({
				id: vm.selectedGeofenceId,
                sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
			}, function (response) {
                vm.assetRecords = response;
			});
		}
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetHealthController", AssetHealthController);

    AssetHealthController.$inject = [
        "$scope",
        "$rootScope",
        "AlertService",
        "DEFAULT_LATITUDE",
        "DEFAULT_LONGITUDE",
        "UserAccount",
        "UserGeofences",
        "GeofenceIDs",
        "AssetByID",
        "AssetType",
        "BufferGeofencesByMiniID",
        "AssetGroupByBufferGeo",
    ];

    function AssetHealthController(
        $scope,
        $rootScope,
        AlertService,
        DEFAULT_LATITUDE,
        DEFAULT_LONGITUDE,
        UserAccount,
        UserGeofences,
        GeofenceIDs,
        AssetByID,
        AssetType,
        BufferGeofencesByMiniID,
        AssetGroupByBufferGeo
    ) {
        var vm = this;

        var locations = {};
        var isAdmin = false;
        vm.userGeofences = [];
        vm.selectedGeofenceId = 0;
        var markers = [];
        var polylines = [];
        vm.mapAssets = [];
        var latlng = null;
        var activeInfo;
        vm.selectedGeofence = {};
        vm.assetTypes = [];
        vm.previousPolygons = [];
        vm.select2 = select2;
        vm.closeAssetAttributesModal = closeAssetAttributesModal;
        vm.closeThreePointReference = closeThreePointReference;
        vm.saveGeofenceFilter = saveGeofenceFilter;
        vm.showAssetHealth = showAssetHealth;
        var openedInfoWindow = null;
        var prevInfoWindow = null;
        vm.bufferGeoAssets = [];
        var polylines = [];
        vm.assetHealthDistance = [];
        vm.select2();
        load();

        function select2() {
            $(".select2").select2();
        }

        function load() {
            document.getElementById("myspan").textContent = " ";
            /*  var myOptions = {
                zoom: 12,
                center: new google.maps.LatLng(
                    DEFAULT_LATITUDE.value,
                    DEFAULT_LONGITUDE.value
                ),
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */

            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(
                    12,
                    new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value)
                )
            );
            geoLocation(locations.map);
            vm.userGeofences = [];
            UserAccount.get(function (data) {
                isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }
                });
                if (isAdmin) {
                    GeofenceIDs.getAll(function (response) {
                        response.forEach(function (geofence) {
                            vm.userGeofences.push(geofence);

                            if (vm.selectedGeofenceId == null) {
                                vm.selectedGeofenceId = geofence.id;
                            }
                        });
                        vm.countLength = vm.userGeofences.length;
                    });
                } else {
                    UserGeofences.getAll(function (response) {
                        response.forEach(function (geofence) {
                            vm.userGeofences.push(geofence);

                            if (vm.selectedGeofenceId == null) {
                                vm.selectedGeofenceId = geofence.id;
                            }
                        });
                        vm.countLength = vm.userGeofences.length;
                    });
                }
            });
            AssetType.query(
                {
                    page: 0,
                    size: 100,
                },
                onSuccess,
                onError
            );
            function onSuccess(data, headers) {
                vm.assetTypes = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function showAssetHealth() {
            vm.mapAssets = [];
            markers = [];
            polylines = [];
            vm.assetHealthDistance = [];

            var myOptions = {
                zoom: 12,
                center: new google.maps.LatLng(
                    DEFAULT_LATITUDE.value,
                    DEFAULT_LONGITUDE.value
                ),
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };

            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(
                    12,
                    new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value)
                )
            );
            geoLocation(locations.map);
            document.getElementById("myspan").textContent = "";
            saveGeofenceFilter();

            AssetGroupByBufferGeo.get(
                vm.selectedGeofenceId,
                function (response) {
                    vm.bufferGeoAssets = Object.values(response);
                    var geofenceIds = Object.keys(response);
                    vm.bufferGeoAssets.forEach(function (assetList, index) {
                        drawAssets(assetList, geofenceIds[index]);
                    });
                }
            );
        }

        function drawAssets(response, geofenceId) {
            var normalDistance = 0;
            var okDistance = 0;
            var notOkDistance = 0;
            if (response) {
                var assetList = [];
                $.each(response, function (index, value) {
                    if (value.assetTypeLayout == null) {
                        value.assetTypeName = value.assetType.name;
                        value.assetTypeLayout = value.assetType.layout;
                        value.assetTypeImagePath = value.assetType.imagePath;
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "FIXED"
                    ) {
                        if (value.assetCoordinates.length > 1) {
                            var value1 = value;
                            value1.assetCoordinates = [
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ],
                            ];

                            // drawFixedAsset(value1);
                            assetList.push(value1);
                        } else {
                            // drawFixedAsset(value);
                            assetList.push(value);
                        }
                    }
                });
                assetList.forEach(function (value) {
                    drawFixedAsset(value);
                });
                var previousAsset = null;
                assetList.forEach(function (assetVal) {
                    if (previousAsset != null) {
                        if (previousAsset.assetCoordinates != undefined) {
                            var pathColor = "blue";
                            if (
                                previousAsset.healthIndicator == null ||
                                assetVal.healthIndicator == null
                            ) {
                                pathColor = "blue";
                            } else if (
                                previousAsset.healthIndicator &&
                                assetVal.healthIndicator
                            ) {
                                pathColor = "green";
                            } else if (
                                !previousAsset.healthIndicator ||
                                !assetVal.healthIndicator
                            ) {
                                pathColor = "red";
                            }

                            var path = [];

                            path.push({
                                lat: previousAsset.assetCoordinates[0].latitude,
                                lng:
                                    previousAsset.assetCoordinates[0].longitude,
                            });
                            path.push({
                                lat: assetVal.assetCoordinates[0].latitude,
                                lng: assetVal.assetCoordinates[0].longitude,
                            });
                            var dis = distanceCal(
                                path[0].lat,
                                path[0].lng,
                                path[1].lat,
                                path[1].lng
                            );
                            switch (pathColor) {
                                case "green":
                                    okDistance += dis;
                                    break;
                                case "red":
                                    notOkDistance += dis;
                                    break;
                                case "blue":
                                    normalDistance += dis;
                                    break;
                                default:
                                    normalDistance += dis;
                                    break;
                            }
                            drawHealthPolyline(path, pathColor);
                        }
                    }
                    previousAsset = assetVal;
                });
            }
            for (var i = 0; i < vm.assetHealthDistance.length; i++) {
                if (vm.assetHealthDistance[i].id == geofenceId) {
                    vm.assetHealthDistance[i].okDistance = okDistance.toFixed(
                        2
                    );
                    vm.assetHealthDistance[
                        i
                    ].notOkDistance = notOkDistance.toFixed(2);
                    vm.assetHealthDistance[
                        i
                    ].normalDistance = normalDistance.toFixed(2);
                }
            }
        }

        function saveGeofenceFilter() {
            vm.previousPolygons.forEach(function (polygon) {
                polygon.setMap(null);
            });
            vm.previousPolygons = [];
            var canZoomToLocation = true;
            BufferGeofencesByMiniID.get(
                vm.selectedGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.assetHealthDistance.push({
                            id: value.id,
                            name: value.name,
                        });
                        vm.previousPolygons.push(
                            drawPolygon(value, locations.latlng, "blue", 3)
                        );
                        if (canZoomToLocation) {
                            var path = JSON.parse(value.coordinates);
                            locations.map.setZoom(14);
                            if (path.length > 0) {
                                locations.map.setCenter(path[0]);
                            }
                            canZoomToLocation = false;
                        }
                    });
                }
            );
        }

        function drawPolygon(value, latlang, color, zIndex) {
            var path = JSON.parse(value.coordinates);
            // drawPolylineForGeoFence(path, locations.map, value.name);
            var infowindow = new google.maps.InfoWindow({
                content:
                    '<div class="infoWindowhead">' +
                    "name" +
                    '<div class="infoWindowContent"> <b>Description :</b> ' +
                    "des" +
                    "</div></div>",
                minWidth: 160,
            });

            infowindow.setPosition(latlang);
            var strokeColor = "#ff0000";

            if (color == "green") {
                strokeColor = "#00CC00";
            } else if (color == "blue") {
                strokeColor = "#0066CC";
            }

            var tempPolygon = new google.maps.Polygon({
                paths: path,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 1.2,
                fillColor: strokeColor,
                fillOpacity: 0.1,
                zIndex: zIndex,
            });
            google.maps.event.addListener(
                tempPolygon,
                "mouseout",
                function (event) {
                    infowindow.close();
                }
            );

            google.maps.event.addListener(
                tempPolygon,
                "click",
                function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent(
                        '<div class="infoWindowhead">' +
                            "<b>Geofence Name : </b><br><br>" +
                            value.name +
                            "</br></div>"
                    );

                    infowindow.mousemove;
                    infowindow.open(locations.map);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                }
            );
            tempPolygon.setMap(locations.map);
            return tempPolygon;
        }

        function drawFixedAsset(fixed) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";

                var isFixedAsset = false;
                if ($scope.variableHealth) {
                    if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Chamber"
                    ) {
                        iconUrl = "content/images/chamber_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Chamber"
                    ) {
                        iconUrl = "content/images/chamber_red.png";
                    } else if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Coupler"
                    ) {
                        iconUrl = "content/images/coupler_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Coupler"
                    ) {
                        iconUrl = "content/images/coupler_red.png";
                    } else if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Pole"
                    ) {
                        iconUrl = "content/images/pole_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Pole"
                    ) {
                        iconUrl = "content/images/pole_red.png";
                    } else {
                        iconUrl = fixed.assetTypeImagePath;
                    }
                } else {
                    iconUrl = fixed.assetTypeImagePath;
                }

                iconUrl = fixed.assetTypeImagePath;

                var health = "Medium";
                var healthColor = "#0096FF";

                if (fixed.healthIndicator == true) {
                    health = "Good";
                    healthColor = "#00FF7F";
                } else if (fixed.healthIndicator == false) {
                    health = "Bad";
                    healthColor = "#FF5733";
                }

                var iconSize = 36;

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(18, -3),
                    },
                    label: {
                        text: ".",
                        color: healthColor,
                        fontWeight: "bold",
                        fontSize: "40px",
                        opacity: 0.25,
                    },
                });

                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    "<b>Asset Name</b> : " +
                    startMarker.title +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br><b>Health</b> :" +
                    health +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        if (activeInfo != null) {
                            activeInfo.close();
                        }
                        AssetByID.get(fixed.id, function (response) {
                            vm.assetToEdit = response;
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                btnShowAttributes,
                                btnThreePointRef;

                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<b>Asset Name</b> : " +
                                startMarker.title +
                                '</div><div class="infoWindowContent">' +
                                "<b>Lat</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Long</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "<br><b>Health</b> : " +
                                health +
                                "</div><br>";

                            vm.assetTitle = startMarker.title;

                            var attr = document.createAttribute("data-toggle");
                            attr.value = "modal";
                            var attr1 = document.createAttribute("data-target");
                            attr1.value = "#myModalMap";

                            btnShowAttributes = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnShowAttributes.type = "button";
                            btnShowAttributes.value = "More Details";
                            btnShowAttributes.className = "button";

                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            google.maps.event.addDomListener(
                                btnShowAttributes,
                                "click",
                                function () {
                                    showAssetAttributesModal(response);
                                }
                            );

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    showThreePontReferenceModal(response);
                                }
                            );

                            var infoWindow2 = new google.maps.InfoWindow({
                                content: userContent,
                                minWidth: 350,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            infoWindow2.open(locations.map, startMarker);
                            setTimeout(function () {
                                infoWindow2.close();
                            }, 10000);

                            activeInfoWindow = infoWindow2;
                            prevInfoWindow = infoWindow2;
                        });
                    }
                );
                openedInfoWindow = infoWindow2;
            });
        }

        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";

            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Name</th><th style='border: 1px solid black;text-align: center;'>Value</th></tr>";

            assetTypeAttributeValuesList.forEach(function (value) {
                if (
                    value.assetTypeAttribute.assetAttributeTypes ==
                    "NON_REFERENCE"
                ) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        value.assetTypeAttribute.name +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        value.attributeValue +
                        "</td></tr>";
                }
            });
            newTable += "</table>";
            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }

        function showThreePontReferenceModal(assetVal) {
            $("#modalThreePointReference").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues;
            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Object</th><th style='border: 1px solid black;text-align: center;'>Distance (mtr)</th></tr>";
            var ref = ["", "", ""];
            var dist = [0, 0, 0];
            assetTypeAttributeValuesList.forEach(function (value) {
                if (
                    value.assetTypeAttribute.assetAttributeTypes ==
                    "THREE_PNT_REFERENCE"
                ) {
                    if (value.assetTypeAttribute.name == "3 Point Reference1") {
                        ref[0] = value.attributeValue;
                    } else if (
                        value.assetTypeAttribute.name == "3 Point Reference2"
                    ) {
                        ref[1] = value.attributeValue;
                    } else if (
                        value.assetTypeAttribute.name == "3 Point Reference3"
                    ) {
                        ref[2] = value.attributeValue;
                    } else if (value.assetTypeAttribute.name == "Distance1") {
                        dist[0] = value.attributeValue;
                    } else if (value.assetTypeAttribute.name == "Distance2") {
                        dist[1] = value.attributeValue;
                    } else if (value.assetTypeAttribute.name == "Distance3") {
                        dist[2] = value.attributeValue;
                    }
                }
            });

            for (var i = 0; i < 3; i++) {
                newTable +=
                    "<tr><td style='border: 1px solid black;text-align: center;'>" +
                    ref[i] +
                    "</td><td style='border: 1px solid black;text-align: center;'>" +
                    dist[i] +
                    "</td></tr>";
            }
            newTable += "</table>";
            document.getElementById(
                "assetNameThreePointReference"
            ).textContent = assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById(
                "threePointReferenceTable"
            ).innerHTML = newTable;
        }

        function closeAssetAttributesModal() {
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
        }

        function closeThreePointReference() {
            $("#modalThreePointReference").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalThreePointReference").hide();
        }

        function drawHealthPolyline(path, color) {
            var strokeColor = "#0000FF";
            if (color == "green") {
                strokeColor = "#008000";
            } else if (color == "red") {
                strokeColor = "#FF0000";
            } else if (color == "blue") {
                strokeColor = "#fd7a24";
            }

            var polyline = new google.maps.Polyline({
                path: path,
                geodesic: true,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 10,
                fillColor: strokeColor,
                fillOpacity: 0.4,
            });
            polyline.setMap(locations.map);
            polylines.push(polyline);
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                    Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                    Math.cos(degrees_to_radians(lat2)) *
                    Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "AssetGeofenceMappingController",
            AssetGeofenceMappingController
        );

    AssetGeofenceMappingController.$inject = [
        "$scope",
        "AllMiniGeofencesByMasterID",
        "AllTenant",
        "MasterGeofencesByTenantID",
        "AssetsGeofenceMapping"
    ];

    function AssetGeofenceMappingController(
        $scope,
        AllMiniGeofencesByMasterID,
        AllTenant,
        MasterGeofencesByTenantID,
        AssetsGeofenceMapping
    ) {
        var vm = this;

        vm.userMasterGeofences = [];
        vm.geofenceMini = [];
        vm.associateAssetsToGeofence = associateAssetsToGeofence;
        

        load();

        function load() {
            AllTenant.getAll(function (response) {
                vm.tenants = response;
            });
        }

        $scope.onTenantChange = function () {
            vm.userMasterGeofences = [];
            MasterGeofencesByTenantID.get(
                vm.selectedTenantId,
                function (response) {
                    vm.userMasterGeofences = response;
                }
            );
        };

        $scope.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.selectedGeofenceId = "";
            vm.geofenceMini = [];
            AllMiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );
        };

        function associateAssetsToGeofence() {
            AssetsGeofenceMapping.query(
                {
                    geofenceId: vm.selectedGeofenceId,
                },
                onSuccess,
                onError
            );
            function onSuccess(data, headers) {
                console.log(data);
                console.log(headers);
            }

            function onError(error) {
                console.log(error);
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetReportController', AssetReportController)

	AssetReportController.$inject = [ '$timeout', '$scope', 'Report', '$stateParams', '$q', '$filter', 'CaseType', 'AssetSearchForMap', 'AllCaseTypes' ];

	function AssetReportController($timeout, $scope, Report, $stateParams, $q, $filter, CaseType, AssetSearchForMap, AllCaseTypes) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.today = today;
		vm.today();
		vm.assetList = "";
		var usersMap = {};
		vm.caseType = "";

		vm.filterAssetsList = filterAssetsList;

		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
		}
		vm.caseTypes = loadPage();// CaseType.query();

		function loadPage() {
			AllCaseTypes.getAll(function(response) {
				vm.caseTypes = response;
			});
		}

		// Added for asset search start
		function filterAssetsList() {
			if (vm.assetType != null && vm.assetType != "" && !angular.isUndefined(vm.assetType)) {
				AssetSearchForMap.searchassetsformap(vm.assetType, function(response) {
					vm.assetList = response;
				});
			}
		}
		;
		// Added for asset search end ////

		// Added for caseType Attribute start /////
		// vm.caseType = vm.caseTypes;
		vm.selectattributes = function() {
			if (vm.caseType) {
				vm.attributeValues = [];
				$.each(vm.caseType.caseTypeAttribute, function(key, value) {
					if (vm.caseType.caseTypeAttribute[key].dataType === 'INTEGER' || vm.caseType.caseTypeAttribute[key].dataType === 'FLOAT')
						vm.attributeValues.push({
							caseTypeAttribute : vm.caseType.caseTypeAttribute[key]
						});
				});
			}

		}
		// clear search fields
		$scope.clearSearch = function() {
			vm.caseType = "";
			vm.attribute = "";
		};
		// Added for caseType Attribute end ////////
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;
		
		if (vm.fromDate > vm.toDate) {
             return false;
         }

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		$scope.assetReport = function() {

			// vm.caseType = vm.caseType.id;
			// vm.attribute = vm.attribute.caseTypeAttribute.name;
			angular.forEach(vm.assetList, function(value, key) {
				if (vm.assetType === value.name) {
					vm.assetIdReport = value.id;
				}
			});

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			if (vm.assetIdReport != null && vm.caseType.id == null) {
				Report.getAssetCaseTypeReport(vm.assetIdReport, vm.fromTime, vm.toTime, function(response) {
					$scope.assetBar = response;
					$scope.assetCaseCount = [];
					$scope.caseType = [];

					angular.forEach($scope.assetBar, function(value, key) {
						$scope.assetCaseCount.push(value.count);
						$scope.caseType.push(value.caseType);

					});
					// $scope.assetValue = [10, 15, 20, 25];
					// $scope.createTime = ['2017-3-9', '2017-3-10',
					// '2017-3-11', '2017-3-12' ];

					Highcharts.chart('asset_graph', {
						chart : {
							type : 'column'
						},
						title : {
							text : 'Asset Usage Report'
						},

						subtitle : {
							text : vm.assetType
						},

						yAxis : {
							title : {
								text : "Task Count"
							}
						},
						legend : {
							layout : 'vertical',
							align : 'right',
							verticalAlign : 'middle'
						},
						xAxis : {
							categories : $scope.caseType
						},

						series : [ {
							name : ' ',
							data : $scope.assetCaseCount
						} ],
						credits : {
							enabled : false
						},
						exporting : {
							buttons : {
								contextButton : {
									menuItems : [ {
										textKey : 'downloadPNG',
										onclick : function() {
											var fileName = "Asset_report";
											this.exportChart({
												filename : fileName
											});
										}
									}, {
										textKey : 'downloadPDF',
										onclick : function() {
											this.exportChart({
												type : 'application/pdf'
											});
										}
									} ]
								}
							}
						}

					});

				})
			}
			// if end
			else if (vm.assetIdReport != null && vm.caseType.id != null) {
				Report.getAssetReport(vm.assetIdReport, vm.caseType.id, vm.attribute.caseTypeAttribute.name, vm.fromTime, vm.toTime, function(response) {
					$scope.assetLine = response;
					$scope.assetValue = [];
					vm.totalcount = null;
					$scope.createTime = [];
					angular.forEach($scope.assetLine, function(value, key) {
						;
						vm.totalcount += value.value;
						$scope.assetValue.push(value.value);
						$scope.createTime.push($filter('date')(value.datetime, dateFormat));

					});
					// $scope.assetValue = [10, 15, 20, 25];
					// $scope.createTime = ['2017-3-9', '2017-3-10',
					// '2017-3-11', '2017-3-12' ];

					Highcharts.chart('asset_graph', {

						title : {
							text : 'Asset Usage Report'
						},

						subtitle : {
							text : vm.assetType
						},

						yAxis : {
							title : {
								text : vm.attribute.caseTypeAttribute.name
							}
						},
						legend : {
							title : {
								text : 'Total :' + vm.totalcount
							},
							layout : 'vertical',
							align : 'right',
							verticalAlign : 'middle'
						},
						xAxis : {
							categories : $scope.createTime
						},

						series : [ {
							name : ' ',
							data : $scope.assetValue
						} ],
						credits : {
							enabled : false
						},
						exporting : {
							buttons : {
								contextButton : {
									menuItems : [ {
										textKey : 'downloadPNG',
										onclick : function() {
											var fileName = "Asset_report";
											this.exportChart({
												filename : fileName
											});
										}
									}, {
										textKey : 'downloadPDF',
										onclick : function() {
											this.exportChart({
												type : 'application/pdf'
											});
										}
									} ]
								}
							}
						}

					});

				})
			}// else end

		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetCaseReportController', AssetCaseReportController)

	AssetCaseReportController.$inject = [ '$timeout', '$scope', 'Report', '$stateParams', '$q', '$filter', 'CaseType', 'AssetSearchForMap', 'AllCaseTypes' ];

	function AssetCaseReportController($timeout, $scope, Report, $stateParams, $q, $filter, CaseType, AssetSearchForMap, AllCaseTypes) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		var dateFormat = 'dd EEE HH:mm';
		var date = "dd EEE";
		vm.today = today;
		vm.today();
		vm.assetList = "";
		var usersMap = {};
		vm.caseType = "";
		$scope.reporthide = false;
		vm.search='';
		vm.report;

		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
		}
		vm.caseTypes = loadPage();// CaseType.query();

		function loadPage() {
			AllCaseTypes.getAll(function(response) {
				vm.caseTypes = response;
			});
		}
		

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		$scope.assetReport = function() {
			
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
			$scope.reporthide = true;
			vm.search='';
				Report.getAssetCaseReport(vm.caseType, vm.fromTime, vm.toTime, function(response) {
					vm.reportRecords = response;
				});
		
			
		}
		
		$scope.assetReportSearch = function() {
			if (vm.search != null && vm.search != "" && !angular.isUndefined(vm.search)) {
				Report.getAssetCaseReportSearch(vm.caseType, vm.fromTime, vm.toTime,vm.search, function(response) {
					vm.reportRecords = response;
				});
			}else{
				Report.getAssetCaseReport(vm.caseType, vm.fromTime, vm.toTime, function(response) {
					vm.reportRecords = response;
				});
		}
			
		}

	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("NavbarController", NavbarController);

    NavbarController.$inject = [
        "$state",
        "Auth",
        "Principal",
        "ProfileService",
        "LoginService",
        "$rootScope",
        "UserLogout",
        "Configs"
    ];

    function NavbarController(
        $state,
        Auth,
        Principal,
        ProfileService,
        LoginService,
        $rootScope,
        UserLogout,
        Configs
    ) {
        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated;
        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        var prev = [];
        var prevPlus = [];
        vm.accessRolePlanning = false
        vm.accessRoleRollout = false
        vm.currYear = new Date().getFullYear();
        
        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            UserLogout.post(
                {
                    username: $rootScope.userName,
                    password: "password",
                },
                function (data) {
                    Auth.logout();
                    $rootScope.listAuthorities();
                    $state.go("home");
                }
            );
        }

        vm.isNavbarCollapsed = true;
        function toggleNavbar(id) {
            if (document.getElementById("dashboardtitle")) {
                var getUrl = window.location.hash;
                if (getUrl != "#/login" && getUrl != "#/dashboard") {
                    document.getElementById("dashboardtitle").style.visibility =
                        "hidden";
                }
            }
            
            $(".fa-plus").removeClass("fa-minus");
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
            $(".treeview-menu").removeClass("menu-close").addClass("menu-open");
            /* $("#" + id + " > span.pull-right-container > i").toggleClass(
                "down"
            ); */
            prev.unshift(id);
            if (prev[0] != prev[1]) {
                $(
                    "#" + prev[1] + " > span.pull-right-container > i"
                ).removeClass("down");
                prev.length = 2;
            }
        }

        function collapseNavbar(id) {
            if (document.getElementById("dashboardtitle")) {
                if (typeof id === "undefined") {
                    document.getElementById("dashboardtitle").style.visibility =
                        "hidden";
                } else {
                    document.getElementById("dashboardtitle").style.visibility =
                        "visible";
                }
            }

            vm.isNavbarCollapsed = false;
            //$(".fa-plus").removeClass("fa-minus");
            $(".rotate").removeClass("down");
            $(".treeview").removeClass("active");
            $(".treeview-menu").addClass("menu-close").removeClass("menu-open");
            $rootScope.close = {
                display: "none",
            };
        }

        $rootScope.listAuthorities = function () {
            $rootScope.has_ROLE_SUPER_ADMIN = false;
            $rootScope.has_ROLE_USER_ADMIN = false;
            $rootScope.has_ROLE_USER = false;
            $rootScope.has_ROLE_VENDOR_ADMIN = false;
            $rootScope.has_ROLE_HOD = false;
            $rootScope.has_ROLE_CITY_MANAGER = false;
            $rootScope.has_ROLE_CITY_PLANNER = false;
            $rootScope.has_ROLE_ASSISTANT_MANAGER = false;
            $rootScope.has_ROLE_TEAM_LEADER = false;
            $rootScope.has_ROLE_NETWORK_ENGINEER = false;
            $rootScope.has_ROLE_FRT = false;
            $rootScope.has_ROLE_PATROLLER = false;

            $rootScope.has_ROLE_PLAN_ADMIN = false;
            $rootScope.has_ROLE_ROLLOUT_ADMIN = false;

            Principal.identity().then(function (identity) {
                vm.accessRolePlanning = vm.accessRoleRollout = vm.accessRoleRollout = vm.accessRolePlanningAdmin = vm.accessRoleRolloutAdmin = vm.groupRollout = vm.groupPlan = false
                
                if(identity != null) {
                    //Checking group  
                    identity.groups.forEach(function (val){
                        var convert = val.name.toLowerCase()
                        var res = convert.replace(/[^a-zA-Z]/g, "");
                        if(res.includes("planning")){
                        vm.groupPlan = true
                    }else if(res.includes("rollout")){
                        vm.groupRollout = true
                    }
                    })

                    identity.authorities.forEach(function (val){
                        if((vm.groupPlan && val.includes("ROLE_PLAN_"))){
                        vm.accessRolePlanning = true
                    }else if( (vm.groupRollout && val.includes("ROLE_ROLLOUT_")) || (vm.groupPlan && val.includes("ROLE_ROLLOUT_")) || (vm.groupRollout && val.includes("ROLE_PLAN_"))){
                        vm.accessRoleRollout = true
                    }
                    })

                    //Access for Entity Configuration
                    identity.authorities.forEach(function (val){
                        if(vm.accessRolePlanning && val == "ROLE_PLAN_ADMIN"){
                        vm.accessRolePlanningAdmin = true
                        vm.accessRoleRolloutAdmin = true
                    }/* else if(vm.accessRoleRollout && val == "ROLE_ROLLOUT_ADMIN"){
                        vm.accessRoleRolloutAdmin = true
                    } */
                    })
                }
                if(identity != null) {
                Configs.get("Features", function (response) {
                    response.filter(function (value){

                        if(value.configKey == "SurveyReport"){
                            if(value.configValue == "True"){
                                vm.showSurveyReport = true
                            }else{
                                vm.showSurveyReport = false
                            }
                        }

                        if(value.configKey == "PatrollingReport"){
                            if(value.configValue == "True"){
                                vm.showAssetHealthStatus = true
                            }else{
                                vm.showAssetHealthStatus = false
                            }
                        }

                        if(value.configKey == "EntityImport"){
                            if(value.configValue == "True"){
                                vm.showEntityImport = true
                            }else{
                                vm.showEntityImport = false
                            }
                        }

                        if(value.configKey == "AssetLinkRequest"){
                            if(value.configValue == "True"){
                                vm.showAssetLinkRequest = true
                            }else{
                                vm.showAssetLinkRequest = false
                            }
                        }
                    })
                });}

                if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_SUPER_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_SUPER_ADMIN = true;
                    // $state.go('tenant');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_VENDOR") !== -1
                ) {
                    $rootScope.has_ROLE_VENDOR = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_USER_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_USER_ADMIN = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_HOD") !== -1
                ) {
                    $rootScope.has_ROLE_HOD = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_CITY_MANAGER") !== -1
                ) {
                    $rootScope.has_ROLE_CITY_MANAGER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_CITY_PLANNER") !== -1
                ) {
                    $rootScope.has_ROLE_CITY_PLANNER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_ASSISTANT_MANAGER") !==
                        -1
                ) {
                    $rootScope.has_ROLE_ASSISTANT_MANAGER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_TEAM_LEADER") !== -1
                ) {
                    $rootScope.has_ROLE_TEAM_LEADER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_NETWORK_ENGINEER") !== -1
                ) {
                    $rootScope.has_ROLE_NETWORK_ENGINEER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_FRT") !== -1
                ) {
                    $rootScope.has_ROLE_FRT = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_PATROLLER") !== -1
                ) {
                    $rootScope.has_ROLE_PATROLLER = true;
                    //$state.go('location-log');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_USER") !== -1
                ) {
                    $rootScope.has_ROLE_USER = true;
                    //$state.go('location-log');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_VENDOR_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_VENDOR_ADMIN = true;
                    //$state.go('location-log');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_PLAN_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_PLAN_ADMIN = true;
                    //$state.go('location-log');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_ROLLOUT_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_ROLLOUT_ADMIN = true;
                    //$state.go('location-log');
                }


                if (identity) {
                    $rootScope.userName = identity.login;
                    $rootScope.image = identity.userImage;
                }
            });
        };
        $rootScope.getLocalhour = function (hour) {
            var d = new Date();
            d.setUTCHours(hour);
            d.setUTCMinutes(30);
            return d.getHours();
        };

        $rootScope.getUTChour = function (hour) {
            var d = new Date();
            d.setHours(hour);
            d.setMinutes(0);
            return d.getUTCHours();
        };
        $rootScope.listAuthorities();

        $(document).ready(function () {
            $(window)
                .resize(function () {
                    var width = $(window).width();
                    if (width <= 770) {
                        $(".sidebar-menu>li > a").attr(
                            "data-toggle",
                            "offcanvas"
                        );
                    } else {
                        $(".sidebar-menu>li > a").attr("data-toggle", "");
                    }
                })
                .resize(); //trigger the resize event on page load.
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('HomeController', HomeController)
        .value('DEFAULT_LATITUDE', { value: "12.98330744645683" })
  		.value('DEFAULT_LONGITUDE', { value: "77.56018512933986" });

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$rootScope','UserDetails','DEFAULT_LATITUDE','DEFAULT_LONGITUDE'];

    function HomeController($scope, Principal, LoginService, $state, $rootScope, UserDetails,DEFAULT_LATITUDE,DEFAULT_LONGITUDE) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $rootScope.$on('authenticationSuccess', function () {
            getAccount();
            $rootScope.listAuthorities();
            //  validateStates();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (vm.isAuthenticated() == true) {
					UserDetails.getMasterGeofenceCoods(function (response) {
  						if (response && response.lat && response.lng) {
    						DEFAULT_LATITUDE.value = response.lat;
    						DEFAULT_LONGITUDE.value = response.lng;

  						}
					});
                    validateStates();
                }
            });
        }

        function validateStates() {
            if ($rootScope.has_ROLE_SUPER_ADMIN == true) {
                //$state.go('user-management');
                $state.go('tenant');
            } else if ($rootScope.has_ROLE_USER_ADMIN === true) {
                $state.go('dashboard');
            } else if ($rootScope.has_ROLE_VENDOR === true) {
                $state.go('dashboard');
            } else if ($rootScope.has_ROLE_HOD === true) {
                $state.go('dashboard');
            } else if ($rootScope.has_ROLE_CITY_MANAGER === true) {
                $state.go('dashboard');
            } else if ($rootScope.has_ROLE_CITY_PLANNER === true) {
                $state.go('dashboard');
            } else if ($rootScope.has_ROLE_ASSISTANT_MANAGER === true) {
                $state.go('dashboard');
            } else if ($rootScope.has_ROLE_TEAM_LEADER === true) {
                $state.go('dashboard');
            } else if ($rootScope.has_ROLE_NETWORK_ENGINEER === true) {
                $state.go('dashboard');
            } else if ($rootScope.has_ROLE_FRT == true) {
                $state.go('tr-case');
            }  else if ($rootScope.has_ROLE_PATROLLER == true) {
                $state.go('tr-case');
                /* }else if($rootScope.has_ROLE_USER ==true){
                //$state.go('location-log');
                $state.go('tr-case'); */
            } else if ($rootScope.has_ROLE_ROLLOUT_ADMIN == true) {
                $state.go('work-flow');
            } else if ($rootScope.has_ROLE_PLAN_ADMIN == true) {
                $state.go('work-order');
            }
        }


        function register() {
            $state.go('register');
        }

    }

})();
(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("history", {
                abstract: true,
                parent: "app",
            })
            .state("asset-history", {
                parent: "history",
                url: "/asset-changelog",
                data: {
                    pageTitle: "trakeyeApp.asset.home.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/history/asset-history.html",
                        controller: "AssetHistory",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("asset");
                            return $translate.refresh();
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("History", History);

    History.$inject = ["$resource"];

    function History($resource) {
        var resourceUrl = "api/asset-changelog";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('HistorySearch', HistorySearch);

	HistorySearch.$inject = ['$resource'];

	function HistorySearch($resource) {
		var service = $resource('/api/asset-changelog-search/:searchtext', {
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").controller("AssetHistory", AssetHistory);

    AssetHistory.$inject = [
        "History",
        "$state",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$scope",
        "HistorySearch"
    ];

    function AssetHistory(
        History,
        $state,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $scope,
        HistorySearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.goToPage = goToPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterAssetHistorySearch = filterAssetHistorySearch;

        $("#pagenum").val(pagingParams.page + "");

        loadAll();

        $scope.orderProperty = "assetName";

        $scope.setOrderProperty = function (propertyName) {
            if ($scope.orderProperty === propertyName) {
                $scope.orderProperty = "-" + propertyName;
            } else if ($scope.orderProperty === "-" + propertyName) {
                $scope.orderProperty = propertyName;
            } else {
                $scope.orderProperty = propertyName;
            }
        };

        function loadAll() {
            History.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                },
                onSuccess,
                onError
            );

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;

                vm.page = pagingParams.page;
                getData(data);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function padTo2Digits(num) {
            return num.toString().padStart(2, "0");
        }

        function formatDate(date) {
            return [
                padTo2Digits(date.getDate()),
                padTo2Digits(date.getMonth() + 1),
                date.getFullYear(),
            ].join("/");
        }

        function getData(data) {
            vm.assetHistory = [];
            data.forEach(function (asset) {
                var cdate = formatDate(new Date(asset.createdDate));
                var ldate = formatDate(new Date(asset.lastModifiedDate));

                vm.assetHistory.push({
                    assetId: asset.assetId,
                    assetName: asset.assetName,
                    assetTypeName: asset.assetTypeName,
                    createdBy: asset.createdBy,
                    cdate: cdate,
                    lastModifiedBy: asset.lastModifiedBy,
                    ldate: ldate,
                    modeName: asset.modeName,
                    newValue: asset.newValue,
                    oldValue: asset.oldValue,
                    propertyName: asset.propertyName,
                });
            });
        }

        function goToPage() {
            vm.page = parseInt(document.getElementById("pagenum").value);
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                pagesize: vm.itemsPerPage,
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function filterAssetHistorySearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                HistorySearch.query(
                    {
                        searchtext: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
    
                    vm.page = pagingParams.page;
                    getData(data);
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkOrderTypeDialogController",
            WorkOrderTypeDialogController
        );

    WorkOrderTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "WorkOrderType",
        "User",
        "WorkOrderTypeSearch",
        "AllCustomWorkOrderTypeAttribute",
    ];

    function WorkOrderTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        WorkOrderType,
        User,
        WorkOrderTypeSearch,
        AllCustomWorkOrderTypeAttribute
    ) {
        var vm = this;
        //workOrdertype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.workOrderType = entity;
        vm.workOrderTypeImageName = workOrderTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customWorkOrderTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        function workOrderTypeImageName(image) {
            vm.workOrderType.image = image;
        }

        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomWorkOrderTypeAttribute.getAll(function (response) {
                vm.customWorkOrderTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customWorkOrderTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.workOrderType.workOrderTypeAttribute != null &&
            vm.workOrderType.workOrderTypeAttribute.length != 0
        ) {
            vm.items = vm.workOrderType.workOrderTypeAttribute;
        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.workOrderType.id !== null) {
                vm.workOrderType.workOrderTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.workOrderType.workOrderTypeAttribute.push({
                        id: vm.items[i].id,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                    });
                }
                WorkOrderType.update(
                    vm.workOrderType,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                vm.workOrderType.workOrderTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.workOrderType.workOrderTypeAttribute.push({
                        id: vm.items[i].id,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                    });
                }
                WorkOrderType.save(
                    vm.workOrderType,
                    onSaveSuccess,
                    onSaveError
                );
            }
        }

        $("#workOrderTypeImage").change(function () {
            var filesSelected =
                document.getElementById("workOrderTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.workOrderType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:workOrderTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "work-order.new") {
                $state.go("work-order.new");
            } else {
                $state.go("workorder-type");
            }
            // sessionStorage.removeItem('prevPage');
            // $state.go('workorder-type');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.addmore = function () {
            vm.items.push({ name: "", attributeDataType: {}, value: "" });
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkOrderTypeDetailController",
            WorkOrderTypeDetailController
        );

    WorkOrderTypeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "WorkOrderType",
        "User",
    ];

    function WorkOrderTypeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        WorkOrderType,
        User
    ) {
        var vm = this;

        vm.workOrderType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workOrderTypeUpdate",
            function (event, result) {
                vm.workOrderType = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkOrderTypeDeleteController",
            WorkOrderTypeDeleteController
        );

    WorkOrderTypeDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "WorkOrderType",
    ];

    function WorkOrderTypeDeleteController(
        $uibModalInstance,
        entity,
        WorkOrderType
    ) {
        var vm = this;

        vm.workOrderType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            WorkOrderType.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("workorder-type", {
                parent: "entity",
                url: "/workorder-type",
                data: {
                    authorities:["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-types.html",
                        controller: "WorkOrderTypeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("workorder-type-detail", {
                parent: "workorder-type",
                url: "/workorder-type/{id}",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-detail.html",
                        controller: "WorkOrderTypeDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkOrderType",
                        function ($stateParams, WorkOrderType) {
                            return WorkOrderType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "workorder-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("workorder-type.new", {
                parent: "workorder-type",
                url: "/create",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-dialog.html",
                        controller: "WorkOrderTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            description: null,
                            createdDate: null,
                            updateDate: null,
                            id: null,
                        };
                    },
                },
            })
            .state("workorder-type.edit", {
                parent: "workorder-type",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-dialog.html",
                        controller: "WorkOrderTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkOrderType",
                        function ($stateParams, WorkOrderType) {
                            return WorkOrderType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "workorder-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("workorder-type.delete", {
                parent: "workorder-type",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/workorder-type/workorder-type-delete-dialog.html",
                                controller: "WorkOrderTypeDeleteController",
                                controllerAs: "vm",
                                size: "sm",
                                resolve: {
                                    entity: [
                                        "WorkOrderType",
                                        function (WorkOrderType) {
                                            return WorkOrderType.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("workorder-type", null, {
                                        reload: "workorder-type",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkOrderType", WorkOrderType);

    WorkOrderType.$inject = ["$resource", "DateUtils"];

    function WorkOrderType($resource, DateUtils) {
        var resourceUrl = "api/workorder-types/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );
    }
})();
(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderTypeSearch", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getworkOrdertypebyname = function (data, callback) {
                $http
                    .get("api/workorder-types-details/" + data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderTypeSearch", WorkOrderTypeSearch);

    WorkOrderTypeSearch.$inject = ["$resource"];

    function WorkOrderTypeSearch($resource) {
        var service = $resource(
            "/api/workorder-types/searchvalue/:userId",
            { userId: "@id" },
            {},
            {
                query: { method: "GET", isArray: true },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllCustomWorkOrderTypeAttribute", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/all-custom-workorder-type-attributes")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderTypeController", WorkOrderTypeController);

    WorkOrderTypeController.$inject = [
        "$scope",
        "$state",
        "WorkOrderType",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "WorkOrderTypeSearch",
    ];

    function WorkOrderTypeController(
        $scope,
        $state,
        WorkOrderType,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        WorkOrderTypeSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                WorkOrderTypeSearch.query(
                    {
                        userId: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        //  result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.workOrderTypes = data;
                    vm.page = pagingParams.page;
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        loadAll();

        function loadAll() {
            WorkOrderType.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.workOrderTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderDialogController", WorkOrderDialogController)
        .directive("mySrc", function () {
            return {
                restrict: "A",
                scope: {
                    callback: "&",
                },
                link: function (scope, elem, attrs) {
                    elem.attr("src", scope.callback());
                },
            };
        });
    WorkOrderDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$q",
        "AssetByID",
        "TrUnresolvedGroupWorkFlowForMap",
        "WorkFlowById",
        "UnresolvedLocGroupWorkFlowForMap",
        "pagingParams",
        "entity",
        "WorkOrder",
        "UserGroupIDs",
        "User",
        "WorkOrderType",
        "Principal",
        "Asset",
        "$state",
        "ActivatedUsers",
        "UserValueSearch",
        "AlertService",
        "ActivatedUserSearch",
        "WorkOrderUpload",
        "AssetSearchForMap",
        "AssetSearch",
        "AllWorkOrderTypes",
        "AllCustomWorkOrderTypeAttribute",
        "$ngConfirm",
        "Configs",
        "DEFAULT_LATITUDE",
        "DEFAULT_LONGITUDE",
        "UserAccount"

    ];

    function WorkOrderDialogController(
        $timeout,
        $scope,
        $stateParams,
        $q,
        AssetByID,
        TrUnresolvedGroupWorkFlowForMap,
        WorkFlowById,
        UnresolvedLocGroupWorkFlowForMap,
        pagingParams,
        entity,
        WorkOrder,
        UserGroupIDs,
        User,
        WorkOrderType,
        Principal,
        Asset,
        $state,
        ActivatedUsers,
        UserValueSearch,
        AlertService,
        ActivatedUserSearch,
        WorkOrderUpload,
        AssetSearchForMap,
        AssetSearch,
        AllWorkOrderTypes,
        AllCustomWorkOrderTypeAttribute,
        $ngConfirm,
        Configs,
        DEFAULT_LATITUDE,
        DEFAULT_LONGITUDE,
        UserAccount
    ) {
        var vm = this;

        vm.workOrder = entity;

        var entity_old = angular.copy(vm.workOrder);
        vm.datePickerOpenStatus = {};
        vm.save = save;
        vm.assetList = "";
        vm.customAttributesMap = {};
        var usersMap = {};
        $scope.model = {};
        vm.selectedWorkFlows = [];
        var map = null;
        var markers = [];
        var polylines = [];
        var workFlowLat = null;
        var workFlowLng = null;
        var workFlowDistance = null;
        var openedInfoWindow = null;
        vm.resolved = 0.0;
        vm.unresolved = 0.0;
        vm.navigateGroupfromWorkOrder = navigateGroupfromWorkOrder;
        vm.navigateWorkOrderTypefromWorkOrder = navigateWorkOrderTypefromWorkOrder;
        vm.phaseAccess = true

        $(".select2").select2();

        $(":file").filestyle({
            buttonBefore: true,
        });

        $(":file").filestyle("buttonText", "Browse File");

        vm.workOrderTypes = loadPage();
        vm.selectattributes = selectedWorkOrderTypeAttributes;

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        vm.workOrderType = entity.workOrderType;

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        function selectedWorkOrderTypeAttributes() {
            if (vm.workOrderType) {
                vm.workOrder.workOrderType = vm.workOrderType;
                if (
                    entity_old.workOrderType &&
                    vm.workOrderType.id === entity_old.workOrderType.id
                ) {
                    vm.workOrder.workOrderTypeAttributeValues = [];
                    vm.workOrder.workOrderTypeAttributeValues =
                        entity_old.workOrderTypeAttributeValues;
                } else {
                    vm.workOrder.workOrderTypeAttributeValues = [];
                    $.each(
                        vm.workOrderType.workOrderTypeAttribute,
                        function (key, value) {
                            vm.workOrder.workOrderTypeAttributeValues.push({
                                workOrderTypeAttribute:
                                    vm.workOrderType.workOrderTypeAttribute[
                                        key
                                    ],
                            });
                        }
                    );
                }
            }
        }

        function loadPage() {
            vm.multgroup = [];
            var selectedGroups = [];
            var workOrderWorkFlowsList = [];

            if(vm.workOrder.id){
                Configs.get("WorkOrderStatus",function(response){
                    vm.workOrderStatus = response
                })
    
                Configs.get("Phases",function(response){
                    vm.phases = response
                })
            }

            if (vm.workOrder.id != null) {
                vm.workOrder.groups.forEach(function (group) {
                    selectedGroups.push(group.id);
                });
                vm.workOrder.workFlows.forEach(function (workFlowVal) {
                    workOrderWorkFlowsList.push(workFlowVal);
                });
            }

            AllWorkOrderTypes.getAll(function (response) {
                vm.workOrderTypes = response;
            });

            UserGroupIDs.getAll(function (response) {
                vm.multigroup = response
                response.forEach(function(val){
                    if(val.name == "Planning Group"){
                        val.ticked = true
                    }
                })
            });

            if(vm.workOrder.id){
                UserAccount.get(function (data) { 
                    data.authorities.find(function (val) { 
                        if(val == "ROLE_PLAN_ADMIN" || val == "ROLE_ROLLOUT_ADMIN" ){
                            vm.phaseAccess = false
                        }
                    })
                })
            }

            AllCustomWorkOrderTypeAttribute.getAll(function (response) {
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customWorkOrderTypeAttributeValues;
                });
            });

            TrUnresolvedGroupWorkFlowForMap.getAllWorkFlows(function (
                response
            ) {
                vm.workFlows = [];
                response.forEach(function (workFlowVal) {
                    workOrderWorkFlowsList.forEach(function (
                        workFlowValChecked
                    ) {
                        if (workFlowValChecked.id == workFlowVal.id) {
                            workFlowVal.isChecked = true;
                            workFlowValChecked.isChecked = true;

                            vm.selectedWorkFlows.push(workFlowValChecked);
                            showWorkFlowAssetsOnMap(workFlowValChecked);
                        }
                    });
                    vm.workFlows.push(workFlowVal);
                });
            });
            /* var myOptions = {
                zoom: 10,
                center: new google.maps.LatLng("5.431587", "101.128162"),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            var center = new google.maps.LatLng(DEFAULT_LATITUDE.value,
                DEFAULT_LONGITUDE.value)
            map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(10,center)
            );
            if (map != null) {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
        }
        // This executes when workflow checkbox checked/unchecked
        $scope.selectEntity = function () {
            if (map != null) {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            vm.resolved = 0.0;
            vm.unresolved = 0.0;
            vm.selectedWorkFlows = [];
            vm.workFlows.forEach(function (workFlowVal) {
                if (workFlowVal.isChecked) {
                    if (workFlowVal.status == "Lighting") {
                        vm.resolved += parseFloat(workFlowVal.fiberDistance);
                    } else {
                        vm.unresolved += parseFloat(workFlowVal.fiberDistance);
                    }
                    WorkFlowById.get(workFlowVal.id, function (workFlowVal) {
                        workFlowVal.groups = vm.workOrder.groups;
                        vm.selectedWorkFlows.push(workFlowVal);
                        if (workFlowVal.workFlowAssets.length > 0) {
                            showWorkFlowAssetsOnMap(workFlowVal);
                        }
                    });
                }
            });

            var totalDistance = vm.resolved + vm.unresolved;
            var workOrderAV = vm.workOrder.workOrderTypeAttributeValues;
            for (
                var workOrderIndex = 0;
                workOrderIndex < workOrderAV.length;
                workOrderIndex++
            ) {
                if (
                    workOrderAV[workOrderIndex].workOrderTypeAttribute.name ===
                    "Fiber Distance"
                ) {
                    workOrderAV[
                        workOrderIndex
                    ].attributeValue = totalDistance.toFixed(2);
                } else if (
                    workOrderAV[workOrderIndex].workOrderTypeAttribute.name ===
                    "Unresolved Distance"
                ) {
                    workOrderAV[
                        workOrderIndex
                    ].attributeValue = vm.unresolved.toFixed(2);
                } else if (
                    workOrderAV[workOrderIndex].workOrderTypeAttribute.name ===
                    "Resolved Distance"
                ) {
                    workOrderAV[
                        workOrderIndex
                    ].attributeValue = vm.resolved.toFixed(2);
                }
            }
            vm.workOrder.workOrderTypeAttributeValues = workOrderAV;
        };

        function showWorkFlowAssetsOnMap(workFlowVal) {
            workFlowVal.workFlowAssets.forEach(function (assetVal) {
                if (
                    assetVal.assetType.layout == "SPREAD" &&
                    assetVal.assetCoordinates != null
                ) {
                    var spreadAssetCoordinates = [];
                    assetVal.assetCoordinates.forEach(function (loc) {
                        spreadAssetCoordinates.push({
                            lat: loc.latitude,
                            lng: loc.longitude,
                        });
                    });
                    var polylineColor = "#000000";
                    var polylinepath = new google.maps.Polyline({
                        path: spreadAssetCoordinates,
                        geodesic: true,
                        strokeColor: polylineColor,
                        strokeOpacity: 1.0,
                        strokeWeight: 2.5,
                        fillColor: polylineColor,
                        fillOpacity: 0.3,
                        editable: false,
                    });

                    polylinepath.setMap(map);

                    polylines.push(polylinepath);
                    try {
                        var pos = {
                            lat: assetVal.assetCoordinates[0].latitude,
                            lng: assetVal.assetCoordinates[0].longitude,
                        };
                        map.setCenter(pos);

                        var midLatLng = {
                            lat:
                                spreadAssetCoordinates[
                                    spreadAssetCoordinates.length - 1
                                ].lat,
                            lng:
                                spreadAssetCoordinates[
                                    spreadAssetCoordinates.length - 1
                                ].lng,
                        };
                        var infowindow = new google.maps.InfoWindow({
                            content:
                                '<div class="infoWindowhead">' +
                                "name" +
                                '<div class="infoWindowContent"> <b>Name :</b> ' +
                                assetVal.name +
                                "</div></div>",
                        });

                        infowindow.setPosition(midLatLng);
                        google.maps.event.addListener(
                            polylinepath,
                            "mouseout",
                            function (event) {
                                infowindow.close();
                            }
                        );

                        google.maps.event.addListener(
                            polylinepath,
                            "mouseover",
                            function (event) {
                                if (openedInfoWindow != null) {
                                    openedInfoWindow.close();
                                }
                                infowindow.setContent(
                                    '<div class="infoWindowhead">' +
                                        "<b></b>" +
                                        assetVal.name +
                                        "</br></div>"
                                );

                                infowindow.mousemove;
                                infowindow.open(map);
                                infowindow.setPosition(event.latLng);
                                openedInfoWindow = infowindow;
                            }
                        );
                    } catch (err) {}
                } else if (
                    assetVal.assetType.layout == "FIXED" &&
                    assetVal.assetCoordinates != null
                ) {
                    try {
                        createMarker(assetVal.assetCoordinates[0], map);
                        var pos = {
                            lat: assetVal.assetCoordinates[0].latitude,
                            lng: assetVal.assetCoordinates[0].longitude,
                        };
                        map.setCenter(pos);
                    } catch (err) {}
                }
            });
        }

        function createMarker(latlngs, map) {
            try {
                var pos = {
                    lat: latlngs.latitude,
                    lng: latlngs.longitude,
                };

                var marker = new google.maps.Marker({
                    position: pos,
                    map: map,
                    icon:
                        "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                });

                marker.setMap(map);
                markers.push(marker);

                var infowindow = new google.maps.InfoWindow({
                    content:
                        '<div class="infoWindowhead">' +
                        "name" +
                        '<div class="infoWindowContent"> <b>Name :</b> ' +
                        assetVal.name +
                        "</div></div>",
                });

                infowindow.setPosition(pos);
                google.maps.event.addListener(
                    marker,
                    "mouseout",
                    function (event) {
                        infowindow.close();
                    }
                );

                google.maps.event.addListener(
                    marker,
                    "mouseover",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead">' +
                                "<b></b>" +
                                assetVal.name +
                                "</br></div>"
                        );

                        infowindow.mousemove;
                        infowindow.open(map);
                        infowindow.setPosition(event.latLng);
                        openedInfoWindow = infowindow;
                    }
                );
                // markers.push(marker);
            } catch (err) {}
        }

        vm.createfence = function () {
            $("#workflowsModal").show();
            var myCenter = new google.maps.LatLng(DEFAULT_LATITUDE.value,
                DEFAULT_LONGITUDE.value);
            var ele = document.getElementById("workflowsModal");
            $(ele).modal("show");
            //
            var locMap = new google.maps.Map(
                document.getElementById("map_canvas_workflows"),
                myOption(12,myCenter)
            );
            var address = new google.maps.Geocoder();

            google.maps.event.addListener(locMap, "click", function (event) {
                address.geocode(
                    {
                        latLng: event.latLng,
                    },
                    function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            if (results[0]) {
                                $ngConfirm({
                                    title:
                                        "Are you sure you want to select this address?",
                                    content:
                                        "<strong>Address: </strong>" +
                                        results[0].formatted_address +
                                        "<br/>" +
                                        "<strong>Latitude: </strong>" +
                                        event.latLng.lat() +
                                        "</br>" +
                                        "<strong>Longitude: </strong>" +
                                        event.latLng.lng(),
                                    type: "blue",
                                    typeAnimated: true,
                                    buttons: {
                                        OK: {
                                            text: "OK",
                                            btnClass: "btn-primary",
                                            action: function () {
                                                $scope.$apply(function () {
                                                    workFlowLat = event.latLng.lat();
                                                    workFlowLng = event.latLng.lng();
                                                    workFlowDistance = document.getElementById(
                                                        "workflow_distance"
                                                    ).value;
                                                    UnresolvedLocGroupWorkFlowForMap.query(
                                                        {
                                                            lat: workFlowLat,
                                                            lng: workFlowLng,
                                                            dis: workFlowDistance,
                                                        },
                                                        function (response) {
                                                            vm.workFlows = response;

                                                            var workOrderWorkFlowsList =
                                                                vm.workOrder
                                                                    .workFlows;

                                                            if (
                                                                workOrderWorkFlowsList !==
                                                                undefined
                                                            ) {
                                                                workOrderWorkFlowsList.forEach(
                                                                    function (
                                                                        workFlow
                                                                    ) {
                                                                        for (
                                                                            var i = 0;
                                                                            i <
                                                                            vm
                                                                                .workFlows
                                                                                .length;
                                                                            i++
                                                                        ) {
                                                                            if (
                                                                                workFlow.id ==
                                                                                vm
                                                                                    .workFlows[
                                                                                    i
                                                                                ]
                                                                                    .id
                                                                            ) {
                                                                                vm.workFlows[
                                                                                    i
                                                                                ].isChecked = true;
                                                                            }
                                                                        }
                                                                    }
                                                                );
                                                            }

                                                            /* var myOptions = {
                                                                zoom: 10,
                                                                center:new google.maps.LatLng(DEFAULT_LATITUDE.value,
                                                                    DEFAULT_LONGITUDE.value),
                                                                mapTypeId:
                                                                    google.maps
                                                                        .MapTypeId
                                                                        .ROADMAP,
                                                            }; */
                                                            var center = new google.maps.LatLng(DEFAULT_LATITUDE.value,
                                                                DEFAULT_LONGITUDE.value)
                                                            map = new google.maps.Map(
                                                                document.getElementById(
                                                                    "map_canvas"
                                                                ),
                                                                myOption(10,center)
                                                            );
                                                        }
                                                    );
                                                    hideModal();
                                                });
                                            },
                                        },
                                        Cancel: {
                                            text: "Cancel",
                                            btnClass: "btn-danger",
                                            action: function () {},
                                        },
                                    },
                                });
                            }
                        }
                    }
                );
            });
            $("#workflowsModal").on("show.bs.modal", function (event) {
                $("#location-map-workflows").css("width", "100%");
                $("#map_canvas_workflows").css("width", "100%");
            });
        };
        function hideModal() {
            $("#workflowsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#workflowsModal").hide();
        }

        function save() {
            vm.isSaving = true;

            vm.workOrder.workFlows = [];
            vm.selectedWorkFlows.forEach(function (workflow) {
                workflow.groups = vm.workOrder.groups;
                vm.workOrder.workFlows.push(workflow);
            });
            if (vm.workOrder.workFlows.length > 0) {
                try {
                    vm.workOrder.pinLat =
                        vm.workOrder.workFlows[0].workFlowAssets[0].assetCoordinates[0].latitude;
                    vm.workOrder.pinLong =
                        vm.workOrder.workFlows[0].workFlowAssets[0].assetCoordinates[0].longitude;
                } catch (error) {
                    vm.isSaving = false;
                }
                if (vm.workOrder.id !== null) {
                    WorkOrder.update(vm.workOrder, onSaveSuccess, onSaveError);
                } else {
                    WorkOrder.save(vm.workOrder, onSaveSuccess, onSaveError);
                }
            } else {
                alert("Please select atleast one work flow");
                vm.isSaving = false;
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:workOrderUpdate", result);
            $state.go("work-order");
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function navigateGroupfromWorkOrder() {
            sessionStorage.setItem("prevPage", "work-order.new");
            $state.go("group.new");
        }

        function navigateWorkOrderTypefromWorkOrder() {
            sessionStorage.setItem("prevPage", "work-order.new");
            $state.go("workorder-type.new");
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderDetailController", WorkOrderDetailController);

    WorkOrderDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "WorkOrder",
        "User",
        "CaseType",
        "$window",
    ];

    function WorkOrderDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        WorkOrder,
        User,
        CaseType,
        $window
    ) {
        var vm = this;

        if (entity.status) {
            entity.status = entity.status.replace("NEW", "PLANNING PHASE");
            entity.status = entity.status.replace(
                "INPROGRESS",
                "ROLL-OUT PHASE"
            );
            entity.status = entity.status.replace(
                "RESOLVED",
                "OPERATION PHASE"
            );
        }
        if (
            entity.createDate == "0" ||
            entity.createDate == undefined ||
            entity.createDate == null
        ) {
            entity.createDate = "";
        }
        vm.workOrder = entity;
        vm.previousState = previousState.name;
        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workOrderUpdate",
            function (event, result) {
                vm.workOrder = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderDeleteController", WorkOrderDeleteController);

    WorkOrderDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "WorkOrder",
        "$scope",
    ];

    function WorkOrderDeleteController(
        $uibModalInstance,
        entity,
        WorkOrder,
        $scope
    ) {
        var vm = this;

        vm.workOrder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            $scope.deletefail = true;
            WorkOrder.delete({ id: id }, function () {
                $scope.deletefail = false;
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("work-order", {
                parent: "app",
                url: "/work-order",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workOrder.home.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/work-order/work-orders.html",
                        controller: "WorkOrderController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrder");
                            $translatePartialLoader.addPart("workOrderStatus");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("work-order-detail", {
                parent: "work-order",
                url: "/work-order/{id}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workOrder.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-order/work-order-detail.html",
                        controller: "WorkOrderDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrder");
                            $translatePartialLoader.addPart("workOrderStatus");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkOrder",
                        function ($stateParams, WorkOrder) {
                            return WorkOrder.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-order",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-order.priority", {
                parent: "work-order",
                url: "/work-order/{priority}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workOrder.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/work-order/work-orders.html",
                        controller: "WorkOrderController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                                priority: $stateParams.priority,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrder");
                            $translatePartialLoader.addPart("workOrderStatus");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("work-order.new", {
                parent: "work-order",
                url: "/create/{lat}/{lng}/{assetdetails}/{desc}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-order/work-order-dialog.html",
                        controller: "WorkOrderDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                description: $stateParams.desc,
                                createDate: null,
                                updateDate: null,
                                pinLat: parseFloat($stateParams.lat),
                                pinLong: parseFloat($stateParams.lng),
                                address: null,
                                escalated: null,
                                status: null,
                                id: null,
                                workOrderImages: [],
                                // ,
                                // asset: {name: $stateParams.assetdetails}
                            };
                        },
                    ],
                },
            })

            .state("work-order.import", {
                parent: "work-order",
                url: "/import",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-order/work-order-import.html",
                        controller: "WorkOrderImportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            workOrderImages: [],
                        };
                    },
                },
            })
            .state("work-order.edit", {
                parent: "work-order",
                url: "/Edit/{id}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workOrder.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-order/work-order-dialog.html",
                        controller: "WorkOrderDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "WorkOrder",
                        function ($stateParams, WorkOrder) {
                            return WorkOrder.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],

                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-order",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-order.delete", {
                parent: "work-order",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/work-order/work-order-delete-dialog.html",
                                controller: "WorkOrderDeleteController",
                                controllerAs: "vm",
                                size: "md",
                                resolve: {
                                    entity: [
                                        "WorkOrder",
                                        function (WorkOrder) {
                                            return WorkOrder.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("work-order", null, {
                                        reload: "work-order",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkOrder", WorkOrder);

    WorkOrder.$inject = ["$resource", "DateUtils"];

    function WorkOrder($resource, DateUtils) {
        var resourceUrl = "api/work-orders/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderPriority", WorkOrderPriority);

    WorkOrderPriority.$inject = ["$resource"];

    function WorkOrderPriority($resource) {
        var service = $resource(
            "/api/work-orders/priority/:priority",
            {
                priority: "@priorirty",
            },
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderSearch", WorkOrderSearch);

    WorkOrderSearch.$inject = ["$resource"];

    function WorkOrderSearch($resource) {
        var service = $resource(
            "/api/work-orders/searchvalue/:search",
            {},
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkorderCountByGroup", [
        "$http",
        function ($http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/workordercountbygroup")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkorderCountByStatus", [
        "$http",
        function ($http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/workordercountbystatus")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkOrderGroup", WorkOrderGroup);

    WorkOrderGroup.$inject = ["$resource", "DateUtils"];

    function WorkOrderGroup($resource, DateUtils) {
        var resourceUrl = "api/work-orders-group";

        return $resource(resourceUrl, {
            query: {
                method: "GET",
                isArray: true,
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderGroupSearch", WorkOrderGroupSearch);

    WorkOrderGroupSearch.$inject = ["$resource"];

    function WorkOrderGroupSearch($resource) {
        var service = $resource(
            "/api/work-orders-group/searchvalue/:search",
            {},
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderGroupPrioritySearch", WorkOrderGroupPrioritySearch);

    WorkOrderGroupPrioritySearch.$inject = ["$resource"];

    function WorkOrderGroupPrioritySearch($resource) {
        var service = $resource(
            "/api/work-orders-group/prioritysearch/:priority/:searchtext",
            {
                priority: "@priorirty",
                searchtext: "@searchtext",
            },
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderGroupPriority", WorkOrderGroupPriority);

    WorkOrderGroupPriority.$inject = ["$resource"];

    function WorkOrderGroupPriority($resource) {
        var service = $resource(
            "/api/work-orders-group/priority/:priority",
            {
                priority: "@priorirty",
            },
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllWorkOrderTypes", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http.get("api/workorder-alltypes").then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderPrioritySearch", WorkOrderPrioritySearch);

    WorkOrderPrioritySearch.$inject = ["$resource"];

    function WorkOrderPrioritySearch($resource) {
        var service = $resource(
            "/api/work-orders/prioritysearch/:priority/:searchtext",
            {
                priority: "@priorirty",
                searchtext: "@searchtext",
            },
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("WorkOrderUpdateGroup", WorkOrderUpdateGroup);

    WorkOrderUpdateGroup.$inject = ["$resource"];

    function WorkOrderUpdateGroup($resource) {
        var resourceUrl = "api/work-orders/groups";

        return $resource(
            resourceUrl,
            {},
            {
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("WorkOrderBulkDelete", WorkOrderBulkDelete);

    WorkOrderBulkDelete.$inject = ["$resource"];

    function WorkOrderBulkDelete($resource) {
        var resourceUrl = "api/work-orders/bulk/delete";

        return $resource(
            resourceUrl,
            {},
            {
                save: {
                    method: "POST",
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderUser", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getworkordersuser = function (callback) {
                $http
                    .get("api/work-orders/live-logs")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getworkordersuserbyid = function (id, callback) {
                $http
                    .get("api/work-orders/live-logs/" + id)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.searchworkordersuserbyvalue = function (id, callback) {
                $http
                    .get("api/work-orders/search/" + id)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getworkordersanduserbypriority = function (
                priority,
                callback
            ) {
                $http
                    .get("api/work-orders/live-logs/priority/" + priority)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAgents = function (callback) {
                $http
                    .get("api/dashboard/agentdashboard")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderEdit", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getallworkorders = function (callback) {
                $http.get("api/tr-allworkorders").then(function (response) {
                    callback(response.data);
                });
            };

            service.editworkorder = function (data, callback) {
                $http
                    .post(
                        "api/work-orderedit/" +
                            data.userId +
                            "/" +
                            data.workorderId,
                        {}
                    )
                    .then(
                        function (response) {
                            callback(response, response.headers);
                        },
                        function (error) {
                            callback(error, error.headers);
                        }
                    );

                /*
                 * $http.post('api/work-orderedit/'+data.userId+'/'+data.workorderId).then(function(response){
                 * callback(response.data); });
                 */
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkOrderUpload", WorkOrderUpload);

    WorkOrderUpload.$inject = ["$http"];

    function WorkOrderUpload($http) {
        var service = {};
        service.workorderupload = function (data, callback) {
            $http
                .post("api/workorderimport", data, {
                    transformRequest: angular.identity,
                    headers: {
                        "Content-Type": undefined,
                    },
                })
                .then(
                    function (response) {
                        callback(response, response.headers);
                    },
                    function (error) {
                        callback(error, error.headers);
                    }
                );
        };

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrGroupWorkOrderSearchForMap", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.searchworkorderformap = function (search, callback) {
                $http
                    .get("api/tr-groupworkordersformap/searchvalue/" + search)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrGroupWorkOrderForMap", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAllWorkOrders = function (callback) {
                $http
                    .get("api/tr-groupworkordersformap")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderSearchForMap", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.searchworkorderformap = function (search, callback) {
                $http
                    .get("api/work-ordersformap/searchvalue/" + search)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.prioritysearchworkorderformap = function (
                priority,
                callback
            ) {
                $http
                    .get("api/work-ordersformap/priority/" + priority)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderLastLocation", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};

            service.getlastlogs = function (callback) {
                $http
                    .get("api/location-logs/lastuserpath")
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrdersForMapByAdmin", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.workordersformapbyadmin = function (adminid, callback) {
                $http
                    .get("api/work-ordersformap/" + adminid)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderForMap", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAllWorkOrders = function (callback) {
                $http.get("api/work-ordersformap").then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("ChildWorkflows", ChildWorkflows);

    ChildWorkflows.$inject = ["$resource"];

    function ChildWorkflows($resource) {
        var resourceUrl = "api/linkedWorkFlows/:parentId";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("ChildServices", ChildServices);

    ChildServices.$inject = ["$resource"];

    function ChildServices($resource) {
        var resourceUrl = "api/linkedServices/:parentId";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('Configs', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
        var config_catName = "ROLLOUT_FEATURES"
		service.get = function (name, callback) {
			$http.get('api/configs/' + name).then(function (response) {
				callback(response.data);
			});
		};

        service.rolloutFeatures = function (callback) {
			$http.get('api/configs/'+config_catName).then(function (response) {
                callback(response.data);
            },
            function (error) {
                callback(error);
            });
		};

		return service;
	}]);
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("WorkOrderWorkflowAssets", WorkOrderWorkflowAssets);

    WorkOrderWorkflowAssets.$inject = ["$resource"];

    function WorkOrderWorkflowAssets($resource) {
        var resourceUrl = "api/linkedAssets/:parentId";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderImportController", WorkOrderImportController)
        .directive("fileread", [
            function () {
                "use strict";

                return {
                    restrict: "A",

                    link: function ($scope, element) {
                        element.change(function (event) {
                            $scope.$apply(function () {
                                $scope.myFile = element[0].files[0];
                            });
                        });
                    },
                };
            },
        ]);

    WorkOrderImportController.$inject = [
        "$timeout",
        "$scope",
        "WorkOrderUpload",
    ];

    function WorkOrderImportController($timeout, $scope, WorkOrderUpload) {
        var vm = this;

        vm.upload = upload;

        var formData;
        function upload() {
            formData = new FormData();
            formData.append("file", $scope.myFile);

            WorkOrderUpload.workorderupload(
                formData,
                function (response, headers) {
                    if (response.status == 200) {
                        vm.error = null;
                        vm.success = "OK";

                        $timeout(function () {
                            vm.success = "";
                        }, 4000);
                    }
                    if (response.status == 400) {
                        vm.success = null;
                        vm.error = "error";
                    }
                }
            );
        }
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderController", WorkOrderController);

    WorkOrderController.$inject = [
        "$filter",
        "$scope",
        "$state",
        "$compile",
        "$stateParams",
        "pagingParams",
        "paginationConstants",
        "WorkOrder",
        "WorkOrderGroup",
        "WorkOrderUpdateGroup",
        "WorkOrderBulkDelete",
        "TrCaseById",
        "AssetByID",
        "UserGroupIDs",
        "ParseLinks",
        "AlertService",
        "WorkOrderSearch",
        "WorkOrderGroupSearch",
        "WorkOrderPriority",
        "WorkOrderGroupPriority",
        "WorkOrderPrioritySearch",
        "WorkOrderGroupPrioritySearch",
        "WorkOrderForMap",
        "WorkOrderSearchForMap",
        "WorkOrderLastLocation",
        "ChildWorkflows",
        "WorkOrderWorkflowAssets",
        "UserAccount",
    ];

    function WorkOrderController(
        $filter,
        $scope,
        $state,
        $compile,
        $stateParams,
        pagingParams,
        paginationConstants,
        WorkOrder,
        WorkOrderGroup,
        WorkOrderUpdateGroup,
        WorkOrderBulkDelete,
        TrCaseById,
        AssetByID,
        UserGroupIDs,
        ParseLinks,
        AlertService,
        WorkOrderSearch,
        WorkOrderGroupSearch,
        WorkOrderPriority,
        WorkOrderGroupPriority,
        WorkOrderPrioritySearch,
        WorkOrderGroupPrioritySearch,
        WorkOrderForMap,
        WorkOrderSearchForMap,
        WorkOrderLastLocation,
        ChildWorkflows,
        WorkOrderWorkflowAssets,
        UserAccount
    ) {
        var vm = this;
        $scope.search = pagingParams.search;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterWorkOrderSearch = filterWorkOrderSearch;
        vm.filterSearchMap = filterSearchMap;
        vm.showWorkOrderBreakUps = showWorkOrderBreakUps;
        // vm.showWorkflowBOQBreakUp = showWorkflowBOQBreakUp;
        // vm.showWorkflowPBBreakUp = showWorkflowPBBreakUp;
        vm.showWorkOrderPowerBudgetBreakUps = showWorkOrderPowerBudgetBreakUps;
        vm.selectedWorkOrders = selectedWorkOrders;
        vm.selectWorkOrderEntity = selectWorkOrderEntity;
        vm.selectAllWorkOrder = selectAllWorkOrder;
        vm.updateWorkOrderGroup = updateWorkOrderGroup;
        vm.hideWorkOrderModal = hideWorkOrderModal;
        vm.hideWorkOrderPBModal = hideWorkOrderPBModal;
        // vm.hideWorkflowboqModal = hideWorkflowboqModal;
        // vm.hideWorkflowPBModal = hideWorkflowPBModal;
        vm.searchWorkOrders = searchWorkOrders;
        var latlng;
        var userPaths = {};
        var locations = {};
        var nearbyAgentsMarkers = [];
        var openedInfoWindow = null;
        vm.resolved = [];
        vm.unresolved = [];

        vm.selectWorkOrders = [];
        vm.multgroup = [];
        var selctedGroup = [];
        vm.groupOrders = true;
        vm.showActions = true;
        vm.totalSelected = 0;
        vm.assetsTable = assetsTable;
        vm.workflowTable = workflowTable;
        vm.createAccess = false;
        // vm.serviceTable = serviceTable;

        vm.items = [
            {
                name: "Update Group Mapping",
            },
            {
                name: "Delete Multiple WorkOrders",
            },
        ];

        UserAccount.get(function (data) {
            data.authorities.find(function (val) {
                if (
                    val == "ROLE_PLAN_ADMIN" ||
                    val == "ROLE_PLAN_INFRA" ||
                    val == "ROLE_PLAN_SURVEY"
                ) {
                    vm.createAccess = true;
                }
            });
        });

        $scope.tab = 4;
        $scope.$on("$destroy", function () {});
        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        if ($scope.tab == 4) {
            UserGroupIDs.getAll(function (response) {
                response.forEach(function (group) {
                    if (selctedGroup.indexOf(group.id) !== -1) {
                        vm.multgroup.push({
                            name: group.name,
                            id: group.id,
                            ticked: true,
                        });
                    } else {
                        vm.multgroup.push({
                            name: group.name,
                            id: group.id,
                            ticked: false,
                        });
                    }
                });
            });
            filterGroupSearch();
        }

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 4) {
                vm.itemsPerPage = paginationConstants.itemsPerPage;
                filterGroupSearch();
            }
        };

        function workflowTable(workOrder) {
            vm.workOrders.forEach(function (item) {
                item.isExpanded = false;
            });
            if (vm.toggle == workOrder.id) {
                vm.toggle = undefined;
            } else {
                workOrder.isExpanded = true;
                vm.toggle = workOrder.id;
            }
            ChildWorkflows.query(
                {
                    parentId: workOrder.id,
                },
                onSuccess
            );

            function onSuccess(data, headers) {
                var workFlowsRes = [];
                var Cost = "";
                var pb = "";
                var totalDis = 0.0;
                data.forEach(function (values) {
                    vm.parentGroup = values.groups[0].name;
                    /* if (values.status) {
                        values.status = values.status.replace(
                            "NEW",
                            "PLANNING PHASE"
                        );
                        values.status = values.status.replace(
                            "INPROGRESS",
                            "ROLL-OUT PHASE"
                        );
                        values.status = values.status.replace(
                            "RESOLVED",
                            "OPERATION PHASE"
                        );
                    } */
                    var caseTypeTypeAttrVal =
                        values.workFlowTypeAttributeValues;
                    caseTypeTypeAttrVal.forEach(function (item) {
                        if (item.workFlowTypeAttribute.name == "Cost") {
                            Cost = item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Power Budget"
                        ) {
                            pb = item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Fiber Distance"
                        ) {
                            totalDis = item.attributeValue;
                        }
                    });
                    var res = {
                        id: values.id,
                        description: values.description,
                        status: values.status,
                        phase: values.phase,
                        // fiberStatus: FiberStatus,
                        groups: values.groups,
                        Cost: "$" + Cost,
                        pb: "$" + pb,
                        totalDistance: totalDis,
                    };

                    workFlowsRes.push(res);
                });
                vm.workflowAssets = workFlowsRes;
            }
        }
        // function serviceTable(value) {
        // 	ChildServices.query({
        // 		parentId: value.id
        // 	}, onSuccess);

        // 	function onSuccess(data, headers) {

        // 		var servicesRes = [];
        // 		data.forEach(function (values) {
        // 			if (values.status) {
        // 				values.status = values.status.replace("NEW", "PLANNING PHASE");
        // 				values.status = values.status.replace("INPROGRESS", "ROLL-OUT PHASE");
        // 				values.status = values.status.replace("RESOLVED", "OPERATION PHASE");
        // 			}
        // 			var res = {
        // 				id: values.id,
        // 				description: values.description,
        // 				status: values.status,
        // 				reportedByUser: values.reportedByUser,
        // 				assignedToUser: values.assignedToUser,
        // 				// fiberStatus: FiberStatus,
        // 				groups: values.groups,
        // 			};

        // 			servicesRes.push(res);
        // 		});
        // 		vm.serviceAssets = servicesRes;
        // 	}
        // }
        function assetsTable(value) {
            WorkOrderWorkflowAssets.query(
                {
                    parentId: value.id,
                },
                onSuccess
            );

            function onSuccess(data, headers) {
                var servicesRes = [];
                var Cost = "";
                var pb = "";
                var totalDistance = 0.0;
                data.forEach(function (values) {
                    // if (values.status) {
                    // 	values.status = values.status.replace("NEW", "PLANNING PHASE");
                    // 	values.status = values.status.replace("INPROGRESS", "ROLL-OUT PHASE");
                    // 	values.status = values.status.replace("RESOLVED", "OPERATION PHASE");
                    // }
                    var assetAttrVal = values.assetTypeAttributeValues;

                    assetAttrVal.forEach(function (item) {
                        if (item.assetTypeAttribute.name == "Cost") {
                            Cost = item.attributeValue;
                        } else if (
                            item.assetTypeAttribute.name == "Power Budget"
                        ) {
                            pb = item.attributeValue;
                        } else if (
                            item.assetTypeAttribute.name == "Fiber Distance"
                        ) {
                            totalDis = item.attributeValue;
                        }
                    });
                    if ((values.status = "true") || (values.status = "false")) {
                        values.status = "";
                    }
                    var res = {
                        id: values.id,
                        description: values.description,
                        status: values.status,
                        phase: values.phase,
                        // reportedByUser: values.reportedByUser,
                        // assignedToUser: values.assignedToUser,
                        // fiberStatus: FiberStatus,
                        groups: values.groups,
                        Cost: "$" + Cost,
                        pb: "$" + pb,
                        totalDistance: totalDistance,
                    };

                    servicesRes.push(res);
                });
                vm.serviceAssets = servicesRes;
            }
        }
        function searchWorkOrders() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search) &&
                $scope.search.length != 1 &&
                $scope.search.length != 2 &&
                $scope.search.length != 3 &&
                $scope.search.length != 4
            ) {
                if ($stateParams.priority == undefined) {
                    WorkOrderSearch.query(
                        {
                            search: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrderPrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    var workOrdersRes = [];
                    data.forEach(function (values) {
                        var workFlows = values.workOrderCases;
                        var disVal = 0.0;
                        var Cost = "";
                        var pb = "";
                        var totalDis = 0.0;

                        var FiberStatus = "";
                        var workOrderTypeAttrVal =
                            values.workOrderTypeAttributeValues;

                        workOrderTypeAttrVal.forEach(function (item) {
                            if (item.workOrderDataTypeName == "Fiber Status") {
                                FiberStatus = item.attributeValue;
                            }

                            if (item.name == "Cost") {
                                Cost = item.attributeValue;
                            } else if (item.name == "Power Budget") {
                                pb = item.attributeValue;
                            } else if (item.name == "Fiber Distance") {
                                totalDis = item.attributeValue;
                            }
                        });
                        /*  if (values.status) {
                            values.status = values.status.replace(
                                "NEW",
                                "PLANNING PHASE"
                            );
                            values.status = values.status.replace(
                                "INPROGRESS",
                                "ROLL-OUT PHASE"
                            );
                            values.status = values.status.replace(
                                "RESOLVED",
                                "OPERATION PHASE"
                            );
                        } */
                        var res = {
                            id: values.id,
                            description: values.description,
                            address: values.address,
                            escalated: values.escalated,
                            status: values.status,
                            phase: values.phase,
                            reportedByUser: values.reportedByUser,
                            assignedToUser: values.assignedToUser,
                            workOrderTypeName: values.workOrderTypeName,
                            pinLat: values.pinLat,
                            pinLong: values.pinLong,
                            workOrderType: values.workOrderType,
                            priority: values.priority,
                            fiberStatus: FiberStatus,
                            groups: values.groups,
                            workOrderCases: values.workOrderCases,
                            geofenceName: values.geofenceName,
                            workOrderTypeAttributeValues:
                                values.workOrderTypeAttributeValues,
                            Cost: "$" + Cost,
                            pb: "$" + pb,
                            totalDistance: totalDistance,
                        };

                        workOrdersRes.push(res);
                    });
                    vm.page = pagingParams.page;
                    vm.workOrders = [];
                    workOrdersRes.forEach(function (workOrderVal) {
                        workOrderVal.workOrderTypeAttributeValues.forEach(
                            function (val) {
                                if (val.name == "Resolved Distance") {
                                    workOrderVal.resolved = val.attributeValue;
                                }
                                if (val.name == "Unresolved Distance") {
                                    workOrderVal.unresolved =
                                        val.attributeValue;
                                }
                            }
                        );
                        var total =
                            parseFloat(workOrderVal.unresolved) +
                            parseFloat(workOrderVal.resolved);
                        var percent =
                            (parseFloat(workOrderVal.resolved) * 100) / total;
                        workOrderVal.totaldistance = total.toFixed(2);
                        if (
                            total > 0 &&
                            parseFloat(workOrderVal.resolved) > 0
                        ) {
                            workOrderVal.percentdistance = percent.toFixed(0);
                        } else {
                            workOrderVal.percentdistance = 0;
                        }
                        vm.workOrders.push(workOrderVal);
                    });
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function filterWorkOrderSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                if ($stateParams.priority == undefined) {
                    WorkOrderSearch.query(
                        {
                            search: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrderPrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    vm.workOrders = [];
                    data.forEach(function (workOrderVal) {
                        workOrderVal.workOrderTypeAttributeValues.forEach(
                            function (val) {
                                if (val.name == "Resolved Distance") {
                                    workOrderVal.resolved = val.attributeValue;
                                }
                                if (val.name == "Unresolved Distance") {
                                    workOrderVal.unresolved =
                                        val.attributeValue;
                                }
                            }
                        );
                        var total =
                            parseFloat(workOrderVal.unresolved) +
                            parseFloat(workOrderVal.resolved);
                        var percent =
                            (parseFloat(workOrderVal.resolved) * 100) / total;
                        workOrderVal.totaldistance = total.toFixed(2);
                        if (
                            total > 0 &&
                            parseFloat(workOrderVal.resolved) > 0
                        ) {
                            workOrderVal.percentdistance = percent.toFixed(0);
                        } else {
                            workOrderVal.percentdistance = 0;
                        }
                        vm.workOrders.push(workOrderVal);
                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function filterGroupSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                if ($stateParams.priority == undefined) {
                    WorkOrderGroupSearch.query(
                        {
                            search: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrderGroupPrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    vm.workOrders = [];
                    data.forEach(function (workOrderVal) {
                        workOrderVal.workOrderTypeAttributeValues.forEach(
                            function (val) {
                                if (val.name == "Resolved Distance") {
                                    workOrderVal.resolved = val.attributeValue;
                                }
                                if (val.name == "Unresolved Distance") {
                                    workOrderVal.unresolved =
                                        val.attributeValue;
                                }
                            }
                        );
                        var total =
                            parseFloat(workOrderVal.unresolved) +
                            parseFloat(workOrderVal.resolved);
                        var percent =
                            (parseFloat(workOrderVal.resolved) * 100) / total;
                        workOrderVal.totaldistance = total.toFixed(2);
                        if (
                            total > 0 &&
                            parseFloat(workOrderVal.resolved) > 0
                        ) {
                            workOrderVal.percentdistance = percent.toFixed(0);
                        } else {
                            workOrderVal.percentdistance = 0;
                        }
                        vm.workOrders.push(workOrderVal);
                        vm.workOrders.push(workOrderVal);
                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            if ($stateParams.priority == undefined) {
                if ($scope.tab == 4) {
                    WorkOrderGroup.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrder.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            } else {
                if ($scope.tab == 4) {
                    WorkOrderGroupPriority.query(
                        {
                            priority: $stateParams.priority,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrderPriority.query(
                        {
                            priority: $stateParams.priority,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            }

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    // result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                var workOrdersRes = [];
                data.forEach(function (values) {
                    var workFlows = values.workOrderCases;
                    var disVal = 0.0;
                    var Cost = "";
                    var pb = "";
                    var totalDistance = 0.0;

                    var FiberStatus = "";
                    var workOrderTypeAttrVal =
                        values.workOrderTypeAttributeValues;

                    workOrderTypeAttrVal.forEach(function (item) {
                        if (item.workOrderDataTypeName == "Fiber Status") {
                            FiberStatus = item.attributeValue;
                        }

                        if (item.name == "Cost") {
                            Cost = item.attributeValue;
                        } else if (item.name == "Power Budget") {
                            pb = item.attributeValue;
                        } else if (item.name == "Fiber Distance") {
                            totalDistance = item.attributeValue;
                        }
                    });
                    /* if (values.status) {
                        values.status = values.status.replace(
                            "NEW",
                            "PLANNING PHASE"
                        );
                        values.status = values.status.replace(
                            "INPROGRESS",
                            "ROLL-OUT PHASE"
                        );
                        values.status = values.status.replace(
                            "RESOLVED",
                            "OPERATION PHASE"
                        );
                    } */
                    var res = {
                        id: values.id,
                        description: values.description,
                        address: values.address,
                        escalated: values.escalated,
                        status: values.status,
                        phase: values.phase,
                        reportedByUser: values.reportedByUser,
                        assignedToUser: values.assignedToUser,
                        workOrderTypeName: values.workOrderTypeName,
                        pinLat: values.pinLat,
                        pinLong: values.pinLong,
                        workOrderType: values.workOrderType,
                        priority: values.priority,
                        fiberStatus: FiberStatus,
                        groups: values.groups,
                        workOrderCases: values.workOrderCases,
                        geofenceName: values.geofenceName,
                        workOrderTypeAttributeValues:
                            values.workOrderTypeAttributeValues,
                        Cost: "$" + Cost,
                        pb: pb,
                        totalDistance: totalDistance,
                    };

                    workOrdersRes.push(res);
                });
                vm.page = pagingParams.page;
                vm.workOrders = [];
                workOrdersRes.forEach(function (workOrderVal) {
                    workOrderVal.workOrderTypeAttributeValues.forEach(function (
                        val
                    ) {
                        if (val.name == "Resolved Distance") {
                            workOrderVal.resolved = val.attributeValue;
                        }
                        if (val.name == "Unresolved Distance") {
                            workOrderVal.unresolved = val.attributeValue;
                        }
                    });
                    var total =
                        parseFloat(workOrderVal.unresolved) +
                        parseFloat(workOrderVal.resolved);
                    var percent =
                        (parseFloat(workOrderVal.resolved) * 100) / total;
                    workOrderVal.totaldistance = total.toFixed(2);
                    if (total > 0 && parseFloat(workOrderVal.resolved) > 0) {
                        workOrderVal.percentdistance = percent.toFixed(0);
                    } else {
                        workOrderVal.percentdistance = 0;
                    }
                    vm.workOrders.push(workOrderVal);
                });
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function filterSearchMap() {
            var data;
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                WorkOrderSearchForMap.searchtrworkOrderformap(
                    $scope.search,
                    function (response) {
                        drawResponseMap(response);
                    }
                );
            } else {
                if ($stateParams.priority == undefined) {
                    WorkOrderForMap.getAllCases(function (response) {
                        drawResponseMap(response);
                    });
                } else {
                    WorkOrderSearchForMap.prioritysearchtrworkOrderformap(
                        $stateParams.priority,
                        function (response) {
                            drawResponseMap(response);
                        }
                    );
                }
            }
            $scope.search = "";
        }
        function showWorkOrderBreakUps(workCost) {
            vm.workOrderName = workCost.description;
            vm.workBreakUps = [];
            var dateFormat = "yyyy-MM-dd";
            WorkOrder.get({ id: workCost.id }, function (workCase) {
                workCase.workOrderCases.forEach(function (data) {
                    var orderCost = 0.0;
                    var orderPb = 0.0;
                    var orderDis = 0.0;
                    data.workFlowTypeAttributeValues.forEach(function (item) {
                        if (item.workFlowTypeAttribute.name == "Cost") {
                            orderCost = "$" + item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Power Budget"
                        ) {
                            orderPb = item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Fiber Distance"
                        ) {
                            orderDis = item.attributeValue;
                        }
                    });

                    var orders = {
                        id: data.id,
                        description: data.description,
                        createDate: $filter("date")(
                            data.createDate,
                            dateFormat
                        ),
                        Cost: orderCost,
                        pb: orderPb,
                        totalDistance: orderDis,
                    };
                    vm.workBreakUps.push(orders);
                });
            });
            $("#workOrderBreakUpModal").show();
        }

        function showWorkOrderPowerBudgetBreakUps(workPB) {
            vm.workOrderName = workPB.description;
            vm.workBreakUps = [];
            var dateFormat = "yyyy-MM-dd";
            WorkOrder.get({ id: workPB.id }, function (workCase) {
                workCase.workOrderCases.forEach(function (data) {
                    var orderCost = 0.0;
                    var orderPb = 0.0;
                    var orderDis = 0.0;
                    data.workFlowTypeAttributeValues.forEach(function (item) {
                        if (item.workFlowTypeAttribute.name == "Cost") {
                            orderCost = "$" + item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Power Budget"
                        ) {
                            orderPb = item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Fiber Distance"
                        ) {
                            orderDis = item.attributeValue;
                        }
                    });

                    var orders = {
                        id: data.id,
                        description: data.description,
                        createDate: $filter("date")(
                            data.createDate,
                            dateFormat
                        ),
                        Cost: orderCost,
                        pb: orderPb,
                        totalDistance: orderDis,
                    };
                    vm.workBreakUps.push(orders);
                });
            });
            $("#PBWorkOrderBreakUp").show();
        }

        // function showWorkflowBOQBreakUp(boqBreak) {
        // 	vm.workflowBoq = [];
        // 	var res = {
        // 		description: boqBreak.description,
        // 		group: boqBreak.groups[0].name,
        // 		boq: boqBreak.Cost,
        // 		totalDistance: boqBreak.totalDistance
        // 	};
        // 	vm.workflowBoq.push(res);
        // 	$("#WorkflowboqBreakUp").show();
        // }
        function showWorkflowPBBreakUp(pbBreak) {
            vm.workflowPB = [];
            var res = {
                description: pbBreak.description,
                group: pbBreak.groups[0].name,
                pb: pbBreak.pb,
                totalDistance: pbBreak.totalDistance,
            };
            vm.workflowPB.push(res);
            $("#WorkflowPBBreakUp").show();
        }

        function hideWorkOrderModal() {
            $("#workOrderBreakUpModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#workOrderBreakUpModal").hide();
        }

        function hideWorkOrderPBModal() {
            $("#PBWorkOrderBreakUp").removeClass("in");
            $(".modal-backdrop").remove();
            $("#PBWorkOrderBreakUp").hide();
        }
        // function hideWorkflowboqModal() {
        // 	$("#WorkflowboqBreakUp").hide();
        // }
        // function hideWorkflowPBModal() {
        // 	$("#WorkflowPBBreakUp").hide();
        // }

        function selectWorkOrderEntity(workOrder) {
            if (workOrder.id != null) {
                if (workOrder.isChecked == true) {
                    vm.totalSelected++;
                    vm.showActions = false;
                    vm.isAllSelected = vm.workOrders.every(function (itm) {
                        return itm.isChecked;
                    });
                    vm.selectWorkOrders.push(workOrder.id);
                } else {
                    vm.totalSelected--;
                }
                if (vm.totalSelected == 0) {
                    vm.groupAssets = true;
                    vm.showActions = true;
                    loadAll();
                }
            }
        }

        function selectAllWorkOrder() {
            var toggleStatus = vm.isAllSelected;
            if (toggleStatus) {
                vm.showActions = false;
                vm.selectWorkOrders = [];
                vm.workOrders.forEach(function (workOrder) {
                    vm.selectWorkOrders.push(workOrder.id);
                });
                vm.showActions = true;
                vm.selectWorkOrders = [];
            }
            angular.forEach(vm.workOrders, function (itm) {
                itm.isChecked = toggleStatus;
            });
        }

        function updateWorkOrderGroup(name) {
            vm.multgroup.forEach(function (group) {
                if (group.name == name) {
                    if (vm.selectWorkOrders.length > 0) {
                        var workFlowGroupArray = [];
                        vm.selectWorkOrders.forEach(function (workOrderId) {
                            workFlowGroupArray.push({
                                workOrderId: workOrderId,
                                groupId: group.id,
                            });
                        });
                        WorkOrderUpdateGroup.update(
                            workFlowGroupArray,
                            onSuccess,
                            onError
                        );
                        function onSuccess() {
                            vm.groupOrders = true;
                            vm.showActions = true;
                            loadAll();
                            // $state.go('work-order');
                        }
                        function onError() {}
                    } else {
                        alert("Please select WorkOrder to update group");
                    }
                }
            });
        }

        function selectedWorkOrders(name) {
            if (name == "Update Group Mapping") {
                vm.groupOrders = false;
            } else if (name == "Delete Multiple WorkOrders") {
                vm.groupOrders = true;
                if (vm.selectWorkOrders.length > 0) {
                    var workOrderGroupArray = [];
                    vm.selectWorkOrders.forEach(function (workOrderId) {
                        workOrderGroupArray.push({ id: workOrderId });
                    });
                    WorkOrderBulkDelete.save(
                        workOrderGroupArray,
                        onSuccess,
                        onError
                    );
                    function onSuccess() {
                        vm.groupOrders = true;
                        vm.showActions = true;
                        loadAll();
                        // $state.go('work-order');
                    }
                    function onError(error) {
                        var msg =
                            "WorkOrder deletion failed, WorkOrder has some dependent data";
                        if (error.status == 400) {
                            AlertService.error(msg);
                        } else {
                            AlertService.error(error.data.message);
                        }
                    }
                } else {
                    alert("Please select WorkOrder to delete list");
                }
            }
        }

        function animatedMove(marker, t, current, moveto) {
            var lat = current.lat();
            var lng = current.lng();

            var deltalat = (moveto.lat() - current.lat()) / 100;
            var deltalng = (moveto.lng() - current.lng()) / 100;

            var delay = 10 * t;
            for (var i = 0; i < 100; i++) {
                (function (ind) {
                    setTimeout(function () {
                        var lat = marker.position.lat();
                        var lng = marker.position.lng();
                        lat += deltalat;
                        lng += deltalng;
                        latlng = new google.maps.LatLng(lat, lng);
                        marker.setPosition(latlng);
                    }, delay * ind);
                })(i);
            }
        }

        function drawResponseMap(data) {
            var myOptions = {
                zoom: 10,
                center: new google.maps.LatLng("5.431587", "101.128162"),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };

            if ($scope.tab == 2 || $scope.tab == 5) {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas1"),
                    myOptions
                );
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () {};
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById("map_canvas1");
                drawLatestWorkOrders(data);
            } else if ($scope.tab == 3) {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas2"),
                    myOptions
                );
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () {};
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById("map_canvas2");
                drawCasesAndNearByAgents(data);
                WorkOrderLastLocation.getlastlogs(function (response) {
                    var lastLocByAgents = response;
                    var markerIcon = "inactive";
                    var imageUrl = "";
                    switch (markerIcon) {
                        case "inactive":
                            imageUrl = "content/images/marker_inactive.png";
                            break;
                        case "idle":
                            imageUrl = "content/images/marker_idle.png";
                            break;
                        case "active":
                            imageUrl = "content/images/marker_active.png";
                            break;
                        case "active_case":
                            imageUrl = "content/images/marker_active_case.png";
                            break;
                        default:
                            imageUrl = "content/images/green.png";
                            break;
                    }

                    var lastLocVal = [];
                    removeMarkers();
                    for (var i = 0; i < lastLocByAgents.length; i++) {
                        var path = lastLocByAgents[i].path;
                        if (path.length > 1) {
                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(
                                    path[0].lat,
                                    path[0].lng
                                ),
                                map: locations.map,
                                icon: {
                                    scaledSize: new google.maps.Size(42, 40),
                                    origin: new google.maps.Point(0, 0),
                                    url: imageUrl,
                                    anchor: new google.maps.Point(16, 16),
                                },
                                label: {
                                    color: "#000000",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    text: lastLocByAgents[i].userName,
                                    backgroundcolor: "#ff9800",
                                },
                                title: lastLocByAgents[i].userName,
                            });
                            var markerContent =
                                '<div class="infoWindowhead">' +
                                name +
                                '</div><div class="infoWindowContent"> <br> <b> Lat  :</b> ' +
                                "<br> <b>Lng :</b> " +
                                "</div>";
                            var infowindow = new google.maps.InfoWindow({
                                content: markerContent,
                            });
                            marker.addListener("click", function () {
                                infowindow.open(locations.map, marker);
                            });

                            animatedMove(
                                marker,
                                50,
                                marker.position,
                                new google.maps.LatLng(path[1].lat, path[1].lng)
                            );
                            nearbyAgentsMarkers.push(marker);
                        }
                    }
                });
            }
        }
        function removeMarkers() {
            for (var i = 0; i < nearbyAgentsMarkers.length; i++) {
                nearbyAgentsMarkers[i].setMap(null);
            }
            nearbyAgentsMarkers = [];
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                priority: pagingParams.priority,
            });
        }

        $scope.openInfoWindow = function (e, selectedMarker) {
            e.preventDefault();
            google.maps.event.trigger(selectedMarker, "click");
        };

        function drawLatestWorkOrders(response) {
            if (response) {
                initializeWorkOrderMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // function() {
                    $.each(response, function (index, value) {
                        var infoWindow = new google.maps.InfoWindow();
                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });

                        var infoWindow2 = new google.maps.InfoWindow();
                        if (value.priority == "LOW") {
                            startMarker.setIcon(
                                "content/images/Pointers-L4.png"
                            );
                        } else if (value.priority == "MEDIUM") {
                            startMarker.setIcon(
                                "content/images/Pointers-M4.png"
                            );
                        } else if (value.priority == "HIGH") {
                            startMarker.setIcon(
                                "content/images/Pointers-H4.png"
                            );
                        } else if (value.priority == "CRITICAL") {
                            startMarker.setIcon(
                                "content/images/Pointer-C4.png"
                            );
                        }
                        var span =
                            '<a userId="' +
                            value.geofenceName +
                            '" class="userpath" >Load travelled path</a>';
                        startMarker.content =
                            '<div class="infoWindowContent"> <b>Case Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b>Address :</b> " +
                            value.address +
                            "</div>";
                        $compile(startMarker.content)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "mouseover",
                            function () {
                                infoWindow.setContent(
                                    '<div class="infoWindowhead">' +
                                        startMarker.title +
                                        "</div>" +
                                        startMarker.content
                                );
                                infoWindow.open(locations.map, startMarker);
                            }
                        );

                        google.maps.event.addListener(
                            startMarker,
                            "mouseout",
                            function () {
                                infoWindow.close();
                            }
                        );
                    });
                });
            }
        }

        function initializeWorkOrderMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        function drawCasesAndNearByAgents(response) {
            if (response) {
                initializeMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // setupMap(function() {
                    $.each(response, function (index, value) {
                        var infoWindow = new google.maps.InfoWindow();
                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });

                        var infoWindow2 = new google.maps.InfoWindow();

                        if (value.priority == "LOW") {
                            startMarker.setIcon(
                                "content/images/Pointers-L4.png"
                            );
                        } else if (value.priority == "MEDIUM") {
                            startMarker.setIcon(
                                "content/images/Pointers-M4.png"
                            );
                        } else if (value.priority == "HIGH") {
                            startMarker.setIcon(
                                "content/images/Pointers-H4.png"
                            );
                        } else if (value.priority == "CRITICAL") {
                            startMarker.setIcon(
                                "content/images/Pointer-C4.png"
                            );
                        }
                        var span =
                            '<a userId="' +
                            value.geofenceName +
                            '" class="userpath" >Load travelled path</a>';
                        startMarker.content =
                            '<div class="infoWindowContent"><b>Case Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b>Address :</b> " +
                            value.address +
                            "</div>";

                        $compile(startMarker.content)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "mouseover",
                            function () {
                                infoWindow.setContent(
                                    '<div class="infoWindowhead">' +
                                        startMarker.title +
                                        "</div>" +
                                        startMarker.content
                                );
                                infoWindow.open(locations.map, startMarker);
                            }
                        );

                        // on mouseout
                        google.maps.event.addListener(
                            startMarker,
                            "mouseout",
                            function () {
                                infoWindow.close();
                            }
                        );

                        resizeMap();
                    });
                    // });
                });
            }
        }

        $scope.workOrderLocation = function (selectedCase) {
            $("#workOrderLocationModal").show();
            var myCenter = new google.maps.LatLng(
                selectedCase.pinLat,
                selectedCase.pinLong
            );
            var ele = document.getElementById("workOrderLocationModal");
            $(ele).modal("show");

            var map = new google.maps.Map(
                document.getElementById("map_canvas_workorder_location"),
                {
                    center: myCenter,
                    zoom: 12,
                }
            );
            selectedCase.workOrderCases.forEach(function (caseVal) {
                TrCaseById.get(caseVal.id, function (caseDetails) {
                    caseDetails.caseAssets.forEach(function (assetVal) {
                        if (assetVal.assetType.layout == "SPREAD") {
                            AssetByID.get(assetVal.id, function (assetVal1) {
                                var spreadAssetCoordinates = [];

                                assetVal1.assetCoordinates.forEach(function (
                                    loc
                                ) {
                                    spreadAssetCoordinates.push({
                                        lat: loc.latitude,
                                        lng: loc.longitude,
                                    });
                                });
                                var polylineColor = "#000000";
                                var polylinepath = new google.maps.Polyline({
                                    path: spreadAssetCoordinates,
                                    geodesic: true,
                                    strokeColor: polylineColor,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2.5,
                                    fillColor: polylineColor,
                                    fillOpacity: 0.3,
                                    editable: false,
                                });

                                polylinepath.setMap(map);

                                var pos = {
                                    lat: assetVal1.assetCoordinates[0].latitude,
                                    lng:
                                        assetVal1.assetCoordinates[0].longitude,
                                };
                                map.setCenter(pos);

                                var midLatLng = {
                                    lat:
                                        spreadAssetCoordinates[
                                            spreadAssetCoordinates.length - 1
                                        ].lat,
                                    lng:
                                        spreadAssetCoordinates[
                                            spreadAssetCoordinates.length - 1
                                        ].lng,
                                };
                                var infowindow = new google.maps.InfoWindow({
                                    content:
                                        '<div class="infoWindowhead">' +
                                        "name" +
                                        '<div class="infoWindowContent"> <b>Name :</b> ' +
                                        assetVal1.name +
                                        "</div></div>",
                                });

                                infowindow.setPosition(midLatLng);
                                google.maps.event.addListener(
                                    polylinepath,
                                    "mouseout",
                                    function (event) {
                                        infowindow.close();
                                    }
                                );

                                google.maps.event.addListener(
                                    polylinepath,
                                    "mouseover",
                                    function (event) {
                                        if (openedInfoWindow != null) {
                                            openedInfoWindow.close();
                                        }
                                        infowindow.setContent(
                                            '<div class="infoWindowhead">' +
                                                "<b></b>" +
                                                assetVal1.name +
                                                "</br></div>"
                                        );

                                        infowindow.mousemove;
                                        infowindow.open(map);
                                        infowindow.setPosition(event.latLng);
                                        openedInfoWindow = infowindow;
                                    }
                                );
                            });
                        } else if (assetVal.assetType.layout == "FIXED") {
                            AssetByID.get(assetVal.id, function (assetVal1) {
                                createMarker(
                                    assetVal1.assetCoordinates[0],
                                    map
                                );
                                var pos = {
                                    lat: assetVal1.assetCoordinates[0].latitude,
                                    lng:
                                        assetVal1.assetCoordinates[0].longitude,
                                };
                                map.setCenter(pos);
                            });
                        }
                    });
                });
            });

            $("#workOrderLocationModal").on("show.bs.modal", function (event) {
                $("#location-map-workorder-location").css("width", "100%");
                $("#map_canvas_workorder_location").css("width", "100%");
            });
        };

        function createMarker(latlngs, map) {
            try {
                var pos = {
                    lat: latlngs.latitude,
                    lng: latlngs.longitude,
                };

                var marker = new google.maps.Marker({
                    position: pos,
                    map: map,
                    icon:
                        "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                });
            } catch (err) {}
        }

        function resizeMap() {
            setTimeout(function () {
                google.maps.event.trigger(locations.map, "resize");
                locations.map.setCenter(locations.latlng);
            }, 1000);
        }

        function initializeMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        $(".select2").select2();

        vm.success = null;
        vm.error = null;
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkFlowTypeDialogController",
            WorkFlowTypeDialogController
        );

    WorkFlowTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "WorkFlowType",
        "User",
        "WorkFlowTypeSearch",
        "AllCustomWorkFlowTypeAttribute",
    ];

    function WorkFlowTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        WorkFlowType,
        User,
        WorkFlowTypeSearch,
        AllCustomWorkFlowTypeAttribute
    ) {
        var vm = this;
        //workFlowtype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.workFlowType = entity;
        vm.workFlowTypeImageName = workFlowTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customWorkFlowTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        vm.checkNumber;

        function workFlowTypeImageName(image) {
            vm.workFlowType.image = image;
        }

        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomWorkFlowTypeAttribute.getAll(function (response) {
                vm.customWorkFlowTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customWorkFlowTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.workFlowType.workFlowTypeAttribute != null &&
            vm.workFlowType.workFlowTypeAttribute.length != 0
        ) {
            vm.items = vm.workFlowType.workFlowTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.workFlowCategory == null) {
                value.workFlowCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.workFlowType.id !== null) {
                vm.workFlowType.workFlowTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.workFlowType.workFlowTypeAttribute.push({
                        workFlowCategory: vm.items[i].workFlowCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        workFlowTypeAttribOrder:
                            vm.items[i].workFlowTypeAttribOrder,
                    });
                }
                WorkFlowType.update(
                    vm.workFlowType,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                vm.workFlowType.workFlowTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.workFlowType.workFlowTypeAttribute.push({
                        workFlowCategory: vm.items[i].workFlowCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        workFlowTypeAttribOrder:
                            vm.items[i].workFlowTypeAttribOrder,
                    });
                }
                WorkFlowType.save(vm.workFlowType, onSaveSuccess, onSaveError);
            }
        }

        $("#workFlowTypeImage").change(function () {
            var filesSelected =
                document.getElementById("workFlowTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.workFlowType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:workFlowTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("work-flow-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.addmore = function (index) {
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice(index + 1, 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkFlowTypeDetailController",
            WorkFlowTypeDetailController
        );

    WorkFlowTypeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "WorkFlowType",
        "User",
    ];

    function WorkFlowTypeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        WorkFlowType,
        User
    ) {
        var vm = this;

        vm.workFlowType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workFlowTypeUpdate",
            function (event, result) {
                vm.workFlowType = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkFlowTypeDeleteController",
            WorkFlowTypeDeleteController
        );

    WorkFlowTypeDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "CaseType",
    ];

    function WorkFlowTypeDeleteController($uibModalInstance, entity, CaseType) {
        var vm = this;

        vm.caseType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            CaseType.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("work-flow-type", {
                parent: "entity",
                url: "/work-flow-type",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-types.html",
                        controller: "WorkFlowTypeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("work-flow-type-detail", {
                parent: "work-flow-type",
                url: "/work-flow-type/{id}",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-detail.html",
                        controller: "WorkFlowTypeDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkFlowType",
                        function ($stateParams, WorkFlowType) {
                            return WorkFlowType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-flow-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-flow-type.new", {
                parent: "work-flow-type",
                url: "/create",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-dialog.html",
                        controller: "WorkFlowTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            description: null,
                            createdDate: null,
                            updateDate: null,
                            id: null,
                        };
                    },
                },
            })
            .state("work-flow-type.edit", {
                parent: "work-flow-type",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-dialog.html",
                        controller: "WorkFlowTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkFlowType",
                        function ($stateParams, WorkFlowType) {
                            return WorkFlowType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-flow-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-flow-type.delete", {
                parent: "work-flow-type",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/work-flow-type/work-flow-type-delete-dialog.html",
                                controller: "WorkFlowTypeDeleteController",
                                controllerAs: "vm",
                                size: "sm",
                                resolve: {
                                    entity: [
                                        "WorkFlowType",
                                        function (WorkFlowType) {
                                            return WorkFlowType.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("work-flow-type", null, {
                                        reload: "work-flow-type",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkFlowType", WorkFlowType);

    WorkFlowType.$inject = ["$resource", "DateUtils"];

    function WorkFlowType($resource, DateUtils) {
        var resourceUrl = "api/work-flow-types/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );
    }
})();
(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkFlowTypeSearch", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getworkflowtypebyname = function (data, callback) {
                $http
                    .get("api/work-flow-types-details/" + data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkFlowTypeSearch", WorkFlowTypeSearch);

    WorkFlowTypeSearch.$inject = ["$resource"];

    function WorkFlowTypeSearch($resource) {
        var service = $resource(
            "/api/work-flow-types/searchvalue/:userId",
            { userId: "@id" },
            {},
            {
                query: { method: "GET", isArray: true },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllCustomWorkFlowTypeAttribute", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/all-custom-workflow-type-attributes")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowTypeController", WorkFlowTypeController);

    WorkFlowTypeController.$inject = [
        "$scope",
        "$state",
        "WorkFlowType",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "WorkFlowTypeSearch",
    ];

    function WorkFlowTypeController(
        $scope,
        $state,
        WorkFlowType,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        WorkFlowTypeSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                WorkFlowTypeSearch.query(
                    {
                        userId: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        //  result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.workFlowTypes = data;
                    vm.page = pagingParams.page;
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        loadAll();

        function loadAll() {
            WorkFlowType.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.workFlowTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowDialogController", WorkFlowDialogController);

    WorkFlowDialogController.$inject = [
        "$scope",
        "$state",
        "$stateParams",
        "entity",
        "AlertService",
        "WorkFlow",
        "AssetGroupSearch",
        "AssetGroup",
        "AllWorkFlowTypes",
        "AllCustomWorkFlowTypeAttribute",
        "AllCustomAssetTypeAttribute",
        "UserGroupIDs",
        "ActivatedUserSearch",
        "AllAssetsTypes",
        "WorkFlowCheckAsset",
        "Configs",
        "DEFAULT_LATITUDE",
        "DEFAULT_LONGITUDE",
        "UserAccount",
    ];

    function WorkFlowDialogController(
        $scope,
        $state,
        $stateParams,
        entity,
        AlertService,
        WorkFlow,
        AssetGroupSearch,
        AssetGroup,
        AllWorkFlowTypes,
        AllCustomWorkFlowTypeAttribute,
        AllCustomAssetTypeAttribute,
        UserGroupIDs,
        ActivatedUserSearch,
        AllAssetsTypes,
        WorkFlowCheckAsset,
        Configs,
        DEFAULT_LATITUDE,
        DEFAULT_LONGITUDE,
        UserAccount
    ) {
        var vm = this;

        vm.workFlow = entity;
        var entity_old = angular.copy(vm.workFlow);
        vm.filterActivatedUser = filterActivatedUser;
        vm.selectattributes = selectedWorkFlowTypeAttributes;
        vm.saveEditAsset = saveEditAsset;
        vm.selectedGroup = selectedGroup;
        var openedInfoWindow = null;
        vm.connectSelectedAssets = connectSelectedAssets;
        vm.saveLinkPits = saveLinkPits;
        vm.connectMultipleAssets = connectMultipleAssets;
        vm.hideConnectMultipleAssetsModal = hideConnectMultipleAssetsModal;
        vm.searchAssetName = searchAssetName;
        vm.refreshPage = refreshPage;
        vm.connectAssets = connectAssets;
        vm.recalculate = recalculate;
        vm.isSiteASelected = false;
        vm.isSiteBSelected = false;
        vm.selectedSiteA = {};
        vm.selectedSiteB = {};
        vm.linkAssetType = null;
        vm.manholeAssetType = null;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.showZoomLocation = showZoomLocation

        vm.editAsset = editAsset;
        vm.workFlowTypes = [];
        vm.multigroup = [];
        vm.assetType = [];
        var parentSite = [];

        vm.deleteAssetModal = deleteAssetModal;
        vm.confirmDeleteAsset = confirmDeleteAsset;
        vm.cleardeleteAsset = cleardeleteAsset;
        vm.clearCreateAsset = clearCreateAsset;
        var deleteAssetName = null;
        vm.createAssetModal = createAssetModal;
        vm.createAsset = createAsset;
        vm.assetNameVal = null;
        /* vm.assetLat = null;
        vm.assetLong = null; */
        vm.getLocationCoordinate = null
        var createAssetData = {};

        vm.customAttributesMap = {};
        var usersMap = {};
        var mappedAssetTemp = {};
        vm.mappedAssetsList = [];
        vm.tempLinkWithPits = [];
        vm.deletedAssetsList = [];
        var selectedGroup = [];
        var assetsPlanningMap = null;
        var assetsDeployedMap = null;
        vm.isShowing = true;
        vm.save = save;
        vm.handleTabClick = handleTabClick;
        vm.assetExisting = false;
        $scope.search = null;
        vm.assets = [];
        vm.showAssetCreation = false;
        vm.showAssetName = false;
        var centerlatlng = null;
        vm.hideUser = true;
        var marker = null;
        //        vm.searchAssets = searchAssets;
        var editAssetMap = null;
        vm.validUser = true;
        vm.assignedUsers = [];
        vm.validUser = true;
        vm.hideConnectSitesModal = hideConnectSitesModal;
        vm.previousId = sessionStorage.getItem("prevEditId");
        if (vm.previousId) {
            vm.validUser = false;
        }
        $scope.tab = 1;
        vm.siteAssets = [];
        vm.phaseAccess = true;
        jQuery(document).ready(function () {
            var back = jQuery(".prev");
            var next = jQuery(".next");
            var steps = jQuery(".step");

            next.bind("click", function () {
                jQuery.each(steps, function (i) {
                    if (
                        !jQuery(steps[i]).hasClass("current") &&
                        !jQuery(steps[i]).hasClass("done")
                    ) {
                        jQuery(steps[i]).addClass("current");
                        jQuery(steps[i - 1])
                            .removeClass("current")
                            .addClass("done");
                        return false;
                    }
                });
            });
            back.bind("click", function () {
                jQuery.each(steps, function (i) {
                    if (
                        jQuery(steps[i]).hasClass("done") &&
                        jQuery(steps[i + 1]).hasClass("current")
                    ) {
                        jQuery(steps[i + 1]).removeClass("current");
                        jQuery(steps[i])
                            .removeClass("done")
                            .addClass("current");
                        return false;
                    }
                });
            });
        });

        $scope.assetTypeLabel = {
            search: "Search",
            nothingSelected: "Select Asset Type",
        };

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                disableDoubleClickZoom: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                ],
            });
        }

        var latlngs = new google.maps.LatLng(
            DEFAULT_LATITUDE.value,
            DEFAULT_LONGITUDE.value
        );

        if ($scope.tab == 1) {
            vm.toggleFirst = true;
            vm.toggleSecond = false;
            vm.toggleThird = false;
            AllWorkFlowTypes.getAll(function (response) {
                vm.workFlowTypes = response;
            });

            Configs.get("Phases", function (response) {
                vm.workFlowPhase = response;
                //vm.workFlow.phase = "Planning Phase"
                /*  if(vm.workFlow.id == null){
                    response.forEach(function(val){
                        if(val.configValue == '01'){
                            vm.workFlow.phase = val.configKey
                        }
                    })
                }*/
            });

            if (vm.workFlow.id) {
                Configs.get("WorkFlowStatus", function (response) {
                    vm.workFlowStatus=[];
                    var workFlowStatusList = response[0].configValue.split(",");
                    workFlowStatusList.forEach(function(value){
                        if(value.length > 0){
                            vm.workFlowStatus.push({"configKey":value,"configValue":value});
                        }
                    });
                    console.log(vm.workFlowStatus);
                });
                
            }

            AllCustomWorkFlowTypeAttribute.getAll(function (response) {
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customWorkFlowTypeAttributeValues;
                });
            });

            if (vm.workFlow.id != null) {
                vm.hideUser = false;
                vm.workFlow.groups.forEach(function (group) {
                    selectedGroup.push(group.id);
                });
            }

            UserGroupIDs.getAll(function (response) {
                vm.multigroup = response;
                response.forEach(function (val) {
                    if (val.name == "Planning Group") {
                        val.ticked = true;
                    }
                });
            });

            UserAccount.get(function (data) {
                data.authorities.find(function (val) {
                    if (
                        val == "ROLE_PLAN_ADMIN" ||
                        val == "ROLE_ROLLOUT_ADMIN"
                    ) {
                        vm.phaseAccess = false;
                    }
                });
            });

            AllAssetsTypes.getAll(function (response) {
                vm.assetTypeResponse = []
                response.filter(function (eachElement){
                    if(eachElement.layout == "SPREAD"){
                        vm.assetTypeResponse.push(eachElement)
                    }
                })
                response.forEach(function (assettype) {
                    if (assettype.layout == "FIXED") {
                        assettype.icon =
                            '<img  src="' +
                            assettype.imagePath +
                            '"style="width: 24px; height: 24px;">';
                    } else {
                        assettype.icon =
                            '<img class="square" style="background-color:' +
                            assettype.colorcode +
                            ';">';
                    }
                    vm.assetType.push(assettype);
                });
            });

            AllCustomAssetTypeAttribute.getAll(function (response) {
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customAssetTypeAttributeValues;
                });
            });

            if (vm.workFlow.id != null) {
                if (vm.workFlow.workFlowAssets != null) {
                    vm.workFlow.workFlowAssets.forEach(function (asset) {
                        asset.isChecked = true;
                        vm.mappedAssetsList.push(asset);
                        vm.isShowing = false;
                        $scope.toggle = true;
                    });
                }
                vm.workFlowType = entity.workFlowType;
            }
        }

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            $scope.search = "";

            if ($scope.tab == 1) {
                vm.toggleFirst = true;
                vm.toggleSecond = false;
                vm.toggleThird = false;
            } else if ($scope.tab == 2) {
                vm.toggleFirst = false;
                vm.toggleSecond = true;
                vm.toggleThird = false;
                initPlanningMap();
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                        createMarkerForSelectedAsset(
                            vm.mappedAssetsList[i],
                            assetsPlanningMap
                        );
                    } else if (
                        vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                    ) {
                        var assetCoordinateValues =
                            vm.mappedAssetsList[i].assetCoordinates;
                        drawPolylineForGeneratedLoc(
                            vm.mappedAssetsList[i],
                            assetCoordinateValues,
                            assetsPlanningMap,
                            "yellow"
                        );
                    }
                }

                AllAssetsTypes.getAll(function (data) {
                    data.forEach(function (item) {
                        if (item.name == "Link") {
                            vm.linkAssetType = {};
                            vm.linkAssetType.assetType = item;
                            vm.linkAssetType.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                vm.linkAssetType.assetType
                            );
                            //                            $.each(vm.linkAssetType.assetType.assetTypeAttributes,function(key, value) {
                            //                                vm.linkAssetType.assetTypeAttributeValues.push({
                            //                                        assetTypeAttribute: vm.linkAssetType.assetType.assetTypeAttributes[key]
                            //                                    });
                            //                            });
                        } else if (item.name == "Manhole") {
                            vm.manholeAssetType = {};
                            vm.manholeAssetType.assetType = item;
                            vm.manholeAssetType.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                vm.manholeAssetType.assetType
                            );
                            //                            $.each(vm.manholeAssetType.assetType.assetTypeAttributes,function(key, value) {
                            //                                vm.manholeAssetType.assetTypeAttributeValues.push({
                            //                                        assetTypeAttribute: vm.manholeAssetType.assetType.assetTypeAttributes[key]
                            //                                    });
                            //                            });
                        }
                    });
                });

            } else if ($scope.tab == 3) {
                vm.toggleFirst = false;
                vm.toggleSecond = false;
                vm.toggleThird = true;
                var totalCost = 0;
                var totalPowerBudget = 0;
                var totalFiberDistance = 0.0;
                for (
                    var assetIndex = 0;
                    assetIndex < vm.mappedAssetsList.length;
                    assetIndex++
                ) {
                    if (vm.mappedAssetsList[assetIndex].name != null) {
                        var assetAV =
                            vm.mappedAssetsList[assetIndex]
                                .assetTypeAttributeValues;
                        var isSpread = false;
                        var fiberDistance = 0.0;

                        if (
                            vm.mappedAssetsList[assetIndex].assetType.layout ==
                            "SPREAD"
                        ) {
                            isSpread = true;
                            var spreadAV =
                                vm.mappedAssetsList[assetIndex]
                                    .assetTypeAttributeValues;
                            for (
                                var spreadAssetIndex = 0;
                                spreadAssetIndex < spreadAV.length;
                                spreadAssetIndex++
                            ) {
                                if (
                                    spreadAV[spreadAssetIndex]
                                        .assetTypeAttribute.name ===
                                    "Fiber Distance (km)"
                                ) {
                                    fiberDistance = parseFloat(
                                        "0" +
                                            spreadAV[spreadAssetIndex]
                                                .attributeValue
                                    );
                                }
                            }
                        }

                        assetAV.forEach(function (item) {
                            var value = 0;
                            if (item.attributeValue != null) {
                                value = parseFloat(item.attributeValue);
                            } else {
                                value = parseFloat(
                                    item.assetTypeAttribute.defaultValue
                                );
                            }

                            if (item.assetTypeAttribute.name == "Cost") {
                                var tempCost = parseFloat(value);
                                if (isSpread) {
                                    tempCost =
                                        parseFloat(value) * fiberDistance;
                                }
                                if (tempCost > 0) {
                                    totalCost += tempCost;
                                }
                            }
                            if (
                                item.assetTypeAttribute.name == "Power Budget"
                            ) {
                                var tempPowerBudget = parseFloat(value);
                                if (isSpread) {
                                    tempPowerBudget =
                                        parseFloat(value) * fiberDistance;
                                }
                                if (tempPowerBudget > 0) {
                                    totalPowerBudget += tempPowerBudget;
                                }
                            }
                        });
                        totalFiberDistance += fiberDistance;
                    }
                }

                var workFlowAV = vm.workFlow.workFlowTypeAttributeValues;
                for (
                    var workFlowIndex = 0;
                    workFlowIndex < workFlowAV.length;
                    workFlowIndex++
                ) {
                    if (
                        workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                        "Cost"
                    ) {
                        workFlowAV[
                            workFlowIndex
                        ].attributeValue = totalCost.toFixed(2);
                    }
                    if (
                        workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                        "Power Budget"
                    ) {
                        workFlowAV[
                            workFlowIndex
                        ].attributeValue = totalPowerBudget.toFixed(2);
                    }
                    if (
                        workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                        "Fiber Distance"
                    ) {
                        workFlowAV[
                            workFlowIndex
                        ].attributeValue = totalFiberDistance.toFixed(2);
                    }
                }
                vm.workFlow.workFlowTypeAttributeValues = workFlowAV;

                assetsDeployedMap = new google.maps.Map(
                    document.getElementById("map_canvas_deployed"),
                    myOption(11, latlngs)
                    /* {
                        center: {
                            lat: 5.431587,
                            lng: 101.128162,
                        },
                        zoom: 13,
                        fullscreenControl: true,
                    } */
                );

                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                        createMarkerForSelectedAsset(
                            vm.mappedAssetsList[i],
                            assetsDeployedMap
                        );
                    } else if (
                        vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                    ) {
                        var assetCoordinateValues =
                            vm.mappedAssetsList[i].assetCoordinates;
                        drawPolylineForGeneratedLoc(
                            vm.mappedAssetsList[i],
                            assetCoordinateValues,
                            assetsDeployedMap,
                            "yellow"
                        );
                    }
                }

                if (vm.mappedAssetsList.length > 0) {
                    vm.workFlow.pinLat =
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude;
                    vm.workFlow.pinLong =
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude;
                    vm.workFlow.address = "";
                    if (vm.workFlow.id == null) {
                        vm.workFlow.status = "NEW";
                    }
                }
                if (vm.mappedAssetsList.length > 0) {
                    assetsDeployedMap.setCenter(
                        new google.maps.LatLng(
                            vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                            vm.mappedAssetsList[0].assetCoordinates[0].longitude
                        )
                    );
                }
                //
                //				var pointA = new google.maps.LatLng(12.917358683134225,77.62311194634297);
                //            	var pointB = new google.maps.LatLng(12.915999226925456,77.63823960497554);
                //
                //				getPointsRoute(pointA, pointB, assetsDeployedMap, 200);
            }
        };

        function handleTabClick($event) {
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }

        function clearCreateAsset() {
            $("#create-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#create-asset").hide();
        }

        function createAssetModal(item) {
            vm.tempItem = item
            vm.assetExisting = false;
            if (item.name == "LINK_WITH_MH") {
                connectMultipleAssets();
            } else {
                vm.CreateAssetName = item.name;
                vm.assetNameVal = null;
                /* vm.assetLat = null;
                vm.assetLong = null; */
                vm.getLocationCoordinate = null
                $("#create-asset").show();
                createAssetData = item;
                vm.showAssetName = false;
                vm.parentAsset = null;
            }
        }

        function getConsolidatedAssetTypeAttributeValue(assetType) {
            var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({
                    assetTypeAttribute: assetTypeAttribute1,
                    attributeValue:
                        assetType.assetTypeAttributes[index].defaultValue,
                });
            }

            assetTypeAttributeValuesList.sort(function (a, b) {
                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                    nameB = b.assetTypeAttribute.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });
            return assetTypeAttributeValuesList;
        }

        function searchAssetName() {
            // vm.assetExisting = false;
            // var searchName = vm.assetNameVal;
            // vm.showAssetCreation = false;
            // if (searchName != undefined && searchName.length > 2) {
            //     WorkFlowCheckAsset.get(
            //         { name: searchName },
            //         function (checkAsset) {
            //             if (checkAsset.name == searchName) {
            //                 vm.assetExisting = true;
            //                 vm.showAssetCreation = true;
            //             } else if (vm.mappedAssetsList.length > 0) {
            //                 vm.mappedAssetsList.forEach(function (maplist) {
            //                     if (maplist.name == searchName) {
            //                         vm.assetExisting = true;
            //                         vm.showAssetCreation = true;
            //                     }
            //                 });
            //             }
            //         }
            //     );
            // }
        }

        function refreshPage() {
            if (marker != null) {
                marker.setMap(null);
            }

            initPlanningMap();

            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(
                        vm.mappedAssetsList[i],
                        assetsPlanningMap
                    );
                } else if (
                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                ) {
                    var assetCoordinateValues =
                        vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        assetsPlanningMap,
                        "yellow"
                    );
                }
            }
        }

        function createAsset() {
            var assetName = vm.assetNameVal;
            vm.assetExisting = false;
            var coOrdinate = [];
            parentSite = [];
            if (marker != null) {
                marker.setMap(null);
            }
            if (vm.parentAsset != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.parentAsset == vm.mappedAssetsList[i].name) {
                        parentSite.push(vm.mappedAssetsList[i]);
                        coOrdinate.push({
                            lat:
                                vm.mappedAssetsList[i].assetCoordinates[0]
                                    .latitude,
                            lng:
                                vm.mappedAssetsList[i].assetCoordinates[0]
                                    .longitude,
                        });
                        assetsPlanningMap = new google.maps.Map(
                            document.getElementById("map_canvas_planning"),
                            myOption(13, coOrdinate[0])
                            /* {
                                center: coOrdinate[0],
                                zoom: 13,
                                fullscreenControl: true,
                            } */
                        );
                        geoLocation(assetsPlanningMap)
                    }
                }
            } else {
               /*  assetsPlanningMap = new google.maps.Map(
                    document.getElementById("map_canvas_planning"),
                    myOption(13, latlngs)
                );
                geoLocation(assetsPlanningMap) */
            }
            if (assetName && assetName.length > 2) {
                if (!isAssetAvailable(assetName)) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (
                            vm.mappedAssetsList[i].assetType.layout == "FIXED"
                        ) {
                            createMarkerForSelectedAsset(
                                vm.mappedAssetsList[i],
                                assetsPlanningMap
                            );
                        } else if (
                            vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                        ) {
                            var assetCoordinateValues =
                                vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(
                                vm.mappedAssetsList[i],
                                assetCoordinateValues,
                                assetsPlanningMap,
                                "yellow"
                            );
                        }
                    }
                    mappedAssetTemp = {};
                    mappedAssetTemp.name = assetName;
                    mappedAssetTemp.description = assetName;
                    mappedAssetTemp.assetType = createAssetData;
                    // mappedAssetTemp.ownedBy = parentSite;
                    mappedAssetTemp.parentAsset = parentSite;
                    var date = new Date();
                    mappedAssetTemp.createDate = date.getTime();
                    mappedAssetTemp.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                        createAssetData
                    );
                    //                    createAssetData.assetTypeAttributeValues = [];
                    //                    $.each(createAssetData.assetTypeAttributes,function (key) {
                    //                            mappedAssetTemp.assetTypeAttributeValues.push({
                    //                                assetTypeAttribute: createAssetData.assetTypeAttributes[key]
                    //                            });
                    //                        });
                    //
                    if (createAssetData.layout == "SPREAD") {
                        drawingManagerSpread();
                        drawingManagerValue(
                            "polylinecomplete",
                            assetsPlanningMap,
                            false
                        );
                    } else if (createAssetData.layout == "FIXED") {
                        if (vm.getLocationCoordinate) {
                            vm.fixedArray = [];
                            var coordinates = {};
                            var latlng = vm.getLocationCoordinate.split(",");
                            coordinates.latitude = latlng[0];
                            coordinates.longitude = latlng[1];

                            vm.fixedArray.push(coordinates);
                            mappedAssetTemp.assetCoordinates = vm.fixedArray;
                            addMappedAssets(mappedAssetTemp);
                            vm.isShowing = false;
                            initPlanningMap();
                            for (
                                var i = 0;
                                i < vm.mappedAssetsList.length;
                                i++
                            ) {
                                if (
                                    vm.mappedAssetsList[i].assetType.layout ==
                                    "FIXED"
                                ) {
                                    createMarkerForSelectedAsset(
                                        vm.mappedAssetsList[i],
                                        assetsPlanningMap
                                    );
                                } else if (
                                    vm.mappedAssetsList[i].assetType.layout ==
                                    "SPREAD"
                                ) {
                                    var assetCoordinateValues =
                                        vm.mappedAssetsList[i].assetCoordinates;
                                    drawPolylineForGeneratedLoc(
                                        vm.mappedAssetsList[i],
                                        assetCoordinateValues,
                                        assetsPlanningMap,
                                        "yellow"
                                    );
                                }
                            }
                            var centerlatlng = {
                                lat: parseFloat(latlng[0]),
                                lng: parseFloat(latlng[1]),
                            };
                            assetsPlanningMap.setCenter(centerlatlng);
                        } else if (vm.parentAsset != null) {
                            // setValues();
                            drawingManagerFixed();
                            drawMarker(
                                assetsPlanningMap,
                                JSON.stringify(coOrdinate)
                            );
                        } else {
                            drawingManagerFixed();
                            drawingManagerValue("click", assetsPlanningMap);
                        }
                    }
                } else {
                    initPlanningMap();
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (
                            vm.mappedAssetsList[i].assetType.layout == "FIXED"
                        ) {
                            createMarkerForSelectedAsset(
                                vm.mappedAssetsList[i],
                                assetsPlanningMap
                            );
                        } else if (
                            vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                        ) {
                            var assetCoordinateValues =
                                vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(
                                vm.mappedAssetsList[i],
                                assetCoordinateValues,
                                assetsPlanningMap,
                                "yellow"
                            );
                        }
                    }
                }
                $("#create-asset").removeClass("in");
                $(".modal-backdrop").remove();
                $("#create-asset").hide();
            }
        }

        function initPlanningMap() {
            assetsPlanningMap = new google.maps.Map(
                document.getElementById("map_canvas_planning"),
                myOption(15, latlngs)
                /* {
                    center: {
                        lat: 5.431587,
                        lng: 101.128162,
                    },
                    zoom: 13,
                    fullscreenControl: true,
                } */
            );
            geoLocation(assetsPlanningMap)
            
            google.maps.event.addListener(assetsPlanningMap,"dblclick", function () {
                if(vm.tempItem){
                    createAssetModal(vm.tempItem)
                }
             })
            if (vm.mappedAssetsList.length > 0) {
                assetsPlanningMap.setCenter(
                    new google.maps.LatLng(
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude
                    )
                );
            }
        }

        function geoLocation(map) { 
            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(
                goTo
            ); 
            goTo.addEventListener("click", function () {
                vm.getLocationCoordinates = null
                gotoLatitute()
             }) 
        }

        
        function showZoomLocation() {
            var latlng = vm.getLocationCoordinates.split(","),gotoMarker = null;;
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinates != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };

                assetsPlanningMap.setCenter(assetCenterLatLng);
                assetsPlanningMap.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: assetsPlanningMap,
                        position: assetCenterLatLng,
                    });

                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }
        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
        }
        
        function closeGotoLatitute(id) {
            $("#"+id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#"+id).hide();
        }

        function getPointsRoute(assetA, assetB, map, dist) {
            var pointA = new google.maps.LatLng(
                assetA.assetCoordinates[0].latitude,
                assetA.assetCoordinates[0].longitude
            );
            var pointB = new google.maps.LatLng(
                assetB.assetCoordinates[0].latitude,
                assetB.assetCoordinates[0].longitude
            );

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: pointA,
                    destination: pointB,
                    travelMode: google.maps.TravelMode.DRIVING,
                },
                function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var route = response.routes[0];
                        var az = 0;
                        for (var i = 0; i < route.legs.length; ++i) {
                            if (route.legs[i].distance) {
                                az += route.legs[i].distance.value;
                            }
                        }
                        dist = Math.max(dist, Math.round(az / 100));
                        var markerPoints = gMilestone(route, dist);
                        var polylinePathPoints = gMilestone(route, 100);
                        var responsePaths = response.routes;
                        vm.spreadArray = [];
                        var overViewPath = route.overview_path;
                        polylinePathPoints.forEach(function (value) {
                            var coordinates = {};
                            coordinates.latitude = value.lat();
                            coordinates.longitude = value.lng();
                            vm.spreadArray.push(coordinates);
                        });
                        var newLinkAsset = {};
                        newLinkAsset.name = assetA.name + "-" + assetB.name;
                        newLinkAsset.description = newLinkAsset.name;
                        newLinkAsset.assetCoordinates = vm.spreadArray;
                        newLinkAsset.assetType = vm.linkAssetType.assetType;
                        var fiberDistance = 0.0;
                        var spreadCoordinates = newLinkAsset.assetCoordinates;
                        if (spreadCoordinates.length > 0) {
                            for (var index in spreadCoordinates) {
                                if (index > 0) {
                                    fiberDistance += distanceCal(
                                        spreadCoordinates[index].latitude,
                                        spreadCoordinates[index].longitude,
                                        spreadCoordinates[index - 1].latitude,
                                        spreadCoordinates[index - 1].longitude
                                    );
                                }
                            }
                        }
                        fiberDistance = fiberDistance.toFixed(2);
                        var spreadAV =
                            vm.linkAssetType.assetTypeAttributeValues;
                        for (
                            var spreadAssetIndex = 0;
                            spreadAssetIndex < spreadAV.length;
                            spreadAssetIndex++
                        ) {
                            if (
                                spreadAV[spreadAssetIndex].assetTypeAttribute
                                    .name === "Fiber Distance (km)"
                            ) {
                                spreadAV[
                                    spreadAssetIndex
                                ].attributeValue = fiberDistance;
                            }
                        }
                        newLinkAsset.assetTypeAttributeValues = spreadAV;
                        newLinkAsset.isChecked = true;
                        vm.tempLinkWithPits.push(newLinkAsset);
                        //drawPolylineForSelectedPath(assetA.name + "-"+ assetB.name, vm.fixedArray, map, 0);
                        markerPoints.forEach(function (point, index) {
                            var newManholeAsset = {};
                            newManholeAsset.name =
                                assetA.name +
                                "-" +
                                assetB.name +
                                " Pit" +
                                (index + 1);
                            newManholeAsset.description = newManholeAsset.name;
                            newManholeAsset.assetType =
                                vm.manholeAssetType.assetType;
                            newManholeAsset.assetTypeAttributeValues =
                                vm.manholeAssetType.assetTypeAttributeValues;
                            vm.fixedArray = [];
                            var coordinates = {};
                            coordinates.latitude = point.lat();
                            coordinates.longitude = point.lng();
                            vm.fixedArray.push(coordinates);
                            newManholeAsset.assetCoordinates = vm.fixedArray;
                            newManholeAsset.isChecked = true;
                            vm.tempLinkWithPits.push(newManholeAsset);
                        });
                        //					map.clear();
                        for (var i = 0; i < vm.tempLinkWithPits.length; i++) {
                            if (
                                vm.tempLinkWithPits[i].assetType.layout ==
                                "FIXED"
                            ) {
                                createMarkerForSelectedAsset(
                                    vm.tempLinkWithPits[i],
                                    map
                                );
                            } else if (
                                vm.tempLinkWithPits[i].assetType.layout ==
                                "SPREAD"
                            ) {
                                var assetCoordinateValues =
                                    vm.tempLinkWithPits[i].assetCoordinates;
                                drawPolylineForGeneratedLoc(
                                    vm.tempLinkWithPits[i],
                                    assetCoordinateValues,
                                    map,
                                    "yellow"
                                );
                            }
                        }
                    } else {
                        window.alert(
                            "Directions request failed due to " + status
                        );
                    }
                }
            );
        }

        function saveLinkPits() {
            vm.tempLinkWithPits.forEach(function (asset) {
                vm.mappedAssetsList.push(asset);
            });
            hideConnectMultipleAssetsModal();
        }
        function gMilestone(route, dist) {
            var path = route.overview_path;
            var geo = google.maps.geometry.spherical;
            var point = path[0];
            var distance = 0;
            var overflow = null;
            var pos = null;
            var leg = null;
            var pointsPosition = [];
            var d1 = 0;

            for (var p = 1; p < path.length; ++p) {
                leg = Math.round(geo.computeDistanceBetween(point, path[p]));
                d1 = distance + 0;
                distance += leg;
                overflow = dist - (d1 % dist);

                if (distance >= dist && leg >= overflow) {
                    if (overflow && leg >= overflow) {
                        pos = geo.computeOffset(
                            point,
                            overflow,
                            geo.computeHeading(point, path[p])
                        );
                        pointsPosition.push(pos);
                        distance -= dist;
                    }

                    while (distance >= dist) {
                        pos = geo.computeOffset(
                            point,
                            dist + overflow,
                            geo.computeHeading(point, path[p])
                        );
                        pointsPosition.push(pos);
                        distance -= dist;
                    }
                }
                point = path[p];
            }
            return pointsPosition;
        }

        function createMarkerForSelectedAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = {
                    lat: parseFloat(asset.assetCoordinates[0].latitude),
                    lng: parseFloat(asset.assetCoordinates[0].longitude),
                };
                if (asset.assetType.name == "Manhole") {
                    var iconSize = 4;
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: {
                            scaledSize: new google.maps.Size(
                                iconSize,
                                iconSize
                            ),
                            url: "content/images/green_circle.png",
                            anchor: new google.maps.Point(
                                iconSize / 2,
                                iconSize / 2
                            ),
                        },
                    });
                } else {
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: {
                            url: "content/images/yellow.png",
                        },
                        label: {
                            color: "black",
                            fontWeight: "medium",
                            fontSize: "12px",
                            text: asset.name,
                            backgroundcolor: "#ff9800",
                        },
                    });
                }
            }
        }

        function createMarkerForSiteAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = {
                    lat: parseFloat(asset.assetCoordinates[0].latitude),
                    lng: parseFloat(asset.assetCoordinates[0].longitude),
                };
                if (asset.assetType.name == "Manhole") {
                    var iconSize = 4;
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: {
                            scaledSize: new google.maps.Size(
                                iconSize,
                                iconSize
                            ),
                            url: "content/images/green_circle.png",
                            anchor: new google.maps.Point(
                                iconSize / 2,
                                iconSize / 2
                            ),
                        },
                    });
                } else {
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon:
                            "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png",
                        label: {
                            color: "black",
                            fontWeight: "medium",
                            fontSize: "12px",
                            text: asset.name,
                            backgroundcolor: "#ff9800",
                        },
                    });
                }
            }
        }

        function drawPolylineForGeneratedLoc(asset, latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];

            latlngsToDraw.forEach(function (value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var ColorValue = "#ff0000";
                if (color == "red") {
                    ColorValue = "#ff0000";
                } else if (color == "black") {
                    ColorValue = "#000000";
                } else if (color == "yellow") {
                    ColorValue = "#F4A500";
                } else {
                    ColorValue = "#208000";
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue,
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(
                    polylinepath,
                    "mouseover",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var infoStr = "";
                        var otdr = "";
                        var infoWindowContent = "";
                        var assetTypeAttributeValuesList =
                            asset.assetTypeAttributeValues;
                        assetTypeAttributeValuesList.forEach(function (
                            attrValues
                        ) {
                            if (attrValues.attributeValue != undefined) {
                                vm.fiberLength = attrValues.attributeValue;
                            }
                            var home = attrValues;
                            var value = null;
                            if (home.attributeValue != undefined) {
                                value = home.attributeValue;
                            } else {
                                value = home.assetTypeAttribute.defaultValue;
                            }
                            infoStr +=
                                "<br><b>" +
                                home.assetTypeAttribute.name +
                                "</b> : " +
                                value;
                            otdr = home;

                            infoWindowContent =
                                '<div class="info_content">' +
                                "<b>" +
                                "Name" +
                                "</b> : " +
                                asset.name +
                                "<br><b>" +
                                "<hr></div><div>" +
                                infoStr +
                                "</div>";
                        });

                        var infoWindow2 = new google.maps.InfoWindow({
                            content: infoWindowContent,
                        });
                        infoWindow2.open(map);
                        infoWindow2.setPosition(event.latLng);
                        openedInfoWindow = infoWindow2;
                    }
                );
            }
        }

        function drawingManagerSpread() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYLINE,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["polyline"],
                },
                polylineOptions: {
                    fillColor: "#ffff00",
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: true,

                    editable: true,
                    zIndex: 1,
                    geodesic: true,
                },
            });
        }

        function drawingManagerFixed() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["marker"],
                },
            });
        }

        function drawingManagerValue(option, map, isEdit) {
            if (option == "polylinecomplete") {
                vm.isShowing = false;
                google.maps.event.addListener(
                    vm.drawingManager,
                    option,
                    function (event) {
                        google.maps.event.addListener(
                            event.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(event, isEdit);
                            }
                        );
                        google.maps.event.addListener(
                            event.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(event, isEdit);
                            }
                        );
                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                        setGoefenceCoordinate(event, isEdit);
                        if (mappedAssetTemp.assetType.layout == "SPREAD") {
                            var fiberDistance = 0.0;
                            var spreadCoordinates =
                                mappedAssetTemp.assetCoordinates;
                            if (spreadCoordinates.length > 0) {
                                for (var index in spreadCoordinates) {
                                    if (index > 0) {
                                        fiberDistance += distanceCal(
                                            spreadCoordinates[index].latitude,
                                            spreadCoordinates[index].longitude,
                                            spreadCoordinates[index - 1]
                                                .latitude,
                                            spreadCoordinates[index - 1]
                                                .longitude
                                        );
                                    }
                                }
                            }
                            fiberDistance = fiberDistance.toFixed(2);
                            var spreadAV =
                                mappedAssetTemp.assetTypeAttributeValues;
                            for (
                                var spreadAssetIndex = 0;
                                spreadAssetIndex < spreadAV.length;
                                spreadAssetIndex++
                            ) {
                                if (
                                    spreadAV[spreadAssetIndex]
                                        .assetTypeAttribute.name ===
                                    "Fiber Distance (km)"
                                ) {
                                    spreadAV[
                                        spreadAssetIndex
                                    ].attributeValue = fiberDistance;
                                }
                            }
                            mappedAssetTemp.assetTypeAttributeValues = spreadAV;
                        }
                        addMappedAssets(mappedAssetTemp);
                    }
                );
                vm.drawingManager.setMap(map);
            } else if (option == "click") {
                vm.isShowing = false;
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                });

                google.maps.event.addListener(map, "click", function (e) {
                    placeMarker(e.latLng, map);
                    vm.fixedArray = [];
                    var coordinates = {};
                    coordinates.latitude = e.latLng.lat();
                    coordinates.longitude = e.latLng.lng();
                    vm.fixedArray.push(coordinates);
                    mappedAssetTemp.assetCoordinates = vm.fixedArray;
                    addMappedAssets(mappedAssetTemp);
                });
            }
        }

        function placeMarker(location, map) {
            if (marker) {
                if (location.lat != null && location.lng != null) {
                    marker.setPosition(location);
                }
            } else {
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                });
            }
        }

        function addMappedAssets(newAsset) {
            if (!isAssetAvailable(newAsset.name)) {
                newAsset.isChecked = true;
                vm.mappedAssetsList.push(newAsset);
            }
            // initPlanningMap();
            // for (var i = 0; i < vm.mappedAssetsList.length; i++) {
            //     if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
            //         createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
            //     } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
            //         var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
            //         drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
            //     }
            // }
        }

        function isAssetAvailable(assetName) {
            var isAssetAvailable = false;

            vm.mappedAssetsList.forEach(function (assetVal) {
                if (assetVal.name === assetName) {
                    isAssetAvailable = true;
                }
            });
            return isAssetAvailable;
        }

        function selectedWorkFlowTypeAttributes() {
            if (vm.workFlowType) {
                vm.workFlow.workFlowType = vm.workFlowType;
                if (
                    entity_old.workFlowType &&
                    vm.workFlowType.id === entity_old.workFlowType.id
                ) {
                    vm.workFlow.workFlowTypeAttributeValues = [];
                    vm.workFlow.workFlowTypeAttributeValues =
                        entity_old.workFlowTypeAttributeValues;
                } else {
                    vm.workFlow.workFlowTypeAttributeValues = [];
                    $.each(
                        vm.workFlowType.workFlowTypeAttribute,
                        function (key, value) {
                            vm.workFlow.workFlowTypeAttributeValues.push({
                                workFlowTypeAttribute:
                                    vm.workFlowType.workFlowTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function deleteAssetModal(name) {
            $("#delete-asset").show();
            deleteAssetName = name;
        }

        function confirmDeleteAsset() {
            var assetArray = vm.mappedAssetsList;
            for (var i = assetArray.length - 1; i >= 0; --i) {
                if (assetArray[i].name == deleteAssetName) {
                    vm.deletedAssetsList.push(assetArray[i]);
                    assetArray.splice(i, 1);
                }
            }
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(
                        vm.mappedAssetsList[i],
                        assetsPlanningMap
                    );
                } else if (
                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                ) {
                    var assetCoordinateValues =
                        vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        assetsPlanningMap,
                        "yellow"
                    );
                }
            }
            vm.mappedAssetsList = [];
            assetArray.forEach(function (asset) {
                vm.mappedAssetsList.push(asset);
            });
            $("#delete-asset").hide();
        }

        function cleardeleteAsset() {
            $("#delete-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#delete-asset").hide();
        }

        function setGoefenceCoordinate(event, isEdit) {
            vm.assetCoordinateValues = [];
            var tempAsset = {};
            tempAsset.assetCoordinates = [];
            var radius = event.getPath();
            for (var i = 0; i < radius.getLength(); i++) {
                var coordinates = {};
                coordinates.latitude = radius.getAt(i).lat();
                coordinates.longitude = radius.getAt(i).lng();
                tempAsset.assetCoordinates.push(coordinates);
            }
            if (isEdit) {
                vm.asset.assetCoordinates = tempAsset.assetCoordinates;
            } else {
                mappedAssetTemp.assetCoordinates = tempAsset.assetCoordinates;
            }
        }

        function saveEditAsset() {
            //vm.tempAssetArray.push(vm.asset);
            vm.mappedAssetsList = [];
            vm.tempAssetArray.forEach(function (assetVal) {
                vm.mappedAssetsList.push(assetVal);
            });
            vm.asset = [];
            vm.tempAssetArray = [];
            hideUserEditModal();
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(
                        vm.mappedAssetsList[i],
                        assetsPlanningMap
                    );
                } else if (
                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                ) {
                    var assetCoordinateValues =
                        vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        assetsPlanningMap,
                        "yellow"
                    );
                }
            }
        }

        function hideUserEditModal() {
            $("#userPathModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#userPathModal").hide();
        }

        function editAsset(asset) {
            vm.tempAssetArray = [];

            vm.mappedAssetsList.forEach(function (assetVal) {
                vm.tempAssetArray.push(assetVal);
            });
            for (var i = 0; i >= vm.tempAssetArray.length; --i) {
                if (vm.tempAssetArray[i].name == asset.name) {
                    vm.tempAssetArray.splice(i, 1);
                }
            }

            vm.asset = asset;
            var maplatlng = {
                lat: parseFloat(asset.assetCoordinates[0].latitude),
                lng: parseFloat(asset.assetCoordinates[0].longitude),
            };
            editAssetMap = new google.maps.Map(
                document.getElementById("map_canvas_edit_asset"),
                myOption(13, maplatlng)
                /* {
                    center: maplatlng,
                    zoom: 13,
                    fullscreenControl: true,
                } */
            );

            if (asset.assetType.layout == "SPREAD") {
                drawingManagerSpread();
                drawingManagerValue("polylinecomplete", editAssetMap);
            } else if (asset.assetType.layout == "FIXED") {
                drawingManagerFixed();
                drawingManagerValue("click", editAssetMap);
            }
            if (asset.name && asset.name != null) {
                if (asset.assetType.layout == "SPREAD") {
                    drawPolyline(function (polyline) {
                        polyline.setMap(editAssetMap);
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(polyline, true);
                            }
                        );
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(polyline, true);
                            }
                        );

                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                    });
                } else if (asset.assetType.layout == "FIXED") {
                    setValues();
                    drawingManagerFixed();
                    drawMarker(editAssetMap, vm.coOrdinate);
                }

                function drawPolyline(callback) {
                    setValues();
                    var centerlatlng = {};
                    if (vm.coOrdinates.length > 1) {
                        vm.coOrdinates.forEach(function (value) {
                            centerlatlng = {
                                lat: value.lat,
                                lng: value.lng,
                            };
                        });

                        callback(
                            new google.maps.Polyline({
                                path: vm.coOrdinates,
                                geodesic: true,
                                strokeColor: vm.asset.assetType.colorcode,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: vm.asset.assetType.colorcode,
                                fillOpacity: 0.3,
                                editable: true,
                            })
                        );
                        editAssetMap.setCenter(centerlatlng);
                    }
                }
            }
            var ele = document.getElementById("userPathModal");
            $(ele).modal("show");
            $("#userPathModal").show();

            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_edit_asset").css("width", "100%");
        }

        function hideConnectAssetsModal() {
            $("#connectAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectAssetsModal").hide();
        }

        function hideConnectSitesModal() {
            $("#connectAssetsModal").hide();
        }

        var input = document.getElementById('field_pinLat');
            input.addEventListener('input', function() {
            this.value = this.value.replace(/[^-0-9\,\.]/, '');
            });
        
        $('#spreadType').select2({
            dropdownParent: $('#connectAssetsModal')
          });

        function connectSelectedAssets() {
            var ele = document.getElementById("connectAssetsModal");
            $(ele).modal("show");
            $("#connectAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_assets").css("width", "100%");
        }

        function hideConnectMultipleAssetsModal() {
            $("#connectMultipleAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectMultipleAssetsModal").hide();
            vm.tempLinkWithPits = [];
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(
                        vm.mappedAssetsList[i],
                        assetsPlanningMap
                    );
                } else if (
                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                ) {
                    var assetCoordinateValues =
                        vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        assetsPlanningMap,
                        "yellow"
                    );
                }
            }
        }

        function connectMultipleAssets() {
            vm.siteAssets = [];
            vm.tempLinkWithPits = [];

            var ele = document.getElementById("connectMultipleAssetsModal");
            $(ele).modal("show");
            $("#connectMultipleAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_multiple_assets").css("width", "100%");
            var multipleSiteMap = new google.maps.Map(
                document.getElementById("map_canvas_connect_multiple_assets"),
                {
                    center: new google.maps.LatLng(
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude
                    ),
                    zoom: 12,
                    fullscreenControl: true,
                }
            );
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (
                    vm.mappedAssetsList[i].assetType.layout == "FIXED" &&
                    vm.mappedAssetsList[i].assetType.name == "Site" &&
                    vm.mappedAssetsList[i].id == null
                ) {
                    vm.siteAssets.push(vm.mappedAssetsList[i]);
                    createMarkerForSiteAsset(
                        vm.mappedAssetsList[i],
                        multipleSiteMap
                    );
                }
            }

            vm.siteAssets.sort(function (assetA, assetB) {
                var assetATime = assetA.createDate,
                    assetBTime = assetB.createDate;
                if (assetATime < assetBTime)
                    // sort string ascending
                    return -1;
                if (assetATime > assetBTime) return 1;
                return 0; // default return value (no sorting)
            });
            for (
                var siteIndex = 1;
                siteIndex < vm.siteAssets.length;
                siteIndex++
            ) {
                getPointsRoute(
                    vm.siteAssets[siteIndex - 1],
                    vm.siteAssets[siteIndex],
                    multipleSiteMap,
                    200
                );
            }
        }

        function recalculate() {
            var totalCost = 0;
            var totalPowerBudget = 0;
            var totalFiberDistance = 0.0;
            for (
                var assetIndex = 0;
                assetIndex < vm.mappedAssetsList.length;
                assetIndex++
            ) {
                var isSpread = false;
                var fiberDistance = 0.0;

                if (
                    vm.mappedAssetsList[assetIndex].assetType.layout == "SPREAD"
                ) {
                    isSpread = true;
                    var spreadAV =
                        vm.mappedAssetsList[assetIndex]
                            .assetTypeAttributeValues;
                    for (
                        var spreadAssetIndex = 0;
                        spreadAssetIndex < spreadAV.length;
                        spreadAssetIndex++
                    ) {
                        if (
                            spreadAV[spreadAssetIndex].assetTypeAttribute
                                .name === "Fiber Distance (km)"
                        ) {
                            fiberDistance = parseFloat(
                                "0" + spreadAV[spreadAssetIndex].attributeValue
                            );
                        }
                    }
                }

                for (
                    var attrIndex = 0;
                    attrIndex <
                    vm.mappedAssetsList[assetIndex].assetTypeAttributeValues
                        .length;
                    attrIndex++
                ) {
                    var item =
                        vm.mappedAssetsList[assetIndex]
                            .assetTypeAttributeValues[attrIndex];
                    var value = parseFloat(
                        item.assetTypeAttribute.defaultValue
                    );

                    if (item.assetTypeAttribute.name == "Cost") {
                        var tempCost = parseFloat(value);
                        if (isSpread) {
                            tempCost = parseFloat(value) * fiberDistance;
                        }
                        if (tempCost > 0) {
                            totalCost += tempCost;
                        }
                        item.attributeValue = value;
                    }
                    if (item.assetTypeAttribute.name == "Power Budget") {
                        var tempPowerBudget = parseFloat(value);
                        if (isSpread) {
                            tempPowerBudget = parseFloat(value) * fiberDistance;
                        }
                        if (tempPowerBudget > 0) {
                            totalPowerBudget += tempPowerBudget;
                        }
                        item.attributeValue = value;
                    }
                    vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[
                        attrIndex
                    ] = item;
                }
                totalFiberDistance += fiberDistance;
            }

            var workFlowAV = vm.workFlow.workFlowTypeAttributeValues;
            for (
                var workFlowIndex = 0;
                workFlowIndex < workFlowAV.length;
                workFlowIndex++
            ) {
                if (
                    workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                    "Cost"
                ) {
                    workFlowAV[
                        workFlowIndex
                    ].attributeValue = totalCost.toFixed(2);
                }
                if (
                    workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                    "Power Budget"
                ) {
                    workFlowAV[
                        workFlowIndex
                    ].attributeValue = totalPowerBudget.toFixed(2);
                }
                if (
                    workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                    "Fiber Distance"
                ) {
                    workFlowAV[
                        workFlowIndex
                    ].attributeValue = totalFiberDistance.toFixed(2);
                }
            }
            vm.workFlow.workFlowTypeAttributeValues = workFlowAV;
        }

        function connectAssets() {
            if (vm.isSiteASelected == false && vm.isSiteBSelected == false) {
                alert("Please Select Site A");
            } else if (
                vm.isSiteASelected == true &&
                vm.isSiteBSelected == false
            ) {
                alert("Please Select Site B");
            } else {
                var siteALatLng = new google.maps.LatLng(
                    vm.selectedSiteA.assetCoordinates[0].latitude,
                    vm.selectedSiteA.assetCoordinates[0].longitude
                );
                var siteBLatLng = new google.maps.LatLng(
                    vm.selectedSiteB.assetCoordinates[0].latitude,
                    vm.selectedSiteB.assetCoordinates[0].longitude
                );
                var map = new google.maps.Map(
                    document.getElementById("map_canvas_connect_assets"),
                    myOption(16, siteALatLng)
                    /* {
                        center: siteALatLng,
                        zoom: 16,
                        fullscreenControl: true,
                    } */
                );
                createMarker(map, vm.selectedSiteA.name, siteALatLng);
                createMarker(map, vm.selectedSiteB.name, siteBLatLng);

                getShortestRoute(vm.selectedSiteA, vm.selectedSiteB, map);
            }
        }

        function setValues() {
            vm.coOrdinates = [];
            for (var i = 0; i < vm.asset.assetCoordinates.length; i++) {
                vm.coOrdinates.push({
                    lat: vm.asset.assetCoordinates[i].latitude,
                    lng: vm.asset.assetCoordinates[i].longitude,
                });
                if (i == vm.asset.assetCoordinates.length - 1) {
                    vm.coOrdinate = JSON.stringify(vm.coOrdinates);
                }
            }
        }

        $("#fromAssetsView").change(function () {
            $("#toAssetsView")[0].selectedIndex = 0;
            var result = $("#fromAssetsView").val();
            if (result != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].name == result) {
                        vm.selectedSiteA = vm.mappedAssetsList[i];
                    }
                }
                vm.isSiteASelected = true;
            }
        });

        $("#toAssetsView").change(function () {
            if (vm.isSiteASelected == true) {
                var result = $("#toAssetsView").val();
                if (result != null) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].name == result) {
                            vm.selectedSiteB = vm.mappedAssetsList[i];
                        }
                    }
                    vm.isSiteBSelected = true;
                }
            } else {
                $("#toAssetsView")[0].selectedIndex = 0;
                alert("Please Select Site A");
            }
        });

        function createMarker(map, assetName, myLatLng) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    scaledSize: new google.maps.Size(24, 24),
                    origin: new google.maps.Point(0, 0),
                    url: "content/images/yellow.png",
                    anchor: new google.maps.Point(16, 16),
                },
                label: {
                    color: "black",
                    fontWeight: "medium",
                    fontSize: "12px",
                    text: assetName,
                    backgroundcolor: "#ff9800",
                },
            });
        }

        function drawMarker(map, response) {
            $.each(JSON.parse(response), function (index, value) {
                centerlatlng = {
                    lat: value.lat,
                    lng: value.lng,
                };

                if (marker) {
                    marker.setMap(null);
                }
                marker = new google.maps.Marker({
                    position: centerlatlng,
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(16, 16),
                    },
                });

                marker.setMap(map);
                vm.fixedArray = [];
                var coordinates = {};
                coordinates.latitude = centerlatlng.lat;
                coordinates.longitude = centerlatlng.lng;
                vm.fixedArray.push(coordinates);
                mappedAssetTemp.assetCoordinates = vm.fixedArray;
                //addMappedAssets(mappedAssetTemp);
            });
        }

        function getShortestRoute(SiteA, SiteB, map) {
            var pointA = new google.maps.LatLng(
                SiteA.assetCoordinates[0].latitude,
                SiteA.assetCoordinates[0].longitude
            );
            var pointB = new google.maps.LatLng(
                SiteB.assetCoordinates[0].latitude,
                SiteB.assetCoordinates[0].longitude
            );

            var newAsset = {
                name: "",
                assetCoordinates: [],
            };
            newAsset.name = SiteA.name + "-" + SiteB.name;

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: pointA,
                    destination: pointB,
                    avoidTolls: true,
                    avoidHighways: false,
                    provideRouteAlternatives: true,
                    travelMode: google.maps.TravelMode.DRIVING,
                },
                function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = response.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                vm.fixedArray = [];
                                var route = pathVal;
                                var legs = route.legs;
                                
                                var polylinePathPoints = [];
                                for (var i = 0; i < legs.length; i++) {
                                    var steps = legs[i].steps;
                                    for (var j = 0; j < steps.length; j++) {
                                        var nextSegment = steps[j].path;
                                        for (
                                            var k = 0;
                                            k < nextSegment.length;
                                            k++
                                        ) {
                                            polylinePathPoints.push(
                                                nextSegment[k]
                                            );
                                        }
                                    }
                                }
                                // var az = 0;
                                // for (var i = 0; i < route.legs.length; ++i) {
                                //     if (route.legs[i].distance) {
                                //         az += route.legs[i].distance.value;
                                //     }
                                // }
                                // var polylinePathPoints = gMilestone(route, 100);
                                //                            var overViewPath = pathVal.overview_path;
                                polylinePathPoints.forEach(function (value) {
                                    var coordinates = {};
                                    coordinates.lat = value.lat();
                                    coordinates.lng = value.lng();
                                    vm.fixedArray.push(coordinates);
                                });
                                drawPolylineForSelectedPath(
                                    SiteA.name + "-" + SiteB.name,
                                    vm.fixedArray,
                                    map,
                                    index
                                );
                            }
                        });
                    } else {
                        window.alert(
                            "Directions request failed due to " + status
                        );
                    }
                }
            );
            return newAsset;
        }

        function drawPolylineForSelectedPath(
            assetName,
            spreadAssetCoordinates,
            map,
            index
        ) {
            if (spreadAssetCoordinates.length > 0) {
                map.setZoom(14);

                var ColorValue = "#ff0000";
                if (index == 0) {
                    ColorValue = "#ff0000";
                } else if (index == 1) {
                    ColorValue = "#000000";
                } else {
                    ColorValue = "#208000";
                }

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue,
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(
                    polylinepath,
                    "mouseover",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var pointContent = document.createElement("div"),
                            button;

                        pointContent.innerHTML =
                            '<div class="infoWindowhead">Point ' +
                            (index + 1) +
                            "</div>";
                        button = pointContent.appendChild(
                            document.createElement("input")
                        );
                        button.type = "button";
                        button.value = "Click to select";
                        button.className = "button";
                        google.maps.event.addDomListener(
                            button,
                            "click",
                            function () {
                                var newAsset = {};
                                newAsset.name = assetName;
                                newAsset.assetCoordinates = [];
                                spreadAssetCoordinates.forEach(function (
                                    assetCoor
                                ) {
                                    newAsset.assetCoordinates.push({
                                        latitude: assetCoor.lat,
                                        longitude: assetCoor.lng,
                                    });
                                });

                                    vm.assetTypeResponse.forEach(function (item) {
                                            if(item.name == vm.selectedAssetType){
                                                vm.isShowing = false;
                                            newAsset.assetType = item;
                                            newAsset.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                                newAsset.assetType
                                            );
                                            //	                                $.each(newAsset.assetType.assetTypeAttributes,function(key, value) {
                                            //	                                    newAsset.assetTypeAttributeValues.push({
                                            //	                                            assetTypeAttribute: newAsset.assetType.assetTypeAttributes[key]
                                            //	                                        });
                                            //	                                });
                                            if (
                                                newAsset.assetType.layout ==
                                                "SPREAD"
                                            ) {
                                                var fiberDistance = 0.0;
                                                var spreadCoordinates =
                                                    newAsset.assetCoordinates;
                                                if (
                                                    spreadCoordinates.length > 0
                                                ) {
                                                    for (var index in spreadCoordinates) {
                                                        if (index > 0) {
                                                            fiberDistance += distanceCal(
                                                                spreadCoordinates[
                                                                    index
                                                                ].latitude,
                                                                spreadCoordinates[
                                                                    index
                                                                ].longitude,
                                                                spreadCoordinates[
                                                                    index - 1
                                                                ].latitude,
                                                                spreadCoordinates[
                                                                    index - 1
                                                                ].longitude
                                                            );
                                                        }
                                                    }
                                                }
                                                fiberDistance = fiberDistance.toFixed(
                                                    2
                                                );
                                                var spreadAV =
                                                    newAsset.assetTypeAttributeValues;
                                                for (
                                                    var spreadAssetIndex = 0;
                                                    spreadAssetIndex <
                                                    spreadAV.length;
                                                    spreadAssetIndex++
                                                ) {
                                                    if (
                                                        spreadAV[
                                                            spreadAssetIndex
                                                        ].assetTypeAttribute
                                                            .name ===
                                                        "Fiber Distance (km)"
                                                    ) {
                                                        spreadAV[
                                                            spreadAssetIndex
                                                        ].attributeValue = fiberDistance;
                                                    }
                                                }
                                                newAsset.assetTypeAttributeValues = spreadAV;
                                            }
                                            newAsset.isChecked = true;
                                            vm.mappedAssetsList.push(newAsset);
                                            initPlanningMap();
                                            for (
                                                var i = 0;
                                                i < vm.mappedAssetsList.length;
                                                i++
                                            ) {
                                                if (
                                                    vm.mappedAssetsList[i]
                                                        .assetType.layout ==
                                                    "FIXED"
                                                ) {
                                                    createMarkerForSelectedAsset(
                                                        vm.mappedAssetsList[i],
                                                        assetsPlanningMap
                                                    );
                                                } else if (
                                                    vm.mappedAssetsList[i]
                                                        .assetType.layout ==
                                                    "SPREAD"
                                                ) {
                                                    var assetCoordinateValues =
                                                        vm.mappedAssetsList[i]
                                                            .assetCoordinates;
                                                    drawPolylineForGeneratedLoc(
                                                        vm.mappedAssetsList[i],
                                                        assetCoordinateValues,
                                                        assetsPlanningMap,
                                                        "yellow"
                                                    );
                                                }
                                            }
                                        
                                            }
                                    });
                                
                                hideConnectAssetsModal();
                            }
                        );

                        var infoWindow2 = new google.maps.InfoWindow({
                            content: pointContent,
                        });
                        infoWindow2.open(map);
                        infoWindow2.setPosition(event.latLng);
                        openedInfoWindow = infoWindow2;
                    }
                );
            }
        }

        function save() {
            vm.isShowing = false;
            vm.workFlow.workFlowAssets = [];
            vm.workFlow.deletedAssets = [];

            vm.mappedAssetsList.forEach(function (workFlowAssetVal) {
                // workFlowAssetVal.phase = vm.workFlow.phase
                if (workFlowAssetVal.isChecked) {
                    vm.workFlow.workFlowAssets.push(workFlowAssetVal);
                }
            });

            vm.deletedAssetsList.forEach(function (asset) {
                vm.workFlow.deletedAssets.push(asset);
            });

            if (vm.workFlow.workFlowAssets.length > 0) {
                vm.isShowing = true;
                vm.isSaving = true;
                var assignedToUser = $("#field_assignedToUser").val();
                vm.workFlow.assignedTo = usersMap[assignedToUser];
                angular.forEach(vm.assetList, function (value, key) {
                    if (vm.workFlow.asset.name === value.name) {
                        vm.workFlow.asset = value;
                    }
                });

                if (vm.workFlow.id !== null) {
                    WorkFlow.update(vm.workFlow, onSaveSuccess, onSaveError);
                } else {
                    WorkFlow.save(vm.workFlow, onSaveSuccess, onSaveError);
                }
            } else {
                alert("No assets are mapped to this work flow");
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:workFlowUpdate", result);
            $state.go("work-flow");
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function selectedGroup(value) {
            var input = document.getElementById("field_assignedToUser");
            input.value = "";
            vm.hideUser = false;
        }
        function filterActivatedUser() {
            if (
                vm.workFlow.assignedToUser != null &&
                vm.workFlow.assignedToUser != "" &&
                vm.workFlow.assignedToUser != "." &&
                !angular.isUndefined(vm.workFlow.assignedToUser)
            ) {
                $('input[name="assignedToUser"]').keyup(function () {
                    vm.user = $(this).val();
                });
                ActivatedUserSearch.query(
                    {
                        // userId: vm.workFlow.assignedToUser,
                        userId: vm.workFlow.groups[0].id,
                        user: vm.user,
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    data.forEach(function (users) {
                        vm.assignedUsers.push(users.login);
                    });
                    vm.activatedusers = data;

                    angular.forEach(vm.activatedusers, function (value, key) {
                        usersMap[value.login] = value.id;
                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                    Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                    Math.cos(degrees_to_radians(lat2)) *
                    Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
        $(document).on("change", "input", function () {
            var options = $("datalist")[0].options;
            for (var i = 0; i < options.length; i++) {
                if (options[i].value == $(this).val()) {
                    if (vm.assignedUsers.includes($(this).val())) {
                        vm.validUser = false;
                    } else {
                        vm.validUser = true;
                    }
                    break;
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowDetailController", WorkFlowDetailController);

    WorkFlowDetailController.$inject = [
        "$scope",
        "$rootScope",
        "previousState",
        "entity",
        "$window",
        "Configs"
    ];

    function WorkFlowDetailController(
        $scope,
        $rootScope,
        previousState,
        entity,
        $window,
        Configs
    ) {
        var vm = this;

        vm.workFlow = entity;
        vm.previousState = previousState.name;
        Configs.get("WorkFlowStatus", function (response) {
            response.forEach(function (status) {
                if (status.configKey == vm.workFlow.status) {
                    vm.workFlow.status = status.configValue;
                }
            });
        });
        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workFlowUpdate",
            function (event, result) {
                vm.workFlow = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowDeleteController", WorkFlowDeleteController);

    WorkFlowDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "WorkFlow",
    ];

    function WorkFlowDeleteController($uibModalInstance, entity, WorkFlow) {
        var vm = this;

        vm.workFlow = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            WorkFlow.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("work-flow", {
                parent: "entity",
                url: "/work-flow?page&sort&search",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workFlow.home.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/work-flow/work-flows.html",
                        controller: "WorkFlowController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlow");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("work-flow-detail", {
                parent: "work-flow",
                url: "/work-flow/{id}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workFlow.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow/work-flow-detail.html",
                        controller: "WorkFlowDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlow");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkFlow",
                        function ($stateParams, WorkFlow) {
                            return WorkFlow.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-flow",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("work-flow.new", {
                url: "/work-flow",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow/work-flow-dialog.html",
                        controller: "WorkFlowDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                description: $stateParams.desc,
                                createDate: null,
                                updateDate: null,
                                pinLat: parseFloat($stateParams.lat),
                                pinLong: parseFloat($stateParams.lng),
                                address: null,
                                escalated: null,
                                status: null,
                                id: null,
                                caseImages: [],
                            };
                        },
                    ],
                },
            })
            .state('work-flow.edit', {
                parent: 'work-flow',
                url: '/Edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: 'trakeyeApp.workFlow.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/work-flow/work-flow-dialog.html',
                        controller: 'WorkFlowDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'WorkFlow', function ($stateParams, WorkFlow) {
                        return WorkFlow.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'work-flow',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state("work-flow.delete", {
                parent: "work-flow",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/work-flow/work-flow-delete-dialog.html",
                                controller: "WorkFlowDeleteController",
                                controllerAs: "vm",
                                size: "md",
                                resolve: {
                                    entity: [
                                        "WorkFlow",
                                        function (WorkFlow) {
                                            return WorkFlow.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("work-flow", null, {
                                        reload: "work-flow",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkFlow", WorkFlow);

    WorkFlow.$inject = ["$resource", "DateUtils"];

    function WorkFlow($resource, DateUtils) {
        var resourceUrl = "api/work-flows/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkFlowCheckAsset", WorkFlowCheckAsset);

    WorkFlowCheckAsset.$inject = ["$resource", "DateUtils"];

    function WorkFlowCheckAsset($resource, DateUtils) {
        var resourceUrl = "api/assets/search/:name";

        return $resource(
            resourceUrl,
            {},
            {
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllWorkFlowTypes", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http.get("api/work-flow-types").then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();


(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrUnresolvedGroupWorkFlowForMap', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAllWorkFlows = function(callback) {
			$http.get('api/unresolvedgroupworkflowsformap').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

// (function() {
// 	'use strict';

// 	angular.module('trakeyeApp').factory('UnresolvedLocGroupWorkFlowForMap', UnresolvedLocGroupWorkFlowForMap);

// 	UnresolvedLocGroupWorkFlowForMap.$inject = [ '$resource' ];

// 	function UnresolvedLocGroupWorkFlowForMap($resource) {
// 		var service = $resource('/api/unresolvedgroupbasednearestworkflowsformap/:lat/:lng/:dis', {},{},{},{}, {
// 			'query' : {
// 				method : 'GET',
// 				isArray : true
// 			},
// 		});

// 		return service;
// 	}

// })();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UnresolvedLocGroupWorkFlowForMap', UnresolvedLocGroupWorkFlowForMap);

	UnresolvedLocGroupWorkFlowForMap.$inject = ['$resource'];

	function UnresolvedLocGroupWorkFlowForMap($resource) {
		var service = $resource('/api/unresolvedgroupbasednearestworkflowsformap/:lat/:lng/:dis', {
			lat: '@lat',
            lng: '@lng',
			dis: '@dis'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('WorkFlowById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/work-flows/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('WorkFlowSearch', WorkFlowSearch);

	WorkFlowSearch.$inject = ['$resource'];

	function WorkFlowSearch($resource) {
		var service = $resource('/api/work-flows/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowController", WorkFlowController);

    WorkFlowController.$inject = [
        "$state",
        "$scope",
        "$stateParams",
        "WorkFlow",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "WorkFlowSearch",
        "Configs"
    ];

    function WorkFlowController(
        $state,
        $scope,
        $stateParams,
        WorkFlow,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        WorkFlowSearch,
        Configs
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterWorkFlowSearch = filterWorkFlowSearch;
        
        loadAll();

        function loadAll() {
            WorkFlow.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                var tempWorkFlows = data;
                vm.workFlows = [];
                vm.page = pagingParams.page;
                Configs.get("WorkFlowStatus", function (response) {
                    tempWorkFlows.forEach(function (val) {
                        response.forEach(function (status) {
                            if (status.configKey == val.status) {
                                val.status = status.configValue;
                            }
                        });
                        val.workFlowTypeAttributeValues.forEach(function (item) {
                            if (item.name == "Fiber Distance")
                                val.distance = item.attributeValue
                        })
                        vm.workFlows.push(val);
                    });
                });

            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function filterWorkFlowSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                
                WorkFlowSearch.query(
                    {
                        search: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );

                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    var tempWorkFlows = data;
                    vm.workFlows = [];
                    vm.page = pagingParams.page;
                    tempWorkFlows.forEach(function (val){
                        val.workFlowTypeAttributeValues.forEach(function (item){
                            if(item.name == "Fiber Distance")
                            val.distance = item.attributeValue
                         })
                         vm.workFlows.push(val);
                    });
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrakeyeTypeDialogController', TrakeyeTypeDialogController);

    TrakeyeTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state', 'entity', 'TrakeyeType', 'User'];

    function TrakeyeTypeDialogController ($timeout, $scope, $stateParams, $state, entity, TrakeyeType, User) {
        var vm = this;

        vm.trakeyeType = entity;  
        $scope.attributetypes = ['INTEGER', 'FLOAT', 'STRING','BOOLEAN'];
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.items=[{name: '',dataType: '',defaultValue :''}];
        
        if(vm.trakeyeType.trakeyeTypeAttribute!=null && vm.trakeyeType.trakeyeTypeAttribute.length!=0){
        	vm.items=vm.trakeyeType.trakeyeTypeAttribute;
        }
        
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
       
        function save () {
            vm.isSaving = true;
        	vm.trakeyeType.trakeyeTypeAttribute=[];
            if (vm.trakeyeType.id !== null) {
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            	    //vm.trakeyeType.trakeyeTypeAttribute.push({"name" :  vm.items[i].name});
            		vm.trakeyeType.trakeyeTypeAttribute.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,  "dataType" :  vm.items[i].dataType,"defaultValue" :  vm.items[i].defaultValue});
            	}
            	TrakeyeType.update(vm.trakeyeType, onSaveSuccess, onSaveError);
            } else {
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            	    //vm.trakeyeType.trakeyeTypeAttribute.push({"name" :  vm.items[i].name});
            		vm.trakeyeType.trakeyeTypeAttribute.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,  "dataType" :  vm.items[i].dataType,"defaultValue" :  vm.items[i].defaultValue});
            	}
            	TrakeyeType.save(vm.trakeyeType, onSaveSuccess, onSaveError);
            }
        }
       

        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:trakeyeTypeUpdate', result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == 'user-management.new') {
                $state.go('user-management.new');
            } else {
                $state.go('trakeye-type');
            }
            // sessionStorage.removeItem('prevPage');
            // $state.go('trakeye-type');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updatedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
       /* vm.addmore = function() {
            var newItemNo = vm.items.length+1;
            vm.items.push({'id':newItemNo});
          };
            
       vm.remove = function() {
            var lastItem = vm.items.length-1;
            vm.items.splice(lastItem);
          };*/
        
        vm.addmore = function() {
            vm.items.push({name: '',dataType:'', defaultValue:''});
          };
            
       vm.remove = function(index) {
            vm.items.splice(index, 1);
          };
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrakeyeTypeDetailController', TrakeyeTypeDetailController);

    TrakeyeTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrakeyeType', 'User'];

    function TrakeyeTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TrakeyeType, User) {
        var vm = this;

        vm.trakeyeType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:trakeyeTypeUpdate', function(event, result) {
            vm.trakeyeType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrakeyeTypeDeleteController',TrakeyeTypeDeleteController);

    TrakeyeTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrakeyeType'];

    function TrakeyeTypeDeleteController($uibModalInstance, entity, TrakeyeType) {
        var vm = this;

        vm.trakeyeType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrakeyeType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trakeye-type', {
            parent: 'entity',
            url: '/trakeye-type',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.trakeyeType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trakeye-type/trakeye-types.html',
                    controller: 'TrakeyeTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'updated_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trakeyeType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trakeye-type-detail', {
            parent: 'entity',
            url: '/trakeye-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.trakeyeType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trakeye-type/trakeye-type-detail.html',
                    controller: 'TrakeyeTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trakeyeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrakeyeType', function($stateParams, TrakeyeType) {
                    return TrakeyeType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trakeye-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
       
        .state('trakeye-type.new', {
            parent: 'trakeye-type',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            views:{
            	'content@':{
            		 templateUrl: 'app/entities/trakeye-type/trakeye-type-dialog.html',
                     controller: 'TrakeyeTypeDialogController',
                     controllerAs: 'vm'
            	}
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        createdDate: null,
                        updatedDate: null,
                        id: null
                    };
                }
            }          
        })
        .state('trakeye-type.edit', {
            parent: 'entity',
            url: '/trakeye-type/Edit/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.trakeyeType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/trakeye-type/trakeye-type-dialog.html',
                    controller: 'TrakeyeTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trakeyeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrakeyeType', function($stateParams, TrakeyeType) {
                    return TrakeyeType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trakeye-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('trakeye-type.delete', {
            parent: 'trakeye-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trakeye-type/trakeye-type-delete-dialog.html',
                    controller: 'TrakeyeTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['TrakeyeType', function(TrakeyeType) {
                            return TrakeyeType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('trakeye-type', null, { reload: 'trakeye-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
	'use strict';
	angular.module('trakeyeApp').factory('TrakeyeType', TrakeyeType);

	TrakeyeType.$inject = [ '$resource', 'DateUtils' ];

	function TrakeyeType($resource, DateUtils) {
		var resourceUrl = 'api/trakeye-types/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrakeyeTypeSearch', TrakeyeTypeSearch);

	TrakeyeTypeSearch.$inject = [ '$resource' ];

	function TrakeyeTypeSearch($resource) {
		var service = $resource('/api/trakeye-types/searchvalue/:userId', {
			userId : '@id'
		}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllTrakeyeTypes', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/trakeye-alltypes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrakeyeTypeController', TrakeyeTypeController);

    TrakeyeTypeController.$inject = ['$scope', '$state', 'TrakeyeType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','TrakeyeTypeSearch'];

    function TrakeyeTypeController ($scope, $state, TrakeyeType, ParseLinks, AlertService, pagingParams, paginationConstants,TrakeyeTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        
        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
				TrakeyeTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trakeyeTypes= data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            TrakeyeType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trakeyeTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('trakeyeApp').controller('TrServiceDialogController', TrServiceDialogController);

    TrServiceDialogController.$inject = ['$timeout', '$scope', '$http', '$stateParams', 'entity', '$state', 'TrService', 'User', 'TrCase', 'ServiceType', 'AllServiceTypes', 'TrServiceImages', 'AllCustomServiceTypeAttribute',
        'UserSearch', '$sce', '$q', '$rootScope', 'TrCaseUser'
    ];

    function TrServiceDialogController($timeout, $scope, $http, $stateParams, entity, $state, TrService, User, TrCase, ServiceType, AllServiceTypes, TrServiceImages, AllCustomServiceTypeAttribute, UserSearch, $sce, $q, $rootScope,
        TrCaseUser) {
        var vm = this;

        vm.trService = entity;
        var entity_old = angular.copy(vm.trService)
            // vm.serviceImages = entity_old.serviceImages;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.checkDate = checkDate;
        vm.save = save;
        vm.errorDate = false;
        vm.filtertrcasesid = filtertrcasesid;
        vm.customAttributesMap = {};
        // if ($rootScope.has_ROLE_USER_ADMIN == true) {
        //     vm.users = User.query();
        // }
        // // vm.trcases = TrCase.query();
        // if ($rootScope.has_ROLE_USER_ADMIN == true) {
        vm.serviceTypes = loadPage(); // ServiceType.query();
        // }
        vm.selectattributes = selectedServiceTypeAttributes;

        var serviceTypeAttributeValuesList = vm.trService.serviceTypeAttributeValues;

        try {
            for (var index in vm.trService.serviceType.serviceTypeAttribute) {
                if (!checkIfServiceTypeExists(vm.trService.serviceType.serviceTypeAttribute[index], vm.trService.serviceTypeAttributeValues)) {
                    var serviceTypeAttribute1 = vm.trService.serviceType.serviceTypeAttribute[index];
                    serviceTypeAttributeValuesList.push({ 'serviceTypeAttribute': serviceTypeAttribute1, 'attributeValue': vm.trService.serviceType.serviceTypeAttribute[index].defaultValue });
                }
            }
        } catch (e) {}

        function checkIfServiceTypeExists(serviceType, serviceTypeAttrVal) {
            var hasServiceType = false;
            for (var i = 0; i < serviceTypeAttrVal.length; i++) {
                var name = serviceTypeAttrVal[i].serviceTypeAttribute.name;
                if (name == serviceType.name) {
                    hasServiceType = true;
                    break;
                }
            }
            return hasServiceType;
        }

        serviceTypeAttributeValuesList
            .sort(function(a, b) {
                var nameA = a.serviceTypeAttribute.name.toLowerCase(),
                    nameB = b.serviceTypeAttribute.name
                    .toLowerCase()
                if (nameA < nameB) // sort string ascending
                    return -1
                if (nameA > nameB)
                    return 1
                return 0 // default return value (no sorting)
            });
        vm.trService.serviceTypeAttributeValues = serviceTypeAttributeValuesList;

        vm.serviceType = {};
        vm.trService.serviceImages = [];
        $scope.allimages = false;

        $scope.toggle = function() {
            $scope.allimages = !$scope.allimages;

            if ($scope.allimages) {

                TrServiceImages.query({
                    caseId: vm.trService.id

                }, onSuccess, onError);

                function onSuccess(data, headers) {
                    // console.log('Received data-----------');
                    vm.serviceImages = data;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }

            }

        };

        $('.select2').select2(); // Added for selectbox search

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });
        if (vm.trService.id && vm.trService.id != null) {
            vm.serviceType = vm.trService.serviceType;
            var date = vm.trService.serviceDate;
            var newdate = new Date(date);
            vm.trService.serviceDate = newdate;
        }

        function loadPage() {
            AllServiceTypes.getAll(function(response) {
                vm.serviceTypes = response;
            });

            AllCustomServiceTypeAttribute.getAll(function(response) {
                //vm.customCaseTypeAttributes = response;
                response.forEach(function(arrayItem) {
                    vm.customAttributesMap[arrayItem.name] = arrayItem.customServiceTypeAttributeValues;
                });

            });
        }

        function save() {
            vm.isSaving = true;
            if (vm.trService.id !== null) {
                var date = vm.trService.serviceDate;
                vm.trService.serviceDate = date.getTime();
                TrService.update(vm.trService, onSaveSuccess, onSaveError);
            } else {
                $scope.date = vm.trService.serviceDate.getTime();
                vm.trService.serviceDate = $scope.date;
                TrService.save(vm.trService, onSaveSuccess, onSaveError);
            }
        }

        $("#serviceImages").change(function() {

            var filesSelected = document.getElementById("serviceImages").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();

                fileReader.onload = function(fileLoadedEvent) {
                    vm.trService.serviceImages.push({
                        image: window.btoa(fileLoadedEvent.target.result),
                        trService: {
                            id: entity_old.id
                        }
                    });
                }
                fileReader.readAsBinaryString(filesSelected[i]);
            }

        });

        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:trServiceUpdate', result);
            // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('tr-service');
        }
        vm.serviceType = entity.serviceType;

        function selectedServiceTypeAttributes() {
            if (vm.serviceType) {
                vm.trService.serviceType = vm.serviceType;
                if (entity_old.serviceType && vm.serviceType.id === entity_old.serviceType.id) {
                    vm.trService.serviceTypeAttributeValues = [];
                    vm.trService.serviceTypeAttributeValues = entity_old.serviceTypeAttributeValues;
                } else {
                    vm.trService.serviceTypeAttributeValues = [];
                    $.each(vm.serviceType.serviceTypeAttribute, function(key, value) {
                        vm.trService.serviceTypeAttributeValues.push({
                            serviceTypeAttribute: vm.serviceType.serviceTypeAttribute[key]
                        });
                    });
                }
            }

        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function filtertrcasesid() {
            if (vm.trService.trCase.id != null && !angular.isUndefined(vm.trService.trCase.id)) {

                TrCaseUser.searchtrcasesuserbyvalue(vm.trService.trCase.id, function(response) {
                    vm.caseids = response;
                    vm.trcaseDate = response[0].createDate;
                });
            }
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;
        vm.datePickerOpenStatus.serviceDate = false;

        function checkDate() {
            var sdate = new Date(vm.trService.serviceDate).getTime();
            if (sdate > vm.trcaseDate) {
                vm.errorDate = false;
            } else {
                vm.errorDate = true;
            }
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;



        }


        // Added for upload styles
        $(":file").filestyle({
            buttonBefore: true
        });
        // $(":file").filestyle('placeholder', 'Choose File');
        $(":file").filestyle('buttonText', 'Browse File');

    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrServiceDetailController', TrServiceDetailController);

    TrServiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity'];

    function TrServiceDetailController($scope, $rootScope, $stateParams, previousState, entity) {
        var vm = this;

        vm.trService = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        var unsubscribe = $rootScope.$on('trakeyeApp:trServiceUpdate', function(event, result) {
            vm.trService = result;
        });
        $scope.$on('$destroy', unsubscribe);
        
        
        function decodeImage(img){
      	   return window.atob(img);
         }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrServiceDeleteController',TrServiceDeleteController);

    TrServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrService','$scope'];

    function TrServiceDeleteController($uibModalInstance, entity, TrService,$scope) {
        var vm = this;

        vm.trService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrService.delete({id: id},
                function () {
            	
           	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-service', {
                parent: 'app',
                url: '/tr-service',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trService.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-service/tr-services.html',
                        controller: 'TrServiceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'modified_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trService');
                        $translatePartialLoader.addPart('serviceStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tr-service-detail', {
                parent: 'tr-service',
                url: '/tr-service/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trService.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-service/tr-service-detail.html',
                        controller: 'TrServiceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trService');
                        $translatePartialLoader.addPart('serviceStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrService', function($stateParams, TrService) {
                        return TrService.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-service',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

        .state('tr-service.new', {
            parent: 'tr-service',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-service/tr-service-dialog.html',
                    controller: 'TrServiceDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function() {
                    return {
                        createdDate: null,
                        modifiedDate: null,
                        description: null,
                        serviceDate: null,
                        status: null,
                        notes: null,
                        id: null,
                        serviceTypeAttributeValues: [],
                        serviceImages: []

                    };
                }
            }

        })

        .state('tr-service.edit', {
            parent: 'tr-service',
            url: '/Edit/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                pageTitle: 'trakeyeApp.trService.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-service/tr-service-dialog.html',
                    controller: 'TrServiceDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trService');
                    $translatePartialLoader.addPart('serviceStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrService', function($stateParams, TrService) {
                    return TrService.get({ id: $stateParams.id }).$promise;
                }],
                previousState: ["$state", function($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tr-service',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })


        .state('tr-service.delete', {
            parent: 'tr-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tr-service/tr-service-delete-dialog.html',
                    controller: 'TrServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',

                    resolve: {
                        entity: ['TrService', function(TrService) {
                            return TrService.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tr-service', null, { reload: 'tr-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
(function() {
	'use strict';
	angular.module('trakeyeApp').factory('TrService', TrService);

	TrService.$inject = [ '$resource', 'DateUtils' ];

	function TrService($resource, DateUtils) {
		var resourceUrl = 'api/tr-services/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrServiceSearch', TrServiceSearch);

	TrServiceSearch.$inject = [ '$resource' ];

	function TrServiceSearch($resource) {

		var service = $resource('/api/tr-services/searchvalue/:search', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrServiceImages', TrServiceImages);

	TrServiceImages.$inject = [ '$resource' ];

	function TrServiceImages($resource) {
		var service = $resource('/api/service-images/:caseId', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrServiceSearchForMap', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.searchserviceinmap = function(serviceId, callback) {

			$http.get('api/tr-services/searchinmap/' + serviceId).then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllServiceTypes', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/service-alltypes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('TrServiceController', TrServiceController);

	TrServiceController.$inject = [ '$scope', '$state', 'DEFAULT_LATITUDE', 'DEFAULT_LONGITUDE', '$compile', 'TrService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TrCaseUser', 'TrServiceSearch',
			'TrServiceSearchForMap' ];

	function TrServiceController($scope, $state, DEFAULT_LATITUDE, DEFAULT_LONGITUDE, $compile, TrService, ParseLinks, AlertService, pagingParams, paginationConstants, TrCaseUser, TrServiceSearch, TrServiceSearchForMap) {
		var vm = this;
		$scope.search = pagingParams.search;
		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.drawservice = drawservice;
		// vm.filterUsers = filterUsers;
		vm.filterSearch = filterSearch;
		vm.filterTrSevices = filterTrSevices;
		vm.selectAllAssets = selectAllAssets;

		var latlng;
		var userPaths = {};
		var locations = {};

		// loadAll();

		$scope.tab = 1;

		$scope.setTab = function(newTab) {
			$scope.tab = newTab;
			if ($scope.tab == 2) {
				// vm.drawservice();
				filterTrSevices();
			}
		};

		$scope.isSet = function(tabNum) {
			return $scope.tab === tabNum;
		};

		if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
			filterSearch();
		} else {
			loadAll();
		}

		function loadAll() {
			TrService.query({
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
			function sort() {
				var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					// result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.trServices = data;
				vm.trServicesbackup = data;
				vm.page = pagingParams.page;
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

		function filterSearch() {
			if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
				TrServiceSearch.query({
					search : $scope.search,
					page : pagingParams.page - 1,
					size : vm.itemsPerPage,
					sort : sort()
				}, onSuccess, onError);
				function sort() {
					var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
					if (vm.predicate !== 'id') {
						// result.push('id');
					}
					return result;
				}
				function onSuccess(data, headers) {
					vm.links = ParseLinks.parse(headers('link'));
					vm.totalItems = headers('X-Total-Count');
					vm.queryCount = vm.totalItems;
					vm.trServices = data;
					vm.page = pagingParams.page;

				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			} else {
				loadAll();
			}
		}

		

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search : $scope.search
			});
		}

		/*
		 * function filterUsers(){ if(vm.seachCase!=null &&
		 * !angular.isUndefined(vm.seachCase)){
		 * TrCaseUser.gettrcasesuserbyid(vm.seachCase,function(response){
		 * $scope.trcaseuser=response; drawLatestCases($scope.trcaseuser); }); } }
		 */

		function selectAllAssets() {
            var toggleStatus = vm.isAllAssetSelected;
            if (toggleStatus) {
                vm.showAssetActions = true;
                vm.selectedAssets = [];
                vm.trServices.forEach(function (asset) {
                    vm.selectedAssets.push(asset.id);
                });
            } else {
                vm.showAssetActions = false;
                vm.selectedAssets = [];
            }
            angular.forEach(vm.trServices, function (item) { item.isChecked = toggleStatus; });
        }



		function filterTrSevices() {
			if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
				TrServiceSearchForMap.searchserviceinmap($scope.search, function(response) {
					var searchArray = [];
					response.forEach(function(ele){
						if($scope.search == ele.id ){
							searchArray.push(ele)
						}
					})
					drawLatestlocations(searchArray);
				});
			} else {
				drawLatestlocations(vm.trServicesbackup);
			}
		}

		function drawservice() {
			drawLatestlocations(vm.trServices);
		}

		function drawLatestlocations(response) {
			if (response) {
				initializeMap(response, function(latlang) {
					locations.latlng = latlang;
					setupMap(function() {
						$.each(response, function(index, value) {
							var infoWindow = new google.maps.InfoWindow();
							var startMarker = new google.maps.Marker({
								map : locations.map,
								position : new google.maps.LatLng(value.trCase.pinLat, value.trCase.pinLong),
								title : value.description,

							});

							var infoWindow2 = new google.maps.InfoWindow();

							if (value.trCase.priority == 'LOW') {
								startMarker.setIcon('content/images/Pointers-L4.png');
							} else if (value.trCase.priority == 'MEDIUM') {
								startMarker.setIcon('content/images/Pointers-M4.png');
							} else if (value.trCase.priority == 'HIGH') {
								startMarker.setIcon('content/images/Pointers-H4.png');
							} else if (value.trCase.priority == 'CRITICAL') {
								startMarker.setIcon('content/images/Pointer-C4.png');
							}
							var span = '<a userId="' + value.trCase.geofenceName + '" class="userpath" >Load travelled path</a>';
							startMarker.content = '<div class="infoWindowContent">' + value.trCase.address + '<br></div>';
							$compile(startMarker.content)($scope);

							google.maps.event.addListener(startMarker, 'mouseover', function() {
								infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
								infoWindow.open(locations.map, startMarker);

							});

							// on mouseout
							google.maps.event.addListener(startMarker, 'mouseout', function() {
								infoWindow.close();
							});

							var activeInfoWindow;
							// add content to InfoWindow for click event
							infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);

							// add listener on InfoWindow for click event
							google.maps.event.addListener(startMarker, 'click', function() {

								if (activeInfoWindow != null)
									activeInfoWindow.close();
								// Open InfoWindow - on click
								infoWindow2.open(locations.map, startMarker);
								$(".userpath").click(function() {
									var ele = document.getElementById("userPathModal");
									$(ele).modal('show');
									vm.drawUserPath($(this).attr('userid'));
								});

								// Store new open InfoWindow in global variable
								activeInfoWindow = infoWindow2;
							});

							// resizeMap();
						});

					});
				});
			}
			function setupMap(callback) {
				var myOptions = {
					zoom : 10,
					center : locations.latlng,
					mapTypeId : google.maps.MapTypeId.ROADMAP
				};
				locations.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
				locations.overlay = new google.maps.OverlayView();
				locations.overlay.draw = function() {
				};
				locations.overlay.setMap($scope.map);
				locations.element = document.getElementById('map_canvas');
				callback();
			}
		}

//		function resizeMap() {
//			setTimeout(function() {
//				google.maps.event.trigger(locations.map, "resize");
//				locations.map.setCenter(locations.latlng);
//			}, 1000);
//		}

		function initializeMap(latlangs, callback) {
			if (latlangs && latlangs.length > 0) {
				latlng = new google.maps.LatLng(latlangs[0].trCase.pinLat, latlangs[0].trCase.pinLong);
				callback(latlng);
			} else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function(position) {

						latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
						callback(latlng);
					}, function() {

						callback(new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value));
					});
				} else {
					callback(new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value));
				}
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrNotificationDialogController', TrNotificationDialogController);

    TrNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state','entity', 'TrNotification', 'User', 'TrCase', 'ActivatedUsers','TrCaseUser','ActivatedUserSearch'];

    function TrNotificationDialogController ($timeout, $scope, $stateParams, $state, entity, TrNotification, User, TrCase,ActivatedUsers,TrCaseUser,ActivatedUserSearch) {
        var vm = this;

        vm.trNotification = entity;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.filtertrcasesid=filtertrcasesid;
        vm.filterActivatedUser = filterActivatedUser;
        var usersMap={};
        //vm.users = User.query();
        ActivatedUsers.getactivatedusers(function(response){
	    	vm.users = response;
	    });
        vm.trcases = TrCase.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
      
        function save () {
            vm.isSaving = true;
            var toUser = $("#field_toUser").val();
            
            vm.trNotification.toUserId = usersMap[toUser];
            if (vm.trNotification.id !== null) {
                TrNotification.update(vm.trNotification, onSaveSuccess, onSaveError);
            } else {
                TrNotification.save(vm.trNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:trNotificationUpdate', result);           
            vm.isSaving = false;
            $state.go('tr-notification');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function filtertrcasesid(){
        	if(vm.trNotification.trCaseId!=null && !angular.isUndefined(vm.trNotification.trCaseId)){
        		
            	TrCaseUser.searchtrcasesuserbyvalue(vm.trNotification.trCaseId,function(response){
            		vm.caseids = response;
            	});
             }
        }
        
        function filterActivatedUser(){
			
			if(vm.trNotification.toUserId!=null && vm.trNotification.toUserId!="" && !angular.isUndefined(vm.trNotification.toUserId)){
				ActivatedUserSearch.query({userId:vm.trNotification.toUserId,
		            }, onSuccess, onError);

         function onSuccess(data, headers) {
             vm.activatedusers = data; 
             
             angular.forEach(vm.activatedusers, function(value, key){
            	 
            	 usersMap[value.login] = value.id; 
            	 
             });
             
         }
         function onError(error) {
             AlertService.error(error.data.message);
         }
			}
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrNotificationDetailController', TrNotificationDetailController);

    TrNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrNotification', 'User', 'TrCase'];

    function TrNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, TrNotification, User, TrCase) {
        var vm = this;

        vm.trNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:trNotificationUpdate', function(event, result) {
            vm.trNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrNotificationDeleteController',TrNotificationDeleteController);

    TrNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrNotification'];

    function TrNotificationDeleteController($uibModalInstance, entity, TrNotification) {
        var vm = this;

        vm.trNotification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-notification', {
                parent: 'app',
                url: '/tr-notification?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trNotification.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-notification/tr-notifications.html',
                        controller: 'TrNotificationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trNotification');
                        $translatePartialLoader.addPart('notificationStatus');
                        $translatePartialLoader.addPart('alertType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tr-notification-detail', {
                parent: 'tr-notification',
                url: '/tr-notification/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_USER'],
                    pageTitle: 'trakeyeApp.trNotification.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-notification/tr-notification-detail.html',
                        controller: 'TrNotificationDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trNotification');
                        $translatePartialLoader.addPart('notificationStatus');
                        $translatePartialLoader.addPart('alertType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrNotification', function($stateParams, TrNotification) {
                        return TrNotification.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-notification',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('tr-notification-detail.edit', {
                parent: 'tr-notification-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-notification/tr-notification-dialog.html',
                        controller: 'TrNotificationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        //size: 'lg',
                        resolve: {
                            entity: ['TrNotification', function(TrNotification) {
                                return TrNotification.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-notification.new', {
                parent: 'tr-notification',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-notification/tr-notification-dialog.html',
                        controller: 'TrNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            createdDate: null,
                            description: null,
                            status: null,
                            subject: null,
                            alertType: null,
                            id: null
                        };
                    }
                }
            })
            .state('tr-notification.edit', {
                parent: 'tr-notification',
                url: '/edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER'],
                    pageTitle: 'trakeyeApp.trNotification.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-notification/tr-notification-dialog.html',
                        controller: 'TrNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trNotification');
                        $translatePartialLoader.addPart('notificationStatus');
                        $translatePartialLoader.addPart('alertType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrNotification', function($stateParams, TrNotification) {
                        return TrNotification.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-notification',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

        .state('tr-notification.delete', {
            parent: 'tr-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tr-notification/tr-notification-delete-dialog.html',
                    controller: 'TrNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TrNotification', function(TrNotification) {
                            return TrNotification.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tr-notification', null, { reload: 'tr-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
(function() {
	'use strict';
	angular.module('trakeyeApp').factory('TrNotification', TrNotification);

	TrNotification.$inject = [ '$resource', 'DateUtils' ];

	function TrNotification($resource, DateUtils) {
		var resourceUrl = 'api/tr-notifications/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrNotificationSearch', TrNotificationSearch);

	TrNotificationSearch.$inject = [ '$resource' ];

	function TrNotificationSearch($resource) {
		var service = $resource('/api/tr-notifications/searchvalue/:search', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();
(function() {
	'use strict';

	angular.module('trakeyeApp').controller('TrNotificationController', TrNotificationController);

	TrNotificationController.$inject = [ '$scope', '$state', 'TrNotification', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TrNotificationSearch' ];

	function TrNotificationController($scope, $state, TrNotification, ParseLinks, AlertService, pagingParams, paginationConstants, TrNotificationSearch) {
		var vm = this;
		$scope.search = pagingParams.search;
		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.filterSearch = filterSearch;

		function filterSearch() {

			if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
				TrNotificationSearch.query({
					search : $scope.search,
					page : pagingParams.page - 1,
					size : vm.itemsPerPage,
					sort : sort()
				}, onSuccess, onError);
				function sort() {
					var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
					if (vm.predicate !== 'id') {
						// result.push('id');
					}
					return result;
				}
				function onSuccess(data, headers) {
					vm.links = ParseLinks.parse(headers('link'));
					vm.totalItems = headers('X-Total-Count');
					vm.queryCount = vm.totalItems;
					vm.trNotifications = data;
					vm.page = pagingParams.page;

				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			} else {
				loadAll();
			}
		}

		if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
			filterSearch();
		} else {
			loadAll();
		}

		function loadAll() {
			TrNotification.query({
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
			function sort() {
				var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					// result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.trNotifications = data;
				vm.page = pagingParams.page;
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search : $scope.search
			});
		}
	}
})();

(function() {
    'use strict';

    angular.module('trakeyeApp').controller('TrCaseWorkFlowController', TrCaseWorkFlowController);

    TrCaseWorkFlowController.$inject = ['$scope', '$state', '$stateParams', 'entity', 'AlertService', 'TrCase', 'AssetGroupSearch', 'AssetGroup', 'AllCaseTypes', 'AllCustomCaseTypeAttribute', 'AllCustomAssetTypeAttribute', 'UserGroupIDs', 'ActivatedUserSearch', 'AllAssetsTypes', 'AssetType', 'TrCaseCheckAsset'];

    function TrCaseWorkFlowController($scope, $state, $stateParams, entity, AlertService, TrCase, AssetGroupSearch, AssetGroup, AllCaseTypes, AllCustomCaseTypeAttribute, AllCustomAssetTypeAttribute, UserGroupIDs, ActivatedUserSearch, AllAssetsTypes, AssetType, TrCaseCheckAsset) {
        var vm = this;

        vm.trCase = entity;
        var entity_old = angular.copy(vm.trCase);
        vm.filterActivatedUser = filterActivatedUser;
        vm.selectattributes = selectedCaseTypeAttributes;
        vm.saveEditAsset = saveEditAsset;
        vm.selectedGroup = selectedGroup;
        var openedInfoWindow = null;
        vm.connectSelectedAssets = connectSelectedAssets;
		vm.saveLinkPits = saveLinkPits;
		vm.connectMultipleAssets = connectMultipleAssets;
		vm.hideConnectMultipleAssetsModal = hideConnectMultipleAssetsModal;
		vm.searchAssetName = searchAssetName;
		vm.refreshPage = refreshPage;
        vm.connectAssets = connectAssets;
		vm.recalculate = recalculate;
        vm.isSiteASelected = false;
        vm.isSiteBSelected = false;
        vm.selectedSiteA = {};
        vm.selectedSiteB = {};
		vm.linkAssetType = null;
		vm.manholeAssetType = null;
	
        vm.editAsset = editAsset;
        vm.caseTypes = [];
        vm.multigroup = [];
        vm.assetType = [];
        var parentSite = []; 

        vm.deleteAssetModal = deleteAssetModal;
        vm.confirmDeleteAsset = confirmDeleteAsset;
        vm.cleardeleteAsset = cleardeleteAsset;
        vm.clearCreateAsset = clearCreateAsset;
        var deleteAssetName = null;
        vm.createAssetModal = createAssetModal;
        vm.createAsset = createAsset;
        vm.assetNameVal = null;
        vm.assetLat = null;
        vm.assetLong = null;
        var createAssetData = {};

        vm.customAttributesMap = {};
        var usersMap = {};
        var mappedAssetTemp = {};
        vm.mappedAssetsList = [];
		vm.tempLinkWithPits = [];
		vm.deletedAssetsList = [];
        var selectedGroup = [];
        var assetsPlanningMap = null;
        var assetsDeployedMap = null;
        vm.isShowing = true;
        vm.save = save;
        vm.handleTabClick = handleTabClick;
        vm.assetExisting = false;
        $scope.search = null;
        vm.assets = [];
        vm.showAssetCreation = false;
        vm.showAssetName = false;
		var centerlatlng = null;
        vm.hideUser = true;
        var marker = null;
//        vm.searchAssets = searchAssets;
        var editAssetMap = null;
        vm.validUser = true;
        vm.assignedUsers = [];
        vm.validUser = true;
        vm.hideConnectSitesModal = hideConnectSitesModal;
        vm.previousId = sessionStorage.getItem("prevEditId");
        if(vm.previousId) {
            vm.validUser = false;
        }
        $scope.tab = 1;
        vm.siteAssets = [];
        if ($scope.tab == 1) {
            vm.toggleFirst = true;
            vm.toggleSecond = false;
            vm.toggleThird = false;
            AllCaseTypes.getAll(function(response) {
                vm.caseTypes = response;
            });

            AllCustomCaseTypeAttribute.getAll(function(response) {
                response.forEach(function(arrayItem) {
                    vm.customAttributesMap[arrayItem.name] = arrayItem.customCaseTypeAttributeValues;
                });
            });

            if (vm.trCase.id != null) {
				vm.hideUser = false;
                vm.trCase.groups.forEach(function(group) {
                    selectedGroup.push(group.id);
                });
            }

            UserGroupIDs.getAll(function(response) {
                response.forEach(function(group) {
                    if (selectedGroup.indexOf(group.id) !== -1) {
                        vm.multigroup.push({ name: group.name, id: group.id, ticked: true });
                    } else {
                        vm.multigroup.push({ name: group.name, id: group.id, ticked: false });
                    }
                });
            });
            AllAssetsTypes.getAll(function(response) {
                response.forEach(function(assettype) {
                    vm.assetType.push(assettype);
                });
            });

            AllCustomAssetTypeAttribute.getAll(function(response) {
                response
                    .forEach(function(arrayItem) {
                        vm.customAttributesMap[arrayItem.name] = arrayItem.customAssetTypeAttributeValues;
                    });
            });

            if (vm.trCase.id != null) {
                vm.trCase.caseAssets.forEach(function(asset) {
                    asset.isChecked = true;
                    vm.mappedAssetsList.push(asset);
                    vm.isShowing = false;
                    $scope.toggle = true;
                });
                vm.caseType = entity.caseType;
            }
        }

        $scope.isSet = function(tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function(newTab) {
            $scope.tab = newTab;
            $scope.search = "";

            if($scope.tab == 1){
                vm.toggleFirst = true;
                vm.toggleSecond = false;
                vm.toggleThird = false;
            }else if ($scope.tab == 2) {
                vm.toggleFirst = false;
                vm.toggleSecond = true;
                vm.toggleThird = false;
                initPlanningMap();
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                        createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                    } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                        var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                        drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                    }
                }
				
				AssetType.query(function(data) {
                    data.forEach(function(item) {
                        if (item.name == "Link") {
							vm.linkAssetType = {};
							vm.linkAssetType.assetType = item;
                            vm.linkAssetType.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(vm.linkAssetType.assetType);
//                            $.each(vm.linkAssetType.assetType.assetTypeAttributes,function(key, value) {
//                                vm.linkAssetType.assetTypeAttributeValues.push({
//                                        assetTypeAttribute: vm.linkAssetType.assetType.assetTypeAttributes[key]
//                                    });
//                            });
						} else if (item.name == "Manhole") {
							vm.manholeAssetType = {};
							vm.manholeAssetType.assetType = item;
                            vm.manholeAssetType.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(vm.manholeAssetType.assetType);
//                            $.each(vm.manholeAssetType.assetType.assetTypeAttributes,function(key, value) {
//                                vm.manholeAssetType.assetTypeAttributeValues.push({
//                                        assetTypeAttribute: vm.manholeAssetType.assetType.assetTypeAttributes[key]
//                                    });
//                            });
						}
					});
				});
				
            } else if ($scope.tab == 3) {
				vm.toggleFirst = false;
                vm.toggleSecond = false;
                vm.toggleThird = true;
				var totalCost = 0;
                var totalPowerBudget = 0;
				var totalFiberDistance = 0.0;
                for (var assetIndex = 0; assetIndex < vm.mappedAssetsList.length; assetIndex++) {
					if(vm.mappedAssetsList[assetIndex].name != null){
	                    var assetAV = vm.mappedAssetsList[assetIndex].assetTypeAttributeValues;
	                    var isSpread = false;
	                    var fiberDistance = 0.0;
	
						if (vm.mappedAssetsList[assetIndex].assetType.layout == "SPREAD") {
							isSpread = true;
		                    var spreadAV = vm.mappedAssetsList[assetIndex].assetTypeAttributeValues;
		                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
		                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
		                          	fiberDistance = parseFloat("0"+spreadAV[spreadAssetIndex].attributeValue);
		                        }
		                    }
		                }
	
	                    assetAV.forEach(function(item) {
	                        var value = 0;
	                        if (item.attributeValue != null) {
	                            value = parseFloat(item.attributeValue);
	                        } else {
	                            value = parseFloat(item.assetTypeAttribute.defaultValue);
	                        }
	
	                        if (item.assetTypeAttribute.name == "Cost") {
	                            var tempCost = parseFloat(value);
	                            if (isSpread) {
	                                tempCost = parseFloat(value) * fiberDistance;
	                            }
	                            if (tempCost > 0) {
	                                totalCost += tempCost
	                            }
	                        }
	                        if (item.assetTypeAttribute.name == "Power Budget") {
	                            var tempPowerBudget = parseFloat(value);
	                            if (isSpread) {
	                                tempPowerBudget = parseFloat(value) * fiberDistance;
	                            }
	                            if (tempPowerBudget > 0) {
	                                totalPowerBudget += tempPowerBudget;
	                            }
	                        }
	                    });
						totalFiberDistance += fiberDistance;
					}
                }

                var caseAV = vm.trCase.caseTypeAttributeValues;
                for (var caseIndex = 0; caseIndex < caseAV.length; caseIndex++) {
                    if (caseAV[caseIndex].caseTypeAttribute.name === "Cost") {
                        caseAV[caseIndex].attributeValue = totalCost.toFixed(2);
                    }
                    if (caseAV[caseIndex].caseTypeAttribute.name === "Power Budget") {
                        caseAV[caseIndex].attributeValue = totalPowerBudget.toFixed(2);
                    }
					if (caseAV[caseIndex].caseTypeAttribute.name === "Fiber Distance") {
                        caseAV[caseIndex].attributeValue = totalFiberDistance.toFixed(2);
                    }
                }
                vm.trCase.caseTypeAttributeValues = caseAV;

                assetsDeployedMap = new google.maps.Map(document.getElementById('map_canvas_deployed'), {
                    center: {
                        lat: 5.431587,
                        lng: 101.128162
                    },
                    zoom: 13,
                    fullscreenControl: true
                });


                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                        createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsDeployedMap);
                    } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                        var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                        drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsDeployedMap, "yellow");
                    }
                }

                if (vm.mappedAssetsList.length > 0) {
                    vm.trCase.pinLat = vm.mappedAssetsList[0].assetCoordinates[0].latitude;
                    vm.trCase.pinLong = vm.mappedAssetsList[0].assetCoordinates[0].longitude;
                    vm.trCase.address = '';
                    if (vm.trCase.id == null) {
                        vm.trCase.status = "NEW";
                    }
                }
                if (vm.mappedAssetsList.length > 0) {
                    assetsDeployedMap.setCenter(new google.maps.LatLng(vm.mappedAssetsList[0].assetCoordinates[0].latitude, vm.mappedAssetsList[0].assetCoordinates[0].longitude));
                }
//
//				var pointA = new google.maps.LatLng(12.917358683134225,77.62311194634297);
//            	var pointB = new google.maps.LatLng(12.915999226925456,77.63823960497554);
//
//				getPointsRoute(pointA, pointB, assetsDeployedMap, 200);
            }
        }

        function handleTabClick($event) {
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }

        function clearCreateAsset() {
            $("#create-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#create-asset").hide();
        }

        function createAssetModal(item) {
			vm.assetExisting = false;
			if(item.name == "LINK_WITH_MH"){
				connectMultipleAssets();
			}else{
	            vm.CreateAssetName = item.name;
	            vm.assetNameVal = null;
	            vm.assetLat = null;
	            vm.assetLong = null;
	            $('#create-asset').show();
	            createAssetData = item;
	            vm.showAssetName = false;
                vm.parentAsset = null;
			}
        }

		function getConsolidatedAssetTypeAttributeValue(assetType){
			var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({ 'assetTypeAttribute': assetTypeAttribute1, 'attributeValue': assetType.assetTypeAttributes[index].defaultValue });
            }

            assetTypeAttributeValuesList
                .sort(function(a, b) {
                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                        nameB = b.assetTypeAttribute.name.toLowerCase()
                    if (nameA < nameB) // sort string ascending
                        return -1
                    if (nameA > nameB)
                        return 1
                    return 0 // default return value (no sorting)
                });
            return assetTypeAttributeValuesList;
		}

        function searchAssetName() {
            vm.assetExisting = false;
            var searchName = vm.assetNameVal;
            vm.showAssetCreation = false;
            if (searchName != undefined && searchName.length > 2) {
                TrCaseCheckAsset.get({ name: searchName }, function (checkAsset) {
                    if (checkAsset.name == searchName) {
                        vm.assetExisting = true;
                        vm.showAssetCreation = true;
                    } else if (vm.mappedAssetsList.length > 0) {
                        vm.mappedAssetsList.forEach(function (maplist) {
                            if (maplist.name == searchName) {
                                vm.assetExisting = true;
                                vm.showAssetCreation = true;
                            }
                        });
                    }
                });
            }
        }
		
		function refreshPage(){
			if (marker != null) {
                marker.setMap(null);
            }

			initPlanningMap();
            
			for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                }
            }
		}
		
		function createAsset() {
            var assetName = vm.assetNameVal;
            vm.assetExisting = false;
            var coOrdinate =  [];
            parentSite = [];
            if (marker != null) {
                marker.setMap(null);
            }
            if (vm.parentAsset != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.parentAsset == vm.mappedAssetsList[i].name) {
                        parentSite.push(vm.mappedAssetsList[i]);
                        coOrdinate.push({
                            lat: vm.mappedAssetsList[i].assetCoordinates[0].latitude,
                            lng: vm.mappedAssetsList[i].assetCoordinates[0].longitude
                        });
                        assetsPlanningMap = new google.maps.Map(document.getElementById('map_canvas_planning'), {
                            center: coOrdinate[0],
                            zoom: 13,
                            fullscreenControl: true
                        });
                    }
                }
            } else {
                assetsPlanningMap = new google.maps.Map(document.getElementById('map_canvas_planning'), {
                    center: {
                        lat: 5.431587,
                        lng: 101.128162
                    },
                    zoom: 13,
                    fullscreenControl: true
                });
            }
             if(assetName && assetName.length > 2) {
                if (!isAssetAvailable(assetName)) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                            createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                        } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                            var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(vm.mappedAssetsList[i], assetCoordinateValues, assetsPlanningMap, "yellow");
                        }
                    }
                    mappedAssetTemp = {};
                    mappedAssetTemp.name = assetName;
                    mappedAssetTemp.description = assetName;
                    mappedAssetTemp.assetType = createAssetData;
                     // mappedAssetTemp.ownedBy = parentSite;
                     mappedAssetTemp.parentAsset = parentSite;
					var date = new Date();
					mappedAssetTemp.createDate = date.getTime();
                    mappedAssetTemp.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(createAssetData);
//                    createAssetData.assetTypeAttributeValues = [];
//                    $.each(createAssetData.assetTypeAttributes,function (key) {
//                            mappedAssetTemp.assetTypeAttributeValues.push({
//                                assetTypeAttribute: createAssetData.assetTypeAttributes[key]
//                            });
//                        });
//					
                    if (createAssetData.layout == 'SPREAD') {
                        drawingManagerSpread();
                        drawingManagerValue('polylinecomplete', assetsPlanningMap, false);
                    } else if (createAssetData.layout == 'FIXED') {
                        if (vm.assetLat > 0 && vm.assetLong > 0) {
                            vm.fixedArray = [];
                            var coordinates = {};
                            coordinates.latitude = vm.assetLat;
                            coordinates.longitude = vm.assetLong;

                            vm.fixedArray.push(coordinates);
                            mappedAssetTemp.assetCoordinates = vm.fixedArray;
                            addMappedAssets(mappedAssetTemp);
                            vm.isShowing = false;
                            initPlanningMap();
                            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i], assetCoordinateValues, assetsPlanningMap, "yellow");
                                }
                            }
                            var centerlatlng = {
                                lat: parseFloat(vm.assetLat),
                                lng: parseFloat(vm.assetLong)
                            };
                            assetsPlanningMap.setCenter(centerlatlng);
                        } else if(vm.parentAsset != null){
                            // setValues();
                            drawingManagerFixed();
                            drawMarker(assetsPlanningMap, JSON.stringify(coOrdinate));
                        } 
                        else {
                            drawingManagerFixed();
                            drawingManagerValue('click', assetsPlanningMap);
                        }
                    }
                } else {
                    initPlanningMap();
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                            createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                        } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                            var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(vm.mappedAssetsList[i], assetCoordinateValues, assetsPlanningMap, "yellow");
                        }
                    }
                }
                $("#create-asset").removeClass("in");
                $(".modal-backdrop").remove();
                $("#create-asset").hide();
            }
        }

        function initPlanningMap() {
            assetsPlanningMap = new google.maps.Map(document.getElementById('map_canvas_planning'), {
                center: {
                    lat: 5.431587,
                    lng: 101.128162
                },
                zoom: 13,
                fullscreenControl: true
            });
            if (vm.mappedAssetsList.length > 0) {
                assetsPlanningMap.setCenter(new google.maps.LatLng(vm.mappedAssetsList[0].assetCoordinates[0].latitude, vm.mappedAssetsList[0].assetCoordinates[0].longitude));
            }
        }

		function getPointsRoute(assetA, assetB, map, dist) {
            	var pointA = new google.maps.LatLng(assetA.assetCoordinates[0].latitude,assetA.assetCoordinates[0].longitude);
            	var pointB = new google.maps.LatLng(assetB.assetCoordinates[0].latitude,assetB.assetCoordinates[0].longitude);


			var directionsService = new google.maps.DirectionsService;
            
			directionsService.route({
                origin: pointA,
                destination: pointB,
                travelMode: google.maps.TravelMode.DRIVING
            }, function(response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
					var route = response.routes[0];
	                var az = 0;
	                for (var i = 0; i < route.legs.length; ++i) {
	                    if (route.legs[i].distance) {
	                        az += route.legs[i].distance.value;
	                    }
	                }
	                dist = Math.max(dist, Math.round(az / 100));
	                var markerPoints = gMilestone(route, dist);
					var polylinePathPoints = gMilestone(route, 100);
					var responsePaths = response.routes;
                    vm.spreadArray = [];
                    var overViewPath = route.overview_path;
                    polylinePathPoints.forEach(function(value) {
                        var coordinates = {};
                        coordinates.latitude = value.lat();
                        coordinates.longitude = value.lng();
                        vm.spreadArray.push(coordinates);
                    });
					var newLinkAsset = {};
					newLinkAsset.name = assetA.name + "-"+ assetB.name;
					newLinkAsset.description = newLinkAsset.name;
					newLinkAsset.assetCoordinates = vm.spreadArray;
					newLinkAsset.assetType = vm.linkAssetType.assetType;
					var fiberDistance = 0.0;
                    var spreadCoordinates = newLinkAsset.assetCoordinates;
                    if (spreadCoordinates.length > 0) {
                        for (var index in spreadCoordinates) {
                            if (index > 0) {
                                fiberDistance += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
                            }
                        }
                    }
	                fiberDistance = fiberDistance.toFixed(2);
                    var spreadAV = vm.linkAssetType.assetTypeAttributeValues;
                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
                            spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
                        }
                    }
                    newLinkAsset.assetTypeAttributeValues = spreadAV;
					newLinkAsset.isChecked = true;
					vm.tempLinkWithPits.push(newLinkAsset);
					//drawPolylineForSelectedPath(assetA.name + "-"+ assetB.name, vm.fixedArray, map, 0);
					markerPoints.forEach(function(point, index){
						var newManholeAsset = {};
						newManholeAsset.name = assetA.name + "-"+ assetB.name + " Pit"+ (index+1);
						newManholeAsset.description = newManholeAsset.name;
						newManholeAsset.assetType = vm.manholeAssetType.assetType;
						newManholeAsset.assetTypeAttributeValues = vm.manholeAssetType.assetTypeAttributeValues;
						vm.fixedArray = [];
						var coordinates = {};
                        coordinates.latitude = point.lat();
                        coordinates.longitude = point.lng();
                        vm.fixedArray.push(coordinates);
						newManholeAsset.assetCoordinates = vm.fixedArray;
						newManholeAsset.isChecked = true;
						vm.tempLinkWithPits.push(newManholeAsset);
					});
//					map.clear();
					for (var i = 0; i < vm.tempLinkWithPits.length; i++) {
                        if (vm.tempLinkWithPits[i].assetType.layout == 'FIXED') {
                            createMarkerForSelectedAsset(vm.tempLinkWithPits[i], map);
                        } else if (vm.tempLinkWithPits[i].assetType.layout == 'SPREAD') {
                            var assetCoordinateValues = vm.tempLinkWithPits[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(vm.tempLinkWithPits[i], assetCoordinateValues, map, "yellow");
                        }
                    }
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
        }

		function saveLinkPits(){
			vm.tempLinkWithPits.forEach(function(asset){
				vm.mappedAssetsList.push(asset);
			});
			hideConnectMultipleAssetsModal();
		}
		function gMilestone(route, dist) {
			var path = route.overview_path;
			var geo = google.maps.geometry.spherical;
			var point = path[0];
			var distance = 0;
			var overflow = null;
			var pos = null;
			var leg = null;
			var pointsPosition = [];
			var d1 = 0;
			
		    for (var p = 1; p < path.length; ++p) {
		        leg = Math.round(geo.computeDistanceBetween(point, path[p]));
		        d1 = distance + 0
		        distance += leg;
		        overflow = dist - (d1 % dist);
		
		        if (distance >= dist && leg >= overflow) {
		            if (overflow && leg >= overflow) {
		                pos = geo.computeOffset(point, overflow, geo.computeHeading(point, path[p]));
						pointsPosition.push(pos);
		                distance -= dist;
		            }
		
		            while (distance >= dist) {
		                pos = geo.computeOffset(point, dist + overflow, geo.computeHeading(point, path[p]));
						pointsPosition.push(pos);
		                distance -= dist;
		            }
		        }
		        point = path[p]
		    }
		    return pointsPosition;
		}

        function createMarkerForSelectedAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = ({ lat: parseFloat(asset.assetCoordinates[0].latitude), lng: parseFloat(asset.assetCoordinates[0].longitude) });
				if(asset.assetType.name == "Manhole"){
					var iconSize = 4;
					var marker = new google.maps.Marker({
	                    position: myLatLng,
	                    map: map,
						icon: {
	                            scaledSize: new google.maps.Size(
	                                iconSize, iconSize),
	                            url: 'content/images/green_circle.png',
	                            anchor: new google.maps.Point(
	                                iconSize / 2, iconSize / 2),
	
	                        }
	                });
				}else{
	                var marker = new google.maps.Marker({
	                    position: myLatLng,
	                    map: map,
	                    icon: {
	                        url: 'content/images/yellow.png'
	                    },
	                    label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: asset.name, backgroundcolor: "#ff9800" },
	                });
				}
            }
        }

		function createMarkerForSiteAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = ({ lat: parseFloat(asset.assetCoordinates[0].latitude), lng: parseFloat(asset.assetCoordinates[0].longitude) });
				if(asset.assetType.name == "Manhole"){
					var iconSize = 4;
					var marker = new google.maps.Marker({
	                    position: myLatLng,
	                    map: map,
						icon: {
                                scaledSize: new google.maps.Size(
                                    iconSize, iconSize),
                                url: 'content/images/green_circle.png',
                                anchor: new google.maps.Point(
                                    iconSize / 2, iconSize / 2),

                            }
	                });
				}else{
	                var marker = new google.maps.Marker({
	                    position: myLatLng,
	                    map: map,
	                    icon: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
	                    label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: asset.name, backgroundcolor: "#ff9800" },
	                });
				}
            }
        }

        function drawPolylineForGeneratedLoc(asset, latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];

            latlngsToDraw.forEach(function(value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var ColorValue = '#ff0000';
                if (color == "red") {
                    ColorValue = '#ff0000';
                } else if (color == "black") {
                    ColorValue = '#000000';
                } else if (color == "yellow") {
                    ColorValue = '#F4A500';
                } else {
                    ColorValue = '#208000';
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    var infoStr = "";
                    var otdr = "";
                    var infoWindowContent = "";
                    var assetTypeAttributeValuesList = asset.assetTypeAttributeValues;
                    assetTypeAttributeValuesList.forEach(function (attrValues) {
                        if(attrValues.attributeValue != undefined) {
                            vm.fiberLength = attrValues.attributeValue;
                        }
                        var home = attrValues;
                        var value = null;
                        if (home.attributeValue != undefined) {
                            value = home.attributeValue;
                        } else {
                            value = home.assetTypeAttribute.defaultValue;
                        }
                        infoStr += '<br><b>' +
                            home.assetTypeAttribute.name +
                            '</b> : ' +
                            value;
                        otdr = home;

                        infoWindowContent = '<div class="info_content">' +
                        '<b>' +
                        'Name' +
                            '</b> : ' +
                            asset.name +
                            '<br><b>' +
                            'Fiber Distance (km)' +
                            '</b> : ' +
                            vm.fiberLength +
                        '<hr></div><div>' + infoStr + '</div>';
                    })

                    var infoWindow2 = new google.maps.InfoWindow({
                        content: infoWindowContent,
                    });
                    infoWindow2.open(map);
                    infoWindow2.setPosition(event.latLng);
                    openedInfoWindow = infoWindow2;
                });
            }
        }

        function drawingManagerSpread() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYLINE,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polyline']
                },
                polylineOptions: {
                    fillColor: '#ffff00',
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: true,

                    editable: true,
                    zIndex: 1,
                    geodesic: true
                }
            });
        }

        function drawingManagerFixed() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['marker']
                }
            });
        }

        function drawingManagerValue(option, map, isEdit) {
            if (option == 'polylinecomplete') {
                vm.isShowing = false;
                google.maps.event.addListener(vm.drawingManager, option,
                    function(event) {
                        google.maps.event.addListener(event.getPath(), 'insert_at', function() {
                            setGoefenceCoordinate(event, isEdit);
                        });
                        google.maps.event.addListener(event.getPath(), 'set_at', function(path) {
                            setGoefenceCoordinate(event, isEdit);
                        });
                        vm.drawingManager.setOptions({
                            drawingControl: false
                        });
                        vm.drawingManager.setMap(null);
                        setGoefenceCoordinate(event, isEdit);
						if (mappedAssetTemp.assetType.layout == "SPREAD") {
							var fiberDistance = 0.0;
		                    var spreadCoordinates = mappedAssetTemp.assetCoordinates;
		                    if (spreadCoordinates.length > 0) {
		                        for (var index in spreadCoordinates) {
		                            if (index > 0) {
		                                fiberDistance += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
		                            }
		                        }
		                    }
			                fiberDistance = fiberDistance.toFixed(2);
		                    var spreadAV = mappedAssetTemp.assetTypeAttributeValues;
		                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
		                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
		                            spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
		                        }
		                    }
		                    mappedAssetTemp.assetTypeAttributeValues = spreadAV;
		                }
                        addMappedAssets(mappedAssetTemp);
                    });
                vm.drawingManager.setMap(map);
            } else if (option == 'click') {
                vm.isShowing = false;
                marker = new google.maps.Marker({
                    position: location,
                    map: map
                });

                google.maps.event.addListener(map, 'click', function(e) {
                    placeMarker(e.latLng, map);
                    vm.fixedArray = [];
                    var coordinates = {};
                    coordinates.latitude = e.latLng.lat();
                    coordinates.longitude = e.latLng.lng();
                    vm.fixedArray.push(coordinates);
                    mappedAssetTemp.assetCoordinates = vm.fixedArray;
                    addMappedAssets(mappedAssetTemp);
                });
            }
        }

        function placeMarker(location, map) {
            if (marker) {
                if (location.lat != null && location.lng != null) {
                    marker.setPosition(location);
                }
            } else {
                marker = new google.maps.Marker({
                    position: location,
                    map: map
                });
            }
        }

        function addMappedAssets(newAsset) {
            if (!isAssetAvailable(newAsset.name)) {
                newAsset.isChecked = true;
                vm.mappedAssetsList.push(newAsset);
            }
			// initPlanningMap();
            // for (var i = 0; i < vm.mappedAssetsList.length; i++) {
            //     if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
            //         createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
            //     } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
            //         var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
            //         drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
            //     }
            // }
        }

        function isAssetAvailable(assetName) {
            var isAssetAvailable = false;

            vm.mappedAssetsList.forEach(function(assetVal) {
                if (assetVal.name === assetName) {
                    isAssetAvailable = true;
                }
            });
            return isAssetAvailable;
        }

        function selectedCaseTypeAttributes() {
            if (vm.caseType) {
                vm.trCase.caseType = vm.caseType;
                if (entity_old.caseType && vm.caseType.id === entity_old.caseType.id) {
                    vm.trCase.caseTypeAttributeValues = [];
                    vm.trCase.caseTypeAttributeValues = entity_old.caseTypeAttributeValues;
                } else {
                    vm.trCase.caseTypeAttributeValues = [];
                    $.each(vm.caseType.caseTypeAttribute, function(key, value) {
                        vm.trCase.caseTypeAttributeValues.push({
                            caseTypeAttribute: vm.caseType.caseTypeAttribute[key]
                        });
                    });
                }
            }
        }

        function deleteAssetModal(name) {
            $('#delete-asset').show();
            deleteAssetName = name;
        }

        function confirmDeleteAsset() {
            var assetArray = vm.mappedAssetsList;
            for (var i = assetArray.length - 1; i >= 0; --i) {
                if (assetArray[i].name == deleteAssetName) {
					vm.deletedAssetsList.push(assetArray[i]);
                    assetArray.splice(i, 1);
                }
            }
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                }
            }
            vm.mappedAssetsList = [];
            assetArray.forEach(function(asset) {
                vm.mappedAssetsList.push(asset);
            });
            $("#delete-asset").hide();
        }

        function cleardeleteAsset() {
            $("#delete-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#delete-asset").hide();
        }

        function setGoefenceCoordinate(event, isEdit) {
            vm.assetCoordinateValues = [];
            var tempAsset = {};
            tempAsset.assetCoordinates = [];
            var radius = event.getPath();
            for (var i = 0; i < radius.getLength(); i++) {
                var coordinates = {};
                coordinates.latitude = radius.getAt(i).lat();
                coordinates.longitude = radius.getAt(i).lng();
                tempAsset.assetCoordinates.push(coordinates);
            }
            if (isEdit) {
                vm.asset.assetCoordinates = tempAsset.assetCoordinates;
            } else {
                mappedAssetTemp.assetCoordinates = tempAsset.assetCoordinates;
            }
        }

        function saveEditAsset() {
            //vm.tempAssetArray.push(vm.asset);
            vm.mappedAssetsList = [];
            vm.tempAssetArray.forEach(function(assetVal) {
                vm.mappedAssetsList.push(assetVal);
            });
            vm.asset = [];
            vm.tempAssetArray = [];
            hideUserEditModal();
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                }
            }
        };

        function hideUserEditModal() {
            $("#userPathModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#userPathModal").hide();
        }

        function editAsset(asset) {
            vm.tempAssetArray = [];

            vm.mappedAssetsList.forEach(function(assetVal) {
                vm.tempAssetArray.push(assetVal);
            });
            for (var i = 0; i >= vm.tempAssetArray.length; --i) {
                if (vm.tempAssetArray[i].name == asset.name) {
                    vm.tempAssetArray.splice(i, 1);
                }
            }

            vm.asset = asset;
            var maplatlng = {
                lat: parseFloat(asset.assetCoordinates[0].latitude),
                lng: parseFloat(asset.assetCoordinates[0].longitude)
            };
            editAssetMap = new google.maps.Map(document.getElementById('map_canvas_edit_asset'), {
                center: maplatlng,
                zoom: 13,
                fullscreenControl: true
            });


            if (asset.assetType.layout == 'SPREAD') {
                drawingManagerSpread();
                drawingManagerValue('polylinecomplete', editAssetMap);
            } else if (asset.assetType.layout == 'FIXED') {
                drawingManagerFixed();
                drawingManagerValue('click', editAssetMap);
            }
            if (asset.name && asset.name != null) {
                if (asset.assetType.layout == 'SPREAD') {
                    drawPolyline(function(polyline) {
                        polyline.setMap(editAssetMap);
                        google.maps.event.addListener(polyline.getPath(),
                            'insert_at',
                            function() {
                                setGoefenceCoordinate(polyline, true);
                            });
                        google.maps.event.addListener(polyline.getPath(),
                            'set_at',
                            function(path) {
                                setGoefenceCoordinate(polyline, true);
                            });

                        vm.drawingManager.setOptions({
                            drawingControl: false
                        });
                        vm.drawingManager.setMap(null);

                    })
                } else if (asset.assetType.layout == 'FIXED') {
                    setValues();
                    drawingManagerFixed();
                    drawMarker(editAssetMap, vm.coOrdinate);
                }

                function drawPolyline(callback) {
                    setValues();
                    var centerlatlng = {};
                    if (vm.coOrdinates.length > 1) {
                        vm.coOrdinates.forEach(function(value) {
                            centerlatlng = {
                                lat: value.lat,
                                lng: value.lng
                            };
                        });

                        callback(new google.maps.Polyline({
                            path: vm.coOrdinates,
                            geodesic: true,
                            strokeColor: vm.asset.assetType.colorcode,
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: vm.asset.assetType.colorcode,
                            fillOpacity: 0.3,
                            editable: true
                        }));
                        editAssetMap.setCenter(centerlatlng);
                    }
                }

            }
            var ele = document.getElementById("userPathModal");
            $(ele).modal('show');
            $("#userPathModal").show();


            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_edit_asset").css("width", "100%");
        }

        function hideConnectAssetsModal() {
            $("#connectAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectAssetsModal").hide();
        }

        function hideConnectSitesModal () {
            $("#connectAssetsModal").hide();
        }

        function connectSelectedAssets() {
            var ele = document.getElementById("connectAssetsModal");
            $(ele).modal('show');
            $("#connectAssetsModal").show();

            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_assets").css("width", "100%");
        }

		function hideConnectMultipleAssetsModal() {
            $("#connectMultipleAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectMultipleAssetsModal").hide();
			vm.tempLinkWithPits = [];
			initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                }
            }
        }

        function connectMultipleAssets() {
			vm.siteAssets = [];
			vm.tempLinkWithPits = [];
					
            var ele = document.getElementById("connectMultipleAssetsModal");
            $(ele).modal('show');
            $("#connectMultipleAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_multiple_assets").css("width", "100%");
			var multipleSiteMap = new google.maps.Map(document.getElementById('map_canvas_connect_multiple_assets'), {
                    center: new google.maps.LatLng(vm.mappedAssetsList[0].assetCoordinates[0].latitude, vm.mappedAssetsList[0].assetCoordinates[0].longitude),
                    zoom: 12,
                    fullscreenControl: true
                });
			for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED' && vm.mappedAssetsList[i].assetType.name == "Site" && vm.mappedAssetsList[i].id == null) {
					vm.siteAssets.push(vm.mappedAssetsList[i]);
                    createMarkerForSiteAsset(vm.mappedAssetsList[i], multipleSiteMap);
                }
            }
			
			vm.siteAssets.sort(function(assetA, assetB) {
                var assetATime = assetA.createDate,
                    assetBTime = assetB.createDate
                if (assetATime < assetBTime) // sort string ascending
                    return -1
                if (assetATime > assetBTime)
                    return 1
                return 0 // default return value (no sorting)
            });
			for(var siteIndex = 1; siteIndex < vm.siteAssets.length; siteIndex++){
				getPointsRoute(vm.siteAssets[siteIndex-1], vm.siteAssets[siteIndex], multipleSiteMap, 200);
			}
        }

		function recalculate(){
            var totalCost = 0;
            var totalPowerBudget = 0;
			var totalFiberDistance = 0.0;
            for (var assetIndex = 0; assetIndex < vm.mappedAssetsList.length; assetIndex++) {
                var isSpread = false;
                var fiberDistance = 0.0;

				if (vm.mappedAssetsList[assetIndex].assetType.layout == "SPREAD") {
					isSpread = true;
                    var spreadAV = vm.mappedAssetsList[assetIndex].assetTypeAttributeValues;
                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
                           fiberDistance = parseFloat("0"+spreadAV[spreadAssetIndex].attributeValue);
                        }
                    }
                }

				for(var attrIndex = 0;attrIndex < vm.mappedAssetsList[assetIndex].assetTypeAttributeValues.length;attrIndex++) {
					var item = vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[attrIndex];
                    var value = parseFloat(item.assetTypeAttribute.defaultValue);

                    if (item.assetTypeAttribute.name == "Cost") {
                        var tempCost = parseFloat(value);
                        if (isSpread) {
                            tempCost = parseFloat(value) * fiberDistance;
                        }
                        if (tempCost > 0) {
                            totalCost += tempCost
                        }
						item.attributeValue = value;
                    }
                    if (item.assetTypeAttribute.name == "Power Budget") {
                        var tempPowerBudget = parseFloat(value);
                        if (isSpread) {
                            tempPowerBudget = parseFloat(value) * fiberDistance;
                        }
                        if (tempPowerBudget > 0) {
                            totalPowerBudget += tempPowerBudget;
                        }
						item.attributeValue = value;
                    }
					vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[attrIndex] = item;
				}
				totalFiberDistance += fiberDistance;
            }

            var caseAV = vm.trCase.caseTypeAttributeValues;
            for (var caseIndex = 0; caseIndex < caseAV.length; caseIndex++) {
                if (caseAV[caseIndex].caseTypeAttribute.name === "Cost") {
                    caseAV[caseIndex].attributeValue = totalCost.toFixed(2);;
                }
                if (caseAV[caseIndex].caseTypeAttribute.name === "Power Budget") {
                    caseAV[caseIndex].attributeValue = totalPowerBudget.toFixed(2);;
                }
				if (caseAV[caseIndex].caseTypeAttribute.name === "Fiber Distance") {
                    caseAV[caseIndex].attributeValue = totalFiberDistance.toFixed(2);;
                }
            }
            vm.trCase.caseTypeAttributeValues = caseAV;
        }

        function connectAssets() {
            if (vm.isSiteASelected == false && vm.isSiteBSelected == false) {
                alert("Please Select Site A");
            } else if (vm.isSiteASelected == true && vm.isSiteBSelected == false) {
                alert("Please Select Site B");
            } else {
                var siteALatLng = new google.maps.LatLng(vm.selectedSiteA.assetCoordinates[0].latitude, vm.selectedSiteA.assetCoordinates[0].longitude);
                var siteBLatLng = new google.maps.LatLng(vm.selectedSiteB.assetCoordinates[0].latitude, vm.selectedSiteB.assetCoordinates[0].longitude);
                var map = new google.maps.Map(document.getElementById('map_canvas_connect_assets'), {
                    center: siteALatLng,
                    zoom: 16,
                    fullscreenControl: true
                });
                createMarker(map, vm.selectedSiteA.name, siteALatLng);
                createMarker(map, vm.selectedSiteB.name, siteBLatLng);

                getShortestRoute(vm.selectedSiteA, vm.selectedSiteB, map);
            }
        }

		function setValues() {
            vm.coOrdinates = [];
            for (var i = 0; i < vm.asset.assetCoordinates.length; i++) {
                vm.coOrdinates.push({
                    lat: vm.asset.assetCoordinates[i].latitude,
                    lng: vm.asset.assetCoordinates[i].longitude
                });
                if (i == vm.asset.assetCoordinates.length - 1) {
                    vm.coOrdinate = JSON.stringify(vm.coOrdinates);
                }
            }
        }

        $("#fromAssetsView").change(function() {
            $("#toAssetsView")[0].selectedIndex = 0;
            var result = $("#fromAssetsView").val();
            if (result != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].name == result) {
                        vm.selectedSiteA = vm.mappedAssetsList[i];
                    }
                }
                vm.isSiteASelected = true;
            }
        });

        $("#toAssetsView").change(function() {
            if (vm.isSiteASelected == true) {
                var result = $("#toAssetsView").val();
                if (result != null) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].name == result) {
                            vm.selectedSiteB = vm.mappedAssetsList[i];
                        }
                    }
                    vm.isSiteBSelected = true;
                }
            } else {
                $("#toAssetsView")[0].selectedIndex = 0;
                alert("Please Select Site A");
            }

        });

        function createMarker(map, assetName, myLatLng) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    scaledSize: new google.maps.Size(
                        24, 24),
                    origin: new google.maps.Point(0, 0),
                    url: 'content/images/yellow.png',
                    anchor: new google.maps.Point(
                        16, 16),

                },
                label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: assetName, backgroundcolor: "#ff9800" },
            });

        }

        function drawMarker(map, response) {
            $.each(JSON.parse(response), function (index, value) {
                centerlatlng = {
                    lat: value.lat,
                    lng: value.lng
                };

                if (marker) {
                    marker.setMap(null);
                }
                marker = new google.maps.Marker({
                    position: centerlatlng,
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(16, 16)
                    },
                });

                marker.setMap(map);
                vm.fixedArray = [];
                var coordinates = {};
                coordinates.latitude = centerlatlng.lat;
                coordinates.longitude =centerlatlng.lng;
                vm.fixedArray.push(coordinates);
                mappedAssetTemp.assetCoordinates = vm.fixedArray;
                addMappedAssets(mappedAssetTemp);
            });
        }

        function getShortestRoute(SiteA, SiteB, map) {
            var pointA = new google.maps.LatLng(SiteA.assetCoordinates[0].latitude, SiteA.assetCoordinates[0].longitude);
            var pointB = new google.maps.LatLng(SiteB.assetCoordinates[0].latitude, SiteB.assetCoordinates[0].longitude);

            var newAsset = {
                name: '',
                assetCoordinates: []
            };
            newAsset.name = SiteA.name + "-" + SiteB.name;

            var directionsService = new google.maps.DirectionsService;

            directionsService.route({
                origin: pointA,
                destination: pointB,
                avoidTolls: true,
                avoidHighways: false,
                provideRouteAlternatives: true,
                travelMode: google.maps.TravelMode.DRIVING
            }, function(response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    var responsePaths = response.routes;
                    responsePaths.forEach(function(pathVal, index) {
                        if (index < 3) {
                            vm.fixedArray = [];
							var route = pathVal;
			                var az = 0;
			                for (var i = 0; i < route.legs.length; ++i) {
			                    if (route.legs[i].distance) {
			                        az += route.legs[i].distance.value;
			                    }
			                }
							var polylinePathPoints = gMilestone(route, 100);
//                            var overViewPath = pathVal.overview_path;
                            polylinePathPoints.forEach(function(value) {
                                var coordinates = {};
                                coordinates.lat = value.lat();
                                coordinates.lng = value.lng();
                                vm.fixedArray.push(coordinates);
                            });
                            drawPolylineForSelectedPath(SiteA.name + "-" + SiteB.name, vm.fixedArray, map, index);
                        }
                    });
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
            return newAsset;
        }

        function drawPolylineForSelectedPath(assetName, spreadAssetCoordinates, map, index) {
            if (spreadAssetCoordinates.length > 0) {
                map.setZoom(14);

                var ColorValue = '#ff0000';
                if (index == 0) {
                    ColorValue = '#ff0000';
                } else if (index == 1) {
                    ColorValue = '#000000';
                } else {
                    ColorValue = '#208000';
                }

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(polylinepath, 'mouseover', function(event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    var pointContent = document.createElement('div'),
                        button;

                    pointContent.innerHTML = '<div class="infoWindowhead">Point ' + (index + 1) +
                        '</div>';
                    button = pointContent.appendChild(document.createElement('input'));
                    button.type = 'button';
                    button.value = 'Click to select';
                    button.className = "button";

                    google.maps.event.addDomListener(button, 'click', function() {
                        var newAsset = {};
                        newAsset.name = assetName;
                        newAsset.assetCoordinates = [];
                        spreadAssetCoordinates.forEach(function(assetCoor) {
                            newAsset.assetCoordinates.push({ latitude: assetCoor.lat, longitude: assetCoor.lng });
                        });

						AssetType.query({}, function(data) {
                            data.forEach(function(item) {
                                if (item.name == "Link") {
									vm.isShowing = false;
                                    newAsset.assetType = item;
                                    newAsset.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(newAsset.assetType);
//	                                $.each(newAsset.assetType.assetTypeAttributes,function(key, value) {
//	                                    newAsset.assetTypeAttributeValues.push({
//	                                            assetTypeAttribute: newAsset.assetType.assetTypeAttributes[key]
//	                                        });
//	                                });
									if (newAsset.assetType.layout == "SPREAD") {
										var fiberDistance = 0.0;
					                    var spreadCoordinates = newAsset.assetCoordinates;
					                    if (spreadCoordinates.length > 0) {
					                        for (var index in spreadCoordinates) {
					                            if (index > 0) {
					                                fiberDistance += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
					                            }
					                        }
					                    }
						                fiberDistance = fiberDistance.toFixed(2);
					                    var spreadAV = newAsset.assetTypeAttributeValues;
					                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
					                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
					                            spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
					                        }
					                    }
					                    newAsset.assetTypeAttributeValues = spreadAV;
					                }
	                                newAsset.isChecked = true;
	                                vm.mappedAssetsList.push(newAsset);
									initPlanningMap();
		                            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
		                                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
		                                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
		                                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
		                                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
		                                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i], assetCoordinateValues, assetsPlanningMap, "yellow");
		                                }
		                            }
                                }
                            });
                        });
                        hideConnectAssetsModal();
                    })

                    var infoWindow2 = new google.maps.InfoWindow({
                        content: pointContent,
                    });
                    infoWindow2.open(map);
                    infoWindow2.setPosition(event.latLng);
                    openedInfoWindow = infoWindow2;
                });
            }
        }

        function save() {
            vm.isShowing = false;
            vm.trCase.caseAssets = [];
			vm.trCase.deletedAssets = [];
			
            vm.mappedAssetsList.forEach(function(caseAssetVal) {
                if (caseAssetVal.isChecked) {
                    vm.trCase.caseAssets.push(caseAssetVal);
                }
            });

			vm.deletedAssetsList.forEach(function(asset){
				vm.trCase.deletedAssets.push(asset);
			});
			
            if (vm.trCase.caseAssets.length > 0) {
                vm.isShowing = true;
                vm.isSaving = true;
                var assignedToUser = $("#field_assignedToUser").val();
                vm.trCase.assignedTo = usersMap[assignedToUser];
                angular.forEach(vm.assetList, function(value, key) {
                    if (vm.trCase.asset.name === value.name) {
                        vm.trCase.asset = value;
                    }
                });

                if (vm.trCase.id !== null) {
                    TrCase.update(vm.trCase, onSaveSuccess, onSaveError);
                } else {
                    TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
                }
            } else {
                alert("No assets are mapped to this work flow");
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:trCaseUpdate', result);
            $state.go('tr-case');
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function selectedGroup(value){
            var input = document.getElementById("field_assignedToUser");
            input.value = '';
            vm.hideUser = false;
        }
        function filterActivatedUser() {
            if (vm.trCase.assignedToUser != null && vm.trCase.assignedToUser != "" && vm.trCase.assignedToUser != "." && !angular.isUndefined(vm.trCase.assignedToUser)) {
                $('input[name="assignedToUser"]').keyup(function () {
                    vm.user = $(this).val();
                });
                    ActivatedUserSearch.query({
                        // userId: vm.trCase.assignedToUser,
                        userId: vm.trCase.groups[0].id,
                        user: vm.user
                    }, onSuccess, onError);
                
                function onSuccess(data, headers) {
                    data.forEach(function (users) {
                        vm.assignedUsers.push(users.login);
                    });
                    vm.activatedusers = data;

                    angular.forEach(vm.activatedusers, function (value, key) {
                        usersMap[value.login] = value.id;

                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            
            }
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return (dist);
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
        $(document).on('change', 'input', function () {
            var options = $('datalist')[0].options;
            for (var i = 0; i < options.length; i++) {
                if (options[i].value == $(this).val()) {
                    if (vm.assignedUsers.includes($(this).val())) {
                        vm.validUser = false;
                    } else {
                        vm.validUser = true;
                    }
                    break;
                }
            }
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('trakeyeApp')
    .controller('TrCaseFiberCoreController', TrCaseFiberCoreController)

  TrCaseFiberCoreController.$inject = ['$timeout', '$scope', 'DEFAULT_LATITUDE', 'DEFAULT_LONGITUDE'];

  function TrCaseFiberCoreController($timeout, $scope, DEFAULT_LATITUDE, DEFAULT_LONGITUDE) {
    var vm = this;
    vm.tubeImagesOrder = tubeImagesOrder;
    vm.colors = ['blue','orange','green','brown','slate','white','red','black','yellow','violet','rose','aqua'];
    var fiberData = {
      madalTube: {
        tubeName: 'Duct#1 Cable',
        tubeModule: '8F * 6 core tubes',
        tubeType: '48F cable wire',
      },
      coreTube: [{
        tubeName: 'Duct#11 Cable',
        parentTube: 'Duct#1 Cable',
        tubeModule: '8F * 3 core tubes',
        tubeType: '24F cable wire'
      },
      {
        tubeName: 'Duct#12 Cable',
        parentTube: 'Duct#1 Cable',
        tubeModule: '8F * 3 core tubes',
        tubeType: '24F cable wire'
      }
      ],
      coreTubeChildA: 
        {
          tubeName: 'Duct#111 Cable',
          parentTube: 'Duct#11 Cable',
          tubeModule: '8F * 1 core tubes',
          tubeType: '8F cable wire'
        },
        // {
        //   tubeName: 'Duct#112 Cable',
        //   parentTube: 'Duct#11 Cable',
        //   tubeModule: '8F * 1 core tubes',
        //   tubeType: '8F cable wire'
        // },
        // {
        //   tubeName: 'Duct#113 Cable',
        //   parentTube: 'Duct#11 Cable',
        //   tubeModule: '8F * 1 core tubes',
        //   tubeType: '8F cable wire'
        // }
      coreTubeChildB: {
        tubeName: 'Duct#121 Cable',
        parentTube: 'Duct#2 Cable',
        tubeModule: '(8 + 4)F core tubes',
        tubeType: '12F cable wire'
      },
      coreTubeChildBZ: {
        tubeName: 'Duct#1211 Cable',
        parentTube: 'Duct#2 Cable',
        tubeModule: '6F core tubes',
        tubeType: '6F cable wire'
      },
      coreTubeChildAZ: {
        tubeName: 'Duct#1111 Cable',
        parentTube: 'Duct#3 Cable',
        tubeModule: '4F core tubes',
        tubeType: '4F cable wire'
      }

    }
    vm.selectedTube = fiberData;
    var modalTube = fiberData.madalTube;
    var coreTubeA = fiberData.coreTube[0];
    var coreTubeB = fiberData.coreTube[1];
    var coreTubeChildA = fiberData.coreTubeChildA;
    var coreTubeChildB = fiberData.coreTubeChildB;
    var coreTubeChildBZ = fiberData.coreTubeChildBZ;
    var coreTubeChildAZ  = fiberData.coreTubeChildAZ;
    $scope.showSelectColor = false;
    
    vm.coreSize = 0;
    
    vm.coreColor = function () { 
      $scope.showSelectColor = true
    }

    function selectedTubes(item) {
      if (item === '48F cable wire') {
        vm.cableId = modalTube.tubeName;
        vm.coreSize = 12;
        vm.tube01 = true;
        vm.tube02 = true;
        vm.tube03 = true;
        vm.tube04 = true;
      } else if (item === 'Duct#11 Cable') {
        vm.cableId = coreTubeA.tubeName
        vm.coreSize = 12;
        vm.tube01 = true;
        vm.tube02 = true;
        vm.tube03 = false;
        vm.tube04 = false;
      } else if (item === 'Duct#12 Cable') {
        vm.coreSize == 12;
        vm.cableId = coreTubeB.tubeName
        vm.tube01 = true;
        vm.tube02 = true;
        vm.tube03 = false;
        vm.tube04 = false;
      }
      else if (item === '12F cable wire') {
        vm.cableId = coreTubeChildA.tubeName
        vm.coreSize = 6;
        vm.tube01 = true;
        vm.tube02 = true;
        vm.tube03 = false;
        vm.tube04 = false;
      }
      else if (item === '8F cable wire') {
        vm.cableId = coreTubeChildB.tubeName
        vm.coreSize = 8;
        vm.tube01 = true;
        vm.tube02 = false;
        vm.tube03 = false;
        vm.tube04 = false;
      }
      else if (item === '6F cable wire'){
        vm.cableId = coreTubeChildBZ.tubeName
        vm.coreSize = 6;
        vm.tube01 = true;
        vm.tube02 = false;
        vm.tube03 = false;
        vm.tube04 = false;
      }else {
        vm.cableId = coreTubeChildAZ.tubeName
        vm.coreSize = 4;
        vm.tube01 = true;
        vm.tube02 = false;
        vm.tube03 = false;
        vm.tube04 = false;
      }
    }

    vm.closeTubeColors = function () {
      $scope.showSelectColor = false;
    }

    function tubeImagesOrder() {
      for (var i = 0; i < 5; i++) {
         tubeImages;
      }
    }

    var mapDiv = document.getElementById("map_canvas");
    var map1 = new google.maps.Map(mapDiv, {
      center: { lat: parseFloat(DEFAULT_LATITUDE.value), lng: parseFloat(DEFAULT_LONGITUDE.value) },
      zoom: 11,
    });
    //  <<<<<<< ========= ######## Duct#1 Cable   ######### ======= >>>>>>
    var flightPath = new google.maps.Polyline({
      strokeColor: "#0000ff",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flightPath.setMap(map1);
    var flightPlanCoordinates = [
      [23.862545, 90.487167],
      [23.851916, 90.468787],
      [23.831900, 90.448787],
      [23.756025, 90.390470]
    ];
    var path = flightPath.getPath();
    for (var i = 0; i < flightPlanCoordinates.length; i++) {
      //var loc = locations[i].split(',');
      var loc = flightPlanCoordinates[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      createInfoWindow(flightPath);
    }
    function createInfoWindow(flightPath) {
      google.maps.event.addListener(flightPath, 'mouseover', function (event) {
        infowindow.setContent(userContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        // selectedTubes(modalTube.tubeType);
      });
      google.maps.event.addListener(flightPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var userContent = document.createElement('div'),
        button;
      userContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + modalTube.tubeName + '</br>' +
        '<b>Core Module : </b> ' + modalTube.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + modalTube.tubeType + '</br>';
      button = userContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: userContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        // debugger;
        selectedTubes(modalTube.tubeType);
        $("#userPathModal").show();
        
      });

    }

    $scope.hideEditModal = function () {
      vm.cableId = " ";
      vm.coreType = " ";
      $scope.showSelectColor = false;
      $("#userPathModal").removeClass("in");
      $(".modal-backdrop").remove();
      $("#userPathModal").hide();
        vm.tube01 = false;
        vm.tube02 = false;
        vm.tube03 = false;
        vm.tube04 = false;
        
    }

    //  <<<<<<< ========= ######## Duct#2A Cable   ######### ======= >>>>>>
    var flyPath = new google.maps.Polyline({
      strokeColor: "#FFA500",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath.setMap(map1);
    var PlanCoordinates = [
      [23.908254, 90.597167],
      [23.862545, 90.487167],
    ];
    var path = flyPath.getPath();
    for (var i = 0; i < PlanCoordinates.length; i++) {
      var loc = PlanCoordinates[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showInfoWindow(flyPath);
    }
   
    function showInfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeB.tubeName);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeA.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeA.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeA.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeA.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        $("#userPathModal").show();
        selectedTubes(coreTubeA.tubeName);
      });

    }
    function showInfoBWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeB.tubeName);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeB.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeB.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeB.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeB.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeB.tubeName);
        $("#userPathModal").show();
      });

    }

    function showDuck03InfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeChildA.tubeType);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeChildA.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeChildA.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeChildA.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeChildA.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeChildA.tubeType);
        $("#userPathModal").show();
      });

    }

    function showDuck12fInfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeChildB.tubeType);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeChildB.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeChildB.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeChildB.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeChildB.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeChildB.tubeType);
        $("#userPathModal").show();
      });

    }

    function showDuck6fInfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeChildBZ.tubeType);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeChildBZ.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeChildBZ.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeChildBZ.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeChildBZ.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeChildBZ.tubeType);
        $("#userPathModal").show();
      });

    }

    function showDuck4fInfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeChildAZ.tubeType);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeChildAZ.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeChildAZ.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeChildAZ.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeChildAZ.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeChildAZ.tubeType);
        $("#userPathModal").show();
      });

    }




  //  <<<<<<< ========= ######## Duct#2 Cable   ######### ======= >>>>>>
    var flyPath1 = new google.maps.Polyline({
      strokeColor: "#FFA500",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath1.setMap(map1);
    var PlanCoordinates1 = [
      [23.938254, 90.487167],
      [23.862545, 90.487167],
    ];
    var path = flyPath1.getPath();
    for (var i = 0; i < PlanCoordinates1.length; i++) {
      var loc = PlanCoordinates1[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showInfoBWindow(flyPath1);
    }
    //  ######## =========  #########

    //  <<<<<<< ========= ######## Duct#3 8f Cable   ######### ======= >>>>>>
    var flyPathA = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathA.setMap(map1);
    var PlanCoordinatesA = [
      [23.973854,90.639167],
      [23.943254,90.629967],
      [23.908254,90.597167]
    ];
    var path = flyPathA.getPath();
    for (var i = 0; i < PlanCoordinatesA.length; i++) {
      var loc = PlanCoordinatesA[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck03InfoWindow(flyPathA);
    }
    //  ######## =========  #########

    //  <<<<<<< ========= ######## Duct#3 8f Cable   ######### ======= >>>>>>
    var flyPathB = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathB.setMap(map1);
    var PlanCoordinatesB = [
      [23.982525,90.672459],
      [23.952545,90.659999],
      [23.932254,90.639167],
      [23.908254,90.597167]
    ];
    var path = flyPathB.getPath();
    for (var i = 0; i < PlanCoordinatesB.length; i++) {
      var loc = PlanCoordinatesB[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck03InfoWindow(flyPathB);
    }
    // ##===== #### =======###
    
    //  <<<<<<< ========= ######## Duct#3 8f Cable   ######### ======= >>>>>>
    var flyPathC = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathC.setMap(map1);
    var PlanCoordinatesC = [
      [23.856254,90.639888],
      [23.893254,90.619167],
      [23.908254,90.597167]
    ];
    var path = flyPathC.getPath();
    for (var i = 0; i < PlanCoordinatesC.length; i++) {
      var loc = PlanCoordinatesC[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck03InfoWindow(flyPathC);
    }

     //  <<<<<<< ========= ######## Duct#3 4f Cable   ######### ======= >>>>>>
     var flyPathC1 = new google.maps.Polyline({
      strokeColor: "#A52A2A",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathC1.setMap(map1);
    var PlanCoordinatesC1 = [
      [23.826254,90.609888],
      [23.836254,90.619888],
      [23.846254,90.629888],
      [23.856254,90.639888]
    ];
    var path = flyPathC1.getPath();
    for (var i = 0; i < PlanCoordinatesC1.length; i++) {
      var loc = PlanCoordinatesC1[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck4fInfoWindow(flyPathC1);
    }

    //  <<<<<<< ========= ######## Duct#3 4f Cable   ######### ======= >>>>>>
    var flyPathC2 = new google.maps.Polyline({
      strokeColor: "#A52A2A",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathC2.setMap(map1);
    var PlanCoordinatesC2 = [
      [23.886254,90.669888],
      [23.876254,90.659888],
      [23.866254,90.649888],
      [23.856254,90.639888]
    ];
    var path = flyPathC2.getPath();
    for (var i = 0; i < PlanCoordinatesC2.length; i++) {
      var loc = PlanCoordinatesC2[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck4fInfoWindow(flyPathC2);
    }


    //  <<<<<<< ========= ######## Duct#3 12f Cable   ######### ======= >>>>>>
    
     var flyPath2 = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath2.setMap(map1);
    var PlanCoordinates2 = [
      [23.998254,90.537167],
      [23.988254,90.517167],
      [23.938254,90.487167]
    ];
    var path = flyPath2.getPath();
    for (var i = 0; i < PlanCoordinates2.length; i++) {
      var loc = PlanCoordinates2[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck12fInfoWindow(flyPath2);
    }
   
     //  <<<<<<< ========= ######## Duct#3 12f Cable   ######### ======= >>>>>>
     var flyPath3 = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath3.setMap(map1);
    var PlanCoordinates3 = [
      [23.948254,90.557167],
      [23.938254,90.487167]
    ];
    var path = flyPath3.getPath();
    for (var i = 0; i < PlanCoordinates3.length; i++) {
      var loc = PlanCoordinates3[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck12fInfoWindow(flyPath3);
    }

    //  <<<<<<< ========= ######## Duct#3 6f Cable   ######### ======= >>>>>>
     var flyPath4 = new google.maps.Polyline({
      strokeColor: "#A52A2A",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath4.setMap(map1);
    var PlanCoordinates4 = [
      [23.999254,90.588167],
      [23.969254,90.578167],
      [23.959254,90.568167],
      [23.948254,90.557167]
    ];
    var path = flyPath4.getPath();
    for (var i = 0; i < PlanCoordinates4.length; i++) {
      var loc = PlanCoordinates4[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck6fInfoWindow(flyPath4);
    }
 //  <<<<<<< ========= ######## Duct#3 6f Cable   ######### ======= >>>>>>
    var flyPath5 = new google.maps.Polyline({
      strokeColor: "#A52A2A",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath5.setMap(map1);
    var PlanCoordinates5 = [
      [23.899254,90.528167],
      [23.929254,90.538167],
      [23.939254,90.548167],
      [23.948254,90.557167]
    ];
    var path = flyPath5.getPath();
    for (var i = 0; i < PlanCoordinates5.length; i++) {
      var loc = PlanCoordinates5[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck6fInfoWindow(flyPath5);
    }
    

  }
})();





(function () {
	'use strict';

	angular.module('trakeyeApp').controller('TrCaseDialogController', TrCaseDialogController).directive('mySrc', function () {
		return {
			restrict: 'A',
			scope: {
				callback: '&'
			},
			link: function (scope, elem, attrs) {
				elem.attr('src', scope.callback());
			}
		};
	})
	TrCaseDialogController.$inject = ['$rootScope', '$timeout', '$scope', 'DEFAULT_LATITUDE', 'DEFAULT_LONGITUDE', '$stateParams', '$q', 'entity', 'TrCase', 'UserGroupIDs', 'User', 'CaseType', 'Principal', 'Asset', '$state', 'ActivatedUsers', 'UserValueSearch',
		'AlertService', 'ActivatedUserSearch', 'TrCaseUpload', 'AssetSearchForMap', 'AssetSearch', 'AllCaseTypes', 'TrCaseImages', 'AllCustomCaseTypeAttribute', 'AssetGroupES', 'AssetByID', 'UserAccount', 'GeofenceIDs', 'UserGeofences', 'Geofence', '$ngConfirm', 'AssocitedVendorSearch'
	,'NearByBGOH','AttributeMappingId','getCaseImage','$localStorage','AttributeMappingList','Configs','FileUploadService'];

	function TrCaseDialogController($rootScope, $timeout, $scope, DEFAULT_LATITUDE, DEFAULT_LONGITUDE, $stateParams, $q, entity, TrCase, UserGroupIDs, User, CaseType, Principal, Asset, $state, ActivatedUsers, UserValueSearch, AlertService, ActivatedUserSearch,
		TrCaseUpload, AssetSearchForMap, AssetSearch, AllCaseTypes, TrCaseImages, AllCustomCaseTypeAttribute, AssetGroupES, AssetByID, UserAccount, GeofenceIDs, UserGeofences, Geofence, $ngConfirm, AssocitedVendorSearch,NearByBGOH,AttributeMappingId,getCaseImage,$localStorage,AttributeMappingList,Configs,FileUploadService) {
		var vm = this;

		vm.trCase = entity;
		vm.showCaseAttachment = false

		var entity_old = angular.copy(vm.trCase);
		// vm.caseImages; // = entity_old.caseImages;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.save = save;
		vm.submit = submit
		vm.decodeImage = decodeImage;
		vm.filterUser = filterUser;
		vm.filterActivatedUser = filterActivatedUser;
		vm.assetList = "";
		vm.filterAssetsList = filterAssetsList;
		vm.getAssetAddress = getAssetAddress;
		vm.filterAssetsOnMapView = filterAssetsOnMapView;
		vm.closeMapFilterModal = closeMapFilterModal;
		vm.closePopupDialogModal = closePopupDialogModal;
		vm.saveFilter = saveFilter;
		vm.showExisting = showExisting;
		vm.customAttributesMap = {};
		vm.customAttributesMapp = [];
		var usersMap = {};
		var openedInfoWindow = null;
		var locations = {};
		var prevInfoWindow = null;
		vm.checkattributeMappingList = []
		vm.closeModal = closeModal
		vm.showCableSplice = false
		vm.showFmsTermination = false
		vm.saveDetails = saveDetails
		// vm.showAddressAddress = true;

		var markers = [];
		var polylines = [];
		var noDataText = null;
		vm.userGeofences = [];
		vm.canFilter = false;

		vm.userAdmin = {};
		vm.userGeofenceList = null;

		$scope.allimages = false;

		vm.prevStatus = vm.trCase.status;

		vm.img;
		var attachment,maxSize;

		/* if(vm.trCase.id){
			vm.assetName = vm.trCase.caseAssets.length > 0 ? " - " + vm.trCase.caseAssets[0].name + ' (Asset Name)' : "Edit Case"
		}

		if($rootScope.createCaseFromAssetMap){
			vm.assetNameInCreate = $rootScope.createCaseFromAssetMap.length > 0 ? " - " + $rootScope.createCaseFromAssetMap[0].name + ' (Asset Name)' : "Create Case"
		} */

		$scope.getImage = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%" src="data:image/jpeg;base64,' +
                    img +
                    '" >'
            );
            imgWindow.document.close(); 
		};

		$scope.toggle = function (id) {
            switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrCaseImages.query(
                            {
                                caseId: vm.trCase.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');
                            vm.caseImages = data.filter(function(caseImages){
                                return caseImages.image
                             });
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getCaseImage.get(vm.trCase.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }
        };
		vm.trCase.caseImages = [];

		$(".select2").select2(); // Added search for select box
		// Added for upload
		$(":file").filestyle({
			buttonBefore: true
		});
		$(":file").filestyle('buttonText', 'Browse File');
		vm.caseTypes = loadPage(); // CaseType.query();
		vm.selectAttributes = selectedCaseTypeAttributes;
		$timeout(function () {
			angular.element('.form-group:eq(1)>input').focus();
		});

		vm.checkFrtPat = false

		$scope.editDetails = function (id, name) {
			vm.editDetails = false
			vm.new = JSON.parse(JSON.stringify(vm.trCase));
            switch (name) {
                case "cableDetails":
                    vm.selectedCable = id;
                    $("#cableDetails").show();
                    break;
                case "splicingDetails":
                    vm.selectedSlicing = id;
                    $("#splicingDetails").show();
                    break;
                case "fmsDetails":
					vm.selectedFms = id;
                    $("#fmsDetails").show();
                    break;
                case "terminationDetails":
					vm.selectedTermination = id;
                    $("#terminationDetails").show();
                    break;
                default:
                    console.log("");
            }
        };
		
		$scope.addDetails = function (id) {
			vm.editDetails = true
            switch (id) {
                case "cableDetails":
                    if (vm.trCase.cableDetails != null) {
                        vm.trCase.cableDetails.length++;
                        vm.selectedCable = vm.trCase.cableDetails.length - 1;

                        if (
                            vm.trCase.splicingDetails.length > 0 &&
                            vm.trCase.cableDetails.length > 0
                        ) {
                            vm.isSaving = false;
                        }
                    }
                    $("#cableDetails").show();
                    break;
                case "splicingDetails":
                    if (vm.trCase.splicingDetails != null) {
                        vm.trCase.splicingDetails.length++;
                        vm.selectedSlicing =
                            vm.trCase.splicingDetails.length - 1;

                        if (
                            vm.trCase.splicingDetails.length > 0 &&
                            vm.trCase.cableDetails.length > 0
                        ) {
                            vm.isSaving = false;
                        }
                    }
                    $("#splicingDetails").show();
                    break;
                case "fmsDetails":
					if (vm.trCase.fmsAndCableDetails != null) {
                        vm.trCase.fmsAndCableDetails.length++;
                        vm.selectedFms =
                            vm.trCase.fmsAndCableDetails.length - 1;

                        if (
                            vm.trCase.fmsAndCableDetails.length > 0 &&
                            vm.trCase.terminationDetails.length > 0
                        ) {
                            vm.isSaving = false;
                        }
                    }
                    $("#fmsDetails").show();
                    break;
                case "terminationDetails":
					if (vm.trCase.terminationDetails != null) {
                        vm.trCase.terminationDetails.length++;
                        vm.selectedTermination =
                            vm.trCase.terminationDetails.length - 1;

                        if (
                            vm.trCase.fmsAndCableDetails.length > 0 &&
                            vm.trCase.terminationDetails.length > 0
                        ) {
                            vm.isSaving = false;
                        }
                    }
                    $("#terminationDetails").show();
                    break;
                default:
                    console.log("");
            }
        };

		$scope.removeDetails = function (id, name) {
            switch (name) {
                case "cableDetails":
                    vm.trCase.cableDetails.splice(id, 1);
                    if (vm.trCase.cableDetails.length == 0) {
                        vm.isSaving = true;
                    }
                    break;
                case "splicingDetails":
                    vm.trCase.splicingDetails.splice(id, 1);
                    if (vm.trCase.splicingDetails.length == 0) {
                        vm.isSaving = true;
                    }
                    break;
                case "fmsDetails":
					vm.trCase.fmsAndCableDetails.splice(id, 1);
                    if (vm.trCase.fmsAndCableDetails.length == 0) {
                        vm.isSaving = true;
                    }
                    break;
                case "terminationDetails":
					vm.trCase.terminationDetails.splice(id, 1);
                    if (vm.trCase.terminationDetails.length == 0) {
                        vm.isSaving = true;
                    }
                    break;
                default:
                    console.log("");
            }
        };

		function saveDetails(id) {
            switch (id) {
                case "cableDetails":
                    if (vm.trCase.cableDetails[vm.selectedCable] == null) {
                        vm.trCase.cableDetails.splice(vm.selectedCable, 1);
                    }
                    break;
                case "splicingDetails":
                    if (vm.trCase.splicingDetails[vm.selectedSlicing] == null) {
                        vm.trCase.splicingDetails.splice(vm.selectedSlicing, 1);
                    }
                    break;
                case "fmsDetails":
					if (vm.trCase.fmsAndCableDetails[vm.selectedFms] == null) {
                        vm.trCase.fmsAndCableDetails.splice(vm.selectedFms, 1);
                    }
                    break;
                case "terminationDetails":
					if (vm.trCase.terminationDetails[vm.selectedTermination] == null) {
                        vm.trCase.terminationDetails.splice(vm.selectedTermination, 1);
                    }
                    break;
                default:
                    console.log("");
            }

            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

		function loadPage() {
			if(vm.trCase.id ==  null){
				vm.isSaving = true
			}
			
			Configs.get("MaxFileSize",function(response){
				maxSize = response[0].configValue
			})

			if(vm.trCase.id){
				Configs.get("CaseImage",function(response){
					if(response.length > 0){
						if(response[0].configValue == "True"){
							vm.showCaseAttachment = true
						}
					}
				})
			}

			vm.multiGroup = [];
			var selectedGroup = [];

			if (vm.trCase.id != null) {
				vm.trCase.groups.forEach(function (group) {
					selectedGroup.push(group.id);
				});
			}

			ReverseGeocode(parseFloat(vm.trCase.pinLat), parseFloat(vm.trCase.pinLong));
			AllCaseTypes.getAll(function (response) {
				vm.caseTypes = response;
			});

			if(vm.trCase.id){
				if(vm.trCase.caseType.name == "Splicing Details"){
					vm.showCableSplice = true;
					Configs.get("CableSide",function(response){ 
						vm.cableSide = response
					})
					Configs.get("CableName",function(response){ 
						vm.cableName = response
					})
					Configs.get("JEAvailability",function(response){ 
						vm.jeAvailability = response
					})
					Configs.get("CableCapacity",function(response){ 
						vm.cableCapacity = response
					})
					Configs.get("TubeSide",function(response){ 
						vm.tubeSide = response
					})
					Configs.get("JENumber",function(response){ 
						vm.jeNumber = response
					})
				}

				if(vm.trCase.caseType.name == "Termination Details"){
					vm.showFmsTermination = true; 
					Configs.get("CableSide",function(response){ 
						vm.cableSide = response
					})
					Configs.get("FMSNumber",function(response){ 
						vm.fmsNumber = response
					}) 
					Configs.get("FMSCapacity",function(response){ 
						vm.fmsCapacity = response
					}) 
					Configs.get("FMS",function(response){ 
						vm.fms = response
					}) 
					Configs.get("Type",function(response){ 
						vm.type = response
					}) 
					Configs.get("CableNumber",function(response){ 
						vm.cableNumber = response
					}) 
				}
			}
			
			UserGroupIDs.getAll(function (response) {
				response.forEach(function (group) {
					if (selectedGroup.indexOf(group.id) !== -1) {
						vm.multiGroup.push({ name: group.name, id: group.id, ticked: true });
					} else {
						vm.multiGroup.push({ name: group.name, id: group.id, ticked: false });
					}
				});
			});

			AllCustomCaseTypeAttribute.getAll(function (response) {
				//vm.customCaseTypeAttributes = response;
				response.forEach(function (arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customCaseTypeAttributeValues;
					vm.customAttributesMap[arrayItem.name].parentId = arrayItem.id
				});

				if(vm.trCase.id){
					var getSelectedName = []
					vm.trCase.caseTypeAttributeValues.forEach(function (val){
						if(val.caseTypeAttribute.attributeDataType.name == 'STRING' ||
						val.caseTypeAttribute.attributeDataType.name == 'FLOAT' ||
						val.caseTypeAttribute.attributeDataType.name == 'INTEGER' ||
						val.attributeValue == null){
							
						}else{
							getSelectedName.push(val)
						}
					})

					getSelectedName.forEach(function(item){ 
						vm.customAttributesMap[item.caseTypeAttribute.attributeDataType.name].forEach(function(item1){
							if(item.attributeValue == item1.value){
								AttributeMappingId.get(item1.id,function(res){ 
									res.forEach(function(val){
										if(vm.customAttributesMap[val.parentValue].parentId == val.parentId){
												vm.customAttributesMap[val.parentValue].length = 0
										}
									}) 
								res.forEach(function(val){
									vm.customAttributesMap[val.parentValue].push({id : val.id , value : val.value, parentId : val.parentId})
								})  
								})
							}
						})
					 })
				}

				/* response.forEach(function (arrayItem) {
					vm.customAttributesMapp.push({ name : arrayItem.name ,customValues : arrayItem.customCaseTypeAttributeValues});
				});

				 if(vm.trCase.id){
					var getSelectedName = []
					vm.trCase.caseTypeAttributeValues.forEach(function (val){
						if(val.caseTypeAttribute.attributeDataType.name == 'STRING' ||
						val.caseTypeAttribute.attributeDataType.name == 'FLOAT' ||
						val.caseTypeAttribute.attributeDataType.name == 'INTEGER' ||
						val.attributeValue == null){
							
						}else{
							getSelectedName.push(val)
						}
					})
					getSelectedName.forEach(function(item){
						 vm.customAttributesMapp.forEach(function(valueParam){
							if(valueParam.name == item.caseTypeAttribute.attributeDataType.name){
								valueParam.customValues.forEach(function(getId){
									if(getId.value  == item.attributeValue){
										AttributeMappingId.get(getId.id,function(res){
											if(res.length > 0){
												res.forEach(function(val){
													if(vm.customAttributesMap[val.parentValue].parentId == val.parentId){
															vm.customAttributesMap[val.parentValue].length = 0
													}
											}) 
											res.forEach(function(val){
												vm.customAttributesMap[val.parentValue].push({id : val.id , value : val.value, parentId : val.parentId})
											}) 
											}
										})
									}  
								})
							}
							 
						}) 
				   }) }  */
				   if(vm.trCase.id){
					$(":file").filestyle({
						buttonBefore: true
					});
					$(":file").filestyle('buttonText', 'Browse File');
				   }
				   AttributeMappingList.query(
					{
						page: 0,
						size: 1000,
						sort: "id,asc",
					},
					onSuccess,
					onError
				);
				function onSuccess(data, headers) {
					vm.attributeMappingList = data;
					vm.attributeMappingList.forEach(function (val){
						vm.checkattributeMappingList.push(val.caseTypeSubCategory.id)
					})
				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			});

			UserAccount.get(function (data) {
				vm.userAdmin = data;
				vm.reportToId = data.id
				var isAdmin = false;
				data.authorities.forEach(function (val) {
					if(val == 'ROLE_FRT' || val == 'ROLE_PATROLLER' ){
						vm.checkFrtPat = true
						vm.isSaving = false
					}

					if (val == "ROLE_USER_ADMIN") {
						isAdmin = true;
					}
					if (val == "ROLE_HOD") {
						isAdmin = true;
					}
				});
				if (isAdmin) {
					GeofenceIDs.getAll(function (response) {
						response.forEach(function (geofence) {
							if (geofence.name != 'Bangalore') {
								vm.userGeofences.push(geofence);
								if (vm.selectedGeofenceId == null) {
									vm.selectedGeofenceId = geofence.id;
									vm.canFilter = true;
								}
							}
						});
						setCaseGeofences();
					});
				} else {
					UserGeofences.getAll(function (response) {
						vm.userGeofenceList = response;
						response.forEach(function (geofence) {
							if (geofence.name != 'Bangalore') {
								vm.userGeofences.push(geofence);
								if (vm.selectedGeofenceId == null) {
									vm.selectedGeofenceId = geofence.id;
									vm.canFilter = true;
								}
							}
						});
						setCaseGeofences();
					});
				}
			});
		}

		function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

		function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
			var locationButton = document.createElement("button");
			locationButton.setAttribute("title","Locate Me");
			locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon)
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
							infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");	
                            infoWindow.open(map);
                            map.setCenter(pos);
							map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

		function ReverseGeocode(latitude, longitude) {
			var address = new google.maps.Geocoder();

			address.geocode({
				'latLng': { lat: latitude, lng: longitude }
			}, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					if (results[0]) {
						vm.trCase.address = results[0].formatted_address;
					}
				}
			});
		}
		 function showExisting(){
			TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
		}
	      
		$scope.attributeMappingChange = function(id){
			var passId;
			vm.customAttributesMap[id.caseTypeAttribute.attributeDataType.name].forEach(function(val){
				if(val.value  == id.attributeValue){
					passId = val.id
				}
			}) 
				AttributeMappingId.get(passId,function(res){
					if(res.length > 0){
						res.forEach(function(val){
								if(vm.customAttributesMap[val.parentValue].parentId == val.parentId){
										vm.customAttributesMap[val.parentValue].length = 0
								}
						}) 
						res.forEach(function(val){
							vm.customAttributesMap[val.parentValue].push({id : val.id , value : val.value, parentId : val.parentId})
						}) 
					} else{
						if(vm.checkattributeMappingList.indexOf(passId) == -1 ){
								AllCustomCaseTypeAttribute.getAll(function (response) {
								response.forEach(function (arrayItem) {
									vm.customAttributesMap[arrayItem.name] = arrayItem.customCaseTypeAttributeValues;
									vm.customAttributesMap[arrayItem.name].parentId = arrayItem.id
								}); 
								
							})
						} 
					} 
					/* if(res.length > 0){
						res.forEach(function(val){
								if(vm.customAttributesMap[val.parentValue].parentId == val.parentId){
										vm.customAttributesMap[val.parentValue].length = 0
								}
						}) 
						res.forEach(function(val){
							vm.customAttributesMap[val.parentValue].push({id : val.id , value : val.value, parentId : val.parentId})
						}) 
					} else{
							AllCustomCaseTypeAttribute.getAll(function (response) {
								response.forEach(function (arrayItem) {
									vm.customAttributesMap[arrayItem.name] = arrayItem.customCaseTypeAttributeValues;
									vm.customAttributesMap[arrayItem.name].parentId = arrayItem.id
								}); 
							})
					} */
				})
		}

		function save() {
			//vm.isSaving = true;
			if(vm.trCase.groups.length == 0 || vm.trCase.assignedToUser == null){
				vm.isSaving = true
			}
			if($rootScope.createCaseFromAssetMap){
				vm.trCase.caseAssets = $rootScope.createCaseFromAssetMap
			}

			if(vm.showCableSplice || vm.showFmsTermination){
				vm.trCase.priority = "LOW"
			}
			
			vm.trCase.submitted = false;
			if(vm.caseType.name != 'Vendor Civil Work'){
				var assignedToUser = $("#field_assignedToUser").val();
				if(vm.checkFrtPat){
					vm.trCase.reportedBy = vm.reportToId;
				}else{
					vm.trCase.assignedTo = usersMap[assignedToUser];
				}
			}
			angular.forEach(vm.assetList, function (value, key) {
				if (vm.trCase.asset.name === value.name) {
					vm.trCase.asset = value;
				}
			});
			var mandatoryCaseAttr = checkMandatoryAttributes(vm.trCase.caseTypeAttributeValues);
			if (mandatoryCaseAttr.length > 0) {
				// alert(mandatoryCaseAttr);

				var ele = document.getElementById("popupDialogModal");
				$(ele).modal('show');
				$("#popupDialogModal").show();
				$("#alertMessage").html("--- Mandatory Attributes --- <br />" + mandatoryCaseAttr.split(",").join("<br />"));
				vm.isSaving = false;
			} else {
				
					if (vm.trCase.id !== null && vm.trCase.assignedToUser != null) {
						TrCase.update(vm.trCase, onSaveSuccesss, onSaveError);
				} else {
					if(vm.caseType.name == 'UG OH Declaration'){ 
						
						NearByBGOH.getAll(vm.trCase, onSuccess, onError)
							function onSuccess(data) {
								//vm.isSaving = false;
								if(data.length > 0){
									$("#existingAsset").show();
								}else{
									TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
								}
							}
	
							function onError(error) {
								/* vm.handlingError = error
								vm.isSaving = false
								AlertService.error(error); */
								if(error == 404){
									TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
								}
							} 
						
					}else {
						TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
					}
				}
				

				
			}
		}
		
		function submit() {
			vm.isSaving = true;
			vm.trCase.submitted = true;
			var assignedToUser = $("#field_assignedToUser").val();
			vm.trCase.assignedTo = usersMap[assignedToUser];
			angular.forEach(vm.assetList, function (value, key) {
				if (vm.trCase.asset.name === value.name) {
					vm.trCase.asset = value;
				}
			});
			var mandatoryCaseAttr = checkMandatoryAttributes(vm.trCase.caseTypeAttributeValues);
			if (mandatoryCaseAttr.length > 0) {
				// alert(mandatoryCaseAttr);

				var ele = document.getElementById("popupDialogModal");
				$(ele).modal('show');
				$("#popupDialogModal").show();
				$("#alertMessage").html("--- Mandatory Attributes --- <br />" + mandatoryCaseAttr.split(",").join("<br />"));
				vm.isSaving = false;
			} else {
				if (vm.trCase.id !== null) {
					TrCase.update(vm.trCase, onSaveSuccess, onSaveError);
				} else {
					TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
				}
			}
		}
		function checkMandatoryAttributes(caseTypeAttribute) {
			var resStr = "";
			
			caseTypeAttribute.forEach(function (value) {
				if (value.caseTypeAttribute.mandatory) {
					if (value.attributeValue == "" || value.attributeValue == "." || value.attributeValue == null) {
						if (((!vm.trCase.id && (value.caseTypeAttribute.caseCategory == 'CATEGORY1' || value.caseTypeAttribute.caseCategory == 'DEFAULT' || value.caseTypeAttribute.caseCategory == null))
							|| (vm.trCase.id && ((vm.prevStatus != 'ASSIGNED' && vm.prevStatus == 'NEW') || (vm.prevStatus != 'NEW' && vm.prevStatus == 'ASSIGNED')) && (value.caseTypeAttribute.caseCategory == 'CATEGORY1' || value.caseTypeAttribute.caseCategory == 'DEFAULT' || value.caseTypeAttribute.caseCategory == null))
							|| (vm.trCase.id && vm.prevStatus != 'ASSIGNED' && vm.prevStatus != 'NEW') || (vm.trCase.id && vm.prevStatus == 'ASSIGNED'  && $rootScope.has_ROLE_FRT && vm.trCase.caseType.name=='Incident Management')
							|| (vm.trCase.id && vm.prevStatus=='ASSIGNED' && (vm.trCase.caseType.name!='Issue on Field' && vm.trCase.caseType.name!='Asset Safety Related' && vm.trCase.caseType.name!='Productivity & NTP' && vm.trCase.caseType.name!='PM Activity' && vm.trCase.caseType.name!='UG OH Declaration' && vm.trCase.caseType.name!='Fiber Provisioning' && vm.trCase.caseType.name!='Chamber Declaration' && vm.trCase.caseType.name!='Vendor Civil Work' && vm.trCase.caseType.name!='Incident Management')))) /*FIBERIFY-482*/{
							if (resStr.length == 0) {
								resStr = value.caseTypeAttribute.name;
							} else {
								resStr = resStr + ", " + value.caseTypeAttribute.name;
							}
						}
					}
				}
			});

			/* caseTypeAttribute.forEach(function (value) { 
				var intial = value.attributeValue
				var parsedValue = JSON.parse(intial)
				value.attributeValue = parsedValue.value
			}) */
			return resStr;
		}

		$("#caseImages").change(function () {

			var files = document.getElementById("caseImages").files;
			vm.fileWarning = false;
			vm.selectedFiles = [];

			for (var i = 0; i < files.length; i++) {

				var file = files[i];
				if (file.size > maxSize) {
					vm.fileWarning = true;
					continue;
				}
				var allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'video/mp4'];

				if (allowedTypes.indexOf(file.type) === -1) {
					vm.fileWarning = true;
					continue;
				}

				vm.selectedFiles.push(file);
			}

			if (!$scope.$$phase) {
				$scope.$apply();
			}
		});
		function finishCaseSave(result) {

			$scope.$emit('trakeyeApp:trCaseUpdate', result);

			vm.selectedFiles = [];
			$("#caseImages").val("");

			vm.isSaving = false;

			$state.go('tr-case');
		}
        vm.uploadCaseImage = function (callback) {

			if (!vm.selectedFiles || vm.selectedFiles.length === 0) {
				if (callback) callback();
				return;
			}

			var uploadCount = 0;
			var totalFiles = vm.selectedFiles.length;

			angular.forEach(vm.selectedFiles, function (file) {

				var fileType = file.type.split('/')[1];
				var finalFileName = new Date().getTime() + "_" + file.name;

				FileUploadService.uploadFile(
					file,
					vm.trCase.id,
					fileType,
					finalFileName,
					function (success) {

						uploadCount++;

						if (!success) {
							console.log("Upload failed:", file.name);
						}

						if (uploadCount === totalFiles) {
							console.log("All uploads finished");
							if (callback) callback();
						}
					}
				);
			});
		};
		$("#attachmentFile").change(function () { 
			attachment = document.getElementById("attachmentFile").files[0];
			vm.fileWarnings = (attachment.size > maxSize) ? true : false
			$scope.$apply();
		})
		
		$scope.deleteDisplayImage = function(id){
            vm.trCase.caseImages.splice(id,1)
        }

		$scope.newTabDisplay = function(id){
            var request = new XMLHttpRequest();
            request.open('GET',"api/trakeyecaseimages/"+vm.trCase.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                window.open(imageUrl, "_blank")}
            } 
            request.send();
        } 

		function onSaveSuccesss(result) {
			if(vm.showCaseAttachment){
				if(attachment && attachment.type == "application/pdf" && attachment.size <= maxSize){
					var req = new XMLHttpRequest();
					var formData = new FormData();
					var name = attachment.name.split(".")[0];
					var type = attachment.name.split(".")[1];
					formData.append("file", attachment);
					req.open(
						"POST",
						"api/trakeyecaseimages/" +
							vm.trCase.id +
							"/" +
							name +
							"/" +
							type
					);
					req.setRequestHeader(
						"Authorization",
						"Bearer " + $localStorage.authenticationToken
					);
					req.send(formData);
					} 
			}
			$scope.$emit('trakeyeApp:trCaseUpdate', result);
			$state.go('tr-case');
			// $uibModalInstance.close(result);
			vm.isSaving = false;
			vm.trCase = result;   
			vm.trCase.id = result.id;  
			if (vm.selectedFiles && vm.selectedFiles.length > 0) {
				vm.uploadCaseImage(function () {
					finishCaseSave(result);
				});
			} else {
				finishCaseSave(result);
			}
		}

		function onSaveSuccess(result) {
			$scope.$emit('trakeyeApp:trCaseUpdate', result);
			$state.go('tr-case');
			// $uibModalInstance.close(result);
			vm.isSaving = false;
			vm.trCase = result;   
			vm.trCase.id = result.id;  
			if (vm.selectedFiles && vm.selectedFiles.length > 0) {
				vm.uploadCaseImage(function () {
					finishCaseSave(result);
				});

			} else {

				finishCaseSave(result);
			}
		}
		vm.caseType = entity.caseType;

		function selectedCaseTypeAttributes() {
			vm.showCableSplice = false;
			vm.showFmsTermination = false;
			$scope.allpdf = false;
			$scope.cableDetails = false;
			$scope.splicingDetails = false;
			$scope.fmsDetails = false;
			$scope.terminationDetails = false;
			vm.showTermination = false; 
			vm.showFMS = false;
			vm.showSplicing = false;
			vm.showCable = false;
			vm.showPdf = false;

			if(vm.caseType.name == "Splicing Details"){
				vm.trCase.cableDetails = []
				vm.trCase.splicingDetails = []
				vm.showCableSplice = true;
				vm.isSaving = true
				Configs.get("CableSide",function(response){ 
					vm.cableSide = response
				})
				Configs.get("CableName",function(response){ 
					vm.cableName = response
				})
				Configs.get("JEAvailability",function(response){ 
					vm.jeAvailability = response
				})
				Configs.get("CableCapacity",function(response){ 
					vm.cableCapacity = response
				})
				Configs.get("TubeSide",function(response){ 
					vm.tubeSide = response
				})
				Configs.get("JENumber",function(response){ 
					vm.jeNumber = response
				})
			}

			if(vm.caseType.name == "Termination Details"){
				vm.showFmsTermination = true;
				vm.trCase.fmsAndCableDetails = []
				vm.trCase.terminationDetails = []
				vm.isSaving = true
				Configs.get("CableSide",function(response){ 
					vm.cableSide = response
				})
				Configs.get("FMSNumber",function(response){ 
					vm.fmsNumber = response
				}) 
				Configs.get("FMSCapacity",function(response){ 
					vm.fmsCapacity = response
				}) 
				Configs.get("FMS",function(response){ 
					vm.fms = response
				}) 
				Configs.get("Type",function(response){ 
					vm.type = response
				}) 
				Configs.get("CableNumber",function(response){ 
					vm.cableNumber = response
				}) 
			}

			if (vm.caseType) {
				vm.trCase.caseType = vm.caseType;
				if (entity_old.caseType && vm.caseType.id === entity_old.caseType.id) {
					vm.trCase.caseTypeAttributeValues = [];
					vm.trCase.caseTypeAttributeValues = entity_old.caseTypeAttributeValues;
				} else {
					vm.trCase.caseTypeAttributeValues = [];
					$.each(vm.caseType.caseTypeAttribute, function (key, value) {
						vm.trCase.caseTypeAttributeValues.push({
							caseTypeAttribute: vm.caseType.caseTypeAttribute[key]
						});
					});
				}
			}
			
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		vm.datePickerOpenStatus.createDate = false;
		vm.datePickerOpenStatus.updateDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		function decodeImage(img) {
			return window.atob(img);
		}

		function filterUser() {
			if (vm.trCase.assignedToUser != null && vm.trCase.assignedToUser != "" && !angular.isUndefined(vm.trCase.assignedToUser)) {
				UserValueSearch.query({
					search: vm.trCase.assignedToUser,
				}, onSuccess, onError);

				function onSuccess(data, headers) {
					vm.users = data;
					angular.forEach(vm.users, function (value, key) {
						usersMap[value.login] = value.id;
					});
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
			}
		}

		$scope.openAssetMapModal = function () {
			var value = vm.trCase.asset;
			if (vm.trCase.asset.assetCoordinates.length > 0) {
				$("#assetsModal").show();
				var myCenter = new google.maps.LatLng(vm.trCase.pinLat, vm.trCase.pinLong);
				var ele = document.getElementById("assetsModal");
				$(ele).modal('show');
				//
				var locMap = new google.maps.Map(document
					.getElementById('map_canvas_assets'),myOption(14,myCenter) /* {
					center: myCenter,
					zoom: 14
				} */);

				//	            var markerA = new google.maps.Marker({
				//                    position: myCenter,
				//                    icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
				//                    map: locMap
				//                });

				//                var markerContent = '<div class="infoWindowhead"><b>'+ vm.trCase.description
				//    			+ '</b></div><div class="infoWindowContent">'
				//    			+'<b>Lat : </b>'+ vm.trCase.pinLat
				//    			+'<br><b>Lng : </b>'+ vm.trCase.pinLong
				//    			+'</div>';
				//                
				//                var infoWindow1 = new google.maps.InfoWindow({
				//                	content: markerContent
				//                });

				//    	        markerA.addListener('click', function () {
				//    	        	if (openedInfoWindow != null) {
				//                        openedInfoWindow.close();
				//                    }
				//    	        	infoWindow1.open(map, markerA);
				//    	        	openedInfoWindow = infoWindow1;
				//    	        });

				if (value.assetType != null) {
					if (value.assetType != null && value.assetType.layout == 'FIXED') {
						drawFixedAsset(value, locMap);
					} else if (value.assetType != null && value.assetType.layout == 'SPREAD') {
						if (value.assetCoordinates.length > 0) {
							drawPolyline(value, locMap);
						}
					}
				}

				$('#assetsModal').on('show.bs.modal', function (event) {
					$("#location-map-assets").css("width", "100%");
					$("#map_canvas_assets").css("width", "100%");
				});
			} else {
				//console.log(value.customerName + " - Location details missing!!!");
			}
		}

		function drawFixedAsset(fixed, locMap) {

			if (fixed.assetCoordinates.length > 0) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}
				var marker = new google.maps.Marker({
					position: new google.maps.LatLng(fixed.assetCoordinates[0].latitude, fixed.assetCoordinates[0].longitude),
					map: locMap,
					icon: {
						scaledSize: new google.maps.Size(
							30, 30),
						origin: new google.maps.Point(
							0, 0),
						url: fixed.assetType.imagePath,
						anchor: new google.maps.Point(
							16, 16),

					}
				});

				marker.setMap(locMap);

				var infowindow = new google.maps.InfoWindow({
					content: fixed.name
				});

				google.maps.event.addListener(marker, 'mouseover', function () {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					infowindow.open(locMap, marker);
					openedInfoWindow = infowindow;
				});
				google.maps.event.addListener(marker, 'mouseout', function () {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
				});
				openedInfoWindow = infowindow;
			}
		}

		function drawPolyline(spread, locMap) {

			var polylineColor = null;

			var spreadAssetCoordinates = [];
			var assetCoordinatesList = spread.assetCoordinates;

			assetCoordinatesList.forEach(function (value) {
				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});

			if (spreadAssetCoordinates.length > 0) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var infowindow = new google.maps.InfoWindow({
					content: '<div class="infoWindowhead">' +
						spread.name +
						'</div>'
				});

				if (spread.assetType.layout == "SPREAD") {
					polylineColor = spread.assetType.colorcode;
				}
				infowindow.setPosition(midLatLng);
				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1.0,
					strokeWeight: 2.5,
					fillColor: spread.assetType.colorcode,
					fillOpacity: 0.3,
					editable: false
				});

				google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
					infowindow.close();
				});

				google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}

					infowindow.setContent('<div class="infoWindowhead">' +
						spread.name +
						'</div>'
					);

					infowindow.mousemove
					infowindow.setPosition(event.latLng);
					infowindow.open(locMap);
					openedInfoWindow = infowindow;
				});

				if (spread.status != null && spread.status === false) {
					polylinepath.setOptions({
						strokeColor: polylineColor
					});
				}

				polylinepath.setMap(locMap);
			}
		}

		function filterActivatedUser() {
			if (vm.trCase.assignedToUser != null && vm.trCase.assignedToUser != "" && !angular.isUndefined(vm.trCase.assignedToUser)) {
				if($rootScope.has_ROLE_TEAM_LEADER && vm.prevStatus=="ASSIGNED" && vm.caseType.name=="Vendor Civil Work"){
					AssocitedVendorSearch.query({
						page: 0,
                        size: 10,
						userId: vm.trCase.assignedToUser,
					}, onSuccess, onError);
				}else{
					ActivatedUserSearch.query({
						userId: vm.trCase.assignedToUser,
					}, onSuccess, onError);
				}

				function onSuccess(data, headers) {
					vm.activatedusers = [];
					data.forEach(function (dataVal) {
						if (vm.trCase.id && $rootScope.has_ROLE_NETWORK_ENGINEER) {
							vm.activatedusers.push(dataVal);
							/* dataVal.authorities.forEach(function (val) {
								if (val == "ROLE_FRT") {
									
								}
							}); */

						} else {
							vm.activatedusers.push(dataVal);
						}
					});

					angular.forEach(vm.activatedusers, function (value, key) {
						usersMap[value.login] = value.id;
					});
					vm.isSaving = false
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
			}
		}

		

		// Added for asset search start
		function filterAssetsList() {
			if (vm.trCase.asset.name != null && vm.trCase.asset.name != "" && !angular.isUndefined(vm.trCase.asset.name)) {
				/*
				 * AssetSearchForMap.searchassetsformap(vm.trCase.asset.name,
				 * function (response) { vm.assetList = response; });
				 */

				AssetSearch.query({
					search: vm.trCase.asset.name,

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					vm.assetList = data;

				}

				function onError(error) {
					AlertService.error(error.data.message);
				}

			}
		};

		// Added for getting lat alng values from map
		var latlng = new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value);
		/* var settings = {
			zoom: 14,
			center: latlng,
			mapTypeControl: true,
			scaleControl: true,
			mapTypeControlOptions: {
				style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
			},
			navigationControl: true,
			navigationControlOptions: {
				style: google.maps.NavigationControlStyle.DEFAULT
			},
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			backgroundColor: 'white',

		}; */

		locations.map = new google.maps.Map(document.getElementById('map_canvas'), myOption(14,latlng)/* settings */);
		geoLocation(locations.map)
		var address = new google.maps.Geocoder();
		google.maps.event.addListener(locations.map, 'click', function (event) {

			address.geocode({
				'latLng': event.latLng
			}, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					if (results[0]) {
						$ngConfirm({
							title: 'Are you sure you want to select this address?',
							content: '<strong>Address: </strong>' + results[0].formatted_address + '<br/>' + '<strong>Latitude: </strong>' + event.latLng.lat() + '</br>' +
								'<strong>Longitude: </strong>' + event.latLng.lng(),
							type: "blue",
							typeAnimated: true,
							buttons: {
								OK: {
									text: 'OK',
									btnClass: 'btn-primary',
									action: function () {
										$scope.$apply(function () {
											vm.trCase.pinLat = event.latLng.lat();
											vm.trCase.pinLong = event.latLng.lng();
											vm.trCase.address = results[0].formatted_address;
											// alert('Lat: ' +
											// event.latLng.lat() + ' Lng: ' +
											// event.latLng.lng())
										})
									}
								},
								Cancel: {
									text: 'Cancel',
									btnClass: 'btn-danger',
									action: function () {

									}

								},

							}
						});

					}
				}
			});
		});

		function setCaseGeofences() {
			var isUserCaseAdmin = false;
			vm.userAdmin.authorities.forEach(function (user) {
				if (user == "ROLE_USER_ADMIN") {
					isUserCaseAdmin = true;
				}
				if (user == "ROLE_HOD") {
					isUserCaseAdmin = true;
				}
			});
			if (isUserCaseAdmin) {
				// Geofence.query({
				// 	page: 0,
				// 	size: 500,
				// }, onSuccess, onError);

				// function onSuccess(data, headers) {
				// 	vm.selectedGeofence = [];
				// 	data.forEach(function (value) {
				// 		if (value.zone) {
				// 			value.type = "MASTER";
				// 		} else {
				// 			value.type = "MINI";
				// 		}
				// 		vm.selectedGeofence.push(value);
				// 	});
				// 	drawLatestGeofence(vm.selectedGeofence);
				// }

				// function onError(error) {
				// 	// AlertService.error(error.data.message);
				// }

				GeofenceIDs.getAll(function (response) {
					vm.selectedGeofence = [];
					response.forEach(function (value) {
						if (value.zone) {
							value.type = "MASTER";
						} else {
							value.type = "MINI";
						}
						vm.selectedGeofence.push(value);
					});
					drawLatestGeofence(vm.selectedGeofence);
				});

			} else {
				drawLatestGeofence(vm.userGeofenceList);
			}
		}

		function drawLatestGeofence(response) {
			if (response) {
				initializeGeofenceMap(response, function (latlang) {
					locations.latlng = latlang;
					// function() {
					$.each(response, function (index, value) {
						try {
							if (value.type != "Master") {
								var path = JSON.parse(value.coordinates);
								// drawPolylineForGeoFence(path, locations.map, value.name);
								var infowindow = new google.maps.InfoWindow(
									{
										content: '<div class="infoWindowhead">'
											+ "name"
											+ '<div class="infoWindowContent"> <b>Description :</b> '
											+ "des" + '</div></div>'
									});

								infowindow.setPosition(latlang);
								var tempGeofences = new google.maps.Polyline({
									path: path,
									geodesic: true,
									strokeColor: "#ff0000",
									strokeOpacity: 0.5,
									strokeWeight: 3
								});
								google.maps.event.addListener(tempGeofences, 'mouseout', function (event) {
									infowindow.close();
								});

								google.maps.event.addListener(tempGeofences, 'click', function (event) {
									if (openedInfoWindow != null) {
										openedInfoWindow.close();
									}
									infowindow.setContent('<div class="infoWindowhead">'
										+ '<b>Geofence Name : </b><br><br>' + value.name + '</br></div>'
									);

									infowindow.mousemove;
									infowindow.open(locations.map);
									infowindow.setPosition(event.latLng);
									openedInfoWindow = infowindow;
								});
								tempGeofences.setMap(locations.map);
							}
						} catch (err) {
							console.log(err);
						}
					});
				});
			}
		}

		function initializeGeofenceMap(latlangs, callback) {
			if (latlangs && latlangs.length > 0) {
				latlng = new google.maps.LatLng(latlangs[0].pinLat, latlangs[0].pinLong);
				callback(latlng);
			} else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {

						latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
						callback(latlng);
					}, function () {

						callback(new google.maps.LatLng("5.431587", "101.128162"));
					});
				} else {
					callback(new google.maps.LatLng("5.431587", "101.128162"));
				}
			}
		}

		function filterAssetsOnMapView() {
			$("#mapFilterModal").show();
			noDataText = document.getElementById("noData");
			noDataText.style.display = "none";
			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
		}

		function closeMapFilterModal(id) {
			vm.isSaving = false;
			$("#"+id).removeClass("in");
			$(".modal-backdrop").remove();
			$("#"+id).hide();
			vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
		}

		function closePopupDialogModal() {
			$("#popupDialogModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#popupDialogModal").hide();
			vm.isSaving = false;
		}

		function closeModal(id) {
			$("#scrollTop").scrollTop(0);
			if(vm.editDetails){
				if(id == 'splicingDetails'){
					vm.trCase.splicingDetails.splice(vm.selectedSlicing,1)
				}
				if(id == 'cableDetails'){
					vm.trCase.cableDetails.splice(vm.selectedCable,1)
				}
				if(id == 'fmsDetails'){
					vm.trCase.fmsAndCableDetails.splice(vm.selectedFms,1)
				}
				if(id == 'terminationDetails'){
					vm.trCase.terminationDetails.splice(vm.selectedTermination,1)
				}
			}else{
				vm.trCase = vm.new
			}
			$("#"+id).removeClass("in");
			$(".modal-backdrop").remove();
			$("#"+id).hide();
		}

		function saveFilter() {
			vm.mapAssets = [];
			markers = [];
			polylines = [];
			/* var myOptions = {
				zoom: 16,
				center: latlng,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			}; */
			locations.map = new google.maps.Map(document.getElementById("map_canvas"), myOption(16,latlng));
			geoLocation(locations.map)
			getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
			setCaseGeofences();
			google.maps.event.addListener(locations.map, 'click', function (event) {

				address.geocode({
					'latLng': event.latLng
				}, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						if (results[0]) {
							$ngConfirm({
								title: 'Are you sure you want to select this address?',
								content: '<strong>Address: </strong>' + results[0].formatted_address + '<br/>' + '<strong>Latitude: </strong>' + event.latLng.lat() + '</br>' +
									'<strong>Longitude: </strong>' + event.latLng.lng(),
								type: "blue",
								typeAnimated: true,
								buttons: {
									OK: {
										text: 'OK',
										btnClass: 'btn-primary',
										action: function () {
											$scope.$apply(function () {
												vm.trCase.pinLat = event.latLng.lat();
												vm.trCase.pinLong = event.latLng.lng();
												vm.trCase.address = results[0].formatted_address;
											})
										}
									},
									Cancel: {
										text: 'Cancel',
										btnClass: 'btn-danger',
										action: function () {

										}

									},

								}
							});

						}
					}
				});
			});
			$("#mapFilterModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterModal").hide();
		}

		function getGroupAssetsFromES(geofenceIdVal, lastAssetId, mapAssetLists) {
			AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;

					vm.mapAssets.push(tmpAsset);
				});
				drawLatestAssets(vm.mapAssets);
				if (data.lastId != null) {
					getGroupAssetsFromES(geofenceIdVal, data.lastId, vm.mapAssets);
				} else {
					if (vm.mapAssets.length > 0) {
						var assetSelected = vm.mapAssets[0];
						AssetByID.get(assetSelected.id, function (assetVal) {
							var assetLatLng = ({
								lat: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].latitude,
								lng: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].longitude
							});
							locations.map.setCenter(assetLatLng);
						});
					}
				}
			});
		}

		function hideEditModal() {
			$("#userPathModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#userPathModal").hide();
		}
		$('#userPathModal').on('hidden.bs.modal', function () {
			//			filterAssetsformap();
		})

		function getAssetAddress() {
			if (vm.trCase.pinLat != null && vm.trCase.pinLong != null) {
				var latlng = new google.maps.LatLng(vm.trCase.pinLat, vm.trCase.pinLong);
				// This is making the Geocode request
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'latLng': latlng }, function (results, status) {
					// if (status !== google.maps.GeocoderStatus.OK) {
					//	console.log(status);
					// }
					// This is checking to see if the Geoeode Status is OK before proceeding
					if (status == google.maps.GeocoderStatus.OK) {
						$scope.$apply(function () {
							vm.trCase.address = results[0].formatted_address;
						});
					}
				});
			}
		}

		function drawLatestAssets(response) {
			if (response) {
				initializeAssetMap(response, function (latlang) {
					locations.latlng = latlang;

					setupAssetMap(function () {
						$.each(response, function (index, value) {
							if (value.assetTypeLayout == null) {
								value.assetTypeName = value.assetType.name;
								value.assetTypeLayout = value.assetType.layout;
								value.assetTypeImagePath = value.assetType.imagePath;
							}
							if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
								if (value.assetCoordinates.length > 1) {
									drawPolyline(value);
									var value1 = value;
									value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

									drawFixedAsset(value1, false);

								} else {
									drawFixedAsset(value, false);
								}
							}
							if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
								drawPolyline(value, locations.map);
							}

						});
					});
				});
			}
		}

		function initializeAssetMap(latlangs, callback) {

			if (latlangs && latlangs.length > 0) {
				var latVal = null;
				var lngVal = null;
				latlangs.forEach(function (value) {
					if (latVal == null && lngVal == null) {
						if (value.assetCoordinates.length > 0) {
							latVal = value.assetCoordinates[value.assetCoordinates.length - 1].latitude;
							lngVal = value.assetCoordinates[value.assetCoordinates.length - 1].longitude;
						}
					}
				});
				if (latVal != null && lngVal != null) {
					latlng = new google.maps.LatLng(latVal, lngVal);
					callback(latlng);
				}
			} else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (
						position) {

						latlng = new google.maps.LatLng(
							position.coords.latitude,
							position.coords.longitude);
						callback(latlng);
					}, function () {

						// callback(new google.maps.LatLng("12.9716", "77.5946"));
						callback(new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value));
					});
				} else {
					callback(new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value));
				}
			}
		}

		function setupAssetMap(callback) {
			if (locations.map == null) {
				/* var myOptions = {
					zoom: 14,
					center: locations.latlng,
					mapTypeId: google.maps.MapTypeId.ROADMAP
				}; */

				locations.map = new google.maps.Map(document
					.getElementById("map_canvas"), myOption(14,locations.latlng));
				geoLocation(locations.map)
				google.maps.event.addListener(locations.map, 'zoom_changed', function () {
					vm.zoomLevel = locations.map.getZoom();
					if ((vm.prevZoomLevel == 17 && vm.zoomLevel == 18) || (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)) {
						drawLatestAssets(vm.mapAssets);
					}
					vm.prevZoomLevel = vm.zoomLevel;

				});
			} else {
				// Loop through all the markers and polylines to remove

				for (var i = 0; i < markers.length; i++) {
					markers[i].setMap(null);
				}

				for (i = 0; i < polylines.length; i++) {
					polylines[i].setMap(null);
				}

				markers = [];
				polylines = [];
			}
			locations.overlay = new google.maps.OverlayView();
			locations.overlay.draw = function () { };
			locations.overlay.setMap($scope.map);
			locations.element = document.getElementById('map_canvas');
			callback();
		}

		function drawPolyline(spread, map) {

			var spreadAssetCoordinates = [];
			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spread.assetTypeColor
				}
				var polylineWeight = 2.5;
				var strokeOpacityVal = 1.0;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div'),
								button;

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(locations.map);
						openedInfoWindow = infowindow;
					}
				});

				var polylinepathDuct = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				polylinepath.setMap(locations.map);

				polylines.push(polylinepath);
			}
		}

		function drawFixedAsset(fixed, hasParent) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 8;
				if (vm.zoomLevel == 10) {
					iconSize = 8;
				} else if (vm.zoomLevel == 11) {
					iconSize = 16;
				}

				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: locations.map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});


				markers.push(startMarker);

				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div'),
							buttonA, buttonB, buttonC, buttonD;
						userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
							'</div><div class="infoWindowContent">' +
							'<b>Lat</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Long</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(locations.map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}

		function distanceCal(lat1, lon1, lat2, lon2) {
			var theta = lon1 - lon2;
			var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
				Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
			dist = Math.acos(dist);
			dist = radians_to_degrees(dist);
			dist = dist * 60 * 1.1515;
			dist = dist * 1.609344;
			if (isNaN(dist)) {
				return 0.0;
			} else {
				return (dist);
			}
		}

		function degrees_to_radians(degrees) {
			var pi = Math.PI;
			return degrees * (pi / 180);
		}

		function radians_to_degrees(radians) {
			var pi = Math.PI;
			return radians * (180 / pi);
		}

		vm.callGroup = function(){
			vm.isSaving = false
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseDetailController', TrCaseDetailController);

    TrCaseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrCase', 'User', 'CaseType', 'TrCaseImages', 'TrCaseRecordings','AlertService','$window','$localStorage','getCaseImage','Configs'];

    function TrCaseDetailController($scope, $rootScope, $stateParams, previousState, entity, TrCase, User, CaseType,TrCaseImages,TrCaseRecordings,AlertService, $window,$localStorage,getCaseImage,Configs) {
		var vm = this;
		
		/*if (entity.status) {
			entity.status = entity.status.replace("NEW", "PLANNING PHASE");
			entity.status = entity.status.replace("INPROGRESS", "ROLL-OUT PHASE");
			entity.status = entity.status.replace("RESOLVED", "OPERATION PHASE");
		}*/
        vm.trCase = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        var unsubscribe = $rootScope.$on('trakeyeApp:trCaseUpdate', function(event, result) {
            vm.trCase = result;
        });
		vm.showCaseAttachment = false

		Configs.get("CaseImage",function(response){
            if(response.length > 0){
				if(response[0].configValue == "True"){
					vm.showCaseAttachment = true
				}
			}
        })
		
        vm.imageInNewTab = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
            );
            imgWindow.document.close(); 
		};

		$scope.newTabDisplay = function(id){
            var request = new XMLHttpRequest();
            request.open('GET',"api/trakeyecaseimages/"+vm.trCase.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                window.open(imageUrl, "_blank")}
            } 
            request.send();
        } 

        $scope.$on('$destroy', unsubscribe);
        
          $scope.go_back = function() { 
        	  $window.history.back();
        	};
        
        $scope.allimages = false;
//		$scope

		$scope.toggle = function(id) {
			switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrCaseImages.query(
                            {
                                caseId: vm.trCase.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.caseImages = data.filter(function(caseImages){
                                return caseImages.image
                             });
                        
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getCaseImage.get(vm.trCase.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }


			
			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/case_"+vm.trCase.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrCaseImages.query({
					caseId : vm.trCase.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.caseImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

//		$scope.playAudio = function() {
////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/case_"+vm.trCase.id+".mp3";
//            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/case_15570572.mp3";
//	        var audio = new Audio(urlStr);
//	        audio.play();
//	    };
		
		
        function decodeImage(img){
     	   return window.atob(img);
        }
         $scope.showCaseImages = function () {

                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) spinner.style.display = "block";

                $scope.mediaImagesIds = [];
                $scope.currentIndex = 0;

                $scope.caseName = "IncidentID_" + vm.trCase.id;

                TrCaseImages.query(
                    { caseId: vm.trCase.id },
                    function (data) {

                        angular.forEach(data, function (item, index) {
                            if (item.image) {
                                $scope.mediaImagesIds.push({
                                    base64: item.image,
                                    imageType: "IMAGE",
                                    imageName: "case_image_" + vm.trCase.id
                                });
                            }
                        });

                        if (!$scope.mediaImagesIds.length) {
                            alert("No images found for this case");
                            if (spinner) spinner.style.display = "none";
                            return;
                        }

                        if (spinner) spinner.style.display = "none";

                        $scope.loadMedia($scope.mediaImagesIds[0]);
                        $("#mediaCarouselModal").modal("show");
                    },
                    function (error) {
                        if (spinner) spinner.style.display = "none";
                        AlertService.error(error.data.message);
                    }
                );
            };
            $scope.loadMedia = function (media) {
                vm.showdownloadButton= true;
                var container = document.getElementById("carouselMediaContainer");
                if (!container) return;

                container.innerHTML = "";

                var img = document.createElement("img");
                img.src = "data:image/png;base64," + media.base64;
                img.style.maxWidth = "100%";
                img.style.maxHeight = "70vh";
                img.style.cursor = "grab";
                img.setAttribute("draggable", "false");

                container.appendChild(img);
                var zoom = 1;
                var minZoom = 1;
                var maxZoom = 5;
                var imgOffsetX = 0;
                var imgOffsetY = 0;

                function applyTransform() {
                    img.style.transform =
                        "translate(" + imgOffsetX + "px," + imgOffsetY + "px) scale(" + zoom + ")";
                }

                container.onwheel = function (e) {
                    e.preventDefault();
                    zoom += e.deltaY < 0 ? 0.1 : -0.1;
                    zoom = Math.min(Math.max(minZoom, zoom), maxZoom);
                    if (zoom === 1) {
                        imgOffsetX = 0;
                        imgOffsetY = 0;
                    }
                    applyTransform();
                };

                var isDragging = false, startX, startY, startOX, startOY;

                img.onmousedown = function (e) {
                    isDragging = true;
                    startX = e.clientX;
                    startY = e.clientY;
                    startOX = imgOffsetX;
                    startOY = imgOffsetY;
                };

                document.onmousemove = function (e) {
                    if (!isDragging) return;
                    imgOffsetX = startOX + (e.clientX - startX);
                    imgOffsetY = startOY + (e.clientY - startY);
                    applyTransform();
                };

                document.onmouseup = function () {
                    isDragging = false;
                };
            };
            $scope.nextMedia = function () {
                $scope.currentIndex =
                    ($scope.currentIndex + 1) % $scope.mediaImagesIds.length;
                $scope.loadMedia($scope.mediaImagesIds[$scope.currentIndex]);
            };

            $scope.prevMedia = function () {
                $scope.currentIndex =
                    ($scope.currentIndex - 1 + $scope.mediaImagesIds.length) %
                    $scope.mediaImagesIds.length;
                $scope.loadMedia($scope.mediaImagesIds[$scope.currentIndex]);
            };

            $scope.jumpToMedia = function (index) {
                $scope.currentIndex = index;
                $scope.loadMedia($scope.mediaImagesIds[index]);
            };
            $scope.downloadMedia = function () {
                var media = $scope.mediaImagesIds[$scope.currentIndex];
                if (!media) return;

                var link = document.createElement("a");
                link.href = "data:image/png;base64," + media.base64;
                link.download = media.imageName + ".png";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };
            vm.isMaximized = false;

            vm.toggleMaximize = function () {

                var modalDialog = document.getElementById("mediaModalDialog");
                var maxBtn = document.getElementById("maximizeBtn");
                var minBtn = document.getElementById("minimizeBtn");

                if (!vm.isMaximized) {
                    modalDialog.classList.add("modal-fullscreen-custom");

                    maxBtn.style.display = "none";
                    minBtn.style.display = "inline-block";
                    vm.isMaximized = true;
                } else {
                    modalDialog.classList.remove("modal-fullscreen-custom");
                    maxBtn.style.display = "inline-block";
                    minBtn.style.display = "none";
                    vm.isMaximized = false;
                }
            };
            vm.openPdfAttachments = function () {
                $("#loading-bar-spinner").show();
                getCaseImage.get(vm.trCase.id, function (res) {
                    $("#loading-bar-spinner").hide();
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                    vm.attachments = res || [];
                    if (!vm.attachments.length) {
                        alert("No attachments available");
                        return;
                    }
                    $("#attachmentModal").modal("show");
                });
            };

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseDeleteController',TrCaseDeleteController);

    TrCaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrCase','$scope'];

    function TrCaseDeleteController($uibModalInstance, entity, TrCase,$scope) {
        var vm = this;

        vm.trCase = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrCase.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-case', {
                parent: 'app',
                url: '/tr-case',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-cases.html',
                        controller: 'TrCaseController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'update_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trCase');
                        $translatePartialLoader.addPart('caseStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-case-detail', {
                parent: 'tr-case',
                url: '/tr-case/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-detail.html',
                        controller: 'TrCaseDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trCase');
                        $translatePartialLoader.addPart('caseStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrCase', function ($stateParams, TrCase) {
                        return TrCase.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-case',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-case.priority', {
                parent: 'tr-case',
                url: '/tr-cases/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-cases.html',
                        controller: 'TrCaseController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'update_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trCase');
                        $translatePartialLoader.addPart('caseStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-case.attendance', {
                parent: 'tr-case',
                url: '/tr-cases/attendance/{login}/{fromTime}/{toTime}/{caseStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-cases.html',
                        controller: 'TrCaseController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'update_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            caseStatus: $stateParams.caseStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trCase');
                        $translatePartialLoader.addPart('caseStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-case.new', {
                parent: 'tr-case',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-dialog.html',
                        controller: 'TrCaseDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            caseImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-case.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-case/tr-case-work-flow.html',
                    controller: 'TrCaseWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        caseImages: []
                    };
                }]
            }
        })

        .state('tr-case.import', {
                parent: 'tr-case',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-import.html',
                        controller: 'TrCaseImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            caseImages: []
                        };
                    }
                }

            })
            .state('tr-case.edit', {
                parent: 'tr-case',
                url: '/Edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-dialog.html',
                        controller: 'TrCaseDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrCase', function ($stateParams, TrCase) {
                        return TrCase.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-case',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-case.delete', {
                parent: 'tr-case',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-case/tr-case-delete-dialog.html',
                        controller: 'TrCaseDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrCase', function (TrCase) {
                                return TrCase.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-case', null, { reload: 'tr-case' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-case.fibercore', {
                parent: 'tr-case',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-fiber-core.html',
                        controller: 'TrCaseFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            caseImages: []
                        };
                    }
                }

            })

            .state('show-hide-case', {
                parent: 'report',
                url: '/show-hide-case',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/show-hide-case.html',
                        controller: 'ShowHideCaseController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCase', TrCase);

	TrCase.$inject = ['$resource', 'DateUtils'];

	function TrCase($resource, DateUtils) {
		var resourceUrl = 'api/tr-cases/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGeofence', TrCaseGeofence);

	TrCaseGeofence.$inject = ['$resource'];

	function TrCaseGeofence($resource) {
		var service = $resource('/api/tr-cases/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseCustomTime', TrCaseCustomTime);

	TrCaseCustomTime.$inject = ['$resource'];

	function TrCaseCustomTime($resource) {
		var service = $resource('/api/tr-cases-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGeofenceCustomTime', TrCaseGeofenceCustomTime);

	TrCaseGeofenceCustomTime.$inject = ['$resource'];

	function TrCaseGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-cases-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseCheckAsset', TrCaseCheckAsset);

	TrCaseCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrCaseCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CasesForAsset', CasesForAsset);

    CasesForAsset.$inject = ['$resource'];

    function CasesForAsset($resource) {
        var resourceUrl = 'api/cases-for-asset/:assetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-cases/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getCaseImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyecaseimages/' + id).then(function (response) {
				callback(response.data);
			}).catch(function (error) {
            console.log("Error object:", error)
            if (error.status === 404 || 
                (error.data && error.data.status === 404)) {
                callback([]);
            } else {
                callback(null);
            }
        });
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id,data,callback) {
			$http.post('api/assets/nearby-fixed/' + id,data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-cases-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-case-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseById', TrCaseById);

	TrCaseById.$inject = [ '$resource' ];

	function TrCaseById($resource) {
		var service = $resource('/api/tr-cases/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/casecountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadCaseReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-cases').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/casecountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCasePriority', TrCasePriority);

	TrCasePriority.$inject = ['$resource'];

	function TrCasePriority($resource) {
		var service = $resource('/api/tr-cases/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, {geofenceId : '@geofenceId'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseAttendance', TrCaseAttendance);

	TrCaseAttendance.$inject = ['$resource'];

	function TrCaseAttendance($resource) {
		var service = $resource('/api/tr-cases/attendance/:login/:fromTime/:toTime/:caseStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseSearch', TrCaseSearch);

	TrCaseSearch.$inject = ['$resource'];

	function TrCaseSearch($resource) {
		var service = $resource('/api/tr-cases/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseSearchCustom', TrCaseSearchCustom);

	TrCaseSearchCustom.$inject = ['$resource'];

	function TrCaseSearchCustom($resource) {
		var service = $resource('/api/tr-cases-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGeofenceSearch', TrCaseGeofenceSearch);

	TrCaseGeofenceSearch.$inject = ['$resource'];

	function TrCaseGeofenceSearch($resource) {
		var service = $resource('/api/tr-cases/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGeofenceSearchCustom', TrCaseGeofenceSearchCustom);

	TrCaseGeofenceSearchCustom.$inject = ['$resource'];

	function TrCaseGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-cases-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseGroup', TrCaseGroup);

	TrCaseGroup.$inject = ['$resource', 'DateUtils'];

	function TrCaseGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-cases-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGroupSearch', TrCaseGroupSearch);

	TrCaseGroupSearch.$inject = ['$resource'];

	function TrCaseGroupSearch($resource) {
		var service = $resource('/api/tr-cases-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGroupPrioritySearch', TrCaseGroupPrioritySearch);

	TrCaseGroupPrioritySearch.$inject = ['$resource'];

	function TrCaseGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-cases-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGroupPriority', TrCaseGroupPriority);

	TrCaseGroupPriority.$inject = ['$resource'];

	function TrCaseGroupPriority($resource) {
		var service = $resource('/api/tr-cases-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseImages', TrCaseImages);

	TrCaseImages.$inject = ['$resource'];

	function TrCaseImages($resource) {
		var service = $resource('/api/case-images/:caseId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCasesForType', TrCasesForType);

	TrCasesForType.$inject = ['$resource'];

	function TrCasesForType($resource) {
		var service = $resource('/api/trcasesbytype/:caseTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
 (function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data,success,error) {
			$http.post('api/tr-cases/nearby-bgoh-assets',data).then(function (response) {
				success(response.data);
			},function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();  

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseRecordings', TrCaseRecordings);

	TrCaseRecordings.$inject = ['$resource'];

	function TrCaseRecordings($resource) {
		var service = $resource('/api/case-recordings/:caseId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllCaseTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/case-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCasePrioritySearch', TrCasePrioritySearch);

	TrCasePrioritySearch.$inject = ['$resource'];

	function TrCasePrioritySearch($resource) {
		var service = $resource('/api/tr-cases/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseUpdateGroup', TrCaseUpdateGroup);

	TrCaseUpdateGroup.$inject = ['$resource'];

	function TrCaseUpdateGroup($resource) {
		var resourceUrl = 'api/tr-cases/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseBulkDelete', TrCaseBulkDelete);

	TrCaseBulkDelete.$inject = ['$resource'];

	function TrCaseBulkDelete($resource) {
		var resourceUrl = 'api/tr-cases/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrcasesuser = function (callback) {
			$http.get('api/tr-cases/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrcasesuserbyid = function (id, callback) {
			$http.get('api/tr-cases/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrcasesuserbyvalue = function (id, callback) {
			$http.get('api/tr-cases/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrcasesanduserbypriority = function (priority, callback) {
			$http.get('api/tr-cases/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrcases = function (callback) {
			$http.get('api/tr-allcases').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrcase = function (data, callback) {
			$http.post('api/tr-caseedit/' + data.userId + '/' + data.caseId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-caseedit/'+data.userId+'/'+data.caseId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseUpload', TrCaseUpload);

	TrCaseUpload.$inject = ['$http'];

	function TrCaseUpload($http) {

		var service = {};
		service.trcaseupload = function (data, callback) {

			$http.post('api/caseimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupCaseSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrcaseformap = function (search, callback) {
			$http.get('api/tr-groupcasesformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupCaseForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllCases = function (callback) {
			$http.get('api/tr-groupcasesformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrcaseformap = function (search, callback) {
			$http.get('api/tr-casesformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrcaseformap = function (priority, callback) {
			$http.get('api/tr-casesformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrCaseLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('CasesForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.casesformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-casesformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllCases = function (data, callback) {
			// $http.get('api/tr-casesformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-casesformap', data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ShowCaseById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (caseid, callback) {
            $http.put('api/show-case/' + caseid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('HideCaseById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (caseid, callback) {
            $http.put('api/hide-case/' + caseid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp')
        .factory('FileUploadService', ['$http', '$timeout', function ($http, $timeout) {

            var service = {};
            var MAX_RETRIES = 3;
            var RETRY_DELAY_MS = 3000;

            service.uploadFile = function (file, caseId, fileType, finalFileName, callback) {

                var CHUNK_SIZE = (fileType.toUpperCase() === "MP4")
                    ? (2 * 1024 * 1024)
                    : (1 * 1024 * 1024);

                var totalChunks = Math.ceil(file.size / CHUNK_SIZE);
                var chunkNumber = 0;
                var retryCount = 0;

                function uploadNextChunk() {

                    var start = chunkNumber * CHUNK_SIZE;
                    var end = Math.min(start + CHUNK_SIZE, file.size);
                    var isLastChunk = (chunkNumber === totalChunks - 1);

                    var chunkBlob = file.slice(start, end);
                    var formData = new FormData();
                    formData.append("file", chunkBlob, file.name);

                    var uploadUrl =
                        "api/case/uploadFiles/" +
                        caseId + "/" +
                        chunkNumber + "/" +
                        totalChunks + "/" +
                        isLastChunk + "/" +
                        fileType + "/" +
                        encodeURIComponent(finalFileName);

                    $http.post(uploadUrl, formData, {
                        headers: { 'Content-Type': undefined }
                    }).then(function () {

                        chunkNumber++;
                        retryCount = 0;

                        if (chunkNumber < totalChunks) {
                            uploadNextChunk();
                        } else {
                            callback(true);
                        }

                    }).catch(function (error) {

                        console.error("Chunk upload failed:", chunkNumber, error);

                        if (retryCount < MAX_RETRIES) {
                            retryCount++;
                            console.warn("Retrying chunk:", chunkNumber, "Attempt:", retryCount);

                            $timeout(function () {
                                uploadNextChunk();
                            }, RETRY_DELAY_MS);
                        } else {
                            callback(false);
                        }
                    });
                }

                uploadNextChunk();
            };

            return service;
        }]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseImportController', TrCaseImportController)
    .directive("fileread", [function () {
    	'use strict';

        return {
            restrict: "A",

            link: function($scope, element){

                element.change(function(event){
                    $scope.$apply(function(){
                      $scope.myFile =element[0].files[0];
                      
                    });
                });
            }

        };
}]);

    TrCaseImportController.$inject = ['$timeout', '$scope','TrCaseUpload'];

    function TrCaseImportController ($timeout, $scope, TrCaseUpload) {
        var vm = this;

        vm.upload= upload;
        
		 var formData;
	        function upload(){
	        	formData=new FormData();
	        	formData.append('file',$scope.myFile);
	        
	        	TrCaseUpload.trcaseupload(formData,function(response,headers){
	        		if(response.status == 200){
	             		vm.error=null;
	             		vm.success='OK';
	             		
	            		$timeout(function(){
	            			vm.success= '';
	            		},4000);
	            		
	            		
	             	} 
	             	if(response.status == 400){
	             		vm.success=null;
	             		vm.error='error';
	             			
	             	} 
	             });
	        	
	        }
			$(":file").filestyle({buttonBefore: true});      
			$(":file").filestyle('buttonText', 'Browse File');
		

    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrCaseController", TrCaseController);

    TrCaseController.$inject = [
        "$filter",
        "$rootScope",
        "$scope",
        "$state",
        "$stateParams",
        "$compile",
        "$timeout",
        "DEFAULT_LATITUDE",
        "DEFAULT_LONGITUDE",
        "pagingParams",
        "paginationConstants",
        "TrCase",
        "TrCaseGeofence",
        "ParseLinks",
        "AlertService",
        "TrCaseUser",
        "TrCaseSearch",
        "TrCaseGeofenceSearch",
        "TrCasePriority",
        "TrCasePrioritySearch",
        "TrCaseEdit",
        "TrCaseForMap",
        "TrCaseSearchForMap",
        "TrCaseLastLocation",
        "UserAccount",
        "GeofenceIDs",
        "UserGeofences",
        "AssetGroupES",
        "TrCaseById",
        "AssetByID",
        "TrCaseAttendance",
        "Report",
        "UserMasterGeofences",
        "GeofenceByID",
        "MiniGeofencesByMasterID",
        "$localStorage",
        "Configs",
        "getNearbyFixed",
        "BaseUrl",
        "AssetType",
        "TrCaseCustomTime",
        "TrCaseGeofenceCustomTime",
        "TrCaseSearchCustom",
        "TrCaseGeofenceSearchCustom",
        "CaseType"
    ];

    function TrCaseController(
        $filter,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $compile,
        $timeout,
        DEFAULT_LATITUDE,
        DEFAULT_LONGITUDE,
        pagingParams,
        paginationConstants,
        TrCase,
        TrCaseGeofence,
        ParseLinks,
        AlertService,
        TrCaseUser,
        TrCaseSearch,
        TrCaseGeofenceSearch,
        TrCasePriority,
        TrCasePrioritySearch,
        TrCaseEdit,
        TrCaseForMap,
        TrCaseSearchForMap,
        TrCaseLastLocation,
        UserAccount,
        GeofenceIDs,
        UserGeofences,
        AssetGroupES,
        TrCaseById,
        AssetByID,
        TrCaseAttendance,
        Report,
        UserMasterGeofences,
        GeofenceByID,
        MiniGeofencesByMasterID,
        $localStorage,
        Configs,
        getNearbyFixed,
        BaseUrl,
        AssetType,
        TrCaseCustomTime,
        TrCaseGeofenceCustomTime,
        TrCaseSearchCustom,
        TrCaseGeofenceSearchCustom,
        CaseType
    ) {
        var vm = this;
        $scope.search = pagingParams.search;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.selectedListGeofenceId = parseInt(pagingParams.listgeofenceid);
        if (isNaN(vm.selectedListGeofenceId)) {
            vm.selectedListGeofenceId = 0;
        }
        vm.filterTrcaseSearch = filterTrcaseSearch;
        vm.filterTrCaseSearchMap = filterTrCaseSearchMap;
        vm.selectTrcaseEntity = selectTrcaseEntity;
        vm.selectAllTrCases = selectAllTrCases;
        vm.searchTrCases = searchTrCases;
        vm.selectAllAssets = selectAllAssets;
        vm.filterAssetsOnMapView = filterAssetsOnMapView;
        vm.closeMapFilterModal = closeMapFilterModal;
        vm.saveListFilter = saveListFilter;
        vm.filterTrcasesOnListView = filterTrcasesOnListView;
        vm.closeListFilterModal = closeListFilterModal;
        vm.showPriorityStatusFilter = showPriorityStatusFilter;
        vm.closePriorityStatusFilterModal = closePriorityStatusFilterModal;

        vm.openCalendar = openCalendar;
        vm.usersTable = usersTable;
        vm.saveFilter = saveFilter;
        vm.isExpanded = false;
        vm.expandedCaseId = 0;
        var openedInfoWindow = null;
        vm.usersList = [];
        var prevInfoWindow = null;
        //		 vm.trCases = [];
        var latlng;
        var userPaths = {};
        var locations = {};
        var nearbyAgentsMarkers = [];
        vm.caseAroundUsers = [];
        var markers = [];
        var polylines = [];
        var noDataText = null;
        var activeInfo;
        var infoTimer;
        vm.saveImage = saveImage;
        vm.imageUpload = imageUpload;
        vm.closeImageUpload = closeImageUpload;
        vm.downloadPdfButton = downloadPdfButton;
        vm.fileWarning = false
        vm.newCases = newCases

        vm.userGeofences = [];

        vm.geofencesListView = [];
        vm.userMasterGeofences = [];
        vm.selectedMasterGeofenceId = 0;
        vm.dateFilterTrCaseSearchMap = dateFilterTrCaseSearchMap

        vm.selectedWorkCases = [];
        vm.multgroup = [];
        var selctedGroup = [];
        var tempGeofenceId = null
        vm.groupCases = false;
        vm.showTrCaseActions = false;
        vm.totalTrcaseSelected = 0;
        vm.navigateCaseEdit = navigateCaseEdit;
        vm.goToEditPage = goToEditPage;
        vm.selectedGeofenceId = null;
        vm.mapCases = [];
        vm.items = [
            {
                name: "Update Group Mapping",
            },
        ];

        var isNewCaseSelected = $state.params.rangeOption;
        var fromDateValue = 0;
        var toDateValue = 0;

        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");
        // Get the current date and time in epoch format
        var now = Date.now();

        // Calculate the date six months ago in epoch format
        var sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        var sixMonthsAgoEpoch = sixMonthsAgo.setHours(23, 59, 59, 999);

        /* vm.priorityType = ["PRIORITY"];
        vm.statusType = ["STATUS"];
        vm.priorityList = ["HIGH", "MEDIUM", "LOW", "CRITICAL"];
        vm.statusList = [
            "NEW",
            "INPROGRESS",
            "PENDING",
            "ASSIGNED",
            "RESOLVED",
            "CANCELLED",
            "CLOSED",
        ]; */
        vm.datePickerOpenStatus = {};
        function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;

		}

        vm.statusType = [
        {   name: '<strong>PRIORITY</strong>' , msGroup: true }, 
        {   name: 'CRITICAL', selected: true   },
        {   name: 'HIGH', selected : true   },       
        {   name: 'MEDIUM', selected: true   },
        {   name: 'LOW', selected: true   },        
        {   msGroup: false },
        {   name: '<strong>STATUS</strong>', msGroup: true }, 
        {   name: 'NEW', selected: true   },
        {   name: 'INPROGRESS', selected : true   },       
        {   name: 'PENDING', selected: true   },
        {   name: 'ASSIGNED', selected: true   },        
        {   name: 'CANCELLED', selected: false   },
        {   name: 'CLOSED', selected: false   },        
        {   msGroup: false },
        {   name: '<strong>CASE TYPE</strong>', msGroup: true } ]

        CaseType.query({
            page: 0,
            size: 100,
            sort: 'name,asc'
        }, function(data){
            if(data.length){
                data.forEach(function(item){
                    vm.statusType.push({name:item.name,selected:false,value:item.id})
                })
                vm.statusType.push({ msGroup: false})
            }
        }, function(err){});
        vm.selectedPriorityList = [];
        vm.selectedStatusList = [];
        vm.selectedPriorityType = [];
        vm.selectedStatusType = [];
        vm.showCaseAttachment = false

         vm.statusType.forEach(function(val){
            if(val.name == 'CRITICAL' || val.name ==  'HIGH' || val.name == "MEDIUM" || val.name == "LOW" ){
               vm.selectedPriorityList.push(val.name)
           } 
           if(val.name == 'NEW' || val.name ==  'INPROGRESS' || val.name == "PENDING" || val.name == "ASSIGNED"){
               vm.selectedStatusList.push(val.name)
           }
       }) 

        /* vm.priorityList.forEach(function (value) {
            vm.selectedPriorityList.push(value);
        });
        vm.statusList.forEach(function (value) {
            vm.selectedStatusList.push(value);
        });
        vm.priorityType.forEach(function (value) {
            vm.selectedPriorityType.push(value);
        });
        vm.statusType.forEach(function (value) {
            vm.selectedStatusType.push(value);
        }); */

        var pinLat = 0.0;
        var pinLong = 0.0;
        $rootScope.hideCaseEditBtn = false
        $rootScope.createCaseFromAssetMap = null

        $scope.tab = 1;
        $scope.$on("$destroy", function () {
            //            $interval.cancel(updateUserAgentPath);
        });
        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        if ($scope.tab == 1) {
            vm.dateRange = $state.params.rangeOption

            if(vm.dateRange == "custom"){
                vm.fromDate = $state.params.fromTime
                vm.toDate = $state.params.toTime
            }
            
            UserAccount.get(function (data) {
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    } else if (val != "ROLE_VENDOR" ){
                       AssetType.query(
                            {
                                page: 0,
                                size: 100,
                                sort: sort(),
                            },
                            onSuccess,
                            onError
                        );
                        function sort() {
                            var result = [
                                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                            ];
                            if (vm.predicate !== "id") {
                                //  result.push('id');
                            }
                            return result;
                        }
                        function onSuccess(data, headers) {
                            vm.assetTypes = data;
                        }
                        function onError(error) {
                            AlertService.error(error.data.message);
                        } 
                    }
                });
                if (isAdmin) {
                    vm.adminFilter = true;
                    filterTrcasesOnListView()
                    filterTrcaseSearch();
                } else {
                    vm.adminFilter = false;
                    filterTrcasesOnListView()
                    filterTrcaseSearch();
                }
            });
            Configs.get("CaseImage",function(response){
                if(response.length > 0){
                    if(response[0].configValue == "True"){
                        vm.showCaseAttachment = true
                    }
                }
            })
        }

        function imageUpload(id){
            vm.caseId = id
            $('#myModalUpload').show()
        }
        
        function saveImage(){
            var photo = document.getElementById("assetImages").files[0]; // file from input
            var req = new XMLHttpRequest();
            var formData = new FormData();
            if(photo){
                if(photo.type == "application/pdf"){
                    var name = photo.name.split('.')[0]
                    var type = photo.name.split('.')[1]
                    vm.fileWarning = false
                    formData.append("file", photo);
                    req.open("POST", "api/trakeyecaseimages/" + vm.caseId.id+"/"+name+"/"+type);
                    req.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
                    req.onload = function(e) {
                        if (this.status === 200) { 
                            closeImageUpload()
                            $('#successImage').show()
                        }else{
                            closeImageUpload()
                            $('#errorImage').show()
                        }}
                    req.send(formData);
                    }else{
                        vm.fileWarning = true 
                    }
            } 
        }

        function closeImageUpload() {
            $("#myModalUpload").removeClass("in");
            $(".modal-backdrop").remove();
            $("#myModalUpload").hide();
            setTimeout(function(){$('#successImage').hide()},2000)
            setTimeout(function(){$('#errorImage').hide()},2000)
        }

        function downloadPdfButton(selectedCaseId) {
            var downloadfileName = "";
            var downloadCaseDesc = "";
			vm.trCases.forEach(function(caseVal){
                if(caseVal.id == selectedCaseId){
                    downloadfileName = caseVal.caseTypeName;
                    downloadCaseDesc = caseVal.description;
                }
            });
            BaseUrl.getBaseUrl(function(baseurl){
				var request = new XMLHttpRequest();
				request.open('GET', baseurl.stringValue+"api/download-splicing-pdf/"+selectedCaseId, true);
				request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
				request.responseType = 'blob';
				
				request.onload = function(e) {
					if (this.status === 200) {
						var blob = this.response;
						if(blob.size > 0){
							var blob = new Blob([this.response], {type: 'application/pdf'});
							var link = document.createElement('a');
							link.href = window.URL.createObjectURL(blob);
							link.download = "document.pdf";
							link.download = downloadfileName+"_"+downloadCaseDesc + ".pdf";
							
							link.click();
							
						}
					}
				};
				request.send();
			});
        }

        function downloadPdfMapButton(caseId, fileName) {
            var downloadfileName = "";
            var downloadCaseDesc = "";
			vm.trCases.forEach(function(caseVal){
                if(caseVal.id == caseId){
                    downloadfileName = caseVal.caseTypeName;
                    downloadCaseDesc = caseVal.description;
                }
            });
            BaseUrl.getBaseUrl(function(baseurl){
				var request = new XMLHttpRequest();
				request.open('GET', baseurl.stringValue+"api/download-splicing-pdf/"+caseId, true);
				request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
				request.responseType = 'blob';
				
				request.onload = function(e) {
					if (this.status === 200) {
						var blob = this.response;
						if(blob.size > 0){
							var blob = new Blob([this.response], {type: 'application/pdf'});
							var link = document.createElement('a');
							link.href = window.URL.createObjectURL(blob);
							link.download = fileName + ".pdf";
							
							link.click();
							
						}
					}
				};
				request.send();
			});
        }


        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        $scope.geofencelabel = {
            search          : "Search",
            nothingSelected : "Geofence"      
        }

        $scope.statuslabel = {
            search          : "Search",
            nothingSelected : "Priority/Status",
            selectAll       : "All",
            selectNone      : "None", 
            Done : "Done" 
        }

        vm.showCasesFilter = false
        vm.textFilter = "Show"
        vm.showHideFilter = function (){
            vm.showCasesFilter = !vm.showCasesFilter
            vm.textFilter = vm.showCasesFilter ? "Hide" : "Show"
        }
        $scope.setTab = function (newTab) {
            $scope.search = null;
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                /* filterTrcasesOnListView()
                filterTrcaseSearch(); */
                if(tempGeofenceId){
                    vm.selectedListGeofenceId = tempGeofenceId
                    saveListFilter()
                    vm.geofencesListView.forEach(function (item){
                        if(item.id == vm.selectedListGeofenceId){
                            item.ticked = true
                        }else{
                            item.ticked = false
                        }
                    })
                }
                
            } else if ($scope.tab == 2) {
                /* var myOptions = {
                    zoom: 12,
                    center: new google.maps.LatLng(
                        DEFAULT_LATITUDE.value,
                        DEFAULT_LONGITUDE.value
                    ),
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas1"),
                    myOption(12,new google.maps.LatLng(
                        DEFAULT_LATITUDE.value,
                        DEFAULT_LONGITUDE.value
                    ))
                );
                geoLocation(locations.map);
                vm.selectedGeofenceId = 0;
                //filterTrCaseSearchMap();
                //vm.mapAssets = [];
                //getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
                setTimeout(function () {
                    removeMarkers();
                }, 2000);

                statusFilter();
                filterAssetsOnMapView()
                if(tempGeofenceId){
                    vm.selectedGeofenceId = tempGeofenceId
                    saveFilter()
                }
                
            } else if ($scope.tab == 3) {
                filterAssetsOnMapView()
                //vm.selectedGeofenceId = 0;
                //filterTrCaseSearchMap();
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas2"),
                    myOption(12,new google.maps.LatLng(
                        DEFAULT_LATITUDE.value,
                        DEFAULT_LONGITUDE.value
                    ))
                );
                geoLocation(locations.map); 
                getAllUsers()
                if(tempGeofenceId){
                    vm.selectedGeofenceId = tempGeofenceId
                    saveFilter()
                }
            } else if ($scope.tab == 4) {
                vm.selectedGeofenceId = 0;
                vm.selectedGeofenceMap = null
                /* var myOptions = {
                    zoom: 12,
                    center: new google.maps.LatLng(
                        DEFAULT_LATITUDE.value,
                        DEFAULT_LONGITUDE.value
                    ),
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas4"),
                    myOption(12,new google.maps.LatLng(
                        DEFAULT_LATITUDE.value,
                        DEFAULT_LONGITUDE.value
                    ))
                );
                geoLocation(locations.map);

                vm.userMasterGeofences = [];
                //UserMasterGeofences.getAll(function (response) {
				UserMasterGeofences.getAllMasterGeofenceByUser(function (response) {
                    vm.userMasterGeofences = response;
                });
                setTimeout(function () {
                    removeMarkers();
                }, 2000);
                statusFilter();
                vm.selectedMasterGeofenceId = 0;
            }
        };

        $("#masterGeofence").on("change", function () {
            var value = $(this).val();
            vm.selectedMasterGeofenceId = value;
            filterAssetsOnMapView()
        });

        function statusFilter() {
            $scope.togglePriorityTypeSelection = function togglePriorityTypeSelection(
                priorityName
            ) {
                var idx = vm.selectedPriorityType.indexOf(priorityName);

                if (idx > -1) {
                    vm.selectedPriorityType.splice(idx, 1);
                    vm.selectedPriorityList = [];
                } else {
                    vm.selectedPriorityType.push(priorityName);
                    vm.selectedPriorityList = [];
                    vm.priorityList.forEach(function (value) {
                        vm.selectedPriorityList.push(value);
                    });
                }
            };

            $scope.togglePriorityListSelection = function togglePriorityListSelection(
                priorityName
            ) {
                var idx = vm.selectedPriorityList.indexOf(priorityName);

                if (idx > -1) {
                    vm.selectedPriorityList.splice(idx, 1);
                } else {
                    vm.selectedPriorityList.push(priorityName);
                }
            };

            $scope.toggleStatusTypeSelection = function toggleStatusTypeSelection(
                statusName
            ) {
                var idx = vm.selectedStatusType.indexOf(statusName);

                if (idx > -1) {
                    vm.selectedStatusType.splice(idx, 1);
                    vm.selectedStatusList = [];
                } else {
                    vm.selectedStatusType.push(statusName);
                    vm.selectedStatusList = [];
                    vm.statusList.forEach(function (value) {
                        vm.selectedStatusList.push(value);
                    });
                }
            };

            $scope.toggleStatusListSelection = function toggleStatusListSelection(
                statusName
            ) {
                var idx = vm.selectedStatusList.indexOf(statusName);

                if (idx > -1) {
                    vm.selectedStatusList.splice(idx, 1);
                } else {
                    vm.selectedStatusList.push(statusName);
                }
            };
        }

        $scope.savePriorityStatusFilter = function () {
            vm.selectedPriorityList = []
            vm.selectedStatusList = []
            vm.selectedCaseTypeList = []
            vm.selectedstatusType.forEach(function(val){
                 if(val.name == 'CRITICAL' || val.name ==  'HIGH' || val.name == "MEDIUM" || val.name == "LOW" ){
                    vm.selectedPriorityList.push(val.name)
                } else if(val.name == 'NEW' || val.name ==  'INPROGRESS' || val.name == "PENDING" || val.name == "ASSIGNED"
                || val.name ==  'CANCELLED' || val.name == "CLOSED" ){
                    vm.selectedStatusList.push(val.name)
                }else{
                    vm.selectedCaseTypeList.push(val.value)
                }

            })

            if (
                vm.selectedPriorityList.length > 0 &&
                vm.selectedStatusList.length > 0
            ) {
                saveFilter();
            }
        };

        function navigateCaseEdit(selectedId) {
            vm.editId = selectedId.id;
            sessionStorage.setItem("prevEditId", vm.editId);
            $state.go("tr-case.edit", {
                id: vm.editId,
            });
        }

        function goToEditPage(selectedId) {
            $state.go("asset.edit", {
                id: selectedId.id,
            });
        }

        function usersTable(trCase) {
            vm.trCases.forEach(function (item) {
                item.isExpanded = false;
            });
            if (vm.toggle == trCase.id) {
                vm.toggle = undefined;
            } else {
                trCase.isExpanded = true;
                vm.toggle = trCase.id;
            }

            Report.getUsersAroundCase(
                {
                    id: trCase.id,
                    fromTime: trCase.createDate,
                    toTime: trCase.createDate + 1.8e6,
                },
                function (response) {
                    if (response instanceof Array) {
                        vm.caseAroundUsers = response;
                    } else {
                        vm.caseAroundUsers = [];
                        vm.caseAroundUsers.push(response);
                    }
                    vm.search = "";
                    vm.reporthide = true;
                }
            );
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                    Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                    Math.cos(degrees_to_radians(lat2)) *
                    Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

        function searchTrCases() {
            if(isNewCaseSelected == 'day') {
                fromDateValue = sixMonthsAgoEpoch;
                toDateValue = now;
            } else {
                fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
                toDateValue = vm.toDate.setHours(23, 59, 59, 999);
            }
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search) &&
                $scope.search.length != 1 &&
                $scope.search.length != 2 &&
                $scope.search.length != 3 &&
                $scope.search.length != 4
            ) {
                if ($stateParams.priority == undefined) {
                    if (vm.selectedListGeofenceId > 0) {
                        TrCaseGeofenceSearchCustom.query(
                            {
                                search: $scope.search,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                geofenceId: vm.selectedListGeofenceId,
                                fromDate: fromDateValue,
                                toDate: toDateValue
                            },
                            onSuccess,
                            onError
                        );
                    } else {
                        TrCaseSearchCustom.query(
                            {
                                search: $scope.search,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                geofenceId: vm.selectedListGeofenceId,
                                fromDate: fromDateValue,
                                toDate: toDateValue
                            },
                            onSuccess,
                            onError
                        );
                    }
                } else {
                    TrCasePrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }

                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    var trCasesSearchRes = [];
                    data.forEach(function (values) {
                        var FiberStatus = "";
                        var Cost = "";
                        var pb = "";
                        var dis = "";
                        var baseCost = "";
                        var caseTypeAttrVal = values.caseTypeAttributeValues;

                        caseTypeAttrVal.forEach(function (item) {
                            if (item.caseDataTypeName == "Fiber Status") {
                                FiberStatus = item.attributeValue;
                            }
                            if (item.name == "Cost") {
                                Cost = item.attributeValue;
                            } else if (item.name == "Power Budget") {
                                pb = item.attributeValue;
                            } else if (item.name == "Fiber Distance") {
                                dis = item.attributeValue;
                            } else if (item.name == "Base Cost") {
                                baseCost = item.attributeValue;
                            }
                        });

                        //						if (values.status) {
                        //							values.status = values.status.replace("NEW", "PLANNING PHASE");
                        //							values.status = values.status.replace("INPROGRESS", "ROLL-OUT PHASE");
                        //							values.status = values.status.replace("RESOLVED", "OPERATION PHASE");
                        //						}

                        var isVerified = false;
                        if (values.verified) {
                            isVerified = true;
                        }
                        var res = {
                            id: values.id,
                            description: values.description,
                            address: values.address,
                            escalated: values.escalated,
                            status: values.status,
                            reportedByUser: values.reportedByUser,
                            assignedToUser: values.assignedToUser,
                            verified: isVerified,
                            caseTypeName: values.caseTypeName,
                            pinLat: values.pinLat,
                            pinLong: values.pinLong,
                            caseType: values.caseType,
                            priority: values.priority,
                            caseNumber: caseNumber.caseNumber,
                            fiberStatus: FiberStatus,
                            groups: values.groups,
                            geofenceName: values.geofenceName,
                            caseAssets: values.caseAssets,
                            Cost: "$" + Cost,
                            pb: pb,
                            dis: dis,
                            baseCost: baseCost,
                            updatedByUser: values.updatedByUser,
                            isOpened : values.isOpened
                        };

                        trCasesSearchRes.push(res);
                    });
                    vm.trCases = trCasesSearchRes;
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function filterTrcaseSearch() {
            if(isNewCaseSelected == 'day') {
                fromDateValue = sixMonthsAgoEpoch;
                toDateValue = now;
            } else {
                if(vm.fromDate && vm.toDate){
                    fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
                    toDateValue = vm.toDate.setHours(23, 59, 59, 999);
                }
            }
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                if ($stateParams.priority == undefined) {
                    if (vm.selectedListGeofenceId > 0) {
                        TrCaseGeofenceSearchCustom.query(
                            {
                                search: $scope.search,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                geofenceId: vm.selectedListGeofenceId,
                                fromDate: fromDateValue,
                                toDate: toDateValue,
                            },
                            onSuccess,
                            onError
                        );
                    } else {
                        TrCaseSearchCustom.query(
                            {
                                search: $scope.search,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                fromDate: fromDateValue,
                                toDate: toDateValue,
                            },
                            onSuccess,
                            onError
                        );
                    }
                } else {
                    TrCasePrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }

                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    var dateFormat = "dd-MM-yyyy";
                    // vm.trCases = data;
                    var trCaseSearch = [];

                    data.forEach(function (value) {
                        var isVerified = false;
                        if (value.verified) {
                            isVerified = true;
                        }
                        var res = {
                            id: value.id,
                            createDateFormat: $filter("date")(
                                value.createDate,
                                dateFormat
                            ),
                            createDate: value.createDate,
                            description: value.description,
                            address: value.address,
                            escalated: value.escalated,
                            status: value.status,
                            reportedByUser: value.reportedByUser,
                            assignedToUser: value.assignedToUser,
                            verified: isVerified,
                            caseTypeName: value.caseTypeName,
                            pinLat: value.pinLat,
                            pinLong: value.pinLong,
                            caseType: value.caseType,
                            priority: value.priority,
                            caseNumber: value.caseNumber,
                            groups: value.groups,
                            geofenceName: value.geofenceName,
                            caseAssets: value.caseAssets,
                            updatedByUser: value.updatedByUser,
                            isOpened : value.isOpened
                        };
                        trCaseSearch.push(res);
                    });
                    vm.trCases = trCaseSearch;
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function getGroupAssetsFromES(
            geofenceIdVal,
            lastAssetId,
            mapAssetLists
        ) {
            AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;

                    vm.mapAssets.push(tmpAsset);
                });
                drawLatestAssets(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupAssetsFromES(
                        geofenceIdVal,
                        data.lastId,
                        vm.mapAssets
                    );
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].longitude,
                            };
                            locations.map.setCenter(assetLatLng);
                        });
                    }
                }
            });
        }

        $scope.submitDate = function (){
            $scope.search = "";
            $state.params.rangeOption = 'custom'
            isNewCaseSelected = $state.params.rangeOption
            //isNewCaseSelected = false;
            
            if(vm.fromDate && vm.toDate){
                fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
                toDateValue = vm.toDate.setHours(23, 59, 59, 999);
                if (vm.selectedListGeofenceId > 0) {
                    TrCaseGeofenceCustomTime.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                            geofenceId: vm.selectedListGeofenceId,
                            fromDate: fromDateValue,
                            toDate: toDateValue,
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    TrCaseCustomTime.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                            fromDate: fromDateValue,
                            toDate: toDateValue,
                        },
                        onSuccess,
                        onError
                    );
                }
            }
            
        }

        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers("link"));
            vm.totalItems = headers("X-Total-Count");
            vm.queryCount = vm.totalItems;
            var trCasesRes = [];
            var dateFormat = "dd-MM-yyyy";
            vm.trBreakUps = data;
            data.forEach(function (values) {
                if (values.groups.length > 0) {
                    vm.parentGroup = values.groups[0].name;
                }
                var FiberStatus = "";
                var Cost = "";
                var pb = "";
                var dis = "";
                var baseCost = "";
                var caseTypeAttrVal = values.caseTypeAttributeValues;

                caseTypeAttrVal.forEach(function (item) {
                    if (item.caseDataTypeName == "Fiber Status") {
                        FiberStatus = item.attributeValue;
                    }
                    if (item.name == "Cost") {
                        Cost = item.attributeValue;
                    } else if (item.name == "Power Budget") {
                        pb = item.attributeValue;
                    } else if (item.name == "Fiber Distance") {
                        dis = item.attributeValue;
                    } else if (item.name == "Base Cost") {
                        baseCost = item.attributeValue;
                    }
                });
                var isVerified = false;
                if (values.verified) {
                    isVerified = true;
                }
                var res = {
                    id: values.id,
                    createDateFormat: $filter("date")(
                        values.createDate,
                        dateFormat
                    ),
                    createDate: values.createDate,
                    description: values.description,
                    address: values.address,
                    escalated: values.escalated,
                    status: values.status,
                    reportedByUser: values.reportedByUser,
                    assignedToUser: values.assignedToUser,
                    verified: isVerified,
                    caseTypeName: values.caseTypeName,
                    pinLat: values.pinLat,
                    pinLong: values.pinLong,
                    caseType: values.caseType,
                    priority: values.priority,
                    caseNumber: values.caseNumber,
                    fiberStatus: FiberStatus,
                    groups: values.groups,
                    geofenceName: values.geofenceName,
                    caseAssets: values.caseAssets,
                    Cost: "$" + Cost,
                    pb: pb,
                    dis: dis,
                    baseCost: baseCost,
                    updatedByUser: values.updatedByUser,
                    isOpened : values.isOpened
                };
                trCasesRes.push(res);
            });
            vm.trCases = trCasesRes;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function newCases(){
            $scope.search = "";
            $state.params.rangeOption = vm.dateRange
            isNewCaseSelected = $state.params.rangeOption;
                        
            if(isNewCaseSelected == 'day') {
                fromDateValue = sixMonthsAgoEpoch;
                toDateValue = now;
                vm.fromDate = null
                vm.toDate = null
            } else {
                fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
                toDateValue = vm.toDate.setHours(23, 59, 59, 999);
            }
            
            if (vm.selectedListGeofenceId > 0) {
                TrCaseGeofenceCustomTime.query(
                    {
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                        geofenceId: vm.selectedListGeofenceId,
                        fromDate: fromDateValue,
                        toDate: toDateValue,
                    },
                    onSuccess,
                    onError
                );
            } else {
                TrCaseCustomTime.query(
                    {
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                        fromDate: fromDateValue,
                        toDate: toDateValue,
                    },
                    onSuccess,
                    onError
                );
            }
        }
        function loadAll() {
            $scope.search == null;

            if ($stateParams.priority == undefined) {
                vm.groupCases = false;
                vm.showTrCaseActions = false;
                if ($stateParams.caseStatus == undefined) {
                    newCases()
                } else {
                    TrCaseAttendance.query(
                        {
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            caseStatus: $stateParams.caseStatus,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            } else {
                TrCasePriority.query(
                    {
                        priority: $stateParams.priority,
                        geofenceId: $stateParams.geofenceId,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
            }

            /* function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    // result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                var trCasesRes = [];
                var dateFormat = "dd-MM-yyyy";
                vm.trBreakUps = data;
                data.forEach(function (values) {
                    if (values.groups.length > 0) {
                        vm.parentGroup = values.groups[0].name;
                    }
                    var FiberStatus = "";
                    var Cost = "";
                    var pb = "";
                    var dis = "";
                    var baseCost = "";
                    var caseTypeAttrVal = values.caseTypeAttributeValues;

                    caseTypeAttrVal.forEach(function (item) {
                        if (item.caseDataTypeName == "Fiber Status") {
                            FiberStatus = item.attributeValue;
                        }
                        if (item.name == "Cost") {
                            Cost = item.attributeValue;
                        } else if (item.name == "Power Budget") {
                            pb = item.attributeValue;
                        } else if (item.name == "Fiber Distance") {
                            dis = item.attributeValue;
                        } else if (item.name == "Base Cost") {
                            baseCost = item.attributeValue;
                        }
                    });
                    var isVerified = false;
                    if (values.verified) {
                        isVerified = true;
                    }
                    var res = {
                        id: values.id,
                        createDateFormat: $filter("date")(
                            values.createDate,
                            dateFormat
                        ),
                        createDate: values.createDate,
                        description: values.description,
                        address: values.address,
                        escalated: values.escalated,
                        status: values.status,
                        reportedByUser: values.reportedByUser,
                        assignedToUser: values.assignedToUser,
                        verified: isVerified,
                        caseTypeName: values.caseTypeName,
                        pinLat: values.pinLat,
                        pinLong: values.pinLong,
                        caseType: values.caseType,
                        priority: values.priority,
                        caseNumber: values.caseNumber,
                        fiberStatus: FiberStatus,
                        groups: values.groups,
                        geofenceName: values.geofenceName,
                        caseAssets: values.caseAssets,
                        Cost: "$" + Cost,
                        pb: pb,
                        dis: dis,
                        baseCost: baseCost,
                    };
                    trCasesRes.push(res);
                });
                vm.trCases = trCasesRes;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            } */
        }

        function saveListFilter() {
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
            filterTrcaseSearch();
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
        }

        $scope.geofenceListView = function(){
            if($scope.tab == 1){
                isNewCaseSelected = vm.dateRange
                vm.selectedListGeofenceId = vm.selectedGeofenceId[0].id
                tempGeofenceId = vm.selectedGeofenceId[0].id
                saveListFilter()
            }else if($scope.tab == 2 || $scope.tab == 3 || $scope.tab == 4){
                $scope.search = ""
                vm.selectedGeofenceId = vm.selectedGeofenceMap[0].id
                tempGeofenceId = vm.selectedGeofenceMap[0].id
                saveFilter()
            }
        }
        function filterTrcasesOnListView() {
            tempGeofenceId = $state.params.listgeofenceid
            vm.geofencesListView = [];
            vm.userGeofences = []
            if (vm.adminFilter) {
                GeofenceIDs.getAll(function (response) {
                    if (response.length >= 2) {
                        vm.geofencesListView.push({ id: 0, name: "All", label : "All" });
                    }
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                        vm.geofencesListView.push(geofence);
                        vm.userGeofences.push(geofence);
                        /* if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        } */
                    });
                });
            } else {
                UserGeofences.getAll(function (response) {
                    if (response.length >= 2) {
                        vm.geofencesListView.push({ id: 0, name: "All", label : "All" });
                    }
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                        vm.userGeofences.push(geofence);
                        vm.geofencesListView.push(geofence);
                        /* if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        } */
                    });
                });
            }
            //$("#listFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
        }

        function closeListFilterModal() {
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
            vm.selectedListGeofenceId = vm.PrevselectedListGeofenceId;
        }

        function showPriorityStatusFilter() {
            vm.currentZoom = locations.map.getZoom();

            vm.getCenter = locations.map.center;

            $("#priorityStatusfilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function closePriorityStatusFilterModal() {
            $("#priorityStatusfilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#priorityStatusfilterModal").hide();
        }

        function dateFilterTrCaseSearchMap(){
            var tempResponse
            if(vm.geofenceResponse && vm.geofenceResponse.length > 0 && $scope.search){
                tempResponse = vm.geofenceResponse.find(function (element){
                    return $scope.search == element.id
                })
                if(tempResponse){
                    drawResponseMap([tempResponse]);
                }
            }
        }

        function filterTrCaseSearchMap() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                // TrCaseSearchForMap.searchtrcaseformap($scope.search, function (response) {
                //     drawResponseMap(response);
                // });

                TrCaseForMap.getAllCases(
                    {
                        geofenceId: vm.selectedGeofenceId,
                        searchText: $scope.search,
                        priorityList: vm.selectedPriorityList,
                        statusList: vm.selectedStatusList,
                    },
                    function (response) {
                        drawResponseMap(response);
                    }
                );
            } else {
                if ($stateParams.priority == undefined) {
                    // TrCaseForMap.getAllCases(function (response) {
                    //     drawResponseMap(response);
                    // });
                    TrCaseForMap.getAllCases(
                        {
                            geofenceId: vm.selectedGeofenceId,
                            priorityList: vm.selectedPriorityList,
                            statusList: vm.selectedStatusList,
                        },
                        function (response) {
                            drawResponseMap(response);
                        }
                    );
                } else {
                    TrCaseForMap.getAllCases(
                        {
                            geofenceId: vm.selectedGeofenceId,
                            prioritySearch: $stateParams.priority,
                        },
                        function (response) {
                            drawResponseMap(response);
                        }
                    );
                    // TrCaseSearchForMap.prioritysearchtrcaseformap($stateParams.priority, function (response) {
                    //     drawResponseMap(response);
                    // });
                }
            }
        }

        function drawLatestAssets(response) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                            value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    drawFixedAsset(value1, false);
                                } else {
                                    drawFixedAsset(value, false);
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                drawPolyline(value, locations.map);
                            }
                        });
                    });
                });
            }
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 14,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(14,locations.latlng)
                );

                google.maps.event.addListener(
                    locations.map,
                    "zoom_changed",
                    function () {
                        vm.zoomLevel = locations.map.getZoom();
                        if (
                            (vm.prevZoomLevel == 17 && vm.zoomLevel == 18) ||
                            (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)
                        ) {
                            drawLatestAssets(vm.mapAssets);
                        }
                        vm.prevZoomLevel = vm.zoomLevel;
                    }
                );
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () {};
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");
            callback();
        }

        function initializeAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            lngVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            // callback(new google.maps.LatLng("12.9716", "77.5946"));
                            callback(
                                new google.maps.LatLng(
                                    DEFAULT_LATITUDE.value,
                                    DEFAULT_LONGITUDE.value
                                )
                            );
                        }
                    );
                } else {
                    callback(
                        new google.maps.LatLng(
                            DEFAULT_LATITUDE.value,
                            DEFAULT_LONGITUDE.value
                        )
                    );
                }
            }
        }

        function drawFixedAsset(fixed, hasParent) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                    },
                });
                markers.push(startMarker);

                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    startMarker.title +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        AssetByID.get(fixed.id, function (response) {
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                buttonA,
                                buttonB,
                                buttonC,
                                buttonD;
                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<b>Name</b> : " + startMarker.title +
                                '</div><div class="infoWindowContent">' +
                                "<b>Asset Type</b> : " + fixed.assetTypeName +
                                "<br><b>Latitude</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Longitude</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "<br>" +
                                infoStr +
                                "</div>";

                            var infoWindow2 = new google.maps.InfoWindow({
                                content: userContent,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            infoWindow2.open(locations.map, startMarker);
                            setTimeout(function () {
                                infoWindow2.close();
                            }, 5000);

                            activeInfoWindow = infoWindow2;
                            prevInfoWindow = infoWindow2;
                        });
                    }
                );
                openedInfoWindow = infoWindow2;
            });
        }

        function selectAllAssets() {
            var toggleStatus = vm.isAllAssetSelected;
            if (toggleStatus) {
                vm.showAssetActions = true;
                vm.selectedAssets = [];
                vm.trCases.forEach(function (asset) {
                    vm.selectedAssets.push(asset.id);
                });
            } else {
                vm.showAssetActions = false;
                vm.selectedAssets = [];
            }
            angular.forEach(vm.trCases, function (item) {
                item.isChecked = toggleStatus;
            });
        }

        function filterAssetsOnMapView() {
            vm.userGeofences = [];
            if (vm.adminFilter) {
                if ($scope.tab == 2 || $scope.tab == 3) {
                    GeofenceIDs.getAll(function (response) {
                        response.forEach(function (geofence) {
                            geofence.label = geofence.name.substring(0, 15) + "..";
                            vm.userGeofences.push(geofence);

                            geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                           /*  if (vm.selectedGeofenceId == null) {
                                vm.selectedGeofenceId = geofence.id;
                            } */
                        });
                        vm.countUserGeofences = vm.userGeofences.length;
                    });
                } else if ($scope.tab == 4) {
                    vm.userGeofences = [];
                    MiniGeofencesByMasterID.get(
                        vm.selectedMasterGeofenceId,
                        function (response) {
                            response.forEach(function (geofence) {
                                geofence.label = geofence.name.substring(0, 15) + "..";
                                vm.userGeofences.push(geofence);

                                //geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                                /* if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                } */
                            });
                            vm.countUserGeofences = vm.userGeofences.length;
                        }
                    );
                }
            } else {
                UserGeofences.getAll(function (response) {
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        vm.userGeofences.push(geofence);
                        if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        }
                    });
                    vm.countUserGeofences = vm.userGeofences.length;
                });
            }
            //$("#mapFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            //vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
            /* vm.selectedPriorityList = [];
            vm.priorityList.forEach(function (value) {
                vm.selectedPriorityList.push(value);
            });
            vm.selectedStatusList = [];
            vm.statusList.forEach(function (value) {
                vm.selectedStatusList.push(value);
            }); */
        }

        function closeMapFilterModal() {
            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
        }

        function saveFilter() {
            if(isNewCaseSelected == 'day') {
                fromDateValue = sixMonthsAgoEpoch;
                toDateValue = now;
            } else {
                fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
                toDateValue = vm.toDate.setHours(23, 59, 59, 999);
            }
            if ($stateParams.priority == undefined) {
                var sendData
                if (vm.dateRange == 'day'){
                    sendData = {
                        geofenceId: vm.selectedGeofenceId,
                        priorityList: vm.selectedPriorityList,
                        statusList: vm.selectedStatusList,
                        caseTypeIds : vm.selectedCaseTypeList,
                        fromDate: fromDateValue,
                        toDate: toDateValue,
                    }

                }else if(vm.dateRange == 'custom'){
                    sendData = {
                        geofenceId: vm.selectedGeofenceId,
                        priorityList: vm.selectedPriorityList,
                        statusList: vm.selectedStatusList,
                        caseTypeIds : vm.selectedCaseTypeList,
                        fromDate: vm.fromDate.setHours(0, 0, 0, 0),
                        toDate: vm.toDate.setHours(23, 59, 59, 999)
                    }
                }

                TrCaseForMap.getAllCases(
                    sendData,
                    function (response) {
                        vm.geofenceResponse = response
                        drawResponseMap(response);
                        vm.mapAssets = [];
                        markers = [];
                        polylines = [];
                       /*  var myOptions = {
                            zoom: 17,
                            center: locations.latlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                        }; */
                        if ($scope.tab == 2) {
                            locations.map = new google.maps.Map(
                                document.getElementById("map_canvas1"),
                                myOption(17,locations.latlng)
                            );
                        } else if ($scope.tab == 3) {
                            locations.map = new google.maps.Map(
                                document.getElementById("map_canvas2"),
                                myOption(17,locations.latlng)
                            );
                        } else if ($scope.tab == 4) {
                            locations.map = new google.maps.Map(
                                document.getElementById("map_canvas4"),
                                myOption(17,locations.latlng)
                            );
                        }

                        geoLocation(locations.map);
                        getGroupAssetsFromES(
                            vm.selectedGeofenceId,
                            null,
                            vm.mapAssets
                        );
                        drawLatestTrCases(response);
                        closePriorityStatusFilterModal();
                        vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
                    }
                );
            }

            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
        }

        function selectTrcaseEntity(trCase) {
            if (trCase.id != null) {
                if (trCase.isChecked == true) {
                    vm.totalTrcaseSelected++;
                    vm.showTrCaseActions = true;
                    vm.isAllTrCaseSelected = vm.trCases.every(function (itm) {
                        return itm.isChecked;
                    });
                    vm.selectedWorkCases.push(trCase.id);
                } else {
                    vm.totalTrcaseSelected--;
                }
                if (vm.totalTrcaseSelected == 0) {
                    vm.groupAssets = true;
                    vm.showTrCaseActions = false;
                    filterTrcaseSearch();
                }
            }
        }

        function selectAllTrCases() {
            var toggleStatus = vm.isAllTrCaseSelected;
            if (toggleStatus) {
                vm.showTrCaseActions = true;
                vm.selectedWorkCases = [];
                vm.trCases.forEach(function (trCase) {
                    vm.selectedWorkCases.push(trCase.id);
                });
            } else {
                vm.showTrCaseActions = false;
                vm.selectedWorkCases = [];
            }
            angular.forEach(vm.trCases, function (itm) {
                itm.isChecked = toggleStatus;
            });
        }

        function animatedMove(marker, t, current, moveto) {
            var lat = current.lat();
            var lng = current.lng();

            var deltalat = (moveto.lat() - current.lat()) / 100;
            var deltalng = (moveto.lng() - current.lng()) / 100;

            var delay = 10 * t;
            for (var i = 0; i < 100; i++) {
                (function (ind) {
                    setTimeout(function () {
                        var lat = marker.position.lat();
                        var lng = marker.position.lng();
                        lat += deltalat;
                        lng += deltalng;
                        latlng = new google.maps.LatLng(lat, lng);
                        marker.setPosition(latlng);
                    }, delay * ind);
                })(i);
            }
        }

        function getAllUsers(){
            TrCaseLastLocation.getlastlogs(function (response) {
                var lastLocByAgents = response;
                vm.usersList = [];
                response.forEach(function (user) {
                    if (user.path.length > 0) {
                        vm.usersList.push(user);
                    }
                });
                var markerIcon = "inactive";
                var imageUrl = "";
                switch (markerIcon) {
                    case "inactive":
                        imageUrl = "content/images/inactive_out.png";
                        break;
                    case "idle":
                        imageUrl = "content/images/marker_idle.png";
                        break;
                    case "active":
                        imageUrl = "content/images/marker_active.png";
                        break;
                    case "active_case":
                        imageUrl = "content/images/marker_active_case.png";
                        break;
                    default:
                        imageUrl = "content/images/green.png";
                        break;
                }

                var lastLocVal = [];
                removeMarkers();
                for (var i = 0; i < lastLocByAgents.length; i++) {
                    var path = lastLocByAgents[i].path;
                    if (path.length > 1) {
                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng(
                                path[0].lat,
                                path[0].lng
                            ),
                            map: locations.map,
                            icon: {
                                scaledSize: new google.maps.Size(42, 40),
                                origin: new google.maps.Point(0, 0),
                                url: imageUrl,
                                anchor: new google.maps.Point(16, 16),
                            },
                            label: {
                                color: "#000000",
                                fontWeight: "bold",
                                fontSize: "16px",
                                text: lastLocByAgents[i].userName,
                                backgroundcolor: "#ff9800",
                            },
                            title: lastLocByAgents[i].userName,
                        });
                        var markerContent =
                            '<div class="infoWindowhead">' +
                            lastLocByAgents[i].userName +
                            '</div><div class="infoWindowContent"> <br> <b> Lat  :</b> ' +
                            +path[0].lat +
                            "<br> <b>Lng :</b> " +
                            path[0].lng +
                            "</div>";

                        infowindowUsers(markerContent, marker);

                        animatedMove(
                            marker,
                            50,
                            marker.position,
                            new google.maps.LatLng(path[1].lat, path[1].lng)
                        );
                        nearbyAgentsMarkers.push(marker);
                    }
                }
            });
        }

        function drawResponseMap(data) {
            var myOptions = null;
            var latCase
            var longCase
            data.forEach(function (coOrdinates) {
                if (coOrdinates.pinLat != null && coOrdinates.pinLong != null) {
                     latCase = coOrdinates.pinLat.toString();
                     longCase = coOrdinates.pinLong.toString();
                   /*  myOptions = {
                        zoom: 10,
                        center: new google.maps.LatLng(lat, long),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                    }; */
                }
            });
            if ($scope.tab == 2 || $scope.tab == 4) {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas1"),
                    myOption(10,new google.maps.LatLng(latCase, longCase))
                );
                geoLocation(locations.map);
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () {};
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById("map_canvas1");
                drawLatestTrCases(data);
            } else if ($scope.tab == 3) {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas2"),
                    myOption(10,new google.maps.LatLng(latCase, longCase))
                );
                geoLocation(locations.map);
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () {};
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById("map_canvas2");
                drawCasesAndNearByAgents(data);
                getAllUsers()
            }
        }

        function infowindowUsers(markerContent, marker) {
            var infowindow = new google.maps.InfoWindow();
            marker.addListener("click", function () {
                clearTimeout(infoTimer);
                if (activeInfo != null) {
                    activeInfo.close();
                }
                infowindow.setContent(markerContent);
                infowindow.open(locations.map, marker);
                activeInfo = infowindow;
                infoTimer = setTimeout(function () {
                    if (activeInfo != null) {
                        activeInfo.close();
                    }
                }, 8000);
            });
        }

        function removeMarkers() {
            for (var i = 0; i < nearbyAgentsMarkers.length; i++) {
                nearbyAgentsMarkers[i].setMap(null);
            }
            nearbyAgentsMarkers = [];
        }

        $("#searchOnMap").change(function () {
            var userSelected = JSON.parse($("#searchOnMap").val());
            var userLatLng = {
                lat: userSelected.path[0].lat,
                lng: userSelected.path[0].lng,
            };
            locations.map.setZoom(15);
            locations.map.setCenter(userLatLng);
        });

        /*function filterTrcases() {
            vm.itemsPerPage = 1000;
            if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
                if ($stateParams.priority == undefined) {

                    TrCaseSearchCustom.query({
                        search : $scope.search,
                        page : pagingParams.page - 1,
                        size : vm.itemsPerPage,
                        sort : sort()
                    }, onSuccess, onError);
                } else {
                    TrCasePrioritySearch.query({
                        searchtext : $scope.search,
                        priority : $stateParams.priority,
                        page : pagingParams.page - 1,
                        size : vm.itemsPerPage,
                        sort : sort()
                    }, onSuccess, onError);
                }
            } else {
                if ($stateParams.priority == undefined) {

                    TrCase.query({
                        page : pagingParams.page - 1,
                        size : vm.itemsPerPage,
                        sort : sort()
                    }, onSuccess, onError);
                } else {
                    TrCasePriority.query({
                        priority : $stateParams.priority,
                        page : pagingParams.page - 1,
                        size : vm.itemsPerPage,
                        sort : sort()
                    }, onSuccess, onError);
                }
            }
            function sort() {
                var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
                if (vm.predicate !== 'id') {
                    // result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                var myOptions = {
                    zoom : 10,
                    center : new google.maps.LatLng("5.431587","101.128162"),
                    mapTypeId : google.maps.MapTypeId.ROADMAP
                };

                if ($scope.tab == 2) {

                    locations.map = new google.maps.Map(document.getElementById("map_canvas1"), myOptions);
                    locations.overlay = new google.maps.OverlayView();
                    locations.overlay.draw = function() {
                    };
                    locations.overlay.setMap($scope.map);
                    locations.element = document.getElementById('map_canvas1');
                    drawLatestTrCases(data);
                } else if ($scope.tab == 3) {

                    locations.map = new google.maps.Map(document.getElementById("map_canvas2"), myOptions);
                    locations.overlay = new google.maps.OverlayView();
                    locations.overlay.draw = function() {
                    };
                    locations.overlay.setMap($scope.map);
                    locations.element = document.getElementById('map_canvas2');
                    drawCasesAndNearByAgents(data);
                }

            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

        }*/

        /*if ($scope.search === null || $scope.search === "" || angular.isUndefined($scope.search)) {
            loadAll();
        } else {
            if ($scope.tab == 2) {
                filterTrcases();
            	
            }
            if ($scope.tab == 3) {
                TrCaseUser.gettrcasesuser(function(response) {
                    $scope.trcaseuser = response;
                });
                filterTrcases();
            	
            } else if ($scope.tab == 1) {
                vm.itemsPerPage = paginationConstants.itemsPerPage;
                filterTrcaseSearch();
            }
        }*/

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }
        
        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                priority: pagingParams.priority,
                geofenceId : pagingParams.geofenceId,
                login: $stateParams.login,
                fromTime: vm.fromDate,
                toTime: vm.toDate,
                listgeofenceid: vm.selectedListGeofenceId,
                caseStatus: $stateParams.caseStatus,
                rangeOption : vm.dateRange,
            })
        }

        $scope.openInfoWindow = function (e, selectedMarker) {
            e.preventDefault();
            google.maps.event.trigger(selectedMarker, "click");
        };

        function drawPolyline(spread, map) {
            var spreadAssetCoordinates = [];
            var spreadColor = 0;
            var spreadWidth = 0;
            var spreadOpacity = 0;

            vm.assetTypes.forEach(function (assetType) {
                if (assetType.name == spread.assetTypeName) {
                    spreadColor = assetType.colorcode;
                    spreadWidth = assetType.lineWidth * 0.05;
                    spreadOpacity = assetType.transparency * 0.01;
                }
            });

            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
               if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spreadColor;
                }
                var polylineWeight = spreadWidth;
                var strokeOpacityVal = spreadOpacity;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }

                                var userContent = document.createElement("div"),
                                    button;

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    "<b>Name : </b> " +
                                    spread.name +
                                    "<br><b>Asset Type : </b> " + spread.assetType.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km</br>";

                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });
                            });
                        }
                        if (infowindow != null) {
                            infowindow.setPosition(event.latLng);
                            infowindow.open(locations.map);
                            openedInfoWindow = infowindow;
                        }
                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locations.map);

                polylines.push(polylinepath);
            }
        }
        

        function drawLatestTrCases(response) {
            if (response) {
                initializeTrcaseMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // function() {
                    var btnDrawLine,brBreak,noAssetsFound,btnDownloadPdf;
                    var entryMarker = []
                    var endMarker = []
                    $.each(response, function (index, value) {
                        var userContent = document.createElement("div"),
                            button;

                        var infoWindow = new google.maps.InfoWindow({
                            content: userContent,
                        });

                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });
                        var infoWindow2 = new google.maps.InfoWindow();
                        // if(value.userCase=='C'){
                        if (value.priority == "LOW") {
                            startMarker.setIcon(
                                "content/images/Pointers-L4.png"
                            );
                        } else if (value.priority == "MEDIUM") {
                            startMarker.setIcon(
                                "content/images/Pointers-M4.png"
                            );
                        } else if (value.priority == "HIGH") {
                            startMarker.setIcon(
                                "content/images/Pointers-H4.png"
                            );
                        } else if (value.priority == "CRITICAL") {
                            startMarker.setIcon(
                                "content/images/Pointer-C4.png"
                            );
                        }

                        userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            startMarker.title +
                            '</div><div class="infoWindowContent"> <b>Case Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b>Address :</b> " +
                            value.address +
                            "</div>";

                        // var span = '<a userId="' + value.geofenceName + '" class="userpath" >Load travelled path</a>';
                        // startMarker.content = '<div class="infoWindowContent"> <b>Case Id : </b>' + value.id + '<br> <b>Reported By :</b> ' + value.reportedByUser + '<br> <b> Assigned To :</b> ' + value.assignedToUser +
                        //     '<br> <b>Address :</b> ' + value.address + '</div>';

                        button = userContent.appendChild(
                            document.createElement("input")
                        );
                        button.type = "button";
                        button.value = "Case Details";
                        button.className = "button";

                        google.maps.event.addDomListener(
                            button,
                            "click",
                            function () {
                                $state.go("tr-case-detail", {
                                    id: value.id,
                                });
                            }
                        );
                        $compile(userContent)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "click",
                            function () {
                                // infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + userContent);
                                // infoWindow.open(locations.map, startMarker);
                                TrCaseById.get(value.id, function (response) {
                                    userContent.innerHTML =
                                        '<div class="infoWindowhead">' +
                                        response.description +
                                        '</div><div class="infoWindowContent"> <b>Case Id : </b>' +
                                        value.id +
                                        "<br><b>Description : </b>" +
                                        response.description +
                                        "<br><b>Case Type : </b>" +
                                        response.caseType.name +
                                        "<br> <b>Reported By :</b> " +
                                        response.reportedByUser +
                                        "<br> <b> Assigned To :</b> " +
                                        response.assignedToUser +
                                        "<br> <b>Address :</b> " +
                                        response.address +
                                        "</div>";

                                        if ($scope.tab == 2) { 
                                            brBreak = userContent.appendChild(
                                                document.createElement("br")
                                            );
    
                                            btnDrawLine = userContent.appendChild(
                                                document.createElement("button")
                                            );
                                            btnDrawLine.classList.add("btn");
                                            btnDrawLine.classList.add("btn-sm");
                                            btnDrawLine.classList.add("btn-primary");
                                            btnDrawLine.textContent = "Nearby Assets";
                                            btnDrawLine.style.marginRight = "4px";

                                            btnDrawLine.onclick = function () { 
                                                for (var i = 0; i < entryMarker.length; i++) {
                                                    entryMarker[i].setMap(null);
                                                }
                                                for (var i = 0; i < endMarker.length; i++) {
                                                    endMarker[i].setMap(null);
                                                }

                                                var sendLatLng ={lat: response.pinLat,lng:response.pinLong}
                                                getNearbyFixed.get(vm.selectedGeofenceId,sendLatLng,function (getLatLng){
                                                    
                                                var directionsService = new google.maps.DirectionsService();

                                                if(getLatLng.length > 0){
                                                    var marker = new google.maps.Marker({
                                                        icon:  {
                                                            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                                            strokeColor: "#808000",
                                                            fillColor:'#808000',
                                                            fillOpacity:1,
                                                            scale: 4,
                                                            labelOrigin: new google.maps.Point(-1, 7)
                                                        },
                                                        map: locations.map,
                                                        position: {"lat":response.pinLat,
                                                        "lng":response.pinLong},
                                                        label: {
                                                            text:"Start",
                                                            fontSize: '15px',
                                                            fontWeight: 'bold'
                                                          }
                                                    });
                                                    entryMarker.push(marker)
                                                    marker.setMap(locations.map)
                                                    infoWindow.close();
                                                    calculateAndDisplayRoute(directionsService,getLatLng);
                                                }else{
                                                    noAssetsFound = userContent.appendChild(
                                                        document.createElement("b")
                                                    );
                                                    noAssetsFound.textContent = "No Nearby Assets";
                                                    noAssetsFound.style.marginRight = "4px";
                                                    noAssetsFound.style.color = "red"
                                                    noAssetsFound.style.fontSize = "15px";
                                                }
                                                })
                                            } 


                                            if(value.caseTypeName=='Termination Details' || value.caseTypeName=='Splicing Details') {
                                                btnDownloadPdf = userContent.appendChild(
                                                    document.createElement("button")
                                                );
                                                btnDownloadPdf.classList.add("btn");
                                                btnDownloadPdf.classList.add("btn-sm");
                                                btnDownloadPdf.classList.add("btn-primary");
                                                btnDownloadPdf.textContent = "Download Pdf";
                                                btnDownloadPdf.style.marginRight = "4px";
                                                btnDownloadPdf.onclick = function () { 
                                                    downloadPdfMapButton(value.id, value.caseTypeName+"_"+value.id);
                                                }
                                            }
                                          
                                            function calculateAndDisplayRoute(
                                                directionsService,
                                                getLatLng
                                              ) {
                                              
                                                for(var i=0;i<getLatLng.length;i++){
                                                    
                                                   directionsService
                                                  .route({
                                                    origin: { lat: response.pinLat,  lng: response.pinLong }, 
                                                    destination: { lat: getLatLng[i].latitude , lng: getLatLng[i].longitude }, 
                                                    travelMode: google.maps.TravelMode.WALKING,
                                                  })
                                                  .then(function(response)  {
                                                        var marker = new google.maps.Marker({
                                                            icon: {
                                                                path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                                                                strokeColor: "#7F00FF ",
                                                                fillColor:'#7F00FF ',
                                                                fillOpacity:1,
                                                                scale: 4,
                                                                labelOrigin: new google.maps.Point(1, -7)
                                                            },
                                                            map: locations.map,
                                                            position: { lat: response.request.destination.location.lat() , lng: response.request.destination.location.lng() },
                                                            label : {text:response.routes[0].legs[0].distance.value + "m",fontSize: '15px',
                                                            fontWeight: 'bold'} 
                                                            
                                                        });
                                                        endMarker.push(marker)
                                                        marker.setMap(locations.map);
                                                  })
                                                  .catch(function(e) {console.log("Directions request failed due to " + e)} );
                                                }
                                                
                                              }
                                        }  
                                        
                                    infoWindow = new google.maps.InfoWindow({
                                        content: userContent,
                                    });
                                    infoWindow.open(locations.map, startMarker);
                                    setTimeout(function () {
                                        infoWindow.close();
                                    }, 5000);
                                });
                            }
                        );

                        // }
                        // on mouseout
                        // google.maps.event.addListener(startMarker, 'mouseout', function () {
                        //     infoWindow.close();
                        // });

                        //						var activeInfoWindow;
                        //						// add content to InfoWindow for click event
                        //						infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
                        //
                        //						// add listener on InfoWindow for click event
                        //						google.maps.event.addListener(startMarker, 'click', function() {
                        //
                        //							if (activeInfoWindow != null)
                        //								activeInfoWindow.close();
                        //							// Open InfoWindow - on click
                        //							infoWindow2.open(locations.map, startMarker);
                        //							$(".userpath").click(function() {
                        //								var ele = document.getElementById("userPathModal");
                        //								$(ele).modal('show');
                        //								vm.drawUserPath($(this).attr('userid'));
                        //							});
                        //
                        //							// Store new open InfoWindow in global variable
                        //							activeInfoWindow = infoWindow2;
                        //						});
                        //						resizeTrCaseMap();
                    });
                    // resizeTrCaseMap();
                    // };
                });
            }

            /*
             * function setupTrcaseMap(callback) { var myOptions = { zoom : 10,
             * center : new google.maps.LatLng("5.431587","101.128162"), mapTypeId :
             * google.maps.MapTypeId.ROADMAP }; locations.map = new
             * google.maps.Map(document.getElementById("map_canvas1"),
             * myOptions); locations.overlay = new google.maps.OverlayView();
             * locations.overlay.draw = function() { };
             * locations.overlay.setMap($scope.map); locations.element =
             * document.getElementById('map_canvas1'); callback(); }
             */
        }

        //		function resizeTrCaseMap() {
        //			setTimeout(function() {
        //				google.maps.event.trigger(locations.map, "resize");
        //				locations.map.setCenter(locations.latlng);
        //			}, 1000);
        //		}

        function initializeTrcaseMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        /*
         * function drawCasesA() { drawLatestCases($scope.trcaseuser); }
         */
        function drawCasesAndNearByAgents(response) {
            if (response) {
                initializeMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // setupMap(function() {
                    $.each(response, function (index, value) {
                        var infoWindow = new google.maps.InfoWindow();
                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });

                        var infoWindow2 = new google.maps.InfoWindow();

                        if (value.priority == "LOW") {
                            startMarker.setIcon(
                                "content/images/Pointers-L4.png"
                            );
                        } else if (value.priority == "MEDIUM") {
                            startMarker.setIcon(
                                "content/images/Pointers-M4.png"
                            );
                        } else if (value.priority == "HIGH") {
                            startMarker.setIcon(
                                "content/images/Pointers-H4.png"
                            );
                        } else if (value.priority == "CRITICAL") {
                            startMarker.setIcon(
                                "content/images/Pointer-C4.png"
                            );
                        }

                        $compile(startMarker.content)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "click",
                            function () {
                                TrCaseById.get(value.id, function (response) {
                                    var userContent = document.createElement(
                                        "div"
                                    );

                                    userContent.innerHTML =
                                        '<div class="infoWindowContent"><b>Case Id : </b>' +
                                        response.id +
                                        "<br> <b>Description : </b>" +
                                        response.description +
                                        "<br> <b>Reported By :</b> " +
                                        response.reportedByUser +
                                        "<br> <b> Assigned To :</b> " +
                                        response.assignedToUser +
                                        "<br> <b>Address :</b> " +
                                        response.address +
                                        "</div>";

                                    infoWindow2 = new google.maps.InfoWindow({
                                        content: userContent,
                                    });
                                    infoWindow2.open(
                                        locations.map,
                                        startMarker
                                    );
                                    setTimeout(function () {
                                        infoWindow2.close();
                                    }, 5000);
                                });
                            }
                        );

                        // on mouseout
                        google.maps.event.addListener(
                            startMarker,
                            "mouseout",
                            function () {
                                infoWindow.close();
                            }
                        );

                        resizeMap();
                    });
                    // });
                });
            }
            //			drawAgents();
        }

        function drawAgents() {
            var infoWindow = null;
            var markers = [
                {
                    Lat: "0.0",
                    Lng: "0.0",
                    name: "default",
                },
            ];
            TrCaseUser.getAgents(function (response) {
                $.each(response.liveLogs, function (index, value) {
                    infoWindow = new google.maps.InfoWindow();

                    var imgbg = document.createElement("img");
                    imgbg.className = "marker_back_image";

                    if (value.status == "ACTIVE") {
                        imgbg.src = "content/images/greenmarker.png";
                    } else if (value.status == "INACTIVE") {
                        imgbg.src = "content/images/redmarker.png";
                    } else if (value.status == "IDLE") {
                        imgbg.src = "content/images/yellowmarker.png";
                    }

                    function customMarker() {
                        this.latlng = new google.maps.LatLng(
                            value.latitude,
                            value.longitude
                        );
                        this.setMap(locations.map);
                        this.title = value.login;
                        this.icon = imgbg;
                    }
                    var userContent;
                    if (value.userImage != null) {
                        userContent =
                            '<div class="infoWindowhead">' +
                            value.login +
                            '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="data:image/png;base64,' +
                            value.userImage +
                            '" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>' +
                            value.address +
                            "</p><p>Phone : " +
                            value.phone +
                            "</p><p>Battery :" +
                            value.batteryPercentage +
                            " %</p></div></div></div>";
                    } else {
                        userContent =
                            '<div class="infoWindowhead">' +
                            value.login +
                            '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="content/images/userimg.gif" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>' +
                            value.address +
                            "</p><p>Phone : " +
                            value.phone +
                            "</p><p>Battery :" +
                            value.batteryPercentage +
                            " %</p></div></div></div>";
                    }
                    var infowindowPopup = new google.maps.InfoWindow({
                        content: userContent,
                        pixelOffset: new google.maps.Size(0, -50),
                    });
                    infowindowPopup.setPosition(
                        new google.maps.LatLng(value.latitude, value.longitude)
                    );

                    customMarker.prototype = new google.maps.OverlayView();
                    customMarker.prototype.draw = function () {
                        var self = this;
                        var div = this.div;

                        if (!div) {
                            div = this.div = document.createElement("div");
                            div.id = "marker";
                            div.style.width = "100px";
                            div.style.height = "100px";

                            var div_pointer = document.createElement("div");
                            div_pointer.className = "triangle";

                            var image_container = document.createElement("div");
                            image_container.className = "image_container";

                            var img = document.createElement("img");
                            img.className = "marker_image";
                            img.src = "data:image/png;base64,";
                            img.src += value.userImage;
                            if (value.userImage == undefined) {
                                img.src = "content/images/userimg.gif";
                            }

                            var name_container = document.createElement("div");
                            name_container.className = "name_container";

                            div.appendChild(image_container);
                            image_container.appendChild(img);
                            image_container.appendChild(imgbg);

                            name_container.onmouseover = function () {
                                name_container.style.opacity = "0.6";
                                div.style.zIndex = "1000";
                            };
                            name_container.onmouseout = function () {
                                name_container.style.opacity = "0";
                                div.style.zIndex = "100";
                            };

                            google.maps.event.addDomListener(
                                imgbg,
                                "click",
                                function (event) {
                                    google.maps.event.trigger(self, "click");
                                    infowindowPopup.open(locations.map);
                                }
                            );

                            var panes = this.getPanes();

                            panes.overlayImage.appendChild(div);
                        }

                        var point = this.getProjection().fromLatLngToDivPixel(
                            this.latlng
                        );

                        if (point) {
                            div.style.left = point.x - 50 + "px";
                            div.style.top = point.y - 125 + "px";
                        }
                    };

                    customMarker.prototype.getPosition = function () {
                        return this.latlng;
                    };
                    markers.forEach(function (marker) {
                        var overlay = new customMarker();
                    });
                });
            });
        }
        $scope.caseLocation = function (selectedCase) {
            $("#caseLocationModal").show();
            var myCenter = new google.maps.LatLng(
                selectedCase.pinLat,
                selectedCase.pinLong
            );
            var ele = document.getElementById("caseLocationModal");
            $(ele).modal("show");

            var map = new google.maps.Map(
                document.getElementById("map_canvas_case_location"),
                {
                    center: myCenter,
                    zoom: 18,
                }
            );

            var markerIcon = "";
            if (selectedCase.priority == "LOW") {
                markerIcon = "content/images/Pointers-L4.png";
            } else if (selectedCase.priority == "MEDIUM") {
                markerIcon = "content/images/Pointers-M4.png";
            } else if (selectedCase.priority == "HIGH") {
                markerIcon = "content/images/Pointers-H4.png";
            } else if (selectedCase.priority == "CRITICAL") {
                markerIcon = "content/images/Pointer-C4.png";
            }

            var markerContent = null;
            if (selectedCase.caseDistance != null) {
                markerContent =
                    '<div class="infoWindowhead">' +
                    "<b>Case Id : </b>" +
                    selectedCase.id +
                    "<br><b>Description : </b>" +
                    selectedCase.description +
                    "<br> <b>Lat : </b>" +
                    selectedCase.pinLat +
                    "<br> <b>Lng : </b>" +
                    selectedCase.pinLong +
                    "<br><b>Address : </b>" +
                    selectedCase.address +
                    "<br><b>Distance (km) : </b>" +
                    selectedCase.caseDistance +
                    "</div>";
            } else {
                markerContent =
                    '<div class="infoWindowhead">' +
                    "<b>Case Id : </b>" +
                    selectedCase.id +
                    "<br><b>Description : </b>" +
                    selectedCase.description +
                    "<br> <b>Lat : </b>" +
                    selectedCase.pinLat +
                    "<br> <b>Lng : </b>" +
                    selectedCase.pinLong +
                    "<br><b>Address : </b>" +
                    selectedCase.address +
                    "</div>";
            }
            var marker = new google.maps.Marker({
                position: myCenter,
                content: markerContent,
                icon: {
                    url: markerIcon,
                    size: new google.maps.Size(70, 86), //marker image size
                    origin: new google.maps.Point(0, 0), // marker origin
                    anchor: new google.maps.Point(35, 86), // X-axis value (35, half of marker width) and 86 is Y-axis value (height of the marker).
                },
            });

            var infowindow = new google.maps.InfoWindow({
                content: markerContent,
            });
            infowindow.open(map, marker);
            marker.addListener("click", function () {
                // infowindow.open(map, marker);
                TrCaseById.get(selectedCase.id, function (response) {
                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        response.description +
                        '</div><div class="infoWindowContent"> <b>Case Id : </b>' +
                        value.id +
                        "<br> <b>Description : </b>" +
                        value.description +
                        "<br> <b>Reported By :</b> " +
                        response.reportedByUser +
                        "<br> <b> Assigned To :</b> " +
                        response.assignedToUser +
                        "<br> <b>Address :</b> " +
                        response.address +
                        "</div>";

                    infoWindow = new google.maps.InfoWindow({
                        content: userContent,
                    });
                    infoWindow.open(locations.map, startMarker);
                    setTimeout(function () {
                        infoWindow.close();
                    }, 5000);
                });
            });
            marker.setMap(map);

            $("#caseLocationModal").on("show.bs.modal", function (event) {
                $("#location-map-case-location").css("width", "100%");
                $("#map_canvas_case_location").css("width", "100%");
            });
        };

        function resizeMap() {
            setTimeout(function () {
                google.maps.event.trigger(locations.map, "resize");
                locations.map.setCenter(locations.latlng);
            }, 1000);
        }

        function initializeMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        $(".select2").select2();

        function assigncasetouser(userId, userLogin) {
            vm.editUserId = userId;
            $scope.edituserLogin = userLogin;
            TrCaseEdit.getalltrcases(function (response) {
                $scope.trallcases = response;
            });
        }
        vm.success = null;
        vm.error = null;

        function editcase() {
            var data = {
                userId: vm.editUserId,
                caseId: vm.seachCaseId,
            };

            /*
             * TrCaseEdit.edittrcase(data, function(response){
             * $scope.edittrcaseresponse=response; vm.success = 'OK';
             *
             * });
             */
            TrCaseEdit.edittrcase(data, function (response, headers) {
                if (response.status == 200) {
                    vm.error = null;
                    vm.success = "OK";
                }
                if (response.status == 400) {
                    vm.success = null;
                    vm.error = "No case found with this case id";
                }
            });
            $timeout(function () {
                $("#assigncaseModal").modal("hide");
                vm.success = null;
                vm.error = null;
                vm.seachCaseId = null;
                vm.caseIds = null;
            }, 2000);
        }
    }

    var uniqueItems = function (data, key) {
        var result = [];

        for (var i = 0; i < data.length; i++) {
            var value = data[i][key];

            if (result.indexOf(value) == -1) {
                result.push(value);
            }
        }
        return result;
    };
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('ShowHideCaseController', ShowHideCaseController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	ShowHideCaseController.$inject = ['$scope', '$sce', '$state', 'ShowCaseById', 'HideCaseById'];

	function ShowHideCaseController($scope, $sce, $state, ShowCaseById, HideCaseById) {
		var vm = this;
		vm.showCase = showCase;
		vm.hideCase = hideCase;
		vm.status = 0;

		function showCase() {
			vm.status = 0;
			var caseId = parseInt(vm.caseId);
			if(caseId > 0){
				ShowCaseById.update(caseId, function(response) {
					if(response == 200){
						vm.status = 200;
					}else{
						vm.status = 400;
					}
				});
			}else{
				alert("Please Enter Valid Case ID");
			}
		}

		function hideCase() {
			vm.status = 0;
			var caseId = parseInt(vm.caseId);
			if(caseId > 0){
				HideCaseById.update(caseId, function(response) {
					if(response == 200){
						vm.status = 200;
					}else{
						vm.status = 400;
					}
				});
			}else{
				alert("Please Enter Valid Case ID");
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TenantDialogController', TenantDialogController);

    TenantDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity','$state', 'Tenant'];

    function TenantDialogController ($timeout, $scope, $stateParams, entity, $state, Tenant) {
    	$scope.EMAIL_REGEXP =/^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
        $scope.PHONE_REGEXP =/^[0-9]+$/;
        var vm = this;

        vm.tenant = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tenant.id !== null) {
                Tenant.update(vm.tenant, onSaveSuccess, onSaveError);
            } else {
                Tenant.save(vm.tenant, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:tenantUpdate', result);
            vm.isSaving = false;
            $state.go('tenant');
         }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TenantDetailController', TenantDetailController);

    TenantDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tenant'];

    function TenantDetailController($scope, $rootScope, $stateParams, previousState, entity, Tenant) {
        var vm = this;

        vm.tenant = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:tenantUpdate', function(event, result) {
            vm.tenant = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TenantDeleteController',TenantDeleteController);

    TenantDeleteController.$inject = [ 'entity', 'Tenant'];

    function TenantDeleteController( entity, Tenant) {
        var vm = this;

        vm.tenant = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
          //  $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tenant.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
       /* .state('tenant', {
            parent: 'entity',
            url: '/tenant?page&sort&search',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tenant/tenants.html',
                    controller: 'TenantController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })*/
        .state('tenant', {
            parent: 'entity',
            url: '/tenant?page&sort$search',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tenant/tenants.html',
                    controller: 'TenantController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }]

            }       
			})
        
        
        
        
        
        /*.state('tenant-detail', {
            parent: 'entity',
            url: '/tenant/{id}',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tenant/tenant-detail.html',
                    controller: 'TenantDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tenant', function($stateParams, Tenant) {
                    return Tenant.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tenant',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })*/
		.state('tenant-detail', {
            parent: 'entity',
            url: '/tenant/{id}',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tenant/tenant-detail.html',
                    controller: 'TenantDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tenant', function($stateParams, Tenant) {
                    return Tenant.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tenant',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
			
			
			
			
			
        /*.state('tenant-detail.edit', {
            parent: 'tenant-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tenant', function(Tenant) {
                            return Tenant.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('tenant-detail.edit', {
            parent: 'tenant-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tenant', function($stateParams, Tenant) {
                    return Tenant.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tenant',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        
        
       /* .state('tenant.new', {
            parent: 'tenant',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                organization: null,
                                loginName: null,
                                email: null,
                                phone: null,
                                city: null,
                                address: null,
                                createdDate: null,
                                updatedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tenant', null, { reload: 'tenant' });
                }, function() {
                    $state.go('tenant');
                });
            }]
        })*/
        .state('tenant.new', {
            parent: 'tenant',
            url: '/new',
            data: {
            	 authorities: ['ROLE_SUPER_ADMIN']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm'
				}
			},
			 resolve: {
                        entity: function () {
                            return {
                            	 organization: null,
                                 loginName: null,
                                 email: null,
                                 phone: null,
                                 city: null,
                                 address: null,
                                 createdDate: null,
                                 updatedDate: null,
                                 id: null
                            };
                        }
                    }
            
        })
        
        
       /*.state('tenant.edit', {
            parent: 'tenant',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tenant', function(Tenant) {
                            return Tenant.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tenant', null, { reload: 'tenant' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('tenant.edit', {
            parent: 'tenant',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenat.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tenant', function($stateParams, Tenant) {
                    return Tenant.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tenant',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('tenant.delete', {
            parent: 'tenant',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tenant/tenant-delete-dialog.html',
                    controller: 'TenantDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tenant', function(Tenant) {
                            return Tenant.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tenant', null, { reload: 'tenant' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('Tenant', Tenant);

    Tenant.$inject = ['$resource'];

    function Tenant ($resource) {
        var resourceUrl =  'api/tenants/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TenantSearch', TenantSearch);

    TenantSearch.$inject = ['$resource'];

    function TenantSearch ($resource) {
        var service = $resource('/api/tenants/searchvalue/:searchvalue',{searchvalue:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllTenant', AllTenant);

    AllTenant.$inject = ['$resource'];

    function AllTenant($resource) {
        var service = $resource('/api/all-tenants', {}, {
            'getAll': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TenantController', TenantController);

    TenantController.$inject = ['$scope', '$state', 'Tenant', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TenantSearch'];

    function TenantController ($scope, $state, Tenant, ParseLinks, AlertService, pagingParams, paginationConstants, TenantSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;
        
        function filterSearch(){
			if(vm.search!=null && vm.search!="" && !angular.isUndefined(vm.search)){
			TenantSearch.query({searchvalue:vm.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tenants = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}

        loadAll();

        function loadAll () {
            Tenant.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tenants = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ServiceTypeDialogController', ServiceTypeDialogController);

    ServiceTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state', 'entity', 'ServiceType', 'User','AllCustomServiceTypeAttribute'];

    function ServiceTypeDialogController ($timeout, $scope, $stateParams, $state, entity, ServiceType, User,AllCustomServiceTypeAttribute) {
        var vm = this;
        vm.serviceType = entity;       
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.customServiceTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.attributetypes = ['INTEGER', 'FLOAT', 'STRING','BOOLEAN'];
       // vm.items=[{name: 'SLA',dataType: 'INTEGER',value :'4'}];
        vm.items=[{ name: '',attributeDataType: {},value :''}];
        if(vm.serviceType.serviceTypeAttribute!=null && vm.serviceType.serviceTypeAttribute.length!=0){
        	vm.items=vm.serviceType.serviceTypeAttribute;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        
        function loadPage() {
	    	 AllCustomServiceTypeAttribute.getAll(function(response) {
	    		 vm.customServiceTypeAttributes = response;
	     		 response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customServiceTypeAttributeValues;
					});
	    		 
				});
	    	    
	    	 }
        
        function save () {
            vm.isSaving = true;
            
            if (vm.serviceType.id !== null) {
            	vm.serviceType.serviceTypeAttribute=[];
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            	   // vm.serviceType.serviceTypeAttribute.push({"name" :  vm.items[i].name, "value" :  vm.items[i].value});
            	    vm.serviceType.serviceTypeAttribute.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,   "attributeDataType" :  vm.items[i].attributeDataType,"value" :  vm.items[i].value});
            	    
            	}
                ServiceType.update(vm.serviceType, onSaveSuccess, onSaveError);
            } else {
            	vm.serviceType.serviceTypeAttribute=[];
            	
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            	    //vm.serviceType.serviceTypeAttribute.push({"name" :  vm.items[i].name, "value" :  vm.items[i].value});
            		vm.serviceType.serviceTypeAttribute.push({"id" : vm.items[i].id ,"name" :  vm.items[i].name, "attributeDataType" :  vm.items[i].attributeDataType, "value" :  vm.items[i].value});
             	    
            	}
                ServiceType.save(vm.serviceType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:serviceTypeUpdate', result);
            vm.isSaving = false;
			$state.go('service-type');
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
      /* vm.addmore = function() {
            var newItemNo = vm.items.length+1;
            vm.items.push({'id':newItemNo});
          };*/
        vm.addmore = function() {
            //vm.items.push({name: '',dataType:'', value:''});
        	 vm.items.push({name: '',attributeDataType:{}, value:''});
          };
          
          vm.remove = function(index) {
              vm.items.splice(index, 1);
            };
            
     /*  vm.remove = function() {
            var lastItem = vm.items.length-1;
            vm.items.splice(lastItem);
          };*/

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updatedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ServiceTypeDetailController', ServiceTypeDetailController);

    ServiceTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ServiceType', 'User'];

    function ServiceTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, ServiceType, User) {
        var vm = this;

        vm.serviceType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:serviceTypeUpdate', function(event, result) {
            vm.serviceType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ServiceTypeDeleteController',ServiceTypeDeleteController);

    ServiceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceType'];

    function ServiceTypeDeleteController($uibModalInstance, entity, ServiceType) {
        var vm = this;

        vm.serviceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ServiceType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-type', {
            parent: 'entity',
            url: '/service-type',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.serviceType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-type/service-types.html',
                    controller: 'ServiceTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'updated_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-type-detail', {
            parent: 'entity',
            url: '/service-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.serviceType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-type/service-type-detail.html',
                    controller: 'ServiceTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceType', function($stateParams, ServiceType) {
                    return ServiceType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-type.new', {
            parent: 'service-type',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/service-type/service-type-dialog.html',
                    controller: 'ServiceTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updatedDate: null,
                                id: null
                            };
                        }
                    }            
        })
		.state('service-type.edit', {
            parent: 'entity',
            url: '/service-type/Edit/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-type/service-type-dialog.html',
                    controller: 'ServiceTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceType', function($stateParams, ServiceType) {
                    return ServiceType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('service-type.delete', {
            parent: 'service-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-type/service-type-delete-dialog.html',
                    controller: 'ServiceTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['ServiceType', function(ServiceType) {
                            return ServiceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-type', null, { reload: 'service-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('ServiceType', ServiceType);

    ServiceType.$inject = ['$resource', 'DateUtils'];

    function ServiceType ($resource, DateUtils) {
        var resourceUrl =  'api/service-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ServiceTypeSearch', ServiceTypeSearch);

    ServiceTypeSearch.$inject = ['$resource'];

    function ServiceTypeSearch ($resource) {
        var service = $resource('/api/service-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomServiceTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-service-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ServiceTypeController', ServiceTypeController);

    ServiceTypeController.$inject = ['$scope', '$state', 'ServiceType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','ServiceTypeSearch'];

    function ServiceTypeController ($scope, $state, ServiceType, ParseLinks, AlertService, pagingParams, paginationConstants,ServiceTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			ServiceTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                   // result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            ServiceType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                   // result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LocationLogDialogController', LocationLogDialogController);

    LocationLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LocationLog', 'User'];

    function LocationLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LocationLog, User) {
        var vm = this;

        vm.locationLog = entity;
        vm.locationLog.createdDateTime = (new Date()).getTime();
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
       // vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	vm.isSaving = true;
            if (vm.locationLog.id !== null) {
                LocationLog.update(vm.locationLog, onSaveSuccess, onSaveError);
            } else {
                LocationLog.save(vm.locationLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:locationLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDateTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LocationLogDetailController', LocationLogDetailController);

    LocationLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'LocationLog', 'User'];

    function LocationLogDetailController($scope, $rootScope, $stateParams, previousState, entity, LocationLog, User) {
        var vm = this;

        vm.locationLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:locationLogUpdate', function(event, result) {
            vm.locationLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LocationLogDeleteController',LocationLogDeleteController);

    LocationLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'LocationLog'];

    function LocationLogDeleteController($uibModalInstance, entity, LocationLog) {
        var vm = this;

        vm.locationLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LocationLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('location-log', {
                parent: 'app',
                url: '/live-monitoring?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.locationLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-log/location-logs.html',
                        controller: 'LocationLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationLog');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('location-log.login', {
                parent: 'app',
                url: '/live-monitoring/{login}?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.locationLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-log/location-logs.html',
                        controller: 'LocationLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationLog');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('location-log-detail', {
                parent: 'entity',
                url: '/location-log/{id}',
                data: {
                    authorities: ['ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.locationLog.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-log/location-log-detail.html',
                        controller: 'LocationLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationLog');
                        $translatePartialLoader.addPart('logSource');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'LocationLog', function($stateParams, LocationLog) {
                        return LocationLog.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'location-log',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('location-log-detail.edit', {
                parent: 'location-log-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-log/location-log-dialog.html',
                        controller: 'LocationLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        //size: 'lg',
                        resolve: {
                            entity: ['LocationLog', function(LocationLog) {
                                return LocationLog.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('location-log.new', {
                parent: 'location-log',
                url: '/new',
                data: {
                    authorities: ['ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-log/location-log-dialog.html',
                        controller: 'LocationLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        // size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    latitude: null,
                                    longitude: null,
                                    address: null,
                                    logSource: null,
                                    createdDateTime: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('location-log', null, { reload: 'location-log' });
                    }, function() {
                        $state.go('location-log');
                    });
                }]
            })
            .state('location-log.edit', {
                parent: 'location-log',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-log/location-log-dialog.html',
                        controller: 'LocationLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        // size: 'lg',
                        resolve: {
                            entity: ['LocationLog', function(LocationLog) {
                                return LocationLog.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('location-log', null, { reload: 'location-log' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })




        .state('location-log.delete', {
            parent: 'location-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location-log/location-log-delete-dialog.html',
                    controller: 'LocationLogDeleteController',
                    controllerAs: 'vm',
                    //size: 'md',
                    resolve: {
                        entity: ['LocationLog', function(LocationLog) {
                            return LocationLog.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('location-log', null, { reload: 'location-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LocationLog', LocationLog);

    LocationLog.$inject = ['$resource', 'DateUtils'];

    function LocationLog($resource, DateUtils) {
        var resourceUrl = 'api/location-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });
    }
})();

// (function() {
// 	'use strict';

// 	angular.module('trakeyeApp').factory('AssetsList', [ '$rootScope', '$http', function($rootScope, $http) {

// 		var service = {};
// 		service.getAll = function( callback) {
// 			$http.get('api/assetlisttypespread').then(function(response) {
// 				callback(response.data);
// 			});
// 		};

// 		return service;
// 	} ]);
// })();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LocationLogMapPath', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getmaplogs = function (data, callback) {

                $http.get('api/location-logs/userpath/' + data.userId + '/' + data.fromDate + '/' + data.toDate).then(function (response) {
                    callback(response.data);
                });
            };
            service.downloadUserPath = function (data, callback) {

				$http.get('api/location-logs/download-userpath/' + data.userId + '/' + data.fromDate + '/' + data.toDate + '/' + data.type).then(function (response) {
					callback(response.data);
				});
			};
            service.locateUsers = function (callback) {
                $http.get('api/dashboard/agentlivedashboard').then(function (response) {
                    callback(response.data);
                });
            };

            service.locateUsersLogin = function (loginName,callback) {
                $http.get('api/dashboard/agentlivedashboard/' + loginName).then(function (response) {
                    callback(response.data);
                });
            };

            /* service.locateInActiveUsers = function (callback){
                 $http.get('api/location-logs/latestinactive').then(function(response){
                     callback(response.data);
                 });
             };*/

            return service;
        }]);



})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LocationLogVehicleMapPath', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getmaplogs = function (data, callback) {

                $http.get('api/location-logs/vehiclepath/' + data.userId + '/' + data.fromDate + '/' + data.toDate).then(function (response) {
                    callback(response.data);
                });
            };
            return service;
        }]);



})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LocationLogMap', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getlogsbydate = function (data, callback) {

                $http.get('api/location-logs/' + data.fromDate + '/' + data.toDate).then(function (response) {
                    callback(response.data, response.headers);
                });
            };

            return service;
        }]);



})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('UsersGeoFenceData', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getGeoFenceData = function (data, callback) {

                $http.get('api/users-geofences/' + data).then(function (response) {
                    callback(response.data, response.headers);
                });
            };

            return service;
        }]);
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('VehicleGeoFenceData', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getGeoFenceData = function (data, callback) {

                $http.get('api/vehicle-geofences/' + data).then(function (response) {
                    callback(response.data, response.headers);
                });
            };

            return service;
        }]);



})();











(function () {
	'use strict';

	angular.module('trakeyeApp').controller('LocationLogController', LocationLogController);

	LocationLogController.$inject = ['$filter', '$scope', 'DEFAULT_LATITUDE', 'DEFAULT_LONGITUDE', '$compile', '$state', 'LocationLog', 'ParseLinks', 'AlertService', 'pagingParams', '$stateParams', 'paginationConstants', 'LocationLogMap',
		'LocationLogMapPath', 'LocationLogVehicleMapPath', 'UsersGeoFenceData', 'UserAccount', 'GeofenceIDs', 'UserGeofences', 'AssetGroupES', 'AssetByID', '$interval', 'Report', 'AssetTypesByGeofenceID', 'VehicleGeoFenceData', 'AssetType'];

	function LocationLogController($filter, $scope, DEFAULT_LATITUDE, DEFAULT_LONGITUDE, $compile, $state, LocationLog, ParseLinks, AlertService, pagingParams, $stateParams, paginationConstants, LocationLogMap, LocationLogMapPath, LocationLogVehicleMapPath,
		UsersGeoFenceData, UserAccount, GeofenceIDs, UserGeofences, AssetGroupES, AssetByID, $interval, Report, AssetTypesByGeofenceID, VehicleGeoFenceData, AssetType) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.drawUserPath = drawUserPath;
		vm.type = "user";
		vm.pathuserid = null;
		vm.logsbystatus = [];
		vm.all = all;
		vm.active = active;
		vm.inactive = inactive;
		vm.idle = idle;
		vm.filterUsers = filterUsers;
		vm.fromDate = null;
		vm.toDate = null;
		vm.today = today;
		vm.today();
		vm.onChangeDate = onChangeDate;
		var openedInfoWindow = null;
		var latlng;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		var dateFormat = 'yyyy-MM-dd';
		vm.selectedLogs = "ALL";
		var markerUserName = "";
		$scope.alllength;
		$scope.activelength;
		$scope.inactivelength;
		$scope.idlelength;
		vm.vehicles = [];

		vm.allGeofences = [];
		vm.selectedGeofenceId = null;
		vm.prevSelectedGeofenceId = null;
		var prevInfoWindow = null;

		vm.userGeofences = [];
		vm.assetFilterGeofences = [];
		vm.selectedUserGeofenceId = null;
		vm.prevSelectedUserGeofenceId = null;
		vm.responseLiveLogs = null

		vm.filterAssetsLocationOnMapView = filterAssetsLocationOnMapView;
		vm.closeMapLocationFilterModal = closeMapLocationFilterModal;
		vm.filterAssetsLoadOnMapView = filterAssetsLoadOnMapView;
		vm.closeMapLoadPathFilterModal = closeMapLoadPathFilterModal;
		vm.saveLocationFilter = saveLocationFilter;
		vm.saveLoadPathFilter = saveLoadPathFilter;
		vm.downloadLoadPath = downloadLoadPath;


		//measure tool
		var measureEnabled = false
		var polyMeasureTool, segmentDistance, midpoint
		var totalDistance = 0
		var distanceMarkers = []
		var totalDistanceMarkers = []
		var pointerMarkers = []
		var arrpolyMeasureTool = []
		vm.gotoLatitute = gotoLatitute;
		vm.gotoLatituteCity = gotoLatituteCity;
		vm.closeGotoLatitute = closeGotoLatitute;
		vm.closeGotoLatituteCity = closeGotoLatituteCity;
		vm.showZoomLocation = showZoomLocation;
		var gotoMarker = null;

		var markers = [];
		var polylines = [];

		var markersForPath = [];
		var polylinesForPath = [];

		var noDataText = null;
		vm.mapAssets = [];
		var userPathId = null;
		var userIdSelected = null;
		var latlng = null;
		vm.assetTypeValues = [];
		var gotoMarker = null;
		var isLevel1AssetsVisible = false;
		var isLevel2AssetsVisible = false;
		var isLevel3AssetsVisible = false;
		var isLevel4AssetsVisible = false;
		var isLevel5AssetsVisible = false;

		var level1AssetsMarkers = [];
		var level2AssetsMarkers = [];
		var level3AssetsMarkers = [];
		var level4AssetsMarkers = [];
		var level5AssetsMarkers = [];

		var level1AssetsPolyline = [];
		var level2AssetsPolyline = [];
		var level3AssetsPolyline = [];
		var level4AssetsPolyline = [];
		var level5AssetsPolyline = [];

		vm.assetTypeValuesPath = [];

		var isLevel1AssetsVisiblePath = false;
		var isLevel2AssetsVisiblePath = false;
		var isLevel3AssetsVisiblePath = false;
		var isLevel4AssetsVisiblePath = false;
		var isLevel5AssetsVisiblePath = false;

		var level1AssetsMarkersPath = [];
		var level2AssetsMarkersPath = [];
		var level3AssetsMarkersPath = [];
		var level4AssetsMarkersPath = [];
		var level5AssetsMarkersPath = [];

		var level1AssetsPolylinePath = [];
		var level2AssetsPolylinePath = [];
		var level3AssetsPolylinePath = [];
		var level4AssetsPolylinePath = [];
		var level5AssetsPolylinePath = [];
		vm.selecterange = selectRange;
		vm.customRange = customRange;

		// vm.loadLogsTable();
		// setTimeout(function () {
		// 	vm.updateUsers();
		// 	vm.locateUsers;
		// }, 1000);

		$scope.tab = 1;
		$scope.geofencelabel = {
			search: "Search",
			nothingSelected: "Geofence"
		}
		$scope.setTab = function (newTab) {
			$scope.tab = newTab;
			if ($scope.tab == 1) {
				//filterAssetsLocationOnMapView()
				// console.log($scope.tab);
			} else if ($scope.tab == 2) {
				vm.locateUsers;
			}
		};
		$scope.isSet = function (tabNum) {
			return $scope.tab === tabNum;
		};
		$(".select2").select2();
		$scope.geofenceMapview = function () {
			vm.selectedGeofenceId = vm.selectedGeofence[0].id
			saveLocationFilter()
		}

		$scope.geofenceTravelledPath = function () {
			vm.selectedUserGeofenceId = vm.selectedGeofencePath[0].id
			saveLoadPathFilter()
		}

		$("#searchOnMap").change(function () {
			var vehicleSelected = JSON.parse($("#searchOnMap").val());
			var vehicleLatLng = ({
				lat: vehicleSelected.latitude,
				lng: vehicleSelected.longitude
			});
			locations.map.setCenter(vehicleLatLng);
			locations.map.setZoom(20);
		});

		function myOption(zoom, center) {
			var myOptions;
			return (myOptions = {
				zoom: zoom,
				center: center,
				scaleControl: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: [
					{
						featureType: "poi",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						elementType: "labels.text.fill",
						stylers: [
							{
								color: "#63666A",
							},
						],
					} /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
					{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						featureType: "road",
						elementType: "labels.icon",
						stylers: [{ visibility: "off" }],
					},
					{
						featureType: "landscape",
						stylers: [
							{
								color: "#efefef",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "geometry",
						stylers: [
							{
								color: "#ffffff",
							},
						],
					}
				],
			});
		}

		// function geoLocation(map) {
		//     var infoWindow = new google.maps.InfoWindow();
		// 	var locationButton = document.createElement("button");
		// 	locationButton.setAttribute("title","Locate Me");
		// 	locationButton.classList.add("custom-map-control-button");
		//     var geoIcon = document.createElement("i");
		//     geoIcon.classList.add("fa");
		//     geoIcon.classList.add("fa-crosshairs");
		//     geoIcon.classList.add("geo");
		//     locationButton.appendChild(geoIcon)
		//     map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
		//         locationButton
		//     );

		//     locationButton.addEventListener("click", function () {
		//         // Try HTML5 geolocation.
		//         if (navigator.geolocation) {
		//             navigator.geolocation.getCurrentPosition(
		//                 function (position) {
		//                     var pos = {
		//                         lat: position.coords.latitude,
		//                         lng: position.coords.longitude,
		//                     };
		//                     infoWindow.setPosition(pos);
		//                     infoWindow.setContent("Location found.");	
		//                     infoWindow.open(map);
		//                     map.setCenter(pos);
		// 					map.setZoom(18);
		//                 },
		//                 function () {
		//                     handleLocationError(
		//                         true,
		//                         infoWindow,
		//                         map.getCenter()
		//                     );
		//                 },
		//                 { enableHighAccuracy: true,
		//                     timeout: 5000,
		//                     maximumAge: 0}
		//             );
		//         } else {
		//             // Browser doesn't support Geolocation
		//             handleLocationError(
		//                 false,
		//                 infoWindow,
		//                 map.getCenter()
		//             );
		//         }
		//     });

		//     function handleLocationError(
		//         browserHasGeolocation,
		//         infoWindow,
		//         pos
		//     ) {
		//         infoWindow.setPosition(pos);
		//         infoWindow.setContent(
		//             browserHasGeolocation
		//                 ? "Error: The Geolocation service failed."
		//                 : "Error: Your browser doesn't support geolocation."
		//         );
		//         infoWindow.open(map);
		//     }
		// }

		if ($scope.tab == 1) {
			UserAccount.get(function (data) {
				var isAdmin = false;
				data.authorities.forEach(function (val) {
					if (val == "ROLE_USER_ADMIN") {
						isAdmin = true;
					} else if (val == "ROLE_HOD") {
						isAdmin = true;
					}
				});
				if (isAdmin) {
					vm.adminFilter = true;
					filterUsers();
					vm.updateUsers();
					vm.locateUsers;
					filterAssetsLocationOnMapView()
				} else {
					vm.adminFilter = false;
					filterUsers();
					vm.updateUsers();
					vm.locateUsers;
					filterAssetsLocationOnMapView()
				}
				AssetType.query(
					{
						page: 0,
						size: 100,
						sort: sort(),
					},
					onSuccess,
					onError
				);
				function sort() {
					var result = [
						vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
					];
					if (vm.predicate !== "id") {
						//  result.push('id');
					}
					return result;
				}
				function onSuccess(data, headers) {
					vm.assetTypes = data;
				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			});
		}

		function getGroupAssetsFromES(geofenceIdVal, lastAssetId, mapAssetLists) {
			AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;

					vm.mapAssets.push(tmpAsset);
				});


				if (data.assets.length < 500) {
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						var assetType = vm.assetTypeValues[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValues[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						if (vm.assetTypeValues[index].zoomLevel > 11 && vm.assetTypeValues[index].zoomLevel < 15) {
							vm.assetTypeValues[index].assets.forEach(function (assetVal) {
								assetList.push(assetVal);
							});
						}
					}
					drawAssets(assetList, "level1");
					if (vm.selectedLogs === "ALL") {
						vm.all();
					} else if (vm.selectedLogs === "ACTIVE") {
						vm.active();
					} else if (vm.selectedLogs === "INACTIVE") {
						vm.inactive();
					} else if (vm.selectedLogs === "IDLE") {
						vm.idle();
					}
					isLevel1AssetsVisible = true;
				}
				// drawLatestAssets(vm.mapAssets);
				if (data.lastId != null) {
					getGroupAssetsFromES(geofenceIdVal, data.lastId, vm.mapAssets);
				} else {
					if (vm.mapAssets.length > 0) {
						var assetSelected = vm.mapAssets[0];
						// AssetByID.get(assetSelected.id, function (assetVal) {
						// 	var assetLatLng = ({
						// 		lat: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].latitude,
						// 		lng: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].longitude
						// 	});
						// 	try {
						// 		locations.map.setCenter(assetLatLng);
						// 	} catch (error) {
						// 		console.log(error);
						// 	}
						// });
					}
				}
			});
		}

		function getGroupAssetsFromESPath(geofenceIdVal, lastAssetId, mapAssetLists) {
			AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapUserAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;
					vm.mapUserAssets.push(tmpAsset);
				});


				if (data.assets.length < 500) {
					for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
						var assetType = vm.assetTypeValuesPath[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapUserAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValuesPath[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
						if (vm.assetTypeValuesPath[index].zoomLevel > 11 && vm.assetTypeValuesPath[index].zoomLevel < 15) {
							vm.assetTypeValuesPath[index].assets.forEach(function (assetVal) {
								assetList.push(assetVal);
							});
						}
					}
					drawAssetsForPath(assetList, "level1");
					// var centerlatlng = {
					// 	lat: parseFloat(assetList[assetList.length - 1].assetCoordinates[0].latitude),
					// 	lng: parseFloat(assetList[assetList.length - 1].assetCoordinates[0].longitude)
					// };
					// userPaths.map.setCenter(centerlatlng);
					// userPaths.map.setZoom(14);
					mapZoomChangeForPath();
					isLevel1AssetsVisiblePath = true;
				}
				if (data.lastId != null) {
					getGroupAssetsFromESPath(geofenceIdVal, data.lastId, vm.mapUserAssets);
				} else {
					if (vm.mapUserAssets.length > 0) {
						var assetSelected = vm.mapUserAssets[0];
						// AssetByID.get(assetSelected.id, function (assetVal) {
						// 	var assetLatLng = ({
						// 		lat: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].latitude,
						// 		lng: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].longitude
						// 	});
						// 	try {
						// 		userPaths.map.setCenter(assetLatLng);
						// 	} catch (error) {
						// 		console.log(error);
						// 	}
						// });
					}
				}
			});
		}

		vm.updateUsers = function () {
			vm.locateUsers(function () {
				if (vm.selectedLogs === "ALL") {
					vm.all();
				} else if (vm.selectedLogs === "ACTIVE") {
					vm.active();
				} else if (vm.selectedLogs === "INACTIVE") {
					vm.inactive();
				} else if (vm.selectedLogs === "IDLE") {
					vm.idle();
				}
			});
		}
		var updateLogs = $interval(function () {

			vm.updateUsers();
			vm.locateUsers;

			/* if (vm.selectedGeofenceId != null) {
				vm.mapAssets = [];
				getGroupLocationAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
			} */
		}, 180000);

		var userPaths = {};
		var locations = {};

		function onChangeDate() {
			if (vm.fromDate && vm.toDate) {
				vm.toDate.setHours(23, 59, 59, 999);
				if (vm.fromDate <= vm.toDate) {
					vm.drawUserPath(vm.pathuserid, vm.type);
					userIdSelected = vm.pathuserid;
				} else {
					//customRange()
					alert('Selected "From Date" is greater than "To Date" : Please Select Proper Date')
				}
			}
		}

		function customRange() {
			vm.fromDate = null
			vm.toDate = null
			/* var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
			vm.toDate.setHours(23, 59, 59, 999); */
			vm.totalDistance = 0;
			$scope.totalDistanceTravelled = "0 kms";
			vm.inProgressDistance = 0
			userPaths.map = new google.maps.Map(document.getElementById("userPath_map_canvas"), myOption(13, userPaths.latlng));
		}
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
		}
		var date = new Date();

		$scope.options = {
			maxDate: date.setDate(date.getDate())
		};
		function selectRange() {
			selectRangePresent()
			vm.drawUserPath(vm.pathuserid, vm.type);
			userIdSelected = vm.pathuserid;
		}
		function selectRangePresent() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		/* function loadLogsTable() {

			var fromDate = $filter('date')(vm.fromDate, dateFormat);
			var toDate = $filter('date')(vm.toDate, dateFormat);
			var data = {
				fromDate: vm.fromDate.getTime(),
				toDate: vm.toDate.getTime()
			}

			LocationLogMap.getlogsbydate(data, function (response, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.locationLogs = response;
				vm.page = pagingParams.page;
			});
		} */

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page: vm.page,
				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search: vm.currentSearch
			});
		}

		$scope.$watch('login', function (searchkey, oldval) {
			if (searchkey || oldval)
				drawLatestlocations($filter('filter')($scope.locations, {
					userName: searchkey
				}));
		})

		$scope.openInfoWindow = function (e, selectedMarker) {
			e.preventDefault();
			google.maps.event.trigger(selectedMarker, 'click');
		}

		function drawUserPath(userId) {
			var data = {
				fromDate: vm.fromDate.getTime(),
				toDate: vm.toDate.getTime(),
				userId: userId
			}
			if (vm.type == "user") {
				LocationLogMapPath.getmaplogs(data, function (response) {
					vm.pathuserid = response.id;
					drawlines(response);
				});
			} else {
				LocationLogVehicleMapPath.getmaplogs(data, function (response) {
					vm.pathuserid = response.id;
					drawlines(response);
				});
			}
		}

		vm.locateUsers = function (callback) {
			LocationLogMapPath.locateUsers(function (response) {
				vm.responseLiveLogs = response.liveLogs
				$scope.trCases = response.trCases;
				$scope.locations = response.liveLogs;
				vm.vehicles = response.vehicleLocationList;
				$scope.offDutyUserlocations = response.inactiveUserLogs;
				callback();
			});
		}

		function filterUsers() {
			var isTrue
			if (vm.responseLiveLogs && vm.searchUser) {
				isTrue = vm.responseLiveLogs.find(function (item) {
					return item.login == vm.searchUser
				})
			}

			if (vm.searchUser && !isTrue) {
				LocationLogMapPath.locateUsersLogin(vm.searchUser, function (response) {
					var updatedResponse = [
						{
							"latitude": response[0].latitude,
							"longitude": response[0].longitude,
							"login": response[0].login,
							"userid": response[0].userId
						}
					]
					//$scope.locations = updatedResponse;
					callSelectedLogs(updatedResponse)
				})
			}

			callSelectedLogs($scope.locations)

		}

		function callSelectedLogs(param) {
			if (vm.selectedLogs === "ALL") {

				drawLatestlocations($filter('filter')(param, {
					'login': vm.searchUser
				}));


			} else {
				$scope.alllength = ($filter('filter')($filter('filter')(param, {
					'status': vm.selectedLogs
				}, true), {
					'login': vm.searchUser
				})).length;
				drawLatestlocations($filter('filter')($filter('filter')(param, {
					'status': vm.selectedLogs
				}, true), {
					'login': vm.searchUser
				}));
			}
		}

		function all() {
			vm.selectedLogs = "ALL";
			if ($stateParams.login == undefined) {
				try {
					$scope.alllength = ($filter('filter')($scope.locations, {
						'login': $stateParams.login
					})).length;
					$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "INACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "IDLE"
					}, true), {
						'login': vm.searchUser
					})).length;
				} catch (err) {
					console.log(err);
				}
				drawLatestlocations($filter('filter')($scope.locations, {
					'login': vm.searchUser
				}));
			} else {
				try {
					$scope.alllength = ($filter('filter')($scope.locations, {
						'login': $stateParams.login
					})).length;
					$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "INACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "IDLE"
					}, true), {
						'login': vm.searchUser
					})).length;
				} catch (err) {
					console.log(err);
				}
				drawLatestlocations($filter('filter')($scope.locations, {
					'login': $stateParams.login
				}));
			}
			// if (vm.selectedGeofenceId != null) {
			// 	vm.mapAssets = [];
			// 	getGroupLocationAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets, locations.map);
			// }
		}
		function active() {
			vm.selectedLogs = "ACTIVE";
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "INACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "IDLE"
			}, true), {
				'login': vm.searchUser
			})).length;

			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));
			// if (vm.selectedGeofenceId != null) {
			// 	vm.mapAssets = [];
			// 	getGroupLocationAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets, locations.map);
			// }
		}

		function inactive() {
			vm.selectedLogs = "INACTIVE";
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "IDLE"
			}, true), {
				'login': vm.searchUser
			})).length;
			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));
			// if (vm.selectedGeofenceId != null) {
			// 	vm.mapAssets = [];
			// 	getGroupLocationAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets, locations.map);
			// }
		}

		function idle() {
			vm.selectedLogs = "IDLE";
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "INACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;

			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));
			// if (vm.selectedGeofenceId != null) {
			// 	vm.mapAssets = [];
			// 	getGroupLocationAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets, locations.map);
			// }
		}

		function drawLatestVehicles(vehicles) {
			vehicles.forEach(function (vehicle) {
				var activeInfoWindow;
				var startMarker = new google.maps.Marker({
					map: locations.map,
					position: new google.maps.LatLng(vehicle.latitude, vehicle.longitude),
					title: vehicle.licenseplate,
					icon: {
						scaledSize: new google.maps.Size(
							32, 32),
						url: 'content/images/car.png',
						anchor: new google.maps.Point(
							(32 / 2) + 16, (32 / 2) + 16),
					}
				});
				var infoWindow = new google.maps.InfoWindow();

				var userContent = document.createElement('div'),
					button;
				userContent.innerHTML = '<div>' +
					'<b>Vehicle Id&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </b>&nbsp;' + vehicle.vehicleid + '<br>' +
					'<b>License Plate&nbsp; : </b>&nbsp;' + vehicle.licenseplate + '<br>' +
					'<b>GPS IMEI&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </b>&nbsp;' + vehicle.gpsimei + '<br>' +
					'<b>Vehicle Type&nbsp;&nbsp; : </b>&nbsp;' + vehicle.vehicletype + '</div>';

				button = userContent.appendChild(document.createElement('input'));
				button.type = 'button';
				button.value = 'Load travelled path';
				button.className = "button";
				google.maps.event.addDomListener(button, 'click', function () {
					vm.dateRange = null
					vm.dateRange = 'day'
					selectRangePresent()
					vm.type = "vehicle";
					markerUserName = vehicle.licenseplate;
					userPath(vehicle.vehicleid);
				})
				var infowindowPopup = new google.maps.InfoWindow({
					content: userContent,
					pixelOffset: new google.maps.Size(0, -50),
				});
				google.maps.event.addDomListener(startMarker, 'click', function (event) {
					infowindowPopup.setPosition(new google.maps.LatLng(vehicle.latitude, vehicle.longitude));
					infowindowPopup.open(locations.map);

					if (activeInfoWindow != null)
						activeInfoWindow.close();
					activeInfoWindow = infowindowPopup;

				});

				google.maps.event.addDomListener(startMarker, "click", function (event) {
					google.maps.event.trigger(self, "click");

					infowindowPopup.open(locations.map);
				});
				function userPath(id) {
					vm.userGeofences = [];
					vm.assetFilterGeofences = [];
					vm.selectedUserGeofenceId = null;
					vm.prevSelectedUserGeofenceId = null;
					var ele = document.getElementById("userPathModal");
					$(ele).modal('show');
					vm.drawUserPath(id);
					userIdSelected = id;
					var cleratodatefromdate = vm.today();
					// cleratodatefromdate.remove();
				}
			});
		}

		function drawLatestlocations(response) {
			var markers = [{
				Lat: "0.0",
				Lng: "0.0",
				name: "default"
			}];

			if (response) {
				var activeInfoWindow;
				initializeMap(
					response,
					function (latlang) {
						locations.latlng = latlang;
						var bounds = new google.maps.LatLngBounds();

						setupUsersMap(function () {

							$.each(response, function (index, value) {
								var infoWindow = new google.maps.InfoWindow();

								var infoWindow2 = new google.maps.InfoWindow();

								// Create a custom marker

								var imgbg = document.createElement('img');
								imgbg.className = "marker_back_image";

								// if (value.reportingStatus == true) {
								// 	if (value.status == 'ACTIVE') {
								// 		imgbg.src = 'content/images/greenmarker.png';
								// 	} else if (value.status == 'INACTIVE') {
								// 		imgbg.src = 'content/images/redmarker.png';
								// 	} else if (value.status == 'IDLE') {
								// 		imgbg.src = 'content/images/yellowmarker.png';
								// 	} else if (value.status == 'Off duty user') {
								// 		imgbg.src = 'content/images/marker_offduty1.png';
								// 	}
								// } else {
								// 	imgbg.src = 'content/images/marker_active_case.png'
								// }

								if (value.reportingStatus == true) {
									if (value.status == 'ACTIVE') {
										if (value.geoStatus == 'IN') {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_active_in.png';
											} else {
												imgbg.src = 'content/images/active_in.png';
											}

										} else {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_active_out.png';
											} else {
												imgbg.src = 'content/images/active_out.png';
											}
										}
										// imgbg.src = 'content/images/greenmarker.png';
									} else if (value.status == 'INACTIVE') {
										if (value.geoStatus == 'IN') {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_inactive_out.png';
											} else {
												imgbg.src = 'content/images/inactive_in.png';
											}
										} else {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_inactive_out.png';
											} else {
												imgbg.src = 'content/images/inactive_out.png';
											}
										}
										// imgbg.src = 'content/images/redmarker.png';
									} else if (value.status == 'IDLE') {
										if (value.geoStatus == 'IN') {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_idle_in.png';
											} else {
												imgbg.src = 'content/images/idle_in.png';
											}
										} else {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_idle_out.png';
											} else {
												imgbg.src = 'content/images/idle_out.png';
											}
										}
										// imgbg.src = 'content/images/yellowmarker.png';
									} else if (value.status == 'Off duty user') {
										if (value.geoStatus == 'IN') {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_off_duty_in.png';
											} else {
												imgbg.src = 'content/images/off_duty_in.png';
											}
										} else {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_off_duty_out.png';
											} else {
												imgbg.src = 'content/images/off_duty_out.png';
											}
										}
										// imgbg.src = 'content/images/marker_offduty1.png';
									}
								} else {
									if (value.geoStatus == 'IN') {
										if (value.userRole == 'ROLE_PATROLLER') {
											imgbg.src = 'content/images/pat_caseactive_in.png';
										} else {
											imgbg.src = 'content/images/case_active_in.png';
										}
									} else {
										if (value.userRole == 'ROLE_PATROLLER') {
											imgbg.src = 'content/images/pat_caseactive_out.png';
										} else {
											imgbg.src = 'content/images/case_active_out.png';
										}
									}
									// imgbg.src = 'content/images/marker_active_case.png'
								}

								if (value.address == 'SOS') {
									imgbg.src = 'content/images/alert.png'
								}

								if ($scope.trCases != undefined && $scope.trCases.length > 0) {

									$.each($scope.trCases, function (index, value) {

										var infoWindow = new google.maps.InfoWindow();
										var startMarker = new google.maps.Marker({
											map: locations.map,
											position: new google.maps.LatLng(value.pinLat, value.pinLong),
											title: value.description,

										});
										var infoWindow2 = new google.maps.InfoWindow();
										if (value.priority == 'LOW') {
											startMarker.setIcon('content/images/Pointers-L4.png');
										} else if (value.priority == 'MEDIUM') {

											startMarker.setIcon('content/images/Pointers-M4.png');
										} else if (value.priority == 'HIGH') {
											startMarker.setIcon('content/images/Pointers-H4.png');
										} else if (value.priority == 'CRITICAL') {
											startMarker.setIcon('content/images/Pointer-C4.png');
										}
										var span = '<a userId="' + value.geofenceName + '" class="userpath" >Load travelled path</a>';
										startMarker.content = '<div class="infoWindowContent"><b>Case Id : </b>' + value.id + '<br> <b>Reported By :</b> ' + value.reportedByUser
											+ '<br> <b> Assigned To :</b> ' + value.assignedToUser + '<br> <b>Address :</b> ' + value.address + '</div>';

										$compile(startMarker.content)($scope);

										google.maps.event.addListener(startMarker, 'mouseover', function () {
											infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
											infoWindow.open(locations.map, startMarker);
										});
										// on mouseout
										google.maps.event.addListener(startMarker, 'mouseout', function () {
											infoWindow.close();
										});

										var activeInfoWindow;
										// add content to
										// InfoWindow for
										// click event
										infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
									})
								}

								function customMarker() {
									this.latlng = new google.maps.LatLng(value.latitude, value.longitude);
									this.setMap(locations.map);
									this.title = value.login;
									this.icon = imgbg;
								}

								bounds.extend(new google.maps.LatLng(value.latitude, value.longitude));

								/*var userContent;// working before browser update
								var travelPathLink = '<a userId=' + value.userid + ' class="userpath" >Load travelled path</a>';
								if (value.userImage != null) {
									userContent = '<div class="infoWindowhead">' + value.login
											+ '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="data:image/png;base64,' + value.userImage
											+ '" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>' + value.address + '</p><p>Phone : ' + value.phone
											+ '</p><p>Battery :' + value.batteryPercentage + ' %</p><p>' + travelPathLink + '</p></div></div></div>';
								} else {
									userContent = '<div class="infoWindowhead">'
											+ value.login
											+ '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="content/images/userimg.gif" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>'
											+ value.address + '</p><p>Phone : ' + value.phone + '</p><p>Battery :' + value.batteryPercentage + ' %</p><p>' + travelPathLink
											+ '</p></div></div></div>';
								}*/

								var userContent = document.createElement('div'),
									button;


								if (value.userImage != null) {
									userContent.innerHTML = '<div class="infoWindowhead">' + value.login
										+ '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-8"><p>' + value.address + '</p><p><b>Phone</b> : ' + value.phone;
									button = userContent.appendChild(document.createElement('input'));
									button.type = 'button';
									button.value = 'Load travelled path';
									button.className = "button";

									// userContent.innerHTML = '<div class="infoWindowhead">' + value.login
									// + '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="data:image/png;base64,' + value.userImage
									// + '" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>' + value.address + '</p><p><b>Phone</b> : ' + value.phone;
									// button = userContent.appendChild(document.createElement('input'));
									// button.type = 'button';
									// button.value = 'Load travelled path';
									// button.className = "button";

									google.maps.event.addDomListener(button, 'click', function () {
										markerUserName = value.login;
										userPath(value.userid);
									})
								} else {
									/*userContent.innerHTML = '<div class="infoWindowhead">' + value.login
									+ '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-8"><p>' + value.address + '</p><p>Phone : ' + value.phone
									+ '</p><p>Battery :' + value.batteryPercentage+' %</p></div></div><div class="col-md-4"> <img src="content/images/userimg.gif" '
									+ '" style="width: 100px; height: 120px;"></div></div>'  ;*/

									// userContent.innerHTML = '<div class="infoWindowhead"><span style="margin-left:10px;"><b>' + value.login
									// 	+ '</b></span></div><div style="width: 300px; height: 120px;" class="infoWindowContent"><div class="rows"><div class="col-md-7"><p>' + value.address + '</p><p><b>Phone</b> : ' + value.phone
									// 	+ '</p><b>Latitude</b> : ' + value.latitude + '</p> <p> <b>Longitude1</b> : ' + value.longitude + '</p> </div></div></div>';

									button = userContent.appendChild(document.createElement('input'));
									button.type = 'button';
									button.value = 'Load travelled path';
									button.className = "button"; // set the CSS class

									var text1 = value.login
									var text2 = value.latitude.toFixed(5) + " , " + value.longitude.toFixed(5);
									var text3 = value.address

									var boldText1 = document.createElement("b");
									var dataTag1 = document.createElement("h4");

									var dataTag2 = document.createElement("h4");
									var dataTag3 = document.createElement("h5");

									var textContent1 = document.createTextNode(text1);
									var textContent2 = document.createTextNode(text2);
									var textContent3 = document.createTextNode(text3);

									boldText1.appendChild(textContent1);
									dataTag1.appendChild(boldText1);

									dataTag2.appendChild(textContent2);
									dataTag3.appendChild(textContent3);

									userContent.appendChild(dataTag1);
									userContent.appendChild(dataTag2);

									if (value.address) {
										userContent.appendChild(dataTag3);
									}

									// userContent.innerHTML = '<div class="infoWindowhead"><span style="margin-left:10px;"><b>' + value.login
									// 	+ '</b></span></div><div style="width: 300px; height: 120px;" class="infoWindowContent"><div class="rows"><div class="col-md-7"><p>' + value.address + '</p><p><b>Phone</b> : ' + value.phone
									// 	+ '</p><b>Latitude</b> : ' + value.latitude + '</p> <p> <b>Longitude</b> : ' + value.longitude + '</p> </div></div><div class="col-md-5"><br><br> <img src="content/images/userimg.gif" style="width: 80px; height: 90px; margin-top:26px;"></div></div>';

									// button = userContent.appendChild(document.createElement('input'));
									// button.type = 'button';
									// button.value = 'Load travelled path';
									// button.className = "button"; // set the CSS class

									google.maps.event.addDomListener(button, 'click', function () {
										//   console.log('2222')
										vm.dateRange = null
										vm.dateRange = 'day'
										selectRangePresent()
										vm.type = "user";
										markerUserName = value.login;
										userPath(value.userid);
									});

									userPathId = value.userid;
									// console.log('userPathId',userPathId);
								}

								function userPath(id) {
									vm.userGeofences = [];
									vm.assetFilterGeofences = [];
									vm.selectedUserGeofenceId = null;
									vm.prevSelectedUserGeofenceId = null;
									var ele = document.getElementById("userPathModal");
									$(ele).modal('show');
									vm.drawUserPath(id);
									userIdSelected = id;
									var cleratodatefromdate = vm.today();
									// cleratodatefromdate.remove();
								}
								var infowindowPopup = new google.maps.InfoWindow({
									content: userContent,
									pixelOffset: new google.maps.Size(0, -50),
								});

								customMarker.prototype = new google.maps.OverlayView();

								customMarker.prototype.draw = function () {
									var self = this;
									var div = this.div;

									if (!div) {

										div = this.div = document.createElement('div');
										div.id = 'marker';
										div.style.width = '100px';
										div.style.height = '100px';

										var div_pointer = document.createElement('div');
										div_pointer.className = 'triangle';

										var image_container = document.createElement('div');
										image_container.className = 'image_container';

										var img = document.createElement('img');
										img.className = "marker_image";
										var image2 = "data:image/png;base64,";
										image2 += value.userImage;
										if (value.userImage == undefined) {
											image2 = "content/images/userimg.gif";
										}

										img.src = image2;

										var name_container = document.createElement('div');
										name_container.className = 'name_container';

										var exit = document.createElement('div');
										exit.className = 'exit';
										exit.innerHTML = '<img className="exit_image" style="width:30px; height:30px;" src="https://cdn0.iconfinder.com/data/icons/large-glossy-icons/512/Delete.png">'
											+ '</img>';
										exit.style.display = 'none';

										div.appendChild(image_container);
										image_container.appendChild(img);
										image_container.appendChild(imgbg);

										div.appendChild(exit);

										name_container.onmouseover = function () {
											name_container.style.opacity = '0.6';
											div.style.zIndex = '1000'
										};
										name_container.onmouseout = function () {
											name_container.style.opacity = '0';
											div.style.zIndex = '100'
										};

										// add content to
										// InfoWindow for
										// click event
										infoWindow2.setContent('<div class="infoWindowhead">' + value.login + '</div>' + userContent);
										if (activeInfoWindow != null)
											activeInfoWindow.close();

										google.maps.event.addDomListener(imgbg, 'click', function (event) {
											infowindowPopup.setPosition(new google.maps.LatLng(value.latitude, value.longitude));
											infowindowPopup.open(locations.map);

											if (activeInfoWindow != null)
												activeInfoWindow.close();
											/* 	$(".userpath").click(function() { // working before browser update

													var ele = document.getElementById("userPathModal");
													$(ele).modal('show');
													vm.drawUserPath($(this).attr('userid'));
													var cleratodatefromdate = vm.today();
													// cleratodatefromdate.remove();
												});*/
											activeInfoWindow = infowindowPopup;

										});

										google.maps.event.addDomListener(imgbg, "click", function (event) {
											google.maps.event.trigger(self, "click");

											infowindowPopup.open(locations.map);
										});

										var panes = this.getPanes();

										panes.overlayImage.appendChild(div);

									}

									var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

									if (point) {
										div.style.left = (point.x - 50) + 'px';
										div.style.top = (point.y - 125) + 'px';
									}
								}

								customMarker.prototype.remove = function () {

									if (this.div) {
										this.div.parentNode.removeChild(this.div);
										this.div = null;
									}

								}

								customMarker.prototype.getPosition = function () {
									return this.latlng;
								}
								markers.forEach(function (marker) {
									// image =
									// value.userImage;

									var overlay = new customMarker();
								});
								// end

							});

							locations.map.fitBounds(bounds);
						});
					});
			}
			drawLatestVehicles(vm.vehicles);

		}

		function setupUsersMap(callback) {
			/* var myOptions = {
				zoom: 13,
				center: locations.latlng,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			}; */
			locations.map = new google.maps.Map(document.getElementById("map_canvas"), myOption(13, locations.latlng));
			geoLocation(locations.map)
			locations.overlay = new google.maps.OverlayView();
			locations.overlay.draw = function () {
			};
			locations.overlay.setMap($scope.map);
			locations.element = document.getElementById('map_canvas');
			callback();

			isLevel1AssetsVisible = false;
			isLevel2AssetsVisible = false;
			isLevel3AssetsVisible = false;
			isLevel4AssetsVisible = false;
			isLevel5AssetsVisible = false;
			if (vm.assetTypeValues != null) {
				if (vm.assetTypeValues.length > 0) {
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						var assetType = vm.assetTypeValues[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValues[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						if (vm.assetTypeValues[index].zoomLevel > 11 && vm.assetTypeValues[index].zoomLevel < 15) {
							vm.assetTypeValues[index].assets.forEach(function (assetVal) {
								assetList.push(assetVal);
							});
						}
					}
					drawAssets(assetList, "level1");
					isLevel1AssetsVisible = true;
				}
			}
			mapZoomChange();
		}

		function mapZoomChange() {
			google.maps.event.addListener(locations.map, 'zoom_changed', function () {
				vm.zoomLevel = locations.map.getZoom();
				document.getElementById("myspan").textContent = "ZOOM : " + vm.zoomLevel;
				if (vm.zoomLevel < 15) {
					for (var i = 0; i < level2AssetsMarkers.length; i++) {
						level2AssetsMarkers[i].setMap(null);
					}

					for (i = 0; i < level2AssetsPolyline.length; i++) {
						level2AssetsPolyline[i].setMap(null);
					}
					isLevel2AssetsVisible = false;
				}
				if (vm.zoomLevel == 15) {
					if (!isLevel2AssetsVisible) {
						var chamberList = [];
						for (var index = 0; index < vm.assetTypeValues.length; index++) {
							if (vm.assetTypeValues[index].zoomLevel == 15) {
								vm.assetTypeValues[index].assets.forEach(function (assetVal) {
									chamberList.push(assetVal);
								});
							}
						}
						drawAssets(chamberList, "level2");
						isLevel2AssetsVisible = true;
					}
				}

				if (vm.prevZoomLevel == 16 && vm.zoomLevel == 15) {
					for (var i = 0; i < level3AssetsMarkers.length; i++) {
						level3AssetsMarkers[i].setMap(null);
					}

					for (i = 0; i < level3AssetsPolyline.length; i++) {
						level3AssetsPolyline[i].setMap(null);
					}
					isLevel3AssetsVisible = false;
				}

				if ((vm.prevZoomLevel == 15 && vm.zoomLevel == 16)) {
					if (!isLevel3AssetsVisible) {
						var couplerList = [];
						for (var index = 0; index < vm.assetTypeValues.length; index++) {
							if (vm.assetTypeValues[index].zoomLevel == 16) {
								vm.assetTypeValues[index].assets.forEach(function (assetVal) {
									couplerList.push(assetVal);
								});
							}
						}
						drawAssets(couplerList, "level3");
						isLevel3AssetsVisible = true;
					}
				}

				if (vm.prevZoomLevel == 17 && vm.zoomLevel == 16) {
					for (var i = 0; i < level4AssetsMarkers.length; i++) {
						level4AssetsMarkers[i].setMap(null);
					}

					for (i = 0; i < level4AssetsPolyline.length; i++) {
						level4AssetsPolyline[i].setMap(null);
					}
					isLevel4AssetsVisible = false;
				}

				if ((vm.prevZoomLevel == 16 && vm.zoomLevel == 17)) {
					if (!isLevel4AssetsVisible) {
						var poleList = [];
						for (var index = 0; index < vm.assetTypeValues.length; index++) {
							if (vm.assetTypeValues[index].zoomLevel == 17) {
								vm.assetTypeValues[index].assets.forEach(function (assetVal) {
									poleList.push(assetVal);
								});
							}
						}
						drawAssets(poleList, "level4");
						isLevel4AssetsVisible = true;
					}
				}

				if (vm.prevZoomLevel == 18 && vm.zoomLevel == 17) {
					for (var i = 0; i < level5AssetsMarkers.length; i++) {
						level5AssetsMarkers[i].setMap(null);
					}

					for (i = 0; i < level5AssetsPolyline.length; i++) {
						level5AssetsPolyline[i].setMap(null);
					}
					isLevel5AssetsVisible = false;
				}
				if ((vm.prevZoomLevel == 17 && vm.zoomLevel == 18)) {
					if (!isLevel5AssetsVisible) {
						var otherList = [];
						for (var index = 0; index < vm.assetTypeValues.length; index++) {
							if (vm.assetTypeValues[index].zoomLevel == 18) {
								vm.assetTypeValues[index].assets.forEach(function (assetVal) {
									otherList.push(assetVal);
								});
							}
						}
						drawAssets(otherList, "level5");
						isLevel5AssetsVisible = true;
					}
				}

				vm.prevZoomLevel = vm.zoomLevel;
			});
		}

		function mapZoomChangeForPath() {
			google.maps.event.addListener(userPaths.map, 'zoom_changed', function () {
				vm.zoomLevel = userPaths.map.getZoom();
				document.getElementById("userpathzoom").textContent = "ZOOM : " + vm.zoomLevel;
				if (vm.zoomLevel < 15) {
					for (var i = 0; i < level2AssetsMarkersPath.length; i++) {
						level2AssetsMarkersPath[i].setMap(null);
					}

					for (i = 0; i < level2AssetsPolylinePath.length; i++) {
						level2AssetsPolylinePath[i].setMap(null);
					}
					isLevel2AssetsVisiblePath = false;
				}
				if (vm.zoomLevel == 15) {
					if (!isLevel2AssetsVisiblePath) {
						var chamberList = [];
						for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
							if (vm.assetTypeValuesPath[index].zoomLevel == 15) {
								vm.assetTypeValuesPath[index].assets.forEach(function (assetVal) {
									chamberList.push(assetVal);
								});
							}
						}
						drawAssetsForPath(chamberList, "level2");
						isLevel2AssetsVisiblePath = true;
					}
				}

				if (vm.prevZoomLevel == 16 && vm.zoomLevel == 15) {
					for (var i = 0; i < level3AssetsMarkersPath.length; i++) {
						level3AssetsMarkersPath[i].setMap(null);
					}

					for (i = 0; i < level3AssetsPolylinePath.length; i++) {
						level3AssetsPolylinePath[i].setMap(null);
					}
					isLevel3AssetsVisiblePath = false;
				}

				if ((vm.prevZoomLevel == 15 && vm.zoomLevel == 16)) {
					if (!isLevel3AssetsVisiblePath) {
						var couplerList = [];
						for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
							if (vm.assetTypeValuesPath[index].zoomLevel == 16) {
								vm.assetTypeValuesPath[index].assets.forEach(function (assetVal) {
									couplerList.push(assetVal);
								});
							}
						}
						drawAssetsForPath(couplerList, "level3");
						isLevel3AssetsVisiblePath = true;
					}
				}

				if (vm.prevZoomLevel == 17 && vm.zoomLevel == 16) {
					for (var i = 0; i < level4AssetsMarkersPath.length; i++) {
						level4AssetsMarkersPath[i].setMap(null);
					}

					for (i = 0; i < level4AssetsPolylinePath.length; i++) {
						level4AssetsPolylinePath[i].setMap(null);
					}
					isLevel4AssetsVisiblePath = false;
				}

				if ((vm.prevZoomLevel == 16 && vm.zoomLevel == 17)) {
					if (!isLevel4AssetsVisiblePath) {
						var poleList = [];
						for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
							if (vm.assetTypeValuesPath[index].zoomLevel == 17) {
								vm.assetTypeValuesPath[index].assets.forEach(function (assetVal) {
									poleList.push(assetVal);
								});
							}
						}
						drawAssetsForPath(poleList, "level4");
						isLevel4AssetsVisiblePath = true;
					}
				}

				if (vm.prevZoomLevel == 18 && vm.zoomLevel == 17) {
					for (var i = 0; i < level5AssetsMarkersPath.length; i++) {
						level5AssetsMarkersPath[i].setMap(null);
					}

					for (i = 0; i < level5AssetsPolylinePath.length; i++) {
						level5AssetsPolylinePath[i].setMap(null);
					}
					isLevel5AssetsVisiblePath = false;
				}
				if ((vm.prevZoomLevel == 17 && vm.zoomLevel == 18)) {
					if (!isLevel5AssetsVisiblePath) {
						var otherList = [];
						for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
							if (vm.assetTypeValuesPath[index].zoomLevel == 18) {
								vm.assetTypeValuesPath[index].assets.forEach(function (assetVal) {
									otherList.push(assetVal);
								});
							}
						}
						drawAssetsForPath(otherList, "level5");
						isLevel5AssetsVisiblePath = true;
					}
				}

				vm.prevZoomLevel = vm.zoomLevel;
			});
		}

		function drawAssets(response, level) {
			if (response) {
				$.each(response, function (index, value) {
					if (value.assetTypeLayout == null) {
						value.assetTypeName = value.assetType.name;
						value.assetTypeLayout = value.assetType.layout;
						value.assetTypeImagePath = value.assetType.imagePath;
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
						if (value.assetCoordinates.length > 1) {
							// drawPolyline(value);
							var value1 = value;
							value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

							drawFixedAsset(value1, false, level);

						} else {
							drawFixedAsset(value, false, level);
						}
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
						drawPolyline(value, locations.map, level);
					}

				});
			}
			switch (level) {
				case "level1":
					isLevel1AssetsVisible = true;
					break;
				case "level2":
					isLevel2AssetsVisible = true;
					break;
				case "level3":
					isLevel3AssetsVisible = true;
					break;
				case "level4":
					isLevel4AssetsVisible = true;
					break;
				case "level5":
					isLevel5AssetsVisible = true;
					break;
				default:
					break;
			}
		}

		function drawAssetsForPath(response, level) {
			if (response) {
				$.each(response, function (index, value) {
					if (value.assetTypeLayout == null) {
						value.assetTypeName = value.assetType.name;
						value.assetTypeLayout = value.assetType.layout;
						value.assetTypeImagePath = value.assetType.imagePath;
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
						if (value.assetCoordinates.length > 1) {
							var value1 = value;
							value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

							drawFixedAssetForPath(value1, false, level);

						} else {
							drawFixedAssetForPath(value, false, level);
						}
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
						drawPolylineForPath(value, userPaths.map, level);
					}

				});
			}
			switch (level) {
				case "level1":
					isLevel1AssetsVisiblePath = true;
					break;
				case "level2":
					isLevel2AssetsVisiblePath = true;
					break;
				case "level3":
					isLevel3AssetsVisiblePath = true;
					break;
				case "level4":
					isLevel4AssetsVisiblePath = true;
					break;
				case "level5":
					isLevel5AssetsVisiblePath = true;
					break;
				default:
					break;
			}
		}

		function drawFixedAsset(fixed, hasParent, level) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 8;
				if (vm.zoomLevel == 10) {
					iconSize = 8;
				} else if (vm.zoomLevel == 11) {
					iconSize = 16;
				}

				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: locations.map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});

				// if (vm.zoomLevel == 10) {
				//     startMarker.setLabel('');
				// } else if (vm.zoomLevel == 11) {
				//     var label = { color: '#000000', fontWeight: 'bold', fontSize: '12px', text: fixed.name };
				//     startMarker.setLabel(label);
				// }

				// if (fixed.status != null &&
				//     fixed.status === false) {
				//     startMarker.setLabel({
				//         color: 'red',
				//         fontSize: '30px',
				//         fontWeight: '20px',
				//         text: '\u2297'
				//     });
				// }
				// Add marker to the array.

				// markers.push(startMarker);

				switch (level) {
					case "level1":
						level1AssetsMarkers.push(startMarker);
						break;
					case "level2":
						level2AssetsMarkers.push(startMarker);
						break;
					case "level3":
						level3AssetsMarkers.push(startMarker);
						break;
					case "level4":
						level4AssetsMarkers.push(startMarker);
						break;
					case "level5":
						level5AssetsMarkers.push(startMarker);
						break;
					default:
						markers.push(startMarker);
						break;
				}
				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div'),
							button;
						userContent.innerHTML = '<div class="infoWindowhead">' + "<b>Name</b> : " + startMarker.title +
							'</div><div class="infoWindowContent">' +
							"<b>Asset Type</b> : " + fixed.assetTypeName +
							"<br><b>Latitude</b> :" +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Longitude</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						button = userContent.appendChild(document.createElement('input'));
						button.type = 'button';
						button.value = 'Creat Case';
						button.className = "button";

						google.maps.event.addDomListener(button, 'click', function () {
							$state.go("tr-case.new", {
								'lat': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude,
								'lng': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude,
								'desc': fixed.name
							});
						});


						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(locations.map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}

		function drawPolyline(spread, map, level) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});

			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false,
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(locations.map);
						openedInfoWindow = infowindow;
					}
				});

				var polylinepathDuct = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				polylinepath.setMap(locations.map);

				// polylines.push(polylinepath);
				switch (level) {
					case "level1":
						level1AssetsPolyline.push(polylinepath);
						break;
					case "level2":
						level2AssetsPolyline.push(polylinepath);
						break;
					case "level3":
						level3AssetsPolyline.push(polylinepath);
						break;
					case "level4":
						level4AssetsPolyline.push(polylinepath);
						break;
					case "level5":
						level5AssetsPolyline.push(polylinepath);
						break;
					default:
						polylines.push(polylinepath);
						break;
				}
			}
		}

		function drawFixedAssetForPath(fixed, hasParent, level) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 16;
				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: userPaths.map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});

				switch (level) {
					case "level1":
						level1AssetsMarkersPath.push(startMarker);
						break;
					case "level2":
						level2AssetsMarkersPath.push(startMarker);
						break;
					case "level3":
						level3AssetsMarkersPath.push(startMarker);
						break;
					case "level4":
						level4AssetsMarkersPath.push(startMarker);
						break;
					case "level5":
						level5AssetsMarkersPath.push(startMarker);
						break;
					default:
						markersForPath.push(startMarker);
						break;
				}
				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div'),
							button;
						userContent.innerHTML = '<div class="infoWindowhead">' + "<b>Name</b> : " + startMarker.title +
							'</div><div class="infoWindowContent">' +
							"<b>Asset Type</b> : " + fixed.assetTypeName +
							"<br><b>Latitude</b> :" +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Longitude</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						button = userContent.appendChild(document.createElement('input'));
						button.type = 'button';
						button.value = 'Creat Case';
						button.className = "button";

						google.maps.event.addDomListener(button, 'click', function () {
							$state.go("tr-case.new", {
								'lat': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude,
								'lng': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude,
								'desc': fixed.name
							});
						});


						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(userPaths.map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}

		function drawPolylineForPath(spread, map, level) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});
			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(userPaths.map);
						openedInfoWindow = infowindow;
					}
				});

				var polylinepathDuct = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				polylinepath.setMap(userPaths.map);

				// polylines.push(polylinepath);
				switch (level) {
					case "level1":
						level1AssetsPolylinePath.push(polylinepath);
						break;
					case "level2":
						level2AssetsPolylinePath.push(polylinepath);
						break;
					case "level3":
						level3AssetsPolylinePath.push(polylinepath);
						break;
					case "level4":
						level4AssetsPolylinePath.push(polylinepath);
						break;
					case "level5":
						level5AssetsPolylinePath.push(polylinepath);
						break;
					default:
						polylinesForPath.push(polylinepath);
						break;
				}
			}
		}

		function drawlines(paths) {
			vm.userPathName = paths.userName;
			var userData = paths;
			if (paths.path.length > 0) {

				var data = [{
					"latitude": paths.path[0].lat,
					"longitude": paths.path[0].lng
				}];
			} else {
				var data = [{
					"latitude": Floatparse(DEFAULT_LATITUDE.value),
					"longitude": parseFloat(DEFAULT_LONGITUDE.value)
				}];
			}
			initializeMap(data, function (latlang) {
				userPaths.latlng = latlang;
				setupMap(function () {
					google.maps.event.addListener(userPaths.map, 'zoom_changed', function () {
						vm.zoomLevel = userPaths.map.getZoom();
					});
					if (paths && paths.path && paths.path.length > 0) {
						loadUserPaths(paths);
					} else {
						//						resizeMap();
						if (vm.type == "user") {
							UsersGeoFenceData.getGeoFenceData(markerUserName, function (response) {
								vm.userGeofences = [];
								vm.assetFilterGeofences = [];
								$.each(response, function (index, value) {
									if (value.geofenceType != "MASTER") {
										if (value.geofenceType == "MINI") {
											vm.userGeofences.push(value);
											value.label = value.name.substring(0, 15) + "..";
											vm.assetFilterGeofences.push(value);
											if (vm.selectedUserGeofenceId == null) {
												vm.selectedUserGeofenceId = value.id;
												vm.canUserGeofenceFilter = true;
												vm.mapUserAssets = [];
												AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
													vm.assetTypeValuesPath = assetTypeVal;
													getGroupAssetsFromESPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
												});
											}
										} else {
											vm.userGeofences.push(value);
										}
									}
								});
							});
						} else {
							VehicleGeoFenceData.getGeoFenceData(paths.id, function (response) {
								vm.userGeofences = [];
								vm.assetFilterGeofences = [];
								$.each(response, function (index, value) {
									if (value.geofenceType != "MASTER") {
										if (value.geofenceType == "MINI") {
											vm.userGeofences.push(value);
											value.label = value.name.substring(0, 15) + "..";
											vm.assetFilterGeofences.push(value);
											if (vm.selectedUserGeofenceId == null) {
												vm.selectedUserGeofenceId = value.id;
												vm.canUserGeofenceFilter = true;
												vm.mapUserAssets = [];
												AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
													vm.assetTypeValuesPath = assetTypeVal;
													getGroupAssetsFromESPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
												});
											}
										} else {
											vm.userGeofences.push(value);
										}
									}
								});
							});
						}
						vm.totalDistance = 0;
						$scope.totalDistanceTravelled = "0 kms";
						vm.inProgressDistance = 0
						console.log('there are no user agents found');
					}
				});


				function loadUserPaths(paths) {
					var pathIn = [];
					var pathOut = [];
					var pathArr = paths.path;
					var prevCor = null;
					var pathOther = []

					for (var i = 0; i < pathArr.length; i++) {
						if (pathArr[i].geofenceStatus == "IN") {
							pathIn.push(pathArr[i]);

							if (prevCor != null) {
								var coordinatesList = [];
								coordinatesList.push(prevCor);
								coordinatesList.push(pathArr[i]);
								drawPolylineForGeoFence(coordinatesList, userPaths.map, "green", "Inside Geofence");
							}
						} else if (pathArr[i].geofenceStatus == "OUT") {
							pathOut.push(pathArr[i]);

							if (prevCor != null) {
								var coordinatesList = [];
								coordinatesList.push(prevCor);
								coordinatesList.push(pathArr[i]);
								drawPolylineForGeoFence(coordinatesList, userPaths.map, "orange", "Outside Geofence");
							}
						} else {
							pathOther.push(pathArr[i]);

							if (prevCor != null) {
								var coordinatesList = [];
								coordinatesList.push(prevCor);
								coordinatesList.push(pathArr[i]);
								drawPolylineForGeoFence(coordinatesList, userPaths.map, "DarkBlue", "Other");
							}
						}
						prevCor = pathArr[i];
					}

					drawMarkers(paths, pathArr, pathIn, "green");
					drawMarkers(paths, pathArr, pathOut, "orange");
					if (vm.type == "user") {
						UsersGeoFenceData.getGeoFenceData(markerUserName, function (response) {
							vm.userGeofences = [];
							vm.assetFilterGeofences = [];
							$.each(response, function (index, value) {
								if (value.geofenceType != "MASTER") {
									if (value.geofenceType == "MINI") {
										vm.userGeofences.push(value);
										value.label = value.name.substring(0, 15) + "..";
										vm.assetFilterGeofences.push(value);
										if (vm.selectedUserGeofenceId == null) {
											vm.selectedUserGeofenceId = value.id;
											vm.mapUserAssets = [];
											AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
												vm.assetTypeValuesPath = assetTypeVal;
												getGroupAssetsFromESPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
											});
											vm.canUserGeofenceFilter = true;
										}
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name);
									} else {
										vm.userGeofences.push(value);
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name);
									}
								}
							});
						});
					} else {
						VehicleGeoFenceData.getGeoFenceData(paths.id, function (response) {
							vm.userGeofences = [];
							vm.assetFilterGeofences = [];
							$.each(response, function (index, value) {
								if (value.geofenceType != "MASTER") {
									if (value.geofenceType == "MINI") {
										vm.userGeofences.push(value);
										value.label = value.name.substring(0, 15) + "..";
										vm.assetFilterGeofences.push(value);
										if (vm.selectedUserGeofenceId == null) {
											vm.selectedUserGeofenceId = value.id;
											vm.mapUserAssets = [];
											AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
												vm.assetTypeValuesPath = assetTypeVal;
												getGroupAssetsFromESPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
											});
											vm.canUserGeofenceFilter = true;
										}
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name);
									} else {
										vm.userGeofences.push(value);
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name);
									}
								}
							});
						});
					}

					if (vm.selectedUserGeofenceId != null) {
						vm.mapUserAssets = [];
						AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
							vm.assetTypeValuesPath = assetTypeVal;
							getGroupAssetsFromESPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
						});
					}

					Report.getReportingReport({
						id: userIdSelected,
						fromTime: vm.fromDate.getTime(),
						toTime: vm.toDate.getTime()
					}, function (response) {
						response.forEach(function (reporting) {

							if (reporting.userLatitude > 0 && reporting.userLongitude > 0) {
								var iconUrl = 'content/images/Pointer-C4.png';
								if (reporting.reportType == "CHECKIN") {
									iconUrl = 'content/images/Pointers-L4.png';
								} else {
									iconUrl = 'content/images/Pointer-C4.png';
								}
								var startMarker = new google.maps.Marker({
									map: userPaths.map,
									position: new google.maps.LatLng(
										reporting.userLatitude,
										reporting.userLongitude),
									icon: iconUrl,
									title: reporting.userLogin
								});

								google.maps.event.addListener(startMarker, 'click', function (event) {
									var date = new Date(reporting.dateTime);
									var infowindow = new google.maps.InfoWindow(
										{
											content: '<div class="infoWindowhead">' +
												'<b>Name : </b> ' + reporting.userLogin + '</br>' +
												'<b>Reporting Status : </b> ' + reporting.reportType + '</br>' +
												'<b>Reporting Time : </b> ' + date.toString() + '</br>' +
												'<b>LatLng : </b> ' + reporting.userLatitude + ', ' + reporting.userLongitude + '</br>'
										});
									infowindow.open(userPaths.map);
									infowindow.setPosition(event.latLng);
								});
							}
						});
					});

					function drawPolylineForGeoFence(latlngsToDraw, map, color, details) {
						var spreadAssetCoordinates = [];
						$.each(latlngsToDraw, function (index, value) {

							spreadAssetCoordinates.push({
								lat: value.lat,
								lng: value.lng
							});
						});

						if (spreadAssetCoordinates.length > 0) {
							var midLatLng = {
								lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
								lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
							};
							var infowindow = new google.maps.InfoWindow(
								{
									content: '<div class="infoWindowhead">'
										+ "name"
										+ '<div class="infoWindowContent"> <b>Description :</b> '
										+ "des" + '</div></div>'
								});

							infowindow.setPosition(midLatLng);
							var lineSymbol = {
								path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
								scale: 2,
							};
							var iconStyle = [{
								icon: lineSymbol,
								offset: '100%',
								repeat: '500px'
							}];

							var ColorValue = '#ff0000';
							if (color == "red") {
								ColorValue = '#ff0000';
							} else if (color == "black") {
								ColorValue = '#000000';
							} else if (color == "blue") {
								ColorValue = '#68A8DE';
							} else if (color == "green") {
								ColorValue = '#00e658';
							} else if (color == "orange") {
								ColorValue = '#fd7a24';
							} else if (color == "DarkBlue") {
								ColorValue = '#CA902E';
							} else {
								ColorValue = '#208000';
							}

							var polylinepath = null;

							if (color == "blue") {
								polylinepath = new google.maps.Polyline({
									path: spreadAssetCoordinates,
									geodesic: true,
									strokeColor: ColorValue,
									strokeOpacity: paths.stroke.weight,
									strokeWeight: 3
								});
							} else {
								polylinepath = new google.maps.Polyline({
									path: spreadAssetCoordinates,
									geodesic: true,
									strokeColor: ColorValue,
									strokeOpacity: paths.stroke.weight,
									strokeWeight: 3,
									icons: iconStyle
								});
							}

							polylinepath.setOptions({
								strokeColor: ColorValue
							});

							google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
								infowindow.close();
							});

							google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
								if (openedInfoWindow != null) {
									openedInfoWindow.close();
								}
								infowindow.setContent('<div class="infoWindowhead">'
									+ '<b></b>' + details + '</br></div>'
								);

								infowindow.mousemove;
								infowindow.open(map);
								infowindow.setPosition(event.latLng);
								openedInfoWindow = infowindow;
							});
							polylinepath.setMap(map);
						}
					}
				}

				// added for calculating previous point start
				function previos_dist(i, markers) {
					var locDiff = 0;
					if (i > 0) {
						var data1 = markers[i];
						var data2 = markers[i - 1];
						var radlat1 = Math.PI * data1.lat / 180
						var radlat2 = Math.PI * data2.lat / 180
						var theta = data1.lng - data2.lng
						var radtheta = Math.PI * theta / 180
						var locDiff = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
						locDiff = Math.acos(locDiff)
						locDiff = locDiff * 180 / Math.PI
						locDiff = locDiff * 60 * 1.1515
						locDiff = locDiff * 1.609344
						locDiff = locDiff * 1000
					}
					return locDiff;
				}

				function drawMarkers(userdata, paths, userpath, colorVal) {
					var imgUrl = "content/images/dot.png";
					if (colorVal == "green") {
						imgUrl = "content/images/green_dot.png";
					} else {
						imgUrl = "content/images/orange_dot.png";
					}

					var markers = userpath;

					var infoWindow = new google.maps.InfoWindow();
					var lat_lng = new Array();

					var icon = {
						url: imgUrl, // url
						scaledSize: new google.maps.Size(5, 5),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(0, 0)
					};

					for (var i = 0; i < markers.length; i++) {
						var data = markers[i];
						var locDiff = previos_dist(i, markers);

						var myLatlng = new google.maps.LatLng(data.lat, data.lng);
						lat_lng.push(myLatlng);
						var marker = new google.maps.Marker({
							position: myLatlng,
							map: userPaths.map,
							icon: icon
						});

						(function (marker, data) {

							var logdate;
							if (data.updatedDateTime != 0) {
								logdate = new Date(data.updatedDateTime);

							} else {
								logdate = new Date(data.createdDateTime);
							}

							var logDateTime = $filter('date')(logdate, 'dd MMM HH:mm:ss');

							var travel_data = '<div class="infoWindowhead">' + logDateTime + '</div><div class="infoWindowContent"><div class="rows"><!--<p><strong>Address: </strong>' + data.address + '</p>--><p><strong>Coordinates(Lat , Long): </strong>' + data.lat.toFixed(4)
								+ ' , ' + data.lng.toFixed(4) + '</p><!--<p><strong>DistFromPrevLoc: </strong>' + locDiff.toFixed(2) + ' Meters</p>--></div></div>';

							google.maps.event.addListener(marker, "mouseover", function (e) {
								infoWindow.setContent(travel_data);
								infoWindow.open(userPaths.map, marker);
							});
							google.maps.event.addListener(marker, "mouseout", function (e) {
								infoWindow.close(userPaths.map, marker);
							});
						})(marker, data);


					}

					var infoWindow = new google.maps.InfoWindow();
					var distanceIn = userdata.distanceIn;
					var distanceOut = userdata.distanceOut;
					var distanceUnderived = userdata.distanceUnderived;

					var startMarker = new google.maps.Marker({
						map: userPaths.map,
						position: new google.maps.LatLng(paths[0].lat, paths[0].lng),
						title: 'Started here',
						icon: "content/images/green.png"
					});
					startMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

					google.maps.event.addListener(startMarker, 'mouseover', function () {
						infoWindow.setContent(startMarker.content + '<div class="infoWindowContent">' + startMarker.title + '</div>');
						infoWindow.open(userPaths.map, startMarker);

					});
					google.maps.event.addListener(startMarker, 'mouseout', function () {
						infoWindow.close(userPaths.map, startMarker);
					});

					var infoWindow1 = new google.maps.InfoWindow();
					var endMarker = new google.maps.Marker({
						map: userPaths.map,
						position: new google.maps.LatLng(paths[paths.length - 1].lat, paths[paths.length - 1].lng),
						title: "Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence " + (distanceOut).toFixed(2) + " Km",
						icon: "content/images/red.png"

					})
					if (vm.type == "user") {
						vm.totalDistance = (distanceIn + distanceOut + distanceUnderived).toFixed(2);
						$scope.totalDistanceTravelled = "   Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence - " + (distanceOut).toFixed(2) + " Km";
						vm.inProgressDistance = (distanceUnderived).toFixed(2);
					} else {
						vm.totalDistance = (distanceIn).toFixed(2);
						$scope.totalDistanceTravelled = "";
					}


					endMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

					google.maps.event.addListener(endMarker, 'mouseover', function () {

						infoWindow1.setContent(endMarker.content + '<div class="infoWindowContent">' + endMarker.title + '</div>');
						infoWindow1.open(userPaths.map, endMarker);

					});
					google.maps.event.addListener(endMarker, 'mouseout', function () {
						infoWindow1.close(userPaths.map, endMarker);
					});
				}
			});

		}

		function setupMap(callback) {
			/* var myOptions = {
				zoom: 13,
				center: userPaths.latlng,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			}; */
			userPaths.map = new google.maps.Map(document.getElementById("userPath_map_canvas"), myOption(13, userPaths.latlng));
			geoLocation(userPaths.map)
			userPaths.overlay = new google.maps.OverlayView();
			userPaths.overlay.draw = function () {
			};
			userPaths.overlay.setMap(userPaths.map);
			userPaths.element = document.getElementById('userPath');
			callback();
		}

		$scope.$on('$destroy', function () {
			$interval.cancel(updateLogs);
		});



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;

		}

		$scope.reset = function () {
			vm.userGeofences = [];
			vm.assetFilterGeofences = [];
			vm.selectedUserGeofenceId = null;
			vm.prevSelectedUserGeofenceId = null;
			var cleratodatefromdate = vm.today();
			// cleratodatefromdate.remove();
		}

		function downloadLoadPath() {
			var data = {
				fromDate: vm.fromDate.getTime(),
				toDate: vm.toDate.getTime(),
				userId: vm.pathuserid,
				type: vm.type
			}
			LocationLogMapPath.downloadUserPath(data, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/text' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "TravelledPath.kml";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function filterAssetsLocationOnMapView() {
			vm.allGeofences = []
			if (vm.adminFilter) {
				GeofenceIDs.getAll(function (response) {
					response.forEach(function (geofence) {
						if (geofence.name != 'Bangalore') {
							geofence.label = geofence.name.substring(0, 15) + "..";
							vm.allGeofences.push(geofence);
							if (vm.selectedGeofenceId == null) {
								vm.selectedGeofenceId = geofence.id;
							}
						}
					});
				});
			} else {
				UserGeofences.getAll(function (response) {
					response.forEach(function (geofence) {
						if (geofence.name != 'Bangalore') {
							geofence.label = geofence.name.substring(0, 15) + "..";
							vm.allGeofences.push(geofence);
							if (vm.selectedGeofenceId == null) {
								vm.selectedGeofenceId = geofence.id;
							}
						}
					});
				});
			}
			/* $("#mapFilterLocationModal").show();
			noDataText = document.getElementById("noData");
			noDataText.style.display = "none"; */
			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
		}

		function closeMapLocationFilterModal() {
			$("#mapFilterLocationModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLocationModal").hide();
			vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
		}

		function filterAssetsLoadOnMapView() {
			$("#mapFilterLoadPathModal").show();
			noDataText = document.getElementById("noData");
			noDataText.style.display = "none";
			vm.prevSelectedUserGeofenceId = vm.selectedUserGeofenceId;
		}

		function closeMapLoadPathFilterModal() {
			$("#mapFilterLoadPathModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLoadPathModal").hide();
			vm.selectedUserGeofenceId = vm.prevSelectedUserGeofenceId;
		}



		function saveLoadPathFilter() {
			/* $("#mapFilterLoadPathModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLoadPathModal").hide(); */
			onChangeDate(vm.pathuserid);

			vm.mapUserAssets = [];
			AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				vm.assetTypeValuesPath = assetTypeVal;
				getGroupAssetsFromESPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
			});

			vm.prevSelectedUserGeofenceId = vm.selectedUserGeofenceId;

		}

		function clearMarkers(markersList) {
			for (var i = 0; i < markersList.length; i++) {
				markersList[i].setMap(null);
			}
		}

		function clearPolylines(polylinesList) {
			for (var i = 0; i < polylinesList.length; i++) {
				polylinesList[i].setMap(null);
			}
		}


		function saveLocationFilter() {
			// if (vm.selectedLogs === "ALL") {
			// 	vm.all();
			// } else if (vm.selectedLogs === "ACTIVE") {
			// 	vm.active();
			// } else if (vm.selectedLogs === "INACTIVE") {
			// 	vm.inactive();
			// } else if (vm.selectedLogs === "IDLE") {
			// 	vm.idle();
			// }

			vm.mapAssets = [];
			AssetTypesByGeofenceID.get(vm.selectedGeofenceId, function (assetTypeVal) {
				vm.assetTypeValues = assetTypeVal;
				getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
			});

			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;

			$("#mapFilterLocationModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLocationModal").hide();
		}

		function getGroupLocationAssetsFromES(geofenceIdVal, lastAssetId, mapAssetLists, map) {
			AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;

					vm.mapAssets.push(tmpAsset);
				});
				drawLatestLocationAssets(vm.mapAssets, map);
				if (data.lastId != null) {
					getGroupLocationAssetsFromES(geofenceIdVal, data.lastId, vm.mapAssets, map);
				}
			});
		}

		function drawLatestLocationAssets(response, map) {
			if (response) {
				initializeLocationAssetMap(response, function (latlang) {
					locations.latlng = latlang;
					$.each(response, function (index, value) {
						if (value.assetTypeLayout == null) {
							value.assetTypeName = value.assetType.name;
							value.assetTypeLayout = value.assetType.layout;
							value.assetTypeImagePath = value.assetType.imagePath;
						}
						if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
							if (value.assetCoordinates.length > 1) {
								drawPolyline(value);
								var value1 = value;
								value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

								drawFixedLocationAsset(value1, false, map);

							} else {
								drawFixedLocationAsset(value, false, map);
							}
						}
						if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
							drawPolyline(value, map);
						}

					});
				});
			}
		}

		function initializeLocationAssetMap(latlangs, callback) {

			if (latlangs && latlangs.length > 0) {
				var latVal = null;
				var lngVal = null;
				latlangs.forEach(function (value) {
					if (latVal == null && lngVal == null) {
						if (value.assetCoordinates.length > 0) {
							latVal = value.assetCoordinates[value.assetCoordinates.length - 1].latitude;
							lngVal = value.assetCoordinates[value.assetCoordinates.length - 1].longitude;
						}
					}
				});
				if (latVal != null && lngVal != null) {
					latlng = new google.maps.LatLng(latVal, lngVal);
					callback(latlng);
				}
			} else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (
						position) {

						latlng = new google.maps.LatLng(
							position.coords.latitude,
							position.coords.longitude);
						callback(latlng);
					}, function () {
						callback(new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value));
					});
				} else {
					callback(new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value));
				}
			}
		}

		function drawPolyline(spread, map) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});
			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false,
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(map);
						openedInfoWindow = infowindow;
					}
				});

				polylinepath.setMap(map);

				polylines.push(polylinepath);
			}
		}

		function drawFixedLocationAsset(fixed, hasParent, map) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 8;
				if (vm.zoomLevel == 10) {
					iconSize = 8;
				} else if (vm.zoomLevel == 11) {
					iconSize = 16;
				}

				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});


				markers.push(startMarker);

				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div');
						userContent.innerHTML = '<div class="infoWindowhead">' + "<b>Name</b> : " + startMarker.title +
							'</div><div class="infoWindowContent">' +
							"<b>Asset Type</b> : " + fixed.assetTypeName +
							"<br><b>Latitude</b> :" +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Longitude</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}

		function distanceCal(lat1, lon1, lat2, lon2) {
			var theta = lon1 - lon2;
			var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
				Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
			dist = Math.acos(dist);
			dist = radians_to_degrees(dist);
			dist = dist * 60 * 1.1515;
			dist = dist * 1.609344;
			if (isNaN(dist)) {
				return 0.0;
			} else {
				return (dist);
			}
		}

		function degrees_to_radians(degrees) {
			var pi = Math.PI;
			return degrees * (pi / 180);
		}

		function radians_to_degrees(radians) {
			var pi = Math.PI;
			return radians * (180 / pi);
		}

		function showZoomLocation() {
			var latlng = vm.getLocationCoordinate.split(",");
			if (gotoMarker != null) {
				gotoMarker.setMap(null);
			}
			if (vm.getLocationCoordinate != null) {
				var centerlatlng = {
					lat: parseFloat(latlng[0]),
					lng: parseFloat(latlng[1])
				};
					locations.map.setCenter(centerlatlng);
					locations.map.setZoom(18);
					var startMarker = new google.maps.Marker({
						map: locations.map,
						position: centerlatlng,
					});
				gotoMarker = startMarker;
				$("#modalLatLongs").removeClass("in");
				$(".modal-backdrop").remove();
				$("#modalLatLongs").hide();
			}
		}
		function gotoLatitute() {
			$("#modalLatLongs").show();
			//  noDataText = document.getElementById("noData");
			// noDataText.style.display = "none"; 
		}

		function gotoLatituteCity() {
			$("#modalLatLongs").show();
			// noDataText = document.getElementById("noData");
			// noDataText.style.display = "none";
		}
		function closeGotoLatitute(id) {
			$("#" + id).removeClass("in");
			$(".modal-backdrop").remove();
			$("#" + id).hide();
		}
		function closeGotoLatituteCity() {
			$("#modalLatLongs").removeClass("in");
			$(".modal-backdrop").remove();
			$("#modalLatLongs").hide();
		}
		function geoLocation(map) {
			var infoWindow = new google.maps.InfoWindow();
			var locationButton = document.createElement("button");
			locationButton.setAttribute("title", "Locate Me");
			locationButton.classList.add("custom-map-control-button");
			var geoIcon = document.createElement("i");
			geoIcon.classList.add("fa");
			geoIcon.classList.add("fa-crosshairs");
			geoIcon.classList.add("geo");
			locationButton.appendChild(geoIcon);
			map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
				locationButton
			);

			var goTo = document.createElement("button");
			goTo.setAttribute("title", "Location Coordinates");
			goTo.classList.add("custom-map-control-button");
			var gotoIcon = document.createElement("i");
			gotoIcon.classList.add("fa");
			gotoIcon.classList.add("fa-location-arrow");
			gotoIcon.classList.add("geo");
			goTo.appendChild(gotoIcon);
			map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);

			/* var zoomLabel = document.createElement("span");
			zoomLabel.setAttribute("title", "Zoom");
			zoomLabel.classList.add("custom-map-control-button");
			var textnode = document.createTextNode("Zoom :"+vm.zoomLevel);
			zoomLabel.appendChild(textnode);
			map.controls[google.maps.ControlPosition.LEFT_TOP].push(
				zoomLabel
			);  */

			goTo.addEventListener("click", function () {
				gotoLatitute();
			});
			var measureTool = document.createElement("button");
			measureTool.setAttribute("title", "Measure Distance");
			measureTool.classList.add("custom-map-control-button");
			var measureToolIcon = document.createElement("i");
			measureToolIcon.classList.add("fa");
			measureToolIcon.classList.add("fa-arrows-h");
			measureToolIcon.classList.add("ruler");
			measureTool.appendChild(measureToolIcon);
			map.controls[google.maps.ControlPosition.RIGHT_TOP].push(measureTool);
			measureTool.addEventListener("click", function () {

				if (measureEnabled) {
					google.maps.event.removeListener(vm.clickListener);
					totalDistance = 0
					clearMeasureTool(distanceMarkers)
					clearMeasureTool(pointerMarkers)
					clearMeasureTool(arrpolyMeasureTool)
					clearMeasureTool(totalDistanceMarkers)
					distanceMarkers = []
					totalDistanceMarkers = []
					pointerMarkers = []
					arrpolyMeasureTool = []
					measureEnabled = false
					measureTool.setAttribute("title", "Measure Distance");
					measureToolIcon.classList.remove("fa-times");
					measureToolIcon.classList.add("fa-arrows-h");
				} else {
					measureEnabled = true
					polyMeasureTool = new google.maps.Polyline({
						strokeColor: 'black',
						strokeOpacity: 1.0,
						strokeWeight: 3
					});
					polyMeasureTool.setMap(locations.map);
					arrpolyMeasureTool.push(polyMeasureTool)

					vm.clickListener = locations.map.addListener('click', addLatLng);
					measureTool.setAttribute("title", "Clear Distance");
					measureToolIcon.classList.remove("fa-arrows-h");
					measureToolIcon.classList.add("fa-times");
				}
			});

			locationButton.addEventListener("click", function () {
				// Try HTML5 geolocation.
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						function (position) {
							var pos = {
								lat: position.coords.latitude,
								lng: position.coords.longitude,
							};

							infoWindow.setPosition(pos);
							infoWindow.setContent("Location found.");
							infoWindow.open(map);
							// var image = {
							//     url: "content/images/geoLocation.png", // url
							//     scaledSize: new google.maps.Size(25, 25), // scaled size
							//     origin: new google.maps.Point(0, 0), // origin
							//     anchor: new google.maps.Point(0, 0), // anchor
							// };
							// var markerGeo = new google.maps.Marker({
							//     position: pos,
							//     icon: image,
							// });
							// map.setZoom(20);
							// markerGeo.setMap(map);
							map.setZoom(18);
							map.setCenter(pos);
						},
						function () {
							handleLocationError(
								true,
								infoWindow,
								map.getCenter()
							);
						},
						{
							enableHighAccuracy: true,
							timeout: 5000,
							maximumAge: 0,
						}
					);
				} else {
					// Browser doesn't support Geolocation
					handleLocationError(false, infoWindow, map.getCenter());
				}
			});

			function handleLocationError(
				browserHasGeolocation,
				infoWindow,
				pos
			) {
				infoWindow.setPosition(pos);
				infoWindow.setContent(
					browserHasGeolocation
						? "Error: The Geolocation service failed."
						: "Error: Your browser doesn't support geolocation."
				);
				infoWindow.open(map);
			}
		}
		function clearMeasureTool(arr) {
			for (var i = 0; i < arr.length; i++) {
				arr[i].setMap(null)
			}
		}

		function addLatLng(event) {
			var path = polyMeasureTool.getPath();
			path.push(event.latLng);
			addPointer(event.latLng);
			var point1, point2
			for (var i = 0; i < path.getLength() - 1; i++) {
				point1 = path.getAt(i);
				point2 = path.getAt(i + 1);
				segmentDistance = google.maps.geometry.spherical.computeDistanceBetween(point1, point2);
				// Add distance marker
				midpoint = google.maps.geometry.spherical.interpolate(point1, point2, 0.5);

			}
			if (path.getLength() > 1) {
				totalDistance += segmentDistance;
				var marker = new google.maps.Marker({
					position: midpoint,
					map: locations.map,
					icon: {
						url: 'content/images/iconTransparent.png',
					},
					label: {
						color: "black",
						fontWeight: "bold",
						fontSize: "14px",
						text: formatDistance(segmentDistance),
					},
				});
				distanceMarkers.push(marker);

				var totalDistanceMarker = new google.maps.Marker({
					position: point2,
					map: locations.map,
					icon: {
						url: 'content/images/iconTransparent.png',
					},
					label: {
						color: "black",
						fontWeight: "bold",
						fontSize: "14px",
						text: "Total : " + formatDistance(totalDistance),
					},
				});
				totalDistanceMarkers.push(totalDistanceMarker);
			}
		}
		function addPointer(location, map) {
			var pointerIcon = {
				path: google.maps.SymbolPath.CIRCLE,
				scale: 5,
				strokeColor: 'black',
				fillColor: 'white',
				fillOpacity: 1,
				strokeWeight: 2
			};

			var pointer = new google.maps.Marker({
				position: location,
				map: map,
				icon: pointerIcon
			});
			pointerMarkers.push(pointer);
		}

		function formatDistance(distance) {
			// Convert meters to kilometers
			var km = distance / 1000;
			// Show in meters if less than 1 km, otherwise show in kilometers
			if (km < 1) {
				return distance.toFixed(0) + ' m';
			} else {
				return km.toFixed(2) + ' km';
			}
		}
		function initializeMap(latlangs, callback) {
			if (latlangs && latlangs.length > 0) {
				latlng = new google.maps.LatLng(latlangs[0].latitude, latlangs[0].longitude);
				callback(latlng);
			} else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {
						google.maps.event.trigger(locations.map, "resize");
						var centerlatlng = {
							lat: parseFloat(latlng[0]),
							lng: parseFloat(latlng[1])
						};
						try {
							locations.map.setCenter(centerlatlng);
						} catch (err) {
							console.log(err);
						}
					}, function () {
						setTimeout(function () {
							google.maps.event.trigger(locations.map, "resize");
							var centerlatlng = {
								lat: parseFloat(latlng[0]),
								lng: parseFloat(latlng[1])
							};
							try {
								locations.map.setCenter(centerlatlng);
							} catch (err) {
								console.log(err);
							}
						}, 100);
					});
				} else {
					setTimeout(function () {
						google.maps.event.trigger(locations.map, "resize");
						var centerlatlng = {
							lat: parseFloat(latlng[0]),
							lng: parseFloat(latlng[1])
						};
						try {
							locations.map.setCenter(centerlatlng);
						} catch (err) {
							console.log(err);
						}
					}, 100);
				}
			}
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeDialogController', GroupTypeDialogController);

    GroupTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams',  'entity', 'GroupType', 'User','AllCustomGroupTypeAttribute', '$state', '$q'];

    function GroupTypeDialogController ($timeout, $scope, $stateParams,  entity, GroupType, User,AllCustomGroupTypeAttribute, $state, $q) {
        var vm = this;

        vm.groupType = entity;
        $scope.attributetypes = ['INTEGER', 'FLOAT', 'STRING','BOOLEAN'];
        vm.clear = clear;
        
        vm.customCaseTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        
        
		vm.save = save;
		 $(":file").filestyle({buttonBefore: true});      
	     $(":file").filestyle('buttonText', 'Browse File');
       
        
	     vm.items=[{ name: '',attributeDataType: {},defaultValue :''}];
	     
	     if(vm.groupType.groupTypeAttributes!=null && vm.groupType.groupTypeAttributes.length!=0){
	        	vm.items=vm.groupType.groupTypeAttributes;
	        }
	     
	     function loadPage() {
	    	 AllCustomGroupTypeAttribute.getAll(function(response) {
	    		 vm.customGroupTypeAttributes = response;
	     		 response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customGroupTypeAttributeValues;
					});
	    		 
				});
	    	    
	    	 }
        
        if(vm.groupType.groupTypeAttributes!=null && vm.groupType.groupTypeAttributes.length!=0){
        	vm.items=vm.groupType.groupTypeAttributes;
        }
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.groupType.id !== null) {
            	vm.groupType.groupTypeAttributes=[];
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            		 vm.groupType.groupTypeAttributes.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,  "attributeDataType" :  vm.items[i].attributeDataType,"defaultValue" :  vm.items[i].defaultValue});
            	}
                GroupType.update(vm.groupType, onSaveSuccess, onSaveError);
            } else {
                vm.groupType.groupTypeAttributes=[];
            	
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            		 vm.groupType.groupTypeAttributes.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,   "attributeDataType" :  vm.items[i].attributeDataType,"defaultValue" :  vm.items[i].defaultValue});
            	}
                GroupType.save(vm.groupType, onSaveSuccess, onSaveError);
            }
        }
        
        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:groupTypeUpdate', result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == 'group.new') {
                $state.go('group.new');
            } else {
                $state.go('group-type');
            }
            // sessionStorage.removeItem("prevPage");
            // $state.go('group-type');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        
        vm.addmore = function() {
        	vm.items.push({name: '',attributeDataType:{}, defaultValue:''});
          };
            
       vm.remove = function(index) {
            vm.items.splice(index, 1);
          };

    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeDetailController', GroupTypeDetailController);

    GroupTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GroupType', 'User'];

    function GroupTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, GroupType, User) {
        var vm = this;

        vm.groupType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:groupTypeUpdate', function(event, result) {
            vm.groupType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeDeleteController',GroupTypeDeleteController);

    GroupTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'GroupType'];

    function GroupTypeDeleteController($uibModalInstance, entity, GroupType) {
        var vm = this;

        vm.groupType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GroupType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('group-type', {
            parent: 'entity',
            url: '/group-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER_ADMIN','ROLE_USER'],
                pageTitle: 'trakeyeApp.groupType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group-type/group-types.html',
                    controller: 'GroupTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    $translatePartialLoader.addPart('layout');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('group-type-detail', {
            parent: 'entity',
            url: '/group-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group-type/group-type-detail.html',
                    controller: 'GroupTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    $translatePartialLoader.addPart('layout');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('group-type-detail.edit', {
            parent: 'group-type-detail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/group-type/group-type-dialog.html',
                    controller: 'GroupTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
       
        
        .state('group-type.new', {
            parent: 'group-type',
            url: '/new',
            data: {
            	 authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					 templateUrl: 'app/entities/group-type/group-type-dialog.html',
	                    controller: 'GroupTypeDialogController',
	                    controllerAs: 'vm',
				}
			},
			 resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                description: null,
                                layout: null,
                                colorcode: null,
                                createDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
            
        })
        
        .state('group-type.edit', {
            parent: 'group-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/group-type/group-type-dialog.html',
                    controller: 'GroupTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('group-type.delete', {
            parent: 'group-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-type/group-type-delete-dialog.html',
                    controller: 'GroupTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GroupType', function(GroupType) {
                            return GroupType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group-type', null, { reload: 'group-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('GroupType', GroupType);

    GroupType.$inject = ['$resource'];

    function GroupType ($resource) {
        var resourceUrl =  'api/group-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('GroupTypeSearch', GroupTypeSearch);

    GroupTypeSearch.$inject = ['$resource'];

    function GroupTypeSearch ($resource) {
        var service = $resource('/api/group-types/searchvalue/:searchvalue',{searchvalue:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomGroupTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-group-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeController', GroupTypeController);

    GroupTypeController.$inject = ['$scope', '$state', 'GroupType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'GroupTypeSearch'];

    function GroupTypeController ($scope, $state, GroupType, ParseLinks, AlertService, pagingParams, paginationConstants, GroupTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;
        
        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			GroupTypeSearch.query({searchvalue:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    //result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groupTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}

        loadAll();

        function loadAll () {
            GroupType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groupTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupDialogController', GroupDialogController);

    GroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state', 'entity', 'Group', 'AllCustomGroupTypeAttribute', 'AllGroupsTypes', 'UserIDs','AssetIDs','AssetByID','Principal'];

    function GroupDialogController ($timeout, $scope, $stateParams, $state, entity, Group, AllCustomGroupTypeAttribute, AllGroupsTypes, UserIDs,Principal) {
        var vm = this;
        vm.group = entity;
        vm.clear = clear;
		var entity_old = angular.copy(vm.group);
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
		vm.customAttributesMap = {};
		vm.selectattributes = selectedGroupTypeAttributes;
		vm.save = save;
		vm.navigateGroupTypefromGroup = navigateGroupTypefromGroup;
        loadPage();
		var selctedUsers = [];
        
        function loadPage() {
        	vm.multiuser = [];
          	vm.multigroups = [];
          	AllGroupsTypes.getAll(function(response) {
				vm.grouptypes = response;
			});
			
			AllCustomGroupTypeAttribute.getAll(function(response) {
				response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customGroupTypeAttributeValues;
				});
			
			});
        	
        	UserIDs.getAdminAll(function(response) {
        		response.forEach(function(user) {
        			if(selctedUsers.indexOf(user.id) !== -1){
        					vm.multiuser.push({ login: user.login, id:user.id ,ticked: true });
        				}else{
        					vm.multiuser.push({ login: user.login, id:user.id ,ticked: false });
        			}
        		});
			});
		}
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }
        
		function selectedGroupTypeAttributes() {
			if (vm.groupType) {
				vm.isSite = false;
				
				vm.group.groupType = vm.groupType;
				if (entity_old.groupType
						&& vm.groupType.id === entity_old.groupType.id) {
					vm.group.groupTypeAttributeValues = [];
					vm.group.groupTypeAttributeValues = entity_old.groupTypeAttributeValues;
				} else {
					vm.group.groupTypeAttributeValues = [];
					$.each(
						vm.groupType.groupTypeAttributes,
						function(key, value) {
							vm.group.groupTypeAttributeValues
								.push({
									groupTypeAttribute : vm.groupType.groupTypeAttributes[key]
								});
						});
				}

			}

		}
     
        function save () {
            vm.isSaving = true;
            if (vm.group.id !== null) {
                Group.update(vm.group, onSaveSuccess, onSaveError);
            } else {
                Group.save(vm.group, onSaveSuccess, onSaveError);
            }
        }

		function onSaveSuccess(result) {
			$scope.$emit('trakeyeApp:groupUpdate', result);
			// $uibModalInstance.close(result);
			vm.isSaving = false;
			var pageValue = sessionStorage.getItem("prevPage");
			var previousId = sessionStorage.getItem("prevId");
			var prevEditDetail = sessionStorage.getItem("prevEditId");
			if (pageValue == 'user-management.new') {
				$state.go('user-management.new');
			} else if (previousId) {
				sessionStorage.setItem("groupToEditAsset", "groupToasset");
				$state.go('asset.edit', {
					'id': previousId
				});
			} else if (prevEditDetail) {
				sessionStorage.setItem("groupToEditAssetDetail", "groupToassetDetail");
				$state.go('asset-detail.edit', {
					'id': prevEditDetail
				});
			} else if(sessionStorage.getItem("createGroup")) {
				$state.go('asset.new', {
				});
			}
			else {
				$state.go('group');
			}
		}

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;
        

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
		}
		
		function navigateGroupTypefromGroup() {
			sessionStorage.setItem("prevPage", "group.new");
			$state.go('group-type.new');
		}
    }
    
})();


(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupDetailController', GroupDetailController);

    GroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Group', 'User'];

    function GroupDetailController($scope, $rootScope, $stateParams, previousState, entity, Group, User) {
        var vm = this;
       
        vm.group = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:groupUpdate', function(event, result) {
            vm.group = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
          
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupDeleteController',GroupDeleteController);

    GroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'Group'];

    function GroupDeleteController($uibModalInstance, entity, Group) {
        var vm = this;

        vm.group = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Group.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('group', {
                parent: 'entity',
                url: '/group?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'trakeyeApp.group.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group/groups.html',
                        controller: 'GroupController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'modified_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('group-detail', {
                parent: 'entity',
                url: '/group/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'trakeyeApp.group.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group/group-detail.html',
                        controller: 'GroupDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Group', function($stateParams, Group) {
                        return Group.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'group',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

        .state('group.new', {
                parent: 'group',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group/group-dialog.html',
                        controller: 'GroupDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            name: null,
                            description: null,
                            coordinates: null,
                            createdDate: null,
                            modifiedDate: null,
                            id: null
                        };
                    }
                }

            })
            .state('group.edit', {
                parent: 'entity',
                url: '/group/edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group/group-dialog.html',
                        controller: 'GroupDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Group', function($stateParams, Group) {
                        return Group.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'group',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })


        .state('group.delete', {
            parent: 'group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group/group-delete-dialog.html',
                    controller: 'GroupDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['Group', function(Group) {
                            return Group.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group', null, { reload: 'group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('group.import', {
            parent: 'group',
            url: '/import',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group/group-import.html',
                    controller: 'GroupImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function() {
                    return {
                        description: null,
                        createDate: null,
                        updateDate: null,
                        pinLat: null,
                        pinLong: null,
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        caseImages: []
                    };
                }
            }

        });
    }

})();
(function() {
	'use strict';
	angular.module('trakeyeApp').factory('Group', Group);

	Group.$inject = [ '$resource', 'DateUtils' ];

	function Group($resource, DateUtils) {
		var resourceUrl = 'api/groups/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('GroupSearch', GroupSearch);

	GroupSearch.$inject = [ '$resource' ];

	function GroupSearch($resource) {
		var service = $resource('/api/groups/searchvalue/:userId', {
			userId : '@id'
		}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllGroups', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/groupsall').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllGroupsTypes', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/group-alltypes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';
	angular.module('trakeyeApp').factory('GroupUpload', GroupUpload);

	GroupUpload.$inject = [ '$http' ];

	function GroupUpload($http) {

		var service = {};
		service.groupUpload = function(data,assetType, callback) {
			$http.post('api/groupsimport/'+assetType.name, data, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}
			}).then(function(response) {

				callback(response, response.headers);
			}, function(error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

//(function() {
//	'use strict';
//
//	angular.module('trakeyeApp').factory('GroupIDs', [ '$rootScope', '$http', function($rootScope, $http) {
//
//		var service = {};
//		service.getAll = function( callback) {
//			$http.get('api/grouplist').then(function(response) {
//				callback(response.data);
//			});
//		};
//
//		return service;
//	} ]);
//})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('UserGroupIDs', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function( callback) {
			$http.get('api/user-groups').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupController', GroupController);

    GroupController.$inject = ['$scope', '$state', 'Group', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','GroupSearch'];

    function GroupController ($scope, $state, Group, ParseLinks, AlertService, pagingParams, paginationConstants,GroupSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			GroupSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groups = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        loadAll();

        function loadAll () {
            Group.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groups = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceImportController', GeofenceImportController)
        .directive("fileread", [function () {
            'use strict';

            return {
                restrict: "A",

                link: function ($scope, element) {

                    element.change(function (event) {
                        $scope.$apply(function () {
                            $scope.myFile = element[0].files[0];

                        });
                    });
                }

            };
        }]);

    GeofenceImportController.$inject = ['$timeout', '$scope', 'GeofenceUpload', 'AllAssetsTypes'];

    function GeofenceImportController($timeout, $scope, GeofenceUpload, AllAssetsTypes) {
        var vm = this;

        vm.upload = upload;
        vm.geofencetype = null;
        var formData;

        function upload() {
            formData = new FormData();
            formData.append('file', $scope.myFile);
            if (vm.geofencetype != null) {
                // var isMaster = false;

                // if (vm.geofencetype == "MASTER") {
                //     isMaster = true;
                // }
                GeofenceUpload.geofenceUpload(formData, vm.geofencetype, function (response, headers) {
                    if (response.status == 200) {
                        vm.error = null;
                        vm.success = 'OK';

                        $timeout(function () {
                            vm.success = '';
                        }, 4000);


                    }
                    if (response.status == 400) {
                        vm.success = null;
                        vm.error = 'error';

                    }
                });
            } else {
                AlertService.error("Please select Geofence type.");
            }
        }
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle('buttonText', 'Browse File');


    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceDialogController', GeofenceDialogController);

    GeofenceDialogController.$inject = ['$timeout', '$scope', 'DEFAULT_LATITUDE', 'DEFAULT_LONGITUDE', '$stateParams', '$state', 'entity', 'Geofence', 'UserIDs', 'AssetIDs', 'AssetByID', 'AssetsForMap', 'Principal','BufferGeofencesByMiniID','MiniGeofencesByMasterID'];

    function GeofenceDialogController($timeout, $scope, DEFAULT_LATITUDE, DEFAULT_LONGITUDE, $stateParams, $state, entity, Geofence, UserIDs, AssetIDs, AssetByID, AssetsForMap, Principal,BufferGeofencesByMiniID,MiniGeofencesByMasterID) {
        var vm = this;
        var newFence = false;
        vm.geofence = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.assets = [];
        vm.ownedBy = [];
        vm.assetList = [];
        vm.navigateCreateAssetGeo = navigateCreateAssetGeo;
        loadPage();
        var marker;

        if (vm.geofence.id != null) {
            // if (vm.geofence.zone == true) {
            //     vm.geofenceType = "MASTER";
            // } else {
            //     vm.geofenceType = "MINI";
            // }
            vm.geofenceType = vm.geofence.geofenceType;
        }

        function loadPage() {
            vm.multiuser = [];
            //vm.multiassets = [];

            var selctedUsers = [];
            var selctedAssets = [];

            if (vm.geofence.id != null) {
                vm.geofence.ownedBy.forEach(function (user) {
                    selctedUsers.push(user.id);
                })

                vm.geofence.assets.forEach(function (asset) {
                    selctedAssets.push(asset.id);
                })
            } else {
                Principal.identity().then(function (identity) {
                    selctedUsers.push(identity.id);
                });
            }

            UserIDs.getAdminAll(function (response) {
                response.forEach(function (user) {
                    if (selctedUsers.indexOf(user.id) !== -1) {
                        var userExits = false;
                        vm.multiuser.forEach(function (userVal) {
                            if (userVal.login == user.login) {
                                userExits = true;
                            }
                        });
                        if (!userExits) {
                            vm.multiuser.push({ login: user.login, id: user.id, ticked: true });
                        }
                    } else {
                        var userExits = false;
                        vm.multiuser.forEach(function (userVal) {
                            if (userVal.login == user.login) {
                                userExits = true;
                            }
                        });
                        if (!userExits) {
                            vm.multiuser.push({ login: user.login, id: user.id, ticked: false });
                        }
                    }
                });
            });

            /*AssetsForMap.assetsformap(function(response) {
                vm.assetList = response;
            });*/

            /*AssetIDs.getAll(function(response) {
                response.forEach(function(asset) {
                    if (selctedAssets.indexOf(asset.id) !== -1) {
                        vm.multiassets.push({ name: asset.name, id: asset.id, ticked: true });
                    } else {
                        vm.multiassets.push({ name: asset.name, id: asset.id, ticked: false });
                    }
                });
            });*/

        }


        /*$scope.modernBrowsers = [
            { icon: "<img src=[..]/opera.png.. />",               name: "Opera",              maker: "(Opera Software)",        ticked: true  },
            { icon: "<img src=[..]/internet_explorer.png.. />",   name: "Internet Explorer",  maker: "(Microsoft)",             ticked: false },
            { icon: "<img src=[..]/firefox-icon.png.. />",        name: "Firefox",            maker: "(Mozilla Foundation)",    ticked: true  },
            { icon: "<img src=[..]/safari_browser.png.. />",      name: "Safari",             maker: "(Apple)",                 ticked: false },
            { icon: "<img src=[..]/chrome.png.. />",              name: "Chrome",             maker: "(Google)",                ticked: true  }
        ]; 
        */

        function drawFixedAsset(fixed, map) {
            $.each(fixed.assetCoordinates, function (index, value1) {

                var infoWindow = new google.maps.InfoWindow();
                var startMarker = new google.maps.Marker({
                    map: map,
                    position: new google.maps.LatLng(value1.latitude, value1.longitude),
                    title: fixed.name,
                    icon: {
                        // size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(20, 20),
                        origin: new google.maps.Point(0, 0),
                        // url : "data:image/png;base64," +
                        // fixed.assetType.image,
                        url: "data:image/png;base64," + vm.assetTypeMap[fixed.assetType.name],

                        anchor: new google.maps.Point(16, 16)
                    },
                });
                var infoWindow2 = new google.maps.InfoWindow();
                startMarker.content = '<div class="infoWindowContent"> <b>Description :</b> ' + fixed.description + '</div>';

                // on mouseout
                google.maps.event.addListener(startMarker, 'mouseout', function () {
                    infoWindow.close();
                });

                var activeInfoWindow;
                // add content to InfoWindow for click event
                infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);

                // add listener on InfoWindow for click event
                google.maps.event.addListener(startMarker, 'click', function () {

                    if (activeInfoWindow != null)
                        activeInfoWindow.close();
                    // Open InfoWindow - on click
                    infoWindow2.open(map, startMarker);
                    $(".userpath").click(function () {
                        var ele = document.getElementById("userPathModal");
                        $(ele).modal('show');
                        vm.drawUserPath($(this).attr('userid'));
                    });

                    // Store new open InfoWindow in global variable
                    activeInfoWindow = infoWindow2;
                });
                // function resizeMap(){
                setTimeout(function () {
                    google.maps.event.trigger(map, "resize");
                }, 100);
                // }
                // resizeAssetMap();

            });

        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }
        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title","Locate Me");
			locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon)
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
							infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");	
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function navigateCreateAssetGeo() {
            sessionStorage.setItem("prevPage", "geofence.new");
            $state.go('asset.new');
        }

        vm.createNewFence = function () {
            newFence = true;
            vm.geofence.coordinates = [];
            vm.createfence();
        }
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        vm.clearCoordinates = function () {
            newFence = false;
            vm.geofence.coordinates = [];
        }

        function save() {
            vm.isSaving = true;
            if (vm.geofenceType == "MASTER") {
                vm.geofence.zone = true;
            } else {
                vm.geofence.zone = false;
            }

            vm.geofence.geofenceType = vm.geofenceType;
            if (vm.geofence.id !== null) {
                Geofence.update(vm.geofence, onSaveSuccess, onSaveError);
            } else {
                Geofence.save(vm.geofence, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:geofenceUpdate', result);
            // $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.geofence = result;
            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == 'user-management.new') {
                $state.go('user-management.new');
            } else {
                $state.go('geofence');

            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        
vm.createfence = function () {
    if(vm.geofence.geofenceType=="MINI"){
    vm.getMiniGeofences();
   
    }else if(vm.geofence.geofenceType=="BUFFER"){
       
        vm.getBufferZones()
    }

    var coOrdinates = JSON.parse(entity.coordinates);
    if (vm.geofence.id !== null) {
        var map = new google.maps.Map(document.getElementById('map_canvas'),
        myOption(10,{ lat: coOrdinates[0].lat, lng: coOrdinates[0].lng } ) /* {
            // center: { lat: parseFloat(DEFAULT_LATITUDE.value), lng: parseFloat(DEFAULT_LONGITUDE.value) },
            center: { lat: coOrdinates[0].lat, lng: coOrdinates[0].lng },
            zoom: 12
        } */);
        geoLocation(map)
    } else {
        var map = new google.maps.Map(document.getElementById('map_canvas'),
        myOption(10,{ lat: parseFloat(DEFAULT_LATITUDE.value), lng: parseFloat(DEFAULT_LONGITUDE.value) }) /* {
            center: { lat: parseFloat(DEFAULT_LATITUDE.value), lng: parseFloat(DEFAULT_LONGITUDE.value) },
            // center: { lat: coOrdinates[0].lat, lng: coOrdinates[0].lng },
            zoom: 12
        } */);
        geoLocation(map)
    }
    // $.each(vm.assetList, function(index, value) {
    //     var assetCorRes = value.assetCoordinates;
    //     var assetCorVal = [];
    //     for (var i = 0; i < assetCorRes.length; i++) {
    //         assetCorVal.push({ lat: assetCorRes[i].latitude, lng: assetCorRes[i].longitude });;
    //     }
    //     drawPolylineForGeoFence(assetCorVal, map, value);
    // });

    var drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['polygon']
        },
        polygonOptions: {
            fillColor: '#00000',
            fillOpacity: 0.0,
            strokeWeight: 5,
            clickable: false,
            editable: true,
            zIndex: 1,
            geodesic: true
        }
    });

    google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
        attachPolygonListeners(polygon,map,entity.name);
        drawingManager.setOptions({ drawingControl: false });
        drawingManager.setMap(null);
        setGeofenceCoordinate(polygon);
    });
    drawingManager.setMap(map);

    if (entity.id && entity.id != null && !newFence) {
        drawPolygon(function (polygon) {
            polygon.setMap(map);
            attachPolygonListeners(polygon,map,entity.name);
            drawingManager.setOptions({ drawingControl: false });
            drawingManager.setMap(null);
        });
    }
    function attachPolygonListeners(polygon,map,name) {
        google.maps.event.addListener(polygon.getPath(), 'insert_at', function () {
            setGeofenceCoordinate(polygon);
        });
        google.maps.event.addListener(polygon.getPath(), 'set_at', function () {
            setGeofenceCoordinate(polygon);
        });
   
    }

    function setGeofenceCoordinate(polygon) {
        var coOrdinates = [];
        var path = polygon.getPath();

        for (var i = 0; i < path.getLength(); i++) {
            coOrdinates.push({ lat: path.getAt(i).lat(), lng: path.getAt(i).lng() });
            if (i === path.getLength() - 1) {
                $scope.$apply(function () {
                    vm.geofence.coordinates = JSON.stringify(coOrdinates);
                });
            }
        }
    }

    function drawPolygon(callback) {
        callback(new google.maps.Polygon({
            path: JSON.parse(entity.coordinates),
            strokeColor: "#fd7a24",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#fd7a24",
            fillOpacity: 0.3,
            editable: true
        }));
    }

    if (entity.id && entity.id != null) {
        vm.geofence.assets.forEach(function (value) {
            //Asset ID object contains light weight object , get detailsed object and plot details
            AssetByID.get(value.id, function (response) {
                 //response.forEach(function(user) {
                if (response.assetType.layout === 'FIXED') {
                    drawFixedAsset(response, map);
                } else if (response.assetType.layout === 'SPREAD') {
                    drawPolyline(response, map);
                }
            });
        });
    }

    function drawPolyline(spread, map) {
        var spreadAssetCoordinates = spread.assetCoordinates.map(function (coord) {
            return { lat: coord.latitude, lng: coord.longitude };
        });
        var midLatLng = {
            lat: spread.assetCoordinates[0].latitude,
            lng: spread.assetCoordinates[0].longitude
        };
        var infowindow = new google.maps.InfoWindow({
            content: '<div class="infoWindowhead">' + spread.name + '<div class="infoWindowContent"><b>Description :</b> ' + spread.description + '</div></div>'
        });
        infowindow.setPosition(midLatLng);
        // infowindow.open(locations.map);
        var polylinePath = new google.maps.Polyline({
            path: spreadAssetCoordinates,
            geodesic: true,
            strokeColor: spread.assetType.colorcode,
            strokeOpacity: 1.0,
            strokeWeight: 2.5,
            fillColor: spread.assetType.colorcode,
            fillOpacity: 0.3,
            editable: false
        });

        polylinePath.setMap(map);

        setTimeout(function () {
            google.maps.event.trigger(map, "resize");
            map.setCenter(midLatLng);
        }, 100);
    }
};

vm.getMiniGeofences = function () {
    var parentGeofenceId = entity.parentGeofence.map(function (parentID) {
        return parentID.id;
    });

    MiniGeofencesByMasterID.get(parentGeofenceId, function (response) {
        vm.miniGeofences = response;
        var firstItem = vm.miniGeofences[0];
        var firstCoordinates = JSON.parse(firstItem.coordinates);
        var map = new google.maps.Map(document.getElementById('map_canvas'), myOption(10, { lat: firstCoordinates[0].lat, lng: firstCoordinates[0].lng }));
        geoLocation(map)
        vm.miniGeofences.forEach(function (co_ordinates) {
            var paths = JSON.parse(co_ordinates.coordinates);
            var bounds = new google.maps.LatLngBounds();
            paths.forEach(function (point) {
                bounds.extend(point);
            });
            var center = bounds.getCenter();
        
            var tempPolygon = new google.maps.Polygon({
                paths: paths,
                strokeOpacity: 0.5,
                strokeColor: "#fd7a24",
                strokeWeight: 1.2,
                fillColor: "#fd7a24",
                fillOpacity: 0.1,
                zIndex: 1,
                editable: co_ordinates.id === vm.geofence.id
            });
        
            // Now, you can set the map center to the polygon's center
            map.setCenter(center); // Assuming 'map' is your Google Map instance 
            tempPolygon.setMap(map);
            attachPolygonListeners(tempPolygon,map,co_ordinates.name);
        });
    });
    
};

vm.getBufferZones=function(){
    var parentGeofenceId = entity.parentGeofence.map(function (parentID) {
        return parentID.id;
    });
    BufferGeofencesByMiniID.get(parentGeofenceId,function(bufferZone){
        vm.bufferZones=bufferZone
        var firstItem = vm.bufferZones[0];
        var firstCoordinates = JSON.parse(firstItem.coordinates);   
        var map = new google.maps.Map(document.getElementById('map_canvas'), myOption(10, { lat: firstCoordinates[0].lat, lng: firstCoordinates[0].lng }))
        geoLocation(map)
        vm.bufferZones.forEach(function (co_ordinates) {
            var paths = JSON.parse(co_ordinates.coordinates);
            var bounds = new google.maps.LatLngBounds();
            paths.forEach(function (point) {
                bounds.extend(point);
            });
            var center = bounds.getCenter();
            var tempPolygon = new google.maps.Polygon({
                paths: JSON.parse(co_ordinates.coordinates),
                strokeOpacity: 0.5,
                strokeColor: "#fd7a24",
                strokeWeight: 1.2,
                fillColor: "#fd7a24",
                fillOpacity: 0.1,
                zIndex: 1,
                editable: co_ordinates.id === vm.geofence.id
            });
            map.setCenter(center);
            tempPolygon.setMap(map);
            attachPolygonListeners(tempPolygon,map,co_ordinates.name);
        });
    })
}

function attachPolygonListeners(polygon,map,name) {
    google.maps.event.addListener(polygon.getPath(), 'insert_at', function () {
        setGeofenceCoordinate(polygon);
    });
    google.maps.event.addListener(polygon.getPath(), 'set_at', function () {
        setGeofenceCoordinate(polygon);
    });
   var infowindow=new google.maps.InfoWindow()
   
   google.maps.event.addListener(polygon,'click',function(event){
   var contentString='<div class="infoWindowhead"><b>'+name+'</b></div>'
    infowindow.setContent(contentString)
    infowindow.setPosition(event.latLng)
    infowindow.open(map)
   })
   google.maps.event.addListener(polygon,'mouseout',function(event){
    infowindow.close()
   })
}

function setGeofenceCoordinate(polygon) {
    var coOrdinates = [];
    var path = polygon.getPath();

    for (var i = 0; i < path.getLength(); i++) {
        coOrdinates.push({ lat: path.getAt(i).lat(), lng: path.getAt(i).lng() });
        if (i === path.getLength() - 1) {
            $scope.$apply(function () {
                vm.geofence.coordinates = JSON.stringify(coOrdinates);
            });
        }
    }
}
}

    function drawPolylineForGeoFence(latlngsToDraw, map, asset) {
        var spreadAssetCoordinates = [];
        $.each(latlngsToDraw, function (index, value) {

            spreadAssetCoordinates.push({
                lat: value.lat,
                lng: value.lng
            });
        });

        if (spreadAssetCoordinates.length > 0) {
            var midLatLng = {
                lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
                lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
            };
            var infowindow = new google.maps.InfoWindow({
                content: '<div class="infoWindowhead">' +
                    "name" +
                    '<div class="infoWindowContent"> <b>Description :</b> ' +
                    "des" + '</div></div>'
            });

            infowindow.setPosition(midLatLng);
            var polylineColor = '#000000';

            var spreadAttrValues = asset.assetTypeAttributeValues;
            spreadAttrValues.forEach(function (item, index) {
                if (item.name == "Fiber Status") {
                    if (item.attributeValue == "Planned") {
                        polylineColor = '#0000cc';
                    } else if (item.attributeValue == "On Air") {
                        polylineColor = '#00e658';
                    } else if (item.attributeValue == "Under Deployment") {
                        polylineColor = '#ff0000';
                    }
                }
            });

            var polylinepath = new google.maps.Polyline({
                path: spreadAssetCoordinates,
                geodesic: true,
                strokeColor: polylineColor,
                strokeWeight: 3
            });

            polylinepath.setOptions({
                strokeColor: polylineColor
            });

            google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
                infowindow.close();
            });

            google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
                infowindow.setContent('<div class="infoWindowhead">' +
                    '<b></b>' + asset.name + '</br></div>'
                );

                infowindow.mousemove;
                infowindow.open(map);
                infowindow.setPosition(event.latLng);
            });
            polylinepath.setMap(map);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceDetailController', GeofenceDetailController);

    GeofenceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Geofence', 'User'];

    function GeofenceDetailController($scope, $rootScope, $stateParams, previousState, entity, Geofence, User) {
        var vm = this;
        google.maps.Polygon.prototype.getBounds = function () {
            var bounds = new google.maps.LatLngBounds();
            var paths = this.getPaths();
            var path;
            for (var i = 0; i < paths.getLength(); i++) {
                path = paths.getAt(i);
                for (var ii = 0; ii < path.getLength(); ii++) {
                    bounds.extend(path.getAt(ii));
                }
            }
            return bounds;
        }
        vm.geofence = entity;
        vm.previousState = previousState.name;

        // if (vm.geofence.zone == true) {
        // 	vm.geofence.zone = "MASTER"
        // } else {
        // 	vm.geofence.zone = "MINI"
        // }


        var unsubscribe = $rootScope.$on('trakeyeApp:geofenceUpdate', function (event, result) {
            vm.geofence = result;
        });
        $scope.$on('$destroy', unsubscribe);

        drawmap(JSON.parse(entity.coordinates), function (latlng, geofence) {

            var myOptions = {
                zoom: 13,
                center: geofence.getBounds().getCenter(),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);

            geofence.setMap($scope.map);
        });

        function drawmap(path, callback) {
            try {

                callback(new google.maps.LatLng(path[0].lat, path[0].lng), new google.maps.Polygon({
                    paths: path,
                    strokeColor: '#fd7a24',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#fd7a24',
                    fillOpacity: 0.35
                }));
            } catch (err) { }

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceDeleteController',GeofenceDeleteController);

    GeofenceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Geofence'];

    function GeofenceDeleteController($uibModalInstance, entity, Geofence) {
        var vm = this;

        vm.geofence = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Geofence.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('geofence', {
                parent: 'entity',
                url: '/geofence?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'trakeyeApp.geofence.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/geofence/geofences.html',
                        controller: 'GeofenceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'modified_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('geofence');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('geofence-detail', {
                parent: 'entity',
                url: '/geofence/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'trakeyeApp.geofence.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/geofence/geofence-detail.html',
                        controller: 'GeofenceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('geofence');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Geofence', function($stateParams, Geofence) {
                        return Geofence.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'geofence',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

        .state('geofence.new', {
                parent: 'geofence',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_PLANNER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/geofence/geofence-dialog.html',
                        controller: 'GeofenceDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            name: null,
                            description: null,
                            coordinates: null,
                            createdDate: null,
                            modifiedDate: null,
                            id: null
                        };
                    }
                }

            })
            .state('geofence.edit', {
                parent: 'entity',
                url: '/geofence/edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_PLANNER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/geofence/geofence-dialog.html',
                        controller: 'GeofenceDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('geofence');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Geofence', function($stateParams, Geofence) {
                        return Geofence.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'geofence',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })


        .state('geofence.delete', {
            parent: 'geofence',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geofence/geofence-delete-dialog.html',
                    controller: 'GeofenceDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['Geofence', function(Geofence) {
                            return Geofence.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('geofence', null, { reload: 'geofence' });
                }, function() {
                    $state.go('^');
                });
            }]
        })




        .state('geofence.import', {
            parent: 'geofence',
            url: '/import',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_PLANNER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geofence/geofence-import.html',
                    controller: 'GeofenceImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function() {
                    return {
                        description: null,
                        createDate: null,
                        updateDate: null,
                        pinLat: null,
                        pinLong: null,
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        caseImages: []
                    };
                }
            }

        });
    }

})();
(function () {
    'use strict';
    angular.module('trakeyeApp').factory('Geofence', Geofence);

    Geofence.$inject = ['$resource', 'DateUtils'];

    function Geofence($resource, DateUtils) {
        var resourceUrl = 'api/geofences/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceByID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/geofences/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('MiniGeofencesByMasterID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/mini-geofences-by-master/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllMiniGeofencesByMasterID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/all-mini-geofences-by-master/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('MasterGeofencesByTenantID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/master-geofences-by-tenant/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('BufferGeofencesByMiniID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/buffer-geofences-by-mini/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceSearch', GeofenceSearch);

    GeofenceSearch.$inject = ['$resource'];

    function GeofenceSearch($resource) {
        var service = $resource('/api/geofences/searchvalue/:userId', {
            userId: '@id'
        }, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllGeofences', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/geofencesall').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UserMasterGeofences', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/user-geofences-by-type-master').then(function (response) {
                callback(response.data);
            });
        };

		service.getAllMasterGeofenceByUser = function (callback) {
            $http.get('api/user-geofences-by-type-master-user').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('GeofenceUpload', GeofenceUpload);

    GeofenceUpload.$inject = ['$http'];

    function GeofenceUpload($http) {

        var service = {};
        service.geofenceUpload = function (data, geoType, callback) {
            $http.post('api/geofencesimport/' + geoType, data, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {

                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/geofencelist').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceMasterMiniIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/master-mini-geofences').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('MasterGeofences', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/master-geofences').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllGeofenceIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/all-geofences').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UserGeofences', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/user-geofences-web').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceChildAssets', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/geofence-users/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceController', GeofenceController);

    GeofenceController.$inject = ['$scope', '$rootScope','$state', '$compile', 'DEFAULT_LATITUDE', 'DEFAULT_LONGITUDE', 'Geofence', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'GeofenceSearch', 'UserAccount', 'GeofenceIDs', 'UserGeofences', 'AssetGroupES', 'AssetByID', 'GeofenceChildAssets', 'Report', 'UserMasterGeofences', 'GeofenceByID', 'MiniGeofencesByMasterID', 'BufferGeofencesByMiniID','AssetLinkList'];

    function GeofenceController($scope, $rootScope, $state, $compile, DEFAULT_LATITUDE, DEFAULT_LONGITUDE, Geofence, ParseLinks, AlertService, pagingParams, paginationConstants, GeofenceSearch, UserAccount, GeofenceIDs, UserGeofences, AssetGroupES, AssetByID, GeofenceChildAssets, Report, UserMasterGeofences, GeofenceByID, MiniGeofencesByMasterID, BufferGeofencesByMiniID,AssetLinkList) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        vm.filterGeofenceSearchMap = filterGeofenceSearchMap;
        vm.filterAssetsOnGeofenveMapView = filterAssetsOnGeofenveMapView;
        vm.closeMapFilterModal = closeMapFilterModal;
        vm.saveGeofenceFilter = saveGeofenceFilter;
        vm.geofencesTable = geofencesTable;
        vm.downloadAttendenceReport = downloadAttendenceReport;
        vm.downloadAttendenceReportKml = downloadAttendenceReportKml;
        $scope.tab = 1;
        var locations = {};
        var latlng;

        var noDataText = null;
        var markers = [];
        var polylines = [];
        vm.userGeofences = [];
        vm.geofenceChildUsers = [];
        var openedInfoWindow = null;

        vm.userMasterGeofences = [];
        vm.previousPolygons = [];

        vm.selectGeofenceEntity = selectGeofenceEntity;
        vm.selectAllGeofences = selectAllGeofences;
        vm.isAllGeofencesSelected = false;
        vm.selectedGeofences = [];

        vm.gotoLatitute = gotoLatitute;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.showZoomLocation = showZoomLocation;
        var centerLatLng;
        vm.selectCityFilter= false;

        $scope.geofencelabel = {
            search          : "Search",
            nothingSelected : "Geofence"      
        }

        $scope.geofenceMap = function(){
            vm.selectedGeofenceId = vm.selectedGeofence[0].id
            saveGeofenceFilter()
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title","Locate Me");
			locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon)
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(
                goTo
            ); 

            goTo.addEventListener("click", function () {
                gotoLatitute()
            })

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");	
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        { enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0}
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(
                        false,
                        infoWindow,
                        map.getCenter()
                    );
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                /* if(vm.userGeofences.length > 0){
                    filterSearch();
                } */
                filterSearch();
            } else if ($scope.tab == 2) {
                vm.selectCityFilter = false
                var centerGeofence = new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value);
                locations.map = new google.maps.Map(document.getElementById("map_canvas1"), myOption(15,centerGeofence));
                geoLocation(locations.map)
                
                vm.userMasterGeofences = [];
                UserMasterGeofences.getAllMasterGeofenceByUser(function (response) {
                    vm.userMasterGeofences = response;
                });
                //filterGeofenceSearchMap();
                vm.mapAssets = [];
                //getGroupGeofenceAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
            }
        }

        if ($scope.tab == 1) {
            UserAccount.get(function (data) {
                vm.userId = data.id
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }
                });
                filterSearch();
                /* if (isAdmin) {
                    GeofenceIDs.getAll(function (response) {
                        response.forEach(function (geofence) {
                            if (geofence.name != 'Bangalore') {
                                vm.userGeofences.push(geofence);
                                if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                    vm.canFilter = true;
                                }
                            }
                        });
                    }); 
                    filterSearch();
                } else {
                    UserGeofences.getAll(function (response) {
                        response.forEach(function (geofence) {
                            if (geofence.name != 'Bangalore') {
                                vm.userGeofences.push(geofence);
                                if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                    vm.canFilter = true;
                                }
                            }
                        });
                    filterSearch();
                    });
                } */
            });
        }

        function filterGeofenceSearchMap() {
            var data = vm.geofences;
            drawResponseMap(data);
        }

        vm.sendAssetLinkRequest = function(geoId,geoName){
            $('#mappingFixed').show()
            vm.geoName = geoName
            vm.geoId = geoId
        }

        vm.postRequest = function (){
            AssetLinkList.post({
                "entityName": "Assets",
                "entityLayout": "SPREAD",
                "reqByUserId": vm.userId,
                "messageType": "ADD",
                "messageStatus": "OPEN",
                "geofences": [
                    {
                        "id": vm.geoId
                    }
                ] 
            }, function (response) {
                vm.success = response.status == 200 ? "success" : ""
                if (vm.success) {
                    $rootScope.highlightAssetLink = true
                    vm.mappingFixed()
                    setTimeout(function () {
                        vm.success = "";
                        $scope.$apply()
                    }, 5000);
                }else{
                    $rootScope.highlightAssetLink = false
                }
            })
        }

        vm.mappingFixed= function(){
            $("#mappingFixed").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mappingFixed").hide();
        }
        function drawResponseMap(data) {
            //var myOptions = null;
            var centerGeofence
            data.forEach(function (assets) {
                JSON.parse(assets.coordinates).forEach(function (value, key) {
                    var lat = value.lat.toString();
                    var long = value.lng.toString();
                    centerGeofence = new google.maps.LatLng(lat, long)
                    /* myOptions = {
                        zoom: 15,
                        center: new google.maps.LatLng(lat, long),
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    }; */
                });
            });
            if ($scope.tab == 2) {
                locations.map = new google.maps.Map(document.getElementById("map_canvas1"), myOption(15,centerGeofence));
                geoLocation(locations.map)

                
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () { };
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById('map_canvas1');
                
                // drawLatestGeofence(data);
                // Geofence.query({
                //     page: 0,
                //     size: 100000,
                // }, onSuccessPolygon, onErrorPolygon);

                // function onSuccessPolygon(data, headers) {
                //     vm.geofencesPolygon = [];
                //     data.forEach(function (value) {
                //         if (value.zone) {
                //             value.type = "MASTER";
                //         } else {
                //             value.type = "MINI";
                //         }
                //         vm.geofencesPolygon.push(value);
                //     });
                //     drawLatestGeofence(vm.geofencesPolygon);
                // }

                // function onErrorPolygon(error) {  
                //     // AlertService.error(error.data.message);
                // }
            }
        }

        function selectAllGeofences() {
            var toggleStatus = vm.isAllGeofencesSelected;
            if (toggleStatus) {
                vm.canDownload = true;
                vm.selectedGeofences = [];
                vm.geofences.forEach(function (geofence) {
                    vm.selectedGeofences.push(geofence.id);
                });
            } else {
                vm.canDownload = false;
                vm.selectedGeofences = [];
            }
            angular.forEach(vm.geofences, function (item) { item.isChecked = toggleStatus; });
        }

        function selectGeofenceEntity(geofence) {
            if (geofence.id != null) {
                if (geofence.isChecked) {
                    vm.canDownload = true;
                    vm.selectedGeofences.push(geofence.id);
                } else {
                    var index = vm.selectedGeofences.indexOf(geofence.id);
                    if (index > -1) {
                        vm.selectedGeofences.splice(index, 1);
                    }
                }
                if (vm.selectedGeofences.length == 0) {
                    vm.canDownload = false;
                    // getAssetsForListView();
                } else {
                    vm.canDownload = true;
                }
            }
        };

        function downloadAttendenceReport() {
			Report.downloadGeofenceDump({
				ids: vm.selectedGeofences
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "geofence.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function downloadAttendenceReportKml() {
			Report.downloadGeofenceDumpKml({
				ids: vm.selectedGeofences
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/text' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "geofence.kml";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

        function drawLatestGeofence(response) {
            if (response) {
                initializeGeofenceMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // function() {
                    $.each(response, function (index, value) {

                        try {
                            if (value.type == "MASTER") {
                                drawPolygon(value, latlang, "#fd7a24", 1);
                            }

                        } catch (err) {
                            console.log(err);
                        }
                    });
                    $.each(response, function (index, value) {

                        try {
                            if (value.type == "MINI") {
                                drawPolygon(value, latlang, "#fd7a24", 2);
                            }

                        } catch (err) {
                            console.log(err);
                        }
                    });
                    $.each(response, function (index, value) {

                        try {
                            if (value.type == "BUFFER") {
                                drawPolygon(value, latlang,"#fd7a24", 3);
                            }

                        } catch (err) {
                            console.log(err);
                        }
                    });
                });
            }
        }

        function drawPolygon(value, latlang, color, zIndex) {
            var path = JSON.parse(value.coordinates);
            // drawPolylineForGeoFence(path, locations.map, value.name);
            var infowindow = new google.maps.InfoWindow(
                {
                    content: '<div class="infoWindowhead">'
                        + "name"
                        + '<div class="infoWindowContent"> <b>Description :</b> '
                        + "des" + '</div></div>'
                });

            infowindow.setPosition(latlang);
            var strokeColor = "#ff6a08";

            if(color == "green"){
                strokeColor = "#00e658";
            } else if (color == "blue") {
                strokeColor = "#0066CC";
            }
            
            var tempPolygon = new google.maps.Polygon({
                paths: path,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 1.2,
                fillColor: strokeColor,
                fillOpacity: 0.1,
                zIndex: zIndex
            });
            google.maps.event.addListener(tempPolygon, 'mouseout', function (event) {
                infowindow.close();
            });

            google.maps.event.addListener(tempPolygon, 'click', function (event) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }
                infowindow.setContent('<div class="infoWindowhead">'
                    + '<b>Geofence Name : </b><br><br>' + value.name + '</br></div>'
                );

                infowindow.mousemove;
                infowindow.open(locations.map);
                infowindow.setPosition(event.latLng);
                openedInfoWindow = infowindow;
            });
            tempPolygon.setMap(locations.map);
            return tempPolygon
        }

        function GetCenterFromDegrees(data) {
            if (!(data.length > 0)) {
                return false;
            }

            var num_coords = data.length;

            var X = 0.0;
            var Y = 0.0;
            var Z = 0.0;

            for (var i = 0; i < data.length; i++) {
                var lat = (data[i].lat * Math.PI) / 180;
                var lon = (data[i].lng * Math.PI) / 180;

                var a = Math.cos(lat) * Math.cos(lon);
                var b = Math.cos(lat) * Math.sin(lon);
                var c = Math.sin(lat);

                X += a;
                Y += b;
                Z += c;
            }

            X /= num_coords;
            Y /= num_coords;
            Z /= num_coords;

            var lon = Math.atan2(Y, X);
            var hyp = Math.sqrt(X * X + Y * Y);
            var lat = Math.atan2(Z, hyp);

            var newX = (lat * 180) / Math.PI;
            var newY = (lon * 180) / Math.PI;

            centerLatLng = ({
                lat: newX,
                lng: newY
            });

            return centerLatLng
        }

        $('#masterGeofence').on('change', function() {
            vm.selectCityFilter = true;
            var value = $(this).val();
            if(value != ""){
            GeofenceByID.get(value, function (geofenceDetails) {
                var points = JSON.parse(geofenceDetails.coordinates);
                GetCenterFromDegrees(points)
                locations.latlng = {lat:points[0].lat, lng:points[0].lng};
                /* var myOptions = {
                    zoom: 10,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                }; */

                locations.map = new google.maps.Map(document
                    .getElementById("map_canvas1"), myOption(10,locations.latlng));
                geoLocation(locations.map)   
                drawPolygon(geofenceDetails, locations.latlng, "red", 1);
                MiniGeofencesByMasterID.get(geofenceDetails.id, function (response) {
                    vm.userGeofences = [];
                    response.forEach(function(value){
                        vm.previousPolygons.push(drawPolygon(value, locations.latlng, "red", 2));
                        value.label = value.name.substring(0, 15) + "..";
                        vm.userGeofences.push(value);
                    });
                });
                locations.map.setCenter(centerLatLng)
            });
            }
        });

        function drawPolylineForGeoFence(latlngsToDraw, map, details) {
            var spreadAssetCoordinates = [];
            $.each(latlngsToDraw, function (index, value) {

                spreadAssetCoordinates.push({
                    lat: value.lat,
                    lng: value.lng
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var midLatLng = {
                    lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
                    lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
                };
                var infowindow = new google.maps.InfoWindow(
                    {
                        content: '<div class="infoWindowhead">'
                            + "name"
                            + '<div class="infoWindowContent"> <b>Description :</b> '
                            + "des" + '</div></div>'
                    });

                infowindow.setPosition(midLatLng);
                var ColorValue = '#68A8DE';
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 0.8,
                    strokeWeight: 3
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue
                });

                google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
                    infowindow.close();
                });

                google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent('<div class="infoWindowhead">'
                        + '<b></b>' + details + '</br></div>'
                    );

                    infowindow.mousemove;
                    infowindow.open(map);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                });
                polylinepath.setMap(map);
            }
        }

        function initializeGeofenceMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(latlangs[0].pinLat, latlangs[0].pinLong);
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {

                        latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        callback(latlng);
                    }, function () {

                        callback(new google.maps.LatLng("5.431587", "101.128162"));
                    });
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        function geofencesTable(geo) {
            vm.geofences.forEach(function (item) {
                item.isExpanded = false;
            })
            if (vm.toggle == geo.id) {
                vm.toggle = undefined
            } else {
                geo.isExpanded = true;
                vm.toggle = geo.id;
            }
            GeofenceChildAssets.get(geo.id, function (response) {
                vm.geofenceChildUsers = response;
            });
        }



        function filterSearch() {
            if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
                var str = $scope.search+"";
                    str = str.replace('/', 'slash');
                GeofenceSearch.query({
                    userId: str,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);

                function sort() {
                    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                    if (vm.predicate !== 'id') {
                        //  result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.geofences = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.geofences.push(value);
                    });
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            Geofence.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.geofences = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.geofences.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        var gotoMarker = null;
        
        var input = document.getElementById('field_pinLat');
            input.addEventListener('input', function() {
            this.value = this.value.replace(/[^-0-9\,\.]/, '');
            });
        function showZoomLocation() {
            var latlng = vm.getLocationCoordinate.split(",");
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinate != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };
                locations.map.setCenter(assetCenterLatLng);
                locations.map.setZoom(18);
                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: assetCenterLatLng,
                });

                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }
        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function closeGotoLatitute() {
            $("#modalLatLongs").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalLatLongs").hide();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search
            });
        }

        function filterAssetsOnGeofenveMapView() {
            $("#mapFilterGeofenceModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.marginLeft = "25px";
            vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
        }

        function closeMapFilterModal() {
            $("#mapFilterGeofenceModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterGeofenceModal").hide();
            vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
        }

        function saveGeofenceFilter() {
            vm.mapAssets = [];
            //getGroupGeofenceAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
            vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
            vm.previousPolygons.forEach(function(polygon){
                polygon.setMap(null);
            });
            vm.userGeofences.forEach(function(value){
                if(value.id == vm.selectedGeofenceId){
                    vm.previousPolygons.push(drawPolygon(value, locations.latlng, "green", 2));
                } else {
                    vm.previousPolygons.push(drawPolygon(value, locations.latlng, "red", 2));
                }
            });
           
            BufferGeofencesByMiniID.get(vm.selectedGeofenceId, function (response) {
                response.forEach(function(value){
                    vm.previousPolygons.push(drawPolygon(value, locations.latlng, "blue", 3));
                });
            });
            $("#mapFilterGeofenceModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterGeofenceModal").hide();
        }

        /* function getGroupGeofenceAssetsFromES(geofenceIdVal, lastAssetId, mapAssetLists) {
            AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;

                    vm.mapAssets.push(tmpAsset);
                });
                drawLatestAssetsOnMap(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupGeofenceAssetsFromES(geofenceIdVal, data.lastId, vm.mapAssets);
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = ({
                                lat: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].latitude,
                                lng: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].longitude
                            });
                            locations.map.setCenter(assetLatLng);
                        });
                    }
                }
                // filterGeofenceSearchMap();
            });
        } */

       /*  function drawLatestAssetsOnMap(response) {
            if (response) {
                initializeGeofenceAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath = value.assetType.imagePath;
                            }
                            if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
                                if (value.assetCoordinates.length > 1) {
                                    drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

                                    drawFixedGeofenceAsset(value1, false);

                                } else {
                                    drawFixedGeofenceAsset(value, false);
                                }
                            }
                            if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
                                drawPolyline(value, locations.map);
                            }

                        });
                    });
                });
            }
        } */

        /* function initializeGeofenceAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal = value.assetCoordinates[value.assetCoordinates.length - 1].latitude;
                            lngVal = value.assetCoordinates[value.assetCoordinates.length - 1].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (
                        position) {

                        latlng = new google.maps.LatLng(
                            position.coords.latitude,
                            position.coords.longitude);
                        callback(latlng);
                    }, function () {

                        // callback(new google.maps.LatLng("12.9716", "77.5946"));
                        callback(new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value));
                    });
                } else {
                    callback(new google.maps.LatLng(DEFAULT_LATITUDE.value, DEFAULT_LONGITUDE.value));
                }
            }
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                var myOptions = {
                    zoom: 14,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                locations.map = new google.maps.Map(document
                    .getElementById("map_canvas"), myOptions);

                // google.maps.event.addListener(locations.map, 'zoom_changed', function () {
                //     vm.zoomLevel = locations.map.getZoom();
                //     if ((vm.prevZoomLevel == 17 && vm.zoomLevel == 18) || (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)) {
                //         drawLatestAssetsOnMap(vm.mapAssets);
                //     }
                //     vm.prevZoomLevel = vm.zoomLevel;

                // });
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () { };
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById('map_canvas');
            callback();
        }

        function drawPolyline(spread, map) {
            var spreadAssetCoordinates = [];
            $.each(spread.assetCoordinates, function (index, value) {

                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
                    lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
                };

                var polylineColor = '#FFFFFF';
                var distanceFromPOP = '';
                var fiberCoreVal = '';
                var infowindow = new google.maps.InfoWindow();
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spread.assetTypeColor
                }
                var polylineWeight = 2.5;
                var strokeOpacityVal = 1.0;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false
                });

                google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
                    infowindow.close();
                });

                google.maps.event.addListener(polylinepath, 'click', function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent('<div class="infoWindowhead">'
                        + '<b>Asset Name : </b><br><br>' + spread.name + '</br></div>'
                    );

                    infowindow.mousemove;
                    infowindow.open(locations.map);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                });

                polylinepath.setMap(locations.map);
                polylines.push(polylinepath);
            }
        }

        function drawFixedGeofenceAsset(fixed, hasParent) {

            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infowindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(
                            iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2, iconSize / 2),
                    },
                });
                google.maps.event.addListener(startMarker, 'mouseout', function (event) {
                    infowindow.close();
                });

                google.maps.event.addListener(startMarker, 'click', function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent('<div class="infoWindowhead">'
                        + '<b>Asset Name : </b><br><br>' + fixed.name + '</br></div>'
                    );

                    infowindow.mousemove;
                    infowindow.open(locations.map);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                });
                markers.push(startMarker);

                openedInfoWindow = infowindow;
            });
        } */
    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDialogController', FeasibilityCheckDialogController);

    FeasibilityCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FeasibilityCheck'];

    function FeasibilityCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FeasibilityCheck) {
        var vm = this;
        $scope.EMAIL_REGEXP = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
		$scope.PHONE_REGEXP = /^[0-9]+$/;
        vm.feasibilityCheck = entity;
        vm.clear = clear;
        vm.save = save;
        vm.feasibilityCheck.notificationType = "SMS";
       // vm.users = User.query();
       // vm.tenants = Tenant.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.feasibilityCheck.id !== null) {
                FeasibilityCheck.update(vm.feasibilityCheck, onSaveSuccess, onSaveError);
            } else {
                FeasibilityCheck.save(vm.feasibilityCheck, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:feasibilityCheckUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDetailController', FeasibilityCheckDetailController);

    FeasibilityCheckDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FeasibilityCheck', 'User', 'Tenant'];

    function FeasibilityCheckDetailController($scope, $rootScope, $stateParams, previousState, entity, FeasibilityCheck, User, Tenant) {
        var vm = this;

        vm.feasibilityCheck = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:feasibilityCheckUpdate', function(event, result) {
            vm.feasibilityCheck = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDeleteController',FeasibilityCheckDeleteController);

    FeasibilityCheckDeleteController.$inject = ['$uibModalInstance', 'entity', 'FeasibilityCheck'];

    function FeasibilityCheckDeleteController($uibModalInstance, entity, FeasibilityCheck) {
        var vm = this;

        vm.feasibilityCheck = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FeasibilityCheck.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('feasibility-check', {
            parent: 'entity',
            url: '/feasibility-check?page&sort&search',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.feasibilityCheck.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feasibility-check/feasibility-checks.html',
                    controller: 'FeasibilityCheckController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                		value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityCheck');
                    $translatePartialLoader.addPart('alertType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('feasibility-check-detail', {
            parent: 'feasibility-check',
            url: '/feasibility-check/{id}',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.feasibilityCheck.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-detail.html',
                    controller: 'FeasibilityCheckDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityCheck');
                    $translatePartialLoader.addPart('alertType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FeasibilityCheck', function($stateParams, FeasibilityCheck) {
                    return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'feasibility-check',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('feasibility-check-detail.edit', {
            parent: 'feasibility-check-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('feasibility-check.new', {
            parent: 'feasibility-check',
            url: '/new',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                requestId: null,
                                customerName: null,
                                phone: null,
                                email: null,
                                createDate: null,
                                updateDate: null,
                                notes: null,
                                latitude: null,
                                longitude: null,
                                address: null,
                                notificationType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('feasibility-check');
                });
            }]
        })
        .state('feasibility-check.edit', {
            parent: 'feasibility-check',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('feasibility-check.delete', {
            parent: 'feasibility-check',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-delete-dialog.html',
                    controller: 'FeasibilityCheckDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('FeasibilityCheck', FeasibilityCheck);

    FeasibilityCheck.$inject = ['$resource'];

    function FeasibilityCheck ($resource) {
        var resourceUrl =  'api/feasibility-checks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();



(function() {
	'use strict';

	angular.module('trakeyeApp').factory('FeasibilityCheckSearch', FeasibilityCheckSearch);

	FeasibilityCheckSearch.$inject = [ '$resource' ];

	function FeasibilityCheckSearch($resource) {
		var service = $resource('api/feasibility-checks/search/:searchText', {
			searchText : '@searchText'
		}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();





(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckController', FeasibilityCheckController);

    FeasibilityCheckController.$inject = ['$state', '$scope','FeasibilityCheck', 'FeasibilityCheckSearch','ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FeasibilityCheckController($state, $scope,FeasibilityCheck, FeasibilityCheckSearch,ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;
        $scope.search = pagingParams.search;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        loadAll();

        function loadAll () {
            FeasibilityCheck.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.feasibilityChecks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function filterSearch () {
        	if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
        		FeasibilityCheckSearch.query({
            	 	searchText : $scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.feasibilityChecks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
            
        	}else{
        		loadAll ();
            }
        	
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search,
            });
        }
    }
})();

(function() {
    'use strict';

    
    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkOrderTypeAttributeDialogController",
            CustomWorkOrderTypeAttributeDialogController
        );

    CustomWorkOrderTypeAttributeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "$stateParams",
        "entity",
        "CustomWorkOrderTypeAttribute",
    ];

    function CustomWorkOrderTypeAttributeDialogController(
        $timeout,
        $scope,
        $state,
        $stateParams,
        entity,
        CustomWorkOrderTypeAttribute
    ) {
        var vm = this;

        vm.customWorkOrderTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.customworkordertypeattributevalues = CustomWorkOrderTypeAttributeValue.query();

        vm.items = [
            {
                value: "",
            },
        ];

        if (
            vm.customWorkOrderTypeAttribute
                .customWorkOrderTypeAttributeValues != null &&
            vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues
                .length != 0
        ) {
            vm.items =
                vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues;
        }
        vm.addmore = function () {
            vm.items.push({
                value: "",
            });
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
        };

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.customWorkOrderTypeAttribute.id !== null) {
                vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues =
                    [];
                for (var i = 0; i < vm.items.length; i++) {
                    vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues.push(
                        {
                            id: vm.items[i].id,
                            value: vm.items[i].value,
                        }
                    );
                }
                CustomWorkOrderTypeAttribute.update(
                    vm.customWorkOrderTypeAttribute,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues =
                    [];

                for (var i = 0; i < vm.items.length; i++) {
                    vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues.push(
                        {
                            id: vm.items[i].id,
                            value: vm.items[i].value,
                        }
                    );
                }

                CustomWorkOrderTypeAttribute.save(
                    vm.customWorkOrderTypeAttribute,
                    onSaveSuccess,
                    onSaveError
                );
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit(
                "trakeyeApp:customWorkOrderTypeAttributeUpdate",
                result
            );
            // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go("custom-workorder-type-attribute");
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkOrderTypeAttributeDetailController",
            CustomWorkOrderTypeAttributeDetailController
        );

    CustomWorkOrderTypeAttributeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "CustomWorkOrderTypeAttribute",
    ];

    function CustomWorkOrderTypeAttributeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        CustomWorkOrderTypeAttribute
    ) {
        var vm = this;

        vm.customWorkOrderTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:customWorkOrderTypeAttributeUpdate",
            function (event, result) {
                vm.customWorkOrderTypeAttribute = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkOrderTypeAttributeDeleteController",
            CustomWorkOrderTypeAttributeDeleteController
        );

    CustomWorkOrderTypeAttributeDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "CustomWorkOrderTypeAttribute",
    ];

    function CustomWorkOrderTypeAttributeDeleteController(
        $uibModalInstance,
        entity,
        CustomWorkOrderTypeAttribute
    ) {
        var vm = this;

        vm.customWorkOrderTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            CustomWorkOrderTypeAttribute.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("custom-workorder-type-attribute", {
                parent: "entity",
                url: "/custom-workorder-type-attribute?page&sort&search",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle:
                        "trakeyeApp.customWorkOrderTypeAttribute.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/custom-workorder-type-attribute/custom-workorder-type-attributes.html",
                        controller: "CustomWorkOrderTypeAttributeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart(
                                "customWorkOrderTypeAttribute"
                            );
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("custom-workorder-type-attribute-detail", {
                parent: "custom-workorder-type-attribute",
                url: "/custom-workorder-type-attribute/{id}",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle:
                        "trakeyeApp.customWorkOrderTypeAttribute.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-detail.html",
                        controller:
                            "CustomWorkOrderTypeAttributeDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart(
                                "customWorkOrderTypeAttribute"
                            );
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "CustomWorkOrderTypeAttribute",
                        function ($stateParams, CustomWorkOrderTypeAttribute) {
                            return CustomWorkOrderTypeAttribute.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "custom-workorder-type-attribute",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("custom-workorder-type-attribute.new", {
                parent: "custom-workorder-type-attribute",
                url: "/new",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-dialog.html",
                        controller:
                            "CustomWorkOrderTypeAttributeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            description: null,
                            id: null,
                        };
                    },
                },
            })

            .state("custom-workorder-type-attribute.edit", {
                parent: "custom-workorder-type-attribute",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle:
                        "trakeyeApp.customWorkOrderTypeAttribute.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-dialog.html",
                        controller:
                            "CustomWorkOrderTypeAttributeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart(
                                "customWorkOrderTypeAttribute"
                            );
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "CustomWorkOrderTypeAttribute",
                        function ($stateParams, CustomWorkOrderTypeAttribute) {
                            return CustomWorkOrderTypeAttribute.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "custom-workorder-type-attribute",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("custom-workorder-type-attribute.delete", {
                parent: "custom-workorder-type-attribute",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-delete-dialog.html",
                                controller:
                                    "CustomWorkOrderTypeAttributeDeleteController",
                                controllerAs: "vm",
                                size: "md",
                                resolve: {
                                    entity: [
                                        "CustomWorkOrderTypeAttribute",
                                        function (
                                            CustomWorkOrderTypeAttribute
                                        ) {
                                            return CustomWorkOrderTypeAttribute.get(
                                                { id: $stateParams.id }
                                            ).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go(
                                        "custom-workorder-type-attribute",
                                        null,
                                        {
                                            reload: "custom-workorder-type-attribute",
                                        }
                                    );
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("CustomWorkOrderTypeAttribute", CustomWorkOrderTypeAttribute);

    CustomWorkOrderTypeAttribute.$inject = ["$resource"];

    function CustomWorkOrderTypeAttribute($resource) {
        var resourceUrl = "api/custom-workorder-type-attributes/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkOrderTypeAttributeController",
            CustomWorkOrderTypeAttributeController
        );

    CustomWorkOrderTypeAttributeController.$inject = [
        "$state",
        "CustomWorkOrderTypeAttribute",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
    ];

    function CustomWorkOrderTypeAttributeController(
        $state,
        CustomWorkOrderTypeAttribute,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomWorkOrderTypeAttribute.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.customWorkOrderTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomWorkFlowTypeAttributeDialogController', CustomWorkFlowTypeAttributeDialogController);

    CustomWorkFlowTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomWorkFlowTypeAttribute'];

    function CustomWorkFlowTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomWorkFlowTypeAttribute) {
        var vm = this;

        vm.customWorkFlowTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customworkflowtypeattributevalues = CustomWorkFlowTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues != null && vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.length != 0) {
			vm.items = vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customWorkFlowTypeAttribute.id !== null) {
            	
            	 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomWorkFlowTypeAttribute.update(vm.customWorkFlowTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomWorkFlowTypeAttribute.save(vm.customWorkFlowTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customWorkFlowTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-work-flow-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkFlowTypeAttributeDetailController",
            CustomWorkFlowTypeAttributeDetailController
        );

    CustomWorkFlowTypeAttributeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "CustomWorkFlowTypeAttribute",
        "User",
        "Tenant"
    ];

    function CustomWorkFlowTypeAttributeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        CustomWorkFlowTypeAttribute,
        User,
        Tenant
    ) {
        var vm = this;

        vm.customWorkFlowTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:customWorkFlowTypeAttributeUpdate",
            function (event, result) {
                vm.customWorkFlowTypeAttribute = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkFlowTypeAttributeDeleteController",
            CustomWorkFlowTypeAttributeDeleteController
        );

    CustomWorkFlowTypeAttributeDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "CustomWorkFlowTypeAttribute",
    ];

    function CustomWorkFlowTypeAttributeDeleteController(
        $uibModalInstance,
        entity,
        CustomWorkFlowTypeAttribute
    ) {
        var vm = this;

        vm.customWorkFlowTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            CustomWorkFlowTypeAttribute.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-work-flow-type-attribute', {
            parent: 'entity',
            url: '/custom-work-flow-type-attribute?page&sort&search',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                pageTitle: 'trakeyeApp.customWorkFlowTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attributes.html',
                    controller: 'CustomWorkFlowTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-work-flow-type-attribute-detail', {
            parent: 'custom-work-flow-type-attribute',
            url: '/custom-work-flow-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                pageTitle: 'trakeyeApp.customWorkFlowTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-detail.html',
                    controller: 'CustomWorkFlowTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomWorkFlowTypeAttribute', function($stateParams, CustomWorkFlowTypeAttribute) {
                    return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-work-flow-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })

        .state('custom-work-flow-type-attribute.new', {
            parent: 'custom-work-flow-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
            }
        })
        .state('custom-work-flow-type-attribute.edit', {
            parent: 'custom-work-flow-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomWorkFlowTypeAttribute', function($stateParams, CustomWorkFlowTypeAttribute) {
                    return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-work-flow-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-work-flow-type-attribute.delete', {
            parent: 'custom-work-flow-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-delete-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomWorkFlowTypeAttribute', function(CustomWorkFlowTypeAttribute) {
                            return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-work-flow-type-attribute', null, { reload: 'custom-work-flow-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("CustomWorkFlowTypeAttribute", CustomWorkFlowTypeAttribute);

    CustomWorkFlowTypeAttribute.$inject = ["$resource"];

    function CustomWorkFlowTypeAttribute($resource) {
        var resourceUrl = "api/custom-workflow-type-attributes/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllCustomWorkFlowTypeAttribute", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/custom-workflow-type-attributes")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkFlowTypeAttributeController",
            CustomWorkFlowTypeAttributeController
        );

    CustomWorkFlowTypeAttributeController.$inject = [
        "$state",
        "CustomWorkFlowTypeAttribute",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
    ];

    function CustomWorkFlowTypeAttributeController(
        $state,
        CustomWorkFlowTypeAttribute,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomWorkFlowTypeAttribute.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            function onSuccess(data, headers) {
                // vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.customWorkFlowTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeDialogController', CustomServiceTypeAttributeDialogController);

    CustomServiceTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams',  'entity', 'CustomServiceTypeAttribute'];

    function CustomServiceTypeAttributeDialogController ($timeout, $scope, $state, $stateParams,  entity, CustomServiceTypeAttribute) {
        var vm = this;

        vm.customServiceTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       
        
       // vm.customservicetypeattributevalues = CustomServiceTypeAttributeValue.query();

        
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customServiceTypeAttribute.customServiceTypeAttributeValues != null && vm.customServiceTypeAttribute.customServiceTypeAttributeValues.length != 0) {
			vm.items = vm.customServiceTypeAttribute.customServiceTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};
        
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customServiceTypeAttribute.id !== null) {
            	 vm.customServiceTypeAttribute.customServiceTypeAttributeValues = [];
 				for (var i = 0; i < vm.items.length; i++) {
 					vm.customServiceTypeAttribute.customServiceTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
                CustomServiceTypeAttribute.update(vm.customServiceTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	vm.customServiceTypeAttribute.customServiceTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					vm.customServiceTypeAttribute.customServiceTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
            	
                CustomServiceTypeAttribute.save(vm.customServiceTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customServiceTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-service-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeDetailController', CustomServiceTypeAttributeDetailController);

    CustomServiceTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomServiceTypeAttribute'];

    function CustomServiceTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomServiceTypeAttribute) {
        var vm = this;

        vm.customServiceTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customServiceTypeAttributeUpdate', function(event, result) {
            vm.customServiceTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeDeleteController',CustomServiceTypeAttributeDeleteController);

    CustomServiceTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomServiceTypeAttribute'];

    function CustomServiceTypeAttributeDeleteController($uibModalInstance, entity, CustomServiceTypeAttribute) {
        var vm = this;

        vm.customServiceTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomServiceTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-service-type-attribute', {
            parent: 'entity',
            url: '/custom-service-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customServiceTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attributes.html',
                    controller: 'CustomServiceTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customServiceTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-service-type-attribute-detail', {
            parent: 'custom-service-type-attribute',
            url: '/custom-service-type-attribute/{id}',
            data: {
                authorities:  [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customServiceTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-detail.html',
                    controller: 'CustomServiceTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customServiceTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomServiceTypeAttribute', function($stateParams, CustomServiceTypeAttribute) {
                    return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-service-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-service-type-attribute-detail.edit', {
            parent: 'custom-service-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       /* .state('custom-service-type-attribute.new', {
            parent: 'custom-service-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('custom-service-type-attribute');
                });
            }]
        })*/
        
        .state('custom-service-type-attribute.new', {
			parent : 'custom-service-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					 templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
	                    controller: 'CustomServiceTypeAttributeDialogController',
	                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-service-type-attribute.edit', {
            parent: 'custom-service-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-service-type-attribute.edit', {
			parent : 'custom-service-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customServiceTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customServiceTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomServiceTypeAttribute', function($stateParams, CustomServiceTypeAttribute) {
					return CustomServiceTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-service-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-service-type-attribute.delete', {
            parent: 'custom-service-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-delete-dialog.html',
                    controller: 'CustomServiceTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomServiceTypeAttribute', CustomServiceTypeAttribute);

    CustomServiceTypeAttribute.$inject = ['$resource'];

    function CustomServiceTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-service-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeController', CustomServiceTypeAttributeController);

    CustomServiceTypeAttributeController.$inject = ['$state', 'CustomServiceTypeAttribute', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomServiceTypeAttributeController($state, CustomServiceTypeAttribute, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CustomServiceTypeAttribute.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customServiceTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDialogController', CustomGroupTypeAttributeDialogController);

    CustomGroupTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDialogController ($timeout, $scope, $state, $stateParams, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
        //vm.customgrouptypeattributevalues = CustomGroupTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customGroupTypeAttribute.customGroupTypeAttributeValues != null && vm.customGroupTypeAttribute.customGroupTypeAttributeValues.length != 0) {
			vm.items = vm.customGroupTypeAttribute.customGroupTypeAttributeValues;
		}
        
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
           // $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customGroupTypeAttribute.id !== null) {
            	
            	 vm.customGroupTypeAttribute.customGroupTypeAttributeValues = [];
 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customGroupTypeAttribute.customGroupTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
            	
                CustomGroupTypeAttribute.update(vm.customGroupTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customGroupTypeAttribute.customGroupTypeAttributeValues = [];

 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customGroupTypeAttribute.customGroupTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
                CustomGroupTypeAttribute.save(vm.customGroupTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customGroupTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-group-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDetailController', CustomGroupTypeAttributeDetailController);

    CustomGroupTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customGroupTypeAttributeUpdate', function(event, result) {
            vm.customGroupTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDeleteController',CustomGroupTypeAttributeDeleteController);

    CustomGroupTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDeleteController($uibModalInstance, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomGroupTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-group-type-attribute', {
            parent: 'entity',
            url: '/custom-group-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customGroupTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attributes.html',
                    controller: 'CustomGroupTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customGroupTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-group-type-attribute-detail', {
            parent: 'custom-group-type-attribute',
            url: '/custom-group-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customGroupTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-detail.html',
                    controller: 'CustomGroupTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customGroupTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomGroupTypeAttribute', function($stateParams, CustomGroupTypeAttribute) {
                    return CustomGroupTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-group-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-group-type-attribute-detail.edit', {
            parent: 'custom-group-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomGroupTypeAttribute', function(CustomGroupTypeAttribute) {
                            return CustomGroupTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
       /* .state('custom-group-type-attribute.new', {
            parent: 'custom-group-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-group-type-attribute', null, { reload: 'custom-group-type-attribute' });
                }, function() {
                    $state.go('custom-group-type-attribute');
                });
            }]
        })*/
        
        .state('custom-group-type-attribute.new', {
			parent : 'custom-group-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-group-type-attribute.edit', {
            parent: 'custom-group-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomGroupTypeAttribute', function(CustomGroupTypeAttribute) {
                            return CustomGroupTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-group-type-attribute', null, { reload: 'custom-group-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-group-type-attribute.edit', {
			parent : 'custom-group-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customGroupTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customGroupTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomGroupTypeAttribute', function($stateParams, CustomGroupTypeAttribute) {
					return CustomGroupTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-group-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
		
        .state('custom-group-type-attribute.delete', {
            parent: 'custom-group-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-delete-dialog.html',
                    controller: 'CustomGroupTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomGroupTypeAttribute', function(CustomGroupTypeAttribute) {
                            return CustomGroupTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-group-type-attribute', null, { reload: 'custom-group-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomGroupTypeAttribute', CustomGroupTypeAttribute);

    CustomGroupTypeAttribute.$inject = ['$resource'];

    function CustomGroupTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-group-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeController', CustomGroupTypeAttributeController);

    CustomGroupTypeAttributeController.$inject = ['$state', 'CustomGroupTypeAttribute', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomGroupTypeAttributeController($state, CustomGroupTypeAttribute, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CustomGroupTypeAttribute.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customGroupTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeDialogController', CustomCaseTypeAttributeDialogController);

    CustomCaseTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomCaseTypeAttribute'];

    function CustomCaseTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomCaseTypeAttribute) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customcasetypeattributevalues = CustomCaseTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customCaseTypeAttribute.customCaseTypeAttributeValues != null && vm.customCaseTypeAttribute.customCaseTypeAttributeValues.length != 0) {
			vm.items = vm.customCaseTypeAttribute.customCaseTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customCaseTypeAttribute.id !== null) {
            	
            	 vm.customCaseTypeAttribute.customCaseTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customCaseTypeAttribute.customCaseTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomCaseTypeAttribute.update(vm.customCaseTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customCaseTypeAttribute.customCaseTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customCaseTypeAttribute.customCaseTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomCaseTypeAttribute.save(vm.customCaseTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customCaseTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-case-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeDetailController', CustomCaseTypeAttributeDetailController);

    CustomCaseTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomCaseTypeAttribute'];

    function CustomCaseTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomCaseTypeAttribute) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customCaseTypeAttributeUpdate', function(event, result) {
            vm.customCaseTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeDeleteController',CustomCaseTypeAttributeDeleteController);

    CustomCaseTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomCaseTypeAttribute'];

    function CustomCaseTypeAttributeDeleteController($uibModalInstance, entity, CustomCaseTypeAttribute) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomCaseTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-case-type-attribute', {
            parent: 'entity',
            url: '/custom-case-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attributes.html',
                    controller: 'CustomCaseTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-case-type-attribute-detail', {
            parent: 'custom-case-type-attribute',
            url: '/custom-case-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-detail.html',
                    controller: 'CustomCaseTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
                    return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-case-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-case-type-attribute-detail.edit', {
            parent: 'custom-case-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-case-type-attribute.new', {
            parent: 'custom-case-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('custom-case-type-attribute');
                });
            }]
        })*/
        
        .state('custom-case-type-attribute.new', {
			parent : 'custom-case-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-case-type-attribute.edit', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-case-type-attribute.edit', {
			parent : 'custom-case-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customCaseTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customCaseTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
					return CustomCaseTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-case-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-case-type-attribute.delete', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-delete-dialog.html',
                    controller: 'CustomCaseTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-case-type-attribute', {
            parent: 'entity',
            url: '/custom-case-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attributes.html',
                    controller: 'CustomCaseTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-case-type-attribute-detail', {
            parent: 'custom-case-type-attribute',
            url: '/custom-case-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-detail.html',
                    controller: 'CustomCaseTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
                    return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-case-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-case-type-attribute-detail.edit', {
            parent: 'custom-case-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-case-type-attribute.new', {
            parent: 'custom-case-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('custom-case-type-attribute');
                });
            }]
        })
        .state('custom-case-type-attribute.edit', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-case-type-attribute.delete', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-delete-dialog.html',
                    controller: 'CustomCaseTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomCaseTypeAttribute', CustomCaseTypeAttribute);

    CustomCaseTypeAttribute.$inject = ['$resource'];

    function CustomCaseTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-case-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomCaseTypeAttributeList', CustomCaseTypeAttributeList);

    CustomCaseTypeAttributeList.$inject = ['$resource'];

    function CustomCaseTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-case-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeController', CustomCaseTypeAttributeController);

    CustomCaseTypeAttributeController.$inject = ['$state', 'CustomCaseTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomCaseTypeAttributeController($state, CustomCaseTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomCaseTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customCaseTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeDialogController', CustomAssetTypeAttributeDialogController);

    CustomAssetTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'CustomAssetTypeAttribute'];

    function CustomAssetTypeAttributeDialogController ($timeout, $scope, $state, $stateParams, entity, CustomAssetTypeAttribute) {
        var vm = this;

        vm.customAssetTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
        //vm.customassettypeattributevalues = CustomAssetTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customAssetTypeAttribute.customAssetTypeAttributeValues != null && vm.customAssetTypeAttribute.customAssetTypeAttributeValues.length != 0) {
			vm.items = vm.customAssetTypeAttribute.customAssetTypeAttributeValues;
		}
        
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
           // $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customAssetTypeAttribute.id !== null) {
            	
            	 vm.customAssetTypeAttribute.customAssetTypeAttributeValues = [];
 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customAssetTypeAttribute.customAssetTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
            	
                CustomAssetTypeAttribute.update(vm.customAssetTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customAssetTypeAttribute.customAssetTypeAttributeValues = [];

 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customAssetTypeAttribute.customAssetTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
                CustomAssetTypeAttribute.save(vm.customAssetTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customAssetTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-asset-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeDetailController', CustomAssetTypeAttributeDetailController);

    CustomAssetTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomAssetTypeAttribute'];

    function CustomAssetTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomAssetTypeAttribute) {
        var vm = this;

        vm.customAssetTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customAssetTypeAttributeUpdate', function(event, result) {
            vm.customAssetTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeDeleteController',CustomAssetTypeAttributeDeleteController);

    CustomAssetTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomAssetTypeAttribute'];

    function CustomAssetTypeAttributeDeleteController($uibModalInstance, entity, CustomAssetTypeAttribute) {
        var vm = this;

        vm.customAssetTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomAssetTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-asset-type-attribute', {
            parent: 'entity',
            url: '/custom-asset-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customAssetTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attributes.html',
                    controller: 'CustomAssetTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customAssetTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-asset-type-attribute-detail', {
            parent: 'custom-asset-type-attribute',
            url: '/custom-asset-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customAssetTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-detail.html',
                    controller: 'CustomAssetTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customAssetTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomAssetTypeAttribute', function($stateParams, CustomAssetTypeAttribute) {
                    return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-asset-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-asset-type-attribute-detail.edit', {
            parent: 'custom-asset-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
       /* .state('custom-asset-type-attribute.new', {
            parent: 'custom-asset-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('custom-asset-type-attribute');
                });
            }]
        })*/
        
        .state('custom-asset-type-attribute.new', {
			parent : 'custom-asset-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-asset-type-attribute.edit', {
            parent: 'custom-asset-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-asset-type-attribute.edit', {
			parent : 'custom-asset-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customAssetTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customAssetTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomAssetTypeAttribute', function($stateParams, CustomAssetTypeAttribute) {
					return CustomAssetTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-asset-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
		
        .state('custom-asset-type-attribute.delete', {
            parent: 'custom-asset-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-delete-dialog.html',
                    controller: 'CustomAssetTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomAssetTypeAttribute', CustomAssetTypeAttribute);

    CustomAssetTypeAttribute.$inject = ['$resource'];

    function CustomAssetTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-asset-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeController', CustomAssetTypeAttributeController);

    CustomAssetTypeAttributeController.$inject = ['$state', 'CustomAssetTypeAttribute', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomAssetTypeAttributeController($state, CustomAssetTypeAttribute, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CustomAssetTypeAttribute.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customAssetTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("CaseTypeDialogController", CaseTypeDialogController);

    CaseTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "CaseType",
        "User",
        "CaseTypeSearch",
        "AllCustomCaseTypeAttribute",
    ];

    
    function CaseTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        CaseType,
        User,
        CaseTypeSearch,
        AllCustomCaseTypeAttribute
    ) {
        var vm = this;
        //casetype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.caseType = entity;
        vm.caseTypeImageName = caseTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customCaseTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function caseTypeImageName(image) {
            vm.caseType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomCaseTypeAttribute.getAll(function (response) {
                vm.customCaseTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customCaseTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.caseType.caseTypeAttribute != null &&
            vm.caseType.caseTypeAttribute.length != 0
        ) {
            vm.items = vm.caseType.caseTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.caseCategory == null) {
                value.caseCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.caseType.id !== null) {
                vm.caseType.caseTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.caseType.caseTypeAttribute.push({
                        caseCategory: vm.items[i].caseCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        caseTypeAttribOrder: vm.items[i].caseTypeAttribOrder
                    });
                }
                CaseType.update(vm.caseType, onSaveSuccess, onSaveError);
            } else {
                vm.caseType.caseTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.caseType.caseTypeAttribute.push({
                        caseCategory: vm.items[i].caseCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        caseTypeAttribOrder: vm.items[i].caseTypeAttribOrder
                    });
                }
                CaseType.save(vm.caseType, onSaveSuccess, onSaveError);
            }
        }

        $("#caseTypeImage").change(function () {
            var filesSelected = document.getElementById("caseTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.caseType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:caseTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("case-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CaseTypeDetailController', CaseTypeDetailController);

    CaseTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CaseType', 'User'];

    function CaseTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, CaseType, User) {
        var vm = this;

        vm.caseType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:caseTypeUpdate', function(event, result) {
            vm.caseType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CaseTypeDeleteController',CaseTypeDeleteController);

    CaseTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CaseType'];

    function CaseTypeDeleteController($uibModalInstance, entity, CaseType) {
        var vm = this;

        vm.caseType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CaseType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('case-type', {
            parent: 'entity',
            url: '/case-type',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.caseType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/case-type/case-types.html',
                    controller: 'CaseTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('case-type-detail', {
            parent: 'case-type',
            url: '/case-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.caseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/case-type/case-type-detail.html',
                    controller: 'CaseTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CaseType', function($stateParams, CaseType) {
                    return CaseType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'case-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('case-type.new', {
            parent: 'case-type',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/case-type/case-type-dialog.html',
                    controller: 'CaseTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('case-type.edit', {
            parent: 'case-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.caseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/case-type/case-type-dialog.html',
                    controller: 'CaseTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CaseType', function($stateParams, CaseType) {
                    return CaseType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'case-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('case-type.delete', {
            parent: 'case-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/case-type/case-type-delete-dialog.html',
                    controller: 'CaseTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['CaseType', function(CaseType) {
                            return CaseType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('case-type', null, { reload: 'case-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CaseType', CaseType);

    CaseType.$inject = ['$resource', 'DateUtils'];

    function CaseType ($resource, DateUtils) {
        var resourceUrl =  'api/case-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CaseTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getcasetypebyname = function (data,callback){
		$http.get('api/case-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CaseTypeSearch', CaseTypeSearch);

    CaseTypeSearch.$inject = ['$resource'];

    function CaseTypeSearch ($resource) {
        var service = $resource('/api/case-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomCaseTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-case-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CaseTypeController', CaseTypeController);

    CaseTypeController.$inject = ['$scope', '$state', 'CaseType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','CaseTypeSearch'];

    function CaseTypeController ($scope, $state, CaseType, ParseLinks, AlertService, pagingParams, paginationConstants,CaseTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			CaseTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.caseTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            CaseType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.caseTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider 
            .state("attribute-mapping", {
                parent: "entity",
                url: "/custom-case-type-mappers?page&sort&search",
                data: {
                    pageTitle: "trakeyeApp.caseType.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/attributeMapping/attribute-mapping.html",
                        controller: "AttributeMapping",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("caseType");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state('attribute-mapping.new', {
                parent : 'attribute-mapping',
                url : '/new',
                data : {
                    authorities : [ 'ROLE_USER_ADMIN' ]
                },
                views : {
                    'content@' : {
                        templateUrl: 'app/entities/attributeMapping/attribute-mapping-dialog.html',
                        controller: 'AttributeMappingDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            })
            .state('attribute-mapping.delete', {
                parent: 'attribute-mapping',
                url: '/{id}',
                data: {
                    authorities: [ 'ROLE_USER_ADMIN' ],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/attributeMapping/attribute-mapping-delete-dialog.html',
                        controller: 'AttributeMappingDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            
                        }
                    }).result.then(function() {
                        $state.go('attribute-mapping', null, { reload: 'attribute-mapping' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("Mapping", [
        "$rootScope",
        "$http",

        function ($rootScope, $http) {
            var service = {};

            service.postMapping = function (data, callback) {
                $http
                    .post("api/custom-case-type-mapper", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("AttributeMappingList", AttributeMappingList);

    AttributeMappingList.$inject = ["$resource"];

    function AttributeMappingList($resource) {
        var resourceUrl = "api/custom-case-type-mappers";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    angular.module("trakeyeApp").service("myservice", function () {
        var value = null;
        return {
            setValue: function (newValue) {
                value = newValue;
            },
            getValue: function () {
                return value;
            },
        };
    });
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AttributeMappingDelete", [
        "$http",
        function ($http) {
            var service = {};
            service.delete = function (id, callback) {
                $http
                    .delete("api/custom-case-type-mappers/" + id)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("AttributeMappingListId", AttributeMappingListId);

    AttributeMappingListId.$inject = ["$resource"];

    function AttributeMappingListId($resource) {
        var resourceUrl = "api/custom-case-type-mappers/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AttributeMappingDialogController', AttributeMappingDialogController);

        AttributeMappingDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomCaseTypeAttribute','CustomCaseTypeAttributeList','pagingParams','Mapping'];

    function AttributeMappingDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomCaseTypeAttribute,CustomCaseTypeAttributeList,pagingParams,Mapping) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.predicate = pagingParams.predicate;
        vm.clear = clear;
        vm.save = save;
        vm.searchMini=""

        loadAll();

        function loadAll() {
            CustomCaseTypeAttributeList.query(
                {
                    page: pagingParams.page - 1,
                    size: 100,
                    sort: "id,asc",
                },
                onSuccess,
                onError
            );
            function onSuccess(data, headers) {
                vm.category = []
                data.forEach(function(item, index, object){
                    if(item.name == "STRING" || item.name == "INTEGER" ||  item.name == "FLOAT"){
                        
                    }else{
                        vm.category.push(item)
                    }
                })
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        $scope.funcCategoryLeft=function(){
            vm.subCategoryLeft = []
            vm.selectedCategoryLeft[0].customCaseTypeAttributeValues.forEach(function(val){
                vm.subCategoryLeft.push(val)
            })
            vm.category.forEach(function(val){
                val.disabledRight = false;
                if(val.id == vm.selectedCategoryLeft[0].id){
                    val.disabledRight = true
                }
            })
        }
        $scope.funcCategoryRight=function(){
            vm.subCategoryRight = []
            vm.selectedCategoryRight[0].customCaseTypeAttributeValues.forEach(function(val){
                vm.subCategoryRight.push(val)
            })
            vm.category.forEach(function(val){
                val.disabledLeft = false;
                if(val.id == vm.selectedCategoryRight[0].id){
                    val.disabledLeft = true
                }
            })
        }

        function save () {
            var selectedParentCaseTypeCategory = []
            selectedParentCaseTypeCategory.push({id : vm.selectedCategoryLeft[0].id , value: vm.selectedCategoryLeft[0].name} )
            
            var selectedParentSubCaseTypeCategory = []
            selectedParentSubCaseTypeCategory.push({id : vm.selectedCategoryRight[0].id , value: vm.selectedCategoryRight[0].name} )
            
            var sendMapping = []

            for(var i=0;i<vm.selectedSubCategoryRight.length;i++){
                sendMapping.push({
                    caseTypeCategory : vm.selectedSubCategoryLeft[0],
                    caseTypeSubCategory : vm.selectedSubCategoryRight[i],
                    parentCaseTypeCategory : selectedParentCaseTypeCategory[0],
                    parentCaseTypeSubCategory : selectedParentSubCaseTypeCategory[0],
                    description : ""
                })
            }
            Mapping.postMapping(sendMapping,function (response){
                onSaveSuccess()
            }) 
        }

        function onSaveSuccess () {
            //vm.isSaving = false;
            $state.go('attribute-mapping');
        }

        /* function onSaveError () {
            vm.isSaving = false;
        } */


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AttributeMappingDeleteController',AttributeMappingDeleteController);

        AttributeMappingDeleteController.$inject = ['$uibModalInstance','AttributeMappingDelete','$scope',"myservice"];

    function AttributeMappingDeleteController($uibModalInstance, AttributeMappingDelete,$scope,myservice) {
        var vm = this;

        //vm.customCaseTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
           $scope.value = myservice.getValue();
           AttributeMappingDelete.delete( $scope.value,
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AttributeMapping", AttributeMapping);

    AttributeMapping.$inject = [
        "$state",
        "AttributeMappingList",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$scope",
        "myservice"
    ];

    function AttributeMapping(
        $state,
        AttributeMappingList,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $scope,
        myservice
    ) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();
        $scope.passDeleteId = function(id){
            myservice.setValue(id);
        }

        function loadAll() {
            AttributeMappingList.query(
                {
                    page: pagingParams.page - 1,
                    size:  vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.attributeMappingList = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetTypeDialogController', AssetTypeDialogController);

    AssetTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams',  'entity', 'AssetType', 'User','AllCustomAssetTypeAttribute', '$state', '$q'];

    function AssetTypeDialogController ($timeout, $scope, $stateParams,  entity, AssetType, User,AllCustomAssetTypeAttribute, $state, $q) {
        var vm = this;
        $scope.IMAGE_EXT_REGEXP =/^(.*?)\.(jpg||jpeg||png)$/;

        vm.assetType = entity;
        $scope.attributetypes = ['INTEGER', 'FLOAT', 'STRING','BOOLEAN'];
        var userAdminAuthorities = ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER',
            'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_VENDOR'
        ];
        vm.clear = clear;
        vm.colorcode = colorcode;
        vm.assetImageName = assetImageName;
        vm.decodeImage = decodeImage;
        vm.authorities = [];
        vm.customCaseTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        var zoomlevelLabel,zoomlevelObj,zoomlevelObjfixed;
        
		$scope.allimages = false;
		 $scope.toggle = function() {
			$scope.allimages = !$scope.allimages;
		};

        zoomlevelObj = document.getElementById("zoomlevel");
        setSelectedValue(zoomlevelObj, vm.assetType.zoomLevel);

        zoomlevelObjfixed = document.getElementById("zoomlevelFixed");
        setSelectedValue(zoomlevelObjfixed, vm.assetType.zoomLevel);

        /* zoomlevelLabel = document.getElementById("zoomlevelLabel");
        setSelectedValue(zoomlevelLabel, vm.assetType.zoomLevelLabel); */
       
		vm.save = save;
		 $(":file").filestyle({buttonBefore: true});      
	     $(":file").filestyle('buttonText', 'Browse File');
       
         vm.addNonReferenceAttribute = function(){
            vm.items=[{ name: '',attributeDataType: {},defaultValue :''}];
            var tempItems = [];
		    vm.items.forEach(function(value){
			if(value.assetAttributeTypes == null){
				value.assetAttributeTypes = "NON_REFERENCE";
			}
			tempItems.push(value);
		});
         }
	     //vm.items=[{name: '',dataType: '',defaultValue :''}];
	     vm.referenceAttribute = []
	     vm.addNewReferenceAttribute = function(){
            if(!vm.assetType.id){
                vm.referenceAttribute = [
                    { name: "", attributeDataType: {}, defaultValue: "" },
                    {
                        name: "",
                        attributeDataType: {},
                        defaultValue: "",
                    },{
                        name: "",
                        attributeDataType: {},
                        defaultValue: "",
                    }
                ];
            }
            
            if(vm.assetType.id &&  vm.assetType.assetTypeReferenceAttributes.length == 0 ){ 
                vm.referenceAttribute = [
                    { name: "", attributeDataType: {}, defaultValue: "" },
                    {
                        name: "",
                        attributeDataType: {},
                        defaultValue: "",
                    },{
                        name: "",
                        attributeDataType: {},
                        defaultValue: "",
                    }
                ];
            }

            var tempItems = [];
            vm.referenceAttribute.forEach(function (value) {
                if (value.assetAttributeTypes == null) {
                    value.assetAttributeTypes = "THREE_PNT_REFERENCE";
                }
                tempItems.push(value);
            });
         }
		

	     if(vm.assetType.assetTypeAttributes!=null && vm.assetType.assetTypeAttributes.length!=0){
	        	vm.items=vm.assetType.assetTypeAttributes;
	        	
	        }

           

            if (
                vm.assetType.assetTypeReferenceAttributes != null &&
                vm.assetType.assetTypeReferenceAttributes.length != 0
            ) {
                vm.assetType.assetTypeReferenceAttributes.forEach(function (val){
                    vm.referenceAttribute.push(val['assetAttributeName'])
                    vm.referenceAttribute.push(val['assetAttributeValue'])
                    if(val['assetAttributeImage'] != null){
                        val['assetAttributeImage'].assetTypeRfrncAttribOrder = val.assetTypeRfrncAttribOrder
                    }
                    vm.referenceAttribute.push(val['assetAttributeImage'])
                })
            }
	     
		function loadPage() {
            vm.multiAuthorities = [];
            var selectedAuthorities = [];
			AllCustomAssetTypeAttribute.getAll(function(response) {
				vm.customAssetTypeAttributes = response;
				response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customAssetTypeAttributeValues;
				});
                if (vm.assetType.lineWidth != null) {
					var lineWidthObj = document.getElementById("lineWidth");
					setSelectedValue(lineWidthObj, vm.assetType.lineWidth);
				}
				if (vm.assetType.transparency != null) {
					var transparencyObj = document.getElementById("transparency");
					setSelectedValue(transparencyObj, vm.assetType.transparency);
				}
			});
            if(vm.assetType.id != null){
                vm.assetType.authorities.forEach(function (authority) {
                    selectedAuthorities.push(authority);
                });
            }
            
            userAdminAuthorities.forEach(function(authority){
                if (selectedAuthorities.indexOf(authority) !== -1) {
                    vm.multiAuthorities.push({ name: authority, ticked: true });
                } else {
                    vm.multiAuthorities.push({ name: authority, ticked: false });
                }
            });
            
		}
        function setSelectedValue(selectObj, valueToSet) {
            for (var i = 0; i < selectObj.options.length; i++) {
                if (selectObj.options[i].text== valueToSet) {
                    selectObj.options[i].selected = true;
                    return;
                }
            }
        }

        if(vm.assetType.assetTypeAttributes!=null && vm.assetType.assetTypeAttributes.length!=0){
        	vm.items=vm.assetType.assetTypeAttributes;
        }
        
        function colorcode(color) {
        	vm.assetType.colorcode = color;
            
        }
        function assetImageName(image) {
        	vm.assetType.image = image;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        function save () {
            vm.isSaving = true;
            vm.assetType.authorities = [];
            vm.authorities.forEach(function(auth){
                vm.assetType.authorities.push(auth.name);
            });
            if(document.getElementById("lineWidth") != null && document.getElementById("transparency") != null){
                vm.assetType.lineWidth = parseInt(document.getElementById("lineWidth").value);
                vm.assetType.transparency = parseInt(document.getElementById("transparency").value);
            }

            if(vm.assetType.layout == 'SPREAD'){
                vm.assetType.zoomLevel = parseInt(document.getElementById("zoomlevel").value);
            }

            if(vm.assetType.layout == 'FIXED'){
                vm.assetType.zoomLevel = parseInt(document.getElementById("zoomlevelFixed").value);
                //vm.assetType.zoomLevelLabel = parseInt(document.getElementById("zoomlevelLabel").value);
            }
            
            if(vm.assetType.isSeniorElement){
                vm.assetType.zoomLevel = null;
            }
            if (vm.assetType.id !== null) {
            	vm.assetType.assetTypeAttributes=[];

                if(vm.items != null && vm.items.length > 0){ 
                    for(var i = 0; i < vm.items.length; i++){
                        var attributes ={"name" :  vm.items[i]};
                        //vm.assetType.assetTypeAttributes.push({"name" :  vm.items[i].name});
                         vm.assetType.assetTypeAttributes.push({"assetAttributeTypes" : vm.items[i].assetAttributeTypes,"id" : vm.items[i].id , "name" :  vm.items[i].name,  "attributeDataType" :  vm.items[i].attributeDataType,"defaultValue" :  vm.items[i].defaultValue, 
                         assetTypeAttribOrder:vm.items[i].assetTypeAttribOrder, 
                         assetTypePopupDisplay:vm.items[i].assetTypePopupDisplay
                        //  assetTypeListViewDisplay:vm.items[i].assetTypeListViewDisplay
                        });
                    }
                }
            	

                if(vm.assetType.layout == "FIXED" && vm.referenceAttribute != null && vm.referenceAttribute.length > 0){
                    vm.assetType.assetTypeReferenceAttributes=[];
                    callAssetTypeReference()
                }
                AssetType.update(vm.assetType, onSaveSuccess, onSaveError);
            } else {
                vm.assetType.assetTypeAttributes=[];

                if(vm.items != null && vm.items.length > 0){
                    for(var i = 0; i < vm.items.length; i++){
                        var attributes ={"name" :  vm.items[i]};
                       // vm.assetType.assetTypeAttributes.push({"name" :  vm.items[i].name});
                         vm.assetType.assetTypeAttributes.push({"assetAttributeTypes" : vm.items[i].assetAttributeTypes,"id" : vm.items[i].id , "name" :  vm.items[i].name,   "attributeDataType" :  vm.items[i].attributeDataType,"defaultValue" :  vm.items[i].defaultValue,
                         assetTypeAttribOrder:vm.items[i].assetTypeAttribOrder,
                         assetTypePopupDisplay:vm.items[i].assetTypePopupDisplay
                        //  assetTypeListViewDisplay:vm.items[i].assetTypeListViewDisplay
                        });
                    }
                }
            	
                if(vm.assetType.layout == "FIXED" && vm.referenceAttribute != null && vm.referenceAttribute.length > 0){
                    /* for(var i = 0; i < vm.referenceAttribute.length; i++){
                        var attributes ={"name" :  vm.referenceAttribute[i]};
                        //vm.assetType.assetTypeAttributes.push({"name" :  vm.referenceAttribute[i].name});
                         vm.assetType.assetTypeReferenceAttributes.push({
                            "assetTypeRfrncAttribOrder":  vm.referenceAttribute[i].assetTypeAttribOrder,
                            "assetAttributeName" : {
                                "assetAttributeTypes": vm.referenceAttribute[i].assetAttributeTypes,
                                "name": vm.referenceAttribute[i].name,
                                "attributeDataType": vm.referenceAttribute[i].attributeDataType,
                                "defaultValue" : vm.referenceAttribute[i].arridefaultValue,
                                "assetTypeAttribOrder": null,
                            }

                        });
                    } */
                    vm.assetType.assetTypeReferenceAttributes=[];
                    callAssetTypeReference()
                }
                AssetType.save(vm.assetType, onSaveSuccess, onSaveError);
            }
        }
       
        function callAssetTypeReference(){
            for (var i = 0; i < vm.referenceAttribute.length; i += 3) {
                        
                var obj = {
                    "assetTypeRfrncAttribOrder":  vm.referenceAttribute[i+2].assetTypeRfrncAttribOrder 
                    };
              
                obj["assetAttributeName"] = vm.referenceAttribute[i] ? {"assetAttributeTypes": vm.referenceAttribute[i].assetAttributeTypes,
                "name": vm.referenceAttribute[i].name,
                "attributeDataType": vm.referenceAttribute[i].attributeDataType,
                "defaultValue" : vm.referenceAttribute[i].defaultValue,
                "assetTypeAttribOrder": "0",} : null;
                obj["assetAttributeValue"] = vm.referenceAttribute[i + 1] ? {"assetAttributeTypes": vm.referenceAttribute[i+1].assetAttributeTypes,
                "name": vm.referenceAttribute[i+1].name,
                "attributeDataType": vm.referenceAttribute[i+1].attributeDataType,
                "defaultValue" : vm.referenceAttribute[i+1].defaultValue,
                "assetTypeAttribOrder": "1",} : null;
                obj["assetAttributeImage"] = vm.referenceAttribute[i + 2] ? {"assetAttributeTypes": vm.referenceAttribute[i+2].assetAttributeTypes,
                "name": vm.referenceAttribute[i+2].name,
                "attributeDataType": vm.referenceAttribute[i+2].attributeDataType,
                "defaultValue" : vm.referenceAttribute[i+2].defaultValue,
                "assetTypeAttribOrder": "2",} : null;

                vm.assetType.assetTypeReferenceAttributes.push(obj);
              }
        }
       /* $scope.fileNameChanged = function() {
        	
        	 var filesSelected = document.getElementById("assetImage").files;
        	 for(var i=0; i<filesSelected.length; i++){
 				var fileReader = new FileReader();
                  fileReader.onload = function(fileLoadedEvent) {
 			    	var test=window.btoa(fileLoadedEvent.target.result);
 			    	 vm.assetType.image= test;
 			    }
 			      fileReader.readAsBinaryString(filesSelected[i]);
 			}
 		   
        	}*/
        
        $("#assetImage").change(function(){
        	var filesSelected = document.getElementById("assetImage").files;
       	 	for(var i=0; i<filesSelected.length; i++){
				var fileReader = new FileReader();
                fileReader.onload = function(fileLoadedEvent) {
			    	var test=window.btoa(fileLoadedEvent.target.result);
			    	 vm.assetType.image= test;
			    	
			    }
			    fileReader.readAsBinaryString(filesSelected[i]);
			}
		    
		});
        
        

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:assetTypeUpdate", result);
            vm.isSaving = false;
            var previousId = sessionStorage.getItem("prevId");
            var prevEditDetail = sessionStorage.getItem("prevEditId");
            if (previousId) {
                sessionStorage.setItem("AssetTypeToEditAsset", "assetTypeToAsset");
                $state.go("asset.edit", {
                    id: previousId
                });
                sessionStorage.removeItem("prevId");
            } else if (prevEditDetail) {
                sessionStorage.setItem("AssetTypeToEditDetails", "assetTypeToAssetDetails");
                $state.go("asset-detail.edit", {
                    id: prevEditDetail
                });
                sessionStorage.removeItem("prevEditId");
            } else if(sessionStorage.getItem("createAssetType")) {
                $state.go("asset.new", {
                });
            }
             else if(sessionStorage.getItem("createAssetTypeAssetType")){
                $state.go("asset-type");
            } else {
                $state.go("asset-type");
            }
        }

        function onSaveError () {
            vm.isSaving = false;
        }

      /*  vm.addmore = function() {
            vm.items.push({name: ''});
          };
            
         vm.remove = function(index) {
            vm.items.splice(index, 1);
          };*/
        
        vm.addmore = function(index) {
        	vm.items.splice((index+1), 0,{name: '',attributeDataType:{}, defaultValue:'', assetAttributeTypes:"NON_REFERENCE"});
             
          };

          vm.addReferenceAttribute = function (index) {
              for (var i = 0; i < 3; i++) {
                  /* 1039 change to i<3 */
                  vm.referenceAttribute.splice(index + 1, 0, {
                      name: "",
                      attributeDataType: {},
                      defaultValue: "",
                      assetAttributeTypes: "THREE_PNT_REFERENCE",
                  });
              }
          };

          $scope.removeRow = function (index) {
              for (var i = 0; i < 3; i++) {
                  /* 1039 change to i<3*/
                  vm.referenceAttribute.splice(index - i, 1);
              }
          };

       vm.remove = function(index) {
            vm.items.splice(index, 1);
          };
          function decodeImage(img){
        	   return window.atob(img);
           }

    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetTypeDetailController', AssetTypeDetailController);

    AssetTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AssetType', 'User'];

    function AssetTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, AssetType, User) {
        var vm = this;

        vm.assetType = entity;
        vm.previousState = previousState.name;
        vm.referenceAttribute = []

        var unsubscribe = $rootScope.$on('trakeyeApp:assetTypeUpdate', function(event, result) {
            vm.assetType = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.assetType.assetTypeReferenceAttributes.forEach(function (val){
            vm.referenceAttribute.push(val['assetAttributeName'])
            vm.referenceAttribute.push(val['assetAttributeValue'])
            vm.referenceAttribute.push(val['assetAttributeImage'])
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetTypeDeleteController',AssetTypeDeleteController);

    AssetTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'AssetType'];

    function AssetTypeDeleteController($uibModalInstance, entity, AssetType) {
        var vm = this;

        vm.assetType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AssetType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('asset-type', {
            parent: 'entity',
            url: '/asset-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER_ADMIN','ROLE_USER'],
                pageTitle: 'trakeyeApp.assetType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/asset-type/asset-types.html',
                    controller: 'AssetTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assetType');
                    $translatePartialLoader.addPart('layout');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('asset-type-detail', {
            parent: 'entity',
            url: '/asset-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.assetType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/asset-type/asset-type-detail.html',
                    controller: 'AssetTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assetType');
                    $translatePartialLoader.addPart('layout');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssetType', function($stateParams, AssetType) {
                    return AssetType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'asset-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('asset-type-detail.edit', {
            parent: 'asset-type-detail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.assetType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/asset-type/asset-type-dialog.html',
                    controller: 'AssetTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assetType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssetType', function($stateParams, AssetType) {
                    return AssetType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'asset-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
       
        
        .state('asset-type.new', {
            parent: 'asset-type',
            url: '/new',
            data: {
            	 authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					 templateUrl: 'app/entities/asset-type/asset-type-dialog.html',
	                    controller: 'AssetTypeDialogController',
	                    controllerAs: 'vm',
				}
			},
			 resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                description: null,
                                layout: null,
                                colorcode: null,
                                createDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
            
        })
        
        .state('asset-type.edit', {
            parent: 'asset-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.assetType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/asset-type/asset-type-dialog.html',
                    controller: 'AssetTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assetType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssetType', function($stateParams, AssetType) {
                    return AssetType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'asset-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('asset-type.delete', {
            parent: 'asset-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/asset-type/asset-type-delete-dialog.html',
                    controller: 'AssetTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AssetType', function(AssetType) {
                            return AssetType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('asset-type', null, { reload: 'asset-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('AssetType', AssetType);

    AssetType.$inject = ['$resource'];

    function AssetType($resource) {
        var resourceUrl = 'api/asset-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('AssetTypeSearch', AssetTypeSearch);

    AssetTypeSearch.$inject = ['$resource'];

    function AssetTypeSearch($resource) {
        var service = $resource('/api/asset-types/searchvalue/:searchvalue', { searchvalue: '@id' }, {}, {
            'query': { method: 'GET', isArray: true },
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllCustomAssetTypeAttribute', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/all-custom-asset-type-attributes').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetTypesByGeofenceID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (geofenceId, callback) {
            $http.get('api/asset-types-geofence/' + geofenceId).then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetTypesByGeofenceIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function ( data, callback) {
            $http.post("api/asset-types-geofences", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetTypeController', AssetTypeController);

    AssetTypeController.$inject = ['$scope', '$state', 'AssetType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'AssetTypeSearch'];

    function AssetTypeController ($scope, $state, AssetType, ParseLinks, AlertService, pagingParams, paginationConstants, AssetTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;
        vm.navigateCreateAssetType = navigateCreateAssetType;
        
        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			AssetTypeSearch.query({searchvalue:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    //result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.assetTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}

        loadAll();

        function loadAll () {
            AssetType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.assetTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function navigateCreateAssetType() {
            sessionStorage.setItem("createAssetTypeAssetType", "createAssetTypeFromAssetType");
            $state.go("asset-type.new", {
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetImportController", AssetImportController);

    AssetImportController.$inject = ["AllAssetsTypes", "AssetUpload"];
    function AssetImportController(AllAssetsTypes, AssetUpload) {

        var vm = this;
        var formData,getFile;

        AllAssetsTypes.getAll(function (response) {
            vm.assettypes = response;
        });

        $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });

        vm.importxlsx = /^(.*?)\.(xlsx|kml)$/;
        
        vm.upload = function () {

            getFile = document.getElementById('uploadfile').files[0]
            formData = new FormData();
            formData.append("assettype", vm.importassettype.name);
            formData.append("file", getFile);
            
            AssetUpload.assetupload(formData, function (response) {
                vm.success = response.status == 200 ? "success" : ""
                if (vm.success) {
                    setTimeout(function () {
                        vm.success = "";
                    }, 3000);
                }
            });
        };
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetDialogController", AssetDialogController)

        .directive("fileread", [
            function () {
                "use strict";

                return {
                    restrict: "A",

                    link: function ($scope, element) {
                        element.change(function (event) {
                            $scope.$apply(function () {
                                $scope.myFile = element[0].files[0];
                                $scope.asset = $scope.assetname;
                            });
                        });
                    },
                };
            },
        ])

        .directive("fileModel", [
            "$parse",
            function ($parse) {
                return {
                    restrict: "A",
                    link: function (
                        scope,
                        element,
                        attrs,
                        $rootScope,
                        $broadcast
                    ) {
                        var model = $parse(attrs.fileModel);
                        var modelSetter = model.assign;

                        element.bind("change", function () {
                            var files = element[0].files;
                            var allowedTypes = {
                                "image/png": true,
                                "image/jpg": true,
                                "image/jpeg": true,
                            };

                            var data = {
                                file: files,
                                types: allowedTypes,
                            };
                            scope.$emit("callFunction", data);
                            //uploadFiles("reference", allowedTypes,files);
                        });
                    },
                };
            },
        ])

        .directive("fileStyle", function () {
            return {
                link: function (scope, element) {
                    $(element).filestyle({
                        buttonBefore: true,
                    });
                    $(element).filestyle("buttonText", "Browse File");
                },
            };
        });

    AssetDialogController.$inject = [
        "$timeout",
        "$scope",
        "DEFAULT_LATITUDE",
        "DEFAULT_LONGITUDE",
        "$stateParams",
        "AssetImages",
        "GroupAssets",
        "ParseLinks",
        "AlertService",
        "entity",
        "Asset",
        "User",
        "$state",
        "AssetUpload",
        "AllAssetsTypes",
        "AllCustomAssetTypeAttribute",
        "UserGroupIDs",
        "AssetByID",
        "AssetGroupSearch",
        "UserAccount",
        "GeofenceIDs",
        "UserGeofences",
        "AssetGroupES",
        "Geofence",
        "$localStorage",
        "Configs",
    ];

    function AssetDialogController(
        $timeout,
        $scope,
        DEFAULT_LATITUDE,
        DEFAULT_LONGITUDE,
        $stateParams,
        AssetImages,
        GroupAssets,
        ParseLinks,
        AlertService,
        entity,
        Asset,
        User,
        $state,
        AssetUpload,
        AllAssetsTypes,
        AllCustomAssetTypeAttribute,
        UserGroupIDs,
        AssetByID,
        AssetGroupSearch,
        UserAccount,
        GeofenceIDs,
        UserGeofences,
        AssetGroupES,
        Geofence,
        $localStorage,
        Configs
    ) {
        var vm = this;

        vm.asset = entity;
        var entity_old = angular.copy(vm.asset);
        vm.clear = clear;
        vm.save = save;
        vm.assetType = entity.assetType;

        vm.upload = upload;
        vm.showAssetImage = false;

        vm.assettypes = loadPage();
        vm.selectattributes = selectedAssetTypeAttributes;
        vm.coOrdinates = [];
        vm.coOrdinate = null;
        var newFence = false;
        var latlng;
        var locations = {};
        var centerlatlng = null;
        vm.customAttributesMap = {};
        var formData, maxSize = '2021440';
        var spreadAssets = [];
        vm.parentLatLng = [];
        vm.userAdmin = {};
        vm.userGeofenceList = null;

        vm.selectedGeofenceId = null;
        vm.prevSelectedGeofenceId = null;
        vm.userGeofences = [];
        var openedInfoWindow = null;
        var prevInfoWindow = null;
        vm.asset.assetImages = [];

        vm.navigateCreateAsset = navigateCreateAsset;
        vm.navigateCreateGroup = navigateCreateGroup;
        vm.navigateAssetType = navigateAssetType;
        vm.filterParentAssets = filterParentAssets;
        vm.filterAssetsOnMapView = filterAssetsOnMapView;
        vm.closeMapFilterModal = closeMapFilterModal;
        vm.saveFilter = saveFilter;
        vm.selectAssetCordinates = false;
        vm.showFilter = false;
        vm.fileWarning = false;
        //vm.referenceImages = false;
        //vm.assetRefAttributes = [];
        var markers = [];
        var polylines = [];
        var noDataText = null;
        var rolloutRoles = [
            "ROLE_ROLLOUT_INFRA",
            "ROLE_ROLLOUT_SURVEY",
            "ROLE_ROLLOUT_ADMIN",
        ];
        var planRoles = [
            "ROLE_PLAN_ADMIN",
            "ROLE_PLAN_INFRA",
            "ROLE_PLAN_SURVEY",
        ];
        var groupPlanRollout = ["Rollout Group", "Planning Group"];
        vm.roleAccess = false;
        vm.groupAccess = false;
        vm.roleRolloutAdmin = false;

        vm.onSelectPhase = function () {
            vm.asset.phase = vm.asset.phase[0].configKey;
        };

        $scope.$on("callFunction", function (event, data) {
            // Call the function in this controller
            uploadFiles(
                "reference",
                data.types,
                data.file,
                event.targetScope.attribute.id
            );
        });

        function loadPage() {
            if (!vm.asset.id) {
                vm.asset.phase = "ROLLOUT";
            }

            vm.multiGroup = [];
            var selectedGroup = [];

            vm.multiassets = [];
            vm.multiassetsLink = [];
            var selectedAssets = [];

            Configs.get("AssetImage", function (response) {
                if (response.length > 0) {
                    if (response[0].configValue == "True") {
                        vm.showAssetImage = true;
                    }
                }
            });

            Configs.get("MaxFileSize", function (response) {
                maxSize = response[0].configValue;
            });

            if (vm.asset.id) {
                if (vm.asset.assetReferenceAttributes.length) {
                    vm.assetRefAttributes = [];
                    vm.asset.assetReferenceAttributes.forEach(function (get) {
                        if (get["assetAttributeName"] != null) {
                            get[
                                "assetAttributeName"
                            ].assetTypeAttribute.attributeValue =
                                get["assetAttributeName"].attributeValue;
                            vm.assetRefAttributes.push(
                                get["assetAttributeName"].assetTypeAttribute
                            );
                        }

                        if (get["assetAttributeValue"] != null) {
                            get[
                                "assetAttributeValue"
                            ].assetTypeAttribute.attributeValue =
                                get["assetAttributeValue"].attributeValue;
                            vm.assetRefAttributes.push(
                                get["assetAttributeValue"].assetTypeAttribute
                            );
                        }

                        if (get["assetAttributeImage"] != null)   {
                            get[
                                "assetAttributeImage"
                            ].assetTypeAttribute.attributeValue =
                                get["assetAttributeImage"].image;
                            get[
                                    "assetAttributeImage"
                                ].assetTypeAttribute.attributeName =
                                    get["assetAttributeImage"].imageName;
                            get[
                                        "assetAttributeImage"
                                    ].assetTypeAttribute.imageId =
                                        get["assetAttributeImage"].imageId;
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.attributeType =
                                            get["assetAttributeImage"].imageType;
                            vm.assetRefAttributes.push(
                                get["assetAttributeImage"].assetTypeAttribute
                            );
                        }
                    });
                }else{
                    vm.assetRefAttributes = [];
                    if (vm.asset.assetType.assetTypeReferenceAttributes.length) {
                        vm.asset.assetType.assetTypeReferenceAttributes.forEach(function (get) {
                            get["assetAttributeName"].attributeValue =
                            get["assetAttributeName"].defaultValue;
                        vm.assetRefAttributes.push(get["assetAttributeName"]);
                        get["assetAttributeValue"].attributeValue =
                            get["assetAttributeValue"].defaultValue;
                        vm.assetRefAttributes.push(get["assetAttributeValue"]);
                        vm.assetRefAttributes.push(get["assetAttributeImage"]);
                        });
                     }
                    
                }
            }

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                        img +
                        '">'
                );
                imgWindow.document.close();
            };

            if (vm.asset.id != null) {
                vm.asset.ownedBy.forEach(function (asset) {
                    selectedAssets.push(asset.id);
                    vm.selectedParent = asset.name;
                    AssetGroupSearch.query(
                        {
                            search: asset.name,
                        },
                        onSuccess,
                        onError
                    );

                    function onSuccess(data, headers) {
                        vm.parentAssets = data;
                    }

                    function onError(error) {
                        AlertService.error(error.data.message);
                    }
                });

                vm.asset.groups.forEach(function (group) {
                    selectedGroup.push(group.id);
                });
            }

            var assetTypeAttributeValuesList =
                vm.asset.assetTypeAttributeValues;

            try {
                for (var index in vm.asset.assetType.assetTypeAttributes) {
                    if (
                        !checkIfAssetTypeExists(
                            vm.asset.assetType.assetTypeAttributes[index],
                            vm.asset.assetTypeAttributeValues
                        )
                    ) {
                        var assetTypeAttribute1 =
                            vm.asset.assetType.assetTypeAttributes[index];
                        assetTypeAttributeValuesList.push({
                            assetTypeAttribute: assetTypeAttribute1,
                            attributeValue:
                                vm.asset.assetType.assetTypeAttributes[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) {}

            function checkIfAssetTypeExists(assetType, assetTypeAttrVal) {
                var hasAssetType = false;
                for (var i = 0; i < assetTypeAttrVal.length; i++) {
                    var name = assetTypeAttrVal[i].assetTypeAttribute.name;
                    if (name == assetType.name) {
                        hasAssetType = true;
                        break;
                    }
                }
                return hasAssetType;
            }

            // assetTypeAttributeValuesList.sort(function (a, b) {
            //     var nameA = a.assetTypeAttribute.name.toLowerCase(),
            //         nameB = b.assetTypeAttribute.name.toLowerCase();
            //     if (nameA < nameB)
            //         // sort string ascending
            //         return -1;
            //     if (nameA > nameB) return 1;
            //     return 0; // default return value (no sorting)
            // });
            // vm.asset.assetTypeAttributeValues = assetTypeAttributeValuesList;

            UserGroupIDs.getAll(function (response) {
                response.forEach(function (group) {
                    if (selectedGroup.indexOf(group.id) !== -1) {
                        vm.multiGroup.push({
                            name: group.name,
                            id: group.id,
                            ticked: true,
                        });
                    } else {
                        vm.multiGroup.push({
                            name: group.name,
                            id: group.id,
                            ticked: false,
                        });
                    }

                    if (groupPlanRollout.includes(group.name)) {
                        vm.groupAccess = true;
                    }
                });
            });
            //            if (!entity.assetImport) {
            //                getGroupAsset(0, vm.multiassets, selectedAssets);
            //            }

            AllAssetsTypes.getAll(function (response) {
                vm.assettypes = response;
            });

            AllCustomAssetTypeAttribute.getAll(function (response) {
                // vm.customCaseTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customAssetTypeAttributeValues;
                });
            });

            vm.multiassets.sort(function (a, b) {
                var nameA = a.name.toLowerCase(),
                    nameB = b.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });

            UserAccount.get(function (data) {
                vm.userAdmin = data;
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    }
                    if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }

                    if (
                        val == "ROLE_ROLLOUT_ADMIN" &&
                        vm.asset.phase == "ROLLOUT"
                    ) {
                        vm.roleRolloutAdmin = true;
                    }

                    if (rolloutRoles.includes(val) || planRoles.includes(val)) {
                        vm.roleAccess = true;
                    }
                });
                if (isAdmin) {
                    GeofenceIDs.getAll(function (response) {
                        response.forEach(function (geofence) {
                            if (geofence.name != "Bangalore") {
                                vm.userGeofences.push(geofence);
                                if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                    vm.canFilter = true;
                                }
                            }
                        });
                    });
                } else {
                    UserGeofences.getAll(function (response) {
                        vm.userGeofenceList = response;
                        response.forEach(function (geofence) {
                            if (geofence.name != "Bangalore") {
                                vm.userGeofences.push(geofence);
                                if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                    vm.canFilter = true;
                                }
                            }
                        });
                    });
                }
            });
            if (vm.asset.id) {
                vm.nameImages = [];
                vm.asset.assetImages.forEach(function (item) {
                    vm.nameImages.push(item);
                });
            }
        }

        $scope.newTabDisplay = function (id,name) {
            var request = new XMLHttpRequest(), apiImage = name == 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";
            
            request.open(
                    "GET",
                    apiImage + vm.asset.id + "/" + id,
                    true
            );
            
            request.setRequestHeader(
                "Authorization",
                "Bearer " + $localStorage.authenticationToken
            );
            request.responseType = "blob";
            request.onload = response;

            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank");
                }
            }
            request.send();
        };

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function filterParentAssets() {
            // if (vm.asset.user.length > 2 && vm.asset.user != null && vm.asset.user != "" && vm.asset.user != "." && !angular.isUndefined(vm.asset.user)) {
            if (vm.selectedParent.length > 1) {
                AssetGroupSearch.query(
                    {
                        search: vm.selectedParent,
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    vm.parentAssets = data;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }
            // }
        }

        Configs.get("Phases", function (response) {
            vm.phases = response;
            /*  response.forEach(function (item){
                 if(!vm.asset.phase){
                     item.ticked = (item.configKey == "ROLLOUT") ? true : false
                      
                 }else{
                     item.ticked = (vm.asset.phase == item.configKey) ? true : false
                 }

                 if(vm.roleRolloutAdmin){
                     item.roleRolloutAdmin = false
                 }else {
                     item.roleRolloutAdmin = true
                 }
             }) */
        });

        function getGroupAsset(pageNum, mapAssetLists, selectedAssets) {
            GroupAssets.query(
                {
                    page: pageNum,
                    size: 500,
                },
                onSuccess,
                onError
            );

            function onSuccess(data, headers) {
                vm.multiassets = mapAssetLists;
                data.forEach(function (asset) {
                    if (selectedAssets.indexOf(asset.id) !== -1) {
                        vm.multiassets.push({
                            lat:
                                asset.assetCoordinates[
                                    asset.assetCoordinates.length - 1
                                ].latitude,
                            lng:
                                asset.assetCoordinates[
                                    asset.assetCoordinates.length - 1
                                ].longitude,
                            name: asset.name,
                            layout: asset.assetType.layout,
                            assetType: asset.assetTypeName,
                            assetCoordinates: asset.assetCoordinates,
                            id: asset.id,
                            ownedBy: asset.ownedBy,
                            ticked: true,
                        });
                    } else {
                        try {
                            vm.multiassets.push({
                                lat:
                                    asset.assetCoordinates[
                                        asset.assetCoordinates.length - 1
                                    ].latitude,
                                lng:
                                    asset.assetCoordinates[
                                        asset.assetCoordinates.length - 1
                                    ].longitude,
                                name: asset.name,
                                assetType: asset.assetTypeName,
                                layout: asset.assetType.layout,
                                assetCoordinates: asset.assetCoordinates,
                                id: asset.id,
                                ownedBy: asset.ownedBy,
                                ticked: false,
                            });
                        } catch (e) {
                            // TODO: handle exception
                        }
                    }
                });
                if (vm.assetTotalPage == 0) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.assetTotalPage = Math.ceil(vm.totalItems / 500);
                }

                vm.assetCurrentPage = pageNum;

                if (vm.assetTotalPage > 1) {
                    if (vm.assetCurrentPage != vm.assetTotalPage) {
                        //                        getGroupAsset(pageNum + 1, vm.multiassets, selectedAssets);
                    } else {
                        var lastAsset =
                            vm.multiassets[vm.multiassets.length - 1];
                        if (lastAsset.assetCoordinates.length > 0) {
                            var latestLatLng = {
                                lat: lastAsset.assetCoordinates[0].latitude,
                                lng: lastAsset.assetCoordinates[0].longitude,
                            };
                            map.setCenter(latestLatLng);
                        }
                    }
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function upload() {
            formData = new FormData();

            formData.append("assettype", vm.importassettype.name);
            formData.append("file", $scope.myFile);

            AssetUpload.assetupload(formData, function (response, headers) {
                if (response.status == 200) {
                    vm.error = null;
                    vm.success = "OK";
                    $scope.spreadassetname = "";

                    $timeout(function () {
                        vm.success = "";
                    }, 4000);
                }
                if (response.status == 400) {
                    vm.success = null;
                    vm.error = "error";
                }
            });
        }

        $(":file").filestyle({
            buttonBefore: true,
        });
        // $(":file").filestyle('placeholder', 'Choose File');
        $(":file").filestyle("buttonText", "Browse File");

        //		$scope.importxlsx = /^(.*?)\.(xlsx)$/;
        $scope.importxlsx = /^(.*?)\.(xlsx|kml)$/;

        /* import end */
        vm.createNewFence = function () {
            newFence = true;
            vm.asset.assetCoordinates = [];
            vm.createfence();
        };

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        $("#assetImages").change(function () {
            $scope.allimages = false; // to close preview table
            var allowedTypes = {
                "image/png": true,
                "image/jpg": true,
                "image/jpeg": true,
            };

            uploadFiles("assetImages", allowedTypes);
        });

        $("#assetAttachment").change(function () {
            var allowedTypes = {
                "application/pdf": true,
            };

            uploadFiles("assetAttachment", allowedTypes);
        });

        function uploadFiles(id, allowedTypes, fileReference, referenceId) {
            if (id == "reference") {
                filesSelected = fileReference;
            } else if (id != "reference") {
                var filesSelected = document.getElementById(id).files;
            } //vm.attributeImage = [] 1039
            for (var i = 0; i < filesSelected.length; i++) {
                if (
                    allowedTypes[filesSelected[i].type] &&
                    filesSelected[i].size <= maxSize
                ) {
                    if (id != "reference") {
                        var fileReader = new FileReader();
                        fileReader.onload = function (fileLoadedEvent) {
                            vm.asset.assetImages.push({
                                image: window.btoa(
                                    fileLoadedEvent.target.result
                                ),
                                asset: {
                                    id: entity_old.id,
                                },
                                imageName: fileLoadedEvent.target.name,
                                imageType: fileLoadedEvent.target.type,
                            });
                        };
                        fileReader.name = filesSelected[i].name.split(".")[0];
                        fileReader.type = filesSelected[i].type
                            .split("/")[1]
                            .toUpperCase();
                        fileReader.readAsBinaryString(filesSelected[i]);
                    } else if (id == "reference") {
                        vm.assetRefAttributes.forEach(function (val) {
                            if (val.id == referenceId) {
                                var fileReader_reference = new FileReader();
                                fileReader_reference.onload = function (
                                    fileLoadedEvent
                                ) {
                                    val.attributeValue = window.btoa(
                                            fileLoadedEvent.target.result
                                        );
                                    val.attributeName =  fileLoadedEvent.target.name;
                                    val.attributeType =  fileLoadedEvent.target.type;
                                };
                                fileReader_reference.name = filesSelected[i].name.split(".")[0];
                                fileReader_reference.type = filesSelected[i].type
                                    .split("/")[1]
                                    .toUpperCase();
                                fileReader_reference.readAsBinaryString(
                                    filesSelected[i]
                                );
                            }
                        });
                    }

                    if (
                        vm.fileWarning ||
                        vm.imageWarning ||
                        vm.referenceWarning
                    ) {
                        boolWarning(id, false);
                    }
                } else {
                    boolWarning(id, true);
                }
            }
        }

        function boolWarning(id, bool) {
            switch (id) {
                case "assetAttachment":
                    vm.fileWarning = bool;
                    break;
                case "assetImages":
                    vm.imageWarning = bool;
                    break;
                case "referenceImages":
                    vm.referenceWarning = bool;
                    break;
            }
            $scope.$apply();
        }

        $scope.deleteDisplayImage = function (id) {
            vm.asset.assetImages.splice(id, 1);
            $(":file").filestyle("clear");
        };

        $scope.toggle = function (id) {
            switch (id) {
                case "images":
                    $scope.allimages = !$scope.allimages;
                    break;

                case "pdf":
                    vm.showAttachments = !vm.showAttachments;
                    vm.showPdf = !vm.showPdf;
                    break;

                case "existingImg":
                    vm.showExistingImage = !vm.showExistingImage;
                    vm.showImg = !vm.showImg;
                    break;

                default:
                    console.log("");
            }
            /* //$("#soundtrack").get(0).play();
            
            if ($scope.allimages) {
                AssetImages.query(
                    {
                        assetId: vm.asset.id,
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    vm.assetImages = data;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }*/
        };

        function save() {
            if (vm.asset.assetCoordinates.length > 0) {
                vm.asset.ownedBy = [];
                var parentLat = 0.0;
                var parentLng = 0.0;
                if (vm.parentAssets != null) {
                    vm.parentAssets.forEach(function (value) {
                        if (value.name == vm.selectedParent) {
                            var tempAsset = {};
                            tempAsset.id = value.id;
                            tempAsset.name = value.name;
                            parentLat =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            parentLng =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                            vm.asset.ownedBy.push(tempAsset);
                        }
                    });
                }
                //vm.isSaving = true;
                var fiberDistance = 0.0;
                if (vm.asset.assetType.layout == "SPREAD") {
                    var spreadCoordinates = vm.asset.assetCoordinates;
                    if (spreadCoordinates.length > 0) {
                        for (var index in spreadCoordinates) {
                            if (index > 0) {
                                fiberDistance += distanceCal(
                                    spreadCoordinates[index].latitude,
                                    spreadCoordinates[index].longitude,
                                    spreadCoordinates[index - 1].latitude,
                                    spreadCoordinates[index - 1].longitude
                                );
                            }
                        }
                    }
                    fiberDistance = fiberDistance.toFixed(2);
                    var spreadAV = vm.asset.assetTypeAttributeValues;
                    for (
                        var spreadAssetIndex = 0;
                        spreadAssetIndex < spreadAV.length;
                        spreadAssetIndex++
                    ) {
                        if (
                            spreadAV[spreadAssetIndex].assetTypeAttribute
                                .name === "Fiber Distance (km)"
                        ) {
                            spreadAV[
                                spreadAssetIndex
                            ].attributeValue = fiberDistance;
                        }
                    }
                    vm.asset.assetTypeAttributeValues = spreadAV;
                    // var tempCoordinates = [];
                    // tempCoordinates.push({ latitude: parentLat, longitude: parentLng });
                    // vm.asset.assetCoordinates.forEach(function(value) {
                    //     tempCoordinates.push(value);
                    // });
                    // vm.asset.assetCoordinates = tempCoordinates;
                }

                /* vm.asset.assetTypeAttributeValues.forEach(function (attribute){
                    if(attribute.assetTypeAttribute.attributeDataType.name == 'IMAGE'){
                        attribute.attributeValue =  vm.attributeImage
                    }
                }) 1039 */
                vm.asset.assetReferenceAttributes = [];
                if (vm.assetRefAttributes != null) {
                    for (var i = 0; i < vm.assetRefAttributes.length; i += 3) {
                        var obj = {};

                        obj["assetAttributeName"] = vm.assetRefAttributes[i]
                            ? {
                                  assetTypeAttribute: vm.assetRefAttributes[i],
                                  attributeValue:
                                      vm.assetRefAttributes[i].attributeValue,
                                  order: 0,
                                  popupDisplay:
                                      vm.assetRefAttributes[i]
                                          .assetTypePopupDisplay,
                              }
                            : null;

                        obj["assetAttributeValue"] = vm.assetRefAttributes[
                            i + 1
                        ]
                            ? {
                                  assetTypeAttribute:
                                      vm.assetRefAttributes[i + 1],
                                  attributeValue:
                                      vm.assetRefAttributes[i + 1]
                                          .attributeValue,
                                  order: 1,
                                  popupDisplay:
                                      vm.assetRefAttributes[i + 1]
                                          .assetTypePopupDisplay,
                              }
                            : null;


                        obj["assetAttributeImage"] = vm.assetRefAttributes[
                            i + 2
                        ]
                            ? {
                                  assetTypeAttribute:
                                      vm.assetRefAttributes[i + 2],
                                  image:
                                      vm.assetRefAttributes[i + 2]
                                          .attributeValue,
                                  imageName : vm.assetRefAttributes[i + 2]
                                          .attributeName,
                                  imageType : vm.assetRefAttributes[i + 2]
                                  .attributeType,
                                  imageId : vm.assetRefAttributes[i + 2]
                                  .imageId,
                                  attributeValue: "images",
                                  order: 2,
                                  popupDisplay:
                                      vm.assetRefAttributes[i + 2]
                                          .assetTypePopupDisplay,
                              }
                            : null;
                        vm.asset.assetReferenceAttributes.push(obj);
                    }
                }
                vm.assetTypeReferenceAttributesVal = [];
                vm.asset.assetReferenceAttributes.forEach(function (value) {
                    var assetTypeReferenceAttributesValue = value;
                    vm.assetType.assetTypeReferenceAttributes.forEach(function (
                        assettyperef
                    ) {
                        if (
                            value.assetAttributeName.assetTypeAttribute.id ==
                            assettyperef.assetAttributeName.id
                        ) {
                            assetTypeReferenceAttributesValue.assetRfrncAttribOrder =
                                assettyperef.assetTypeRfrncAttribOrder;
                        }
                    });
                    vm.assetTypeReferenceAttributesVal.push(
                        assetTypeReferenceAttributesValue
                    );
                });
                vm.asset.assetReferenceAttributes =
                    vm.assetTypeReferenceAttributesVal;

                if (vm.asset.id !== null) {
                    Asset.update(vm.asset, onSaveSuccess, onSaveError);
                } else {
                    Asset.save(vm.asset, onSaveSuccess, onSaveError);
                }
            } else {
                vm.selectAssetCordinates = true;
                // alert("Asset Coordinates should not be empty");
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = true;
            if (vm.asset.groups.length > 0) {
                vm.isSaving = false;
                $scope.$emit("trakeyeApp:assetUpdate", result);
                var pageValue = sessionStorage.getItem("prevPage");
                var previousId = sessionStorage.getItem("prevId");
                var prevEditDetail = sessionStorage.getItem("prevEditId");
                var preEditPage = sessionStorage.getItem("firstEditPage");
                var preEditDetailPage = sessionStorage.getItem(
                    "firstEditDetailPage"
                );

                var assetToassetVar = sessionStorage.getItem(
                    "assetCreateToassetEdit"
                );
                var assetTypeToAssetVar = sessionStorage.getItem(
                    "AssetTypeToEditAsset"
                );
                var groupToAssetVar = sessionStorage.getItem(
                    "groupToEditAsset"
                );

                var groupToEditAssetDetailVar = sessionStorage.getItem(
                    "groupToEditAssetDetail"
                );
                var AssetTypeToEditDetailsVar = sessionStorage.getItem(
                    "AssetTypeToEditDetails"
                );
                var assetCreateToassetEditDetailsVar = sessionStorage.getItem(
                    "assetCreateToassetEditDetails"
                );

                if (pageValue == "geofence.new") {
                    $state.go("geofence.new");
                } else if (pageValue == "asset") {
                    $state.go("asset");
                } else if (previousId) {
                    if (
                        preEditPage == "asset" ||
                        groupToAssetVar == "groupToasset" ||
                        assetTypeToAssetVar == "assetTypeToAsset" ||
                        assetToassetVar == "assetToasset"
                    ) {
                        $state.go("asset", {
                            id: previousId,
                        });
                    } else if (preEditPage == "assetEdit") {
                        sessionStorage.setItem(
                            "assetCreateToassetEdit",
                            "assetToasset"
                        );
                        $state.go("asset.edit", {
                            id: previousId,
                        });
                    }
                } else if (prevEditDetail) {
                    if (
                        preEditDetailPage == "assetDetail" ||
                        groupToEditAssetDetailVar == "groupToassetDetail" ||
                        AssetTypeToEditDetailsVar ==
                            "assetTypeToAssetDetails" ||
                        assetCreateToassetEditDetailsVar ==
                            "assetToassetDetails"
                    ) {
                        $state.go("asset", {
                            id: prevEditDetail,
                        });
                    } else if (preEditDetailPage == "assetEditDetails") {
                        sessionStorage.setItem(
                            "assetCreateToassetEditDetails",
                            "assetToassetDetails"
                        );
                        $state.go("asset-detail.edit", {
                            id: prevEditDetail,
                        });
                    }
                } else {
                    $state.go("asset");
                }
            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function selectedAssetTypeAttributes() {
            vm.createfence()
            vm.showFilter = true;
            vm.asset.ownedBy = [];
            //vm.referenceAttribute = [];
            if (vm.parentAssets != null) {
                vm.parentAssets.forEach(function (value) {
                    if (value.name == vm.selectedParent) {
                        var tempAsset = {};
                        tempAsset.id = value.id;
                        tempAsset.lat = value.assetCoordinates[0].latitude;
                        tempAsset.lng = value.assetCoordinates[0].longitude;
                        vm.asset.ownedBy.push(tempAsset);
                    }
                });
            }
            if (vm.assetType) {
                if (vm.assetType.assetTypeReferenceAttributes.length) {
                    vm.assetRefAttributes = [];
                    vm.assetType.assetTypeReferenceAttributes.forEach(function (
                        get
                    ) {
                        get["assetAttributeName"].attributeValue =
                            get["assetAttributeName"].defaultValue;
                        vm.assetRefAttributes.push(get["assetAttributeName"]);
                        get["assetAttributeValue"].attributeValue =
                            get["assetAttributeValue"].defaultValue;
                        vm.assetRefAttributes.push(get["assetAttributeValue"]);
                        vm.assetRefAttributes.push(get["assetAttributeImage"]);
                    });
                }
                if (vm.asset.ownedBy != "") {
                    for (var i = 0; i < vm.multiassets.length; i++) {
                        if (vm.multiassets[i].id == vm.asset.ownedBy[0].id) {
                            if (vm.multiassets[i].layout == "FIXED") {
                                vm.fixedArray = [];
                                var coordinates = {};
                                coordinates.latitude =
                                    vm.multiassets[
                                        i
                                    ].assetCoordinates[0].latitude;
                                coordinates.longitude =
                                    vm.multiassets[
                                        i
                                    ].assetCoordinates[0].longitude;
                                vm.fixedArray.push(coordinates);
                                vm.asset.assetCoordinates = vm.fixedArray;
                                vm.parentLatLng.push({
                                    latitude:
                                        vm.multiassets[i].assetCoordinates[0]
                                            .latitude,
                                    longitude:
                                        vm.multiassets[i].assetCoordinates[0]
                                            .longitude,
                                });
                            }
                        }
                    }
                }

                vm.asset.assetType = vm.assetType;
                if (
                    entity_old.assetType &&
                    vm.assetType.id === entity_old.assetType.id
                ) {
                    vm.asset.assetTypeAttributeValues = [];
                    vm.asset.assetTypeAttributeValues =
                        entity_old.assetTypeAttributeValues;
                } else {
                    vm.asset.assetTypeAttributeValues = [];
                    $.each(
                        vm.assetType.assetTypeAttributes,
                        function (key, value) {
                            vm.asset.assetTypeAttributeValues.push({
                                assetTypeAttribute:
                                    vm.assetType.assetTypeAttributes[key],
                            });
                        }
                    );
                    /* vm.asset.assetReferenceAttributes = [];
                    $.each(
                        vm.assetType.assetTypeReferenceAttributes,
                        function (key, value) {
                            vm.asset.assetReferenceAttributes.push([
                                vm.assetType.assetTypeReferenceAttributes[key]
                            ]);
                        }
                    );
                    var referenceAttribute = [];
                    vm.assetType.assetTypeReferenceAttributes.forEach(function(value){
                        var attrName = {};
                        attrName["assetTypeAttribute"] = value.assetAttributeName;
                        attrName["attributeValue"] = value.assetAttributeName.defaultValue;
                        attrName["order"] = value.assetAttributeName.assetTypeAttribOrder;
                        attrName["popupDisplay"] = value.assetAttributeName.assetTypePopupDisplay;
                        var attrValue = {};
                        attrValue["assetTypeAttribute"] = value.assetAttributeValue;
                        attrValue["attributeValue"] = value.assetAttributeValue.defaultValue;
                        attrValue["order"] = value.assetAttributeValue.assetTypeAttribOrder;
                        attrValue["popupDisplay"] = value.assetAttributeValue.assetTypePopupDisplay;
                        referenceAttribute.push({
                            assetAttributeName: attrName,
                            assetAttributeValue: attrValue
                        });
                    });
                    vm.asset.assetReferenceAttributes = referenceAttribute; */
                }
            }
        }
        vm.createfence = function () {
            var elem = document.getElementById("map_canvas");
            vm.asset.ownedBy = [];
            if (vm.parentAssets != null) {
                vm.parentAssets.forEach(function (value) {
                    if (value.name == vm.selectedParent) {
                        var tempAsset = {};
                        tempAsset.id = value.id;
                        tempAsset.lat = value.assetCoordinates[0].latitude;
                        tempAsset.lng = value.assetCoordinates[0].longitude;
                        vm.asset.ownedBy.push(tempAsset);
                    }
                });
            }
            /* if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                //Firefox
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                //Chrome, Safari & Opera
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                //IE/Edge
                elem.msRequestFullscreen();
            } */

            if (vm.asset.ownedBy == "") {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    {
                        center: {
                            lat: parseFloat(DEFAULT_LATITUDE.value),
                            lng: parseFloat(DEFAULT_LONGITUDE.value),
                        },
                        zoom: 13,
                        fullscreenControl: true,
                        styles: mapStyles(),
                    }
                );
                geoLocation(locations.map);
            } else {
                var coordinates = [];
                if (vm.asset.ownedBy.length > 0) {
                    coordinates.push({
                        lat: vm.asset.ownedBy[0].lat,
                        lng: vm.asset.ownedBy[0].lng,
                    });
                }
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    {
                        center: coordinates[0],
                        zoom: 13,
                        fullscreenControl: true,
                        styles: mapStyles(),
                    }
                );
                geoLocation(locations.map);
            }

            if (vm.assetType.layout == "SPREAD") {
                setGeofences();
                drawingManagerSpread();
                drawingManagerValue("polylinecomplete", locations.map);
            } else if (vm.assetType.layout == "FIXED") {
                setGeofences();
                drawingManagerFixed();
                drawingManagerValue("click", locations.map);
            }

            if (entity.id && entity.id != null && !newFence) {
                if (vm.assetType.layout == "SPREAD") {
                    drawPolyline(function (polyline) {
                        polyline.setMap(locations.map);
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(polyline);
                            }
                        );
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(polyline);
                            }
                        );

                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                    });
                } else if (vm.assetType.layout == "FIXED") {
                    if (vm.asset.assetCoordinates.length > 1) {
                        drawPolyline(function (polyline) {
                            polyline.setMap(locations.map);
                            google.maps.event.addListener(
                                polyline.getPath(),
                                "insert_at",
                                function () {
                                    setGoefenceCoordinate(polyline);
                                }
                            );
                            google.maps.event.addListener(
                                polyline.getPath(),
                                "set_at",
                                function (path) {
                                    setGoefenceCoordinate(polyline);
                                }
                            );

                            vm.drawingManager.setOptions({
                                drawingControl: false,
                            });
                            vm.drawingManager.setMap(null);
                        });
                    } else {
                        var latitudelongitude = {
                            latitude: vm.asset.assetCoordinates.latitude,
                            longitude: vm.asset.assetCoordinates.longitude,
                        };

                        setValues();
                        drawingManagerFixed();
                        drawMarker(locations.map, vm.coOrdinate);
                        // drawFixedAssetImages(vm.coOrdinate);
                    }
                }
            }

            function drawPolyline(callback) {
                setValues();
                JSON.parse(vm.coOrdinate).forEach(function (value, key) {
                    centerlatlng = {
                        lat: value.lat,
                        lng: value.lng,
                    };
                });
                callback(
                    new google.maps.Polyline({
                        path: JSON.parse(vm.coOrdinate),
                        geodesic: true,
                        strokeColor: vm.asset.assetType.colorcode,
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: vm.asset.assetType.colorcode,
                        fillOpacity: 0.3,
                        editable: true,
                    })
                );
                locations.map.setCenter(centerlatlng);
            }

            spreadAssets = [];
            var multiAssetList = vm.multiassets;
            var latlngs = [];
            for (var i = 0; i < multiAssetList.length; i++) {
                var assetCoordinateValues = multiAssetList[i].assetCoordinates;
                if (assetCoordinateValues.length == 1) {
                    latlngs.push({
                        lat:
                            assetCoordinateValues[
                                assetCoordinateValues.length - 1
                            ].latitude,
                        lng:
                            assetCoordinateValues[
                                assetCoordinateValues.length - 1
                            ].longitude,
                        name: multiAssetList[i].name,
                        assetType: multiAssetList[i].assetType,
                    });
                }
                drawPolylineForGeneratedLoc(
                    assetCoordinateValues,
                    map,
                    "yellow"
                );
            }

            for (var i = 0; i < vm.multiassetsLink.length; i++) {
                var assetCoordinateValues =
                    vm.multiassetsLink[i].assetCoordinates;
                drawPolylineForGeneratedLoc(
                    assetCoordinateValues,
                    map,
                    "yellow"
                );
            }

            for (var i = 0; i < latlngs.length; i++) {
                var myLatLng = { lat: latlngs[i].lat, lng: latlngs[i].lng };
                if (
                    latlngs[i].assetType != "WDM" &&
                    latlngs[i].assetType != "Router" &&
                    latlngs[i].assetType != "NTTN" &&
                    latlngs[i].assetType != "Others" &&
                    latlngs[i].assetType != "BackToBack"
                ) {
                    createMarkerOfAllAssets(myLatLng, map, latlngs[i].name);
                }
            }

            for (var i = 0; i < multiAssetList.length; i++) {
                var array_element = multiAssetList[i];
                if (array_element.layout == "SPREAD") {
                    spreadAssets.push(array_element);
                }
            }
            for (var i = 0; i < spreadAssets.length; i++) {
                var spreadAssetAC = spreadAssets[i].assetCoordinates;
                for (var j = 0; j < spreadAssetAC.length; j++) {
                    if (j > 0) {
                        var locValues = [];
                        locValues.push(spreadAssetAC[j - 1]);
                        locValues.push(spreadAssetAC[j]);
                        drawPolylineForGeneratedLoc(locValues, map, "black");
                    }
                }
            }
        };

        function navigateCreateAsset() {
            var previousId = sessionStorage.getItem("prevId");
            var editDetailValue = sessionStorage.getItem("prevEditId");
            sessionStorage.setItem("firstEditPage", "assetEdit");
            sessionStorage.setItem("firstEditDetailPage", "assetEditDetails");
            if (previousId) {
                $state.go("asset.new", {
                    id: previousId,
                });
            }
            if (editDetailValue) {
                $state.go("asset.new", {
                    id: editDetailValue,
                });
            }
        }

        function navigateCreateGroup() {
            sessionStorage.setItem("createGroup", "createAssetToCreateGroup");
            $state.go("group.new", {});
            // var previousId = sessionStorage.getItem("prevId");
            // var editDetailValue = sessionStorage.getItem("prevEditId");
            // console.log('previousId', previousId);
            // console.log('editDetailValue', editDetailValue);
            // if (previousId) {
            //     $state.go("group.new", {
            //         id: previousId
            //     });
            // } else if (editDetailValue) {
            //     $state.go("group.new", {
            //         id: editDetailValue
            //     });
            // }
        }

        function navigateAssetType() {
            sessionStorage.setItem(
                "createAssetType",
                "createAssetToCreateAssetType"
            );
            $state.go("asset-type.new", {});
            // var pageValue = sessionStorage.getItem("prevId");
            // var editDetailValue = sessionStorage.getItem("prevEditId");
            // if (pageValue) {
            //     $state.go("asset-type.new", {
            //         id: pageValue
            //     });
            // } else if (editDetailValue) {
            //     $state.go("asset-type.new", {
            //         id: editDetailValue
            //     });
            // }
        }

        function createMarkerOfAllAssets(myLatLng, map, myLocName, index) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    scaledSize: new google.maps.Size(24, 24),
                    origin: new google.maps.Point(0, 0),
                    url: "content/images/yellow.png",
                    anchor: new google.maps.Point(16, 16),
                },
                //                label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: myLocName, backgroundcolor: "#ff9800" },
            });
        }

        function setGeofences() {
            var isUserAdmin = false;
            vm.userAdmin.authorities.forEach(function (val) {
                if (val == "ROLE_USER_ADMIN") {
                    isUserAdmin = true;
                }
                if (val == "ROLE_HOD") {
                    isUserAdmin = true;
                }
            });
            if (isUserAdmin) {
                // Geofence.query({
                //     page: 0,
                //     size: 500,
                // }, onSuccess, onError);

                // function onSuccess(data, headers) {
                //     vm.selectedGeofence = [];
                //     data.forEach(function (value) {
                //         if (value.zone) {
                //             value.type = "MASTER";
                //         } else {
                //             value.type = "MINI";
                //         }
                //         vm.selectedGeofence.push(value);
                //     });
                //     drawLatestGeofence(vm.selectedGeofence);
                // }

                // function onError(error) {
                //     // AlertService.error(error.data.message);
                // }

                GeofenceIDs.getAll(function (response) {
                    vm.selectedGeofence = [];
                    response.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.selectedGeofence.push(value);
                    });
                    drawLatestGeofence(vm.selectedGeofence);
                });
            } else {
                drawLatestGeofence(vm.userGeofenceList);
            }
        }

        function drawLatestGeofence(response) {
            if (response) {
                initializeGeofenceMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // function() {
                    $.each(response, function (index, value) {
                        try {
                            if (
                                value.type != "MASTER" &&
                                value.coordinates != undefined
                            ) {
                                var path = JSON.parse(value.coordinates);
                                // drawPolylineForGeoFence(path, locations.map, value.name);
                                var infowindow = new google.maps.InfoWindow({
                                    content:
                                        '<div class="infoWindowhead">' +
                                        "name" +
                                        '<div class="infoWindowContent"> <b>Description :</b> ' +
                                        "des" +
                                        "</div></div>",
                                });

                                infowindow.setPosition(latlang);
                                var tempGeofences = new google.maps.Polyline({
                                    path: path,
                                    geodesic: true,
                                    strokeColor: "#ff0000",
                                    strokeOpacity: 0.5,
                                    strokeWeight: 3,
                                });
                                google.maps.event.addListener(
                                    tempGeofences,
                                    "mouseout",
                                    function (event) {
                                        infowindow.close();
                                    }
                                );

                                google.maps.event.addListener(
                                    tempGeofences,
                                    "click",
                                    function (event) {
                                        if (openedInfoWindow != null) {
                                            openedInfoWindow.close();
                                        }
                                        infowindow.setContent(
                                            '<div class="infoWindowhead">' +
                                                "<b>Geofence Name : </b><br><br>" +
                                                value.name +
                                                "</br></div>"
                                        );

                                        infowindow.mousemove;
                                        infowindow.open(locations.map);
                                        infowindow.setPosition(event.latLng);
                                        openedInfoWindow = infowindow;
                                    }
                                );
                                tempGeofences.setMap(locations.map);
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    });
                });
            }
        }

        function initializeGeofenceMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        function drawingManagerSpread() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYLINE,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["polyline"],
                },
                polylineOptions: {
                    fillColor: "#ffff00",
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: true,

                    editable: true,
                    zIndex: 1,
                    geodesic: true,
                },
            });
        }

        function drawingManagerFixed() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["marker"],
                },
                markerOptions: {
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        // url : "data:image/png;base64," +
                        // vm.asset.assetType.image,
                        // url : vm.asset.assetType.imagePath,
                        anchor: new google.maps.Point(16, 16),
                    },
                },
            });
        }

        var recursiveOwnedByAsset = function (ownedBy) {
            var names = [];
            if (ownedBy.length > 0) {
                if (ownedBy[0].ownedBy != null) {
                    if (ownedBy[0].ownedBy.length > 0) {
                        var assetCoordinateValues2 = ownedBy[0].ownedBy;
                        names.push({
                            lat:
                                assetCoordinateValues2[0].assetCoordinates[0]
                                    .latitude,
                            lng:
                                assetCoordinateValues2[0].assetCoordinates[0]
                                    .longitude,
                        });
                        if (assetCoordinateValues2.length > 0) {
                            Array.prototype.push.apply(
                                names,
                                recursiveOwnedByAsset(assetCoordinateValues2)
                            );
                        }
                    }
                }
            }
            return names;
        };

        function drawPolylineForGeneratedLoc(latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];
            $.each(latlngsToDraw, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var midLatLng = {
                    lat:
                        spreadAssetCoordinates[
                            spreadAssetCoordinates.length - 1
                        ].lat,
                    lng:
                        spreadAssetCoordinates[
                            spreadAssetCoordinates.length - 1
                        ].lng,
                };
                var infowindow = new google.maps.InfoWindow({
                    content:
                        '<div class="infoWindowhead">' +
                        "name" +
                        '<div class="infoWindowContent"> <b>Description :</b> ' +
                        "des" +
                        "</div></div>",
                });
                infowindow.setPosition(midLatLng);

                var ColorValue = "#ff0000";
                if (color == "red") {
                    ColorValue = "#ff0000";
                } else if (color == "black") {
                    ColorValue = "#000000";
                } else if (color == "yellow") {
                    ColorValue = "#F4A500";
                } else {
                    ColorValue = "#208000";
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue,
                });

                polylinepath.setMap(map);
            }
        }

        function drawingManagerValue(option, map) {
            var parent = {};
            // for (var i = 0; i < vm.multiassets.length; i++) {
            //     if (vm.multiassets[i].ticked == true) {
            //         parent = vm.multiassets[i];
            //     }
            // }
            if (vm.parentAssets && vm.parentAssets.length > 0) {
                for (var i = 0; i < vm.parentAssets.length; i++) {
                    if (vm.parentAssets[i].status == true) {
                        parent = vm.parentAssets[i];
                    }
                }
            }
            if (parent.id != null) {
                AssetByID.get(parent.id, function (response) {
                    parent = response;
                    var latlngs = [];
                    try {
                        var len = parent.ownedBy;
                        var assetCoordinateValuesParent =
                            parent.assetCoordinates;
                        latlngs.push({
                            lat:
                                assetCoordinateValuesParent[
                                    assetCoordinateValuesParent.length - 1
                                ].latitude,
                            lng:
                                assetCoordinateValuesParent[
                                    assetCoordinateValuesParent.length - 1
                                ].longitude,
                        });

                        if (len.length > 0) {
                            var assetCoordinateValues = len[0].assetCoordinates;
                            latlngs.push({
                                lat:
                                    assetCoordinateValues[
                                        assetCoordinateValues.length - 1
                                    ].latitude,
                                lng:
                                    assetCoordinateValues[
                                        assetCoordinateValues.length - 1
                                    ].longitude,
                            });

                            if (recursiveOwnedByAsset(len) != null) {
                                Array.prototype.push.apply(
                                    latlngs,
                                    recursiveOwnedByAsset(len)
                                );
                            }
                        }

                        for (var i = 0; i < latlngs.length; i++) {
                            createMarker(latlngs[i], map, i);
                        }

                        if (latlngs.length > 0) {
                            moveToLocation(latlngs[0].lat, latlngs[0].lng, map);
                            map.setZoom(16);
                        }
                    } catch (err) {
                        var event232 = err;
                    }
                });
            }

            if (option == "polylinecomplete") {
                vm.selectAssetCordinates = false;
                google.maps.event.addListener(
                    vm.drawingManager,
                    option,
                    function (event) {
                        google.maps.event.addListener(
                            event.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(event);
                            }
                        );
                        google.maps.event.addListener(
                            event.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(event);
                            }
                        );
                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                        setGoefenceCoordinate(event);
                    }
                );
                var assetCoorVal = [];

                vm.parentLatLng.forEach(function (value) {
                    assetCoorVal.push(value);
                });
                vm.asset.assetCoordinates.forEach(function (assetlatlng) {
                    assetCoorVal.push(assetlatlng);
                });
                vm.asset.assetCoordinates = assetCoorVal;
                vm.drawingManager.setMap(map);
            } else if (option == "click") {
                vm.selectAssetCordinates = false;
                google.maps.event.addListener(map, "click", function (e) {
                    placeMarker(e.latLng, map);
                    vm.fixedArray = [];
                    var coordinates = {};
                    coordinates.latitude = e.latLng.lat();
                    coordinates.longitude = e.latLng.lng();
                    vm.fixedArray.push(coordinates);
                    vm.asset.assetCoordinates = vm.fixedArray;
                });
            }
        }

        function moveToLocation(lat, lng, map) {
            var center = new google.maps.LatLng(lat, lng);
            // using global variable:
            map.panTo(center);
        }

        function createMarker(myLatLng, map, index) {
            if (index == 0) {
                var marker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon:
                        "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                    animation: google.maps.Animation.DROP,
                });
            } else {
                var marker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon:
                        "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
                });
            }
        }

        var marker;

        function placeMarker(location, map) {
            if (marker) {
                marker.setPosition(location);
            } else {
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        // url : "data:image/png;base64," +
                        // vm.asset.assetType.image,
                        // url : vm.asset.assetType.imagePath,
                        anchor: new google.maps.Point(16, 16),
                    },
                });
            }
        }
        $scope.mapEvents = {
            click: function () {},
        };

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                    Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                    Math.cos(degrees_to_radians(lat2)) *
                    Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

        function setGoefenceCoordinate(event) {
            vm.assetCoordinateValues = [];
            vm.asset.assetCoordinates = [];

            var radius = event.getPath();
            for (var i = 0; i < radius.getLength(); i++) {
                var coordinates = {};
                coordinates.latitude = radius.getAt(i).lat();
                coordinates.longitude = radius.getAt(i).lng();
                vm.asset.assetCoordinates.push(coordinates);
            }
        }

        function setValues() {
            vm.coOrdinates = [];
            for (var i = 0; i < vm.asset.assetCoordinates.length; i++) {
                vm.coOrdinates.push({
                    lat: vm.asset.assetCoordinates[i].latitude,
                    lng: vm.asset.assetCoordinates[i].longitude,
                });
                if (i == vm.asset.assetCoordinates.length - 1) {
                    vm.coOrdinate = JSON.stringify(vm.coOrdinates);
                }
            }
        }

        function drawMarker(map, response) {
            $.each(JSON.parse(response), function (index, value) {
                centerlatlng = {
                    lat: value.lat,
                    lng: value.lng,
                };

                var startMarker = new google.maps.Marker({
                    map: map,
                    position: new google.maps.LatLng(value.lat, value.lng),

                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        // url : "data:image/png;base64," +
                        // vm.asset.assetType.image,
                        // url : vm.asset.assetType.imagePath,
                        anchor: new google.maps.Point(16, 16),
                    },
                });
            });
            map.setCenter(centerlatlng);
        }

        function filterAssetsOnMapView() {
            $("#mapFilterModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none";
            vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
        }

        function closeMapFilterModal() {
            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
        }

        function saveFilter() {
            vm.mapAssets = [];

            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 16,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                var elem = document.getElementById("map_canvas");
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    /* Firefox */
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) {
                    /* Chrome, Safari & Opera */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) {
                    /* IE/Edge */
                    elem.msRequestFullscreen();
                }

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(16, locations.latlng)
                );
                geoLocation(locations.map);

                getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
                vm.prevSelectedGeofenceId = vm.selectedGeofenceId;

                if (vm.assetType.layout == "SPREAD") {
                    setGeofences();
                    drawingManagerSpread();
                    drawingManagerValue("polylinecomplete", locations.map);
                } else if (vm.assetType.layout == "FIXED") {
                    setGeofences();
                    drawingManagerFixed();
                    drawingManagerValue("click", locations.map);
                }

                $("#mapFilterModal").removeClass("in");
                $(".modal-backdrop").remove();
                $("#mapFilterModal").hide();
            } else {
                /* var myOptions = {
                    zoom: 16,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(16, locations.latlng)
                );
                geoLocation(locations.map);

                getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
                vm.prevSelectedGeofenceId = vm.selectedGeofenceId;

                if (vm.assetType.layout == "SPREAD") {
                    setGeofences();
                    drawingManagerSpread();
                    drawingManagerValue("polylinecomplete", locations.map);
                } else if (vm.assetType.layout == "FIXED") {
                    setGeofences();
                    drawingManagerFixed();
                    drawingManagerValue("click", locations.map);
                }

                $("#mapFilterModal").removeClass("in");
                $(".modal-backdrop").remove();
                $("#mapFilterModal").hide();
            }
        }

        function getGroupAssetsFromES(
            geofenceIdVal,
            lastAssetId,
            mapAssetLists
        ) {
            AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;

                    vm.mapAssets.push(tmpAsset);
                });
                drawLatestAssets(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupAssetsFromES(
                        geofenceIdVal,
                        data.lastId,
                        vm.mapAssets
                    );
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].longitude,
                            };
                            locations.map.setCenter(assetLatLng);
                        });
                    }
                }
            });
        }

        function drawLatestAssets(response) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                            value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    drawFixedAsset(value1, false);
                                } else {
                                    drawFixedAsset(value, false);
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                drawPolyline(value, locations.map);
                            }
                        });
                    });
                });
            }
        }

        function initializeAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            lngVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            // callback(new google.maps.LatLng("12.9716", "77.5946"));
                            callback(
                                new google.maps.LatLng(
                                    DEFAULT_LATITUDE.value,
                                    DEFAULT_LONGITUDE.value
                                )
                            );
                        }
                    );
                } else {
                    callback(
                        new google.maps.LatLng(
                            DEFAULT_LATITUDE.value,
                            DEFAULT_LONGITUDE.value
                        )
                    );
                }
            }
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 16,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(16, locations.latlng)
                );
                geoLocation(locations.map);

                google.maps.event.addListener(
                    locations.map,
                    "zoom_changed",
                    function () {
                        vm.zoomLevel = locations.map.getZoom();
                        if (
                            (vm.prevZoomLevel == 17 && vm.zoomLevel == 18) ||
                            (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)
                        ) {
                            drawLatestAssets(vm.mapAssets);
                        }
                        vm.prevZoomLevel = vm.zoomLevel;
                    }
                );
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () {};
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");
            callback();
        }

        function drawPolyline(spread, map) {
            var spreadAssetCoordinates = [];
            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spread.assetTypeColor;
                }
                var polylineWeight = 2.5;
                var strokeOpacityVal = 1.0;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }

                                var userContent = document.createElement("div"),
                                    button;

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    "<b>Name : </b> " +
                                    spread.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km</br>";

                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });

                                google.maps.event.addDomListener(
                                    button,
                                    "click",
                                    function () {
                                        ChildAssets.query(
                                            {
                                                parentId: spread.id,
                                            },
                                            onSuccess
                                        );

                                        function onSuccess(data, headers) {
                                            if (
                                                spread.assetType.name == "432FR"
                                            ) {
                                                $("#ribbonPathModal").show();
                                                try {
                                                    var assetCoordinateValues =
                                                        spread.assetCoordinates;
                                                    latlngs.push({
                                                        lat:
                                                            assetCoordinateValues[
                                                                assetCoordinateValues.length -
                                                                    1
                                                            ].latitude,
                                                        lng:
                                                            assetCoordinateValues[
                                                                assetCoordinateValues.length -
                                                                    1
                                                            ].longitude,
                                                    });
                                                } catch (err) {
                                                    var event232 = err;
                                                }
                                                showFiberDetails(
                                                    spread,
                                                    data,
                                                    spread.assetCoordinates[
                                                        spread.assetCoordinates
                                                            .length - 1
                                                    ].latitude,
                                                    spread.assetCoordinates[
                                                        spread.assetCoordinates
                                                            .length - 1
                                                    ].longitude,
                                                    latlngs
                                                );
                                            } else {
                                                $("#cablePathModal").show();
                                                try {
                                                    var assetCoordinateValues =
                                                        spread.assetCoordinates;
                                                    latlngs.push({
                                                        lat:
                                                            assetCoordinateValues[
                                                                assetCoordinateValues.length -
                                                                    1
                                                            ].latitude,
                                                        lng:
                                                            assetCoordinateValues[
                                                                assetCoordinateValues.length -
                                                                    1
                                                            ].longitude,
                                                    });
                                                } catch (err) {
                                                    var event232 = err;
                                                }
                                                showFiberDetails(
                                                    spread,
                                                    data,
                                                    spread.assetCoordinates[
                                                        spread.assetCoordinates
                                                            .length - 1
                                                    ].latitude,
                                                    spread.assetCoordinates[
                                                        spread.assetCoordinates
                                                            .length - 1
                                                    ].longitude,
                                                    latlngs
                                                );
                                            }
                                        }
                                    }
                                );
                            });
                        }
                        if (infowindow != null) {
                            infowindow.setPosition(event.latLng);
                            infowindow.open(locations.map);
                            openedInfoWindow = infowindow;
                        }
                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locations.map);

                polylines.push(polylinepath);
            }
        }

        function drawFixedAsset(fixed, hasParent) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                    },
                });

                // if (vm.zoomLevel == 10) {
                //     startMarker.setLabel('');
                // } else if (vm.zoomLevel == 11) {
                //     var label = { color: '#000000', fontWeight: 'bold', fontSize: '12px', text: fixed.name };
                //     startMarker.setLabel(label);
                // }

                // if (fixed.status != null &&
                //     fixed.status === false) {
                //     startMarker.setLabel({
                //         color: 'red',
                //         fontSize: '30px',
                //         fontWeight: '20px',
                //         text: '\u2297'
                //     });
                // }
                // Add marker to the array.
                markers.push(startMarker);

                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    startMarker.title +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        AssetByID.get(fixed.id, function (response) {
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                buttonA,
                                buttonB,
                                buttonC,
                                buttonD;
                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                startMarker.title +
                                '</div><div class="infoWindowContent">' +
                                "<b>Lat</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Long</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "<br>" +
                                infoStr +
                                "</div>";

                            var infoWindow2 = new google.maps.InfoWindow({
                                content: userContent,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            infoWindow2.open(locations.map, startMarker);
                            setTimeout(function () {
                                infoWindow2.close();
                            }, 5000);

                            activeInfoWindow = infoWindow2;
                            prevInfoWindow = infoWindow2;
                        });
                    }
                );
                openedInfoWindow = infoWindow2;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetDetailController', AssetDetailController);

    AssetDetailController.$inject = ['$scope', '$rootScope', '$stateParams','$state', 'pagingParams', 'ParseLinks', 'paginationConstants','previousState', 'entity', 'Asset', 'User', 'AssetType','$localStorage','Configs','MappedFixedAssets'];

    function AssetDetailController($scope, $rootScope, $stateParams,$state, pagingParams, ParseLinks, paginationConstants,previousState, entity, Asset, User, AssetType,$localStorage,Configs,MappedFixedAssets) {
        var vm = this;

        vm.asset = entity;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        $scope.tab = 1;
        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };
        $scope.setTab = function (newTab) {
            $scope.tab = newTab; 
            if ($scope.tab == 2) { 
                MappedFixedAssets.get(vm.asset.id,pagingParams.page - 1,vm.itemsPerPage, function(response){
                    vm.links = ParseLinks.parse(response.headers("link"));
                    vm.totalItems = response.headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.totalItems = Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                    vm.listMappedAssets = response.data
                    vm.page = pagingParams.page;
                })
            }
        }
        vm.previousState = previousState.name;
        //vm.showAssetImage = false

        /* Configs.get("AssetImage",function(response){
            if(response.length > 0){
                if(response[0].configValue == "True"){
                    vm.showAssetImage = true
                }
            }
        }) */
        if(vm.asset.assetReferenceAttributes.length){
            vm.assetRefAttributes = []
            vm.asset.assetReferenceAttributes.forEach(function (get){
                if (get["assetAttributeName"] != null) {
                    get['assetAttributeName'].assetTypeAttribute.attributeValue = get['assetAttributeName'].attributeValue;
                    vm.assetRefAttributes.push(get['assetAttributeName'].assetTypeAttribute);
                }

                if (get["assetAttributeValue"] != null) {
                    get['assetAttributeValue'].assetTypeAttribute.attributeValue = get['assetAttributeValue'].attributeValue;
                    vm.assetRefAttributes.push(get['assetAttributeValue'].assetTypeAttribute);
                }

                if (get["assetAttributeImage"] != null) {
                    get['assetAttributeImage'].assetTypeAttribute.imageId = get['assetAttributeImage'].imageId;
                    get['assetAttributeImage'].assetTypeAttribute.attributeName = get['assetAttributeImage'].imageName;
                    vm.assetRefAttributes.push(get['assetAttributeImage'].assetTypeAttribute);
                }
            })
        }

       /*  vm.imageInNewTab = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
            );
            imgWindow.document.close(); 
		}; */
        vm.transition = function transition() {
          /*  if(vm.queryCount )
            MappedFixedAssets.get(vm.asset.id,vm.page,vm.itemsPerPage, function(response){
                vm.links = ParseLinks.parse(response.headers("link"));
                vm.totalItems = response.headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.totalItems = Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                vm.listMappedAssets = response.data
                vm.page = pagingParams.page;
            }) */
        }

        $scope.newTabDisplay = function(id,name){
            var request = new XMLHttpRequest(),apiImage = name == 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";;
            request.open('GET',apiImage+vm.asset.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                window.open(imageUrl, "_blank")}
            } 
            request.send();
        } 

        var unsubscribe = $rootScope.$on('trakeyeApp:assetUpdate', function(event, result) {
            vm.asset = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetDeleteController',AssetDeleteController);

    AssetDeleteController.$inject = ['$uibModalInstance', 'entity', 'Asset'];

    function AssetDeleteController($uibModalInstance, entity, Asset) {
        var vm = this;

        vm.asset = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Asset.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetConnectController',
			AssetConnectController);

	AssetConnectController.$inject = [ '$timeout', '$scope', '$stateParams','AlertService',
			'entity', 'Asset', 'User', 'AssetType', '$state', 'AssetUpload',
			'AllAssetsTypes', 'AllCustomAssetTypeAttribute', 'AssetIDs','AssetByID' ];

	function AssetConnectController($timeout, $scope, $stateParams, AlertService, entity,
			Asset, User, AssetType, $state, AssetUpload, AllAssetsTypes,
			AllCustomAssetTypeAttribute, AssetIDs,AssetByID) {
		var vm = this;
//		var entity_old = angular.copy(vm.asset);
		vm.asset = entity;
		vm.generatedasset = null;
		vm.childAsset =  null;
		vm.parentName = null;
		vm.clear = clear;
		vm.save = save;
		vm.assetType = entity.assetType;

		vm.upload = upload;
		vm.assettypes = loadPage();
		vm.coOrdinates = [];
		vm.coOrdinate = null;
		vm.isAutomatic = true;
		vm.isRoadLeft = true;
		vm.isSiteASelected = false;
		vm.isSiteBSelected = false;
		vm.selectedSiteA = {};
		vm.selectedSiteB = {};
		var isSaved = false;

		var newFence = false;
		var latlng;
		var locations = {};
		var centerlatlng = null;
		vm.customAttributesMap = {};
		var formData;
		var spreadAssets = [];
		vm.isSaving = true;

		function loadPage() {
            vm.assestList = [];
			vm.multiassets = [];
			var selctedAssets = [];

			if (vm.asset.id != null) {
				vm.asset.ownedBy.forEach(function(asset) {
					selctedAssets.push(asset.id);
				})
			}

			AssetIDs.getAll(function(response) {
				response.forEach(function(asset) {
					vm.assestList.push(asset);
					if(asset.assetTypeName == "Site"){
						if (selctedAssets.indexOf(asset.id) !== -1) {
							vm.multiassets.push({
								lat : asset.assetCoordinates[asset.assetCoordinates.length-1].latitude,
								lng : asset.assetCoordinates[asset.assetCoordinates.length-1].longitude,
								name : asset.name,
								assetType : asset.assetType,
								assetCoordinates : asset.assetCoordinates,
								id : asset.id,
								ownedBy : asset.ownedBy,
								ticked : true
							});
						} else {
							try {
								vm.multiassets.push({
									lat : asset.assetCoordinates[asset.assetCoordinates.length-1].latitude,
									lng : asset.assetCoordinates[asset.assetCoordinates.length-1].longitude,
									name : asset.name,
									assetType : asset.assetType,
									assetCoordinates : asset.assetCoordinates,
									id : asset.id,
									ownedBy : asset.ownedBy,
									ticked : false
								});
							} catch (e) {
								// TODO: handle exception
							}

						}
					}
				});
			});

			AllAssetsTypes.getAll(function(response) {
				vm.assettypes = response;
			});

			AllCustomAssetTypeAttribute.getAll(function(response) {
				response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customAssetTypeAttributeValues;
				});
			});
			$( "#connectTypeRadio1").prop('checked', true);
			$( "#roadSideRadio1").prop('checked', true);
		}

		function upload() {
			formData = new FormData();

			formData.append("assetname", $scope.assetname);
			formData.append('file', $scope.myFile);

			AssetUpload.assetupload(formData, function(response, headers) {
				if (response.status == 200) {
					vm.error = null;
					vm.success = 'OK';
					$scope.spreadassetname = '';

					$timeout(function() {
						vm.success = '';
					}, 4000);

				}
				if (response.status == 400) {
					vm.success = null;
					vm.error = 'error';

				}
			});

		}

        $(".select2").select2();

  		$("#fromAssetsView").change(function () {
			$("#toAssetsView")[0].selectedIndex = 0;
			var result = $("#fromAssetsView").val();
			if(result != null){
				for (var i = 0; i < vm.multiassets.length; i++) {
					if (vm.multiassets[i].id == result) {
						vm.selectedSiteA = vm.multiassets[i];
					}
				}
				vm.isSiteASelected = true;
			}
		});

		$("#toAssetsView").change(function () {
			if(vm.isSiteASelected == true){
				var result = $("#toAssetsView").val();
				if(result != null){
					for (var i = 0; i < vm.multiassets.length; i++) {
					if (vm.multiassets[i].id == result) {
						vm.selectedSiteB = vm.multiassets[i];
					}
				}
					vm.isSiteBSelected = true;
				}
			}else{
				$("#toAssetsView")[0].selectedIndex = 0;
				alert("Please Select Site A");
			}

		});

		/* import end */
		vm.createNewFence = function() {
			newFence = true;
			vm.asset.assetCoordinates = [];
			vm.createfence();
		}

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		function clear() {
			//$uibModalInstance.dismiss('cancel');
			
		}

		function save() {
			if(vm.fiberowner != null){
				if(vm.isSiteASelected == false && vm.isSiteBSelected == false){
					alert("Please Select Site A");
				}else if(vm.isSiteASelected == true && vm.isSiteBSelected == false){
					alert("Please Select Site B");
				}else {
					vm.assestList.forEach(function(assetVal){
						if (assetVal.name == vm.asset.name) {
							alert("site A and site B already exist in assetsList");
						} else {
							vm.asset.assetTypeAttributeValues = [];
							var disVal = 0.0;
							var spreadCoordinates = vm.asset.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
                                        }
                                    }
                                }
							vm.asset.assetType.assetTypeAttributes.forEach(function(assetAttrVal){
								if(assetAttrVal.name == "Fiber Owner"){
									vm.asset.assetTypeAttributeValues.push(
										{
											attributeValue : vm.fiberowner,
											assetTypeAttribute : assetAttrVal
										}
									)
								}else if(assetAttrVal.name == "Fiber Distance (km)"){
									vm.asset.assetTypeAttributeValues.push(
										{
											attributeValue : disVal.toFixed(2),
											assetTypeAttribute : assetAttrVal
										}
									)
								}else{
									vm.asset.assetTypeAttributeValues.push(
										{
											attributeValue : assetAttrVal.defaultValue,
											assetTypeAttribute : assetAttrVal
										}
									)
								}
								
							});
							vm.isSaving = true;
							if(!isSaved){
								Asset.save(vm.asset, onSaveSuccess, onSaveError);
								isSaved = true;
							}
						}
					})
				}
			}else{
				alert("Please Enter Fiber Owner Name");
			}
		}

		function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return (dist);
            }
        }


        function moveToLocation(lat, lng, map) {
            var center = new google.maps.LatLng(lat, lng);
            map.panTo(center);
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

		function onSaveSuccess(result) {
			isSaved = true;
			$scope.$emit('trakeyeApp:assetUpdate', result);
			vm.isSaving = false;
			$state.go('asset');
		}

		function onSaveError() {
			vm.isSaving = false;
		}

//		function onSaveSuccess(result) {
//			$scope.$emit('trakeyeApp:assetUpdate', result);
//			vm.isSaving = false;
//			$state.go('asset');
//		}
//
//		function onSaveError() {
//			vm.isSaving = false;
//		}

		vm.createfence = function() {
			if (vm.selectedSiteA.name == vm.selectedSiteB.name) {
				alert("same asset Name is not valid")
			} else {
			var connectTypeVal = $('input[name=connectTypeRdo]:checked').val();
			if(connectTypeVal == "Automatic"){
				vm.isAutomatic = true;
			}else{
				vm.isAutomatic = false;
			}
		
			var roadSiteVal = $('input[name=RoadSideRdo]:checked').val();
			if(roadSiteVal == "Left"){
				vm.isRoadLeft = true;
			}else{
				vm.isRoadLeft = false;
			}

			

			if(vm.isSiteASelected == false && vm.isSiteBSelected == false){
				alert("Please Select Site A");
			}else if(vm.isSiteASelected == true && vm.isSiteBSelected == false){
				alert("Please Select Site B");
			}else{
				var siteALatLng = new google.maps.LatLng(vm.selectedSiteA.assetCoordinates[0].latitude, vm.selectedSiteA.assetCoordinates[0].longitude);
				var siteBLatLng = new google.maps.LatLng(vm.selectedSiteB.assetCoordinates[0].latitude, vm.selectedSiteB.assetCoordinates[0].longitude);
				var map = new google.maps.Map(document.getElementById('map_canvas'), {
					center : siteALatLng,
					zoom : 16,
					fullscreenControl: true
				});
				createMarker(map, vm.selectedSiteA.name, siteALatLng);
				createMarker(map, vm.selectedSiteB.name, siteBLatLng);
			
				if(vm.isAutomatic){
					var generatedAssetVal = {};
					if(vm.isRoadLeft){
						generatedAssetVal = getShortestRoute(vm.selectedSiteA, vm.selectedSiteB, map);
					}else{
						generatedAssetVal = getShortestRoute(vm.selectedSiteB, vm.selectedSiteA, map);
					}
					
					if(generatedAssetVal != null){
						vm.asset = generatedAssetVal;
					}
				}else{
					var newAsset = {
						name: '',
						assetCoordinates: []
					};
					newAsset.name = vm.selectedSiteA.name+"-"+vm.selectedSiteB.name;
					AssetType.query({}, function (data) {
                        data.forEach(function (item) {
                            if (item.name == "Link") {
                                newAsset.assetType = item;
                            }
                        });
					});
					drawingManagerSpread();
					drawingManagerValue('polylinecomplete', map, newAsset);
				}
				
			}
			vm.isSaving = false;
		  }
		};

		function getShortestRoute(SiteA, SiteB, map){
			var pointA = new google.maps.LatLng(SiteA.assetCoordinates[0].latitude, SiteA.assetCoordinates[0].longitude);
            var pointB = new google.maps.LatLng(SiteB.assetCoordinates[0].latitude, SiteB.assetCoordinates[0].longitude);

            var newAsset = {
                name: '',
                assetCoordinates: []
            };
            newAsset.name = SiteA.name+"-"+SiteB.name;

            var directionsService = new google.maps.DirectionsService;
            var myOptions = {
                zoom: 14,
                center: pointA,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var polylineOptionsActual = new google.maps.Polyline({
                strokeColor: '#ff0000',
                strokeOpacity: 0.5,
                strokeWeight: 4
            });
            var directionsDisplay = new google.maps.DirectionsRenderer({
                map: map,
                polylineOptions: polylineOptionsActual,
                suppressMarkers: true
            });

            directionsService.route({
                origin: pointA,
                destination: pointB,
                avoidTolls: true,
                avoidHighways: false,
                travelMode: google.maps.TravelMode.DRIVING
            }, function (response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
                    var responsePath = response.routes[0].overview_path;
                    vm.fixedArray = [];
                    responsePath.forEach(function (value) {
                        var coordinates = {};
                        coordinates.latitude = value.lat();
                        coordinates.longitude = value.lng();
                        vm.fixedArray.push(coordinates);
                    });
                    newAsset.assetCoordinates = vm.fixedArray;
                    newAsset.layout == 'SPREAD';

                    AssetType.query({}, function (data) {
                        data.forEach(function (item) {
                            if (item.name == "Link") {
                                newAsset.assetType = item;
                            }
                        });
                    });
                } else {
					window.alert('Directions request failed due to ' + status);
                }
			});
			return newAsset;
		}
		function drawingManagerSpread() {
			vm.drawingManager = new google.maps.drawing.DrawingManager({
				drawingMode : google.maps.drawing.OverlayType.POLYLINE,
				drawingControl : true,
				drawingControlOptions : {
					position : google.maps.ControlPosition.TOP_CENTER,
					drawingModes : [ 'polyline' ]
				},
				polylineOptions : {
					fillColor : '#ffff00',
					fillOpacity : 1,
					strokeWeight : 5,
					clickable : true,

					editable : true,
					zIndex : 1,
					geodesic : true
				}
			});
		}

		function createMarker(map, assetName, myLatLng) {
			var marker = new google.maps.Marker(
					{
						position : myLatLng,
						map : map,
						icon : {
							scaledSize : new google.maps.Size(
									24, 24),
									origin : new google.maps.Point(0, 0),
									url :'content/images/yellow.png',
									anchor : new google.maps.Point(
											16, 16),

						},
						label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: assetName, backgroundcolor: "#ff9800" },
					});
			
		}

		function drawingManagerValue(option, map, assetVal) {
			if (option == 'polylinecomplete') {
				google.maps.event.addListener(vm.drawingManager, option,
						function(event) {
							google.maps.event.addListener(event.getPath(),
									'insert_at', function() {
										setGoefenceCoordinate(event, assetVal);
									});
							google.maps.event.addListener(event.getPath(),
									'set_at', function(path) {
										setGoefenceCoordinate(event, assetVal);
									});
							vm.drawingManager.setOptions({
								drawingControl : false
							});
							vm.drawingManager.setMap(null);
							setGoefenceCoordinate(event, assetVal);
						});
				vm.drawingManager.setMap(map);
			}
		}

		function setGoefenceCoordinate(event, assetVal) {
			assetVal.assetCoordinates = [];
			var radius = event.getPath();
			for (var i = 0; i < radius.getLength(); i++) {
				var coordinates = {};
				coordinates.latitude = radius.getAt(i).lat();
				coordinates.longitude = radius.getAt(i).lng();
				assetVal.assetCoordinates.push(coordinates);
			}
			vm.asset = assetVal;
		}

		function moveToLocation(lat, lng, map) {
			var center = new google.maps.LatLng(lat, lng);
			// using global variable:
			map.panTo(center);
		}

		$scope.mapEvents = {
			"click" : function() {

			}
		}
	}
})();
(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetAdditionController',
			AssetAdditionController);

	AssetAdditionController.$inject = [ '$timeout', '$scope', '$stateParams','AlertService',
			'entity', 'Asset', 'User', 'AssetType', '$state', 'AssetUpload',
			'AllAssetsTypes', 'AllCustomAssetTypeAttribute', 'AssetIDs','AssetByID' ];

	function AssetAdditionController($timeout, $scope, $stateParams, AlertService, entity,
			Asset, User, AssetType, $state, AssetUpload, AllAssetsTypes,
			AllCustomAssetTypeAttribute, AssetIDs,AssetByID) {
		var vm = this;
//		var entity_old = angular.copy(vm.asset);
		vm.asset = entity;
		vm.generatedasset = null;
		vm.childAsset =  null;
		vm.parentName = null;
		var entity_old = angular.copy(vm.asset);
		vm.clear = clear;
		vm.save = save;
		vm.assetType = entity.assetType;

		vm.upload = upload;
		var childAC = [];
		vm.assettypes = loadPage();
		vm.coOrdinates = [];
		vm.coOrdinate = null;
		var newFence = false;
		var latlng;
		var locations = {};
		var centerlatlng = null;
		vm.customAttributesMap = {};
		var formData;
		var spreadAssets = [];
		
		function loadPage() {

			vm.multiassets = [];
			var selctedAssets = [];

			if (vm.asset.id != null) {
				vm.asset.ownedBy.forEach(function(asset) {
					selctedAssets.push(asset.id);
				})
			}

			AssetIDs.getAll(function(response) {
				response.forEach(function(asset) {
					if (selctedAssets.indexOf(asset.id) !== -1) {
						vm.multiassets.push({
							lat : asset.assetCoordinates[asset.assetCoordinates.length-1].latitude,
							lng : asset.assetCoordinates[asset.assetCoordinates.length-1].longitude,
							name : asset.name,
							assetType : asset.assetType,
							assetCoordinates : asset.assetCoordinates,
							id : asset.id,
							ownedBy : asset.ownedBy,
							ticked : true
						});
					} else {
						try {
							vm.multiassets.push({
								lat : asset.assetCoordinates[asset.assetCoordinates.length-1].latitude,
								lng : asset.assetCoordinates[asset.assetCoordinates.length-1].longitude,
								name : asset.name,
								assetType : asset.assetType,
								assetCoordinates : asset.assetCoordinates,
								id : asset.id,
								ownedBy : asset.ownedBy,
								ticked : false
							});
						} catch (e) {
							// TODO: handle exception
						}
						
					}
				});
			});
			
			AllAssetsTypes.getAll(function(response) {
				vm.assettypes = response;
			});

			AllCustomAssetTypeAttribute.getAll(function(response) {
				response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customAssetTypeAttributeValues;
				});
			});
		}

		function upload() {
			formData = new FormData();

			formData.append("assetname", $scope.assetname);
			formData.append('file', $scope.myFile);

			AssetUpload.assetupload(formData, function(response, headers) {
				if (response.status == 200) {
					vm.error = null;
					vm.success = 'OK';
					$scope.spreadassetname = '';

					$timeout(function() {
						vm.success = '';
					}, 4000);

				}
				if (response.status == 400) {
					vm.success = null;
					vm.error = 'error';

				}
			});

		}

		/* import end */
		vm.createNewFence = function() {
			newFence = true;
			vm.asset.assetCoordinates = [];
			vm.createfence();
		}

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			if (vm.asset.id !== null) {
				Asset.update(vm.asset, onSaveSuccess, onSaveError);
			} else {
				Asset.save(vm.asset, onSaveSuccess, onSaveError);
			}
		}

		function onSaveSuccess(result) {
			$scope.$emit('trakeyeApp:assetUpdate', result);
			vm.isSaving = false;
			$state.go('asset');
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		vm.createfence = function() {
			
			var elem = document.getElementById("map_canvas");

			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.mozRequestFullScreen) { /* Firefox */
				elem.mozRequestFullScreen();
			} else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
				elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) { /* IE/Edge */
				elem.msRequestFullscreen();
			}
			 
			var child = {};
			childAC = [];
			for (var i = 0; i < vm.multiassets.length; i++) {
				if (vm.multiassets[i].ticked == true) {
					child = vm.multiassets[i];
					childAC = vm.multiassets[i].assetCoordinates;
				}
			}
			
			var myLatLng = ({lat:child.lat, lng:child.lng});
			var map = new google.maps.Map(document
					.getElementById('map_canvas'), {
				center : myLatLng,
				zoom : 16,
				fullscreenControl: true
			});
			
			createMarkerOfAllAssets(myLatLng,map,child.name);

			for(var j = 0; j < childAC.length;j++){
				if(j > 0){
					var locValues =[];
					locValues.push(childAC[j-1]);
					locValues.push(childAC[j]);
					drawPolylineForGeneratedLoc(locValues,map, "black");
				}
			}	
			
			AssetByID.get(child.id,function(response) {
				vm.childAsset = response;
				if(response.ownedBy != null){
					var parent = response.ownedBy;
						if (parent.length > 0) {
							vm.parentName = parent[0].name;
							var assetCoordinateValues = parent[0].assetCoordinates;
							var myLatLng = ({lat:assetCoordinateValues[assetCoordinateValues.length-1].latitude, lng:assetCoordinateValues[assetCoordinateValues.length-1].longitude});
							createMarkerOfAllAssets(myLatLng,map,parent[0].name);
						}
					}
			});
		};

		function drawPolylineForGeneratedLoc(latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];
            $.each(latlngsToDraw, function(index, value) {

                spreadAssetCoordinates.push({
                    lat : value.latitude,
                    lng : value.longitude
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var midLatLng = {
                        lat : spreadAssetCoordinates[spreadAssetCoordinates.length-1].lat,
                        lng : spreadAssetCoordinates[spreadAssetCoordinates.length-1].lng
                    };
                var infowindow = new google.maps.InfoWindow(
                        {
                            content : '<div class="infoWindowhead">'
                                    + "name"
                                    + '<div class="infoWindowContent"> <b>Description :</b> '
                                    + "des" + '</div></div>'
                        });
                infowindow.setPosition(midLatLng);

                var ColorValue = '#ff0000';
                if(color == "red"){
                    ColorValue = '#ff0000';
                }else if(color == "black"){
                	ColorValue = '#000000';
                }else{
                    ColorValue = '#208000';
                }
                var polylinepath = new google.maps.Polyline({
                    path : spreadAssetCoordinates,
                    geodesic : true,
                    strokeColor : ColorValue,
                    strokeOpacity : 1.0,
                    strokeWeight : 2.5,
                    fillColor : ColorValue,
                    fillOpacity : 0.3,
                    editable : false
                });

                google.maps.event.addListener(polylinepath, 'mouseout', function(event) {
					infowindow.close();
				});

				google.maps.event.addListener(polylinepath, 'mouseover', function(event) {
					
					var userContent= document.createElement('div'), button;

					userContent.innerHTML = '<div class="infoWindowhead">' + 'Insert Asset at '
					+ '</div><div class="infoWindowContent">'
					+'<b>Latitude :</b> '
					+ event.latLng.lat()
					+'<br><b>Longitude :</b> '
					+ event.latLng.lng()
					+ '</div>';

					button = userContent.appendChild(document.createElement('input'));
					button.type = 'button';
					button.value = 'Save';
					button.className = "button"; 
					button.style.width = '300px';
					infowindow = new google.maps.InfoWindow({
						content : userContent
					});

					google.maps.event.addDomListener(button, 'click', function () {
						var newAssetAC = [];
						var newChildAC = [];
						var isACSplitted = false;
						
						vm.generatedasset = vm.asset;
						vm.generatedasset.name = "Asset BW "+vm.childAsset.name + " " +vm.parentName;
						vm.generatedasset.assetCoordinates = [];
						vm.generatedasset.assetCoordinates.push({latitude:event.latLng.lat(), longitude:event.latLng.lng()});
						var assetTypes = vm.assettypes;
						var assetTypeAttributesVal = [];
						var assetTypeValConsolidated = null;
						for (var i = 0; i < assetTypes.length; i++) {
							if(assetTypes[i].name == "Joint Kit"){
								assetTypeValConsolidated = assetTypes[i];
								assetTypeAttributesVal = assetTypes[i].assetTypeAttributes;
							}	
						}
						var assetTypeAttributesValConsolidated = [];
						for (var i = 0; i < assetTypeAttributesVal.length; i++) {
							if(assetTypeAttributesVal[i] != null){
								assetTypeAttributesValConsolidated.push({assetTypeAttribute:assetTypeAttributesVal[i],attributeValue:assetTypeAttributesVal[i].defaultValue}  );
							}
						}
						vm.generatedasset.assetTypeAttributeValues = assetTypeAttributesValConsolidated;
						vm.generatedasset.assetType = assetTypeValConsolidated;

						for (var i = 0; i < childAC.length; i++) {
							if(!isACSplitted){
								newAssetAC.push({latitude:childAC[i].latitude, longitude:childAC[i].longitude});
								if(latlngsToDraw[0].latitude == childAC[i].latitude){
									isACSplitted = true;
									newAssetAC.push({latitude:event.latLng.lat(), longitude:event.latLng.lng()});
									newChildAC.push({latitude:event.latLng.lat(), longitude:event.latLng.lng()});
								}
							}else{
								newChildAC.push({latitude:childAC[i].latitude, longitude:childAC[i].longitude});
							}
						}
					
						if(newAssetAC.length > 0){
							vm.childAsset.assetCoordinates.push({latitude:newAssetAC[newAssetAC.length-1].latitude, longitude:newAssetAC[newAssetAC.length-1].longitude});
						}
						
						for (var i = 0; i < newChildAC.length; i++) {
							vm.childAsset.assetCoordinates.push({latitude:newChildAC[i].latitude, longitude:newChildAC[i].longitude});
						}
						
						vm.generatedasset.assetCoordinates = [];
						
						for (var i = 0; i < newAssetAC.length; i++) {
							vm.generatedasset.assetCoordinates.push({latitude:newAssetAC[i].latitude, longitude:newAssetAC[i].longitude});
						}
						

						
						Asset.save(vm.generatedasset, function(response) {
							
							vm.generatedasset.ownedBy = vm.childAsset.ownedBy;
							vm.childAsset.ownedBy = [];
							vm.childAsset.ownedBy.push({id:response.id})
							
							vm.generatedasset.id = response.id;

							Asset.update(vm.childAsset,function(response) {
								Asset.update(vm.generatedasset,function(response) {
									$state.go('asset');
								});
							});
							
							
						});
						newAssetAC = [];
						newChildAC = [];
						
					});
                    infowindow.mousemove;
					infowindow.setPosition(event.latLng);
					infowindow.open(map);
				});
				
                polylinepath.setOptions({
                    strokeColor : ColorValue
                });
                
                
                polylinepath.setMap(map);
            }
        }
		
		function distanceCal(lat1, lon1, lat2, lon2) {
			var theta = lon1 - lon2;
			var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2))
			+ Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
			dist = Math.acos(dist);
			dist = radians_to_degrees(dist);
			dist = dist * 60 * 1.1515;
			dist = dist * 1.609344;
			if(isNaN(dist)){
				return 0.0;
			}else{
				return (dist);	
			}
		}
		function degrees_to_radians(degrees){
			var pi = Math.PI;
			return degrees * (pi/180);
		}

		function radians_to_degrees(radians){
			var pi = Math.PI;
			return radians * (180/pi);
		}

		function createMarkerOfAllAssets(myLatLng, map, myLocName) {
				var marker = new google.maps.Marker(
						{
							position : myLatLng,
							map : map,
							icon : {
								scaledSize : new google.maps.Size(
										24, 24),
										origin : new google.maps.Point(0, 0),
										icon :'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
										anchor : new google.maps.Point(
														0, 0),

							},
							label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: myLocName, backgroundcolor: "#ff9800" },
						});
		}
		

		function moveToLocation(lat, lng, map) {
			var center = new google.maps.LatLng(lat, lng);
			// using global variable:
			map.panTo(center);
		}


	
		$scope.mapEvents = {
			"click" : function() {

			}
		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetTypeSiteReportController', AssetTypeSiteReportController)

	AssetTypeSiteReportController.$inject = [ '$scope', '$state', 'pagingParams','paginationConstants', 'ParseLinks', 'SiteAssets', '$rootScope', '$timeout', '$window', '$filter', '$interval' ];

	function AssetTypeSiteReportController($scope, $state, pagingParams, paginationConstants, ParseLinks, SiteAssets, $rootScope, $timeout, $window, $filter, $interval) {
		var vm = this;
		vm.multiassets = [];
		 vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

		vm.filterSearch=filterSearch;
        
        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			
			}
		}
			
		SiteAssets.query({
                page: pagingParams.page - 1,
                search: $scope.search,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' +
                    (vm.reverse ? 'asc' : 'desc')
                ];
                if (vm.predicate !== 'id') {
                    // result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
				data.forEach(function(asset) {
					if (asset.assetTypeName == "Site") {
						vm.multiassets.push({
							id : asset.name,
							name : asset.siteChildAssetsDTO.siteName,
							WDM : asset.siteChildAssetsDTO.wdmCount,
							NTTN : asset.siteChildAssetsDTO.nttnCount,
							Router : asset.siteChildAssetsDTO.routerCount,
							BackToBack : asset.siteChildAssetsDTO.backtobackCount,
							Others : asset.siteChildAssetsDTO.othersCount
						});
						
						vm.multiassets.sort(function(a, b){
						    var nameA=a.id.toLowerCase(), nameB=b.id.toLowerCase()
						    if (nameA < nameB) //sort string ascending
						        return -1 
						    if (nameA > nameB)
						        return 1
						    return 0 //default return value (no sorting)
						})
                    }
				});
			}
			
			function onError(error) {
                AlertService.error(error.data.message);
            }

		function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search
            });
        }
	}
		

})();
(function () {
    'use strict';

    angular.module('trakeyeApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('asset', {
            parent: 'app',
            url: '/asset?page&sort&search',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER','ROLE_PLAN_ADMIN','ROLE_ROLLOUT_ADMIN'],
                pageTitle: 'trakeyeApp.asset.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/asset/assets.html',
                    controller: 'AssetController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name',
                    squash: true
                },
                search: null,
                pagesize: 10,
                listgeofenceid: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        pagesize: $stateParams.pagesize,
                        listgeofenceid: $stateParams.listgeofenceid
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('asset');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('asset-detail', {
            parent: 'asset',
            url: '/asset/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                pageTitle: 'trakeyeApp.asset.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/asset/asset-detail.html',
                    controller: 'AssetDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('asset');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Asset', function ($stateParams, Asset) {
                    return Asset.get({
                        id: $stateParams.id
                    }).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'asset',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })

            .state('asset-type-site-report', {
                parent: 'asset',
                url: '/asset-type-site-report',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER'],
                    pageTitle: 'trakeyeApp.report.asset-type-site-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-type-site-report.html',
                        controller: 'AssetTypeSiteReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'name',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('asset');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('asset-detail.edit', {
                parent: 'asset-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.asset.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-dialog.html',
                        controller: 'AssetDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('asset');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Asset', function ($stateParams, Asset) {
                        return Asset.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'asset',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('asset.new', {
                parent: 'asset',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-dialog.html',
                        controller: 'AssetDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            description: null,
                            createDate: null,
                            updateDate: null,
                            userId: null,
                            assetType: null,
                            assetTypeAttributeValues: [],
                            assetCoordinates: [],
                            assetImport: false
                        };
                    }
                }

            })

            .state('asset.import', {
                parent: 'asset',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-import.html',
                        controller: 'AssetImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            description: null,
                            createDate: null,
                            updateDate: null,
                            userId: null,
                            assetType: null,
                            assetTypeAttributeValues: [],
                            assetCoordinates: [],
                            assetImport: true
                        };
                    }
                }

            }) 
            /* .state('asset.import', {
                parent: 'asset',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/import/entity-import-dialog.html',
                        controller: 'ImportDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return $state.current.name || 'asset';
                    }]
                }
            }) */

            .state('asset.add', {
                parent: 'asset',
                url: '/add',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-addition.html',
                        controller: 'AssetAdditionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            description: null,
                            createDate: null,
                            updateDate: null,
                            userId: null,
                            assetType: null,
                            assetTypeAttributeValues: [],
                            assetCoordinates: []
                        };
                    }
                }

            })

            .state('asset.connect', {
                parent: 'asset',
                url: '/connect',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_USER', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-connect.html',
                        controller: 'AssetConnectController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            description: null,
                            createDate: null,
                            updateDate: null,
                            userId: null,
                            assetType: null,
                            assetTypeAttributeValues: [],
                            assetCoordinates: []
                        };
                    }
                }

            })

            .state('asset.edit', {
                parent: 'asset',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.asset.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-dialog.html',
                        controller: 'AssetDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('asset');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Asset', function ($stateParams, Asset) {
                        return Asset.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'asset',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('asset.delete', {
                parent: 'asset',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/asset/asset-delete-dialog.html',
                        controller: 'AssetDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Asset', function (Asset) {
                                return Asset.get({
                                    id: $stateParams.id
                                }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        setTimeout(function () {
                            $state.go('asset', null, {
                                reload: 'asset'
                            });
                        }, 1000);
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
(function () {
    'use strict';
    angular.module('trakeyeApp').factory('Asset', Asset);

    Asset.$inject = ['$resource'];

    function Asset($resource) {
        var resourceUrl = 'api/assets/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("ChildAssetMarkers", ChildAssetMarkers);

    ChildAssetMarkers.$inject = ["$resource"];

    function ChildAssetMarkers($resource) {
        var resourceUrl = "api/linked-asset-markers/:assetId";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetByMarkerId', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/asset-by-assetmarkerid/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetSiteIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/siteassetlistnew').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetCountByGroup', ['$http', function ($http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/assetcountbygroup').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetCountBySiteStatus', ['$http', function ($http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/assetcountbystatus').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

//(function() {
//    'use strict';
//
//    angular.module('trakeyeApp').factory('AssetCountByLinkStatus', ['$http', function($http) {
//
//        var service = {};
//        service.getAll = function(callback) {
//            $http.get('api/assetcountbylinkstatus').then(function(response) {
//                callback(response.data);
//            });
//        };
//
//        return service;
//    }]);
//})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetCountByLinkStatus', ['$http', function ($http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/assets/aggs/Link/Link%20Status').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetGroup', AssetGroup);

    AssetGroup.$inject = ['$resource'];

    function AssetGroup($resource) {
        var resourceUrl = 'api/assets-group-db';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupSearch', AssetGroupSearch);

    AssetGroupSearch.$inject = ['$resource'];

    function AssetGroupSearch($resource) {
        var service = $resource('/api/assets-group-db/searchvalue/:search', {
            // searchvalue : '@id'
        }, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetGroupWithGeofence', AssetGroupWithGeofence);

    AssetGroupWithGeofence.$inject = ['$resource'];

    function AssetGroupWithGeofence($resource) {
        var resourceUrl = 'api/assets-group-db/geofence/:geofenceId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetStatusListWithGeofence', AssetStatusListWithGeofence);

    AssetStatusListWithGeofence.$inject = ['$resource'];

    function AssetStatusListWithGeofence($resource) {
        var resourceUrl = 'api/asset-health-list-with-geofence/:geofenceId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupSearchWithGeofence', AssetGroupSearchWithGeofence);

    AssetGroupSearchWithGeofence.$inject = ['$resource'];

    function AssetGroupSearchWithGeofence($resource) {
        var service = $resource('/api/assets-group-db/geofence-searchvalue/:geofenceId/:search', {
            // searchvalue : '@id'
        }, {}, {}, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsUpdateGroup', AssetsUpdateGroup);

    AssetsUpdateGroup.$inject = ['$resource'];

    function AssetsUpdateGroup($resource) {
        var resourceUrl = 'api/assets/groups';

        return $resource(resourceUrl, {}, {
            'update': {
                method: 'PUT'
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsBulkDelete', AssetsBulkDelete);

    AssetsBulkDelete.$inject = ['$resource'];

    function AssetsBulkDelete($resource) {
        var resourceUrl = 'api/assets/bulk/delete';

        return $resource(resourceUrl, {
            'save': {
                method: 'POST'
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('UpdateAssetsGroup', UpdateAssetsGroup);

    UpdateAssetsGroup.$inject = ['$resource'];

    function UpdateAssetsGroup($resource) {
        var resourceUrl = 'api/assets';

        return $resource(resourceUrl, {}, {
            'update': {
                method: 'PUT'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('PrivateAssetsForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformapbyadmin = function (adminid, callback) {
            $http.get('api/privateassetsformap/' + adminid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ChildAssetsType', ChildAssetsType);

    ChildAssetsType.$inject = ['$resource'];

    function ChildAssetsType($resource) {
        var resourceUrl = 'api/childassetslist/:parentId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ChildAssets', ChildAssets);

    ChildAssets.$inject = ['$resource'];

    function ChildAssets($resource) {
        var resourceUrl = 'api/childAssets/:parentId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ChildAssetsByTypeName', ChildAssetsByTypeName);

    ChildAssetsByTypeName.$inject = ['$resource'];

    function ChildAssetsByTypeName($resource) {
        var resourceUrl = 'api/childassetstypenamelist/:parentId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetImages', AssetImages);

    AssetImages.$inject = ['$resource'];

    function AssetImages($resource) {
        var service = $resource('/api/asset-images/:assetId', {}, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupByBufferGeo', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (minigeofenceid, callback) {
            $http.get('api/asset-groupby-buffergeofence/' + minigeofenceid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

/* (function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetIdImageId', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (assetId,imageId, callback) {
            $http.get('api/trakeyeassetimages/' + assetId + '/'+ imageId).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})(); */

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UsersList', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getusers = function (callback) {
            $http.get('api/users').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetUser', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.gettrcasesuser = function (callback) {
            $http.get('api/location-logs/latest').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.searchassetsformap = function (search, callback) {
            $http.get('api/assets/searchformap/' + search).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.searchassetsformap = function (search, callback) {
            $http.get('api/assets/searchgroupassetsformap/' + search).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/assetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupFixedAssets', GroupFixedAssets);

    GroupFixedAssets.$inject = ['$resource'];

    function GroupFixedAssets($resource) {
        var service = $resource('/api/groupfixedassets', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupSpreadAssets', GroupSpreadAssets);

    GroupSpreadAssets.$inject = ['$resource'];

    function GroupSpreadAssets($resource) {
        var service = $resource('/api/groupspreadassets', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupFixedAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupfixedassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupSpreadAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupspreadassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupFixedAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupfixedassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupSpreadAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupspreadassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetsForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformapbyadmin = function (adminid, callback) {
            $http.get('api/assetsformap/' + adminid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetSearch', AssetSearch);

    AssetSearch.$inject = ['$resource'];

    function AssetSearch($resource) {
        var service = $resource('/api/assets/searchvalue/:search', {
            // searchvalue : '@id'
        }, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetUpload', AssetUpload);

    AssetUpload.$inject = ['$http'];

    function AssetUpload($http) {

        var service = {};
        service.assetupload = function (data, callback) {

            $http.post('api/assetsimport', data, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {
                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/assetlistnew').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UserAccount', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (callback) {
            $http.get('api/user-auths').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

/*(function() {
    'use strict';

    angular.module('trakeyeApp').factory('SiteAssets', ['$rootScope', '$http', function($rootScope, $http) {

        var service = {};
        service.getAll = function(callback) {
            $http.get('api/siteassetdashboard').then(function(response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();*/

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('FilterAssetsForMap', FilterAssetsForMap);

    FilterAssetsForMap.$inject = ['$http', 'DateUtils'];

    function FilterAssetsForMap($http, DateUtils) {
        var service = {};

        service.loaddata = function (callback) {

            $http.get('api/filterassetsformap').then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('AttrTypeVal', AttrTypeVal);

    AttrTypeVal.$inject = ['$http', 'DateUtils'];

    function AttrTypeVal($http, DateUtils) {
        var service = {};

        service.loaddata = function (type, attribute, callback) {

            $http.get('api/assets/attrvalue-type-attrname/' + type + '/' + attribute).then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('SiteAssets', SiteAssets);

    SiteAssets.$inject = ['$resource'];

    function SiteAssets($resource) {
        var resourceUrl = 'api/siteassetdashboard';

        return $resource(resourceUrl, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

// (function() {
//     'use strict';

//     angular.module('trakeyeApp').factory('AssetCount', ['$rootScope', '$http', function($rootScope, $http) {

//         var service = {};
//         service.get = function(id, callback) {
//             $http.get('api/assetcountdashboard').then(function(response) {
//                 callback(response.data);
//             });
//         };

//         return service;
//     }]);
// })();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('AssetCount', AssetCount);

    AssetCount.$inject = ['$http', 'DateUtils'];

    function AssetCount($http, DateUtils) {
        var service = {};

        service.get = function (callback) {

            $http.get('api/assetcountdashboard').then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('AssetTypes', AssetTypes);

    AssetTypes.$inject = ['$http', 'DateUtils'];

    function AssetTypes($http, DateUtils) {
        var service = {};

        service.get = function (callback) {

            $http.get('api/assets/type/stats').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('SiteAssetById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/assets/type/' + id + '/stats').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupES', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (geofenceId, lastid, callback) {
            $http.get('api/assets-group-es/' + geofenceId + "/" + lastid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('MappedFixedAssets', [ '$http', function ($http) {

        var service = {};
        service.get = function (id,paramPage,paramSize,callback) {
            $http.get('api/assets-group-db/mapped-fixed-assets/' + id + '?page='+paramPage+'&size='+paramSize).then(function (response) {
                callback(response);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupByGeofencesES', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function ( data, callback) {
            $http.post("api/assets-group-by-geofences-es", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('casesInMap', ['$http', function ($http) {

        var service = {};
        service.get = function ( data, callback) {
            $http.post("api/cases-for-asset-mapview", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllAssetsTypes', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/asset-types-by-roles').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllCusAssetTypeAttr', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getCusAssetTypeAttr = function (callback) {
            $http.get('api/all-custom-asset-type-attributes').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetByID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/assets/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetByName', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.check = function (name, callback) {
            $http.get('api/check-assets/' + name).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetDeleteByID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.delete = function (id, callback) {
            $http.delete('api/assets/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeoAssetTypeReport', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAssetTypesByGeo = function (callback) {
            $http.get('api/reports/geoassettypereport').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('LinkAssets', GroupAssets);

    GroupAssets.$inject = ['$resource'];

    function GroupAssets($resource) {
        var service = $resource('/api/groupassets', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupAssets', GroupAssets);

    GroupAssets.$inject = ['$resource'];

    function GroupAssets($resource) {
        var service = $resource('/api/groupassets', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetChildren', ['$rootScope', '$http', function ($rootScope, $http) {
        var service = {};
        service.getAssetChildren = function (login, callback) {
            var url = 'api/asset-childs/';
            if (login != null) {
                url = url + login
            }
            $http.get(url).then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsByGeofenceId', AssetsByGeofenceId);

    AssetsByGeofenceId.$inject = ['$resource'];

    function AssetsByGeofenceId($resource) {
        var resourceUrl = 'api/geofence-assets/:geofenceId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsGeofenceMapping', AssetsGeofenceMapping);

    AssetsGeofenceMapping.$inject = ['$resource'];

    function AssetsGeofenceMapping($resource) {
        var resourceUrl = 'api/asset-geofence-mapping/:geofenceId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsBulkDelete', AssetsBulkDelete);

    AssetsBulkDelete.$inject = ['$resource'];

    function AssetsBulkDelete($resource) {
        var resourceUrl = 'api/assets/bulk/delete';

        return $resource(resourceUrl, {
            'save': {
                method: 'POST'
            }
        });
    }
})();

// (function () {
//     'use strict';

//     angular.module('trakeyeApp').factory('AssetFixedGroupES', ['$rootScope', '$http', function ($rootScope, $http) {

//         var service = {};
//         service.get = function (geofenceId, lastid, callback) {
//             $http.get('api/assets-fixed-group-es/' + geofenceId + "/" + lastid).then(function (response) {
//                 callback(response.data);
//             });
//         };

//         return service;
//     }]);
// })();

// (function () {
//     'use strict';

//     angular.module('trakeyeApp').factory('AssetSpreadGroupES', ['$rootScope', '$http', function ($rootScope, $http) {

//         var service = {};
//         service.get = function (geofenceId, lastid, callback) {
//             $http.get('api/assets-spread-group-es/' + geofenceId + "/" + lastid).then(function (response) {
//                 callback(response.data);
//             });
//         };

//         return service;
//     }]);
// })();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetController", AssetController)

        .directive("fileModel", [
            "$parse",
            function ($parse) {
                return {
                    restrict: "A",
                    link: function (
                        scope,
                        element,
                        attrs,
                        $rootScope,
                        $broadcast
                    ) {
                        var model = $parse(attrs.fileModel);
                        var modelSetter = model.assign;

                        element.bind("change", function () {
                            var files = element[0].files;
                            var allowedTypes = {
                                "image/png": true,
                                "image/jpg": true,
                                "image/jpeg": true,
                            };

                            var data = {
                                file: files,
                                types: allowedTypes,
                            };
                            scope.$emit("callFunction", data);
                            //uploadFiles("reference", allowedTypes,files);
                        });
                    },
                };
            },
        ])

        .directive("fileStyle", function () {
            return {
                link: function (scope, element) {
                    $(element).filestyle({
                        buttonBefore: true,
                    });
                    $(element).filestyle("buttonText", "Browse File");
                },
            };
        });

    AssetController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "pagingParams",
        "paginationConstants",
        "ParseLinks",
        "DEFAULT_LATITUDE",
        "DEFAULT_LONGITUDE",
        "AssetTypesByGeofenceID",
        "UserGeofences",
        "GeofenceIDs",
        "AssetGroup",
        "AssetGroupSearch",
        "AssetGroupES",
        "AssetByID",
        "UserAccount",
        "AssetsBulkDelete",
        "AssetGroupWithGeofence",
        "AssetGroupSearchWithGeofence",
        "AssetType",
        "AlertService",
        "Asset",
        "AllCustomAssetTypeAttribute",
        "UserMasterGeofences",
        "GeofenceByID",
        "MiniGeofencesByMasterID",
        "AssetTypesByGeofenceIDs",
        "AssetGroupByGeofencesES",
        "$localStorage",
        "Configs",
        "casesInMap",
        "CaseType",
        "EntityImport",
        "$timeout",
        "ChildAssetMarkers",
        "AssetByMarkerId"
    ];

    function AssetController(
        $scope,
        $rootScope,
        $state,
        pagingParams,
        paginationConstants,
        ParseLinks,
        DEFAULT_LATITUDE,
        DEFAULT_LONGITUDE,
        AssetTypesByGeofenceID,
        UserGeofences,
        GeofenceIDs,
        AssetGroup,
        AssetGroupSearch,
        AssetGroupES,
        AssetByID,
        UserAccount,
        AssetsBulkDelete,
        AssetGroupWithGeofence,
        AssetGroupSearchWithGeofence,
        AssetType,
        AlertService,
        Asset,
        AllCustomAssetTypeAttribute,
        UserMasterGeofences,
        GeofenceByID,
        MiniGeofencesByMasterID,
        AssetTypesByGeofenceIDs,
        AssetGroupByGeofencesES,
        $localStorage,
        Configs,
        casesInMap,
        CaseType,
        EntityImport,
        $timeout,
        ChildAssetMarkers,
        AssetByMarkerId
    ) {
        var vm = this;
        $scope.tab = 1;
        vm.selectedListGeofenceId = parseInt(pagingParams.listgeofenceid);
        if (isNaN(vm.selectedListGeofenceId)) {
            vm.selectedListGeofenceId = 0;
        }
        $scope.search = pagingParams.search;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        $("#pagenum").val(pagingParams.page + "");
        if (pagingParams.pagesize != null) {
            vm.itemsPerPage = pagingParams.pagesize;
            //Get select object
            var objSelect = document.getElementById("page_size");

            //Set selected
            setSelectedValue(objSelect, vm.itemsPerPage);
        }
        vm.filterAssetTypes = [];
        vm.filterAssetTypesCity = [];
        vm.assetToEdit = {};
        vm.transition = transition;
        vm.goToPage = goToPage;
        vm.filterAssetsOnListView = filterAssetsOnListView;
        vm.imageUpload = imageUpload;
        vm.showAssetImage = false;

        vm.userGeofences = [];
        vm.userGeofencesCity = [];
        vm.geofencesListView = [];
        vm.selectedMapGeofenceId = null;
        vm.prevSelectedGeofenceId = null;
        vm.selectedMapGeofenceIds = [];
        vm.prevSelectedMapGeofenceIds = [];
        vm.editAssetOnMapView = editAssetOnMapView;
        vm.editAssetMarker = editAssetMarker;
        vm.closeEditAssetModal = closeEditAssetModal;
        vm.showAssetMarkerDetails = showAssetMarkerDetails;
        vm.saveEditMarkerAssetModal = saveEditMarkerAssetModal;
        vm.editAssetMarkerOnMapView = editAssetMarkerOnMapView;
        vm.closeEditAssetMarkerModal = closeEditAssetMarkerModal;
        vm.saveEditAssetModal = saveEditAssetModal;
        vm.viewAssetMarkerOnMapView = viewAssetMarkerOnMapView;
        vm.closeViewAssetMarkerModal = closeViewAssetMarkerModal;
        vm.getAssetsForListView = getAssetsForListView;
        vm.filterAssetsOnMapView = filterAssetsOnMapView;
        vm.filterAssetsOnMapViewCity = filterAssetsOnMapViewCity;
        vm.closeMapFilterModal = closeMapFilterModal;
        vm.closeMapFilterModalCity = closeMapFilterModalCity;
        vm.closeImageUpload = closeImageUpload;
        vm.closeListFilterModal = closeListFilterModal;
        vm.saveListFilter = saveListFilter;
        vm.saveAssetTypeFilter = saveAssetTypeFilter;
        vm.saveAssetTypeFilterCity = saveAssetTypeFilterCity;
        vm.createAsset = createAsset;
        vm.saveFilter = saveFilter;
        vm.saveFilterCity = saveFilterCity;
        vm.selectAllAssets = selectAllAssets;
        vm.selectAssetEntity = selectAssetEntity;
        vm.selectAsets = selectAsets;
        vm.gotoLatitute = gotoLatitute;
        vm.gotoLatituteCity = gotoLatituteCity;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.closeGotoLatituteCity = closeGotoLatituteCity;
        vm.showLayers = showLayers;
        vm.showLayersCity = showLayersCity;
        vm.closeLayers = closeLayers;
        vm.showZoomLocation = showZoomLocation;
        vm.showAssetAttributesModal = showAssetAttributesModal;
        vm.closeAssetAttributesModal = closeAssetAttributesModal;
        vm.closeThreePointReference = closeThreePointReference;
        vm.confirmDelete = confirmDelete;
        vm.saveImage = saveImage;
        vm.customAttributesMap = {};
        vm.zoomLevel = 12;
        vm.zoomLevelCity = 10;
        vm.userMasterGeofences = [];
        vm.previousPolygons = [];

        vm.assetMarkerTable = assetMarkerTable;

        //measure tool
        var measureEnabled = false
        var polyMeasureTool, segmentDistance, midpoint
        var totalDistance = 0
        var distanceMarkers = []
        var totalDistanceMarkers = []
        var pointerMarkers = []
        var arrpolyMeasureTool = []

        var gotoMarker = null;
        var isLevel1AssetsVisible = false;
        var isLevel2AssetsVisible = false;
        var isLevel3AssetsVisible = false;
        var isLevel4AssetsVisible = false;
        var isLevel5AssetsVisible = false;
        var isLevelNodeVisible = false;
        var assetVisibility19 = false;
        var assetVisibility20 = false;

        var isLevel1AssetsVisibleCity = true;
        var isLevel2AssetsVisibleCity = true;
        var isLevel3AssetsVisibleCity = true;
        var isLevel4AssetsVisibleCity = true;
        var isLevel5AssetsVisibleCity = true;

        vm.zoom13 = false;
        vm.zoom14 = false;
        vm.zoomLabel18 = false;
        vm.zoomLabel19 = false;
        vm.zoomLabel20 = false;
        vm.fileWarning = false;

        var nodeCluster, existingHighlight, existingHighlightFixed;
        var nodeMarkers = [];
        var nodePolyline = [];

        var level1AssetsMarkers = [];
        var level2AssetsMarkers = [];
        var level3AssetsMarkers = [];
        var level4AssetsMarkers = [];
        var level5AssetsMarkers = [];
        var level6AssetsMarkers = [];
        var level7AssetsMarkers = [];

        var level1AssetsMarkersCity = [];
        var level2AssetsMarkersCity = [];
        var level3AssetsMarkersCity = [];
        var level4AssetsMarkersCity = [];
        var level5AssetsMarkersCity = [];

        var level1AssetsPolyline = [];
        var level2AssetsPolyline = [];
        var level3AssetsPolyline = [];
        var level4AssetsPolyline = [];
        var level5AssetsPolyline = [];

        var level1AssetsPolylineCity = [];
        var level2AssetsPolylineCity = [];
        var level3AssetsPolylineCity = [];
        var level4AssetsPolylineCity = [];
        var level5AssetsPolylineCity = [];

        vm.isAllAssetSelected = false;
        // vm.isShowing = true;
        $scope.selectAll = false;
        $scope.options = [];
        vm.assetTypeValues = [];
        vm.assetTypeValuesCity = [];
        $scope.selectedFilterAssetTypes = [];
        $scope.selectedFilterAssetTypesCity = [];
        var locations = {};
        var locationsCity = {};
        var latlng = null;
        var openedInfoWindow = null;
        var prevInfoWindow = null;

        var markers = [];
        var markersCity = [];
        var polylines = [];
        var polylinesCity = [];
        var noDataText = null;
        vm.mapAssets = [];
        vm.mapAssetsCity = [];

        vm.selectedAssets = [];
        vm.isAllAssetSelected = false;
        var tempGeofenceId = null,
            caseMarker = [],
            lastOpenedInfoWindow,
            caseTypeIds;

        vm.selectedMasterGeofenceId = 0;

        $scope.bool = true;
        $scope.boolCity = true;

        vm.currentZoom = 12;
        vm.currentZoomCity = 12;

        vm.getCenter;
        vm.getCenterCity;
        var infowindowSearchCity;
        var infowindowSearch;
        var activeInfo;
        var activeInfoCity;
        var spreadPoly;
        var spreadPolyCity;
        var assetTimer;
        var polylineTimer;
        var assetTimerCity;
        var polylineTimerCity;
        var closeClick, tempList;
        $scope.hidethis = true;
        vm.closeModal = closeModal;
        vm.saveAttachments = saveAttachments;
        var filesSelected,
            accessEditAsset = false;
        vm.importxlsx = /^(.*?)\.(csv)$/;

        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        $scope.$on("callFunction", function (event, data) {
            // Call the function in this controller
            uploadFiles(
                "reference",
                data.types,
                data.file,
                event.targetScope.attribute.id
            );
        });

        var maxSize;
        Configs.get("MaxFileSize", function (response) {
            maxSize = response[0].configValue;
        });

        vm.isAssetImport = false
        Configs.get("Features", function (response) {
            response.forEach(function (val) {
                if (val.configKey == "IsNewAssetImport" && val.configValue == "True") {
                    vm.isAssetImport = true
                }
            })
        });

        function uploadFiles(id, allowedTypes, fileReference, referenceId) {
            filesSelected = fileReference;
            for (var i = 0; i < filesSelected.length; i++) {
                if (
                    allowedTypes[filesSelected[i].type] &&
                    filesSelected[i].size <= maxSize
                ) {
                    if (id == "reference") {
                        vm.assetRefAttributes.forEach(function (val) {
                            if (val.id == referenceId) {
                                var fileReader_reference = new FileReader();
                                fileReader_reference.onload = function (
                                    fileLoadedEvent
                                ) {
                                    val.attributeValue = window.btoa(
                                        fileLoadedEvent.target.result
                                    );
                                    val.attributeName = fileLoadedEvent.target.name;
                                    val.attributeType = fileLoadedEvent.target.type;
                                };
                                fileReader_reference.name = filesSelected[i].name.split(".")[0];
                                fileReader_reference.type = filesSelected[i].type
                                    .split("/")[1]
                                    .toUpperCase();
                                fileReader_reference.readAsBinaryString(
                                    filesSelected[i]
                                );
                            }
                        });
                    }
                }
            }
        }

        $scope.geofencelabel = {
            search: "Search",
            nothingSelected: "Geofence",
        };

        $scope.type = {
            assetTypeLabel: {
                search: "Search",
                nothingSelected: "Asset Type",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
            caseTypeLabel: {
                search: "Search",
                nothingSelected: "Case Type",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
        };

        $scope.GeofenceCity = {
            search: "Search",
            nothingSelected: "Geofence",
            selectAll: "All",
            selectNone: "None",
            Done: "Done",
        };

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.centerCapture = function () {
            vm.getCenterCity = locationsCity.mapCity.center;
            vm.currentZoomCity = locationsCity.mapCity.getZoom();
        };
        // $scope.search = null;

        function createAsset() {
            sessionStorage.setItem("pageValue", "asset");
            $state.go("asset.new");
        }

        $(".select2").select2();
        function setSelectedValue(selectObj, valueToSet) {
            for (var i = 0; i < selectObj.options.length; i++) {
                if (selectObj.options[i].text == valueToSet) {
                    selectObj.options[i].selected = true;
                    return;
                }
            }
        }

        $scope.toggle = function () {
            $scope.allimages = true;
        };

        $scope.deleteDisplayImage = function (id) {
            vm.assetAttachments.assetImages.splice(id, 1);
            if (vm.assetAttachments.assetImages.length == 0) {
                filesSelected = null;
                $(":file").filestyle("clear");
            }
        };

        $("#assetImages").change(function () {
            filesSelected = document.getElementById("assetImages").files;
            for (var i = 0; i < filesSelected.length; i++) {
                if (
                    (filesSelected[i].type == "image/png" ||
                        filesSelected[i].type == "image/jpg" ||
                        filesSelected[i].type == "image/jpeg" ||
                        filesSelected[i].type == "application/pdf") &&
                    filesSelected[i].size <= 2621440
                ) {
                    vm.fileWarning = false;
                    var fileReader = new FileReader();
                    /* var name = filesSelected[i].name.split('.')[0]
                        var type = filesSelected[i].name.split('.')[1] */
                    fileReader.onload = function (fileLoadedEvent) {
                        vm.assetAttachments.assetImages.push({
                            image: window.btoa(fileLoadedEvent.target.result),
                            asset: {
                                id: vm.assetIdImg,
                            },
                            imageName: fileLoadedEvent.target.name,
                            imageType: fileLoadedEvent.target.type,
                        });
                    };
                    fileReader.name = filesSelected[i].name.split(".")[0];
                    fileReader.type = filesSelected[i].type
                        .split("/")[1]
                        .toUpperCase();
                    fileReader.readAsBinaryString(filesSelected[i]);
                } else {
                    filesSelected = null;
                    vm.fileWarning = true;
                }
            }
        });


        function saveAttachments() {
            if (filesSelected) {
                Asset.update(
                    vm.assetAttachments,
                    function () {
                        $("#modalAttachment").hide();
                        $(":file").filestyle("clear");
                        $scope.allimages = false;
                    },
                    function () { }
                );
            }
        }

        /* function onSuccess(){
            
        }

        function onError(e){
            console.error(e)
        } */

        function imageUpload(id) {
            vm.assetId = id;
            $("#myModalUpload").show();
        }

        function saveImage() {
            var photo = document.getElementById("assetImages").files[0]; // file from input
            var req = new XMLHttpRequest();
            var formData = new FormData();
            if (photo) {
                if (
                    photo.type == "image/png" ||
                    photo.type == "image/jpg" ||
                    photo.type == "image/jpeg" ||
                    photo.type == "application/pdf"
                ) {
                    var name = photo.name.split(".")[0];
                    var type = photo.name.split(".")[1].toUpperCase();
                    vm.fileWarning = false;
                    formData.append("file", photo);
                    req.open(
                        "POST",
                        "api/trakeyeassetimages/" +
                        vm.assetId.id +
                        "/" +
                        name +
                        "/" +
                        type
                    );
                    req.setRequestHeader(
                        "Authorization",
                        "Bearer " + $localStorage.authenticationToken
                    );
                    req.onload = function (e) {
                        if (this.status === 200) {
                            closeImageUpload();
                            $("#successImage").show();
                        } else {
                            closeImageUpload();
                            $("#errorImage").show();
                        }
                    };
                    req.send(formData);
                } else {
                    vm.fileWarning = true;
                }
            }
        }


        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                ],
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);

            /* var zoomLabel = document.createElement("span");
            zoomLabel.setAttribute("title", "Zoom");
            zoomLabel.classList.add("custom-map-control-button");
            var textnode = document.createTextNode("Zoom :"+vm.zoomLevel);
            zoomLabel.appendChild(textnode);
            map.controls[google.maps.ControlPosition.LEFT_TOP].push(
                zoomLabel
            );  */

            goTo.addEventListener("click", function () {
                gotoLatitute();
            });


            var measureTool = document.createElement("button");
            measureTool.setAttribute("title", "Measure Distance");
            measureTool.classList.add("custom-map-control-button");
            var measureToolIcon = document.createElement("i");
            measureToolIcon.classList.add("fa");
            measureToolIcon.classList.add("fa-arrows-h");
            measureToolIcon.classList.add("ruler");
            measureTool.appendChild(measureToolIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(measureTool);
            measureTool.addEventListener("click", function () {

                if (measureEnabled) {
                    google.maps.event.removeListener(vm.clickListener);

                    totalDistance = 0
                    clearMeasureTool(distanceMarkers)
                    clearMeasureTool(pointerMarkers)
                    clearMeasureTool(arrpolyMeasureTool)
                    clearMeasureTool(totalDistanceMarkers)
                    distanceMarkers = []
                    totalDistanceMarkers = []
                    pointerMarkers = []
                    arrpolyMeasureTool = []


                    measureEnabled = false

                    measureTool.setAttribute("title", "Measure Distance");
                    measureToolIcon.classList.remove("fa-times");
                    measureToolIcon.classList.add("fa-arrows-h");


                } else {
                    measureEnabled = true
                    polyMeasureTool = new google.maps.Polyline({
                        strokeColor: 'black',
                        strokeOpacity: 1.0,
                        strokeWeight: 3
                    });
                    polyMeasureTool.setMap(locations.map);
                    arrpolyMeasureTool.push(polyMeasureTool)

                    vm.clickListener = locations.map.addListener('click', addLatLng);


                    measureTool.setAttribute("title", "Clear Distance");
                    measureToolIcon.classList.remove("fa-arrows-h");
                    measureToolIcon.classList.add("fa-times");
                }
            });


            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };

                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            // var image = {
                            //     url: "content/images/geoLocation.png", // url
                            //     scaledSize: new google.maps.Size(25, 25), // scaled size
                            //     origin: new google.maps.Point(0, 0), // origin
                            //     anchor: new google.maps.Point(0, 0), // anchor
                            // };
                            // var markerGeo = new google.maps.Marker({
                            //     position: pos,
                            //     icon: image,
                            // });
                            // map.setZoom(20);
                            // markerGeo.setMap(map);
                            map.setZoom(18);
                            map.setCenter(pos);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        if ($scope.tab == 1) {
            UserAccount.get(function (data) {
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    vm.isAdmin = val
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }

                    if (
                        val == "ROLE_USER_ADMIN" ||
                        val == "ROLE_CITY_PLANNER"
                    ) {
                        accessEditAsset = true;
                    }
                });
                if (isAdmin) {
                    vm.adminFilter = true;
                    filterAssetsOnListView();
                    getAssetsForListView();
                } else {
                    vm.adminFilter = false;
                    filterAssetsOnListView();
                    getAssetsForListView();
                }
            });
            Configs.get("AssetImage", function (response) {
                if (response.length > 0) {
                    if (response[0].configValue == "True") {
                        vm.showAssetImage = true;
                    }
                }
            });

            AllCustomAssetTypeAttribute.getAll(function (response) {
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customAssetTypeAttributeValues;
                });
            });
            AssetType.query(
                {
                    page: 0,
                    size: 100,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.assetTypes = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        $scope.setTab = function (newTab) {
            $scope.search = null;
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                if (tempGeofenceId) {
                    vm.selectedListGeofenceId = tempGeofenceId;
                    getAssetsForListView();
                    vm.geofencesListView.forEach(function (item) {
                        if (item.id == vm.selectedListGeofenceId) {
                            item.ticked = true;
                        } else {
                            item.ticked = false;
                        }
                    });
                }

                /* getAssetsForListView();
                filterAssetsOnListView()
                vm.selectedMapGeofenceId = null;
                vm.userGeofences.forEach(function (value) {
                    if (vm.selectedMapGeofenceId == null) {
                        vm.selectedMapGeofenceId = value.id;
                    }
                }); */
            } else if ($scope.tab == 2) {
                CaseType.query(
                    {
                        page: 0,
                        size: 100,
                        sort: "update_date,desc",
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data) {
                    vm.caseType = data;
                    caseTypeIds = data
                        .filter(function (item) {
                            return item.showInAssetsView;
                        })
                        .map(function (item) {
                            return item.id;
                        });
                }
                function onError(error) {
                    console.error(error);
                }
                //vm.selectedGeofence.length=0
                vm.mapAssets = [];
                vm.mapAssetsCity = [];
                /* AssetTypesByGeofenceID.get(
                    vm.selectedMapGeofenceId,
                    function (assetTypeVal) {
                        vm.assetTypeValues = assetTypeVal;
                        getGroupAssetsFromES(
                            vm.selectedMapGeofenceId,
                            null,
                            vm.mapAssets
                        );
                    }
                );*/
                document.getElementById("myspan").textContent = " ";
                /*  var myOptions = {
                    zoom: 12,
                    center: new google.maps.LatLng(
                        DEFAULT_LATITUDE,
                        DEFAULT_LONGITUDE
                    ),
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(
                        12,
                        new google.maps.LatLng(
                            DEFAULT_LATITUDE.value,
                            DEFAULT_LONGITUDE.value
                        )
                    )
                );
                geoLocation(locations.map);
                filterAssetsOnMapView();
                if (tempGeofenceId) {
                    vm.selectedMapGeofenceId = tempGeofenceId;
                    saveFilter();
                }
                var input = document.getElementById("field_pinLat");
                input.value = "";
            } else if ($scope.tab == 3) {
                vm.userGeofencesCity.length = 0;
                vm.mapAssets = [];
                vm.userMasterGeofences = [];
                UserMasterGeofences.getAllMasterGeofenceByUser(function (response) {
                    vm.userMasterGeofences = response;
                });
                vm.mapAssetsCity = [];
                document.getElementById("myspanCity").textContent = " ";
                /* var myOptions = {
                    zoom: vm.zoomLevelCity,
                    center: new google.maps.LatLng(
                        DEFAULT_LATITUDE.value,
                        DEFAULT_LONGITUDE.value
                    ),
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locationsCity.mapCity = new google.maps.Map(
                    document.getElementById("map_canva"),
                    myOption(
                        12,
                        new google.maps.LatLng(
                            DEFAULT_LATITUDE.value,
                            DEFAULT_LONGITUDE.value
                        )
                    )
                );
                geoLocation(locationsCity.mapCity);
                var input = document.getElementById("field_pinLat");
                input.value = "";
            }
        };

        $("#masterGeofence").on("change", function () {
            $scope.searchAssetCity = "";
            vm.mapAssetsCity = [];
            vm.userGeofencesCity = [];
            var value = $(this).val();
            vm.selectedMasterGeofenceId = value;
            GeofenceByID.get(value, function (geofenceDetails) {
                var points = JSON.parse(geofenceDetails.coordinates);
                locationsCity.latlng = {
                    lat: points[0].lat,
                    lng: points[0].lng,
                };
                /* var myOptions = {
                    zoom: 10,
                    center: locationsCity.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locationsCity.mapCity = new google.maps.Map(
                    document.getElementById("map_canva"),
                    myOption(10, locationsCity.latlng)
                );
                geoLocation(locationsCity.mapCity);
                drawPolygon(
                    geofenceDetails,
                    locationsCity.latlng,
                    "#fd7a24",
                    1
                );
                vm.selectedMapGeofenceIds = [];
                MiniGeofencesByMasterID.get(
                    geofenceDetails.id,
                    function (response) {
                        if (response.length > 0) {
                            mapZoomChangeCity(locationsCity.mapCity);
                        } else {
                            document.getElementById("myspanCity").textContent =
                                "";
                        }
                        vm.userGeofencesCity = [];
                        response.forEach(function (value, index) {
                            value.ticked = true;
                            $scope.selectAll = true;
                            $scope.options[index] = true;
                            value.label = value.name.substring(0, 15);
                            vm.userGeofencesCity.push(value);
                            vm.selectedMapGeofenceIds.push(value.id);
                            vm.previousPolygons.push(
                                drawPolygon(
                                    value,
                                    locationsCity.latlng,
                                    "#00e658",
                                    2
                                )
                            );
                        });
                        AssetTypesByGeofenceIDs.get(
                            {
                                geofences: vm.selectedMapGeofenceIds,
                            },
                            function (assetTypeVal) {
                                vm.assetTypeValuesCity = assetTypeVal;
                                vm.filterAssetTypesCity = [];

                                assetTypeVal.forEach(function (assettype) {
                                    vm.filterAssetTypesCity.push({
                                        id: assettype.id,
                                        name: assettype.assetTypeName,
                                        ticked: false,
                                    });
                                });
                                $scope.selectedFilterAssetTypesCity = [];
                                for (
                                    var i = 0;
                                    i < vm.filterAssetTypesCity.length;
                                    i++
                                ) {
                                    if (
                                        vm.filterAssetTypesCity[i].name ==
                                        "KML Link" ||
                                        vm.filterAssetTypesCity[i].name ==
                                        "Optical Fiber Cable"
                                    ) {
                                        $scope.selectedFilterAssetTypesCity.push(
                                            vm.filterAssetTypesCity[i]
                                        );
                                        vm.filterAssetTypesCity[
                                            i
                                        ].ticked = true;
                                    } else {
                                        vm.filterAssetTypesCity[
                                            i
                                        ].ticked = false;
                                    }
                                }
                                var assetLayersbyCity = [];
                                vm.mapAssetsCity = [];
                                $scope.selectedFilterAssetTypesCity.forEach(
                                    function (item) {
                                        assetLayersbyCity.push(item.name);
                                    }
                                );
                                getGroupAssetsFromESCity(
                                    vm.selectedMapGeofenceIds,
                                    null,
                                    vm.mapAssetsCity,
                                    assetLayersbyCity
                                );
                            }
                        );
                    }
                );
            });
        });

        function drawTheAssetsCity() {
            vm.zoomLevelCity = locationsCity.mapCity.getZoom();

            if (vm.zoomLevelCity > 9) {
                var assetListCity = [];
                var chamberListCity = [];
                var couplerListCity = [];
                var poleListCity = [];
                var otherListCity = [];
                var handholeListCity = [];
                var jointClosureListCity = [];
                var SiteListCity = [];
                var handholeCHListCity = [];

                for (
                    var index = 0;
                    index < vm.assetTypeValuesCity.length;
                    index++
                ) {
                    if (
                        vm.assetTypeValuesCity[index].zoomLevel >= 10 &&
                        vm.assetTypeValuesCity[index].zoomLevel <= 14
                    ) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            assetListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 15) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            chamberListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 15) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            handholeListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 15) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            handholeCHListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 15) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            SiteListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 16) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            couplerListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 17) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            poleListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 16) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            jointClosureListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 18) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            otherListCity.push(assetVal);
                        });
                    }
                }
                drawLatestAssetsCity(assetListCity, "level1");

                drawAssetsCity(chamberListCity, "level2");
                drawAssetsCity(handholeListCity, "level2");
                drawAssetsCity(SiteListCity, "level2");

                drawAssetsCity(couplerListCity, "level3");

                drawAssetsCity(poleListCity, "level4");
                drawAssetsCity(jointClosureListCity, "level4");

                drawAssetsCity(otherListCity, "level5");
            }
        }

        $scope.toggleUserGeofences = function (index) {
            vm.userGeofencesCity[index].checked = !vm.userGeofencesCity[index]
                .checked;
            $scope.selectAll = true;
            vm.userGeofencesCity.forEach(function (value) {
                if (!value.checked) {
                    $scope.selectAll = false;
                }
            });
        };

        $scope.toggleAll = function () {
            var checked = $scope.selectAll;
            for (var i = 0; i < vm.userGeofencesCity.length; i++) {
                $scope.options[i] = checked;
                vm.userGeofencesCity[i].checked = checked;
            }
        };

        function drawPolygon(value, latlang, color, zIndex) {
            var path = JSON.parse(value.coordinates);
            // drawPolylineForGeoFence(path, locations.map, value.name);
            var infowindow = new google.maps.InfoWindow({
                content:
                    '<div class="infoWindowhead">' +
                    "name" +
                    '<div class="infoWindowContent"> <b>Description :</b> ' +
                    "des" +
                    "</div></div>",
            });

            infowindow.setPosition(latlang);
            var strokeColor = "#ff6a08";

            if (color == "green") {
                strokeColor = "#00e658";
            } else if (color == "blue") {
                strokeColor = "#0066CC";
            }

            var tempPolygon = new google.maps.Polygon({
                paths: path,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 1.2,
                fillColor: strokeColor,
                fillOpacity: 0.1,
                zIndex: zIndex,
            });
            google.maps.event.addListener(
                tempPolygon,
                "mouseout",
                function (event) {
                    infowindow.close();
                }
            );

            google.maps.event.addListener(
                tempPolygon,
                "click",
                function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent(
                        '<div class="infoWindowhead">' +
                        "<b>Geofence Name : </b><br><br>" +
                        value.name +
                        "</br></div>"
                    );

                    infowindow.mousemove;
                    infowindow.open(locationsCity.mapCity);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                }
            );
            tempPolygon.setMap(locationsCity.mapCity);
            return tempPolygon;
        }

        $(function () {
            $("#page_size").change(function () {
                vm.itemsPerPage = parseInt(
                    document.getElementById("page_size").value
                );
                vm.showAssetDelete = false;
                vm.selectedAssets = [];
                getAssetsForListView();
                vm.selectedMapGeofenceId = null;
                vm.userGeofences.forEach(function (value) {
                    if (vm.selectedMapGeofenceId == null) {
                        vm.selectedMapGeofenceId = value.id;
                    }
                });
            });
        });

        function getAssetsForListView() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var str = $scope.search + "";
                str = str.replace("/", "slash");
                if (vm.selectedListGeofenceId > 0) {
                    AssetGroupSearchWithGeofence.query(
                        {
                            search: str,
                            geofenceId: vm.selectedListGeofenceId,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                        },
                        onSuccessListSearch,
                        onErrorListSearch
                    );
                } else {
                    AssetGroupSearch.query(
                        {
                            search: str,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                        },
                        onSuccessListSearch,
                        onErrorListSearch
                    );
                }

                function onSuccessListSearch(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.totalItems =
                        Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                    vm.assetsForListView = data;
                    tempList = []
                    data.forEach(function (item) {
                        tempList.push({ id: item.id, burriedStatus: item.burried })
                    })
                    vm.page = pagingParams.page;
                }

                function onErrorListSearch(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                if (vm.selectedListGeofenceId > 0) {
                    AssetGroupWithGeofence.query(
                        {
                            geofenceId: vm.selectedListGeofenceId,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                        },
                        onSuccessList,
                        onErrorList
                    );
                } else {
                    AssetGroup.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                        },
                        onSuccessList,
                        onErrorList
                    );
                }

                function onSuccessList(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.totalItems =
                        Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                    vm.assetsForListView = data;
                    tempList = []
                    data.forEach(function (item) {
                        tempList.push({ id: item.id, burriedStatus: item.burried })
                    })
                    vm.page = pagingParams.page;
                }

                function onErrorList(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        $scope.accessibleCheckChange = function (asset) {
            vm.checkAccessible = asset.accessible;
            vm.changeAcessibleStatus = vm.checkAccessible
                ? "Accessible"
                : "Inaccessible";
            var yes = document.getElementById("yes-button");

            yes.onclick = function () {
                AssetByID.get(asset.id, function (assetVal) {
                    assetVal.accessible = asset.accessible;
                    assetVal.assetImages = []
                    Asset.update(assetVal);
                });
            };

            var no = document.getElementById("remove-button");

            no.onclick = function () {
                getAssetsForListView();
            };

            var close = document.getElementById("close-button");

            close.onclick = function () {
                getAssetsForListView();
            };

            var closeModal = document.getElementById("myModal");

            closeModal.onclick = function (e) {
                if (e.target == this) {
                    getAssetsForListView();
                }
            };
        };

        vm.onChangeBuried = function (asset) {
            vm.assetTitle = asset.name
            var yes = document.getElementById("yesButtonBurried");
            var no = document.getElementById("noButtonBurried");
            var close = document.getElementById("closeButtonBurried");

            var tempBuriedStatus = tempList.find(function (item) {
                return item.id == asset.id
            })

            yes.onclick = function () {
                AssetByID.get(asset.id, function (assetVal) {
                    assetVal.burried = asset.burried;
                    assetVal.assetImages = []
                    Asset.update(assetVal);
                });
            };

            no.onclick = function () {
                asset.burried = tempBuriedStatus.burriedStatus
                $scope.$apply()
            };

            close.onclick = function () {
                asset.burried = tempBuriedStatus.burriedStatus
                $scope.$apply()
            };
        }

        function getGroupAssetsFromES(
            geofenceIdVal,
            lastAssetId,
            mapAssetLists
        ) {
            AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                if (lastAssetId == null) {
                    vm.filterAssetTypes = [];
                    if (data.assettypes.length) {
                        data.assettypes.forEach(function (assettype) {
                            if (vm.assetTypes.length) {
                                vm.assetTypes.forEach(function (item) {
                                    if (item.id == assettype.id) {
                                        assettype.layout = item.layout
                                        if (item.layout == "FIXED") {
                                            assettype.icon =
                                                '<img  src="' +
                                                item.imagePath +
                                                '"style="width: 24px; height: 24px;">';
                                            assettype.code = item.imagePath
                                        } else {
                                            assettype.icon =
                                                '<img class="square" style="background-color:' +
                                                item.colorcode +
                                                ';">';
                                            assettype.code = item.colorcode
                                        }
                                    }
                                })
                            }


                            vm.filterAssetTypes.push({
                                id: assettype.id,
                                name: assettype.assetTypeName,
                                ticked: true,
                                icon: assettype.icon,
                                layout: assettype.layout,
                                code: assettype.code
                            });
                        });
                    }
                }
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;
                    tmpAsset.burried = asset.burried
                    //tmpAsset.healthIndicator = asset.healthIndicator;
                    //tmpAsset.healthRemarks = asset.healthRemarks;

                    vm.mapAssets.push(tmpAsset);
                });

                if (data.assets.length < 500) {
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        var assetType = vm.assetTypeValues[index];
                        var typeName = assetType.assetTypeName;
                        var typeAssetsList = [];
                        if (assetType.assets != null) {
                            typeAssetsList = assetType.assets;
                        }

                        vm.mapAssets.forEach(function (asset) {
                            if (typeName == asset.assetTypeName) {
                                typeAssetsList.push(asset);
                            }
                        });
                        assetType.assets = typeAssetsList;
                        vm.assetTypeValues[index] = assetType;
                        if (vm.assetTypeValues[index].zoomLevel >= 15) {
                            var labelLength = vm.assetTypeValues[index].assets;
                            for (var i = 0; i < labelLength.length; i++) {
                                vm.assetTypeValues[index].assets[i].label =
                                    vm.assetTypeValues[index].zoomLevel;
                            }
                        }
                    }

                    if (vm.zoomLevel == 12) {
                        var assetList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 12) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        assetList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawLatestAssets(assetList, "level1");
                        isLevel1AssetsVisible = true;
                    }

                    vm.nodeAssets = [];
                    var tempNodeAssets = [];

                    vm.mapAssets.forEach(function (asset) {
                        if (
                            asset.assetTypeName == "BX1" ||
                            asset.assetTypeName == "BX2" ||
                            asset.assetTypeName == "BX3" ||
                            asset.assetTypeName == "BX4" ||
                            asset.assetTypeName == "DX4" ||
                            asset.assetTypeName == "DX16" ||
                            asset.assetTypeName == "DX11" ||
                            asset.assetTypeName == "DX10" ||
                            asset.assetTypeName == "DX15" ||
                            asset.assetTypeName == "ADX1" ||
                            asset.assetTypeName == "DX7" ||
                            asset.assetTypeName == "DX12" ||
                            asset.assetTypeName == "Sr Elements_Ax" ||
                            asset.assetTypeName == "Sr Elements_Bx" ||
                            asset.assetTypeName == "Sr Elements_Dx" ||
                            asset.assetTypeName == "Sr Elements_Mcr" ||
                            asset.assetTypeName == "Sr Elements_AX" ||
                            asset.assetTypeName == "Sr Elements_BX" ||
                            asset.assetTypeName == "Sr Elements_DX" ||
                            asset.assetTypeName == "Sr Elements_MCR" ||
                            asset.assetTypeName == "Sr_Elements_Cluster_New" ||
                            asset.assetTypeName == "Sr_Elements_Cluster"
                        ) {
                            var lat = asset.assetCoordinates[0].latitude.toFixed(
                                4
                            );
                            var lng = asset.assetCoordinates[0].longitude.toFixed(
                                4
                            );
                            tempNodeAssets.push({
                                lat: lat,
                                lng: lng,
                                assetDetails: asset,
                            });
                        }
                    });
                    vm.nodeAssets = Object.values(groupByKey(tempNodeAssets));
                }
                // drawLatestAssets(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupAssetsFromES(
                        geofenceIdVal,
                        data.lastId,
                        vm.mapAssets
                    );
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        var assetLatLng = {
                            lat:
                                assetSelected.assetCoordinates[
                                    assetSelected.assetCoordinates.length -
                                    1
                                ].latitude,
                            lng:
                                assetSelected.assetCoordinates[
                                    assetSelected.assetCoordinates.length -
                                    1
                                ].longitude,
                        };
                        try {
                            locations.map.setCenter(assetLatLng);
                        } catch (error) {
                            console.log(error);
                        }
                        /* AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].longitude,
                            };
                            try {
                                locations.map.setCenter(assetLatLng);
                            } catch (error) {
                                console.log(error);
                            }
                        }); */
                    }
                }
                if (vm.isEnableNavigate) {
                    $scope.fillTextbox(vm.storeAsset)
                    $scope.searchAsset = "";
                }
            });
        }

        function groupByKey(array) {
            var flags = [],
                output = [];
            for (var i = 0; i < array.length; i++) {
                if (flags[array[i].lat]) continue;
                flags[array[i].lat] = true;
                output.push(array[i].lat);
            }
            var result = [];
            for (var j = 0; j < output.length; j++) {
                var objArray = [];
                for (var k = 0; k < array.length; k++) {
                    if (output[j] == array[k].lat) {
                        objArray.push(array[k]);
                    }
                }
                result.push(objArray);
            }
            return result;
        }

        function getGroupAssetsFromESCity(
            geofenceIds,
            lastAssetId,
            mapAssetLists,
            assetLayersbyCity
        ) {
            AssetGroupByGeofencesES.get(
                {
                    lastAssetId: lastAssetId,
                    geofences: geofenceIds,
                    assetTypes: assetLayersbyCity,
                },
                function (data) {
                    vm.mapAssetsCity = mapAssetLists;
                    data.assets.forEach(function (asset) {
                        var tmpAsset = {};

                        tmpAsset.assetCoordinates = asset.assetCoordinates;
                        tmpAsset.assetTypeName = asset.assetTypeName;
                        tmpAsset.assetTypeColor = asset.assetColor;
                        tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                        tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                        tmpAsset.id = asset.id;
                        tmpAsset.name = asset.name;

                        vm.mapAssetsCity.push(tmpAsset);
                    });

                    if (data.assets.length < 500) {
                        for (
                            var index = 0;
                            index < vm.assetTypeValuesCity.length;
                            index++
                        ) {
                            var assetType = vm.assetTypeValuesCity[index];
                            var typeName = assetType.assetTypeName;
                            var typeAssetsList = [];
                            if (assetType.assets != null) {
                                typeAssetsList = assetType.assets;
                            }

                            vm.mapAssetsCity.forEach(function (asset) {
                                if (typeName == asset.assetTypeName) {
                                    typeAssetsList.push(asset);
                                }
                            });
                            assetType.assets = typeAssetsList;
                            vm.assetTypeValuesCity[index] = assetType;
                        }
                        /* var assetListCity = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValuesCity.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValuesCity[index].assetTypeName ==
                                    "KML Link" ||
                                vm.assetTypeValuesCity[index].assetTypeName ==
                                    "SOH" ||
                                vm.assetTypeValuesCity[index].assetTypeName ==
                                    "Link" ||
                                vm.assetTypeValuesCity[index].assetTypeName ==
                                    "UG-OH"
                            ) {
                                vm.assetTypeValuesCity[index].assets.forEach(
                                    function (assetVal) {
                                        assetListCity.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawLatestAssetsCity(assetListCity, "level1");
                        */
                        if ($scope.selectedFilterAssetTypesCity.length > 0) {
                            drawTheAssetsCity();
                        }
                    }
                    // drawLatestAssets(vm.mapAssets);
                    if (data.lastId != null) {
                        getGroupAssetsFromESCity(
                            geofenceIds,
                            data.lastId,
                            vm.mapAssetsCity,
                            assetLayersbyCity
                        );
                    } else {
                        if (vm.mapAssetsCity.length > 0) {
                            var assetSelected = vm.mapAssetsCity[0];
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates
                                            .length - 1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates
                                            .length - 1
                                    ].longitude,
                            };
                            try {
                                locationsCity.mapCity.setCenter(
                                    assetLatLng
                                );
                            } catch (error) {
                                console.log(error);
                            }
                            /* AssetByID.get(
                                assetSelected.id,
                                function (assetVal) {
                                    
                                }
                            ); */
                        }
                    }
                }
            );
        }

        function selectAssetEntity(asset) {
            if (asset.id != null) {
                if (asset.isChecked) {
                    vm.showAssetDelete = true;
                    //vm.isAllAssetSelected = vm.assets.every(function (itm) { return itm.isChecked; });
                    vm.selectedAssets.push(asset.id);
                } else {
                    var index = vm.selectedAssets.indexOf(asset.id);
                    if (index > -1) {
                        vm.selectedAssets.splice(index, 1);
                    }
                }
                if (vm.selectedAssets.length == 0) {
                    // vm.groupAssets = true;
                    vm.showAssetDelete = false;
                    getAssetsForListView();
                } else {
                    vm.showAssetDelete = true;
                }
            }
        }

        function selectAllAssets() {
            var toggleStatus = vm.isAllAssetSelected;
            if (toggleStatus) {
                vm.showAssetDelete = true;
                vm.selectedAssets = [];
                vm.assetsForListView.forEach(function (asset) {
                    vm.selectedAssets.push(asset.id);
                });
            } else {
                vm.showAssetDelete = false;
                vm.selectedAssets = [];
            }
            angular.forEach(vm.assetsForListView, function (item) {
                item.isChecked = toggleStatus;
            });
        }

        function confirmDelete() {
            $("#deleteAsset").show();
        }

        function selectAsets() {
            if (vm.selectedAssets.length > 0) {
                var assetGroupArray = [];
                vm.selectedAssets.forEach(function (assetId) {
                    assetGroupArray.push({ id: assetId });
                });
                AssetsBulkDelete.save(assetGroupArray, onSuccess, onError);
                function onSuccess() {
                    $("#deleteAsset").removeClass("in");
                    $(".modal-backdrop").remove();
                    $("#deleteAsset").hide();
                    vm.showAssetDelete = false;
                    vm.selectedAssets = [];
                    vm.isAllAssetSelected = false;
                    getAssetsForListView();
                    // $state.go('asset');
                }
                function onError(error) {
                    $("#deleteAsset").removeClass("in");
                    $(".modal-backdrop").remove();
                    $("#deleteAsset").hide();
                    var msg =
                        "Asset deletion failed, Asset has some dependent data";
                    if (error.status == 400) {
                        AlertService.error(msg);
                    } else {
                        AlertService.error(error.data.message);
                    }
                }
            } else {
                alert("Please select assets to delete list");
            }
        }

        var input = document.getElementById("field_pinLat");
        input.addEventListener("input", function () {
            this.value = this.value.replace(/[^-0-9\,\.]/, "");
        });

        function showZoomLocation() {
            var latlng = vm.getLocationCoordinate.split(",");
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinate != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };

                if ($scope.tab == 2) {
                    locations.map.setCenter(assetCenterLatLng);
                    locations.map.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: locations.map,
                        position: assetCenterLatLng,
                    });
                }

                if ($scope.tab == 3) {
                    locationsCity.mapCity.setCenter(assetCenterLatLng);
                    locationsCity.mapCity.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: locationsCity.mapCity,
                        position: assetCenterLatLng,
                    });
                }

                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }
        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function gotoLatituteCity() {
            $("#modalLatLongs").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function closeGotoLatitute(id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }
        function closeGotoLatituteCity() {
            $("#modalLatLongs").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalLatLongs").hide();
        }

        function showLayers() {
            vm.currentZoom = locations.map.getZoom();

            vm.getCenter = locations.map.center;

            $("#modalLayer").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }
        function showLayersCity() {
            vm.currentZoomCity = locationsCity.mapCity.getZoom();

            vm.getCenterCity = locationsCity.mapCity.center;

            $("#modalLayer").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function closeLayers() {
            $("#modalLayer").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalLayer").hide();
        }

        function filterAssetsOnMapView() {
            vm.userGeofences = [];
            if (vm.adminFilter) {
                GeofenceIDs.getAll(function (response) {
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        vm.userGeofences.push(geofence);
                        /* if (vm.selectedMapGeofenceId == null) {
                            vm.selectedMapGeofenceId = geofence.id;
                        } */
                        if (tempGeofenceId == geofence.id) {
                            geofence.ticked = true;
                        }
                    });
                    vm.countLength = vm.userGeofences.length;
                });
            } else {
                UserGeofences.getAll(function (response) {
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        vm.userGeofences.push(geofence);
                        /* if (vm.selectedMapGeofenceId == null) {
                            vm.selectedMapGeofenceId = geofence.id;
                        } */
                        if (tempGeofenceId == geofence.id) {
                            geofence.ticked = true;
                        }
                    });
                    vm.countLength = vm.userGeofences.length;
                });
            }

            //$("#mapFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.prevSelectedGeofenceId = vm.selectedMapGeofenceId;
        }

        function filterAssetsOnMapViewCity() {
            $("#mapFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.prevSelectedMapGeofenceIds = vm.selectedMapGeofenceIds;
        }

        function closeMapFilterModal() {
            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            vm.selectedMapGeofenceId = vm.prevSelectedGeofenceId;
        }

        function closeImageUpload() {
            $("#myModalUpload").removeClass("in");
            $(".modal-backdrop").remove();
            $("#myModalUpload").hide();
            setTimeout(function () {
                $("#successImage").hide();
            }, 2000);
            setTimeout(function () {
                $("#errorImage").hide();
            }, 2000);
        }

        function closeMapFilterModalCity() {
            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            vm.selectedMapGeofenceIds = vm.prevSelectedMapGeofenceIds;
        }

        function editAssetOnMapView(fixed) {
            $("#assetEditModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none";
        }

        function closeEditAssetModal() {
            document.getElementById("assetEditName").textContent = "Asset";
            $("#assetEditModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#assetEditModal").hide();
        }

        function editAssetMarkerOnMapView(fixed) {
            $("#assetMarkerEditModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none";
        }

        function closeEditAssetMarkerModal() {
            document.getElementById("assetMarkerEditName").textContent = "Asset";
            $("#assetMarkerEditModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#assetMarkerEditModal").hide();
        }

        function viewAssetMarkerOnMapView(fixed) {
            $("#assetMarkerViewModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none";
        }

        function closeViewAssetMarkerModal() {
            document.getElementById("assetMarkerViewName").textContent = "Asset";
            $("#assetMarkerViewModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#assetMarkerViewModal").hide();
        }

        vm.imageInNewTab = function (img) {
            var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' + img + '">'
            );
            imgWindow.document.close();
        };

        function showAssetMarkerDetails(assetMarker) {
            vm.markerAssetToView = assetMarker;
            viewAssetMarkerOnMapView(assetMarker);
        }

        function editAssetMarker(assetMarker) {
            vm.markerAssetToEdit = assetMarker;
            editAssetMarkerOnMapView(assetMarker);
        }

        function saveEditMarkerAssetModal() {
            AssetByMarkerId.get(vm.markerAssetToEdit.id, function (response) {
                var assetMarkersList = [];
                response.assetMarkers.forEach(function (value) {
                    if (value.id == vm.markerAssetToEdit.id) {
                        value = vm.markerAssetToEdit;
                    }
                    assetMarkersList.push(value);
                });
                response.assetMarkers = assetMarkersList;
                Asset.update(response, onSaveSuccess, onSaveError);
                function onSaveSuccess(result) {
                    closeEditAssetMarkerModal();
                    // alert(result.name + " updated successfully!");
                }

                function onSaveError() {
                    closeEditAssetMarkerModal();
                    // alert(vm.assetToEdit.name + " got error while updating!");
                }
            });

        }
        function saveEditAssetModal() {
            if (vm.assetRefAttributes != null) {
                vm.assetToEdit.assetReferenceAttributes = [];
                for (var i = 0; i < vm.assetRefAttributes.length; i += 3) {
                    var obj = {};

                    obj["assetAttributeName"] = vm.assetRefAttributes[i]
                        ? {
                            assetTypeAttribute: vm.assetRefAttributes[i],
                            attributeValue:
                                vm.assetRefAttributes[i].attributeValue,
                            order: 0,
                            popupDisplay:
                                vm.assetRefAttributes[i]
                                    .assetTypePopupDisplay,
                        }
                        : null;

                    obj["assetAttributeValue"] = vm.assetRefAttributes[i + 1]
                        ? {
                            assetTypeAttribute: vm.assetRefAttributes[i + 1],
                            attributeValue:
                                vm.assetRefAttributes[i + 1].attributeValue,
                            order: 1,
                            popupDisplay:
                                vm.assetRefAttributes[i + 1]
                                    .assetTypePopupDisplay,
                        }
                        : null;

                    obj["assetAttributeImage"] = vm.assetRefAttributes[i + 2]
                        ? {
                            assetTypeAttribute: vm.assetRefAttributes[i + 2],
                            image:
                                vm.assetRefAttributes[i + 2].attributeValue,
                            imageName: vm.assetRefAttributes[i + 2]
                                .attributeName,
                            imageType: vm.assetRefAttributes[i + 2]
                                .attributeType,
                            imageId: vm.assetRefAttributes[i + 2]
                                .imageId,
                            attributeValue: "images",
                            order: 1,
                            popupDisplay:
                                vm.assetRefAttributes[i + 2]
                                    .assetTypePopupDisplay,
                        }
                        : null;
                    vm.assetToEdit.assetReferenceAttributes.push(obj);
                }
            }
            vm.assetToEdit.assetImages = []
            Asset.update(vm.assetToEdit, onSaveSuccess, onSaveError);
            function onSaveSuccess(result) {
                closeEditAssetModal();
                var findAssetIndex;
                switch (result.assetType.zoomLevel) {
                    case 15:
                        for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if (result.id == level2AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level2AssetsMarkers[i].setLabel("");
                                level2AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level2AssetsMarkers[i].setLabel(
                                    level2AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 15) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 16:
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if (result.id == level3AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level3AssetsMarkers[i].setLabel("");
                                level3AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level3AssetsMarkers[i].setLabel(
                                    level3AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }

                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 16) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 17:
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if (result.id == level4AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level4AssetsMarkers[i].setLabel("");
                                level4AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level4AssetsMarkers[i].setLabel(
                                    level4AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 17) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 18:
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if (result.id == level5AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level5AssetsMarkers[i].setLabel("");
                                level5AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level5AssetsMarkers[i].setLabel(
                                    level5AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 18) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 19:
                        for (var i = 0; i < level6AssetsMarkers.length; i++) {
                            if (result.id == level6AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level6AssetsMarkers[i].setLabel("");
                                level6AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level6AssetsMarkers[i].setLabel(
                                    level6AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 19) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 20:
                        for (var i = 0; i < level7AssetsMarkers.length; i++) {
                            if (result.id == level7AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level7AssetsMarkers[i].setLabel("");
                                level7AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level7AssetsMarkers[i].setLabel(
                                    level7AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 20) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    default:
                        console.log("not found");
                }
                vm.closeInfoWindow.close();
                //alert(result.name + " updated successfully!");
            }

            function onSaveError() {
                closeEditAssetModal();
                alert(vm.assetToEdit.name + " got error while updating!");
            }
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                pagesize: vm.itemsPerPage,
                listgeofenceid: vm.selectedListGeofenceId,
            });
        }

        function goToPage() {
            vm.page = parseInt(document.getElementById("pagenum").value);
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                pagesize: vm.itemsPerPage,
                listgeofenceid: vm.selectedListGeofenceId,
            });
        }

        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";

            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Name</th><th style='border: 1px solid black;text-align: center;'>Value</th></tr>";

            assetTypeAttributeValuesList.forEach(function (value) {
                if (
                    value.assetTypeAttribute.assetAttributeTypes ==
                    "NON_REFERENCE"
                ) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        value.assetTypeAttribute.name +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        value.attributeValue +
                        "</td></tr>";
                }
            });
            newTable += "</table>";
            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }

        function showThreePontReferenceModal(assetVal) {
            $("#modalThreePointReference").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues,
                assetReferenceAttributesList =
                    assetVal.assetReferenceAttributes,
                referenceAttribute = [];
            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Object</th><th style='border: 1px solid black;text-align: center;'>Distance (mtr)</th></tr>";
            var ref = [];
            var dist = [];
            if (assetVal.assetReferenceAttributes.length) {
                assetReferenceAttributesList.forEach(function (val) {
                    referenceAttribute.push(val["assetAttributeName"]);
                    referenceAttribute.push(val["assetAttributeValue"]);
                });
                referenceAttribute.forEach(function (val) {
                    if (
                        val.assetTypeAttribute.assetAttributeTypes ==
                        "THREE_PNT_REFERENCE"
                    ) {
                        if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference1" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference2" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference3" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance1" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance2" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance3" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        }
                    }
                });
            } else {
                assetTypeAttributeValuesList.forEach(function (value) {
                    if (
                        value.assetTypeAttribute.assetAttributeTypes ==
                        "THREE_PNT_REFERENCE"
                    ) {
                        if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference1"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference2"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference3"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance1"
                        ) {
                            dist.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance2"
                        ) {
                            dist.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance3"
                        ) {
                            dist.push(value.attributeValue);
                        }
                    }
                });
            }

            for (var i = 0; i < 3; i++) {
                if (ref[i] || dist[i]) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        ref[i] +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        dist[i] +
                        "</td></tr>";
                }
            }
            newTable += "</table>";
            document.getElementById(
                "assetNameThreePointReference"
            ).textContent = assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById(
                "threePointReferenceTable"
            ).innerHTML = newTable;
        }

        function closeAssetAttributesModal() {
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
        }

        function closeThreePointReference() {
            $("#modalThreePointReference").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalThreePointReference").hide();
        }

        $scope.geofenceListView = function () {
            if ($scope.tab == 1) {
                vm.selectedListGeofenceId = vm.selectedGeofence[0].id;
                tempGeofenceId = vm.selectedGeofence[0].id;
                getAssetsForListView();
            } else if ($scope.tab == 2) {
                isLevel1AssetsVisible = false;
                isLevel2AssetsVisible = false;
                isLevel3AssetsVisible = false;
                isLevel4AssetsVisible = false;
                isLevel5AssetsVisible = false;
                isLevelNodeVisible = false;
                assetVisibility19 = false;
                assetVisibility20 = false;
                vm.isEnableNavigate = false
                vm.selectedMapGeofenceId = vm.selectedMapGeofence[0].id;
                tempGeofenceId = vm.selectedMapGeofence[0].id; // switiching between one view to another view
                saveFilter();
            }
        };

        function filterAssetsOnListView() {
            tempGeofenceId = $state.params.listgeofenceid;
            vm.geofencesListView = [];
            if (vm.adminFilter) {
                GeofenceIDs.getAll(function (response) {
                    if ($scope.tab == 1) {
                        if (response.length >= 2) {
                            vm.geofencesListView.push({
                                id: 0,
                                name: "All",
                                label: "All",
                            });
                        }
                    }
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        geofence.ticked =
                            tempGeofenceId == geofence.id ? true : false;
                        vm.geofencesListView.push(geofence);
                        if (vm.selectedMapGeofenceId == null) {
                            vm.selectedMapGeofenceId = geofence.id;
                        }
                    });
                    vm.countLength = vm.geofencesListView.length;
                });
            } else {
                UserGeofences.getAll(function (response) {
                    if ($scope.tab == 1) {
                        if (response.length >= 2) {
                            vm.geofencesListView.push({
                                id: 0,
                                name: "All",
                                label: "All",
                            });
                        }
                    }
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        geofence.ticked =
                            tempGeofenceId == geofence.id ? true : false;
                        vm.geofencesListView.push(geofence);
                        if (vm.selectedMapGeofenceId == null) {
                            vm.selectedMapGeofenceId = geofence.id;
                        }
                    });
                    vm.countLength = vm.geofencesListView.length;
                });
            }
            /* $("#listFilterModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
        }

        function closeListFilterModal() {
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
            vm.selectedListGeofenceId = vm.PrevselectedListGeofenceId;
        }

        function saveListFilter() {
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
            getAssetsForListView();
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
        }

        $scope.initial = function (item) {
            if ($scope.bool) {
                // add item
                $scope.selectedFilterAssetTypes.push(item);
            }
        };

        $scope.initialCity = function () {
            if (vm.filterAssetTypesCity[0].isChecked != undefined) {
                $scope.selectedFilterAssetTypesCity = [];
                for (var i = 0; i < vm.filterAssetTypesCity.length; i++) {
                    if (
                        vm.filterAssetTypesCity[i].name == "KML Link" ||
                        vm.filterAssetTypesCity[i].name == "Optical Fiber Cable"
                    ) {
                        $scope.selectedFilterAssetTypesCity.push(
                            vm.filterAssetTypesCity[i]
                        );
                        vm.filterAssetTypesCity[i].ticked = true;
                    } else {
                        vm.filterAssetTypesCity[i].ticked = false;
                    }
                }
            }
        };

        $scope.sync = function () {
            $scope.selectedFilterAssetTypes = [];
            for (var i = 0; i < vm.selectedAsset.length; i++) {
                $scope.selectedFilterAssetTypes.push(vm.selectedAsset[i]);
            }
            vm.getCenter = locations.map.center;
            saveAssetTypeFilter();
        };

        /* $scope.sync = function (bool, item) {
            if (bool) {
                // add item
                $scope.selectedFilterAssetTypes.push(item);
            } else {
                // remove item

                for (
                    var i = 0;
                    i < $scope.selectedFilterAssetTypes.length;
                    i++
                ) {
                    if ($scope.selectedFilterAssetTypes[i].id == item.id) {
                        $scope.selectedFilterAssetTypes.splice(i, 1);
                    }
                }
            }
        };     */

        /* 
         ng-checked="isChecked(item.id)"

         $scope.isChecked = function(id){
            var match = true;
            for(var i=0 ; i < $scope.selectedFilterAssetTypes.length; i++) {
              if($scope.selectedFilterAssetTypes[i].id == id){
                match = true;
              }
            }
            return match;
        };*/

        function saveFilterCity() {
            $scope.searchAssetCity = "";
            vm.mapAssetsCity = [];
            vm.selectedMapGeofenceIds = [];
            vm.userGeofencesCity.forEach(function (geofence) {
                if (geofence.ticked) {
                    vm.selectedMapGeofenceIds.push(geofence.id);
                }
            });
            markersCity = [];
            polylinesCity = [];
            /* var myOptions = {
                zoom: 10,
                center: locationsCity.latlng,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            locationsCity.mapCity = new google.maps.Map(
                document.getElementById("map_canva"),
                myOption(10, locationsCity.latlng)
            );
            geoLocation(locationsCity.mapCity);

            /* var measureTool = new MeasureTool(locationsCity.mapCity, {
                contextMenu: true,
                unit: MeasureTool.UnitTypeId.METRIC,
            }); */

            mapZoomChangeCity(locationsCity.mapCity);
            var assetLayersbyCity = [];

            AssetTypesByGeofenceIDs.get(
                {
                    geofences: vm.selectedMapGeofenceIds,
                },
                function (assetTypeVal) {
                    vm.assetTypeValuesCity = assetTypeVal;
                    vm.filterAssetTypesCity = [];
                    assetTypeVal.forEach(function (assettype) {
                        vm.filterAssetTypesCity.push({
                            id: assettype.id,
                            name: assettype.assetTypeName,
                            ticked: false,
                        });
                    });
                    $scope.selectedFilterAssetTypesCity = [];
                    for (var i = 0; i < vm.filterAssetTypesCity.length; i++) {
                        if (
                            vm.filterAssetTypesCity[i].name == "KML Link" ||
                            vm.filterAssetTypesCity[i].name ==
                            "Optical Fiber Cable"
                        ) {
                            $scope.selectedFilterAssetTypesCity.push(
                                vm.filterAssetTypesCity[i]
                            );
                            vm.filterAssetTypesCity[i].ticked = true;
                        } else {
                            vm.filterAssetTypesCity[i].ticked = false;
                        }
                    }
                    $scope.selectedFilterAssetTypesCity.forEach(function (
                        item
                    ) {
                        assetLayersbyCity.push(item.name);
                    });
                    vm.mapAssetsCity = [];
                    getGroupAssetsFromESCity(
                        vm.selectedMapGeofenceIds,
                        null,
                        vm.mapAssetsCity,
                        assetLayersbyCity
                    );
                }
            );
            vm.prevSelectedMapGeofenceIds = vm.selectedMapGeofenceIds;
            vm.previousPolygons.forEach(function (polygon) {
                polygon.setMap(null);
            });
            GeofenceByID.get(
                vm.selectedMasterGeofenceId,
                function (geofenceDetails) {
                    drawPolygon(
                        geofenceDetails,
                        locationsCity.latlng,
                        "red",
                        1
                    );
                }
            );
            vm.userGeofencesCity.forEach(function (value) {
                if (value.ticked) {
                    vm.previousPolygons.push(
                        drawPolygon(value, locationsCity.latlng, "green", 2)
                    );
                }
            });

            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            $scope.selectedFilterAssetTypesCity = [];
        }

        //vm.boolTrue;
        /*  $scope.check = function () {
            var myOptions = {
                zoom: vm.currentZoom1,
                center: vm.getCenter,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };
            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOptions
            );
            var assetList = [];
            for (var index = 0; index < vm.assetTypeValues.length; index++) {
                if (
                    vm.assetTypeValues[index].assetTypeName == "KML Link" ||
                    vm.assetTypeValues[index].assetTypeName == "SOH" ||
                    vm.assetTypeValues[index].assetTypeName == "Link" ||
                    vm.assetTypeValues[index].assetTypeName == "UG-OH"
                ) {
                    vm.assetTypeValues[index].assets.forEach(function (
                        assetVal
                    ) {
                        assetList.push(assetVal);
                    });
                }
            }

            drawLatestAssets(assetList, "level1");
            isLevel1AssetsVisible = true;
            //saveFilter();
            //  for (var index = 0; index < vm.assetTypeValues.length; index++) {
            //     var assetType = vm.assetTypeValues[index];
            //     var typeName = assetType.assetTypeName;
            //     var typeAssetsList = [];
            //     if (assetType.assets != null) {
            //         typeAssetsList = assetType.assets;
            //     }

            //     vm.mapAssets.forEach(function (asset) {
            //         if (typeName == asset.assetTypeName) {
            //             typeAssetsList.push(asset);
            //         }
            //     });
            //     assetType.assets = typeAssetsList;
            //     vm.assetTypeValues[index] = assetType;
            // }
            
            // var assetList = [];
            // for (var index = 0; index < vm.assetTypeValues.length; index++) {
            //     if (
            //         vm.assetTypeValues[index].assetTypeName == "KML Link" ||
            //         vm.assetTypeValues[index].assetTypeName == "SOH" ||
            //         vm.assetTypeValues[index].assetTypeName == "Link" ||
            //         vm.assetTypeValues[index].assetTypeName == "UG-OH"
            //     ) {
            //         vm.assetTypeValues[index].assets.forEach(function (
            //             assetVal
            //         ) {
            //             assetList.push(assetVal);
            //         });
            //     }
            // }
            // drawLatestAssets(assetList, "level1");
            
            // isLevel1AssetsVisible = true; 

            // vm.nodeAssets = [];
            // var tempNodeAssets = [];

            // vm.mapAssets.forEach(function (asset) {
            //     if (
            //         asset.assetTypeName == "BX1" ||
            //         asset.assetTypeName == "BX2" ||
            //         asset.assetTypeName == "BX3" ||
            //         asset.assetTypeName == "BX4" ||
            //         asset.assetTypeName == "DX4" ||
            //         asset.assetTypeName == "DX16" ||
            //         asset.assetTypeName == "DX11" ||
            //         asset.assetTypeName == "DX10" ||
            //         asset.assetTypeName == "DX15" ||
            //         asset.assetTypeName == "ADX1" ||
            //         asset.assetTypeName == "DX7" ||
            //         asset.assetTypeName == "DX12" ||
            //         asset.assetTypeName == "Sr Elements_Ax" ||
            //         asset.assetTypeName == "Sr Elements_Bx" ||
            //         asset.assetTypeName == "Sr Elements_Dx" ||
            //         asset.assetTypeName == "Sr Elements_Mcr" ||
            //         asset.assetTypeName == "Sr Elements_AX" ||
            //         asset.assetTypeName == "Sr Elements_BX" ||
            //         asset.assetTypeName == "Sr Elements_DX" ||
            //         asset.assetTypeName == "Sr Elements_MCR"
            //     ) {
            //         var lat = asset.assetCoordinates[0].latitude.toFixed(4);
            //         var lng = asset.assetCoordinates[0].longitude.toFixed(4);
            //         tempNodeAssets.push({
            //             lat: lat,
            //             lng: lng,
            //             assetDetails: asset,
            //         });
            //     }
            // });
            // vm.nodeAssets = Object.values(groupByKey(tempNodeAssets));
        };   */

        function saveFilter() {
            vm.storeCases = null;
            vm.displayCaseType = false;
            $scope.$evalAsync();
            $scope.searchAsset = "";
            /* if (vm.prevSelectedGeofenceId != vm.selectedMapGeofenceId) {
                $scope.variableHealth = false;
            }
            vm.health = true; */

            vm.mapAssets = [];
            markers = [];
            polylines = [];

            /* var myOptions = {
                zoom: 12,
                center: locations.latlng,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(12, locations.latlng)
            );

            geoLocation(locations.map);
            /* try{
                var measureTool = new MeasureTool(locations.map, {
                    contextMenu: true,
                    unit: MeasureTool.UnitTypeId.METRIC,
                });
            }catch(err){
                console.log(err)
            } */
            document.getElementById("myspan").textContent = "";
            vm.zoomLevel = locations.map.getZoom();
            AssetTypesByGeofenceID.get(
                vm.selectedMapGeofenceId,
                function (assetTypeVal) {
                    vm.assetTypeValues = assetTypeVal;
                    getGroupAssetsFromES(
                        vm.selectedMapGeofenceId,
                        null,
                        vm.mapAssets
                    );
                }
            );
            vm.prevSelectedGeofenceId = vm.selectedMapGeofenceId;

            /*  $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide(); */
            $scope.selectedFilterAssetTypes = [];
        }

        function saveAssetTypeFilter() {
            $scope.searchAsset = "";
            //closeLayers();
            drawAssets(vm.mapAssets, "level1");
            /* var myOptions = {
                zoom: vm.currentZoom,
                center: vm.getCenter,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(vm.currentZoom, vm.getCenter)
            );
            geoLocation(locations.map);
            /* var measureTool = new MeasureTool(locations.map, {
                contextMenu: true,
                unit: MeasureTool.UnitTypeId.METRIC,
            }); */
            document.getElementById("myspan").textContent = "";
            if ($scope.selectedFilterAssetTypes.length > 0) {
                mapZoomChange(locations.map);
                mapZoomChangeFilter(locations.map);

                var assetList = [];
                for (
                    var index = 0;
                    index < vm.assetTypeValues.length;
                    index++
                ) {
                    if (
                        vm.assetTypeValues[index].zoomLevel >= 10 &&
                        vm.assetTypeValues[index].zoomLevel <= 14
                    ) {
                        vm.assetTypeValues[index].assets.forEach(function (
                            assetVal
                        ) {
                            assetList.push(assetVal);
                        });
                    }
                }

                drawLatestAssets(assetList, "level1");
                isLevel1AssetsVisible = true;
            }

            /* if (vm.mapAssets.length > 0) {
                var assetSelected = vm.mapAssets[0];
                AssetByID.get(assetSelected.id, function (assetVal) {
                    var assetLatLng = {
                        lat: assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                        lng: assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                    };
                    try {
                        locations.map.setCenter(assetLatLng);
                    } catch (error) {
                        console.log(error);
                    }
                }); 
            }*/
        }

        function saveAssetTypeFilterCity() {
            $scope.searchAssetCity = "";
            //closeLayers();
            // drawAssetsCity(vm.mapAssetsCity, "level1");
            $scope.selectedFilterAssetTypesCity = [];
            vm.filterAssetTypesCity.forEach(function (value) {
                if (value.ticked) {
                    $scope.selectedFilterAssetTypesCity.push(value);
                }
            });
            /*  var myOptions = {
                zoom: vm.currentZoomCity,
                center: vm.getCenterCity,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.TERRAIN,
            }; */
            locationsCity.mapCity = new google.maps.Map(
                document.getElementById("map_canva"),
                myOption(vm.currentZoomCity, vm.getCenterCity)
            );

            geoLocation(locationsCity.mapCity);
            document.getElementById("myspanCity").textContent = "";

            //drawTheAssetsCity();

            mapZoomChangeCity(locationsCity.mapCity);

            GeofenceByID.get(
                vm.selectedMasterGeofenceId,
                function (geofenceDetails) {
                    drawPolygon(
                        geofenceDetails,
                        locationsCity.latlng,
                        "red",
                        1
                    );
                }
            );
            vm.userGeofencesCity.forEach(function (value) {
                if (value.ticked) {
                    vm.previousPolygons.push(
                        drawPolygon(value, locationsCity.latlng, "green", 2)
                    );
                }
            });
            var assetLayersbyCity = [];
            vm.mapAssetsCity = [];

            $scope.selectedFilterAssetTypesCity.forEach(function (item) {
                assetLayersbyCity.push(item.name);
            });
            getGroupAssetsFromESCity(
                vm.selectedMapGeofenceIds,
                null,
                vm.mapAssetsCity,
                assetLayersbyCity
            );
        }

        $scope.complete = function () {
            $scope.hidethis = false;
        };

        $scope.hideAssetList = function () {
            $scope.hidethis = true;
        };
        $scope.fillTextbox = function (item) {
            $scope.searchAsset = item.name;
            $scope.hidethis = true;
            var assetSelected = item;
            clearTimeout(assetTimer);
            clearTimeout(polylineTimer);
            clearTimeout(closeClick);
            infowindowSearch = new google.maps.InfoWindow();
            if (activeInfo != null) {
                activeInfo.close();
                if (spreadPoly != null) {
                    spreadPoly.setMap(null);
                }
            }
            if (item.label <= 18) {
                locations.map.setZoom(18);
            } else if (item.label) {
                locations.map.setZoom(item.label);
            } else {
                locations.map.setZoom(21);
            }

            var getMapZoom = locations.map.getZoom();
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (assetVal.assetType.layout == "SPREAD") {
                    locations.map.setZoom(21);
                    var spreadPolyArr = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArr.push({
                            lat: val.latitude,
                            lng: val.longitude,
                            sortOrder: val.sortOrder
                        });
                    });
                    
                    if (spreadPolyArr[0].sortOrder != null) {
                        spreadPolyArr.sort(function (a, b) {
                            return a.sortOrder - b.sortOrder;
                        });
                    }
                    
                    spreadPoly = new google.maps.Polyline({
                        path: spreadPolyArr,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPoly.setMap(locations.map);

                    polylineTimer = setTimeout(function () {
                        if (spreadPoly != null) {
                            spreadPoly.setMap(null);
                            spreadPoly = null;
                        }
                    }, 10000);
                }
                if (getMapZoom > 15) {
                    if (!isLevelNodeVisible) {
                        for (var i = 0; i < nodeMarkers.length; i++) {
                            for (
                                var index = 0;
                                index < nodeMarkers.length;
                                index++
                            ) {
                                nodeMarkers[index].setMap(null);
                            }
                            nodeCluster.clearMarkers();
                            nodeMarkers = [];
                        }
                        drawNodeAssets();
                        isLevelNodeVisible = true;
                    }
                }

                if (getMapZoom > 14) {
                    if (!isLevel2AssetsVisible) {
                        var zoomLevel_15 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 15) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_15.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_15, "level2");

                        /* var handHoleList = [];
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Chamber / Handhole"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    handHoleList.push(assetVal);
                                }
                            );
                        }
                    }
                    drawAssets(handHoleList, "level2");

                    var handHoleCHList = [];
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Handhole CH"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    handHoleCHList.push(assetVal);
                                }
                            );
                        }
                    }
                    drawAssets(handHoleCHList, "level2");

                    var siteList = [];
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Site"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    siteList.push(assetVal);
                                }
                            );
                        }
                    }
                    drawAssets(siteList, "level2"); */
                        isLevel2AssetsVisible = true;
                    }
                }

                if (getMapZoom > 15) {
                    if (!isLevel3AssetsVisible) {
                        var couplerList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 16) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        couplerList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(couplerList, "level3");
                        isLevel3AssetsVisible = true;
                    }
                }

                if (getMapZoom > 16) {
                    if (!isLevel4AssetsVisible) {
                        var zoomLevel_17 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 17) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_17.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_17, "level4");
                        isLevel4AssetsVisible = true;
                    }
                }

                if (getMapZoom > 17) {
                    if (!isLevel5AssetsVisible) {
                        var zoomLevel_18 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 18) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_18.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_18, "level5");
                        isLevel5AssetsVisible = true;
                    }
                }

                if (getMapZoom > 18) {
                    if (!assetVisibility19) {
                        var zoomLevel_19 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 19) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_19.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_19, "level6");
                        assetVisibility19 = true;
                    }
                }

                if (getMapZoom > 19) {
                    if (!assetVisibility20) {
                        var zoomLevel_20 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 20) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_20.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_20, "level7");
                        assetVisibility20 = true;
                    }
                }

                /* if(getMapZoom == 19){
                    if(!vm.zoomLabel19){
                        for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if(level2AssetsMarkers[i].labelZoom == 19){
                                level2AssetsMarkers[i].setLabel(level2AssetsMarkers[i].displayLabel);
                            }
                        }
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if(level3AssetsMarkers[i].labelZoom == 19){
                            level3AssetsMarkers[i].setLabel(level3AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if(level4AssetsMarkers[i].labelZoom == 19){
                            level4AssetsMarkers[i].setLabel(level4AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if(level5AssetsMarkers[i].labelZoom == 19){
                            level5AssetsMarkers[i].setLabel(level5AssetsMarkers[i].displayLabel);}
                        }
                        vm.zoomLabel19 = true 
                    }
                }

                if(getMapZoom == 20){
                    if(!vm.zoomLabel20){
                        for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if(level2AssetsMarkers[i].labelZoom == 20){
                                level2AssetsMarkers[i].setLabel(level2AssetsMarkers[i].displayLabel);
                            }
                        }
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if(level3AssetsMarkers[i].labelZoom == 20){
                            level3AssetsMarkers[i].setLabel(level3AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if(level4AssetsMarkers[i].labelZoom == 20){
                            level4AssetsMarkers[i].setLabel(level4AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if(level5AssetsMarkers[i].labelZoom == 20){
                            level5AssetsMarkers[i].setLabel(level5AssetsMarkers[i].displayLabel);}
                        }
                        vm.zoomLabel20 =  true;
                    }
                } */

                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locations.map.setCenter(assetLatLng);
                infowindowSearch.setContent(item.name);
                infowindowSearch.open(locations.map);
                activeInfo = infowindowSearch;
                infowindowSearch.setPosition(assetLatLng);
                assetTimer = setTimeout(function () {
                    if (activeInfo != null) {
                        activeInfo.close();
                    }
                }, 10000);
            });
            google.maps.event.addListener(locations.map, "click", function () {
                activeInfo.close();
            });
        };
        /* $("#searchAssetsOnMap").click(function () {
            clearTimeout(assetTimer)
            clearTimeout(polylineTimer)
            clearTimeout(closeClick)
            infowindowSearch = new google.maps.InfoWindow();
            var assetSelected = JSON.parse($("#searchAssetsOnMap").val());
            if (activeInfo != null) {
                activeInfo.close();
                if (spreadPoly != null) {
                    spreadPoly.setMap(null);
                }
            }
            locations.map.setZoom(18);
            var getMapZoom = locations.map.getZoom()
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (
                    assetVal.assetType.name == "KML Link" ||
                    assetVal.assetType.name == "SOH" ||
                    assetVal.assetType.name == "Link" ||
                    assetVal.assetType.name == "UG-OH"
                ) {
                    locations.map.setZoom(21);
                    var spreadPolyArr = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArr.push({
                            lat: val.latitude,
                            lng: val.longitude,
                        });
                    });
                    spreadPoly = new google.maps.Polyline({
                        path: spreadPolyArr,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPoly.setMap(locations.map);

                    polylineTimer = setTimeout(function () {
                        if (spreadPoly != null) {
                            spreadPoly.setMap(null);
                            spreadPoly = null;
                        }
                    }, 10000);
                }
                
                if (getMapZoom > 15){
                    if(!isLevelNodeVisible){
                        for (var i = 0; i < nodeMarkers.length; i++) {
                            for (
                                var index = 0;
                                index < nodeMarkers.length;
                                index++
                            ) {
                                nodeMarkers[index].setMap(null);
                            }
                            nodeCluster.clearMarkers();
                            nodeMarkers = [];
                        }
                        drawNodeAssets();
                        isLevelNodeVisible = true;
                    }
                 } 
                 
                 if (getMapZoom > 14){
                    if(!isLevel2AssetsVisible){
                        var chamberList = [];
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Chamber"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    chamberList.push(assetVal);
                                }
                            );
                        }
                    }
                    drawAssets(chamberList, "level2");
                    isLevel2AssetsVisible = true;
                    }
                }
                
                if (getMapZoom > 15){
                    if (!isLevel3AssetsVisible) {
                        var couplerList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValues[index].assetTypeName ==
                                "Coupler"
                            ) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        couplerList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(couplerList, "level3");
                        isLevel3AssetsVisible = true;
                    }
                }
                
                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locations.map.setCenter(assetLatLng);
                infowindowSearch.setContent(assetVal.name);
                infowindowSearch.open(locations.map);
                activeInfo = infowindowSearch;
                infowindowSearch.setPosition(assetLatLng);
                assetTimer = setTimeout(function () { 
                    if (activeInfo != null) {activeInfo.close(); }},10000)
            });
            google.maps.event.addListener(locations.map, "click", function () {
                activeInfo.close();
            });
        }); */

        $scope.searchAssetsOnMapCity = function (item) {
            $scope.searchAssetCity = item.name;
            $scope.hidethis = true;
            var assetSelected = item;
            clearTimeout(assetTimerCity);
            clearTimeout(polylineTimerCity);
            locationsCity.mapCity.setZoom(18);
            infowindowSearchCity = new google.maps.InfoWindow();
            if (activeInfoCity != null) {
                activeInfoCity.close();
                if (spreadPolyCity != null) {
                    spreadPolyCity.setMap(null);
                }
            }
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (assetVal.assetType.layout == "SPREAD") {
                    locationsCity.mapCity.setZoom(21);
                    var spreadPolyArrCity = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArrCity.push({
                            lat: val.latitude,
                            lng: val.longitude,
                        });
                    });
                    spreadPolyCity = new google.maps.Polyline({
                        path: spreadPolyArrCity,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPolyCity.setMap(locationsCity.mapCity);

                    polylineTimerCity = setTimeout(function () {
                        if (spreadPolyCity != null) {
                            spreadPolyCity.setMap(null);
                            spreadPolyCity = null;
                        }
                    }, 10000);
                }
                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locationsCity.mapCity.setCenter(assetLatLng);
                infowindowSearchCity.setContent(item.name);
                infowindowSearchCity.open(locationsCity.mapCity);
                activeInfoCity = infowindowSearchCity;
                infowindowSearchCity.setPosition(assetLatLng);
                assetTimerCity = setTimeout(function () {
                    if (activeInfoCity != null) {
                        activeInfoCity.close();
                    }
                }, 10000);
            });
        };
        /*  $("#searchAssetsOnMapCity").change(function () {
            clearTimeout(assetTimerCity)
            clearTimeout(polylineTimerCity)
            locationsCity.mapCity.setZoom(18);
            infowindowSearchCity = new google.maps.InfoWindow();
            var assetSelected = JSON.parse($("#searchAssetsOnMapCity").val());
            if (activeInfoCity != null) {
                activeInfoCity.close();
                if (spreadPolyCity != null) {
                    spreadPolyCity.setMap(null);
                }
            }
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (
                    assetVal.assetType.name == "KML Link" ||
                    assetVal.assetType.name == "SOH" ||
                    assetVal.assetType.name == "Link" ||
                    assetVal.assetType.name == "UG-OH"
                ) {
                    locationsCity.mapCity.setZoom(21);
                    var spreadPolyArrCity = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArrCity.push({
                            lat: val.latitude,
                            lng: val.longitude,
                        });
                    });
                    spreadPolyCity = new google.maps.Polyline({
                        path: spreadPolyArrCity,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPolyCity.setMap(locationsCity.mapCity);

                    polylineTimerCity = setTimeout(function () {
                        if (spreadPolyCity != null) {
                            spreadPolyCity.setMap(null);
                            spreadPolyCity = null;
                        }
                    }, 10000);
                }
                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locationsCity.mapCity.setCenter(assetLatLng);
                infowindowSearchCity.setContent(assetVal.name);
                infowindowSearchCity.open(locationsCity.mapCity);
                activeInfoCity = infowindowSearchCity;
                infowindowSearchCity.setPosition(assetLatLng);
                assetTimerCity = setTimeout(function () { 
                    if (activeInfoCity != null) {activeInfoCity.close(); }},10000)
            });
        }); */

        function drawLatestAssets(response, level) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    // drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                        value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    if (
                                        $scope.selectedFilterAssetTypes.length >
                                        0
                                    ) {
                                        $scope.selectedFilterAssetTypes.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value1.assetTypeName
                                                ) {
                                                    drawFixedAsset(
                                                        value1,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAsset(value1, false, level);
                                    }
                                } else {
                                    if (
                                        $scope.selectedFilterAssetTypes.length >
                                        0
                                    ) {
                                        $scope.selectedFilterAssetTypes.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value.assetTypeName
                                                ) {
                                                    drawFixedAsset(
                                                        value,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAsset(value, false, level);
                                    }
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                if (
                                    $scope.selectedFilterAssetTypes.length > 0
                                ) {
                                    $scope.selectedFilterAssetTypes.forEach(
                                        function (assetTypeVal) {
                                            if (
                                                assetTypeVal.name ==
                                                value.assetTypeName
                                            ) {
                                                drawPolyline(
                                                    value,
                                                    locations.map,
                                                    level
                                                );
                                            }
                                        }
                                    );
                                } else {
                                    drawPolyline(value, locations.map, level);
                                }
                            }
                        });
                    });
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisible = true;
                    break;
                case "level2":
                    isLevel2AssetsVisible = true;
                    break;
                case "level3":
                    isLevel3AssetsVisible = true;
                    break;
                case "level4":
                    isLevel4AssetsVisible = true;
                    break;
                case "level5":
                    isLevel5AssetsVisible = true;
                    break;
                case "level6":
                    assetVisibility19 = true;
                    break;
                case "level7":
                    assetVisibility20 = true;
                    break;
                default:
                    break;
            }
        }

        function drawLatestAssetsCity(response, level) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locationsCity.latlng = latlang;

                    setupAssetMapCity(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    // drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                        value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    if (
                                        $scope.selectedFilterAssetTypesCity
                                            .length > 0
                                    ) {
                                        $scope.selectedFilterAssetTypesCity.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value1.assetTypeName
                                                ) {
                                                    drawFixedAssetCity(
                                                        value1,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAssetCity(
                                            value1,
                                            false,
                                            level
                                        );
                                    }
                                } else {
                                    if (
                                        $scope.selectedFilterAssetTypesCity
                                            .length > 0
                                    ) {
                                        $scope.selectedFilterAssetTypesCity.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value.assetTypeName
                                                ) {
                                                    drawFixedAssetCity(
                                                        value,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAssetCity(value, false, level);
                                    }
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                if (
                                    $scope.selectedFilterAssetTypesCity.length >
                                    0
                                ) {
                                    $scope.selectedFilterAssetTypesCity.forEach(
                                        function (assetTypeVal) {
                                            if (
                                                assetTypeVal.name ==
                                                value.assetTypeName
                                            ) {
                                                drawPolylineCity(
                                                    value,
                                                    locationsCity.mapCity,
                                                    level
                                                );
                                            }
                                        }
                                    );
                                } else {
                                    drawPolylineCity(
                                        value,
                                        locationsCity.mapCity,
                                        level
                                    );
                                }
                            }
                        });
                    });
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisibleCity = true;
                    break;
                case "level2":
                    isLevel2AssetsVisibleCity = true;
                    break;
                case "level3":
                    isLevel3AssetsVisibleCity = true;
                    break;
                case "level4":
                    isLevel4AssetsVisibleCity = true;
                    break;
                case "level5":
                    isLevel5AssetsVisibleCity = true;
                    break;
                default:
                    break;
            }
        }

        function llFromDistance(
            latitude,
            longitude,
            distance,
            bearing,
            number
        ) {
            // distance in KM, bearing in degrees

            var R = 6378.1; // Radius of the Earth
            var brng = (bearing * Math.PI) / 180; // Convert bearing to radian
            var lat = (latitude * Math.PI) / 180; // Current coords to radians
            var lon = (longitude * Math.PI) / 180;

            lat = Math.asin(
                Math.sin(lat) * Math.cos(distance / R) +
                Math.cos(lat) * Math.sin(distance / R) * Math.cos(brng)
            );
            lon += Math.atan2(
                Math.sin(brng) * Math.sin(distance / R) * Math.cos(lat),
                Math.cos(distance / R) - Math.sin(lat) * Math.sin(lat)
            );
            // Coords back to degrees and return
            return [
                "" + (number + 1) + "",
                (lat * 180) / Math.PI,
                (lon * 180) / Math.PI,
                number + 1,
            ];
        }

        function getPentagonPoints(latlng, distance, numPoints) {
            var pentagonLatLng = [];
            for (var i = 0; i < numPoints; i++) {
                var bearing = Math.round((360 / numPoints) * i);
                pentagonLatLng.push(
                    llFromDistance(latlng.lat, latlng.lng, distance, bearing, i)
                );
            }
            return pentagonLatLng;
        }

        function drawNodeAssets() {
            nodeMarkers = [];
            nodeCluster = null;
            for (var index = 0; index < vm.nodeAssets.length; index++) {
                var nodeAssetVal = vm.nodeAssets[index];
                var latitude =
                    nodeAssetVal[0].assetDetails.assetCoordinates[0].latitude;
                var longitude =
                    nodeAssetVal[0].assetDetails.assetCoordinates[0].longitude;
                var points = getPentagonPoints(
                    {
                        lat: latitude,
                        lng: longitude,
                    },
                    0.01,
                    nodeAssetVal.length
                );

                var infowindow = new google.maps.InfoWindow();

                for (var i = 0; i < nodeAssetVal.length; i++) {
                    var pointVal = points[i];
                    var iconSize = 48;
                    var newMarker = new google.maps.Marker({
                        position: new google.maps.LatLng(
                            pointVal[1],
                            pointVal[2]
                        ),
                        map: locations.map,
                        icon: {
                            labelOrigin: new google.maps.Point(24, -4),
                            scaledSize: new google.maps.Size(
                                iconSize,
                                iconSize
                            ),
                            url:
                                nodeAssetVal[i].assetDetails.assetTypeImagePath,
                            anchor: new google.maps.Point(
                                iconSize / 2,
                                iconSize / 2
                            ),
                        },
                        label: nodeAssetVal[i].assetDetails.name,
                    });

                    google.maps.event.addListener(
                        newMarker,
                        "click",
                        (function (newMarker) {
                            var assetDetails = nodeAssetVal[i].assetDetails;
                            var userContent = document.createElement("div"),
                                btnShowAttributes,
                                btnCr,
                                btnText,
                                btnEditAsset,
                                btnCreateCase,
                                btnThreePointRef,
                                brBreak;

                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                assetDetails.name +
                                '</div><div class="infoWindowContent">' +
                                "<b>Lat</b> :" +
                                pointVal[1] +
                                "<br><b>Long</b> :" +
                                pointVal[2] +
                                "</div><br>";

                            btnText = userContent.appendChild(
                                document.createElement("b")
                            );
                            btnText.textContent = "Accessible";
                            btnText.style.marginRight = "4px";

                            btnCr = userContent.appendChild(
                                document.createElement("input")
                            );
                            var attr = document.createAttribute("data-toggle");
                            attr.value = "modal";
                            var attr1 = document.createAttribute("data-target");
                            attr1.value = "#myModalMap";

                            btnCr.setAttributeNode(attr);
                            btnCr.setAttributeNode(attr1);

                            btnCr.style.marginRight = "18px";
                            btnCr.type = "checkbox";

                            google.maps.event.addDomListener(
                                newMarker,
                                "click",
                                function () {
                                    AssetByID.get(
                                        assetDetails.id,
                                        function (response) {
                                            btnCr.id = response.id;

                                            btnCr.checked = response.accessible;

                                            vm.changeAcessible = response.accessible
                                                ? "Inaccessible"
                                                : "Accessible";

                                            var yes = document.getElementById(
                                                "yesButton"
                                            );

                                            yes.onclick = function () {
                                                if (btnCr.checked == true) {
                                                    response.accessible = true;
                                                }
                                                if (btnCr.checked == false) {
                                                    response.accessible = false;
                                                }
                                                response.assetImages = []
                                                Asset.update(response);
                                            };

                                            var noBtn = document.getElementById(
                                                "noButton"
                                            );

                                            noBtn.onclick = function () {
                                                if (btnCr.checked == true) {
                                                    document.getElementById(
                                                        btnCr.id
                                                    ).checked = false;
                                                } else {
                                                    document.getElementById(
                                                        btnCr.id
                                                    ).checked = true;
                                                }
                                            };

                                            var closeBtn = document.getElementById(
                                                "closeButton"
                                            );

                                            closeBtn.onclick = function () {
                                                if (btnCr.checked == true) {
                                                    document.getElementById(
                                                        btnCr.id
                                                    ).checked = false;
                                                } else {
                                                    document.getElementById(
                                                        btnCr.id
                                                    ).checked = true;
                                                }
                                            };

                                            var closeModal = document.getElementById(
                                                "myModalMap"
                                            );

                                            closeModal.onclick = function (e) {
                                                if (e.target == this) {
                                                    if (btnCr.checked == true) {
                                                        document.getElementById(
                                                            btnCr.id
                                                        ).checked = false;
                                                    } else {
                                                        document.getElementById(
                                                            btnCr.id
                                                        ).checked = true;
                                                    }
                                                }
                                            };
                                        }
                                    );
                                }
                            );

                            brBreak = userContent.appendChild(
                                document.createElement("br")
                            );
                            brBreak = userContent.appendChild(
                                document.createElement("br")
                            );

                            btnCreateCase = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnCreateCase.type = "button";
                            btnCreateCase.value = "Create Case";
                            btnCreateCase.className = "button";

                            btnEditAsset = userContent.appendChild(
                                document.createElement("input")
                            );
                            if (vm.isAdmin == "ROLE_USER_ADMIN" || vm.isAdmin == "ROLE_CITY_PLANNER") {
                                btnEditAsset.type = "button";
                                btnEditAsset.value = "Edit Asset";
                                btnEditAsset.className = "button";
                            }
                            btnShowAttributes = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnShowAttributes.type = "button";
                            btnShowAttributes.value = "Show Attributes";
                            btnShowAttributes.className = "button";

                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            google.maps.event.addDomListener(
                                btnCreateCase,
                                "click",
                                function () {
                                    $state.go("tr-case.new", {
                                        lat: pointVal[1],
                                        lng: pointVal[2],
                                        desc: assetDetails.name,
                                    });
                                }
                            );

                            google.maps.event.addDomListener(
                                btnEditAsset,
                                "click",
                                function () {
                                    AssetByID.get(
                                        assetDetails.id,
                                        function (response) {
                                            vm.assetToEdit = response;
                                            document.getElementById(
                                                "assetEditName"
                                            ).textContent =
                                                "Asset - " +
                                                vm.assetToEdit.name;
                                            editAssetOnMapView(assetDetails);
                                        }
                                    );
                                }
                            );

                            google.maps.event.addDomListener(
                                btnShowAttributes,
                                "click",
                                function () {
                                    AssetByID.get(
                                        assetDetails.id,
                                        function (response) {
                                            showAssetAttributesModal(response);
                                        }
                                    );
                                }
                            );

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    AssetByID.get(
                                        assetDetails.id,
                                        function (response) {
                                            showThreePontReferenceModal(
                                                response
                                            );
                                        }
                                    );
                                }
                            );
                            return function () {
                                infowindow.setContent(userContent);
                                infowindow.open(locations.map, newMarker);
                                infowindow.open(locations.map, nodeCluster);
                                infowindow.setPosition(
                                    new google.maps.LatLng(
                                        newMarker.getPosition().lat(),
                                        newMarker.getPosition().lng()
                                    )
                                );
                                setTimeout(function () {
                                    infowindow.close();
                                }, 20000);
                            };
                        })(newMarker, i)
                    );

                    nodeMarkers.push(newMarker);
                }
            }
            nodeCluster = new MarkerClusterer(locations.map, nodeMarkers, {
                imagePath:
                    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
            });

            google.maps.event.addDomListener(nodeCluster, "click", function () {
                closeClick = setTimeout(function () {
                    locations.map.setZoom(16);
                }, 10000);
            });

            /*  var zoomClose;
            google.maps.event.addDomListener(
                locations.map,
                "zoom_changed",
                function () {
                    var nodeZoom = locations.map.getZoom()
                    if(nodeZoom > 20){
                        clearTimeout(zoomClose)
                        zoomClose = setTimeout(function(){ locations.map.setZoom(16)},12000)
                    }
                }
            );  */
        }

        function drawNodeAssetsPolyline() {
            nodePolyline = [];

            for (var index = 0; index < vm.nodeAssets.length; index++) {
                if (vm.nodeAssets[index].length > 1) {
                    var nodeAssetVal = vm.nodeAssets[index];
                    var nodeAssetFirstVal = nodeAssetVal[0];
                    var nodeAssetFirstCoor =
                        nodeAssetFirstVal.assetDetails.assetCoordinates[0];
                    var latitude = nodeAssetFirstCoor.latitude;
                    var longitude = nodeAssetFirstCoor.longitude;
                    var points = getPentagonPoints(
                        {
                            lat: latitude,
                            lng: longitude,
                        },
                        0.01,
                        nodeAssetVal.length
                    );

                    for (var i = 0; i < nodeAssetVal.length; i++) {
                        var path = [];
                        var pointVal = points[i];
                        path.push({ lat: latitude, lng: longitude });
                        path.push({ lat: pointVal[1], lng: pointVal[2] });
                        var polyline = new google.maps.Polyline({
                            path: path,
                            strokeColor: "#000000",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                        });

                        polyline.setMap(locations.map);

                        nodePolyline.push(polyline);
                    }
                }
            }
        }

        function drawAssets(response, level) {
            if (response) {
                $.each(response, function (index, value) {
                    if (value.assetTypeLayout == null) {
                        value.assetTypeName = value.assetType.name;
                        value.assetTypeLayout = value.assetType.layout;
                        value.assetTypeImagePath = value.assetType.imagePath;
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "FIXED"
                    ) {
                        if (value.assetCoordinates.length > 1) {
                            // drawPolyline(value);
                            var value1 = value;
                            value1.assetCoordinates = [
                                value.assetCoordinates[
                                value.assetCoordinates.length - 1
                                ],
                            ];

                            if ($scope.selectedFilterAssetTypes.length > 0) {
                                $scope.selectedFilterAssetTypes.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value1.assetTypeName
                                        ) {
                                            drawFixedAsset(
                                                value1,
                                                false,
                                                level
                                            );
                                        }
                                    }
                                );
                            } else {
                                drawFixedAsset(value1, false, level);
                            }
                        } else {
                            if ($scope.selectedFilterAssetTypes.length > 0) {
                                $scope.selectedFilterAssetTypes.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value.assetTypeName
                                        ) {
                                            drawFixedAsset(value, false, level);
                                        }
                                    }
                                );
                            } else {
                                drawFixedAsset(value, false, level);
                            }
                        }
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "SPREAD"
                    ) {
                        if ($scope.selectedFilterAssetTypes.length > 0) {
                            $scope.selectedFilterAssetTypes.forEach(function (
                                assetTypeVal
                            ) {
                                if (assetTypeVal.name == value.assetTypeName) {
                                    drawPolyline(value, locations.map, level);
                                }
                            });
                        } else {
                            drawPolyline(value, locations.map, level);
                        }
                    }
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisible = true;
                    break;
                case "level2":
                    isLevel2AssetsVisible = true;
                    break;
                case "level3":
                    isLevel3AssetsVisible = true;
                    break;
                case "level4":
                    isLevel4AssetsVisible = true;
                    break;
                case "level5":
                    isLevel5AssetsVisible = true;
                    break;
                case "level6":
                    assetVisibility19 = true;
                    break;
                case "level7":
                    assetVisibility20 = true;
                    break;
                default:
                    break;
            }
        }

        function drawAssetsCity(response, level) {
            if (response) {
                $.each(response, function (index, value) {
                    if (value.assetTypeLayout == null) {
                        value.assetTypeName = value.assetType.name;
                        value.assetTypeLayout = value.assetType.layout;
                        value.assetTypeImagePath = value.assetType.imagePath;
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "FIXED"
                    ) {
                        if (value.assetCoordinates.length > 1) {
                            // drawPolyline(value);
                            var value1 = value;
                            value1.assetCoordinates = [
                                value.assetCoordinates[
                                value.assetCoordinates.length - 1
                                ],
                            ];
                            if (
                                $scope.selectedFilterAssetTypesCity.length > 0
                            ) {
                                $scope.selectedFilterAssetTypesCity.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value1.assetTypeName
                                        ) {
                                            drawFixedAssetCity(
                                                value1,
                                                false,
                                                level
                                            );
                                        }
                                    }
                                );
                            } else {
                                drawFixedAssetCity(value1, false, level);
                            }
                        } else {
                            if (
                                $scope.selectedFilterAssetTypesCity.length > 0
                            ) {
                                $scope.selectedFilterAssetTypesCity.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value.assetTypeName
                                        ) {
                                            drawFixedAssetCity(
                                                value,
                                                false,
                                                level
                                            );
                                        }
                                    }
                                );
                            } else {
                                drawFixedAssetCity(value, false, level);
                            }
                        }
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "SPREAD"
                    ) {
                        if ($scope.selectedFilterAssetTypesCity.length > 0) {
                            $scope.selectedFilterAssetTypesCity.forEach(
                                function (assetTypeVal) {
                                    if (
                                        assetTypeVal.name == value.assetTypeName
                                    ) {
                                        drawPolylineCity(
                                            value,
                                            locationsCity.mapCity,
                                            level
                                        );
                                    }
                                }
                            );
                        } else {
                            drawPolylineCity(
                                value,
                                locationsCity.mapCity,
                                level
                            );
                        }
                    }
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisibleCity = true;
                    break;
                case "level2":
                    isLevel2AssetsVisibleCity = true;
                    break;
                case "level3":
                    isLevel3AssetsVisibleCity = true;
                    break;
                case "level4":
                    isLevel4AssetsVisibleCity = true;
                    break;
                case "level5":
                    isLevel5AssetsVisibleCity = true;
                    break;
                default:
                    break;
            }
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 12,
                    center: locations.latlng,
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(12, locations.latlng)
                );
                geoLocation(locations.map);
                document.getElementById("myspan").textContent = "";
                mapZoomChange(locations.map);
                /* var measureTool = new MeasureTool(locations.map, {
                    contextMenu: true,
                    unit: MeasureTool.UnitTypeId.METRIC,
                }); */
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
                mapZoomChange(locations.map);
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () { };
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");

            callback();
        }
        function setupAssetMapCity(callback) {
            if (locationsCity.mapCity == null) {
                /* var myOptions = {
                    zoom: 12,
                    center: locationsCity.latlng,
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locationsCity.mapCity = new google.maps.Map(
                    document.getElementById("map_canva"),
                    myOption(12, locationsCity.latlng)
                );
                geoLocation(locationsCity.mapCity);
                document.getElementById("myspanCity").textContent = "";

                //drawTheAssetsCity();
                mapZoomChangeCity(locationsCity.mapCity);
                /* var measureTool = new MeasureTool(locationsCity.mapCity, {
                    contextMenu: true,
                    unit: MeasureTool.UnitTypeId.METRIC,
                }); */
            }
            locationsCity.overlay = new google.maps.OverlayView();
            locationsCity.overlay.draw = function () { };
            locationsCity.overlay.setMap($scope.mapCity);
            locationsCity.element = document.getElementById("map_canva");

            callback();
        }

        function showAssetsonZoom(zoom) {
            var assetList = [];
            for (var index = 0; index < vm.assetTypeValues.length; index++) {
                if (vm.assetTypeValues[index].zoomLevel == zoom) {
                    vm.assetTypeValues[index].assets.forEach(function (
                        assetVal
                    ) {
                        assetList.push(assetVal);
                    });
                }
            }
            drawLatestAssets(assetList, "level1");
        }

        function showLabelBounds() {
            var bounds = locations.map.getBounds();
            for (var i = 0; i < level2AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level2AssetsMarkers[i].position)) {
                    level2AssetsMarkers[i].setLabel("");
                    level2AssetsMarkers[i].setLabel(
                        level2AssetsMarkers[i].displayLabel
                    );
                }
            }

            for (var i = 0; i < level3AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level3AssetsMarkers[i].position)) {
                    level3AssetsMarkers[i].setLabel("");
                    level3AssetsMarkers[i].setLabel(
                        level3AssetsMarkers[i].displayLabel
                    );
                }
            }
            for (var i = 0; i < level4AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level4AssetsMarkers[i].position)) {
                    level4AssetsMarkers[i].setLabel("");
                    level4AssetsMarkers[i].setLabel(
                        level4AssetsMarkers[i].displayLabel
                    );
                }
            }

            for (var i = 0; i < level5AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level5AssetsMarkers[i].position)) {
                    level5AssetsMarkers[i].setLabel("");
                    level5AssetsMarkers[i].setLabel(
                        level5AssetsMarkers[i].displayLabel
                    );
                }
            }

            for (var i = 0; i < level6AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level6AssetsMarkers[i].position)) {
                    level6AssetsMarkers[i].setLabel("");
                    level6AssetsMarkers[i].setLabel(
                        level6AssetsMarkers[i].displayLabel
                    );
                }
            }

            for (var i = 0; i < level7AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level7AssetsMarkers[i].position)) {
                    level7AssetsMarkers[i].setLabel("");
                    level7AssetsMarkers[i].setLabel(
                        level7AssetsMarkers[i].displayLabel
                    );
                }
            }
        }
        function showLabelOnView() {
            google.maps.event.addListener(
                locations.map,
                "dragend",
                function () {
                    //var bounds = locations.map.getBounds();
                    if (vm.zoomLevel < 18) {
                        clearLabel();
                    }
                    if (vm.zoomLevel >= 18) {
                        showLabelBounds();
                    }
                }
            );
        }

        function clearLabel() {
            for (var i = 0; i < level2AssetsMarkers.length; i++) {
                level2AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level3AssetsMarkers.length; i++) {
                level3AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level4AssetsMarkers.length; i++) {
                level4AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level5AssetsMarkers.length; i++) {
                level5AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level6AssetsMarkers.length; i++) {
                level6AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level7AssetsMarkers.length; i++) {
                level7AssetsMarkers[i].setLabel("");
            }
            vm.zoomLabel18 = false;
            /* vm.zoomLabel19 = false
            vm.zoomLabel20 = false */
        }

        vm.showCases = function () {
            clearCaseMarker();
            if (vm.storeCases && vm.zoomLevel >= 15 && vm.selectedCase.length) {
                callTempUG(vm.selectedCase);
            }
        };

        function clearCaseMarker() {
            for (var i = 0; i < caseMarker.length; i++) {
                caseMarker[i].setMap(null);
            }

            /* for (var i = 0; i < caseMarker.length; i++) {
                caseMarker[i].setLabel("");
            } */
        }

        function callTempUG(arr) {
            var tempUGMapMarker,
                image,
                userContent,
                infowindow,
                btnEditCase,
                btnViewCase;
            infowindow = new google.maps.InfoWindow();

            arr.forEach(function (arrId) {
                vm.storeCases[arrId.id].forEach(function (item) {
                    if (vm.caseTypes) {
                        var caseType = vm.caseTypes.find(function (caseType) {
                            return caseType.name == item.caseTypeName;
                        });
                        image =
                            caseType && caseType.image
                                ? "data:image/png;base64," + caseType.image
                                : "content/images/dot_marker.png";
                    }

                    tempUGMapMarker = new google.maps.Marker({
                        map: locations.map,
                        position: new google.maps.LatLng(
                            item.pinLat,
                            item.pinLong
                        ),
                        title: item.description,
                        icon: {
                            url: image,
                            scaledSize: new google.maps.Size(24, 24),
                            labelOrigin: new google.maps.Point(25, -4),
                        },
                    });

                    tempUGMapMarker.setMap(locations.map);
                    /* tempUGMapMarker.displayLabel =  {
                        text: item.description,
                        color: '#000',
                        fontSize: '12px',
                        fontWeight: 'bold',
                      }
    
                    tempUGMapMarker.setLabel(tempUGMapMarker.displayLabel); */
                    userContent = document.createElement("div");
                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        "<b> Case Type : </b>" +
                        item.caseTypeName +
                        "<br> <b> Description : </b>" +
                        item.description +
                        '</div><div class="infoWindowContent">' +
                        "<b> Case Id : </b>" +
                        item.id +
                        "<br><b> Priority : </b>" +
                        item.priority +
                        "<br> <b> Status : </b>" +
                        item.status +
                        "<br><b>Latitude</b> :" +
                        item.pinLat +
                        "<br><b>Longitude</b> :" +
                        item.pinLong;
                    ("</div>");

                    /* btnEditCase = userContent.appendChild(
                        document.createElement("input")
                    );
    
                    btnEditCase.type = "button";
                    btnEditCase.value = "Edit Case";
                    btnEditCase.className = "button"; */

                    btnViewCase = userContent.appendChild(
                        document.createElement("input")
                    );

                    btnViewCase.type = "button";
                    btnViewCase.value = "View Case";
                    btnViewCase.className = "button";

                    /* google.maps.event.addDomListener(
                        btnEditCase,
                        "click",
                        function () {
                            $state.go("tr-case.edit", {
                                     id: item.id,
                                 });
                        }
                    ); */

                    google.maps.event.addDomListener(
                        btnViewCase,
                        "click",
                        function () {
                            $rootScope.hideCaseEditBtn = true;
                            $state.go("tr-case-detail", {
                                id: item.id,
                            });
                        }
                    );

                    google.maps.event.addListener(
                        tempUGMapMarker,
                        "click",
                        (function (tempUGMapMarker, userContent, infowindow) {
                            return function () {
                                closeLastOpenedInfoWindow();
                                infowindow.setContent(userContent);
                                infowindow.open(locations.map, tempUGMapMarker);
                                lastOpenedInfoWindow = infowindow;
                                setTimeout(function () {
                                    lastOpenedInfoWindow.close();
                                }, 8000);
                            };
                        })(tempUGMapMarker, userContent, infowindow)
                    );

                    caseMarker.push(tempUGMapMarker);
                });
            });
        }

        function closeLastOpenedInfoWindow() {
            if (lastOpenedInfoWindow) {
                lastOpenedInfoWindow.close();
            }
            if (vm.closeInfoWindow) {
                vm.closeInfoWindow.close();
            }
            if (openedInfoWindow) {
                openedInfoWindow.close();
            }
        }

        function mapZoomChange(map) {
            google.maps.event.addListener(
                locations.map,
                "zoom_changed",
                function () {
                    vm.zoomLevel = locations.map.getZoom();
                    vm.currentZoom = locations.map.getZoom();
                    document.getElementById("myspan").textContent =
                        "ZOOM : " + vm.zoomLevel;
                    if (vm.prevZoomLevel == 19 && vm.zoomLevel <= 18) {
                        clearTimeout(closeClick);
                    }
                    if (vm.zoomLevel < 12) {
                        for (var i = 0; i < level1AssetsMarkers.length; i++) {
                            level1AssetsMarkers[i].setMap(null);
                        }

                        for (i = 0; i < level1AssetsPolyline.length; i++) {
                            level1AssetsPolyline[i].setMap(null);
                        }
                        isLevel1AssetsVisible = false;
                        vm.zoom13 = false;
                        vm.zoom14 = false;
                    }
                    if (vm.zoomLevel == 12) {
                        if (!isLevel1AssetsVisible) {
                            var assetList = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 12) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            assetList.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawLatestAssets(assetList, "level1");
                            isLevel1AssetsVisible = true;
                        }
                    }

                    if (vm.zoomLevel == 13) {
                        if (!vm.zoom13) {
                            showAssetsonZoom(13);
                            vm.zoom13 = true;
                        }
                    }

                    if (vm.zoomLevel == 14) {
                        if (!vm.zoom14) {
                            showAssetsonZoom(14);
                            vm.zoom14 = true;
                        }
                    }
                    if (vm.zoomLevel < 15) {
                        vm.displayCaseType = false;
                        $scope.$evalAsync();

                        for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            level2AssetsMarkers[i].setMap(null);
                        }

                        for (i = 0; i < level2AssetsPolyline.length; i++) {
                            level2AssetsPolyline[i].setMap(null);
                        }

                        clearCaseMarker();

                        isLevel2AssetsVisible = false;
                    }

                    if (vm.zoomLevel < 18) {
                        clearLabel();
                    }

                    /* if(vm.prevZoomLevel == 18 && vm.zoomLevel == 19) {
                    if(!vm.zoomLabel19){
                        showLabelBounds()
                        showLabelOnView()
                        
                         for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if(level2AssetsMarkers[i].labelZoom == 19){
                                level2AssetsMarkers[i].setLabel(level2AssetsMarkers[i].displayLabel);
                            }
                        }
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if(level3AssetsMarkers[i].labelZoom == 19){
                            level3AssetsMarkers[i].setLabel(level3AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if(level4AssetsMarkers[i].labelZoom == 19){
                            level4AssetsMarkers[i].setLabel(level4AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if(level5AssetsMarkers[i].labelZoom == 19){
                            level5AssetsMarkers[i].setLabel(level5AssetsMarkers[i].displayLabel);}
                        } 
                        vm.zoomLabel19 = true 
                    }
                } */

                    if (vm.prevZoomLevel == 14 && vm.zoomLevel == 15) {
                        vm.displayCaseType = true;
                        $scope.$evalAsync();
                        vm.getCenter = locations.map.center;
                        vm.currentZoom1 = locations.map.getZoom();

                        if (!vm.storeCases) {
                            casesInMap.get(
                                {
                                    geofenceId: vm.selectedMapGeofenceId,
                                    caseTypeIds: caseTypeIds,
                                },
                                function (response) {
                                    vm.tempLength = response.cases.length > 0;
                                    var result = {},
                                        arrId = [];
                                    if (vm.tempLength) {
                                        response.casetypes.forEach(function (
                                            casetype
                                        ) {
                                            result[
                                                casetype.id
                                            ] = response.cases.filter(function (
                                                c
                                            ) {
                                                return (
                                                    c.caseTypeName ===
                                                    casetype.name
                                                );
                                            });
                                        });
                                    }

                                    vm.storeCases = vm.tempLength
                                        ? result
                                        : false;
                                    vm.caseTypes =
                                        response.cases.length > 0
                                            ? vm.caseType.filter(function (
                                                obj1
                                            ) {
                                                obj1.showInAssetsView = true;

                                                for (var property in result) {
                                                    if (property == obj1.id) {
                                                        obj1.displayName =
                                                            obj1.name +
                                                            " - (" +
                                                            result[obj1.id]
                                                                .length +
                                                            ")";
                                                    }
                                                }

                                                return response.casetypes.some(
                                                    function (obj2) {
                                                        return (
                                                            obj1.id ===
                                                            obj2.id
                                                        );
                                                    }
                                                );
                                            })
                                            : [];

                                    vm.caseTypes.forEach(function (id) {
                                        arrId.push({ id: id.id });
                                    });
                                    if (vm.storeCases) {
                                        callTempUG(arrId);
                                    }
                                }
                            );
                        } else if (vm.storeCases && vm.selectedCase.length) {
                            callTempUG(vm.selectedCase);
                        }

                        if (!isLevel2AssetsVisible) {
                            var zoomLevel_15 = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                /* vm.assetTypeValues.forEach(function (val){
                                val.assets.forEach(function(item){
                                    item.label = val.zoomLevelLabel
                                })
                            }) */
                                if (vm.assetTypeValues[index].zoomLevel == 15) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            zoomLevel_15.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(zoomLevel_15, "level2");

                            /* var siteList = [];
                        for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                        ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Site"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    siteList.push(assetVal);
                                }
                            );
                        }
                        }
                        drawAssets(siteList, "level2");

                        var chamberHandHoleList = [];
                        for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                        ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Chamber / Handhole"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    chamberHandHoleList.push(assetVal);
                                }
                            );
                        }
                        }
                        drawAssets(chamberHandHoleList, "level2");

                        var handHoleChList = [];
                        for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                        ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Handhole CH"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    handHoleChList.push(assetVal);
                                }
                            );
                        }
                        }
                        drawAssets(handHoleChList, "level2"); */

                            isLevel2AssetsVisible = true;
                        }
                    }
                    /* if (vm.currentZoom >= 15) {
                    vm.getCenter = locations.map.center;
                    if (isLevel2AssetsVisible) {
                        var chamberList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValues[index].assetTypeName ==
                                "Chamber"
                            ) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        chamberList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(chamberList, "level2");
                        isLevel2AssetsVisible = true;
                    }
                } */

                    if (vm.zoomLevel <= 15) {
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            level3AssetsMarkers[i].setMap(null);
                        }

                        for (i = 0; i < level3AssetsPolyline.length; i++) {
                            level3AssetsPolyline[i].setMap(null);
                        }
                        isLevel3AssetsVisible = false;
                    }

                    if (vm.prevZoomLevel == 15 && vm.zoomLevel == 16) {
                        vm.getCenter = locations.map.center;
                        vm.currentZoom1 = locations.map.getZoom();
                        if (!isLevel3AssetsVisible) {
                            var couplerList = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 16) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            couplerList.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(couplerList, "level3");
                            isLevel3AssetsVisible = true;
                        }
                    }

                    /*  if (vm.currentZoom >= 16) {
                    vm.getCenter = locations.map.center;
                    if (isLevel3AssetsVisible) {
                        var couplerList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValues[index].assetTypeName ==
                                "Coupler"
                            ) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        couplerList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(couplerList, "level3");
                        isLevel3AssetsVisible = true;
                    }
                } */

                    if (vm.zoomLevel <= 16) {
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            level4AssetsMarkers[i].setMap(null);
                        }

                        for (i = 0; i < level4AssetsPolyline.length; i++) {
                            level4AssetsPolyline[i].setMap(null);
                        }
                        isLevel4AssetsVisible = false;
                    }

                    if (vm.prevZoomLevel == 16 && vm.zoomLevel == 17) {
                        vm.getCenter = locations.map.center;
                        vm.currentZoom1 = locations.map.getZoom();
                        if (!isLevel4AssetsVisible) {
                            var zoomLevel_17 = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 17) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            zoomLevel_17.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(zoomLevel_17, "level4");

                            /* var jointClosureList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValues[index].assetTypeName ==
                                "Joint Closure"
                            ) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        jointClosureList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(jointClosureList, "level4"); */
                            isLevel4AssetsVisible = true;
                        }
                    }

                    if (vm.zoomLevel <= 17) {
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            level5AssetsMarkers[i].setMap(null);
                        }
                        isLevel5AssetsVisible = false;
                    }
                    if (vm.prevZoomLevel == 17 && vm.zoomLevel == 18) {
                        if (!isLevel5AssetsVisible) {
                            var otherList = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 18) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            otherList.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(otherList, "level5");
                            isLevel5AssetsVisible = true;
                        }
                    }

                    if (vm.zoomLevel <= 18) {
                        for (var i = 0; i < level6AssetsMarkers.length; i++) {
                            level6AssetsMarkers[i].setMap(null);
                        }
                        assetVisibility19 = false;
                    }
                    if (vm.prevZoomLevel == 18 && vm.zoomLevel == 19) {
                        if (!assetVisibility19) {
                            var assetZoom19 = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 19) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            assetZoom19.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(assetZoom19, "level6");
                            showLabelBounds();
                            assetVisibility19 = true;
                        }
                    }

                    if (vm.zoomLevel <= 19) {
                        for (var i = 0; i < level7AssetsMarkers.length; i++) {
                            level7AssetsMarkers[i].setMap(null);
                        }
                        assetVisibility20 = false;
                    }
                    if (vm.prevZoomLevel == 19 && vm.zoomLevel == 20) {
                        if (!assetVisibility20) {
                            var assetZoom20 = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 20) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            assetZoom20.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(assetZoom20, "level7");
                            showLabelBounds();
                            assetVisibility20 = true;
                        }
                    }
                    if (vm.zoomLevel <= 15) {
                        for (var i = 0; i < nodeMarkers.length; i++) {
                            for (
                                var index = 0;
                                index < nodeMarkers.length;
                                index++
                            ) {
                                nodeMarkers[index].setMap(null);
                            }
                            nodeCluster.clearMarkers();
                            nodeMarkers = [];
                            isLevelNodeVisible = false;
                        }
                    }

                    if (vm.prevZoomLevel == 17 && vm.zoomLevel == 18) {
                        if (!vm.zoomLabel18) {
                            showLabelBounds();
                            showLabelOnView();
                            /* for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if(level2AssetsMarkers[i].labelZoom == 18){
                                level2AssetsMarkers[i].setLabel(level2AssetsMarkers[i].displayLabel);
                            }
                        }
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if(level3AssetsMarkers[i].labelZoom == 18){
                            level3AssetsMarkers[i].setLabel(level3AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if(level4AssetsMarkers[i].labelZoom == 18){
                            level4AssetsMarkers[i].setLabel(level4AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if(level5AssetsMarkers[i].labelZoom == 18){
                            level5AssetsMarkers[i].setLabel(level5AssetsMarkers[i].displayLabel);}
                        } */
                            vm.zoomLabel18 = true;
                        }
                    }

                    if (vm.prevZoomLevel == 15 && vm.zoomLevel == 16) {
                        if (!isLevelNodeVisible) {
                            for (var i = 0; i < nodeMarkers.length; i++) {
                                for (
                                    var index = 0;
                                    index < nodeMarkers.length;
                                    index++
                                ) {
                                    nodeMarkers[index].setMap(null);
                                }
                                nodeCluster.clearMarkers();
                                nodeMarkers = [];
                            }
                            drawNodeAssets();
                            isLevelNodeVisible = true;
                        }
                    }

                    if (vm.prevZoomLevel >= 19 && vm.zoomLevel <= 18) {
                        for (var i = 0; i < nodePolyline.length; i++) {
                            for (
                                var index = 0;
                                index < nodePolyline.length;
                                index++
                            ) {
                                nodePolyline[index].setMap(null);
                            }
                            nodePolyline = [];
                        }
                    }
                    if (vm.zoomLevel >= 19 && nodePolyline.length == 0) {
                        drawNodeAssetsPolyline();
                    }

                    vm.prevZoomLevel = vm.zoomLevel;
                }
            );
        }

        function mapZoomChangeCity(map) {
            google.maps.event.addListener(
                locationsCity.mapCity,
                "idle",
                function () {
                    vm.zoomLevelCity = locationsCity.mapCity.getZoom();

                    document.getElementById("myspanCity").textContent =
                        "ZOOM : " + vm.zoomLevelCity;
                }
            );
        }

        function mapZoomChangeFilter(map) {
            google.maps.event.addListener(locations.map, "idle", function () {
                vm.currentZoom = locations.map.getZoom();

                document.getElementById("myspan").textContent =
                    "ZOOM : " + vm.currentZoom;

                if (vm.currentZoom >= 15) {
                    if (isLevel2AssetsVisible) {
                        var zoomLevel_15 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 15) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_15.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_15, "level2");

                        /* var siteList = [];
                        for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                        ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Site"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    siteList.push(assetVal);
                                }
                            );
                        }
                        }
                        drawAssets(siteList, "level2"); */

                        isLevel2AssetsVisible = true;
                    }
                    if (vm.storeCases && vm.selectedCase.length) {
                        callTempUG(vm.selectedCase);
                    }
                }

                if (vm.currentZoom >= 16) {
                    if (isLevel3AssetsVisible) {
                        var couplerList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 16) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        couplerList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(couplerList, "level3");
                        isLevel3AssetsVisible = true;
                    }
                }
            });
        }

        function initializeAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            lngVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            // callback(new google.maps.LatLng("12.9716", "77.5946"));
                            callback(
                                new google.maps.LatLng(
                                    DEFAULT_LATITUDE.value,
                                    DEFAULT_LONGITUDE.value
                                )
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    callback(
                        new google.maps.LatLng(
                            DEFAULT_LATITUDE.value,
                            DEFAULT_LONGITUDE.value
                        )
                    );
                }
            }
        }

        function drawFixedAsset(fixed, hasParent, level) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";

                var isFixedAsset = false;

                /*  if ($scope.variableHealth) {
                    if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Chamber"
                    ) {
                        iconUrl = "content/images/chamber_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Chamber"
                    ) {
                        iconUrl = "content/images/chamber_red.png";
                    } else if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Coupler"
                    ) {
                        iconUrl = "content/images/coupler_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Coupler"
                    ) {
                        iconUrl = "content/images/coupler_red.png";
                    } else if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Pole"
                    ) {
                        iconUrl = "content/images/pole_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Pole"
                    ) {
                        iconUrl = "content/images/pole_red.png";
                    } else {
                        iconUrl = fixed.assetTypeImagePath;
                    }
                } else {
                    iconUrl = fixed.assetTypeImagePath;
                } */

                //buried chamber
                if (fixed.assetTypeName == "Chamber" && fixed.burried) {
                    iconUrl = "content/images/buriedChamber.png"
                } else {
                    iconUrl = fixed.assetTypeImagePath;
                }

                //iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });
                startMarker.labelZoom = fixed.label;
                startMarker.assetId = fixed.id;
                startMarker.displayLabel = {
                    text: fixed.name,
                    color: "#000",
                    fontSize: "12px",
                    fontWeight: "bold",
                };

                // if (vm.zoomLevel == 10) {
                //     startMarker.setLabel('');
                // } else if (vm.zoomLevel == 11) {
                //     var label = { color: '#000000', fontWeight: 'bold', fontSize: '12px', text: fixed.name };
                //     startMarker.setLabel(label);
                // }

                // if (fixed.status != null &&
                //     fixed.status === false) {
                //     startMarker.setLabel({
                //         color: 'red',
                //         fontSize: '30px',
                //         fontWeight: '20px',
                //         text: '\u2297'
                //     });
                // }
                // Add marker to the array.

                // markers.push(startMarker);

                switch (level) {
                    case "level1":
                        level1AssetsMarkers.push(startMarker);
                        break;
                    case "level2":
                        level2AssetsMarkers.push(startMarker);
                        break;
                    case "level3":
                        level3AssetsMarkers.push(startMarker);
                        break;
                    case "level4":
                        level4AssetsMarkers.push(startMarker);
                        break;
                    case "level5":
                        level5AssetsMarkers.push(startMarker);
                        break;
                    case "level6":
                        level6AssetsMarkers.push(startMarker);
                        break;
                    case "level7":
                        level7AssetsMarkers.push(startMarker);
                        break;
                    default:
                        markers.push(startMarker);
                        break;
                }
                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    startMarker.title +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        if (existingHighlightFixed != null) {
                            existingHighlightFixed.setMap(null);
                            existingHighlightFixed = null;
                        }

                        var circle = new google.maps.Circle({
                            map: locations.map, // The map object
                            center: { lat: startMarker.map.center.lat(), lng: startMarker.map.center.lng() }, // Center of the circle (same as the marker)
                            radius: 2, // Radius in meters (1000 meters = 1 kilometer)
                            strokeColor: '#fd7a24', // Color of the circle's border
                            strokeOpacity: 0.8, // Opacity of the circle's border
                            strokeWeight: 2, // Width of the circle's border
                            fillColor: '#fd7a24', // Fill color of the circle
                            fillOpacity: 1, // Opacity of the circle's fill color
                        });

                        // Bind the circle to the marker so it moves with the marker if the marker is draggable
                        circle.bindTo('center', startMarker, 'position');
                        existingHighlightFixed = circle;

                        var fixedHighlightTimer = setTimeout(function () {
                            if (circle != null) {
                                circle.setMap(null);
                                circle = null;
                            }
                        }, 6000);

                        if (activeInfo != null) {
                            activeInfo.close();
                        }
                        closeLastOpenedInfoWindow();

                        AssetByID.get(fixed.id, function (response) {
                            vm.assetRefAttributes = [];
                            if (response.assetReferenceAttributes.length) {
                                response.assetReferenceAttributes.forEach(
                                    function (get) {
                                        get[
                                            "assetAttributeName"
                                        ].assetTypeAttribute.attributeValue =
                                            get[
                                                "assetAttributeName"
                                            ].attributeValue;
                                        vm.assetRefAttributes.push(
                                            get["assetAttributeName"]
                                                .assetTypeAttribute
                                        );
                                        get[
                                            "assetAttributeValue"
                                        ].assetTypeAttribute.attributeValue =
                                            get[
                                                "assetAttributeValue"
                                            ].attributeValue;
                                        vm.assetRefAttributes.push(
                                            get["assetAttributeValue"]
                                                .assetTypeAttribute
                                        );
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.attributeValue =
                                            get["assetAttributeImage"].image;
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.attributeName =
                                            get["assetAttributeImage"].imageName;
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.imageId =
                                            get["assetAttributeImage"].imageId;
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.attributeType =
                                            get["assetAttributeImage"].imageType;
                                        vm.assetRefAttributes.push(
                                            get["assetAttributeImage"]
                                                .assetTypeAttribute
                                        );
                                    }
                                );
                            }
                            vm.assetToEdit = {};
                            vm.assetToEdit = response;
                            vm.assetAttachments = response;
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                btnShowAttributes,
                                btnCr,
                                btnText,
                                btnText1,
                                btnText2,
                                btnEditAsset,
                                btnCreateCase,
                                btnThreePointRef,
                                btnShowAttachments,
                                btnTextBuried,
                                btnBuried;

                            var url = $state.href('asset-detail', { id: response.id });

                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                /* "<b>Id</b> : <a target='_blank' href='" + url + "'>" + response.id+
                                "</a><br><b>Name</b>"+ */
                                response.name +
                                '</div><div class="infoWindowContent">' +
                                "<b>Asset Type</b> : " +
                                fixed.assetTypeName +
                                "<br><b>Latitude</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Longitude</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "</div>";

                            vm.assetTitle = response.name;
                            btnText = userContent.appendChild(
                                document.createElement("b")
                            );

                            btnText.textContent = "Accessible";
                            btnText.style.marginRight = "4px";

                            btnCr = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnCr.style.marginRight = "18px";
                            btnCr.type = "checkbox";
                            btnCr.id = response.id;

                            btnCr.checked = response.accessible;

                            btnText1 = userContent.appendChild(
                                document.createElement("b")
                            );

                            /* if (
                                ($scope.variableHealth == true &&
                                    response.healthIndicator == true) ||
                                ($scope.variableHealth == true &&
                                    response.healthIndicator == false)
                            ) {
                                btnText1.textContent =
                                    "Remarks:" + response.healthRemarks;
                                btnText1.style.marginLeft = "4px";
                            } */

                            var attr = document.createAttribute("data-toggle");
                            attr.value = "modal";
                            var attr1 = document.createAttribute("data-target");
                            attr1.value = "#myModalMap";

                            btnCr.setAttributeNode(attr);
                            btnCr.setAttributeNode(attr1);

                            vm.changeAcessible = response.accessible
                                ? "Inaccessible"
                                : "Accessible";

                            var yes = document.getElementById("yesButton");

                            yes.onclick = function () {
                                if (btnCr.checked == true) {
                                    response.accessible = true;
                                }
                                if (btnCr.checked == false) {
                                    response.accessible = false;
                                }
                                response.assetImages = []
                                Asset.update(response);
                            };

                            var noBtn = document.getElementById("noButton");

                            noBtn.onclick = function () {
                                if (btnCr.checked == true) {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = false;
                                } else {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = true;
                                }
                            };

                            var closeBtn = document.getElementById(
                                "closeButton"
                            );

                            closeBtn.onclick = function () {
                                if (btnCr.checked == true) {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = false;
                                } else {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = true;
                                }
                            };

                            var closeModal = document.getElementById(
                                "myModalMap"
                            );

                            closeModal.onclick = function (e) {
                                if (e.target == this) {
                                    if (btnCr.checked == true) {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = true;
                                    }
                                }
                            };

                            var brBreak = userContent.appendChild(
                                document.createElement("br")
                            );
                            var brBreak1 = userContent.appendChild(
                                document.createElement("br")
                            );


                            if (response.assetTypeName == "Chamber") {
                                btnTextBuried = userContent.appendChild(
                                    document.createElement("b")
                                );
                                btnTextBuried.textContent = "Buried Chamber";
                                btnTextBuried.style.marginRight = "4px";

                                btnBuried = userContent.appendChild(
                                    document.createElement("input")
                                );
                                btnBuried.style.marginRight = "18px";
                                btnBuried.type = "checkbox";
                                btnBuried.checked = response.burried;
                                btnBuried.id = response.id + '0';

                                var brBreak = userContent.appendChild(
                                    document.createElement("br")
                                );
                                var brBreak1 = userContent.appendChild(
                                    document.createElement("br")
                                );

                                var attr = document.createAttribute("data-toggle");
                                attr.value = "modal";
                                var attr1 = document.createAttribute("data-target");
                                attr1.value = "#myModalBuried";

                                btnBuried.setAttributeNode(attr);
                                btnBuried.setAttributeNode(attr1);

                                var yesBurried = document.getElementById("yesButtonBurried");

                                yesBurried.onclick = function () {
                                    if (btnBuried.checked == true) {
                                        response.burried = true;
                                    }
                                    if (btnBuried.checked == false) {
                                        response.burried = false;
                                    }
                                    response.assetImages = []
                                    Asset.update(response, onSaveSuccessBuried);
                                };

                                var noBtnBurried = document.getElementById("noButtonBurried");

                                noBtnBurried.onclick = function () {
                                    if (btnBuried.checked == true) {
                                        document.getElementById(
                                            btnBuried.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnBuried.id
                                        ).checked = true;
                                    }
                                };

                                var closeBtnBurried = document.getElementById(
                                    "closeButtonBurried"
                                );

                                closeBtnBurried.onclick = function () {
                                    if (btnBuried.checked == true) {
                                        document.getElementById(
                                            btnBuried.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnBuried.id
                                        ).checked = true;
                                    }
                                };

                                /* var closeModalBurried = document.getElementById(
                                    "myModalBuried"
                                );
    
                                closeModalBurried.onclick = function (e) {
                                    if (e.target == this) {
                                        if (btnBuried.checked == true) {
                                            document.getElementById(
                                                btnBuried.id
                                            ).checked = false;
                                        } else {
                                            document.getElementById(
                                                btnBuried.id
                                            ).checked = true;
                                        }
                                    }
                                }; */
                            }


                            btnCreateCase = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnCreateCase.type = "button";
                            btnCreateCase.value = "Create Case";
                            btnCreateCase.className = "button";

                            btnEditAsset = userContent.appendChild(
                                document.createElement("input")
                            );
                            if (vm.isAdmin == "ROLE_USER_ADMIN" || vm.isAdmin == "ROLE_CITY_PLANNER") {
                                btnEditAsset.type = "button";
                                btnEditAsset.value = "Edit Asset";
                                btnEditAsset.className = "button";
                            }
                            btnShowAttributes = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnShowAttributes.type = "button";
                            btnShowAttributes.value = "Show Attributes";
                            btnShowAttributes.className = "button";

                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            vm.nameImages = [];
                            vm.assetIdImg = response.id;
                            response.assetImages.forEach(function (item) {
                                vm.nameImages.push(item);
                            });

                            btnShowAttachments = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnShowAttachments.type = "button";
                            btnShowAttachments.value = "Attachments";
                            btnShowAttachments.className = "button";

                            google.maps.event.addDomListener(
                                btnShowAttachments,
                                "click",
                                function () {
                                    vm.assetAttachments.assetImages = [];
                                    $("#modalAttachment").show();
                                }
                            );

                            google.maps.event.addDomListener(
                                btnCreateCase,
                                "click",
                                function () {
                                    $rootScope.createCaseFromAssetMap = [
                                        response,
                                    ];
                                    $state.go("tr-case.new", {
                                        lat:
                                            fixed.assetCoordinates[
                                                fixed.assetCoordinates.length -
                                                1
                                            ].latitude,
                                        lng:
                                            fixed.assetCoordinates[
                                                fixed.assetCoordinates.length -
                                                1
                                            ].longitude,
                                        desc: fixed.name,
                                    });
                                }
                            );

                            google.maps.event.addDomListener(
                                btnEditAsset,
                                "click",
                                function () {
                                    // $state.go("asset.edit", {
                                    //     id: fixed.id,
                                    // });

                                    document.getElementById(
                                        "assetEditName"
                                    ).textContent =
                                        "Asset - " + vm.assetToEdit.name;
                                    editAssetOnMapView(fixed);
                                }
                            );

                            google.maps.event.addDomListener(
                                btnShowAttributes,
                                "click",
                                function () {
                                    showAssetAttributesModal(response);
                                }
                            );

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    showThreePontReferenceModal(response);
                                }
                            );

                            vm.closeInfoWindow = new google.maps.InfoWindow({
                                content: userContent,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            vm.closeInfoWindow.open(locations.map, startMarker);
                            setTimeout(function () {
                                vm.closeInfoWindow.close();
                            }, 10000);

                            activeInfoWindow = vm.closeInfoWindow;
                            prevInfoWindow = vm.closeInfoWindow;
                        });
                    }
                );
                openedInfoWindow = infoWindow2;
            });
        }

        function drawFixedAssetCity(fixed, hasParent, level) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevelCity == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevelCity == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locationsCity.mapCity,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                    },
                });

                // if (vm.zoomLevel == 10) {
                //     startMarker.setLabel('');
                // } else if (vm.zoomLevel == 11) {
                //     var label = { color: '#000000', fontWeight: 'bold', fontSize: '12px', text: fixed.name };
                //     startMarker.setLabel(label);
                // }

                // if (fixed.status != null &&
                //     fixed.status === false) {
                //     startMarker.setLabel({
                //         color: 'red',
                //         fontSize: '30px',
                //         fontWeight: '20px',
                //         text: '\u2297'
                //     });
                // }
                // Add marker to the array.

                // markers.push(startMarker);

                switch (level) {
                    case "level1":
                        level1AssetsMarkersCity.push(startMarker);
                        break;
                    case "level2":
                        level2AssetsMarkersCity.push(startMarker);
                        break;
                    case "level3":
                        level3AssetsMarkersCity.push(startMarker);
                        break;
                    case "level4":
                        level4AssetsMarkersCity.push(startMarker);
                        break;
                    case "level5":
                        level5AssetsMarkersCity.push(startMarker);
                        break;
                    default:
                        markersCity.push(startMarker);
                        break;
                }
                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    startMarker.title +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        if (activeInfoCity != null) {
                            activeInfoCity.close();
                        }
                        AssetByID.get(fixed.id, function (response) {
                            vm.assetToEdit = {};
                            vm.assetToEdit = response;
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                btnShowAttributes,
                                btnCr,
                                btnText,
                                btnEditAsset,
                                btnCreateCase,
                                btnThreePointRef;

                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<b>Name</b> : " +
                                startMarker.title +
                                '</div><div class="infoWindowContent">' +
                                "<b>Asset Type</b> : " +
                                fixed.assetTypeName +
                                "<br><b>Latitude</b> : " +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Longitude</b> : " +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "</div><br>";

                            vm.assetTitle = startMarker.title;
                            btnText = userContent.appendChild(
                                document.createElement("b")
                            );

                            btnText.textContent = "Accessible";
                            btnText.style.marginRight = "4px";

                            btnCr = userContent.appendChild(
                                document.createElement("input")
                            );
                            var attr = document.createAttribute("data-toggle");
                            attr.value = "modal";
                            var attr1 = document.createAttribute("data-target");
                            attr1.value = "#myModalMap";

                            btnCr.setAttributeNode(attr);
                            btnCr.setAttributeNode(attr1);

                            btnCr.style.marginRight = "18px";
                            btnCr.type = "checkbox";
                            btnCr.id = response.id;

                            btnCr.checked = response.accessible;

                            vm.changeAcessible = response.accessible
                                ? "Inaccessible"
                                : "Accessible";

                            var yes = document.getElementById("yesButton");

                            yes.onclick = function () {
                                if (btnCr.checked == true) {
                                    response.accessible = true;
                                }
                                if (btnCr.checked == false) {
                                    response.accessible = false;
                                }
                                response.assetImages = []
                                Asset.update(response);
                            };

                            var noBtn = document.getElementById("noButton");

                            noBtn.onclick = function () {
                                if (btnCr.checked == true) {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = false;
                                } else {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = true;
                                }
                            };

                            var closeBtn = document.getElementById(
                                "closeButton"
                            );

                            closeBtn.onclick = function () {
                                if (btnCr.checked == true) {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = false;
                                } else {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = true;
                                }
                            };

                            var closeModal = document.getElementById(
                                "myModalMap"
                            );

                            closeModal.onclick = function (e) {
                                if (e.target == this) {
                                    if (btnCr.checked == true) {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = true;
                                    }
                                }
                            };

                            var brBreak = userContent.appendChild(
                                document.createElement("br")
                            );
                            var brBreak1 = userContent.appendChild(
                                document.createElement("br")
                            );

                            btnCreateCase = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnCreateCase.type = "button";
                            btnCreateCase.value = "Create Case";
                            btnCreateCase.className = "button";

                            btnEditAsset = userContent.appendChild(
                                document.createElement("input")
                            );
                            if (vm.isAdmin == "ROLE_USER_ADMIN" || vm.isAdmin == "ROLE_CITY_PLANNER") {
                                btnEditAsset.type = "button";
                                btnEditAsset.value = "Edit Asset";
                                btnEditAsset.className = "button";

                            }
                            btnShowAttributes = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnShowAttributes.type = "button";
                            btnShowAttributes.value = "Show Attributes";
                            btnShowAttributes.className = "button";

                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            google.maps.event.addDomListener(
                                btnCreateCase,
                                "click",
                                function () {
                                    $state.go("tr-case.new", {
                                        lat:
                                            fixed.assetCoordinates[
                                                fixed.assetCoordinates.length -
                                                1
                                            ].latitude,
                                        lng:
                                            fixed.assetCoordinates[
                                                fixed.assetCoordinates.length -
                                                1
                                            ].longitude,
                                        desc: fixed.name,
                                    });
                                }
                            );

                            google.maps.event.addDomListener(
                                btnEditAsset,
                                "click",
                                function () {
                                    // $state.go("asset.edit", {
                                    //     id: fixed.id,
                                    // });

                                    document.getElementById(
                                        "assetEditName"
                                    ).textContent =
                                        "Asset - " + vm.assetToEdit.name;
                                    editAssetOnMapView(fixed);
                                }
                            );

                            google.maps.event.addDomListener(
                                btnShowAttributes,
                                "click",
                                function () {
                                    showAssetAttributesModal(response);
                                }
                            );

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    showThreePontReferenceModal(response);
                                }
                            );

                            var infoWindow2 = new google.maps.InfoWindow({
                                content: userContent,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            infoWindow2.open(
                                locationsCity.mapCity,
                                startMarker
                            );
                            setTimeout(function () {
                                infoWindow2.close();
                            }, 10000);

                            activeInfoWindow = infoWindow2;
                            prevInfoWindow = infoWindow2;
                        });
                    }
                );
                openedInfoWindow = infoWindow2;
            });
        }

        function drawPolyline(spread, map, level) {
            var spreadAssetCoordinates = [];
            var spreadColor = 0;
            var spreadWidth = 0;
            var spreadOpacity = 0;

            vm.assetTypes.forEach(function (assetType) {
                if (assetType.name == spread.assetTypeName) {
                    spreadColor = assetType.colorcode;
                    spreadWidth = assetType.lineWidth * 0.05;
                    spreadOpacity = assetType.transparency * 0.01;
                }
            });

            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                    sortOrder: value.sortOrder
                });
            });
			if (Array.isArray(spreadAssetCoordinates) 
				&& spreadAssetCoordinates.length > 0
			 	&& spreadAssetCoordinates[0]
				&& spreadAssetCoordinates[0].sortOrder != undefined  
				&& spreadAssetCoordinates[0].sortOrder != null) {
				spreadAssetCoordinates.sort(function(a, b) {
					return a.sortOrder - b.sortOrder; // Ascending order
				});
			}
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spreadColor;
                }
                var polylineWeight = spreadWidth;
                var strokeOpacityVal = spreadOpacity;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {

                        if (existingHighlight != null) {
                            existingHighlight.setMap(null);
                            existingHighlight = null;
                        }

                        var polylinepathHighlight = new google.maps.Polyline({
                            path: spreadAssetCoordinates,
                            strokeColor: "#FFFF00",
                            strokeOpacity: 0.6,
                            strokeWeight: 19,
                        });


                        polylinepathHighlight.setMap(locations.map);
                        existingHighlight = polylinepathHighlight;

                        var polylineTimer = setTimeout(function () {
                            if (polylinepathHighlight != null) {
                                polylinepathHighlight.setMap(null);
                                polylinepathHighlight = null;
                            }
                        }, 10000);

                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        closeLastOpenedInfoWindow();
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD" || spread.assetType.layout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                vm.assetToEdit = {};
                                vm.assetToEdit = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }
                                var assetTypeAttrPopupNames = [];
                                assetVal.assetType.assetTypeAttributes.forEach(
                                    function (assetTypeAttrVal) {
                                        if (
                                            assetTypeAttrVal.assetTypePopupDisplay ==
                                            true
                                        ) {
                                            assetTypeAttrPopupNames.push(
                                                assetTypeAttrVal.name
                                            );
                                        }
                                    }
                                );
                                var getAttribute =
                                    assetVal.assetTypeAttributeValues;
                                var userContent = document.createElement("div"),
                                    btnShowAttributes,
                                    btnEditAssets;

                                var url = $state.href('asset-detail', { id: spread.id });

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' + "<b>Id</b> : <a target='_blank' href='" + url + "'>" + spread.id +
                                    "</a><br><b>Name : </b> " +
                                    spread.name +
                                    "<br><b>Asset Type : </b> " +
                                    spread.assetType.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km";

                                for (i = 0; i < getAttribute.length; i++) {
                                    if (
                                        assetTypeAttrPopupNames.includes(
                                            getAttribute[i].assetTypeAttribute
                                                .name
                                        )
                                    ) {
                                        userContent.innerHTML +=
                                            "<b>" +
                                            getAttribute[i].assetTypeAttribute
                                                .name +
                                            "</b>" +
                                            " : " +
                                            getAttribute[i].attributeValue +
                                            "</br>";
                                    }
                                }

                                if (accessEditAsset && vm.isAdmin == "ROLE_USER_ADMIN" || vm.isAdmin == "ROLE_CITY_PLANNER") {
                                    btnEditAssets = userContent.appendChild(
                                        document.createElement("input")
                                    );

                                    btnEditAssets.type = "button";
                                    btnEditAssets.value = "Edit Asset";
                                    btnEditAssets.className = "button";

                                    google.maps.event.addDomListener(
                                        btnEditAssets,
                                        "click",
                                        function () {
                                            $(":file").filestyle("clear");
                                            $("#assetEditModal").show();
                                        }
                                    );
                                }

                                btnShowAttributes = userContent.appendChild(
                                    document.createElement("input")
                                );

                                btnShowAttributes.type = "button";
                                btnShowAttributes.value = "Show Attributes";
                                btnShowAttributes.className = "button";

                                google.maps.event.addDomListener(
                                    btnShowAttributes,
                                    "click",
                                    function () {
                                        showAssetAttributesModal(assetVal);
                                    }
                                );
                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });

                                if (infowindow != null) {
                                    infowindow.setPosition(event.latLng);
                                    infowindow.open(locations.map);
                                    openedInfoWindow = infowindow;
                                }
                            });
                        }

                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locations.map);

                // polylines.push(polylinepath);
                switch (level) {
                    case "level1":
                        level1AssetsPolyline.push(polylinepath);
                        break;
                    case "level2":
                        level2AssetsPolyline.push(polylinepath);
                        break;
                    case "level3":
                        level3AssetsPolyline.push(polylinepath);
                        break;
                    case "level4":
                        level4AssetsPolyline.push(polylinepath);
                        break;
                    case "level5":
                        level5AssetsPolyline.push(polylinepath);
                        break;
                    default:
                        polylines.push(polylinepath);
                        break;
                }
            }
        }

        function drawPolylineCity(spread, map, level) {
            var spreadAssetCoordinates = [];
            var spreadColor = 0;
            var spreadWidth = 0;
            var spreadOpacity = 0;

            vm.assetTypes.forEach(function (assetType) {
                if (assetType.name == spread.assetTypeName) {
                    spreadColor = assetType.colorcode;
                    spreadWidth = assetType.lineWidth * 0.05;
                    spreadOpacity = assetType.transparency * 0.01;
                }
            });

            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                    sortOrder: value.sortOrder
                });
            });
            if (spreadAssetCoordinates[0].sortOrder != null) {
                spreadAssetCoordinates.sort(function (a, b) {
                    return a.sortOrder - b.sortOrder;
                });
            }
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spreadColor;
                }
                var polylineWeight = spreadWidth;
                var strokeOpacityVal = spreadOpacity;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }

                                var userContent = document.createElement("div");

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    "<b>Name : </b> " +
                                    spread.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km</br>";

                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });
                            });
                        }
                        if (infowindow != null) {
                            infowindow.setPosition(event.latLng);
                            infowindow.open(locationsCity.mapCity);
                            openedInfoWindow = infowindow;
                        }
                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locationsCity.mapCity);

                // polylines.push(polylinepath);
                switch (level) {
                    case "level1":
                        level1AssetsPolylineCity.push(polylinepath);
                        break;
                    case "level2":
                        level2AssetsPolylineCity.push(polylinepath);
                        break;
                    case "level3":
                        level3AssetsPolylineCity.push(polylinepath);
                        break;
                    case "level4":
                        level4AssetsPolylineCity.push(polylinepath);
                        break;
                    case "level5":
                        level5AssetsPolylineCity.push(polylinepath);
                        break;
                    default:
                        polylinesCity.push(polylinepath);
                        break;
                }
            }
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                Math.cos(degrees_to_radians(lat2)) *
                Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

        function closeModal(id) {
            if (id == 'modalAttachment') {
                $(":file").filestyle("clear");
                $scope.allimages = false;
            }
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

        $scope.newTabDisplay = function (id, name) {
            var request = new XMLHttpRequest(), apiImage = name == 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";
            request.open(
                "GET",
                apiImage + vm.assetIdImg + "/" + id,
                true
            );
            request.setRequestHeader(
                "Authorization",
                "Bearer " + $localStorage.authenticationToken
            );
            request.responseType = "blob";
            request.onload = response;

            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank");
                }
            }
            request.send();
        };

        vm.assetMarkerUpload = function (id) {
            vm.assetMarkerUploadId = id;
            $("#markerUploadModal").show();
        };

        vm.closeAssetMarkerModal = function () {
            $scope.uploadfile = null;
            $(":file").filestyle("clear");
            $("#markerUploadModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#markerUploadModal").hide();
        };

        vm.uploadAssetMarker = function () {
            var getFile, lastDotPosition, format;
            getFile = document.getElementById("uploadfile").files[0];
            lastDotPosition = getFile.name.lastIndexOf(".");
            format = getFile.name.substring(lastDotPosition + 1);

            var fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                EntityImport.get(
                    {
                        entityName: "ASSETSMARKER",
                        parentEntityId: vm.assetMarkerUploadId.id,
                        parentEntityName: "ASSETS",
                        entityLayout: "SPREAD",
                        fileFormat: format,
                        messageType: "ADD",
                        messageStatus: "OPEN",
                        fileImage: window.btoa(fileLoadedEvent.target.result), // imported file
                    },
                    function (response) {
                        vm.success = true;
                        $timeout(function () {
                            vm.closeAssetMarkerModal();
                        }, 2300);
                        /* vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id;
                        $timeout(function () {
                            $state.go(vm.currentState)
                        }, 4000); */
                    }
                );
            };
            fileReader.readAsBinaryString(getFile);
        };

        function assetMarkerTable(asset) {
            vm.assetsForListView.forEach(function (item) {
                item.isExpanded = false;
            });
            if (vm.toggle == asset.id) {
                vm.toggle = undefined;
            } else {
                asset.isExpanded = true;
                vm.toggle = asset.id;
            }
            if (asset.isExpanded) {
                ChildAssetMarkers.query(
                    {
                        assetId: asset.id,
                    },
                    onSuccess
                );

                function onSuccess(data) {
                    var assetMarkersRes = [];
                    data.forEach(function (values, index) {
                        values.no = index + 1;
                        assetMarkersRes.push(values);
                    });
                    vm.assetMarkers = assetMarkersRes;
                }
            }

        }

        function onSaveSuccessBuried(result) {

            var assetImagePath = result.assetType.imagePath
            var findAssetIndex;
            switch (result.assetType.zoomLevel) {
                case 15:
                    for (var i = 0; i < level2AssetsMarkers.length; i++) {
                        if (result.id == level2AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level2AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level2AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level2AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level2AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 15) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                case 16:
                    for (var i = 0; i < level3AssetsMarkers.length; i++) {
                        if (result.id == level3AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level3AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level3AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level3AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level3AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }


                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 16) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }

                            break;
                        }
                    }
                    break;

                case 17:
                    for (var i = 0; i < level4AssetsMarkers.length; i++) {
                        if (result.id == level4AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level4AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level4AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level4AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level4AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 17) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                case 18:
                    for (var i = 0; i < level5AssetsMarkers.length; i++) {
                        if (result.id == level5AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level5AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level5AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level5AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level5AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 18) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                case 19:
                    for (var i = 0; i < level6AssetsMarkers.length; i++) {
                        if (result.id == level6AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level6AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level6AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level6AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level6AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 19) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                case 20:
                    for (var i = 0; i < level7AssetsMarkers.length; i++) {
                        if (result.id == level7AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level7AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level7AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level7AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level7AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 20) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                default:
                    console.log("not found");
            }


        }

        vm.onNavigate = function (asset, geofence) {
            assetVisibility20 = false
            assetVisibility19 = false
            isLevel4AssetsVisible = false
            isLevel3AssetsVisible = false
            isLevel2AssetsVisible = false
            isLevelNodeVisible = false
            isLevel5AssetsVisible = false

            vm.isEnableNavigate = true
            vm.storeAsset = asset
            tempGeofenceId = geofence[0].id
            /* var getZoom = vm.assetTypes.find(function(item){
                return item.name == asset.assetTypeName
            })
            vm.getZoomLevel = getZoom.zoomLevel */
            $scope.setTab(2)
        }


        function addLatLng(event) {
            var path = polyMeasureTool.getPath();
            path.push(event.latLng);


            addPointer(event.latLng);

            var point1, point2
            for (var i = 0; i < path.getLength() - 1; i++) {
                point1 = path.getAt(i);
                point2 = path.getAt(i + 1);
                segmentDistance = google.maps.geometry.spherical.computeDistanceBetween(point1, point2);


                // Add distance marker
                midpoint = google.maps.geometry.spherical.interpolate(point1, point2, 0.5);

            }


            if (path.getLength() > 1) {
                totalDistance += segmentDistance;
                var marker = new google.maps.Marker({
                    position: midpoint,
                    map: locations.map,
                    icon: {
                        url: 'content/images/iconTransparent.png',
                    },
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "14px",
                        text: formatDistance(segmentDistance),
                    },
                });
                distanceMarkers.push(marker);

                var totalDistanceMarker = new google.maps.Marker({
                    position: point2,
                    map: locations.map,
                    icon: {
                        url: 'content/images/iconTransparent.png',
                    },
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "14px",
                        text: "Total : " + formatDistance(totalDistance),
                    },
                });
                totalDistanceMarkers.push(totalDistanceMarker);
            }

        }

        function addPointer(location) {
            var pointerIcon = {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 5,
                strokeColor: 'black',
                fillColor: 'white',
                fillOpacity: 1,
                strokeWeight: 2
            };

            var pointer = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: pointerIcon
            });
            pointerMarkers.push(pointer);
        }
        function formatDistance(distance) {
            // Convert meters to kilometers
            var km = distance / 1000;

            // Show in meters if less than 1 km, otherwise show in kilometers
            if (km < 1) {
                return distance.toFixed(0) + ' m';
            } else {
                return km.toFixed(2) + ' km';
            }
        }

        function clearMeasureTool(arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i].setMap(null)
            }
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dashboard', {
            parent: 'app',
            url: '/dashboard',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/dashboard.html',
                    controller: 'DashboardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]

            }
        });
    }
})();
(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('DashboardService', DashboardService);

        DashboardService.$inject = ['$http', 'DateUtils'];

    function DashboardService ($http, DateUtils) {
    	var service ={};
    	
    	service.loaddata = function (callback){
    		
    		$http.get('api/dashboard/dashboarddata').then(function(response){
        		callback(response.data);
        	});
    	};
    	
    	
    	return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('DashboardServiceGeo', DashboardServiceGeo);

    DashboardServiceGeo.$inject = ['$resource'];

    function DashboardServiceGeo($resource) {
        var service = $resource('/api/dashboard/dashboarddata/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CaseCountByPriority', CaseCountByPriority);

        CaseCountByPriority.$inject = ['$http'];

    function CaseCountByPriority ($http) {
    	var service ={};
    	
    	service.get= function (callback){	
    		$http.get('api/dashboard/case-count-by-priority').then(function(response){
        		callback(response.data);
        	});
    	};
    	
    	return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('CaseCountByPriorityGeo', CaseCountByPriorityGeo);

    CaseCountByPriorityGeo.$inject = ['$resource'];

    function CaseCountByPriorityGeo($resource) {
        var service = $resource('/api/dashboard/case-count-by-priority/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CaseCountByStatus', CaseCountByStatus);

        CaseCountByStatus.$inject = ['$http'];

    function CaseCountByStatus ($http) {
    	var service ={};
    	
    	service.get= function (callback){	
    		$http.get('api/dashboard/case-count-by-status').then(function(response){
        		callback(response.data);
        	});
    	};
    	
    	return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('CaseCountByStatusGeo', CaseCountByStatusGeo);

    CaseCountByStatusGeo.$inject = ['$resource'];

    function CaseCountByStatusGeo($resource) {
        var service = $resource('/api/dashboard/case-count-by-status/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistanceGeo', UserListAndDistanceGeo);

        UserListAndDistanceGeo.$inject = ['$resource'];

    function UserListAndDistanceGeo ($resource) {
        var service = $resource('api/dashboard/userlist/:geofenceId',{geofenceId:'@geofenceId'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LinkService', LinkService);

    LinkService.$inject = ['$http', 'DateUtils'];

    function LinkService ($http, DateUtils) {
    	var service ={};
    	
    	service.loaddata = function (callback){
    		
    		$http.get('api/dashboard/dashboardlinkdata').then(function(response){
        		callback(response.data);
        	});
    	};
    	
    	
    	return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistance', UserListAndDistance);

    UserListAndDistance.$inject = ['$resource'];

    function UserListAndDistance ($resource) {
        var service = $resource('api/dashboard/userlist',{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistanceSearch', UserListAndDistanceSearch);

    UserListAndDistanceSearch.$inject = ['$resource'];

    function UserListAndDistanceSearch ($resource) {
        var service = $resource('api/dashboard/userlist/:login',{login:'@login'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("DashboardController", HomeController);

    HomeController.$inject = [
        "$scope",
        "GeoAssetTypeReport",
        "AlertService",
        "ParseLinks",
        "$state",
        "pagingParams",
        "paginationConstants",
        "DashboardServiceGeo",
        "CaseCountByPriority",
        "CaseCountByStatus",
        "$filter",
        "UserListAndDistanceGeo",
        "UserListAndDistanceSearch",
        "$interval",
        "UserMasterGeofences",
        "CaseCountByPriorityGeo",
        "CaseCountByStatusGeo"
    ];

    function HomeController(
        $scope,
        GeoAssetTypeReport,
        AlertService,
        ParseLinks,
        $state,
        pagingParams,
        paginationConstants,
        DashboardServiceGeo,
        CaseCountByPriority,
        CaseCountByStatus,
        $filter,
        UserListAndDistanceGeo,
        UserListAndDistanceSearch,
        $interval,
        UserMasterGeofences,
        CaseCountByPriorityGeo,
        CaseCountByStatusGeo
    ) {
        var vm = this;

        // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        // vm.transition = transition;
        //vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPage = 4;
        vm.userslist = [];
        vm.filterSearch = filterSearch;
        vm.loaddata = loaddata;

        vm.userMasterGeofences = [];
        vm.selectCityFilter= false;
        vm.currYear = new Date().getFullYear();
        vm.isGeofences = false
        var tempWidth, tempHeight

        loaddata();

        var updateDashboard = $interval(function () {
            // loaddata();
            var date = new Date();

            var weekday = new Array(7);
            weekday[0] = "Sunday";
            weekday[1] = "Monday";
            weekday[2] = "Tuesday";
            weekday[3] = "Wednesday";
            weekday[4] = "Thursday";
            weekday[5] = "Friday";
            weekday[6] = "Saturday";
            vm.day = weekday[date.getDay()];

            var month = new Array();
            month[0] = "January";
            month[1] = "February";
            month[2] = "March";
            month[3] = "April";
            month[4] = "May";
            month[5] = "June";
            month[6] = "July";
            month[7] = "August";
            month[8] = "September";
            month[9] = "October";
            month[10] = "November";
            month[11] = "December";
            vm.month = month[date.getMonth()];
            vm.todayDate = date.getDate();
            vm.year = date.getFullYear();
            var dateFormat = "hh:mm";
            vm.time = $filter("date")(formatAMPM(date), dateFormat);
        }, 10000);
        $scope.$on("$destroy", function () {
            $interval.cancel(updateDashboard);
        });

        var date = new Date();

        var weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        vm.day = weekday[date.getDay()];

        var month = new Array();
        month[0] = "January";
        month[1] = "February";
        month[2] = "March";
        month[3] = "April";
        month[4] = "May";
        month[5] = "June";
        month[6] = "July";
        month[7] = "August";
        month[8] = "September";
        month[9] = "October";
        month[10] = "November";
        month[11] = "December";
        vm.month = month[date.getMonth()];
        vm.todayDate = date.getDate();
        vm.year = date.getFullYear();
        var dateFormat = "hh:mm";
        vm.time = $filter("date")(formatAMPM(date), dateFormat);

        $scope.setOrderProperty = function (propertyName) {
            if ($scope.orderProperty === propertyName) {
                $scope.orderProperty = "-" + propertyName;
            } else if ($scope.orderProperty === "-" + propertyName) {
                $scope.orderProperty = propertyName;
            } else {
                $scope.orderProperty = propertyName;
            }
        };

        function loaddata() {
            var geoResult = [];
            var geoGrouped = {};
            var assetTypeResult = [];
            var assetTypeGrouped = {};
            var geofences = [];
            var geoAssetTypeAssetsList = [];

            
            // CaseCountByPriority.get(function (data) {
            //     vm.casepriority = data.casePriority;
            // });

            vm.userMasterGeofences = [];
            UserMasterGeofences.getAllMasterGeofenceByUser(function (response) {
                if(response.length>0){
                    vm.masterGeofence = response[0].id+"";   
                }
                vm.userMasterGeofences = response;
                CaseCountByPriorityGeo.get(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessCasePriorityGeo,
                    onErrorCasePriorityGeo
                );
                function onSuccessCasePriorityGeo(data, headers) {
                    vm.casepriority = data.casePriority;
                }

                function onErrorCasePriorityGeo(error) {
                    AlertService.error(error.data.message);
                }

                UserListAndDistanceGeo.query(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessUserListGeo,
                    onErrorUserListGeo
                );
                function onSuccessUserListGeo(data, headers) {
                    vm.userslist = data;
                }
    
                function onErrorUserListGeo(error) {
                    AlertService.error(error.data.message);
                }
                
                DashboardServiceGeo.get(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessUserDashboardDataGeo,
                    onErrorUserDashboardDataGeo
                );
                function onSuccessUserDashboardDataGeo(data, headers) {
                    showDashboardData(data);
                }
    
                function onErrorUserDashboardDataGeo(error) {
                    AlertService.error(error.data.message);
                }
                
                CaseCountByStatusGeo.get(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessCaseStatusGeo,
                    onErrorCaseStatusGeo
                );
                function onSuccessCaseStatusGeo(data, headers) {
                    showCaseStatus(data);
                }

                function onErrorCaseStatusGeo(error) {
                    AlertService.error(error.data.message);
                }
            });
        }

        function showCaseStatus(data){
            
            var svgtemp = d3.select("#case-chart");
            svgtemp.selectAll("*").remove();

            var dataset = [
                { label: "New", count: data.caseType.NEW },
                { label: "In Progress", count: data.caseType.INPROGRESS },
                { label: "Pending", count: data.caseType.PENDING },
                { label: "Assigned", count: data.caseType.ASSIGNED },
                { label: "Resolved", count: data.caseType.RESOLVED },
                { label: "Cancelled", count: data.caseType.CANCELLED },
                { label: "Closed", count: data.caseType.CLOSED },
            ];

            var width = 240;
            var height = 300;

            try {
                width = document.getElementById("case-chart").offsetWidth;
                height = document.getElementById("case-chart").offsetHeight;
            } catch (error) {
                // console.log(error);
            }

            // var radius = Math.min(width, height) / 2;
            // var donutWidth = 40;

            var radius = Math.min(width, height) / 1.8;
            var legendRectSize = 12;
            var legendSpacing = 3;

            var color = d3.scale
                .ordinal()
                .range([
                    "#FD7A24",
                    "#82eedd",
                    "#C6418F",
                    "#00e658",
                    "#ee8293",
                    "#bbc641",
                ]);

            var svg = d3
                .select("#case-chart")
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("shape-rendering", "geometricPrecision")
                .attr(
                    "transform",
                    "translate(" + width / 2 + "," + height / 2 + ")"
                );
                

            var arc = d3.svg
                .arc()
                .innerRadius(radius - 70)
                .outerRadius(radius - 30);

            var pie = d3.layout
                .pie()
                .value(function (d) {
                    return d.count;
                })
                .sort(null);

            dataset.forEach(function (d) {
                d.count = +d.count;
                d.enabled = true;
            });

            var path = svg
                .selectAll("path")
                .data(pie(dataset))
                .enter()
                .append("path")
                .attr("d", arc)
                .attr("fill", function (d, i) {
                    return color(d.data.label + " - " + d.data.count);
                })
                .each(function (d) {
                    this._current = d;
                });

            var tooltip2 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");

            path.on("mouseover", function (d) {
                tooltip2
                    .style("left", d3.event.pageX - 50 + "px")
                    .style("top", d3.event.pageY - 50 + "px")
                    .style("display", "inline-block")
                    .style("fill", "black")
                    .html(d.data.label + "<br>" + d.value);
                return tooltip2.style("visibility", "visible");
            })
                .on("mousemove", function () {
                    return tooltip2
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip2.style("visibility", "hidden");
                });

            var legend = svg
                .selectAll(".legend")
                .data(color.domain())
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("transform", function (d, i) {
                    var height = legendRectSize + legendSpacing;
                    var offset = (height * color.domain().length) / 2;
                    var horz = -4.5 * legendRectSize;
                    var vert = i * height - offset;
                    return "translate(" + horz + "," + vert + ")";
                });

            legend
                .append("rect")
                .attr("width", legendRectSize)
                .attr("height", legendRectSize)
                .style("fill", color)
                .style("stroke", color)
                .on("click", function (label) {
                    var rect = d3.select(this);
                    var enabled = true;
                    var totalEnabled = d3.sum(
                        dataset.map(function (d) {
                            return d.enabled ? 1 : 0;
                        })
                    );

                    if (rect.attr("class") === "disabled") {
                        rect.attr("class", "");
                    } else {
                        if (totalEnabled < 2) return;
                        rect.attr("class", "disabled");
                        enabled = false;
                    }

                    pie.value(function (d) {
                        if (d.label === label) d.enabled = enabled;
                        return d.enabled ? d.count : 0;
                    });

                    path = path.data(pie(dataset));

                    path.transition()
                        .duration(750)
                        .attrTween("d", function (d) {
                            var interpolate = d3.interpolate(
                                this._current,
                                d
                            );
                            this._current = interpolate(0);
                            return function (t) {
                                return arc(interpolate(t));
                            };
                        });
                });

            legend
                .append("text")
                .attr("x", legendRectSize + legendSpacing)
                .attr("y", legendRectSize - legendSpacing)
                .style("font-family", "sans-serif")
                .style("font-size", "12px")
                .text(function (d) {
                    return d;
                });
        }

        function showDashboardData(data){
            vm.users = data.users;
            vm.isGeofences = data.geofences.length == 0
            var svgtempstatus = d3.select("#status");
                svgtempstatus.selectAll("*").remove();
            var svgtemp = d3.select("#stacked-chart-status");
                svgtemp.selectAll("*").remove();
            

            // geofence bar graph
            var margin2 = { top: 30, right: 10, bottom: 85, left: 30 };

            var width2 = 960;
            var height2 = 300 - margin2.top - margin2.bottom;

            try {
                width2 =
                    document.getElementById("stacked-chart-status")
                        .offsetWidth -
                    margin2.left -
                    margin2.right;

                
                height2 =
                    document.getElementById("stacked-chart-status")
                        .offsetHeight -
                    margin2.top -
                    margin2.bottom; 

                    if (width2 < 0 || height2 < 0) {
                        width2 = tempWidth;
                        height2 = tempHeight;
                    }
            } catch (error) {
                // console.log(error);
            }
            tempWidth = width2
            tempHeight = height2
            var svg = d3
                .select("#stacked-chart-status")
                .append("svg")
                .attr("width", width2 + margin2.left + margin2.right)
                .attr("height", height2 + margin2.top + margin2.bottom)
                .append("g")
                .attr(
                    "transform",
                    "translate(" + margin2.left + "," + margin2.top + ")"
                )
                .attr("shape-rendering", "geometricPrecision");
            // /* Data in strings like it would be if imported from a csv */

            var cases = data.geofences.map(function (d) {
                return {
                    x:
                        d.label.slice(0, 15) +
                        (d.label.length > 15 ? "..." : ""),
                    y: +d.caseStatusCountDto.critical_priority,
                    x1: d.label,
                };
            });
            // Transpose the data into layers
            //actual data
            var dataset = d3.layout.stack()(
                ["active", "idle", "inactive"].map(function (fruit) {
                    var groupData = data.geofences.slice(0, 40);
                    return groupData.map(function (d) {
                        return {
                            x:
                                d.label.slice(0, 15) +
                                (d.label.length > 15 ? "..." : ""),
                            y: +d.userStatusCount[fruit],
                            x1: d.label,
                        };
                    });
                    // }
                })
            );

            // Set x, y and colors
            var x = d3.scale
                .ordinal()
                .domain(
                    dataset[0].map(function (d) {
                        return d.x;
                    })
                )
                .rangeRoundBands([10, width2 - 50], 0.5);

            var countUsers = d3.max(dataset, function (d) {
                return d3.max(d, function (d) {
                    return d.y0 + d.y;
                });
            })

            if(countUsers >=1){
                var y = d3.scale
                .linear()
                .domain([
                    0,
                    d3.max(dataset, function (d) {
                        return d3.max(d, function (d) {
                            return d.y0 + d.y;
                        });
                    }),
                ])
                .range([height2, 0]);
            }else {
                var y = d3.scale
                .linear()
                .domain([
                    0,
                    d3.max(cases, function (d) {
                            return  d.y;
                    }),
                ])
                .range([height2, 0]);
            }
            
            var colors = ["#00e658", "#FD7A24", "#afafaf"];

            // Define and draw axes
            var yAxis = d3.svg
                .axis()
                .scale(y)
                .orient("left")
                .ticks(5)
                .tickSize(-width2, 0, 0)
                .tickFormat(function (d) { if((d % 1 == 0)){
                    return d
                }});

            var xAxis = d3.svg.axis().scale(x).orient("bottom");
            // .tickFormat(d3.time.format("%y"));

            svg.append("g").attr("class", "y axis").call(yAxis);

            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height2 + ")")
                .call(xAxis)
                .selectAll("text")
                .style("text-anchor", "end")
                .style("font-family", "sans-serif")
                .style("font-size", "11px")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-45)");

            // Create groups for each series, rects for each segment
            var groups = svg
                .selectAll("g.cost")
                .data(dataset)
                .enter()
                .append("g")
                .attr("class", "cost")
                .style("fill", function (d, i) {
                    return colors[i];
                });

            var rect = groups
                .selectAll("rect")
                .data(function (d) {
                    return d;
                })
                .enter()
                .append("rect")
                .attr("x", function (d) {
                    return x(d.x) + x.rangeBand() / 2;
                })
                .attr("y", function (d) {
                    return y(d.y0 + d.y);
                })
                .attr("height", function (d) {
                    return y(d.y0) - y(d.y0 + d.y);
                })
                .attr("width", x.rangeBand() / 2);

            var caseBar = svg.selectAll(".bar1")
                .data(cases)
                .enter()
                .append("g")
                .attr("class", "bar1")
                .append("rect")
                .attr("x", function (d) {
                    return x(d.x); // center it
                })
                .attr("width", x.rangeBand() / 2) // make it slimmer
                .attr("y", function (d) {
                    return y(d.y);
                })
                .attr("height", function (d) {
                    return height2 - y(d.y);
                });
            // Draw legend
            var svg1 = d3
                .select("#status")
                .append("svg")
                .attr("width", width2 + margin2.left + margin2.right)
                .attr("height", 15)
                .append("g")
                .attr("transform", "translate(" + (margin2.right - 25) + "," + -220 + ")")
                .attr("shape-rendering", "geometricPrecision");

            var legend = svg1
                .selectAll(".legend")
                .data(colors)
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("width", 15)
                .attr("height", 15)
                .attr("transform", function (d, i) {
                    if(i==2){
                        return "translate(" + ((i * 80)-18) + ",30)";
                    }else{
                        return "translate(" + i * 80 + ",30)";
                    }
                })
                // .on("click", function(d) {

                // });
                .on("click", function (d, i) {
                    if (i == 1) {
                        if (
                            d3
                                .select(this)
                                .style("fill" == "#FD7A24")
                                .style("opacity") == 1
                        ) {
                            d3.selectAll(".cost:nth-child(4)").style(
                                "opacity",
                                0
                            );
                            d3.select(this)
                                .style("fill", "#FD7A24")
                                .style("opacity", "0.5");
                        } else {
                            d3.selectAll(".cost:nth-child(4)").style(
                                "opacity",
                                9
                            );
                            d3.select(this)
                                .style("fill", "#FD7A24")
                                .style("opacity", 9);
                        }
                    }
                    if (i == 2) {
                        if (
                            d3
                                .select(this)
                                .style("fill" == "#afafaf")
                                .style("opacity") == 1
                        ) {
                            d3.selectAll(".cost:nth-child(5)").style(
                                "opacity",
                                0
                            );
                            d3.select(this)
                                .style("fill", "#afafaf")
                                .style("opacity", "0.5");
                        } else {
                            d3.selectAll(".cost:nth-child(5)").style(
                                "opacity",
                                9
                            );
                            d3.select(this)
                                .style("fill", "#afafaf")
                                .style("opacity", 9);
                        }
                    }
                    if (i == 0) {
                        if (
                            d3
                                .select(this)
                                .style("fill" == "#00e658")
                                .style("opacity") == 1
                        ) {
                            d3.selectAll(".cost:nth-child(3)").style(
                                "opacity",
                                0
                            );
                            d3.select(this)
                                .style("fill", "#00e658")
                                .style("opacity", "0.5");
                        } else {
                            d3.selectAll(".cost:nth-child(3)").style(
                                "opacity",
                                9
                            );
                            d3.select(this)
                                .style("fill", "#00e658")
                                .style("opacity", 9);
                        }
                    }
                });
            // .attr("transform", function(d,i) {
            // 	return "translate(" + width2 + "," + i * height2 + ")"; })

            legend
                .append("circle")
                .attr("cx", width2 / 2 - 96)
                .attr("cy", height2 + 67)
                .attr("r", 6)
                .style("fill", function (d, i) {
                    return colors[i];
                });

            legend
                .append("text")
                .attr("x", width2 / 2 - 85)
                .attr("y", height2 + 67)
                .attr("dy", ".35em")
                .style("text-anchor", "start")
                .style("font-family", "sans-serif")
                .style("font-size", "12px")
                .style("font-weight", "700")
                .style("cursor", "pointer")
                .text(function (d, i) {
                    switch (i) {
                        case 0:
                            return "ACTIVE";
                        case 1:
                            return "IDLE";
                        case 2:
                            return "INACTIVE";
                    }
                });

            var tooltip1 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");

            rect.on("mouseover", function (d) {
                tooltip1
                    .style("left", d3.event.pageX - 50 + "px")
                    .style("top", d3.event.pageY - 50 + "px")
                    .style("display", "inline-block")
                    .style("fill", "black")
                    .html(d.x1 + "<br>" + d.y);
                return tooltip1.style("visibility", "visible");
            })
                .on("mousemove", function () {
                    return tooltip1
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip1.style("visibility", "hidden");
                });
                
            caseBar.on("mouseover", function (d) {
                tooltip1
                    .style("left", d3.event.pageX - 50 + "px")
                    .style("top", d3.event.pageY - 50 + "px")
                    .style("display", "inline-block")
                    .style("fill", "black")
                    .html("Critical Case Count" + "<br>" + d.y);
                return tooltip1.style("visibility", "visible");
            })
                .on("mousemove", function () {
                    return tooltip1
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip1.style("visibility", "hidden");
                });
        }

        function formatAMPM(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? "PM" : "AM";
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? "0" + minutes : minutes;
            var strTime = hours + ":" + minutes + " " + ampm;
            return strTime;
        }

        function filterSearch() {
            if (
                vm.search != null &&
                vm.search != "" &&
                !angular.isUndefined(vm.search)
            ) {
                UserListAndDistanceSearch.query({}, onSuccess, onError);
            } else {
                UserListAndDistanceGeo.query(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessUserListGeo,
                    onErrorUserListGeo
                );
                function onSuccessUserListGeo(data, headers) {
                    vm.userslist = data;
                }
    
                function onErrorUserListGeo(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                result.push("id");
            }
            return result;
        }

        function onSuccess(data, headers) {
            // vm.links = ParseLinks.parse(headers('link'));
            // vm.totalItems = headers('X-Total-Count');
            // vm.queryCount = vm.totalItems;
            vm.userslist = data;
            // vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        // $('#masterGeofence').on('change', function() {
        $scope.optionChange = function(){
            vm.masterGeofence = document.getElementById("masterGeofence").value;  
            CaseCountByPriorityGeo.get(
                {
                    geofenceId: vm.masterGeofence
                },
                onSuccessCasePriorityGeo,
                onErrorCasePriorityGeo
            );
            function onSuccessCasePriorityGeo(data, headers) {
                vm.casepriority = data.casePriority;
            }

            function onErrorCasePriorityGeo(error) {
                AlertService.error(error.data.message);
            }

            UserListAndDistanceGeo.query(
                {
                    geofenceId: vm.masterGeofence
                },
                onSuccessUserListGeo,
                onErrorUserListGeo
            );
            function onSuccessUserListGeo(data, headers) {
                vm.userslist = data;
            }

            function onErrorUserListGeo(error) {
                AlertService.error(error.data.message);
            }
            
            DashboardServiceGeo.get(
                {
                    geofenceId: vm.masterGeofence
                },
                onSuccessUserDashboardDataGeo,
                onErrorUserDashboardDataGeo
            );
            function onSuccessUserDashboardDataGeo(data, headers) {
                showDashboardData(data);
            }

            function onErrorUserDashboardDataGeo(error) {
                AlertService.error(error.data.message);
            }

            CaseCountByStatusGeo.get(
                {
                    geofenceId: vm.masterGeofence
                },
                onSuccessCaseStatusGeo,
                onErrorCaseStatusGeo
            );
            function onSuccessCaseStatusGeo(data, headers) {
                showCaseStatus(data);
            }

            function onErrorCaseStatusGeo(error) {
                AlertService.error(error.data.message);
            }
        }

        // function loadPage(page) {
        //     vm.page = page;
        //     vm.transition();
        // }

        // function transition() {
        //     $state.transitionTo($state.$current, {
        //         page: vm.page,
        //         sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        //         search: vm.currentSearch
        //     });
        // }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('trakeyeApp')
        .component('jhiItemCount', jhiItemCount);
})();

/* 
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes. 
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 * 
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy 
 * of this software and associated documentation files (the "Software"), to deal 
 * in the Software without restriction, including without limitation the rights 
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
 * copies of the Software, and to permit persons to whom the Software is 
 * furnished to do so, subject to the following conditions: 
 *
 * The above copyright notice and this permission notice shall be included in all 
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */

'use strict'

angular.module( 'isteven-multi-select', ['ng'] ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict: 
            'AE',

        scope: 
        {   
            // models
            inputModel      : '=',
            outputModel     : '=',

            // settings based on attribute
            isDisabled      : '=',

            // callbacks
            onClear         : '&',  
            onClose         : '&',
            onSearchChange  : '&',  
            onItemClick     : '&',            
            onOpen          : '&', 
            onReset         : '&',  
            onSelectAll     : '&',  
            onSelectNone    : '&',  
            onSelectDone    : '&', 

            // i18n
            translation     : '='   
        },
        
        /* 
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */
                                                         
         templateUrl: 
            'isteven-multi-select.htm',                            

        link: function ( $scope, element, attrs ) {                       

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';               
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';                        
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };                        
            $scope.tabIndex         = 0;            
            $scope.lang             = {};
            $scope.helperStatus     = {
                all     : true,
                none    : true,
                reset   : true,
                filter  : true,
                done : true
            };

            var 
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null                

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {                
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );                
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );   
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {                                                
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }                
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {      
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;                   
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }
                    
                    // if it's data 
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {                        
                        
                        // If we set the search-key attribute, we use this loop. 
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }

                        if ( gotData === true ) {    
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined' 
                                && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }                

                $scope.filteredModel.reverse();  
                
                $timeout( function() {                    

                    $scope.getFormElements();               
                    
                    // Callback: on filter change                      
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {                   
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                                                    
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );                                
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];      
                                }
                            }
                        });

                        $scope.onSearchChange({ 
                            data: 
                            {
                                keyword: $scope.inputLabel.labelFilter, 
                                result: filterObj 
                            } 
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated. 
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {                                     
                formElements = [];

                var 
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];
                
                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.done || $scope.helperStatus.reset ) {                                                       
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );                    
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {                                            
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );                        
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {   
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
               
                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.done && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[] 
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }                                
            }            

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true; 
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false; 
                return true;
            }                       

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {                                      

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {                        
                    return false;
                }                                

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }                

                var index = $scope.filteredModel.indexOf( item );       

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected                
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {                                  

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }
                    
                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;                    

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {  

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index ) 
                        {
                            break;
                        }
                    
                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {
                            
                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1; 
                            }                            
                            nestLevel = nestLevel + 1;
                        }                                                

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;                            

                            // cek if all are ticked or not                            
                            if ( tempArr.length > 0 && nestLevel === 0 ) {                                

                                var allTicked = true;       

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {                                
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }                                                                                    

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }                                
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;                                                
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }                                            
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }                                
                                }                                                                                    
                            }
                        }
            
                        // if data
                        else {                            
                            tempArr.push( $scope.filteredModel[ i ] );                                                                                    
                        }
                    }                                 
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        
                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {                            
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        for( i=0 ; i < $scope.inputModel.length ; i++) {                            
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        
                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;                                                                 
                    }   

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];                                        
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];                    
                }                                  

                // we execute the callback function here
                clickedItem = angular.copy( item );                                                    
                if ( clickedItem !== null ) {                        
                    $timeout( function() {
                        delete clickedItem[ $scope.indexProperty ];
                        delete clickedItem[ $scope.spacingProperty ];      
                        $scope.onItemClick( { data: clickedItem } );
                        clickedItem = null;                    
                    }, 0 );                                                 
                }                                    
                
                $scope.refreshOutputModel();
                $scope.refreshButton();                              

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;
                                
                // Set focus on the hidden checkbox 
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );       
                }
            }     

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {            
                
                $scope.outputModel  = [];
                var 
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {                    
                    outputProps = attrs.outputProperties.split(' ');                
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {                                
                                if ( outputProps.indexOf( key1 ) > -1 ) {                                                                         
                                    tempObj[ key1 ] = value1;                                    
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';                
                var ctr                 = 0;                  

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19                    
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {                
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }                
                    
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {                        
                            if ( ctr < tempMaxLabels ) {                            
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });                

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';                        
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );                
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {
                
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return true;
                }
                else {             
                    if ( $scope.isDisabled === true ) {                        
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                
            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {
                
                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );                    
                var label   = '';                

                angular.forEach( temp, function( value, key ) {                    
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ]; 
                    }, item ));        
                });
                
                if ( type.toUpperCase() === 'BUTTONLABEL' ) {                    
                    return label;
                }
                return $sce.trustAsHtml( label );
            }                                

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {                                    
                
                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );        

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect 
                // His version is awesome if you need a more simple multi-select approach.                                

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {                         

                    angular.element( checkBoxLayer ).removeClass( 'show' );                    
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );                    
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );                                    

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                } 
                // open
                else                 
                {    
                    // clear filter
                    $scope.inputLabel.labelFilter = '';                
                    $scope.updateFilter();                                

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );       

                    // Attach change event listener on the input filter. 
                    // We need this because ng-change is apparently not an event listener.                    
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );  

                    // to get the initial tab index, depending on how many helper elements we have. 
                    // priority is to always focus it on the input filter                                                                
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];                
                    
                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }
                    
                    // focus on the filter element on open. 
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {                        
                        element[ 0 ].querySelector( '.inputFilter' ).focus();    
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {                  
                        if ( !$scope.isDisabled ) {                        
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }                            
                        }
                    }                          

                    // open callback
                    $scope.onOpen();
                }                            
            }
            
            // handle clicks outside the button / multi select layer
            $scope.externalClickListener = function( e ) {                   

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {                                        
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }

                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );                    
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener ); 
                angular.element( document ).off( 'keydown', $scope.keyboardListener );                
                
                // close callback                
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
            }
   
            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                                
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });                            
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                  
                        $scope.onSelectAll();                                                
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onSelectNone();                        
                        break;
                    
                    case 'DONE':                                                                          
                            $scope.onSelectDone();
                            angular.element( checkBoxLayer ).removeClass( 'show' );                      
                            break;

                    case 'RESET':            
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                var temp = value[ $scope.indexProperty ];                                
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onReset();                        
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();    
                        break;
                    case 'FILTER':                        
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:                        
                }                                                                                 
            }            

            // just to create a random variable name                
            function genRandomString( length ) {                
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                     temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;                                                
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;                    
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }                    
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }                 
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) { 
                
                var key = e.keyCode ? e.keyCode : e.which;      
                var isNavigationKey = false;                                                

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();                   
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }                    
                
                
                // next element ( tab, down & right key )                    
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {                    
                    
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex++;                         
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1; 
                    }                                                            
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;                            
                        }                                                                                    
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }              
                }
                  
                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) { 
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex--;                              
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }                                         
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {                        
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }                                            
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }                             
                    }                                                     
                }                    

                if ( isNavigationKey === true ) {                                         
                    
                    e.preventDefault();

                    // set focus on the checkbox                    
                    formElements[ $scope.tabIndex ].focus();    
                    var actEl = document.activeElement;                     
                    
                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {                                                   
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }                    
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    } 
                }                

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {                                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );                        
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************             
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;   
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;
            
            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;         

            // set orientation css            
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {                    
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else 
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }            

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {                
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );                                
            }

            // some flags for easier checking            
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {                    
                    if ( 
                        typeof attrs.helperElements !== 'undefined' 
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1 
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
                $scope.helperStatus[ 'done' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to. 
            $scope.icon        = {};            
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';
            $scope.icon.Done = '';     
            $scope.icon.reset      = '&#8630;';     // undo icon            
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon 

            // configurable button labels                       
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.Done      = $sce.trustAsHtml( /* $scope.icon.Done + '&nbsp;&nbsp;' + */ $scope.translation.Done );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;                
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );                
            }
            else {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );                
                $scope.lang.Done      = $sce.trustAsHtml( $scope.icon.Done + '&nbsp;&nbsp;Select Done' );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
                $scope.lang.search          = 'Search...';
                $scope.lang.nothingSelected = 'None Selected';               
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );
                
            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/
            
            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8            
            $scope.$watch( 'inputModel' , function( newVal ) {                                 
                if ( newVal ) {                            
                    $scope.refreshOutputModel();                                    
                    $scope.refreshButton();                                                  
                }
            }, true );
            
            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {  
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );    
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();                                                              
                    $scope.refreshOutputModel();                
                    $scope.refreshButton();                                                                                                                 
                }
            });                        

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {         
                $scope.isDisabled = newVal;                               
            });            
            
            // this is for touch enabled devices. We don't want to hide checkboxes on scroll. 
            var onTouchStart = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = false;
            	}); 
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = true;                
            	});
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);            

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
			    angular.element( document ).unbind( 'touchstart', onTouchStart);
            	angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template = 
        '<span class="multiSelect inlineBlock">' +
            // main button
            '<button id="{{directiveId}}" type="button"' +                
                'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
                'ng-bind-html="varButtonLabel"' +
                'ng-disabled="disable-button"' +
            '>' +
            '</button>' +
            // overlay layer
            '<div class="checkboxLayer">' +
                // container of the helper elements
                '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none ||  helperStatus.done || helperStatus.reset ">' +
                    // container of the first 3 buttons, select all, none and reset
                    '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.done || helperStatus.reset ">' +
                        // select all
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.all"' +
                            'ng-click="select( \'all\', $event );"' +
                            'ng-bind-html="lang.selectAll">' +
                        '</button>'+
                        // select none
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.none"' +
                            'ng-click="select( \'none\', $event );"' +
                            'ng-bind-html="lang.selectNone">' +
                        '</button>'+
                            //done
                        '<button type="button" class="pull-right doneFilter helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.done"' +
                            'ng-click="select( \'done\', $event );"' +
                            'ng-bind-html="lang.Done">' +
                        '</button>'+

                        // reset
                        '<button type="button" class="helperButton reset"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.reset"' +
                            'ng-click="select( \'reset\', $event );"' +
                            'ng-bind-html="lang.reset">'+
                        '</button>' +
                    '</div>' +
                    // the search box
                    '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
                        // textfield                
                        '<input placeholder="{{lang.search}}" type="text"' +
                            'ng-click="select( \'filter\', $event )" '+
                            'ng-model="inputLabel.labelFilter" '+
                            'ng-change="searchChanged()" class="inputFilter"'+
                            '/>'+
                        // clear button
                        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
                    '</div> '+
                '</div> '+
                // selection items
                '<div class="checkBoxContainer">'+
                    '<div '+
                        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
                        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
                        'ng-click="syncItems( item, $event, $index );" '+
                        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
                        // this is the spacing for grouped items
                        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+                        
                    '</div>  '+        
                    '<div class="acol">'+
                        '<label>'+                                
                            // input, so that it can accept focus on keyboard click
                            '<input class="checkbox focusable" type="checkbox" '+
                                'ng-disabled="itemIsDisabled( item )" '+
                                'ng-checked="item[ tickProperty ]" '+
                                'ng-click="syncItems( item, $event, $index )" />'+
                            // item label using ng-bind-hteml
                            '<span '+
                                'ng-class="{disabled:itemIsDisabled( item )}" '+
                                'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
                            '</span>'+
                        '</label>'+
                    '</div>'+
                    // the tick/check mark
                    '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</span>';
	$templateCache.put( 'isteven-multi-select.htm' , template );
}]); 

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/login/login.html',
                    controller: 'LoginControllers',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LoginControllers', LoginControllers);

    LoginControllers.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'Principal'];

    function LoginControllers($rootScope, $state, $timeout, Auth, Principal) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function () { angular.element('#username').focus(); });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            //  $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $rootScope.has_ROLE_SUPER_ADMIN = false;
                $rootScope.has_ROLE_USER_ADMIN = false;
                $rootScope.has_ROLE_USER = false;
                $rootScope.has_ROLE_VENDOR_ADMIN = false;
                $rootScope.has_ROLE_HOD = false;
                $rootScope.has_ROLE_CITY_MANAGER = false;
                $rootScope.has_ROLE_CITY_PLANNER = false;
                $rootScope.has_ROLE_ASSISTANT_MANAGER = false;
                $rootScope.has_ROLE_TEAM_LEADER = false;
                $rootScope.has_ROLE_NETWORK_ENGINEER = false;
                $rootScope.has_ROLE_FRT = false;
                $rootScope.has_ROLE_PATROLLER = false;

                $rootScope.has_ROLE_ROLLOUT_SURVEY = false;
                $rootScope.has_ROLE_ROLLOUT_INFRA = false;
                $rootScope.has_ROLE_ROLLOUT_ADMIN = false;
                $rootScope.has_ROLE_PLAN_SURVEY = false;
                $rootScope.has_ROLE_PLAN_INFRA = false;
                $rootScope.has_ROLE_PLAN_ADMIN = false;

                Principal.identity().then(function (identity) {
                    if (identity && identity.authorities && identity.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1) {
                        $rootScope.has_ROLE_SUPER_ADMIN = true;
                        $state.go('tenant');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_USER_ADMIN') !== -1) {
                        $rootScope.has_ROLE_USER_ADMIN = true;
                        $state.go('dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_VENDOR') !== -1) {
                        $rootScope.has_ROLE_VENDOR = true;
                        $state.go('dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_HOD') !== -1) {
                        $rootScope.has_ROLE_HOD = true;
                        $state.go('dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_CITY_MANAGER') !== -1) {
                        $rootScope.has_ROLE_CITY_MANAGER = true;
                        $state.go('dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_CITY_PLANNER') !== -1) {
                        $rootScope.has_ROLE_CITY_PLANNER = true;
                        $state.go('dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ASSISTANT_MANAGER') !== -1) {
                        $rootScope.has_ROLE_ASSISTANT_MANAGER = true;
                        $state.go('dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_TEAM_LEADER') !== -1) {
                        $rootScope.has_ROLE_TEAM_LEADER = true;
                        $state.go('dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_NETWORK_ENGINEER') !== -1) {
                        $rootScope.has_ROLE_NETWORK_ENGINEER = true;
                        $state.go('dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_FRT') !== -1) {
                        $rootScope.has_ROLE_FRT = true;
                        $state.go('tr-case');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_PATROLLER') !== -1) {
                        $rootScope.has_ROLE_PATROLLER = true;
                        $state.go('tr-case');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_USER') !== -1) {
                        $rootScope.has_ROLE_USER = true;
                        // $state.go('location-log');
                        $state.go('tr-case');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_VENDOR_ADMIN') !== -1) {
                        $rootScope.has_ROLE_VENDOR_ADMIN = true;
                        $state.go('location-log');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ROLLOUT_SURVEY') !== -1) {
                        $rootScope.has_ROLE_ROLLOUT_SURVEY = true;
                        $state.go('work-flow');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ROLLOUT_ADMIN') !== -1) {
                        $rootScope.has_ROLE_ROLLOUT_ADMIN = true;
                        //$state.go('work-flow');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ROLLOUT_INFRA') !== -1) {
                        $rootScope.has_ROLE_ROLLOUT_INFRA = true;
                        $state.go('work-flow');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_PLAN_SURVEY') !== -1) {
                        $rootScope.has_ROLE_PLAN_SURVEY = true;
                        $state.go('work-order');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_PLAN_INFRA') !== -1) {
                        $rootScope.has_ROLE_PLAN_INFRA = true;
                        $state.go('work-order');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_PLAN_ADMIN') !== -1) {
                        $rootScope.has_ROLE_PLAN_ADMIN = true;
                        //$state.go('work-order');
                    }

                    if (identity) {
                        $rootScope.userName = identity.login;
                        $rootScope.image = identity.userImage;
                    }
                });

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState

                ///////////////////No use with this code ///////////////////
                /*if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }*/
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register() {
            //$uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword() {
            //$uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'de',
            'hi',
            'ja'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('trakeyeApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('trakeyeApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-trakeyeApp-error');
                var entityKey = httpResponse.headers('X-trakeyeApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('trakeyeApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('trakeyeApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-trakeyeApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-trakeyeApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('trakeyeApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
   
   
    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

/*! AdminLTE app.js
 * ================
 * Main JS application file for AdminLTE v2. This file
 * should be included in all pages. It controls some layout
 * options and implements exclusive AdminLTE plugins.
 *
 * @Author  Almsaeed Studio
 * @Support <http://www.almsaeedstudio.com>
 * @Email   <abdullah@almsaeedstudio.com>
 * @version 2.3.6
 * @license MIT <http://opensource.org/licenses/MIT>
 */
function _init() {
    "use strict";
	$("#map_canvas").height($(window).height());
	$(window).resize(function() {
			if ($(window).height() <= 250){
				$("#map_canvas").height($(window).height()+250);
			}
			else{							
				$("#map_canvas").height($(window).height()-262);
			}
		});
 		$(window).trigger('resize');
	
    $.AdminLTE.layout = {
        activate: function() {
            var a = this;
            a.fix(), a.fixSidebar(), $(window, ".wrapper").resize(function() {
                a.fix(), a.fixSidebar()
            })
        },
        fix: function() { /*var a=$(".main-header").outerHeight()+$(".main-footer").outerHeight(),*/
            var a = 102,
                b = $(window).height(),
                c = $(".sidebar").height();
            if ($("body").hasClass("fixed")) $(".content-wrapper, .right-side").css("min-height", b - $(".main-footer").outerHeight());
            else {
                var d;
                b >= c ? ($(".content-wrapper, .right-side").css("min-height", b - a), d = b - a) : ($(".content-wrapper, .right-side").css("min-height", c), d = c);
                var e = $($.AdminLTE.options.controlSidebarOptions.selector);
                "undefined" != typeof e && e.height() > d && $(".content-wrapper, .right-side").css("min-height", e.height())
            }
        },
        fixSidebar: function() {
            return $("body").hasClass("fixed") ? ("undefined" == typeof $.fn.slimScroll && window.console && window.console.error("Error: the fixed layout requires the slimscroll plugin!"), void($.AdminLTE.options.sidebarSlimScroll && "undefined" != typeof $.fn.slimScroll && ($(".sidebar").slimScroll({
                destroy: !0
            }).height("auto"), $(".sidebar").slimscroll({
                height: $(window).height() - $(".main-header").height() + "px",
                color: "rgba(0,0,0,0.2)",
                size: "3px"
            })))) : void("undefined" != typeof $.fn.slimScroll && $(".sidebar").slimScroll({
                destroy: !0
            }).height("auto"))
        }
    }, $.AdminLTE.pushMenu = {
        activate: function(a) {
            var b = $.AdminLTE.options.screenSizes;
            $(document).on("click", a, function(a) {
                a.preventDefault(), $(window).width() > b.sm - 1 ? $("body").hasClass("sidebar-collapse") ? $("body").removeClass("sidebar-collapse").trigger("expanded.pushMenu") : $("body").addClass("sidebar-collapse").trigger("collapsed.pushMenu") : $("body").hasClass("sidebar-open") ? $("body").removeClass("sidebar-open").removeClass("sidebar-collapse").trigger("collapsed.pushMenu") : $("body").addClass("sidebar-open").trigger("expanded.pushMenu")
            }), $(".content-wrapper").click(function() {
                $(window).width() <= b.sm - 1 && $("body").hasClass("sidebar-open") && $("body").removeClass("sidebar-open")
            }), ($.AdminLTE.options.sidebarExpandOnHover || $("body").hasClass("fixed") && $("body").hasClass("sidebar-mini")) && this.expandOnHover()
        },
        expandOnHover: function() {
            var a = this,
                b = $.AdminLTE.options.screenSizes.sm - 1;
            $(".main-sidebar").hover(function() {
                $("body").hasClass("sidebar-mini") && $("body").hasClass("sidebar-collapse") && $(window).width() > b && a.expand()
            }, function() {
                $("body").hasClass("sidebar-mini") && $("body").hasClass("sidebar-expanded-on-hover") && $(window).width() > b && a.collapse()
            })
        },
        expand: function() {
            $("body").removeClass("sidebar-collapse").addClass("sidebar-expanded-on-hover")
        },
        collapse: function() {
            $("body").hasClass("sidebar-expanded-on-hover") && $("body").removeClass("sidebar-expanded-on-hover").addClass("sidebar-collapse")
        }
    }, $.AdminLTE.tree = function(a) {
        var b = this,
            c = $.AdminLTE.options.animationSpeed;
        $(document).off("click", a + " li a").on("click", a + " li a", function(a) {
            var d = $(this),
                e = d.next();
            if (e.is(".treeview-menu") && e.is(":visible") && !$("body").hasClass("sidebar-collapse")) e.slideUp(c, function() {
                d.children('.pull-right-container').children('.rotate').removeClass('down')
                d.children('.pull-right-container').children('.fa-plus').removeClass('fa-minus')
                e.removeClass("menu-open")
                var t = e.children('li').children('a').next()
                t.removeClass("menu-open")
                t.css({'display':'none'});
            }), e.parent("li").removeClass("active");
            else if (e.is(".treeview-menu") && !e.is(":visible")) {
                var f = d.parents("ul").first(),
                    g = f.find("ul:visible").slideUp(c);
                g.removeClass("menu-open");
                var t = e.children('li').children('a').next()
                t.removeClass("menu-open")
                t.css({'display':'none'});
                d.children('.pull-right-container').children('.rotate').removeClass('down')
                d.children('.pull-right-container').children('.fa-plus').removeClass('fa-minus')
                var h = d.parent("li");
                e.slideDown(c, function() {
                    d.children('.pull-right-container').children('.rotate').addClass('down'),d.children('.pull-right-container').children('.fa-plus').addClass('fa-minus'), e.addClass("menu-open"), f.find("li.active").removeClass("active"), h.addClass("active"), b.layout.fix()
                })
            }
            e.is(".treeview-menu") && a.preventDefault()
        })
    }, $.AdminLTE.controlSidebar = {
        activate: function() {
            var a = this,
                b = $.AdminLTE.options.controlSidebarOptions,
                c = $(b.selector),
                d = $(b.toggleBtnSelector);
            d.on("click", function(d) {
                d.preventDefault(), c.hasClass("control-sidebar-open") || $("body").hasClass("control-sidebar-open") ? a.close(c, b.slide) : a.open(c, b.slide)
            });
            var e = $(".control-sidebar-bg");
            a._fix(e), $("body").hasClass("fixed") ? a._fixForFixed(c) : $(".content-wrapper, .right-side").height() < c.height() && a._fixForContent(c)
        },
        open: function(a, b) {
            b ? a.addClass("control-sidebar-open") : $("body").addClass("control-sidebar-open")
        },
        close: function(a, b) {
            b ? a.removeClass("control-sidebar-open") : $("body").removeClass("control-sidebar-open")
        },
        _fix: function(a) {
            var b = this;
            if ($("body").hasClass("layout-boxed")) {
                if (a.css("position", "absolute"), a.height($(".wrapper").height()), b.hasBindedResize) return;
                $(window).resize(function() {
                    b._fix(a)
                }), b.hasBindedResize = !0
            } else a.css({
                position: "fixed",
                height: "auto"
            })
        },
        _fixForFixed: function(a) {
            a.css({
                position: "fixed",
                "max-height": "100%",
                overflow: "auto",
                "padding-bottom": "50px"
            })
        },
        _fixForContent: function(a) {
            $(".content-wrapper, .right-side").css("min-height", a.height())
        }
    }, $.AdminLTE.boxWidget = {
        selectors: $.AdminLTE.options.boxWidgetOptions.boxWidgetSelectors,
        icons: $.AdminLTE.options.boxWidgetOptions.boxWidgetIcons,
        animationSpeed: $.AdminLTE.options.animationSpeed,
        activate: function(a) {
            var b = this;
            a || (a = document), $(a).on("click", b.selectors.collapse, function(a) {
                a.preventDefault(), b.collapse($(this))
            }), $(a).on("click", b.selectors.remove, function(a) {
                a.preventDefault(), b.remove($(this))
            })
        },
        collapse: function(a) {
            var b = this,
                c = a.parents(".box").first(),
                d = c.find("> .box-body, > .box-footer, > form  >.box-body, > form > .box-footer");
            c.hasClass("collapsed-box") ? (a.children(":first").removeClass(b.icons.open).addClass(b.icons.collapse), d.slideDown(b.animationSpeed, function() {
                c.removeClass("collapsed-box")
            })) : (a.children(":first").removeClass(b.icons.collapse).addClass(b.icons.open), d.slideUp(b.animationSpeed, function() {
                c.addClass("collapsed-box")
            }))
        },
        remove: function(a) {
            var b = a.parents(".box").first();
            b.slideUp(this.animationSpeed)
        }
    }
}
if ("undefined" == typeof jQuery) throw new Error("AdminLTE requires jQuery");
$.AdminLTE = {}, $.AdminLTE.options = {
        navbarMenuSlimscroll: !0,
        navbarMenuSlimscrollWidth: "3px",
        navbarMenuHeight: "200px",
        animationSpeed: 500,
        sidebarToggleSelector: "[data-toggle='offcanvas']",
        sidebarPushMenu: !0,
        sidebarSlimScroll: !0,
        sidebarExpandOnHover: !1,
        enableBoxRefresh: !0,
        enableBSToppltip: !0,
        BSTooltipSelector: "[data-toggle='tooltip']",
        enableFastclick: !1,
        enableControlSidebar: !0,
        controlSidebarOptions: {
            toggleBtnSelector: "[data-toggle='control-sidebar']",
            selector: ".control-sidebar",
            slide: !0
        },
        enableBoxWidget: !0,
        boxWidgetOptions: {
            boxWidgetIcons: {
                collapse: "fa-minus",
                open: "fa-plus",
                remove: "fa-times"
            },
            boxWidgetSelectors: {
                remove: '[data-widget="remove"]',
                collapse: '[data-widget="collapse"]'
            }
        },
        directChat: {
            enable: !0,
            contactToggleSelector: '[data-widget="chat-pane-toggle"]'
        },
        colors: {
            lightBlue: "#3c8dbc",
            red: "#f56954",
            green: "#00a65a",
            aqua: "#00c0ef",
            yellow: "#f39c12",
            blue: "#0073b7",
            navy: "#001F3F",
            teal: "#39CCCC",
            olive: "#3D9970",
            lime: "#01FF70",
            orange: "#FF851B",
            fuchsia: "#F012BE",
            purple: "#8E24AA",
            maroon: "#D81B60",
            black: "#222222",
            gray: "#d2d6de"
        },
        screenSizes: {
            xs: 480,
            sm: 768,
            md: 992,
            lg: 1200
        }
    }, $(function() {
        "use strict";
        $("body").removeClass("hold-transition"), "undefined" != typeof AdminLTEOptions && $.extend(!0, $.AdminLTE.options, AdminLTEOptions);
        var a = $.AdminLTE.options;
        _init(), $.AdminLTE.layout.activate(), $.AdminLTE.tree(".sidebar"), a.enableControlSidebar && $.AdminLTE.controlSidebar.activate(), a.navbarMenuSlimscroll && "undefined" != typeof $.fn.slimscroll && $(".navbar .menu").slimscroll({
            height: a.navbarMenuHeight,
            alwaysVisible: !1,
            size: a.navbarMenuSlimscrollWidth
        }).css("width", "100%"), a.sidebarPushMenu && $.AdminLTE.pushMenu.activate(a.sidebarToggleSelector), a.enableBSToppltip && $("body").tooltip({
            selector: a.BSTooltipSelector
        }), a.enableBoxWidget && $.AdminLTE.boxWidget.activate(), a.enableFastclick && "undefined" != typeof FastClick && FastClick.attach(document.body), a.directChat.enable && $(document).on("click", a.directChat.contactToggleSelector, function() {
            var a = $(this).parents(".direct-chat").first();
            a.toggleClass("direct-chat-contacts-open")
        }), $('.btn-group[data-toggle="btn-toggle"]').each(function() {
            var a = $(this);
            $(this).find(".btn").on("click", function(b) {
                a.find(".btn.active").removeClass("active"), $(this).addClass("active"), b.preventDefault()
            })
        })
    }),
    function(a) {
        "use strict";
        a.fn.boxRefresh = function(b) {
            function c(a) {
                a.append(f), e.onLoadStart.call(a)
            }

            function d(a) {
                a.find(f).remove(), e.onLoadDone.call(a)
            }
            var e = a.extend({
                    trigger: ".refresh-btn",
                    source: "",
                    onLoadStart: function(a) {
                        return a
                    },
                    onLoadDone: function(a) {
                        return a
                    }
                }, b),
                f = a('<div class="overlay"><div class="fa fa-refresh fa-spin"></div></div>');
            return this.each(function() {
                if ("" === e.source) return void(window.console && window.console.log("Please specify a source first - boxRefresh()"));
                var b = a(this),
                    f = b.find(e.trigger).first();
                f.on("click", function(a) {
                    a.preventDefault(), c(b), b.find(".box-body").load(e.source, function() {
                        d(b)
                    })
                })
            })
        }
    }(jQuery),
    function(a) {
        "use strict";
        a.fn.activateBox = function() {
            a.AdminLTE.boxWidget.activate(this)
        }, a.fn.toggleBox = function() {
            var b = a(a.AdminLTE.boxWidget.selectors.collapse, this);
            a.AdminLTE.boxWidget.collapse(b)
        }, a.fn.removeBox = function() {
            var b = a(a.AdminLTE.boxWidget.selectors.remove, this);
            a.AdminLTE.boxWidget.remove(b)
        }
    }(jQuery),
    function(a) {
        "use strict";
        a.fn.todolist = function(b) {
            var c = a.extend({
                onCheck: function(a) {
                    return a
                },
                onUncheck: function(a) {
                    return a
                }
            }, b);
            return this.each(function() {
                "undefined" != typeof a.fn.iCheck ? (a("input", this).on("ifChecked", function() {
                    var b = a(this).parents("li").first();
                    b.toggleClass("done"), c.onCheck.call(b)
                }), a("input", this).on("ifUnchecked", function() {
                    var b = a(this).parents("li").first();
                    b.toggleClass("done"), c.onUncheck.call(b)
                })) : a("input", this).on("change", function() {
                    var b = a(this).parents("li").first();
                    b.toggleClass("done"), a("input", b).is(":checked") ? c.onCheck.call(b) : c.onUncheck.call(b)
                })
            })
        }
    }(jQuery);
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('trakeyeApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('VehicleManagementDialogController', VehicleManagementDialogController);

    VehicleManagementDialogController.$inject = ['$rootScope', '$scope', '$state', 'entity', 'Vehicle', 'JhiLanguageService', 'Principal', 'ReportingNeUsers'
    ];

    function VehicleManagementDialogController($rootScope, $scope, $state, entity, Vehicle, JhiLanguageService, Principal, ReportingNeUsers) {
        $scope.IMEI_REGEXP = /^[0-9]+$/;
        var vm = this;

        vm.languages = null;
        vm.save = save;
        vm.vehicle = entity;
        vm.multiUser = [];
        var selectedUsers = [];
        vm.selectedUserId = [];

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        if(vm.vehicle.attachedTo != null){
            selectedUsers = vm.vehicle.attachedTo;
        }

        ReportingNeUsers.getAll(function (response) {
            response.forEach(function (user) {
                // if (user.authorities.includes("ROLE_NETWORK_ENGINEER")) {
                    if (selectedUsers == user.id) {
                        vm.multiUser.push({ login: user.login, id: user.id, ticked: true });
                    } else {
                        vm.multiUser.push({ login: user.login, id: user.id, ticked: false });
                    }
                // }
            });
        });

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go('vehicle-management');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.selectedUserId.forEach(function(user){
                vm.vehicle.attachedTo = user.id;
            });
            vm.isSaving = true;
            if (vm.vehicle.id !== null) {
                Vehicle.update(vm.vehicle, onSaveSuccess, onSaveError);
            } else {
                Vehicle.save(vm.vehicle, onSaveSuccess, onSaveError);
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('VehicleManagementDetailController', VehicleManagementDetailController);

    VehicleManagementDetailController.$inject = ['$stateParams', 'Vehicle'];

    function VehicleManagementDetailController($stateParams, Vehicle) {
        var vm = this;

        vm.load = load;
        vm.vehicle = {};

        vm.load($stateParams.id);

        function load(id) {
            Vehicle.get({ id: id }, function (result) {
                vm.vehicle = result;
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('vehicle-management', {
            parent: 'admin',
            url: '/vehicle-management',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                pageTitle: 'vehicleManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/vehicle-management/vehicle-management.html',
                    controller: 'VehicleManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicle-management');
                    return $translate.refresh();
                }]

            }
        })

            .state('vehicle-management-detail', {
                parent: 'admin',
                url: '/vehicles/:id',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'vehicle-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/vehicle-management/vehicle-management-detail.html',
                        controller: 'VehicleManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('vehicle-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('vehicle-management.new', {
                parent: 'vehicle-management',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/vehicle-management/vehicle-management-dialog.html',
                        controller: 'VehicleManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            "id": null,
                            "status": null,
                            "vehicleType": null,
                            "licensePlate": null,
                            "gpsimei": null,
                            "createdDate": null,
                            "lastModifiedBy": null,
                            "lastModifiedDate": null
                        };
                    }
                }

            })

            .state('vehicle-management.edit', {
                parent: 'vehicle-management',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/vehicle-management/vehicle-management-dialog.html',
                        controller: 'VehicleManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('vehicle-management');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Vehicle', function ($stateParams, Vehicle) {
                        return Vehicle.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('Vehicle', Vehicle);

    Vehicle.$inject = ['$resource'];

    function Vehicle($resource) {
        var service = $resource('api/vehicles/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });

        return service;
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('VehicleValueSearch', VehicleValueSearch);

	VehicleValueSearch.$inject = ['$resource'];

	function VehicleValueSearch($resource) {
		var service = $resource('/api/vehicles/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('VehicleManagementController', VehicleManagementController);

    VehicleManagementController.$inject = ['$scope', 'Principal', 'Vehicle', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'UserValueSearch', 'UsersStatusService', '$stateParams', 'VehicleValueSearch', 'UsersHierarchy', 'UserAccount', 'GeofenceIDs', 'UserGeofences'];

    function VehicleManagementController($scope, Principal, Vehicle, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, UserValueSearch, UsersStatusService, $stateParams, VehicleValueSearch, UsersHierarchy, UserAccount, GeofenceIDs, UserGeofences) {
        var vm = this;
        $scope.search = pagingParams.search;
        vm.authorities = ['ROLE_USER', 'ROLE_USER_ADMIN', 'ROLE_VENDOR_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.vehicles = [];
        vm.vehiclesList = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;

            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });


        if ($scope.search === null || $scope.search === "" || angular.isUndefined($scope.search)) {
            loadAll();
        } else {
            filterSearch();
        }

        function filterSearch() {

            if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {

                VehicleValueSearch.query({
                    search: $scope.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);

            } else {
                loadAll();
            }
        }



        function loadAll() {

            if ($stateParams.status == undefined) {
                Vehicle.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
        }

        function onSuccess(data, headers) {
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.vehicles = data;

        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.vehicle = {
                "id": null,
                "status": null,
                "vehicleType": null,
                "licensePlate": null,
                "gpsimei": null,
                "createdDate": null,
                "lastModifiedBy": null,
                "lastModifiedDate": null
            };
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                // result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search,
                status: pagingParams.status
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$rootScope', '$scope', '$stateParams', '$state', 'entity', 'User', 'JhiLanguageService', 'UserGroupIDs', 'Geofence', 'TrakeyeType', 'AllTrakeyeTypes', 'GeofenceMasterMiniIDs',
        'UserIDs', 'Principal', 'ReportingUsers', 'Vendors','Configs','UserAccount'
    ];

    function UserManagementDialogController($rootScope, $scope, $stateParams, $state, entity, User, JhiLanguageService, UserGroupIDs, Geofence, TrakeyeType, AllTrakeyeTypes, GeofenceMasterMiniIDs, UserIDs, Principal, ReportingUsers, Vendors, Configs,UserAccount) {
        $scope.EMAIL_REGEXP = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
        $scope.PHONE_REGEXP = /^[0-9]+$/;
        $scope.IMEI_REGEXP = /^[0-9]+$/;
        $scope.IMAGE_EXT_REGEXP = /^(.*?)\.(jpg||jpeg||png)$/;
        var vm = this;

        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.decodeImage = decodeImage;
        $scope.hasDeviceInfo = false;

        if(vm.user.hasDeviceInfo){
            $scope.hasDeviceInfo = true;
        }
        /* var userAdminAuthorities = ['ROLE_USER_ADMIN', 'ROLE_USER', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER',
            'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_VENDOR'
        ];
        var hodAuthorities = ['ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'];
        var cityManagerAuthorities = ['ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'];
        var assistantManagerAuthorities = ['ROLE_TEAM_LEADER', 'ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'];
        var teamLeaderAuthorities = ['ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'];  */

        vm.navigateGeofence = navigateGeofence
        vm.navigateGroupfromUserMng = navigateGroupfromUserMng;
        vm.navigateFiberifyTypefromGroup = navigateFiberifyTypefromGroup;

        $scope.allimages = false;
        $(":file").filestyle({
            buttonBefore: true
        });
        $(":file").filestyle('buttonText', 'Browse File');

        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;

        };

        $("#userImage").change(function () {
            var filesSelected = document.getElementById("userImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();

                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.user.userImage = test;
                }
                fileReader.readAsBinaryString(filesSelected[i]);
            }

        });

        var entity_old = angular.copy(vm.user)
        Principal.identity().then(function (identity) {
            /*
             * if(identity.authorities &&
             * identity.authorities.indexOf('ROLE_SUPER_ADMIN') !==- 1){
             * vm.authorities = ['ROLE_USER_ADMIN'];
             * 
             * }else if(identity.authorities &&
             * identity.authorities.indexOf('ROLE_USER_ADMIN') !==- 1){
             */
            /* vm.authorities = [
                //'ROLE_USER', 
                'ROLE_USER_ADMIN',
                //'ROLE_VENDOR_ADMIN',
                'ROLE_USER',
                'ROLE_CITY_MANAGER',
                'ROLE_CITY_PLANNER',
                'ROLE_ASSISTANT_MANAGER',
                'ROLE_TEAM_LEADER',
                'ROLE_NETWORK_ENGINEER',
                'ROLE_FRT',
                'ROLE_PATROLLER'
            ]; */

            /* if ($rootScope.has_ROLE_USER_ADMIN) {
                vm.authorities = userAdminAuthorities;
            } else if ($rootScope.has_ROLE_USER) {
                vm.authorities = hodAuthorities;
            } else if ($rootScope.has_ROLE_CITY_MANAGER || $rootScope.has_ROLE_CITY_PLANNER) {
                vm.authorities = cityManagerAuthorities;
            } else if ($rootScope.has_ROLE_ASSISTANT_MANAGER) {
                vm.authorities = assistantManagerAuthorities;
            } else if ($rootScope.has_ROLE_TEAM_LEADER) {
                vm.authorities = teamLeaderAuthorities;
            } */

            Configs.get("Roles",function(response){
                vm.authorities = response
            })


            vm.selectattributes = selectedTrakeyeTypeAttributes;
            vm.geofences = loadAllGeofences(); // Geofence.query();
            vm.trakeyeTypes = loadAllTrakeyeTypes(); // TrakeyeType.query();

            // }
            if (vm.user.id == null) {
                vm.user.langKey = 'en';
                // vm.user.authorities=vm.authorities;
                vm.user.fromTime = 8;
                vm.user.toTime = 20;

            }

        });

        function loadAllTrakeyeTypes() {
            AllTrakeyeTypes.getAll(function (response) {
                vm.trakeyeTypes = response;
            });

        }

        function loadAllGeofences() {

            vm.multiGeofence = [];
            vm.multiGroup = [];
            var selectedGeofence = [];
            var selectedGroup = [];
            vm.multiUser = [];
            vm.multiVendor = [];
            var selectedUsers = [];
            var selectedVendors = [];

            if (vm.user.id != null) {
                vm.user.geofences.forEach(function (geofence) {
                    selectedGeofence.push(geofence);
                });

                vm.user.groups.forEach(function (group) {
                    selectedGroup.push(group.id);
                });

                vm.user.ownedBy.forEach(function (user) {
                    selectedUsers.push(user.id);
                });

                if (vm.user.vendors != null) {
                    vm.user.vendors.forEach(function (user) {
                        selectedVendors.push(user.id);
                    });
                }

                if (selectedUsers.length === 0) {
                    selectedUsers.push(vm.user.id);
                }

            } else {

                Principal.identity().then(function (identity) {
                    selectedUsers.push(identity.id);
                });
            }

            GeofenceMasterMiniIDs.getAll(function (response) {
                response.forEach(function (geofence) {
                    // var zone = "MINI";

                    // if (geofence.zone == true) {
                    //     zone = "MASTER";
                    // }

                    if (selectedGeofence.indexOf(geofence.id) !== -1) {
                        vm.multiGeofence.push({ name: geofence.name, id: geofence.id, nameZone: geofence.name + " - " + geofence.geofenceType, ticked: true });
                    } else {
                        vm.multiGeofence.push({ name: geofence.name, id: geofence.id, nameZone: geofence.name + " - " + geofence.geofenceType, ticked: false });
                    }
                });
            });

            UserGroupIDs.getAll(function (response) {
                response.forEach(function (group) {
                    if (selectedGroup.indexOf(group.id) !== -1) {
                        vm.multiGroup.push({ name: group.name, id: group.id, ticked: true });
                    } else {
                        vm.multiGroup.push({ name: group.name, id: group.id, ticked: false });
                    }
                });

                if (selectedGroup.length === 0) {
                    var tempGroups = [];
                    vm.multiGroup.forEach(function (groupVal) {
                        if (groupVal.name === "Default Group") {
                            groupVal.ticked = true;
                        }
                        tempGroups.push(groupVal);
                    });
                    vm.multiGroup = tempGroups;
                }
            });

            // UserIDs.getAdminAll(function(response) {
            //     response.forEach(function(user) {
            //         if (selectedUsers.indexOf(user.id) !== -1) {
            //             vm.multiUser.push({ login: user.login, id: user.id, ticked: true });
            //         } else {
            //             vm.multiUser.push({ login: user.login, id: user.id, ticked: false });
            //         }
            //     });
            // });
            ReportingUsers.getAll(function (response) {
                response.forEach(function (user) {
                    if (selectedUsers.indexOf(user.id) !== -1) {
                        vm.multiUser.push({ login: user.login, id: user.id, ticked: true });
                    } else {
                        vm.multiUser.push({ login: user.login, id: user.id, ticked: false });
                    }
                });
            });

            Vendors.getAll(function (response) {
                response.forEach(function (user) {
                    if (selectedVendors.indexOf(user.id) !== -1) {
                        vm.multiVendor.push({ login: user.login, id: user.id, ticked: true });
                    } else {
                        vm.multiVendor.push({ login: user.login, id: user.id, ticked: false });
                    }
                });
            });
        }

        function selectedTrakeyeTypeAttributes() {
            if (vm.user.trakeyeType) {
                if (entity_old.trakeyeType && vm.user.trakeyeType.id === entity_old.trakeyeType.id) {
                    vm.user.trakeyeTypeAttributeValues = [];
                    vm.user.trakeyeTypeAttributeValues = entity_old.trakeyeTypeAttributeValues;
                } else {
                    vm.user.trakeyeTypeAttributeValues = [];
                    $.each(vm.user.trakeyeType.trakeyeTypeAttribute, function (key, value) {
                        vm.user.trakeyeTypeAttributeValues.push({
                            trakeyeTypeAttribute: vm.user.trakeyeType.trakeyeTypeAttribute[key]
                        });
                    });
                }
            }

        }

        vm.selectfrom = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go('user-management');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {

            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function decodeImage(img) {
            return window.atob(img);
        }

        function navigateGeofence() {
            sessionStorage.setItem("prevPage", "user-management.new");
            $state.go('geofence.new');
        }

        function navigateGroupfromUserMng() {
            sessionStorage.setItem("prevPage", "user-management.new");
            $state.go('group.new');
        }

        function navigateFiberifyTypefromGroup() {
            sessionStorage.setItem("prevPage", "user-management.new");
            $state.go('trakeye-type.new');
        }


        vm.reportsEnable = true
            vm.deviceInfo = true
            Configs.get("InputFields", function (response) {
                if (response.length > 0) {
                    response.forEach(function(val){
                        if(val.configKey == "DeviceInfo" && val.configValue == "True" ){
                            vm.deviceInfo = false
                        }

                        if(val.configKey == "ReportsTo" && val.configValue == "True"){
                            vm.reportsEnable = false
                        }
                    })
                }
            });
        
    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};
       
        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'last_modified_date,desc',
                    squash: true
                },
                search: null,
                listgeofenceid: null,
                columnNames: null,
                columnList: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        listgeofenceid: $stateParams.listgeofenceid,
                        columnNames: $stateParams.columnNames,
                        columnList: $stateParams.columnList
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }
        })

            .state('user-management.status', {
                parent: 'user-management',
                url: '/user-management/{status}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'userManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            status: $stateParams.status,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]

                }
            })

            .state('user-management-detail', {
                parent: 'admin',
                url: '/user/:login',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'user-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            }).state('user-management.new', {
                parent: 'user-management',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            login: null,
                            firstName: null,
                            lastName: null,
                            email: null,
                            phone: null,
                            imsi: null,
                            activated: true,
                            langKey: null,
                            createdBy: null,
                            createdDate: null,
                            lastModifiedBy: null,
                            lastModifiedDate: null,
                            resetDate: null,
                            resetKey: null,
                            authorities: null,
                            geofences: null
                        };
                    }
                }

            })

            .state('user-management.edit', {
                parent: 'user-management',
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'User', function ($stateParams, User) {
                        return User.get({
                            login: $stateParams.login
                        }).$promise;
                    }],
                }

            }).state('user-management.delete', {
                parent: 'user-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'sm',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({
                                    login: $stateParams.login
                                });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {
                            reload: true
                        });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ReportingUsers', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/reporting-users').then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ReportingNeUsers', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/reporting-ne-users').then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('Vendors', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/vendors').then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('NearbyUser', NearbyUser);

    NearbyUser.$inject = ['$resource'];

    function NearbyUser($resource) {
        var resourceUrl = 'api/nearby-users/:latitude/:longitude/:dis';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("UserManagementController", UserManagementController);

    UserManagementController.$inject = [
        "$rootScope",
        "$scope",
        "$ngConfirm",
        "$filter",
        "DEFAULT_LATITUDE",
        "DEFAULT_LONGITUDE",
        "Principal",
        "User",
        "ReportingUsers",
        "ParseLinks",
        "AlertService",
        "$state",
        "pagingParams",
        "paginationConstants",
        "JhiLanguageService",
        "UserValueSearch",
        "UsersStatusService",
        "$stateParams",
        "UserStatusSearch",
        "UsersHierarchy",
        "UserAccount",
        "GeofenceMasterMiniIDs",
        "UserGeofences",
        "AssetGroupES",
        "AssetByID",
        "NearbyUser",
        "MasterGeofences",
        "UserValueGeofenceSearch",
        "UsersByGeo",
        "DownloadUsers",
    ];

    function UserManagementController(
        $rootScope,
        $scope,
        $ngConfirm,
        $filter,
        DEFAULT_LATITUDE,
        DEFAULT_LONGITUDE,
        Principal,
        User,
        ReportingUsers,
        ParseLinks,
        AlertService,
        $state,
        pagingParams,
        paginationConstants,
        JhiLanguageService,
        UserValueSearch,
        UsersStatusService,
        $stateParams,
        UserStatusSearch,
        UsersHierarchy,
        UserAccount,
        GeofenceMasterMiniIDs,
        UserGeofences,
        AssetGroupES,
        AssetByID,
        NearbyUser,
        MasterGeofences,
        UserValueGeofenceSearch,
        UsersByGeo,
        DownloadUsers
    ) {
        var vm = this;
        $scope.search = pagingParams.search;
        vm.authorities = ["ROLE_USER", "ROLE_USER_ADMIN", "ROLE_VENDOR_ADMIN"];
        vm.currentAccount = null;
        vm.languages = null;
        vm.setActive = setActive;
        vm.loadAll = loadAll;
        vm.users = [];
        vm.usersList = [];
        vm.page = 1;
        vm.totalItems = null;
        var userMarkers = [];
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.downloadImage = downloadImage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.getLocalhour = getLocalhour;
        vm.filterSearch = filterSearch;
        vm.usersTable = usersTable;
        vm.selectedListGeofenceId = parseInt(pagingParams.listgeofenceid);
        vm.saveListFilter = saveListFilter;
        vm.filterAssetsOnListView = filterAssetsOnListView;
        vm.closeListFilterModal = closeListFilterModal;
        vm.downloadUserManagementUserList = downloadUserManagementUserList;
        vm.downloadUsers = downloadUsers;
        vm.filterAssetsOnUserManagementMapView = filterAssetsOnUserManagementMapView;
        vm.closeUserManagementMapFilterModal = closeUserManagementMapFilterModal;
        vm.saveUserManagementGeofenceFilter = saveUserManagementGeofenceFilter;
        vm.masterGeofences = [];
        // vm.loadAll();
        $scope.tab = 1;
        var svgUH = null;
        var svgUHwidth = null;
        var svgUHheigth = null;

        var activeInfoWindow = [];
        var prevSelectedCircle = null;
        vm.columnList = pagingParams.columnList;

        if(vm.columnList == undefined){
            vm.columnList = [{name:"login", ticked:true}, 
            {name:"email", ticked:true}, 
            {name:"phone", ticked:true}, 
            {name:"applicationVersion", ticked:true}, 
            {name:"gpsimei", ticked:true}];
        }
        

        vm.selectedColumnList = pagingParams.columnNames;

        var noDataText = null;
        var markers = [];
        var polylines = [];
        vm.userGeofences = [];
        var openedInfoWindow = null;

        var locations = {};
        var latlng;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        $scope.geofencelabel = {
            list : {
                search          : "Search",
                nothingSelected : "City"      
            },
            map : {
                    search          : "Search",
                    nothingSelected : "Geofence"  
            }
        }

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;

            if ($scope.tab == 1) {
                filterAssetsOnListView()
                /* vm.masterGeofences = [];
                vm.masterGeofences.push({id:0,name:"All"});
                if(isNaN(vm.selectedListGeofenceId)){
                    vm.selectedListGeofenceId = 0;
                }
                
                MasterGeofences.getAll(function (response) {
                    response.forEach(function(geofence){
                        vm.masterGeofences.push(geofence);
                    });
                }); */
                filterSearch();
            } else if ($scope.tab == 2) {
                UsersHierarchy.getUsersHierarchy(null, function (response) {
                    u_data = response;
                    orgChart.initTree({
                        id: "#body",
                        data: response,
                        modus: "diagonal",
                        loadFunc: loadChilds,
                    });
                });
            } else {
                filterAssetsOnUserManagementMapView()
                vm.mapAssets = [];
                var latlngs = new google.maps.LatLng(
                    DEFAULT_LATITUDE.value,
                    DEFAULT_LONGITUDE.value
                );
                /* var myOptions = {
                    zoom: 17,
                    center: latlngs,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */
                var map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(17, latlngs)
                );
                geoLocation(map);
                //getGroupUserManagementAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
            }
        };

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });

        if ($scope.tab == 1) {
            UserAccount.get(function (data) {
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }
                });
                if (isAdmin) {
                    vm.adminFilter = true;
                } else {
                    vm.adminFilter = false;
                }
            });
            filterAssetsOnListView()
        }

        function filterAssetsOnListView() {
            var tempGeofenceId = $state.params.listgeofenceid
            vm.masterGeofences = [];
            vm.masterGeofences.push({ id: 0, name: "All" });
            if (isNaN(vm.selectedListGeofenceId)) {
                vm.selectedListGeofenceId = 0;
            }
            MasterGeofences.getAll(function (response) {
                response.forEach(function (geofence) {
                    geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                    vm.masterGeofences.push(geofence);
                });
            });
            //$("#listFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
        }

        function closeListFilterModal() {
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
            vm.selectedListGeofenceId = vm.PrevselectedListGeofenceId;
        }

        function saveListFilter() {
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
            filterSearch();
        }

        function usersTable(actualElement, successFunction) {
            UsersHierarchy.getUsersHierarchy(
                actualElement.id,
                function (response) {
                    vm.usersData = response.children;
                }
            );
        }

        function getLocalhour(hour) {
            var d = new Date();
            d.setUTCHours(hour);
            return d.getHours();
        }

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        // ReportingUsers.getAll(function(response) {
        //     vm.usersReporting = response;
        // });

        if (
            $scope.search === null ||
            $scope.search === "" ||
            angular.isUndefined($scope.search)
        ) {
            loadAll();
        } else {
            filterSearch();
        }

        $scope.geofenceListView = function(){
            if($scope.tab == 1){
                vm.selectedListGeofenceId = vm.selectedGeofenceNearby[0].id
                saveListFilter()
            }else if($scope.tab == 3){
                vm.selectedGeofenceId = vm.selectedGeofenceNearby[0].id
                saveUserManagementGeofenceFilter()
            }
            
        }
        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                if ($stateParams.status == undefined) {
                    if (
                        isNaN(vm.selectedListGeofenceId) ||
                        vm.selectedListGeofenceId == 0
                    ) {
                        UserValueSearch.query(
                            {
                                search: $scope.search,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                            },
                            onSuccess,
                            onError
                        );
                    } else {
                        var columnList = [];
                        vm.selectedColumnList.forEach(function(value){
                            columnList.push(value.name);
                        });

                        UserValueGeofenceSearch.query(
                            {
                                search: $scope.search,
                                geofenceId: vm.selectedListGeofenceId,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                columnNames: columnList
                            },
                            onSuccess,
                            onError
                        );
                    }
                } else {
                    UserStatusSearch.query(
                        {
                            status: $stateParams.status,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {

            if ($stateParams.status == undefined) {
                if (
                    isNaN(vm.selectedListGeofenceId) ||
                    vm.selectedListGeofenceId == 0
                ) {
                    User.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    UsersByGeo.query(
                        {
                            geofenceId: vm.selectedListGeofenceId,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            } else {
                UsersStatusService.query(
                    {
                        status: $stateParams.status,
                        geofenceId : $stateParams.geofenceId,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
            }
        }

        function onSuccess(data, headers) {
            // hide anonymous user from user management: it's a required user
            // for Spring Security
            for (var i in data) {
                if (data[i]["login"] === "anonymoususer") {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers("link"));
            vm.totalItems = headers("X-Total-Count");
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.user = {
                id: null,
                login: null,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                imsi: null,
                activated: null,
                langKey: null,
                createdBy: null,
                createdDate: null,
                lastModifiedBy: null,
                lastModifiedDate: null,
                resetDate: null,
                resetKey: null,
                authorities: null,
            };
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                status: pagingParams.status,
                geofenceId : pagingParams.geofenceId,
                listgeofenceid: vm.selectedListGeofenceId,
                columnNames: vm.selectedColumnList,
                columnList: vm.columnList
            });
        }

        function filterAssetsOnUserManagementMapView() {
            vm.userGeofences = [];
            if (vm.adminFilter) {
                GeofenceMasterMiniIDs.getAll(function (response) {
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        vm.userGeofences.push(geofence);
                        if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        }
                    });
                    // filterSearch();
                });
            } else {
                UserGeofences.getAll(function (response) {
                    response.forEach(function (geofence) {
                        vm.userGeofences.push(geofence);
                        if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        }
                    });
                    //filterSearch();
                });
            }
            //$("#mapFilterUserManagementModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            //vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
        }

        function closeUserManagementMapFilterModal() {
            $("#mapFilterUserManagementModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterUserManagementModal").hide();
            vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
        }

        function saveUserManagementGeofenceFilter() {
            vm.mapAssets = [];
            // var myOptions = {
            //     zoom: 17,
            //     center: latlngs,
            //     mapTypeId: google.maps.MapTypeId.ROADMAP
            // };
            // var map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
            getGroupUserManagementAssetsFromES(
                vm.selectedGeofenceId,
                null,
                vm.mapAssets
            );
            //vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
/* 
            $("#mapFilterUserManagementModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterUserManagementModal").hide(); */
        }

        function getGroupUserManagementAssetsFromES(
            geofenceIdVal,
            lastAssetId,
            mapAssetLists
        ) {
            AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;

                    vm.mapAssets.push(tmpAsset);
                });
                drawLatestAssetsOnMap(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupUserManagementAssetsFromES(
                        geofenceIdVal,
                        data.lastId,
                        vm.mapAssets
                    );
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].longitude,
                            };
                            locations.map.setCenter(assetLatLng);
                        });
                    }
                }
                // filterGeofenceSearchMap();
            });
        }

        function drawLatestAssetsOnMap(response) {
            if (response) {
                initializeGeofenceAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                            value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    drawFixedGeofenceAsset(value1, false);
                                } else {
                                    drawFixedGeofenceAsset(value, false);
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                drawPolyline(value, locations.map);
                            }
                        });
                    });
                });
            }
        }

        function initializeGeofenceAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            lngVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            // callback(new google.maps.LatLng("12.9716", "77.5946"));
                            callback(
                                new google.maps.LatLng(
                                    DEFAULT_LATITUDE.value,
                                    DEFAULT_LONGITUDE.value
                                )
                            );
                        }
                    );
                } else {
                    callback(
                        new google.maps.LatLng(
                            DEFAULT_LATITUDE.value,
                            DEFAULT_LONGITUDE.value
                        )
                    );
                }
            }
        }

        $("#searchUsersOnMap").change(function () {
            var userSelected = JSON.parse($("#searchUsersOnMap").val());
            var userLatLng = {
                lat: userSelected.latitude,
                lng: userSelected.longitude,
            };
            locations.map.setCenter(userLatLng);
        });

        function drawLatestlocations(response) {
            vm.usersList = response;
            for (var i = 0; i < userMarkers.length; i++) {
                userMarkers[i].setMap(null);
            }
            userMarkers = [];
            var markers = [
                {
                    Lat: "0.0",
                    Lng: "0.0",
                    name: "default",
                },
            ];

            $.each(response, function (index, value) {
                var infoWindow2 = new google.maps.InfoWindow();
                var imgbg = document.createElement("img");
                imgbg.className = "marker_back_image";

                if (value.reportingStatus == true) {
                    if (value.status == "ACTIVE") {
                        imgbg.src = "content/images/greenmarker.png";
                    } else if (value.status == "INACTIVE") {
                        imgbg.src = "content/images/redmarker.png";
                    } else if (value.status == "IDLE") {
                        imgbg.src = "content/images/yellowmarker.png";
                    } else if (value.status == "Off duty user") {
                        imgbg.src = "content/images/marker_offduty1.png";
                    }
                } else {
                    imgbg.src = "content/images/marker_active_case.png";
                }

                if (value.address == "SOS") {
                    imgbg.src = "content/images/alert.png";
                }

                if ($scope.trCases != undefined && $scope.trCases.length > 0) {
                    $.each($scope.trCases, function (index, value) {
                        var infoWindow = new google.maps.InfoWindow();
                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });
                        var infoWindow2 = new google.maps.InfoWindow();
                        if (value.priority == "LOW") {
                            startMarker.setIcon(
                                "content/images/Pointers-L4.png"
                            );
                        } else if (value.priority == "MEDIUM") {
                            startMarker.setIcon(
                                "content/images/Pointers-M4.png"
                            );
                        } else if (value.priority == "HIGH") {
                            startMarker.setIcon(
                                "content/images/Pointers-H4.png"
                            );
                        } else if (value.priority == "CRITICAL") {
                            startMarker.setIcon(
                                "content/images/Pointer-C4.png"
                            );
                        }
                        var span =
                            '<a userId="' +
                            value.geofenceName +
                            '" class="userpath" >Load travelled path</a>';
                        startMarker.content =
                            '<div class="infoWindowContent"><b>Case Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b>Address :</b> " +
                            value.address +
                            "</div>";

                        $compile(startMarker.content)($scope);

                        google.maps.event.addListener(
                            startMarker,
                            "mouseover",
                            function () {
                                infoWindow.setContent(
                                    '<div class="infoWindowhead">' +
                                        startMarker.title +
                                        "</div>" +
                                        startMarker.content
                                );
                                infoWindow.open(locations.map, startMarker);
                            }
                        );
                        // on mouseout
                        google.maps.event.addListener(
                            startMarker,
                            "mouseout",
                            function () {
                                infoWindow.close();
                            }
                        );

                        var activeInfoWindow;
                        infoWindow2.setContent(
                            '<div class="infoWindowhead">' +
                                startMarker.title +
                                "</div>" +
                                startMarker.content
                        );
                        userMarkers.push(startMarker);
                    });
                }

                function customMarker() {
                    this.latlng = new google.maps.LatLng(
                        value.latitude,
                        value.longitude
                    );
                    this.setMap(locations.map);
                    this.title = value.login;
                    this.icon = imgbg;
                }
                var userContent = document.createElement("div"),
                    button;

                if (value.userImage != null) {
                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        value.login +
                        '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="data:image/png;base64,' +
                        value.userImage +
                        '" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>' +
                        value.address +
                        "</p><p><b>Phone</b> : " +
                        value.phone;
                    button = userContent.appendChild(
                        document.createElement("input")
                    );
                    button.type = "button";
                    button.value = "Load travelled path";
                    button.className = "button";

                    google.maps.event.addDomListener(
                        button,
                        "click",
                        function () {
                            markerUserName = value.login;
                            userPath(value.userid);
                        }
                    );
                } else {
                    userContent.innerHTML =
                        '<div class="infoWindowhead"><span style="margin-left:10px;"><b>' +
                        value.login +
                        '</b></span></div><div style="width: 300px; height: 120px;" class="infoWindowContent"><div class="rows"><div class="col-md-7"><p>' +
                        value.address +
                        "</p><p><b>Phone</b> : " +
                        value.phone +
                        "</p><b>Latitude</b> : " +
                        value.latitude +
                        "</p> <p> <b>Longitude</b> : " +
                        value.longitude +
                        '</p> </div></div><div class="col-md-5"> <img src="content/images/userimg.gif" style="width: 80px; height: 90px; margin-top:26px;"></div></div>';

                    button = userContent.appendChild(
                        document.createElement("input")
                    );
                    button.type = "button";
                    button.value = "Load travelled path";
                    button.className = "button"; // set the CSS class

                    google.maps.event.addDomListener(
                        button,
                        "click",
                        function () {
                            markerUserName = value.login;
                            userPath(value.userid);
                        }
                    );
                }

                function userPath(id) {
                    var ele = document.getElementById("userPathModal");
                    $(ele).modal("show");
                    vm.drawUserPath(id);
                    var cleratodatefromdate = vm.today();
                    // cleratodatefromdate.remove();
                }
                var infowindowPopup = new google.maps.InfoWindow({
                    content: userContent,
                    pixelOffset: new google.maps.Size(0, -50),
                });

                customMarker.prototype = new google.maps.OverlayView();

                customMarker.prototype.draw = function () {
                    var self = this;
                    var div = this.div;

                    if (!div) {
                        div = this.div = document.createElement("div");
                        div.id = "marker";
                        div.style.width = "100px";
                        div.style.height = "100px";

                        var div_pointer = document.createElement("div");
                        div_pointer.className = "triangle";

                        var image_container = document.createElement("div");
                        image_container.className = "image_container";

                        var img = document.createElement("img");
                        img.className = "marker_image";
                        var image2 = "data:image/png;base64,";
                        image2 += value.userImage;
                        if (value.userImage == undefined) {
                            image2 = "content/images/userimg.gif";
                        }

                        img.src = image2;

                        var name_container = document.createElement("div");
                        name_container.className = "name_container";

                        var exit = document.createElement("div");
                        exit.className = "exit";
                        exit.innerHTML =
                            '<img className="exit_image" style="width:30px; height:30px;" src="https://cdn0.iconfinder.com/data/icons/large-glossy-icons/512/Delete.png">' +
                            "</img>";
                        exit.style.display = "none";

                        div.appendChild(image_container);
                        image_container.appendChild(img);
                        image_container.appendChild(imgbg);

                        div.appendChild(exit);

                        name_container.onmouseover = function () {
                            name_container.style.opacity = "0.6";
                            div.style.zIndex = "1000";
                        };
                        name_container.onmouseout = function () {
                            name_container.style.opacity = "0";
                            div.style.zIndex = "100";
                        };

                        infoWindow2.setContent(
                            '<div class="infoWindowhead">' +
                                value.login +
                                "</div>" +
                                userContent
                        );
                        // if (activeInfoWindow != null)
                        //     activeInfoWindow.close();

                        google.maps.event.addDomListener(
                            imgbg,
                            "click",
                            function (event) {
                                infowindowPopup.setPosition(
                                    new google.maps.LatLng(
                                        value.latitude,
                                        value.longitude
                                    )
                                );
                                infowindowPopup.open(locations.map);

                                if (activeInfoWindow != null)
                                    activeInfoWindow.close();
                                activeInfoWindow = infowindowPopup;
                            }
                        );

                        google.maps.event.addDomListener(
                            imgbg,
                            "click",
                            function (event) {
                                google.maps.event.trigger(self, "click");

                                infowindowPopup.open(locations.map);
                            }
                        );

                        var panes = this.getPanes();

                        panes.overlayImage.appendChild(div);
                    }

                    var point = this.getProjection().fromLatLngToDivPixel(
                        this.latlng
                    );

                    if (point) {
                        div.style.left = point.x - 50 + "px";
                        div.style.top = point.y - 125 + "px";
                    }
                };

                customMarker.prototype.remove = function () {
                    if (this.div) {
                        this.div.parentNode.removeChild(this.div);
                        this.div = null;
                    }
                };

                customMarker.prototype.getPosition = function () {
                    return this.latlng;
                };
                markers.forEach(function (marker) {
                    // image =
                    // value.userImage;

                    var overlay = new customMarker();
                });
                // end
            });
        }

        function downloadImage() {
            var svgString = getSVGString(svgUH.node());
            svgString2Image(svgString, 2 * 2160, 2 * 2160, "png", save);

            function save(dataBlob, filesize) {
                var imageURL = URL.createObjectURL(dataBlob);

                var link = document.createElement("a");
                link.href = imageURL;
                link.download = "UserHierarchy.png";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

        // Below are the functions that handle actual exporting:
        // getSVGString ( svgNode ) and svgString2Image( svgString, width, height, format, callback )
        function getSVGString(svgNode) {
            svgNode.setAttribute("xlink", "http://www.w3.org/1999/xlink");
            var cssStyleText = getCSSStyles(svgNode);
            appendCSS(cssStyleText, svgNode);

            var serializer = new XMLSerializer();
            var svgString = serializer.serializeToString(svgNode);
            svgString = svgString.replace(/(\w+)?:?xlink=/g, "xmlns:xlink="); // Fix root xlink without namespace
            svgString = svgString.replace(/NS\d+:href/g, "xlink:href"); // Safari NS namespace fix

            return svgString;

            function getCSSStyles(parentElement) {
                var selectorTextArr = [];

                // Add Parent element Id and Classes to the list
                selectorTextArr.push("#" + parentElement.id);
                for (var c = 0; c < parentElement.classList.length; c++)
                    if (
                        !contains(
                            "." + parentElement.classList[c],
                            selectorTextArr
                        )
                    )
                        selectorTextArr.push("." + parentElement.classList[c]);

                // Add Children element Ids and Classes to the list
                var nodes = parentElement.getElementsByTagName("*");
                for (var i = 0; i < nodes.length; i++) {
                    var id = nodes[i].id;
                    if (!contains("#" + id, selectorTextArr))
                        selectorTextArr.push("#" + id);

                    var classes = nodes[i].classList;
                    for (var c = 0; c < classes.length; c++)
                        if (!contains("." + classes[c], selectorTextArr))
                            selectorTextArr.push("." + classes[c]);
                }

                // Extract CSS Rules
                var extractedCSSText = "";
                for (var i = 0; i < document.styleSheets.length; i++) {
                    var s = document.styleSheets[i];

                    try {
                        if (!s.cssRules) continue;
                    } catch (e) {
                        if (e.name !== "SecurityError") throw e; // for Firefox
                        continue;
                    }

                    var cssRules = s.cssRules;
                    for (var r = 0; r < cssRules.length; r++) {
                        if (contains(cssRules[r].selectorText, selectorTextArr))
                            extractedCSSText += cssRules[r].cssText;
                    }
                }

                return extractedCSSText;

                function contains(str, arr) {
                    return arr.indexOf(str) === -1 ? false : true;
                }
            }

            function appendCSS(cssText, element) {
                var styleElement = document.createElement("style");
                styleElement.setAttribute("type", "text/css");
                styleElement.innerHTML = cssText;
                var refNode = element.hasChildNodes()
                    ? element.children[0]
                    : null;
                element.insertBefore(styleElement, refNode);
            }
        }

        function svgString2Image(svgString, width, height, format, callback) {
            var format = format ? format : "png";

            var imgsrc =
                "data:image/svg+xml;base64," +
                btoa(unescape(encodeURIComponent(svgString))); // Convert SVG string to data URL

            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");

            canvas.width = width;
            canvas.height = height;

            var image = new Image();
            image.onload = function () {
                context.clearRect(0, 0, width, height);
                context.drawImage(image, 0, 0, width, height);

                canvas.toBlob(function (blob) {
                    var filesize = Math.round(blob.length / 1024) + " KB";
                    if (callback) callback(blob, filesize);
                });
            };

            image.src = imgsrc;
        }

        function onSuccessUsers(data, headers) {
            drawLatestlocations($filter("filter")(data, { login: "" }));
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 16,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(16, locations.latlng)
                );
                geoLocation(locations.map);
                var address = new google.maps.Geocoder();

                google.maps.event.addListener(
                    locations.map,
                    "click",
                    function (event) {
                        address.geocode(
                            {
                                latLng: event.latLng,
                            },
                            function (results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    if (results[0]) {
                                        $ngConfirm({
                                            title:
                                                "Are you sure you want to select this address?",
                                            content:
                                                "<strong>Address: </strong>" +
                                                results[0].formatted_address +
                                                "<br/>" +
                                                "<strong>Latitude: </strong>" +
                                                event.latLng.lat() +
                                                "</br>" +
                                                "<strong>Longitude: </strong>" +
                                                event.latLng.lng(),
                                            type: "blue",
                                            typeAnimated: true,
                                            buttons: {
                                                OK: {
                                                    text: "OK",
                                                    btnClass: "btn-primary",
                                                    action: function () {
                                                        var distance = parseInt(
                                                            document.getElementById(
                                                                "user_distance"
                                                            ).value
                                                        );

                                                        vm.filterData = true;
                                                        var clickLoc = {
                                                            lat: event.latLng.lat(),
                                                            lng: event.latLng.lng(),
                                                        };
                                                        var circle = new google.maps.Circle(
                                                            {
                                                                map:
                                                                    locations.map,
                                                                radius:
                                                                    distance +
                                                                    distance /
                                                                        2,
                                                                center: clickLoc,
                                                                fillColor:
                                                                    "#FD7A24",
                                                                strokeColor:
                                                                    "#FF0000",
                                                                strokeOpacity: 0.8,
                                                                strokeWeight: 1.0,
                                                            }
                                                        );

                                                        if (
                                                            prevSelectedCircle ==
                                                            null
                                                        ) {
                                                            prevSelectedCircle = circle;
                                                        } else {
                                                            prevSelectedCircle.setMap(
                                                                null
                                                            );
                                                            prevSelectedCircle = circle;
                                                        }
                                                        NearbyUser.query(
                                                            {
                                                                latitude: event.latLng.lat(),
                                                                longitude: event.latLng.lng(),
                                                                dis: distance,
                                                            },
                                                            onSuccessUsers
                                                        );
                                                    },
                                                },
                                                Cancel: {
                                                    text: "Cancel",
                                                    btnClass: "btn-danger",
                                                    action: function () {},
                                                },
                                            },
                                        });
                                    }
                                }
                            }
                        );
                    }
                );
                // google.maps.event.addListener(locations.map, 'zoom_changed', function () {
                //     vm.zoomLevel = locations.map.getZoom();
                //     if ((vm.prevZoomLevel == 17 && vm.zoomLevel == 18) || (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)) {
                //         drawLatestAssetsOnMap(vm.mapAssets);
                //     }
                //     vm.prevZoomLevel = vm.zoomLevel;

                // });
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () {};
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");
            callback();
        }

        function drawPolyline(spread, map) {
            var spreadAssetCoordinates = [];
            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "#FFFFFF";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = new google.maps.InfoWindow();
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spread.assetTypeColor;
                }
                var polylineWeight = 2.5;
                var strokeOpacityVal = 1.0;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "mouseout",
                    function (event) {
                        infowindow.close();
                    }
                );

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead">' +
                                "<b>Asset Name : </b><br><br>" +
                                spread.name +
                                "</br></div>"
                        );

                        infowindow.mousemove;
                        infowindow.open(locations.map);
                        infowindow.setPosition(event.latLng);
                        openedInfoWindow = infowindow;
                    }
                );

                polylinepath.setMap(locations.map);
                polylines.push(polylinepath);
            }
        }

        function drawFixedGeofenceAsset(fixed, hasParent) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infowindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                    },
                });
                google.maps.event.addListener(
                    startMarker,
                    "mouseout",
                    function (event) {
                        infowindow.close();
                    }
                );

                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead">' +
                                "<b>Asset Name : </b><br><br>" +
                                fixed.name +
                                "</br></div>"
                        );

                        infowindow.mousemove;
                        infowindow.open(locations.map);
                        infowindow.setPosition(event.latLng);
                        openedInfoWindow = infowindow;
                    }
                );
                markers.push(startMarker);

                openedInfoWindow = infowindow;
            });
        }

        /* treeeeeeeeeeeeeeeeeeeeeeeeeeeee */
        var orgChart = (function () {
            var _margin = {
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20,
                },
                _root = {},
                _nodes = [],
                _counter = 0,
                _svgroot = null,
                _svg = null,
                _tree = null,
                _diagonal = null,
                _lineFunction = null,
                _loadFunction = null,
                /* Configuration */
                _duration = 750,
                /* Duration of the animations */
                _rectW = 150,
                /* Width of the rectangle */
                _rectH = 50,
                /* Height of the rectangle */
                _rectSpacing = 20,
                /* Spacing between the rectangles */
                _fixedDepth = 80,
                /*
                 * Height of the line for child
                 * nodes
                 */
                _mode = "line",
                /*
                 * Choose the values "line" or
                 * "diagonal"
                 */
                _callerNode = null,
                _callerMode = 0,
                defLinearGradient = function (id, x1, y1, x2, y2, stopsdata) {
                    var gradient = _svgroot
                        .append("svg:defs")
                        .append("svg:linearGradient")
                        .attr("id", id)
                        .attr("x1", x1)
                        .attr("y1", y1)
                        .attr("x2", x2)
                        .attr("y2", y2)
                        .attr("spreadMethod", "pad");

                    $.each(stopsdata, function (index, value) {
                        gradient
                            .append("svg:stop")
                            .attr("offset", value.offset)
                            .attr("stop-color", value.color)
                            .attr("stop-opacity", value.opacity);
                    });
                },
                defBoxShadow = function (id) {
                    var filter = _svgroot
                        .append("svg:defs")
                        .append("svg:filter")
                        .attr("id", id)
                        .attr("height", "150%")
                        .attr("width", "150%");

                    filter
                        .append("svg:feOffset")
                        .attr("dx", "2")
                        .attr("dy", "2")
                        .attr("result", "offOut"); // how
                    // much
                    // to
                    // offset
                    filter
                        .append("svg:feGaussianBlur")
                        .attr("in", "offOut")
                        .attr("result", "blurOut")
                        .attr("stdDeviation", "2"); // stdDeviation
                    // is
                    // how
                    // much
                    // to
                    // blur
                    filter
                        .append("svg:feBlend")
                        .attr("in", "SourceGraphic")
                        .attr("in2", "blurOut")
                        .attr("mode", "normal");
                },
                collapse = function (d) {
                    if (d.children) {
                        d._children = d.children;
                        d._children.forEach(collapse);
                        d.children = null;
                    }
                },
                update = function (source) {
                    // Compute the new tree layout.
                    _nodes = _tree.nodes(_root).reverse();
                    var links = _tree.links(_nodes);

                    // Normalize for fixed-depth.
                    _nodes.forEach(function (d) {
                        d.y = d.depth * _fixedDepth;
                    });

                    // Update the nodes
                    var node = _svg
                        .selectAll("g.node")
                        .data(_nodes, function (d) {
                            return d.id || (d.id = ++_counter);
                        });

                    // Enter any new nodes at the parent's previous position.
                    var nodeEnter = node
                        .enter()
                        .append("g")
                        .attr("class", "node")
                        .attr("transform", function (d) {
                            return (
                                "translate(" + source.x0 + "," + source.y0 + ")"
                            );
                        })
                        .on("click", nodeclick);

                    nodeEnter
                        .append("rect")
                        .attr("width", _rectW)
                        .attr("height", _rectH)
                        .attr("fill", "#898989")
                        .attr("filter", "url(#boxShadow)");

                    nodeEnter
                        .append("rect")
                        .attr("width", _rectW)
                        .attr("height", _rectH)
                        .attr("id", function (d) {
                            return d.id;
                        })
                        .attr("fill", function (d) {
                            return d.children || d._children || d.hasChild
                                ? "url(#gradientchilds)"
                                : "url(#gradientnochilds)";
                        })
                        .style("cursor", function (d) {
                            return d.children || d._children || d.hasChild
                                ? "pointer"
                                : "default";
                        })
                        .attr("class", "box1");

                    nodeEnter
                        .append("text")
                        .attr("x", _rectW / 2)
                        .attr("y", _rectH / 2)
                        .attr("dy", ".35em")
                        .attr("text-anchor", "middle")
                        .style("cursor", function (d) {
                            return d.children || d._children || d.hasChild
                                ? "pointer"
                                : "default";
                        })
                        .text(function (d) {
                            return d.firstName + " " + d.lastName;
                        });

                    // Transition nodes to their new position.
                    var nodeUpdate = node
                        .transition()
                        .duration(_duration)
                        .attr("transform", function (d) {
                            return "translate(" + d.x + "," + d.y + ")";
                        });

                    nodeUpdate.select("rect.box1").attr("fill", function (d) {
                        return d.children || d._children || d.hasChild
                            ? "url(#gradientchilds)"
                            : "url(#gradientnochilds)";
                    });

                    // Transition exiting nodes to the parent's new position.
                    var nodeExit = node
                        .exit()
                        .transition()
                        .duration(_duration)
                        .attr("transform", function (d) {
                            return (
                                "translate(" + source.x + "," + source.y + ")"
                            );
                        })
                        .remove();

                    // Update the links
                    var link = _svg
                        .selectAll("path.link")
                        .data(links, function (d) {
                            return d.target.id;
                        });

                    if (_mode === "line") {
                        // Enter any new links at the parent's previous position.
                        link.enter()
                            .append("path", "g")
                            .attr("class", "link")
                            .attr("d", function (d) {
                                var u_line = (function (d) {
                                    var u_linedata = [
                                        {
                                            x:
                                                d.source.x0 +
                                                parseInt(_rectW / 2),
                                            y: d.source.y0 + _rectH + 2,
                                        },
                                        {
                                            x:
                                                d.source.x0 +
                                                parseInt(_rectW / 2),
                                            y: d.source.y0 + _rectH + 2,
                                        },
                                        {
                                            x:
                                                d.source.x0 +
                                                parseInt(_rectW / 2),
                                            y: d.source.y0 + _rectH + 2,
                                        },
                                        {
                                            x:
                                                d.source.x0 +
                                                parseInt(_rectW / 2),
                                            y: d.source.y0 + _rectH + 2,
                                        },
                                    ];

                                    return u_linedata;
                                })(d);

                                return _lineFunction(u_line);
                            });

                        // Transition links to their new position.
                        link.transition()
                            .duration(_duration)
                            .attr("d", function (d) {
                                var u_line = (function (d) {
                                    var u_linedata = [
                                        {
                                            x:
                                                d.source.x +
                                                parseInt(_rectW / 2),
                                            y: d.source.y + _rectH,
                                        },
                                        {
                                            x:
                                                d.source.x +
                                                parseInt(_rectW / 2),
                                            y: d.target.y - _margin.top / 2,
                                        },
                                        {
                                            x:
                                                d.target.x +
                                                parseInt(_rectW / 2),
                                            y: d.target.y - _margin.top / 2,
                                        },
                                        {
                                            x:
                                                d.target.x +
                                                parseInt(_rectW / 2),
                                            y: d.target.y,
                                        },
                                    ];

                                    return u_linedata;
                                })(d);

                                return _lineFunction(u_line);
                            });

                        // Transition exiting nodes to the parent's new position.
                        link.exit()
                            .transition()
                            .duration(_duration)
                            .attr("d", function (d) {
                                /*
                                 * This is needed to draw the lines
                                 * right back to the caller
                                 */
                                var u_line = (function (d) {
                                    var u_linedata = [
                                        {
                                            x:
                                                _callerNode.x +
                                                parseInt(_rectW / 2),
                                            y: _callerNode.y + _rectH + 2,
                                        },
                                        {
                                            x:
                                                _callerNode.x +
                                                parseInt(_rectW / 2),
                                            y: _callerNode.y + _rectH + 2,
                                        },
                                        {
                                            x:
                                                _callerNode.x +
                                                parseInt(_rectW / 2),
                                            y: _callerNode.y + _rectH + 2,
                                        },
                                        {
                                            x:
                                                _callerNode.x +
                                                parseInt(_rectW / 2),
                                            y: _callerNode.y + _rectH + 2,
                                        },
                                    ];

                                    return u_linedata;
                                })(d);

                                return _lineFunction(u_line);
                            })
                            .each("end", function () {
                                _callerNode = null;
                                /*
                                 * After
                                 * transition
                                 * clear
                                 * the
                                 * caller
                                 * node
                                 * variable
                                 */
                            });
                    } else if (_mode === "diagonal") {
                        // Enter any new links at the parent's previous position.
                        link.enter()
                            .insert("path", "g")
                            .attr("class", "link")
                            .attr("x", _rectW / 2)
                            .attr("y", _rectH / 2)
                            .attr("d", function (d) {
                                var o = {
                                    x: source.x0,
                                    y: source.y0,
                                };
                                return _diagonal({
                                    source: o,
                                    target: o,
                                });
                            });

                        // Transition links to their new position.
                        link.transition()
                            .duration(_duration)
                            .attr("d", _diagonal);

                        // Transition exiting nodes to the parent's new position.
                        link.exit()
                            .transition()
                            .duration(_duration)
                            .attr("d", function (d) {
                                var o = {
                                    x: source.x,
                                    y: source.y,
                                };
                                return _diagonal({
                                    source: o,
                                    target: o,
                                });
                            })
                            .remove();
                    }

                    // Stash the old positions for transition.
                    _nodes.forEach(function (d) {
                        d.x0 = d.x;
                        d.y0 = d.y;
                    });
                },
                // Toggle children on click.
                nodeclick = function (d) {
                    if (!d.children && !d._children && d.hasChild) {
                        // If there are no childs --> Try to load child nodes
                        _loadFunction(d, function (childs) {
                            var response = {
                                id: d.id,
                                login: d.login,
                                children: childs.result,
                            };

                            response.children.forEach(function (child) {
                                if (!_tree.nodes(d)[0]._children) {
                                    _tree.nodes(d)[0]._children = [];
                                }

                                child.x = d.x;
                                child.y = d.y;
                                child.x0 = d.x0;
                                child.y0 = d.y0;
                                _tree.nodes(d)[0]._children.push(child);
                            });

                            if (d.children) {
                                _callerNode = d;
                                _callerMode = 0; // Collapse
                                d._children = d.children;
                                d.children = null;
                            } else {
                                _callerNode = null;
                                _callerMode = 1; // Expand
                                d.children = d._children;
                                d._children = null;
                            }

                            update(d);
                        });
                    } else {
                        if (d.children) {
                            _callerNode = d;
                            _callerMode = 0; // Collapse
                            d._children = d.children;
                            d.children = null;
                        } else {
                            _callerNode = d;
                            _callerMode = 1; // Expand
                            d.children = d._children;
                            d._children = null;
                        }

                        update(d);
                    }
                },
                // Redraw for zoom
                redraw = function () {
                    _svg.attr(
                        "transform",
                        "translate(" +
                            d3.event.translate +
                            ")" +
                            " scale(" +
                            d3.event.scale.toFixed(1) +
                            ")"
                    );
                },
                initTree = function (options) {
                    var u_opts = $.extend(
                            {
                                id: "",
                                data: {},
                                modus: "line",
                                loadFunc: function () {},
                            },
                            options
                        ),
                        id = u_opts.id;

                    _loadFunction = u_opts.loadFunc;
                    _mode = u_opts.modus;
                    _root = u_opts.data;

                    if (_mode == "line") {
                        _fixedDepth = 80;
                    } else {
                        _fixedDepth = 110;
                    }

                    $(id).html(""); // Reset

                    var width =
                            $(id).innerWidth() - _margin.left - _margin.right,
                        height =
                            $(id).innerHeight() - _margin.top - _margin.bottom;

                    //    var width = 1050;
                    //    var height = 1500;

                    _tree = d3.layout
                        .tree()
                        .nodeSize([
                            _rectW + _rectSpacing,
                            _rectH + _rectSpacing,
                        ]);

                    /* Basic Setup for the diagonal function. _mode = "diagonal" */
                    _diagonal = d3.svg.diagonal().projection(function (d) {
                        return [d.x + _rectW / 2, d.y + _rectH / 2];
                    });

                    /* Basic setup for the line function. _mode = "line" */
                    _lineFunction = d3.svg
                        .line()
                        .x(function (d) {
                            return d.x;
                        })
                        .y(function (d) {
                            return d.y;
                        })
                        .interpolate("linear");

                    var u_childwidth = parseInt(
                        (_root.children.length * _rectW) / 2
                    );
                    var zm;
                    _svgroot = d3
                        .select(id)
                        .append("svg")
                        .attr("width", width)
                        .attr("height", height)
                        .call(
                            (zm = d3.behavior
                                .zoom()
                                .scaleExtent([0.15, 3])
                                .on("zoom", redraw))
                        );

                    _svg = _svgroot
                        .append("g")
                        .attr(
                            "transform",
                            "translate(" +
                                parseInt(
                                    u_childwidth +
                                        (width - u_childwidth * 2) / 2 -
                                        _margin.left / 2
                                ) +
                                "," +
                                20 +
                                ")"
                        )
                        .attr("shape-rendering", "geometricPrecision");

                    var u_stops = [
                        { offset: "0%", color: "#03A9F4", opacity: 1 },
                        { offset: "100%", color: "#0288D1", opacity: 1 },
                    ];
                    defLinearGradient(
                        "gradientnochilds",
                        "0%",
                        "0%",
                        "0%",
                        "100%",
                        u_stops
                    );
                    var u_stops = [
                        { offset: "0%", color: "#00e658", opacity: 1 },
                        { offset: "100%", color: "#048033", opacity: 1 },
                    ];
                    defLinearGradient(
                        "gradientchilds",
                        "0%",
                        "0%",
                        "0%",
                        "100%",
                        u_stops
                    );

                    defBoxShadow("boxShadow");

                    // necessary so that zoom knows where to zoom and unzoom from
                    zm.translate([
                        parseInt(
                            u_childwidth +
                                (width - u_childwidth * 2) / 2 -
                                _margin.left / 2
                        ),
                        20,
                    ]);

                    _root.x0 = 0; // the root is already centered
                    _root.y0 = height / 2; // draw & animate from center

                    _root.children.forEach(collapse);
                    update(_root);

                    d3.select(id).style(
                        "height",
                        height + _margin.top + _margin.bottom
                    );
                    svgUH = _svgroot;
                    svgUHwidth = width;
                    svgUHheigth = height;
                };

            return { initTree: initTree };
        })();

        var u_data = {};

        function loadChilds(actualElement, successFunction) {
            UsersHierarchy.getUsersHierarchy(
                actualElement.login,
                function (response) {
                    var result = { result: response.children };
                    successFunction(result);
                }
            );
        }

        // treeeeeeeeeeeeee------------------------------------------///

        function downloadUserManagementUserList() {
            // DownloadCaseReports.download(function (response) {
            var a = document.createElement("a");
            a.style = "display: none";
            var file = new Blob([response], { type: "application/csv" });
            var fileURL = URL.createObjectURL(file);
            // window.open(fileURL, "_blank");
            a.href = fileURL;
            a.download = "case_report.csv";
            a.click();
            window.URL.revokeObjectURL(fileURL);
            // });
        }

        function downloadUsers() {
            DownloadUsers.download(function (response) {
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([response], { type: "application/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "users.csv";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ImportDialogController", ImportDialogController);

    ImportDialogController.$inject = ["EntityImport", "$timeout", "$state","previousState"];
    function ImportDialogController(EntityImport, $timeout, $state,previousState) {
        var vm = this;
        var getFile, lastDotPosition, format;
        vm.currentState = previousState

        $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });
        
        vm.importxlsx = /^(.*?)\.(xlsx|kml)$/;

        vm.onSubmit = function () {
            getFile = document.getElementById("uploadfile").files[0];
            lastDotPosition = getFile.name.lastIndexOf(".");
            format = getFile.name.substring(lastDotPosition + 1);

            var fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                EntityImport.get(
                    {
                        entityName: vm.entity,
                        entityLayout: vm.entityLayout,
                        fileFormat: format,
                        messageType: "ADD",
                        messageStatus: "OPEN",
                        fileImage: window.btoa(fileLoadedEvent.target.result), // imported file
                    },
                    function (response) {
                        vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id;
                        $timeout(function () {
                            $state.go(vm.currentState)
                        }, 4000);
                    }
                );
            };
            fileReader.readAsBinaryString(getFile);
        };
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("entity-import", {
                parent: "admin",
                url: "/entity-import",
                data: {
                    authorities: [
                        "ROLE_USER_ADMIN",
                    ],
                    pageTitle: "global.menu.entityImport",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/import/entity-import.html",
                        controller: "ImportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
    
                }
            })

            .state('entity-import.new', {
                parent: 'entity-import',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/import/entity-import-dialog.html',
                        controller: 'ImportDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return $state.current.name || 'entity-import';
                    }]
                }
            })
        }
    })();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('EntityImport', ['$http', function ($http) {

		var service = {};
		service.get = function (data,callback) {
			$http.post('api/assetsimportrequests',data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('EntityImportList', ['$http', function ($http) {

		var service = {};
		service.get = function (callback) {
			$http.get('api/assetsimportrequests').then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AssetLinkList', ['$http', function ($http) {

		var service = {};
		service.get = function (callback) {
			$http.get('api/link-assets').then(function (response) {
				callback(response.data);
			}); 
		};

		service.post = function (data,callback) {
			$http.post('api/link-assets',data).then(function (response) {
				callback(response);
			}); 
		};
		return service;
	}]);
})(); 


(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ImportController", ImportController);

        ImportController.$inject = ["EntityImportList"];
    function ImportController(EntityImportList) {

        var vm = this;

        EntityImportList.get(function (response){
            vm.displayList = response
        })

        vm.refresh = function(){
            EntityImportList.get(function (response){
                vm.displayList = response
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('trakeyeApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomerManagementDetailController', CustomerManagementDetailController);

    CustomerManagementDetailController.$inject = ['$stateParams', '$state', 'CustomerDetails', 'CustomerUpdate'];

    function CustomerManagementDetailController ($stateParams, $state, CustomerDetails, CustomerUpdate) {
        var vm = this;
        
        vm.save = save;
        vm.load = load;
        vm.customer = {};

        vm.load($stateParams.id);

        function load (id) {
        	CustomerDetails.get({customerId: id}, function(result) {
                vm.customer = result;
            });
        }

        function onSaveSuccess (result) {
            //vm.isSaving = false;
            $state.go('customer-management');
        }

        function onSaveError () {
            //vm.isSaving = false;
        }
        
        function save () {
       
            if (vm.customer.id !== null) {
                CustomerUpdate.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                CustomerUpdate.save(vm.customer, onSaveSuccess, onSaveError);
            }
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomerManagementDetailController', CustomerManagementDetailController);

    CustomerManagementDetailController.$inject = ['$stateParams', 'CustomerDetails'];

    function CustomerManagementDetailController ($stateParams, CustomerDetails) {
        var vm = this;

        vm.load = load;
        vm.customer = {};

        vm.load($stateParams.id);

        function load (id) {
        	CustomerDetails.get({customerId: id}, function(result) {
                vm.customer = result;
            });
        }
       
    }
})();


(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-management', {
            parent: 'admin',
            //url: '/customer-management?page&sort$search',
            url: '/customer-management',
            data: {
            	authorities: [],
                pageTitle: 'customerManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/customer-management/customer-management.html',
                    controller: 'CustomerManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer-management');
                    return $translate.refresh();
                }]

            }       
			})
    
    .state('customer-management.edit', {
        parent: 'customer-management',
        url: '/{id}/edit',
        data: {
        	 //authorities: ['ROLE_SUPER_ADMIN','ROLE_USER_ADMIN']
        },
		views:{
			'content@':{
				templateUrl: 'app/admin/customer-management/customer-management-dialog.html',
                controller: 'CustomerDetails',
                controllerAs: 'vm'
			}
		},
		resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('customer-management');
                return $translate.refresh();
            }],
			entity: ['$stateParams', 'CustomerDetails', function($stateParams, CustomerDetails) {
                return CustomerDetails.get({id : $stateParams.id}).$promise;
            }],
        }		        
    })
    
    .state('customer-management-detail', {
        parent: 'admin',
        url: '/customer/:id',
        data: {
        	 //authorities: ['ROLE_SUPER_ADMIN','ROLE_USER_ADMIN'],
            pageTitle: 'customer-management.detail.title'
        },
        views: {
            'content@': {
                templateUrl: 'app/admin/customer-management/customer-management-dialog.html',
                controller: 'CustomerManagementDetailController',
                controllerAs: 'vm'
            }
        },
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('customer-management');
                return $translate.refresh();
            }]
        }
    });
    }
})();

(function() {
    'use strict';

    angular
    .module('trakeyeApp')
    .controller('CustomerManagementController', CustomerManagementController);

    //CustomerManagementController.$inject = ['Customer','ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService','$stateParams'];
    CustomerManagementController.$inject = ['CustomerDetails', 'CustomerValueSearch', '$state', 'pagingParams', 'paginationConstants','$stateParams', 'Customer', 'AlertService'];
    
    function CustomerManagementController(CustomerDetails, CustomerValueSearch, $state, pagingParams, paginationConstants, $stateParams, Customer, AlertService) {
        var vm = this;

        vm.firstName = null;
        vm.lastName = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.customers = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.getLocalhour = getLocalhour;
        vm.filterSearch=filterSearch;

        vm.loadAll();
        
        function getLocalhour(hour){
        	var d  = new Date();
			d.setUTCHours(hour);
			return d.getHours();
		}

        function setActive (customer, isActivated) {
            customer.activated = isActivated;
            Customer.update(customer, function () {
                vm.loadAll();
                vm.clear();
            });
        }
        
        function filterSearch(){
			if(vm.search!=null && vm.search!="" && !angular.isUndefined(vm.search)){
				CustomerValueSearch.query({customerId:vm.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
			}else{
				loadAll ();
			}

		}
        

        function loadAll () {        	
          if($stateParams.status==undefined){
        	  Customer.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
          }else{ 
        	 
        	CustomersStatusService.query({status:$stateParams.status,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
          }    
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['firstName'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            //vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.customers = data;
           
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.customer = {
                id: null, firstName: null, lastName: null, email: null, mobilePhone: null,
                langKey: null, createdDate: null, status:null, city:null, state:null, country:null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("asset-link", {
                parent: "admin",
                url: "/asset-link",
                data: {
                    authorities: [
                        "ROLE_USER_ADMIN",
                    ],
                    pageTitle: "global.menu.assetLink",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/asset-link/asset-link-request.html",
                        controller: "AssetLinkController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
    
                }
            })
        }
    })();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetLinkController", AssetLinkController);

        AssetLinkController.$inject = ["AssetLinkList"];
    function AssetLinkController(AssetLinkList) {

        var vm = this;

        AssetLinkList.get(function (response){
            vm.displayList = response
        })

        vm.refresh = function(){
            AssetLinkList.get(function (response){
                vm.displayList = response
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER','ROLE_SUPER_ADMIN','ROLE_USER_ADMIN','ROLE_VENDOR_ADMIN'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth','$state'];

    function RequestResetController ($timeout, Auth,$state) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;
        vm.errorUserDeactivate= null;
        vm.countExceeded = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.login).then(function (response) {
                vm.success = 'OK';
                vm.resetAccount.login = '';
                $timeout(function (){
                	$state.go("login");
                },2000);
                
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'username not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                   
                } else if(response.status === 400 && response.data === 'user is deactivated'){
                	 vm.errorUserDeactivate = 'ERROR';
                    
                } else if(response.status === 400 && response.data === 'Reset password count exceeded for the day'){
               	 vm.countExceeded = 'ERROR';
                 
                }else {
                    vm.error = 'ERROR';//User has not yet set password once. So forget password email can not be sent. Check your email to set the password
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;
        vm.emaillinkinvalid = null;
        vm.verifyaccount=null;
        
        Auth.verify($stateParams.key ,function (response) {
        	vm.verifyaccount = response.data;
            
        });
        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if(response.status === 400 && response.data === 'email link invalid'){
                   	 vm.emaillinkinvalid = 'ERROR';
                    }else{
                    	vm.error = 'ERROR';
                    }
                    
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
		
        $timeout(function (){angular.element('#login').focus();});

        function register () {
        
            vm.registerAccount.langKey = $translate.use();
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;

            Auth.createAccount(vm.registerAccount).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'firstName already in use') {
                    vm.errorUserExists = 'ERROR';
                } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                    vm.errorEmailExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        	}
        }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER','ROLE_SUPER_ADMIN','ROLE_USER_ADMIN','ROLE_VENDOR_ADMIN'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('FeasibilityVerifyFinish', FeasibilityVerifyFinish);

    FeasibilityVerifyFinish.$inject = ['$resource'];

    function FeasibilityVerifyFinish($resource) {
        var service = $resource('api/feasibility-checks/record', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('feasibilityVerify', {
            parent: 'account',
            url: '/feasibilityverify/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/feasibility/verify/finish/feasibility.verify.finish.html',
                    controller: 'FeasibilityVerifyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityVerify');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityVerifyController', FeasibilityVerifyController);

    FeasibilityVerifyController.$inject = ['$stateParams', '$timeout','Feasibility'];

    function FeasibilityVerifyController ($stateParams, $timeout,Feasibility) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        //vm.confirmPassword = null;
        //vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
       // vm.login = LoginService.open;
       // vm.resetAccount = {};
        vm.success = null;
       
       
       // vm.emaillinkinvalid = null;
       // vm.verifyaccount=null;
        
       /* Auth.verify($stateParams.key ,function (response) {
        	vm.verifyaccount = response.data;
            
        });*/
       // $timeout(function (){angular.element('#password').focus();});
       // var geocoder = new google.maps.Geocoder();
        function finishReset() {
           // vm.doNotMatch = null;
            vm.error = null;
            
          /*  if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if(response.status === 400 && response.data === 'email link invalid'){
                   	 vm.emaillinkinvalid = 'ERROR';
                    }else{
                    	vm.error = 'ERROR';
                    }
                    
                });
            }*/
            
            
            if (navigator.geolocation) {
                var location_timeout = setTimeout("geolocFail()", 10000);

                navigator.geolocation.getCurrentPosition(function(position) {
                    clearTimeout(location_timeout);

                    var lat = position.coords.latitude;
                    var lng = position.coords.longitude;
                   alert("Your location has been shared to ACT. You will receive a confirmation about broadband connection feasibility at your location  Lat [" + lat + "]  lan ["+ lng+"]");
                   Feasibility.fesibilityVerify({key: $stateParams.key, latitude: lat,longitude: lng }).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if(response.status === 400 && response.data === 'email link invalid'){
                   	 vm.emaillinkinvalid = 'ERROR';
                    }else{
                    	vm.error = 'ERROR';
                    }
                    
                })
                   
                   
                   // geocodeLatLng(lat, lng);
                }, function(error) {
                      alert(error.message);
                    clearTimeout(location_timeout);
                    geolocFail();
                });
            } else {
                  alert("Turn on the location service to make the deposit");
                // Fallback for no geolocation
                geolocFail();
            }
            
            
            
        }
        
        
        
        function geolocFail(){
        	 alert("Turn on the location service to Verify feasibility");
        	 document.write("Turn on the location service to Verify feasibility");
        	}
        
        function geocodeLatLng(lat, lng) {
        	var latlng = new google.maps.LatLng(lat, lng);
       	geocoder.geocode({'latLng': latlng}, function(results, status) {
        	if (status == google.maps.GeocoderStatus.OK) {
        	if (results[1]) {
        	//formatted address
       	var add= results[0].formatted_address
        	alert(add);

        	//city data
        	//alert(city.short_name + " " + city.long_name)

        	} else {
        	alert("No results found");
        	}
        	} else {
        	alert("Geocoder failed due to: " + status);
        	}
        	});
        	}
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Feasibility', Feasibility);

    Feasibility.$inject = ['$rootScope', '$http', 'FeasibilityVerifyFinish'];

    function Feasibility ($rootScope, $http,FeasibilityVerifyFinish) {
        var service = {
           
            fesibilityVerify: fesibilityVerify
            
        };
        return service;
        
        function fesibilityVerify (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return FeasibilityVerifyFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }
        
    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('trakeyeApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/dashboard/dashboard.html','<div ng-cloak><div class="content" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER"><div class="row mt-5"><!--  <div class="col-sm-3">\n                 <h2>Welcome, UserName! &#128075;</h2> \n                 <div class="dashboard_time">\n                    <h2 class="text-center" style="margin-top: 3%;">{{vm.time}}</h1>\n                        <h4 class="text-center">{{vm.day}}, {{vm.month}} {{vm.todayDate}}, {{vm.year}}</h4>   \n                </div> \n            </div> --><!--col-sm-3--><div class="col-sm-5"><div class="dashboard_opencases"><div class="open-head"><i class="fa fa-file-text-o" aria-hidden="true" style="color:rgba(0, 0, 0, 0.39)"></i><span class="case-heading"> Open Cases - Priority view</span></div><div class="clearfix"></div><div class="col-md-3 col-sm-3 col-xs-6 notification-border plr-5"><h3 class="red">Critical</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.priority({priority:\'CRITICAL\',geofenceId:vm.masterGeofence})"><span class="notification-count text-info">{{vm.casepriority.CRITICAL}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-info">{{vm.casepriority.CRITICAL}}</span></div></div><!--notification--><div class="col-md-3 col-sm-3 col-xs-6 notification-border plr-5"><h3 class="yellow">High</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.priority({priority:\'HIGH\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.casepriority.HIGH}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.casepriority.HIGH}}</span></div></div><!--notification--><div class="col-md-3 col-sm-3 col-xs-6 notification-border plr-5"><h3 class="green">Medium</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.priority({priority:\'MEDIUM\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.casepriority.MEDIUM}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.casepriority.MEDIUM}}</span></div></div><!--notification--><div class="col-md-3 col-sm-3 col-xs-6 plr-5"><h3 class="blue">Low</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.priority({priority:\'LOW\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.casepriority.LOW}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.casepriority.LOW}}</span></div></div><!--notification--></div><!--dashboard_opencases--></div><!--col-sm-5--><div class="col-sm-4"><div class="dashboard_opencases"><div class="open-head"><i class="fa fa-user" aria-hidden="true" style="color:rgba(0, 0, 0, 0.39)"></i><span class="case-heading"> Patrollers/FRT</span></div><div class="clearfix"></div><div class="col-md-4 col-sm-4 col-xs-6 notification-border plr-5"><h3 class="green">Active</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="user-management.status({status:\'ACTIVE\',geofenceId:vm.masterGeofence})"><span class="notification-count text-info">{{vm.users.ACTIVE}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-info">{{vm.users.ACTIVE}}</span></div></div><!--notification--><div class="col-md-4 col-sm-4 col-xs-6 notification-border plr-5"><h3 class="yellow">Idle</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="user-management.status({status:\'IDLE\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.users.IDLE}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.users.IDLE}}</span></div></div><!--notification--><div class="col-md-4 col-sm-4 col-xs-6 plr-5"><h3 class="inactive">Inactive</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="user-management.status({status:\'INACTIVE\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.users.INACTIVE}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.users.INACTIVE}}</span></div></div><!--notification--></div><!--dashboard_opencases--></div><div class="col-md-3"><div class="open-head"><i class="fa fa-user" aria-hidden="true" style="color:rgba(0, 0, 0, 0.39)"></i><span class="case-heading"> City</span></div><select id="masterGeofence" ng-model="vm.masterGeofence" ng-change="optionChange()"><option value="">Select City</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select><br><span id="noData" ng-if="vm.masterGeofence==\'\'">*Please Select City</span></div><!--col-sm-5--></div><div class="row" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER"><!-- <div class="col-md-6 ">\n\t\t\t<div class="box box-solid ">\n\t\t\t<div class="box-header ">\n\t\t\t  <h3 class="box-title ">Geo Fence Report</h3>\n\t\t\t</div>\n\t\t\t<div class="box-body chart-responsive ">\n\t\t\t  <div class="chart " id="bar-chart " style="height: 300px; "></div>\n\t\t\t</div>\n         </div>\n        </div>--><div class="col-md-12 col-sm-12"><!-- Map box --><div class="box box-solid"><div class="box-header with-border"><div class="col-md-4"><h3 class="box-title">Agent Status Report - Geofence view</h3></div><div ng-hide="vm.isGeofences" class="col-md-4" id="status"></div></div><div class="box-body chart-responsive"><h4 ng-show="vm.isGeofences">No data available</h4><div ng-hide="vm.isGeofences" id="stacked-chart-status" style="height: 247px; position: relative;"></div></div><!-- <div class="box-header ">\n                        <h3 class="box-title ">Site Asset View</h3>\n                    </div>\n                    <div class="box-body chart-responsive ">\n                        <div id="geo1 " style=" "></div>\n                    </div> --><!-- /.box-body --></div></div><div class="col-md-6 col-sm-12"><div class="box box-solid"><div class="box-header with-border" style="height: 48px;"><div class="col-md-12"><h3 class="box-title mt-5">Cases - Status view</h3></div></div><div class="box-body chart-responsive"><div id="case-chart" style="height: 285px; position: relative;"></div></div><!-- /.box-body --></div></div><!-- <div class="col-md-4 col-sm-12">\n                <div class="box box-solid ">\n                    <div class="box-header with-border">\n                        <h3 class="box-title ">Services Chart</h3>\n                    </div>\n                    <div class="box-body chart-responsive ">\n                        <div  id="service-chart" style="height: 285px; position: relative; "></div>\n                    </div>\n                </div>\n            </div> --><div class="col-xs-12 col-md-6"><div class="box box-solid" style="height: 346px"><div class="box-header with-border"><div class="col-md-6"><h3 class="box-title mt-5">Agent Activity Report</h3></div><div class="col-md-6"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control input-sm" placeholder="Search" ng-model="search" style="border-top-left-radius: 15px;\n                                        border-bottom-left-radius: 15px;"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat header-button" style="background-color:#efefef !important;"><i class="fa fa-search" style="color:#fd7124"></i></button></span></div></div></div><!-- <div class="col-md-12 mt-5 mb-5 ">\n                        \n                    </div> --><div class="box-body scrollbar" style="height: fit-content;" id="style-3" ng-hide="has_ROLE_VENDOR"><ul class="nav nav-stacked"><!--  <li ng-repeat="user in vm.userslist ">--><!-- <li dir-paginate="user in users = (vm.userslist|filter:search) | itemsPerPage: vm.itemsPerPage "\n                                style="text-align: center;">\n                                <a ui-sref="location-log.login({login: \'{{user.login}}\'}) ">\n                                    <div class="col-md-12" style="height: 40px;">\n                                        <div class="col-md-4 ">\n                                            <i class="pull-left fa fa-user" style="text-align: left;width: auto;"\n                                            aria-hidden="true ">\n                                            {{user.login}}</i>\n                                        </div>\n            \n                                        <div class="col-md-2 ">\n                                            <span class="badge bg-grey" style="width: auto;">{{user.cases |\n                                                number}}</span>\n                                        </div>\n                                        <div class="col-md-3 ">\n                                            <span class="badge bg-grey " style="width: auto;">{{(user.percentageCovered).toFixed(2)}} %</span>\n                                        </div>\n                                        <div class="col-md-3 ">\n                                            <span class="pull-right badge bg-grey " style="width: auto;">{{user.distance |\n                                                number}} KM</span>\n                                        </div>\n                                    <div>\n                                </a>\n                            </li> --><div class="case-table" aria-hidden="false"><div class="table-responsive mt-10"><table class="table table-responsive table-hover"><thead class="bg-default"><tr class="font_sizeEm"><th class="pull-left" ng-click="setOrderProperty(\'login\')">Agent Name <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'cases\')">Assigned Cases <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'percentageCovered\')">Target Covered <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'distance\')">Distance <span class="fa fa-sort"></span></th></tr></thead><tbody><!----><tr dir-paginate="user in users = (vm.userslist|filter:search) | itemsPerPage: vm.itemsPerPage | orderBy:orderProperty" style="text-align: center;" ui-sref="location-log.login({login: \'{{user.login}}\'}) "><td class="pull-left"><i class="fa fa-user mr-5" aria-hidden="true "></i> <span>{{user.login}}</span></td><td><span class="bg-grey">{{user.cases | number}}</span></td><!-- <div><span>{{user.reportCases |\n                                        number}}</span></div> --><td><span class="badge bg-grey" ng-style=" (user.percentageCovered >= 70) && {\'background-color\':\'#00e658\'}  || (user.percentageCovered >= 34) && {\'background-color\':\'#FD7A24\'} || (user.percentageCovered <= 33) && {\'background-color\':\'#FF0000\'}">{{(user.percentageCovered).toFixed(2)}} %</span></td><td><span>{{user.distance | number}} KM</span></td></tr></tbody></table></div></div><!-- <div class="flex-container">\n                                <div>\n                                    Agent <span class="fa fa-sort" ng-click="setOrderProperty(\'login\')"></span> Name  \n                                </div>\n        \n                                <div>\n                                   Assigned <span class="fa fa-sort" ng-click="setOrderProperty(\'cases\')"></span> Cases \n                                </div>\n                                 <div>\n                                    Reported <span class="fa fa-sort" ng-click="setOrderProperty(\'rCases\')"></span> Cases \n                                </div>\n                                <div>\n                                    Target <span class="fa fa-sort" ng-click="setOrderProperty(\'percentageCovered\')"></span> Covered \n                                </div>\n                                <div>\n                                    Distance <span class="fa fa-sort" ng-click="setOrderProperty(\'distance\')"></span>\n                                </div>\n                            </div> --><!-- <li dir-paginate="user in users = (vm.userslist|filter:search) | itemsPerPage: vm.itemsPerPage "\n                                style="text-align: center;">\n                                <a ui-sref="location-log.login({login: \'{{user.login}}\'}) ">\n                                    <i class="pull-left fa fa-user" style="width: 200px;text-align: left;"\n                                        aria-hidden="true ">\n                                        {{user.login}}</i>\n                                    <span class="badge bg-grey">{{user.cases |\n                                        number}}</span>\n                                    <span class="badge bg-grey " style="width: 80px;">{{(user.percentageCovered).toFixed(2)}} %</span>\n                                    <span class="pull-right badge bg-grey " style="width: 100px;">{{user.distance |\n                                        number}} KM</span>\n                                </a>\n                            </li> --><li ng-show="vm.userslist==0" style="text-align: center;"><h4>No data available</h4></li></ul></div><div class="box-body scrollbar" id="style-3" ng-if="has_ROLE_VENDOR"><ul class="nav nav-stacked"><!--  <li ng-repeat="user in vm.userslist ">--><li dir-paginate="user in vm.userslist | itemsPerPage: vm.itemsPerPage " style="text-align: center;"><a><i class="pull-left fa fa-user" style="width: 200px;text-align: left;" aria-hidden="true ">{{user.login}}</i> <span class="badge bg-grey">{{user.cases | number}}</span> <span class="pull-right badge bg-grey" style="width: 160px;">{{user.distance | number}} KM</span></a></li><li ng-show="vm.userslist==0" style="text-align: center;"><h4>No data available</h4></li></ul></div><div class="row mt-5"><!--<div class="col-md-4 ">\n\t\t\t\t\t\t\t<div class="count-length ">\n\t\t\t\t\t\t\t\t<jhi-item-count page="vm.page " total="vm.queryCount " items-per-page="vm.itemsPerPage "></jhi-item-count>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>--><div class="col-md-12"><div class="pull-right pr-10"><div class="pagination-list"><!--  <uib-pagination class="pagination-sm pagination-bottom " total-items="vm.totalItems " ng-model="vm.page " ng-change="vm.transition() "></uib-pagination>--><dir-pagination-controls direction-links="true " boundary-links="true "></dir-pagination-controls></div></div></div></div><!-- /.box-body --></div></div></div><div class="col-md-12 col-sm-12 text-center"><strong>&copy; {{vm.currYear}} Fiberify Inc</strong></div></div></div>');
$templateCache.put('app/history/asset-history.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="glyphicon glyphicon-time"></i> &nbsp;<span>Asset History</span></h3><div class="col-md-3 search-top pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetHistorySearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="box-body border"><div class="case-table"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-click="setOrderProperty(\'assetId\')">Asset Id <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'assetName\')">Asset Name <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'assetTypeName\')">Asset Type Name <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'modeName\')">Mode Name <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'propertyName\')">Property Name <span class="fa fa-sort"></span></th><th>New Value</th><th>Old Value</th><th ng-click="setOrderProperty(\'createdBy\')"><span>Created By</span> <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'cdate\')"><span>Created Date </span><span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'lastModifiedBy\')"><span>Last Modified By</span> <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'ldate\')">Last Modified Date <span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="asset in vm.assetHistory  | orderBy:orderProperty"><td>{{asset.assetId}}</td><td>{{asset.assetName}}</td><td>{{asset.assetTypeName}}</td><td>{{asset.modeName}}</td><td>{{asset.propertyName}}</td><td>{{asset.newValue}}</td><td>{{asset.oldValue}}</td><td>{{asset.createdBy}}</td><td>{{asset.cdate}}</td><td>{{asset.lastModifiedBy}}</td><td>{{asset.ldate}}</td></tr><tr><td colspan="10" ng-show="vm.assetHistory == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row row__div--pagination"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-3"><label>Go To</label> <input type="text" id="pagenum" oninput="this.value|=0" onkeyup="if(this.value<0){this.value= this.value * -1}" maxlength="4"> <button type="button " ng-click="vm.goToPage()" class="button__goto"><i class="fa fa-caret-right"></i></button></div><div class="col-md-4 pull-right"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/home/home.html','<div class="content" ng-if="!vm.isAuthenticated()" ng-cloak style="padding:0px;"><div class="container navbar-wrapper"><div class="row"><nav class="navbar navbar-default" role="navigation"><div class="col-sm-4 mt-45 mt-65"><div class="row"><div class="col-xs-9 col-sm-12"><img src="content/images/fiberify-logo.png" alt="trakeye" class="img-responsive2 trakeye_logo"><!--  content/images/newlogo3.png orange logo --></div><!-- <div class="navbar-header col-xs-3">\n\t\t\t\t\t<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">\n\t\t\t\t\t  <span class="sr-only">Toggle navigation</span>\n\t\t\t\t\t  <span class="icon-bar"></span>\n\t\t\t\t\t  <span class="icon-bar"></span>\n\t\t\t\t\t  <span class="icon-bar"></span>\n\t\t\t\t\t</button>\n\t\t\t\t  </div> --></div><!--row--></div><!--col-sm-4--><div class="col-sm-8 mt-45 mt-bg"><!-- Brand and toggle get grouped for better mobile display --><!-- Collect the nav links, forms, and other content for toggling --><div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1"><!--<ul class="nav navbar-nav navbar-right">\n\t\t\t   <li><a ui-sref="home">Home</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Solutions</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Industries</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Support</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Blog</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Contact Us</a></li>\n\t\t\t</ul>--></div><!-- /.navbar-collapse --></div><!--col-sm-8--></nav></div><!--row--></div><!-- Carousel\n    ================================================== --><div id="myCarousel" class="carousel slide" data-ride="carousel"><!-- Indicators --><ol class="carousel-indicators"><li data-target="#myCarousel" data-slide-to="0" class="active"></li><li data-target="#myCarousel" data-slide-to="1" class=""></li><li data-target="#myCarousel" data-slide-to="2" class=""></li></ol><div class="carousel-inner" role="listbox"><div class="item active"><img class="second-slide" src="content/images/bg3.png" alt="Second slide"><div class="container"><div class="col-sm-7 col-lg-7"><div class="home-banner"><img src="content/images/bg1-slide.png" class="img-responsive" alt="First slide" style="padding-top:0vh"></div></div><div class="col-sm-5 col-lg-5"><div class="home-banner-con"><div style="padding-top:16vh"><h1 style="color: #fff;">Field Activity Management</h1><h4 style="color: #fff;">Field activity monitoring console</h4><h4 style="color: #fff;">Location based issue reporting</h4><h4 style="color: #fff;">Find near-by agents to attend issues</h4><h4 style="color: #fff;">Get service activity updates from field</h4><h4 style="color: #fff;">View open issues and service activity on maps</h4></div></div></div></div></div><div class="item"><img class="first-slide" src="content/images/bg1.png" alt="First slide"><div class="container"><div class="col-sm-7 col-lg-7 col-lg-7"><div class="home-banner"><img src="content/images/bg1-slide3.png" class="img-responsive" alt="First slide" style="padding-top:0vh"></div></div><div class="col-sm-5 col-lg-5"><div class="home-banner-con"><div style="padding-top:16vh"><h1>Field Agent Tracking</h1><h4>Field agents live monitoring console</h4><h4>Individual field agent and vehicle tracking</h4><h4>Geofence entry/exit control</h4><h4>Field vehicle efficiency tracking</h4></div></div></div></div></div><div class="item"><img class="third-slide" src="content/images/bg2.png" alt="Third slide"><div class="container"><div class="col-sm-7 col-lg-7"><div class="home-banner"><img src="content/images/bg2-slide.png" class="img-responsive" alt="First slide" style="padding-top:0vh"></div></div><div class="col-sm-5 col-lg-5"><div class="home-banner-con"><div style="padding-top:20vh"><h1>Real-time Analytics</h1><h4>Ad-hoc Reports</h4><h4>Scheduled Reports</h4><h4>Analytics Dashboard</h4></div></div></div></div></div></div><a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> <span class="sr-only">Previous</span> </a><a class="right carousel-control" href="#myCarousel" role="button" data-slide="next"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span> <span class="sr-only">Next</span></a></div><!-- /.carousel --><!--<div class="row login-sizes">\n     \t \t<div class="col-md-6">\n\t\t\t<div class="home-content text-center mt-110">\n\t\t\t\t<h1 class="home-heading">Data Driven.</h1>\n\t\t\t\t<h1 class="home-subheading">Decision Making</h1>\n\t\t\t\t<h4 class="home-subheading">Field Optimized Solution</h4>\n\t\t\n\t\t\t\t<button class="btn btn-danger" ui-sref="register">Try it Now</button>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="col-md-5">\n\t\t\t<div class="phone-image">\n\t\t\t\t<img ng-src="content/images/phone.png" class="img-responsive phone" style="width: 100%; height: 495px;">\n\t\t\t</div>\n\t\t\t<div class="content-data">\n\t\t\t\t<h3 class="phone-head text-center">Our Platform represent everything <br/>you want to track</h3>\n\t\t\t</div>\n\t\t</div>\n    </div>\t--></div>');
$templateCache.put('app/upload/uploadagent.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);vm.showandroidfiles();" data-toggle="tab">Upload APK Files</a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2);vm.showiosfiles();" data-toggle="tab">Upload IPA Files</a></li></ul></div><!-- /.box-header --><!-- form start --><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p translate="upload.success">File has been uploaded successfully</p></div><!-- <div class="alert alert-danger" ng-show="vm.error">\r\n\t\t\t        <p >Only apk file should be uploaded</p>\r\n\t\t\t  </div>  --><div class="form-group"><label for="upload" class="col-sm-3 control-label" translate="upload.uploadfile">Upload File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="upload-file-input" class="filestyle" valid-file agent-file accept="*.ipa||*.apk" required ng-pattern="FILE_EXT_REGEXP"><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern" translate="upload.patternerror">Only apk and ipa file should be uploaded</p><!-- <div ng-show="uploadForm.uploadfile.$invalid">\r\n\t\t                   <p class="help-block" ng-show="uploadForm.uploadfile.$error.pattern" >\r\n                                  Only apk file should be uploaded\r\n                          </p>\r\n\t\t             </div>  --></div></div><div class="form-group"><label for="version" class="col-sm-3 control-label" translate="upload.versionno">Version Number</label><div class="col-sm-8"><input type="text" name="version" id="versionno" ng-model="version" placeholder="Version Number" class="form-control" required></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div><div class="col-md-8 col-md-offset-2" ng-show="isSet(1)"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i> Uploaded APK Details</h3></div><div class="box-body"><div class="table-responsive mt-10" style="max-height: 400px;  overflow: hidden; overflow-y: auto;"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>File Name<span class="fa fa-sort"></span></th><th>Version<span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="file in vm.files"><td>{{file.fileName}}</td><td>{{file.version}}</td></tr></tbody></table></div></div></div></div><div class="col-md-8 col-md-offset-2" ng-show="isSet(2)"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i> Uploaded IPA Details</h3></div><div class="box-body"><div class="table-responsive mt-10" style="max-height: 400px;  overflow: hidden; overflow-y: auto;"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>File Name<span class="fa fa-sort"></span></th><th>Version<span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="file in vm.iosfiles"><td>{{file.fileName}}</td><td>{{file.version}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/asset-case-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-bandcamp"></i> <span translate="global.menu.asset-case-report">Asset Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="assetForm" ng-submit="assetReport()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">From Date <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label assetCaseReport_toDate">To Date <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.report.casetype">caseType</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="caseType" ng-model="vm.caseType" ng-options="item.id as item.name for item in vm.caseTypes track by item.id" required><option value="" translate="trakeyeApp.report.selectcase">--- Select CaseType ---</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="assetForm.$invalid">Submit</button></div></div></form></div></div></div><!-- <div class="row">\r\n\t\t<div class="col-md-10 col-md-offset-1">\r\n\t\t\t<div  ng-if="assetreportbutton == \'option2\'">\r\n\t\t\t\t<div id="asset_graph"></div>\r\n\t\t\t</div>\r\n\t\t\t<div  ng-if="assetreportbutton == \'option1\'">\r\n\t\t\t\t<div id="asset_graph"></div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div> --><div class="row" ng-if="reporthide"><div class="col-md-10 col-md-offset-1"><!-- Map box --><div class="box box-solid"><div class="box-header"><i class="fa fa-server"></i><h3 class="box-title" translate="global.menu.asset-case-report">Generic Reports</h3></div><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control" placeholder="Search" ng-change="assetReportSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Asset Name</span></th><th><span>Asset Status</span></th><th><span>Case ID</span></th><th><span>Case Description</span></th><th>Case Status</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords"><td>{{record.assetName}}</td><td>{{record.assetStatus == true ? \'ACTIVE\' : \'IN-ACTIVE\' }}</td><td><a ui-sref="tr-case-detail({id:record.caseId})">{{record.caseId}}</a></td><td>{{record.caseDescription}}</td><td>{{record.caseStatus}}</td></tr></tbody></table></div></div><!--  added for heightchart end --></div></div></div>');
$templateCache.put('app/report/asset-geofence-mapping.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-heartbeat"></i> &nbsp;<span> Asset Geofence Mapping</span></h3></div><div class="box-body border"><div class="col-md-12 form-group"><label class="col-md-3 control-label"><span>Select Tenant</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedTenantId" ng-change="onTenantChange();" required><option value="">Select Tenant</option><option ng-repeat="item in vm.tenants" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="col-md-12 form-group" ng-show="vm.selectedTenantId"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="onMasterChange();" required><option value="">Select Geofence</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><br><div class="col-md-12 form-group" ng-show="vm.selectedMasterGeofenceId"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedGeofenceId" required><option value="">Select Geofence</option><option ng-repeat="item in vm.geofenceMini" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="row" ng-show="vm.selectedGeofenceId" style="margin: 20px;"><button class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" ng-click="vm.associateAssetsToGeofence()" style="margin: 20px;">Associate <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></div></div></div></div>');
$templateCache.put('app/report/asset-health-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-heartbeat"></i> &nbsp;<span> Asset Health Report</span></h3></div><div class="box-body"><jhi-alert></jhi-alert><div class="col-md-12" style="margin: 10px;"><div class="form-group"><label class="col-md-2 control-label mt-8"><span>Select Geofence</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3 ml_4"><select id="miniGeofences" class="select2 form-control" name="search" ng-model="vm.selectedGeofenceId" ng-options="item.id as item.name for item in vm.userGeofences" required><option value="">Select geofence</option><option ng-repeat="geofence in vm.userGeofences" value="geofence.id">{{geofence.name}}</option></select></div><div class="col-md-2 mr_5"><button type="button" class="btn btn-info btn-flat" ng-click="vm.showAssetHealth()" ng-if="vm.selectedGeofenceId!=null">Show Assets</button></div></div><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="vm.mapAssets.length>0"><select id="searchAssetsOnMap" class="select2 form-control" name="search"><option value="">Search Asset</option><option ng-repeat="item in vm.mapAssets" value="{{item}}">{{item.name}}</option></select></div><!-- <div class="col-md-1" ng-show="isSet(2)">\r\n                            <button type="button" value="GOTO" class="btn btn-info btn-flat"\r\n                                ng-click="vm.gotoLatitute()">\r\n                                GOTO\r\n                            </button>\r\n                        </div>\r\n\t\t\t\t\t\t<div class="pull-right ml-10 mt-0 div--filter" ng-show="isSet(2)">\r\n                            <button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnMapView()"\r\n                                >\r\n                                <i class="fa fa-filter"></i>\r\n                            </button>\r\n                            <button type="button" value="Layers" class="btn btn-info btn-flat"\r\n                                ng-click="vm.showLayers()">\r\n                                Layers\r\n                            </button>\r\n                        </div> --></div><div class="map-view"><div class="row mt-5"><div class="pull-right"><span id="myspan"></span></div><div class="col-md-8"><div id="map_canvas" style="height:{{mapHeight}}px;"></div></div><div class="col-md-4 table-responsive mt_3" ng-show="vm.selectedGeofenceId>0"><table class="jh-table table table-responsive table-hover" style="display: block;height: {{mapHeight}}px;overflow: auto;"><thead class="thead-light"><tr><th><span translate="">Geofence</span></th><th><span translate="">Good (Km)</span></th><th><span translate="">Bad (Km)</span></th><th><span translate="">NA (Km)</span></th></tr></thead><tbody><tr ng-repeat="assethealth in vm.assetHealthDistance" ng-show="vm.assetHealthDistance.length>0"><td>{{assethealth.name}}</td><td>{{assethealth.okDistance}}</td><td>{{assethealth.notOkDistance}}</td><td>{{assethealth.normalDistance}}</td></tr><tr><td colspan="10" ng-show="vm.assetHealthDistance.length == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div></div></div></div><div id="modalAssetAttributes" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Asset Attributes</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body"><div id="assetAttributeTable"></div></div></form></div></div></div><div id="modalThreePointReference" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameThreePointReference" class="span__modal-header">3 Point Reference</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeThreePointReference()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body"><div id="threePointReferenceTable"></div></div></form></div></div></div>');
$templateCache.put('app/report/asset-health-status-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-heartbeat"></i> &nbsp;<span> Asset Health Status Report</span></h3></div><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="onMasterChange();" required><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><br><div class="form-group" ng-show="vm.selectedMasterGeofenceId"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedGeofenceId" ng-change="onMiniChange();" required><option value="">Select Geofence</option><option ng-repeat="item in vm.geofenceMini" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="row" ng-show="vm.assetRecords" style="margin: 20px;"><button class="btn btn-primary btn-sm pull-right" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAssetHealthStatusReport()" style="margin: 20px;">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th style="width: 2%;"></th><th jh-sort-by="assetId"><span>Asset Id </span><span class="fa fa-sort"></span></th><th jh-sort-by="assetName"><span>Asset Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="assetStatus"><span>Asset Status </span><span class="fa fa-sort"></span></th><th jh-sort-by="geofenceName"><span>Geofence Name</span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat-start="assetRecord in vm.assetRecords | filter:search" ng-class="{selected: assetRecord.isChecked}"><!-- <td style="position:relative; padding-left: 1px;width: 2%">\r\n                                            <button ng-click="vm.caseTable(assetRecord);" expand\r\n                                                style="padding: 4px 4px;position: absolute;margin-top: -6px;">\r\n                                            <span ng-bind="assetRecord.isExpanded ? \'-\' : \'+\'"\r\n                                                    style="position: absolute;margin-top: -11px;margin-left: -4px;"></span>\r\n                                            </button>\r\n                                        </td> --><td class="td__listViewRow" ng-click="vm.caseTable(assetRecord);" expand><span ng-if="!assetRecord.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="assetRecord.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{assetRecord.assetId}}</td><td>{{assetRecord.assetName}}</td><td>{{assetRecord.assetStatus}}</td><td>{{assetRecord.geofenceName}}</td></tr><tr ng-show="assetRecord.isExpanded"><td></td><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 27px;"><thead><tr></tr></thead><tbody><tr ng-repeat-start="case in vm.caseRecords"><td>{{case.id}}</td><td>{{case.description}}</td><td>{{case.createDate | date:\'medium\'}}</td><td>{{case.status}}</td><td>{{case.reportedByUser}}</td><td>{{case.assignedToUser}}</td></tr><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.assetRecords == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/report/asset-kml-dump-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span>Create New Request</span></h3></div><!-- /.box-header --><!-- form start --><div class="col-md-12 mt-5"><span ui-sref="dashboard" class="fa fa-arrow-left" style="font-size: 15px;cursor: pointer;color:#000">Back</span></div><form class="form-horizontal" name="entityForm" ng-submit="entityDump()"><div class="box-body border"><div class="form-group" ng-if="vm.entity==\'Assets\' && (has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="onMasterChange();" required><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && vm.selectedMasterGeofenceId>0 && (has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.geofenceMini" output-model="vm.selectedGeofenceId" button-label="name" item-label="name" tick-property="ticked" selection-mode="single" helper-elements="all none filter" output-properties="id geofenceDTO"></div><input type="text" ng-model="vm.selectedGeofenceId" name="vm.searchMini" style="display:none" required></div></div><!-- <div class="form-group"\n\t\t\t\t\t\t\tng-if="vm.entity==\'Assets\' && vm.selectedGeofenceId!=null &&(has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)">\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\n\t\t\t\t\t\t\t\t<span>Select Task</span><sup><span class="required-icon"><i\n\t\t\t\t\t\t\t\t\t\t\tclass="fa fa-asterisk text-danger"></i></span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-3">\n\t\t\t\t\t\t\t\t<select class="form-control" ng-model="vm.entityTask" required>\n\t\t\t\t\t\t\t\t\t<option value="">--- Select Task ---</option>\n\t\t\t\t\t                <option value="UPDATE">UPDATE</option>\n                                    <option value="DOWNLOAD">DOWNLOAD</option>\n\t\t\t\t\t            </select>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div> --><div class="form-group" ng-if="vm.entityTask==\'DOWNLOAD\'"><label class="col-md-3 control-label"><span>Select Source</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" ng-model="vm.entitySource" required><option value="">--- Select Source ---</option><option value="DB">DB</option><option value="ES">ES</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm pull-right" ng-disabled="entityForm.$invalid">Submit</button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/asset-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-bandcamp"></i> <span translate="trakeyeApp.report.asset-report">Asset Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="assetForm" ng-submit="assetReport()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">From Date <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-2"><div class="input-group"><input type="text" id="date" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label assetReport_toDate">To Date <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><span class="dateError col-md-2" ng-if="vm.fromDate > vm.toDate">To date should be greater than from date</span></div><div class="form-group"><label class="col-sm-3 control-label ng-scope" translate="report.report">Report</label><div class="col-sm-8" ng-init="assetreportbutton=\'option1\'"><label class="radio-inline"><input type="radio" ng-model="assetreportbutton" value="option1" checked="checked" ng-change="clearSearch()"> Asset Report</label> <label class="radio-inline"><input type="radio" ng-model="assetreportbutton" value="option2" ng-change="clearSearch()"> Asset Case Attribute Report</label></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_asset"><span translate="trakeyeApp.report.asset">Asset</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><input list="assetlist" class="form-control" id="asset_list" placeholder="Search Asset" type="text" ng-model="vm.assetType" autocomplete="off" name="assetList" ng-change="vm.filterAssetsList()" required><datalist ng-hide="vm.assetList" id="assetlist" class="form-control1" required><option ng-repeat="asset in vm.assetList" value="{{asset.name}}"></datalist></div></div><div class="form-group" ng-if="assetreportbutton == \'option2\'"><label class="col-md-3 control-label"><span translate="trakeyeApp.report.casetype">caseType</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="caseType" ng-model="vm.caseType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.caseTypes track by item.id" required><option value="" translate="trakeyeApp.report.selectcase">--- Select CaseType ---</option></select></div></div><div class="form-group" ng-if="assetreportbutton == \'option2\'"><label class="col-md-3 control-label"><span translate="trakeyeApp.report.attribute">Attribute</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="attribute" ng-model="vm.attribute" ng-options="attribute as attribute.caseTypeAttribute.name for attribute in vm.attributeValues" required><option value="" translate="trakeyeApp.report.selectattribute">--- Select Attribute ---</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="assetForm.$invalid || vm.toDate < vm.fromDate">Submit</button></div></div></form></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><div ng-if="assetreportbutton == \'option2\'"><div id="asset_graph"></div></div><div ng-if="assetreportbutton == \'option1\'"><div id="asset_graph"></div></div></div></div><!--  added for heightchart end --></div>');
$templateCache.put('app/report/battery-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-battery-full"></i> <span translate="global.menu.battery-report">Battery Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="batteryreportForm" ng-submit="batteryreport()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label battery_toDate">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" required ng-model="vm.userid" ng-options="item.id as item.login for item in vm.batteryusers"><option value="">Select UserName</option><option ng-repeat="user in vm.batteryusers" value="user.id">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="batteryreportForm.$invalid">Submit</button></div></div></form></div></div></div><!--  added for heightchart start --><!--<div class="row" ng-if="batteryreport">\n\t\t<div id="linegraphdiv">\n\t\t\t<div class="col-md-10 col-md-offset-1">\n\t\t\t\t<div class="box box-solid">\n\t\t\t\t\t<div class="box-header">\n\t\t\t\t\t\t<h3 class="box-title">Battery Line Graph</h3>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="box-body chart-responsive">\n\t\t\t\t\t\t<div id="linegraphmessage">\n\t\t\t\t\t\t\t<p class="text-danger">No battery data available for the given input</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div id="battery_graph"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>--><div class="row"><div class="col-md-10 col-md-offset-1"><div id="battery_graph"></div></div></div><!--  added for heightchart end --><div class="row"><!-- Map box --><div class="col-md-12"><!-- <div class="box box-solid">\n                <div class="box-body chart-responsive">\n                    <h4 style="text-align: center;">Battery Reports</h4>\n                    <div id="line-chart" style="height: 285px; position: relative;"></div>\n                </div>\n            </div> --></div></div></div><style>.axis path,\n    .axis line {\n        fill: none;\n        stroke: grey;\n        stroke-width: 1;\n        shape-rendering: crispEdges;\n    }</style>');
$templateCache.put('app/report/burried-chamber-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> &nbsp;<span> Buried Chamber Report</span></h3></div><form class="form-horizontal" name="entityForm"><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="vm.onMasterChange();" required><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-show="vm.selectedMasterGeofenceId"><label class="col-md-3 control-label"><span>Select Mini</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedGeofenceId" ng-change="vm.onMiniChange();" required><option value="">Select Mini</option><option ng-repeat="item in vm.geofenceMini" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-show="vm.selectedGeofenceId && vm.assets.length > 0"><label class="col-md-3 control-label"><span>Select Asset</span></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedAssetId" ng-change="vm.onAssetChange();"><option value="">Select Asset</option><option ng-repeat="item in vm.assets" value="{{item.id}}">{{item.name}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button ng-click="vm.surveyReport()" class="btn btn-primary btn-sm pull-left" style="margin: 20px;" ng-disabled="entityForm.$invalid">Submit</button></div><div class="col-md-2 col-md-offset-3 pull-right"><button class="btn btn-primary btn-sm pull-right" ng-click="vm.downloadBurriedReport()" style="margin: 20px;" ng-disabled="entityForm.$invalid">Download CSV <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div><div class="col-md-12 table-responsive mt-10" ng-if="vm.burriedReportList != null || vm.burriedReportList != undefined"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr ng-if="vm.selectedAssetId==0 || vm.selectedAssetId==undefined"><th>SL No.</th><th>Asset Id</th><th>Asset Name</th><th>Buried</th><th>Updated By</th><th>Updated Date</th></tr><tr ng-if="vm.selectedAssetId>0"><th>Asset Id</th><th>Asset Name</th><th>New Buried Status</th><th>Old Buried Status</th><th>Created By</th><th>Created Date</th><th>Last Modified By</th><th>Last Modified Date</th></tr></thead><tbody><tr ng-repeat="asset in vm.burriedReportList | filter:search" ng-if="vm.burriedReportList.length>0 && (vm.selectedAssetId==0 || vm.selectedAssetId==undefined)"><td>{{asset.slno}}</td><td>{{asset.assetid}}</td><td>{{asset.assetname}}</td><td>{{asset.burried === \'true\' || asset.burried === \'Yes\' ? \'Yes\' : \'No\'}}</td><td>{{asset.updatedBy}}</td><td>{{asset.updatedDate | date:\'medium\'}}</td></tr><tr ng-repeat="asset in vm.burriedReportList | filter:search" ng-if="vm.burriedReportList.length>0 && vm.selectedAssetId>0"><td>{{asset.assetId}}</td><td>{{asset.assetName}}</td><td>{{asset.newValue === \'true\' || asset.newValue === \'Yes\' ? \'Yes\' : \'No\'}}</td><td>{{asset.oldValue === \'true\' || asset.oldValue === \'Yes\' ? \'Yes\' : \'No\'}}</td><td>{{asset.createdBy}}</td><td>{{asset.createdDate | date:\'medium\'}}</td><td>{{asset.lastModifiedBy}}</td><td>{{asset.lastModifiedDate | date:\'medium\'}}</td></tr><tr><td colspan="10" ng-show="vm.burriedReportList.length == 0"><h4>No data available</h4></td></tr></tbody></table></div></div></div></form></div></div></div></div>');
$templateCache.put('app/report/case-aging-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-bar-chart"></i> <span translate="trakeyeApp.caseAging.report">Case Aging Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label" translate="trakeyeApp.caseAging.agerange">Age Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="WEEKS"> <span translate="trakeyeApp.caseAging.agerangevalue.weeks">WEEKS</span></label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="MONTHS"> <span translate="trakeyeApp.caseAging.agerangevalue.months">MONTHS</span></label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="YEARS"> <span translate="trakeyeApp.caseAging.agerangevalue.years">YEARS</span></label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="DAYS"> <span translate="trakeyeApp.caseAging.agerangevalue.days">DAYS</span></label></div></div><div class="form-group" ng-if="vm.dateRange == \'DAYS\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" ng-model="vm.reportGeofence"><option value="">Select Geofence</option><option ng-repeat="geofence in vm.geofence" ng-selected="vm.reportGeofence" value="{{geofence.id}}">{{geofence.name}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="report()">Submit</button></div><div><button ng-if="vm.reportGenerated" class="btn btn-primary center-block" ng-click="downloadCaseAgingReport()">Download CSV <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div><div class="container" style="overflow-x: scroll;overflow-y: hidden;width: 100%;" ng-show="vm.data.length>0"><!-- <button class="btn btn-primary center-block" ng-click="getPdf()"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="reportpdf"><!-- <div class="col-md-12" data-ng-bind-html="myhtml | trustFilter"> --></div><h3 style="margin-left: 300px;margin-bottom: 50px;" ng-show="vm.reportGenerated">Case aging report by <span style="text-transform: lowercase;">{{vm.dateRange}}</span></h3><div class="col-md-12"><div id="virticalBarchart"></div></div><div style="margin-top: 10px;"><table ng-show="vm.reportGenerated" border="2px" style="width: 1000px;"><thead style="background-color: rgb(190, 192, 240);"><tr class="caseHeading"><th>Case Number</th><th>Age</th><th>Status</th><th>Created date</th><th>Assigned To</th><th>Priority</th></tr></thead><tbody><tr ng-repeat="case in vm.data" style="text-align: center;"><td>{{case.id}}</td><td>{{case.ageType}}</td><td>{{case.status}}</td><td>{{case.createDate | date:\'medium\'}}</td><td>{{case.assignedToName}}</td><td>{{case.priority}}</td></tr></tbody></table></div></div><div class="container" ng-show="vm.data.length == 0"><h3 style="margin-left: 300px;">No data available</h3></div><hr>');
$templateCache.put('app/report/case-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="global.menu.reportcharts.case-report">Generic Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label" translate="report.report">Report</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="report" class="report" ng-model="vm.reportType" value="AGENT" required ng-click="vm.reportTypeChange()"><span>User-Agent</span></label> <label class="radio-inline"><input type="radio" name="report" class="report" ng-model="vm.reportType" value="GEOFENCE" ng-click="vm.reportTypeChange()">Geofence</label></div></div><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-1 control-label">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group" ng-if="vm.reportType == \'AGENT\'"><label class="col-sm-3 control-label">User-Agent Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="AGENT" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'AGENT\' && vm.userAgent==\'AGENT\'"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><!-- useragent Report --><!-- Geofence Report --><div class="form-group" ng-if="vm.reportType == \'GEOFENCE\'"><label class="col-sm-3 control-label">Geofence Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="geofence" required ng-model="vm.geofence" value="GEOFENCE" ng-click="vm.select2()">Geofence Name</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.geofence" value="all">All Geofence</label></div></div><div class="form-group" ng-if="vm.reportType == \'GEOFENCE\' && vm.geofence == \'GEOFENCE\'"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-7"><select class="form-control select2" name="search" required id="geofences" ng-model="vm.id" ng-options="item.id as item.name for item in vm.geofences"><option value="">Select Geofence</option></select></div></div><!--Geofence Report --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><div style="display: block;" class="birt-graph" data-ng-bind-html="myhtml | trustFilter"></div></div></div></div>');
$templateCache.put('app/report/case-tat-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="trakeyeApp.caseTat.title">Case TAT Report</span></h3></div><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label" translate="trakeyeApp.caseTat.agerange">Age Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="MONTHS"> <span translate="trakeyeApp.caseTat.agerangevalue.months">MONTHS</span></label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="DAYS"> <span translate="trakeyeApp.caseTat.agerangevalue.days">DAYS</span></label><!--  <label class="radio-inline pl-10"><input type="radio"\r\n\t\t\t\t\t\t\t\t\tname="dateRange" ng-model="vm.dateRange" value="custom">Custom</label>--></div></div><div class="form-group" ng-if="vm.dateRange == \'DAYS\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.caseTat.tat">TAT</span></label><div class="col-md-1"><input type="number" class="form-control" name="tat" ng-model="vm.tat" ngminlength="1" ngmaxlength="1000" min="1" max="1000"></div><label class="col-sm-2 control-label tatReport_selectUser"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" ng-model="vm.reportUser"><option value="">Select UserName</option><option ng-repeat="item in vm.users" title="{{item.login}}" ng-selected="{{item.login == vm.reportUser}}" value="{{item.login}}">{{item.login}}</option></select></div></div><div class="form-group"></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div></div><div class="content" style="overflow: scroll;overflow-x: scroll;overflow-y:hidden"><!-- <button class="btn btn-primary center-block"  ng-click="getPdf()"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="reportpdf"><div class="col-md-12" data-ng-bind-html="myhtml | trustFilter"></div><!-- <div class="col-md-12">\r\n\t\t\t<div id="verticalBarChart" style="width: 100%;height: 100%;"></div>\r\n\t\t</div> --></div>');
$templateCache.put('app/report/case-type-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="global.menu.reportcharts.case-report">CaseType Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label">Case Type Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="case" required ng-model="vm.selectCaseType" value="1">Case Type</label> <label class="radio-inline"><input type="radio" name="case" ng-model="vm.selectCaseType" value="all">All Cases</label></div></div><div class="form-group" ng-if="vm.selectCaseType == 1"><label class="col-sm-3 control-label"><span>Select Case Type</span></label><div class="col-sm-4"><select class="select2 form-control" name="caseType" ng-model="vm.selectedCaseType" ng-options="item as item.name for item in\n\t\t\t\t\t\t\t\t\tvm.caseTypes track by item.id" style="width: 100%;" value="{{item.id}}"><option value="">--- Select CaseType ---</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" ng-click="vm.submitCaseReport()" translate="upload.submit">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadCaseReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div><div class="content"><div class="row" ng-if="reporthide"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-body"><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="id"><span>ID </span><span class="fa fa-sort"></span></th><th jh-sort-by="description"><span>Description </span><span class="fa fa-sort"></span></th><th jh-sort-by="status"><span>Status </span><span class="fa fa-sort"></span></th><th jh-sort-by="caseTypeName"><span>Case Type </span><span class="fa fa-sort"></span></th><th jh-sort-by="address"><span>Address </span><span class="fa fa-sort"></span></th><th jh-sort-by="pinLat"><span>Latitude </span><span class="fa fa-sort"></span></th><th jh-sort-by="pinLong"><span>Longitude </span><span class="fa fa-sort"></span></th><th jh-sort-by="assignedToUser"><span>Assigned To </span><span class="fa fa-sort"></span></th><th jh-sort-by="reportedByUser"><span>Reported By </span><span class="fa fa-sort"></span></th><th jh-sort-by="updatedByUser"><span>Updated By </span><span class="fa fa-sort"></span></th><th jh-sort-by="assignedByUser"><span>Assigned By </span><span class="fa fa-sort"></span></th><th jh-sort-by="createDate"><span>Created Date </span><span class="fa fa-sort"></span></th><th jh-sort-by="updateDate"><span>Updated Date </span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td>{{record.id}}</td><td>{{record.description}}</td><td>{{record.status}}</td><td>{{record.caseTypeName}}</td><td>{{record.address}}</td><td>{{record.pinLat}}</td><td>{{record.pinLong}}</td><td>{{record.assignedToUser}}</td><td>{{record.reportedByUser}}</td><td>{{record.updatedByUser}}</td><td>{{record.assignedByUser}}</td><td><span>{{record.createDate | date:\'medium\'}}</span></td><td><span>{{record.updateDate | date:\'medium\'}}</span></td></tr></tbody></table></div></div></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><div style="display: block;" class="birt-graph" data-ng-bind-html="myhtml | trustFilter"></div></div></div></div></div>');
$templateCache.put('app/report/cases-dump-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate=" ">Download Cases</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-4 control-label">Select Type</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="type" ng-model="vm.downloadType" value="opencases">Open Cases</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.downloadType" value="closedcases">Closed Cases</label></div></div><div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessage"><h1>THANK YOU!</h1><i class="fa fa-check main-content__checkmark" style="font-size:96px;color: green;"></i><p>Action has been taken.</p><p>We are now generating the report</p></div></div><div class="box-footer"><div><button class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" ng-click="vm.downloadCaseDumpReport()" style="margin: 20px;">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/distance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="global.menu.reportcharts.distance-report">Generic Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-1 control-label">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" required ng-model="vm.userid" ng-options="item.login as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.login">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><div style="display: block;" class="birt-graph" data-ng-bind-html="myhtml | trustFilter"></div></div></div></div>');
$templateCache.put('app/report/distance-travelled.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-motorcycle"></i> <span translate="global.menu.distance-travelled">Distance Travelled</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="distanceForm" ng-submit="distancereport()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label dstnTrvld_toDate">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" required ng-model="vm.userid" ng-options="item.id as item.login for item in vm.batteryusers"><option value="">Select UserName</option><option ng-repeat="user in vm.batteryusers" value="user.id">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="distanceForm.$invalid">Submit</button></div></div></form></div></div></div><!--  added for heightchart start --><!--<div class="row" ng-if="batteryreport">\n\t\t<div id="linegraphdiv">\n\t\t\t<div class="col-md-10 col-md-offset-1">\n\t\t\t\t<div class="box box-solid">\n\t\t\t\t\t<div class="box-header">\n\t\t\t\t\t\t<h3 class="box-title">Battery Line Graph</h3>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="box-body chart-responsive">\n\t\t\t\t\t\t<div id="linegraphmessage">\n\t\t\t\t\t\t\t<p class="text-danger">No battery data available for the given input</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div id="battery_graph"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>--><div class="row"><div class="col-md-10 col-md-offset-1"><div id="distance_graph"></div></div></div><!--  added for heightchart end --><div class="row"><!-- Map box --><!-- <div class="col-md-12">\n            <div class="box box-solid">\n                <div class="box-body chart-responsive">\n                    <h4 style="text-align: center;">Distance Travelled Reports</h4>\n                    <div id="line-chart" style="height: 285px; position: relative;"></div>\n                </div>\n            </div>\n        </div> --></div></div><style>.axis path,\n    .axis line {\n        fill: none;\n        stroke: grey;\n        stroke-width: 1;\n        shape-rendering: crispEdges;\n    }</style>');
$templateCache.put('app/report/entity-dump-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span>Create New Request</span></h3></div><!-- /.box-header --><!-- form start --><div class="col-md-12 mt-5"><span ui-sref="entity-dump" class="fa fa-arrow-left" style="font-size: 15px;cursor: pointer;color:#000">Back</span></div><form class="form-horizontal" name="entityForm" ng-submit="entityDump()"><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select Entity</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="entity" ng-model="vm.entity" required><option value="">--- Select Entity ---</option><option value="Assets" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD">Assets</option><option value="Cases">Cases</option><option value="Users">Users</option></select></div></div><div class="form-group" ng-if="(vm.entity==\'Assets\' && (has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)) || (vm.entity==\'Cases\')"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="onMasterChange();" required><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-if="(vm.entity==\'Assets\' && vm.selectedMasterGeofenceId>0 && (has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)) ||(vm.entity==\'Cases\')"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.geofenceMini" output-model="vm.selectedGeofenceId" button-label="name" item-label="name" tick-property="ticked" helper-elements="all none filter" output-properties="id geofenceDTO"></div><input type="text" ng-model="vm.selectedGeofenceId" name="vm.searchMini" style="display:none" required></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && (has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select Asset Layout</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="layout" ng-model="vm.entityLayout" ng-change="assetLayoutChange()" required><option value="">--- Select Asset Layout ---</option><option value="FIXED">FIXED</option><option value="SPREAD">SPREAD</option></select></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && vm.entityLayout.length >0 && (has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select Asset Type</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.assetTypes" selection-mode="single" output-model="vm.selectedAssettypeId" button-label="name" item-label="name" tick-property="ticked" helper-elements="all none filter" output-properties="id"></div><input type="text" ng-model="vm.selectedAssettypeId" name="vm.searchMini" style="display:none" required></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && vm.selectedAssettypeId.length > 0 &&(has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select File Format</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" ng-model="vm.entityFileFormat" required><option value="">--- Select File Format ---</option><option value="CSV">CSV</option><option value="KML">KML</option><!-- <option value="EXCEL">EXCEL</option> --></select></div></div><div class="form-group" ng-if="vm.entity==\'Cases\'"><label class="col-sm-3 control-label">Select Type</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="type" ng-model="vm.entityStatus" value="ALL">All</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.entityStatus" value="OPEN">Open Cases</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.entityStatus" value="CLOSED">Closed Cases</label></div></div><div class="form-group" ng-if="(vm.entityStatus == \'OPEN\' || vm.entityStatus == \'CLOSED\' || vm.entityStatus == \'ALL\') && vm.entity==\'Cases\' && (has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)"><div class="form-group"><label class="col-sm-3 control-label">Select</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="case" ng-model="vm.selectCaseType" value="all">All</label> <label class="radio-inline"><input type="radio" name="case" required ng-model="vm.selectCaseType" value="1">Case Type</label></div></div><div class="form-group" ng-if="vm.selectCaseType == 1"><label class="col-sm-3 control-label"><span>Select Case Type</span></label><div class="col-sm-4"><select class="select2 form-control" name="caseType" ng-model="vm.selectedCaseType" ng-options="item as item.name for item in\r\n\t\t\t\t\t\t\t\t\t\tvm.caseTypes track by item.id" style="width: 100%;" value="{{item.id}}"><option value="">--- Select CaseType ---</option></select></div></div><div class="form-group" ng-if="(vm.selectCaseType == 1 && vm.selectedCaseType.id>0) || vm.selectCaseType == \'all\' "><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" datepicker-options="optionsFrom" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" datepicker-options="optionsTo" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><!-- <div class="form-group" ng-show="vm.entity !== \'Asset\'">\r\n\t\t\t\t\t\t\t<label class="col-sm-3 control-label">From Date</label>\r\n\t\t\t\t\t\t\t<div class="col-sm-3">\r\n\t\t\t\t\t\t\t\t<div class="input-group">\r\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="fromDate" required disabled\r\n\t\t\t\t\t\t\t\t\t\tdatetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate"\r\n\t\t\t\t\t\t\t\t\t\tng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate" />\r\n\t\t\t\t\t\t\t\t\t<span class="input-group-btn">\r\n\t\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-default"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.openCalendar(\'fromDate\')">\r\n\t\t\t\t\t\t\t\t\t\t\t<i class="glyphicon glyphicon-calendar"></i>\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t<label class="col-sm-2 control-label">To Date</label>\r\n\t\t\t\t\t\t\t<div class="col-sm-3">\r\n\t\t\t\t\t\t\t\t<div class="input-group">\r\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="toDate" required disabled\r\n\t\t\t\t\t\t\t\t\t\tdatetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate"\r\n\t\t\t\t\t\t\t\t\t\tng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate" />\r\n\t\t\t\t\t\t\t\t\t<span class="input-group-btn">\r\n\t\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-default"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.openCalendar(\'toDate\')">\r\n\t\t\t\t\t\t\t\t\t\t\t<i class="glyphicon glyphicon-calendar"></i>\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessage"><h1>THANK YOU!</h1><i class="fa fa-check main-content__checkmark" style="font-size:96px;color: green;"></i><!-- <p>Your Request Has Been Successfully Recorded.</p>\r\n\t\t\t\t\t\t\t<p>Please Expect Email Soon..</p> --><p>Your Tracking Id is {{vm.trackingId}}</p></div><div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessageError"><h1>Error</h1><i class="fa fa-times main-content__checkmark" style="font-size:96px;color: red;"></i><p>{{vm.errorMessage}}</p></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm pull-right" ng-disabled="entityForm.$invalid">Submit</button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/entity-dump.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="glyphicon glyphicon-envelope"></i> &nbsp;<span> Entity Dump</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="entity-dump.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><i class="fa fa-refresh" aria-hidden="true" style="font-size: 20px;cursor: pointer;color:#000" title="Refresh" ng-click="vm.refresh()"></i><div class="table-responsive mt-10"><table class="table table-responsive table-hover"><thead class="bg-default"><tr><th></th><!-- <th>ID</th> --><th>Entity Name</th><th>Entity Layout</th><th>Entity Status</th><th>Geofence Name</th><th>Request From Date</th><th>Request To Date</th><th><span>Status</span></th><th><span>Created Date</span></th><th></th><!-- <th><span>Type</span> <span\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-sort"></span></th> --></tr></thead><tbody><tr ng-repeat-start="list in vm.displayList track by list.id" ng-class="{greenyellow: $index === 0 && vm.highlightRow }"><td class="td__listViewRow" ng-click="vm.expand(list);" ng-show="(list.entityName == \'CASES\' || list.entityName == \'ASSETS\') && list.messageStatus == \'COMPLETE\'"><span ng-if="!list.expand"><i class="fa fa-plus-square" aria-hidden="true" title="Details"></i></span> <span ng-if="list.expand"><i class="fa fa-minus-square" aria-hidden="true" title="Details"></i></span></td><td ng-hide="(list.entityName == \'CASES\' || list.entityName == \'ASSETS\') && list.messageStatus == \'COMPLETE\'"></td><!-- <td>\r\n                                         {{list.id}}\r\n                                    </td> --><td>{{list.entityName}}</td><td><span ng-show="list.entityLayout != null">{{list.entityLayout}}</span> <span ng-show="list.entityLayout == null"></span></td><td><span ng-show="list.entityStatus != null">{{list.entityStatus}}</span> <span ng-show="list.entityStatus == null"></span></td><!-- <td>\r\n                                        <div ng-repeat="geofenceVal in list.geofences">\r\n                                            <span style="display: block;width: 250px;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{geofenceVal.name}}</span>\r\n                                        </div>\r\n                                    </td> --><td><span ng-show="list.geofenceName != null">{{list.geofenceName}}</span> <span ng-show="list.geofenceName == null"></span></td><td><span ng-show="list.reqFromDate != null">{{list.reqFromDate | date: "dd/MM/yyyy \'at\' h:mma"}}</span> <span ng-show="list.reqFromDate == null"></span></td><td><span ng-show="list.reqToDate != null">{{list.reqToDate | date: "dd/MM/yyyy \'at\' h:mma"}}</span> <span ng-show="list.reqToDate == null"></span></td><td><span class="label label-info" ng-if="list.messageStatus == \'OPEN\'">{{list.messageStatus}}</span> <span class="label label-success" ng-if="list.messageStatus == \'COMPLETE\'">{{list.messageStatus}}</span> <span class="label label-danger" ng-if="(list.messageStatus !== \'OPEN\') && (list.messageStatus !== \'COMPLETE\')">{{list.messageStatus}}</span></td><td>{{list.createdDate | date: "dd/MM/yyyy \'at\' h:mma"}}</td></tr><tr ng-show="list.expand"><td colspan="11"><table style="width: 40%; height:100%; border-spacing:0; margin-left: 3%;"><thead><tr><th>Sl No</th><!--  <th>Report Name</th> --><th>File Name</th><th>Type</th></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td>{{$index+1}}</td><!-- <td>{{item.imageName}}</td> --><td ng-click="vm.download(item.imageId,item.trackerId,item.imageName)"><a>{{item.imageName}}</a></td><td>{{item.imageType}}</td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.displayList.length == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/report/fiber-status-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-line-chart"></i> <span>Fiber Status Reports</span></h3></div><form class="form-horizontal" name="batteryreportForm"><div class="box-body border" style="height: 120px"><div class="form-group" style="margin-top: 30px;"><label class="col-sm-2 control-label"><span>Select Vendor</span></label><div class="col-sm-2"><select id="userlist" class="select2 form-control" style="width: 220px; height: 40px"><option value="">---All Vendors---</option><option ng-repeat="item in vm.userlist" value="{{item.id}}">{{item.firstName}} {{item.lastName}}</option></select></div></div></div><div class="col-sm-7" style="margin-top: 20px"><div class="box box-solid"><div class="box-body"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Fiber Provider</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>On Air</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Under Deployment</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Planned</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.multiassets track by asset.name"><td data-ng-click="vm.caseTypeClick(asset.name,\'\')" style="text-align:center;vertical-align:middle">{{asset.name}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'On Air\')" style="text-align:center;vertical-align:middle">{{asset.onair}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'Under Deployment\')" style="text-align:center;vertical-align:middle">{{asset.deployed}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'Planned\')" style="text-align:center;vertical-align:middle">{{asset.planned}}</td></tr></tbody></table></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Name</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Fiber Status</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Distance</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Link Status</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.assets track by asset.name"><td data-ng-click="vm.caseTypeClick(asset.name,\'\')" style="text-align:center;vertical-align:middle">{{asset.name}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'On Air\')" style="text-align:center;vertical-align:middle">{{asset.status}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'Under Deployment\')" style="text-align:center;vertical-align:middle">{{asset.distance}}</td><td style="text-align:center;vertical-align:middle">{{asset.linkstatus}}</td></tr></tbody></table></div></div></div></div><div class="col-sm-5" style="margin-top: 20px"><div style="text-align: center"><div class="box box-solid"><div class="box-body chart-responsive" style="text-align: center"><h3>On Air Status</h3><div class="chart" id="vendor-chart" style="height: 285px; position: relative;"></div></div><!-- /.box-body --></div></div><div style="text-align: center"><div class="box box-solid"><div class="box-body chart-responsive" style="align-content: center"><h3>Fiber Status</h3><div class="chart" id="fiber-chart" style="height: 285px; position: relative;"></div></div><!-- /.box-body --></div></div></div></form></div></div></div></div>');
$templateCache.put('app/report/geofence-dump.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate=" ">Geofence Dump</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label"><span>Select geofence</span></label><div class="col-sm-4"><select class="select2 form-control" name="search" ng-model="vm.selectedGeofenceId" ng-options="item.id as item.nameZone for item in vm.geofences" required><option value="">Select geofence</option><option ng-repeat="geofence in vm.geofences" value="geofence.id">{{geofence.nameZone}}</option></select></div></div></div><div class="box-footer"><div><button class="btn btn-primary pull-left" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download CSV <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div><div><button class="btn btn-primary pull-right" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReportKml()">Download KML <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/geofence-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span>Geofence Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group" ng-if="vm.reportType == \'agent\'"><label class="col-sm-3 control-label">User-Agent Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'agent\' && vm.userAgent==\'username\'"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><!-- useragent Report --><!-- Geofence Report --><div class="form-group" ng-if="vm.reportType == \'geofence\'"><label class="col-sm-3 control-label">Geofence Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="geofence" required ng-model="vm.geofence" value="geofence" ng-click="vm.select2()">Geofence Name</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.geofence" value="all">All Geofence</label></div></div><div class="form-group" ng-if="vm.reportType == \'geofence\' && vm.geofence == \'geofence\'"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-7"><select class="form-control select2" name="search" required id="geofences" ng-model="vm.id" ng-options="item.id as item.name for item in vm.geofences"><option value="">Select Geofence</option></select></div></div><!--Geofence Report --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div><div class="row" ng-if="reporthide"><div class="col-md-10 col-md-offset-1"><!-- Map box --><div class="box box-solid"><div class="box-body"><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th ng-if="vm.reportType==\'agent\'"><span>Login</span> </th> --><th ng-if="vm.reportType==\'geofence\'"><span>Name</span></th><!-- <th ng-if="vm.reportType==\'agent\'"><span>From Hour</span></th>\n\t\t\t\t\t\t\t\t\t<th ng-if="vm.reportType==\'agent\'"><span>To Hour</span> </th> --><th><span>Cases</span></th><!-- <th><span>Services</span> </th> --><!-- <th ng-if="vm.reportType==\'agent\'">Distance Within Geofence</th> --><!-- <th ng-if="vm.reportType==\'agent\'">Distance Outside Geofence</th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><!-- <td ng-if="vm.reportType==\'agent\'">{{record.login}}</td> --><td ng-if="vm.reportType==\'geofence\'">{{record.name}}</td><!-- \t<td ng-if="vm.reportType==\'agent\'">{{getLocalhour(record.fromTime)}}</td>\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.reportType==\'agent\'">{{getLocalhour(record.toTime)}}</td> --><td>{{record.cases}}</td><!-- <td>{{record.services}}</td>\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.reportType==\'agent\'">{{record.distance_in |\n\t\t\t\t\t\t\t\t\t\tnumber:2}} KM</td>\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.reportType==\'agent\'">{{record.distance_out |\n\t\t\t\t\t\t\t\t\tnumber:2}} KM</td> --><td><a href="" ng-click="vm.detailedReport(record.id)"><i class="fa fa-eye"></i></a></td></tr></tbody></table></div></div></div></div></div><div class="row"><div id="report" class="col-md-10 col-md-offset-1" style="display: none;"><!-- box content--><div class="box box-solid"><div class="box-header box-info"><button type="button" class="btn btn-info btn-flat pull-right" ng-click="close()">Close</button><h4 class="box-title text-left"><img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;"></h4></div><button class="btn btn-primary center-block" ng-click="getPdf()">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="box-body" ng-if="vm.reportType==\'geofence\'" id="reportpdf"><h4 class="text-center mt-5">Geofence Report for <b>{{vm.detailedReportCounts.name}}</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowCancelled}}</p></div></div></div></div></div><!-- Services --><!-- <div class="box box-solid">\n\n                        <div class="box-header">\n                            <h3 class="box-title">Services</h3>\n                        </div>\n                        <div class="box-body">\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-danger">Critical</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-success">High</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-primary">Medium</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                            <div class="col-sm-3">\n                                <h4 class="report-head text-warning">Low</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class="box box-solid"><div class="box-header"><h3 class="box-title">Geofence</h3></div><div class="box-body"><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:300px; width:100%;"></div></div></div></div></div></div><div class="box-body" ng-if="vm.reportType==\'agent\'" id="reportpdf"><!-- <div class="box-body" ng-if="vm.reportType==\'agent\'"> --><h4 class="text-center mt-5">Agent Report for <b>{{vm.detailedReportCounts.name}} ({{vm.detailedReportCounts.login}})</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Created by Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Assigned to Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowCancelled}}</p></div></div></div></div></div><!-- Services --><!-- <div class="box box-solid">\n                        <div class="box-header">\n                            <h3 class="box-title">Services</h3>\n                        </div>\n                        <div class="box-body">\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-danger">Critical</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-success">High</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-primary">Medium</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                            <div class="col-sm-3">\n                                <h4 class="report-head text-warning">Low</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class="box box-solid"><div class="box-header"><h3 class="box-title">Distanc IN</h3>{{vm.detailedReportCounts.distance_in | number:2}} KM<h3 class="box-title">Distanc OUT</h3>{{vm.detailedReportCounts.distance_out | number:2}} KM</div><!-- <div class="box-body">\n\t\t\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100%;"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div>');
$templateCache.put('app/report/gps-user-attendance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-motorcycle"></i> <span translate=" ">Distance Travelled Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\'"><label class="col-sm-4 control-label">User-Attendance Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10 table-scroll" ng-if=\'vm.userType=="gpsUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="userName"><span>Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="startTime"><span>Start Time </span><span class="fa fa-sort"></span></th><th><span>Start LatLng</span></th><th jh-sort-by="endTime"><span>End Time </span><span class="fa fa-sort"></span></th><th><span>End LatLng</span></th><th jh-sort-by="distanceIn">Distance Within Geofence <span class="fa fa-sort"></span></th><th jh-sort-by="distanceOut">Distance Outside Geofence <span class="fa fa-sort"></span></th><th jh-sort-by="totalDistance"><span>Distance </span><span class="fa fa-sort"></span></th><th jh-sort-by="createdCaseCount"><span>Case Created </span><span class="fa fa-sort"></span></th><th jh-sort-by="assignedCaseCount"><span>Case Assigned </span><span class="fa fa-sort"></span></th><th jh-sort-by="resolvedCaseCount"><span>Case Resolved </span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.totalDistance>0"><td>{{record.userName}}</td><td>{{record.startTime | date:\'medium\'}}</td><td>{{record.startLatLng}}</td><td>{{record.endTime | date:\'medium\'}}</td><td>{{record.endLatLng}}</td><td>{{record.distanceIn | number:2}} KM</td><td>{{record.distanceOut | number:2}} KM</td><td>{{record.totalDistance | number:2}} KM</td><!-- <td>{{record.createdCaseCount}}</td>\r\n                                     <td>{{record.assignedCaseCount}}</td>\r\n                                      <td>{{record.resolvedCaseCount}}</td> --><td><a ui-sref="tr-case.attendance({login:record.userId, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.createdCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.userId, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assignedCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.userId, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolvedCaseCount}}</a></td></tr></tbody></table></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="mobileUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Name</span></th><th><span>Check-In Time</span></th><th><span>Check-In Location</span></th><th><span>Check-In Address</span></th><th><span>Check-Out Time</span></th><th><span>Check-Out Location</span></th><th><span>Check-Out Address</span></th><th><span>Case Created</span></th><th><span>Case Assigned</span></th><th><span>Case Resolved</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.checkInTime>0||record.createdCaseCount>0||record.assignedCaseCount>0||record.resolvedCaseCount>0"><td>{{record.userName}}</td><td ng-if="record.checkInTime>0">{{record.checkInTime | date:\'medium\'}}</td><td>{{record.checkInLocation}}</td><td title="{{record.checkInAddress}}">{{record.checkInAddress | limitTo: 20 }}{{record.checkInAddress.length > 20 ? \'...\' : \'\'}}</td><td ng-if="record.checkInTime==0">NA</td><td ng-if="record.checkOutTime>0">{{record.checkOutTime | date:\'medium\'}}</td><td>{{record.checkOutLocation}}</td><td title="{{record.checkOutAddress}}">{{record.checkOutAddress | limitTo: 20 }}{{record.checkOutAddress.length > 20 ? \'...\' : \'\'}}</td><td ng-if="record.checkOutTime==0">NA</td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.createdCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assignedCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolvedCaseCount}}</a></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/mobile-user-attendance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate=" ">User Attendance Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- <div class="form-group">\r\n                            <label class="col-sm-4 control-label">User-Attendance Type</label>\r\n                            <div class="col-sm-6">\r\n                                <label class="radio-inline"><input type="radio" name="userType" required\r\n                                        ng-model="vm.userType" value="gpsUser">GPS-User</label>\r\n                                <label class="radio-inline"><input type="radio" name="userType" ng-model="vm.userType"\r\n                                        value="mobileUser">Mobile-User</label>\r\n                            </div>\r\n                        </div> --><!-- user attendance type --><!-- user attendance Report --><div class="form-group" ng-if="vm.userType == \'mobileUser\'"><label class="col-sm-4 control-label">User-Attendance Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.userType == \'mobileUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="attendanceDate"><span>Date </span><span class="fa fa-sort"></span></th><th jh-sort-by="userName"><span>Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="checkInTime"><span>Check-In Time </span><span class="fa fa-sort"></span></th><th><span>Check-In Location</span></th><th><span>Check-In Geofence Status</span></th><!-- <th><span>Check-In Address</span> </th> --><th jh-sort-by="checkOutTime"><span>Check-Out Time </span><span class="fa fa-sort"></span></th><th><span>Check-Out Location</span></th><th><span>Check-Out Geofence Status</span></th><th jh-sort-by="vendorName"><span>Vendor </span><span class="fa fa-sort"></span></th><!-- <th><span>Check-Out Address</span> </th> --><!-- <th><span>Case Created</span></th>\r\n                                    <th><span>Case Assigned</span></th>\r\n                                    <th><span>Case Resolved</span></th> --></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td style="white-space: nowrap;overflow: hidden;">{{record.attendanceDate}}</td><td>{{record.userName}}</td><td ng-if="record.checkInTime>0">{{record.checkInTime | date:\'medium\'}}</td><td ng-if="record.checkInTime==0">NA</td><td>{{record.checkInLocation}}</td><td>{{record.checkInGeofenceStatus}}</td><td ng-if="record.checkOutTime>0">{{record.checkOutTime | date:\'medium\'}}</td><td ng-if="record.checkOutTime==0">NA</td><td>{{record.checkOutLocation}}</td><td>{{record.checkOutGeofenceStatus}}</td><td>{{record.vendorName}}</td><!-- <td><a\r\n                                            ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.createdCaseCount}}</a>\r\n                                    </td>\r\n                                    <td><a\r\n                                            ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assignedCaseCount}}</a>\r\n                                    </td>\r\n                                    <td><a\r\n                                            ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolvedCaseCount}}</a>\r\n                                    </td> --></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="global.menu.generic-report">Generic Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label" translate="report.report">Report</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="report" class="report" ng-model="vm.reportType" value="agent" required ng-click="vm.reportTypeChange()"><span>User-Agent Report</span></label> <label class="radio-inline"><input type="radio" name="report" class="report" ng-model="vm.reportType" value="geofence" ng-click="vm.reportTypeChange()">Geofence Report</label></div></div><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group" ng-if="vm.reportType == \'agent\'"><label class="col-sm-3 control-label">User-Agent Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'agent\' && vm.userAgent==\'username\'"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><!-- useragent Report --><!-- Geofence Report --><div class="form-group" ng-if="vm.reportType == \'geofence\'"><label class="col-sm-3 control-label">Geofence Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="geofence" required ng-model="vm.geofence" value="geofence" ng-click="vm.select2()">Geofence Name</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.geofence" value="all">All Geofence</label></div></div><div class="form-group" ng-if="vm.reportType == \'geofence\' && vm.geofence == \'geofence\'"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-7"><select class="form-control select2" name="search" required id="geofences" ng-model="vm.id" ng-options="item.id as item.name for item in vm.geofences"><option value="">Select Geofence</option></select></div></div><!--Geofence Report --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div><div class="row" ng-if="reporthide"><div class="col-md-10 col-md-offset-1"><!-- Map box --><div class="box box-solid"><div class="box-header"><i class="fa fa-server"></i><h3 class="box-title" translate="global.menu.generic-report">Generic Reports</h3></div><div class="box-body"><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th ng-if="vm.reportType==\'agent\'"><span>Login</span></th><th ng-if="vm.reportType==\'geofence\'"><span>Name</span></th><!-- <th ng-if="vm.reportType==\'agent\'"><span>From Hour</span></th>\n\t\t\t\t\t\t\t\t\t<th ng-if="vm.reportType==\'agent\'"><span>To Hour</span> </th> --><th><span>Cases</span></th><th><span>Services</span></th><th ng-if="vm.reportType==\'agent\'">Distance Covered</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td ng-if="vm.reportType==\'agent\'">{{record.login}}</td><td ng-if="vm.reportType==\'geofence\'">{{record.name}}</td><!-- \t<td ng-if="vm.reportType==\'agent\'">{{getLocalhour(record.fromTime)}}</td>\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.reportType==\'agent\'">{{getLocalhour(record.toTime)}}</td> --><td>{{record.cases}}</td><td>{{record.services}}</td><td ng-if="vm.reportType==\'agent\'">{{record.distance | number:2}} KM</td><td><a href="" ng-click="vm.detailedReport(record.id)"><i class="fa fa-eye"></i></a></td></tr></tbody></table></div></div></div></div></div><div class="row"><div id="report" class="col-md-10 col-md-offset-1" style="display: none;"><!-- box content--><div class="box box-solid"><div class="box-header box-info"><button type="button" class="close" ng-click="close()">&times;</button><h4 class="box-title text-left"><img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;"></h4></div><button class="btn btn-primary center-block" ng-click="getPdf()">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="box-body" ng-if="vm.reportType==\'geofence\'" id="reportpdf"><h4 class="text-center mt-5">Geofence Report for <b>{{vm.detailedReportCounts.name}}</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Services --><div class="box-header"><h3 class="box-title">Services</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><div class="box-header"><h3 class="box-title">Geofence</h3></div><div class="box-body"><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:300px; width:100%;"></div></div></div></div></div></div><div class="box-body" ng-if="vm.reportType==\'agent\'" id="reportpdf"><!-- <div class="box-body" ng-if="vm.reportType==\'agent\'"> --><h4 class="text-center mt-5">Agent Report for <b>{{vm.detailedReportCounts.name}} ({{vm.detailedReportCounts.login}})</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Created by Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Assigned to Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Services --><div class="box-header"><h3 class="box-title">Services</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><div class="box-header"><h3 class="box-title">Distanc Covered</h3>{{vm.detailedReportCounts.distance | number:2}} KM</div><!-- <div class="box-body">\n\t\t\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100%;"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div>');
$templateCache.put('app/report/site-status-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-line-chart"></i> <span>Site Status Reports</span></h3></div><form class="form-horizontal" name="batteryreportForm"><div class="box-body border" style="height: 120px"><div class="form-group" style="margin-top: 30px;"><label class="col-sm-2 control-label"><span>Select Vendor</span></label><div class="col-sm-2"><select id="userlist" class="select2 form-control" style="width: 220px; height: 40px"><option value="">---All Vendors---</option><option ng-repeat="item in vm.userlist" value="{{item.id}}">{{item.firstName}} {{item.lastName}}</option></select></div></div></div><div class="col-sm-7" style="margin-top: 20px"><div class="box box-solid"><div class="box-body"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Asset Name</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>On Air</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Under Deployment</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Planned</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.multiassets track by asset.name"><td style="text-align:center;vertical-align:middle">{{asset.name}}</td><td style="text-align:center;vertical-align:middle">{{asset.onair}}</td><td style="text-align:center;vertical-align:middle">{{asset.deployed}}</td><td style="text-align:center;vertical-align:middle">{{asset.planned}}</td></tr></tbody></table></div></div></div></div><div class="col-sm-5" style="margin-top: 20px"><div style="text-align: center"><div class="box box-solid"><div class="box-body chart-responsive" style="text-align: center"><h3>Site Type On Air Distribution</h3><div class="chart" id="vendor-chart" style="height: 285px; position:;"></div></div></div></div></div><div class="row" ng-if="reporthide"><div class="col-sm-7" style="margin-top: 20px"><div class="box box-solid"><div class="box-body"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Asset Name</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>On Air</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Under Deployment</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Planned</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.multiassets track by asset.name"><td style="text-align:center;vertical-align:middle">{{asset.name}}</td><td style="text-align:center;vertical-align:middle">{{asset.onair}}</td><td style="text-align:center;vertical-align:middle">{{asset.deployed}}</td><td style="text-align:center;vertical-align:middle">{{asset.planned}}</td></tr></tbody></table></div></div></div></div><div class="col-sm-5" style="margin-top: 20px"><div style="text-align: center"><div class="box box-solid"><div class="box-body chart-responsive" style="text-align: center"><h3>Site Type On Air Distribution</h3><div class="chart" id="vendor-chart1" style="height: 285px; position:;"></div></div></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/report/splicing-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate="">Splicing Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><div class="col-sm-12"><label class="col-sm-3 control-label"><span>Select Case Type</span></label><div class="col-sm-4"><select class="select2 form-control" ng-model="vm.selectedCaseTypeId" ng-change="onCaseTypeChange();" required><option value="">Select Case Type</option><option ng-repeat="caseType in vm.caseTypes" value="{{caseType.id}}">{{caseType.name}}</option></select></div></div></div><div class="form-group"><div class="col-sm-12" ng-show="vm.selectedCaseTypeId!=null"><label class="col-sm-3 control-label"><span>Select Case</span></label><div class="col-sm-4"><select class="select2 form-control" name="case" ng-model="vm.selectedCaseId" required><option value="">Select Case</option><option ng-repeat="case in vm.cases" value="{{case.id}}">{{case.name}}</option></select></div></div></div></div><div class="box-footer"><label class="col-sm-3 control-label"><span></span></label><div class="col-sm-2" ng-if="vm.selectedCaseId!=null"><button class="btn btn-primary" ng-disabled="reportForm.$invalid" ng-click="vm.downloadSplicingReport()">Download PDF Report <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/survey-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> &nbsp;<span> Survey Report</span></h3></div><form class="form-horizontal" name="entityForm"><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="vm.onMasterChange();" required><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-show="vm.selectedMasterGeofenceId"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedGeofenceId" required><option value="">Select Geofence</option><option ng-repeat="item in vm.geofenceMini" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-if="vm.selectedGeofenceId && vm.statusType.length > 0"><label class="col-md-3 control-label"><span>Select Attributes</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><div isteven-multi-select input-model="vm.statusType" output-model="vm.selectedstatusType" button-label="value" item-label="value" tick-property="selected" group-property="msGroup" translation="vm.statuslabel" output-properties="value id" on-select-done="vm.savePriorityStatusFilter()" max-labels="2" max-height="280px" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedstatusType" name="vm.searchMini" style="display:none" required> <span id="noData" ng-if="vm.selectedPriorityList.length == 0 || vm.selectedStatusList.length == 0">* Select atleast one from each group.</span></div></div><div class="row" style="margin: 20px;"><button class="btn btn-primary btn-sm pull-right" ng-click="vm.downloadSurveyReport()" style="margin: 20px;" ng-disabled="entityForm.$invalid">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button ng-click="vm.surveyReport()" class="btn btn-primary btn-sm pull-right" ng-disabled="entityForm.$invalid">Submit</button></div></div></form><div class="col-md-12 table-responsive mt-10" ng-show="vm.surveyReportList.length > 0"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Total Length : {{(vm.surveyTotalLength).toFixed(2)}} Km</th></tr><tr><th>Asset Name</th><th>Asset Length (Km)</th><th ng-repeat="(key, value)  in vm.surveyReportList[0].attributeList" ng-if="key == \'terrain type\' || key == \'authority\' || key == \'activity type\' || key == \'existing infra\' ">{{key}}</th></tr></thead><tbody><tr ng-repeat="list in vm.surveyReportList | filter:search"><td>{{list.asset_name}}</td><td>{{(list.asset_length).toFixed(2)}}</td><td ng-repeat="(key, value) in list.attributeList" ng-if="key == \'terrain type\' || key == \'authority\' || key == \'activity type\' || key == \'existing infra\'">{{value}}</td></tr><tr><td colspan="10" ng-show="vm.surveyReportList == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/report/team-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="trakeyeApp.teamreport.title">Case TAT Report</span></h3></div><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" ng-model="vm.reportUser"><option value="">Select UserName</option><option ng-repeat="item in vm.users" title="{{item.login}}" ng-selected="{{item.login == vm.reportUser}}" value="{{item.login}}">{{item.login}}</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label teamReport_toDate">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div><div><button ng-if="vm.reportGenerated" class="btn btn-primary center-block" ng-click="download()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div><div class="content" style="overflow: scroll;overflow-x: scroll;overflow-y:hidden"><!-- <button class="btn btn-primary center-block"  ng-click="getPdf()"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="reportpdf"><div class="col-md-6" align="center" data-ng-bind-html="myhtml | trustFilter"></div></div>');
$templateCache.put('app/report/user-agent-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-vcard"></i> <span>User Agent Report</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group" ng-if="vm.reportType == \'agent\'"><label class="col-sm-3 control-label">User-Agent Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'agent\' && vm.userAgent==\'username\'"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><!-- useragent Report --><!-- Geofence Report --><div class="form-group" ng-if="vm.reportType == \'geofence\'"><label class="col-sm-3 control-label">Geofence Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="geofence" required ng-model="vm.geofence" value="geofence" ng-click="vm.select2()">Geofence Name</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.geofence" value="all">All Geofence</label></div></div><div class="form-group" ng-if="vm.reportType == \'geofence\' && vm.geofence == \'geofence\'"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-7"><select class="form-control select2" name="search" required id="geofences" ng-model="vm.id" ng-options="item.id as item.name for item in vm.geofences"><option value="">Select Geofence</option></select></div></div><!--Geofence Report --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadUserAgentReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div><!-- <div class="col-md-12">\n\t\t\t<div class="box box-solid">\n\t\t\t\t<div class="box-header with-border">\n\t\t\t\t\t<h3 class="box-title">Uesr - Agent Reports</h3>\n\t\t\t\t</div>\n\t\t\t\t<div class="box-body chart-responsive">\n\t\t\t\t\t<div class="chart" id="line-chart" style="height: 500px; position: relative;"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div> --></div><div class="row" ng-if="reporthide"><div class="col-md-10 col-md-offset-1"><!-- Map box --><div class="box box-solid"><div class="box-body"><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="login" ng-if="vm.reportType==\'agent\'"><span>Login </span><span class="fa fa-sort"></span></th><th jh-sort-by="created_cases"><span>Created Cases </span><span class="fa fa-sort"></span></th><th jh-sort-by="assigned_cases"><span>Assigned Cases </span><span class="fa fa-sort"></span></th><th jh-sort-by="resolved_cases"><span>Resolved Cases </span><span class="fa fa-sort"></span></th><th jh-sort-by="distance"><span>Total Distance </span><span class="fa fa-sort"></span></th><th jh-sort-by="distance_in" ng-if="vm.reportType==\'agent\'"><span>Distance Within Geofence </span><span class="fa fa-sort"></span></th><th jh-sort-by="distance_out" ng-if="vm.reportType==\'agent\'"><span>Distance Outside Geofence </span><span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td ng-if="vm.reportType==\'agent\'">{{record.login}}</td><td ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.created_cases}}</a></td><td ng-if="has_ROLE_VENDOR">{{record.created_cases}}</td><td ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assigned_cases}}</a></td><td ng-if="has_ROLE_VENDOR">{{record.assigned_cases}}</td><td ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolved_cases}}</a></td><td ng-if="has_ROLE_VENDOR">{{record.resolved_cases}}</td><td>{{record.distance | number:2}} KM</td><td ng-if="vm.reportType==\'agent\'">{{record.distance_in | number:2}} KM</td><td ng-if="vm.reportType==\'agent\'">{{record.distance_out | number:2}} KM</td><td><a href="" ng-click="vm.detailedReport(record.id)"><i class="fa fa-eye"></i></a></td></tr></tbody></table></div></div></div></div></div><div class="row"><div id="report" class="col-md-10 col-md-offset-1" style="display: none;"><!-- box content--><div class="box box-solid"><div class="box-header box-info"><button type="button" class="close" ng-click="close()">&times;</button><h4 class="box-title text-left"><img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;"></h4></div><button class="btn btn-primary center-block" ng-click="getPdf()">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="box-body" ng-if="vm.reportType==\'geofence\'" id="reportpdf"><h4 class="text-center mt-5">Geofence Report for <b>{{vm.detailedReportCounts.name}}</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowCancelled}}</p></div></div></div></div></div><!-- <div class="box box-solid">\n                         Services \n                        <div class="box-header">\n                            <h3 class="box-title">Services</h3>\n                        </div>\n                        <div class="box-body">\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-danger">Critical</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-success">High</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-primary">Medium</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                            <div class="col-sm-3">\n                                <h4 class="report-head text-warning">Low</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class="box box-solid"><div class="box-header"><h3 class="box-title">Geofence</h3></div><div class="box-body"><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:300px; width:100%;"></div></div></div></div></div></div><div class="box-body" ng-if="vm.reportType==\'agent\'" id="reportpdf"><!-- <div class="box-body" ng-if="vm.reportType==\'agent\'"> --><h4 class="text-center mt-5">Agent Report for <b>{{vm.detailedReportCounts.name}} ({{vm.detailedReportCounts.login}})</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Created by Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Assigned to Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowCancelled}}</p></div></div></div></div></div><!-- Services --><!-- <div class="box box-solid">\n                        \n                        <div class="box-header">\n                            <h3 class="box-title">Services</h3>\n                        </div>\n                        <div class="box-body">\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-danger">Critical</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-success">High</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="col-sm-3 report-data">\n                                <h4 class="report-head text-primary">Medium</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                            <div class="col-sm-3">\n                                <h4 class="report-head text-warning">Low</h4>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Inprogress</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Pending</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p>\n                                    </div>\n                                </div>\n\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Closed</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p>\n                                    </div>\n                                </div>\n                                <div class="row">\n                                    <div class="col-sm-6 col-xs-6">\n                                        <p class="report-info">Cancelled</p>\n                                    </div>\n                                    <div class="col-sm-2 col-xs-2">\n                                        <p class="report-info">:</p>\n                                    </div>\n                                    <div class="col-sm-4 col-xs-4">\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class="box box-solid"><div class="box-header"><h3 class="box-title">Distanc IN</h3>{{vm.detailedReportCounts.distance_in | number:2}} KM<h3 class="box-title">Distanc OUT</h3>{{vm.detailedReportCounts.distance_out | number:2}} KM</div><!-- <div class="box-body">\n\t\t\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100%;"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div>');
$templateCache.put('app/report/user-attendance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate=" ">User Attendance Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-4 control-label">User-Attendance Type</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="userType" required ng-model="vm.userType" value="gpsUser">GPS-User</label> <label class="radio-inline"><input type="radio" name="userType" ng-model="vm.userType" value="mobileUser">Mobile-User</label></div></div><!-- user attendance type --><!-- user attendance Report --><div class="form-group" ng-if="vm.reportType == \'gpsUser\'"><label class="col-sm-4 control-label">User-Attendance Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'gpsUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="gpsUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Name</span></th><th><span>Start Time</span></th><th><span>Start LatLng</span></th><th><span>End Time</span></th><th><span>End LatLng</span></th><th>Distance Within Geofence</th><th>Distance Outside Geofence</th><th>Total Distance</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.totalDistance>0"><td>{{record.userName}}</td><td>{{record.startTime | date:\'medium\'}}</td><td>{{record.startLatLng}}</td><td>{{record.endTime | date:\'medium\'}}</td><td>{{record.endLatLng}}</td><td>{{record.distanceIn | number:2}} KM</td><td>{{record.distanceOut | number:2}} KM</td><td>{{record.totalDistance | number:2}} KM</td></tr></tbody></table></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="mobileUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Name</span></th><th><span>Check-In Time</span></th><th><span>Check-In Location</span></th><th><span>Check-In Address</span></th><th><span>Check-Out Time</span></th><th><span>Check-Out Location</span></th><th><span>Check-Out Address</span></th><th><span>Case Created</span></th><th><span>Case Assigned</span></th><th><span>Case Resolved</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.checkInTime>0||record.createdCaseCount>0||record.assignedCaseCount>0||record.resolvedCaseCount>0"><td>{{record.userName}}</td><td ng-if="record.checkInTime>0">{{record.checkInTime | date:\'medium\'}}</td><td>{{record.checkInLocation}}</td><td title="{{record.checkInAddress}}">{{record.checkInAddress | limitTo: 20 }}{{record.checkInAddress.length > 20 ? \'...\' : \'\'}}</td><td ng-if="record.checkInTime==0">NA</td><td ng-if="record.checkOutTime>0">{{record.checkOutTime | date:\'medium\'}}</td><td>{{record.checkOutLocation}}</td><td title="{{record.checkOutAddress}}">{{record.checkOutAddress | limitTo: 20 }}{{record.checkOutAddress.length > 20 ? \'...\' : \'\'}}</td><td ng-if="record.checkOutTime==0">NA</td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.createdCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assignedCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolvedCaseCount}}</a></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/user-geofence-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate=" ">User Geofence Dump</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-2 control-label">Download By</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.userAgent" value="geofence" ng-click="vm.select2()">Geofence</label></div></div><div class="form-group" ng-if="vm.userAgent == \'username\'"><label class="col-sm-2 control-label"><span></span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.userid" ng-options="item.id as item.login for item in vm.users"><option value="">Select User</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><div class="form-group" ng-if="vm.userAgent == \'geofence\'"><label class="col-sm-2 control-label"><span></span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.geofenceid" ng-options="item.id as item.name for item in vm.userGeofences"><option value="">Select Geofence</option><option ng-repeat="geofence in vm.userGeofences" value="geofence.id">{{user.name}}</option></select></div></div></div><div class="box-footer"><div class="col-sm-3"><button class="btn btn-primary pull-right" ng-disabled="reportForm.$invalid" ng-click="vm.downloadUserGeofenceReport()">Download</button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/user-login-history-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-calendar-plus-o"></i> <span translate=" ">User Last Login</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Select User</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span></span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadUserLastLoginReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="userName"><span>Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="dateTime"><span>Login Date </span><span class="fa fa-sort"></span></th><th jh-sort-by="gpsImei"><span>GPS IMEI </span><span class="fa fa-sort"></span></th><th jh-sort-by="imei"><span>IMEI </span><span class="fa fa-sort"></span></th><th jh-sort-by="phone"><span>Phone </span><span class="fa fa-sort"></span></th><th jh-sort-by="reportMethod"><span>Report Method </span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td>{{record.userLogin}}</td><td>{{record.dateTime | date:\'medium\'}}</td><td>{{record.gpsimei}}</td><td>{{record.imei}}</td><td>{{record.phone}}</td><td>{{record.reportMethod}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/user-reporting-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-calendar-plus-o"></i> <span translate=" ">User Reporting Status</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Select Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="Date" required datetime-picker="mediumDate" enable-time="false" ng-model="vm.currentDate" ng-change="vm.calculateDate()" is-open="vm.datePickerOpenStatus.Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-4"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords.length > 0" style="margin: 20px"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Time</span></th><th><span>Status</span></th><th><span>Report Method</span></th><th><span>LatLng</span></th><th><span>Shift</span></th><th><span>Image</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td><b>{{record.dateTime | date:\'mediumTime\'}}</b></td><td><b>{{record.reportType}}</b></td><td><b>{{record.reportMethod}}</b></td><td>{{record.userLatitude}} , {{record.userLongitude}}</td><td>{{record.userShift}}</td><td><img data-toggle="modal" data-target="#myModalMap" ng-show="record.selfyImage != null" ng-src="data:image/jpeg;base64,{{record.selfyImage}}" ng-click="getImage(record.selfyImage)" style="width: 50px; height: 50px"></td></tr></tbody></table></div></div></div></div></div></div><div class="modal fade" id="myModalMap" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div id="imgZoom" style="background: url(\'data:image/jpeg;base64,{{vm.img}}\');background-size: cover"></div></div></div>');
$templateCache.put('app/report/user-stats-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-bar-chart"></i> <span translate=" ">User Statistics Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\'"><label class="col-sm-4 control-label">Select User</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()"> By user name</label><!-- <label class="radio-inline"><input type="radio" name="user"\r\n                                        ng-model="vm.userAgent" value="all">All Users </label> --></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span></span><!-- <label class="col-sm-4 control-label"> <span>Select User</span> --></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadUserStatsReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="gpsUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="login"><span>Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="geofenceName"><span>Geofence </span><span class="fa fa-sort"></span></th><th jh-sort-by="totalNumAssets"><span>Total Assets </span><span class="fa fa-sort"></span></th><th jh-sort-by="travelledNumAssets"><span>Assets Covered </span><span class="fa fa-sort"></span></th><th jh-sort-by="percentageDistance"><span>Distance Covered (%) </span><span class="fa fa-sort"></span></th><th><span>Distance Not Covered (%)</span></th><th jh-sort-by="timeSpent"><span>Time Spent ( HH:MM:SS ) </span><span class="fa fa-sort"></span></th><th jh-sort-by="averageSpeed"><span>Average Speed ( KMPH ) </span><span class="fa fa-sort"></span></th><th><span>Checked-IN Time</span></th><th><span>Checked-OUT Time</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td>{{record.login}}</td><td>{{record.geofenceName}}</td><td>{{record.totalNumAssets}}</td><td>{{record.travelledNumAssets}}</td><td>{{record.percentageDistance}} %</td><td>{{100-record.percentageDistance}} %</td><td>{{record.timeSpent}}</td><td>{{record.averageSpeed | number:2}}</td><td>{{record.userCheckInDateTime | date:\'medium\'}}</td><td>{{record.userCheckOutDateTime | date:\'medium\'}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/vehicle-distance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-car"></i> <span translate=" ">Vehicle Distance Travelled</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\'"><label class="col-sm-4 control-label">Vehicle Distance Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">Vehicle License Plate</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Vehicles</label></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span>Select Vehicle</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.licensePlate for item in vm.vehicles"><option value="">Select Vehicle License Plate</option><option ng-repeat="vehicle in vm.vehicles" value="vehicle.id">{{vehicle.licensePlate}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadVehicleDistanceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="gpsUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="licensePlate"><span>License Plate </span><span class="fa fa-sort"></span></th><th jh-sort-by="gpsimei"><span>GPS IMEI</span><span class="fa fa-sort"></span></th><th jh-sort-by="startTime"><span>Start Time </span><span class="fa fa-sort"></span></th><th><span>Start LatLng</span></th><th jh-sort-by="endTime"><span>End Time </span><span class="fa fa-sort"></span></th><th><span>End LatLng</span></th><th><span>Description</span></th><th><span>Vendor</span></th><th jh-sort-by="totalDistance"><span>Total Distance </span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.totalDistance>0"><td>{{record.licensePlate}}</td><td>{{record.gpsimei}}</td><td>{{record.startTime | date:\'medium\'}}</td><td>{{record.startLatLng}}</td><td>{{record.endTime | date:\'medium\'}}</td><td>{{record.endLatLng}}</td><td>{{record.description}}</td><td>{{record.vendor}}</td><td>{{record.totalDistance | number:2}} KM</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div class="content"><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ui-sref="login">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="container"><div class="row"><nav class="navbar navbar-default" role="navigation"><div class="col-sm-4 mt-20"><div class="row"><div class="col-xs-9 col-sm-12"><img src="content/images/fy-fiberify-logo.png" alt="trakeye" class="img-responsive trakeye_logo"></div><!-- <div class="navbar-header col-xs-3">\n\t\t\t\t\t<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">\n\t\t\t\t\t  <span class="sr-only">Toggle navigation</span>\n\t\t\t\t\t  <span class="icon-bar"></span>\n\t\t\t\t\t  <span class="icon-bar"></span>\n\t\t\t\t\t  <span class="icon-bar"></span>\n\t\t\t\t\t</button>\n\t\t\t\t  </div> --></div><!--row--></div><!--col-sm-4--><div class="col-sm-8 mt-20"><!-- Brand and toggle get grouped for better mobile display --><!-- Collect the nav links, forms, and other content for toggling --> <!-- <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">\n\t\t\t<ul class="nav navbar-nav navbar-right">\n\t\t\t   <li><a ui-sref="home">Home</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Solutions</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Industries</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Support</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Blog</a></li>\n\t\t\t\t\t\t<li><a ui-sref="">Contact Us</a></li>\n\t\t\t</ul>\n\t\t  </div> --><!-- /.navbar-collapse --></div><!--col-sm-8--></nav></div><!--row--><div class="tryitmain"><div class="row"><div class="col-sm-7"><div class="tryit-content"><h1 class="text-center tryit-head">Welcome to Fiberify</h1><p class="text-center">The most efficient services management apllication for your organization.</p><p class="text-center">Now control Manage and Monitor your field agents, Field activity and Field assets effectively in real-time.</p><h2 class="text-center tryit-head">Request for a free demo</h2></div></div><!--col-sm-7--><div class="col-sm-5"><div class="col-sm-10"><div class="alert alert-success" ng-show="vm.success" translate="register.messages.success"><strong>Thank you for your interest in Fiberify</strong> One of our team members will contact you shortly.</div><form ng-show="!vm.success" name="form" role="form" ng-submit="vm.register()" novalidate class="tryit-form" autocomplete="off"><!-- show-validation --><div class="form-group"><jhi-alert-error></jhi-alert-error><div><input type="firstname" class="form-control" name="firstname" id="firstName" placeholder="{{\'register.form.firstname.placeholder\' | translate}}" ng-model="vm.registerAccount.firstName" ng-minlength="3" ng-maxlength="50" ng-required="true"><div ng-show="form.firstname.$invalid"><p class="help-block" ng-show="form.firstname.$error.minlength" translate="register.messages.validate.firstname.minlength" translate-value-min="3">This field should be longer than 3 characters.</p><p class="help-block" ng-show="form.firstname.$error.maxlength" translate="register.messages.validate.firstname.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><div><input type="lastname" class="form-control" name="lastname" id="lastname" placeholder="{{\'register.form.lastname.placeholder\' | translate}}" ng-model="vm.registerAccount.lastName" ng-minlength="3" ng-maxlength="50" ng-required="true"><div ng-show="form.lastname.$invalid"><p class="help-block" ng-show="form.lastname.$error.minlength" translate="register.messages.validate.lastname.minlength" translate-value-min="3">This field should be longer than 3 characters.</p><p class="help-block" ng-show="form.last.$error.maxlength" translate="register.messages.validate.lastname.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><!-- <div class="form-group">\t\t\t\t\t \n\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t \n\t\t\t\t\t\t\t<input type="lastname" class="form-control" name="login" id="login" placeholder="{{\'register.form.login.placeholder\' | translate}}"\n                           ng-model="vm.registerAccount.login" ng-minlength="3" ng-maxlength="50" ng-required="true">\n                                   <div ng-show="form.login.$invalid">\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.login.$error.minlength" translate="register.messages.validate.loginv.minlength"\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 3 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.login.$error.maxlength" translate="register.messages.validate.loginv.maxlength"\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n                        \n\t\t\t\t\t\t  </div>\n\t\t\t\t</div> --><div class="form-group"><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><div><input type="number" class="form-control" name="mobileno" id="mobileno" placeholder="{{\'register.form.mobileno.placeholder\' | translate}}" ng-model="vm.registerAccount.mobilePhone" ng-minlength="10" ng-maxlength="50" ng-required="true"><div ng-show="form.mobileno.$invalid"><p class="help-block" ng-show="form.mobileno.$error.minlength" translate="register.messages.validate.mobileno.minlength" translate-value-min="10">This field should be longer than 10 characters.</p><p class="help-block" ng-show="form.mobileno.$error.maxlength" translate="register.messages.validate.mobileno.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><!-- <div class="form-group">\t\t\t\t\t \n\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t\t<input type="organization" class="form-control" name="organization" id="organization" placeholder="{{\'register.form.organization.placeholder\' | translate}}"\n                           ng-model="vm.registerAccount.organization" ng-minlength="3" ng-maxlength="50" ng-required="true">\n                           \n                           \t\t<div ng-show="form.organization.$invalid">\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.organization.$error.minlength" translate="register.messages.validate.organization.minlength"\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 3 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.organization.$error.maxlength" translate="register.messages.validate.organization.maxlength"\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n                        \n\t\t\t\t\t\t  </div>\n\t\t\t\t</div> --><!-- \t<div class="form-group">\t\t\t\t\t \n\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t\t<select class="form-control countries" name="country" id="countryId sel1" ng-model="vm.registerAccount.country" ng-required="true">\n\t\t\t\t\t\t\t<option value="">Select Country</option>\n                           </select>\n                          \n\t\t\t\t\t\t  </div>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div class="form-group">\t\t\t\t\t \n\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t\t<select class="form-control states" name="state" id="sel12 stateId" ng-model="vm.registerAccount.state" ng-required="true">\n\t\t\t\t\t\t\t<option value="">Select State</option>\n                           </select>\n\n\t\t\t\t\t\t  </div>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div class="form-group">\t\t\t\t\t \n\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t\t<select  class="form-control cities" name="city" id="sel13 cityId" \n                           ng-model="vm.registerAccount.city" ng-required="true">\n                           \t<option value="">Select City</option>\n                           </select>\n\n\t\t\t\t\t\t  </div>\n\t\t\t\t</div> --><!-- <div class="form-group">\t\t\t\t\t \n\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t \n\t\t\t\t\t\t\t<input type="text" class="form-control" name="city" id="city" placeholder="{{\'register.form.city.placeholder\' | translate}}"\n                           ng-model="vm.registerAccount.city" ng-minlength="3" ng-maxlength="50" ng-required="true">\n                                 <div ng-show="form.city.$invalid">\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.city.$error.minlength" translate="register.messages.validate.city.minlength"\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 10 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.city.$error.maxlength" translate="register.messages.validate.city.maxlength"\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t  </div>\n\t\t\t\t</div>\n\t\t\t\t\t<div class="form-group">\t\t\t\t\t \n\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t  \n\t\t\t\t\t\t\t<input type="text" class="form-control" name="state" id="state" placeholder="{{\'register.form.state.placeholder\' | translate}}"\n                           ng-model="vm.registerAccount.state" ng-minlength="3" ng-maxlength="50" ng-required="true">\n                                 <div ng-show="form.state.$invalid">\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.state.$error.minlength" translate="register.messages.validate.state.minlength"\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 10 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.state.$error.maxlength" translate="register.messages.validate.state.maxlength"\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n                           \n\t\t\t\t\t\t  </div>\n\t\t\t\t</div>\n\t\t\t\t\t<div class="form-group">\t\t\t\t\t \n\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t \n\t\t\t\t\t\t\t<input type="text" class="form-control" name="country" id="country" placeholder="{{\'register.form.country.placeholder\' | translate}}"\n                           ng-model="vm.registerAccount.country" ng-minlength="3" ng-maxlength="50" ng-required="true">\n                                 <div ng-show="form.country.$invalid">\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.country.$error.minlength" translate="register.messages.validate.country.minlength"\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 10 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t\t   ng-show="form.country.$error.maxlength" translate="register.messages.validate.country.maxlength"\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n                          \n\t\t\t\t\t\t  </div>\n\t\t\t\t</div> --> <button type="submit" ng-disabled="form.$invalid" class="btn btn-warning btn-block" translate="\t">Contact Us</button></form></div><div class="col-sm-2"></div></div><!--col-sm-5--><!--            <div class="alert alert-danger" ng-show="vm.error" translate="register.messages.error.fail">\n                <strong>Registration failed!</strong> Please try again later.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.errorUserExists" translate="register.messages.error.userexists">\n                <strong>Login name already registered!</strong> Please choose another one.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.errorEmailExists" translate="register.messages.error.emailexists">\n                <strong>E-mail is already in use!</strong> Please choose another one.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">\n                The password and its confirmation do not match!\n            </div> --></div></div></div><script src="http://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js"></script><script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script><script src="http://iamrohit.in/lab/js/location.js"></script></div>');
$templateCache.put('app/account/password/password.html','<div class="content"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title" translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h3></div><form name="form" role="form" class="form-horizontal" novalidate ng-submit="vm.changePassword()" show-validation><div class="box-body"><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="form-group"><label class="col-md-3 control-label" for="password" translate="global.form.newpassword">New password</label><div class="col-md-6"><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div></div><div class="form-group"><label class="col-md-3 control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><div class="col-md-6"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div></div><div class="box-footer"><div class="col-md-3 col-md-offset-3 save-buttons"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-sm" translate="password.form.button">Save</button></div></div></form></div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div class="content"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title" translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for -<b>{{vm.settingsAccount.login}}</b></h3></div><form name="form" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label" for="firstName" translate="settings.form.firstname">First Name</label><div class="col-md-8"><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" for="lastName" translate="settings.form.lastname">Last Name</label><div class="col-md-8"><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" for="email" translate="global.form.email">E-mail</label><div class="col-md-8"><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100" readonly="readonly"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div></div><!--<div class="form-group">\n\t\t\t\t\t\t\t\t\t<label for="langKey" class="col-md-3 control-label" translate="settings.form.language">Language</label>\n\t\t\t\t\t\t\t\t\t<div class="col-md-8">\n\t\t\t\t\t\t\t\t\t\t<select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select>\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\t--></div><div class="box-footer"><div class="col-md-3 col-md-offset-3 save-buttons"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-sm" translate="settings.form.button">Save</button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/asset-link/asset-link-request.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-link"></i><span> Asset Link Request</span></h3><!-- <div class="box-tools">\r\n                        <button class="btn btn-create btn-sm" ui-sref="entity-import.new">\r\n                            <span class="glyphicon glyphicon-plus"></span>\r\n                            <span>\r\n                                New\r\n                            </span>\r\n                        </button>\r\n                    </div> --></div><div class="box-body"><i class="fa fa-refresh" aria-hidden="true" style="font-size: 20px;cursor: pointer;color:#000" title="Refresh" ng-click="vm.refresh()"></i><div class="table-responsive mt-10"><table class="table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Entity Name</th><th><span>Status</span></th><th>Created Date</th></tr></thead><tbody><tr ng-repeat="list in vm.displayList track by list.id" ng-class="{greenyellow: $index === 0 && highlightAssetLink }"><!-- ng-class="{greenyellow: $index === 0 && vm.highlightRow }" --><td>{{list.id}}</td><td>{{list.entityName}}</td><td><span class="label label-info" ng-if="list.messageStatus == \'OPEN\'">{{list.messageStatus}}</span> <span class="label label-success" ng-if="list.messageStatus == \'COMPLETE\'">{{list.messageStatus}}</span> <span class="label label-danger" ng-if="list.messageStatus == \'FAILED\'">{{list.messageStatus}}</span> <span class="label label-warning" ng-if="list.messageStatus == \'IN-PROGRESS\'">IMPORT IN PROGRESS</span></td><td>{{list.createdDate | date: "dd/MM/yyyy \'at\' h:mma"}}</td></tr><tr><td colspan="10" ng-show="vm.displayList.length == 0"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title" translate="configuration.title">Configuration</h3><div class="box-tools"><form class="form-horizontal"><div class="form-group"><label class="col-md-6 control-label"><span translate="configuration.filter">Filter (by prefix)</span></label><div class="col-md-6"><input type="text" ng-model="filter" class="form-control input-sm"></div></div></form></div></div><div class="row"><div class="col-md-6"><div class="box-body"><div class="box box-solid"><div class="box-header"><h3 class="box-title" ng-hide="filteredConfig.length == 0">Spring configuration</h3></div></div><div class="table-responsive"><table class="jh-table table table-responsive table-hover" ng-hide="filtered.length == 0"><thead class="bg-default"><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table></div></div></div><div class="col-md-6"><div class="box-body"><div class="table-responsive" ng-repeat="(key, value) in vm.allConfiguration"><span class="profile-heading" ng-hide="filtered.length == 0"><b>{{key}}</b></span><div class="mt-5"></div><table class="jh-table table table-responsive table-hover" ng-hide="filteredConfig.length == 0"><thead class="bg-default"><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/customer-management/customer-management-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myUserLabel" ng-if="has_ROLE_SUPER_ADMIN"><span ng-if="!vm.customer.id" translate="customerManagement.home.create">Create</span> <span ng-if="vm.customer.id" translate="customerManagement.home.edit">Edit</span></h3></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.login">Login Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="login" ng-model="vm.customer.login" ng-required="vm.customer.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-readonly="vm.customer.id"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.firstName">First Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="firstName" ng-model="vm.customer.firstName" ng-required="vm.customer.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-readonly="vm.customer.id"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.lastName">Last Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="lastName" ng-model="vm.customer.lastName" ng-maxlength="50" ng-required="true" ng-readonly="vm.customer.id"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.email">Email</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="email" class="form-control" name="email" ng-model="vm.customer.email" required ng-maxlength="100" ng-pattern="EMAIL_REGEXP" ng-readonly="vm.customer.id"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.mobilephone">Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="mobilePhone" ng-model="vm.customer.mobilePhone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required ng-readonly="vm.customer.id"><p class="help-block" ng-show="editForm.mobilePhone.$error.maxlength" translate="global.messages.validate.mobilePhone.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.mobilePhone.$error.minlength" translate="global.messages.validate.mobilePhone.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.mobilePhone.$error.pattern" translate="global.messages.validate.mobilePhone.invalid">Your phone number is invalid.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.organization">Organization</span></label><div class="col-md-7"><input type="text" class="form-control" name="organization" ng-model="vm.customer.organization" ng-maxlength="50" ng-minlength="3" ng-readonly="vm.customer.id"><p class="help-block text-danger" ng-show="editForm.organization.$error.maxlength" translate="global.messages.validate.organization.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.organization.$error.minlength" translate="global.messages.validate.organization.minlength" translate-value-min="3">This field cannot be lesser than 3 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.city">City</span></label><div class="col-md-7"><input type="text" class="form-control" name="city" ng-model="vm.customer.city" ng-maxlength="50" ng-minlength="3" ng-readonly="vm.customer.id"><p class="help-block text-danger" ng-show="editForm.city.$error.maxlength" translate="global.messages.validate.city.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.city.$error.minlength" translate="global.messages.validate.city.minlength" translate-value-min="3">This field cannot be lesser than 3 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.state">State</span></label><div class="col-md-7"><input type="text" class="form-control" name="state" ng-model="vm.customer.state" ng-maxlength="50" ng-minlength="3" ng-readonly="vm.customer.id"><p class="help-block text-danger" ng-show="editForm.state.$error.maxlength" translate="global.messages.validate.state.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.state.$error.minlength" translate="global.messages.validate.state.minlength" translate-value-min="3">This field cannot be lesser than 3 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.country">Country</span></label><div class="col-md-7"><input type="text" class="form-control" name="country" ng-model="vm.customer.country" ng-maxlength="50" ng-minlength="3" ng-readonly="vm.customer.id"><p class="help-block text-danger" ng-show="editForm.country.$error.maxlength" translate="global.messages.validate.country.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.organization.$error.minlength" translate="global.messages.validate.organization.minlength" translate-value-min="3">This field cannot be lesser than 3 characters.</p></div></div><!-- \t\t\t\t\t\t <div class="form-group">\r\n\t\t\t\t\t\t \t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="customerManagement.gender">Gender</span> \t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-7">\r\n\t\t\t\t            <input type="text" class="form-control" name="gender"\r\n\t\t\t\t                   ng-model="vm.customer.gender" ng-readonly="vm.customer.id">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t            </div>\r\n\t\t\t\t\t\t</div>   --><div class="form-group"><label class="col-md-3 control-label" translate="customerManagement.langKey">Lang Key</label><div class="col-md-7"><input type="langKey" class="form-control" name="langKey" ng-model="vm.customer.langKey" ng-readonly="vm.customer.id"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="customerManagement.status">Status</label><div class="col-md-7"><select class="form-control" value="vm.customer.status" selected="selected" name="status" ng-model="vm.customer.status" id="status" required><option disabled="disabled" selected="selected" value>--- Select Status ---</option><option value="NEW">NEW</option><option value="CREATED">CREATED</option></select></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button class="btn btn-default btn-sm" ui-sref="customer-management"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-edit"></span> <span translate="entity.action.edit">Edit</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/customer-management/customer-management.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-user"></span> <span translate="customerManagement.home.customerstitle" ng-if="has_ROLE_SUPER_ADMIN">Customers</span></h3><div class="box-tools"><!-- \t\t\t\t\t  <button class="btn btn-success btn-create" ui-sref="user-management.new">\r\n\t\t\t              <span class="glyphicon glyphicon-plus"></span> <span ng-if="has_ROLE_SUPER_ADMIN" translate="userManagement.home.createCustomerLabel">Create Customer</span>\r\n\t\t\t              <span ng-if="has_ROLE_USER_ADMIN" translate="userManagement.home.createUserLabel">Create Agent</span>\r\n\t\t\t              \r\n\t\t\t          </button> --></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-2 pull-right"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control input-sm ng-pristine ng-valid ng-empty ng-touched" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_]{3,}$/" placeholder="{{\'customerManagement.home.search\' | translate}}" aria-invalid="false"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="firstName"><span translate="customerManagement.firstName">First Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="lastName"><span translate="customerManagement.lastName">Last Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="email"><span translate="customerManagement.email">Email</span> <span class="fa fa-sort"></span></th><th jh-sort-by="mobilePhone"><span translate="customerManagement.mobilephone">Phone</span> <span class="fa fa-sort"></span></th><th jh-sort-by="organization"><span translate="customerManagement.organization">Organization</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="customerManagement.status">Status</span> <span class="fa fa-sort"></span></th><!-- \t\t\t\t\t                <th jh-sort-by="gender"><span translate="customerManagement.gender">Gender</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="customer in vm.customers   | filter :search track by customer.id"><td><a ui-sref="customer-management-detail({id:customer.id})">{{customer.firstName}}</a></td><td>{{customer.lastName}}</td><td>{{customer.email}}</td><td>{{customer.mobilePhone}}</td><!-- \t\t\t\t\t                 <td ng-if="has_ROLE_USER_ADMIN">{{user.imei}}</td>\r\n\t\t\t\t\t                 <td ng-if="has_ROLE_USER_ADMIN">{{user.operatingSystem}}</td>\r\n\t\t\t\t\t                 <td ng-if="has_ROLE_USER_ADMIN">{{user.applicationVersion}}</td> --><td>{{customer.organization}}</td><td>{{customer.status}}</td><td><div class="actions"><a ui-sref="customer-management-detail({id:customer.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><!-- \t\t\t\t\t                        <a ui-sref="customer-management.edit({id:customer.id})"\r\n\t\t\t\t\t                                class="actions-icons text-primary" title="Edit">\r\n\t\t\t\t\t                            <span class="fa fa-pencil-square"></span>\r\n\t\t\t\t\t                        </a>\r\n\t\t\t\t\t                        <a ui-sref="customer-management.delete({id:customer.id})"\r\n\t\t\t\t\t                                class="action-icons text-danger" ng-disabled="vm.currentAccount.id==customer.id">\r\n\t\t\t\t\t                            <span class="fa fa-times-circle"></span>\r\n\t\t\t\t\t                        </a> --></div></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/import/entity-import-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span>Create New Request</span></h3></div><!-- /.box-header --><!-- form start --><div class="alert alert-success mt-5" ng-show="vm.showMessage"><strong>Import Successfull</strong> Your Tracking Id is {{vm.trackingId}}.</div><div class="col-md-12 mt-5"><span ui-sref="{{vm.currentState}}" class="fa fa-arrow-left" style="font-size: 15px;cursor: pointer;color:#000">Back</span></div><form class="form-horizontal" name="entityForm" ng-submit="vm.onSubmit()"><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select Entity</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="entity" ng-model="vm.entity" required><option value="">--- Select Entity ---</option><option value="Assets">Assets</option><!-- <option value="Cases">Cases</option>\r\n\t\t\t\t\t\t\t\t\t<option value="Users">Geofences</option> --></select></div></div><!-- <div class="form-group"\r\n\t\t\t\t\t\t\tng-if="vm.entity==\'Assets\'">\r\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t<span>Select Asset Layout</span><sup><span class="required-icon"><i\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fa fa-asterisk text-danger"></i></span>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<select class="form-control" name="layout" ng-model="vm.entityLayout" required>\r\n\t\t\t\t\t\t\t\t\t<option value="">--- Select Asset Layout ---</option>\r\n\t\t\t\t\t                <option value="FIXED">FIXED</option>\r\n                                    <option value="SPREAD">SPREAD</option>\r\n\t\t\t\t\t            </select>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="form-group" ng-show="vm.entity==\'Assets\'"><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-4"><input type="file" name="uploadfile" id="uploadfile" class="filestyle" ng-pattern="vm.importxlsx" accept="*.xlsx||*.xls||*.kml" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel, kml and xml file should be uploaded</p></div></div></div><!-- <div class="form-group"\r\n\t\t\t\t\t\t\tng-if="vm.entity==\'Assets\' && vm.selectedAssettypeId.length > 0 &&(has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)">\r\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t<span>Select File Format</span><sup><span class="required-icon"><i\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fa fa-asterisk text-danger"></i></span>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<select class="form-control" ng-model="vm.entityFileFormat" required>\r\n\t\t\t\t\t\t\t\t\t<option value="">--- Select File Format ---</option>\r\n\t\t\t\t\t                <option value="CSV">CSV</option>\r\n                                    <option value="KML">KML</option>\r\n\t\t\t\t\t\t\t\t\t<option value="EXCEL">EXCEL</option>\r\n\t\t\t\t\t            </select>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><!-- <div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessage">\r\n\t\t\t\t\t\t\t<h1>THANK YOU!</h1>\r\n\t\t\t\t\t\t\t<i class="fa fa-check main-content__checkmark" style="font-size:96px;color: green;"></i>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t<p>Your Tracking Id is {{vm.trackingId}} </p>\r\n\t\t\t\t\t\t</div> --><!-- <div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessageError">\r\n\t\t\t\t\t\t\t<h1>Error</h1>\r\n\t\t\t\t\t\t\t<i class="fa fa-times main-content__checkmark" style="font-size:96px;color: red;"></i>\r\n\t\t\t\t\t\t\t<p>{{vm.errorMessage}}</p>\r\n\t\t\t\t\t\t</div>  --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm pull-right" ng-disabled="entityForm.$invalid">Submit</button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/import/entity-import.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i><span> Import Entity</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="entity-import.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><i class="fa fa-refresh" aria-hidden="true" style="font-size: 20px;cursor: pointer;color:#000" title="Refresh" ng-click="vm.refresh()"></i><div class="table-responsive mt-10"><table class="table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Entity Name</th><th><span>Status</span></th><th>Created Date</th></tr></thead><tbody><tr ng-repeat="list in vm.displayList track by list.id"><!-- ng-class="{greenyellow: $index === 0 && vm.highlightRow }" --><td>{{list.id}}</td><td>{{list.entityName}}</td><td><span class="label label-info" ng-if="list.messageStatus == \'OPEN\'">{{list.messageStatus}}</span> <span class="label label-success" ng-if="list.messageStatus == \'COMPLETE\'">{{list.messageStatus}}</span> <span class="label label-danger" ng-if="list.messageStatus == \'FAILED\'">{{list.messageStatus}}</span> <span class="label label-warning" ng-if="list.messageStatus == \'IN-PROGRESS\'">IMPORT IN PROGRESS</span></td><td>{{list.createdDate | date: "dd/MM/yyyy \'at\' h:mma"}}</td></tr><tr><td colspan="10" ng-show="vm.displayList.length == 0"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/vehicle-management/vehicle-management-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><span translate="vehicleManagement.detail.agenttitle" ng-if="has_ROLE_USER_ADMIN">Agent</span> - {{vm.user.login}}</div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vehicleManagement.licensePlate">License Plate</span></dt><dd><span>{{vm.vehicle.licensePlate}}</span></dd><dt><span translate="vehicleManagement.status">Status</span></dt><dd>{{vm.vehicle.status}}</dd><dt><span translate="vehicleManagement.vehicleType">Vehicle Type</span></dt><dd>{{vm.vehicle.vehicleType}}</dd><dt><span translate="vehicleManagement.vendor">Vendor</span></dt><dd>{{vm.vehicle.vendor}}</dd><dt><span translate="vehicleManagement.description">Description</span></dt><dd>{{vm.vehicle.description}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="vehicleManagement.gpsimei">GPS DEVICE IMEI</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">{{vm.vehicle.gpsimei}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="vehicle-management" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="vehicle-management.edit({id:vm.vehicle.id}) " class="btn btn-primary btn-sm" ng-hide="has_ROLE_VENDOR"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/admin/vehicle-management/vehicle-management-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myVehicleLabel" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span ng-if="!vm.vehicle.id" translate="vehicleManagement.home.createvehicle">Create</span> <span ng-if="vm.vehicle.id" translate="vehicleManagement.home.Editvehicle">Edit</span></h3></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label" for="field_status"><span translate="vehicleManagement.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="status" ng-model="vm.vehicle.status" id="field_status" required><option value="InService" translate="vehicleManagement.inservice">InService</option><option value="OutOfService" translate="vehicleManagement.outofservice">OutOfService</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_vehicleType"><span translate="vehicleManagement.vehicleType">Vehicle Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="vehicleType" ng-model="vm.vehicle.vehicleType" id="field_vehicleType" required><option value="DEFAULT" translate="vehicleManagement.default">DEFAULT</option><option value="FRT" translate="vehicleManagement.frt">FRT</option><option value="SOH" translate="vehicleManagement.soh">SOH</option><option value="CIVIL" translate="vehicleManagement.civil">CIVIL</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="vehicleManagement.licensePlate">License Plate</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="licensePlate" ng-model="vm.vehicle.licensePlate" ng-maxlength="100" ng-required="true"><div ng-show="editForm.licensePlate.$invalid"><p class="help-block" ng-show="editForm.licensePlate.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="vehicleManagement.gpsimei">GPS IMEI</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="gpsimei" ng-model="vm.vehicle.gpsimei" ng-maxlength="50" ng-minlength="15" required><p class="help-block text-danger" ng-show="editForm.gpsimei.$error.maxlength" translate="global.messages.validate.imei.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.gpsimei.$error.minlength" translate="global.messages.validate.imei.minlength" translate-value-max="15">This field cannot be lesser than 15 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Attached To </span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.multiUser" output-model="vm.selectedUserId" button-label="login" item-label="login" tick-property="ticked" selection-mode="single" output-properties="id selected"></div><input type="text" ng-model="vm.selectedUserId" name="usreName" style="display:none" required></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="vehicleManagement.vendor">Vendor</span></label><div class="col-md-7"><input type="text" class="form-control" name="vendor" ng-model="vm.vehicle.vendor" ng-maxlength="100"><div ng-show="editForm.vendor.$invalid"><p class="help-block" ng-show="editForm.vendor.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="vehicleManagement.description">Description</span></label><div class="col-md-7"><textarea rows="2" type="text" class="form-control" name="description" ng-model="vm.vehicle.description" ng-maxlength="250"></textarea><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button class="btn btn-default btn-sm" ui-sref="vehicle-management"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/vehicle-management/vehicle-management.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><span class="fa fa-car"></span> <span translate="vehicleManagement.home.customerstitle" ng-if="has_ROLE_SUPER_ADMIN">Customers</span> <span translate="vehicleManagement.home.vehiclestitle" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">Agents</span></h3></div><div class="col-md-6 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)} " ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(1); " data-toggle="tab "><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li></ul></div><div class="box-tools"><button class="btn btn-create" ui-sref="vehicle-management.new "><span class="glyphicon glyphicon-plus"></span> <span ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">New</span></button></div></div><div class="box-body"><div class="row"><div class="col-md-3 pull-right" ng-show="isSet(1)" style="margin-right: 20px;"><div class="input-group"><input type="text " ng-model="search " ng-change="vm.filterSearch() " class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-minlength="3 " ng-pattern="/^[a-zA-Z0-9_@ ]{3,}$/ " placeholder="{{\n                                    \'vehicleManagement.home.search\' | translate}} " aria-invalid="false "> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="vehiclelisttab" ng-show="isSet(1) "><jhi-alert></jhi-alert><div class="table-responsive table-header-fixed mt-10"><table class="jh-table table table-responsive table-hover" style="width: 100%; border-spacing:0; margin:0;"><thead class="bg-default"><tr jh-sort="vm.predicate " ascending="vm.reverse " callback="vm.transition() "><th jh-sort-by="gps_imei"><span translate="vehicleManagement.gpsimei ">GPS IMEI </span><span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="vehicleManagement.status ">Status </span><span class="fa fa-sort"></span></th><th jh-sort-by="vehicle_type"><span translate="vehicleManagement.vehicleType ">Vehicle Type </span><span class="fa fa-sort"></span></th><th jh-sort-by="license_plate"><span translate="vehicleManagement.licensePlate ">License Plate </span><span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="vehicleManagement.description ">Description </span><span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="vehicle in vm.vehicles"><td>{{vehicle.gpsimei}}</td><td>{{vehicle.status}}</td><td>{{vehicle.vehicleType}}</td><td>{{vehicle.licensePlate}}</td><td>{{vehicle.description}}</td><td style="width: 6%;"><div class="actions"><a ui-sref="vehicle-management-detail({id:vehicle.id}) " class="action-icons text-info" title="View "><span class="fa fa-eye"></span> </a><a ui-sref="vehicle-management.edit({id:vehicle.id}) " class="actions-icons text-primary" title="Edit "><span class="fa fa-pencil-square"></span></a></div></td></tr></tbody></table></div><div class="row mt-10"><div class="col-md-4"><div class="count-length"><jhi-item-count page=" vm.page " total=" vm.queryCount " items-per-page=" vm.itemsPerPage "></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items=" vm.totalItems " ng-model=" vm.page " ng-change=" vm.transition() "></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-body text-center mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="userManagement.detail.customertitle" ng-if="has_ROLE_SUPER_ADMIN">Customer</span> <span translate="userManagement.detail.agenttitle" ng-if="has_ROLE_USER_ADMIN">Agent</span> - {{vm.user.login}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>User Name</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="userManagement.phone">Phone</span></dt><dd>{{vm.user.phone}}</dd><!-- <dt\n                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">\n                            <span translate="userManagement.imei">IMEI</span>\n                        </dt>\n                        <dd\n                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">\n                            {{vm.user.imei}}</dd> --><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.gpsimei">GPS DEVICE IMEI</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">{{vm.user.gpsimei}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.operatingsystem">Operating System</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">{{vm.user.operatingSystem}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.applicationversion">Application Version</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">{{vm.user.applicationVersion}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.gpsstatus">GPS Status</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER" ng-show="vm.user.gpsStatus" class="dot dotOn"></dd><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER" ng-show="!vm.user.gpsStatus" class="dot dotOff"></dd><dt><span translate="userManagement.status">Status</span></dt><dd ng-show="vm.user.activated"><span class="label label-success" translate="userManagement.activated">Activated</span></dd><dd ng-show="!vm.user.activated"><span class="label label-danger" translate="userManagement.deactivated">Deactivated</span></dd><!-- <dt><span translate="userManagement.phone">Phone</span></dt>\n\t\t\t\t\t\t        <dd>{{vm.user.phone}}</dd>\n\t\t\t\t\t\t        <dt><span translate="userManagement.imsi">IMSI</span></dt>\n\t\t\t\t\t\t        <dd>{{vm.user.imsi}}</dd> --><!--<dt><span translate="userManagement.activated">Activated</span></dt>\n\t\t\t\t\t\t        <dd>{{vm.user.activated}}</dd>--><dt><span translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.fromTime">From Time</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">{{vm.user.fromTime}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.toTime">To Time</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">{{vm.user.toTime}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.geofence">Geofence</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span><div ng-repeat="geofence in vm.user.geofenceNames"><span class="label label-default">{{ geofence}}</span></div></span></dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.group">Group</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span><div ng-repeat="group in vm.user.groups"><span class="label label-default">{{ group.name}}</span></div></span></dd><dt><span translate="userManagement.profiles">Profiles</span></dt><dd><span><div ng-repeat="authority in vm.user.authorities"><span class="label label-primary">{{ authority }}</span><!-- <span ng-show="authority === \'ROLE_USER\'" class="label label-info">{{ authority }}</span> --></div></span></dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span translate="userManagement.userimage">User Image</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><div class="col-md-2" ng-show="vm.user.userImage != null"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{vm.user.userImage}}" style="padding-bottom: 10px; width:40px;height:40px;"></div></dd></dl><div class="box-buttons pull-right"><a ui-sref="user-management" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="user-management.edit({login:vm.user.login})" class="btn btn-primary btn-sm" ng-hide="has_ROLE_VENDOR"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myUserLabel" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><span ng-if="!vm.user.id" translate="userManagement.home.createagent">Create</span> <span ng-if="vm.user.id" translate="userManagement.home.Editagent">Edit</span></h3><h3 class="box-title" id="myUserLabel" ng-if="has_ROLE_SUPER_ADMIN"><span ng-if="!vm.user.id" translate="userManagement.home.create">Create</span> <span ng-if="vm.user.id" translate="userManagement.home.Edit">Edit</span></h3></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span>User Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'@A-Za-z0-9-]*$/" ng-readonly="vm.user.id"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.pattern">special characters not allowed.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.firstName">First Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50" ng-required="true"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.lastName">Last Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50" ng-required="true"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.email">Email</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100" ng-pattern="EMAIL_REGEXP"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.phone">Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="phone" ng-model="vm.user.phone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required><p class="help-block" ng-show="editForm.phone.$error.maxlength" translate="global.messages.validate.phone.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.phone.$error.minlength" translate="global.messages.validate.phone.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.phone.$error.pattern" translate="global.messages.validate.phone.invalid">Your phone number is invalid.</p></div></div><!-- <div class="form-group"\n                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">\n                            <label class="col-md-3 control-label">\n                                <span translate="userManagement.imei">IMEI</span>\n\n                            </label>\n                            <div class="col-md-7">\n                                <input type="text" class="form-control" name="imei" ng-model="vm.user.imei"\n                                    ng-maxlength="50" ng-minlength="15">\n\n                                <p class="help-block text-danger" ng-show="editForm.imei.$error.maxlength"\n                                    translate="global.messages.validate.imei.maxlength" translate-value-max="15">\n                                    This field cannot be longer than 15 characters.\n                                </p>\n                                <p class="help-block text-danger" ng-show="editForm.imei.$error.minlength"\n                                    translate="global.messages.validate.imei.minlength" translate-value-max="15">\n                                    This field cannot be lesser than 15 characters.\n                                </p>\n\n                            </div>\n                        </div> --><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.gpsimei">GPS IMEI</span></label><div class="col-md-7"><input type="text" class="form-control" name="gpsimei" ng-model="vm.user.gpsimei" ng-maxlength="50" ng-minlength="15" ng-disabled="!has_ROLE_USER_ADMIN"><p class="help-block text-danger" ng-show="editForm.gpsimei.$error.maxlength" translate="global.messages.validate.imei.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.gpsimei.$error.minlength" translate="global.messages.validate.imei.minlength" translate-value-max="15">This field cannot be lesser than 15 characters.</p></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.fromTime">Duty Start</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><select class="form-control" name="selectFrom" ng-model="vm.user.fromTime" ng-options="selectfrom as selectfrom for selectfrom in vm.selectfrom" required></select></div><label class="col-md-3 control-label user_endTime"><span translate="userManagement.toTime">End Time</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><select class="form-control" name="selectTo" ng-model="vm.user.toTime" ng-options="selectfrom as selectfrom for selectfrom in vm.selectfrom" required></select></div></div><div class="form-group" ng-if="vm.user.id"><label class="col-md-3 control-label" for="activated"><span translate="userManagement.activated">Activated</span></label><div class="col-md-5"><!--  ng-disabled="vm.user.id === null --> <input ng-disabled="!has_ROLE_USER_ADMIN" name="activated" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.user.activated"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Device Info</span></label><div class="col-md-5"><!-- ng-disabled="!hasDeviceInfo" --> <input ng-disabled="vm.deviceInfo" name="hasDeviceInfo" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.user.hasDeviceInfo"></div></div><div class="form-group" ng-if="vm.user.id"><label class="col-md-3 control-label" for="reportingStatus"><span translate="userManagement.reportingStatus">Reporting Status</span></label><div class="col-md-5"><!-- ng-disabled="vm.user.id === null" --> <input ng-disabled="!has_ROLE_USER_ADMIN" name="reportingStatus" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.user.reportingStatus"></div></div><!-- <div class="form-group" ng-if="vm.user.id">\n                            <label class="col-md-3 control-label" for="checkinWithoutImage">\n                                <span translate="userManagement.allowCheckinWithoutSelfie">Allow Check-In without Selfie</span>\n                            </label>\n                            <div class="col-md-5">\n                                <input ng-disabled="vm.user.id === null" name="checkinWithoutImage" type="checkbox"\n                                    class="checkbox" id="field_escalated" ng-model="vm.user.checkinWithoutImage">\n                            </div>\n                        </div> --><div class="form-group" ng-hide="vm.user.id || !vm.user.id"><label class="col-md-3 control-label" translate="userManagement.langKey">Lang Key</label><div class="col-md-7"><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.profiles">Profiles</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" style="height:max-content;" name="authority"\n                                    ng-model="vm.user.authorities"\n                                    ng-options="authority for authority in vm.authorities" multiple required>\n                                </select> --> <select class="form-control" style="height:max-content;" ng-model="vm.user.authorities" ng-disabled="!has_ROLE_USER_ADMIN" multiple="multiple" required><option ng-repeat="item in vm.authorities" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.geofence">Geofence</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" multiple  name="geofences" ng-model="vm.user.geofences" required\n\t\t\t\t\t\t\t\t\t\tng-options="geofence.id as geofence.name for geofence in vm.geofences">\n\t\t\t\t\t\t\t\t\t      \n\t\t\t\t\t\t\t\t</select> --><div isteven-multi-select input-model="vm.multiGeofence" output-model="vm.user.geofences" helper-elements="all filter none" button-label="nameZone" item-label="nameZone" tick-property="ticked" output-properties="id selected"></div><input type="text" ng-model="vm.user.geofences" name="fence" style="display:none" required><!-- <div>selected geofence id: {{vm.user.geofences}} </div> --></div><!-- <div class="col-md-3" ui-sref="geofence.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="userManagement.createGeofence">\n                                Create Geofence\n                            </div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\n                                <i class="fa fa-plus-square" ng-click="vm.navigateGeofence();" style="cursor: pointer;" title=\'Create Geofence\'></i>\n                            </div> --></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.group">Group</span></label><div class="col-md-3"><div isteven-multi-select input-model="vm.multiGroup" output-model="vm.user.groups" button-label="name" item-label="name" helper-elements="all none" tick-property="ticked" output-properties="id selected"></div><input type="text" ng-model="vm.user.groups" name="group" style="display:none" required></div><!-- <div class="col-md-3" ui-sref="group-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="userManagement.createGroupType">\n                                Create Group Type\n                            </div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\n                                <i class="fa fa-plus-square" ng-click="vm.navigateGroupfromUserMng();" title=\'Create Group\' style="cursor: pointer;"></i>\n                            </div> --></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span>Reports To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" multiple  name="geofences" ng-model="vm.user.geofences" required\n\t\t\t\t\t\t\t\t\t\tng-options="geofence.id as geofence.name for geofence in vm.geofences">\n\t\t\t\t\t\t\t\t\t      \n\t\t\t\t\t\t\t\t</select> --><div is-disabled="vm.reportsEnable" isteven-multi-select input-model="vm.multiUser" output-model="vm.user.ownedBy" button-label="login" item-label="login" tick-property="ticked" selection-mode="single" output-properties="id selected"></div><input type="text" ng-model="vm.user.ownedBy" name="usreName" style="display:none" required><!-- <div>selected geofence id: {{vm.user.geofences}} </div> --></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.vendor">Vendor</span></label><div class="col-md-7"><div isteven-multi-select input-model="vm.multiVendor" output-model="vm.user.vendors" button-label="login" item-label="login" tick-property="ticked" selection-mode="single" output-properties="id selected"></div><input type="text" ng-model="vm.user.vendors" name="usreName" style="display:none"></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.trakeye">User Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="trakeyeType" ng-model="vm.user.trakeyeType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.trakeyeTypes track by item.id" required><option value="" translate="userManagement.selecttrakeye">---User Type---</option></select></div><!-- <div class="col-md-3" ui-sref="trakeye-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="userManagement.createFiberifyType">\n                                Create User Type\n                            </div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\n                                <i class="fa fa-plus-square" ng-click="vm.navigateFiberifyTypefromGroup();" title=\'Create User Type\' style="cursor: pointer;"></i>\n                            </div> --></div><div ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><div class="form-group" ng-repeat="attribute in vm.user.trakeyeTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.trakeyeTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-if="attribute.trakeyeTypeAttribute.dataType == \'FLOAT\'" type="text" class="form-control" ng-value="attribute.trakeyeTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue" step="0.01"> <span ng-if="attribute.trakeyeTypeAttribute.dataType == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.trakeyeTypeAttribute.dataType == \'INTEGER\'" type="text" class="form-control" ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue" name="value{{$index+1}}" ng-value="attribute.trakeyeTypeAttribute.value" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.trakeyeTypeAttribute.dataType == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-if="attribute.trakeyeTypeAttribute.dataType == \'STRING\'" type="text" class="form-control" name="value{{$index+1}}" ng-value="attribute.trakeyeTypeAttribute.value" ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue"> <span ng-if="attribute.trakeyeTypeAttribute.dataType == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue" ng-init="vm.user.trakeyeTypeAttributeValues[$index].attributeValue = attribute.trakeyeTypeAttribute.value" ng-if="attribute.trakeyeTypeAttribute.dataType ==  \'BOOLEAN\' && !vm.user.id" class="form-control select2" name="value"><option value="true">True</option><option value="false">False</option></select> <select ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue" ng-init="vm.user.trakeyeTypeAttributeValues[$index].attributeValue == attribute.trakeyeTypeAttribute.value" ng-if="attribute.trakeyeTypeAttribute.dataType ==  \'BOOLEAN\' && vm.user.id" class="form-control select2" name="value"><option value="true">True</option><option value="false">False</option></select></div></div></div><div class="form-group" ng-show="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label" translate="userManagement.userimage">User Image</label><div class="col-md-6"><input type="file" name="file" class="filestyle" id="userImage" accept="image/*" ng-model="userImage" valid-file ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="assettype.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 userMngnt_showImg" ng-if="vm.user.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2" ng-show="vm.user.userImage != null"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{vm.user.userImage}}" style="padding-bottom: 10px;margin-left:250px; width:40px;height:40px;"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button class="btn btn-default btn-sm" ui-sref="user-management"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><span class="fa fa-user"></span> <span translate="userManagement.home.customerstitle" ng-if="has_ROLE_SUPER_ADMIN">Customers</span> <span translate="userManagement.home.userstitle" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">Agents</span></h3></div><div class="col-md-5 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)} " ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(1); " data-toggle="tab "><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(2)} " ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(2); " data-toggle="tab "><i class="fa fa-sitemap"></i><span class="header-view">Hierarchy</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(3)} " ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(3); " data-toggle="tab "><i class="fa fa-user-circle"></i><span class="header-view">Nearby</span> <span class="header_view">Agent</span></a></li></ul></div><div class="box-tools"><button class="btn btn-create" ui-sref="user-management.new " ng-if="has_ROLE_USER_ADMIN"><span class="glyphicon glyphicon-plus" ng-if="has_ROLE_SUPER_ADMIN "></span> <span ng-if="has_ROLE_SUPER_ADMIN " translate="userManagement.home.createCustomerLabel ">Create Customer</span> <span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><div class="row"><!-- <div class="col-md-1" ng-show="isSet(1)"  ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">\n                            <button class="btn btn-primary center-block" ng-click="vm.downloadUsers()">\n                                Download All Users <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button>\n                        </div> --><div class="col-md-3 dropFilter" ng-show="isSet(1)" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD"><!-- <button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnListView()">\n                                <i class="fa fa-filter"></i>\n                            </button> --><div isteven-multi-select input-model=" vm.masterGeofences" output-model="vm.selectedGeofenceNearby" button-label="name" item-label="name" tick-property="ticked" translation="geofencelabel.list" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceNearby" name="vm.searchMini" style="display:none" required></div><!-- <div class="col-md-3 pull-right">\n                            <div class="input-group  ">\n                                <input type="text " ng-model="search " ng-change="vm.filterSearch() "\n                                    class="form-control  ng-pristine ng-valid ng-empty ng-touched "\n                                    ng-minlength="3 " ng-pattern="/^[a-zA-Z0-9_@ ]{3,}$/ " placeholder="{{ \'userManagement.home.search\'\n                                | translate}} " aria-invalid="false ">\n                                <span class="input-group-btn ">\n                                    <button type="button " class="btn btn-info btn-flat ">\n                                        <i class="fa fa-search "></i></button>\n                                </span>\n                            </div>\n                        </div> --><!-- <div class="col-md-3 pull-right" ng-show="isSet(1) ">\n                            <button class="btn btn-primary center-block" ng-click="vm.downloadUserManagementUserList()">\n                                Download\n                                Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button>\n                        </div> --><div class="col-md-3 dropFilter" ng-show="isSet(3)"><!-- <button type="button" class="btn btn-info btn-flat"\n                                ng-click="vm.filterAssetsOnUserManagementMapView()">\n                                <i class="fa fa-filter"></i>\n                            </button> --><div isteven-multi-select input-model="vm.userGeofences" output-model="vm.selectedGeofenceNearby" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel.map" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceNearby" name="vm.searchMini" style="display:none" required> <span id="noData" ng-show="vm.selectedGeofenceNearby.length < 1">*Please Select Geofence</span></div><div class="col-md-2" ng-show="isSet(3) && vm.selectedGeofenceNearby.length >= 1"><!-- <label for="area" style="font-weight: normal;">Agent within </label> --> <select name="user_distance" id="user_distance"><!-- <option>---Select Distance---</option> --><option value="">Agent within</option><option value="250">250 m</option><option value="500">500 m</option><option value="1000" selected="selected">1 km</option><option value="5000">5 km</option><option value="10000">10 km</option><option value="20000">20 km</option><option value="50000">50 km</option><option value="100000">100 km</option></select></div><div class="col-md-2 pull-right" ng-show="isSet(2)"><button type="button" class="btn btn-info btn-flat" ng-click="vm.downloadImage()">Download</button></div><div class="col-md-2 selectAsset_drp pull-right" ng-show="isSet(3) && vm.selectedGeofenceNearby.length >= 1 "><select id="searchUsersOnMap" class="select2 form-control" name="search" style="width: 150px; height: 34px"><option value="">Search Agent</option><option ng-repeat="item in vm.usersList" value="{{item}}">{{item.login}}</option></select></div><div class="col-md-7 pull-right" ng-show="isSet(1)"><div ng-show="vm.selectedListGeofenceId!=0 && (has_ROLE_USER_ADMIN || has_ROLE_HOD)"><label class="col-md-2"><span>Search By Column</span></label><div class="col-md-6"><div isteven-multi-select input-model="vm.columnList" output-model="vm.selectedColumnList" helper-elements="all filter none" button-label="name" item-label="name" tick-property="ticked" output-properties="name selected"></div><input type="text" ng-model="vm.selectedColumnList" name="fence" style="display:none" required></div></div><div class="col-md-4 input-group pull-right"><input type="text " ng-model="search " placeholder="Search" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-minlength="3 " ng-pattern="/^[a-zA-Z0-9_@. ]{3,}$/ " aria-invalid="false "> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><!--users-tabs--><!-- <div class="userlisttab" ng-show="isSet(1) ">\n                        <jhi-alert></jhi-alert>\n                        <div class="table-responsive mt-10  table-scroll">\n                            <table class="jh-table table table-responsive table-hover "\n                                style=" width: 100%; border-spacing:0; margin:0; ">\n                                <thead class="bg-default ">\n                                    <tr>\n                                        <th style="width: 6%; "><span translate="userManagement.login">Login</span></th>\n                                        <th style="width: 6%; "><span translate="userManagement.reportto">Report\n                                                To</span></th>\n                                        <th style="width: 10%; "><span translate="userManagement.email ">Email</span>\n                                        </th>\n                                        <th style="width: 6%; "><span translate="userManagement.phone ">Phone</span>\n                                        </th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span translate="userManagement.imei ">IMEI</span>\n                                        </th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%;\n                                        "><span translate="userManagement.gpsimei ">GPS\n                                                IMEI</span></th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span\n                                                translate="userManagement.operatingsystem ">Operating System</span>\n                                        </th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span\n                                                translate="userManagement.applicationversion ">Application\n                                                Vesrion</span>\n                                        </th>\n                                        <th><span translate="userManagement.status " style="width: 6%; ">Status</span>\n                                        </th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span translate="userManagement.gpsstatus ">GPS\n                                                Status</span></th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span\n                                                translate="userManagement.geofence ">Geofences</span></th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 7%; "><span\n                                                translate="userManagement.profiles ">Profiles</span></th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span translate="userManagement.fromTime ">From\n                                                Time</span></th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span translate="userManagement.toTime ">To Time</span>\n                                        </th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span translate="userManagement.userimage ">User\n                                                Image</span></th>\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span>Checked In</span></th>\n                                        <th style="width: 5%; ">Actions</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n\n                                    <tr ng-repeat-start="user in vm.usersReporting | filter :search track by user.id ">\n                                        <td style="width: 6%; "><a\n                                                ui-sref="user-management-detail({login:user.login}) ">{{user.login}}</a>\n                                        </td>\n                                        <td style="width: 6%; ">{{user.ownedBy[0].login}}</td>\n                                        <td style="width: 10%; ">{{user.email}}</td>\n                                        <td style="width: 6%; ">{{user.phone}}</td>\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 8%; ">{{user.imei}}</td>\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; ">{{user.gpsimei}}</td>\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; "><span\n                                                class="admin-name ">{{user.operatingSystem}}</span></td>\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; ">{{user.applicationVersion}}</td>\n                                        <td style="width: 6%; ">\n                                            <span class="label label-danger " ng-show="!user.activated "\n                                                translate="userManagement.deactivated ">Deactivated</span>\n                                            <span class="label label-success " ng-show="user.activated "\n                                                translate="userManagement.activated ">Activated</span>\n                                        </td>\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; ">\n                                            <span ng-show="user.gpsStatus " translate="userManagement.gpson ">On</span>\n                                            <span ng-show="!user.gpsStatus "\n                                                translate="userManagement.gpsoff ">Off</span>\n                                        </td>\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; ">\n                                            <div ng-repeat="geofenceNames in user.geofenceNames ">\n                                                <span class="label label-default ">{{geofenceNames}}</span>\n                                            </div>\n                                        </td>\n\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT "\n                                            style="width:\n                                        7%; ">\n                                            <div ng-repeat="authority in user.authorities ">\n                                                <span ng-show="authority===\'ROLE_USER_ADMIN\' "\n                                                    class="label label-primary ">{{ authority }}</span>\n                                                <span ng-show="authority===\'ROLE_VENDOR_ADMIN\' "\n                                                    class="label label-primary ">{{ authority }}</span>\n                                                <span ng-show="authority===\'ROLE_HOD\' " class="label label-primary ">{{\n                                                    authority }}</span>\n                                                <span ng-show="authority===\'ROLE_CITY_MANAGER\' "\n                                                    class="label label-info ">{{ authority }}</span>\n                                                <span ng-show="authority===\'ROLE_CITY_PLANNER\' "\n                                                    class="label label-info ">{{ authority }}</span>\n                                                <span ng-show="authority===\'ROLE_ASSISTANT_MANAGER\' "\n                                                    class="label label-info ">{{ authority }}</span>\n                                                <span ng-show="authority===\'ROLE_TEAM_LEADER\' "\n                                                    class="label label-info ">{{ authority }}</span>\n                                                <span ng-show="authority===\'ROLE_NETWORK_ENGINEER\' "\n                                                    class="label label-info ">{{ authority }}</span>\n                                                <span ng-show="authority===\'ROLE_FRT\' " class="label label-info ">{{\n                                                    authority }}</span>\n                                                <span ng-show="authority===\'ROLE_PATROLLER\' "\n                                                    class="label label-info ">{{ authority }}</span>\n                                            </div>\n                                        </td>\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; ">{{getLocalhour(user.fromTime)}}</td>\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "\n                                            style="width: 6%; ">{{getLocalhour(user.toTime)}}</td>\n                                        <td style="width: 6%; ">\n                                            <div class="col-md-10 ">\n                                                <img ng-show="user.userImage " class="img-responsive "\n                                                    ng-src="data:image/jpeg;base64,{{user.userImage}} "\n                                                    style="padding-bottom: 10px; height: 50px; width: 80px ">\n                                                <img ng-show="!user.userImage " class="img-responsive "\n                                                    ng-src="content/images/userimg.gif " style="padding-bottom: 10px; ">\n                                            </div>\n                                        </td>\n                                        <td style="width: 5%; "> {{ user.reportingStatus }}</td>\n                                        <td style="width: 5%; ">\n                                            <div class="actions ">\n                                                <a ui-sref="user-management-detail({login:user.login}) "\n                                                    class="action-icons text-info " title="View ">\n                                                    <span class="fa fa-eye "></span>\n                                                </a>\n                                                <a ui-sref="user-management.edit({login:user.login}) "\n                                                    class="actions-icons text-primary " title="Edit ">\n                                                    <span class="fa fa-pencil-square "></span>\n                                                </a>\n                                            </div>\n                                        </td>\n                                    </tr>\n                                    </tr>\n                                    <tr ng-repeat-end></tr>\n                                    <tr>\n                                        <td colspan="10 " ng-show="vm.users==0 " style="text-align: center; ">\n                                            <h4>No data available</h4>\n                                        </td>\n                                    </tr>\n\n                                </tbody>\n                            </table>\n                        </div>\n                    </div> --><div class="userlisttab" ng-show="isSet(1) "><jhi-alert></jhi-alert><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover" style="width: 100%; border-spacing:0; margin:0;"><thead class="bg-default"><tr jh-sort="vm.predicate " ascending="vm.reverse " callback="vm.transition() "><!-- <th style="width: 2%; "></th> --><th jh-sort-by="login "><span>User Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="login "><span translate="userManagement.reportedto ">Reported To</span> <span class="fa fa-sort"></span></th><th jh-sort-by="email "><span translate="userManagement.email ">Email</span> <span class="fa fa-sort"></span></th><th jh-sort-by="phone "><span translate="userManagement.phone ">Phone</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="imei"\n                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER ">\n                                            <span translate="userManagement.imei ">IMEI</span>\n                                            <span class="fa fa-sort"></span>\n                                        </th> --><th jh-sort-by="gps_imei " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span translate="userManagement.gpsimei ">GPS IMEI</span> <span class="fa fa-sort"></span></th><th jh-sort-by="operating_system " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span translate="userManagement.operatingsystem ">Operating System</span> <span class="fa fa-sort"></span></th><th jh-sort-by="application_version " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span translate="userManagement.applicationversion ">Application Vesrion</span> <span class="fa fa-sort"></span></th><th jh-sort-by="activated "><span translate="userManagement.status ">Status</span> <span class="fa fa-sort"></span></th><th jh-sort-by="gps_status " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span translate="userManagement.gpsstatus ">GPS Status</span> <span class="fa fa-sort"></span></th><!-- <th\n                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER ">\n                                            <span translate="userManagement.geofence ">Geofences</span>\n                                        </th> --><th ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span translate="userManagement.profiles ">Profiles</span></th><th jh-sort-by="from_time " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span translate="userManagement.fromTime ">From Time</span> <span class="fa fa-sort"></span></th><th jh-sort-by="to_time " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span translate="userManagement.toTime ">To Time</span> <span class="fa fa-sort"></span></th><th ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span translate="userManagement.userimage ">User Image</span></th><th jh-sort-by="reporting_status " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span>Checked In</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="user in vm.users | filter :search track by user.id "><!-- <td style="position:relative; padding-left: 1px;width: 2% ">\n                                            <button ng-click="vm.usersTable({id:user.firstName});expanded=! expanded "\n                                                expand style="padding: 4px 4px;position: absolute;margin-top: -6px; ">\n                                                <span ng-bind="expanded ? \'-\' : \'+\' "\n                                                    style="position: absolute;margin-top: -11px;margin-left: -4px; "></span>\n                                            </button>\n                                        </td> --><td><a ui-sref="user-management-detail({login:user.login}) ">{{user.login}}</a></td><td>{{user.ownedBy[0].login}}</td><td>{{user.email}}</td><td>{{user.phone}}</td><!-- <td\n                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER ">\n                                            {{user.imei}}</td> --><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER ">{{user.gpsimei}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span class="admin-name">{{user.operatingSystem}}</span></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER ">{{user.applicationVersion}}</td><td><span class="label label-danger" ng-show="!user.activated " translate="userManagement.deactivated ">Deactivated</span> <span class="label label-success" ng-show="user.activated " translate="userManagement.activated ">Activated</span></td><td style="text-align: center;padding-top: 14px" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER "><span ng-show="user.gpsStatus " class="dot dotOn"></span> <span ng-show="!user.gpsStatus " class="dot dotOff"></span></td><!-- <td\n                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER ">\n                                            <div ng-repeat="geofenceNames in user.geofenceNames | limitTo:5">\n                                                <span class="label label-default ">{{geofenceNames}}</span>\n                                            </div>\n                                        </td> --><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT "><div ng-repeat="authority in user.authorities "><span ng-show="authority===\'ROLE_USER_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_VENDOR_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_VENDOR\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_HOD\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_CITY_MANAGER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_CITY_PLANNER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ASSISTANT_MANAGER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_TEAM_LEADER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_NETWORK_ENGINEER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_FRT\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_PATROLLER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_PLAN_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_PLAN_INFRA\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_PLAN_SURVEY\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_INFRA\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_SURVEY\' " class="label label-info">{{ authority }}</span></div></td><td style="text-align: center;" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER ">{{user.fromTime}}</td><td style="text-align: center;" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER ">{{user.toTime}}</td><td><div class="col-md-10"><img ng-show="user.userImage " class="img-responsive" ng-src="data:image/jpeg;base64,{{user.userImage}} " style="height: 50px; width: 80px"> <img ng-show="!user.userImage " class="img-responsive" ng-src="content/images/userimg.gif "></div></td><td style="text-align: center;">{{ user.reportingStatus }}</td><td><div class="actions"><a ui-sref="user-management-detail({login:user.login}) " class="action-icons text-info" title="View "><span class="fa fa-eye"></span> </a><a ui-sref="user-management.edit({login:user.login}) " class="actions-icons text-primary" title="Edit " ng-hide="has_ROLE_VENDOR"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-show="expanded "><td></td><td colspan="16"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 20px;"><thead><tr></tr></thead><tbody><tr ng-repeat-start="userData in vm.usersData "><td style="width: 7%;"><a ui-sref="user-management-detail({login:user.login}) ">{{userData.login}}</a></td><td style="width: 6%;">{{userData.createdBy}}</td><td style="width: 12%;">{{userData.email}}</td><td style="width: 6%;">{{userData.phone}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 6%;">{{userData.imei}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 8%;">{{userData.gpsimei}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 7%;"><span class="admin-name">{{userData.operatingSystem}}</span></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 6%;">{{userData.applicationVersion}}</td><td style="width: 6%;"><span class="label label-danger" ng-show="!userData.activated " translate="userManagement.deactivated ">Deactivated</span> <span class="label label-success" ng-show="userData.activated " translate="userManagement.activated ">Activated</span></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 6%;"><span ng-show="userData.gpsStatus " translate="userManagement.gpson ">On</span> <span ng-show="!userData.gpsStatus " translate="userManagement.gpsoff ">Off</span></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 6%;"><div ng-repeat="geofenceNames in userData.geofenceNames "><span class="label label-default">{{geofenceNames}}</span></div></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 7%;"><div ng-repeat="authority in userData.authorities "><span ng-show="authority===\'ROLE_USER_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_HOD\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_CITY_MANAGER\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_CITY_PLANNER\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_ASSISTANT_MANAGER\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_TEAM_LEADER\' " class="label label-primary">{{ authority }}</span></div></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 6%;">{{getLocalhour(userData.fromTime)}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER " style="width: 6%;">{{getLocalhour(userData.toTime)}}</td><td style="width: 6%;"><div class="col-md-10"><img ng-show="userData.userImage " class="img-responsive" ng-src="data:image/jpeg;base64,{{userData.userImage}} " style="padding-bottom: 10px; height: 50px; width: 80px"> <img ng-show="!userData.userImage " class="img-responsive" ng-src="content/images/userimg.gif " style="padding-bottom: 10px;"></div></td><td style="width: 5%;">{{ user.reportingStatus }}</td><td style="width: 6%;"><div class="actions"><a ui-sref="user-management-detail({login:userData.login}) " class="action-icons text-info" title="View "><span class="fa fa-eye"></span> </a><a ui-sref="user-management.edit({login:userData.login}) " class="actions-icons text-primary" title="Edit "><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.users==0 " style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-10"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page " total="vm.queryCount " items-per-page="vm.itemsPerPage "></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems " ng-model="vm.page " ng-change="vm.transition() "></uib-pagination></div></div></div></div><!--userlisttab--><div class="hierarchytab" ng-show="isSet(2) "><div id="body"></div></div><!--hierarchy View--><!--Nearest Users--><div class="map-view" ng-show="isSet(3) "><div class="row mt-5"><div class="col-md-12"><div id="map_canvas" style="height:{{mapHeight}}px; width:100%"></div></div></div></div><!--Nearest Users--></div></div></div></div></div><div id="listFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 70%;" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Master Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeListFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Master Geofence for List</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveListFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" style="color: red;font-weight: bold;" ng-show="vm.masterGeofences.length <= 1">* NO DATA</span><div style="margin-left: 35px;"><br><div ng-repeat="item in vm.masterGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedListGeofenceId" ng-value="{{item.id}}"> <label for="{{item.id}}" style="margin-left: 10px;font-size: medium;">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="mapFilterUserManagementModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 70%;" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeUserManagementMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveUserManagementGeofenceFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" style="color: red;font-weight: bold;" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div style="margin-left: 35px;"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" style="margin-left: 10px;font-size: medium;">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="container"><div class="content" ng-if="!vm.isAuthenticated()" ng-cloak><div class="row login-sizes"><div class="mt-45"></div><div class="col-md-7 col-sm-8 login-main"><div class="login-image"><img class="img-responsive1" ng-src="content/images/welcome-to-fiberify.png"></div></div><div class="col-md-4 col-sm-8 col-md-offset-1 col-sm-offset-2"><div class="mt-45"></div><div class="panel panel-primary login-panel"><div class="panel-heading"><span translate="login.title" class="signin-heading">Sign in</span></div><div class="panel-body"><form class="form-horizontal" role="form" ng-submit="vm.login($event)"><div class="form-group"><div class="col-md-12"><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div></div><div class="form-group has-feedback"><div class="col-sm-12"><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"> <span class="fa fa-user form-control-feedback"></span></div></div><div class="form-group has-feedback"><div class="col-sm-12"><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"> <span class="fa fa-lock form-control-feedback"></span></div></div><div class="form-group"><label for="rememberMe" class="col-md-12"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span translate="login.form.rememberme">Remember me</span></label></div><div class="form-group"><div class="col-sm-12"><button type="submit" class="btn btn-info btn-sm btn-block" translate="login.form.button">Sign in</button></div></div></form><div class="mt-20"></div></div><div class="panel-footer bg-default text-center"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" translate="login.password.forgot">Did you forget your password?</a></div></div><div class="col-md-12 login-shadow"><div class="footer-shadow"><img ng-src="content/images/shadow.png" class="img-responsive"></div></div></div></div></div></div><div class="pt-76"></div>');
$templateCache.put('app/entities/asset-type/asset-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.assetType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.assetType.delete.question" translate-values="{id: \'{{vm.assetType.id}}\'}">Are you sure you want to delete this Asset Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/asset-type/asset-type-detail.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate="trakeyeApp.assetType.detail.title">Asset Type</span> - {{vm.assetType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.assetType.name">Name</span></dt><dd><span>{{vm.assetType.name}}</span></dd><dt><span translate="trakeyeApp.assetType.description">Description</span></dt><dd><span>{{vm.assetType.description}}</span></dd><dt><span translate="trakeyeApp.assetType.layout">Layout</span></dt><dd><span translate="{{\'trakeyeApp.Layout.\' + vm.assetType.layout}}">{{vm.assetType.layout}}</span></dd><dt><span>Asset Visibility</span></dt><dd><span>{{vm.assetType.zoomLevel}}</span></dd><!-- <dt ng-show="vm.assetType.layout == \'FIXED\'"><span>Asset Label Visibility</span></dt>\n\t\t\t\t\t\t\t<dd ng-show="vm.assetType.layout == \'FIXED\'">\n\t\t\t\t\t\t\t\t<span>{{vm.assetType.zoomLevelLabel}}</span>\n\t\t\t\t\t\t\t</dd> --><dt ng-show="{{vm.assetType.colorcode != null}}"><span translate="trakeyeApp.assetType.colorcode">Colorcode</span></dt><dd ng-show="{{vm.assetType.colorcode != null}}"><span><div class="square" style="background-color: {{vm.assetType.colorcode}}"></div></span></dd><dt ng-show="{{vm.assetType.image != null}}"><span translate="trakeyeApp.assetType.assetimage">Asset Image</span></dt><dd ng-show="{{vm.assetType.image != null}}"><div class="col-md-3"><img class="img-responsive img__assetImage" ng-src="data:image/jpeg;base64,{{vm.assetType.image}}"></div></dd><dt><span translate="trakeyeApp.assetType.createDate">Create Date</span></dt><dd><span>{{vm.assetType.createDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.assetType.updateDate">Update Date</span></dt><dd><span>{{vm.assetType.updateDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.assetType.user">User</span></dt><dd><span>{{vm.assetType.createdBy}}</span></dd><div class="form-group div__attribute" ng-repeat="item in vm.assetType.assetTypeAttributes"><dt><span>Non-Reference Attribute</span><span> {{$index + 1}}</span></dt><div class="col-md-6"><span>{{item.name}}</span><span class="span__attribute">{{item.defaultValue}}</span></div></div><div class="form-group div__attribute" ng-repeat="item in  vm.referenceAttribute"><dt><span>Reference Attribute</span><span> {{$index + 1}}</span></dt><div class="col-md-6"><span>{{item.name}}</span><span class="span__attribute">{{item.defaultValue}}</span></div></div></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="asset-type-detail.edit({id:vm.assetType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/asset-type/asset-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.assetType.id" translate="trakeyeApp.assetType.home.create">Create</span> <span ng-if="vm.assetType.id" translate="trakeyeApp.assetType.home.edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group" ng-show="vm.assetType.id">\n\t\t\t\t\t            <label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label>\n\t\t\t\t\t            <div class="col-md-7">\n\t\t\t\t\t            \t<input type="text" class="form-control" id="id" name="id"\n\t\t\t\t\t                    ng-model="vm.assetType.id" readonly />\n\t\t\t\t\t            </div>\n\t\t\t\t\t            \t\n\t\t\t\t\t        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.assetType.name" for="field_name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><input type="text" id="xyz" class="form-control" name="name" id="field_name" ng-model="vm.assetType.name" required ng-minlength="2" ng-maxlength="50" ng-disabled="vm.assetType.id!=null"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.assetType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.assetType.description"></textarea></div></div><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.assetType.layout" for="field_layout">Layout</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9" ng-show="vm.assetType.layout == null"><select class="form-control" name="layout" ng-model="vm.assetType.layout" id="field_layout" required><option value="FIXED" translate="trakeyeApp.assetType.Layout.FIXED">FIXED</option><option value="SPREAD" translate="trakeyeApp.assetType.Layout.SPREAD">SPREAD</option></select></div><div class="col-md-9" ng-show="vm.assetType.layout != null"><select class="form-control" name="layout" ng-model="vm.assetType.layout" id="field_layout" ng-disabled="vm.assetType.layout != null"><option value="FIXED" translate="trakeyeApp.assetType.Layout.FIXED">FIXED</option><option value="SPREAD" translate="trakeyeApp.assetType.Layout.SPREAD">SPREAD</option></select></div></div><div class="form-group" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="col-md-2 control-label" translate="trakeyeApp.assetType.selectcolor" for="field_description">Select Color</label><div class="col-md-9"><div class="square--CYAN square" ng-click="vm.colorcode(\'CYAN\')"></div>&nbsp;&nbsp;<div class="square--BLACK square" ng-click="vm.colorcode(\'BLACK\')"></div>&nbsp;&nbsp;<div class="square--BLUE square" ng-click="vm.colorcode(\'BLUE\')"></div>&nbsp;&nbsp;<div class="square--BLUEVIOLET square" ng-click="vm.colorcode(\'BLUEVIOLET\')"></div>&nbsp;&nbsp;<div class="square--BROWN square" ng-click="vm.colorcode(\'BROWN\')"></div>&nbsp;&nbsp;<div class="square--CHARTREUSE square" ng-click="vm.colorcode(\'CHARTREUSE\')"></div>&nbsp;&nbsp;<div class="square--CRIMSON square" ng-click="vm.colorcode(\'CRIMSON\')"></div>&nbsp;&nbsp;<div class="square--YELLOW square" ng-click="vm.colorcode(\'YELLOW\')"></div>&nbsp;&nbsp;<div class="square--MAGENTA square" ng-click="vm.colorcode(\'MAGENTA\')"></div>&nbsp;&nbsp;<div class="square--DEEPPINK square" ng-click="vm.colorcode(\'DEEPPINK\')"></div>&nbsp;&nbsp;<div class="square--LIGHTCORAL square" ng-click="vm.colorcode(\'LIGHTCORAL\')"></div>&nbsp;&nbsp;<div class="square--DARKORANGE square" ng-click="vm.colorcode(\'DARKORANGE\')"></div></div></div><div class="form-group" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="col-md-2 control-label"><span translate="trakeyeApp.assetType.colorcode" for="field_colorcode">Colorcode</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><input type="text" class="form-control" name="colorcode" id="field_colorcode" ng-model="vm.assetType.colorcode" readonly="readonly" required></div></div><div class="form-group"><label class="col-md-2 control-label"><span>ROLE</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><div isteven-multi-select input-model="vm.multiAuthorities" output-model="vm.authorities" button-label="name" item-label="name" tick-property="ticked" helper-elements="all none" output-properties="name selected"></div><input type="text" ng-model="vm.authorities" name="fence" id="input__none" required></div></div><div class="form-group" ng-if="vm.assetType.layout==\'FIXED\'"><label class="col-md-2 control-label"><span>Senior Element</span></label><div class="col-md-9"><label class="switch" style="margin-top: 7px;"><input type="checkbox" style="margin-top: 10px;\n                                             margin-left: 15px;" ng-model="vm.assetType.isSeniorElement"> <span class="slider round"></span></label></div></div><div class="form-group" ng-hide="vm.assetType.isSeniorElement"><label class="col-md-2 control-label">Asset Visibility</label> <select class="col-md-1" id="zoomlevel" ng-show="vm.assetType.layout==\'SPREAD\'"><!-- <option>10</option>\n\t\t\t\t\t\t\t\t<option>11</option> --><option>12</option><option>13</option><option>14</option></select> <select class="col-md-1" id="zoomlevelFixed" ng-show="vm.assetType.layout==\'FIXED\'"><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option></select></div><!-- <div class="form-group" ng-show="vm.assetType.layout==\'FIXED\'">\n                            <label class="col-md-2  control-label">Asset Label Visibility</label>\n\t\t\t\t\t\t\t<select class="col-md-1"  id="zoomlevelLabel" >\n\t\t\t\t\t\t\t\t<option>18</option>\n\t\t\t\t\t\t\t\t<option>19</option>\n\t\t\t\t\t\t\t\t<option>20</option>\n\t\t\t\t\t\t\t</select>\n                        </div> --><div class="form-group" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="col-md-2 control-label">Link Width</label> <select class="col-md-1" id="lineWidth"><option>20</option><option>40</option><option>60</option><option>80</option><option>100</option><option>120</option><option>140</option><option>160</option><option>180</option><option>200</option><option>220</option><option>240</option><option>260</option><option>280</option><option>300</option><option>320</option><option>340</option><option>360</option><option>380</option><option>400</option></select></div><div class="form-group" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="col-md-2 control-label">Opacity</label> <select class="col-md-1" id="transparency"><option>20</option><option>40</option><option>60</option><option>80</option><option>100</option></select></div><div class="form-group" ng-show="vm.assetType.layout==\'FIXED\'"><label class="col-md-2 control-label"><span translate="trakeyeApp.assetType.assetimage" for="field_assetimage">Asset Image</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="assetImage" id="assetImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.assetType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 assetType_showImage" ng-if="vm.assetType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-3"><!-- <img class="img-responsive " ng-src="data:image/jpeg;base64,{{vm.assetType.image}}" style="padding-bottom: 10px; width:55px; height:55px; margin-left:250px;"> --> <img class="img-responsive img__showImage" ng-src="{{assetType.imagePath}}"></div></div></div><!--  <div class="form-group" ng-repeat="item in vm.items">\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.assetType.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-7">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" required>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t<div class="col-md-2 mt-5">\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\n\t\t\t\t\t\t\t\t  </button>\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>             \n\t\t               </div> --><!-- <div class="form-group" ng-repeat="item in vm.items">\n\t\t\t\t\t       \n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.assetType.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.assetType.dataType">Data Type</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType"  class="form-control select2" ng-change="dataTypeValue()">\n\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in attributetypes">{{atttype }} \n\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.assetType.defaultValue">Dafault Value</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t   <input  type="number" ng-if="item.dataType == \'\'" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"   ng-model="item.defaultValue">\n\t\t\t\t\t\t\t\t<input  ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01" required  >\n\t\t\t\t\t\t\t\t<input  ng-if="item.dataType == \'INTEGER\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"     ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/"  required  >\n\t\t\t\t\t\t\t\t<input  ng-if="item.dataType == \'STRING\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"   ng-model="item.defaultValue"  required  >\n\t\t\t\t\t\t\t\t<p ng-if="item.dataType == \'float\'" class="help-block"\n\t\t\t\t\t\t\t\t   ng-show="editForm.types.$error.pattern">\n\t\t\t\t\t\t\t\t\tInvalid.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t    <select ng-model="item.defaultValue"  ng-if="item.dataType == \'BOOLEAN\'" class="form-control select2" >\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\n\t\t\t\t\t\t\t   </select>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t\n       \n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\n\t\t\t\t\t\t\t\t  </button>\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>             \n\t\t\t\t\t\t</div>\t --><div class="form-group caseType_repeat"><br><div class="container"><div class="row text-center"><label class="col-md-10 col-sm-3 mb-5"><span><u>Non-Reference</u></span></label></div><div class="row"><label class="col-md-2 col-sm-3"><span translate="trakeyeApp.assetType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2 col-sm-3"><span translate="trakeyeApp.assetType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2 col-sm-2"><span translate="trakeyeApp.assetType.defaultValue">Default Value</span></label> <label class="col-md-2 col-sm-2"><span>Attribute Type</span></label> <label class="col-md-1 col-sm-1" ng-if="vm.assetType.layout==\'SPREAD\'"><span>Popup Display</span></label><!-- <label class="col-md-1  col-sm-1 ">\n\t\t\t\t\t\t\t\t\t\t<span>List View Display</span>\n\t\t\t\t\t\t\t\t\t</label> --> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <button type="button" class="btn btn-xs btn-primary add-more" ng-hide="vm.items.length > 0" ng-click="vm.addNonReferenceAttribute($index)"><i class="fa fa-plus"></i></button></div><br><div class="row" ng-repeat="item in vm.items"><div class="col-md-2 col-sm-3"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><div class="col-md-2 col-sm-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customAssetTypeAttributes track by item.id"></select></div><div class="col-md-2 col-sm-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue"> <select ng-model="item.defaultValue" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-2 col-sm-2"><select ng-model="item.assetAttributeTypes" class="form-control"><option value="NON_REFERENCE">NON_REFERENCE</option><option value="THREE_PNT_REFERENCE">THREE_PNT_REFERENCE</option></select></div><div class="col-md-1 col-sm-1" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="switch"><input type="checkbox" style="margin-top: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t margin-left: 15px;" ng-model="item.assetTypePopupDisplay"> <span class="slider round"></span></label></div><!-- <div class="col-md-1 col-sm-1">\n\t\t\t\t\t\t\t\t\t\t<label class="switch">\n\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" style="\n\t\t\t\t\t\t\t\t\t\t\t\t\t margin-top: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t margin-left: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\t " \n\t\t\t\t\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t\t\t\t\t ng-model="item.assetTypeListViewDisplay"\n\t\t\t\t\t\t\t\t\t\t\t\t  /> \n\t\t\t\t\t\t\t\t\t\t\t <span class="slider round"></span>\n\t\t\t\t\t\t\t\t\t\t\t </label>\n\t\t\t\t\t\t\t\t\t</div> --><div class="col-md-1"><input type="text" class="form-control" ng-model="item.assetTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><div class="col-md-1 col-sm-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div></div></div><hr><div class="form-group caseType_repeat" ng-if="vm.assetType.layout==\'FIXED\'"><br><div class="container"><div class="row text-center"><label class="col-md-10 col-sm-3 mb-5"><span><u>Reference</u></span></label></div><div class="row"><label class="col-md-2 col-sm-3"><span translate="trakeyeApp.assetType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2 col-sm-3"><span translate="trakeyeApp.assetType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2 col-sm-2"><span translate="trakeyeApp.assetType.defaultValue">Default Value</span></label><!-- <label class="col-md-2  col-sm-2 ">\n\t\t\t\t\t\t\t\t\t\t<span>Attribute Type</span>\n\t\t\t\t\t\t\t\t\t</label> --><!-- <label class="col-md-1  col-sm-1 " ng-if="vm.assetType.layout==\'SPREAD\'">\n\t\t\t\t\t\t\t\t\t\t<span>Popup Display</span>\n\t\t\t\t\t\t\t\t\t</label> --> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <button type="button" class="btn btn-xs btn-primary add-more" ng-hide="vm.referenceAttribute.length > 0" ng-click="vm.addNewReferenceAttribute($index)"><i class="fa fa-plus"></i></button></div><br><div class="row" ng-repeat="item in vm.referenceAttribute"><div class="col-md-2 col-sm-3"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><div class="col-md-2 col-sm-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customAssetTypeAttributes track by item.id"></select></div><div class="col-md-2 col-sm-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue"> <select ng-model="item.defaultValue" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1" ng-if="( $index + 1) % 3 === 0"><!-- 1039 change % 2 to % 3--> <input type="text" class="form-control" ng-model="item.assetTypeRfrncAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><div class="col-md-1 col-sm-1" ng-if="( $index + 1) % 3 === 0"><!-- 1039 change % 2 to % 3--> <button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addReferenceAttribute($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="removeRow($index)" ng-disabled="vm.referenceAttribute.length <= 3"><i class="fa fa-minus"></i></button></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="asset-type"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset-type/asset-types.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-suitcase"></i> <span translate="trakeyeApp.assetType.home.title">Asset Types</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ng-click="vm.navigateCreateAssetType();"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.assetType.home.createLabel">Create new Asset Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.assetType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> \n\t\t\t\t\t\t\t\t\t\t<span class="fa fa-sort"></span></th>--><th jh-sort-by="name"><span translate="trakeyeApp.assetType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.assetType.description">Description</span><span class="fa fa-sort"></span></th><th jh-sort-by="layout"><span translate="trakeyeApp.assetType.layout">Layout</span><span class="fa fa-sort"></span></th><th jh-sort-by="colorcode"><span translate="trakeyeApp.assetType.colorcode">Colorcode</span><span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.assetType.assetimage">Asset Image</span></th><!-- <th><span translate="trakeyeApp.assetType.createDate">Create Date</span><span class="fa fa-sort"></span></th>\n\t\t\t\t\t\t\t\t\t<th><span translate="trakeyeApp.assetType.updateDate">Update Date</span><span class="fa fa-sort"></span></th> --><th><span translate="trakeyeApp.assetType.user">User</span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="assetType in vm.assetTypes track by assetType.id "><!-- <td><a ui-sref="asset-type-detail({id:assetType.id})">{{assetType.id}}</a></td> --><td>{{assetType.name}}</td><td>{{assetType.description}}</td><td translate="{{\'trakeyeApp.Layout.\' + assetType.layout}}">{{assetType.layout}}</td><!-- <td>{{assetType.colorcode}}</td>  --><td><div class="square" style="background-color: {{assetType.colorcode}}"></div></td><!-- <td> --><!-- <img ng-src={{assetType.assetImage}} style="width: 15px; height: 25px;" ng-show="{{assetType.assetImage != null}}"/> --><td><!-- <img ng-src={{assetType.assetImage}} style="width: 15px; height: 25px;" ng-show="{{assetType.assetImage != null}}"/> --><!-- <div class="col-md-9"\n\t\t\t\t\t\t\t\t\t\t\tng-show="{{assetType.imagePath != null}}">\n\t\t\t\t\t\t\t\t\t\t\t<img class="img-responsive"\n\t\t\t\t\t\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{assetType.imagePath}}"\n\t\t\t\t\t\t\t\t\t\t\t\tstyle="width: 40px; height: 40px;">\n\t\t\t\t\t\t\t\t\t\t</div> --><div class="col-md-9" ng-show="{{assetType.imagePath != null}}"><img class="img-responsive img__assetImage" ng-src="{{assetType.imagePath}}"></div><!--  <img class="img-responsive" ng-src="{{assetType.imagePath}}" style="padding-bottom: 10px;">--></td><!-- <td>{{assetType.createDate| date:\'medium\'}}</td>\n\t\t\t\t                    <td>{{assetType.updateDate| date:\'medium\'}}</td> --><td>{{assetType.createdBy}}</td><td><div class="action"><a ui-sref="asset-type-detail({id:assetType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="asset-type.edit({id:assetType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><!--<a ui-sref="asset-type.delete({id:assetType.id})"\n\t\t\t\t\t\t\t\t\t\t\t\tclass="action-icons text-primary" title="Edit">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="fa fa-trash"></span> \n\t\t\t\t\t\t\t\t\t\t\t</a>--></div></td></tr><tr><td colspan="10" ng-show="vm.assetTypes == 0" class="td__noDataAvailable"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/attributeMapping/attribute-mapping-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Attribute Mapping ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/attributeMapping/attribute-mapping-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomCaseTypeAttributeLabel"><span ng-if="!vm.customCaseTypeAttribute.id">Create a new Attribute Mapping</span><!-- <span ng-if="vm.customCaseTypeAttribute.id">Edit</span> --></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span>Select Parent Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4 dropFilter"><div isteven-multi-select input-model="vm.category" output-model="vm.selectedCategoryLeft" button-label="name" item-label="name" output-properties="id name customCaseTypeAttributeValues" tick-property="ticked" on-item-click="funcCategoryLeft()" disable-property="disabledLeft" max-height="236px" selection-mode="single" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedCategoryLeft" name="vm.searchMini" style="display:none" required></div><div ng-show="vm.selectedCategoryLeft.length > 0"><label class="col-md-2 control-label"><span>Select Parent Sub-Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4 dropFilter"><div isteven-multi-select input-model="vm.category" output-model="vm.selectedCategoryRight" button-label="name" item-label="name" output-properties="id name customCaseTypeAttributeValues" tick-property="selected" on-item-click="funcCategoryRight()" max-height="236px" selection-mode="single" helper-elements="all none Done filter" disable-property="disabledRight"></div><input type="text" ng-model="vm.selectedCategoryRight" name="vm.searchMini" style="display:none" required></div></div></div><div class="form-group" ng-show="vm.selectedCategoryLeft.length > 0 && vm.selectedCategoryRight.length > 0"><label class="col-md-2 control-label"><span>Select Case-Type Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4 dropFilter"><div isteven-multi-select input-model="vm.subCategoryLeft" output-model="vm.selectedSubCategoryLeft" button-label="value" item-label="value" output-properties="id value" tick-property="ticked" max-height="236px" selection-mode="single" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedSubCategoryLeft" name="vm.searchMini" style="display:none" required></div><div ng-show="vm.selectedCategoryRight.length > 0 && vm.selectedSubCategoryLeft.length > 0"><label class="col-md-2 control-label"><span>Select Case-Type Sub-Category </span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4 dropFilter"><div isteven-multi-select input-model="vm.subCategoryRight" output-model="vm.selectedSubCategoryRight" button-label="value" item-label="value" output-properties="id value" tick-property="ticked" max-height="236px" helper-elements="all none filter"></div><input type="text" ng-model="vm.selectedSubCategoryRight" name="vm.searchMini" style="display:none" required></div></div></div><!-- <div class="form-group">\r\n\t\t\t\t\t\t\t<div  ng-show="vm.selectedSubCategoryLeft.length > 0">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="attribute-mapping"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/attributeMapping/attribute-mapping.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span>Attribute Mapping</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="attribute-mapping.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><!-- <div class="row">\r\n\t\t\t\t\t\t\t<div class="col-md-3 pull-right">\r\n\t\t\t\t\t\t\t\t<div class="input-group ">\r\n\t\t\t\t\t\t\t\t<input  type="text"  ng-model="search" class="form-control " ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.attributeMap.home.search\' | translate}}">\r\n\t\t\t\t\t\t\t\t\t<span class="input-group-btn">\r\n\t\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-info btn-flat"  ng-click="vm.filterSearch()">\r\n\t\t\t\t\t\t\t\t\t\t<i class="fa fa-search"></i></button>\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th><span>Parent Case Type Category</span> <span class="fa fa-arrow-right"></span></th><th><span class="fa fa-arrow-left"></span> <span>Parent Case Type Sub Category</span></th><th><span>Case Type Category</span> <span class="fa fa-arrow-right"></span></th><th><span class="fa fa-arrow-left"></span> <span>Case Type Sub Category</span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="attributeMap in vm.attributeMappingList  | filter :search track by attributeMap.id"><td><a ui-sref="custom-case-type-attribute-detail({id:attributeMap.id})">{{attributeMap.id}}</a></td><td>{{attributeMap.parentCaseTypeCategory.name}}</td><td>{{attributeMap.parentCaseTypeSubCategory.name}}</td><td>{{attributeMap.caseTypeCategory.value}}</td><td>{{attributeMap.caseTypeSubCategory.value}}</td><td><div class="actions"><!-- <a ui-sref="custom-case-type-attribute-detail({id:attributeMap.id})"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="action-icons text-info" title="View">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="fa fa-eye"></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t  </a> --><!-- <a ui-sref="custom-case-type-attribute.edit({id:attributeMap.id})"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="action-icons text-primary" title="Edit">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="fa fa-pencil-square"></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a> --> <a ui-sref="attribute-mapping.delete({id:attributeMap.id})" ng-click="passDeleteId(attributeMap.id)" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.attributeMappingList == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-addition.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.asset.id" translate="trakeyeApp.asset.home.create">Create</span> <span ng-if="vm.asset.id" translate="trakeyeApp.asset.home.update">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div><label class="col-md-3 control-label asset_parent"><span>Select Asset</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7 asset_parent"><div isteven-multi-select input-model="vm.multiassets" output-model="vm.asset.ownedBy" button-label="name" item-label="name" tick-property="ticked" selection-mode="single" output-properties="id selected"></div><input type="text" ng-model="vm.asset.ownedBy" name="assetName" id="input__none"><br></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.coordinates">Coordinates</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><div class="input-group"><input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled="disabled" ng-model="vm.asset.assetCoordinates" required> <span class="input-group-btn" ng-if="vm.asset.id==null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Create</button> </span><span class="input-group-btn" ng-if="vm.asset.id!=null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">View or Edit</button> </span><span class="input-group-btn" ng-if="vm.asset.id!=null"><button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm">Destroy and Create</button></span></div><br><div id="map_canvas" class="div__map-canvas"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="asset"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button><!-- ng-disabled="editForm.$invalid || vm.isSaving" --><!-- \t\t\t\t        <button type="submit"  class="btn btn-primary btn-sm"> --><!-- <button onclick="topFunction()" id="myBtn" type="submit"\n\t\t\t\t\t\t\t\tclass="btn btn-primary btn-sm pull-left">\n\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-save"></span>&nbsp;<span\n\t\t\t\t\t\t\t\t\ttranslate="entity.action.save">Save</span>\n\t\t\t\t\t\t\t</button> --></div><script>//Get the button\n\t\t\t\t\t\t\tvar mybutton = document.getElementById("myBtn");\n\n\t\t\t\t\t\t\t// When the user scrolls down 20px from the top of the document, show the button\n\t\t\t\t\t\t\twindow.onscroll = function() {\n\t\t\t\t\t\t\t\tscrollFunction()\n\t\t\t\t\t\t\t};\n\n\t\t\t\t\t\t\tfunction scrollFunction() {\n\t\t\t\t\t\t\t\t/* if (document.body.scrollTop\n\t\t\t\t\t\t\t\t\t\t|| document.documentElement.scrollTop) {\n\t\t\t\t\t\t\t\t\tmybutton.style.display = "block";\n\t\t\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t\t\tmybutton.style.display = "none";\n\t\t\t\t\t\t\t\t} */\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t// When the user clicks on the button, scroll to the top of the document\n\t\t\t\t\t\t\tfunction topFunction() {\n\t\t\t\t\t\t\t\tdocument.body.scrollTop = 0;\n\t\t\t\t\t\t\t\tdocument.documentElement.scrollTop = 0;\n\t\t\t\t\t\t\t}</script></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-connect.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.asset.id">Connect Two Sites</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div class="col-md-10"><div class="col-md-2"><span><b>Connect Type :</b></span></div><div class="col-md-4"><fieldset data-role="controlgroup" data-type="horizontal" name="connecttype" id="connecttype" style="margin-left: -38px;"><span><input name="connectTypeRdo" id="connectTypeRadio1" value="Automatic" type="radio"> <label for="connectTypeRadio1">Automatic</label> </span>&nbsp;&nbsp;&nbsp; <span><input name="connectTypeRdo" id="connectTypeRadio2" value="Manual" type="radio"> <label for="connectTypeRadio2">Manual</label></span></fieldset></div><div class="col-md-2"><span><b>Road Side :</b></span></div><div class="col-md-4"><fieldset data-role="controlgroup" data-type="horizontal" name="roadside" id="roadside" style="margin-left: -63px;"><span><input name="RoadSideRdo" id="roadSideRadio1" value="Left" type="radio"> <label for="roadSideRadio1">Left</label> </span>&nbsp;&nbsp;&nbsp; <span><input name="RoadSideRdo" id="RoadSiteRdo" value="Right" type="radio"> <label for="roadSideRadio2">Right</label></span></fieldset></div></div><br><br><div style="margin-top: 8px; margin-left: 36px;"><label class="col-md-2"><span>Fiber Owner</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-4"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.fiberowner" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><br><br><div style="margin-top: 8px; margin-left: 36px;"><div class="col-md-1 select_asset" style="text-align: right"><label style="padding-top: 6px;">Site A</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;"><select id="fromAssetsView" class="select2 form-control" name="search" style="width:\n                                    220px; height: 40px"><option value="">--Select Site A--</option><option ng-repeat="item in vm.multiassets" value="{{item.id}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px; margin-left: 93px;"><label style="padding-top: 6px;">Site B</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;margin-left: -15px;"><select id="toAssetsView" class="select2 form-control" name="search" style="width:\n                                    220px; height: 40px;"><option value="">--Select Site B--</option><option ng-repeat="item in vm.multiassets" value="{{item.id}}">{{item.name}}</option></select></div><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Connect</button></div><div class="form-group"><div class="col-md-11" style="margin: 20px"><div id="map_canvas" style="height:360px;"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="asset"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button><!-- type="submit" ng-disabled="editForm.$invalid || vm.isSaving" --> <button class="btn btn-primary btn-sm" ng-click="vm.save()" type="button" class="btn btn-primary btn-sm pull-right" ng-disabled="vm.isSaving"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button><!-- <button type="button" class="btn btn-default btn-sm"\n                                ui-sref="asset">\n                                <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span\n                                    translate="entity.action.cancel">Cancel</span>\n                            </button>\n                            <button ng-click="vm.save()" type="button" class="btn btn-primary btn-sm pull-right" ng-disabled="vm.isEnabled">\n                                <span class="glyphicon glyphicon-save"></span>&nbsp;<span\n                                    translate="entity.action.save">Save</span>\n                            </button> --></div><script>//Get the button\n                            var mybutton = document.getElementById("myBtn");\n\n                            // When the user scrolls down 20px from the top of the document, show the button\n                            window.onscroll = function() {\n                                scrollFunction()\n                            };\n\n                            function scrollFunction() {\n                                if (document.body.scrollTop ||\n                                    document.documentElement.scrollTop) {\n                                    mybutton.style.display = "block";\n                                } else {\n                                    mybutton.style.display = "none";\n                                }\n                            }\n\n                            // When the user clicks on the button, scroll to the top of the document\n                            function topFunction() {\n                                document.body.scrollTop = 0;\n                                document.documentElement.scrollTop = 0;\n                            }</script></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.asset.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.asset.delete.question" translate-values="{id: \'{{vm.asset.name}}\'}">Are you sure you want to delete this Asset?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/asset/asset-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" ng-hide=\'vm.asset.assetType.layout == "SPREAD"\'><span translate="trakeyeApp.asset.detail.title">Asset</span> - {{vm.asset.name}}</h3><div class="col-md-4 col-sm-2 headerTab30" ng-show=\'vm.asset.assetType.layout == "SPREAD"\'><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view">Asset</span> <span class="header_view">Details</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2);" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Linked Fixed</span> <span class="header_view">Assets</span></a></li></ul></div></div><div ng-show="isSet(1)"><div class="col-md-12 mt-5"><a ui-sref="asset-detail.edit({id:vm.asset.id})" class="btn btn-primary" ng-if="has_ROLE_CITY_PLANNER||has_ROLE_USER_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Asset Details</span></h4><div class="box-body"><!-- <jhi-alert-error></jhi-alert-error> --><dl class="dl-horizontal jh-entity-details"><!-- <dt>\n                                    <span>Id</span>\n                                </dt>\n                                <dd>\n                                    <span>{{vm.asset.id}}</span>\n                                </dd> --><dt><span translate="trakeyeApp.asset.name">Name</span></dt><dd><span>{{vm.asset.name}}</span></dd><dt><span translate="trakeyeApp.asset.description">Description</span></dt><dd><span>{{vm.asset.description}}</span></dd><!-- <dt><span translate="trakeyeApp.geofence.coordinates">Coordinates</span></dt>\n                                    <dd>\n                                    <div id="map_canvas" style="width:100%;height:400px;    margin-bottom: 10px;"></div>\n                                    </dd> --><!-- <dt><span>Health Indicator</span></dt>\n                                <dd>\n                                    <span>\n                                        <input\n                                            type="checkbox"                                   \n                                            style="\n                                                margin-left: 5px;\n                                                width: 17px;\n                                                height: 17px;\n                                                cursor: not-allowed\n                                            "onclick="return false"\n                                            ng-checked="vm.asset.healthIndicator"                                    \n                                    /></span>\n                                </dd>\n        \n                                <dt><span>Health Remarks</span></dt>\n                                <dd>\n                                    <span>{{vm.asset.healthRemarks}}</span>\n                                </dd> --><dt><span translate="trakeyeApp.asset.assetType">Asset Type</span></dt><dd><span><a ui-sref="asset-type-detail({id:vm.asset.assetType.id})">{{vm.asset.assetType.name}}</a></span></dd><dd ng-if="has_ROLE_USER">{{vm.asset.assetType.name}}</dd><dt ng-show=\'vm.asset.assetType.layout == "SPREAD"\'><span>Length (mtrs)</span></dt><dd ng-show=\'vm.asset.assetType.layout == "SPREAD"\'><span>{{(vm.asset.assetLength * 1000).toFixed(2)}}</span></dd><dt><span>Accessible</span></dt><dd><span><!-- <input\n                                            type="checkbox"                                   \n                                            style="\n                                                margin-left: 5px;\n                                                width: 17px;\n                                                height: 17px;\n                                                cursor: not-allowed\n                                            "onclick="return false"\n                                            ng-checked="vm.asset.accessible"                                    \n                                    /> --><label class="switch"><input type="checkbox" style="margin-top: 10px;\n                                        margin-left: 15px;\n                                        cursor: not-allowed" onclick="return false" ng-checked="vm.asset.accessible"> <span class="slider round" style="cursor: not-allowed;"></span></label></span></dd><dt ng-show=\'vm.asset.assetTypeName == "Chamber"\'><span>Buried Chamber</span></dt><dd ng-show=\'vm.asset.assetTypeName == "Chamber"\'><span><label class="switch"><input type="checkbox" style="margin-top: 10px;\n                                        margin-left: 15px;\n                                        cursor: not-allowed" onclick="return false" ng-checked="vm.asset.burried"> <span class="slider round" style="cursor: not-allowed;"></span></label></span></dd><dt ng-show="vm.asset.phase != null"><span>Phase</span></dt><dd ng-show="vm.asset.phase != null"><span>{{vm.asset.phase}}</span></dd><dt><span translate="trakeyeApp.asset.user">User</span></dt><dd><span>{{vm.asset.userIdDTO.login}}</span></dd><dt><span translate="trakeyeApp.asset.createDate">Create Date</span></dt><dd><span>{{vm.asset.createDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.asset.updateDate">Update Date</span></dt><dd><span>{{vm.asset.updateDate | date:\'medium\'}}</span></dd></dl><h4 class="box-title" style="text-align:unset"><span>Images</span></h4><div class="table-scroll --header-height"><div class="form-group"><table class="jh-table table table-responsive table-hover"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.asset.assetImages"><td ng-show="image.imageName != null && image.imageType != \'PDF\'" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null && image.imageType != \'PDF\'">{{image.imageType}}</td></tr></table></div></div></div></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Additional Details</span></h4><div class="table-scroll box-body"><div class="form-group div--form-group"><dl class="dl-horizontal jh-entity-details" ng-repeat="item in vm.asset.assetTypeAttributeValues"><!-- <dt>\n                                        <span>Asset Value </span><span>\n                                            {{$index + 1}}</span>\n                                            \n                                    </dt> --><dt><span><b>{{item.assetTypeAttribute.name}}</b></span></dt><dd><span>{{item.attributeValue}}</span></dd></dl><dl class="dl-horizontal jh-entity-details" ng-repeat="item in vm.assetRefAttributes"><!-- <dt>\n                                    <span>Asset Value </span><span>\n                                        {{$index + 1}}</span>\n                                        \n                                </dt> --><dt ng-show="item.attributeDataType.name != \'IMAGE\'"><span><b>{{item.name}}</b></span></dt><dt ng-show="item.attributeDataType.name == \'IMAGE\' && item.imageId != null"><span><b>{{item.name}}</b></span></dt><dd ng-show="item.attributeDataType.name != \'IMAGE\'"><span>{{item.attributeValue}}</span></dd><dd ng-show="item.attributeDataType.name == \'IMAGE\' && item.imageId != null"><p ng-show="item.attributeName != null" ng-click="newTabDisplay(item.imageId,\'reference\')" style="color: #3c8dbc;">{{item.attributeName}}</p></dd></dl></div></div></div><h4 class="box-title" style="text-align:unset"><span>Attachments</span></h4><div class="table-scroll --header-height"><div class="form-group"><table class="jh-table table table-responsive table-hover"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.asset.assetImages"><td ng-show="image.imageName != null && image.imageType == \'PDF\'" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null && image.imageType == \'PDF\'">{{image.imageType}}</td></tr></table></div></div></div></div><div class="case-table" ng-show="isSet(2)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span translate="trakeyeApp.asset.name">Name</span> <span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.asset.assetType">Asset Type</span></th><th><span>ID</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.listMappedAssets track by asset.id"><td>{{asset.name}}</td><td>{{asset.assetTypeName}}</td><td><a ui-sref="asset-detail({id:asset.id})">{{asset.id}}</a></td></tr><tr><td colspan="10" ng-show="!vm.listMappedAssets"><h4>No data available</h4></td></tr></tbody></table></div><div class="row row__div--pagination" ng-show="vm.listMappedAssets"><!-- <div class="col-md-2 pull-left row__div--pagesize">\n                            <label for="area">Page size </label>\n                            <select name="page_size" id="page_size">\n                                <option value="10">10</option>\n                                <option value="20">20</option>\n                                <option value="50">50</option>\n                            </select>\n                        </div> --><div class="col-md-3 row__div--showingnoitems"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><!-- <div class="col-md-2">\n                            <label>Go To </label>\n                            <input type="text" id="pagenum" oninput="this.value|=0"\n                                onkeyup="if(this.value<0){this.value= this.value * -1}" maxlength="4" />\n                            <button type="button " ng-click="vm.goToPage()" class="button__goto">\n                                <i class="fa fa-caret-right"></i>\n                            </button>\n                        </div> --><div class="col-md-4 pull-right"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div><div class="col-md-12" ng-show="isSet(1)"><a onclick="history.back()" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span></a></div></div></div>');
$templateCache.put('app/entities/asset/asset-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.asset.id" translate="trakeyeApp.asset.home.create">Create</span> <span ng-if="vm.asset.id" translate="trakeyeApp.asset.home.update">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- \t<div class="form-group" ng-show="vm.asset.id">\n\t\t\t\t\t            <label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label>\n\t\t\t\t\t            <div class="col-md-7">\n\t\t\t\t\t            \t<input type="text" class="form-control" id="id" name="id"\n\t\t\t\t\t                    ng-model="vm.asset.id" readonly />\n\t\t\t\t\t            </div>\n\t\t\t\t\t            \t\n\t\t\t\t\t        </div> --><!-- <div class="form-group" ng-if="vm.asset.id">\n                                <label for="id" class="col-md-3 control-label" translate="global.field.id">Id</label>\n                                <div class="col-md-8">\n                                    <input type="text" class="form-control" id="id" name="id" ng-model="vm.asset.id"\n                                        readonly />\n                                </div>\n                            </div> --><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.name" for="field_name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.asset.name" required ng-minlength="2" ng-maxlength="200"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div></div><div class="form-group"><!--   <label class="col-md-3 control-label" translate="trakeyeApp.asset.description" for="field_description">Description</label> --> <label class="col-md-3 control-label" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.asset.description"></textarea></div></div><!--<div class="form-group">\n\t\t\t\t\t\t\t<label class="col-md-3 control-label" translate="trakeyeApp.asset.networkId" for="field_networkId">Network ID</label>\n\t\t\t\t\t\t   <div class="col-md-7">\n\t\t\t\t\t\t\t\t<input type="text"  class="form-control" name="networkId" id="field_networkId" ng-model="vm.asset.networkId"></textarea>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>--><!-- <div class="row">\n                            <div class="col-md-3 control-label asset_parent">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.asset.ownedby">Owner</span> \n                                </div>\n                            <div class="col-md-3 asset_parent" style="margin-bottom: 16px;">\n                                <div isteven-multi-select input-model="vm.multiassets" output-model="vm.asset.ownedBy" button-label="name" item-label="name" tick-property="ticked" output-properties="id selected">\n                                </div>\n                                <input type="text" ng-model="vm.asset.ownedBy" name="assetName" style="display:none" />\n                            </div>\n                            <div class="col-md-3" style="margin-top: 10px;">\n                                <i class="fa fa-plus-square" ng-click="vm.navigateCreateAsset();" style="cursor: pointer;" title=\'Create Asset\'></i>\n                            </div>\n                        </div> --><div class="form-group"><label class="col-md-3 control-label" for="field_parentAsset"><!-- <span translate="trakeyeApp.asset.ownedby">Owner</span> --> <span>Link to Asset</span><!-- 508 --></label><div class="col-md-8"><input list="parentAsset" class="form-control" id="field_selectParentAsset" placeholder="Search parent asset" type="text" ng-model="vm.selectedParent" autocomplete="off" name="seletedParent" ng-change="vm.filterParentAssets()"><datalist id="parentAsset" class="form-control1"><option ng-repeat="parent in vm.parentAssets" value="{{parent.name}}"></option></datalist></div></div><div class="form-group row"><div class="col-md-3 control-label"><span>Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3"><div isteven-multi-select input-model="vm.multiGroup" output-model="vm.asset.groups" button-label="name" item-label="name" helper-elements="all none" tick-property="ticked" output-properties="id selected"></div><input type="text" ng-model="vm.asset.groups" name="group" id="input__none" required></div><!-- <div class="col-md-3" ui-sref="group-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="trakeyeApp.asset.home.createNewGroupType">\n                                    Create Group\n                            </div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\n                                <i class="fa fa-plus-square" ng-click="vm.navigateCreateGroup();" style="cursor: pointer;" title=\'Create Group\'></i>\n                            </div> --></div><div class="form-group" ng-show="vm.roleAccess && vm.groupAccess && vm.asset.phase"><label class="col-md-3 control-label"><span>Phase</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup> --></label><div class="col-md-3"><!--  <div isteven-multi-select input-model="vm.phases" output-model="vm.asset.phase"\n                                button-label="configKey" item-label="configKey" helper-elements="all none" tick-property="ticked"\n                                output-properties="configKey" selection-mode="single" on-item-click="vm.onSelectPhase()" disable-property="roleRolloutAdmin"></div>\n                            <input type="text" ng-model="vm.asset.phase" name="configKey" id="input__none" required /> --> <select class="form-control" name="status" ng-model="vm.asset.phase" ng-disabled="!vm.roleRolloutAdmin"><option value="">--- Select Phase ---</option><option ng-repeat="item in vm.phases" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><!--<div class="form-group" >\n\t\t\t\t\t\t\t<label class="col-md-3 control-label col-xs-2 asset_active" for="activated">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.asset.active">Active</span> \n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-5 col-xs-6 active_checkbox">\n\t\t\t\t\t\t\t\t<input  name="activated" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.asset.status">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>--><div class="form-group" ng-show=\'vm.asset.assetType.layout == "SPREAD"\'><label class="col-md-3 control-label"><span>Length (mtrs)</span></label><div class="col-md-8" style="margin-top: 7px;"><span>{{(vm.asset.assetLength * 1000).toFixed(2)}}</span></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Accessible</span></label><!-- <input type="checkbox" style="margin-top: 10px; margin-left: 10px" ng-model="vm.asset.accessible" /> --><div class="col-md-8"><label class="switch" style="margin-top: 7px;"><input type="checkbox" style="margin-top: 10px;\n                                             margin-left: 15px;" ng-model="vm.asset.accessible"> <span class="slider round"></span></label></div></div><div class="form-group" ng-if="vm.asset.id"><!-- 508 --> <label class="col-md-3 control-label"><span>Health Indicator</span></label><div class="col-md-7"><input type="checkbox" style="margin-top: 10px; margin-left: 10px" ng-model="vm.asset.healthIndicator"></div></div><div class="form-group" ng-if="vm.asset.id"><!-- 508 --> <label class="col-md-3 control-label" for="health_Remarks">Health Remarks</label><div class="col-md-7"><textarea rows="2" class="form-control" name="healthRemarks" id="health_Remarks" ng-model="vm.asset.healthRemarks"></textarea></div></div><div class="form-group row"><div class="col-md-3 control-label"><span translate="trakeyeApp.asset.assetType" for="field_assetType">Asset Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3"><!-- <select class="form-control" id="field_assetType" name="assetType" ng-model="vm.asset.assetTypeId" ng-options="assetType.id as assetType.name for assetType in vm.assettypes"            >\n\t\t\t\t\t                <option value=""></option>\n\t\t\t\t\t            </select> --> <select class="form-control select2" name="assetType" ng-model="vm.assetType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.assettypes track by item.id" required><option value="">--- Select AssetType ---</option></select></div><!-- <div class="col-md-3" ui-sref="asset-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="trakeyeApp.asset.home.createNewAssetType">\n                                    Create Asset Type\n                            </div> --><div class="col-md-3 div__mt-10"><i class="fa fa-plus-square i__fa-plus-square" ng-click="vm.navigateAssetType();" title="Create Asset Type"></i></div></div><div class="form-group" ng-show="vm.assetType.name == \'Chamber\'"><label class="col-md-3 control-label"><span>Buried Chamber</span></label><div class="col-md-8"><label class="switch" style="margin-top: 7px;"><input type="checkbox" style="margin-top: 10px;\n                                             margin-left: 15px;" ng-model="vm.asset.burried"> <span class="slider round"></span></label></div></div><div class="form-group" ng-repeat="attribute in vm.asset.assetTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.assetTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-disabled="(!Roles.NO_OF_DUCT || !Roles.NO_OF_CABLE) && \n                                    (attribute.assetTypeAttribute.name == \'No of Duct\' || attribute.assetTypeAttribute.name == \'No of Cable\')"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/" ng-disabled="(!Roles.NO_OF_DUCT || !Roles.NO_OF_CABLE) && \n                                    (attribute.assetTypeAttribute.name == \'No of Duct\' || attribute.assetTypeAttribute.name == \'No of Cable\')"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-disabled="(!Roles.NO_OF_DUCT || !Roles.NO_OF_CABLE) && \n                                    (attribute.assetTypeAttribute.name == \'No of Duct\' || attribute.assetTypeAttribute.name == \'No of Cable\')"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue == attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div><div class="form-group" ng-repeat="attribute in  vm.assetRefAttributes track by $index"><div><label class="col-md-3 control-label"><span>{{attribute.name}}</span><br></label><div class="col-md-7"><input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'STRING\'" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name != \'STRING\' && attribute.attributeDataType.name != \'FLOAT\' && attribute.attributeDataType.name != \'INTEGER\' && attribute.attributeDataType.name != \'IMAGE\'" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.attributeDataType.name]">{{atttype.value}}</option></select><div><input type="file" ng-model="attribute.attributeValue" file-model="attribute.attributeValue" class="filestyle" ng-if="attribute.attributeDataType.name == \'IMAGE\'" file-style><!-- <img src="data:image/jpeg;base64,{{attribute.image}}" height="50px" width="50px" ng-show="attribute.attributeDataType.name == \'IMAGE\' && attribute.attributeValue != null" ng-click="vm.imageInNewTab(attribute.attributeValue)"/> --><p ng-show="attribute.attributeName != null && attribute.imageId != null" ng-click="newTabDisplay(attribute.imageId,\'reference\')" style="color: #3c8dbc;">Existing Image Name - {{attribute.attributeName}}</p></div><!-- <input type="file" ng-if="attribute.attributeDataType.name == \'IMAGE\'" ng-model="attribute.id"  class="filestyle" id="attribute.id" file-style/>\n                                     <button ng-if="attribute.attributeDataType.name == \'IMAGE\'" ng-click="handleFileSelect(attribute.id, attribute)"> ADD</button> \n                                   <input type="file" name="file" ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'IMAGE\'" class="filestyle" id="attribute.id" ng-click="vm.referenceImagesClick(attribute.id)"\n                                   file-style/> --><!--  \n                                    <span ng-if="!vm.referenceWarning">Supported Attachment Format - PNG,JPG/JPEG.</span>\n                                    <span id="noData" ng-if="vm.referenceWarning">Please upload PNG,JPG/JPEG format with maximum size of 2.5MB/2560KB</span>  --></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.coordinates">Coordinates</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><div class="input-group"><input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled="disabled" ng-model="vm.asset.assetCoordinates"><!--<span class="input-group-btn" ng-if="vm.asset.id==null">\n                                \t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Enter LatLng</button>\n                                \t\t\t\t\t\t\t\t   </span>--> <span class="input-group-btn" ng-if="vm.asset.id==null && !vm.isSite"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Select On Map</button> </span><span ng-show="vm.selectAssetCordinates"><span class="help-block span__help-block"><b>*</b>Asset coordinates should not be empty </span></span><span class="input-group-btn" ng-if="vm.asset.id!=null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Edit</button> </span><span class="input-group-btn" ng-if="vm.asset.id!=null"><button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm">Recreate</button></span></div><div id="map_canvas" class="div__map-canvas"></div></div><br><div class="col-md-1"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnMapView()" ng-show="vm.showFilter"><i class="fa fa-filter"></i></button><!-- <button style="color: gray;" type="button" class="btn btn-info btn-flat"\n                                    ng-show="vm.canFilter == false">\n                                    <i class="fa fa-filter"></i>\n                                </button>--></div></div></div><div class="form-group asset_images" ng-show="vm.showAssetImage"><label class="col-md-3 control-label">Images</label><div class="col-md-4"><input type="file" name="file" multiple="multiple" class="filestyle" id="assetImages"> <span ng-if="!vm.imageWarning">Supported Attachment Format - PNG,JPG/JPEG.</span> <span id="noData" ng-if="vm.imageWarning">Please upload PNG,JPG/JPEG format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-1 assetType_showImage"><a class="btn btn-sm btn-primary" ng-click="toggle(\'images\')">Preview</a></div><div class="col-md-2 caseType_showImg" ng-if="vm.asset.id"><a class="btn btn-sm btn-primary" ng-click="toggle(\'existingImg\')"><span ng-hide="vm.showImg">Show Existing Images</span> <span ng-show="vm.showImg">Hide Existing Images</span></a></div></div><div class="form-group" ng-if="allimages"><label class="col-md-3 control-label">Selected Images</label><div class="col-md-6"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\n                        margin-right: auto;"><tr><th>Image</th><th>Image Name</th><th>Delete</th></tr><tr ng-repeat="img in vm.asset.assetImages" ng-hide="img.imageType == \'PDF\'"><td><img class="img-responsive img__img-responsive width60" ng-src="data:image/jpeg;base64,{{img.image}}"></td><td>{{img.imageName}}</td><td ng-click="deleteDisplayImage($index)"><span class="fa fa-trash-o" style="color: red"></span></td></tr></table></div><!-- <div class="row">\n                            <div class="col-md-8 col-md-offset-3">\n                                <div class="col-md-3" ng-repeat="img in vm.asset.assetImages">\n                                    <img class="img-responsive img__img-responsive"\n                                        ng-src="data:image/jpeg;base64,{{img.image}}" />\n                                </div>\n                            </div>\n                        </div> --></div><div class="form-group" ng-if="vm.showExistingImage"><label class="col-md-3 control-label">List of Existing Images</label><div class="col-md-6 table-scroll --header-height"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\n                        margin-right: auto;"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.nameImages"><td ng-show="image.imageName != null && image.imageType != \'PDF\'" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null && image.imageType != \'PDF\'">{{image.imageType}}</td></tr></table></div></div><div class="form-group asset_images" ng-show="vm.showAssetImage"><label class="col-md-3 control-label">Attachments</label><div class="col-md-4"><input type="file" name="file" multiple="multiple" class="filestyle" id="assetAttachment"> <span ng-if="!vm.fileWarning">Supported Attachment Format - PDF.</span> <span id="noData" ng-if="vm.fileWarning">Please upload PDF format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-2 caseType_showImg" ng-if="vm.asset.id"><a class="btn btn-sm btn-primary" ng-click="toggle(\'pdf\')"><span ng-hide="vm.showPdf">Show Attachments</span> <span ng-show="vm.showPdf">Hide Attachments</span></a></div></div><div class="form-group" ng-if="vm.showAttachments"><label class="col-md-3 control-label">List of Existing Attachments</label><div class="col-md-6 table-scroll --header-height"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\n                        margin-right: auto;"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.nameImages"><td ng-show="image.imageName != null && image.imageType == \'PDF\'" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null && image.imageType == \'PDF\'">{{image.imageType}}</td></tr></table></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="asset"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button onclick="topFunction()" id="myBtn" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm pull-left"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div><script>var mybutton = document.getElementById("myBtn");\n\n                            // When the user scrolls down 20px from the top of the document, show the button\n                            window.onscroll = function () {\n                                scrollFunction();\n                            };\n\n                            function scrollFunction() {\n                                if (\n                                    document.body.scrollTop ||\n                                    document.documentElement.scrollTop\n                                ) {\n                                    mybutton.style.display = "block";\n                                } else {\n                                    mybutton.style.display = "none";\n                                }\n                            }\n\n                            // When the user clicks on the button, scroll to the top of the document\n                            function topFunction() {\n                                document.body.scrollTop = 0;\n                                document.documentElement.scrollTop = 0;\n                            }</script></div></form></div></div></div></div><div id="mapFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Assets Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="row div__done"><button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilter()"><span><b>Done</b></span></button></div><span class="span__title">Select Geofence</span><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-import.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i>Import Assets</h3><div class="box-tools ng-scope"><button class="btn btn-create"><span class="fa fa-download"></span> <a id="a__text" href="content/images/SampleAssets.xlsx" download>Sample File</a></button></div></div><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file ng-pattern="vm.importxlsx" accept="*.xlsx||*.xls||*.kml" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel & kml file should be uploaded</p></div></div><div class="form-group"><label class="col-sm-3 control-label">Asset Type</label><div class="col-md-8"><select class="form-control select2" name="assetType" ng-model="vm.importassettype" ng-change="vm.assetTypeSelect()" ng-options="item as item.name for item in vm.assettypes track by item.id" required><option value="">--- Select Asset Type ---</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-type-site-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span>Site Asset Reports</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ng-if="has_ROLE_USER_ADMIN"><span class="fa fa-download"></span> <span>Download Excel</span></button></div></div><!-- /.box-header --><!-- form start --></div></div><div class="col-md-3 search-top pull-right"><div class="input-group"><input type="text" ng-model="searchText" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="row div__mt-10"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-body"><div class="table-responsive mt-10"><table class="myTable myTable-zebra myTable-horizontal"><thead class="table-head"><tr class="tr__row"><th style="text-align:center;vertical-align:middle;"><span>Site Code</span></th><th style="text-align:center;vertical-align:middle;"><span>Site Name</span></th><th style="text-align:center;vertical-align:middle;"><span>WDM</span></th><th style="text-align:center;vertical-align:middle;"><span>NTTN</span></th><th style="text-align:center;vertical-align:middle;"><span>Router</span></th><th style="text-align:center;vertical-align:middle;"><span>BackToBack</span></th><th style="text-align:center;vertical-align:middle;"><span>Others</span></th></tr></thead><tbody class="table-body"><tr class="table-row" ng-repeat="asset in vm.multiassets | filter : searchText"><td style="text-align:center;vertical-align:middle; min-width: 120px;width:120px;">{{asset.id}}</td><td style="text-align:center;vertical-align:middle; min-width: 150px;width:150px;">{{asset.name}}</td><td style="text-align:center;vertical-align:middle; min-width: 100px;width:100px;">{{asset.WDM}}</td><td style="text-align:center;vertical-align:middle; min-width: 130px;width:130px;">{{asset.NTTN}}</td><td style="text-align:center;vertical-align:middle; min-width: 120px;width:120px;">{{asset.Router}}</td><td style="text-align:center;vertical-align:middle; min-width: 135px;width:135px;">{{asset.BackToBack}}</td><td style="text-align:center;vertical-align:middle; min-width: 125px;width:125px;">{{asset.Others}}</td><!--\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.WDM > 0) ? true: false}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.NTTN > 0) ? true: false}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.Router > 0) ? true: false}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.BackToBack > 0) ? true: false}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.Others > 0) ? true: false}}</td>--></tr></tbody></table></div><div class="row" style="margin:10px;"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div><div class="row"><div id="report" class="col-md-10 col-md-offset-1" style="display: none;"><!-- box content--><div class="box box-solid"><div class="box-header box-info"><button type="button" class="btn btn-info btn-flat pull-right" ng-click="close()">Close</button><h4 class="box-title text-left"><img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;"></h4></div><button class="btn btn-primary center-block" ng-click="getPdf()">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="box-body" ng-if="vm.reportType==\'geofence\'" id="reportpdf"><h4 class="text-center mt-5">Geofence Report for <b>{{vm.detailedReportCounts.name}}</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Services --><div class="box-header"><h3 class="box-title">Services</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><div class="box-header"><h3 class="box-title">Geofence</h3></div><div class="box-body"><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:300px; width:100%;"></div></div></div></div></div></div><div class="box-body" ng-if="vm.reportType==\'agent\'" id="reportpdf"><!-- <div class="box-body" ng-if="vm.reportType==\'agent\'"> --><h4 class="text-center mt-5">Agent Report for <b>{{vm.detailedReportCounts.name}} ({{vm.detailedReportCounts.login}})</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Created by Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Assigned to Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Services --><div class="box-header"><h3 class="box-title">Services</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><div class="box-header"><h3 class="box-title">Distanc IN</h3>{{vm.detailedReportCounts.distance_in | number:2}} KM<h3 class="box-title">Distanc OUT</h3>{{vm.detailedReportCounts.distance_out | number:2}} KM</div><!-- <div class="box-body">\n\t\t\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100%;"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div>');
$templateCache.put('app/entities/asset/assets.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-cubes"></i> <span translate="trakeyeApp.asset.home.title">Assets</span></h3></div><div class="col-md-5 col-sm-3 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-map"></i><span class="header-view">Map</span> <span class="header_view">View</span></a></li><li ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER" ng-class="{active:isSet(3)}"><a href ng-click="setTab(3); search = null" data-toggle="tab"><i class="fa fa-globe"></i><span class="header-view">Region</span> <span class="header_view">View</span></a></li></ul></div><div class="box-tools"><button ng-hide="vm.isAssetImport" class="btn btn-create btn-sm" ui-sref="asset.import"><span class="glyphicon glyphicon-plus"></span> <span>Import</span></button> <button ng-if="vm.isAssetImport" class="btn btn-create btn-sm" ui-sref="entity-import.new"><span class="glyphicon glyphicon-plus"></span> <span>Import</span></button> <button class="btn btn-create btn-sm" ng-click="vm.createAsset()"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><!-- <script src="https://unpkg.com/measuretool-googlemaps-v3"></script> --><!-- <script src="https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js"></script> --><jhi-alert></jhi-alert><div class="row"><!-- <div class="col-md-5">\r\n                            <ul class="nav nav-pills nav-justified">\r\n                                <li ng-class="{active:isSet(1)}">\r\n                                    <a href ng-click="setTab(1); search = null" data-toggle="tab">List View</a>\r\n                                </li>\r\n                                <li ng-class="{active:isSet(2)}">\r\n                                    <a href ng-click="setTab(2); search = null" data-toggle="tab">Map View</a>\r\n                                </li>\r\n                                <li ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER"\r\n                                    ng-class="{active:isSet(3)}">\r\n                                    <a href ng-click="setTab(3); search = null" data-toggle="tab">City View</a>\r\n                                </li>\r\n                            </ul>\r\n                        </div>\r\n                        <div class="div--filter pull-right" ng-show="isSet(1)">\r\n                            <button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnListView()">\r\n                                <i class="fa fa-filter"></i>\r\n                            </button>\r\n                        </div> --><div class="col-md-4 pull-left dropFilter" ng-show="isSet(1) && vm.countLength > 0"><div isteven-multi-select input-model="vm.geofencesListView" output-model="vm.selectedGeofence" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceId" name="vm.searchMini" style="display:none" required></div><div class="col-md-3 dropFilter" ng-show="isSet(2)"><div isteven-multi-select input-model="vm.userGeofences" output-model="vm.selectedMapGeofence" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceId" name="vm.searchMini" style="display:none" required> <span id="noData" ng-show="vm.selectedGeofence.length < 1 && vm.selectedMapGeofence.length < 1">*Please Select Geofence Filter</span></div><div class="col-md-3 dropFilter" ng-show="isSet(2)"><div isteven-multi-select input-model="vm.filterAssetTypes" output-model="vm.selectedAsset" button-label="name" item-label="name icon" tick-property="ticked" translation="type.assetTypeLabel" max-height="236px" on-select-done="sync()" max-labels="1" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedAsset" name="vm.searchMini" style="display:none" required><!--  <span id="noData" ng-show="vm.filterAssetTypes.length < 1">*Asset Types Not Available</span> --></div><div class="col-md-3 dropFilter" ng-show="isSet(2) && vm.displayCaseType"><div isteven-multi-select input-model="vm.caseTypes" output-model="vm.selectedCase" button-label="name" item-label="displayName" output-properties="id" tick-property="showInAssetsView" translation="type.caseTypeLabel" max-height="236px" on-select-done="vm.showCases()" max-labels="1" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedCase" name="vm.searchMini" style="display:none" required></div><!-- <div class="col-md-3 dropFilter" ng-show="isSet(2) && !vm.tempLength && vm.selectedMapGeofence.length > 0">\r\n                            <span id="noData">*Case Types Not Available</span>\r\n                        </div> --><!-- <div class="col-md-2 mt-5" ng-show="isSet(2) && vm.tempLength">\r\n                            <label>\r\n                                <span>Cases</span>\r\n                            </label>\r\n                            <label class="switch">\r\n                                <input type="checkbox" style="\r\n                                         margin-top: 10px;\r\n                                         margin-left: 15px;\r\n                                     " ng-model="vm.boolCase"\r\n                                     ng-change="vm.showCases()" /> \r\n                                 <span class="slider round"></span>\r\n                            </label>\r\n                        </div> --><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(3)"><select id="masterGeofence" class="select2 form-control" ng-model="vm.masterGeofence"><option value=" ">Select City</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select> <span id="noData" ng-if="vm.userGeofencesCity.length < 1">*Please Select City</span></div><!-- <span id="noData" ng-show="isSet(3) && vm.cityLength">* NO\r\n                            DATA Available in Selected City.</span> --><div class="col-md-3 dropFilter" ng-show="isSet(3) && vm.userGeofencesCity.length > 0"><div isteven-multi-select input-model="vm.userGeofencesCity" output-model="vm.selectedAssetCity" button-label="label" item-label="name" tick-property="ticked" translation="GeofenceCity" on-select-done="vm.saveFilterCity()" max-labels="1" helper-elements="all none Done filter" max-height="170px"></div><input type="text" ng-model="vm.selectedAssetCity" name="vm.searchMini" style="display:none" required></div><!-- <div class="col-md-2 selectAsset_drp div--searchasset pull-right" ng-show="isSet(2) && vm.selectedGeofence.length > 0">\r\n                            <select id="searchAssetsOnMap" class="select2 form-control"\r\n                                name="search">\r\n                                <option value="">Search Asset</option>\r\n                                <option ng-repeat="item in vm.mapAssets" value="{{item}}">\r\n                                    {{item.name}}\r\n                                </option>\r\n                            </select>\r\n                        </div> --><div class="col-md-3 dropFilter" ng-show="isSet(3) && vm.userGeofencesCity.length > 0"><div isteven-multi-select input-model="vm.filterAssetTypesCity" output-model="vm.selectedAssetTypeCity" button-label="name" item-label="name" tick-property="ticked" translation="type.assetTypeLabel" on-open="centerCapture()" on-select-done="vm.saveAssetTypeFilterCity()" max-labels="1" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedAssetTypeCity" name="vm.searchMini" style="display:none" required> <span id="noData" ng-show="vm.filterAssetTypesCity.length < 1">*Asset Types Not Available</span></div><div class="col-md-3 search-top pull-right" ng-mouseleave="hideAssetList()" ng-show="isSet(3) && vm.mapAssetsCity.length>0"><div class="input-group"><input type="text" ng-model="searchAssetCity" ng-mouseenter="complete()" ng-keyup="complete()" class="form-control clear" placeholder="Search Assets"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click=""><i class="fa fa-search"></i></button></span></div><ul class="list-group searchList" ng-model="hidethis" ng-hide="hidethis"><li class="list-group-item list-groupBorder" value="{{item}}" ng-repeat="item in vm.mapAssetsCity | filter : searchAssetCity" ng-click="searchAssetsOnMapCity(item)">{{item.name}}</li></ul></div><!-- <div class="col-md-2 selectAsset_drp div--searchasset"\r\n                            ng-show="isSet(3) && vm.mapAssetsCity.length>0">\r\n                            <select id="searchAssetsOnMapCity" class="select2 form-control" name="search">\r\n                                <option value="">Search Asset</option>\r\n                                <option ng-repeat="item in vm.mapAssetsCity" value="{{item}}">\r\n                                    {{item.name}}\r\n                                </option>\r\n                            </select>\r\n                        </div> --><div class="col-md-3 search-top pull-right" ng-mouseleave="hideAssetList()" ng-show="isSet(2)"><div class="input-group"><input type="text" ng-model="searchAsset" ng-mouseenter="complete()" ng-keyup="complete()" class="form-control clear" placeholder="Search Assets"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click=""><i class="fa fa-search"></i></button></span></div><ul class="list-group searchList" ng-model="hidethis" ng-hide="hidethis"><li class="list-group-item list-groupBorder" value="{{item}}" ng-repeat="item in vm.mapAssets | filter : searchAsset" ng-click="fillTextbox(item)">{{item.name}}</li></ul></div><!-- <div class=" ml-10 mt-0 div--filter" ng-show="isSet(2)">\r\n                            <button type="button" value="Layers" class="btn btn-info btn-flat"\r\n                                ng-click="vm.showLayers()">\r\n                                Layers\r\n                            </button>\r\n                        </div> --><!--   <div ng-show="isSet(2)" class="modal-body div__modal-body">\r\n                            <span id="noData" ng-show="vm.filterAssetTypes <= 1">* NO DATA</span>\r\n                            <p ng-repeat="item in vm.filterAssetTypes" class="item"\r\n                                class="p--filterassettypes">\r\n                                <input type="checkbox" ng-init="initial(item)" id="{{item.id}}" ng-change="sync(bool,item)" ng-model="bool" />\r\n                                <label for="{{item.id}}">{{item.name}}</label>\r\n                            </p>\r\n                        </div>  \r\n                          <div class="row div__done" ng-show="isSet(2) && vm.filterAssetTypes.length > 0">\r\n                            <button class="btn btn-info btn-flat button__done" ng-click="vm.saveAssetTypeFilter()">\r\n                                <span><b>Done</b></span>\r\n                            </button>\r\n                        </div>  --><!-- <div class="col-md-1" ng-show="isSet(2)">\r\n                            <button type="button" value="GOTO" class="btn btn-info btn-flat"\r\n                                ng-click="vm.gotoLatitute()">\r\n                                GO TO\r\n                            </button>\r\n                        </div> --><div class="col-md-3 search-top pull-right" ng-show="isSet(1)"><div class="input-group"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3" placeholder="{{\'trakeyeApp.asset.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.getAssetsForListView()"><i class="fa fa-search"></i></button></span></div></div><!--  <div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(3)">\r\n                            <select id="masterGeofence" class="select2 form-control" ng-model="vm.masterGeofence">\r\n                                <option value="">Select City</option>\r\n                                <option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">\r\n                                    {{item.name}}\r\n                                </option>\r\n                            </select>\r\n                        </div> --><!-- <div class="col-md-2" ng-show="isSet(2) && vm.health">\r\n                            <label>Health:</label>\r\n                            <input type="checkbox" ng-model="variableHealth" ng-click="check()">\r\n                        </div> --><!-- <div class="col-md-1" ng-show="isSet(3)">\r\n                            <button type="button" value="GOTO" class="btn btn-info btn-flat"\r\n                                ng-click="vm.gotoLatituteCity()">\r\n                                GO TO\r\n                            </button>\r\n                        </div> --><!-- <div class="pull-right ml-10 mt-0 div--filter" ng-show="isSet(2)">\r\n                            <button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnMapView()"\r\n                                >\r\n                                <i class="fa fa-filter"></i>\r\n                            </button>\r\n                            <button type="button" value="Layers" class="btn btn-info btn-flat"\r\n                                ng-click="vm.showLayers()">\r\n                                Layers\r\n                            </button>\r\n                        </div> --><!-- <div class="ml-10 mt-0 div--filter"\r\n                            ng-show="isSet(3)  && vm.selectedMasterGeofenceId>0">\r\n                             <button type="button" class="btn btn-info btn-flat"\r\n                                ng-click="vm.filterAssetsOnMapViewCity()">\r\n                                <i class="fa fa-filter"></i>\r\n                            </button> \r\n                    \r\n                            <button type="button" value="Layers" class="btn btn-info btn-flat"\r\n                                ng-click="vm.showLayersCity()">\r\n                                Layers\r\n                            </button>\r\n                        </div> --><!-- <div class="col-md-5 selectAsset_drp mt-10" ng-show="isSet(2)">\r\n                            <div class="search-bar-align">\r\n                                <select id="searchAssetsOnMap" class="select2 form-control" name="search"\r\n                                    style="width: 220px; height: 40px">\r\n                                    <option value="">Search Asset</option>\r\n                                    <option ng-repeat="item in vm.mapAssets" value="{{item}}">{{item.name}}</option>\r\n                                </select>\r\n                                \r\n                            </div>\r\n                        </div> --></div><div class="ml-5 mt-5" ng-show="isSet(1)"><div class="pull-left" ng-show="vm.showAssetDelete"><button class="btn btn-danger button--showassetdelete" ng-click="vm.confirmDelete()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></div></div><div class="case-table" ng-show="isSet(1)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><input type="checkbox" ng-click="vm.selectAllAssets()" ng-model="vm.isAllAssetSelected"></th><th></th><!-- <th>Id</th> --><th jh-sort-by="name"><span translate="trakeyeApp.asset.name">Name</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="description">\r\n                                        <span translate="trakeyeApp.asset.description">Description</span><span\r\n                                            class="fa fa-sort"></span>\r\n                                    </th> --><th><span>Geofence</span></th><th><span translate="trakeyeApp.asset.assetType">Asset Type</span></th><th>Length (mtrs)</th><th>Accessible</th><th>Buried Chamber</th><th>Graphical Id</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="asset in vm.assetsForListView track by asset.id" ng-class="{selected: asset.isChecked}"><td><input type="checkbox" ng-model="asset.isChecked" ng-change="vm.selectAssetEntity(asset)"></td><td class="td__listViewRow" ng-click="vm.assetMarkerTable(asset);" ng-show="asset.assetTypeLayout==\'SPREAD\'" expand><span ng-if="!asset.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="asset.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td ng-show="asset.assetTypeLayout!=\'SPREAD\'"></td><!-- <td><a ui-sref="asset-detail({id:asset.id})">{{asset.id}}</a></td> --><td>{{asset.name}}</td><!-- <td>{{asset.description}}</td> --><td><div ng-repeat="geofenceVal in asset.geofenceIdNameList"><span style="overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{geofenceVal.name}}</span></div></td><td><a ui-sref="asset-type-detail({id:asset.assetType.id})">{{asset.assetType.name}}</a> <a ui-sref="asset-type-detail({id:asset.assetType.id})">{{asset.assetTypeName}}</a></td><td ng-if=\'asset.assetTypeLayout=="FIXED"\'></td><td ng-if=\'asset.assetTypeLayout=="SPREAD"\'>{{(asset.assetLength * 1000).toFixed(2)}}</td><td><label class="switch"><input type="checkbox" style="margin-top: 10px;\r\n                                                margin-left: 15px;" data-toggle="modal" data-target="#myModal" id="{{asset.id}}" ng-checked="asset.accessible" ng-model="asset.accessible" ng-change="accessibleCheckChange(asset)"> <span class="slider round"></span></label></td><td ng-show="asset.assetTypeName == \'Chamber\'"><label class="switch"><input type="checkbox" style="margin-top: 10px;\r\n                                                margin-left: 15px;" data-toggle="modal" data-target="#myModalBuried" id="{{asset.id + \'0\'}}" ng-checked="asset.burried" ng-model="asset.burried" ng-change="vm.onChangeBuried(asset)"> <span class="slider round"></span></label></td><td ng-if=\'asset.assetTypeName != "Chamber"\'></td><td><div ng-repeat="attrData in asset.assetAttributeList"><span ng-if="attrData.attributeName == \'GRAPHICAL ID\'">{{attrData.attributeValue}}</span></div></td><td><div class="action"><!-- <a ng-if ="vm.showAssetImage" class="action-icons text-info" ng-click="vm.imageUpload({id:asset.id})"\r\n                                            title="Upload"><span class="fa fa-upload"></span></a> --> <a ui-sref="asset-detail({id:asset.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span></a> <a ui-sref="asset.edit({id:asset.id})" ng-if="has_ROLE_USER_ADMIN || has_ROLE_CITY_PLANNER" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ui-sref="asset.delete({id:asset.id})" ng-if="has_ROLE_USER_ADMIN || has_ROLE_CITY_PLANNER" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span> </a><a ng-if=\'asset.assetTypeLayout=="SPREAD"\' class="action-icons text-primary" ng-click="vm.assetMarkerUpload({id:asset.id})" title="Upload"><span class="fa fa-upload"></span></a> <a class="action-icons text-primary" ng-click="vm.onNavigate(asset,asset.geofenceIdNameList)" title="Navigate To Map View"><span class="fa fa-map-marker"></span></a></div></td></tr><tr ng-show="asset.isExpanded"><td></td><td colspan="13" ng-show="vm.assetMarkers.length > 0"><table class="table__userNames"><thead><th>SL No.</th><!-- <th>Id</th> --><th>Name</th><th>Marker Type</th><th>Created Date</th><th ng-repeat="header  in vm.assetMarkers[0].assetMarkerTypeAttributeValues">{{header.assetMarkerTypeAttribute.name}}</th></thead><tbody><tr ng-repeat="assetMarkers in vm.assetMarkers"><td>{{assetMarkers.no}}</td><!-- <td>{{assetMarkers.id}}</td> --><td>{{assetMarkers.name}}</td><td>{{assetMarkers.assetMarkerType.name}}</td><td>{{assetMarkers.createDate| date:\'dd/MM/yy h a\'}}</td><td ng-repeat="value in assetMarkers.assetMarkerTypeAttributeValues">{{value.attributeValue}}</td><td><div class="actions" style="width: fit-content;" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a class="action-icons text-info" title="View" ng-click="vm.showAssetMarkerDetails(assetMarkers)"><span class="fa fa-eye"></span> </a><a id="editlink" class="action-icons text-primary" title="Edit" ng-click="vm.editAssetMarker(assetMarkers)"><span class="fa fa-pencil-square"></span> </a><!-- <a id="editlink" \r\n                                                                class="action-icons text-primary"\r\n                                                                title="Delete">\r\n                                                                <span class="fa fa-trash-o"></span>\r\n                                                            </a> --></div></td><td style="width: 20%;"></td></tr></tbody></table></td><td colspan="2" ng-show="vm.assetMarkers.length == 0"><h4>No data available</h4></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.assetsForListView.length == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row row__div--pagination"><div class="col-md-2 pull-left row__div--pagesize"><label for="area">Page size</label> <select name="page_size" id="page_size"><option value="10">10</option><option value="20">20</option><option value="50">50</option></select></div><div class="col-md-3 row__div--showingnoitems"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-2"><label>Go To</label> <input type="text" id="pagenum" oninput="this.value|=0" onkeyup="if(this.value<0){this.value= this.value * -1}" maxlength="4"> <button type="button " ng-click="vm.goToPage()" class="button__goto"><i class="fa fa-caret-right"></i></button></div><div class="col-md-4 pull-right"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="map-view" ng-show="isSet(2) "><div class="row mt-5"><div class="col-md-12"><div id="map_canvas" style="height:65vh"></div></div><div class="pull-right" ng-show="isSet(2)"><span id="myspan">Zoom :</span></div></div><div class="legendsAssetType"><div class="flex-item" ng-repeat="item in vm.filterAssetTypes" ng-show="vm.selectedMapGeofence.length"><img class="square" ng-style="{\'background-color\': item.code}" ng-show="item.layout == \'SPREAD\'"> <img src="{{item.code}}" class="fixedImg" ng-show="item.layout == \'FIXED\'"> {{item.name}}<!-- You can also use an image here if you have an image URL in the \'image\' property --><!-- <img ng-src="{{item.image}}" alt="{{item.name}}" width="20" height="20"> --><br></div></div></div><div class="map-view" ng-show="isSet(3)"><div class="row mt-5"><div class="col-md-12"><div id="map_canva" style="height:{{mapHeight}}px;"></div></div><div class="pull-right" ng-show="isSet(3)"><span id="myspanCity">Zoom :</span></div></div></div></div></div></div></div><div id="mapFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div ng-show="isSet(2)" class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div ng-show="isSet(3)" class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModalCity()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div ng-show="isSet(2)" class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilter()"><span><b>Done</b></span></button></div></div><div class="col-md-12"><div ng-show="isSet(3)" class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilterCity()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div ng-show="isSet(2)" class="row"><span id="noData" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div><div ng-show="isSet(3)" class="row"><br><span id="noData" ng-show="vm.userGeofencesCity.length == 0" style="margin-left:25px">* NO DATA</span><div ng-show="vm.userGeofencesCity.length > 0" class="div__list"><input type="checkbox" ng-model="selectAll" ng-change="toggleAll()"> <label class="label__item" for="chk-all">Select All</label></div><br><div class="div__list" ng-repeat="item in vm.userGeofencesCity"><input type="checkbox" ng-model="options[$index]" ng-change="toggleUserGeofences($index)"> <label class="label__item" for="chk-{{item.id}}">{{item.name}}</label></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="assetEditModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetEditName" class="span__modal-header">Asset</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeEditAssetModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" style="height: 70vh; overflow-y: auto"><form class="form-horizontal" role="form" style="margin-bottom: 10px"><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.name" for="field_name">Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.assetToEdit.name" ng-minlength="2"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Asset Type</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.assetToEdit.assetType.name" ng-minlength="2" disabled="disabled"></div></div><div class="form-group" ng-repeat="attribute in vm.assetToEdit.assetTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.assetTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.assetToEdit.id" type="text" class="form-control" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.assetToEdit.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.assetToEdit.id" type="text" class="form-control" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.assetToEdit.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && !vm.assetToEdit.id" type="text" class="form-control" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && vm.assetToEdit.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.assetToEdit.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue == attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.assetToEdit.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div><div class="form-group" ng-repeat="attribute in  vm.assetRefAttributes track by $index"><div><label class="col-md-3 control-label"><span>{{attribute.name}}</span></label><div class="col-md-7"><input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'STRING\'" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name != \'STRING\' && attribute.attributeDataType.name != \'FLOAT\' && attribute.attributeDataType.name != \'INTEGER\' && attribute.attributeDataType.name != \'IMAGE\'" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.attributeDataType.name]">{{atttype.value}}</option></select><div><input type="file" ng-model="attribute.attributeValue" file-model="attribute.attributeValue" class="filestyle" ng-if="attribute.attributeDataType.name == \'IMAGE\'" file-style><!--  <img src="data:image/jpeg;base64,{{attribute.attributeValue}}" height="50px"\r\n                                        width="50px"\r\n                                        ng-show="attribute.attributeDataType.name == \'IMAGE\' && attribute.attributeValue != null"\r\n                                        ng-click="vm.imageInNewTab(attribute.attributeValue)" /> --><p ng-show="attribute.attributeName != null && attribute.imageId != null" ng-click="newTabDisplay(attribute.imageId,\'reference\')" style="color: #3c8dbc;">Existing Image Name - {{attribute.attributeName}}</p></div></div></div></div></form></div><div class="modal-footer"><div style="margin-left: 120px"><button ng-click="vm.saveEditAssetModal()" id="myBtn" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm pull-left"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default btn-sm pull-left" ng-click="vm.closeEditAssetModal()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="assetMarkerEditModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetMarkerEditName" class="span__modal-header">Edit Asset Marker</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeEditAssetMarkerModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" style="height: 70vh; overflow-y: auto"><form class="form-horizontal" role="form" style="margin-bottom: 10px"><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.name" for="field_name">Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.markerAssetToEdit.name" ng-minlength="2"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Asset MarkerType</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.markerAssetToEdit.assetMarkerType.name" ng-minlength="2" disabled="disabled"></div></div><div class="form-group" ng-repeat="attribute in vm.markerAssetToEdit.assetMarkerTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.assetMarkerTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.markerAssetToEdit.id" type="text" class="form-control" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue = attribute.assetMarkerTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.markerAssetToEdit.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.markerAssetToEdit.id" type="text" class="form-control" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue = attribute.assetMarkerTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.markerAssetToEdit.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'STRING\' && !vm.markerAssetToEdit.id" type="text" class="form-control" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue = attribute.assetMarkerTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'STRING\' && vm.markerAssetToEdit.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue = attribute.assetMarkerTypeAttribute.defaultValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetMarkerTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetMarkerTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.markerAssetToEdit.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetMarkerTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue == attribute.assetMarkerTypeAttribute.defaultValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetMarkerTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetMarkerTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.markerAssetToEdit.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetMarkerTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></form></div><div class="modal-footer"><div style="margin-left: 120px"><button ng-click="vm.saveEditMarkerAssetModal()" id="myBtn" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm pull-left"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default btn-sm pull-left" ng-click="vm.closeEditAssetMarkerModal()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="assetMarkerViewModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetMarkerViewName" class="span__modal-header">Asset Marker Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeViewAssetMarkerModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" style="height: 70vh; overflow-y: auto"><form class="form-horizontal" role="form" style="margin-bottom: 10px"><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.name" for="field_name">Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.markerAssetToView.name" ng-minlength="2"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Asset MarkerType</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.markerAssetToView.assetMarkerType.name" ng-minlength="2" disabled="disabled"></div></div><div class="form-group table-scroll box-body"><div class="col-md-3"></div><div class="col-md-7"><dl ng-repeat="item in vm.markerAssetToView.assetMarkerTypeAttributeValues"><dt><span><b>{{item.assetMarkerTypeAttribute.name}}</b></span></dt><dd><span>{{item.attributeValue}}</span></dd></dl></div></div></form></div><div class="modal-footer"><div style="margin-left: 120px"><button type="button" class="btn btn-default btn-sm pull-left" ng-click="vm.closeViewAssetMarkerModal()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="listFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeListFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence for List</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveListFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.countLength == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.geofencesListView"><input type="radio" id="{{item.id}}" ng-model="vm.selectedListGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="listFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Asset Type Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeListFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="row div__done"><button class="btn btn-info btn-flat button__done" ng-click="vm.saveListFilter()"><span><b>Done</b></span></button></div><span class="span__title">Select Geofence for List</span><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.geofencesListView.length <= 1">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.geofencesListView"><input type="radio" id="{{item.id}}" ng-model="vm.selectedListGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label--geofencelistview">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form ng-show="isSet(2) || isSet(3)" name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" id="field_pinLat" ng-model="vm.getLocationCoordinate" required></div></div><!--  <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span translate=" ">Longitude :</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                        </label>\r\n                        <div class="col-md-8">\r\n                            <input type="number" class="form-control" placeholder="enter the co-ordinates" name="pinLat" id="field_pinLat"\r\n                                ng-model="vm.pinLatLong" required />\r\n                        </div>\r\n                    </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">OK</button></div></form><!-- <form ng-show="isSet(3)" name="editForm" role="form" class="form-horizontal" novalidate\r\n                ng-submit="vm.showZoomLocationCity()" show-validation>\r\n                <div class="modal-body">\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span translate=" ">Pin Lat</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                        </label>\r\n                        <div class="col-md-8">\r\n                            <input type="number" class="form-control" name="pinLat" id="field_pinLat"\r\n                                ng-model="vm.pinLatitude" required />\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span translate=" ">Pin Long</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                        </label>\r\n                        <div class="col-md-8">\r\n                            <input type="number" class="form-control" name="pinLat" id="field_pinLat"\r\n                                ng-model="vm.pinLatLong" required />\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="modal-footer">\r\n                    <button type="button" class="btn btn-default" data-dismiss="modal"\r\n                        ng-click="vm.closeGotoLatituteCity()">\r\n                        Cancel\r\n                    </button>\r\n                    <button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">\r\n                        OK\r\n                    </button>\r\n                </div>\r\n            </form> --></div></div></div><div id="modalAssetAttributes" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Asset Attributes</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body" style="overflow-y: scroll;height: 80vh"><div id="assetAttributeTable"></div></div></form></div></div></div><div id="modalThreePointReference" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameThreePointReference" class="span__modal-header">3 Point Reference</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeThreePointReference()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body"><div id="threePointReferenceTable"></div><!-- <table class="jh-table table table-responsive table-hover" \r\n                    style="margin-left: auto;\r\n                    margin-right: auto;">\r\n                        <tr>\r\n                            <th ng-repeat="img in vm.referenceAttribute">Image</th>\r\n                        </tr>\r\n                        <tr ng-repeat="img in vm.referenceAttribute">\r\n                            <td>\r\n                                <img class="img-responsive img__img-responsive width60"\r\n                                ng-src="data:image/jpeg;base64,{{img.image}}"  />\r\n                            </td>\r\n                            <td>\r\n                                {{img.imageName}}\r\n                            </td>\r\n                            <td  ng-click="deleteDisplayImage($index)">\r\n                                <span class="fa fa-trash-o" style="\r\n                                color: red"></span>\r\n                            </td>\r\n                        </tr>\r\n                    </table> --></div></form></div></div></div><div id="modalLayer" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Filter By Asset Type</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeLayers()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div ng-show="isSet(2)" class="modal-body div__modal-body"><span id="noData" ng-show="vm.filterAssetTypes <= 1">* NO DATA</span><p ng-repeat="item in vm.filterAssetTypes" class="item" class="p--filterassettypes"><input type="checkbox" ng-init="initial(item)" id="{{item.id}}" ng-change="sync(bool,item)" ng-model="bool"> <label for="{{item.id}}">{{item.name}}</label></p></div><div ng-show="isSet(3)" class="modal-body div__modal-body"><span id="noData" ng-show="vm.filterAssetTypesCity <= 1">* NO DATA</span><p ng-repeat="item in vm.filterAssetTypesCity" class="item" class="p--filterassettypes"><input type="checkbox" ng-model="item.isChecked" id="{{item.id}}"> <label for="{{item.id}}">{{item.name}}</label></p></div><div class="row div__done" ng-show="isSet(2) && vm.filterAssetTypes.length > 0"><button class="btn btn-info btn-flat button__done" ng-click="vm.saveAssetTypeFilter()"><span><b>Done</b></span></button></div><div class="row div__done" ng-show="isSet(3) && vm.filterAssetTypesCity.length > 0"><button class="btn btn-info btn-flat button__done" ng-click="vm.saveAssetTypeFilterCity()"><span><b>Done</b></span></button></div></form></div></div></div><div class="modal fade" id="modalAttachment" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'modalAttachment\')"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Attachments - {{vm.assetTitle}}</span></div><form name="editForm" class="form-horizontal"><div class="modal-body" style="overflow-y: scroll;overflow-x: hidden;height: 40vh"><div class="form-group asset_images" ng-show="vm.showAssetImage"><label class="col-md-3 control-label">Attachments</label><div class="col-md-6 mb-5"><input type="file" name="file" multiple="multiple" class="filestyle" id="assetImages"> <span ng-if="!vm.fileWarning">Supported Attachment Format - PNG,JPG/JPEG,PDF.</span> <span id="noData" ng-if="vm.fileWarning">Please upload PNG,JPG/JPEG,PDF format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-2 assetType_showImage"><a class="btn btn-sm btn-primary" ng-click="toggle()"><span><i class="fa fa-plus"></i></span> Add</a></div></div><div class="form-group" ng-show="allimages && vm.assetAttachments.assetImages.length > 0"><label class="col-md-3 control-label">Selected Attachments</label><div class="col-md-7"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                            margin-right: auto;"><tr><th>Thumbnail</th><th>Name</th><th>Delete</th></tr><tr ng-repeat="img in vm.assetAttachments.assetImages"><td><img class="img-responsive img__img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" width="50" height="50" ng-show="img.imageType != \'PDF\'"> <i class="fa fa-file-pdf-o pdf-icon" ng-show="img.imageType == \'PDF\'"></i></td><td>{{img.imageName}}</td><td ng-click="deleteDisplayImage($index)"><span class="fa fa-trash-o" style="color: red"></span></td></tr></table></div></div><div class="form-group"><label class="col-md-3 control-label">List of Existing Attachments</label><div class="col-md-6 mt-5"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                                margin-right: auto;"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.nameImages"><td ng-show="image.imageName != null" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null">{{image.imageType}}</td></tr></table></div></div></div><div class="modal-footer"><div class="col-md-4 col-md-offset-3 save-buttons pull-right"><button type="button" class="btn btn-default btn-sm" ng-click="vm.closeModal(\'modalAttachment\')"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button> <button class="btn btn-primary btn-sm pull-left" ng-show="vm.showAssetImage" ng-click="vm.saveAttachments()"><span class="fa fa-upload"></span>&nbsp;<span>Upload</span></button></div></div></form></div></div></div><div class="modal fade" id="myModalUpload" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeImageUpload()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Upload Attachment</span></div><div class="modal-body"><div class="form-group asset_images"><label class="col-md-3 control-label">Attachments</label><div class="col-md-8"><input type="file" name="file" class="filestyle" id="assetImages"> <span ng-if="!vm.fileWarning">Supported Attachment Format - PNG,JPG/JPEG,PDF.</span> <span id="noData" ng-if="vm.fileWarning">Please upload PNG,JPG/JPEG,PDF format.</span></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.saveImage()" class="btn btn-primary btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-save"></i> Save</button> <button type="button" ng-click="vm.closeImageUpload()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button></div></div></div></div><div class="modal fade" id="successImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="col-lg-12 col-sm-12 col-xs-12 alert alert-success"><strong>Upload Successfull</strong></div></div></div></div><div class="modal fade" id="errorImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="col-lg-12 col-sm-12 col-xs-12 alert alert-danger"><strong>Error</strong></div></div></div></div><div class="modal fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" id="close-button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Change Asset Status</span></div><div class="modal-body">Are you sure you want to change Asset Status to {{vm.changeAcessibleStatus}}?</div><div class="modal-footer"><button type="button" id="remove-button" class="btn btn-default" data-dismiss="modal">No</button> <button type="button" id="yes-button" class="btn btn-primary" data-dismiss="modal">Yes</button></div></div></div></div><div class="modal fade" id="deleteAsset" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'deleteAsset\')"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body">Are you sure you want to delete Asset?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.closeGotoLatitute(\'deleteAsset\')" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-danger" ng-click="vm.selectAsets()" data-dismiss="modal"><span class="glyphicon glyphicon-remove-circle"></span> <span translate="entity.action.delete">Delete</span></button></div></div></div></div><div class="modal fade" id="myModalMap" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" id="closeButton" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Change Asset Status</span></div><div class="modal-body">Are you sure you want to change <b>{{vm.assetTitle}}</b> Status to {{vm.changeAcessible}}?</div><div class="modal-footer"><button type="button" id="noButton" class="btn btn-default" data-dismiss="modal">No</button> <button type="button" id="yesButton" class="btn btn-primary" data-dismiss="modal">Yes</button></div></div></div></div><div class="modal fade" id="myModalBuried" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" id="closeButtonBurried" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'myModalBuried\')"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Change Asset Status</span></div><div class="modal-body">Are you sure you want to change <b>{{vm.assetTitle}}</b> Buried Status?</div><div class="modal-footer"><button type="button" id="noButtonBurried" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'myModalBuried\')">No</button> <button type="button" id="yesButtonBurried" class="btn btn-primary" data-dismiss="modal">Yes</button></div></div></div></div><div class="modal fade" id="markerUploadModal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeAssetMarkerModal()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Upload Asset Markers</span></div><div class="modal-body"><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.uploadAssetMarker()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file ng-pattern="vm.importxlsx" accept="*.csv" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel & kml file should be uploaded</p></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.closeAssetMarkerModal()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button> <button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></form></div></div></div></div>');
$templateCache.put('app/entities/case-type/case-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.caseType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.caseType.delete.question" translate-values="{id: \'{{vm.caseType.id}}\'}">Are you sure you want to delete this Case Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/case-type/case-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.caseType.detail.title">Case Type</span> {{vm.caseType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.caseType.name">Name</span></dt><dd><span>{{vm.caseType.name}}</span></dd><dt><span translate="trakeyeApp.caseType.description">Description</span></dt><dd><span>{{vm.caseType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\n\t\t\t\t\t\t\t<dd>\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\n                                    <input type="checkbox" style="\n                                             margin-top: 10px;\n                                             margin-left: 15px;\n                                         " ng-model="vm.caseType.showInAssetsView" onclick="return false"/> \n                                     <span class="slider round" style="cursor: not-allowed;"></span>\n                                </label>\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.caseType.createdDate">Created Date</span></dt><dd><span>{{vm.caseType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.caseType.updateDate">Update Date</span></dt><dd><span>{{vm.caseType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.caseType.user">User</span></dt><dd>{{vm.caseType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="case-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="case-type.edit({id:vm.caseType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/case-type/case-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCaseTypeLabel"><span ng-if="!vm.caseType.id" translate="trakeyeApp.caseType.home.create">Create</span> <span ng-if="vm.caseType.id" translate="trakeyeApp.caseType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.caseType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.caseType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.caseType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.caseType.description"></textarea></div></div><!-- <div class="form-group">\n                            <label class="col-md-2 control-label">\n                                <span>Asset Map View</span>\n                            </label>\n                            <div class="col-md-9">\n                                <label class="switch" style="margin-top: 7px;">\n                                    <input type="checkbox" style="\n                                             margin-top: 10px;\n                                             margin-left: 15px;\n                                         " ng-model="vm.caseType.showInAssetsView" /> \n                                     <span class="slider round"></span>\n                                </label>\n                            </div>\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.caseType.casetypeimage" for="field_assetimage">CaseType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="caseTypeImage" id="caseTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.caseType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 caseType_showImg" ng-if="vm.caseType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageCase" ng-src="data:image/jpeg;base64,{{vm.caseType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.dataType">Data Type</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\n\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customCaseTypeAttributes">{{atttype.name }} \n\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.value">Dafault Value</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\n\t\t\t\t\t\t\t   </select>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t\n       \n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\n\t\t\t\t\t\t\t\t  </button>\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>             \n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.caseType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.caseType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.caseType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group caseType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.dataType">Data Type</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customCaseTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.caseCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.caseTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.value">Dafault Value</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="case-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/case-type/case-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.caseType.home.title">Case Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="case-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.caseType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.caseType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.caseType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.caseType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.caseType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="caseType in vm.caseTypes  | filter : search  track   by caseType.id"><!--  <td><a ui-sref="case-type-detail({id:caseType.id})">{{caseType.id}}</a></td> --><td>{{caseType.name}}</td><td>{{caseType.description}}</td><!--  <td>{{caseType.createdDate | date:\'medium\'}}</td>\n\t\t\t\t                    <td>{{caseType.updateDate | date:\'medium\'}}</td>--><!-- <td>\n\t\t\t\t                        {{caseType.createdBy}}\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="case-type-detail({id:caseType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="case-type.edit({id:caseType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.caseTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-asset-type-attribute/custom-asset-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customAssetTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customAssetTypeAttribute.delete.question" translate-values="{id: \'{{vm.customAssetTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Asset Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-asset-type-attribute/custom-asset-type-attribute-detail.html','<div class="custom_assetType"><h2><span data-translate="trakeyeApp.customAssetTypeAttribute.detail.title">Custom Asset Type Attribute</span> {{vm.customAssetTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span></dt><dd><span>{{vm.customAssetTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customAssetTypeAttribute.description">Description</span></dt><dd><span>{{vm.customAssetTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-asset-type-attribute.edit({id:vm.customAssetTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="mycustomAssetTypeAttributeLabel"><span ng-if="!vm.customAssetTypeAttribute.id" translate="trakeyeApp.customAssetTypeAttribute.home.create">Create</span> <span ng-if="vm.customAssetTypeAttribute.id" translate="trakeyeApp.customAssetTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customAssetTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customAssetTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customAssetTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customAssetTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-asset-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- <form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myCustomAssetTypeAttributeLabel" data-translate="trakeyeApp.customAssetTypeAttribute.home.createOrEditLabel">Create or edit a Custom Asset Type Attribute</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.customAssetTypeAttribute.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.customAssetTypeAttribute.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.customAssetTypeAttribute.name" for="field_name">Name</label>\n            <input type="text" class="form-control" name="name" id="field_name"\n                    ng-model="vm.customAssetTypeAttribute.name"\n                    required/>\n            <div ng-show="editForm.name.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.customAssetTypeAttribute.description" for="field_description">Description</label>\n            <input type="text" class="form-control" name="description" id="field_description"\n                    ng-model="vm.customAssetTypeAttribute.description"\n                    />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\n        </button>\n    </div>\n</form> -->');
$templateCache.put('app/entities/custom-asset-type-attribute/custom-asset-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customAssetTypeAttribute.home.title">Case Type Attribute DataTypes</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="custom-asset-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customAssetTypeAttribute.home.createLabel">Create new Case Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customAssetTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customAssetTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customAssetTypeAttribute in vm.customAssetTypeAttributes | filter:search track by customAssetTypeAttribute.id"><td><a ui-sref="custom-case-type-attribute-detail({id:customAssetTypeAttribute.id})">{{customAssetTypeAttribute.id}}</a></td><td>{{customAssetTypeAttribute.name}}</td><td>{{customAssetTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-asset-type-attribute-detail({id:customAssetTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-asset-type-attribute.edit({id:customAssetTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-asset-type-attribute.delete({id:customAssetTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customAssetTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\n    <h2 data-translate="trakeyeApp.customAssetTypeAttribute.home.title">Custom Case Type Attributes</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="custom-case-type-attribute.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span  data-translate="trakeyeApp.customAssetTypeAttribute.home.createLabel">\n                        Create new Custom Case Type Attribute\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customAssetTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="customAssetTypeAttribute in vm.customAssetTypeAttributes track by customAssetTypeAttribute.id">\n                    <td><a ui-sref="custom-case-type-attribute-detail({id:customAssetTypeAttribute.id})">{{customAssetTypeAttribute.id}}</a></td>\n                    <td>{{customAssetTypeAttribute.name}}</td>\n                    <td>{{customAssetTypeAttribute.description}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute-detail({id:customAssetTypeAttribute.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute.edit({id:customAssetTypeAttribute.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute.delete({id:customAssetTypeAttribute.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div> --><!-- <div>\n    <h2 data-translate="trakeyeApp.customAssetTypeAttribute.home.title">Custom Asset Type Attributes</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="custom-asset-type-attribute.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span  data-translate="trakeyeApp.customAssetTypeAttribute.home.createLabel">\n                        Create new Custom Asset Type Attribute\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customAssetTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="customAssetTypeAttribute in vm.customAssetTypeAttributes track by customAssetTypeAttribute.id">\n                    <td><a ui-sref="custom-asset-type-attribute-detail({id:customAssetTypeAttribute.id})">{{customAssetTypeAttribute.id}}</a></td>\n                    <td>{{customAssetTypeAttribute.name}}</td>\n                    <td>{{customAssetTypeAttribute.description}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="custom-asset-type-attribute-detail({id:customAssetTypeAttribute.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-asset-type-attribute.edit({id:customAssetTypeAttribute.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-asset-type-attribute.delete({id:customAssetTypeAttribute.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div> -->');
$templateCache.put('app/entities/custom-case-type-attribute/custom-case-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customCaseTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customCaseTypeAttribute.delete.question" translate-values="{id: \'{{vm.customCaseTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Case Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-case-type-attribute/custom-case-type-attribute-detail.html','<div class="custom_caseType"><h2><span data-translate="trakeyeApp.customCaseTypeAttribute.detail.title">Custom Case Type Attribute</span> {{vm.customCaseTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customCaseTypeAttribute.name">Name</span></dt><dd><span>{{vm.customCaseTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customCaseTypeAttribute.description">Description</span></dt><dd><span>{{vm.customCaseTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-case-type-attribute.edit({id:vm.customCaseTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomCaseTypeAttributeLabel"><span ng-if="!vm.customCaseTypeAttribute.id" translate="trakeyeApp.customCaseTypeAttribute.home.create">Create</span> <span ng-if="vm.customCaseTypeAttribute.id" translate="trakeyeApp.customCaseTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customCaseTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customCaseTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customCaseTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customCaseTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customCaseTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-case-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myCustomCaseTypeAttributeLabel" data-translate="trakeyeApp.customCaseTypeAttribute.home.createOrEditLabel">Create or edit a Custom Case Type Attribute</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.customCaseTypeAttribute.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.customCaseTypeAttribute.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.customCaseTypeAttribute.name" for="field_name">Name</label>\n            <input type="text" class="form-control" name="name" id="field_name"\n                    ng-model="vm.customCaseTypeAttribute.name"\n                    required/>\n            <div ng-show="editForm.name.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.customCaseTypeAttribute.description" for="field_description">Description</label>\n            <input type="text" class="form-control" name="description" id="field_description"\n                    ng-model="vm.customCaseTypeAttribute.description"\n                    />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\n        </button>\n    </div>\n</form> -->');
$templateCache.put('app/entities/custom-case-type-attribute/custom-case-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customCaseTypeAttribute.home.title">Case Type Attribute DataTypes</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="custom-case-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customCaseTypeAttribute.home.createLabel">Create new Case Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customCaseTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customCaseTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customCaseTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customCaseTypeAttribute in vm.customCaseTypeAttributes  | filter :search track by customCaseTypeAttribute.id"><td><a ui-sref="custom-case-type-attribute-detail({id:customCaseTypeAttribute.id})">{{customCaseTypeAttribute.id}}</a></td><td>{{customCaseTypeAttribute.name}}</td><td>{{customCaseTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-case-type-attribute-detail({id:customCaseTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-case-type-attribute.edit({id:customCaseTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-case-type-attribute.delete({id:customCaseTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customCaseTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\n    <h2 data-translate="trakeyeApp.customCaseTypeAttribute.home.title">Custom Case Type Attributes</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="custom-case-type-attribute.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span  data-translate="trakeyeApp.customCaseTypeAttribute.home.createLabel">\n                        Create new Custom Case Type Attribute\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customCaseTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customCaseTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="customCaseTypeAttribute in vm.customCaseTypeAttributes track by customCaseTypeAttribute.id">\n                    <td><a ui-sref="custom-case-type-attribute-detail({id:customCaseTypeAttribute.id})">{{customCaseTypeAttribute.id}}</a></td>\n                    <td>{{customCaseTypeAttribute.name}}</td>\n                    <td>{{customCaseTypeAttribute.description}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute-detail({id:customCaseTypeAttribute.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute.edit({id:customCaseTypeAttribute.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute.delete({id:customCaseTypeAttribute.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div> -->');
$templateCache.put('app/entities/custom-group-type-attribute/custom-group-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customGroupTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customGroupTypeAttribute.delete.question" translate-values="{id: \'{{vm.customGroupTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Group Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-group-type-attribute/custom-group-type-attribute-detail.html','<div class="custom_groupType"><h2><span data-translate="trakeyeApp.customGroupTypeAttribute.detail.title">Custom Group Type Attribute</span> {{vm.customGroupTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span></dt><dd><span>{{vm.customGroupTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customGroupTypeAttribute.description">Description</span></dt><dd><span>{{vm.customGroupTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-group-type-attribute.edit({id:vm.customGroupTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="mycustomGroupTypeAttributeLabel"><span ng-if="!vm.customGroupTypeAttribute.id" translate="trakeyeApp.customGroupTypeAttribute.home.create">Create</span> <span ng-if="vm.customGroupTypeAttribute.id" translate="trakeyeApp.customGroupTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customGroupTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customGroupTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customGroupTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customGroupTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-group-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- <form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myCustomGroupTypeAttributeLabel" data-translate="trakeyeApp.customGroupTypeAttribute.home.createOrEditLabel">Create or edit a Custom Group Type Attribute</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.customGroupTypeAttribute.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.customGroupTypeAttribute.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.customGroupTypeAttribute.name" for="field_name">Name</label>\n            <input type="text" class="form-control" name="name" id="field_name"\n                    ng-model="vm.customGroupTypeAttribute.name"\n                    required/>\n            <div ng-show="editForm.name.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.customGroupTypeAttribute.description" for="field_description">Description</label>\n            <input type="text" class="form-control" name="description" id="field_description"\n                    ng-model="vm.customGroupTypeAttribute.description"\n                    />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\n        </button>\n    </div>\n</form> -->');
$templateCache.put('app/entities/custom-group-type-attribute/custom-group-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customGroupTypeAttribute.home.title">Case Type Attribute DataTypes</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="custom-group-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customGroupTypeAttribute.home.createLabel">Create new Case Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customGroupTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customGroupTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customGroupTypeAttribute in vm.customGroupTypeAttributes | filter:search track by customGroupTypeAttribute.id"><td><a ui-sref="custom-case-type-attribute-detail({id:customGroupTypeAttribute.id})">{{customGroupTypeAttribute.id}}</a></td><td>{{customGroupTypeAttribute.name}}</td><td>{{customGroupTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-group-type-attribute-detail({id:customGroupTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-group-type-attribute.edit({id:customGroupTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-group-type-attribute.delete({id:customGroupTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customGroupTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\n    <h2 data-translate="trakeyeApp.customGroupTypeAttribute.home.title">Custom Case Type Attributes</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="custom-case-type-attribute.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span  data-translate="trakeyeApp.customGroupTypeAttribute.home.createLabel">\n                        Create new Custom Case Type Attribute\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customGroupTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="customGroupTypeAttribute in vm.customGroupTypeAttributes track by customGroupTypeAttribute.id">\n                    <td><a ui-sref="custom-case-type-attribute-detail({id:customGroupTypeAttribute.id})">{{customGroupTypeAttribute.id}}</a></td>\n                    <td>{{customGroupTypeAttribute.name}}</td>\n                    <td>{{customGroupTypeAttribute.description}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute-detail({id:customGroupTypeAttribute.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute.edit({id:customGroupTypeAttribute.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-case-type-attribute.delete({id:customGroupTypeAttribute.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div> --><!-- <div>\n    <h2 data-translate="trakeyeApp.customGroupTypeAttribute.home.title">Custom Group Type Attributes</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="custom-group-type-attribute.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span  data-translate="trakeyeApp.customGroupTypeAttribute.home.createLabel">\n                        Create new Custom Group Type Attribute\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customGroupTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="customGroupTypeAttribute in vm.customGroupTypeAttributes track by customGroupTypeAttribute.id">\n                    <td><a ui-sref="custom-group-type-attribute-detail({id:customGroupTypeAttribute.id})">{{customGroupTypeAttribute.id}}</a></td>\n                    <td>{{customGroupTypeAttribute.name}}</td>\n                    <td>{{customGroupTypeAttribute.description}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="custom-group-type-attribute-detail({id:customGroupTypeAttribute.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-group-type-attribute.edit({id:customGroupTypeAttribute.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-group-type-attribute.delete({id:customGroupTypeAttribute.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div> -->');
$templateCache.put('app/entities/custom-service-type-attribute/custom-service-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customServiceTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customServiceTypeAttribute.delete.question" translate-values="{id: \'{{vm.customServiceTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Service Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-service-type-attribute/custom-service-type-attribute-detail.html','<div class="customSer_label"><h2><span data-translate="trakeyeApp.customServiceTypeAttribute.detail.title">Custom Service Type Attribute</span> {{vm.customServiceTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customServiceTypeAttribute.name">Name</span></dt><dd><span>{{vm.customServiceTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customServiceTypeAttribute.description">Description</span></dt><dd><span>{{vm.customServiceTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-service-type-attribute.edit({id:vm.customServiceTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="mycustomServiceTypeAttributeLabel"><span ng-if="!vm.customServiceTypeAttribute.id" translate="trakeyeApp.customServiceTypeAttribute.home.create">Create</span> <span ng-if="vm.customServiceTypeAttribute.id" translate="trakeyeApp.customServiceTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customServiceTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customServiceTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customServiceTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customServiceTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customServiceTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-service-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- <form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myCustomServiceTypeAttributeLabel" data-translate="trakeyeApp.customServiceTypeAttribute.home.createOrEditLabel">Create or edit a Custom Service Type Attribute</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.customServiceTypeAttribute.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.customServiceTypeAttribute.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.customServiceTypeAttribute.name" for="field_name">Name</label>\n            <input type="text" class="form-control" name="name" id="field_name"\n                    ng-model="vm.customServiceTypeAttribute.name"\n                    required/>\n            <div ng-show="editForm.name.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.customServiceTypeAttribute.description" for="field_description">Description</label>\n            <input type="text" class="form-control" name="description" id="field_description"\n                    ng-model="vm.customServiceTypeAttribute.description"\n                    />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\n        </button>\n    </div>\n</form> -->');
$templateCache.put('app/entities/custom-service-type-attribute/custom-service-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customServiceTypeAttribute.home.title">Custom Service Type Attribute DataTypes</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="custom-service-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customServiceTypeAttribute.home.createLabel">Create new service Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customServiceTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customServiceTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customServiceTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customServiceTypeAttribute in vm.customServiceTypeAttributes  | filter :search track by customServiceTypeAttribute.id"><td><a ui-sref="custom-service-type-attribute-detail({id:customServiceTypeAttribute.id})">{{customServiceTypeAttribute.id}}</a></td><td>{{customServiceTypeAttribute.name}}</td><td>{{customServiceTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-service-type-attribute-detail({id:customServiceTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-service-type-attribute.edit({id:customServiceTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-service-type-attribute.delete({id:customServiceTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customServiceTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\n    <h2 data-translate="trakeyeApp.customServiceTypeAttribute.home.title">Custom Service Type Attributes</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="custom-service-type-attribute.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span  data-translate="trakeyeApp.customServiceTypeAttribute.home.createLabel">\n                        Create new Custom Service Type Attribute\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customServiceTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customServiceTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="customServiceTypeAttribute in vm.customServiceTypeAttributes track by customServiceTypeAttribute.id">\n                    <td><a ui-sref="custom-service-type-attribute-detail({id:customServiceTypeAttribute.id})">{{customServiceTypeAttribute.id}}</a></td>\n                    <td>{{customServiceTypeAttribute.name}}</td>\n                    <td>{{customServiceTypeAttribute.description}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="custom-service-type-attribute-detail({id:customServiceTypeAttribute.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-service-type-attribute.edit({id:customServiceTypeAttribute.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="custom-service-type-attribute.delete({id:customServiceTypeAttribute.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div> -->');
$templateCache.put('app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customWorkFlowTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customWorkFlowTypeAttribute.delete.question" translate-values="{id: \'{{vm.customWorkFlowTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Work Flow Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-detail.html','<div><h2><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.detail.title">Custom Work Flow Type Attribute</span> {{vm.customWorkFlowTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.name">Name</span></dt><dd><span>{{vm.customWorkFlowTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.description">Description</span></dt><dd><span>{{vm.customWorkFlowTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-work-flow-type-attribute.edit({id:vm.customWorkFlowTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomWorkFlowTypeAttributeLabel"><span ng-if="!vm.customWorkFlowTypeAttribute.id" translate="trakeyeApp.customWorkFlowTypeAttribute.home.create">Create</span> <span ng-if="vm.customWorkFlowTypeAttribute.id" translate="trakeyeApp.customWorkFlowTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customWorkFlowTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customWorkFlowTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customWorkFlowTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customWorkFlowTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-work-flow-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customWorkFlowTypeAttribute.home.title">WorkFlow Type Attribute DataTypes</span></h3><div class="box-tools custom_WorkFlowTypeAttr"><button class="btn btn-create" ui-sref="custom-work-flow-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customWorkFlowTypeAttribute.home.createLabel">Create new WorkFlow Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customWorkFlowTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customWorkFlowTypeAttribute in vm.customWorkFlowTypeAttributes  | filter :search track by customWorkFlowTypeAttribute.id"><td><a ui-sref="custom-work-flow-type-attribute-detail({id:customWorkFlowTypeAttribute.id})">{{customWorkFlowTypeAttribute.id}}</a></td><td>{{customWorkFlowTypeAttribute.name}}</td><td>{{customWorkFlowTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-work-flow-type-attribute-detail({id:customWorkFlowTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-work-flow-type-attribute.edit({id:customWorkFlowTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-work-flow-type-attribute.delete({id:customWorkFlowTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customWorkFlowTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/feasibility-check/feasibility-check-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.feasibilityCheck.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.feasibilityCheck.delete.question" translate-values="{id: \'{{vm.feasibilityCheck.id}}\'}">Are you sure you want to delete this Feasibility Check?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/feasibility-check/feasibility-check-detail.html','<div><h2><span data-translate="trakeyeApp.feasibilityCheck.detail.title">Feasibility Check</span> {{vm.feasibilityCheck.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.feasibilityCheck.requestId">Request Id</span></dt><dd><span>{{vm.feasibilityCheck.requestId}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.customerName">Customer Name</span></dt><dd><span>{{vm.feasibilityCheck.customerName}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.phone">Phone</span></dt><dd><span>{{vm.feasibilityCheck.phone}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.email">Email</span></dt><dd><span>{{vm.feasibilityCheck.email}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.createDate">Create Date</span></dt><dd><span>{{vm.feasibilityCheck.createDate}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.updateDate">Update Date</span></dt><dd><span>{{vm.feasibilityCheck.updateDate}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.notes">Notes</span></dt><dd><span>{{vm.feasibilityCheck.notes}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.latitude">Latitude</span></dt><dd><span>{{vm.feasibilityCheck.latitude}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.longitude">Longitude</span></dt><dd><span>{{vm.feasibilityCheck.longitude}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.address">Address</span></dt><dd><span>{{vm.feasibilityCheck.address}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="feasibility-check-detail.edit({id:vm.feasibilityCheck.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/feasibility-check/feasibility-check-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFeasibilityCheckLabel" data-translate="trakeyeApp.feasibilityCheck.home.createOrEditLabel">Create or edit a Feasibility Check</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group" ng-show="vm.feasibilityCheck.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.feasibilityCheck.id" readonly />\n        </div> --><div class="form-group"><label for="field_requestId"><span translate="trakeyeApp.feasibilityCheck.requestId">Request Id</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <input type="text" class="form-control" name="requestId" id="field_requestId" ng-model="vm.feasibilityCheck.requestId" required><!-- <div ng-show="editForm.requestId.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.requestId.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div> --></div><div class="form-group"><label class="control-label" data-translate="trakeyeApp.feasibilityCheck.customerName" for="field_customerName">Customer Name</label> <input type="text" class="form-control" name="customerName" id="field_customerName" ng-model="vm.feasibilityCheck.customerName"></div><div class="form-group"><label for="field_phone"><span translate="trakeyeApp.feasibilityCheck.phone">Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.feasibilityCheck.phone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required><p class="help-block" ng-show="editForm.phone.$error.maxlength" translate="global.messages.validate.phone.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.phone.$error.minlength" translate="global.messages.validate.phone.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.phone.$error.pattern" translate="global.messages.validate.phone.invalid">Your phone number is invalid.</p><!-- <div ng-show="editForm.phone.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div> --></div><div class="form-group"><label class="control-label" data-translate="trakeyeApp.feasibilityCheck.email" for="field_email">Email</label> <input type="email" class="form-control" name="email" id="field_email" ng-model="vm.feasibilityCheck.email" ng-pattern="EMAIL_REGEXP"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><!-- <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.createDate" for="field_createDate">Create Date</label>\n            <input type="number" class="form-control" name="createDate" id="field_createDate"\n                    ng-model="vm.feasibilityCheck.createDate"\n                    />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.updateDate" for="field_updateDate">Update Date</label>\n            <input type="number" class="form-control" name="updateDate" id="field_updateDate"\n                    ng-model="vm.feasibilityCheck.updateDate"\n                    />\n        </div> --><div class="form-group"><label class="control-label" data-translate="trakeyeApp.feasibilityCheck.notes" for="field_notes">Notes</label> <input type="text" class="form-control" name="notes" id="field_notes" ng-model="vm.feasibilityCheck.notes"></div><!-- <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.latitude" for="field_latitude">Latitude</label>\n            <input type="number" class="form-control" name="latitude" id="field_latitude"\n                    ng-model="vm.feasibilityCheck.latitude"\n                    />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.longitude" for="field_longitude">Longitude</label>\n            <input type="number" class="form-control" name="longitude" id="field_longitude"\n                    ng-model="vm.feasibilityCheck.longitude"\n                    />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.address" for="field_address">Address</label>\n            <input type="text" class="form-control" name="address" id="field_address"\n                    ng-model="vm.feasibilityCheck.address"\n                    />\n        </div> --><div class="form-group"><label class="control-label" data-translate="trakeyeApp.feasibilityCheck.notificationType" for="field_notificationType">Notification Type</label> <select class="form-control" name="notificationType" ng-model="vm.feasibilityCheck.notificationType" id="field_notificationType"><option value="EMAIL" data-translate="trakeyeApp.AlertType.EMAIL">EMAIL</option><option value="SMS" data-translate="trakeyeApp.AlertType.SMS">SMS</option></select></div><!-- <div class="form-group">\n            <label data-translate="trakeyeApp.feasibilityCheck.user" for="field_user">User</label>\n            <select class="form-control" id="field_user" name="user" ng-model="vm.feasibilityCheck.userId" ng-options="user.id as user.login for user in vm.users"            >\n                <option value=""></option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label data-translate="trakeyeApp.feasibilityCheck.tenant" for="field_tenant">Tenant</label>\n            <select class="form-control" id="field_tenant" name="tenant" ng-model="vm.feasibilityCheck.tenantId" ng-options="tenant.id as tenant.id for tenant in vm.tenants"            >\n                <option value=""></option>\n            </select>\n        </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/feasibility-check/feasibility-checks.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-asterisk"></i> <span translate="trakeyeApp.feasibilityCheck.home.title">Feasibility Checks</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create btn-sm" ui-sref="feasibility-check.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.feasibilityCheck.home.createLabel">Create new Feasibility Check</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.feasibilityCheck.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="requestId"><span data-translate="trakeyeApp.feasibilityCheck.requestId">Request Id</span> <span class="fa fa-sort"></span></th><th jh-sort-by="customerName"><span data-translate="trakeyeApp.feasibilityCheck.customerName">Customer Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="latitude"><span data-translate="trakeyeApp.feasibilityCheck.latitude">Latitude</span> <span class="fa fa-sort"></span></th><th jh-sort-by="longitude"><span data-translate="trakeyeApp.feasibilityCheck.longitude">Longitude</span> <span class="fa fa-sort"></span></th><th jh-sort-by="address"><span data-translate="trakeyeApp.feasibilityCheck.address">Address</span> <span class="fa fa-sort"></span></th><th jh-sort-by="phone"><span data-translate="trakeyeApp.feasibilityCheck.phone">Phone</span> <span class="fa fa-sort"></span></th><th jh-sort-by="email"><span data-translate="trakeyeApp.feasibilityCheck.email">Email</span> <span class="fa fa-sort"></span></th><th jh-sort-by="createDate"><span data-translate="trakeyeApp.feasibilityCheck.createDate">Create Date</span> <span class="fa fa-sort"></span></th><th jh-sort-by="updateDate"><span data-translate="trakeyeApp.feasibilityCheck.updateDate">Update Date</span> <span class="fa fa-sort"></span></th><th jh-sort-by="notes"><span data-translate="trakeyeApp.feasibilityCheck.notes">Notes</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="feasibilityCheck in vm.feasibilityChecks track by feasibilityCheck.id"><!-- <td><a ui-sref="feasibility-check-detail({id:feasibilityCheck.id})">{{feasibilityCheck.id}}</a></td> --><td>{{feasibilityCheck.requestId}}</td><td>{{feasibilityCheck.customerName}}</td><td>{{feasibilityCheck.latitude}}</td><td>{{feasibilityCheck.longitude}}</td><td>{{feasibilityCheck.address}}</td><td>{{feasibilityCheck.phone}}</td><td>{{feasibilityCheck.email}}</td><td>{{feasibilityCheck.createDate | date:\'medium\'}}</td><td>{{feasibilityCheck.updateDate |date:\'medium\'}}</td><td>{{feasibilityCheck.notes}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="feasibility-check-detail({id:feasibilityCheck.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="feasibility-check.edit({id:feasibilityCheck.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="feasibility-check.delete({id:feasibilityCheck.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.feasibilityChecks == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\n    <h2 data-translate="trakeyeApp.feasibilityCheck.home.title">Feasibility Checks</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="feasibility-check.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span  data-translate="trakeyeApp.feasibilityCheck.home.createLabel">\n                        Create new Feasibility Check\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="requestId"><span data-translate="trakeyeApp.feasibilityCheck.requestId">Request Id</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="customerName"><span data-translate="trakeyeApp.feasibilityCheck.customerName">Customer Name</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="latitude"><span data-translate="trakeyeApp.feasibilityCheck.latitude">Latitude</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="longitude"><span data-translate="trakeyeApp.feasibilityCheck.longitude">Longitude</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="address"><span data-translate="trakeyeApp.feasibilityCheck.address">Address</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="phone"><span data-translate="trakeyeApp.feasibilityCheck.phone">Phone</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="email"><span data-translate="trakeyeApp.feasibilityCheck.email">Email</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="createDate"><span data-translate="trakeyeApp.feasibilityCheck.createDate">Create Date</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="updateDate"><span data-translate="trakeyeApp.feasibilityCheck.updateDate">Update Date</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="notes"><span data-translate="trakeyeApp.feasibilityCheck.notes">Notes</span> <span class="fa fa-sort"></span></th>\n                   <th jh-sort-by="notificationType"><span data-translate="trakeyeApp.feasibilityCheck.notificationType">Notification Type</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="userLogin"><span data-translate="trakeyeApp.feasibilityCheck.user">User</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="tenantId"><span data-translate="trakeyeApp.feasibilityCheck.tenant">Tenant</span> <span class="fa fa-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="feasibilityCheck in vm.feasibilityChecks track by feasibilityCheck.id">\n                    <td><a ui-sref="feasibility-check-detail({id:feasibilityCheck.id})">{{feasibilityCheck.id}}</a></td>\n                    <td>{{feasibilityCheck.requestId}}</td>\n                    <td>{{feasibilityCheck.customerName}}</td>\n                    <td>{{feasibilityCheck.latitude}}</td>\n                    <td>{{feasibilityCheck.longitude}}</td>\n                    <td>{{feasibilityCheck.address}}</td>\n                    <td>{{feasibilityCheck.phone}}</td>\n                    <td>{{feasibilityCheck.email}}</td>\n                    <td>{{feasibilityCheck.createDate}}</td>\n                    <td>{{feasibilityCheck.updateDate}}</td>\n                    <td>{{feasibilityCheck.notes}}</td>\n                    \n                    <td data-translate="{{\'trakeyeApp.AlertType.\' + feasibilityCheck.notificationType}}">{{feasibilityCheck.notificationType}}</td>\n                    <td>\n                        {{feasibilityCheck.userLogin}}\n                    </td>\n                    <td>\n                        <a ui-sref="tenant-detail({id:feasibilityCheck.tenantId})">{{feasibilityCheck.tenantId}}</a>\n                    </td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="feasibility-check-detail({id:feasibilityCheck.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="feasibility-check.edit({id:feasibilityCheck.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="feasibility-check.delete({id:feasibilityCheck.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div>\n -->');
$templateCache.put('app/entities/group/group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.group.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.group.delete.question" translate-values="{id: \'{{vm.group.id}}\'}">Are you sure you want to delete this Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/group/group-detail.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate="trakeyeApp.group.detail.title">Group</span> - {{vm.group.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.group.name">Name</span></dt><dd><span>{{vm.group.name}}</span></dd><dt><span translate="trakeyeApp.group.description">Description</span></dt><dd><span>{{vm.group.description}}</span></dd><dt><span translate="trakeyeApp.group.createDate">Create Date</span></dt><dd><span>{{vm.group.groupType.createDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.group.updateDate">Update Date</span></dt><dd><span>{{vm.group.groupType.updateDate| date:\'medium\'}}</span></dd><dt><span translate="User">User</span></dt><dd><span>{{vm.group.createdBy}}</span></dd><!--     <dt ><span translate="trakeyeApp.group.ownedby">Owner</span></dt>\n\t\t\t\t\t\t        <dd ><span><div ng-repeat="ownedBy in vm.group.ownedBy">\n\t\t\t\t\t                        <span class="label label-default">{{ ownedBy.login}}</span>\n\t\t\t\t\t                    </div></span></dd> --></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="group.edit({id:vm.group.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/group/group-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.group.id" translate="trakeyeApp.group.home.create">Create</span> <span ng-if="vm.group.id" translate="trakeyeApp.group.home.Edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.group.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.group.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.group.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.group.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.group.groupType" for="field_groupType">Group Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="groupType" ng-model="vm.groupType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.grouptypes track by item.id" required><!-- <option value="">--- Select GroupType ---</option> --><option value="">{{vm.group.groupType.name}}</option></select></div><!-- <div class="col-md-3" ui-sref="group-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="trakeyeApp.group.home.create">\n                                    Create Group Type\n                                </div> --><div class="col-md-3 div__mt-10"><i class="fa fa-plus-square i__fa-plus-square" ng-click="vm.navigateGroupTypefromGroup();" title="Create Group Type"></i></div></div><div class="form-group" ng-repeat="attribute in vm.group.groupTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.groupTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.group.id" type="text" class="form-control" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue = attribute.groupTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.group.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span class="span__valid" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.group.id" type="text" class="form-control" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue = attribute.groupTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.group.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span class="span__valid" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern">Enter a Valid Number </span><input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'STRING\' && !vm.group.id" type="text" class="form-control" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue = attribute.groupTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'STRING\' && vm.group.id" type="text" class="form-control" name="value{{$index+1}}"> <span class="span__valid" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern">Enter a Message</span> <select ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue = attribute.groupTypeAttribute.defaultValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name != \'STRING\' && attribute.groupTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.groupTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.group.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.groupTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue == attribute.groupTypeAttribute.defaultValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name != \'STRING\' && attribute.groupTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.groupTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.group.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.groupTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="group"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/group/groups.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-group"></i> <span translate="trakeyeApp.group.home.title">Groups</span></h3><div class="box-tools group_labels"><!-- <button class="btn btn-create btn-sm" ui-sref="group.import" ng-if="has_ROLE_USER_ADMIN">\n\t\t\t\t\t\t\t<span class="glyphicon glyphicon-plus"></span> <span > Import </span>\n\t\t\t\t\t\t</button> --> <button class="btn btn-create btn-sm" ui-sref="group.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.group.home.createLabel">Create new Group</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.group.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span>\n\t\t\t\t\t\t\t\t\t\t<span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.group.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.group.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="group in vm.groups | filter: users track by group.id"><!-- <td><a ui-sref="group-detail({id:group.id})">{{group.id}}</a></td> --><td>{{group.name}}</td><td>{{group.description}}</td><td><div class="action"><a ui-sref="group-detail({id:group.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="group.edit({id:group.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.groups == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customWorkOrderTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customWorkOrderTypeAttribute.delete.question" translate-values="{id: \'{{vm.customWorkOrderTypeAttribute.id}}\'}">Are you sure you want to delete this Custom WorkOrder Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-detail.html','<div class="custom_workOrderType"><h2><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.detail.title">Custom WorkOrder Type Attribute</span> {{vm.customWorkOrderTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span></dt><dd><span>{{vm.customWorkOrderTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.description">Description</span></dt><dd><span>{{vm.customWorkOrderTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-workorder-type-attribute.edit({id:vm.customWorkOrderTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomWorkOrderTypeAttributeLabel"><span ng-if="!vm.customWorkOrderTypeAttribute.id" translate="trakeyeApp.customWorkOrderTypeAttribute.home.create">Create</span> <span ng-if="vm.customWorkOrderTypeAttribute.id" translate="trakeyeApp.customWorkOrderTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customWorkOrderTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customWorkOrderTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customWorkOrderTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customWorkOrderTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-workorder-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/custom-workorder-type-attribute/custom-workorder-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.title">WorkOrder Type Attribute DataTypes</span></h3><div class="box-tools custom_WorkOrderTypeAttr"><button class="btn btn-create" ui-sref="custom-workorder-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.createLabel">Create new WorkOrder Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control input-sm" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customWorkOrderTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customWorkOrderTypeAttribute in vm.customWorkOrderTypeAttributes  | filter :search track by customWorkOrderTypeAttribute.id"><td><a ui-sref="custom-workorder-type-attribute-detail({id:customWorkOrderTypeAttribute.id})">{{customWorkOrderTypeAttribute.id}}</a></td><td>{{customWorkOrderTypeAttribute.name}}</td><td>{{customWorkOrderTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-workorder-type-attribute-detail({id:customWorkOrderTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-workorder-type-attribute.edit({id:customWorkOrderTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-workorder-type-attribute.delete({id:customWorkOrderTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.customWorkOrderTypeAttributes == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/geofence/geofence-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.geofence.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.geofence.delete.question" translate-values="{id: \'{{vm.geofence.id}}\'}">Are you sure you want to delete this Geofence?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/geofence/geofence-detail.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate="trakeyeApp.geofence.detail.title">Geofence</span> - {{vm.geofence.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.geofence.name">Name</span></dt><dd><span>{{vm.geofence.name}}</span></dd><dt><span translate="trakeyeApp.geofence.description">Description</span></dt><dd><span>{{vm.geofence.description}}</span></dd><dt><span translate="trakeyeApp.geofence.assets">Assets</span></dt><dd><span><div ng-repeat="asset in vm.geofence.assets"><span class="label label-default">{{ asset.name}}</span></div></span></dd><dt><span translate="trakeyeApp.geofence.ownedby">Owner</span></dt><dd><span><div ng-repeat="ownedBy in vm.geofence.ownedBy"><span class="label label-default">{{ ownedBy.login}}</span></div></span></dd><dt><span translate="">Type</span><dd><span>{{vm.geofence.geofenceType}}</span></dd></dt><dt><span translate="trakeyeApp.geofence.coordinates">Coordinates</span></dt><dd><div id="map_canvas" class="div__map--canvas"></div></dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="geofence.edit({id:vm.geofence.id})" class="btn btn-primary btn-sm" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/geofence/geofence-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.geofence.id" translate="trakeyeApp.geofence.home.create">Create</span> <span ng-if="vm.geofence.id" translate="trakeyeApp.geofence.home.Edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.geofence.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.geofence.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.geofence.description"></textarea></div></div><div class="form-group"><!-- <label class="col-md-3 control-label"> <span\n\t\t\t\t\t\t\t\t\ttranslate="trakeyeApp.geofence.assets">assets</span>\n\t\t\t\t\t\t\t\t\t<sup><span\n\t\t\t\t\t\t\t\t\t\tclass="required-icon"><i\n\t\t\t\t\t\t\t\t\t\t\tclass="fa fa-asterisk text-danger"></i></span> </sup>\n\t\t\t\t\t\t\t\t</label> --><!--  <div class="col-md-3">\n                                    <div isteven-multi-select input-model="vm.multiassets" output-model="vm.geofence.assets" button-label="name" item-label="name" tick-property="ticked" output-properties="id selected">\n                                    </div>\n                                    <input type="text" ng-model="vm.geofence.assets" name="fence" style="display:none" />\n                                </div> --><!-- <div class="col-md-3" ui-sref="asset.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="trakeyeApp.geofence.home.CreateAssetInGeo">\n                                    Create Asset\n\t\t\t\t\t\t\t\t</div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\n                                    <i class="fa fa-plus-square" ng-click="vm.navigateCreateAssetGeo();" style="cursor: pointer;" title=\'Create Asset\'></i>\n                                </div> --></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.ownedby">Owner</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" multiple  name="ownedBy" ng-model="vm.geofence.ownedBy" \n\t\t\t\t\t\t\t\t\t\tng-options="user.id as user.login for user in vm.users  track by user.id">\n\t\t\t\t\t\t\t\t</select> --><div isteven-multi-select input-model="vm.multiuser" output-model="vm.geofence.ownedBy" button-label="login" item-label="login" tick-property="ticked" helper-elements="all none" output-properties="id selected"></div><input type="text" ng-model="vm.geofence.ownedBy" name="owner" id="input__none" required></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.geofenceType" for="field_type">Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="layout" ng-model="vm.geofenceType" id="field_layout" required><option value="">---Select Geofence Type---</option><option value="MASTER" translate="trakeyeApp.geofence.type.MASTER">MASTER</option><option value="MINI" translate="trakeyeApp.geofence.type.MINI">MINI</option><option value="BUFFER" translate="trakeyeApp.geofence.type.BUFFER">BUFFER</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.coordinates">Coordinates</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><div class="input-group"><input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled="disabled" ng-model="vm.geofence.coordinates" required> <span class="input-group-btn" ng-if="vm.geofence.id==null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Create</button> </span><span class="input-group-btn" ng-if="vm.geofence.id!=null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">View or Edit</button> </span><span class="input-group-btn" ng-if="vm.geofence.id!=null"><button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm">Destroy and Create</button></span></div><br><div id="map_canvas" class="div__map-canvas" ng-if="vm.geofence.layout!=null || vm.geofence.coordinates != \'\'"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="geofence"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/geofence/geofence-import.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i>Import Geofences</h3><div class="box-tools ng-scope"><button class="btn btn-create"><span class="fa fa-download"></span> <a href="content/images/geofences.kml" download id="a__text">Sample File</a></button></div></div><!-- /.box-header --><!-- form start --><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file accept="*.kml||*.kml" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only KML file should be uploaded</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.geofenceType" for="field_type">Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="layout" ng-model="vm.geofencetype" onchange="vm.setGeofenceType()" id="field_layout" required><option value="">---Select Geofence Type---</option><option value="MASTER" translate="trakeyeApp.geofence.type.MASTER">MASTER</option><option value="MINI" translate="trakeyeApp.geofence.type.MINI">MINI</option><option value="BUFFER" translate="trakeyeApp.geofence.type.BUFFER">BUFFER</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/geofence/geofences.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-street-view"></i> <span>Geofences</span><!-- translate="trakeyeApp.geofence.home.title" --></h3></div><div class="col-md-5 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1); search = null" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-map"></i><span class="header-view">Map</span> <span class="header_view">View</span></a></li></ul></div><div class="box-tools geofence_labels" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER"><button class="btn btn-create btn-sm" ui-sref="geofence.import"><span class="glyphicon glyphicon-plus"></span> <span>Import</span></button> <button class="btn btn-create btn-sm" ui-sref="geofence.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="alert alert-success" ng-show="vm.success"><p>Request Sent, To Track Your Request Click Here - <a ui-sref="asset-link">Asset Link</a></p></div><div class="row"><div class="col-md-3 pull-right" ng-show="isSet(1)"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" placeholder="{{\'trakeyeApp.geofence.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div><!-- <div class="col-md-3 search-top" ng-show="isSet(2)">\n                            <div class="input-group ">\n                                <input type="text" ng-model="search" class="form-control " ng-minlength="0"\n                                    ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/"\n                                    placeholder="{{\'trakeyeApp.geofence.home.search\' | translate}}">\n                                <span class="input-group-btn">\n                                    <button type="button" class="btn btn-info btn-flat"\n                                        ng-click="vm.filterGeofenceSearchMap()">\n                                        <i class="fa fa-search"></i></button>\n                                </span>\n                            </div>\n                        </div> --><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(2)"><select id="masterGeofence" class="select2 form-control" ng-model="vm.masterGeofence"><option value="">Select City</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select> <span id="noData" ng-if="!vm.selectCityFilter">*Please Select City</span></div><!-- <div class="col-md-1" ng-show="isSet(2)">\n                            <button\n                                type="button"\n                                value="GOTO"\n                                class="btn btn-info btn-flat"\n                                ng-click="vm.gotoLatitute()"\n                            >\n                                GO TO\n                            </button>\n                        </div> --><div class="col-md-3 dropFilter div--filter" ng-show="isSet(2) && vm.selectCityFilter"><!-- <button type="button" class="btn btn-info btn-flat"\n                                ng-click="vm.filterAssetsOnGeofenveMapView()">\n                                <i class="fa fa-filter"></i>\n                            </button> --><div isteven-multi-select input-model="vm.userGeofences" output-model="vm.selectedGeofence" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceMap()" max-height="150px"></div><input type="text" ng-model="vm.selectedGeofence" name="vm.searchMini" style="display:none" required> <span id="noData" ng-if="vm.selectedGeofence.length < 1">*Please Select Geofence</span></div><div class="row" ng-show="isSet(1)"><div class="pull-right" ng-show="vm.canDownload"><button class="btn btn-primary button__downloadCsv" ng-click="vm.downloadAttendenceReport()"><span class="glyphicon glyphicon-download"></span>&nbsp;<span translate="entity.action.downloadcsv">Download CSV</span></button> <button class="btn btn-primary button__downloadKml" ng-click="vm.downloadAttendenceReportKml()"><span class="glyphicon glyphicon-download"></span>&nbsp;<span translate="entity.action.downloadkml">Download KML</span></button></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span>\n\t\t\t\t\t\t\t\t\t\t<span class="fa fa-sort"></span></th> --><th><input type="checkbox" ng-click="vm.selectAllGeofences()" ng-model="vm.isAllGeofencesSelected"></th><th></th><th jh-sort-by="name"><span translate="trakeyeApp.geofence.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.geofence.description">Description</span></th><th><span>Parent</span> <span class="fa fa-sort"></span></th><th>Geofence Type</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="geofence in vm.geofences | filter: users track by geofence.id" ng-class="{selected: geofence.isChecked}"><!-- <td><a ui-sref="geofence-detail({id:geofence.id})">{{geofence.id}}</a></td> --><td><input type="checkbox" ng-model="geofence.isChecked" ng-change="vm.selectGeofenceEntity(geofence)"></td><!-- <td class="td__listViewRow">\n                                        <button class="button__listViewRow" ng-click="vm.geofencesTable(geofence);" expand>\n                                            <span class="span__listViewRow" ng-bind="geofence.isExpanded ? \'-\' : \'+\'" ></span>\n                                        </button>\n                                    </td> --><td class="td__listViewRow" ng-click="vm.geofencesTable(geofence);" expand><span ng-if="!geofence.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="geofence.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{geofence.name}}</td><td>{{geofence.description}}</td><td>{{geofence.parentGeofence[0].nameType}}</td><td>{{geofence.geofenceType}}</td><td><div class="action"><a ui-sref="geofence-detail({id:geofence.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="geofence.edit({id:geofence.id})" class="action-icons text-primary" title="Edit" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER"><span class="fa fa-pencil-square"></span> </a><!-- <a ng-if="geofence.geofenceType == \'MINI\'" ng-click="vm.sendAssetLinkRequest(geofence.id,geofence.name)"\n                                                class="action-icons text-info" title="Send Asset Link Request">\n                                                <span class="fa fa-link"></span>\n                                            </a> --></div></td></tr><tr ng-show="geofence.isExpanded"><td></td><td colspan="13"><table class="table__userNames"><thead><th></th><th>UserNames</th></thead><tbody><tr ng-repeat="users in vm.geofenceChildUsers"><td>{{}}</td><td>{{users.login}}</td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.geofences == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="map-view" ng-show="isSet(2)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas1" style="height:{{mapHeight}}px; width:100%"></div></div></div></div></div></div></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" id="field_pinLat" ng-model="vm.getLocationCoordinate" required></div></div><!-- <div class="form-group">\n                        <label class="col-md-3 control-label">\n                            <span translate=" ">Longitude :</span>\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\n                        </label>\n                        <div class="col-md-8">\n                            <input type="number" class="form-control" placeholder="enter the co-ordinates" name="pinLat" id="field_pinLat"\n                                ng-model="vm.pinLatLong" required />\n                        </div>\n                    </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute()">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">OK</button></div></form></div></div></div><div id="mapFilterGeofenceModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done" ng-show="vm.userGeofences.length >= 1"><span class="span__title" ng-show="vm.userGeofences.length >= 1">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveGeofenceFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div class="modal fade" id="mappingFixed" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.mappingFixed()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Map Fixed Assets to Spread</span></div><div class="modal-body"><b>Are you sure you want to Map Fixed Asset to Spread Asset in {{vm.geoName}} Geofence ?</b></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.mappingFixed()">No</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.postRequest()">Yes</button></div></div></div></div>');
$templateCache.put('app/entities/location-log/location-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.locationLog.id)"><div class="modal-header bg-primary"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body text-center"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.locationLog.delete.question" translate-values="{id: \'{{vm.locationLog.id}}\'}">Are you sure you want to delete this Location Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/location-log/location-log-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.locationLog.detail.title">Location Log</span> {{vm.locationLog.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.locationLog.latitude">Latitude</span></dt><dd><span>{{vm.locationLog.latitude}}</span></dd><dt><span translate="trakeyeApp.locationLog.longitude">Longitude</span></dt><dd><span>{{vm.locationLog.longitude}}</span></dd><dt><span translate="trakeyeApp.locationLog.address">Address</span></dt><dd><span>{{vm.locationLog.address}}</span></dd><dt><span translate="trakeyeApp.locationLog.logSource">Log Source</span></dt><dd><span translate="{{\'trakeyeApp.LogSource.\' + vm.locationLog.logSource}}">{{vm.locationLog.logSource}}</span></dd><dt><span translate="trakeyeApp.locationLog.createdDateTime">Created Date Time</span></dt><dd><span>{{vm.locationLog.createdDateTime | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.locationLog.user">User</span></dt><dd>{{vm.locationLog.userId}}</dd></dl><div class="box-buttons pull-right"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="location-log-detail.edit({id:vm.locationLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/location-log/location-log-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header bg-primary"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLocationLogLabel" translate="trakeyeApp.locationLog.home.createOrEditLabel">Create or edit a Location Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.locationLog.id"><label class="col-md-3 control-label" for="id" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.locationLog.id" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.locationLog.latitude" for="field_latitude">Latitude</label><div class="col-md-8"><input type="number" class="form-control" name="latitude" id="field_latitude" ng-model="vm.locationLog.latitude" required><div ng-show="editForm.latitude.$invalid"><p class="help-block" ng-show="editForm.latitude.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.latitude.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.locationLog.longitude" for="field_longitude">Longitude</label><div class="col-md-8"><input type="number" class="form-control" name="longitude" id="field_longitude" ng-model="vm.locationLog.longitude" required><div ng-show="editForm.longitude.$invalid"><p class="help-block" ng-show="editForm.longitude.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.longitude.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.locationLog.address" for="field_address">Address</label><div class="col-md-8"><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.locationLog.address"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.locationLog.logSource" for="field_logSource">Log Source</label><div class="col-md-8"><select class="form-control" name="logSource" ng-model="vm.locationLog.logSource" id="field_logSource" required><option value="NP" translate="trakeyeApp.LogSource.NP">NP</option><option value="GPS" translate="trakeyeApp.LogSource.GPS">GPS</option></select><div ng-show="editForm.logSource.$invalid"><p class="help-block" ng-show="editForm.logSource.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/location-log/location-logs.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-map-marker"></i> <span translate="trakeyeApp.locationLog.home.title">Live Monitoring</span></h3></div><!-- <div class="box-tools" has-authority="ROLE_USER">\n\t\t\t\t\t\t  <button class="btn btn-create" ui-sref="location-log.new" >\n\t\t\t                    <span class="glyphicon glyphicon-plus"></span>\n\t\t\t                    <span  translate="trakeyeApp.locationLog.home.createLabel">\n\t\t\t                        Create Location Log\n\t\t\t                    </span>\n\t\t\t                </button>\n\t\t\t\t\t</div>\t--><!-- <div class="col-md-4 headerTab">\n\t\t\t\t\t\t<ul class="nav nav-pills nav-justified">\n\t\t\t\t\t\t\t<li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-map"></i><span class="header-view">Map</span> <span class="header_view">View</span></a></li>\n\t\t\t\t\t\t\t<li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2);" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div> --></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 search-top pull-right" ng-show="isSet(2)"><div class="input-group"><input type="text" ng-model="users" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="Search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 dropFilter" ng-show="isSet(1)"><!-- <button type="button" class="btn btn-info btn-flat"\n\t\t\t\t\t\t\t\tng-click="vm.filterAssetsLocationOnMapView()">\n\t\t\t\t\t\t\t\t<i class="fa fa-filter"></i>\n\t\t\t\t\t\t\t</button> --><div isteven-multi-select input-model="vm.allGeofences" output-model="vm.selectedGeofence" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceMapview()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofence" name="vm.searchMini" style="display:none" required></div><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(1)"><select id="searchOnMap" class="select2 form-control" name="search"><option value="">Search Vehicle</option><option ng-repeat="item in vm.vehicles" value="{{item}}">{{item.licenseplate}}</option></select></div><div class="col-md-3 search-top pull-right" ng-show="isSet(1)" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n\t\t\t\t\t\t\t|| has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT"><div class="input-group"><input type="text" ng-model="vm.searchUser" class="form-control" placeholder="Search User"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterUsers()"><i class="fa fa-search"></i></button></span></div></div></div><!-- map view start--><div class="row mt-5" ng-show="isSet(1)"><div class="mt-5"><div class="col-md-9" ng-if="has_ROLE_USER_ADMIN"><a ng-click="vm.all()" class="btn btn-md" ng-class="{\'btn-info\':vm.selectedLogs==\'ALL\',\'btn-default\':vm.selectedLogs!=\'ALL\'}"><i class="fa text-info fa-map-marker"></i> All : {{alllength}} users</a> <a ng-click="vm.active()" class="btn btn-md" ng-class="{\'btn-success\':vm.selectedLogs==\'ACTIVE\',\'btn-default\':vm.selectedLogs!=\'ACTIVE\'}"><i class="fa text-success fa-map-marker"></i> Active : {{activelength}} users</a> <a ng-click="vm.inactive()" class="btn btn-md" ng-class="{\'inactive-bg\':vm.selectedLogs==\'INACTIVE\',\'btn-default\':vm.selectedLogs!=\'INACTIVE\'}"><i class="fa inactive fa-map-marker"></i> Inactive : {{inactivelength}} users</a> <a ng-click="vm.idle()" class="btn btn-md" ng-class="{\'btn-warning\':vm.selectedLogs==\'IDLE\',\'btn-default\':vm.selectedLogs!=\'IDLE\'}"><i class="fa fa-map-marker yellow"></i> Idle : {{idlelength}} users</a></div></div><div class="col-md-12 mt-5"><div id="map_canvas" style="height:{{mapHeight}}px; width:100%;"></div><div class="pull-right"><span id="myspan">ZOOM : 14</span></div></div></div><!-- map view end--><!-- List view start --><div class="list-view" ng-show="isSet(2)"><div class="table-responsive mt-5"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span translate="trakeyeApp.locationLog.firstname">First Name</span></th><th><span translate="trakeyeApp.locationLog.lastname">Last Name</span></th><th><span translate="trakeyeApp.locationLog.login">User</span></th><th><span translate="trakeyeApp.locationLog.address">Address</span></th></tr></thead><tbody><tr ng-repeat="locationLog in locations | filter : users  track by locationLog.userid"><td>{{locationLog.firstName}}</td><td>{{locationLog.lastName}}</td><td>{{locationLog.login}}</td><td>{{locationLog.address}}</td></tr></tbody></table></div><!--<div class="row">\n\t\t\t\t\t\t\t<div class="col-md-4">\n\t\t\t\t\t\t\t\t<div class="count-length">\n\t\t\t\t\t\t\t\t\t<jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="col-md-8">\n\t\t\t\t\t\t\t\t<div class="pagination-list pull-right">\n\t\t\t\t\t\t\t\t\t<uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\t\t\t\t\t\n\t\t\t\t\t\t</div>--></div><!-- list view end --></div></div></div></div><!-- \t<div class="row">\n\t\t<div class="col-md-12">\n\t\t\t<div class="box box-info">\n\t\t\t\t <div class="box-header">\n\t\t\t\t\t<h3 class="box-title"></h3>\n\t\t\t\t</div>\n\t\t\t\t  <div class="box-body">\n\t\t\t\t\t<div class="table-responsive">\t\t\t\t\t \n\t\t\t\t  <table class="jh-table table table-responsive table-hover">\n\t\t\t\t\t<thead class="bg-default">\n\t\t\t\t\t\t <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n\t\t                    <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n\t\t                    <th jh-sort-by="latitude"><span translate="trakeyeApp.locationLog.latitude">Latitude</span> <span class="fa fa-sort"></span></th>\n\t\t                    <th jh-sort-by="longitude"><span translate="trakeyeApp.locationLog.longitude">Longitude</span> <span class="fa fa-sort"></span></th>\n\t\t                    <th jh-sort-by="address"><span translate="trakeyeApp.locationLog.address">Address</span> <span class="fa fa-sort"></span></th>\n\t\t                    <th jh-sort-by="logSource"><span translate="trakeyeApp.locationLog.logSource">Log Source</span> <span class="fa fa-sort"></span></th>\n\t\t                    <th jh-sort-by="createdDateTime"><span translate="trakeyeApp.locationLog.createdDateTime">Created Date Time</span> <span class="fa fa-sort"></span></th>\n\t\t                    <th jh-sort-by="createdDateTime"><span>Updated Date Time</span> <span class="fa fa-sort"></span></th>\n\t\t                    <th jh-sort-by="userId"><span translate="trakeyeApp.locationLog.user">User</span> <span class="fa fa-sort"></span></th>\n\t\t                    <th>Actions</th>\n\t\t                </tr>\n\t\t            </thead>\n\t\t            <tbody>\n\t\t                <tr ng-repeat="locationLog in vm.locationLogs | filter : users  track by locationLog.id">\n\t\t                    <td><a ui-sref="location-log-detail({id:locationLog.id})">{{locationLog.id}}</a></td>\n\t\t                    <td>{{locationLog.latitude}}</td>\n\t\t                    <td>{{locationLog.longitude}}</td>\n\t\t                    <td>{{locationLog.address}}</td>\n\t\t                    <td translate="{{\'trakeyeApp.LogSource.\' + locationLog.logSource}}">{{locationLog.logSource}}</td>\n\t\t                    <td>{{locationLog.createdDateTime | date:\'medium\'}}</td>\n\t\t                    <td>{{locationLog.updatedDateTime | date:\'medium\'}}</td>\n\t\t                    <td>\n\t\t                        {{locationLog.userName}}\n\t\t                    </td>\n\t\t                    <td>\n\t\t                        <div class="actions">\n\t\t                            <a type="submit"\n\t\t                                    ui-sref="location-log-detail({id:locationLog.id})"\n\t\t                                    class="btn btn-info btn-sm" ng-if="has_ROLE_USER">\n\t\t                                <span class="glyphicon glyphicon-eye-open"></span>\n\t\t                            </a>\n\t\t                            <a type="submit"\n\t\t                                    ui-sref="location-log.edit({id:locationLog.id})"\n\t\t                                    class="btn btn-primary btn-sm" ng-if="has_ROLE_USER">\n\t\t                                <span class="glyphicon glyphicon-pencil"></span>\n\t\t                            </a>\n\t\t                            \n\t\t                        </div>\n\t\t                    </td>\n\t\t                </tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>--><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" id="field_pinLat" ng-model="vm.getLocationCoordinate" required></div></div><!--  <div class="form-group">\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\n\t\t\t\t\t\t\t\t<span translate=" ">Longitude :</span>\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-8">\n\t\t\t\t\t\t\t\t<input type="number" class="form-control" placeholder="enter the co-ordinates" name="pinLat" id="field_pinLat"\n\t\t\t\t\t\t\t\t\tng-model="vm.pinLatLong" required />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">OK</button></div></form><!-- <form ng-show="isSet(3)" name="editForm" role="form" class="form-horizontal" novalidate\n\t\t\t\t\tng-submit="vm.showZoomLocationCity()" show-validation>\n\t\t\t\t\t<div class="modal-body">\n\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\n\t\t\t\t\t\t\t\t<span translate=" ">Pin Lat</span>\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-8">\n\t\t\t\t\t\t\t\t<input type="number" class="form-control" name="pinLat" id="field_pinLat"\n\t\t\t\t\t\t\t\t\tng-model="vm.pinLatitude" required />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\n\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\n\t\t\t\t\t\t\t\t<span translate=" ">Pin Long</span>\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-8">\n\t\t\t\t\t\t\t\t<input type="number" class="form-control" name="pinLat" id="field_pinLat"\n\t\t\t\t\t\t\t\t\tng-model="vm.pinLatLong" required />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="modal-footer">\n\t\t\t\t\t\t<button type="button" class="btn btn-default" data-dismiss="modal"\n\t\t\t\t\t\t\tng-click="vm.closeGotoLatituteCity()">\n\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">\n\t\t\t\t\t\t\tOK\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</form> --></div></div></div><!-- Modal --><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div--travelMap"><!-- Modal content--><div class="modal-content"><div class="modal-header modal-info"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="reset()"><span aria-hidden="true">&times;</span></button><!-- <button type="button" class="close" ng-click="reset()" data-dismiss="modal">&times;</button> --> <span class="span__modal-header">{{vm.userPathName}} - Travel Path</span> <button type="button" class="btn btn-info btn-flat" ng-click="vm.downloadLoadPath()" style="margin-left: 1%;padding: 4px 6px;"><i class="fa fa-download"></i> KML</button></div><div class="modal-body"><div class="rows"><div class="col-md-12"><label class="col-sm-2 control-label">Date Range :</label><div class="col-sm-3"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange()">Today</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" ng-click="vm.customRange()" value="custom">Custom Date</label></div><div class="form-group" ng-show="vm.dateRange == \'custom\'"><div class="col-md-3"><!-- <label class="control-label">From\n\t\t\t\t\t\t\t\t\t :</label> --><!-- \t<input type="date" class=" form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required/> --><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')">From <i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_serviceDate" type="text" class="form-control" name="fromDate" ng-model="vm.fromDate" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.fromDate" enable-time="false" datepicker-options="options" required></div><span id="noData" ng-show="vm.fromDate == null">*select from date</span></div><div class="col-md-3"><!-- <label class="control-label location_labels"\n\t\t\t\t\t\t\t\t>To :</label> --><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')">To <i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_toDate" type="text" class="form-control" name="toDate" ng-model="vm.toDate" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.toDate" enable-time="false" datepicker-options="options" required></div><span id="noData" ng-show="vm.toDate == null">*select to date</span></div><div class="col-md-1"><button type="button" class="btn btn-info btn-flat" ng-click="vm.onChangeDate()">OK</button></div></div></div><div class="col-md-12 mt-5"><form class=""><!-- <label class="control-label col-md-1 location_labels" >Total Distance : {{vm.totalDistance}} KM </label> --><!-- <label class="control-label col-md-2 location_labels"></label> --><div class="col-md-3 dropFilter dropFilterWidth pull-right"><!-- <button type="button" class="btn btn-info btn-flat button--filter"\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.filterAssetsLoadOnMapView()">\n\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-filter"></i>\n\t\t\t\t\t\t\t\t\t\t</button> --><div isteven-multi-select input-model="vm.assetFilterGeofences" output-model="vm.selectedGeofencePath" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceTravelledPath()" max-height="150px"></div><input type="text" ng-model="vm.selectedGeofencePath" name="vm.searchMini" style="display:none" required></div><div class="col-md-3"><label class="control-label">Total Distance : {{vm.totalDistance}} Km</label><br><label class="control-label">{{totalDistanceTravelled}}</label><br><label class="control-label">Processing : {{vm.inProgressDistance}} Km</label></div></form></div></div><!-- <div class="row">\n\t\t\t\t\t\t<label class="control-label col-md-4 location_labels" >Total Distance : {{vm.totalDistance}} KM</label>\n\t\t\t\t\t\t<label class="control-label col-md-6 location_labels">{{totalDistanceTravelled}}</label>\n\t\t\t\t\t</div> --><div class="row"><div class="col-md-12"><div id="userPath_map_canvas"></div><span class="pull-right" id="userpathzoom">ZOOM :</span></div></div></div></div></div></div><div id="mapFilterLocationModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapLocationFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveLocationFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.allGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.allGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="mapFilterLoadPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">User Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapLoadPathFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select User Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveLoadPathFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal"><div class="row"><span id="noData" ng-show="vm.assetFilterGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.assetFilterGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedUserGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div>');
$templateCache.put('app/entities/group-type/group-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.groupType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.groupType.delete.question" translate-values="{id: \'{{vm.groupType.id}}\'}">Are you sure you want to delete this Group Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/group-type/group-type-detail.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate="trakeyeApp.groupType.detail.title">Group Type</span> - {{vm.groupType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.groupType.name">Name</span></dt><dd><span>{{vm.groupType.name}}</span></dd><dt><span translate="trakeyeApp.groupType.description">Description</span></dt><dd><span>{{vm.groupType.description}}</span></dd><dt ng-show="{{vm.groupType.colorcode != null}}"><span translate="trakeyeApp.groupType.colorcode">Colorcode</span></dt><dd ng-show="{{vm.groupType.colorcode != null}}"><span><div class="square" style="background-color: {{vm.groupType.colorcode}}"></div></span></dd><dt ng-show="{{vm.groupType.image != null}}"><span translate="trakeyeApp.groupType.groupimage">Group Image</span></dt><dd ng-show="{{vm.groupType.image != null}}"><div class="col-md-3"><img class="img-responsive img__assetImage" ng-src="data:image/jpeg;base64,{{vm.groupType.image}}"></div></dd><dt><span translate="trakeyeApp.groupType.createDate">Create Date</span></dt><dd><span>{{vm.groupType.createDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.groupType.updateDate">Update Date</span></dt><dd><span>{{vm.groupType.updateDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.groupType.user">User</span></dt><dd><span>{{vm.groupType.createdBy}}</span></dd><div class="form-group div__attribute" ng-repeat="item in vm.groupType.groupTypeAttributes"><dt><span translate="trakeyeApp.groupType.attribute">Attribute</span><span> {{$index + 1}}</span></dt><div class="col-md-6"><span>{{item.name}}</span><span class="span__attribute">{{item.defaultValue}}</span></div></div></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="group-type-detail.edit({id:vm.groupType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/group-type/group-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.groupType.id" translate="trakeyeApp.groupType.home.create">Create</span> <span ng-if="vm.groupType.id" translate="trakeyeApp.groupType.home.edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.groupType.name" for="field_name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><input type="text" id="xyz" class="form-control" name="name" id="field_name" ng-model="vm.groupType.name" required ng-minlength="3" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.groupType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.groupType.description"></textarea></div></div><div class="form-group caseType_repeat" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.groupType.attribute">Attribute</span><span> {{$index + 1}}</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><label class="col-md-1 control-label"><span translate="trakeyeApp.groupType.dataType">Data Type</span><span> {{$index + 1}}</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customGroupTypeAttributes track by item.id"></select></div><label class="col-md-2 control-label"><span translate="trakeyeApp.groupType.defaultValue">Dafault Value</span><span> {{$index + 1}}</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01" required> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/" required> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" required> <select ng-model="item.defaultValue" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="group-type"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/group-type/group-types.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-suitcase"></i> <span translate="trakeyeApp.groupType.home.title">Group Types</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="group-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.groupType.home.createLabel">Create new Group Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.groupType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> \n\t\t\t\t\t\t\t\t\t\t<span class="fa fa-sort"></span></th>--><th jh-sort-by="name"><span translate="trakeyeApp.groupType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.groupType.description">Description</span><span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.groupType.user">User</span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="groupType in vm.groupTypes track by groupType.id "><!-- <td><a ui-sref="group-type-detail({id:groupType.id})">{{groupType.id}}</a></td> --><td>{{groupType.name}}</td><td>{{groupType.description}}</td><td>{{groupType.createdBy}}</td><td><div class="action"><a ui-sref="group-type-detail({id:groupType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="group-type.edit({id:groupType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.groupTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tenant/tenant-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tenant.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.tenant.delete.question" translate-values="{id: \'{{vm.tenant.id}}\'}">Are you sure you want to delete this Tenant?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tenant/tenant-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.tenant.detail.title">Tenant</span> - {{vm.tenant.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.tenant.organization">Organization</span></dt><dd><span>{{vm.tenant.organization}}</span></dd><dt><span translate="trakeyeApp.tenant.loginName">Login Name</span></dt><dd><span>{{vm.tenant.loginName}}</span></dd><dt><span translate="trakeyeApp.tenant.email">Email</span></dt><dd><span>{{vm.tenant.email}}</span></dd><dt><span translate="trakeyeApp.tenant.phone">Phone</span></dt><dd><span>{{vm.tenant.phone}}</span></dd><dt><span translate="trakeyeApp.tenant.city">City</span></dt><dd><span>{{vm.tenant.city}}</span></dd><dt><span translate="trakeyeApp.tenant.address">Address</span></dt><dd><span>{{vm.tenant.address}}</span></dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tenant-detail.edit({id:vm.tenant.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div><!-- <div>\n    <h2><span translate="trakeyeApp.tenant.detail.title">Tenant</span> {{vm.tenant.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span translate="trakeyeApp.tenant.organization">Organization</span></dt>\n        <dd>\n            <span>{{vm.tenant.organization}}</span>\n        </dd>\n        <dt><span translate="trakeyeApp.tenant.loginName">Login Name</span></dt>\n        <dd>\n            <span>{{vm.tenant.loginName}}</span>\n        </dd>\n        <dt><span translate="trakeyeApp.tenant.email">Email</span></dt>\n        <dd>\n            <span>{{vm.tenant.email}}</span>\n        </dd>\n        <dt><span translate="trakeyeApp.tenant.phone">Phone</span></dt>\n        <dd>\n            <span>{{vm.tenant.phone}}</span>\n        </dd>\n        <dt><span translate="trakeyeApp.tenant.city">City</span></dt>\n        <dd>\n            <span>{{vm.tenant.city}}</span>\n        </dd>\n        <dt><span translate="trakeyeApp.tenant.address">Address</span></dt>\n        <dd>\n            <span>{{vm.tenant.address}}</span>\n        </dd>\n        <dt><span translate="trakeyeApp.tenant.createdDate">Created Date</span></dt>\n        <dd>\n            <span>{{vm.tenant.createdDate}}</span>\n        </dd>\n        <dt><span translate="trakeyeApp.tenant.updatedDate">Updated Date</span></dt>\n        <dd>\n            <span>{{vm.tenant.updatedDate}}</span>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span>\n    </button>\n\n    <button type="button" ui-sref="tenant-detail.edit({id:vm.tenant.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm" translate="entity.action.edit"> Edit</span>\n    </button>\n</div> -->');
$templateCache.put('app/entities/tenant/tenant-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myUserLabel"><span ng-if="!vm.tenant.id" translate="trakeyeApp.tenant.home.create">Create</span> <span ng-if="vm.tenant.id" translate="trakeyeApp.tenant.home.edit">Edit</span></h3></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tenant.id"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-7"><input type="text" class="form-control" id="id" name="id" ng-model="vm.tenant.id" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.tenant.organization">Organization</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="organization" id="field_organization" ng-model="vm.tenant.organization" ng-required ng-minlength="3" ng-maxlength="50" ng-pattern="/^[a-zA-Z0-9]*$/"><div ng-show="editForm.organization.$invalid"><p class="help-block" ng-show="editForm.organization.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.organization.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.organization.$error.pattern" translate="entity.validation.pattern">This field should follow pattern "^[a-zA-Z0-9]*$".</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.tenant.loginName">Login Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="loginName" id="field_loginName" ng-model="vm.tenant.loginName" ng-minlength="3" ng-maxlength="50" ng-pattern="/^[a-zA-Z0-9]*$/" ng-readonly="vm.tenant.id" ng-required><div ng-show="editForm.loginName.$invalid"><p class="help-block" ng-show="editForm.loginName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.loginName.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.loginName.$error.pattern" translate="entity.validation.pattern">This field should follow pattern "/^[a-zA-Z0-9]*$/".</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.tenant.email">Email</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.tenant.email" ng-pattern="EMAIL_REGEXP" ng-required ng-maxlength="100" ng-readonly="vm.tenant.id"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.tenant.phone">Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.tenant.phone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required><p class="help-block" ng-show="editForm.phone.$error.maxlength" translate="global.messages.validate.phone.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.phone.$error.minlength" translate="global.messages.validate.phone.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.phone.$error.pattern" translate="global.messages.validate.phone.invalid">Your phone number is invalid.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span ttranslate="trakeyeApp.tenant.city">City</span></label><div class="col-md-7"><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.tenant.city"></div></div><div class="form-group"><label class="col-md-3 control-label"><span ttranslate="trakeyeApp.tenant.address">Address</span></label><div class="col-md-7"><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.tenant.address"></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button class="btn btn-default btn-sm" ui-sref="tenant"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div><!-- <form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myTenantLabel" translate="trakeyeApp.tenant.home.createOrEditLabel">Create or edit a Tenant</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.tenant.id">\n            <label for="id" translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.tenant.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" translate="trakeyeApp.tenant.organization" for="field_organization">Organization</label>\n            <input type="text" class="form-control" name="organization" id="field_organization"\n                    ng-model="vm.tenant.organization"\n                    required ng-minlength="3" ng-maxlength="50" ng-pattern="/^[a-zA-Z0-9]*$/" />\n            <div ng-show="editForm.organization.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.organization.$error.required" translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.organization.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">\n                    This field is required to be at least 3 characters.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.organization.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">\n                    This field cannot be longer than 50 characters.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.organization.$error.pattern" translate="entity.validation.pattern" translate-value-pattern="^[a-zA-Z0-9]*$">\n                    This field should follow pattern "^[a-zA-Z0-9]*$".\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label" translate="trakeyeApp.tenant.loginName" for="field_loginName">Login Name</label>\n            <input type="text" class="form-control" name="loginName" id="field_loginName"\n                    ng-model="vm.tenant.loginName"\n                    required ng-minlength="3" ng-maxlength="50" ng-pattern="/^[a-zA-Z0-9]*$/" />\n            <div ng-show="editForm.loginName.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.loginName.$error.required" translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.loginName.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">\n                    This field is required to be at least 3 characters.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.loginName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">\n                    This field cannot be longer than 50 characters.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.loginName.$error.pattern" translate="entity.validation.pattern" translate-value-pattern="^[a-zA-Z0-9]*$">\n                    This field should follow pattern "^[a-zA-Z0-9]*$".\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label" translate="trakeyeApp.tenant.email" for="field_email">Email</label>\n            <input type="text" class="form-control" name="email" id="field_email"\n                    ng-model="vm.tenant.email" ng-pattern="EMAIL_REGEXP"\n                     />\n            <div ng-show="editForm.email.$invalid">\n\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t   ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength"\n\t\t\t\t\t\t\t\t   translate-value-max="100">\n\t\t\t\t\t\t\t\t\tThis field cannot be longer than 100 characters.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p class="help-block"\n\t\t\t\t\t\t\t\t   ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">\n\t\t\t\t\t\t\t\t\tYour e-mail is invalid.\n\t\t\t\t\t\t\t\t</p>  \n\t\t\t\t\t\t\t</div>         \n        </div>\n        <div class="form-group">\n            <label class="control-label" translate="trakeyeApp.tenant.phone" for="field_phone">Phone</label>\n            <input type="text" class="form-control" name="phone" id="field_phone"\n                    ng-model="vm.tenant.phone"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" translate="trakeyeApp.tenant.city" for="field_city">City</label>\n            <input type="text" class="form-control" name="city" id="field_city"\n                    ng-model="vm.tenant.city"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" translate="trakeyeApp.tenant.address" for="field_address">Address</label>\n            <input type="text" class="form-control" name="address" id="field_address"\n                    ng-model="vm.tenant.address"\n                     />\n        </div>\n       <div class="form-group">\n            <label class="control-label" translate="trakeyeApp.tenant.createdDate" for="field_createdDate">Created Date</label>\n            <input type="number" class="form-control" name="createdDate" id="field_createdDate"\n                    ng-model="vm.tenant.createdDate"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" translate="trakeyeApp.tenant.updatedDate" for="field_updatedDate">Updated Date</label>\n            <input type="number" class="form-control" name="updatedDate" id="field_updatedDate"\n                    ng-model="vm.tenant.updatedDate"\n                     />\n        </div>  \n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span>\n        </button>\n    </div>\n</form>\n -->');
$templateCache.put('app/entities/tenant/tenants.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-user"></span> <span translate="trakeyeApp.tenant.home.title">Tenants</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="tenant.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.tenant.home.createLabel">Create Tenant</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-2 pull-right"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_]{3,}$/" placeholder="{{\'trakeyeApp.tenant.home.search\' | translate}}" aria-invalid="false"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="organization"><span translate="trakeyeApp.tenant.organization">Organization</span> <span class="fa fa-sort"></span></th><th jh-sort-by="loginName"><span translate="trakeyeApp.tenant.loginName">Login Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="email"><span translate="trakeyeApp.tenant.email">Email</span> <span class="fa fa-sort"></span></th><th jh-sort-by="phone"><span translate="trakeyeApp.tenant.phone">Phone</span> <span class="fa fa-sort"></span></th><th jh-sort-by="city"><span translate="trakeyeApp.tenant.city">City</span> <span class="fa fa-sort"></span></th><th jh-sort-by="address"><span translate="trakeyeApp.tenant.address">Address</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="tenant in vm.tenants   | filter :search track by tenant.id"><td><a ui-sref="tenant-detail({id:tenant.id})">{{tenant.id}}</a></td><td>{{tenant.organization}}</td><td>{{tenant.loginName}}</td><td>{{tenant.email}}</td><td>{{tenant.phone}}</td><td>{{tenant.city}}</td><td>{{tenant.address}}</td><td><div class="actions"><a ui-sref="tenant-detail({id:tenant.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="tenant.edit({id:tenant.id})" class="actions-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><!--<a ui-sref="tenant.delete({id:tenant.id})"\n\t\t\t\t\t                                class="action-icons text-danger">\n\t\t\t\t\t                            <span class="fa fa-times-circle"></span>\n\t\t\t\t\t                        </a>--></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.tenants == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\n    <h2 translate="trakeyeApp.tenant.home.title">Tenants</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="tenant.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span  translate="trakeyeApp.tenant.home.createLabel">\n                        Create new Tenant\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="organization"><span translate="trakeyeApp.tenant.organization">Organization</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="loginName"><span translate="trakeyeApp.tenant.loginName">Login Name</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="email"><span translate="trakeyeApp.tenant.email">Email</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="phone"><span translate="trakeyeApp.tenant.phone">Phone</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="city"><span translate="trakeyeApp.tenant.city">City</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="address"><span translate="trakeyeApp.tenant.address">Address</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="createdDate"><span translate="trakeyeApp.tenant.createdDate">Created Date</span> <span class="fa fa-sort"></span></th>\n                    <th jh-sort-by="updatedDate"><span translate="trakeyeApp.tenant.updatedDate">Updated Date</span> <span class="fa fa-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="tenant in vm.tenants track by tenant.id">\n                    <td><a ui-sref="tenant-detail({id:tenant.id})">{{tenant.id}}</a></td>\n                    <td>{{tenant.organization}}</td>\n                    <td>{{tenant.loginName}}</td>\n                    <td>{{tenant.email}}</td>\n                    <td>{{tenant.phone}}</td>\n                    <td>{{tenant.city}}</td>\n                    <td>{{tenant.address}}</td>\n                    <td>{{tenant.createdDate}}</td>\n                    <td>{{tenant.updatedDate}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="tenant-detail({id:tenant.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm" translate="entity.action.view"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="tenant.edit({id:tenant.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="tenant.delete({id:tenant.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div> -->');
$templateCache.put('app/entities/service-type/service-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceType.id)"><div class="modal-body text-center mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.serviceType.delete.question" translate-values="{id: \'{{vm.serviceType.id}}\'}">Are you sure you want to delete this Service Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-type/service-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.serviceType.detail.title">Service Type</span> {{vm.serviceType.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.serviceType.name">Name</span></dt><dd><span>{{vm.serviceType.name}}</span></dd><dt><span translate="trakeyeApp.serviceType.description">Description</span></dt><dd><span>{{vm.serviceType.description}}</span></dd><dt><span translate="trakeyeApp.serviceType.createdDate">Created Date</span></dt><dd><span>{{vm.serviceType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.serviceType.updatedDate">Updated Date</span></dt><dd><span>{{vm.serviceType.updatedDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.serviceType.user">User</span></dt><dd>{{vm.serviceType.createdBy}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="service-type.edit({id:vm.serviceType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/service-type/service-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span ng-if="!vm.serviceType.id" translate="trakeyeApp.serviceType.home.create">Create</span> <span ng-if="vm.serviceType.id" translate="trakeyeApp.serviceType.home.Edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group" ng-show="vm.serviceType.id">\n\t\t\t\t\t\t\t<label class="col-md-2 control-label" for="id" translate="global.field.id">ID</label>\n\t\t\t\t\t\t\t<div class="col-md-8">\n\t\t\t\t\t\t\t\t <input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceType.id" readonly>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.serviceType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.serviceType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.serviceType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.serviceType.description"></textarea></div></div><!--  <div class="form-group" ng-repeat="item in vm.items">\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-3">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" placeholder="item{{$index + 1}}"   required id="field_key" name="field" ng-readonly="item.name == \'SLA\'"  ng-model="item.name">\n\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.value">Value</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-3">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_value" name="field"  ng-model="item.value"  required>\n\t\t\t\t\t\t\t</div>   \n\t\t\t\t\t\t\t<div class="col-md-2 mt-5">\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\n\t\t\t\t\t\t\t\t  </button>\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\n\t\t\t\t\t\t\t\t  </button>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>             \n\t\t\t\t\t\t</div> --><!-- <div class="form-group" ng-repeat="item in vm.items">\n\t\t\t\t\t       \n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.dataType">Data Type</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null"  ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\n\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in attributetypes">{{atttype }} \n\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.value">Dafault Value</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType == \'\'" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'INTEGER\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'STRING\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required >\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType == \'BOOLEAN\'" class="form-control select2" >\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\n\t\t\t\t\t\t\t   </select>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t\n       \n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\n\t\t\t\t\t\t\t\t  </button>\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>             \n\t\t\t\t\t\t</div>\t --><div class="form-group caseType_repeat" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.serviceType.home.attribute">Attribute</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><label class="col-md-1 control-label"><span translate="trakeyeApp.serviceType.home.dataType">Data Type</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customServiceTypeAttributes track by item.id"></select></div><label class="col-md-2 control-label"><span translate="trakeyeApp.serviceType.home.value">Dafault Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="number" ng-if="item.attributeDataType.name == \'\'" class="form-control" id="field_value" name="types" ng-model="item.value"> <input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/" required> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" required> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select><!-- <select ng-model="item.value"  ng-if="item.dataType == \'BOOLEAN\'" class="form-control select2" >\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\n\t\t\t\t\t\t\t   </select> --></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="service-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/service-type/service-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-paper-plane"></span> <span translate="trakeyeApp.serviceType.home.title">Case Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="service-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.serviceType.home.createLabel">Create Service Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.serviceType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.serviceType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.serviceType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.serviceType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="serviceType in vm.serviceTypes | filter :search track by serviceType.id"><!--  <td><a ui-sref="service-type-detail({id:serviceType.id})">{{serviceType.id}}</a></td> --><td>{{serviceType.name}}</td><td>{{serviceType.description}}</td><!--  <td>\n\t\t\t\t                        {{serviceType.createdBy}}\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="service-type-detail({id:serviceType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a type="submit" ui-sref="service-type.edit({id:serviceType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.serviceTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-case/show-hide-case.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-check-square-o"></i> <span translate=" ">Show/Hide Case</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-2 control-label"><span>Enter Case Id</span></label><div class="col-sm-4"><input type="number" ng-model="vm.caseId" ng-pattern="/^[0-9]*$/" required></div></div><div class="col-sm-3 td__noDataAvailable" ng-if="vm.status == 200" ng-hide="vm.status == 0"><h3>Case Updated successfully</h3><i class="fa fa-check main-content__checkmark fs9_cG"></i></div><div class="col-sm-3 td__noDataAvailable" ng-if="vm.status != 200" ng-hide="vm.status == 0"><h3>Please Enter Valid CaseId</h3><i class="fa fa-times main-content__checkmark fs9_cR"></i></div></div><div class="col-md-12 box-footer"><div class="col-md-2"><button class="btn btn-primary" ng-disabled="reportForm.$invalid" ng-click="vm.showCase()">Show Case <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div><div class="col-md-2"></div><div class="col-md-2"><button class="btn btn-primary" ng-disabled="reportForm.$invalid" ng-click="vm.hideCase()">Hide Case <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trCase.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this case needs to be deleted before deleting case</p><p translate="trakeyeApp.trCase.delete.question" translate-values="{id: \'{{vm.trCase.id}}\'}">Are you sure you want to delete this Tr Case?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-case/tr-case-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.trCase.detail.title">Tr Case</span> {{vm.trCase.id}}</h3><button class="btn btn-primary btn-sm pull-right" ng-click="showCaseImages()" style="margin-left: 8px;">Show Images</button> <button class="btn btn-primary btn-sm pull-right" ng-click="vm.openPdfAttachments()" style="margin-left: 8px;">Show Attachments</button></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt ng-show="vm.trCase.caseAssets.length"><span>Asset Name</span></dt><dd ng-show="vm.trCase.caseAssets.length"><span class="node" ui-sref="asset-detail({id:vm.trCase.caseAssets[0].id})">{{vm.trCase.caseAssets[0].name}}</span></dd><dt><span translate="trakeyeApp.trCase.description">Description</span></dt><dd><span>{{vm.trCase.description}}</span></dd><dt><span translate="trakeyeApp.trCase.status">Status</span></dt><dd><!-- <span translate="{{\'trakeyeApp.CaseStatus.\' + vm.trCase.status}}">{{vm.trCase.status}}</span> --> <span>{{vm.trCase.status}}</span></dd><!-- <dt><span translate="trakeyeApp.trCase.escalated">Escalated</span></dt>\n\t\t\t\t\t\t<dd>\n\t\t\t\t\t\t\t<span ng-if="vm.trCase.escalated">YES</span>\n\t\t\t\t\t\t\t<span ng-if="!vm.trCase.escalated">NO</span>\n\t\t\t\t\t\t</dd> --><dt><span translate="trakeyeApp.trCase.verified">Verified</span></dt><dd><span ng-if="vm.trCase.verified">YES</span> <span ng-if="!vm.trCase.verified">NO</span></dd><dt><span translate="trakeyeApp.trCase.address">Address</span></dt><dd><span>{{vm.trCase.address}}</span><!-- <a ui-sref="case-type-detail({id:vm.trCase.address})">{{vm.trCase.address}}</a> --></dd><dt><span>Pin Lat</span></dt><dd><span>{{vm.trCase.pinLat}}</span><!-- <a ui-sref="case-type-detail({id:vm.trCase.address})">{{vm.trCase.address}}</a> --></dd><dt><span>Pin Long</span></dt><dd><span>{{vm.trCase.pinLong}}</span><!-- <a ui-sref="case-type-detail({id:vm.trCase.address})">{{vm.trCase.address}}</a> --></dd><dt><span translate="trakeyeApp.trCase.assignedTo">Assigned To</span></dt><dd>{{vm.trCase.assignedToUser}}</dd><dt><span translate="trakeyeApp.trCase.reportedBy">Reported By</span></dt><dd>{{vm.trCase.reportedByUser}}</dd><dt><span translate="trakeyeApp.trCase.updatedBy">Updated By</span></dt><dd>{{vm.trCase.updatedByUser}}</dd><dt><span translate="trakeyeApp.trCase.assignedBy">Assigned By</span></dt><dd>{{vm.trCase.assignedByUser}}</dd><dt><span>Viewed By</span></dt><dd>{{vm.trCase.updatedByUser}}</dd><dt><span>Case Number</span></dt><dd>{{vm.trCase.caseNumber}}</dd><dt><span translate="trakeyeApp.trCase.createDate">Create Date</span></dt><dd><span>{{vm.trCase.createDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trCase.updateDate">Update Date</span></dt><dd><span>{{vm.trCase.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trCase.caseType">Case Type</span></dt><dd ng-if="has_ROLE_USER_ADMIN"><!--  <a ui-sref="case-type-detail({id:vm.trCase.caseType.id})">{{vm.trCase.caseType.name}}</a> --> {{vm.trCase.caseType.name}}</dd><dd ng-if="has_ROLE_USER">{{vm.trCase.caseType.name}}</dd><!--  <dt><span translate="trakeyeApp.trCase.pinLat">Pin Lat</span></dt>\n\t\t\t\t\t        <dd>\n\t\t\t\t\t            <span>{{vm.trCase.pinLat}}</span>\n\t\t\t\t\t        </dd>\n\t\t\t\t\t        <dt><span translate="trakeyeApp.trCase.pinLong">Pin Long</span></dt>\n\t\t\t\t\t        <dd>\n\t\t\t\t\t            <span>{{vm.trCase.pinLong}}</span>\n\t\t\t\t\t        </dd> --><div class="form-group" ng-repeat="attribute in vm.trCase.caseTypeAttributeValues"><!-- <dt><span >{{attribute.caseTypeAttribute.name}}</span></dt>\n\t\t\t\t\t\t\t\t<dd>\n\t\t\t\t\t\t\t\t\t<span >{{vm.trCase.caseTypeAttributeValues[$index].attributeValue}}</span></dt>\n\t\t\t\t\t\t\t\t</dd> --><div ng-repeat="attributeValue in vm.trCase.caseTypeAttributeValues track by $index"><div ng-if="attributeValue.caseTypeAttribute.id == attribute.caseTypeAttribute.id"><dt><span>{{attribute.caseTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div><hr><!--  <dt><span translate="trakeyeApp.trCase.caseImages">Case Images</span></dt> --><dt ng-if="vm.trCase.caseType.name == \'Splicing Details\'"><div class="col-md-2"><a class="btn btn-sm btn-primary" ng-click="toggle(\'cable\')"><span ng-hide="vm.showCable">Show Cable Details</span> <span ng-show="vm.showCable">Hide Cable Details</span></a></div></dt><dd ng-if="cableDetails"><div class="form-group pull-left"><div class="row"><div class="col-md-12"><table class="jh-table table table-responsive table-hover"><tr><th>Cable Name</th><th>JE Availability</th><th>Cable Capacity</th><th>Drum Number</th><th>From Direction</th><th>Approx Loop Length</th></tr><tr ng-repeat="list in vm.trCase.cableDetails"><td>{{list.cableName}}</td><td>{{list.jeAvailability}}</td><td>{{list.cableCapacity}}</td><td>{{list.drumNumber}}</td><td>{{list.fromDirection}}</td><td>{{list.approxLoopLength}}</td></tr></table></div></div></div></dd><dt ng-if="vm.trCase.caseType.name == \'Splicing Details\'"><div class="col-md-2"><a class="btn btn-sm btn-primary" ng-click="toggle(\'splicing\')"><span ng-hide="vm.showSplicing">Show Splicing Details</span> <span ng-show="vm.showSplicing">Hide Splicing Details</span></a></div></dt><dd ng-if="splicingDetails"><div class="form-group pull-left"><div class="row"><div class="col-md-12"><table class="jh-table table table-responsive table-hover"><tr><th>JE Number</th><th>Cable A Side</th><th>Tube A Side</th><th>Core A Start</th><th>Core A End</th><th>Cable B Side</th><th>Tube B Side</th><th>Core B Start</th><th>Core B End</th><th>Number of Splice</th><th>Utilization</th></tr><tr ng-repeat="list in vm.trCase.splicingDetails"><td>{{list.jeNumber}}</td><td>{{list.fromFiber.cableSide}}</td><td>{{list.fromFiber.tubeSide}}</td><td>{{list.fromFiber.coreStart}}</td><td>{{list.fromFiber.coreEnd}}</td><td>{{list.toFiber.cableSide}}</td><td>{{list.toFiber.tubeSide}}</td><td>{{list.toFiber.coreStart}}</td><td>{{list.toFiber.coreEnd}}</td><td>{{list.numberOfSplice}}</td><td>{{list.utilization}}</td></tr></table></div></div></div></dd><dt ng-if="vm.trCase.caseType.name == \'Termination Details\'"><div class="col-md-2"><a class="btn btn-sm btn-primary" ng-click="toggle(\'fms\')"><span ng-hide="vm.showFMS">Show FMS & Cable Details</span> <span ng-show="vm.showFMS">Hide FMS & Cable Details</span></a></div></dt><dd ng-if="fmsDetails"><div class="form-group"><div class="row"><div class="col-md-12" style="overflow-x: scroll;"><table class="jh-table table table-responsive table-hover"><tr><th>FMS Number</th><th>FMS Capacity</th><th>Cable Number A Side</th><th>Drum Number A Side</th><th>Cable Number B Side</th><th>Drum Number B Side</th><th>From Chamber ID / Location for C1</th><th>To Chamber ID / Location for C2</th></tr><tr ng-repeat="list in vm.trCase.fmsAndCableDetails"><td>{{list.fmsNumber}}</td><td>{{list.fmsCapacity}}</td><td>{{list.sideACable.cableNumber}}</td><td>{{list.sideACable.drumNumber}}</td><td>{{list.sideBCable.cableNumber}}</td><td>{{list.sideBCable.drumNumber}}</td><td>{{list.fromChamberId}}</td><td>{{list.toChamberId}}</td></tr></table></div></div></div></dd><dt ng-if="vm.trCase.caseType.name == \'Termination Details\'"><div class="col-md-2"><a class="btn btn-sm btn-primary" ng-click="toggle(\'termination\')"><span ng-hide="vm.showTermination">Show Termination Details</span> <span ng-show="vm.showTermination">Hide Termination Details</span></a></div></dt><dd ng-if="terminationDetails"><div class="form-group"><div class="row"><div class="col-md-12" style="overflow-x: scroll;"><table class="jh-table table table-responsive table-hover"><tr><th>FMS</th><th>Type</th><th>Port Number Start</th><th>Port Number End</th><th>Cable Number A Side</th><th>Core Number A Side Start</th><th>Core Number A Side End</th><th>Number of Splice</th><th>Port used for</th><th>Cable Number B Side</th><th>Core Number B Side Start</th><th>Core Number B Side End</th></tr><tr class="ws-nowrap" ng-repeat="list in vm.trCase.terminationDetails"><td>{{list.fms}}</td><td>{{list.type}}</td><td>{{list.portNumberStart}}</td><td>{{list.portNumberEnd}}</td><td>{{list.sideACable.cableNumber}}</td><td>{{list.sideACable.coreNumberStart}}</td><td>{{list.sideACable.coreNumberEnd}}</td><td>{{list.numberOfSplice}}</td><td>{{list.portUsedFor}}</td><td>{{list.sideBCable.cableNumber}}</td><td>{{list.sideBCable.coreNumberStart}}</td><td>{{list.sideBCable.coreNumberEnd}}</td></tr></table></div></div></div></dd><!-- <dt>\n\t\t\t\t\t\t\t\t<div class="col-md-2 trCase_showImgDiv" ng-if="vm.trCase.id">\n\t\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')">\n\t\t\t\t\t\t\t\t\t\t<span ng-hide="vm.showImages">Show Images</span>\n                                <span ng-show="vm.showImages">Hide Images</span></a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</dt> --><dd ng-if="allimages"><div class="form-group"><div class="row"><div class="col-md-8"><div class="col-md-3" ng-repeat="img in vm.caseImages"><img ng-if="img.image != null" class="img-responsive img__img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" ng-click="vm.imageInNewTab(img.image)"><br><span class="fs_s" ng-show="img.imgDescription != null"><b>Description :</b> {{img.imgDescription}}</span><br><span class="fs_s" ng-show="img.imgLat != null && img.imgLong != null"><b>LatLng :</b> {{img.imgLat}},{{img.imgLong}}</span></div></div></div></div></dd><!-- <dt>\n\t\t\t\t\t\t\t\t<div class="col-md-2 trCase_showImgDiv" ng-if="vm.trCase.id && vm.showCaseAttachment">\n\t\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'pdf\')">\n\t\t\t\t\t\t\t\t\t\t<span ng-hide="vm.showPdf">Show Attachments</span>\n                                <span ng-show="vm.showPdf">Hide Attachments</span></a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</dt> --><!-- <div >\n\t\t\t\t\t\t\t\t<div class="col-md-3" ng-repeat="img in vm.trCase.caseImages ">\n\t\t\t\t\t\t\t\t <img class="img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" style="padding-bottom: 10px;"> \n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t        </div> --><!-- \t\t\t\t\t\t\t\t\t<button id="audioplay" ng-click="playAudio()">Play</button> --><!-- <dd ng-if="allpdf">\n\t\t\t\t\t\t\t\t<div class="form-group" >\n\t\t\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t\t\t<h4 class="box-title" style="text-align:unset">\n\t\t\t\t\t\t\t\t\t\t\t<span> Attachments</span\n\t\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t<div class="table-scroll" style="\n\t\t\t\t\t\t\t\t\t\theight: max-content;\n\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\t\t\t\t\tclass="form-group"\n\t\t\t\t\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t\t<table class="jh-table table table-responsive table-hover">\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Name</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Type</th>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr ng-repeat="image in vm.attachments">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-show="image.imageName != null" ng-click="newTabDisplay(image.imageId)" style="\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: #3c8dbc;\n\t\t\t\t\t\t\t\t\t\t\t\t">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{image.imageName}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-show="image.imageName != null">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{image.imageType}}\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</dd> --></dl><div id="audioLayout"></div><div class="box-buttons pull-right"><a href="javascript:void(0);" ui-sref="tr-case" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-case.edit({id:vm.trCase.id})" class="btn btn-primary btn-sm" ng-hide="has_ROLE_VENDOR && vm.trCase.caseType.name!=\'Vendor Civil Work\' || hideCaseEditBtn"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div><div class="modal fade" id="mediaCarouselModal" tabindex="-1" role="dialog"><div class="modal-dialog modal-lg" id="mediaModalDialog" role="document"><div class="modal-content"><div class="modal-header ml-3" style="display: flex;"><div class="carousel-downloads"><button ng-show="vm.showdownloadButton" class="btn btn-primary btn-sm" ng-click="downloadMedia()">Download</button><!-- <button ng-show="vm.showdownloadButton" class="btn btn-primary btn-sm"  ng-click="downloadAllMedia()">Download All</button> --></div><button id="maximizeBtn" type="button" style="border:none" ng-click="vm.toggleMaximize()"><span class="fa fa-window-maximize" aria-hidden="true"></span></button> <button id="minimizeBtn" type="button" style="display:none;border:none" ng-click="vm.toggleMaximize()"><span class="fa fa-window-minimize" aria-hidden="true"></span></button> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="closeModal(\'mediaCarouselModal\')"><span aria-hidden="true">&times;</span></button></div><div id="loading-bar-spinner" style="display: none;"><div class="spinner-icon"></div></div><div class="modal-body text-center"><div class="position-relative d-flex justify-content-center align-items-center"><i class="fa fa-arrow-left nav-button prevs" ng-click="prevMedia()" style="font-size:2rem;cursor:pointer"></i><div id="carouselMediaContainer" class="carousel-displays mx-3"></div><i class="fa fa-arrow-right nav-button nexts" ng-click="nextMedia()" style="font-size:2rem;cursor:pointer"></i></div><div class="thumbnails_container mt-3" style="white-space:nowrap;overflow-x:auto"><div ng-repeat="media in mediaImagesIds track by $index" ng-class="{\'selected-thumbnail\': $index === currentIndex}" style="display:inline-block;margin:5px;cursor:pointer" ng-click="jumpToMedia($index)"><img ng-src="data:image/png;base64,{{media.base64}}" style="width:50px;height:50px;object-fit:cover;border-radius:4px"></div></div></div></div></div></div><div class="modal fade" id="attachmentModal" tabindex="-1"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header" style="height: 10vh;"><h4 class="modal-title">Attachments</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><table class="table table-hover"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.attachments"><td ng-click="newTabDisplay(image.imageId)" style="color:#3c8dbc;cursor:pointer">{{image.imageName}}</td><td>{{image.imageType}}</td></tr></table></div></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><!-- <span ng-if="!vm.trCase.id">Create Case  <span ng-show="!vm.trCase.id && createCaseFromAssetMap.length"><a>\n                                <span ui-sref="asset-detail({id:createCaseFromAssetMap[0].id})" ng-bind="vm.assetNameInCreate">Create</span>\n                            </a></span></span>\n\n                            <span ng-if="vm.trCase.id">Edit Case  <span ng-show="vm.trCase.id && vm.trCase.caseAssets.length"><a>\n                                        <span ui-sref="asset-detail({id:vm.trCase.caseAssets[0].id})" ng-bind="vm.assetName">Edit</span>\n                                    </a></span></span> --> <span ng-if="!vm.trCase.id" translate="trakeyeApp.trCase.home.create">Create</span> <span ng-if="vm.trCase.id" translate="trakeyeApp.trCase.home.EditLabel">Edit</span></h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.trCase.id"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.trCase.id" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.trCase.description">Description</span><!-- <sup\n                                    ><span class="required-icon"\n                                        ><i\n                                            class="fa fa-asterisk text-danger"\n                                        ></i\n                                    ></span>\n                                </sup> --></label><div class="col-md-8"><textarea class="form-control" rows="2" name="description" id="field_description" ng-model="vm.trCase.description" ng-required="true"></textarea></div></div><div class="form-group" ng-show="!vm.trCase.id"><label class="col-md-3 control-label">Select Coordinates</label><div class="col-md-8"><div id="map_canvas" style="height: 300px"></div></div><div class="col-md-1"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnMapView()"><i class="fa fa-filter"></i></button><!-- <button style="color: gray;" type="button" class="btn btn-info btn-flat"\n                                    ng-show="vm.canFilter == false">\n                                    <i class="fa fa-filter"></i>\n                                </button> --></div></div><div class="form-group"><label class="col-md-3 control-label" ng-if="vm.trCase.id"><span translate="trakeyeApp.trCase.pinLat">Pin Lat</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3" ng-if="vm.trCase.id"><input type="number" class="form-control" name="pinLat" id="field_pinLat" ng-model="vm.trCase.pinLat" required readonly="readonly"></div><label class="col-md-2 control-label" ng-if="vm.trCase.id"><span translate="trakeyeApp.trCase.pinLong">Pin Long</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3" ng-if="vm.trCase.id"><input type="number" class="form-control" name="pinLong" id="field_pinLong" ng-model="vm.trCase.pinLong" required readonly="readonly"></div><label class="col-md-3 control-label" ng-if="!vm.trCase.id"><span translate="trakeyeApp.trCase.pinLat">Pin Lat</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3" ng-if="!vm.trCase.id"><input type="number" class="form-control" name="pinLat" id="field_pinLat" ng-model="vm.trCase.pinLat" required></div><label class="col-md-2 control-label" ng-if="!vm.trCase.id"><span translate="trakeyeApp.trCase.pinLong">Pin Long</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3" ng-if="!vm.trCase.id"><input type="number" class="form-control" name="pinLong" id="field_pinLong" ng-model="vm.trCase.pinLong" required></div><div class="col-md-1"><button type="button" class="btn btn-primary btn-sm" ng-disabled="vm.showAddressAddress" ng-click="vm.getAssetAddress()"><span class="fa fa-refresh"></span></button></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.address">Address</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea rows="2" class="form-control" name="address" id="field_address" ng-model="vm.trCase.address" readonly="readonly" required></textarea></div></div><!-- <div class="form-group">\n                            <label\n                                class="col-md-3 control-label"\n                                translate="trakeyeApp.trCase.escalated"\n                                for="field_escalated"\n                                >Escalated</label\n                            >\n                            <div class="col-md-8">\n                                <input\n                                    type="checkbox"\n                                    class="checkbox"\n                                    name="escalated"\n                                    id="field_escalated"\n                                    ng-model="vm.trCase.escalated"\n                                    ng-true-value="true"\n                                    ng-false-value="false"\n                                />\n                            </div>\n                        </div> --><div class="form-group" ng-if="has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_CITY_PLANNER"><label class="col-md-3 control-label" translate="trakeyeApp.trCase.verified" for="field_verified">Verified</label><div class="col-md-8"><input type="checkbox" class="checkbox" name="verified" id="field_verified" ng-model="vm.trCase.verified" ng-true-value="true" ng-false-value="false"></div></div><div class="form-group" ng-if="vm.trCase.id && !has_ROLE_FRT && !has_ROLE_PATROLLER"><label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.trCase.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.trCase.status" id="field_status" required><option value="NEW" translate="trakeyeApp.CaseStatus.NEW">NEW</option><option value="INPROGRESS" translate="trakeyeApp.CaseStatus.INPROGRESS">IN PROGRESS</option><option value="PENDING" translate="trakeyeApp.CaseStatus.PENDING">PENDING</option><option value="ASSIGNED" translate="trakeyeApp.CaseStatus.ASSIGNED">ASSIGNED</option><option value="RESOLVED" translate="trakeyeApp.CaseStatus.RESOLVED">RESOLVED</option><option value="CANCELLED" translate="trakeyeApp.CaseStatus.CANCELLED">CANCELLED</option><option value="CLOSED" translate="trakeyeApp.CaseStatus.CLOSED">CLOSED</option><!-- <option value="NEW">New</option>\n                                    <option value="INPROGRESS">ROLL-OUT PHASE</option>\n                                    <option value="PENDING" translate="trakeyeApp.CaseStatus.PENDING">PENDING</option>\n                                    <option value="ASSIGNED" translate="trakeyeApp.CaseStatus.ASSIGNED">ASSIGNED</option>\n                                    <option value="RESOLVED">OPERATION PHASE</option>\n                                    <option value="CANCELLED" translate="trakeyeApp.CaseStatus.CANCELLED">CANCELLED</option> --></select></div></div><div class="form-group row"><div class="col-md-3 control-label"><span translate="trakeyeApp.trCase.group">Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3"><div isteven-multi-select input-model="vm.multiGroup" output-model="vm.trCase.groups" button-label="name" item-label="name" tick-property="ticked" output-properties="id selected" selection-mode="single" on-item-click="vm.callGroup()"></div><!-- <input type="text" ng-model="vm.trCase.groups" name="group" style="display:none" /> --> <span id="noData" ng-if="vm.trCase.groups.length == 0">**Please Select Group</span> <input type="text" ng-model="vm.trCase.groups" name="group" style="display: none" required></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER || (has_ROLE_NETWORK_ENGINEER && vm.caseType.name != \'Vendor Civil Work\')"><label class="col-md-3 control-label" for="field_assignedTo"><span translate="trakeyeApp.trCase.assignedTo">Assigned To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input list="userslist" class="form-control" id="field_assignedToUser" placeholder="Search user login name" type="text" ng-model="vm.trCase.assignedToUser" autocomplete="off" name="assignedToUser" ng-change="vm.filterActivatedUser()" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER || (has_ROLE_NETWORK_ENGINEER && vm.caseType.name != \'Vendor Civil Work\')" required><datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1"><option ng-repeat="user in\n                                        vm.activatedusers" value="{{user.login}}"></option></datalist><span id="noData" ng-if="vm.trCase.assignedToUser == null">**Please Select</span></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.caseType">caseType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="caseType" ng-model="vm.caseType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\n                                    vm.caseTypes track by item.id" ng-disabled="vm.trCase.id!=null" required style="width: 100%"><option value="" translate="trakeyeApp.trCase.selectcase">--- Select CaseType ---</option></select></div></div><!-- <div class="form-group">\n                            <label class="col-md-3 control-label" for="field_asset">\n\t\t            \t<span  translate="trakeyeApp.trCase.asset">Asset</span>\n\t\t            </label>\n                            <div class="col-md-8">\n                                <input list="assetlist" class="form-control" id="asset_list" placeholder="Search Asset" type="text" ng-model="vm.trCase.asset.name" autocomplete="off" name="assetList" ng-change="vm.filterAssetsList()">\n                                <datalist ng-hide="vm.assetList" id="assetlist" class="form-control1">\t\t            \n\t\t\t\t\t\t\t<option ng-repeat="asset in vm.assetList" value="{{asset.name}}"/>\n\t           \t\t\t \t\n\t\t            </datalist>\n                            </div> --></div><div class="form-group" ng-repeat="attribute in\n                        vm.trCase.caseTypeAttributeValues" ng-class="{\n                        \'has-error\' : userIntForm.value.$invalid }"><label class="col-md-3 control-label" ng-show="((!vm.trCase.id && (attribute.caseTypeAttribute.caseCategory==\'CATEGORY1\'||attribute.caseTypeAttribute.caseCategory==\'DEFAULT\'||attribute.caseTypeAttribute.caseCategory==null))\n                            ||(vm.trCase.id && ((vm.prevStatus!=\'ASSIGNED\' && vm.prevStatus==\'NEW\') || (vm.prevStatus!=\'NEW\' && vm.prevStatus==\'ASSIGNED\')) && (attribute.caseTypeAttribute.caseCategory==\'CATEGORY1\'||attribute.caseTypeAttribute.caseCategory==\'DEFAULT\'||attribute.caseTypeAttribute.caseCategory==null))\n                            ||(vm.trCase.id && vm.prevStatus!=\'ASSIGNED\' && vm.prevStatus!=\'NEW\') || (vm.trCase.id && vm.prevStatus==\'ASSIGNED\' && has_ROLE_FRT && vm.trCase.caseType.name==\'Incident Management\'))\n                            ||(vm.trCase.id && vm.prevStatus==\'ASSIGNED\' && (vm.trCase.caseType.name!=\'Issue on Field\' && vm.trCase.caseType.name!=\'Asset Safety Related\' && vm.trCase.caseType.name!=\'Productivity & NTP\' && vm.trCase.caseType.name!=\'PM Activity\' && vm.trCase.caseType.name!=\'UG OH Declaration\' && vm.trCase.caseType.name!=\'Fiber Provisioning\' && vm.trCase.caseType.name!=\'Chamber Declaration\' && vm.trCase.caseType.name!=\'Vendor Civil Work\' && vm.trCase.caseType.name!=\'Incident Management\'))"><span>{{attribute.caseTypeAttribute.name}} </span><sup><span class="required-icon" ng-show="attribute.caseTypeAttribute.mandatory == true"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8" ng-repeat="attributeValue in\n                            vm.trCase.caseTypeAttributeValues track by $index" ng-show="((!vm.trCase.id && (attribute.caseTypeAttribute.caseCategory==\'CATEGORY1\'||attribute.caseTypeAttribute.caseCategory==\'DEFAULT\'||attribute.caseTypeAttribute.caseCategory==null))\n                            ||(vm.trCase.id && ((vm.prevStatus!=\'ASSIGNED\' && vm.prevStatus==\'NEW\') || (vm.prevStatus!=\'NEW\' && vm.prevStatus==\'ASSIGNED\')) && (attribute.caseTypeAttribute.caseCategory==\'CATEGORY1\'||attribute.caseTypeAttribute.caseCategory==\'DEFAULT\'||attribute.caseTypeAttribute.caseCategory==null))\n                            ||(vm.trCase.id && vm.prevStatus!=\'ASSIGNED\' && vm.prevStatus!=\'NEW\') || (vm.trCase.id && vm.prevStatus==\'ASSIGNED\' && has_ROLE_FRT && vm.trCase.caseType.name==\'Incident Management\'))\n                            ||(vm.trCase.id && vm.prevStatus==\'ASSIGNED\' && (vm.trCase.caseType.name!=\'Issue on Field\' && vm.trCase.caseType.name!=\'Asset Safety Related\' && vm.trCase.caseType.name!=\'Productivity & NTP\' && vm.trCase.caseType.name!=\'PM Activity\' && vm.trCase.caseType.name!=\'UG OH Declaration\' && vm.trCase.caseType.name!=\'Fiber Provisioning\' && vm.trCase.caseType.name!=\'Chamber Declaration\' && vm.trCase.caseType.name!=\'Vendor Civil Work\' && vm.trCase.caseType.name!=\'Incident Management\'))"><div ng-if=" attributeValue.caseTypeAttribute.id==attribute.caseTypeAttribute.id"><input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                    == \'FLOAT\' && !vm.trCase.id" type="text" class="form-control" ng-init="attributeValue.attributeValue=\n                                    attribute.caseTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                    == \'FLOAT\' && vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <span ng-if="attribute.caseTypeAttribute.dataType\n                                    == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                    == \'INTEGER\' && !vm.trCase.id" type="text" class="form-control" ng-model="attributeValue.attributeValue" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\n                                    attribute.caseTypeAttribute.value" oninput="this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\');"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                    == \'INTEGER\' && vm.trCase.id" type="text" class="form-control" ng-model="attributeValue.attributeValue" name="value{{$index+1}}" oninput="this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\');"> <span ng-if="attribute.caseTypeAttribute.dataType\n                                    == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Valid Number </span><input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                    == \'STRING\' && !vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\n                                    attribute.caseTypeAttribute.value" ng-model="attributeValue.attributeValue"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                    == \'STRING\' && vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue"> <span ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                    == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Message</span> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                != \'STRING\' &&\n                                attribute.caseTypeAttribute.attributeDataType.name\n                                != \'FLOAT\' &&\n                                attribute.caseTypeAttribute.attributeDataType.name\n                                != \'INTEGER\' && attribute.caseTypeAttribute.attributeDataType.canMultiSelect" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue" readonly="readonly"> <span ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                != \'STRING\' &&\n                                attribute.caseTypeAttribute.attributeDataType.name\n                                != \'FLOAT\' &&\n                                attribute.caseTypeAttribute.attributeDataType.name\n                                != \'INTEGER\' && !vm.trCase.id" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Message</span> <select ng-model="attributeValue.attributeValue" ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                != \'STRING\' &&\n                                attribute.caseTypeAttribute.attributeDataType.name\n                                != \'FLOAT\' &&\n                                attribute.caseTypeAttribute.attributeDataType.name\n                                != \'INTEGER\'&& !attribute.caseTypeAttribute.attributeDataType.canMultiSelect && attribute.caseTypeAttribute.name != \'Ticket Sub Cat\'" class="form-control select2" ng-change="attributeMappingChange(attributeValue)"><!--  --><option value="">-- Select Value --</option><option value="{{atttype.value}}" ng-repeat="atttype in\n                                    vm.customAttributesMap[attribute.caseTypeAttribute.attributeDataType.name]">{{atttype.value}}</option></select> <select ng-model="attributeValue.attributeValue" ng-if="attribute.caseTypeAttribute.attributeDataType.name\n\t\t\t\t\t\t\t                                != \'STRING\' &&\n\t\t\t\t\t\t\t                                attribute.caseTypeAttribute.attributeDataType.name\n\t\t\t\t\t\t\t                                != \'FLOAT\' &&\n\t\t\t\t\t\t\t                                attribute.caseTypeAttribute.attributeDataType.name\n\t\t\t\t\t\t\t                                != \'INTEGER\'&& !attribute.caseTypeAttribute.attributeDataType.canMultiSelect && attribute.caseTypeAttribute.name === \'Ticket Sub Cat\' && vm.trCase.id === null && vm.trCase.caseType.name === \'Asset Safety Related\'" class="form-control select2" ng-change="attributeMappingChange(attributeValue)"><!--  --><option value="">-- Select Value --</option><option value="{{atttype.value}}" ng-repeat="atttype in\n\t\t\t\t\t\t\t                                    vm.customAttributesMap[attribute.caseTypeAttribute.attributeDataType.name]">{{atttype.value}}</option></select> <input ng-model="attributeValue.attributeValue" ng-if="attribute.caseTypeAttribute.attributeDataType.name\n\t\t\t\t\t\t\t     != \'STRING\' &&\n\t\t\t\t\t\t\tattribute.caseTypeAttribute.attributeDataType.name != \'FLOAT\' &&\n\t\t\t\t\t\t\tattribute.caseTypeAttribute.attributeDataType.name != \'INTEGER\'&& !attribute.caseTypeAttribute.attributeDataType.canMultiSelect && \n\t\t\t\t\t\t\tattribute.caseTypeAttribute.name === \'Ticket Sub Cat\' && vm.trCase.id !== null && vm.trCase.caseType.name === \'Asset Safety Related\'" type="text" class="form-control" name="value{{$index+1}}" readonly="readonly"></div></div></div><div class="form-group" ng-show="vm.showCableSplice"><label class="col-md-3 control-label">Cable Details <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="toggle(\'cable\')"><span ng-hide="vm.showCable">Show Cable Details</span> <span ng-show="vm.showCable">Hide Cable Details</span></a></div><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="addDetails(\'cableDetails\')"><span class="fa fa-plus"></span> Add</a></div></div><div class="form-group" ng-if="cableDetails"><div class="row"><div class="col-md-8 col-md-offset-3"><table class="jh-table table table-responsive table-hover" style="margin-left: 17%;\n                        margin-right: auto;"><tr><th>Cable Name</th><th>JE Availability</th><th>Cable Capacity</th><th>Drum Number</th><th>From Direction</th><th>Approx Loop Length</th><th>Actions</th></tr><tr ng-repeat="list in vm.trCase.cableDetails"><td>{{list.cableName}}</td><td>{{list.jeAvailability}}</td><td>{{list.cableCapacity}}</td><td>{{list.drumNumber}}</td><td>{{list.fromDirection}}</td><td>{{list.approxLoopLength}}</td><td><a ng-click="editDetails($index,\'cableDetails\')" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ng-click="removeDetails($index,\'cableDetails\')" class="action-icons text-primary" title="Remove"><span class="fa fa-minus"></span></a></td></tr></table></div></div></div><div class="form-group" ng-show="vm.showCableSplice"><label class="col-md-3 control-label">Splicing Details <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="toggle(\'splicing\')"><span ng-hide="vm.showSplicing">Show Splicing Details</span> <span ng-show="vm.showSplicing">Hide Splicing Details</span></a></div><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="addDetails(\'splicingDetails\')"><span class="fa fa-plus"></span> Add</a></div></div><div class="form-group" ng-if="splicingDetails"><div class="row"><div class="col-md-8 col-md-offset-3"><table class="jh-table table table-responsive table-hover" style="margin-left: 17%;\n                        margin-right: auto;"><tr><th>JE Number</th><th>Cable A Side</th><th>Tube A Side</th><th>Core A Start</th><th>Core A End</th><th>Cable B Side</th><th>Tube B Side</th><th>Core B Start</th><th>Core B End</th><th>Number of Splice</th><th>Utilization</th><th>Actions</th></tr><tr ng-repeat="list in vm.trCase.splicingDetails"><td>{{list.jeNumber}}</td><td>{{list.fromFiber.cableSide}}</td><td>{{list.fromFiber.tubeSide}}</td><td>{{list.fromFiber.coreStart}}</td><td>{{list.fromFiber.coreEnd}}</td><td>{{list.toFiber.cableSide}}</td><td>{{list.toFiber.tubeSide}}</td><td>{{list.toFiber.coreStart}}</td><td>{{list.toFiber.coreEnd}}</td><td>{{list.numberOfSplice}}</td><td>{{list.utilization}}</td><td><a ng-click="editDetails($index,\'splicingDetails\')" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ng-click="removeDetails($index,\'splicingDetails\')" class="action-icons text-primary" title="Remove"><span class="fa fa-minus"></span></a></td></tr></table></div></div></div><div class="form-group" ng-show="vm.showFmsTermination"><label class="col-md-3 control-label">FMS & Cable Details <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="toggle(\'fms\')"><span ng-hide="vm.showFMS">Show FMS & Cable Details</span> <span ng-show="vm.showFMS">Hide FMS & Cable Details</span></a></div><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="addDetails(\'fmsDetails\')"><span class="fa fa-plus"></span> Add</a></div></div><div class="form-group" ng-if="fmsDetails"><div class="row"><div class="col-md-11 col-md-offset-3" style="overflow-x: scroll;"><table class="jh-table table table-responsive table-hover" style="margin-right: auto;"><tr><th>FMS Number</th><th>FMS Capacity</th><th>Cable Number A Side</th><th>Drum Number A Side</th><th>Cable Number B Side</th><th>Drum Number B Side</th><th>From Chamber ID / Location for C1</th><th>To Chamber ID / Location for C2</th><th>Actions</th></tr><tr ng-repeat="list in vm.trCase.fmsAndCableDetails"><td>{{list.fmsNumber}}</td><td>{{list.fmsCapacity}}</td><td>{{list.sideACable.cableNumber}}</td><td>{{list.sideACable.drumNumber}}</td><td>{{list.sideBCable.cableNumber}}</td><td>{{list.sideBCable.drumNumber}}</td><td>{{list.fromChamberId}}</td><td>{{list.toChamberId}}</td><td><a ng-click="editDetails($index,\'fmsDetails\')" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ng-click="removeDetails($index,\'fmsDetails\')" class="action-icons text-primary" title="Remove"><span class="fa fa-minus"></span></a></td></tr></table></div></div></div><div class="form-group" ng-show="vm.showFmsTermination"><label class="col-md-3 control-label">Termination Details <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="toggle(\'termination\')"><span ng-hide="vm.showTermination">Show Termination Details</span> <span ng-show="vm.showTermination">Hide Termination Details</span></a></div><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="addDetails(\'terminationDetails\')"><span class="fa fa-plus"></span> Add</a></div></div><div class="form-group" ng-if="terminationDetails"><div class="row"><div class="col-md-11 col-md-offset-3" style="overflow-x: scroll;"><table class="jh-table table table-responsive table-hover" style="margin-right: auto;"><tr><th>FMS</th><th>Type</th><th>Port Number Start</th><th>Port Number End</th><th>Cable Number A Side</th><th>Core Number A Side Start</th><th>Core Number A Side End</th><th>Number of Splice</th><th>Port used for</th><th>Cable Number B Side</th><th>Core Number B Side Start</th><th>Core Number B Side End</th><th>Actions</th></tr><tr class="ws-nowrap" ng-repeat="list in vm.trCase.terminationDetails"><td>{{list.fms}}</td><td>{{list.type}}</td><td>{{list.portNumberStart}}</td><td>{{list.portNumberEnd}}</td><td>{{list.sideACable.cableNumber}}</td><td>{{list.sideACable.coreNumberStart}}</td><td>{{list.sideACable.coreNumberEnd}}</td><td>{{list.numberOfSplice}}</td><td>{{list.portUsedFor}}</td><td>{{list.sideBCable.cableNumber}}</td><td>{{list.sideBCable.coreNumberStart}}</td><td>{{list.sideBCable.coreNumberEnd}}</td><td><a ng-click="editDetails($index,\'terminationDetails\')" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ng-click="removeDetails($index,\'terminationDetails\')" class="action-icons text-primary" title="Remove"><span class="fa fa-minus"></span></a></td></tr></table></div></div></div><div class="form-group" ng-hide="vm.showCableSplice || vm.showFmsTermination"><label class="col-md-3 control-label" for="field_priority"><span translate="trakeyeApp.trCase.priority">Priority</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="priority" ng-model="vm.trCase.priority" id="field_priority"><option disabled="disabled" selected="selected" value>--- Select Priority ---</option><option value="LOW">LOW</option><option value="MEDIUM">MEDIUM</option><option value="HIGH" selected="selected" value>HIGH</option><option value="CRITICAL">CRITICAL</option></select></div></div><div class="form-group" ng-show="!vm.trCase.id && createCaseFromAssetMap.length"><label class="col-md-3 control-label"><span>Asset Name</span></label><div class="col-md-8 node" ui-sref="asset-detail({id:createCaseFromAssetMap[0].id})"><input type="text" class="form-control node" ng-model="createCaseFromAssetMap[0].name" readonly="readonly"></div></div><div class="form-group" ng-show="vm.trCase.id && vm.trCase.caseAssets.length"><label class="col-md-3 control-label"><span>Asset Name</span></label><div class="col-md-8 node" ui-sref="asset-detail({id:vm.trCase.caseAssets[0].id})"><input type="text" class="form-control node" ng-model="vm.trCase.caseAssets[0].name" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.trCase.caseImages">images</label><div class="col-md-6"><input type="file" name="file" multiple="multiple" class="filestyle" id="caseImages" accept="image/*"> <span id="noData" ng-if="vm.fileWarning">Please upload PNG,JPG/JPEG format with maximum size of 10MB</span></div><div class="col-md-2 caseType_showImg" ng-if="vm.trCase.id"><a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')"><span ng-hide="vm.showImages">Show Images</span> <span ng-show="vm.showImages">Hide Images</span></a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-8 col-md-offset-3"><div class="col-md-3" ng-repeat="img in\n                                    vm.caseImages"><img ng-if="img.image != null" class="img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" ng-click="getImage(img.image)" style="padding-bottom: 10px"> <span ng-show="img.imgDescription != null">Description : {{img.imgDescription}}</span> <span ng-show="img.imgLat != null && img.imgLong != null">LatLng : {{img.imgLat}},{{img.imgLong}}</span></div></div></div></div><div class="form-group" ng-show="vm.trCase.id && vm.showCaseAttachment"><label class="col-md-3 control-label">Attachments</label><div class="col-md-6"><input type="file" name="file" class="filestyle" id="attachmentFile" accept="application/pdf"> <span id="noData" ng-if="vm.fileWarnings">Please upload PDF format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-2 mt-5 caseType_showImg" ng-if="vm.trCase.id"><a class="btn btn-sm btn-primary" ng-click="toggle(\'pdf\')"><span ng-hide="vm.showPdf">Show Attachments</span> <span ng-show="vm.showPdf">Hide Attachments</span></a></div></div><div class="form-group" ng-if="allpdf"><label class="col-md-3 control-label">Attachment Display</label><div class="col-md-6"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\n                        margin-right: auto;"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.attachments"><td ng-show="image.imageName != null" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null">{{image.imageType}}</td></tr></table></div></div><!-- <div class="form-group" ng-if="a">\n                        <label class="col-md-3 control-label" >Selected Images</label>\n                        <div class="col-md-6"> \n                            <table class="jh-table table table-responsive table-hover" \n                        style="margin-left: auto;\n                        margin-right: auto;">\n                            <tr>\n                                <th>Image</th>\n                                <th>Image Name</th>\n                                <th>Delete</th>\n                            </tr>\n                            <tr ng-repeat="img in vm.trCase.caseImages">\n                                <td>\n                                    <img class="img-responsive img__img-responsive"\n                                    ng-src="data:image/jpeg;base64,{{img.image}}" />\n                                </td>\n                                <td>\n                                    {{img.imageName}}\n                                </td>\n                                <td  ng-click="deleteDisplayImage($index)">\n                                    <span class="fa fa-trash-o" style="\n                                    color: red"></span>\n                                </td>\n                            </tr>\n                        </table>\n                        </div>\n                    </div> --><div><div class="col-md-2"></div><div class="col-md-6"><div class="btn btn-create btn-sm" ng-if="vm.trCase.asset"><a style="margin-bottom: 10px; color: white" ng-click="openAssetMapModal()">Show Map</a></div></div></div><!-- <div ng-show="vm.ugAlertGreen" class="col-md-12"> \n                        <span class="ugAlertGreen"> <i class=\'fa fa-check-circle\'></i> No existing assets nearby</span>\n                    </div> --><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-case"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button ng-hide="vm.saveHide" type="submit" ng-disabled="editForm.$invalid\n                                || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button><!-- <button\n                                ng-show="vm.existingAsset"\n                                type="button"\n                                ng-disabled="editForm.$invalid\n                                || vm.isSaving"\n                                class="btn btn-info btn-flat"\n                                ng-click="vm.showExisting()"\n                            >\n                                <span\n                                    >Check for Existing Assets</span\n                                >\n                            </button> --><!-- <button type="submit" ng-disabled="editForm.$invalid\n                                || vm.isSaving" class="btn btn-primary btn-sm"\n                                ng-if="!vm.trCase.id || (vm.trCase.id && !has_ROLE_FRT && !has_ROLE_PATROLLER)">\n                                <span class="glyphicon glyphicon-save"></span>\n                                <span translate="entity.action.save">Save</span>\n                            </button> --><!-- <button ng-disabled="editForm.$invalid\n                                || vm.isSaving" class="btn btn-primary btn-sm" ng-click="vm.submit()"\n                                ng-if="vm.trCase.id">\n                                <span class="glyphicon glyphicon-save"></span>\n                                <span>Submit</span>\n                            </button> --></div></div></div></form></div></div></div><div id="assetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%; height: 580px; padding-top: 7px" class="modal-body"><div class="row"><div class="col-md-12 modal_body_map"><div class="location-map-assets"><div style="width: 100%;\n                                    height: 510px;\n                                    display: inline-block;" id="map_canvas_assets"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><div id="mapFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 70%" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Assets Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal(\'mapFilterModal\')"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div style="margin-left: 35px"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" style="margin-left: 10px; font-size: medium">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div class="modal fade" id="myModalMap" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div id="imgZoom" style="background: url(\'data:image/jpeg;base64,{{vm.img}}\');"></div></div></div><div id="existingAsset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; height: 30vh" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal(\'existingAsset\')"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Existing Assets</span></div><div style="color: black;\n                    font-weight: bold;\n                    text-align: center;\n                    font-size: larger;" class="modal-body"><div class="row"><div class="col-md-12"><span class="ug-alert"><i class="fa fa-exclamation-circle"></i> There is an existing UG OH asset nearby</span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" ng-click="vm.closeMapFilterModal(\'existingAsset\')"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.showExisting()"><span class="glyphicon glyphicon-save"></span> <span>OK</span></button></div></div></div></div><!-- <div\n    id="handlingError"\n    class="fade modal"\n    role="dialog"\n    data-keyboard="true"\n    tabindex="-1"\n>\n    <div\n        class="modal-dialog modal-fluid"\n        style="width: 40%; height: 30vh"\n        role="document"\n    >\n        \n        <div class="modal-content">\n            <div class="modal-header">\n                 <button\n                    type="button"\n                    class="close"\n                    data-dismiss="modal"\n                    aria-label="Close"\n                    ng-click="vm.closeMapFilterModal(\'handlingError\')"\n                >\n                    <span aria-hidden="true">&times;</span>\n                </button> \n                <span class="span__modal-header">\n                    {{vm.handlingError}} Error\n                </span>\n            </div>\n            <div\n                style="\n                    color: black;\n                    text-align: center;\n                    font-size: larger;\n                "\n                class="modal-body"\n            >\n                <div class="row">\n                    <div  class="col-md-12"> \n                        <span class="ug-alert"> <i class=\'fa fa-exclamation-triangle\'></i> Please verify entered details</span>\n                    </div>\n                </div>\n                \n            </div>\n            <div class="modal-footer">\n                <button\n                    type="button"\n                    class="btn btn-danger btn-sm"\n                    ng-click="vm.closeMapFilterModal(\'handlingError\')"\n                >\n                <span>OK</span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div> --><div id="popupDialogModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; height: 30vh" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Mandatory Attributes</span></div><div style="color: black;\n                    font-weight: bold;\n                    text-align: center;\n                    font-size: larger;" class="modal-body"><div class="row"><span id="alertMessage"></span></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.closePopupDialogModal()"><span>OK</span></button></div></div></div></div><div id="cableDetails" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Cable Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'cableDetails\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.saveDetails(\'cableDetails\')" show-validation><div class="modal-body" style="max-height: 65vh;"><div class="form-group"><label class="col-md-3 control-label"><span for="Cable">Cable Name</span></label><div class="col-md-7"><select class="form-control" name="Cable" ng-model="vm.trCase.cableDetails[vm.selectedCable].cableName"><option value="">Select Value</option><option ng-repeat="item in vm.cableName" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="jeAvailability">JE Availability</span></label><div class="col-md-7"><select class="form-control" name="jeAvailability" ng-model="vm.trCase.cableDetails[vm.selectedCable].jeAvailability"><option value="">Select Value</option><option ng-repeat="item in vm.jeAvailability" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableCapacity">Cable Capacity</span></label><div class="col-md-7"><select class="form-control" name="cableCapacity" ng-model="vm.trCase.cableDetails[vm.selectedCable].cableCapacity"><option value="">Select Value</option><option ng-repeat="item in vm.cableCapacity" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Drum">Drum Number</span></label><div class="col-md-7"><input type="text" class="form-control" name="Drum" ng-model="vm.trCase.cableDetails[vm.selectedCable].drumNumber"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Direction">From Direction</span></label><div class="col-md-7"><input type="text" class="form-control" name="Direction" ng-model="vm.trCase.cableDetails[vm.selectedCable].fromDirection"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Length">Approx Loop Length</span></label><div class="col-md-7"><input type="number" min="0" oninput="this.value = Math.abs(this.value)" class="form-control" name="Length" ng-model="vm.trCase.cableDetails[vm.selectedCable].approxLoopLength"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'cableDetails\')">Cancel</button> <button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div><div id="splicingDetails" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Splicing Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'splicingDetails\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.saveDetails(\'splicingDetails\')" show-validation><div class="modal-body" id="scrollTop" style="max-height: 65vh;\n                overflow: auto;overflow-x: hidden"><div class="form-group"><label class="col-md-3 control-label"><span for="jeNumber">JE Number</span></label><div class="col-md-6"><select class="form-control" name="jeNumber" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].jeNumber"><option value="">Select Value</option><option ng-repeat="item in vm.jeNumber" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableSide">Cable A Side</span></label><div class="col-md-6"><select class="form-control" name="cableSide" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].fromFiber.cableSide"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="tubeSide">Tube A Side</span></label><div class="col-md-6"><select class="form-control" name="tubeSide" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].fromFiber.tubeSide"><option value="">Select Value</option><option ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="CoreStart">Core A Start</span></label><div class="col-md-6"><input type="text" class="form-control" name="CoreStart" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].fromFiber.coreStart"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreEnd">Core A End</span></label><div class="col-md-6"><input type="text" class="form-control" name="coreEnd" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].fromFiber.coreEnd"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableSide">Cable B Side</span></label><div class="col-md-6"><select class="form-control" name="cableSide" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].toFiber.cableSide"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="tubeSide">Tube B Side</span></label><div class="col-md-6"><select class="form-control" name="tubeSide" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].toFiber.tubeSide"><option value="">Select Value</option><option ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreStartb">Core B Start</span></label><div class="col-md-6"><input type="text" class="form-control" name="coreStartb" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].toFiber.coreStart"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreEndb">Core B End</span></label><div class="col-md-6"><input type="text" class="form-control" name="coreEndb" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].toFiber.coreEnd"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="numberOfSplice">Number of Splice</span></label><div class="col-md-6"><input type="number" min="0" oninput="this.value = Math.abs(this.value)" class="form-control" name="numberOfSplice" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].numberOfSplice"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="utilization">Utilization</span></label><div class="col-md-6"><input type="text" class="form-control" name="utilization" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].utilization"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'splicingDetails\')">Cancel</button> <button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div><div id="fmsDetails" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">FMS & Cable Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'fmsDetails\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.saveDetails(\'fmsDetails\')" show-validation><div class="modal-body" id="scrollTop" style="max-height: 65vh;\n                overflow: auto;overflow-x: hidden"><div class="form-group"><label class="col-md-3 control-label"><span for="fmsNumber">FMS Number</span></label><div class="col-md-6"><select class="form-control" name="fmsNumber" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].fmsNumber"><option value="">Select Value</option><option ng-repeat="item in vm.fmsNumber" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Capacity">FMS Capacity</span></label><div class="col-md-6"><select class="form-control" name="Capacity" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].fmsCapacity"><option value="">Select Value</option><option ng-repeat="item in vm.fmsCapacity" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Number1">Cable Number A Side</span></label><div class="col-md-6"><select class="form-control" name="Number1" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].sideACable.cableNumber"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Drum1">Drum Number A Side</span></label><div class="col-md-6"><input type="text" class="form-control" name="Drum1" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].sideACable.drumNumber"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Number2">Cable Number B Side</span></label><div class="col-md-6"><select class="form-control" name="Number2" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].sideBCable.cableNumber"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Drum2">Drum Number B Side</span></label><div class="col-md-6"><input type="text" class="form-control" name="Drum2" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].sideBCable.drumNumber"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="From">From Chamber ID / Location for C1</span></label><div class="col-md-6"><input type="text" class="form-control" name="From" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].fromChamberId"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="To">To Chamber ID / Location for C2</span></label><div class="col-md-6"><input type="text" class="form-control" name="To" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].toChamberId"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'fmsDetails\')">Cancel</button> <button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div><div id="terminationDetails" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Termination Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'terminationDetails\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.saveDetails(\'terminationDetails\')" show-validation><div class="modal-body" id="scrollTop" style="max-height: 65vh;\n                overflow: auto;overflow-x: hidden"><div class="form-group"><label class="col-md-3 control-label"><span for="FMS">FMS</span></label><div class="col-md-6"><select class="form-control" name="FMS" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].fms"><option value="">Select Value</option><option ng-repeat="item in vm.fms" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Type">Type</span></label><div class="col-md-6"><select class="form-control" name="Type" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].type"><option value="">Select Value</option><option ng-repeat="item in vm.type" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Port">Port Number Start</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="Port" id="field_name" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portNumberStart"></div><!-- <div class="col-md-6">\n                                <select class="form-control" name="Port" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portNumberStart"  \n                                >\n                                <option  value="">Select Value</option>\n                                <option  ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select>\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="PortEnd">Port Number End</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="PortEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portNumberEnd"></div><!-- <div class="col-md-6">\n                                <select class="form-control" name="PortEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portNumberEnd"  \n                                >\n                                <option  value="">Select Value</option>\n                                <option  ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select>\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableNumber1">Cable Number A Side</span></label><div class="col-md-6"><select class="form-control" name="cableNumber1" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.cableNumber"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreStart">Core Number A Side Start</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="coreStart" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.coreNumberStart"></div><!-- <div class="col-md-6">\n                                <select class="form-control" name="coreStart" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.coreNumberStart"  \n                                >\n                                <option  value="">Select Value</option>\n                                <option  ng-repeat="item in vm.cableNumber" value="{{item.configKey}}">{{item.configValue}}</option></select>\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreEnd">Core Number A Side End</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="coreEnd" id="field_name" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.coreNumberEnd"></div><!-- <div class="col-md-6">\n                                <select class="form-control" name="coreEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.coreNumberEnd"  \n                                >\n                                <option  value="">Select Value</option>\n                                <option  ng-repeat="item in vm.cableNumber" value="{{item.configKey}}">{{item.configValue}}</option></select>\n\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="numberOfSplice">Number of Splice</span></label><div class="col-md-6"><input type="number" min="0" oninput="this.value = Math.abs(this.value)" class="form-control" name="numberOfSplice" id="field_name" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].numberOfSplice"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="portUsedFor">Port used for</span></label><div class="col-md-6"><input type="text" class="form-control" name="portUsedFor" id="field_name" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portUsedFor"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableNumber">Cable Number B Side</span></label><div class="col-md-6"><select class="form-control" name="cableNumber" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.cableNumber"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreNumberStart">Core Number B Side Start</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="coreNumberStart" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.coreNumberStart"></div><!-- <div class="col-md-6">\n                                <select class="form-control" name="coreNumberStart" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.coreNumberStart"  \n                                >\n                                <option  value="">Select Value</option>\n                                <option  ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select>\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreNumberEnd">Core Number B Side End</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="coreNumberEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.coreNumberEnd"></div><!-- <div class="col-md-6">\n                                <select class="form-control" name="coreNumberEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.coreNumberEnd"  \n                                >\n                                <option  value="">Select Value</option>\n                                <option  ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select>\n                        </div> --></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'terminationDetails\')">Cancel</button> <button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-fiber-core.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate=" "></span>Fiber Core Map View</h3></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="map-view"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas" style="height:600px; width:100%"></div></div></div></div></div></div></div></div></div><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 50%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">Fiber Core Cable Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="hideEditModal()"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="myEditAssetText"></span></div><div style="width: 100%; height: 500px; padding-top: 7px;" class="modal-body"><div class="row"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label" for="field_Id"><span translate="">Cable Id</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_id" ng-model="vm.cableId" required ng-minlength="3" ng-maxlength="50"></div></div><br><br><div class="form-group"><label class="col-md-3 control-label" for="field_search"><span translate="">Select Cable Type</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><select class="form-control" name="status" ng-model="vm.coreType" id="field_color" required><!-- <option value="blue" translate=" ">All</option> --><option value="blue" translate=" ">{{vm.selectedTube.madalTube.tubeType}}</option><option value="Orange" translate=" ">{{vm.selectedTube.coreTube[0].tubeType}}</option><option value="Green" translate=" ">{{vm.selectedTube.coreTube[1].tubeType}}</option><option value="Brown" translate=" ">{{vm.selectedTube.coreTubeChildA.tubeType}}</option><option value="Slate" translate=" ">{{vm.selectedTube.coreTubeChildB.tubeType}}</option><option value="White" translate=" ">{{vm.selectedTube.coreTubeChildBZ.tubeType}}</option><option value="Red" translate=" ">{{vm.selectedTube.coreTubeChildAZ.tubeType}}</option></select></div></div><br><br><div class="form-group"><label class="col-md-3 control-label" for="field_search"><span translate="">Fiber Core Cable</span></label><div class="col-md-7"><img class="img-responsive col-md-1" ng-show="vm.tube01" ng-src="content/images/tube01.png" ng-click="vm.coreColor()" style="float:left; display: inline-flex; width: 15%; padding:0px; outline:none;"> <img class="img-responsive col-md-1" ng-show="vm.tube02" ng-src="content/images/tube02.png" ng-click="vm.coreColor()" style="float:left; display: inline-flex; width: 13%; padding:0px; outline:none;"> <img class="img-responsive col-md-1" ng-show="vm.tube03" ng-src="content/images/tube03.png" ng-click="vm.coreColor()" style="float:left; display: inline-flex; width: 15%; padding:0px; outline:none;margin-left: 3px;"> <img class="img-responsive col-md-1" ng-show="vm.tube04" ng-src="content/images/tube04.png" ng-click="vm.coreColor()" style="float:left; display: inline-flex; width: 15%; padding:0px; outline:none;margin-left: 3px;"></div></div><br><br><div class="form-group" ng-if="showSelectColor"><label class="col-md-3 control-label" for="field_search"></label><div class="col-md-7" style="text-align: right;"><div style="font-size:14px;margin-right: 17px; color: green;">&#9733; : Used Cables</div><div style="font-size:14px; color: red;">&#9734; : Available Cables</div></div></div><br><br><div class="form-group" ng-if="showSelectColor"><label class="col-md-3 control-label" translate=" " for="field_description">core Colors</label><ol class="col-md-7" type="1" ng-click="vm.closeTubeColors()" style="margin-top: 8px; outline: 1cm;"><li class="rectangle" style="height: 15px;width: 400px;background-color: blue;" ng-if="vm.coreSize > 11"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: orange;" ng-if="vm.coreSize > 10"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: green;" ng-if="vm.coreSize > 9"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: brown;" ng-if="vm.coreSize > 8"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: slategray;" ng-if="vm.coreSize > 7"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color:snow" ng-if="vm.coreSize > 6"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: red;" ng-if="vm.coreSize > 5"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: black;" ng-if="vm.coreSize > 4"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: yellow;" ng-if="vm.coreSize > 3"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: violet;" ng-if="vm.coreSize > 2"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: rosybrown;" ng-if="vm.coreSize > 1"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: aqua;" ng-if="vm.coreSize > 0"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li></ol></div><!-- <div style="height: 40px; width: 98%;" class="col-md-12 modal_body_content">\n                            <button class="btn btn-info btn-flat"\n                                style="float: right; border-radius: 5px; padding: 6px 25px; border: none"\n                                ng-click="saveEditAsset()">\n                                <span><b>Save</b></span>\n                            </button>\n                        </div> --><!-- <div style="height: 40px; width: 98%;" class="col-md-12 modal_body_content">\n                        <button class="btn btn-info btn-flat" style="float: right; border-radius: 5px; padding: 6px 25px; border: none"\n                            ng-click="EditAsset()">\n                            <span><b>Edit</b></span>\n                        </button>\n                    </div> --></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-import.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i>Import Cases</h3><div class="box-tools ng-scope"><button class="btn btn-create"><span class="fa fa-download"></span> <a href="content/images/SampleCases.xlsx" download id="a__text">Sample File</a></button></div></div><!-- /.box-header --><!-- form start --><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file accept="*.xlsx||*.xls" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel file should be uploaded</p></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-work-flow.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.trCase.id">Create Work Flow</span> <span ng-if="vm.trCase.id" translate="trakeyeApp.trCase.home.EditLabel">Edit</span></h3></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-8"><button type="button" ng-click="setTab(1)" ng-class="{\'btn-primary\' : vm.toggleFirst, \'btn-default\':!vm.toggleFirst }" style="width: 30%; height: 40px;"><span>Work Flow Details</span></button> <button type="button" ng-disabled="editForm.$invalid ||  vm.isSaving" ng-click="setTab(2)" ng-class="{\'btn-primary\' : vm.toggleSecond, \'btn-default\': !vm.toggleSecond}" style="width: 30%; height: 40px;"><span>Plan Activity</span></button> <button type="button" ng-disabled="editForm.$invalid || vm.isShowing" ng-click="setTab(3)" ng-class="{\'btn-primary\' :vm.toggleThird, \'btn-default\': !vm.toggleThird}" style="width: 30%; height: 40px;"><span>Save Work Flow</span></button></div><div class="pull-right" ng-show="isSet(2)" style="margin-right:15px;margin-left:5px;"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.refreshPage()"><span class="fa fa-refresh"></span></button></div><div class="pull-right" ng-show="isSet(2) && vm.mappedAssetsList.length > 1" style="margin-left:5px;"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.connectSelectedAssets()"><span><b>Connect Two Assets<b></b></b></span></button></div></div></div><br><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.trCase.id" ng-show="isSet(1)"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.trCase.id"></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.trCase.description">Description</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea class="form-control" rows="2" name="description" id="field_description" ng-model="vm.trCase.description" required></textarea></div></div><div class="form-group" ng-if="vm.trCase.id" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.trCase.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.trCase.status" id="field_status" required><!-- <option value="NEW" translate="trakeyeApp.CaseStatus.NEW">NEW</option>\n                                    <option value="INPROGRESS" translate="trakeyeApp.CaseStatus.INPROGRESS">IN PROGRESS</option>\n                                    <option value="PENDING" translate="trakeyeApp.CaseStatus.PENDING">PENDING</option>\n                                    <option value="ASSIGNED" translate="trakeyeApp.CaseStatus.ASSIGNED">ASSIGNED</option>\n                                    <option value="RESOLVED" translate="trakeyeApp.CaseStatus.RESOLVED">RESOLVED</option>\n\t\t\t\t\t\t\t\t\t<option value="CANCELLED" translate="trakeyeApp.CaseStatus.CANCELLED">CANCELLED</option> --><option value="NEW">PLANNING PHASE</option><option value="INPROGRESS">ROLL-OUT PHASE</option><option value="PENDING">PENDING</option><option value="ASSIGNED">ASSIGNED</option><option value="RESOLVED">OPERATION PHASE</option><option value="CANCELLED">CANCELLED</option></select></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_priority"><span translate="trakeyeApp.trCase.priority">Priority</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="priority" ng-model="vm.trCase.priority" id="field_priority" required><option disabled="disabled" selected="selected" value>--- Select Priority ---</option><option value="LOW">LOW</option><option value="MEDIUM">MEDIUM</option><option value="HIGH" selected="selected" value>HIGH</option><option value="CRITICAL">CRITICAL</option></select></div></div><!-- <div class="form-group" ng-if="has_ROLE_USER_ADMIN" ng-show="isSet(1)">\n                            <label class="col-md-3 control-label" for="field_parent">\n\t\t\t\t\t\t\t\t<span>Parent Cases</span>\n                                <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\n                            </label>\n                            <div class="col-md-8">\n                                <input list="userslist" class="form-control" id="field_parent" placeholder="Search case name" type="text" \n                                \tng-model="vm.trCase.parent" autocomplete="off" name="parent" ng-change="vm.filterActivatedcases()" required>\n                                <datalist ng-hide="!vm.childAssets" id="caselist" class="form-control1">\n                                    <option ng-repeat="child in vm.childAssets" value="{{child.name}}"></option>\n                                </datalist>\n                            </div>\n                        </div> --><div class="form-group" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN" ng-show="isSet(1)"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.group">Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.multigroup" output-model="vm.trCase.groups" button-label="name" on-item-click="vm.selectedGroup(vm.trCase.groups)" item-label="name" tick-property="ticked" output-properties="id selected" selection-mode="single"></div><input type="text" ng-model="vm.trCase.groups" name="group" style="display: none"></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_assignedTo"><span translate="trakeyeApp.trCase.assignedTo">Assigned To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input list="userslist" class="form-control" ng-disabled="vm.hideUser" id="field_assignedToUser" placeholder="Search user login name" type="text" ng-model="vm.trCase.assignedToUser" autocomplete="off" name="assignedToUser" ng-change="vm.filterActivatedUser()" required><datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1"><option ng-repeat="user in vm.activatedusers" value="{{user.login}}"></option></datalist></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.caseType">caseType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="caseType" ng-model="vm.caseType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.caseTypes track by item.id" ng-disabled="vm.trCase.id!=null" required style="width: 100%;"><option value="" translate="trakeyeApp.trCase.selectcase">--- Select WorkFlowType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.trCase.caseTypeAttributeValues | orderBy: \'caseTypeAttribute.id\' track by $index" ng-class="{\'has-error\' : userIntForm.value.$invalid }" ng-show="isSet(1)"><label class="col-md-3 control-label"><span>{{attribute.caseTypeAttribute.name}}</span></label><div class="col-md-8" ng-repeat="attributeValue\n                                    in vm.trCase.caseTypeAttributeValues track\n                                    by $index"><div ng-if="attributeValue.caseTypeAttribute.id\n                                        == attribute.caseTypeAttribute.id"><input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                            == \'FLOAT\' && !vm.trCase.id" type="text" class="form-control" ng-init="attributeValue.attributeValue=\n                                            attribute.caseTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                            == \'FLOAT\' && vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <span ng-if="attribute.caseTypeAttribute.dataType\n                                            == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                            == \'INTEGER\' && !vm.trCase.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\n                                            attribute.caseTypeAttribute.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                            == \'INTEGER\' && vm.trCase.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.caseTypeAttribute.dataType\n                                            == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                            == \'STRING\' && !vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\n                                            attribute.caseTypeAttribute.value" ng-model="attributeValue.attributeValue"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                            == \'STRING\' && vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue"> <span ng-if="attribute.caseTypeAttribute.attributeDataType.name\n                                            == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="attributeValue.attributeValue" ng-init="attributeValue.attributeValue = attribute.caseTypeAttribute.value" ng-if="attribute.caseTypeAttribute.attributeDataType.name != \'STRING\' && attribute.caseTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.caseTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trCase.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.caseTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="attributeValue.attributeValue" ng-init="attributeValue.attributeValue == attribute.caseTypeAttribute.attributeValue" ng-if="attribute.caseTypeAttribute.attributeDataType.name != \'STRING\' && attribute.caseTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.caseTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trCase.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.caseTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><div class="map-view row mt-5" ng-show="isSet(2)"><div class="column col-md-8" id="map_canvas_planning" style="height:75vh;width:77%;margin-left: 30px;"></div><div class="column col-md-4" style="width:20%;height:75vh"><div class="row input-group input-group-sm" style="margin-top:3px;margin-left: 5px;"><input type="text" placeholder="Search" ng-model="searchText" class="search-box"></div><br><div class="row"><div class="box-body scrollbar" id="style-3" style="width: 90%;"><table class="jh-table table table-responsive table-hover" style="background-color: #eae9e9;"><thead class="thead-light"><tr><th>Asset Type</th><th>Type</th></tr></thead><tbody><tr ng-repeat="item in vm.assetType | filter : searchText" ng-click="vm.createAssetModal(item)"><td>{{item.name}}</td><td ng-show="{{item.imagePath != null}}"><img class="img-responsive" ng-src="{{item.imagePath}}" style="width: 24px; height: 24px;"></td><td ng-show="{{item.colorcode != null}}"><img class="square" style="background-color:{{item.colorcode}};"></td></tr></tbody></table></div></div><div class="row"><div class="box-body scrollbar" id="style-3" style="width: 90%;"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr><th></th><th><span>Name</span></th><th><span>Actions</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.mappedAssetsList track by asset.name" ng-class="{selected: asset.isChecked}"><td><input type="checkbox" ng-model="asset.isChecked" ng-change="selectEntity(asset)"></td><td>{{asset.name}}</td><td><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a id="editlink" ng-click="vm.editAsset(asset)" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="link" ng-click="vm.deleteAssetModal(asset.name)" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.mappedAssetsList.length==0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div><div class="form-group" style="margin:20px;" ng-show="isSet(3)"><jhi-alert-error></jhi-alert-error><div ng-if="vm.previousId"><button class="btn btn-primary btn-sm pull-right" type="button" class="btn btn-primary btn-sm" ng-click="vm.recalculate()"><span>Recalculate</span></button></div><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.trCase.description" ng-if="vm.trCase.description">Description</span></dt><dd><span>{{vm.trCase.description}}</span></dd><dt><span translate="trakeyeApp.trCase.caseType" ng-if="vm.trCase.caseType">Case Type</span></dt><dd ng-if="vm.trCase.caseType">{{vm.trCase.caseType.name}}</dd></dl><!-- <div ng-repeat="attributeValue in vm.trCase.caseTypeAttributeValues track by $index">\n                                    <div ng-if="attributeValue.caseTypeAttribute.id == attribute.caseTypeAttribute.id">\n                                        <span style="margin-left: 20%"><b>{{attribute.caseTypeAttribute.name}}</b>\n                                        <span style="margin-left: 20px;">{{attribute.attributeValue}}</span></span>\n                                    </div>\n\t\t\t\t\t\t\t\t</div>  --><div class="form-group" ng-if="vm.trCase.caseType" style="height:200px;overflow:scroll;width: 50%;margin-left: 200px;"><table class="jh-table table table-responsive table-hover" style="width:100%;"><thead class="thead-light"><tr><th style="font-weight: 600;font-size: 12px;color: #26292b;text-align: left;border: 1px solid #dddddd;background:#eee;position: sticky;top: 0;z-index: 10;">Name</th><th style="font-weight: 600;font-size: 12px;color: #26292b;text-align: left;border: 1px solid #dddddd;background: #eee;position: sticky;top: 0;z-index: 10;">Value</th></tr></thead><tbody ng-repeat="attribute in vm.trCase.caseTypeAttributeValues | orderBy: \'caseTypeAttribute.id\'"><tr ng-repeat="attributeValue in vm.trCase.caseTypeAttributeValues track by $index"><td ng-if="attributeValue.caseTypeAttribute.id == attribute.caseTypeAttribute.id" style="border: 1px solid #dddddd;">{{attribute.caseTypeAttribute.name}}</td><td ng-if="attributeValue.caseTypeAttribute.id == attribute.caseTypeAttribute.id" style="border: 1px solid #dddddd;">{{attribute.attributeValue}}</td></tr></tbody></table></div><div class="col-md-12"><div class="col-md-9" id="map_canvas_deployed" style="height:500px; width: 100%;"></div></div></div><div class="box-footer"><div class="col-md-12 next-button" ng-show="isSet(1)" style="text-align:right;margin-right:20px;"><button type="button" class="btn btn-primary btn-sm" ng-disabled="editForm.$invalid ||  vm.isSaving || vm.validUser" ng-click="setTab(2)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 next-button" ng-show="isSet(2)" style="text-align:right; margin-right:20px;"><button type="button" class="btn btn-primary btn-sm" ng-click="setTab(1)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="button" class="btn btn-primary btn-sm" ng-disabled="editForm.$invalid || vm.isShowing" ng-click="setTab(3)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 save-buttons" ng-show="isSet(3)" style="text-align:right;margin-right:20px;"><button type="button" class="btn btn-primary btn-sm" ng-click="setTab(2)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon"></span> <span>Submit</span></button></div></div></div></form></div></div></div><!--Modal for editing asset--><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="myEditAssetText"></span></div><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="row"><div class="col-md-12"><div class="box-body"><button class="btn btn-info btn-flat" style="float: right; border: none; margin-right: 20px" ng-click="vm.saveEditAsset()"><span><b>Save</b></span></button><div class="row" style="margin:20px"><label class="col-md-3 control-label"><span>Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.asset.name" ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row" style="margin: 20px;"><div class="col-md-3 control-label"><span>Asset Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3 control-label"><span>{{vm.asset.assetType.name}}</span></div></div><div class="row" ng-repeat="attribute in vm.asset.assetTypeAttributeValues track by $index" style="margin: 20px;"><label class="col-md-3 control-label"><span>{{attribute.assetTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue == attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value}}</option></select></div></div><div class="row" style="margin: 20px;"><!--<label class="col-md-3 control-label">\n\t\t\t\t\t\t\t\t\t\t\t<span>Coordinates</span> \n\t\t\t\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup>\n\t\t\t\t\t\t\t\t\t\t</label>--><div class="col-md-9"><!--<div class="input-group">\n\t\t\t                                    <input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled ng-model="vm.asset.assetCoordinates" />\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id==null && !vm.isSite">\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Select On Map</button>\n\t\t\t\t\t\t\t\t\t\t\t   </span>\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id!=null">\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Edit</button>\n\t\t\t\t\t\t\t\t\t\t\t   </span>\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id!=null">\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm" >Recreate</button>\n\t\t\t\t\t\t\t\t\t\t\t   </span>\n\t\t\t                                </div>\n\t\t\t                                <br/>>\n\t\t\t                                <h4>{{vm.siteLatLng}}</h4>--><div id="map_canvas_edit_asset" style="height:300px;"></div></div></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">Connect Two Assets</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideConnectSitesModal()"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="connectAssetsText"></span></div><!-- Modal body--><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="row"><div style="margin-top: 8px; margin-left: 36px;"><div class="col-md-1 select_asset" style="text-align: right"><label style="padding-top: 6px;">Site A</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;"><select id="fromAssetsView" class="select2 form-control" name="search" style="width:220px; height: 40px"><option value="">--Select Site A--</option><option ng-repeat="item in vm.mappedAssetsList" value="{{item.name}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px; margin-left: 93px;"><label style="padding-top: 6px;">Site B</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;margin-left: -15px;"><select id="toAssetsView" class="select2 form-control" name="search" style="width:220px; height: 40px;"><option value="">--Select Site B--</option><option ng-repeat="item in vm.mappedAssetsList" value="{{item.name}}">{{item.name}}</option></select></div><button type="button" ng-click="vm.connectAssets()" class="btn btn-primary btn-sm">Connect</button></div><div class="form-group"><div class="col-md-11" style="margin: 20px"><div id="map_canvas_connect_assets" style="width: 100%;height:560px;"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectMultipleAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="vm.hideConnectMultipleAssetsModal()" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle; font-weight: 125;" id="connectAssetsText">Select site to connect</span></div><!-- Modal body--><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="col-md-12"><div id="map_canvas_connect_multiple_assets" style="width: 100%;height:68vh;margin-top: 10px;"></div></div><div class="col-md-12"><button class="btn btn-primary btn-sm pull-right" type="button" ng-click="vm.saveLinkPits()" style="margin: 10px;">Save</button></div></div></div></div></div><!-- Modal for delete asset   --><div id="delete-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; margin: 200px auto;" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cleardeleteAsset()">&times;</button></div><div class="modal-body"><h4>Are you sure you want to delete this asset?</h4></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.cleardeleteAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm" ng-click="vm.confirmDeleteAsset()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></div></div></div><!-- Modal for create asset   --><div id="create-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 45%; margin: 100px auto;"><div class="modal-content"><form name="form" class="css-form" novalidate><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">Asset Creation Form of Type {{vm.CreateAssetName}}</span> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clearCreateAsset()">&times;</button></div><div class="modal-body"><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-2 control-label" style="width: 17%;"><span style="vertical-align: center;">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7" style="width: 71%"><input type="text" name="name" ng-model="vm.assetNameVal" ng-change="vm.searchAssetName()" class="form-control" placeholder="Please Enter AssetName" style="padding: 6px;" required><div ng-show="vm.assetExisting"><div class="help-block" ng-show="form.name.$error">AssetName is already exist</div></div></div></div></div><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-2 control-label" style="width: 17%;"><span>Lat</span></label><div class="col-md-3"><input name="Lat" ng-model="vm.assetLat" type="text" style="width: 120%; padding: 6px;"></div><label class="col-md-2"><span style="padding: 13px;">Long</span></label><div class="col-md-3"><input name="Long" ng-model="vm.assetLong" type="text" style="width: 120%; padding: 6px;"></div></div></div><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-4 control-label" style="width: 17%;"><span style="vertical-align: center;">ParentSite</span></label><div class="col-md-8" style="width: 71%"><select class="form-control" name="asset" id="asset" ng-model="vm.parentAsset"><!-- <option value="">Select Parent Site </option> --><option ng-repeat="site in vm.mappedAssetsList" ng-if="site.assetType.name == \'Site\'" value="{{site.name}}">{{site.name}}</option></select></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearCreateAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.createAsset()" ng-disabled="vm.showAssetCreation"><span>OK</span></button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-cases.html','<div class="content"><div class="row"><div ng-show="vm.showCasesFilter"><div class="col-md-3 caseType_showImg mb-5"><label style="margin-right: 10px;">Cases Filter :</label><!-- 6 months\n                                    <label class="switch">\n                                       \n                                        <input type="checkbox" style="\n                                                 margin-top: 10px;\n                                                 margin-left: 15px;\n                                             " data-toggle="modal" data-target="#myModal" id="{{asset.id}}"\n                                             ng-checked="asset.accessible" ng-model="asset.accessible"\n                                             ng-change="accessibleCheckChange(asset)" /> \n                                         <span class="slider round"></span>\n                                         \n                                         </label>\n                                         Custom Date --> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.newCases()">New</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Old</label></div><div class="form-group col-md-9" ng-show="vm.dateRange == \'custom\'"><div class="col-md-3"><!-- <label class="control-label">From\n                        :</label> --><!-- \t<input type="date" class=" form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required/> --><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')">From <i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_serviceDate" type="text" class="form-control" name="fromDate" ng-model="vm.fromDate" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.fromDate" enable-time="false" datepicker-options="options" required></div><span id="noData" ng-show="vm.fromDate == null">*select from date</span></div><div class="col-md-3"><!-- <label class="control-label location_labels">To :</label> --><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')">To <i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_toDate" type="text" class="form-control" name="toDate" ng-model="vm.toDate" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.toDate" enable-time="false" datepicker-options="options" required></div></div><div class="col-md-2"><!--  <label class="control-label location_labels"></label> --><div class="input-group"><a class="btn btn-info btn-flat" ng-click="submitDate()"><span>Submit</span></a></div></div></div></div><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><!--<h3 class="box-title"><i class="fa fa-th-large"></i> <span translate="trakeyeApp.trCase.home.title"> Case </span></h3>--><div class="pull-left"><h3 class="box-title"><i class="fa fa-th-large"></i> <span translate="trakeyeApp.trCase.home.title">Cases</span></h3></div><div class="col-md-6 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}" ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(1); search = null" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(2)}" ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-map"></i><span class="header-view">Map</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(3)}" ng-hide="has_ROLE_VENDOR" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a href ng-click="setTab(3);" data-toggle="tab"><i class="fa fa-user-circle"></i><span class="header-view">Find</span> <span class="header_view">Nearby</span></a></li><li ng-class="{active:isSet(4)}" ng-hide="has_ROLE_VENDOR" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a href ng-click="setTab(4);" data-toggle="tab"><i class="fa fa-globe"></i><span class="header-view">Region</span> <span class="header_view">View</span></a></li></ul></div><div class="box-tools"><button class="btn btn-create btn-sm" title="Cases Date Filter" ng-click="vm.showHideFilter()"><span><i class="fa fa-calendar" aria-hidden="true"></i> {{vm.textFilter}}<!-- <i class="fa fa-filter" aria-hidden="true"></i> --> Filter</span></button> <button class="btn btn-create btn-sm" ui-sref="tr-case.import" ng-if="has_ROLE_USER_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span>Import</span></button> <button class="btn btn-create btn-sm" ui-sref="tr-case.new" ng-hide="has_ROLE_VENDOR"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button><!-- <button class="btn btn-create btn-sm" ui-sref="tr-case.fibercore">\n                            <span class="glyphicon glyphicon-plus"></span>\n                            <span translate=""></span>\n                            <span> Fiber Core Map View </span>\n                        </button> --><!--<button class="btn btn-create btn-sm" ui-sref="tr-case.new">\n                            <span class="glyphicon glyphicon-plus"></span>\n                            <span translate="trakeyeApp.trCase.home.createLabel">\n                                Create Tr Case\n                            </span>\n                        </button>--></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><!-- <div class="col-md-6">\n                            <ul class="nav nav-pills nav-justified">\n                                <li ng-class="{active:isSet(1)}" ng-hide="has_ROLE_VENDOR"><a href\n                                        ng-click="setTab(1); search = null" data-toggle="tab">List View</a></li>\n                                <li ng-class="{active:isSet(2)}" ng-hide="has_ROLE_VENDOR"><a href\n                                        ng-click="setTab(2); search = null" data-toggle="tab">Map View</a></li>\n                                <li ng-class="{active:isSet(3)}" ng-hide="has_ROLE_VENDOR"\n                                    ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">\n                                    <a href ng-click="setTab(3);" data-toggle="tab">Find Nearby</a>\n                                </li>\n                                <li ng-class="{active:isSet(4)}" ng-hide="has_ROLE_VENDOR"\n                                    ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER">\n                                    <a href ng-click="setTab(4);" data-toggle="tab">Region View</a>\n                                </li>\n                             </ul>\n                        </div> --><div class="col-md-3 dropFilter" ng-show="isSet(1)"><!-- <button\n                                type="button"\n                                class="btn btn-info btn-flat"\n                                ng-click="vm.filterTrcasesOnListView()"\n                            >\n                                <i class="fa fa-filter"></i>\n                            </button> --><div isteven-multi-select input-model="vm.geofencesListView" output-model="vm.selectedGeofenceId" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceId" name="vm.searchMini" style="display:none" required></div><div class="col-md-3 search-top pull-right" ng-show="isSet(1)"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.trCase.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterTrcaseSearch()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(4)"><select id="masterGeofence" class="select2 form-control" ng-model="vm.masterGeofence"><option value="">Select City</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select> <span id="noData" ng-if="vm.selectedMasterGeofenceId == 0">*Please Select City</span></div><div class="col-md-3 dropFilter" ng-show="isSet(2) || isSet(3) || (isSet(4) && vm.selectedMasterGeofenceId > 0)"><!-- <button type="button" class="btn btn-info btn-flat"\n                                    ng-click="vm.filterAssetsOnMapView()">\n                                    <i class="fa fa-filter"></i>\n                                </button> --><div isteven-multi-select input-model="vm.userGeofences" output-model="vm.selectedGeofenceMap" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceMap" name="vm.searchMini" style="display:none" required> <span id="noData" ng-if="vm.selectedGeofenceMap.length < 1">*Please Select Geofence</span><!-- <button type="button" value="Layers" class="btn btn-info btn-flat" ng-click="vm.showPriorityStatusFilter()">\n                                    Status Filter\n                                </button> --></div><div class="col-md-3 dropFilter" ng-show="(isSet(2) && vm.selectedGeofenceMap.length > 0) || (isSet(3) && vm.selectedGeofenceMap.length > 0) || (isSet(4) && vm.selectedGeofenceMap.length > 0)"><div isteven-multi-select input-model="vm.statusType" output-model="vm.selectedstatusType" button-label="name" item-label="name" tick-property="selected" group-property="msGroup" translation="statuslabel" output-properties="name value" on-select-done="savePriorityStatusFilter()" max-labels="2" max-height="280px" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedstatusType" name="vm.searchMini" style="display:none" required> <span id="noData" ng-if="vm.selectedPriorityList.length == 0 || vm.selectedStatusList.length == 0">* Select atleast one from each group.</span></div><div class="col-md-3 search-top pull-right" ng-show="isSet(2)"><div class=""><div class="input-group"><input type="number" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search Cases by Id"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.dateFilterTrCaseSearchMap()"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-3 selectAsset_drp" ng-show="isSet(3)"><select id="searchOnMap" class="select2 form-control" name="search"><option value="">Search User</option><option ng-repeat="item in vm.usersList" value="{{item}}">{{item.userName}}</option></select></div><div class="col-md-3 pull-right" ng-show="isSet(3)"><div class="input-group"><input type="number" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search Cases"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.dateFilterTrCaseSearchMap()"><i class="fa fa-search"></i></button></span></div></div><!-- <div class="col-md-1 pull-right" ng-show="isSet(3)">\n                            <button type="button" class="btn btn-info btn-flat"\n                                ng-click="vm.filterAssetsOnMapView()">\n                                <i class="fa fa-filter"></i>\n                            </button>\n                        </div> --></div><div class="row div--attributes" ng-show="isSet(1)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th><input type="checkbox" ng-click="vm.selectAllAssets()" ng-model="vm.isAllAssetSelected"></th> --><th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"></th><th jh-sort-by="create_date"><span>Created Date </span><span class="fa fa-sort"></span></th><th jh-sort-by="case_number"><span>Case Number </span><span class="fa fa-sort"></span></th><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.trCase.description">Description</span> <span class="fa fa-sort"></span></th><th jh-sort-by="address" class="table-size"><span translate="trakeyeApp.trCase.address">Address</span> <span class="fa fa-sort"></span></th><th jh-sort-by="case_type_id"><span translate="trakeyeApp.trCase.caseType">Case Type </span><span class="fa fa-sort"></span></th><th jh-sort-by="priority"><span translate="trakeyeApp.trCase.priority">Priority </span><span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="trakeyeApp.trCase.status">Status</span> <span class="fa fa-sort"></span></th><th jh-sort-by="verified"><span translate="trakeyeApp.trCase.verified">Verified</span> <span class="fa fa-sort"></span></th><!--<th jh-sort-by="escalated"><span translate="trakeyeApp.trCase.escalated">Escalated</span> <span class="fa fa-sort"></span></th>--><th jh-sort-by="reported_by_id"><span translate="trakeyeApp.trCase.createdBy">CreatedBy </span><span class="fa fa-sort"></span></th><th jh-sort-by="assigned_to_id"><span translate="trakeyeApp.trCase.assignedTo">Assigned To </span><span class="fa fa-sort"></span></th><!-- <th><span translate="">Distance(km)</span> </th> --><!-- <th><span>Fiber Status</span></th> --><th>Viewed By</th><!-- <th><span translate="trakeyeApp.trCase.geofence">Geofence</span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="trCase in vm.trCases track by trCase.id"><!-- <td><input type="checkbox" ng-model="trCase.isChecked" ng-change="vm.selectAssetEntity()"></td> --><td class="td__listViewRow" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER" ng-click=" vm.usersTable(trCase);" expand><span ng-if="!trCase.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="trCase.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{trCase.createDateFormat}}<!-- <a ui-sref="tr-case-detail({id:trCase.id})"></a> --></td><td><a ui-sref="tr-case-detail({id:trCase.id})">{{trCase.caseNumber}}</a></td><td><a ui-sref="tr-case-detail({id:trCase.id})">{{trCase.id}}</a></td><td>{{trCase.description | limitTo:40}}</td><td title="{{trCase.address}}">{{trCase.address | limitTo: 8 }}{{trCase.address.length > 20 ? \'...\' : \'\'}}</td><td>{{trCase.caseTypeName}}</td><td>{{trCase.priority}}</td><td translate="{{\'trakeyeApp.CaseStatus.\' + trCase.status}}">{{trCase.status}}</td><td><span ng-if="trCase.verified">Yes</span> <span ng-if="!trCase.verified">No</span></td><!-- <td>{{trCase.address}}</td> --><!--<td>\n                                                                                <div ng-if="trCase.escalated">YES</div>\n                                                                                <div ng-if="!trCase.escalated">NO</div>--><td>{{trCase.reportedByUser}}</td><!--  <td>\n                                    \t\t\t\t                        {{trCase.reportedByUser}}\n                                    \t\t\t\t                        </td> --><td>{{trCase.assignedToUser}}</td><!-- <td ng-if="has_ROLE_USER_ADMIN">\n                                                                                <a ui-sref="case-type-detail({id:trCase.caseType.id})">{{trCase.caseType.name}}</a> {{trCase.caseTypeName}}\n                                                                            </td> --><!-- <td>{{}}</td> --><!-- <td>{{trCase.geofenceName}}</td> --><td ng-if="trCase.isOpened">{{trCase.updatedByUser}}</td><td ng-if="!trCase.isOpened"></td><td><div class="actions"><!-- <a ng-if="vm.showCaseAttachment" class="action-icons text-info" ng-click="vm.imageUpload({id:trCase.id})"\n                                                                                  title="Upload PDF"><span class="fa fa-upload"></span></a> --> <a ui-sref="tr-case-detail({id:trCase.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="tr-case.edit({id:trCase.id})" class="action-icons text-primary" title="Edit" ng-hide="has_ROLE_VENDOR && trCase.caseTypeName!=\'Vendor Civil Work\'"><span class="fa fa-pencil-square"></span> </a><a id="editlink" ui-sref="tr-case.delete({id:trCase.id})" class="action-icons text-primary" title="Delete" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER"><span class="fa fa-trash-o"></span> </a><a id="editlink" ng-click="vm.downloadPdfButton(trCase.id)" class="action-icons text-primary" title="Download PDF" ng-if="(trCase.caseTypeName==\'Termination Details\' || trCase.caseTypeName==\'Splicing Details\') && (has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER)"><span class="fa fa-download"></span> </a><!-- <img src="content/images/map_img.png" ng-click="caseLocation(trCase)" /> --></div></td></tr><tr ng-show="trCase.isExpanded"><td ng-if="vm.caseAroundUsers.length>0"></td><td colspan="13" ng-if="vm.caseAroundUsers.length>0"><table class="table__userNames"><thead><th></th><th>Nearby users within 30 min</th></thead><tbody><tr ng-repeat-start="users in vm.caseAroundUsers"><td>{{}}</td><td>{{users.login}}</td><td>{{users.visitedDateTime | date:\'medium\'}}</td><td class="td--w7"><div ng-repeat="authority in users.authoritieList "><span class="label label-primary">{{ authority }}</span></div></td></tr><tr ng-repeat-end></tr></tbody></table></td><td colspan="13" ng-if="vm.caseAroundUsers.length==0"><table class="table__userNames"><thead><th></th><th>No nearby users within 30 min</th></thead></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.trCases == 0" class="td__noDataAvailable"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="map-view" ng-show="isSet(2)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas1" style="height:{{mapHeight}}px; width:100%"></div></div></div></div><div class="map-view" ng-show="isSet(3)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas2" style="height:{{mapHeight}}px; width:100%"></div></div></div></div><div class="map-view" ng-show="isSet(4)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas4" style="height:{{mapHeight}}px; width:100%"></div></div></div></div></div></div></div></div></div><div class="modal fade" id="myModalUpload" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeImageUpload()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Upload PDF</span></div><div class="modal-body"><div class="form-group asset_images"><label class="col-md-3 control-label">PDF</label><div class="col-md-8"><input type="file" name="file" class="filestyle" id="assetImages" accept="application/pdf"> <span ng-if="!vm.fileWarning">Supported Format - PDF.</span> <span id="noData" ng-if="vm.fileWarning">Please upload PDF format.</span></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.saveImage()" class="btn btn-primary btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-save"></i> Save</button> <button type="button" ng-click="vm.closeImageUpload()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button></div></div></div></div><div class="modal fade" id="successImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="col-lg-12 col-sm-12 col-xs-12 alert alert-success"><strong>PDF Saved Successfully</strong></div></div></div></div><div class="modal fade" id="errorImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="col-lg-12 col-sm-12 col-xs-12 alert alert-danger"><strong>Error</strong></div></div></div></div><div id="listFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeListFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence for List</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveListFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.geofencesListView.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.geofencesListView"><input type="radio" id="{{item.id}}" ng-model="vm.selectedListGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><!--Modal for editing asset--><div id="caseLocationModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div--travelMap" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header" id="myEditAssetText"></span></div><div class="modal-body div__map_canvas_case_location"><div class="row"><div class="col-md-12 modal_body_map"><div class="location-map-case-location" id="location-map-edit"><div id="map_canvas_case_location"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!-- Modal --><div id="assigncaseModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header modal-info"><button type="button" class="close" ng-click="reset()" data-dismiss="modal">&times;</button><h4 class="modal-title text-left">Assign case to {{edituserLogin}}</h4></div><div class="modal-body"><div class="row"><form name="editCaseForm" role="form" class="form-horizontal" novalidate ng-submit="vm.editcase()"><div class="form-group"><label class="col-md-3 control-label" translate="entity.action.selectcase">Select Case Id</label><!-- <div class="col-md-6">\n\t\t\t\t\t<select class="form-control select2" id="field_caseId" name="caseId"  \n\t\t            \tng-options=" case.id for case in trallcases" ng-model="vm.editCase"  required>\n\t\t            \t<option value="" translate="entity.action.selectcase">--- Select Case ---</option>\n\t\t            \t</select>\n\t\t\t\t</div> --><div class="col-md-8"><!-- <select class="form-control select2" id="field_caseId" name="caseId"  ng-options=" case.id for case in trallcases" ng-model="vm.editCase" \n\t\t              ng-change="vm.selectattributes()" style="width: 100%" required>\n\t\t\t\t\t \t<option value="" translate="entity.action.selectcase">--- Select Case Id ---</option>\n\t\t\t\t\t \t</select> --> <input list="caseslist" class="form-control" id="field_caseId" ng-pattern="/^[0-9]+$/" placeholder="Search case id" type="text" ng-model="vm.seachCaseId" autocomplete="off" name="caseId" ng-change="vm.filterTrcasesId()" required><datalist ng-hide="!vm.caseIds" id="caseslist" class="form-control1"><option ng-repeat="case in vm.caseIds" value="{{case.id}}"></option></datalist><p class="help-block" ng-show="editCaseForm.caseId.$error.pattern" translate="trakeyeApp.trCase.caseiderror">Enter only numeric values for case id</p></div></div><div class="form-group"><div class="col-md-3 col-md-offset-3"><button type="submit" ng-disabled="editCaseForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.assigncase">Assign Case</span></button></div></div></form><p class="text-success text-center" ng-show="vm.success" translate-compile>Case {{vm.editCase.id}} has been assigned successfully to user {{edituserLogin}}.</p><p class="text-danger text-center" ng-show="vm.error" translate-compile>{{vm.error}}</p></div></div></div></div></div><div id="mapFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.countUserGeofences == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="priorityStatusfilterModal" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Filter By Priority / Status</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closePriorityStatusFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div class="row div__priorityType"><div><label ng-repeat="priorityType in vm.priorityType" class="label__priorityType"><input class="coupon_question input__priorityType" name="coupon_question" type="checkbox" value="{{priorityType}}" ng-checked="vm.selectedPriorityType.indexOf(priorityType)>-1" ng-click="togglePriorityTypeSelection(priorityType)"> {{priorityType}}</label></div><div><ol class="ol__list"><li ng-repeat="priorityList in vm.priorityList" class="label__priorityType"><input class="input__priorityType" type="checkbox" value="{{priorityList}}" id="{{priorityList}}" ng-checked="vm.selectedPriorityList.indexOf(priorityList)>-1" ng-click="togglePriorityListSelection(priorityList)"> <label for="{{priorityList}}">{{priorityList}}</label></li></ol></div><div><label ng-repeat="statusType in vm.statusType" class="label__priorityType"><input class="coupon_question input__priorityType" name="coupon_question" type="checkbox" value="{{statusType}}" ng-checked="vm.selectedStatusType.indexOf(statusType)>-1" ng-click="toggleStatusTypeSelection(statusType)"> {{statusType}}</label></div><div><ol class="ol__list"><li ng-repeat="statusList in vm.statusList" class="label__priorityType"><input class="input__priorityType" type="checkbox" value="{{statusList}}" id="{{statusList}}" ng-checked="vm.selectedStatusList.indexOf(statusList)>-1" ng-click="toggleStatusListSelection(statusList)"> <label for="{{statusList}}">{{statusList}}</label></li></ol></div><span id="noData" ng-if="vm.selectedPriorityList==0||vm.selectedStatusList==0">* Select atleast one from each group.</span><div class="col-md-12 modal_body_content div__btn_done"><button class="btn btn-info btn-flat button__done" ng-click="savePriorityStatusFilter()"><span><b>Done</b></span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-notification/tr-notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trNotification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><span>&times;</span></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.trNotification.delete.question" translate-values="{id: \'{{vm.trNotification.id}}\'}">Are you sure you want to delete this Tr Notification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-notification/tr-notification-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.trNotification.detail.title">Tr Notification</span> {{vm.trNotification.description}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.trNotification.subject">Subject</span></dt><dd><span>{{vm.trNotification.subject}}</span></dd><dt><span translate="trakeyeApp.trNotification.description">Description</span></dt><dd><span>{{vm.trNotification.description}}</span></dd><dt><span translate="trakeyeApp.trNotification.status">Status</span></dt><dd><span translate="{{\'trakeyeApp.NotificationStatus.\' + vm.trNotification.status}}">{{vm.trNotification.status}}</span></dd><dt><span translate="trakeyeApp.trNotification.alertType">Alert Type</span></dt><dd><span translate="{{\'trakeyeApp.AlertType.\' + vm.trNotification.alertType}}">{{vm.trNotification.alertType}}</span></dd><dt><span translate="trakeyeApp.trNotification.fromUser">From User</span></dt><dd>{{vm.trNotification.fromUserName}}</dd><dt><span translate="trakeyeApp.trNotification.toUser">To User</span></dt><dd>{{vm.trNotification.toUserName}}</dd><dt><span translate="trakeyeApp.trNotification.trCase">Tr Case</span></dt><dd><a ui-sref="tr-case-detail({id:vm.trNotification.trCaseId})">{{vm.trNotification.trCaseId}}</a></dd><dt><span translate="trakeyeApp.trNotification.createdDate">Created Date</span></dt><dd><span>{{vm.trNotification.createdDate | date:\'medium\'}}</span></dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><!-- <a ng-if="has_ROLE_USER_ADMIN" ui-sref="tr-notification.edit({id:vm.trNotification.id})" class="btn btn-primary btn-sm">\n\t\t\t\t\t\t        <span class="glyphicon glyphicon-pencil"></span>\n\t\t\t\t\t\t        <span translate="entity.action.edit"> Edit</span>\n\t\t\t\t\t\t    </a> --></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-notification/tr-notification-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" ng-if="!vm.trNotification.id" translate="trakeyeApp.trNotification.home.create">Create</h3><h3 class="box-title" ng-if="vm.trNotification.id" translate="trakeyeApp.trNotification.home.Edit">Edit</h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!--  <div class="form-group" ng-if="vm.trNotification.id">\n\t\t\t\t            <label class="col-md-3 control-label" for="id" translate="global.field.id">ID</label>\n\t\t\t\t            <div class="col-md-8">\n\t\t\t\t            <input type="text" class="form-control" id="id" name="id"\n\t\t\t\t                    ng-model="vm.trNotification.id" readonly >\n\t\t\t\t            </div>\n\t\t\t\t        </div> --><div class="form-group"><!--  <label class="col-md-3 control-label" translate="trakeyeApp.trNotification.description" for="field_description">Description</label> --> <label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.trNotification.description">Description</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea class="form-control" rows="2" name="description" id="field_description" required ng-model="vm.trNotification.description" ng-readonly="vm.trNotification.id">\n\t\t\t\t            \t</textarea></div></div><div class="form-group"><!--  <label class="col-md-3 control-label" translate="trakeyeApp.trNotification.status" for="field_status">Status</label> --> <label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.trNotification.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" required ng-model="vm.trNotification.status" id="field_status" ng-readonly="vm.trNotification.status == \'DELIVERED\'"><option value="SENT" translate="trakeyeApp.NotificationStatus.SENT">SENT</option><option value="RECIEVED" translate="trakeyeApp.NotificationStatus.RECIEVED">RECIEVED</option><option value="DELIVERED" translate="trakeyeApp.NotificationStatus.DELIVERED">DELIVERED</option><option value="FAILED" translate="trakeyeApp.NotificationStatus.FAILED">FAILED</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.trNotification.subject">Subject</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" name="subject" id="field_subject" ng-model="vm.trNotification.subject" required ng-readonly="vm.trNotification.id"></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_alertType"><span translate="trakeyeApp.trNotification.alertType">Alert Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="alertType" ng-model="vm.trNotification.alertType" id="field_alertType" required ng-readonly="vm.trNotification.id"><option value="" translate="trakeyeApp.trNotification.selectType"></option><option value="EMAIL" translate="trakeyeApp.AlertType.EMAIL">EMAIL</option><option value="SMS" translate="trakeyeApp.AlertType.SMS">SMS</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_toUser"><span translate="trakeyeApp.trNotification.toUser">Recipient</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><!-- <select class="form-control" id="field_toUser" name="toUser" ng-model="vm.trNotification.toUserId" ng-options="user.id as user.login for user in vm.users">\n\t\t\t\t                <option value="" translate="trakeyeApp.trNotification.selectRecipient"></option>\n\t\t\t\t            </select> --> <input list="userslist" class="form-control" id="field_toUser" placeholder="Search user login name" type="text" ng-model="vm.trNotification.toUserId" autocomplete="off" name="toUser" ng-change="vm.filterActivatedUser()" required ng-readonly="vm.trNotification.id"><datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1"><option ng-repeat="user in vm.activatedusers" value="{{user.login}}"></option></datalist></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_trCase"><span translate="trakeyeApp.trNotification.trCase">Tr Case</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><!-- <select class="form-control" id="field_trCase" name="trCase" ng-model="vm.trNotification.trCaseId" ng-options="trCase.id as trCase.id for trCase in vm.trcases">\n\t\t\t\t                <option value="" translate="trakeyeApp.trNotification.selectCase"></option>\n\t\t\t\t            </select> --> <input list="caseslist" class="form-control" id="field_trCase" ng-pattern="/^[0-9]+$/" placeholder="Search case id" type="text" ng-model="vm.trNotification.trCaseId" autocomplete="off" name="trCase" ng-change="vm.filtertrcasesid()" required ng-readonly="vm.trNotification.id"><datalist ng-hide="!vm.caseids" id="caseslist" class="form-control1"><option ng-repeat="case in vm.caseids" value="{{case.id}}"></option></datalist><p class="help-block" ng-show="editForm.trCase.$error.pattern" translate="trakeyeApp.trNotification.caseiderror">Enter only numeric values for case id</p></div></div></div><div class="box-footer"><div class="col-md-3 col-md-offset-3 save-buttons"><button type="button" ui-sref="tr-notification" class="btn btn-default btn-sm"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/tr-notification/tr-notifications.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-bell"></i> <span translate="trakeyeApp.trNotification.home.title">Tr Notifications</span></h3><!-- <div class="box-tools" ng-if="has_ROLE_USER_ADMIN">\n\t\t\t\t\t\t <button class="btn btn-create" ui-sref="tr-notification.new">\n\t\t\t\t\t\t <span class="glyphicon glyphicon-plus"></span>\n\t\t                    <span  translate="trakeyeApp.trNotification.home.createLabel">\n\t\t                        Create Tr Notification\n\t\t                    </span>\n\t\t                </button>\n\t\t\t\t\t</div> --></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.trNotification.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--   <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="subject"><span translate="trakeyeApp.trNotification.subject">Subject</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="trakeyeApp.trNotification.status">Status</span> <span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.trNotification.type">Type</span></th><th><span translate="trakeyeApp.trNotification.alertType">Alert Type</span></th><th><span translate="trakeyeApp.trNotification.toUser">To User</span></th><th><span translate="trakeyeApp.trNotification.trCase">Tr Case</span></th><th><span translate="trakeyeApp.trNotification.createdDate">Created Date</span></th><th ng-if="has_ROLE_USER"><span translate="trakeyeApp.trNotification.downloadApp">Download App</span><span class="fa fa-sort"></span></th><th ng-if="has_ROLE_USER_ADMIN"><span translate="trakeyeApp.trNotification.action">Actions</span></th></tr></thead><tbody><tr ng-repeat="trNotification in vm.trNotifications | filter: search track by trNotification.id"><!--  <td><a ui-sref="tr-notification-detail({id:trNotification.id})">{{trNotification.id}}</a></td> --><td>{{trNotification.subject}}</td><td translate="{{\'trakeyeApp.NotificationStatus.\' + trNotification.status}}">{{trNotification.status}}</td><td>{{trNotification.notificationType}}</td><td translate="{{\'trakeyeApp.AlertType.\' + trNotification.alertType}}">{{trNotification.alertType}}</td><td>{{trNotification.toUserName}}</td><td><a ui-sref="tr-case-detail({id:trNotification.trCaseId})">{{trNotification.trCaseId}}</a></td><td>{{trNotification.createdDate | date:\'medium\'}}</td><td ng-if="has_ROLE_USER && trNotification.downloadLink!=null"><a href="{{trNotification.downloadLink}}" target="blank">Trakeye Apk Link</a></td><td ng-if="has_ROLE_USER_ADMIN"><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a ui-sref="tr-notification-detail({id:trNotification.id})" class="action-icons text-info"><span class="fa fa-eye" title="View"></span> </a><!-- <a ui-sref="tr-notification.edit({id:trNotification.id})"\n\t\t\t\t                                    class="action-icons text-primary" title="Edit">\n\t\t\t\t                                <span class="fa fa-pencil-square"></span>\n\t\t\t\t                            </a> --> <a ui-sref="tr-notification.delete({id:trNotification.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.trNotifications == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-flow/work-flow-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.workFlow.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.workFlow.delete.question" translate-values="{id: \'{{vm.workFlow.id}}\'}">Are you sure you want to delete this Work Flow?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/work-flow/work-flow-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.workFlow.detail.title">Work Flow</span> - {{vm.workFlow.id}}</h3></div><div class="col-md-12 mt-5"><a ui-sref="work-flow.edit({id:vm.workFlow.id})" class="btn btn-primary btn-sm" ng-hide="has_ROLE_VENDOR && vm.workFlow.workFlowType.name!=\'Vendor Civil Work\'"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Workflow Details</span></h4><div class="box-body table-scroll"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.workFlow.description">Description</span></dt><dd><span>{{vm.workFlow.description}}</span></dd><dt><span translate="trakeyeApp.workFlow.status">Status</span></dt><dd><span>{{vm.workFlow.status}}</span></dd><dt><span translate="trakeyeApp.workFlow.workFlowType">Case Type</span></dt><dd>{{vm.workFlow.workFlowType.name}}</dd><dt><span translate="trakeyeApp.workFlow.escalated">Escalated</span></dt><dd><span ng-if="vm.workFlow.escalated">YES</span> <span ng-if="!vm.workFlow.escalated">NO</span></dd><dt><span translate="trakeyeApp.workFlow.verified">Verified</span></dt><dd><span ng-if="vm.workFlow.verified">YES</span> <span ng-if="!vm.workFlow.verified">NO</span></dd><dt><span>Pin Lat</span></dt><dd><span>{{vm.workFlow.pinLat}}</span><!-- <a ui-sref="workflow-type-detail({id:vm.workFlow.address})">{{vm.workFlow.address}}</a> --></dd><dt><span>Pin Long</span></dt><dd><span>{{vm.workFlow.pinLong}}</span><!-- <a ui-sref="workflow-type-detail({id:vm.workFlow.address})">{{vm.workFlow.address}}</a> --></dd><dt><span translate="trakeyeApp.workFlow.assignedTo">Assigned To</span></dt><dd>{{vm.workFlow.assignedToUser}}</dd><dt><span translate="trakeyeApp.workFlow.reportedBy">Reported By</span></dt><dd>{{vm.workFlow.reportedByUser}}</dd><dt><span translate="trakeyeApp.workFlow.updatedBy">Updated By</span></dt><dd>{{vm.workFlow.updatedByUser}}</dd><dt><span translate="trakeyeApp.workFlow.assignedBy">Assigned By</span></dt><dd>{{vm.workFlow.assignedByUser}}</dd><dt><span translate="trakeyeApp.workFlow.createDate">Create Date</span></dt><dd><span>{{vm.workFlow.createDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workFlow.updateDate">Update Date</span></dt><dd><span>{{vm.workFlow.updateDate | date:\'medium\'}}</span></dd></dl></div></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Additional Details</span></h4><div class="box-body table-scroll"><div class="form-group" ng-repeat="attribute in vm.workFlow.workFlowTypeAttributeValues"><div ng-repeat="attributeValue in vm.workFlow.workFlowTypeAttributeValues track by $index"><div ng-if="attributeValue.workFlowTypeAttribute.id == attribute.workFlowTypeAttribute.id"><dl class="dl-horizontal jh-entity-details"><dt><span>{{attribute.workFlowTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></dl></div></div></div></div></div><div class="col-md-12"><div id="audioLayout"></div><div class="box-buttons"><a href="javascript:void(0);" ng-click="go_back()" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-flow/work-flow-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrWorkFlowLabel"><span ng-if="!vm.workFlow.id">Create Workflow</span> <span ng-if="vm.workFlow.id" translate="trakeyeApp.workFlow.home.EditLabel">Edit</span></h3></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="containerwf"><div class="wrapperwf"><div class="arrow-steps clearfix"><div class="step current"><span>Workflow Details</span></div><div class="step"><span>Asset Planning</span></div><div class="step"><span>Save Workflow</span></div></div></div><!-- <button type="button" ng-click="setTab(1)"\r\n\t\t\t\t\t\t\t\t\tng-class="{\'btn-primary\' : vm.toggleFirst, \'btn-default\':!vm.toggleFirst }"\r\n\t\t\t\t\t\t\t\t\tstyle="width: 30%; height: 40px;">\r\n\t\t\t\t\t\t\t\t\t<span>Work Flow Details</span>\r\n\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t<button type="button" ng-disabled="editForm.$invalid ||  vm.isSaving"\r\n\t\t\t\t\t\t\t\t\tng-click="setTab(2)"\r\n\t\t\t\t\t\t\t\t\tng-class="{\'btn-primary\' : vm.toggleSecond, \'btn-default\': !vm.toggleSecond}"\r\n\t\t\t\t\t\t\t\t\tstyle="width: 30%; height: 40px;">\r\n\t\t\t\t\t\t\t\t\t<span>Plan Activity</span>\r\n\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t<button type="button" ng-disabled="editForm.$invalid || vm.isShowing"\r\n\t\t\t\t\t\t\t\t\tng-click="setTab(3)"\r\n\t\t\t\t\t\t\t\t\tng-class="{\'btn-primary\' :vm.toggleThird, \'btn-default\': !vm.toggleThird}"\r\n\t\t\t\t\t\t\t\t\tstyle="width: 30%; height: 40px;">\r\n\t\t\t\t\t\t\t\t\t<span>Save Work Flow</span>\r\n\t\t\t\t\t\t\t\t</button> --></div></div></div><div class="table-responsive table-scroll" ng-show="isSet(1)" style="overflow-x: hidden;"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.workFlow.id" ng-show="isSet(1)"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.workFlow.id" ng-disabled="vm.workFlow.id!=null"></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_description"><span>Workflow Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input class="form-control" name="description" id="field_description" ng-model="vm.workFlow.description" required ng-disabled="vm.workFlow.id!=null"></div></div><div class="form-group" ng-if="vm.workFlow.id" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.workFlow.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.workFlow.status" id="field_status" required><!-- <option value="NEW" translate="trakeyeApp.WorkFlowStatus.NEW">NEW</option>\r\n                                    <option value="INPROGRESS" translate="trakeyeApp.WorkFlowStatus.INPROGRESS">IN PROGRESS</option>\r\n                                    <option value="PENDING" translate="trakeyeApp.WorkFlowStatus.PENDING">PENDING</option>\r\n                                    <option value="ASSIGNED" translate="trakeyeApp.WorkFlowStatus.ASSIGNED">ASSIGNED</option>\r\n                                    <option value="RESOLVED" translate="trakeyeApp.WorkFlowStatus.RESOLVED">RESOLVED</option>\r\n\t\t\t\t\t\t\t\t\t<option value="CANCELLED" translate="trakeyeApp.WorkFlowStatus.CANCELLED">CANCELLED</option> --><!-- <option value="NEW">PLANNING PHASE</option>\r\n\t\t\t\t\t\t\t\t<option value="INPROGRESS">ROLL-OUT PHASE</option>\r\n\t\t\t\t\t\t\t\t<option value="PENDING">PENDING</option>\r\n\t\t\t\t\t\t\t\t<option value="ASSIGNED">ASSIGNED</option>\r\n\t\t\t\t\t\t\t\t<option value="RESOLVED">OPERATION PHASE</option>\r\n\t\t\t\t\t\t\t\t<option value="CANCELLED">CANCELLED</option> --><option ng-repeat="item in vm.workFlowStatus" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group" ng-show="isSet(1)" ng-if="vm.workFlow.id"><label class="col-md-3 control-label"><span>Phase</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.workFlow.phase" ng-disabled="vm.phaseAccess" required><option ng-repeat="item in vm.workFlowPhase" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_priority"><span translate="trakeyeApp.workFlow.priority">Priority</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><label class="radio-inline"><input type="radio" name="type" ng-model="vm.workFlow.priority" value="CRITICAL" required>CRITICAL</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.workFlow.priority" value="HIGH">HIGH</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.workFlow.priority" value="MEDIUM">MEDIUM</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.workFlow.priority" value="LOW">LOW</label><!-- <select class="form-control" name="priority" ng-model="vm.workFlow.priority"\r\n\t\t\t\t\t\t\t\tid="field_priority" required>\r\n\t\t\t\t\t\t\t\t<option disabled selected value> --- Select Priority --- </option>\r\n\t\t\t\t\t\t\t\t<option value="LOW">LOW</option>\r\n\t\t\t\t\t\t\t\t<option value="MEDIUM">MEDIUM</option>\r\n\t\t\t\t\t\t\t\t<option value="HIGH" selected value>HIGH</option>\r\n\t\t\t\t\t\t\t\t<option value="CRITICAL">CRITICAL</option>\r\n\t\t\t\t\t\t\t</select> --></div></div><!-- <div class="form-group" ng-if="has_ROLE_USER_ADMIN" ng-show="isSet(1)">\r\n                            <label class="col-md-3 control-label" for="field_parent">\r\n\t\t\t\t\t\t\t\t<span>Parent WorkFlows</span>\r\n                                <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                            </label>\r\n                            <div class="col-md-8">\r\n                                <input list="userslist" class="form-control" id="field_parent" placeholder="Search workFlow name" type="text" \r\n                                \tng-model="vm.workFlow.parent" autocomplete="off" name="parent" ng-change="vm.filterActivatedworkFlows()" required>\r\n                                <datalist ng-hide="!vm.childAssets" id="workFlowlist" class="form-control1">\r\n                                    <option ng-repeat="child in vm.childAssets" value="{{child.name}}"></option>\r\n                                </datalist>\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-if="(!vm.workFlow.id) && (has_ROLE_USER || has_ROLE_USER_ADMIN)" ng-show="isSet(1)"><label class="col-md-3 control-label"><span translate="trakeyeApp.workFlow.group">Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div is-disabled="true" isteven-multi-select input-model="vm.multigroup" output-model="vm.workFlow.groups" button-label="name" on-item-click="vm.selectedGroup(vm.workFlow.groups)" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><input type="text" ng-model="vm.workFlow.groups" name="group" style="display: none"></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_assignedTo"><span translate="trakeyeApp.workFlow.assignedTo">Assigned To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input list="userslist" class="form-control" id="field_assignedToUser" placeholder="Search user login name" type="text" ng-model="vm.workFlow.assignedToUser" autocomplete="off" name="assignedToUser" ng-change="vm.filterActivatedUser()" required><datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1"><option ng-repeat="user in vm.activatedusers" value="{{user.login}}"></option></datalist></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label"><span translate="trakeyeApp.workFlow.workFlowType">workFlowType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="workFlowType" ng-model="vm.workFlowType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.workFlowTypes track by item.id" ng-disabled="vm.workFlow.id!=null" required style="width: 100%;"><option value="" translate="trakeyeApp.workFlow.selectWorkFlow">--- Select WorkFlowType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.workFlow.workFlowTypeAttributeValues | orderBy: \'workFlowTypeAttribute.id\' track by $index" ng-class="{\'has-error\' : userIntForm.value.$invalid }" ng-show="isSet(1)"><label class="col-md-3 control-label"><span>{{attribute.workFlowTypeAttribute.name}}</span></label><div class="col-md-8" ng-repeat="attributeValue\r\n                                    in vm.workFlow.workFlowTypeAttributeValues track\r\n                                    by $index"><div ng-if="attributeValue.workFlowTypeAttribute.id\r\n                                        == attribute.workFlowTypeAttribute.id"><input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'FLOAT\' && !vm.workFlow.id" type="text" class="form-control" ng-init="attributeValue.attributeValue=\r\n                                            attribute.workFlowTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'FLOAT\' && vm.workFlow.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <span ng-if="attribute.workFlowTypeAttribute.dataType\r\n                                            == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'INTEGER\' && !vm.workFlow.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\r\n                                            attribute.workFlowTypeAttribute.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'INTEGER\' && vm.workFlow.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.workFlowTypeAttribute.dataType\r\n                                            == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\' && !vm.workFlow.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\r\n                                            attribute.workFlowTypeAttribute.value" ng-model="attributeValue.attributeValue"> <input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\' && vm.workFlow.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue"> <span ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="attributeValue.attributeValue" ng-init="attributeValue.attributeValue = attribute.workFlowTypeAttribute.value" ng-if="attribute.workFlowTypeAttribute.attributeDataType.name != \'STRING\' && attribute.workFlowTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.workFlowTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.workFlow.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.workFlowTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="attributeValue.attributeValue" ng-init="attributeValue.attributeValue == attribute.workFlowTypeAttribute.attributeValue" ng-if="attribute.workFlowTypeAttribute.attributeDataType.name != \'STRING\' && attribute.workFlowTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.workFlowTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.workFlow.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.workFlowTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div></div><div class="map-view row mt-5" ng-show="isSet(2)"><div class="col-md-9 mt-5 dropFilter"><div isteven-multi-select input-model="vm.assetType" output-model="item" button-label="name icon" item-label="name icon" tick-property="ticked" translation="assetTypeLabel" selection-mode="single" helper-elements="filter" on-item-click="vm.createAssetModal(item[0])" max-height="170px" style="display:inline-block"></div><div ng-show="isSet(2)" style="margin-left:5px;display:inline-block"><button type="button" class="btn btn-primary" ng-click="vm.refreshPage()"><span class="fa fa-refresh"></span> <span>Refresh</span></button></div><div ng-show="isSet(2) && vm.mappedAssetsList.length > 1" style="margin-left:5px;display:inline-block"><button type="button" class="btn btn-primary" ng-click="vm.connectSelectedAssets()"><span><b>Connect Two Assets<b></b></b></span></button></div><div class="column mt-5" id="map_canvas_planning" style="height:58vh;"></div></div><div class="column col-md-3" style="height:60vh"><!-- <div class="row input-group input-group-sm" style="margin-top:3px;margin-left: 5px;">\r\n\t\t\t\t\t\t\t\t\t<input type="text" placeholder="Search" ng-model="searchText" class="search-box">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<br>\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="box-body scrollbar" id="style-3" style="width: 90%;">\r\n\t\t\t\t\t\t\t\t\t\t<table class="jh-table table table-responsive table-hover"\r\n\t\t\t\t\t\t\t\t\t\t\tstyle="background-color: #eae9e9;">\r\n\t\t\t\t\t\t\t\t\t\t\t<thead class="thead-light">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Asset Type</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Type</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t</thead>\r\n\t\t\t\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<tr ng-repeat="item in vm.assetType | filter : searchText"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.createAssetModal(item)">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{item.name}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-show="{{item.imagePath != null}}">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img class="img-responsive" ng-src="{{item.imagePath}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tstyle="width: 24px; height: 24px;">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-show="{{item.colorcode != null}}">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img class="square" style="background-color:{{item.colorcode}};">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><div class="table-scroll"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr><th></th><th><span>Name</span></th><th><span>Actions</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.mappedAssetsList" ng-class="{selected: asset.isChecked}"><td><input type="checkbox" ng-model="asset.isChecked" ng-change="selectEntity(asset)"></td><td>{{asset.name}}</td><td><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a id="editlink" ng-click="vm.editAsset(asset)" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="link" ng-click="vm.deleteAssetModal(asset.name)" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.mappedAssetsList.length==0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div><div class="form-group" ng-show="isSet(3)"><jhi-alert-error></jhi-alert-error><div ng-if="vm.previousId"><button class="btn btn-primary btn-sm pull-right" type="button" class="btn btn-primary btn-sm" ng-click="vm.recalculate()"><span>Recalculate</span></button></div><div class="col-md-6"><dl class="dl-horizontal jh-entity-details"><dt><span ng-if="vm.workFlow.description">Workflow Name</span></dt><dd><span>{{vm.workFlow.description}}</span></dd><dt><span translate="trakeyeApp.workFlow.workFlowType" ng-if="vm.workFlow.workFlowType">WorkFlow Type</span></dt><dd ng-if="vm.workFlow.workFlowType">{{vm.workFlow.workFlowType.name}}</dd></dl><!-- <div ng-repeat="attributeValue in vm.workFlow.workFlowTypeAttributeValues track by $index">\r\n\t\t\t\t\t\t\t\t\t\t<div ng-if="attributeValue.workFlowTypeAttribute.id == attribute.workFlowTypeAttribute.id">\r\n\t\t\t\t\t\t\t\t\t\t\t<span style="margin-left: 20%"><b>{{attribute.workFlowTypeAttribute.name}}</b>\r\n\t\t\t\t\t\t\t\t\t\t\t<span style="margin-left: 20px;">{{attribute.attributeValue}}</span></span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>  --><div class="form-group" ng-if="vm.workFlow.workFlowType" style="max-height:39vh;overflow-y:scroll;margin-left: 2px;"><table class="jh-table table table-responsive table-hover" style="width:100%;"><thead class="thead-light"><tr><th style="font-weight: 600;font-size: 12px;color: #26292b;text-align: left;border: 1px solid #dddddd;background:#eee;position: sticky;top: 0;z-index: 10;">Name</th><th style="font-weight: 600;font-size: 12px;color: #26292b;text-align: left;border: 1px solid #dddddd;background: #eee;position: sticky;top: 0;z-index: 10;">Value</th></tr></thead><tbody ng-repeat="attribute in vm.workFlow.workFlowTypeAttributeValues | orderBy: \'workFlowTypeAttribute.id\'"><tr ng-repeat="attributeValue in vm.workFlow.workFlowTypeAttributeValues track by $index"><td ng-if="attributeValue.workFlowTypeAttribute.id == attribute.workFlowTypeAttribute.id" style="border: 1px solid #dddddd;">{{attribute.workFlowTypeAttribute.name}}</td><td ng-if="attributeValue.workFlowTypeAttribute.id == attribute.workFlowTypeAttribute.id" style="border: 1px solid #dddddd;">{{attribute.attributeValue}}</td></tr></tbody></table></div></div><div class="col-md-6"><div class="col-md-9" id="map_canvas_deployed" style="height:57vh; width: 100%;"></div></div></div><div class="box-footer"><div class="col-md-12 next-button" ng-show="isSet(1)" style="text-align:right;margin-right:20px;"><button type="button" class="btn btn-primary btn-sm next" ng-disabled="editForm.$invalid" ng-click="setTab(2)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 next-button" ng-show="isSet(2)" style="text-align:right; margin-right:20px;"><button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(1)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="button" class="btn btn-primary btn-sm next" ng-disabled="editForm.$invalid || vm.isShowing" ng-click="setTab(3)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 save-buttons" ng-show="isSet(3)" style="text-align:right;margin-right:20px;"><button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(2)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm" ng-click="vm.save()"><span class="glyphicon glyphicon"></span> <span>Submit</span></button></div></div></div></div></form></div></div></div><!--Modal for editing asset--><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Edit Asset</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="myEditAssetText"></span></div><div style="width: 100%; height: 78vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="row"><div class="col-md-12"><div class="box-body"><button class="btn btn-info btn-flat" style="float: right; border: none; margin-right: 20px" ng-click="vm.saveEditAsset()"><span><b>Save</b></span></button><div class="row" style="margin:20px"><label class="col-md-3 control-label"><span>Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.asset.name" ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row" style="margin: 20px;"><div class="col-md-3 control-label"><span>Asset Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3 control-label"><span>{{vm.asset.assetType.name}}</span></div></div><div class="row" ng-repeat="attribute in vm.asset.assetTypeAttributeValues track by $index" style="margin: 20px;"><label class="col-md-3 control-label"><span>{{attribute.assetTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue == attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value}}</option></select></div></div><div class="row" style="margin: 20px;"><!--<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t\t\t\t<span>Coordinates</span> \r\n\t\t\t\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup>\r\n\t\t\t\t\t\t\t\t\t\t</label>--><div class="col-md-9"><!--<div class="input-group">\r\n\t\t\t                                    <input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled ng-model="vm.asset.assetCoordinates" />\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id==null && !vm.isSite">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Select On Map</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id!=null">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Edit</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id!=null">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm" >Recreate</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                </div>\r\n\t\t\t                                <br/>>\r\n\t\t\t                                <h4>{{vm.siteLatLng}}</h4>--><div id="map_canvas_edit_asset" style="height:300px;"></div></div></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Connect Two Assets</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideConnectSitesModal()"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="connectAssetsText"></span></div><!-- Modal body--><div style="width: 80vw; height: 77vh; padding-top: 7px;" class="modal-body"><div class="row"><div style="margin-top: 8px;"><div class="col-md-1 select_asset" style="text-align: right"><label style="padding-top: 6px;">Site A</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;"><select id="fromAssetsView" class="select2 form-control dropwidthHeight" name="search"><option value="">--Select Site A--</option><option ng-repeat="item in vm.mappedAssetsList" value="{{item.name}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px;"><label style="padding-top: 6px;">Site B</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;margin-left: -15px;"><select id="toAssetsView" class="select2 form-control dropwidthHeight" name="search"><option value="">--Select Site B--</option><option ng-repeat="item in vm.mappedAssetsList" value="{{item.name}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px;"><label style="padding-top: 6px;">Spread Type</label></div><div class="col-md-2 selectAsset_drp spreadTypeWidth"><select class="select2 form-control dropwidthHeight" id="spreadType" ng-model="vm.selectedAssetType"><option value=" ">--Select Type--</option><option ng-repeat="item in vm.assetTypeResponse" value="{{item.name}}">{{item.name}}</option></select></div><button type="button" ng-click="vm.connectAssets()" ng-disabled="!vm.selectedAssetType" class="btn btn-primary btn-sm">Connect</button></div><div class="form-group"><div class="col-md-12 mt-5"><div id="map_canvas_connect_assets" style="width: 100%;height:63vh;"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectMultipleAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="vm.hideConnectMultipleAssetsModal()" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle; font-weight: 125;" id="connectAssetsText">Select site to connect</span></div><!-- Modal body--><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="col-md-12"><div id="map_canvas_connect_multiple_assets" style="width: 100%;height:68vh;margin-top: 10px;"></div></div><div class="col-md-12"><button class="btn btn-primary btn-sm pull-right" type="button" ng-click="vm.saveLinkPits()" style="margin: 10px;">Save</button></div></div></div></div></div><!-- Modal for delete asset   --><div id="delete-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; margin: 200px auto;" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cleardeleteAsset()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><h4>Are you sure you want to delete this asset?</h4></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.cleardeleteAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm" ng-click="vm.confirmDeleteAsset()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></div></div></div><!-- Modal for create asset   --><div id="create-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 45%; margin: 100px auto;"><div class="modal-content"><form name="form" class="css-form" novalidate><div class="modal-header"><span class="span__header">Asset Creation Form of Type {{vm.CreateAssetName}}</span> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clearCreateAsset()">&times;</button></div><div class="modal-body"><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-2 control-label" style="width: 17%;"><span style="vertical-align: center;">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7" style="width: 71%"><input type="text" name="name" ng-model="vm.assetNameVal" ng-change="vm.searchAssetName()" class="form-control" placeholder="Please Enter AssetName" style="padding: 6px;" required><div ng-show="vm.assetExisting"><div class="help-block" ng-show="form.name.$error">AssetName is already exist</div></div></div></div></div><div class="row" style="margin: 20px;"><!-- <div class="form-group">\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label" style="width: 17%;">\r\n\t\t\t\t\t\t\t\t<span>Latitude</span>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<input name="Lat" ng-model="vm.assetLat" type="text" style="width: 120%;">\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2">\r\n\t\t\t\t\t\t\t\t<span style="padding: 13px;">Longitude</span>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<input name="Long" ng-model="vm.assetLong" type="text"\r\n\t\t\t\t\t\t\t\t\tstyle="width: 120%;">\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --> <label class="col-md-2 control-label"><span translate=" ">Co-ordinates</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLatLng" id="field_pinLat" ng-model="vm.getLocationCoordinate" required></div></div><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-4 control-label" style="width: 17%;"><span style="vertical-align: center;">ParentSite</span></label><div class="col-md-8" style="width: 71%"><select class="form-control" name="asset" id="asset" ng-model="vm.parentAsset"><!-- <option value="">Select Parent Site </option> --><option ng-repeat="site in vm.mappedAssetsList" ng-if="site.assetType.name == \'Site\'" value="{{site.name}}">{{site.name}}</option></select></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearCreateAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.createAsset()" ng-disabled="vm.showAssetCreation"><span ng-show="vm.getLocationCoordinate.length > 0">OK</span> <span ng-hide="vm.getLocationCoordinate.length > 0">Select Location on Map</span></button></div></form></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form ng-show="isSet(2)" name="editForm1" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" ng-model="vm.getLocationCoordinates" id="field_pinLat" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')">Cancel</button> <button type="submit" class="btn btn-primary">OK</button></div></form></div></div></div>');
$templateCache.put('app/entities/work-flow/work-flows.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cubes"></i> <span translate="trakeyeApp.workFlow.home.title">Work Flows</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="work-flow.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.workFlow.home.createLabel">Create new Work Flow</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 search-top pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.workFlow.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterWorkFlowSearch()"><i class="fa fa-search"></i></button></span></div></div></div></div><div class="workflow-table"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.workFlow.description">Description</span> <span class="fa fa-sort"></span></th><!--<th jh-sort-by="address" class="table-size"><span translate="trakeyeApp.workFlow.address">Address</span> <span class="fa fa-sort"></span></th>--><!--<th jh-sort-by="escalated"><span translate="trakeyeApp.workFlow.escalated">Escalated</span> <span class="fa fa-sort"></span></th>--><th jh-sort-by="status"><span translate="trakeyeApp.workFlow.status">Status</span> <span class="fa fa-sort"></span></th><th><span>Phase</span></th><!-- <th><span>Group</span></th> --><th><span>Distance</span></th><th><span translate="trakeyeApp.workFlow.assignedTo">Assigned To</span></th><!--<th><span translate="trakeyeApp.workFlow.workFlowType">WorkFlow Type</span> </th>--><th><span translate="trakeyeApp.workFlow.createdBy">CreatedBy</span></th><!-- <th><span>Fiber Status</span></th> --><!--<th><span translate="trakeyeApp.workFlow.geofence">Geofence</span></th>--><th>Actions</th></tr></thead><tbody><tr ng-repeat="workFlow in vm.workFlows track by workFlow.id"><td><a ui-sref="work-flow.edit({id:workFlow.id})">{{workFlow.id}}</a></td><td>{{workFlow.description}}</td><!--<td>{{workFlow.address}}</td>--><!--<td>\n                                        <div ng-if="workFlow.escalated">YES</div>\n                                        <div ng-if="!workFlow.escalated">NO</div>--><td>{{workFlow.status}}</td><td>{{workFlow.phase}}</td><!-- <td>{{workFlow.groups[0].name}}</td> --><td>{{workFlow.distance}}</td><!--  <td>\n                                    {{workFlow.reportedByUser}}\n                                </td> --><td>{{workFlow.assignedToUser}}</td><!--<td ng-if="has_ROLE_USER_ADMIN">\n                                        <a ui-sref="workflow-type-detail({id:workFlow.workFlowType.id})" >{{workFlow.workFlowType.name}}</a>\n                                        {{workFlow.workFlowTypeName}}\n                                    </td>--><!--<td ng-if="has_ROLE_USER">\n                                        {{workFlow.workFlowTypeName}}\n                                    </td>--><td>{{workFlow.reportedByUser}}</td><!-- <td>{{workFlow.fiberStatus}}</td> --><!--<td>{{workFlow.geofenceName}}</td>--><td><div class="actions"><a ui-sref="work-flow-detail({id:workFlow.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="work-flow.edit({id:workFlow.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><!--  <a id="editlink" ui-sref="work-flow.delete({id:workFlow.id})" class="action-icons text-primary" title="Delete">\n                                                <span class="fa fa-trash-o"></span>\n                                            </a> --><!-- <img src="content/images/map_img.png" ng-click="workFlowLocation(workFlow)" /> --></div></td></tr><tr><td colspan="10" ng-show="vm.workFlows == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div><!-- <div class="table-responsive mt-10">\n                        <table class="jh-table table table-responsive table-hover">\n                            <thead class="bg-default">\n                                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span\n                                            class="glyphicon glyphicon-sort"></span></th>\n                                    <th jh-sort-by="name"><span data-translate="trakeyeApp.workFlow.name">Name</span>\n                                        <span class="glyphicon glyphicon-sort"></span>\n                                    </th>\n                                    <th jh-sort-by="description"><span\n                                            data-translate="trakeyeApp.workFlow.description">Description</span> <span\n                                            class="glyphicon glyphicon-sort"></span></th>\n                                    <th jh-sort-by="createDate"><span\n                                            data-translate="trakeyeApp.workFlow.createDate">Create Date</span>\n                                        <span class="glyphicon glyphicon-sort"></span>\n                                    </th>\n                                    <th jh-sort-by="updateDate"><span\n                                            data-translate="trakeyeApp.workFlow.updateDate">Update Date</span>\n                                        <span class="glyphicon glyphicon-sort"></span>\n                                    </th>\n                                    <th jh-sort-by="reportedByLogin"><span\n                                            data-translate="trakeyeApp.workFlow.reportedBy">Reported\n                                            By</span> <span class="glyphicon glyphicon-sort"></span></th>\n                                    <th jh-sort-by="assignedToLogin"><span\n                                            data-translate="trakeyeApp.workFlow.assignedTo">Assigned\n                                            To</span> <span class="glyphicon glyphicon-sort"></span></th>\n                                    <th jh-sort-by="updatedByLogin"><span\n                                            data-translate="trakeyeApp.workFlow.updatedBy">Updated\n                                            By</span> <span class="glyphicon glyphicon-sort"></span></th>\n                                    <th jh-sort-by="assignedByLogin"><span\n                                            data-translate="trakeyeApp.workFlow.assignedBy">Assigned\n                                            By</span> <span class="glyphicon glyphicon-sort"></span></th>\n                                    <th jh-sort-by="workFlowTypeId"><span\n                                            data-translate="trakeyeApp.workFlow.workFlowType">Work Flow\n                                            Type</span> <span class="glyphicon glyphicon-sort"></span></th>\n                                    <th jh-sort-by="workOrderId"><span\n                                            data-translate="trakeyeApp.workFlow.workOrder">Work Order</span>\n                                        <span class="glyphicon glyphicon-sort"></span>\n                                    </th>\n                                    <th jh-sort-by="tenantId"><span\n                                            data-translate="trakeyeApp.workFlow.tenant">Tenant</span> <span\n                                            class="glyphicon glyphicon-sort"></span></th>\n                                    <th></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat="workFlow in vm.workFlows track by workFlow.id">\n                                    <td><a ui-sref="work-flow-detail({id:workFlow.id})">{{workFlow.id}}</a></td>\n                                    <td>{{workFlow.name}}</td>\n                                    <td>{{workFlow.description}}</td>\n                                    <td>{{workFlow.createDate}}</td>\n                                    <td>{{workFlow.updateDate}}</td>\n                                    <td>\n                                        {{workFlow.reportedByLogin}}\n                                    </td>\n                                    <td>\n                                        {{workFlow.assignedToLogin}}\n                                    </td>\n                                    <td>\n                                        {{workFlow.updatedByLogin}}\n                                    </td>\n                                    <td>\n                                        {{workFlow.assignedByLogin}}\n                                    </td>\n                                    <td>\n                                        <a\n                                            ui-sref="work-flow-type-detail({id:workFlow.workFlowTypeId})">{{workFlow.workFlowTypeId}}</a>\n                                    </td>\n                                    <td>\n                                        <a\n                                            ui-sref="work-order-detail({id:workFlow.workOrderId})">{{workFlow.workOrderId}}</a>\n                                    </td>\n                                    <td>\n                                        <a ui-sref="tenant-detail({id:workFlow.tenantId})">{{workFlow.tenantId}}</a>\n                                    </td>\n                                    <td class="text-right">\n                                        <div class="btn-group flex-btn-group-container">\n                                            <button type="submit" ui-sref="work-flow-detail({id:workFlow.id})"\n                                                class="btn btn-info btn-sm">\n                                                <span class="glyphicon glyphicon-eye-open"></span>\n                                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                                            </button>\n                                            <button type="submit" ui-sref="work-flow.edit({id:vm.workFlow.id})"\n                                                class="btn btn-primary btn-sm">\n                                                <span class="glyphicon glyphicon-pencil"></span>\n                                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                                            </button>\n                                            <button type="submit" ui-sref="work-flow.delete({id:workFlow.id})"\n                                                class="btn btn-danger btn-sm">\n                                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                                <span class="hidden-sm-down"\n                                                    data-translate="entity.action.delete"></span>\n                                            </button>\n                                        </div>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                    <div class="text-center">\n                        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage">\n                        </jhi-item-count>\n                        <uib-pagination class="pagination-sm" total-items="vm.totalItems"\n                            items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()">\n                        </uib-pagination>\n                    </div> --></div></div></div></div></div>');
$templateCache.put('app/entities/trakeye-type/trakeye-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trakeyeType.id)"><div class="modal-body text-center mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.trakeyeType.delete.question" translate-values="{id: \'{{vm.trakeyeType.id}}\'}">Are you sure you want to delete this Trakeye Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/trakeye-type/trakeye-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.trakeyeType.detail.title">User Type</span> {{vm.trakeyeType.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.trakeyeType.name">Name</span></dt><dd><span>{{vm.trakeyeType.name}}</span></dd><dt><span translate="trakeyeApp.trakeyeType.description">Description</span></dt><dd><span>{{vm.trakeyeType.description}}</span></dd><dt><span translate="trakeyeApp.trakeyeType.createdDate">Created Date</span></dt><dd><span>{{vm.trakeyeType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trakeyeType.updatedDate">Updated Date</span></dt><dd><span>{{vm.trakeyeType.updatedDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trakeyeType.user">User</span></dt><dd>{{vm.trakeyeType.createdBy}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="trakeye-type.edit({id:vm.trakeyeType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/trakeye-type/trakeye-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span ng-if="!vm.trakeyeType.id" translate="trakeyeApp.trakeyeType.home.create">Create</span> <span ng-if="vm.trakeyeType.id" translate="trakeyeApp.trakeyeType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group" ng-if="vm.trakeyeType.id">\n\t\t\t\t\t         <label for="id" class="col-md-2 control-label" translate="global.field.id">ID</label>\n\t\t\t\t\t\t\t\t<div class="col-md-8">\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" id="id" name="id" ng-model="vm.trakeyeType.id" readonly >\n\t\t\t\t\t\t\t\t</div>           \n\t\t\t\t\t        </div> --><div class="form-group"><label class="col-md-2 control-label" for="field_description"><span translate="trakeyeApp.trakeyeType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trakeyeType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" for="field_description"><span translate="trakeyeApp.trakeyeType.description">Description</span></label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trakeyeType.description"></textarea></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\n\t\t\t\t\t        \t<label class="col-md-2 control-label">\n\t\t\t\t\t          \t\t<span translate="trakeyeApp.trakeyeType.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t          \t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t          \t</label>\n\t\t\t\t\t\t\t\t<div class="col-md-8">\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" placeholder="item{{$index + 1}}"  required id="field_key" name="field" ng-model="item.name">\n\t\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t\t<div class="col-md-2 mt-5">\n\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\n\t\t\t\t\t                     ng-click="vm.addmore()" >\n\t\t\t\t\t                  <i class="fa fa-plus"></i>\n\t\t\t\t\t                  </button>\n\t\t\t\t\t                  <button type="button" class="btn btn-xs btn-danger remove"\n\t\t\t\t\t                     ng-click="vm.remove()" ng-disabled="vm.items.length <= 1"\n\t\t\t\t\t                    >\n\t\t\t\t\t                  <i class="fa fa-minus"></i>\n\t\t\t\t\t                  </button>\n\t\t\t\t\t\t\t\t</div>             \n\t\t\t\t\t        </div>\t --><div class="form-group caseType_repeat" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.trakeyeType.attribute">Attribute</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" ng-readonly="item.name == \'SLA\'" required></div><label class="col-md-1 control-label"><span translate="trakeyeApp.trakeyeType.dataType">Data Type</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><select ng-disabled="item.id!=null" ng-model="item.dataType" class="form-control select2" ng-change="dataTypeValue()"><option value="{{ atttype  }}" ng-repeat="atttype in attributetypes">{{atttype }}</option></select></div><label class="col-md-2 control-label"><span translate="trakeyeApp.trakeyeType.defaultValue">Dafault Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="number" ng-if="item.dataType == \'\'" class="form-control" id="field_value" name="types" ng-model="item.defaultValue"> <input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01" required> <input ng-if="item.dataType == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/" required> <input ng-if="item.dataType == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" required><!--\t<p ng-if="item.dataType == \'float\'" class="help-block"\n\t\t\t\t\t\t\t\t   ng-show="editForm.types.$error.pattern">\n\t\t\t\t\t\t\t\t\tInvalid.\n\t\t\t\t\t\t\t\t</p> --> <select ng-model="item.defaultValue" ng-if="item.dataType == \'BOOLEAN\'" class="form-control select2"><option value="true">True</option><option value="false">False</option></select></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div></div><div class="box-footer"><div class="col-md-3 col-md-offset-2 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="trakeye-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/trakeye-type/trakeye-types.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-eye"></i> <span translate="trakeyeApp.trakeyeType.home.title">User Types</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="trakeye-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.trakeyeType.home.createLabel">Create User Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.trakeyeType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.trakeyeType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.trakeyeType.description">Description</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="user.login"><span translate="trakeyeApp.trakeyeType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="trakeyeType in vm.trakeyeTypes | filter : users track by trakeyeType.id "><!--  <td><a ui-sref="trakeye-type-detail({id:trakeyeType.id})">{{trakeyeType.id}}</a></td> --><td>{{trakeyeType.name}}</td><td>{{trakeyeType.description}}</td><!-- <td>\n\t\t\t\t                        {{trakeyeType.createdBy}}\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="trakeye-type-detail({id:trakeyeType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="trakeye-type.edit({id:trakeyeType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.trakeyeTypes == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-service/tr-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Notifications for this service needs to be deleted before deleting service</p><p translate="trakeyeApp.trService.delete.question" translate-values="{id: \'{{vm.trService.id}}\'}">Are you sure you want to delete this Tr Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-service/tr-service-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.trService.detail.title">Tr Service</span> {{vm.trService.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.trService.description">Description</span></dt><dd><span>{{vm.trService.description}}</span></dd><dt><span translate="trakeyeApp.trService.serviceDate">Service Date</span></dt><dd><span>{{vm.trService.serviceDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trService.status">Status</span></dt><dd><span translate="{{\'trakeyeApp.ServiceStatus.\' + vm.trService.status}}">{{vm.trService.status}}</span></dd><dt><span translate="trakeyeApp.trService.user">User</span></dt><dd>{{vm.trService.trCase.assignedToUser}}</dd><dt><span translate="trakeyeApp.trService.createdDate">Created Date</span></dt><dd><span>{{vm.trService.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trService.modifiedDate">Modified Date</span></dt><dd><span>{{vm.trService.modifiedDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trService.trCase">Tr Case</span></dt><dd><a ui-sref="tr-case-detail({id:vm.trService.trCase.id})">{{vm.trService.trCase.description}}</a></dd><div class="form-group" ng-repeat="attribute in vm.trService.serviceTypeAttributeValues track by $index"><dt><span>{{attribute.serviceTypeAttribute.name}}</span></dt><dd><span>{{vm.trService.serviceTypeAttributeValues[$index].attributeValue}}</span></dd></div><dt><span translate="trakeyeApp.trService.serviceImages">Service Images</span></dt><dd><div><div class="col-md-3" ng-repeat="img in vm.trService.serviceImages track by img.id"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" style="padding-bottom: 10px;"></div></div></dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-service.edit({id:vm.trService.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-service/tr-service-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrServiceLabel"><span ng-if="!vm.trService.id" translate="trakeyeApp.trService.home.create">Create</span> <span ng-if="vm.trService.id" translate="trakeyeApp.trService.home.EditLabel">Edit</span></h3></div><div class="box-body"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.trService.id"><label class="col-md-3 control-label" for="id" translate="global.field.id">ID</label><div class="col-md-7"><input type="text" class="form-control" id="id" name="id" ng-model="vm.trService.id" ng-readonly="true"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.trService.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trService.description" ng-readonly="vm.trService.id"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trService.trCase">Tr Case</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control select2" name="trcases" ng-model="vm.trService.trCase.id"\n\t\t\t\t\t\t             ng-options="trCase.id as trCase.description for trCase in vm.trcases" required ng-disabled="!has_ROLE_USER_ADMIN">\n\t\t\t\t\t\t             <option value="" translate="trakeyeApp.trService.selectCase">Select Case</option>\n\t\t\t\t\t\t            </select>  --> <input list="caseslist" class="form-control" id="field_caseid" placeholder="Search case id" type="text" ng-model="vm.trService.trCase.id" autocomplete="off" name="trcases" ng-change="vm.filtertrcasesid()" required ng-pattern="/^[0-9]+$/"><datalist ng-hide="!vm.caseids" id="caseslist" class="form-control1"><option ng-repeat="case in vm.caseids" value="{{case.id}}"></option></datalist><p class="help-block" ng-show="editForm.trcases.$error.pattern" translate="trakeyeApp.trService.caseiderror">Enter only numeric values for case id</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trService.serviceDate" for="field_serviceDate">Service Date</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div class="input-group"><input id="field_serviceDate" type="text" class="form-control" name="serviceDate" datetime-picker="{{dateformat}}" ng-model="vm.trService.serviceDate" ng-change="vm.checkDate()" is-open="vm.datePickerOpenStatus.serviceDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'serviceDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span ng-if="vm.errorDate" class="text-danger">Service date should be greater than case created date</span></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trService.status">status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="status" ng-model="vm.trService.status" id="field_status" required><option value="INPROGRESS" translate="trakeyeApp.ServiceStatus.INPROGRESS">INPROGRESS</option><option value="PENDING" translate="trakeyeApp.ServiceStatus.PENDING">PENDING</option><option value="CLOSED" translate="trakeyeApp.ServiceStatus.CLOSED">CLOSED</option><option value="CANCELLED" translate="trakeyeApp.ServiceStatus.CANCELLED">CANCELLED</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.trService.notes" for="field_notes">Notes</label><div class="col-md-7"><input type="text" class="form-control" name="notes" id="field_notes" ng-model="vm.trService.notes"></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trService.trServicetype">Tr Service</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control select2" name="trakeyeType" ng-model="vm.serviceType" ng-change="vm.selectattributes()" ng-disabled="vm.trService.id" ng-options="item as item.name for item in vm.serviceTypes track by item.id" required><option value="" translate="trakeyeApp.trService.selectType">Select ServiceType</option></select></div></div><div><div class="form-group" ng-repeat="attribute in vm.trService.serviceTypeAttributeValues track by $index"><label class="col-md-3 control-label">{{attribute.serviceTypeAttribute.name}}</label><div class="col-md-7"><input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trService.id" type="text" class="form-control" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue = attribute.serviceTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" step="0.01"> <input ng-if="attribute.serviceTypeAttribute.attributeDataType.name== \'FLOAT\' && vm.trService.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" step="0.01"> <span ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trService.id" type="text" class="form-control" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue = attribute.serviceTypeAttribute.value" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trService.id" type="text" class="form-control" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Valid Number </span><input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trService.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue = attribute.serviceTypeAttribute.value" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue"> <input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'STRING\' && vm.trService.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue"> <span ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Message</span><!-- <select ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue = attribute.serviceTypeAttribute.value" \n\t\t\t\t\t\t\t    ng-if="attribute.serviceTypeAttribute.dataType ==  \'BOOLEAN\' && !vm.trService.id" class="form-control select2" name="value" >\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\n\t\t\t\t\t\t\t\t    <option value="false" >False</option>\n\t\t\t\t\t\t\t   </select>\n\t\t\t\t\t\t\t   <select ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue == attribute.serviceTypeAttribute.value" \n\t\t\t\t\t\t\t   ng-if="attribute.serviceTypeAttribute.dataType ==  \'BOOLEAN\' && vm.trService.id" class="form-control select2" name="value" >\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\n\t\t\t\t\t\t\t\t    <option value="false" >False</option>\n\t\t\t\t\t\t\t   </select> --> <select ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" ng-if="attribute.serviceTypeAttribute.attributeDataType.name != \'STRING\' && attribute.serviceTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.serviceTypeAttribute.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.serviceTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.trService.serviceImages">images</label><div class="col-md-7"><input type="file" name="file" multiple="multiple" class="filestyle" id="serviceImages" accept="image/*"></div><div class="col-md-2" ng-if="vm.trService.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Images</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-8 col-md-offset-3"><div class="col-md-3" ng-repeat="img in vm.serviceImages track by img.id"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" style="padding-bottom: 10px;"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-service"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.errorDate" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tr-service/tr-services.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><i class="fa fa-server"></i><h3 class="box-title" translate="trakeyeApp.trService.home.title">Tr Services</h3><div class="box-tools"><button class="btn btn-create" ui-sref="tr-service.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.trService.home.createLabel">Create Tr Service</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab">List View</a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2);" data-toggle="tab">Map View</a></li></ul></div><div class="col-md-3 search-top pull-right" ng-show="isSet(1)"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.trService.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 search-top pull-right" ng-show="isSet(2)"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="Service Id "> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterTrSevices()"><i class="fa fa-search"></i></button></span></div></div></div><div class="case-table" ng-show="isSet(1)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th><input type="checkbox" ng-click="vm.selectAllAssets()" ng-model="vm.isAllAssetSelected"></th> --><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.trService.description">Description</span> <span class="fa fa-sort"></span></th><th jh-sort-by="service_date"><span translate="trakeyeApp.trService.serviceDate">Service Date</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="trakeyeApp.trService.status">Status</span> <span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.trService.assignedTo">Assigned To</span></th><th><span translate="trakeyeApp.trService.trCase">Tr Case</span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="trService in vm.trServices track by trService.id"><!-- <td><input type="checkbox" ng-model="trService.isChecked" ng-change="vm.selectAssetEntity()"></td> --><td><a ui-sref="tr-service-detail({id:trService.id})">{{trService.id}}</a></td><td>{{trService.description}}</td><td>{{trService.serviceDate | date:\'medium\'}}</td><td translate="{{\'trakeyeApp.ServiceStatus.\' + trService.status}}">{{trService.status}}</td><td>{{trService.trCase.assignedToUser}}</td><td><a ui-sref="tr-case-detail({id:trService.trCase.id})">{{trService.trCase.description}}</a></td><td><div class="actions"><a ui-sref="tr-service-detail({id:trService.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="tr-service.edit({id:trService.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="tr-service.delete({id:trService.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.trServices == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="map-view" ng-show="isSet(2)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas" style="height:{{mapHeight}}px; width:100%"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-order/work-order-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.workOrder.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services and notifications for this workorder needs to be deleted before deleting workorder</p><p translate="trakeyeApp.workOrder.delete.question" translate-values="{id: \'{{vm.workOrder.id}}\'}">Are you sure you want to delete this Tr WorkOrder?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/work-order/work-order-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.workOrder.detail.title">Work Order </span>- {{vm.workOrder.id}}</h3></div><div class="col-md-12 mt-5"><a ui-sref="work-order.edit({id:vm.workOrder.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Work Order Details</span></h4><div class="box-body table-scroll"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.workOrder.description">Description</span></dt><dd><span>{{vm.workOrder.description}}</span></dd><dt><span translate="trakeyeApp.workOrder.status">Status</span></dt><dd><!-- <span translate="{{\'trakeyeApp.WorkOrderStatus.\' + vm.workOrder.status}}">{{vm.workOrder.status}}</span> --> <span>{{vm.workOrder.status}}</span></dd><dt><span translate="trakeyeApp.workOrder.workFlows">Associated Work Flows</span></dt><dd><ul><li ng-repeat="workorder in vm.workOrder.workOrderCases">{{workorder.description}}</li></ul></dd><dt><span translate="trakeyeApp.workOrder.workOrderType">Work Order Type</span></dt><dd ng-if="has_ROLE_USER_ADMIN">{{vm.workOrder.workOrderType.name}}</dd><dd ng-if="has_ROLE_USER">{{vm.workOrder.workOrderType.name}}</dd><!-- <div class="col-md-8">\n\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100;"></div>\n\t\t\t\t\t\t</div> --><dt><span translate="trakeyeApp.workOrder.assignedTo">Assigned To</span></dt><dd>{{vm.workOrder.assignedToUser}}</dd><dt><span translate="trakeyeApp.workOrder.assignedBy">Assigned By</span></dt><dd>{{vm.workOrder.assignedByUser}}</dd><dt><span translate="trakeyeApp.workOrder.reportedBy">Reported By</span></dt><dd>{{vm.workOrder.reportedByUser}}</dd><dt><span translate="trakeyeApp.workOrder.updatedBy">Updated By</span></dt><dd>{{vm.workOrder.updatedByUser}}</dd><dt><span translate="trakeyeApp.workOrder.createDate">Create Date</span></dt><dd><span>{{vm.workOrder.createDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workOrder.updateDate">Update Date</span></dt><dd><span>{{vm.workOrder.updateDate | date:\'medium\'}}</span></dd></dl></div></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Additional Details</span></h4><div class="box-body table-scroll"><div class="form-group" style="margin-left: 20px" ng-repeat="attribute in vm.workOrder.workOrderTypeAttributeValues | orderBy: \'workOrderTypeAttribute.id\' "><div ng-repeat="attributeValue in vm.workOrder.workOrderTypeAttributeValues track by $index"><div ng-if="attributeValue.workOrderTypeAttribute.id == attribute.workOrderTypeAttribute.id"><dl class="dl-horizontal jh-entity-details"><dt><span>{{attribute.workOrderTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></dl></div></div></div></div></div><div class="box-footer"><div id="audioLayout"><div class="col-md-12"><a href="javascript:void(0);" ng-click="go_back()" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-order/work-order-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myWorkOrderLabel"><span ng-if="!vm.workOrder.id" translate="trakeyeApp.workOrder.home.create">Create</span> <span ng-if="vm.workOrder.id" translate="trakeyeApp.workOrder.home.EditLabel">Edit</span></h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.workOrder.id"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.workOrder.id" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.workOrder.description">Description</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea class="form-control" rows="2" name="description" id="field_description" ng-model="vm.workOrder.description" required></textarea></div></div><div class="form-group" ng-if="vm.workOrder.id"><label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.workOrder.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.workOrder.status" id="field_status" required><!--<option value="NEW" translate="trakeyeApp.WorkOrderStatus.NEW">NEW</option>\n\t\t                <option value="INPROGRESS" translate="trakeyeApp.WorkOrderStatus.INPROGRESS">IN PROGRESS</option>\n\t\t                <option value="PENDING" translate="trakeyeApp.WorkOrderStatus.PENDING">PENDING</option>\n\t\t                <option value="ASSIGNED" translate="trakeyeApp.WorkOrderStatus.ASSIGNED">ASSIGNED</option>\n\t\t                <option value="RESOLVED" translate="trakeyeApp.WorkOrderStatus.RESOLVED">RESOLVED</option>\n                        <option value="CANCELLED" translate="trakeyeApp.WorkOrderStatus.CANCELLED">CANCELLED</option> --><!-- <option value="NEW">PLANNING PHASE</option>\n                                    <option value="INPROGRESS">ROLL-OUT PHASE</option>\n                                    <option value="PENDING">PENDING</option>\n                                    <option value="ASSIGNED">ASSIGNED</option>\n                                    <option value="RESOLVED">OPERATION PHASE</option>\n                                    <option value="CANCELLED">CANCELLED</option> --><option ng-repeat="item in vm.workOrderStatus" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-if="vm.workOrder.id"><label class="col-md-3 control-label"><span>Phase</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.workOrder.phase" ng-disabled="vm.phaseAccess" required><option ng-repeat="item in vm.phases" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_priority"><span translate="trakeyeApp.workOrder.priority">Priority</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="priority" ng-model="vm.workOrder.priority" id="field_priority" required><option disabled="disabled" selected="selected" value>--- Select Priority ---</option><option value="LOW">LOW</option><option value="MEDIUM">MEDIUM</option><option value="HIGH" selected="selected" value>HIGH</option><option value="CRITICAL">CRITICAL</option></select></div></div><div class="form-group" ng-if="(!vm.workOrder.id) && (has_ROLE_USER ||  has_ROLE_USER_ADMIN)"><label class="col-md-3 control-label"><span translate="trakeyeApp.workOrder.group">Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><div is-disabled="true" isteven-multi-select input-model="vm.multigroup" output-model="vm.workOrder.groups" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><input type="text" ng-model="vm.workOrder.groups" name="group" style="display:none" required></div><div class="col-md-3" style="margin-top: 10px;"><i class="fa fa-plus-square" ng-click="vm.navigateGroupfromWorkOrder();" style="cursor: pointer;" title="Create Group"></i></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.workOrder.workOrderType">workOrderType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="workOrderType" ng-model="vm.workOrderType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.workOrderTypes track by item.id" ng-disabled="vm.workOrder.id!=null" required style="width: 100%;"><option value="" translate="trakeyeApp.workOrder.selectworkorder">--- Select WorkOrderType ---</option></select></div><div class="col-md-3" style="margin-top: 10px;"><i class="fa fa-plus-square" ng-click="vm.navigateWorkOrderTypefromWorkOrder();" style="cursor: pointer;" title="Create Work Order Type"></i></div></div><div class="form-group" ng-repeat="attribute in vm.workOrder.workOrderTypeAttributeValues | orderBy: \'workOrderTypeAttribute.id\' track by $index" ng-class="{ \'has-error\' : userIntForm.value.$invalid }"><label class="col-md-3 control-label"><span>{{attribute.workOrderTypeAttribute.name}}</span></label><div class="col-md-8" ng-repeat="attributeValue in vm.workOrder.workOrderTypeAttributeValues track by $index"><div ng-if="attributeValue.workOrderTypeAttribute.id == attribute.workOrderTypeAttribute.id"><input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'FLOAT\'  && !vm.workOrder.id" type="text" class="form-control" ng-init="attributeValue.attributeValue = attribute.workOrderTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.workOrder.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <span ng-if="attribute.workOrderTypeAttribute.dataType == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.workOrder.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-init="attributeValue.attributeValue = attribute.workOrderTypeAttribute.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.workOrder.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.workOrderTypeAttribute.dataType == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'STRING\' && !vm.workOrder.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="attributeValue.attributeValue = attribute.workOrderTypeAttribute.value" ng-model="attributeValue.attributeValue"> <input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'STRING\' && vm.workOrder.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue"> <span ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="attributeValue.attributeValue" ng-if="attribute.workOrderTypeAttribute.attributeDataType.name != \'STRING\' && attribute.workOrderTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.workOrderTypeAttribute.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.workOrderTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><!--<div class="form-group" style="margin-top: 30px;">\n                        <div class="col-md-3"></div>\n                        \n                    </div>\n                     <div class="form-group">\n                        <div class="col-md-3 search-top" style="margin-left: 20px;">\n\n                        </div>\n                    </div> --><div class="form-group"><!-- <div class="col-md-6">\n                            <span  ng-if="vm.asset.id==null && !vm.isSite">\n                                <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm"> Nearby Workflows</button>\n                            </span>\n                        </div> --><div class="col-md-4 workflow-table" style="margin-left: 87px;"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover table-scroll" style="display: block"><thead class="thead-light"><tr><th></th><th><span translate="global.field.id">ID</span></th><th><span translate="trakeyeApp.workOrder.description">Discription</span></th><th><span>Status</span></th><!-- <th><span translate="">BOQ</span></th> --><!-- \t\t\t\t\t\t\t\t\t\t\t<th><span translate="">PB(dBm)</span></th> --><th><span translate="">Distance (kms)</span></th></tr></thead><tbody><tr ng-repeat="workFlow in vm.workFlows | filter : searchText  track by workFlow.id  " ng-class="{selected: workFlow.isChecked}"><td><input type="checkbox" ng-model="workFlow.isChecked" ng-change="selectEntity()"></td><td><a ui-sref="work-flow-detail({id:workFlow.id})">{{workFlow.id}}</a></td><td>{{workFlow.description}}</td><td>{{workFlow.status}}</td><!-- <td>{{workFlow.cost}}</td> --><!-- \t\t\t\t\t\t\t\t\t\t\t<td>{{workFlow.powerBudget}}</td> --><td>{{workFlow.fiberDistance}}</td></tr><tr><td colspan="10" ng-show="vm.workFlows == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody><span ng-if="vm.asset.id==null && !vm.isSite"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Nearby Workflows</button></span><div class="col-md-5 input-group input-group-sm pull-right"><input type="text" ng-model="searchText" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search WorkFlows,ID\'s"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></table></div></div><div class="col-md-6"><div id="map_canvas" style="height:400px; width:100%; margin: 10px"></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="work-order"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div><div id="workflowsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Select radius</span> <select name="workflow_distance" id="workflow_distance"><option value="100" selected="selected">100 m</option><option value="150">150 m</option><option value="200">200 m</option><option value="250">250 m</option><option value="500">500 m</option><option value="1000">1 km</option><option value="5000">5 km</option><option value="10000">10 km</option><option value="100000">100 km</option></select> <span class="span__modal-header">and Click on Map to get nearby workflows</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%;padding-top: 7px;" class="modal-body"><div class="row"><div class="col-md-12 modal_body_map"><div class="location-map-workflows"><div style="width: 100%; height: 72vh; display: inline-block;" id="map_canvas_workflows"></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-order/work-order-import.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i>Import WorkOrders</h3><div class="box-tools ng-scope"><button class="btn btn-create"><span class="fa fa-download"></span> <a href="content/images/SampleWorkOrders.xlsx" download style="color: #fff">Sample File</a></button></div></div><!-- /.box-header --><!-- form start --><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file accept="*.xlsx||*.xls" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel file should be uploaded</p></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/work-order/work-orders.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-th-large"></i> <span>Work Orders</span></h3><div class="box-tools" ng-show="vm.createAccess"><button class="btn btn-create btn-sm" ui-sref="work-order.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.workOrder.home.createLabel">New1</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-8" ng-hide="true"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(4)}"><a href ng-click="setTab(4);" data-toggle="tab">Table View</a></li></ul></div><div class="col-md-3 search-top pull-right" ng-show="isSet(1) || isSet(4)"><div class="input-group"><input type="text" ng-model="search" ng-change="vm.searchWorkOrders()" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.workOrder.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterWorkOrderSearch()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 search-top pull-right" ng-show="isSet(2) || isSet(5)"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.workOrder.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearchMap()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 search-top pull-right" ng-show="isSet(3)"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.workOrder.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearchMap()"><i class="fa fa-search"></i></button></span></div></div></div><div class="row" ng-show="isSet(4)" style="float: right; margin-top: 1px;"><div class="actions dropdown" style="margin-right: 160px;"><div class="dropdown dropdown-scroll" ng-hide="vm.showActions"><button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown">Actions <span class="caret"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" ng-repeat="item in vm.items" ng-click="vm.selectedWorkOrders(item.name)">{{item.name}}</li></ul></div></div><div class="groups dropdown" style="float: right; margin-right:169px; margin-top: -34px;"><div class="dropdown dropdown-scroll" ng-hide="vm.groupOrders" style="margin-right: -190px;"><button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown">Groups <span class="caret"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" ng-repeat="group in vm.multgroup" ng-click="vm.updateWorkOrderGroup(group.name)">{{group.name}}</li></ul></div></div></div><div class="row" ng-show="isSet(4)" style="margin: 25px 0px 0px;"><div class="workOrder-table" ng-show="isSet(4)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="width: 2%;"><input type="checkbox" ng-click="vm.selectAllWorkOrder()" ng-model="vm.isAllSelected"></th><th style="width: 2%;"></th><th jh-sort-by="id" style="width: 8%;"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description" style="width: 12%;"><span translate="trakeyeApp.workOrder.description">Description</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status" style="width: 8%;"><span translate="trakeyeApp.workOrder.status">Status</span> <span class="fa fa-sort"></span></th><th style="width: 12%;"><span>Phase</span></th><th style="width: 12%;"><span>Completed(%)</span></th><th style="width: 12%;"><span>Rolled Out (km)</span></th><th style="width: 12%;"><span>In Progress (km)</span></th><th style="width: 12%;"><span>Total Distance (km)</span></th><!--<th><span translate="trakeyeApp.workOrder.createdBy">CreatedBy</span></th>--><!-- <th style="width: 14%;"><span>Group</span></th> --><!-- <th><span>Completed (%)</span></th>\n                                                            <th><span>Resolved (km)</span></th>\n                                                            <th><span>Unresolved (km)</span></th> --><!-- <th style="width: 11%;"><span>Total Distance (km)</span></th> --><!-- <th style="width: 12%;"><span>BOQ</span></th> --><!--                                             <th style="width: 12%;"><span>PB(dBm)</span></th> --><th style="width: 8%;">Actions</th></tr></thead><tbody><tr ng-repeat-start="workOrder in vm.workOrders track by workOrder.id" ng-class="{selected: workOrder.isChecked}"><td style="width: 2%;"><input type="checkbox" ng-model="workOrder.isChecked" ng-change="vm.selectWorkOrderEntity(workOrder)"></td><!-- <td style="position:relative; padding-left: 1px;width: 2%">\n                                                <button ng-click="vm.workflowTable(workOrder);" expand\n                                                    style="padding: 4px 4px;position: absolute;margin-top: -6px;">\n                                                    <span ng-bind="workOrder.isExpanded ? \'-\' : \'+\'"\n                                                        style="position: absolute;margin-top: -11px;margin-left: -4px;"></span>\n                                                </button>\n                                            </td> --><td class="td__listViewRow" ng-click="vm.workflowTable(workOrder);" expand><span ng-if="!workOrder.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="workOrder.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td style="width: 8%;"><a ui-sref="work-order-detail({id:workOrder.id})">{{workOrder.id}}</a></td><td style="width: 12%;">{{workOrder.description}}</td><!-- <td translate="{{\'trakeyeApp.WorkOrderStatus.\' + workOrder.status}}" style="width: 12%;">{{workOrder.status}}</td> --><td style="width: 8%;">{{workOrder.status}}</td><td style="width: 16%;">{{workOrder.phase}}</td><td style="width: 16%;">{{workOrder.percentdistance}}%</td><td style="width: 16%;">{{workOrder.resolved}}</td><td style="width: 16%;">{{workOrder.unresolved}}</td><td style="width: 16%;">{{workOrder.totalDistance}}</td><!-- <td style="width: 14%;">{{workOrder.groups[0].name}}</td> --><!-- <td>{{workOrder.percentdistance}}%</td>\n                                                            <td>{{workOrder.resolved}}</td> --><!--<td>{{workOrder.reportedByUser}}</td>--><!-- <td>{{workOrder.unresolved}}</td> --><!-- <td style="width: 11%;">{{workOrder.totalDistance}}</td> --><!-- <td style="width: 12%;"><a\n                                                    ng-click="vm.showWorkOrderBreakUps(workOrder)">{{workOrder.Cost}}</a>\n                                            </td> --><!--                                             <td style="width: 12%;"><a ng-click="vm.showWorkOrderPowerBudgetBreakUps(workOrder)">{{workOrder.pb}}</a> --><td style="width: 8%;"><div class="actions"><a ui-sref="work-order-detail({id:workOrder.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="work-order.edit({id:workOrder.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="editlink" ui-sref="work-order.delete({id:workOrder.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span> </a><!-- <img src="content/images/map_img.png"\n                                                        ng-click="workOrderLocation(workOrder)" /> --></div></td></tr><tr ng-show="workOrder.isExpanded"><td></td><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 27px;"><thead><tr></tr></thead><tbody><tr ng-repeat-start="child in vm.workflowAssets"><td style="width: 2%;"><!--<input type="checkbox">--></td><!-- <td style="position:relative;width: 2%;">\n                                                                <button\n                                                                    ng-click="vm.assetsTable({id:child.id});expanding = !expanding"\n                                                                    expand\n                                                                    style="padding: 4px 4px;position: absolute;margin-top: -6px;">\n                                                                    <span ng-bind="expanding ? \'-\' : \'+\'"\n                                                                        style="position: absolute;margin-top: -11px;margin-left: -4px;"></span>\n                                                                </button>\n                                                            </td> --><td style="position:relative;width: 2%;" ng-click="vm.assetsTable({id:child.id});expanding = !expanding" expand><span ng-if="!expanding" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="expanding" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td style="width: 8%;"><a ui-sref="tr-case-detail({id:child.id})">{{child.id}}</a></td><td style="width: 13%;">{{child.description}}</td><!-- <td translate="{{\'trakeyeApp.WorkOrderStatus.\' + workOrder.status}}" style="width: 13%;">{{child.Address}}</td> --><td style="width: 14%;">{{child.status}}</td><td style="width: 12%;">{{child.phase}}</td><td style="width: 13%;">{{child.totalDistance}}</td><td></td><!--                                                             <td style="width: 13%;"><a --><!--                                                                     ng-click="">{{child.pb}}</a></td> --><td style="width: 8%;"><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a ui-sref="tr-case-detail({id:child.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="tr-case.edit({id:child.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="editlink" ui-sref="tr-case.delete({id:child.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span> </a><!-- <img src="content/images/map_img.png"\n                                                                        ng-click="workOrderLocation(child)" /> --></div></td></tr><tr ng-show="expanding"><td></td><td colspan="12"><table style="width: 100%; height:100%; border-spacing:0;margin-left: 15px;"><thead><tr></tr></thead><tbody><tr ng-repeat-start="subChild in vm.serviceAssets"><!-- <td style="width: 3%;">\n                                                                            </td> --><!-- <td style="position:relative;width: 2%;">\n                                                                                <button\n                                                                                    ng-click="vm.subChildTable({id:child.id});grandExpand = !grandExpand"\n                                                                                    expand\n                                                                                    style="padding: 4px 4px;position: absolute;margin-top: -6px;">\n                                                                                    <span\n                                                                                        ng-bind="grandExpand ? \'-\' : \'+\'"\n                                                                                        style="position: absolute;margin-top: -11px;margin-left: -4px;"></span>\n                                                                                </button>\n                                                                            </td> --><td style="position:relative;width: 2%;" ng-click="vm.subChildTable({id:child.id});grandExpand = !grandExpand" expand><span ng-if="!grandExpand" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="grandExpand" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td style="width: 10%;"><a ui-sref="asset-detail({id:subChild.id})">{{subChild.id}}</a></td><td style="width: 15%;">{{subChild.description}}</td><!-- <td translate="{{\'trakeyeApp.WorkOrderStatus.\' + workOrder.status}}" style="width: 13%;">{{subChild.Address}}</td> --><td style="width: 13%;">{{subChild.status}}</td><td style="width: 12%;">{{subChild.phase}}</td><td style="width: 13%;">{{subChild.totalDistance}}</td><td></td><!--                                                                             <td style="width: 14%;"><a --><!--                                                                                     ng-click="">{{subChild.pb}}</a> --><!--                                                                             </td> --><td style="width: 11%;"><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a ui-sref="asset-detail({id:subChild.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="asset.edit({id:subChild.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="editlink" ui-sref="asset.delete({id:subChild.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span> </a><!-- <img src="content/images/map_img.png"\n                                                                                        ng-click="workOrderLocation(subChild)" /> --></div></td></tr><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.workOrders == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div><div class="map-view" ng-show="isSet(2) || isSet(5)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas1" style="height:{{mapHeight}}px; width:100%"></div></div></div></div><div class="map-view" ng-show="isSet(3)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas2" style="height:{{mapHeight}}px; width:100%"></div></div></div></div></div></div></div></div></div><!--Modal for editing asset--><div id="workOrderLocationModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="myEditAssetText"></span></div><div style="width: 100%; height: 680px; padding-top: 7px;" class="modal-body"><div class="row"><div class="col-md-12 modal_body_map"><div class="location-map-workorder-location" id="location-map-edit"><div style="width: 100%; height: 500px; display: inline-block;" id="map_canvas_workorder_location"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!-- Modal --><div id="assignworkorderModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header modal-info"><button type="button" class="close" ng-click="reset()" data-dismiss="modal">&times;</button><h4 class="modal-title text-left">Assign workorder to {{edituserLogin}}</h4></div><div class="modal-body"><div class="row"><form name="editWorkOrderForm" role="form" class="form-horizontal" novalidate ng-submit="vm.editworkorder()"><div class="form-group"><label class="col-md-3 control-label" translate="entity.action.selectworkorder">Select WorkOrder Id</label><!-- <div class="col-md-6">\n\t\t\t\t\t<select class="form-control select2" id="field_workorderId" name="workorderId"  \n\t\t            \tng-options=" workorder.id for workorder in trallworkorders" ng-model="vm.editWorkOrder"  required>\n\t\t            \t<option value="" translate="entity.action.selectworkorder">--- Select WorkOrder ---</option>\n\t\t            \t</select>\n\t\t\t\t</div> --><div class="col-md-8"><!-- <select class="form-control select2" id="field_workorderId" name="workorderId"  ng-options=" workorder.id for workorder in trallworkorders" ng-model="vm.editWorkOrder" \n\t\t              ng-change="vm.selectattributes()" style="width: 100%" required>\n\t\t\t\t\t \t<option value="" translate="entity.action.selectworkorder">--- Select WorkOrder Id ---</option>\n\t\t\t\t\t \t</select> --> <input list="workorderslist" class="form-control" id="field_workorderId" ng-pattern="/^[0-9]+$/" placeholder="Search workorder id" type="text" ng-model="vm.seachWorkOrderId" autocomplete="off" name="workorderId" ng-change="vm.filterTrworkordersId()" required><datalist ng-hide="!vm.workorderIds" id="workorderslist" class="form-control1"><option ng-repeat="workorder in vm.workorderIds" value="{{workorder.id}}"></option></datalist><p class="help-block" ng-show="editWorkOrderForm.workorderId.$error.pattern" translate="trakeyeApp.workOrder.workorderiderror">Enter only numeric values for workorder id</p></div></div><div class="form-group"><div class="col-md-3 col-md-offset-3"><button type="submit" ng-disabled="editWorkOrderForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.assignworkorder">Assign WorkOrder</span></button></div></div></form><p class="text-success text-center" ng-show="vm.success" translate-compile>WorkOrder {{vm.editWorkOrder.id}} has been assigned successfully to user {{edituserLogin}}.</p><p class="text-danger text-center" ng-show="vm.error" translate-compile>{{vm.error}}</p></div></div></div></div></div><div id="workOrderBreakUpModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 50%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">WorkOrder BreakUp({{vm.workOrderName}})</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideWorkOrderModal()"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%;padding-top: 7px; height: 300px;" class="modal-body scrollbar"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="description"><span>Work Flow</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span>Date</span> <span class="fa fa-sort"></span></th><th><span>Distance</span></th><th><span>BOQ</span></th></tr></thead><tbody><tr ng-repeat="work in vm.workBreakUps track by work.id"><td>{{work.description}}</td><td>{{work.createDate}}</td><td></td><td>{{work.Cost}}</td></tr><tr><td colspan="10" ng-show="vm.workBreakUps == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><div id="PBWorkOrderBreakUp" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 50%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">WorkOrder BreakUp({{vm.workOrderName}})</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideWorkOrderPBModal()"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%;padding-top: 7px; height: 300px;" class="modal-body scrollbar"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="description"><span>Work Flow</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span>Date</span> <span class="fa fa-sort"></span></th><th><span>Distance</span></th><!--                                 <th><span>PB(dBm)</span></th> --></tr></thead><tbody><tr ng-repeat="work in vm.workBreakUps track by work.id"><td>{{work.description}}</td><td>{{work.createDate}}</td><td></td><!--                                 <td>{{work.pb}}</td> --></tr><tr><td colspan="10" ng-show="vm.workBreakUps == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-flow-type/work-flow-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.caseType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.caseType.delete.question" translate-values="{id: \'{{vm.caseType.id}}\'}">Are you sure you want to delete this Case Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/work-flow-type/work-flow-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.workFlowType.detail.title">Case Type</span> {{vm.workFlowType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.workFlowType.name">Name</span></dt><dd><span>{{vm.workFlowType.name}}</span></dd><dt><span translate="trakeyeApp.workFlowType.description">Description</span></dt><dd><span>{{vm.workFlowType.description}}</span></dd><dt><span translate="trakeyeApp.workFlowType.createdDate">Created Date</span></dt><dd><span>{{vm.workFlowType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workFlowType.updateDate">Update Date</span></dt><dd><span>{{vm.workFlowType.updateDate | date:\'medium\'}}</span></dd><!-- <dt><span translate="trakeyeApp.workFlowType.user">User</span></dt> --><!-- <dd>\n\t\t\t\t\t\t\t{{vm.workFlowType.user.login}}\n\t\t\t\t\t\t</dd> --></dl><div class="box-buttons pull-right"><a ui-sref="work-flow-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="work-flow-type.edit({id:vm.workFlowType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-flow-type/work-flow-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myWorkFlowTypeLabel"><span ng-if="!vm.workFlowType.id" translate="trakeyeApp.workFlowType.home.create">Create</span> <span ng-if="vm.workFlowType.id" translate="trakeyeApp.workFlowType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.workFlowType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.workFlowType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.workFlowType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.workFlowType.description"></textarea></div></div><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.workFlowType.workFlowtypeimage" for="field_assetimage">WorkFlowType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="workFlowTypeImage" id="workFlowTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.workFlowType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 workFlowType_showImg" ng-if="vm.workFlowType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageWorkFlow" ng-src="data:image/jpeg;base64,{{vm.workFlowType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.dataType">Data Type</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\n\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customWorkFlowTypeAttributes">{{atttype.name }} \n\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.value">Dafault Value</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<div class="col-md-2">\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\n\t\t\t\t\t\t\t   </select>\n\t\t\t\t\t\t\t</div>  \n\t\t\t\t\t\t\t\n       \n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\n\t\t\t\t\t\t\t\t  </button>\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>             \n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.workFlowType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.workFlowType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.workFlowType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group workFlowType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.attribute">Attribute</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.dataType">Data Type</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customWorkFlowTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.workFlowCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.workFlowTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.value">Dafault Value</span><span> {{$index + 1}}</span> \n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="work-flow-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/work-flow-type/work-flow-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.workFlowType.home.title">Work Flow Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="work-flow-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.workFlowType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.workFlowType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.workFlowType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.workFlowType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.workFlowType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="workFlowType in vm.workFlowTypes  | filter : search  track   by workFlowType.id"><!--  <td><a ui-sref="work-flow-type-detail({id:workFlowType.id})">{{workFlowType.id}}</a></td> --><td>{{workFlowType.name}}</td><td>{{workFlowType.description}}</td><!--  <td>{{workFlowType.createdDate | date:\'medium\'}}</td>\n\t\t\t\t                    <td>{{workFlowType.updateDate | date:\'medium\'}}</td>--><!-- <td>\n\t\t\t\t                        {{workFlowType.createdBy}}\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="work-flow-type-detail({id:workFlowType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="work-flow-type.edit({id:workFlowType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.workFlowTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<div ng-switch="vm.isAuthenticated()"><!-- After Login --><header class="main-header application-logo" role="navigation" ng-switch-when="true"><a ui-sref="#/" class="logo"><span class="logo-mini"><center><img ng-src="content/images/fy-logo.png" class="imd-responsive sidebarlogo"></center></span><span class="logo-lg"><center><img ng-src="content/images/fiberify-logo.png" class="img-responsive sidebarlogo"></center></span></a><nav class="navbar navbar-static-top"><div class="navBar"><a class="sidebar-toggle" data-toggle="offcanvas" role="button"><span class="sr-only">Toggle navigation</span></a><div class="c-wrapper2"><div ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n                    || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"><button ui-sref="tr-notification" type="button" class="icon-button"><span class="fa fa-bell notify"></span> <span class="icon-button__badge"></span></button></div></div><div class="navbar-custom-menu" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav"><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><img ng-show="image" ng-src="data:image/jpeg;base64,{{image}}" class="img-circle" style="width: 35px; height: 35px" alt="{{userName}}"> <img ng-show="!image" ng-src="content/images/userimg.gif" class="img-circle" style="width: 35px; height: 35px" alt="{{userName}}"> <span><span class="admin-name">{{userName}} </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings"><span class="fa fa-wrench"></span> <span translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password"><span class="fa fa-unlock"></span> <span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="fa fa-sign-in"></span> <span translate="global.menu.account.logout">Sign out</span></a></li></ul></li></ul></div></div><!-- <h3\n                id="dashboardtitle"\n                ng-init="vm.dashboardtitle()"\n                ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n            || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"\n            >\n                <i class="fa fa-home"></i>\n                <span>Dashboard</span>\n            </h3> --><!-- <span id="dashboardtitle" ng-init="vm.dashboardtitle()">Dashboard</span> --></nav></header><!-- Before Login --><header class="main-header" ng-switch-when="false"><nav class="navbar navbar-inverse navbar-static-top"><div class="container"><div class="row"><!-- <div class="col-sm-6">\n                        <a href="http://www.tresbu.com" class="navlogo sidelogo" target="_blank">\n                        <span class="mainlogo"> Tresbu.com</span>\n                      </a>\n                    </div> --><div class="col-sm-12 side-menu-right navbar-top-custom"><ul class="nav navbar-nav navbar-right"><!-- <li ui-sref-active="active" >\n                               <a ui-ref="" ng-click="vm.login()" id="login">\n                                   <span class="fa fa-log-in"></span>\n                                   <span translate="global.menu.account.login">Sign in</span>\n                               </a>\n                           </li>--><li class="nav_phn"><a><i class="fa fa-mobile" aria-hidden="true"></i> +91 9845692420</a></li><!--<li class="nav_phn"><a> <i class="fa fa-phone" aria-hidden="true"></i> +91 804 111 4634 / <i class="fa fa-mobile" aria-hidden="true"></i> +91 9845692420</a></li>--><li ui-sref-active="active"><a ui-sref="login" id="login"><span translate="global.menu.account.login">Sign In</span></a></li><li><span class="line-login">|</span></li><li ui-sref-active="active"><a ui-sref="register" id="register"><span translate="global.menu.account.demo">Demo</span></a></li></ul></div></div></div></nav></header></div><div class="" ng-switch="vm.isAuthenticated()"><aside class="main-sidebar nav-side-bar" ng-switch-when="true" style="height: 100%"><section class="sidebar scrollbar" style="height: 100%"><ul class="sidebar-menu"><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a ui-sref="dashboard" ng-click="vm.collapseNavbar(\'dashboard\')"><i class="fa fa-home"></i> <span class="" translate="global.menu.dashboard">Dashboard</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!-- <li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN">\n                    <a ui-sref="feasibility-check" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-cog" aria-hidden="true"></i>\n                        <span data-translate="global.menu.entities.feasibilityCheck">Feasibility Check</span>\n                    </a>\n                </li> --><!--<li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN">\n                    <a ui-sref="tr-case" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-th-large"></i>\n                        <span translate="global.menu.entities.trCase">Tr Case</span>\n                    </a>\n                </li>--><li ui-sref-active="active" ng-if="vm.accessRolePlanning"><a ui-sref="work-order" ng-click="vm.collapseNavbar()"><i class="fa fa-th-large"></i> <span>Work Orders</span></a></li><!-- <li ui-sref-active="active" ng-if="vm.accessRoleRollout || vm.accessRolePlanning">\n                    <a ui-sref="work-flow" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-th-large"></i>\n                        <span>Workflows</span>\n                    </a>\n                </li> --><li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n                    || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"><a ui-sref="tr-case" ng-click="vm.collapseNavbar()"><i class="fa fa-th-large"></i> <span translate="global.menu.entities.trCase">Tr Case</span></a></li><!-- <li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n                || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT || has_ROLE_PATROLLER ">\n                    <a ui-sref="tr-service" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-server"></i>\n                        <span translate="global.menu.entities.trService">Tr Service</span>\n                    </a>\n                </li> --><li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n                    || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN || has_ROLE_ROLLOUT_ADMIN || has_ROLE_PLAN_ADMIN"><a ui-sref="asset" ng-click="vm.collapseNavbar()"><i class="fa fa-cubes"></i> <span translate="global.menu.entities.asset">Assets</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a ui-sref="geofence" ng-click="vm.collapseNavbar()"><i class="fa fa-street-view"></i> <span>Geofences</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n                || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"><a ui-sref="location-log" ng-click="vm.collapseNavbar()"><i class="fa fa-map-marker"></i> <span translate="global.menu.entities.locationLog">Live Monitoring</span></a></li><!-- <li\n                    ui-sref-active="active"\n                    ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n                || has_ROLE_NETWORK_ENGINEER || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"\n                >\n                    <a ui-sref="tr-notification" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-bell"></i>\n                        <span translate="global.menu.entities.trNotification"\n                            >Tr Notification</span\n                        >\n                    </a>\n                </li> --><hr ng-if="has_ROLE_USER_ADMIN || has_ROLE_TEAM_LEADER"><li ng-class="{active: vm.$state.includes(\'admin\')}" class="treeview" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n                     || has_ROLE_VENDOR_ADMIN"><a href="" id="admin" ng-click="vm.toggleNavbar(\'admin\')"><i class="fa fa-user-plus"></i> <span class="">Admin </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_VENDOR || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a ui-sref="user-management"><i class="fa fa-user"></i><!--  translate="global.menu.admin.userManagement" --> <span class="">User Management</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_VENDOR || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a ui-sref="vehicle-management"><i class="fa fa-car"></i><!-- translate="global.menu.admin.vehicleManagement" --> <span class="">Vehicle Management</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER"><a ui-sref="upload"><i class="fa fa-cloud-upload"></i> <span translate="global.menu.admin.upload">Upload</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a ui-sref="asset-history"><i class="glyphicon glyphicon-time"></i> <span>Asset History</span></a></li><!-- <li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN && vm.showEntityImport">\n                            <a ui-sref="entity-import">\n                                <i class="fa fa-cloud-upload"></i>\n                                <span>Import Entity </span>\n                            </a>\n                        </li> --><!-- <li ui-sref-active="active"\n                        ng-if="has_ROLE_USER_ADMIN && vm.showAssetLinkRequest">\n                        <a ui-sref="asset-link">\n                            <i class="fa fa-link"></i>\n                            <span>Asset Link Request </span>\n                        </a>\n                    </li>  --><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><hr ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER \n                ||  has_ROLE_VENDOR_ADMIN"><li ng-class="{active: vm.$state.includes(\'report-menu\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a href="" id="report-menu" ng-click="vm.toggleNavbar(\'report-menu\')"><i class="fa fa-database"></i> <span class="" translate="global.menu.report">Reports </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu reports_menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="battery-report"><i class="fa fa-battery-full"></i> <span translate="global.menu.battery-report">Battery Report</span></a></li><li ui-sref-active="active"><a ui-sref="case-aging-report"><i class="fa fa-bar-chart"></i> <span translate="global.menu.reportcharts.case-aging-report">Case Aging Report</span></a></li><!-- <li ui-sref-active="active">\n                        <a ui-sref="case-tat-report">\n                            <i class="fa fa-bandcamp"></i>\n                            <span translate="global.menu.reportcharts.case-tat-report"> Case TAT Report </span>\n                        </a>\n                    </li> --><li ui-sref-active="active"><a ui-sref="user-agent-report"><i class="fa fa-vcard"></i> <span>User Agent Report</span></a></li><!--<li ui-sref-active="active">\n                        <a ui-sref="fiber-status-report">\n                            <i class="fa fa-bandcamp"></i>\n                            <span> Fiber Report </span>\n                        </a>\n                    </li>--><!--<li ui-sref-active="active">\n                        <a ui-sref="site-status-report">\n                            <i class="fa fa-bandcamp"></i>\n                            <span> Site Case Report </span>\n                        </a>\n                    </li>--><!-- <li ui-sref-active="active">\n                        <a ui-sref="asset-type-site-report">\n                            <i class="fa fa-briefcase"></i>\n                            <span> Site Assets Report </span>\n                        </a>\n                    </li> --><!-- <li ui-sref-active="active">\n                        <a ui-sref="geofence-report">\n                            <i class="fa fa-briefcase"></i>\n                            <span> Geofence Report </span>\n                        </a>\n                    </li> --><!-- <li ui-sref-active="active">\n                        <a ui-sref="battery-report">\n                            <i class="fa fa-battery-full"></i>\n                            <span translate="global.menu.battery-report"> Battery Report</span>\n                        </a>\n                    </li> --><!-- <li ui-sref-active="active">\n                        <a ui-sref="distance-travelled">\n                            <i class="fa fa-motorcycle"></i>\n                            <span translate="global.menu.distance-travelled"> Distance Travelled </span>\n                        </a>\n                    </li> --><!-- <li ui-sref-active="active">\n                        <a ui-sref="case-type-report">\n                            <i class="fa fa-bandcamp"></i>\n                            <span translate=""> CaseType Report </span>\n                        </a>\n                    </li> --><!-- <li ui-sref-active="active">\n                        <a ui-sref="user-attendance-report">\n                            <i class="fa fa-bandcamp"></i>\n                            <span translate=""> User Attendance Report </span>\n                        </a>\n                    </li> --><li ui-sref-active="active"><a ui-sref="mobile-user-attendance-report"><i class="fa fa-briefcase"></i> <span translate="">User Attendance Report</span></a></li><li ui-sref-active="active"><a ui-sref="gps-user-attendance-report"><i class="fa fa-motorcycle"></i> <span translate="">Distance Travelled Report</span></a></li><li ui-sref-active="active"><a ui-sref="vehicle-distance-report"><i class="fa fa-car"></i> <span translate="">Vehicle Distance Travelled</span></a></li><li ui-sref-active="active"><a ui-sref="user-reporting-report"><i class="fa fa-calendar-plus-o"></i> <span translate="">User Reporting Status</span></a></li><li ui-sref-active="active"><a ui-sref="user-login-history-report"><i class="fa fa-calendar-plus-o"></i> <span translate="">User Last Login</span></a></li><li ui-sref-active="active"><a ui-sref="user-stats-report"><i class="fa fa-bar-chart"></i> <span translate="">User Statistics Report</span></a></li><!-- <li ui-sref-active="active">\n                            <a ui-sref="asset-health-report">\n                                <i class="fa fa-heartbeat"></i>\n                                <span translate="">Asset Health Report </span>\n                            </a>\n                        </li> --><li ui-sref-active="active" ng-if="vm.showAssetHealthStatus"><a ui-sref="asset-health-status-report"><i class="fa fa-heartbeat"></i> <span translate="">Asset Health Status Report</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a ui-sref="entity-dump"><i class="glyphicon glyphicon-envelope"></i> <span translate="">Entity Dump</span></a></li><li ui-sref-active="active" ng-if="vm.showSurveyReport"><a ui-sref="survey-report"><i class="fa fa-download"></i> <span translate="">Survey Report</span></a></li><!-- <li\n                        ui-sref-active="active"\n                        ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"\n                    >\n                        <a ui-sref="cases-dump-report">\n                            <i class="fa fa-download"></i>\n                            <span translate="">Cases Dump </span>\n                        </a>\n                    </li> --><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="geofence-dump"><i class="fa fa-download"></i> <span translate="">Geofence Dump</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a ui-sref="splicing-report"><i class="fa fa-download"></i> <span translate="">Splicing Report</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_TEAM_LEADER"><a ui-sref="user-geofence-report"><i class="fa fa-download"></i> <span translate="">User Geofence Dump</span></a></li><li ui-sref-active="active"><a ui-sref="buried-chamber-report"><i class="fa fa-download"></i> <span translate="">Buried chamber Report</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="asset-kml-dump-dialog"><i class="glyphicon glyphicon-envelope"></i> <span translate="">Asset Kml Dump</span></a></li><!--<li ui-sref-active="active">\n                        <a ui-sref="asset-report">\n                            <i class="fa fa-bandcamp"></i>\n                            <span translate="global.menu.asset-report"> Asset Report </span>\n                        </a>\n                    </li>--><!--<li ui-sref-active="active">\n                        <a ui-sref="asset-case-report">\n                            <i class="fa fa-bandcamp"></i>\n                            <span translate="global.menu.asset-case-report"> Asset Case Report </span>\n                        </a>\n                    </li>--></ul></li><hr ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER \n                ||  has_ROLE_VENDOR_ADMIN || vm.accessRolePlanningAdmin"><!-- <li ng-class="{active: vm.$state.includes(\'admin\')}" ui-sref-active="active" ng-if="has_ROLE_USER" class="treeview">\n                    <a ui-sref="location-log" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-map-marker"></i>\n                        <span translate="global.menu.entities.locationLog">Location Log</span>\n                    </a>\n                </li> --><li ng-class="{active: vm.$state.includes(\'admin\')}" class="treeview" ng-if="has_ROLE_SUPER_ADMIN"><a href="" id="entity-menu" ng-click="vm.toggleNavbar(\'entity-menu\')"><i class="fa fa-university"></i> <span class="" translate="global.menu.admin.main">Administration </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="tenant"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.tenant">Tenant</span></a></li><!-- <li ui-sref-active="active">\n                            <a ui-sref="customer-management">\n                                <i class="fa fa-user"></i>\n                                <span translate="global.menu.admin.customerManagement">Customer management</span>\n                            </a>\n                        </li> --><li ui-sref-active="active"><a ui-sref="jhi-metrics"><i class="fa fa-dashboard"></i> <span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health"><i class="fa fa-heart"></i> <span translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration"><i class="fa fa-list-alt"></i> <span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits"><i class="fa fa-bell"></i> <span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs"><i class="fa fa-tasks"></i> <span translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs"><i class="fa fa-book"></i> <span translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex"><i class="fa fa-refresh"></i> <span translate="global.menu.admin.elasticsearch-reindex">Elasticsearch Reindex</span></a></li><li ui-sref-active="active"><a ui-sref="asset-geofence-mapping"><i class="fa fa-refresh"></i> <span translate="global.menu.admin.asset-geo-mapping">Asset Geo Mapping</span></a></li><!-- <li ui-sref-active="active">\n                            <a ui-sref="reassociate-asset-geofence">\n                                <i class="fa fa-link"></i>\n                                <span translate="global.menu.admin.reassociate-asset-geofence">Reassociate Asset\n                                    Geofence\n                                    Reindex</span>\n                            </a>\n                        </li> --><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'entity-menu\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN || vm.accessRoleRolloutAdmin || vm.accessRolePlanningAdmin"><a href="" id="entity-menu" ng-click="vm.toggleNavbar(\'entity-menu\')"><i class="fa fa-th-list"></i> <span class="" translate="global.menu.entities.main">Entities </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><!-- <li ui-sref-active="active">\n                        <a ui-sref="geofence">\n                            <i class="fa fa-street-view"></i>\n                            <span translate="global.menu.entities.geofence">Geofence</span>\n                        </a>\n                    </li> --><li ng-class="{active: vm.$state.includes(\'case-type\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="case-type" id="case-type" ng-click="vm.toggleNavbar(\'case-type\')"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.caseType">Case Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-case-type-attribute"><i class="fa fa-briefcase"></i> <span>Case Type Attributes</span><!-- translate="global.menu.entities.customCaseTypeAttribute" --></a></li><li ui-sref-active="active"><a ui-sref="attribute-mapping"><i class="fa fa-briefcase"></i> <span>Attribute Mapping</span></a></li></ul><!-- <li ui-sref-active="active">\n                        <a ui-sref="service-type">\n                            <i class="fa fa-paper-plane"></i>\n                            <span translate="global.menu.entities.serviceType">Service Type</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active">\n                        <a ui-sref="custom-service-type-attribute">\n                            <i class="fa fa-briefcase"></i>\n                            <span translate="global.menu.entities.customServiceTypeAttribute">Custom Service Type Attribute</span>\n                        </a>\n                    </li> --></li><li ng-class="{active: vm.$state.includes(\'asset-type\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="asset-type" id="asset-type" ng-click="vm.toggleNavbar(\'asset-type\')"><i class="fa fa-suitcase"></i> <span translate="global.menu.entities.assetType">Asset Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-asset-type-attribute"><i class="fa fa-briefcase"></i> <span>Asset Type Attributes</span><!-- translate="global.menu.entities.customAssetTypeAttribute" --></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'group-type\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="group-type" id="group" ng-click="vm.toggleNavbar(\'group\')"><i class="fa fa-suitcase"></i> <span translate="global.menu.entities.groupType">Group Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="group"><i class="fa fa-group"></i> <span>Groups</span></a></li><li ui-sref-active="active"><a ui-sref="custom-group-type-attribute"><i class="fa fa-briefcase"></i> <span>Group Type Attributes</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'work-flow-type\')}" ng-if="vm.accessRoleRolloutAdmin || vm.accessRolePlanningAdmin" class="treeview"><a ui-sref="work-flow-type"><i class="fa fa-suitcase"></i> <span translate="global.menu.entities.workFlowType">Work Flow Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-work-flow-type-attribute"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.customWorkFlowTypeAttribute">Custom Work Flow Type Attribute</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'workorder-type\')}" class="treeview" ng-if="vm.accessRolePlanningAdmin"><a ui-sref="workorder-type"><i class="fa fa-suitcase"></i> <span translate="global.menu.entities.workorderType">Work Order Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-workorder-type-attribute"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.customWorkOrderTypeAttribute">Custom work order Type Attribute</span></a></li></ul></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="show-hide-case"><i class="fa fa-check-square-o"></i> <span translate="">Show/Hide Case</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="trakeye-type"><i class="fa fa-eye"></i> <span translate="global.menu.entities.trakeyeType">User Type</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--                 <li ng-class="{active: vm.$state.includes(\'report\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN"> --><!--                     <a href="" id="report-menu" ng-click="vm.toggleNavbar()"> --><!--                         <i class="fa fa-database"></i> --><!--                         <span class="" translate="global.menu.reportcharts.report-charts"> --><!--                             Report Charts --><!--                         </span> --><!--                         <span class="pull-right-container"><i class="fa fa-chevron-down pull-right"></i></span> --><!--                     </a> --><!--                     <ul class="treeview-menu" ng-style="close"> --><!--                         <li ui-sref-active="active"> --><!--                             <a ui-sref="case-report"> --><!--                                 <i class="fa fa-bandcamp"></i> --><!--                                 <span translate="global.menu.reportcharts.case-report"> Case Report </span> --><!--                             </a> --><!--                         </li> --><!--                         <li ui-sref-active="active"> --><!--                             <a ui-sref="distance-report"> --><!--                                 <i class="fa fa-bandcamp"></i> --><!--                                 <span translate="global.menu.reportcharts.distance-report"> Distance Report </span> --><!--                             </a> --><!--                         </li> --><!--                     </ul> --><!--                 </li> --><!--<li ui-sref-active="active" class="treeview" ng-controller="JhiLanguageController as languageVm">\n                    <a href="" ng-if="languageVm.languages.length > 1">\n                            <i class="fa fa-flag"></i>\n                            <span translate="global.menu.language">Language</span>\n                            <span class="pull-right-container"><i class="fa fa-chevron-down pull-right"></i></span>\n                    </a>\n                    <ul class="treeview-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">\n                        <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\n                            <a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a>\n                        </li>\n                    </ul>\n                </li>--></ul></section><!-- /.sidebar --></aside><div class="col-md-12 col-sm-12 text-center footerLogin" ng-switch-when="false"><strong>Copyright &copy; {{vm.currYear}} Fiberify Inc, All rights reserved</strong></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div class="content" ng-cloak><div class="row"><div class="col-md-6 col-md-offset-3"><h1 translate="error.title" class="text-center">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/entities/workorder-type/workorder-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.workOrderType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.workOrderType.delete.question" translate-values="{id: \'{{vm.workOrderType.id}}\'}">Are you sure you want to delete this WorkOrder Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/workorder-type/workorder-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.workOrderType.detail.title">WorkOrder Type</span> {{vm.workOrderType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.workOrderType.name">Name</span></dt><dd><span>{{vm.workOrderType.name}}</span></dd><dt><span translate="trakeyeApp.workOrderType.description">Description</span></dt><dd><span>{{vm.workOrderType.description}}</span></dd><dt><span translate="trakeyeApp.workOrderType.createdDate">Created Date</span></dt><dd><span>{{vm.workOrderType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workOrderType.updateDate">Update Date</span></dt><dd><span>{{vm.workOrderType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workOrderType.user">User</span></dt><dd>{{vm.workOrderType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="workorder-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="workorder-type.edit({id:vm.workOrderType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/workorder-type/workorder-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myWorkOrderTypeLabel"><span ng-if="!vm.workOrderType.id" translate="trakeyeApp.workOrderType.home.create">Create</span> <span ng-if="vm.workOrderType.id" translate="trakeyeApp.workOrderType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.workOrderType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.workOrderType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.workOrderType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.workOrderType.description"></textarea></div></div><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.workOrderType.workOrdertypeimage" for="field_assetimage">WorkOrderType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="workOrderTypeImage" id="workOrderTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.workOrderType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 workOrderType_showImg" ng-if="vm.workOrderType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{vm.workOrderType.image}}" style="padding-bottom: 10px;  height:55px;margin-left:15px;"></div></div></div><div class="form-group workOrderType_repeat" ng-repeat="item in vm.items | orderBy: \'id\'"><label class="col-md-2 control-label"><span translate="trakeyeApp.workOrderType.attribute">Attribute</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><label class="col-md-1 control-label"><span translate="trakeyeApp.workOrderType.dataType">Data Type</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customWorkOrderTypeAttributes track by item.id"></select></div><label class="col-md-2 control-label"><span translate="trakeyeApp.workOrderType.value">Dafault Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/" required> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" required> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="workorder-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/workorder-type/workorder-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.workOrderType.home.title">WorkOrder Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="workorder-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.workOrderType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control input-sm" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.workOrderType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.workOrderType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.workOrderType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.workOrderType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="workOrderType in vm.workOrderTypes  | filter : search  track   by workOrderType.id"><!--  <td><a ui-sref="workorder-type-detail({id:workOrderType.id})">{{workOrderType.id}}</a></td> --><td>{{workOrderType.name}}</td><td>{{workOrderType.description}}</td><!--  <td>{{workOrderType.createdDate | date:\'medium\'}}</td>\n\t\t\t\t                    <td>{{workOrderType.updateDate | date:\'medium\'}}</td>--><!-- <td>\n\t\t\t\t                        {{workOrderType.createdBy}}\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="workorder-type-detail({id:workOrderType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="workorder-type.edit({id:workOrderType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.workOrderTypes == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="content"><div class="row"><div class="col-md-6 col-md-offset-3"><jhi-alert-error></jhi-alert-error></div><div class="col-md-4 col-md-offset-4"><div class="box box-info login-panel" ng-if="vm.verifyaccount != \'true\'"><div class="alert alert-danger"><p translate="reset.finish.messages.emaillinkinvalid">Email link is invalid. Please use latest email link.</p></div></div><div class="box box-info login-panel" ng-if="vm.verifyaccount"><div class="box-header"><h3 class="box-title" translate="reset.finish.title">Set Password</h3></div><div class="box-body"><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><!-- <div class="alert alert-danger" ng-show="vm.error">\n                <p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p>\n            </div> --><!-- <div class="alert alert-danger" ng-show="vm.emaillinkinvalid">\n                <p translate="reset.finish.messages.emaillinkinvalid">Email link is invalid. Please use latest email link.</p>\n            </div> --><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" ui-sref="login">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">password</label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><div class="form-group"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-block" translate="reset.finish.form.button">Set Password</button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="content"><div class="row"><div class="col-md-6 col-md-offset-3"><jhi-alert-error></jhi-alert-error></div></div><div class="row mt-45"><div class="col-md-4 col-md-offset-4"><div class="box box-info login-panel"><div class="box-header"><h3 class="box-title" translate="reset.request.title">Reset your password</h3></div><form name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="box-body"><jhi-alert></jhi-alert><div class="alert-messages mt-20"><!-- <div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists">\n\t\t\t                <strong>Username isn\'t registered!</strong> Please check and try again.\n\t\t\t            </div>\n\t\t\t            <div class="alert alert-danger" translate="reset.request.messages.userdeactivated" ng-show="vm.errorUserDeactivate">\n\t\t\t                <strong>User is deactivated. </strong>\n\t\t\t            </div>\n\t\t\t            <div class="alert alert-danger" translate="reset.request.messages.countExceeded" ng-show="vm.countExceeded">\n\t\t\t                <strong>Reset password count is exceeded for the day. </strong>\n\t\t\t            </div>  --><!-- <div class="alert alert-success" ng-show="vm.success == \'OK\'">\n\t\t\t                <p translate="reset.request.messages.success">Password reset link has been sent to your email.</p>\n\t\t\t            </div> --></div><div class="form-group"><input type="text" class="form-control" id="username" name="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.resetAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.username.$invalid"><!-- <p class="help-block"\n\t\t\t\t\t\t\t   ng-show="form.username.$error.required" translate="global.messages.validate.username.required">\n\t\t\t\t\t\t\t\tYour username is required.\n\t\t\t\t\t\t\t</p> --><p class="help-block" ng-show="form.username.$error.maxlength" translate="global.messages.validate.username.maxlength">Your username cannot be longer than 50 characters.</p></div></div><div class="form-group mt-20"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-block btn-sm" translate="reset.request.form.button">Reset</button></div></div><div class="box-footer bg-default text-center"><a class="alert-link ng-scope" ui-sref="login" translate="reset.request.form.signin">Go Back to login</a></div></form></div></div></div></div>');
$templateCache.put('app/account/feasibility/verify/finish/feasibility.verify.finish.html','<div class="content"><div class="row"><div class="col-md-6 col-md-offset-3"><jhi-alert-error></jhi-alert-error></div><div class="col-md-4 col-md-offset-4"><div class="box box-info login-panel"><div class="box-header"><h3 class="box-title" translate="trakeyeApp.feasibilityVerify.home.title">Verify Feasib</h3></div><div class="alert alert-success" ng-show="vm.success"><p translate="trakeyeApp.feasibilityVerify.home.success" translate-compile><strong>Feasibility Success.</strong></p></div><div><form name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><button type="submit" class="btn btn-primary btn-block" translate="trakeyeApp.feasibilityVerify.home.button">Verify Feasibility</button></div></form></div><div><p translate="trakeyeApp.feasibilityVerify.home.note">Note</p></div></div></div></div></div>');}]);})();